webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _TreeViewMainMenu = __webpack_require__(517);
	
	var _TreeViewMainMenu2 = _interopRequireDefault(_TreeViewMainMenu);
	
	var _ListTreeViewMainMenu = __webpack_require__(516);
	
	var _ListTreeViewMainMenu2 = _interopRequireDefault(_ListTreeViewMainMenu);
	
	var _ListMainMenu = __webpack_require__(515);
	
	var _ListMainMenu2 = _interopRequireDefault(_ListMainMenu);
	
	var _ReInitAPPComponent = __webpack_require__(512);
	
	var _ReInitAPPComponent2 = _interopRequireDefault(_ReInitAPPComponent);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _IndexedDBUtil = __webpack_require__(347);
	
	var _IndexedDBUtil2 = _interopRequireDefault(_IndexedDBUtil);
	
	var _WebSocketManager = __webpack_require__(109);
	
	var _WebSocketManager2 = _interopRequireDefault(_WebSocketManager);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _LogUtil = __webpack_require__(173);
	
	var _LogUtil2 = _interopRequireDefault(_LogUtil);
	
	var _JobsForm = __webpack_require__(528);
	
	var _JobsForm2 = _interopRequireDefault(_JobsForm);
	
	var _GlobalUserSetForm = __webpack_require__(521);
	
	var _GlobalUserSetForm2 = _interopRequireDefault(_GlobalUserSetForm);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _UserFormUtil = __webpack_require__(158);
	
	var _UserFormUtil2 = _interopRequireDefault(_UserFormUtil);
	
	var _GOTXML2Json = __webpack_require__(104);
	
	var _GOTXML2Json2 = _interopRequireDefault(_GOTXML2Json);
	
	var _NetWorkErrorLog = __webpack_require__(535);
	
	var _NetWorkErrorLog2 = _interopRequireDefault(_NetWorkErrorLog);
	
	var _OnLineUser = __webpack_require__(536);
	
	var _OnLineUser2 = _interopRequireDefault(_OnLineUser);
	
	var _CommandArg = __webpack_require__(156);
	
	var _CommandArg2 = _interopRequireDefault(_CommandArg);
	
	var _CustomMenu = __webpack_require__(530);
	
	var _CustomMenu2 = _interopRequireDefault(_CustomMenu);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _HookUtil = __webpack_require__(401);
	
	var _HookUtil2 = _interopRequireDefault(_HookUtil);
	
	var _LicenseUpLoad = __webpack_require__(593);
	
	var _LicenseUpLoad2 = _interopRequireDefault(_LicenseUpLoad);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RemotePasteDialog = __webpack_require__(174);
	
	var _RemotePasteDialog2 = _interopRequireDefault(_RemotePasteDialog);
	
	var _PerformancTiming = __webpack_require__(348);
	
	var _PerformancTiming2 = _interopRequireDefault(_PerformancTiming);
	
	var _BusinessMapUtil = __webpack_require__(590);
	
	var _BusinessMapUtil2 = _interopRequireDefault(_BusinessMapUtil);
	
	var _PrintReportDialog = __webpack_require__(513);
	
	var _PrintReportDialog2 = _interopRequireDefault(_PrintReportDialog);
	
	var _ReactDOMFactories = __webpack_require__(160);
	
	var _ReactPropTypes = __webpack_require__(333);
	
	var _DataSetUtil = __webpack_require__(164);
	
	var _DataSetUtil2 = _interopRequireDefault(_DataSetUtil);
	
	var _QueryTableUtil = __webpack_require__(371);
	
	var _QueryTableUtil2 = _interopRequireDefault(_QueryTableUtil);
	
	var _DoMainAppInfo = __webpack_require__(514);
	
	var _DoMainAppInfo2 = _interopRequireDefault(_DoMainAppInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var base64js = __webpack_require__(330);
	var pako = __webpack_require__(335);
	
	/*var command = {};command.classType = "service";
	command.className = userSessionPackage;
	command.instanceType = null;
	command.instanceId = null;
	command.methodName = "getCurrentUserSession";
	command.returnType = "UserSession";*/
	
	/*var data = JSON.stringify(command);
	var postdata = {request:data};
	$.ajax({
	    type:'post',
	    url:urlBase+"/GongqiERP/ServiceController",
	    dataType:"json",
	    data:postdata,
	    async:false,
	    //暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
	    xhrFields:{withCredentials:true},
	
	    success:function(data)
	    {
	      //alert(JSON.stringify(data));
	
	    },
	    error:function(data)
	    {
	
	    }
	});*/
	
	var fromOrig = _CommonUtil2.default.getUrlParam("openfrom");
	//如果不是从OS打开的
	if (fromOrig != "oshome") {
	
	  setInterval(function () {
	    if (window.formOSopenDataSetViewId) {
	      return;
	    }
	    _LogUtil2.default.upLog("");
	  }, 60000);
	}
	
	window.executeCommandResult = function (commandResult) {
	  _CommandResolver2.default.resolve(commandResult.tasks, window.formModuleInstance);
	};
	
	window.executeCommandForApp = function (commandResult, formModuleInstance) {
	  _CommandResolver2.default.resolve(commandResult.tasks, formModuleInstance);
	};
	
	window.showWarn = function (options) {
	  _Warn2.default.show(options);
	};
	
	window.setGlobalErrorLog = function (options) {
	  _LogUtil2.default.setGlobalError(options);
	};
	
	window.setRpcLog = function (options) {
	  _LogUtil2.default.setRpcLog(options);
	};
	
	window.setOperate = function (options) {
	  _LogUtil2.default.setOperate(options);
	};
	
	window.onerror = function (msg, url, line, col, error) {
	  window.setGlobalErrorLog({ stackInfo: msg + "\n" + error ? error.stack : '无异常栈' });
	};
	
	//初始化层控制相关结构 {std:{PurchTable:{classDef:function},ProdTable:{classDef:Object}}}
	window.layerConfigs = {};
	
	window.userQueryList = {};
	window.userExportList = {};
	window.flatMainMenuToMenuItem = {};
	window.isSelfFrameRoot = true;
	function getQueryString(name, url) {
	  var arr = url.split("?");
	  if (arr != null && arr.length > 1) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var r = arr[1].match(reg);
	    if (r != null) {
	      return decodeURI(unescape(r[2]));
	    }
	  }
	  return null;
	}
	function getQueryStringStr(name, url) {
	  var arr = url.split("?");
	  if (arr != null && arr.length > 1) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var r = arr[1].match(reg);
	    if (r != null) {
	      return decodeURI(r[2]);
	    }
	  }
	  return null;
	}
	function osUrl(url) {
	  var arr = url.split("?");
	  if (arr != null && arr.length > 1) {
	    return arr[0];
	  }
	  return null;
	}
	
	window.appId = getQueryString("appId", window.location.search);
	window.didomain = getQueryString("domain", window.location.search);
	window.formOSopenUniversal = getQueryString("formOSopenUniversal", window.location.search);
	window.formOSopenDataSetView = getQueryString("formOSopenDataSetView", window.location.search);
	window.formOSopenDataSetViewId = getQueryStringStr("formOSopenDataSetViewId", window.location.search);
	//图表设计器需求  需要获取sesion内历史
	window.fromTB = getQueryStringStr("fromTB", window.location.search);
	
	// 所有域 万能视图设计器
	window.formOSopenAllUniversal = getQueryString("formOSopenAllUniversal", window.location.search);
	window.osUrl = window.location.origin;
	
	window.formOSdsScript = getQueryStringStr("formOSdsScript", window.location.search);
	
	// window.formOSdsScript=true;
	// window.formOSopenUniversal = "true";
	// window.formOSopenDataSetView = false;
	// window.formOSopenDataSetViewId = "";
	// 所有域 万能视图设计器
	// window.formOSopenAllUniversal = true;
	// window.osUrl = "http://127.0.0.1:60000";
	// window.didomain = "MIX";
	
	// window.formOSopenDataSetView = true;
	// window.formOSopenDataSetViewId = "qa";
	window.fixedMenuId = getQueryString("fixedMenuId", window.location.search);
	
	window.toolExportDrop = false;
	window.toolPivotDrop = false;
	window.toolQueryDrop = false;
	window.openFindDrop = false;
	window.toolAttachmentDrop = false;
	
	if (window.appId && window.didomain) {
	  if ($(window.frameElement).is('iframe')) {
	    setTimeout(function () {
	      $(window.frameElement).parent().parent().find('.layui-layer-setwin .icon-zuixiaohua').css('color', 'black');
	      $(window.frameElement).parent().parent().find('.layui-layer-setwin .icon-huanyuan').css('color', 'black');
	      $(window.frameElement).parent().parent().find('.layui-layer-setwin .icon-guanbi').css('color', 'black');
	      var elementEv = $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max')[0];
	      if (elementEv) {
	        elementEv.addEventListener('click', function () {
	          setTimeout(function () {
	            $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').children().first().css('color', 'black');
	            $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display', 'inline-block').css('height', '42px').addClass('layui-layer-ico');
	            if (window.toolbarBig) {
	              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display', 'flex').css('align-items', 'center').css('height', '58px').removeClass('layui-layer-ico');
	              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display', 'flex').css('align-items', 'center').css('height', '58px').removeClass('layui-layer-ico');
	            } else {
	              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display', 'inline-block').css('height', '42px').addClass('layui-layer-ico');
	              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display', 'inline-block').css('height', '42px');
	            }
	          }, 100);
	        });
	      }
	    }, 200);
	  }
	}
	
	document.addEventListener("click", function (event) {
	  // 当点击除了div元素之外的任何地方时，移除标题栏下拉列表类名
	  try {
	    if (event) {
	      if ($(event.target.parentElement.parentElement.parentElement).attr('id') == 'toolbar_print' || $(event.target.parentElement.parentElement).attr('id') == 'toolbar_print') {
	        $('#toolbarExportLi .dropdown-menu').remove();
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarQueryLi .dropdown-menu').remove();
	        $('#toolbarAttchmentLi .dropdown-menu').remove();
	        $('#selectT .dropdown-menu').hide();
	        if ($('#toolbarPrintLi .dropdown-menu').hasClass('dropdown-menu')) {
	          setTimeout(function () {
	            $('#toolbarPrintLi .dropdown-menu').remove();
	            $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	            $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	            $("#toolbar_print .toolbar_print_big").removeClass('drop');
	            $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	          }, 150);
	        }
	
	        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        window.toolExportDrop = false;
	        window.toolPivotDrop = false;
	        window.toolAttachmentDrop = false;
	        return;
	      }
	      if ($(event.target.parentElement.parentElement.parentElement).attr('id') == 'toolbar_export' || $(event.target.parentElement.parentElement).attr('id') == 'toolbar_export') {
	        $('#toolbarPrintLi .dropdown-menu').remove();
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarQueryLi .dropdown-menu').remove();
	        $('#toolbarAttchmentLi .dropdown-menu').remove();
	        $('#selectT .dropdown-menu').hide();
	        // if($('#toolbarExportLi .dropdown-menu').hasClass('dropdown-menu')){
	        //   setTimeout(() => {
	        //     $('#toolbarExportLi .dropdown-menu').remove()
	        //     $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	        //     $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	        //     $("#toolbar_export .toolbar_print_big").removeClass('drop');
	        //     $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        //   }, 150);
	        // }
	
	        if (window.toolExportDropRemove) {
	          $('#toolbarExportLi .dropdown-menu').remove();
	          $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_export .toolbar_print_big").removeClass('drop');
	          $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	          window.toolExportDropRemove = false;
	          window.toolExportDrop = false;
	        }
	
	        if ($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')) {
	          $('#toolbarExportLi .dropdown-menu').remove();
	          $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_export .toolbar_print_big").removeClass('drop');
	          $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	          window.toolExportDropRemove = false;
	          window.toolExportDrop = false;
	        }
	
	        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        window.toolPivotDrop = false;
	        window.toolAttachmentDrop = false;
	
	        return;
	      }
	      if ($(event.target.parentElement.parentElement.parentElement).attr('id') == 'toolbar_Da' || $(event.target.parentElement.parentElement).attr('id') == 'toolbar_Da') {
	        $('#toolbarPrintLi .dropdown-menu').remove();
	        $('#toolbarExportLi .dropdown-menu').remove();
	        $('#toolbarQueryLi .dropdown-menu').remove();
	        $('#toolbarAttchmentLi .dropdown-menu').remove();
	        $('#selectT .dropdown-menu').hide();
	        // if($('#toolbarPivotLi .dropdown-menu').hasClass('dropdown-menu')){
	        //   setTimeout(() => {
	        //     $('#toolbarPivotLi .dropdown-menu').remove()
	        //     $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	        //     $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	        //     $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	        //     $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        //   }, 150);
	        // }
	
	        if (window.toolPivotDropRemove) {
	          $('#toolbarPivotLi .dropdown-menu').remove();
	          $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	          $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	          window.toolPivotDropRemove = false;
	          window.toolPivotDrop = false;
	        }
	
	        if ($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')) {
	          $('#toolbarPivotLi .dropdown-menu').remove();
	          $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	          $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	          window.toolPivotDropRemove = false;
	          window.toolPivotDrop = false;
	        }
	
	        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        window.toolExportDrop = false;
	        window.toolAttachmentDrop = false;
	
	        return;
	      }
	      if ($(event.target.parentElement.parentElement.parentElement).attr('id') == 'toolbar_Queryopen' || $(event.target.parentElement.parentElement).attr('id') == 'toolbar_Queryopen') {
	        $('#toolbarPrintLi .dropdown-menu').remove();
	        $('#toolbarExportLi .dropdown-menu').remove();
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarAttchmentLi .dropdown-menu').remove();
	        $('#selectT .dropdown-menu').hide();
	        if (!window.toolQueryDrop) {
	          $('#toolbarQueryLi .dropdown-menu').remove();
	
	          window.toolQueryDrop = false;
	        }
	        // if((!window.toolbarBig && $(event.target.parentElement.parentElement).attr('id') =='toolbar_Queryopen') || (window.toolbarBig && $(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_Queryopen') && $(event.target).hasClass('icon-container') ) {
	        //   $('#toolbarQueryLi .dropdown-menu').remove()
	        //   window.toolQueryDrop=false;
	        //   $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	        //   $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	        //   $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	        //   $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        // }
	
	        if ($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')) {
	          $('#toolbarQueryLi .dropdown-menu').remove();
	          $("#toolbarQueryLi .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbarQueryLi .toolbar_print_sml").removeClass('drop');
	          $("#toolbarQueryLi .toolbar_print_big").removeClass('drop');
	          $("#toolbarQueryLi .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	          window.toolQueryDrop = false;
	        }
	
	        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        window.toolExportDrop = false;
	        window.toolPivotDrop = false;
	        window.toolAttachmentDrop = false;
	
	        return;
	      }
	
	      if ($(event.target.parentElement.parentElement.parentElement).attr('id') == 'toolbar_Attchment' || $(event.target.parentElement.parentElement).attr('id') == 'toolbar_Attchment') {
	        $('#toolbarPrintLi .dropdown-menu').remove();
	        $('#toolbarExportLi .dropdown-menu').remove();
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarQueryLi .dropdown-menu').remove();
	        $('#selectT .dropdown-menu').hide();
	        // if($('#toolbarAttchmentLi .dropdown-menu').hasClass('dropdown-menu')){
	        //   setTimeout(() => {
	        //     $('#toolbarAttchmentLi .dropdown-menu').remove()
	        //     $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        //     $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        //     $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        //     $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        //     window.toolAttachmentDrop=false;
	        //   }, 100);
	        // }
	        if (window.toolAttachmentDrop) {
	          $('#toolbar_Attchment .dropdown-menu').remove();
	          // window.toolAttachmentDrop=false;
	          $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        }
	
	        if ($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')) {
	          $('#toolbar_Attchment .dropdown-menu').remove();
	          // window.toolAttachmentDrop=false;
	          $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        }
	
	        // if((!window.toolbarBig && $(event.target.parentElement.parentElement).attr('id') =='toolbar_Attchment') || (window.toolbarBig && $(event.target.parentElement.parentElement.parentElement).attr('id')  =='toolbar_Attchment') && $(event.target).hasClass('icon-container') ) {
	        //   $('#toolbarQueryLi .dropdown-menu').remove()
	        //   window.toolAttachmentDrop=false;
	        //   $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        //   $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        //   $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        //   $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        // }
	
	        if ($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')) {
	          $('#toolbar_Attchment .dropdown-menu').remove();
	          // window.toolAttachmentDrop=false;
	          $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	          $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        }
	
	        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big").removeClass('drop');
	        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        return;
	      }
	
	      if ($(event.target.parentElement.parentElement.parentElement).attr('id') == 'toolbar_find' || $(event.target.parentElement.parentElement).attr('id') == 'toolbar_find') {
	        $('#toolbarPrintLi .dropdown-menu').remove();
	        $('#toolbarExportLi .dropdown-menu').remove();
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarQueryLi .dropdown-menu').remove();
	        $('#toolbarAttchmentLi .dropdown-menu').remove();
	        if (!window.openFindDrop) {
	          $('#selectT .dropdown-menu').hide();
	          window.openFindDrop = false;
	        }
	
	        // if((!window.toolbarBig && $(event.target.parentElement.parentElement).attr('id') =='toolbar_find') || (window.toolbarBig && $(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_find') && $(event.target).hasClass('icon-container') ) {
	        //   $('#selectT .dropdown-menu').hide()
	        //   window.openFindDrop=false;
	        //   $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	        //   $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	        //   $("#toolbar_find .toolbar_print_big").removeClass('drop');
	        //   $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        // }
	
	
	        if ($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')) {
	          $('#selectT .dropdown-menu').hide();
	          window.openFindDrop = false;
	          $("#selectT .toolbar_print_sml .icon-drop").removeClass('drop');
	          $("#selectT .toolbar_print_sml").removeClass('drop');
	          $("#selectT .toolbar_print_big").removeClass('drop');
	          $("#selectT .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	        }
	        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big").removeClass('drop');
	        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big").removeClass('drop');
	        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	        window.toolExportDrop = false;
	        window.toolPivotDrop = false;
	        window.toolAttachmentDrop = false;
	
	        return;
	      }
	      $('#toolbarPrintLi .dropdown-menu').remove();
	      $('#toolbarExportLi .dropdown-menu').remove();
	      $('#toolbarPivotLi .dropdown-menu').remove();
	      $('#toolbarQueryLi .dropdown-menu').remove();
	      $('#toolbarAttchmentLi .dropdown-menu').remove();
	      $('#selectT .dropdown-menu').hide();
	
	      $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_print .toolbar_print_big").removeClass('drop');
	      $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_export .toolbar_print_big").removeClass('drop');
	      $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	      $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	      $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_find .toolbar_print_big").removeClass('drop');
	      $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	      $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      window.toolQueryDrop = false;
	      window.toolAttachmentDrop = false;
	      window.openFindDrop = false;
	
	      window.toolExportDrop = false;
	      window.toolPivotDrop = false;
	    } else {
	      $('#toolbarPrintLi .dropdown-menu').remove();
	      $('#toolbarExportLi .dropdown-menu').remove();
	      $('#toolbarPivotLi .dropdown-menu').remove();
	      $('#toolbarQueryLi .dropdown-menu').remove();
	      $('#toolbarAttchmentLi .dropdown-menu').remove();
	      $('#selectT .dropdown-menu').hide();
	
	      $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_print .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_print .toolbar_print_big").removeClass('drop');
	      $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_export .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_export .toolbar_print_big").removeClass('drop');
	      $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_Da .toolbar_print_big").removeClass('drop');
	      $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
	      $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_find .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_find .toolbar_print_big").removeClass('drop');
	      $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
	      $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
	      $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
	      $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
	
	      window.toolQueryDrop = false;
	      window.toolAttachmentDrop = false;
	      window.openFindDrop = false;
	
	      window.toolExportDrop = false;
	      window.toolPivotDrop = false;
	    }
	  } catch (e) {}
	});
	
	window.fadeInfo = function (options) {
	  _Fade2.default.show(options);
	};
	
	window.print = function (event, flag) {
	  // $(event.target).hasClass("menubtnLable") 
	
	  if ($(event.target).hasClass("icon-container") && flag == 'drop') {
	    return;
	  }
	
	  if (flag == 'drop') {
	    if (window.toolbarBig) {
	      $("#toolbar_print .toolbar_print_big").addClass('drop');
	      $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
	    } else {
	      $("#toolbar_print .toolbar_print_sml .icon-drop").addClass('drop');
	      $("#toolbar_print .toolbar_print_sml").addClass('drop');
	    }
	  }
	
	  var _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  if (flag == "print") {
	    //alert(_id_);
	    callIFrameFunc(_id_, 'print_gongqi', 'print_gongqi');
	  } else {
	    callIFrameFunc(_id_, 'print_gongqi', 'drop');
	  }
	  // console.log("1111");
	};
	
	window.openHelp = function (event) {
	  window.open("./help/help.html", "help", "");
	  // window.open("http://gongqi.info/video/c29.html","help","")
	};
	
	window.toobarFunc = function (event, funcName, funcArg) {
	  try {
	    if ("#g_tab_content>.active>iframe"[0] && $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0]) {
	      $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0].remove();
	    }
	  } catch (err) {}
	
	  //来自于bootstrap等三方框架的esc监听 直接返回不能做处理
	  if (event && event.isTrigger == 3) return;
	  var popIframes = $("#formModal iframe");
	  var _id_;
	  if (popIframes.length > 0) {
	    var iframe = popIframes.get(popIframes.length - 1);
	    _id_ = $(iframe).attr("id");
	  } else {
	    _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  }
	
	  if (funcName == 'attachment') {
	    if ($("#toolbar_Attchment").hasClass('disable')) return;
	  }
	
	  if (_id_) {
	    callIFrameFunc(_id_, funcName, funcArg);
	  }
	  if (funcName == 'groupExport') {
	    var remark = { "title": '打开导出' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '003',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(remark)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'da') {
	    var _remark = { "title": '打开数据分析' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '004',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'queryOpen') {
	    var _remark2 = { "title": '打开筛选' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '005',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark2)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'queryRemove') {
	    var _remark3 = { "title": '移除筛选' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '006',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark3)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'attachment') {
	    var _remark4 = { "title": '打开附件' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '007',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark4)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'recordNew') {
	    var _remark5 = { "title": '工具栏新增记录' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '010',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark5)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == ' recordSave') {
	    var _remark6 = { "title": '工具栏保存记录' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '014',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark6)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'groupExport') {
	    var _remark7 = { "title": '打开导出' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '003',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark7)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'da') {
	    var _remark8 = { "title": '打开数据分析' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '004',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark8)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'queryOpen') {
	    var _remark9 = { "title": '打开筛选' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '005',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark9)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'queryRemove') {
	    var _remark10 = { "title": '移除筛选' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '006',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark10)
	    };
	    window.setOperate(data);
	  }
	  if (funcName == 'attachment') {
	    var _remark11 = { "title": '打开附件' };
	    var data = {
	      'dataArea': 'dynamic',
	      'userId': window.userInfos.userId,
	      'userName': window.userInfos.userName,
	      'clientSessionId': window.userInfos.userSessionId,
	      'dateTime': new Date().getTime() + '',
	      'operationId': '007',
	      'formId': '',
	      'formDataSourceName': '',
	      'formItemName': '',
	      'remark': JSON.stringify(_remark11)
	    };
	    window.setOperate(data);
	  }
	
	  if (funcName == "mainMenuToggle") {
	
	    if (window.userSettingEntry && window.userSettingEntry.showLeftListMenu == true) {
	      if ($(".listtree-sidebar").css("display") == "none") {
	        $(".listtree-sidebar").css("display", "block");
	        //$(".listtree-sidebar").slideToggle(500);
	        $("#g_nav_tab_close").css("left", "161px");
	        $(".content-wrapper").css("margin-left", "160px ");
	        $(".main-footer").css("margin-left", "160px ");
	        $('#g_main_header #g_title_area').css('background-color', '#1C69DB');
	        $('#g_main_header #g_title_area .appSpan').css('color', 'white');
	        $('#g_main_header #g_title_area .doMainSpan').css('color', '#eae4e4db');
	        $('#g_main_header #g_title_area .icon-xinxi').css('color', 'white');
	      } else {
	        $(".listtree-sidebar").css("display", "none");
	        //$(".listtree-sidebar").slideToggle(500);
	        $(".content-wrapper").css("margin-left", "0px ");
	        //$("#g_nav_tab_close").css("left", "1px");
	        var styleElement = document.getElementById('g_nav_tab_close');
	        styleElement.setAttribute('style', 'left: 1px !important;position: fixed;width: 30px;');
	        $(".main-footer").css("margin-left", "0px ");
	        $('#g_main_header #g_title_area').css('background-color', 'white');
	        $('#g_main_header #g_title_area span').css('color', 'black');
	        $('#g_main_header #g_title_area .icon-xinxi').css('color', '#4f4f4f');
	      }
	    }
	
	    if (window.userSettingEntry && window.userSettingEntry.showLeftMenu == true) {
	      if ($(".main-sidebar").css("display") == "none") {
	        $(".main-sidebar").css("display", "block");
	        //$(".listtree-sidebar").slideToggle(500);
	        $(".content-wrapper").css("margin-left", "200px");
	        $(".main-footer").css("margin-left", "200px");
	        var styleElement = document.getElementById('g_nav_tab_close');
	        styleElement.setAttribute('style', 'left: 201px !important;position: fixed;width: 30px;');
	
	        var contentWrapper = document.getElementById('contentWrapper');
	        contentWrapper.classList.remove("treeMune_contentClose");
	        var wrappers = document.getElementsByClassName("wrapper");
	        var wrapper = wrappers[0];
	        wrapper.classList.remove("treeMune_wrapperClose");
	        $('#g_main_header #g_title_area').css('background-color', '#1C69DB');
	        $('#g_main_header #g_title_area .appSpan').css('color', 'white');
	        $('#g_main_header #g_title_area .doMainSpan').css('color', '#eae4e4db');
	        $('#g_main_header #g_title_area .icon-xinxi').css('color', 'white');
	      } else {
	        $(".main-sidebar").css("display", "none");
	        //$(".listtree-sidebar").slideToggle(500);
	        $(".content-wrapper").css("margin-left", "0px ");
	        $("#contentWrapper").css("margin-left", "0px ");
	        var contentWrapper = document.getElementById('contentWrapper');
	        contentWrapper.className += ' treeMune_contentClose';
	        var wrappers = document.getElementsByClassName("wrapper");
	        var wrapper = wrappers[0];
	        wrapper.className += ' treeMune_wrapperClose';
	
	        $(".main-footer").css("margin-left", "0px ");
	        var styleElement = document.getElementById('g_nav_tab_close');
	        styleElement.setAttribute('style', 'left: 1px !important;position: fixed;width: 30px;');
	        $('#g_main_header #g_title_area').css('background-color', 'white');
	        $('#g_main_header #g_title_area span').css('color', 'black');
	        $('#g_main_header #g_title_area .icon-xinxi').css('color', '#4f4f4f');
	      }
	    }
	
	    if ($("#toolBarMainMenuToggleA i").hasClass("fa-rotate-180")) {
	      $("#toolBarMainMenuToggleA i").removeClass("fa-rotate-180");
	    } else {
	      $("#toolBarMainMenuToggleA i").addClass("fa-rotate-180");
	    }
	  }
	};
	
	window.callIFrameFunc = function () {
	  var args = arguments;
	  var iframeId = args[0];
	  var funcName = args[1];
	  var funcArg = args[2];
	  var ifr = document.getElementById(iframeId);
	  var win = ifr.window || ifr.contentWindow;
	  var fn = win[funcName];
	  if (typeof fn === 'function') {
	    return fn.apply(null, [funcArg]);
	  }
	  //win.refresh(arg);
	};
	
	window.openMenuItem = function (args) {
	  //alert(menuItemId+JSON.stringify(argCaller));
	
	
	  if (isIE) {
	    //if(!window.ieOpenMenuItemArgsMQ)window.ieOpenMenuItemArgsMQ = [];
	    //window.ieOpenMenuItemArgsMQ.push(args);
	    var key = args.menuItemId + "." + args.formId;
	    if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
	      initFormWholeObject(args);
	    } else {
	      var _window = window;
	      _IndexedDBUtil2.default.getDataById(key, _IndexedDBUtil2.default.DB.name, function (e) {
	        var data = e.target.result;
	        if (data) _window.FormsWholeObjectCache[key] = data.data;
	        _window.initFormWholeObject(args);
	      });
	    }
	    return;
	  }
	
	  if (!$.isEmptyObject(args.argCaller)) sessionStorage.setItem("callerArg", JSON.stringify(args.argCaller));
	  testOpenForm(args);
	};
	
	window.initFormWholeObject = function (openArgs) {
	  var _parentWindow = window;
	  var userId = _parentWindow.userInfos.userId;
	
	  var wholeObject = _parentWindow.getFormWholeObjectCache(window.menuItemId, window.formId);
	  var formObjectStandardMd5 = null;var formObjectUserSetMd5 = null;var md5prefetchCommandResult = null;var formObjectAuthorityMd5s = {};
	  var userGroups = _parentWindow.userInfos.userGroups;
	
	  if (wholeObject) {
	    formObjectStandardMd5 = wholeObject.formObjectStandard.md5;formObjectUserSetMd5 = wholeObject.formObjectUserSet.md5;md5prefetchCommandResult = wholeObject.formPrefetchCommandResult.md5;
	    for (var _i = 0; _i < userGroups.length; _i++) {
	      var _userGroupId = userGroups[_i];
	      var formObjectAuthority = wholeObject.mapFormObjectAuthority[_parentWindow.userInfos.subSysId + "." + window.menuItemId + "." + _userGroupId];
	      if (formObjectAuthority) formObjectAuthorityMd5s[userGroupId] = formObjectAuthority.md5;else formObjectAuthorityMd5s[_userGroupId] = "";
	    }
	  } else {
	    for (var _i2 = 0; _i2 < userGroups.length; _i2++) {
	      var _userGroupId2 = userGroups[_i2];
	      formObjectAuthorityMd5s[_userGroupId2] = "";
	    }
	  }
	
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "loadFormWhole", "FormWholeObject");
	
	  command.appendArg(openArgs.menuItemId);
	  command.appendArg(openArgs.formId);
	  command.appendArg(userId);
	  //standard
	  command.appendArg(formObjectStandardMd5);
	  //userset
	  command.appendArg(formObjectUserSetMd5);
	  command.appendArg(md5prefetchCommandResult);
	
	  command.appendArg(formObjectAuthorityMd5s, "java.util.Map");
	
	  var _faultHandler = function _faultHandler(data) {
	    $("#loading").css('display', 'none');
	    _Warn2.default.show({ text: "页面初始化失败 请检查网络是否正常或联系管理员" });
	  };
	
	  var _resultHandler = function _resultHandler(data) {
	    syncFormWholeObjectIE(wholeObject, data.result, openArgs);
	  };
	  var remoteArg = { command: command, lockText: "正在初始页面结构 请稍后...", resultFunction: _resultHandler, faultFunction: _faultHandler, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	window.syncFormWholeObjectIE = function (wholeObject, data, openArgs) {
	  var _parentWindow = window;
	  var formObjectStandard;var formPrefetchCommandResult;var formObjectUserSet;
	
	  if (data.sameFormObjectStandard) //如果same 则wholeObject一定不为空
	    {
	      formObjectStandard = wholeObject.formObjectStandard;data.formObjectStandard = wholeObject.formObjectStandard;
	    } else {
	    formObjectStandard = data.formObjectStandard;
	  }
	  if (data.sameFormPrefetchCommandResult) {
	    formPrefetchCommandResult = wholeObject.formPrefetchCommandResult;data.formPrefetchCommandResult = wholeObject.formPrefetchCommandResult;
	  } else {
	    formPrefetchCommandResult = data.formPrefetchCommandResult;
	  }
	  if (data.sameFormObjectUserSet) {
	    formObjectUserSet = wholeObject.formObjectUserSet;data.formObjectUserSet = wholeObject.formObjectUserSet;
	  } else {
	    formObjectUserSet = data.formObjectUserSet;
	  }
	  var xmlDoc = _GOTXML2Json2.default.getXMLDoc(formObjectStandard.formXML);
	  var formXML = _GOTXML2Json2.default.parseForm(xmlDoc);
	
	  _parentWindow.origFormXMLDoc = xmlDoc;
	  _parentWindow.formXML = formXML;
	  _parentWindow.formId = formXML.id;
	  var forms = _parentWindow.got.DataDictionary.Forms;
	  if (forms == null) _parentWindow.got.DataDictionary["Forms"] = [formXML];else forms.push(formXML);
	  var _key = _FormItemUtil2.default.getFormStoresKey(openArgs.menuItemId, formXML.id);
	
	  if (formObjectStandard.listRemoteMethods && formPrefetchCommandResult && formPrefetchCommandResult.commandResults) {
	    var _cmdResults = formPrefetchCommandResult.commandResults;
	    var _listRemoteMethods = formObjectStandard.listRemoteMethods;
	    for (var _i3 = 0; _i3 < _listRemoteMethods.length; _i3++) {
	      var item = _listRemoteMethods[_i3];
	      if (item.prefetch == true) {
	        if (_cmdResults.hasOwnProperty(item.methodName)) {
	          item.commandResult = _cmdResults[item.methodName];
	        }
	      }
	    }
	  }
	
	  _parentWindow[_key] = {
	    mapItemProperty: formObjectStandard.mapItemProperty,
	    listRemoteMethods: formObjectStandard.listRemoteMethods,
	    listTmpTable: formObjectStandard.listTmpTable,
	    listAggregateTable: formObjectStandard.listAggregateTable,
	    mapQueryTable: formObjectStandard.mapQueryTable
	  };
	
	  if (formPrefetchCommandResult && formPrefetchCommandResult.commandResults) {
	    var listRemoteMethods = _parentWindow[_key].listRemoteMethods;
	    if (listRemoteMethods) {
	      for (var _i4 = 0; _i4 < listRemoteMethods.length; _i4++) {
	        var remoteMethod = listRemoteMethods[_i4];
	        if (formPrefetchCommandResult.commandResults.hasOwnProperty(remoteMethod.methodName)) {
	          remoteMethod.commandResult = formPrefetchCommandResult.commandResults[remoteMethod.methodName];
	        }
	      }
	    }
	  }
	  //TODO IE 暂不考虑自定义查询 导出
	  /*if(formObjectUserSet.mapUserQueryDefault)
	  {
	    for(let key in formObjectUserSet.mapUserQueryDefault)
	    {
	      let holeKey = key+"."+window.menuItemId;
	       if(!formObjectUserSet.mapUserQueryDefault[key]
	        || !formObjectUserSet.mapUserQueryDefault[key].xml
	      )
	      {
	        delete QueryUtil.userQueryList[holeKey];
	      }
	      else
	      {
	        var obj = formObjectUserSet.mapUserQueryDefault[key];
	        //如果有默认的话 obj.xml是后台保存的xml
	        //如果obj.xml不是JSON 那就调用转换函数转换成JSON
	        obj.xml = QueryUtil.xmlQuery2JsonQuery(obj.xml);
	        QueryUtil.userQueryList[holeKey] = obj.xml;
	      }
	    }
	    }
	   if(formObjectUserSet.mapUserExportDefault)
	  {
	     for(let key in formObjectUserSet.mapUserExportDefault)
	    {
	      if(!formObjectUserSet.mapUserExportDefault[key]
	        || formObjectUserSet.mapUserExportDefault[key] == ""
	        || !formObjectUserSet.mapUserExportDefault[key].xml
	      )
	      {
	       }
	      else
	      {
	        let holeKey = key + "." + window.menuItemId;
	        let obj = formObjectUserSet.mapUserExportDefault[key];
	        FormDataSources.userExportList[holeKey] = obj.xml;
	      }
	    }
	  }*/
	  _parentWindow[_key].mapFormObjectAuthority = data.mapFormObjectAuthority;
	  //setFormAuthority(data.mapFormObjectAuthority,formXML,window.menuItemId);
	
	  if (formObjectUserSet.userFormDefault && formObjectUserSet.userFormDefault.xml) {
	    if (!_parentWindow.userSetForms || !_parentWindow.userSetForms.hasOwnProperty(openArgs.menuItemId + "." + formXML.id)) {
	      var getxml = new DOMParser();
	      var formDefaultDoc = getxml.parseFromString(formObjectUserSet.userFormDefault.xml, "text/xml");
	      var mergedXML = _UserFormUtil2.default.mergeXML(formDefaultDoc.documentElement, xmlDoc, formObjectStandard.formNodeList);
	      if (mergedXML) {
	        if (!_parentWindow.userProperties) _parentWindow.userProperties = {};
	        _parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
	        var userFormXML = _GOTUtil2.default.parseUserForm2Form(xmlDoc, mergedXML);
	        var formDesign = xmlDoc.children[2];
	        xmlDoc.removeChild(formDesign);
	        xmlDoc.appendChild(userFormXML);
	        var defaultForm = _GOTXML2Json2.default.parseForm(xmlDoc);
	        if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
	        _parentWindow.userSetForms[openArgs.menuItemId + "." + formXML.id] = defaultForm;
	      }
	    }
	  }
	
	  _parentWindow.setFormWholeObjectCache(openArgs.menuItemId, openArgs.formId, data);
	
	  //window.ieOpenMenuItemArgsMQ.push(args);
	
	  if (!$.isEmptyObject(openArgs.argCaller)) sessionStorage.setItem("callerArg", JSON.stringify(openArgs.argCaller));
	  testOpenForm(openArgs);
	};
	
	window.exeParentCommandResult = function (formUUId, commandResult) {
	  var hasRelatedForm = false;
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow && this.contentWindow.formModuleInstanceuuId && this.contentWindow.formModuleInstanceuuId == formUUId) {
	      this.contentWindow.exeCommandResult(commandResult);
	      return false;
	    }
	  });
	
	  var popIframes = $("#formModal iframe");
	  for (var i = 0; i < popIframes.length; i++) {
	    var iframe = popIframes.get(i);
	    var iframeSrc = iframe.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (iframe.contentWindow && iframe.contentWindow.formModuleInstanceuuId && iframe.contentWindow.formModuleInstanceuuId == formUUId) {
	      iframe.contentWindow.exeCommandResult(commandResult);
	      return false;
	    }
	  }
	};
	
	window.switchToRelatedForm = function (callerKey, formUUId) {
	  var hasRelatedForm = false;
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow.formModuleInstance && this.contentWindow.argCaller) {
	      var _argCaller = this.contentWindow.argCaller;
	      if (_argCaller.calleruuId == formUUId && callerKey != null && callerKey == _argCaller.callerKey) {
	        $("#g_nav_tabs>li.active").each(function () {
	          $(this).removeClass("active");
	          var origtabpaneid = $(this).attr("tabpaneid");
	          $("#" + origtabpaneid).removeClass("active");
	        });
	        hasRelatedForm = true;
	
	        $(this).parent().addClass("active");
	        var _tabpaneid = $(this).parent().attr("id");
	        $("#g_nav_tabs>li").each(function () {
	          if ($(this).attr("tabpaneid") == _tabpaneid) {
	            $(this).addClass("active");
	            return false;
	          }
	        });
	
	        return false;
	      }
	    }
	  });
	  return hasRelatedForm;
	};
	
	$('#g_tab_content .tab-pane iframe').each(function () {
	  if (this.id == '') {
	    window.formModuleInstance = this.contentWindow.formModuleInstance;
	  }
	});
	
	window.getJoinGroupObject = function (groupAlias, uuid) {
	  var joinGroup = null;
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    //if(this.contentWindow!=_window && typeof(this.contentWindow.linkGroupActiveHandler)=="function")
	    if (this.contentWindow.formModuleInstance && this.contentWindow.formModuleInstanceuuId == uuid) {
	      if (this.contentWindow.formModuleInstance.formDataSources) {
	        var groups = this.contentWindow.formModuleInstance.formDataSources.groups;
	        if (groups && groups.hasOwnProperty(groupAlias)) {
	          joinGroup = groups[groupAlias];
	          return false;
	        }
	      }
	    }
	  });
	
	  var popIframes = $("#formModal iframe");
	  for (var i = 0; i < popIframes.length; i++) {
	    var iframe = popIframes.get(i);
	    var iframeSrc = iframe.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      continue;
	    }
	    if (iframe.contentWindow.formModuleInstance && iframe.contentWindow.formModuleInstanceuuId == uuid) {
	      if (iframe.contentWindow.formModuleInstance.formDataSources) {
	        var groups = iframe.contentWindow.formModuleInstance.formDataSources.groups;
	        if (groups && groups.hasOwnProperty(groupAlias)) {
	          joinGroup = groups[groupAlias];
	          break;
	        }
	      }
	    }
	  }
	
	  return joinGroup;
	};
	
	window.linkGroupActiveJoin = function (group, formModuleInstanceuuId) {
	  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var updateRelatedPart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  try {
	    $("#g_tab_content .tab-pane iframe").each(function () {
	      var iframeSrc = this.src;
	      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	        return true;
	      }
	      //if(this.contentWindow!=_window && typeof(this.contentWindow.linkGroupActiveHandler)=="function")
	      if (this.contentWindow.formModuleInstance) {
	        this.contentWindow.formModuleInstance.formReinitHandler(group, formModuleInstanceuuId, delay, updateRelatedPart);
	      }
	    });
	
	    var popIframes = $("#formModal iframe");
	    for (var i = 0; i < popIframes.length; i++) {
	      var iframe = popIframes.get(i);
	      var iframeSrc = iframe.src;
	      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	        continue;
	      }
	      if (iframe.contentWindow.formModuleInstance) iframe.contentWindow.formModuleInstance.formReinitHandler(group, formModuleInstanceuuId, delay, updateRelatedPart);
	    }
	  } catch (e) {
	    //个别需求如嵌入三方网页时存在跨域如果不捕获会导致该函数中断影响功能
	  }
	};
	
	window.closeFormWithSameId = function (formId) {
	
	  $("#formModal iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow.formId == formId) {
	      closePopUpForm(null, formId);
	    }
	  });
	
	  /*var popIframes = $("#formModal iframe");
	  for(let i = 0;i<popIframes.length;i++)
	  {
	   }
	  if(popIframes.length>0)
	  {
	    var iframe = popIframes.get(0);
	    if(iframe.contentWindow.formId == formId)
	      closePopUpForm(null,formId);
	  }*/
	
	  var activeFormUUId = null;
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow.formId == formId) {
	      var formUUId = this.contentWindow.formModuleInstanceuuId;
	      var tabPane = $(this).parent();
	      if (tabPane.hasClass("active")) {
	        activeFormUUId = formUUId;
	      } else {
	        closeForm(formUUId);
	      }
	    }
	  });
	  if (activeFormUUId) closeForm(activeFormUUId);
	};
	
	window.getFormInstanceByUUID = function (formUUId) {
	  var formInstance = null;
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow.formModuleInstanceuuId == formUUId) {
	      formInstance = this.contentWindow.formModuleInstance;
	      return false;
	    }
	  });
	  if (!formInstance) {
	    $("#formModal iframe").each(function () {
	      if (this.contentWindow.formModuleInstanceuuId == formUUId) {
	        formInstance = this.contentWindow.formModuleInstance;
	        return false;
	      }
	    });
	  }
	  return formInstance;
	};
	
	window.closeForm = function (formUUId) {
	  var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var byKeyBoard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var hasClosed = false;
	  $("#formModal iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow.formModuleInstanceuuId == formUUId) {
	      closePopUpFormByUUId(formUUId, check);
	      return false;
	    }
	  });
	  //TODO_YL ESC 不关闭 画面
	  if (byKeyBoard == 27) {
	    return;
	  }
	
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    var iframeSrc = this.src;
	    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	      return true;
	    }
	    if (this.contentWindow.formModuleInstanceuuId == formUUId) {
	      if (!this.contentWindow.formModuleInstance) {
	        doCloseForm(this);
	        return;
	      }
	      var _menuItemId = this.contentWindow.menuItemId;
	      var _formId = this.contentWindow.formId;
	      var _formName = this.contentWindow.formModuleInstance.formName;
	      if (check) {
	        var _result = this.contentWindow.allowClose();
	        if (!_result.allow) {
	          if (_result.text) {
	            var _that = this;
	            _Warn2.default.show({
	              confirm: _result.noContinue ? {} : {
	                isShow: true, text: "继续关闭", event: function event() {
	
	                  doCloseForm(_that);
	
	                  var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
	                  if (mi) {
	                    if (mi.prefetch == true) {
	                      if (mi.commandResult) {
	                        _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	                      }
	                    } else {
	                      var arg = new _CommandArg2.default();
	                      var command = _CommandHelper2.default.createFormInstance(_formName, "doFormClosed", "void");
	                      command.appendArg(arg, "CommandArg");
	
	                      _ServiceHelper2.default.addTokenWithCommand({
	                        command: command,
	                        resultFunction: function resultFunction(result) {
	                          if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	                        }
	                      });
	                    }
	                  }
	                }
	              }, cancel: { isShow: true, event: '' }, text: _result.text
	            });
	          }
	
	          return;
	        }
	      }
	
	      doCloseForm(this);
	
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
	      if (mi) {
	        if (mi.prefetch == true) {
	          if (mi.commandResult) {
	            _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	          }
	        } else {
	          var arg = new _CommandArg2.default();
	          var command = _CommandHelper2.default.createFormInstance(_formName, "doFormClosed", "void");
	          command.appendArg(arg, "CommandArg");
	
	          _ServiceHelper2.default.addTokenWithCommand({
	            command: command,
	            resultFunction: function resultFunction(result) {
	              if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	            }
	          });
	        }
	      }
	
	      return false;
	    }
	  });
	};
	
	window.doCloseForm = function (_this) {
	  if (window.parent.window.isCanSave != undefined && window.parent.window.isCanSave == true) {
	    alert("请先保存业务导图");
	    return;
	  }
	  var tabPane = $(_this).parent();
	  if (tabPane.hasClass("active")) {
	    var arr = $("#g_tab_content>div.tab-pane");
	
	    var nextIndexTemp = -1;
	    if (window.previousGlobalTabPageId) {
	      var pagearrTemp = $("#g_nav_tabs>li");
	      for (var _i5 = 0; _i5 < pagearrTemp.length; _i5++) {
	        var pageTemp = pagearrTemp[_i5];
	        if ($(pageTemp).attr("tabpaneid") == window.previousGlobalTabPageId) {
	          nextIndexTemp = _i5;
	          break;
	        }
	      }
	    }
	
	    var nextIndex = nextIndexTemp;
	    var childIndex = tabPane.index();
	    if (nextIndex == -1 || nextIndex == childIndex) {
	      if (childIndex - 1 < 0) {
	        if (childIndex + 1 < arr.length) nextIndex = childIndex + 1;
	      } else {
	        nextIndex = childIndex - 1;
	      }
	    }
	
	    var pagearr = $("#g_nav_tabs>li");
	    var liWillRemoved = $("#g_nav_tabs>li.active");
	    var nextpage = pagearr[nextIndex];
	    $(nextpage).addClass("active");
	    $(arr[nextIndex]).addClass("active");
	    var nextIframe = $(arr[nextIndex]).find("iframe");
	    if (nextIframe.length != 0) {
	      var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	      $("#ActiveRecordCount").text("");
	      if (typeof win.closeToCurrent == 'function') win.closeToCurrent();
	    } else {
	      setToolBar(clearToolbarObject);$("#ActiveRecordCount").text("");
	    }
	    tabPane.remove();
	    liWillRemoved.remove();
	  } else {
	    var tabpaneid = tabPane.attr("id");
	    var $li;
	    $("#g_nav_tabs>li").each(function () {
	      if ($(this).attr("tabpaneid") == tabpaneid) {
	        $li = $(this);
	        return false;
	      }
	    });
	    if ($li) $li.remove();
	    tabPane.remove();
	  }
	
	  if ($("#g_nav_tabs>li").length < 1) $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
	};
	
	window.setFormLabel = function (formUUId, label) {
	  var i = window.hasMenuMap ? 1 : 0;
	  var k = -1;
	  $("#g_tab_content .tab-pane iframe").each(function () {
	    try {
	      if (this.contentWindow.formModuleInstanceuuId == formUUId) {
	        k = i;
	        return false;
	      }
	    } catch (e) {}
	    i++;
	  });
	  var j = window.hasMenuMap ? 1 : 0;
	  if (k != -1) {
	    var as = $("#g_nav_tabs>li>a");
	    if (as.length > k - j) {
	      $(as[k - j]).html(label);
	    }
	  }
	};
	
	window.closePopUpFormByUUId = function (uuid) {
	  var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var modalList = $("#formModal .modal");
	  var modalForm;
	  if (modalList.length == 0) return;
	  //存在异常提醒 不关闭画面
	  if ($(".gongqi-warn").hasClass('gongqi-warn')) {
	    return;
	  }
	  var _menuItemId = void 0;var _formId = void 0;var _formName = void 0;
	  for (var _i6 = 0; _i6 < modalList.length; _i6++) {
	    var item = modalList.get(_i6);
	    var itemFrame = $(item).find("iframe");
	    var contentWindow = itemFrame.get(0).window || itemFrame.get(0).contentWindow;
	    if (contentWindow.formModuleInstanceuuId == uuid) {
	      if (check) {
	        var closeResult = contentWindow.allowClose();
	        if (!closeResult.allow) {
	          if (closeResult.text) {
	            var _that = this;
	            _Warn2.default.show({
	              confirm: {
	                isShow: true, text: "继续关闭", event: function event() {
	
	                  if (!modalForm) return;
	                  $(modalForm).remove();
	
	                  var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
	                  if (mi) {
	                    if (mi.prefetch == true) {
	                      if (mi.commandResult) {
	                        _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	                      }
	                    } else {
	                      var arg = new _CommandArg2.default();
	                      var command = _CommandHelper2.default.createFormInstance(_formName, "doFormClosed", "void");
	                      command.appendArg(arg, "CommandArg");
	
	                      _ServiceHelper2.default.addTokenWithCommand({
	                        command: command,
	                        resultFunction: function resultFunction(result) {
	                          if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	                        }
	                      });
	                    }
	                  }
	
	                  $("#ActiveRecordCount").text("");
	                  modalList = $("#formModal .modal");
	                  if (modalList.length > 0) {
	                    var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
	                  } else {
	                    var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
	                  }
	
	                  if (nextIframe.length != 0) {
	                    var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	                    if (typeof win.closeToCurrent == 'function') win.closeToCurrent();
	                  }
	                }
	              }, cancel: { isShow: true, event: '' }, text: closeResult.text
	            });
	          }
	          modalForm = item;_menuItemId = contentWindow.menuItemId;_formId = contentWindow.formId;_formName = contentWindow.formModuleInstance.formName;
	          return;
	        }
	      }
	      modalForm = item;_menuItemId = contentWindow.menuItemId;_formId = contentWindow.formId;_formName = contentWindow.formModuleInstance.formName;
	      break;
	    }
	  }
	  if (!modalForm) return;
	  //modalForm = modalList.get(modalList.length-1);
	  $(modalForm).remove();
	
	  var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
	  if (mi) {
	    if (mi.prefetch == true) {
	      if (mi.commandResult) {
	        _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	      }
	    } else {
	      var arg = new _CommandArg2.default();
	      var command = _CommandHelper2.default.createFormInstance(_formName, "doFormClosed", "void");
	      command.appendArg(arg, "CommandArg");
	
	      _ServiceHelper2.default.addTokenWithCommand({
	        command: command,
	        resultFunction: function resultFunction(result) {
	          if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	        }
	      });
	    }
	  }
	
	  $("#ActiveRecordCount").text("");
	  modalList = $("#formModal .modal");
	  if (modalList.length > 0) {
	    var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
	  } else {
	    var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
	  }
	
	  if (nextIframe.length != 0) {
	    var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	    if (typeof win.closeToCurrent == 'function') win.closeToCurrent();
	  }
	};
	
	window.closePopUpForm = function (menuItemId, formId) {
	  var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var modalList = $("#formModal .modal");
	  var modalForms = [];var modalFormsInfo = [];
	  if (modalList.length == 0) return;
	
	  var _loop = function _loop(_i7) {
	    var item = modalList.get(_i7);
	    var itemFrame = $(item).find("iframe");
	    var contentWindow = itemFrame.get(0).window || itemFrame.get(0).contentWindow;
	    if (!menuItemId) {
	      if (contentWindow.formId == formId) {
	        if (check) {
	          var closeResult = contentWindow.allowClose();
	          if (!closeResult.allow) {
	            if (closeResult.text) _Warn2.default.show({
	              confirm: {
	                text: "继续关闭", event: function event() {
	                  modalForms.push(item);
	                  modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName });
	                  window.doModalFormClose(modalForms, modalFormsInfo);
	                  window.setNextCurrentFormAfterClosePopUpForm();
	                  closePopUpForm(menuItemId, formId, check);
	                }
	              },
	              cancel: { isShow: true, text: "取消" }, text: closeResult.text
	            });
	            return {
	              v: void 0
	            };
	          }
	        }
	        modalForms.push(item);
	        modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName });
	      }
	    } else {
	      if (contentWindow.menuItemId == menuItemId && contentWindow.formId == formId) {
	        if (check) {
	          var _closeResult = contentWindow.allowClose();
	          if (!_closeResult.allow) {
	            if (_closeResult.text) _Warn2.default.show({
	              confirm: {
	                text: "继续关闭", event: function event() {
	                  modalForms.push(item);
	                  modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName });
	                  window.doModalFormClose(modalForms, modalFormsInfo);
	                  window.setNextCurrentFormAfterClosePopUpForm();
	                }
	              },
	              cancel: { isShow: true, text: "取消" }, text: _closeResult.text
	            });
	            return {
	              v: void 0
	            };
	          }
	        }
	        modalForms.push(item);
	        modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName });
	        return 'break';
	      }
	    }
	  };
	
	  _loop2: for (var _i7 = 0; _i7 < modalList.length; _i7++) {
	    var _ret = _loop(_i7);
	
	    switch (_ret) {
	      case 'break':
	        break _loop2;
	
	      default:
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	  }
	
	  if (modalForms.length == 0) return;
	
	  //modalForm = modalList.get(modalList.length-1);
	  window.doModalFormClose(modalForms, modalFormsInfo);
	  window.setNextCurrentFormAfterClosePopUpForm();
	};
	
	window.setNextCurrentFormAfterClosePopUpForm = function () {
	  var modalList = $("#formModal .modal");
	  if (modalList.length > 0) {
	    var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
	  } else {
	    var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
	  }
	
	  if (nextIframe.length != 0) {
	    var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	    if (typeof win.closeToCurrent == 'function') win.closeToCurrent();
	  }
	};
	
	window.doModalFormClose = function (modalForms, modalFormsInfo) {
	  for (var _i8 = 0; _i8 < modalForms.length; _i8++) {
	    var modalForm = modalForms[_i8];
	    $(modalForm).remove();
	    var modalFormInfo = modalFormsInfo[_i8];
	    var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", modalFormInfo.menuItemId, modalFormInfo.formId);
	    if (mi) {
	      if (mi.prefetch == true) {
	        if (mi.commandResult) {
	          _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	        }
	      } else {
	        var arg = new _CommandArg2.default();
	        var command = _CommandHelper2.default.createFormInstance(modalFormInfo.formName, "doFormClosed", "void");
	        command.appendArg(arg, "CommandArg");
	
	        _ServiceHelper2.default.addTokenWithCommand({
	          command: command,
	          resultFunction: function resultFunction(result) {
	            if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	          }
	        });
	      }
	    }
	
	    $("#ActiveRecordCount").text("");
	  }
	};
	
	window.getCurrentFormLabel = function (e) {
	  return $("#g_nav_tabs>li.active>a").text();
	};
	
	window.reOpenCurrentForm = function (e) {
	  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var popIframes = $("#formModal iframe");
	  if (popIframes.length > 0) {
	    iframe = popIframes.get(popIframes.length - 1);
	    var win = iframe.window || iframe.contentWindow;
	    //var argCallerString = sessionStorage.getItem("callerArg");
	    //if(argCallerString != undefined && argCallerString != null)
	    //{
	    //    sessionStorage.removeItem("callerArg");
	    //    var argCaller = JSON.parse(argCallerString);
	    //    window.argCaller = argCaller;
	    //}
	    if (win.argCaller) {
	      var argCallerString = JSON.stringify(win.argCaller);
	      sessionStorage.setItem("callerArg", argCallerString);
	    }
	    win.location.reload();
	  } else {
	    var arr = $("#g_tab_content>div.tab-pane.active iframe");
	    if (arr.length > 0) {
	      var iframe = arr.get(0);
	      var _win = iframe.window || iframe.contentWindow;
	      if (_win.argCaller) {
	        var _argCallerString = JSON.stringify(_win.argCaller);
	        sessionStorage.setItem("callerArg", _argCallerString);
	      }
	
	      /*if(arg)
	      {
	        win[arg.injectName]=arg.injectValue;
	      }*/
	
	      _win.location.reload();
	    }
	  }
	};
	
	//TODO 画面关闭是否需要React卸载
	window.closeCurrentForm = function (e) {
	  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
	  var tabpaneEl = document.getElementById(tabpaneid);
	  var $iframe = $(tabpaneEl).find(">iframe");
	  //var $iframe = $("#"+tabpaneid+" >iframe");
	
	  if ($iframe.length > 0) {
	    var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
	    if (win) closeForm(win.formModuleInstanceuuId, false);
	  }
	};
	window.closeAllForm = function (e) {
	  $("#g_nav_tabs").children("li:not(.menumap)").remove();
	  //打开画面 把content的背景隐藏 避免二次开发设置了带颜色的背景而造成显示问题 当都关掉的时候 需要再行恢复
	  if (window.hasMenuMap) {
	    $("#g_nav_tabs").children(".menumap").addClass('active');
	    $("#g_tab_content").children(".menumap").addClass('active');
	    $("#g_tab_content").children("div:not(.menumap)").remove();
	  } else {
	    $("#g_tab_content").empty().css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
	  }
	};
	window.closeOtherForm = function (e) {
	  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
	  $("#g_tab_content>div.tab-pane").each(function () {
	    if ($(this).hasClass("menumap")) return;
	    if ($(this).attr("id") != tabpaneid) {
	      var $iframe = $(this).find("iframe");
	
	      if ($iframe.length > 0) {
	        var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
	        if (win) closeForm(win.formModuleInstanceuuId, false);
	      }
	    }
	  });
	};
	window.closeRightForms = function (e) {
	  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
	  $("#g_tab_content>div.tab-pane").each(function () {
	
	    if ($(this).attr("id") != tabpaneid) {
	      if ($(e.currentTarget).index() < $(this).index()) {
	        var $iframe = $(this).find("iframe");
	        if ($iframe.length > 0) {
	          var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
	          if (win) closeForm(win.formModuleInstanceuuId, false);
	        }
	      }
	    }
	  });
	};
	window.closeLeftForms = function (e) {
	  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
	  $("#g_tab_content>div.tab-pane").each(function () {
	    if ($(this).hasClass("menumap")) return;
	    if ($(this).attr("id") != tabpaneid) {
	      if ($(e.currentTarget).index() > $(this).index()) {
	        var $iframe = $(this).find("iframe");
	        if ($iframe.length > 0) {
	          var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
	          if (win) closeForm(win.formModuleInstanceuuId, false);
	        }
	      }
	    }
	  });
	};
	
	var globalStep = 0;
	
	var tabpageContextMenuItems = [{ label: '关闭标签页', icon: '', action: closeCurrentForm }, { label: '关闭所有标签页', icon: '', action: closeAllForm }, { label: '关闭其它标签页', icon: '', action: closeOtherForm }, { label: '关闭右侧标签页', icon: '', action: closeRightForms }, { label: '关闭左侧标签页', icon: '', action: closeLeftForms }];
	
	window.testOpenForm = function (args) {
	  //label,formId,menuItemId,onlyQuery,popUp,fixedUrl
	
	  var _label_ = args.label;var _tid_ = args.formId;var _mid_ = args.menuItemId;
	  var onlyQuery = args.onlyQuery;var popUp = args.popUp;var fixedUrl = args.fixedUrl;
	  var _onlyQuery = onlyQuery == true ? true : false;var _fromMainMenu = args.fromMainMenu ? true : false;
	  var _tidid_ = _tid_ + globalStep;globalStep++;
	  if (args.manual) {
	    var menuItem = args.menuItem;
	    var htmlName = _GOTUtil2.default.getPropertyValue(menuItem, "RefObject") || _GOTUtil2.default.getPropertyValue(menuItem, "Source");
	    if (htmlName) {
	      fixedUrl = "html/" + htmlName + "/" + htmlName + ".html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu;
	    }
	  }
	
	  /*if(popUp)
	  {
	    var modalDiv = $("<div>").addClass("modal").css("display","block").css("top","50px").css("z-index","900");
	    var iframe = $("<iframe>").css("width","100%").css("height","100%").css("border","none").attr("id","iframe"+_tidid_);
	    if(!fixedUrl)
	        {iframe.attr("src","form.html?menuItemId="+_mid_+"&formId="+_tid_+"&popUp=true&onlyQuery="+_onlyQuery);}
	    else
	        {iframe.attr("src",fixedUrl);iframe.attr("id","iframe"+_mid_);setToolBar(clearToolbarObject);}
	    $("#formModal").append(modalDiv.append(iframe));
	    return;
	  }*/
	  // 万能视图设计器 预览form
	  if (popUp && args.isDataSetPreview) {
	    var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "2000").css("align-items", "center").css("justify-content", "center");
	    if (window.userSettingEntry && window.userSettingEntry.hideToolBar == true) {
	      modalDiv.css("top", "28px");
	    }
	    //if(ugse.hideToolBar == true)
	    //  ugse.innerToolBar = true;
	    var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + _tidid_).css("width", "100%").css("height", "100%").css("background-color", "transparent");
	    if (!fixedUrl) {
	      iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&popUp=true&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu);
	    } else {
	      iframe.attr("src", fixedUrl);iframe.attr("id", "iframe" + _mid_);setToolBar(clearToolbarObject);
	    }
	    $("#formModal").append(modalDiv.append(iframe));
	    return;
	  }
	  if (popUp && args.datasetSeting) {
	    var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("top", "50px").css("z-index", "1051").css("align-items", "center").css("justify-content", "center");
	    if (window.userSettingEntry && window.userSettingEntry.hideToolBar == true) {
	      modalDiv.css("top", "28px");
	    }
	    //if(ugse.hideToolBar == true)
	    //  ugse.innerToolBar = true;
	    var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + _tidid_).css("width", "100%").css("height", "100%");
	    if (!fixedUrl) {
	      iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&popUp=true&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu);
	    } else {
	      iframe.attr("src", fixedUrl);iframe.attr("id", "iframe" + _mid_);setToolBar(clearToolbarObject);
	    }
	    $("#formModal").append(modalDiv.append(iframe));
	    return;
	  }
	
	  if (popUp) {
	    var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("top", "50px").css("z-index", "900").css("align-items", "center").css("justify-content", "center");
	    if (window.userSettingEntry && window.userSettingEntry.hideToolBar == true) {
	      modalDiv.css("top", "28px");
	    }
	    //if(ugse.hideToolBar == true)
	    //  ugse.innerToolBar = true;
	    var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + _tidid_).css("width", "100%").css("height", "100%");
	    if (!fixedUrl) {
	      iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&popUp=true&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu);
	    } else {
	      iframe.attr("src", fixedUrl);iframe.attr("id", "iframe" + _mid_);setToolBar(clearToolbarObject);
	    }
	    $("#formModal").append(modalDiv.append(iframe));
	    return;
	  }
	
	  if (window.openAlreadyExsistMenu == true) {
	    var has = false;
	    $("#g_tab_content .tab-pane iframe").each(function () {
	      var iframeSrc = this.src;
	      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
	        return true;
	      }
	      if (this.contentWindow.menuItemId == _mid_) {
	        $("#g_nav_tabs>li.active").each(function () {
	          $(this).removeClass("active");
	          var origtabpaneid = $(this).attr("tabpaneid");
	          $("#" + origtabpaneid).removeClass("active");
	        });
	
	        $(this).parent().addClass("active");
	        var _tabpaneid = $(this).parent().attr("id");
	        $("#g_nav_tabs>li").each(function () {
	          if ($(this).attr("tabpaneid") == _tabpaneid) {
	            $(this).addClass("active");
	            return false;
	          }
	        });
	        try {
	          if (typeof this.contentWindow.switchToCurrent == 'function') {
	            this.contentWindow.switchToCurrent();
	            if (window.openAlreadyExsistMenuReload) {
	              this.contentWindow.location.reload();
	            }
	          }
	        } catch (ee) {
	          //第三方跨域系统页面切换
	          setToolBar(clearToolbarObject);
	        }
	        has = true;
	        return false;
	      }
	    });
	    if (has == true) {
	      return;
	    }
	  }
	  // <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="true" style="padding:5px 15px;">Tab 1</a>
	  //  <i class="fa fa-close" style="position: absolute;top: 1px;right: 3px;"></i>
	  //  </li>
	  //var origtabpaneid;var origtabliactive;
	  $("#g_nav_tabs>li.active").each(function () {
	    /*if($(this).hasClass("active"))
	    {
	      origtabliactive = this;
	      origtabpaneid = $(this).attr("tabpaneid");
	      return false;
	    }*/
	    window.previousGlobalTabPageId = $(this).attr("tabpaneid");
	    $(this).removeClass("active");
	    var origtabpaneid = $(this).attr("tabpaneid");
	    //$("#"+origtabpaneid).removeClass("active");
	    var origtabpaneElement = document.getElementById(origtabpaneid);
	    $(origtabpaneElement).removeClass("active");
	  });
	  //var dotChangeReg = new RegExp("\.","g");
	  var tidid_changed = _tidid_ ? _tidid_.replace(/\./g, "_") : "";
	  var mid_changed = _mid_ ? _mid_.replace(/\./g, "_") : "";
	  var li = $("<li>").addClass("active").attr("tabpaneid", !fixedUrl ? tidid_changed : mid_changed).contextPopup({ items: tabpageContextMenuItems });
	  var a = $("<a>").attr("href", "#" + (!fixedUrl ? tidid_changed : mid_changed)).attr("data-toggle", "tab").attr("aria-expanded", "true").addClass("gongqi_tabpage").html(_label_);
	  var i = $("<i>").addClass("fa fa-close").css({ position: "absolute", top: "1px", right: "3px" });
	  li.append(a).append(i);
	  var childrenArray = $("#g_nav_tabs").children().toArray();
	  var targetIndex = childrenArray.length - 1 - 1; // 最后第二个位置的索引
	  var targetElement = childrenArray[targetIndex];
	  $(targetElement).after(li);
	
	  var gnavtab = $("#g_nav_tabs");
	  var leftDiff = li.offset().left - gnavtab.width();
	  if (leftDiff > 0) {
	    gnavtab.scrollLeft(gnavtab.scrollLeft() + leftDiff + li.width());
	  }
	
	  /*li.on('dragstart',function(e){
	    var data=e.originalEvent.dataTransfer;
	    data.setData('text/plain',$(this).index());
	  });
	   li.on('dragover',function(e){
	    e.originalEvent.preventDefault();
	  });
	  li.on('dragend',function(e){
	    e.originalEvent.preventDefault();
	  });
	  li.on('drop',function(e){
	    var origIndex=e.originalEvent.dataTransfer.getData('text/plain');
	    var nowIndex = $(this).index();
	    var parent = $(this).parent();
	    if(nowIndex+"" == origIndex+"")
	      return;
	    if(((nowIndex-1)+"") == origIndex+"")
	      return;
	    var origJqueryEle = $($("#g_nav_tabs > li")[origIndex]);
	    var nowJqueryEle = $($("#g_nav_tabs > li")[nowIndex]);
	    origJqueryEle.insertBefore(nowJqueryEle);
	  });*/
	
	  /*
	  <div class="tab-content" style="width:100%;height:100%;overflow:hidden" id="g_tab_content">
	          <div class="tab-pane active" id="tab_1" style="width:100%;height:100%">
	      <iframe style="width:100%;height:100%;padding-bottom:30px;" src="testInlineblock.html">
	      </iframe>
	          </div>
	  */
	  var divtabpane = $("<div>").addClass("tab-pane active").css({ width: "100%", height: "100%" }).attr("id", tidid_changed);
	  var iframe = $("<iframe>").css("width", "100%").css("height", "100%").css("border", "none").attr("id", "iframe" + _tidid_);
	  if (!fixedUrl) {
	    iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu);
	  } else {
	    iframe.attr("src", fixedUrl);iframe.attr("id", "iframe" + _mid_);divtabpane.attr("id", _mid_);setToolBar(clearToolbarObject);
	  }
	
	  /*li.on('click',function(e){
	    var tabpaneId = a.attr("href");
	    var preActiveLi = $("#g_nav_tabs>li.active");
	    preActiveLi.removeClass("active");
	    $(this).addClass("active");
	    var activepane = $("#g_tab_content>"+tabpaneId);
	    $("#g_tab_content>.tab-pane.active").removeClass("active");
	    activepane.addClass("active");
	     var win = iframe.get(0).window || iframe.get(0).contentWindow;
	    window.previousGlobalTabPageId = preActiveLi.attr("tabpaneid");
	    try
	    {
	      if(typeof(win.switchToCurrent) == 'function')
	        win.switchToCurrent();
	    }
	    catch(ee)
	    {
	      //第三方跨域系统页面切换
	      setToolBar(clearToolbarObject);
	    }
	   });*/
	
	  a.on("shown.bs.tab", function (e) {
	
	    var win = iframe.get(0).window || iframe.get(0).contentWindow;
	    // 获取已激活的标签页的名称
	    var activeTab = $(e.target);
	    // 获取前一个激活的标签页的名称
	    var previousTab = $(e.relatedTarget).text();
	    window.previousGlobalTabPageId = $(e.relatedTarget).parent().attr("tabpaneid");
	    try {
	      if (typeof win.switchToCurrent == 'function') win.switchToCurrent();
	    } catch (ee) {
	      //第三方跨域系统页面切换
	      setToolBar(clearToolbarObject);
	    }
	  });
	
	  $("#g_tab_content").append(divtabpane.append(iframe));
	  i.click(function () {
	    var iframeSrc = iframe[0].src;
	    var _formId = void 0;var _menuItemId = void 0;var _formName = void 0;
	    /*if(iframeSrc.indexOf(urlBase)!=0 && iframeSrc.indexOf(urlBase) != 0)
	    {
	      divtabpane.remove();
	      li.remove();
	      return;
	    }*/
	    //非跨域或者开发环境下 判断是否可关闭
	    if (iframeSrc.indexOf(urlBase) == 0 || iframeSrc.indexOf("http://127.0.0.1:8000") == 0) {
	      var _contentWindow = iframe[0].contentWindow;
	
	      //_contentWindow.beforeClose();
	
	      _formId = _contentWindow.formId;
	      _menuItemId = _contentWindow.menuItemId;
	      if (_contentWindow.formModuleInstance) {
	        _formName = _contentWindow.formModuleInstance.formName;
	        //if(_contentWindow.isFormOpening == true)
	        //  return;
	        var _result = typeof _contentWindow.allowClose == "function" ? _contentWindow.allowClose() : null;
	        if (_result && !_result.allow) {
	          if (_result.text) _Warn2.default.show({
	            confirm: _result.noContinue ? {} : {
	              isShow: true, text: "继续关闭", event: function event() {
	
	                if (li.hasClass("active")) {
	                  var arr = $("#g_tab_content>div.tab-pane");
	
	                  var nextIndexTemp = -1;
	                  if (window.previousGlobalTabPageId) {
	                    var pagearrTemp = $("#g_nav_tabs>li");
	                    for (var _i9 = 0; _i9 < pagearrTemp.length; _i9++) {
	                      var pageTemp = pagearrTemp[_i9];
	                      if ($(pageTemp).attr("tabpaneid") == window.previousGlobalTabPageId) {
	                        nextIndexTemp = _i9;
	                        break;
	                      }
	                    }
	                  }
	
	                  var nextIndex = nextIndexTemp;
	                  var childIndex = divtabpane.index();
	                  if (nextIndex == -1 || nextIndex == childIndex) {
	                    if (childIndex - 1 < 0) {
	                      if (childIndex + 1 < arr.length) nextIndex = childIndex + 1;
	                    } else {
	                      nextIndex = childIndex - 1;
	                    }
	                  }
	
	                  var pagearr = $("#g_nav_tabs>li");
	                  var nextpage = pagearr[nextIndex];
	                  $(nextpage).addClass("active");
	                  $(arr[nextIndex]).addClass("active");
	                  var nextIframe = $(arr[nextIndex]).find("iframe");
	                  try {
	                    if (nextIframe.length != 0) {
	                      var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	                      $("#ActiveRecordCount").text("");
	                      if (typeof win.closeToCurrent == 'function') win.closeToCurrent();
	                    } else {
	                      setToolBar(clearToolbarObject);
	                      $("#ActiveRecordCount").text("");
	                    }
	                  } catch (ee) {
	                    setToolBar(clearToolbarObject);
	                  }
	                }
	                window.destroyIframe(divtabpane.find("iframe").get(0));
	                divtabpane.remove();
	                li.remove();
	
	                var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
	                if (mi) {
	                  if (mi.prefetch == true) {
	                    if (mi.commandResult) {
	                      _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	                    }
	                  } else {
	                    var arg = new _CommandArg2.default();
	                    var command = _CommandHelper2.default.createFormInstance(_formName, "doFormClosed", "void");
	                    command.appendArg(arg, "CommandArg");
	
	                    _ServiceHelper2.default.addTokenWithCommand({
	                      command: command,
	                      resultFunction: function resultFunction(result) {
	                        if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	                      }
	                    });
	                  }
	                }
	
	                if ($("#g_nav_tabs>li").length < 1) $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
	              }
	            }, cancel: { isShow: true }, text: _result.text
	          });
	          return;
	        }
	      }
	    }
	
	    if (li.hasClass("active")) {
	      var arr = $("#g_tab_content>div.tab-pane");
	      var nextIndexTemp = -1;
	      if (window.previousGlobalTabPageId) {
	        var pagearrTemp = $("#g_nav_tabs>li");
	        for (var _i10 = 0; _i10 < pagearrTemp.length; _i10++) {
	          var pageTemp = pagearrTemp[_i10];
	          if ($(pageTemp).attr("tabpaneid") == window.previousGlobalTabPageId) {
	            nextIndexTemp = _i10;
	            break;
	          }
	        }
	      }
	
	      var nextIndex = nextIndexTemp;
	      var childIndex = divtabpane.index();
	      if (nextIndex == -1 || nextIndex == childIndex) {
	        if (childIndex - 1 < 0) {
	          if (childIndex + 1 < arr.length) nextIndex = childIndex + 1;
	        } else {
	          nextIndex = childIndex - 1;
	        }
	      }
	
	      var pagearr = $("#g_nav_tabs>li");
	      var nextpage = pagearr[nextIndex];
	      $(nextpage).addClass("active");
	
	      var nextIframe = $(arr[nextIndex]).find("iframe");
	      var cont = nextIndex;
	      if (nextIframe[0] && nextpage.getAttribute('tabpaneid') && nextIframe[0].id != nextpage.getAttribute('tabpaneid')) {
	        for (var _i11 = 0; _i11 < arr.length; _i11++) {
	          if ($(arr[_i11]).find("iframe")[0] && $(arr[_i11]).find("iframe")[0].id == "iframe" + nextpage.getAttribute('tabpaneid')) {
	            nextIframe = $(arr[_i11]).find("iframe");
	            cont = _i11;
	          }
	        }
	      }
	      $(arr[cont]).addClass("active");
	      try {
	        if (nextIframe.length != 0) {
	          var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	          $("#ActiveRecordCount").text("");
	          if (typeof win.closeToCurrent == 'function') win.closeToCurrent();
	        } else {
	          setToolBar(clearToolbarObject);
	          $("#ActiveRecordCount").text("");
	        }
	      } catch (ee) {
	        setToolBar(clearToolbarObject);
	        $("#ActiveRecordCount").text("");
	      }
	    }
	
	    window.destroyIframe(divtabpane.find("iframe").get(0));
	
	    divtabpane.remove();
	    li.remove();
	
	    if (_formId && _menuItemId && _formName) {
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
	      if (mi) {
	        if (mi.prefetch == true) {
	          if (mi.commandResult) {
	            _CommandResolver2.default.resolve(mi.commandResult.tasks, null);
	          }
	        } else {
	          var arg = new _CommandArg2.default();
	          var command = _CommandHelper2.default.createFormInstance(_formName, "doFormClosed", "void");
	          command.appendArg(arg, "CommandArg");
	
	          _ServiceHelper2.default.addTokenWithCommand({
	            command: command,
	            resultFunction: function resultFunction(result) {
	              if (result.result && result.result.tasks && result.result.tasks.length > 0) _CommandResolver2.default.resolve(result.result.tasks, null);
	            }
	          });
	        }
	      }
	    }
	
	    if ($("#g_nav_tabs>li").length < 1) $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
	  });
	
	  //$(origtabliactive).removeClass("active");
	  //$("#"+origtabpaneid).removeClass("active");
	  $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;background-size:0px!important");
	};
	
	window.destroyIframe = function (iframe) {
	  //把iframe指向空白页面，这样可以释放大部分内存。
	  //第三方页面的内存则无法释放
	  iframe.src = null; //'about:blank';
	  try {
	    $(iframe.contentWindow.document).unbind().die(); //remove listeners on document
	    $(iframe.contentWindow.document).find('*').unbind().die(); //remove listeners on all nodes
	    iframe.contentWindow.document.write('');
	    iframe.contentWindow.document.clear();
	    iframe.contentWindow.location.reload();
	    iframe.contentWindow.close();
	    $(iframe).empty();
	  } catch (e) {}
	  //把iframe从页面移除
	  iframe.parentNode.removeChild(iframe);
	};
	
	var clearToolbarObject = { MainMenu: false, Print: false, Export: false, Da: false, Attachment: false, WorkFlowDetail: false, QueryOpen: false, QueryRemove: false, FindOpen: false, CursorPrev: false, CursorNext: false, RecordNew: false, RecordSave: false, EditModeChange: false, RecordRestore: false, RecordDelete: false };
	
	window.setToolBar = function (obj) {
	  if (!obj) return;
	  window.lastToolBarObject = obj;
	  /*obj.MainMenu == true ? 
	    $("#toolbar_mainMenu").attr("onclick", "mainMenu(event)").attr("en", "true").find("i").css("color", "#FFFFFF") : 
	    $("#toolbar_mainMenu").removeAttr("onclick").removeAttr("en").find("i").css("color", "#3782BB");*/
	  obj.MainMenu == true ? $("#toolbar_mainMenu").attr("onclick", "mainMenu(event)").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_mainMenu").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  // $("#toolbar_print").attr("onclick", "print(event)").attr("en", "true").find("i").css("color", "#1D85ED") ;
	
	  // obj.Export == true ? $("#toolbar_export").attr("onclick", "toobarFunc(event,'groupExport','')").attr("en", "true").find("i").css("color", "#1D85ED") : $("#toolbar_export").removeAttr("onclick").removeAttr("en").find("i").css("color", "#c2c2c2");
	
	  //  obj.Export == true ? 
	  //     $("#toolbar_export").attr("onclick", "toobarFunc(event,'groupExport','')").attr("en", "true").removeClass("disable").addClass("enable"):
	  //     $("#toolbar_export").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  obj.Export == true ? $("#toolbar_export").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_export").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.Export) {
	    $("#toolbar_export  .icon-container").addClass("disable");
	    $("#toolbar_export  .menubtnLable").addClass("disable");
	  } else {
	    $("#toolbar_export .icon-container").removeClass("disable");
	    $("#toolbar_export  .menubtnLable").removeClass("disable");
	  }
	  //obj.Da == true ? $("#toolbar_Da").attr("onclick", "toobarFunc(event,'da','')").attr("en", "true").find("i").css("color", "#1D85ED") : $("#FFFFFF").removeAttr("onclick").removeAttr("en").find("i").css("color", "#c2c2c2");
	
	  //  obj.Da == true ?
	  //     $("#toolbar_Da").attr("onclick", "toobarFunc(event,'da','')").attr("en", "true").removeClass("disable").addClass("enable"):
	  //     $("#toolbar_Da").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	  obj.Da == true ? $("#toolbar_Da").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_Da").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.Da) {
	    $("#toolbar_Da  .icon-container").addClass("disable");
	    $("#toolbar_Da  .menubtnLable").addClass("disable");
	  } else {
	    $("#toolbar_Da .icon-container").removeClass("disable");
	    $("#toolbar_Da  .menubtnLable").removeClass("disable");
	  }
	
	  if (obj.Attachment == true) {
	    $("#toolbar_Attchment").attr("en", "true").removeClass("disable").addClass("enable");
	    // $("#attachmentNum").show();
	    // $("#attachmentNum2").show();
	  } else {
	    $("#toolbar_Attchment").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	    $("#attachmentNum").hide();
	    $("#attachmentNum2").hide();
	  }
	  if (obj.Attachment == true) {
	    $("#toolbar_Attchment").removeClass("disable");
	    $("#toolbar_Attchment .icon-container").removeClass("disable");
	    $("#toolbar_Attchment  .menubtnLable").removeClass("disable");
	  } else {
	    $("#toolbar_Attchment").addClass("disable");
	    $("#toolbar_Attchment  .icon-container").addClass("disable");
	    $("#toolbar_Attchment  .menubtnLable").addClass("disable");
	  }
	
	  //obj.WorkFlowDetail == true ? $("#toolbar_Workflow").attr("onclick", "toobarFunc(event,'workFlow','')").attr("en", "true").find("i").css("color", "#1D85ED") : $("#toolbar_Workflow").removeAttr("onclick").removeAttr("en").find("i").css("color", "#c2c2c2");
	  obj.WorkFlowDetail == true ? $("#toolbar_Workflow").attr("onclick", "toobarFunc(event,'workFlow','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_Workflow").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  // obj.QueryOpen == true ? 
	  //   $("#toolbar_Queryopen").attr("onclick", "toobarFunc(event,'queryOpen','')").attr("en", "true").removeClass("disable").addClass("enable") : 
	  //   $("#toolbar_Queryopen").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	  obj.QueryOpen == true ? $("#toolbar_Queryopen").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_Queryopen").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.QueryOpen) {
	    $("#toolbar_Queryopen  .icon-container").addClass("disable");
	    $("#toolbar_Queryopen  .menubtnLable").addClass("disable");
	  } else {
	    $("#toolbar_Queryopen .icon-container").removeClass("disable");
	    $("#toolbar_Queryopen  .menubtnLable").removeClass("disable");
	  }
	
	  obj.QueryRemove == true ? $("#toolbar_queryRemove").attr("onclick", "toobarFunc(event,'queryRemove','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_queryRemove").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.QueryRemove) {
	    $("#toolbar_queryRemove  .icon-container").addClass("disable");
	    $("#toolbar_queryRemove  .menubtnLable").addClass("disable");
	  } else {
	    $("#toolbar_queryRemove .icon-container").removeClass("disable");
	    $("#toolbar_queryRemove  .menubtnLable").removeClass("disable");
	  }
	  obj.FindOpen == true ? $("#toolbar_find").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_find").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.FindOpen) {
	    $("#toolbar_find  .icon-container").addClass("disable");
	    $("#toolbar_find  .menubtnLable").addClass("disable");
	  } else {
	    $("#toolbar_find .icon-container").removeClass("disable");
	    $("#toolbar_find  .menubtnLable").removeClass("disable");
	  }
	  obj.CursorPrev == true ? $("#toolbar_recordPrev").attr("onclick", "toobarFunc(event,'recordPrev','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_recordPrev").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  obj.CursorNext == true ? $("#toolbar_recordNext").attr("onclick", "toobarFunc(event,'recordNext','')(event)").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_recordNext").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  obj.RecordNew == true ? $("#toolbar_recordNew").attr("onclick", "toobarFunc(event,'recordNew','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_recordNew").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.RecordNew) {
	    $("#toolbar_recordNew  .icon-container").addClass("disable");
	    $("#toolbar_recordNew  .menubtnLable").addClass("disable");
	    $("#toolbar_recordNew  .menubtnCut").addClass("disable");
	  } else {
	    $("#toolbar_recordNew .icon-container").removeClass("disable");
	    $("#toolbar_recordNew  .menubtnLable").removeClass("disable");
	    $("#toolbar_recordNew  .menubtnCut").removeClass("disable");
	  }
	  obj.RecordSave == true ? $("#toolbar_save").attr("onclick", "toobarFunc(event,'recordSave','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_save").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.RecordSave) {
	    $("#toolbar_save  .icon-container").addClass("disable");
	    $("#toolbar_save  .menubtnLable").addClass("disable");
	    $("#toolbar_save  .menubtnCut").addClass("disable");
	  } else {
	    $("#toolbar_save .icon-container").removeClass("disable");
	    $("#toolbar_save  .menubtnLable").removeClass("disable");
	    $("#toolbar_save  .menubtnCut").removeClass("disable");
	  }
	  obj.EditModeChange == true ? $("#toolbar_switchEditMode").attr("onclick", "toobarFunc(event,'switchEditMode','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_switchEditMode").removeAttr("onlick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  obj.RecordRestore == true ? $("#toolbar_recordRestore").attr("onclick", "toobarFunc(event,'recordRestore','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_recordRestore").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	
	  if (!obj.RecordRestore) {
	    $("#toolbar_recordRestore  .icon-container").addClass("disable");
	    $("#toolbar_recordRestore  .menubtnLable").addClass("disable");
	    $("#toolbar_recordRestore  .menubtnCut").addClass("disable");
	  } else {
	    $("#toolbar_recordRestore .icon-container").removeClass("disable");
	    $("#toolbar_recordRestore  .menubtnLable").removeClass("disable");
	    $("#toolbar_recordRestore  .menubtnCut").removeClass("disable");
	  }
	
	  obj.RecordDelete == true ? $("#toolbar_recordDelete").attr("onclick", "toobarFunc(event,'recordDelete','')").attr("en", "true").removeClass("disable").addClass("enable") : $("#toolbar_recordDelete").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
	  if (!obj.RecordDelete) {
	    $("#toolbar_recordDelete  .icon-container").addClass("disable");
	    $("#toolbar_recordDelete  .menubtnLable").addClass("disable");
	    $("#toolbar_recordDelete  .menubtnCut").addClass("disable");
	  } else {
	    $("#toolbar_recordDelete .icon-container").removeClass("disable");
	    $("#toolbar_recordDelete  .menubtnLable").removeClass("disable");
	    $("#toolbar_recordDelete  .menubtnCut").removeClass("disable");
	  }
	};
	
	window.replaceBaseUrl = function (url) {
	  //urlBase.substring(0,urlBase.lastIndexOf("/"))+url.substr(9);
	  var domain = window.didomain;
	  if (domain) {
	    url = url.replace("GongqiERP", "GongqiERP/" + domain);
	  }
	  return urlBase + url.substr(9);
	};
	
	window.getLoginMode = function () {
	  var reg = new RegExp("(^|&)" + "loginMode" + "=([^&]*)(&|$)", "i");
	  var r = window.location.search.substr(1).match(reg);
	  if (r != null) return unescape(r[2]);else return null;
	};
	
	window.shoLogoArea = function (imageBack) {
	  // if (window.logo_Mode == "text") {
	  //   $("#g_title_area .logo-lg>b").html(logo_Text).css("color", imageBack == 2 ? "#fff" : "#000");
	
	  // }
	  // else if (window.logo_Mode == "image") {
	  //   if (imageBack == 2)
	  //     $("#g_title_area").css({
	  //       'background-image': 'url(customdev/images/' + logo_Image_BackBlue + ')',
	  //       'background-repeat': 'no-repeat', 'background-position': 'center'
	  //     });
	  //   else
	  //     $("#g_title_area").css({
	  //       'background-image': 'url(customdev/images/' + logo_Image_BackWhite + ')',
	  //       'background-repeat': 'no-repeat', 'background-position': 'center'
	  //     });
	  // }
	};
	
	window.initUGS = function (ugse) {
	  if (ugse) {
	    //ugse.showLeftListMenu = true;
	    //Object.assign({remoteClass:"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity"},window.userSettingEntry);
	    window.userSettingEntryOrig = Object.assign({ remoteClass: "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity" }, ugse);
	    if (window.userSettingEntryOrig.menuCustomObject) {
	      if (typeof window.userSettingEntryOrig.menuCustomObject == "string") {
	        try {
	          window.userSettingEntryOrig.menuCustomObject = JSON.parse(window.userSettingEntryOrig.menuCustomObject);
	        } catch (e) {
	          //TODO 在删除自定义菜单中全部常用及分组后 保存 后台传回的字符串不是有效JSON
	          window.userSettingEntryOrig.menuCustomObject = null;
	        }
	      }
	    }
	    window.userSettingEntry = ugse;
	    if (ugse.hideToolBar == true) ugse.innerToolBar = true;
	    ugse.showBottomSum = true;
	
	    if (window.userSettingEntry.showLeftMenu == true && window.userSettingEntry.showLeftListMenu == true) window.userSettingEntry.showLeftMenu = false;else if (!window.userSettingEntry.showLeftMenu && !window.userSettingEntry.showLeftListMenu && !window.userSettingEntry.showToolMenu) {
	      $("#g_nav_tabs").css('margin-left', '0px');
	      $("#g_nav_tab_close").css('display', 'none');
	      var content_Wrapper = document.getElementById("contentWrapper");
	      content_Wrapper.className += ' NoMune_content';
	    }
	    // window.userSettingEntry.showLeftListMenu = true;
	    /*window.userSettingEntry.showLeftListMenu = true;
	    window.userSettingEntry.showLeftMenu = false;
	    window.userSettingEntry.showToolMenu = true;*/
	  } else {
	    window.userSettingEntry = {
	      autoEnterList: false,
	      //clickEnterList:false,
	      //flickerTime:800,
	      isAutoSavePrompt: false,
	      isDelPrompt: true,
	      isEditMode: true,
	      isEditModeHelp: true,
	      isRecSavePrompt: false, isReportBrowser: true, isShowBusyRemote: true,
	      showOprInfo: false, downNewRec: false, showLeftMenu: true, showToolMenu: false,
	      innerToolBar: false, hideToolBar: false, showBottomSum: false
	    };
	
	    window.userSettingEntryOrig = Object.assign({ remoteClass: "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity" }, window.userSettingEntry);
	  }
	
	  /*全屏设置的优先级高于用户自定义设置 一旦全屏 菜单的设置将无意义*/
	  if (window.autoFullScreen) {
	    window.userSettingEntry.showLeftMenu = false;
	    window.userSettingEntry.showLeftListMenu = false;
	    window.userSettingEntry.showToolMenu = false;
	  }
	
	  $("#g_nav_tabs").addClass("g_nav_tabs_background"); //css("background","#CAD7E3");
	  $("#toolBarMainMenuToggleA>button").show();
	  //window.userSettingEntry.hideToolBar = true;
	  if (window.userSettingEntry.hideToolBar == true) {
	    $(".main-header").css("display", "none");
	    $(".content-wrapper").css("padding-top", "0px");
	    $('.main-sidebar').css('padding-top', '0px');
	  } else {
	    if (window.userSettingEntry.showLeftListMenu == true) {
	      $(".main-header").css("display", "block");
	      // $(".navbar-static-top").css("border-bottom", "1px solid rgba(151,151,151,0.5)");
	    } else {
	      $(".main-header").css("display", "block"); //.css("border-bottom", "1px solid rgba(151,151,151,0.5)");
	    }
	
	    $(".content-wrapper").css("padding-top", "");
	    $(".main-sidebar").css("padding-top", '');
	  }
	
	  if (window.userSettingEntry.showLeftMenu == false) {
	    $(".main-sidebar").css("display", "none");
	    $(".content-wrapper").css("margin-left", '0px');
	    $(".main-footer").css("margin-left", '0px');
	    $(".content-wrapper").css("padding-top", '80px');
	    $("#g_nav_tab_close").css("left", '161px');
	    if (window.userSettingEntry.showLeftListMenu == true) {
	      var wrappers = document.getElementsByClassName("wrapper");
	      var wrapper = wrappers[0];
	      wrapper.className += ' listMune_weapper';
	      var content_Wrapper = document.getElementById("contentWrapper");
	      content_Wrapper.className += ' listMune_content';
	    }
	  } else {
	    $(".main-sidebar").css("display", "block");
	    $(".content-wrapper").css("margin-left", '200px');
	    $(".main-footer").css("margin-left", '200px');
	    $("#g_nav_tab_close").css("left", '201px');
	    $(".content-wrapper").css("padding-top", '42px');
	    var content_Wrapper = document.getElementById("contentWrapper");
	    content_Wrapper.className += ' treeMune_content';
	    var wrappers = document.getElementsByClassName("wrapper");
	    var wrapper = wrappers[0];
	    wrapper.className += ' treeMune_wrapper';
	  }
	
	  if (window.userSettingEntry.showLeftListMenu == true) {
	    var htmlStyleAttr = $('html').attr('style');
	    if (htmlStyleAttr) $('html').attr('style', htmlStyleAttr.replace('height: auto;', ''));
	    var bodyStyleAttr = $('body').attr('style');
	    if (bodyStyleAttr) $('body').attr('style', bodyStyleAttr.replace('height: auto;', ''));
	    var _wrapperAttr = $("body>div.wrapper").attr('style');
	    if (!_wrapperAttr) _wrapperAttr = "";
	    $("body>div.wrapper").addClass("listtree-sidebar-wrapper").attr('style', _wrapperAttr.replace('height: auto;', ''));;
	    $(".listtree-sidebar").css("display", "block");
	
	    $(".content-wrapper").css("margin-left", '160px').css("padding-top", '0px');
	
	    if (window.userSettingEntry.showToolMenu == true) {
	      $("#listMainMenu").css("margin-left", '100px');$('.navbar-static-top').css('margin-left', '100px');
	      $('.logo-minihide').css({ width: '100px', position: 'absolute', top: '-30px', height: '30px', 'background-color': '#0078D4' });
	      $('.logo-minihide>.logo-lg').css({ height: '30px', 'line-height': '30px' });
	      $('.logo-minihide>.logo-lg>b').css('color', '#fff');
	    } else {
	      $("#listMainMenu").css("margin-left", '100px');$('.navbar-static-top').css('margin-left', '100px');
	      $('.logo-minihide').css({ width: '160px', position: 'absolute', height: '42px' });
	      $('.logo-minihide>.logo-lg>b').css('color', '#fff');
	    }
	
	    if (window.userSettingEntry.hideToolBar == true && window.userSettingEntry.showToolMenu == false) {
	      $(".listtree-sidebar").css("top", "0px");
	      $('.content-wrapper').css('top', '0px');
	    } else if (window.userSettingEntry.hideToolBar == true && window.userSettingEntry.showToolMenu == true) {
	      $(".listtree-sidebar").css("top", "30px");
	      $('.content-wrapper').css('top', '30px');
	    } else if (window.userSettingEntry.hideToolBar == false && window.userSettingEntry.showToolMenu == true) {
	      $(".listtree-sidebar").css("top", "80px");
	      $('.content-wrapper').css('top', '80px');
	    } else if (window.userSettingEntry.hideToolBar == false && window.userSettingEntry.showToolMenu == false) {
	      $(".listtree-sidebar").css("top", "42px");
	      $('.content-wrapper').css('top', '42px');
	    }
	    $(".main-footer").css("margin-left", '160px');
	    /*$(".slimScrollDiv").css("overflow",'').on('mousewheel',
	      function(e)
	      {
	        $(".sidebar").css("overflow",'hidden');$(".slimScrollDiv").css("overflow",'hidden');
	        //alert(223);
	      }
	    );
	    $(".sidebar").css("overflow",'');
	     var timer;
	    var mainMenu_sidebar = document.getElementById("mainMenu_sidebar");
	    mainMenu_sidebar.onscroll = function(e2)
	    {
	      clearTimeout(timer);
	      //alert("onscroll");
	      //$(".sidebar").css("overflow",'hidden');$(".slimScrollDiv").css("overflow",'hidden');
	      var t1 = mainMenu_sidebar.scrollTop;
	      timer = setTimeout(function(e3){
	         var t2 = mainMenu_sidebar.scrollTop;
	        if(t2 === t1)
	        {
	          $(".sidebar").css("overflow",'');
	          $(".slimScrollDiv").css("overflow",'');
	          mainMenu_sidebar.scrollTop = t2;
	        }
	      }, 500);
	    }*/
	
	    /*$(".main-sidebar").css({display:"block",width:"80px"}).find(".sidebar-form").css({display:"none"});
	    $(".content-wrapper").css("margin-left",'80px');
	    $(".main-footer").css("margin-left",'80px');*/
	  }
	
	  if (window.userSettingEntry.showToolMenu == true) {
	    //.$("#toolMenuControl").show();
	    //$("#toolMenuControl").attr("href","javascript:listMainMenuState();").append($("<i class='fa fa-bars'></i>"));
	
	    var content_Wrapper = document.getElementById("contentWrapper");
	    content_Wrapper.className += ' hasToolMenuControl';
	    var content_Wrapper = document.getElementById("mainFooterId");
	    content_Wrapper.className += ' hasToolMenuFooter';
	
	    var _caidanlan_ = void 0;
	    if (window.userSettingEntry.showLeftListMenu) {
	      _caidanlan_ = $("<a title='菜单栏' id='toolMenuControl' href='javascript:listMainMenuState();' class='logo' style='font-size:12px;width: 160px;text-align: left;padding: 0 0 0 44px;background:rgb(53, 68, 93,0.95);'><i class='fa fa-bars' style='color:#474747'></i><i class='fa menuControl-i fa-long-arrow-up' style='color: #474747;'></i></a>");
	      //$("#g_title_area").css("width", "100px").after(_caidanlan_);
	    } else {
	      _caidanlan_ = $("<a title='菜单栏' id='toolMenuControl' href='javascript:listMainMenuState();' class='logo' style='font-size:12px;width: 40px;text-align: left;padding: 0 0 0 3px;'><i class='fa fa-bars' style='color:#474747'></i><i class='fa menuControl-i fa-long-arrow-up' style='color: #474747;'></i></a>");
	      //$("#g_title_area").css("width", "160px").after(_caidanlan_);
	    }
	
	    if (!window.userSettingEntry.hideToolBar) {
	      $('.main-header').css('top', '30px');
	      $('.main-sidebar').css('top', '30px');
	
	      if (!window.userSettingEntry.showLeftListMenu) $('.content-wrapper').css('padding-top', '80px');
	
	      $("#listMainMenu").addClass('listMainMenuShow').show();
	      //$("#g_nav_tabs").addClass("listMainMenuShowUL").show();
	      $("#g_nav_tabs").css('margin-left', '0px');
	      $("#g_nav_tab_close").css('display', 'none');
	    } else {
	      if (!window.userSettingEntry.showLeftListMenu) $('.content-wrapper').css('padding-top', '30px');
	
	      $('.main-sidebar').css('top', '30px');
	      $("#listMainMenu").addClass('listMainMenuShow').show();
	      $("#g_nav_tabs").css('margin-left', '0px');
	      $("#g_nav_tab_close").css('display', 'none');
	    }
	  }
	  if (window.autoFullScreen) {
	    $(".main-header").css("display", 'none');
	    $(".content-wrapper").css("padding-top", "0px");
	    $('.main-sidebar').css('padding-top', '0px');
	    $('#g_nav_tabs').css("display", 'none');
	    $('.main-footer').css("display", 'none');
	    $('#contentWrapper').addClass('autoFullScreenContent');
	    try {
	      $.AdminLTE.layout.fix();
	    } catch (e) {}
	  }
	
	  if (window.userSettingEntry.showLeftListMenu == true) {
	    if (window.userSettingEntry.showToolMenu == true) {
	      shoLogoArea(2);
	    } else {
	      shoLogoArea(1);
	    }
	  } else {
	    shoLogoArea(1);
	  }
	};
	
	/**
	   * 动态加载JS
	   * @param {string} url 脚本地址
	   * @param {function} callback  回调函数
	   */
	window.dynamicLoadJs = function (url, callback) {
	  var head = document.getElementsByTagName('head')[0];
	  var script = document.createElement('script');
	  script.type = 'text/javascript';
	  var newurl = url;
	  script.src = newurl;
	  if (typeof callback == 'function') {
	    script.onload = script.onreadystatechange = function () {
	      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
	        if (callback) callback();
	        script.onload = script.onreadystatechange = null;
	      }
	    };
	  }
	  head.appendChild(script);
	};
	
	/**
	   * 动态加载Css
	   * @param {string} url 脚本地址
	   * @param {function} callback  回调函数
	*/
	window.dynamicLoadCss = function (url, callback) {
	  //<link rel="stylesheet" href="externals/styles/GongqiERP6.css"></link>
	  var head = document.getElementsByTagName('head')[0];
	  var _css_ = document.createElement('link');
	  _css_.rel = "stylesheet";
	  _css_.href = url;
	  if (typeof callback == 'function') {
	    script.onload = script.onreadystatechange = function () {
	      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
	        if (callback) callback();
	        script.onload = script.onreadystatechange = null;
	      }
	    };
	  }
	  head.appendChild(_css_);
	};
	
	window.getUserInfosHandler = function (data) {
	  if (data.status != 0) {
	    alert(data.msg);
	    return;
	  }
	  data = data.result;
	  //console.log(data);
	  var userInfos = {};
	  if (data != null) {
	
	    userInfos.userId = data.userId;
	    userInfos.userName = data.userName;
	    userInfos.loginDate = new Date(data.loginDate);
	    userInfos.loginTime = data.loginTime;
	    userInfos.userSessionId = data.userSessionId;
	    var propertyMap = data.propertyMap;
	    if (propertyMap != null && propertyMap != undefined) {
	
	      userInfos.canEnterMainform = propertyMap.allowEnterMainForm;
	      userInfos.serverDebug = propertyMap.serverDebug;
	
	      if (propertyMap.hasOwnProperty("clientCommandAfterLogin")) {
	        var clientCommandAfterLogin = propertyMap["clientCommandAfterLogin"];
	        userInfos.clientCommandAfterLoginResult = clientCommandAfterLogin;
	      }
	      // 框架版本返回
	      if (propertyMap.hasOwnProperty("frameworkVersion")) {
	        var frameworkVersion = propertyMap["frameworkVersion"];
	        window.frameworkVersion = frameworkVersion;
	      }
	
	      var list = data.userGroups;
	      userInfos.userGroups = list == null || list == undefined ? [] : list;
	
	      if (userInfos.userGroups.indexOf("admin") != -1 || userInfos.userGroups.indexOf("Admin") != -1) {
	        userInfos.isAdmin = true;
	      }
	
	      var _loginMode = window.getLoginMode();
	      if (_loginMode == "embed") {
	        userInfos.toolBarInForm = true;
	        userInfos.showStatusBar = false;
	      }
	      //
	      window.userInfos = userInfos;
	      if (window.formOSopenUniversal) {
	        $("#overallSituationDiv").css("height", "1000px");
	        $("#overallSituationDiv").css("z-index", "1031");
	        $("#overallSituationDiv").css("position", "fixed");
	        $("#overallSituationDiv").css("background-color", "white");
	        $("#overallSituationDiv").css("width", "100%");
	        if (window.formOSopenAllUniversal) {
	          setTimeout(function () {
	            window.showUniversalView();
	          }, 1500);
	        } else {
	          window.showUniversalView();
	        }
	      }
	      //TODO 
	      if (window.formOSopenDataSetView) {
	        $("#dataSetViewReportDiv").css("display", 'block');
	        setTimeout(function () {
	          window.fromOSopenDataSetViewes();
	        }, 1500);
	      }
	      //用户设置
	      var ugse = propertyMap["userSettingProperties"];
	      initUGS(ugse);
	
	      userInfos.daoMaxListSize = propertyMap["daoMaxListSize"];
	
	      //if(Version.CLIENT_VERSION  != propertyMap["frameworkVersion"])
	      //  alert("当前使用的客户端版本与最新版本不一致，为保证正常使用，请清除浏览器缓存或与管理员联系");
	      var license = propertyMap["license"];
	      if (license != "" && license != null) {
	        userInfos.licenseInfo = license;
	      }
	
	      //userInfos.messageURL = replaceBaseUrl(propertyMap["messageURL"]);
	      userInfos.resourceURL = replaceBaseUrl(propertyMap["resourceURL"]);
	      userInfos.serviceURL = replaceBaseUrl(propertyMap["serviceURL"]);
	
	      userInfos.pivotURL = userInfos.serviceURL;
	      userInfos.useHttps = false;
	      userInfos.subSysId = propertyMap["Gongqi_ERP_Data_Area"];
	      userInfos.subSystem = propertyMap["dataAreaLabel"];
	      userInfos.licenseXML = propertyMap.license;
	      userInfos.WILDCARD = propertyMap["queryWildcardCharacter"];
	      //FormItemConst.WILDCARD = 
	
	      $(document).attr('title', userInfos.subSystem);
	      userInfos.userAus = {};
	      var uAus = propertyMap.UserAuthoritys;
	      if (uAus) {
	        for (var _i12 = 0; _i12 < uAus.length; _i12++) {
	          var o = uAus[_i12];
	          var uAuKey = o.authorityMenuItemId + "." + o.authorityFormItemId;
	          var _node = userInfos.userAus[uAuKey];
	          var type = o.authorityNodeType;
	          var visible;var query;var exp;var edit;var save;var _new;var del;
	          var isForbidden = true;
	          visible = o.authorityType_Visible;
	          if (o.authorityType_Visible && isForbidden) isForbidden = false;
	          query = o.authorityType_Query;
	          if (o.authorityType_Query && isForbidden) isForbidden = false;
	          exp = o.authorityType_Export;
	          if (o.authorityType_Export && isForbidden) isForbidden = false;
	          edit = o.authorityType_Edit;
	          if (o.authorityType_Edit && isForbidden) isForbidden = false;
	          save = o.authorityType_Save;
	          if (o.authorityType_Save && isForbidden) isForbidden = false;
	          _new = o.authorityType_New;
	          if (o.authorityType_New && isForbidden) isForbidden = false;
	          del = o.authorityType_Delete;
	          if (o.authorityType_Delete && isForbidden) isForbidden = false;
	          if (_node) {
	            _AuthorityUtil2.default.setUniqueKey(_node, visible, query, exp, edit, save, _new, del);
	          } else {
	            _node = {};_node.type = type;_node.key = uAuKey;_node.visible = visible;
	            _node.query = query;_node["exp"] = exp;_node.edit = edit;_node.save = save;_node._new = _new;_node.del = del;_node.isForbidden = isForbidden;
	            userInfos.userAus[uAuKey] = _node;
	          }
	        }
	      }
	
	      var userMenuMap = propertyMap["businessMaps"];
	      window.userMenuMap = "";
	      if (userMenuMap && !$.isEmptyObject(userMenuMap)) {
	        window.hasMenuMap = true;
	        try {
	          var appId = window.appId;
	          if (userMenuMap[appId]) window.userMenuMap = userMenuMap[appId];
	        } catch (err) {
	          console.log(err);
	        }
	      }
	      if (window.didomain && !loginToken && !loginDataArea) {
	        window.hasMenuMap = true;
	      }
	
	      if (window.didomain && !loginToken && !loginDataArea) {} else {
	        var forceChangePassword = propertyMap["ForceChangePassword"];
	        if (forceChangePassword) {
	          window.showPasswordModal();
	          $('#but_PasswordModalClose').css('display', 'none');
	          $('#but_PasswordModalCancel').css('display', 'none');
	        }
	      }
	    }
	  }
	  if (window.uselayersLevelesConfig != undefined && window.uselayersLevelesConfig == true) {
	    var layerLevelConfig = window.layerLevelConfig;
	    for (var _i13 = 0; _i13 < layerLevelConfig.length; _i13++) {
	      var _layerName = layerLevelConfig[_i13].name;
	      window.layerConfigs[_layerName] = {};
	      //dynamicLoadJs(urlBase+"/layers/"+_layerName+"/"+_layerName+".js");
	      var jsConfig = layerLevelConfig[_i13].js;
	      if (typeof jsConfig == "boolean") {
	        if (layerLevelConfig[_i13].js) dynamicLoadJs("layers/" + _layerName + "/" + _layerName + ".js");
	      } else if ((typeof jsConfig === 'undefined' ? 'undefined' : _typeof(jsConfig)) == "object") {
	        for (var jsKey in jsConfig) {
	          var jsName = jsKey; //jsConfig[jsKey];
	          var jsPath = jsConfig[jsKey];
	          //if(jsName == true)
	          dynamicLoadJs("layers/" + _layerName + "/" + jsPath + jsName + ".js");
	        }
	      }
	
	      if (layerLevelConfig[_i13].css && typeof layerLevelConfig[_i13].css == true) dynamicLoadCss("layers/" + _layerName + "/" + _layerName + ".css");
	    }
	  } else {
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "getClientDevConfigure", "String");
	    var remoteArg = { command: command, resultFunction: window.getLayerConfigHandler,
	      faultFunction: window.getLayerConfigFaultHandler, sync: false };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	  }
	  window.userInfos = userInfos;
	  $("#userId").html(userInfos.userName ? userInfos.userName : userInfos.userId);
	  $(".pull-left.info p").text(userInfos.userId);
	  $("body").addClass("userClass_" + userInfos.userId);
	};
	
	window.getCurrentUserInfoHandler = function (data) {
	  if (data.status == 2) {
	    if (window.didomain && !loginToken && !loginDataArea) {
	      if (typeof window.layui.request.loginOut() == 'function') {
	        var _parentWindow = window;
	      } else if (typeof window.parent.window.layui.request.loginOut() == 'function') {
	        var _parentWindow = window.parent.window;
	      } else {
	        var _parentWindow = window.parent.parent.window;
	      }
	      _parentWindow.layui.request.loginOut();
	      var UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
	      _parentWindow.localStorage.removeItem("username");
	      _parentWindow.localStorage.removeItem("userId");
	      _parentWindow.localStorage.removeItem("permission");
	      _parentWindow.localStorage.removeItem("userToken");
	      _parentWindow.localStorage.removeItem(UserId_desktopData);
	    } else {
	      window.location.href = loginPath;
	    }
	  } else if (data.status != 0) {
	    alert(JSON.stringify(data));
	  } else {
	    window.getUserInfosHandler(data);
	
	    if (window.appId) {
	      // app 默认首页
	      var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "loadSolutionWhole", "Map");
	
	      command.appendArg(window.appId);
	
	      var remoteArg = { command: command, resultFunction: window.rpc_loadSolutionWholeSucess, faultFunction: window.rpc_loadSolutionWholeError, sync: false };
	      _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    }
	
	    if (window.userInfos.isAdmin == true) {
	      $("#extendLi").css("display", "block");
	    } else {
	      $("#extendLi").css("display", "block");
	      $("#extendLi .menu>li").hide();
	      $("#extendLi #extendLi_importManager").show();
	      // $("#extendLi #extendLi_universalView").show();
	      //系统维护按钮
	      // $("#extendLi #extendLi_systemStart").css('display','none')
	      // $("#extendLi #extendLi_systemClose").css('display','none')
	    }
	
	    //权限
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.form.load.FormAuthorityManager", "findMenuByUser", "List");
	    command.appendArg(window.userInfos.userId);
	    if (sessionStorage.getItem("fixedUserGroups")) {
	      var fixedUserGroups = sessionStorage.getItem("fixedUserGroups");
	      sessionStorage.removeItem("fixedUserGroups");
	      command.appendArg(fixedUserGroups);
	      //command.appendArg(fixedUserGroups.split(","),"String[]");
	    } else {
	      var _fixedUserGroups = _CommonUtil2.default.getUrlParam("fixedUserGroups");
	      if (_fixedUserGroups) {
	        command.appendArg(_fixedUserGroups);
	      }
	    }
	    var remoteArg = { command: command, resultFunction: window.getMenuListAuHandler, faultFunction: window.getMenuListAuFaultHandler, sync: false };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	
	    _WebSocketManager2.default.initWebSocket();
	    _IndexedDBUtil2.default.openDB(window.userInfos.subSysId, window.dbOpenSuccess);
	  }
	};
	
	window.rpc_loadSolutionWholeSucess = function (data) {
	  var resultdata = data.result;
	  if (resultdata.AfterLoadingCommand) {
	    for (var _i14 in resultdata.AfterLoadingCommand.tasks) {
	      if (resultdata.AfterLoadingCommand.tasks[_i14].cmd == "openForm") {
	        window.hasAppOpenFormFixed = true;
	        break;
	      }
	    }
	    window.userInfos.clientCommandAfterLoginResult = resultdata.AfterLoadingCommand;
	    // CommandResolver.resolve(window.userInfos.clientCommandAfterLoginResult.tasks);
	  }
	};
	window.rpc_loadSolutionWholeError = function (data) {};
	
	window.switchLayerConfigServerToClient = function (config) {
	  var result = [];
	  for (var _i15 = 0; _i15 < config.length; _i15++) {
	    var _layer = config[_i15];
	
	    if (_layer.name == "app") {
	      var appConfig = { name: "app", css: {}, js: {} };
	      if (window.appId && _layer.hasOwnProperty(window.appId)) {
	        Object.assign(appConfig, _layer[window.appId]);
	
	        if (appConfig.js == true) {
	          appConfig.js = {};
	          appConfig.js[window.appId] = window.appId + "/";
	        } else {
	          appConfig.js = {};
	        }
	      } else if (!window.appId) {
	        for (var key in _layer) {
	          if (key == "name") continue;
	          if (!appConfig) appConfig = { name: "app", css: {}, js: {} };
	          var _item = _layer[key];
	          Object.assign(appConfig.css, _item.css);
	          if (_item.js == true) appConfig.js[key] = key + "/";
	        }
	      }
	
	      result.push(appConfig);
	    } else if (_layer.name == "plg") {
	      var plgConfigClient = { name: "plg", css: {}, js: {} };
	      if (window.appId && _layer.hasOwnProperty(window.appId)) {
	        var plgLayerAppConfig = _layer[window.appId];
	        for (var _key2 in plgLayerAppConfig) {
	          var plgConfig = plgLayerAppConfig[_key2];
	          if (!plgConfig.css) plgConfig.css = {};
	          if (!plgConfigClient.css[window.appId]) plgConfigClient.css[window.appId] = {};
	          if (!plgConfigClient.css[window.appId][_key2]) plgConfigClient.css[window.appId][_key2] = {};
	          Object.assign(plgConfigClient.css[window.appId][_key2], plgConfig.css);
	          if (plgConfig.js == true) plgConfigClient.js[_key2] = window.appId + "/" + _key2 + "/";
	        }
	      } else if (!window.appId) {
	        for (var key1 in _layer) {
	          if (key1 == "name") continue;
	          var item1 = _layer[key1];
	          for (var key2 in item1) {
	            var item2 = item1[key2];
	            if (!plgConfigClient.css[key1]) plgConfigClient.css[key1] = {};
	            if (!plgConfigClient.css[key1][key2]) plgConfigClient.css[key1][key2] = {};
	            Object.assign(plgConfigClient.css[key1][key2], item2.css);
	
	            if (item2.js == true) plgConfigClient.js[key2] = key1 + "/" + key2 + "/";
	          }
	        }
	      }
	      result.push(plgConfigClient);
	    } else if (_layer.name == "ext") {
	      var extConfigClient = { name: "ext", css: {}, js: {} };
	      if (window.appId && _layer.hasOwnProperty(window.appId)) {
	
	        var extLayerAppConfig = _layer[window.appId];
	        Object.assign(extConfigClient.css, extLayerAppConfig.css);
	        if (extLayerAppConfig.js == true) extConfigClient.js[window.appId] = window.appId + "/";
	      } else if (!window.appId) {
	        for (var _key3 in _layer) {
	          if (_key3 == "name") continue;
	          var _item2 = _layer[_key3];
	          Object.assign(extConfigClient.css, _item2.css);
	          if (_item2.js == true) extConfigClient.js[_key3] = _key3 + "/";
	        }
	      }
	      result.push(extConfigClient);
	    } else {
	      result.push(_layer);
	    }
	  }
	  return result;
	};
	window.dynamicCssHand = function (data) {
	  window.dynamicCssLoad = {};
	  try {
	    for (var _i16 = 0; _i16 < data.length; _i16++) {
	      var _layerName = data[_i16].name;
	      if (_layerName == 'ext') {
	        for (var j in data[_i16]) {
	          if (j != 'name') {
	            for (var h in data[_i16][j].css) {
	              if (data[_i16][j].css[h] == true) {
	                window.dynamicCssLoad[h] = j;
	              }
	            }
	          }
	        }
	      }
	    }
	  } catch (error) {}
	};
	
	window.getLayerConfigHandler = function (data) {
	  var layerLevelConfigServer = JSON.parse(data.result);
	  window.dynamicCssHand(layerLevelConfigServer);
	  window.layerLevelConfig = window.switchLayerConfigServerToClient(layerLevelConfigServer);
	  var layerLevelConfig = window.layerLevelConfig;
	  for (var _i17 = 0; _i17 < layerLevelConfig.length; _i17++) {
	    var _layerName = layerLevelConfig[_i17].name;
	    window.layerConfigs[_layerName] = {};
	    //dynamicLoadJs(urlBase+"/layers/"+_layerName+"/"+_layerName+".js");
	    var jsConfig = layerLevelConfig[_i17].js;
	    if (typeof jsConfig == "boolean") {
	      if (layerLevelConfig[_i17].js) dynamicLoadJs("layers/" + _layerName + "/" + _layerName + ".js");
	    } else if ((typeof jsConfig === 'undefined' ? 'undefined' : _typeof(jsConfig)) == "object") {
	      for (var jsKey in jsConfig) {
	        var jsName = jsKey; //jsConfig[jsKey];
	        var jsPath = jsConfig[jsKey];
	        //if(jsName == true)
	        dynamicLoadJs("layers/" + _layerName + "/" + jsPath + jsName + ".js");
	      }
	    }
	
	    var cssConfig = layerLevelConfig[_i17].css;
	    if (typeof cssConfig == "boolean") {
	      if (layerLevelConfig[_i17].css) dynamicLoadCss("layers/" + _layerName + "/" + _layerName + ".css");
	    } else if ((typeof cssConfig === 'undefined' ? 'undefined' : _typeof(cssConfig)) == "object") {
	      if (_layerName == 'plg') {
	        for (var cssKey in cssConfig) {
	          var appName = cssKey; //jsConfig[jsKey];
	          var appCssConfig = cssConfig[cssKey];
	          for (var plgKey in appCssConfig) {
	            var plgPath = appCssConfig[plgKey];
	            for (var pcss in plgPath) {
	              dynamicLoadCss("layers/" + _layerName + "/" + appName + "/" + plgKey + "/" + pcss + ".css");
	            }
	          }
	          //if(jsName == true)
	        }
	      } else {
	        for (var _cssKey in cssConfig) {
	          var cssName = _cssKey; //jsConfig[jsKey];
	          var cssPath = cssConfig[_cssKey];
	          //if(jsName == true)
	          if (cssName.indexOf('.') != -1) {
	            var indexof = cssName.lastIndexOf('.');
	            var app = cssName.substring(0, indexof);
	            dynamicLoadCss("layers/" + _layerName + "/" + app + "/" + cssName + ".css");
	          } else {
	            dynamicLoadCss("layers/" + _layerName + "/" + cssName + ".css");
	          }
	        }
	      }
	    }
	  }
	};
	
	window.getLayerConfigFaultHandler = function (data) {
	  if (layerLevelConfig) {
	    for (var _i18 = 0; _i18 < layerLevelConfig.length; _i18++) {
	      var _layerName = layerLevelConfig[_i18].name;
	      window.layerConfigs[_layerName] = {};
	      //dynamicLoadJs(urlBase+"/layers/"+_layerName+"/"+_layerName+".js");
	      if (layerLevelConfig[_i18].js) dynamicLoadJs("layers/" + _layerName + "/" + _layerName + ".js");
	
	      if (layerLevelConfig[_i18].css && typeof layerLevelConfig[_i18].css == true) dynamicLoadCss("layers/" + _layerName + "/" + _layerName + ".css");
	    }
	  }
	};
	
	window.extendLiDown = function () {
	  var command2 = _Command2.default.createService("gongqi.erp.layers.sys.services.MaintenanceService", "isMaintenance", "boolean");
	  var remoteArg2 = { command: command2, resultFunction: window.isMaintenanceResult, faultFunction: window.isMaintenanceResult, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg2);
	};
	
	window.doOrderOverallSituationModel = function () {
	  var overallTime = $('#overallSituationDialogTime').val();
	  var overallTimeL = overallTime.replace(new RegExp("-", "gm"), "/");
	  var overallTimeN = new Date(overallTimeL).getTime();
	  var command2 = _Command2.default.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance", 'void');
	  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult, faultFunction: window.setMaintenanceResultStart, sync: false };
	  command2.appendArg('true', 'boolean');
	  command2.appendArg('true', 'boolean');
	  command2.appendArg(overallTimeN, 'long');
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg2);
	};
	
	window.doOverallSituationModel = function () {
	  var command2 = _Command2.default.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance", 'void');
	  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult, faultFunction: window.setMaintenanceResultStart, sync: false };
	  command2.appendArg('true', 'boolean');
	  command2.appendArg('false', 'boolean');
	  command2.appendArg(0, 'long');
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg2);
	};
	
	window.showSystemStart = function () {
	  var command2 = _Command2.default.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance", 'void');
	  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult, faultFunction: window.setMaintenanceResultStart, sync: false };
	  command2.appendArg('true', 'boolean');
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg2);
	  // $("#overallSituationDialog").show();
	};
	
	window.showSystemClose = function () {
	  var command2 = _Command2.default.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance", 'void');
	  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult, faultFunction: window.setMaintenanceResultClose, sync: false };
	  command2.appendArg('false', 'boolean');
	  // command2.appendArg('false','boolean');
	  // command2.appendArg(0,'long');
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg2);
	};
	
	window.isMaintenanceResult = function (data) {
	  if (window.userInfos.isAdmin == true) {
	    if (data.status == 0) {
	      if (data.result == false || data.result == 'false') {
	        // $("#extendLi #extendLi_systemStart").css('display','')
	        // $("#extendLi #extendLi_systemClose").css('display','none')
	      } else {
	          // $("#extendLi #extendLi_systemStart").css('display','none')
	          // $("#extendLi #extendLi_systemClose").css('display','');
	        }
	    } else {
	        //alert(data);
	      }
	  }
	};
	
	window.setMaintenanceResultStart = function (data) {
	  if (window.userInfos.isAdmin == true) {
	    if (data.status == 0) {
	      if (data.result == null) {
	        // $("#extendLi #extendLi_systemStart").css('display','')
	        // $("#extendLi #extendLi_systemClose").css('display','none')
	      }
	    } else {
	      alert(data.msg);
	    }
	  }
	};
	
	window.setMaintenanceResultClose = function (data) {
	  if (window.userInfos.isAdmin == true) {
	    if (data.status == 0) {
	      if (data.result == null) {
	        // $("#extendLi #extendLi_systemStart").css('display','none')
	        // $("#extendLi #extendLi_systemClose").css('display','close')
	      }
	    } else {
	      alert(data.msg);
	    }
	  }
	};
	
	window.dbOpenSuccess = function () {
	  window.getClientLogNetWorkErrorData(_LogUtil2.default.upNetWorkErrorLog);
	};
	window.getCurrentUserInfoError = function (data) {
	  if (window.didomain && !loginToken && !loginDataArea) {
	    window.location.href = window.errorPath;
	  } else {
	    window.location.href = loginPath;
	  }
	};
	
	window.getCurrentUserInfo = function () {
	  var command = {};command.classType = "service";command.className = userSessionPackage;command.instanceType = null;
	  command.instanceId = null;command.methodName = "getCurrentUserSession";command.returnType = "UserSession";
	
	  var data = JSON.stringify(command);var postdata = { request: data };
	  var _urlBase = "";
	  if (window.urlBase) _urlBase = window.urlBase;
	  var path = void 0;var _headers = {};
	  if (window.didomain) {
	    path = "/GongqiERP/" + window.didomain + "/ServiceController";
	
	    if (!window.loginToken) {
	      var _token = localStorage.getItem("userToken");
	      if (_token) _headers.token = _token;
	    }
	  } else {
	    path = "/GongqiERP/ServiceController";
	  }
	
	  $.ajax({
	    type: 'post',
	    url: _urlBase + path,
	    dataType: "json",
	    headers: _headers,
	    data: postdata,
	    //暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
	    xhrFields: { withCredentials: true },
	
	    success: window.getCurrentUserInfoHandler,
	    error: window.getCurrentUserInfoError
	  });
	};
	
	window.autoLoginByTokenHandler = function (data) {
	  window.autoFullScreen = _CommonUtil2.default.getUrlParam("autoFullScreen");
	  window.getCurrentUserInfo();
	};
	
	window.autoLoginByTokenError = function (data) {
	  //alert("无法自动登录 点击转入手动登录");
	  window.location.href = loginPath;
	  var faultString;var reqHandler = "";
	  if (data && data.successButNot0) {
	    faultString = data.errText;
	  } else {
	    faultString = "无法自动登录 点击转入手动登录";
	    reqHandler = locationToLoginPath;
	  }
	  _Warn2.default.show({ text: faultString, title: "登录失败", confirm: {
	      isShow: true,
	      event: reqHandler,
	      text: '去登录'
	    } });
	};
	
	window.locationToLoginPath = function () {
	  window.location.href = loginPath;
	};
	
	window.autoLoginByToken = function () {
	  var browserInfo = "";
	  try {
	    var browser = {
	      ie: 0,
	      firefox: 0,
	      safari: 0,
	      konq: 0,
	      opera: 0,
	      chrome: 0
	    };
	    var ua = navigator.userAgent;
	    if (window.opera) {
	      browser.opera = window.opera.version();
	    } else if (/AppleWebKit\/(\S+)/.test(ua)) {
	      // 判断是 Chrome 还是 safari
	      if (/Chrome\/(\S+)/.test(ua)) {
	        browser.chrome = RegExp['$1'];
	      } else if (/Version\/(\S+)/.test(ua)) {
	        // 仅使用于 safari 3 及其更高版本
	        browser.safari = RegExp['$1'];
	      } else {
	        // 个别情况-未获取到 safari 版本号的处理
	      }
	    } else if (/KHTML\/(\S+)/.test(ua) || /Konqueror\/([^;]+)/.test(ua)) {
	      browser.konq = RegExp['$1'];
	    } else if (/rv:([^\)]+)\) Gecko\/\d{8}/.test(ua)) {
	      if (/Firefox\/(\S+)/.test(ua)) {
	        // 火狐浏览器
	        browser.firefox = RegExp['$1'];
	      } else {
	        // 其他情况
	      }
	    } else if (/MSIE ([^;]+)/.test(ua)) {
	      browser.ie = RegExp['$1'];
	    }
	    for (var k in browser) {
	      if (browser[k] != 0) {
	        browserInfo = k + "/" + browser[k];
	      }
	    }
	  } catch (error) {}
	
	  var command = _Command2.default.createService("gongqi.erp.framework.services.UserSessionService", "loginByToken", "UserSession");
	  command.appendArg(loginToken);command.appendArg({ Status: 1, browserInfo: browserInfo, Mac: "", Type: 71, ComputerName: "" }, "java.lang.Object");
	  command.appendArg(loginDataArea);
	  var remoteArg = {
	    command: command, resultFunction: window.autoLoginByTokenHandler,
	    faultFunction: window.autoLoginByTokenError, lockText: "系统正在自动登录..."
	  };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	var loginToken = _CommonUtil2.default.getUrlParam("token");
	window.loginToken = loginToken;
	var loginDataArea = _CommonUtil2.default.getUrlParam("dataArea");
	window.loginDataArea = loginDataArea;
	
	if (fromOrig != "oshome") {
	  if (loginToken && loginDataArea) {
	    window.autoLoginByToken();
	  } else {
	    window.getCurrentUserInfo();
	  }
	}
	
	window.getMenuListAuHandler = function (data) {
	  if (data.status == 0) {
	    var authority = data.result;
	
	    _AuthorityUtil2.default.initMenuListCache(authority);
	
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "getGOT", "byte[]");
	    var remoteArg = { command: command, resultFunction: window.gotSuccessHandler, faultFunction: window.gotErrorHandler, sync: false };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	  } else {
	    alert(data.msg);
	  }
	};
	
	window.getMenuListAuFaultHandler = function (faultEvent) {
	  var faultString;
	  if (faultEvent && faultEvent.successButNot0) {
	    faultString = faultEvent.errText;
	  } else {
	    faultString = "可能是网络错误 请检查网络是否正常";
	  }
	  _Warn2.default.show({ text: faultString, title: "未能正确获取到菜单相关权限" });
	};
	
	function unzip(b64Data) {
	  var strData = atob(b64Data);
	
	  // Convert binary string to character-number array
	  var charData = strData.split('').map(function (x) {
	    return x.charCodeAt(0);
	  });
	
	  // Turn number array into byte-array
	  var binData = new Uint8Array(charData);
	
	  // // unzip
	  var data = pako.inflate(binData);
	
	  // Convert gunzipped byteArray back to ascii string:
	  strData = String.fromCharCode.apply(null, new Uint16Array(data));
	  return strData;
	}
	
	window.dynamicLoadJs = function (url, callback) {
	  var script = document.createElement('script');
	  script.type = "text/javascript";
	  if (typeof callback != "undefined") {
	    if (script.readyState) {
	      script.onreadystatechange = function () {
	        if (script.readyState == "loaded" || script.readyState == "complete") {
	          script.onreadystatechange = null;
	          callback();
	        }
	      };
	    } else {
	      script.onload = function () {
	        callback();
	      };
	    }
	  }
	  var newurl = url;
	  script.src = newurl;
	  document.body.appendChild(script);
	};
	
	window.openForm = function (arg) {
	  _FormLoadHelper2.default.openMenuItem(arg);
	};
	
	window.hideGOTMainMenuByAppId = function (mainMenu) {
	  var items = mainMenu.items;
	  for (var i = 0; i < items.length; i++) {
	    var item = items[i];
	    var _id = item.id;
	    if (_id && _id.indexOf(".") != -1 && _id.indexOf(window.appId) != 0) {
	      item.Properties.Visible.V = false;
	    }
	  }
	};
	
	window.gotSuccessHandler = function (data) {
	
	  var iframe = $("<iframe>").css("border", "none").attr("id", "SupcanFrame").css("width", "5px").css("height", "5px").css("background", "none");
	  iframe.attr("src", "./supcan/print.html");
	  $("#SupcanFrameIf").append(iframe);
	
	  //alert("获取GOT");
	  //TODO 根据window.got的licenseInfo 与 showGongqi变量值 来显示版本号
	  if (data.status == 0) {
	    var compressedByteArray = base64js.toByteArray(data.result);
	    var s = pako.inflate(compressedByteArray, { to: 'string' });
	    window.got = JSON.parse(s);
	
	    var licenseInfo = window.got.licenseInfo;
	    if (licenseInfo) {
	      var infoArray = licenseInfo.split("|");
	      var versionTxt = infoArray[0];
	      $("#versionTxtDiv").html(versionTxt).on("click", window.showLicenseModal);
	      //let customInfo = infoArray[1];
	      //$("#customInfoDiv").html("3.0.99");
	    }
	
	    /*if(window.userInfos.menuCustomObject)
	    {
	      let customMenu = {
	          id: "60102002",
	          createdLayer: "bug",
	          items: [],
	          nextInnerId: "10023",
	          name: "RD",
	          Properties: {ModifiedDate: {V: ""},CreatedTime: {V:""},Visible: {V: "true"},ModifiedBy: {V: ""},CreatedBy: {V: ""},CreatedDate: {V: ""},ModifiedTime: {V: ""},Label: {V: ""},Icon: {V: "fa fa-user-plus"},HelpText: {V: ""}},
	          modifiedLayer: "bug",
	          version: "1"
	      };
	        for(let key in window.userInfos.menuCustomObject)
	      {
	        let customMenuItem = {
	          id: "50213357",
	          createdLayer: "bug",
	          qname: "MenuItem",
	          idInMenu: "10016",
	          nextInnerId: "10001",
	          name: "RD_MyBugList",
	          Properties: {Source: {V: "Form"},Parameters: {V: ""},Visible: {V: "true"},IconType: {V: "Display"},Popup: {V: "false"},Label: {V: "我的问题"},RefObject: {refentityid: "40213347",V: "RD_MyBugList"},HelpText: {V: "iconfont icon-wentiguanli"}},modifiedLayer: "bug",version: "4"
	        }
	      }
	    }*/
	
	    //alert(licenseInfo);
	    if (window.treeViewMainMenuPath) {
	      /*import(window.treeViewMainMenuModule).then((Component) => {
	          //do something with TheComponent = Component.default
	          let Module = Component.default;
	          ReactDOM.render(<Module data={window.got.MainMenu}/>,document.getElementById('mainMenu'));
	      });*/
	      //var page = window.treeViewMainMenuModuleName;
	      //let Module = require("./customdev/menu/${page}");
	      //ReactDOM.render(<Module data={window.got.MainMenu}/>,document.getElementById('mainMenu'));
	      dynamicLoadJs(window.treeViewMainMenuPath);
	    } else {
	      if (window.appId) {
	        //如果是操作系统 获取应用菜单访问管控中心
	        // if (window.didomain && !loginToken && !loginDataArea)
	        // {
	        //   AjaxRemoteUtil.ajaxPost("../../"+window.didomain+"/web/art/application/appMenu",{appId:window.appId},
	        //   "json",false,window.rpc_result_loadApplicationMainMenu,null,false,
	        //   {domain:window.didomain,loginToken:window.loginToken,loginDataArea:window.loginDataArea,relativeUrl:true});
	        // }
	        // else
	
	        var command = _Command2.default.createService(window.servicePath ? window.servicePath : "gongqi.erp.gotmodel.services.GOTService", "loadSolutionWhole", "Map");
	        var remoteArg = { command: command, resultFunction: window.rpc_result_loadApplicationMainMenu, sync: false };
	        command.appendArg(window.appId);
	        _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	        //}
	        return;
	        //hideGOTMainMenuByAppId(window.got.MainMenu);
	      }
	      window.doRenderMainMenu();
	    }
	    window.doAfterMainMenu();
	    //setTimeout(function(){window.testOpenAllWindowAndDelayClose();},10000);
	
	
	    //window.getClientLogNetWorkErrorData(LogUtil.upNetWorkErrorLog);
	  } else {
	    alert(data.msg);
	  }
	};
	
	window.rpc_result_loadApplicationMainMenu = function (data) {
	  var resultdata = data.result;
	  window.got.MainMenu = JSON.parse(resultdata.MainMenu);
	  window.doRenderMainMenu();
	  window.doAfterMainMenu();
	};
	
	window.doRenderMainMenu = function () {
	
	  if (window.fixedMenuId) {
	    var mainMenu = window.got.MainMenu;
	    if (mainMenu && mainMenu.items && mainMenu.items.length > 0) {
	      for (var i = 0; i < mainMenu.items.length; i++) {
	        var item = mainMenu.items[i];
	        if (item.id != window.fixedMenuId) {
	          item.Properties.Visible.V = "false";
	        }
	      }
	    }
	  }
	  if (window.userSettingEntry.showLeftMenu == true) {
	    window.getUserDataSettings("showLeftMenu");
	  } else {
	    if (window.userSettingEntry.showLeftListMenu == true) window.getUserDataSettings("showLeftListMenu");else $("#toolBarMainMenuToggleA").hide();
	  }
	
	  if (window.hasMenuMap && !window.hasAppOpenFormFixed) {
	
	    var liE = $('<li class="active menumap" tabpaneid="menunavmap" style="position: relative; left: 0px; top: 0px;"><a href="#menunavmap" data-toggle="tab" aria-expanded="true" class="gongqi_tabpage">业务地图</a></li>');
	
	    var childrenArray = $("#g_nav_tabs").children().toArray();
	    var targetIndex = childrenArray.length - 1 - 1; // 最后第二个位置的索引
	    var targetElement = childrenArray[targetIndex];
	    $(targetElement).after(liE);
	
	    //$('<div class="tab-pane active menumap" id="menunavmap"  style="width: 100%; height: 100%;"><canvas id="menunavmapcanvas">222</canvas></div>')
	    var tabpane = $('<div class="tab-pane active menumap" id="menunavmap"  style="width: 100%; height: 100%;"></div>');
	    tabpane.appendTo($("#g_tab_content"));
	    //let _menuMap = JSON.parse(window.userMenuMap);
	
	    $("<iframe>").css("border", "none").css("width", "100%").css("height", "100%").attr("src", "./html/menuMap/index.html#/render?businessMapId=" + window.userMenuMap).appendTo(tabpane);
	
	    /* CommonUtil.drawCanvas(
	       _menuMap.cells,
	       //JSON.parse(localStorage.getItem("json")).cells,
	       "menunavmap","menunavmapcanvas"
	     );*/
	  }
	};
	
	window.getBusinessMapJSON = function () {
	  var res = {};
	  if (window.didomain && !loginToken && !loginDataArea) {
	    var mainmenu = window.got.MainMenu;
	    var mainmenuString = JSON.stringify(window.got.MainMenu);
	    var appId = window.appId;
	    res = _BusinessMapUtil2.default.BusinessMapJSON(appId, mainmenuString);
	  }
	  return res;
	};
	
	window.openLuckySheet = function (arg) {
	  var preActiveLi = $("#g_nav_tabs>li.active");
	  preActiveLi.removeClass("active");
	  var preActiveDiv = $("#g_tab_content>div.active");
	  preActiveDiv.removeClass("active");
	  var labelSheet = arg.lable == null ? "luckySheet" : arg.lable;
	  var timestamp = new Date().getTime();
	  $('<li class="active" tabpaneid="' + timestamp + '" style="position: relative; left: 0px; top: 0px;"><a href="#' + timestamp + '" data-toggle="tab" aria-expanded="true" class="gongqi_tabpage">' + labelSheet + '</a>' + '<i class="fa fa-close" style="position: absolute; top: 1px; right: 3px;" onClick="closeLuckySheet(' + timestamp + ')"></i>' + '</li>').appendTo($("#g_nav_tabs"));
	  var tabpane = $('<div class="tab-pane active " id="' + timestamp + '"  style="width: 100%; height: 100%;"></div>');
	  tabpane.appendTo($("#g_tab_content"));
	  var filed = arg.luckysheetFileId == null ? "" : arg.luckysheetFileId;
	  var actionStr = arg.action == null ? "" : arg.action;
	  var appIdStr = arg.appId == null ? "" : arg.appId;
	  var modelId = arg.modelId == null ? "" : arg.modelId;
	  $("<iframe>").css("border", "none").css("width", "100%").css("height", "100%").attr("src", "./html/fileManage/index.html#/templateDesign?luckysheetFileId=" + filed + "&" + "action=" + actionStr + "&appId=" + appIdStr + "&modelId=" + modelId + "").appendTo(tabpane);
	};
	
	window.closeLuckySheet = function (e) {
	  var tabpaneid = e;
	  var tabpaneEl = document.getElementById(tabpaneid);
	  var $iframe = $(tabpaneEl).find(">iframe");
	  //var $iframe = $("#"+tabpaneid+" >iframe");
	
	  if ($iframe.length > 0) {
	    var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
	    if (win) closeForm(win.formModuleInstanceuuId, false);
	  }
	};
	
	window.isH5 = true;
	
	window.exeCommandResult = function (commandResult) {
	  if (commandResult.commandTasks && commandResult.tasks && commandResult.tasks[0] && !commandResult.tasks[0].cmd) {
	    _CommandResolver2.default.resolve(commandResult.commandTasks, window.formModuleInstance);
	  } else {
	    _CommandResolver2.default.resolve(commandResult.tasks, window.formModuleInstance);
	  }
	};
	
	//加载 万能视图 可用导出数据
	window.getUserDataSettings = function (flag) {
	  if (window.rightSidebarClicked) {
	    if (flag === 'showLeftMenu') {
	      _reactDom2.default.render(_react2.default.createElement(_TreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: window.userDataSettingsContent }), document.getElementById('mainMenu'));
	    }
	    if (flag === 'showLeftListMenu') {
	      _reactDom2.default.render(_react2.default.createElement(_ListTreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: window.userDataSettingsContent }), document.getElementById('listtree-mainMenu'));
	    }
	    return;
	  };
	  var content = [];
	
	  var domain = window.didomain;
	  // var url = window.parent.window.osUrl+"/manage/dataSetViewsqlPreview";
	  // var url = window.osUrl+"/"+domain+"/web/apps/gongqi.tool.datasetDesign/dsDesign/loadUserDataSetSetting";
	  var url = window.osUrl + "/" + "MIX" + "/web/apps/gongqi.tool.datasetDesign/dsDesign/loadUserDataSetSetting";
	  var _headers = { "Content-type": "application/json" };
	  if (!window.loginToken) {
	    var _token = localStorage.getItem("userToken");
	    if (_token) _headers.token = _token;
	  }
	  var _that = this;
	  var param = {
	    "domain": window.didomain,
	    "appId": window.appId,
	    "userId": userInfos.userId
	  };
	  $.ajax({
	    type: 'get',
	    url: url,
	    dataType: "json",
	    headers: _headers,
	    data: param,
	    success: function success(data) {
	      var dataSettings = data;
	      if (!dataSettings || dataSettings.length == 0) {
	        if (flag == 'showLeftMenu') {
	          _reactDom2.default.render(_react2.default.createElement(_TreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: '' }), document.getElementById('mainMenu'));
	        }
	        if (flag == 'showLeftListMenu') {
	          _reactDom2.default.render(_react2.default.createElement(_ListTreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: '' }), document.getElementById('listtree-mainMenu'));
	        }
	        return;
	      }
	      window.userDataSettings = dataSettings;
	
	      if (dataSettings && dataSettings != []) {
	        for (var _i19 = 0; _i19 < dataSettings.length; _i19++) {
	          var ds = dataSettings[_i19];
	          if (!ds.menuLabel) {
	            continue;
	          }
	          var _clsName = "iconfont  icon-yingyong-dianjihou text-blue";
	          var _clsName2 = "iconfont  icon-yingyong-dianjihou";
	          if (flag === 'showLeftMenu') {
	            content.push(_react2.default.createElement(
	              'li',
	              { className: 'treeview menuItem', key: 'menuItem-li' + _i19, 'data-formLabel': ds.menuLabel },
	              _react2.default.createElement(
	                'a',
	                { title: ds.menuLabel, style: { cursor: "pointer", display: 'flex', alignItems: 'center', paddingTop: '1px', paddingBottom: '1px' }, onDoubleClick: window.dataSettingClick, 'data-SetId': ds.dataSetId, 'data-SetUniqueId': ds.recId, 'data-menuLabel': ds.menuLabel },
	                _react2.default.createElement('i', { className: _clsName, style: { flexShrink: 0, marginRight: '4px', marginTop: '2px', fontSize: '14px' } }),
	                _react2.default.createElement(
	                  'div',
	                  { 'data-SetId': ds.dataSetId, 'data-SetUniqueId': ds.recId, 'data-menuLabel': ds.menuLabel },
	                  ds.menuLabel
	                )
	              )
	            ));
	          }
	          if (flag === 'showLeftListMenu') {
	            content.push(_react2.default.createElement(
	              'li',
	              { 'data-SetId': ds.dataSetId, 'data-SetUniqueId': ds.recId, 'data-menuLabel': ds.menuLabel },
	              _react2.default.createElement(
	                'a',
	                { className: "listtree-menu-title ", onClick: window.dataSettingClick, 'data-SetId': ds.dataSetId, 'data-SetUniqueId': ds.recId, 'data-menuLabel': ds.menuLabel },
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: 'flex' }, 'data-SetId': ds.dataSetId, 'data-SetUniqueId': ds.recId, 'data-menuLabel': ds.menuLabel },
	                  _react2.default.createElement('div', { className: "listtree-menu-icon " + _clsName2 }),
	                  _react2.default.createElement(
	                    'span',
	                    { 'data-SetId': ds.dataSetId, 'data-SetUniqueId': ds.recId, 'data-menuLabel': ds.menuLabel },
	                    ds.menuLabel
	                  )
	                )
	              )
	            ));
	          }
	        }
	      }
	      window.userDataSettingsContent = content;
	      if (flag === 'showLeftMenu') {
	        _reactDom2.default.render(_react2.default.createElement(_TreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: content }), document.getElementById('mainMenu'));
	      }
	      if (flag === 'showLeftListMenu') {
	        _reactDom2.default.render(_react2.default.createElement(_ListTreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: content }), document.getElementById('listtree-mainMenu'));
	      }
	      window.rightSidebarClicked = true;
	    },
	    error: function error(data) {
	      if (flag === 'showLeftMenu') {
	        _reactDom2.default.render(_react2.default.createElement(_TreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: '' }), document.getElementById('mainMenu'));
	      }
	      if (flag === 'showLeftListMenu') {
	        _reactDom2.default.render(_react2.default.createElement(_ListTreeViewMainMenu2.default, { data: window.got.MainMenu, dataSettings: '' }), document.getElementById('listtree-mainMenu'));
	      }
	    }
	  });
	
	  // var command = Command.createService(
	  // "gongqi.erp.gotmodel.services.UserSettingService",
	  // "loadUserDataSetSetting",
	  // "String"
	  // );
	  // var _resultHandler = function (data) {
	
	  // }
	  // var _resultErrHandler = function (data) {
	  //   if(flag ==='showLeftMenu'){
	  //     ReactDOM.render(<TreeViewMainMenu data={window.got.MainMenu} dataSettings='' />, document.getElementById('mainMenu'));
	  //   }
	  //   if(flag ==='showLeftListMenu'){
	  //     ReactDOM.render(<ListTreeViewMainMenu data={window.got.MainMenu} dataSettings=''/>, document.getElementById('listtree-mainMenu'));
	  //   }
	  // }
	  // var remoteArg = {
	  //   command: command, resultFunction: _resultHandler,
	  //   faultFunction: _resultErrHandler,
	  //   sync: false
	  //   };
	  //   ServiceHelper.addTokenWithCommand(remoteArg);
	};
	
	window.doAfterMainMenu = function () {
	  if (window.userSettingEntry.showToolMenu == true) _reactDom2.default.render(_react2.default.createElement(_ListMainMenu2.default, { data: window.got.MainMenu }), document.getElementById('listMainMenu'));
	  //当有别的主页包含框架时 有时需要直接打开固定页面
	  if (sessionStorage.getItem("openFixedFormArg")) {
	    var fixedOpenFormArgStr = sessionStorage.getItem("openFixedFormArg");
	    var fixedOpenFormArg = JSON.parse(fixedOpenFormArgStr);
	    sessionStorage.removeItem("openFixedFormArg");
	    var ofa_paramObject = fixedOpenFormArg.paramObject;
	    if ((typeof ofa_paramObject === 'undefined' ? 'undefined' : _typeof(ofa_paramObject)) == "object" && ofa_paramObject && !ofa_paramObject.hasOwnProperty("remoteClass")) ofa_paramObject = Object.assign({ remoteClass: "java.util.Map" }, ofa_paramObject);
	
	    var addJoin = false;
	    var _autoJoinParentArg = { autoJoinParent: false };
	
	    _FormLoadHelper2.default.openMenuItemByAuthority({
	      menuItemId: fixedOpenFormArg.menuItemId, parm: fixedOpenFormArg.paramString, fm: null,
	      group: null, callerKey: fixedOpenFormArg.callerKey, paramObject: ofa_paramObject, popUp: fixedOpenFormArg.isPopUp, addJoin: addJoin,
	      autoJoinParentArg: _autoJoinParentArg
	    });
	    //command.appendArg(fixedUserGroups.split(","),"String[]");
	  }
	  //登录后立即执行命令 一般是打开画面
	
	
	  if (window.userInfos.clientCommandAfterLoginResult) {
	    _CommandResolver2.default.resolve(window.userInfos.clientCommandAfterLoginResult.tasks);
	  }
	
	  var fixedOpenForms = _CommonUtil2.default.getUrlParam("fixedOpenForms");
	  if (fixedOpenForms) {
	    var fixedOpenFormsArray = [];
	    if (fixedOpenForms && fixedOpenForms.indexOf("[") == 0) {
	      fixedOpenFormsArray = JSON.parse(fixedOpenForms);
	    } else {
	      fixedOpenFormsArray = [fixedOpenForms];
	    }
	    for (var _i20 = 0; _i20 < fixedOpenFormsArray.length; _i20++) {
	      var fixedOpenForm = fixedOpenFormsArray[_i20] + "";
	      var commandTask = { arg: fixedOpenForm, cmd: "openForm" };
	      _CommandResolver2.default.resolve([commandTask]);
	    }
	  }
	
	  // 从OS 搜索打开页面
	  var fixedOpenMenuItem = getQueryString("menuItem", window.location.search);
	  if (fixedOpenMenuItem) {
	    setTimeout(function () {
	      var commandTask = { arg: { menuItemId: fixedOpenMenuItem, onlyQuery: false, label: "", checkHas: false, fromMainMenu: true }, cmd: "openForm" };
	      _CommandResolver2.default.resolve([commandTask]);
	    }, 2000);
	  }
	  var fixedCommandResult = getQueryString("CommandResult", window.location.search);
	  if (fixedCommandResult) {
	    setTimeout(function () {
	      var obj = JSON.parse(fixedCommandResult);
	      window.exeCommandResult(obj);
	    }, 2000);
	  }
	
	  if (window.userInfos.licenseXML) {
	    var domparse = new DOMParser();
	    var doc = domparse.parseFromString(window.userInfos.licenseXML, "application/xml");
	    var licenses = doc.getElementsByTagName("gongqiLicenses")[0];
	    var license = licenses.getElementsByTagName("license")[0];
	    var customer = license.getElementsByTagName("LicensedCustomer")[0];
	    var customerStr = customer.textContent;
	    var project = license.getElementsByTagName("LicensedProject")[0];
	    var projectStr = project.textContent;
	    $("#versionTxtDiv").html(customerStr + " " + projectStr).on("click", window.showLicenseModal);
	  }
	};
	//TODO OS 搜索 直接打开 MenuItem
	window.OSSearchOpenMenuItem = function (params) {
	  var fixedOpenMenuItem = params ? params : getQueryString("menuItem", window.location.search);
	  if (fixedOpenMenuItem && !fixedOpenMenuItem.tasks) {
	    var commandTask = { arg: { menuItemId: fixedOpenMenuItem, onlyQuery: false, label: "", checkHas: false, fromMainMenu: true }, cmd: "openForm" };
	    _CommandResolver2.default.resolve([commandTask]);
	  }
	  var fixedCommandResult = params ? params : getQueryString("CommandResult", window.location.search);
	  if (fixedCommandResult) {
	    try {
	      var obj = JSON.parse(fixedCommandResult);
	      window.exeCommandResult(obj);
	    } catch (e) {}
	  }
	};
	//TODO OS消息 直接执行CommandResult
	window.OSMessageLinkDoCommand = function (params) {
	  var fixedCommandResult = params ? params : getQueryString("CommandResult", window.location.search);
	  if (fixedCommandResult) {
	    window.exeCommandResult(fixedCommandResult);
	  }
	};
	
	window.gotErrorHandler = function (faultEvent) {
	  var faultString;
	  if (faultEvent && faultEvent.successButNot0) {
	    faultString = faultEvent.errText;
	  } else {
	    faultString = "可能是网络错误 请检查网络是否正常";
	  }
	  _Warn2.default.show({ text: faultString, title: "获取GOT失败" });
	};
	
	//got
	//var command = Command.createService("gongqi.erp.layers.sys.services.TestH5Service","getGOT","Object");// <=f8
	
	
	window.relation1NSuccessHandler = function (data) {
	  if (data.status == 0) {
	    window.relation1N = data.result;
	  } else {
	    alert(JSON.stringify(data));
	  }
	};
	
	window.relation1NErrorHandler = function (faultEvent) {
	
	  var faultString;
	  if (faultEvent && faultEvent.successButNot0) {
	    faultString = faultEvent.errText;
	  } else {
	    faultString = "可能是网络错误 请检查网络是否正常";
	  }
	  _Warn2.default.show({ text: faultString, title: "获取表结构关系失败" });
	};
	
	//realation1N
	
	if (fromOrig != "oshome") {
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "getAllRelations", "List");
	  var remoteArg = { command: command, sync: false, resultFunction: window.relation1NSuccessHandler, faultFunction: window.relation1NErrorHandler };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	}
	
	window.isCurrentWindow = function (formWindow) {
	  var win;var iframe;
	  //TODO弹出页面上又有弹出页面？之前根据经验由于需求过于繁琐采用栈来管理也并不好管理
	  if (formWindow && formWindow.isPopUp) {
	    var popIframes = $("#formModal iframe");
	    if (popIframes.length > 0) {
	      iframe = popIframes.get(popIframes.length - 1);
	      win = iframe.window || iframe.contentWindow;
	      if (win == formWindow) return true;
	    }
	    return false;
	  }
	  var arr = $("#g_tab_content>div.tab-pane.active iframe");
	  if (arr.length > 0) {
	    iframe = arr.get(0);
	    win = iframe.window || iframe.contentWindow;
	    return win == formWindow;
	  }
	  return false;
	};
	
	$("#search-btn").on("click", function () {
	  doSearch();
	});
	
	$("#searchInput").on('input', function () {
	  //todo  取当前值
	  var thisword = $("#searchInput").val();
	  var timerId = setTimeout(function () {
	    //todo 取当前值 一样 执行函数
	    var nowword = $("#searchInput").val();
	
	    if (nowword == thisword) {
	      doSearch();
	      if (!nowword) {
	        $(".sidebar-menu li.active").removeClass("active");
	        $(".sidebar-menu ul.menu-open").removeClass("menu-open");
	        $(".sidebar-menu ul.treeview-menu").css("display", "");
	      }
	    }
	
	    clearTimeout(timerId);
	  }, 500);
	});
	
	function doSearch() {
	  var keyword = $("#searchInput").val().toLowerCase();
	
	  $('.sidebar-menu li').show();
	  //menuitem
	
	  $('.sidebar-menu li.menuItem').each(function () {
	    var dataword = $(this).attr("data-formlabel");
	
	    if (dataword) {
	      var datawordLow = dataword.toLowerCase();
	      if (datawordLow.indexOf(keyword) == -1) {
	        $(this).hide();
	      } else {
	        $(this).show();
	        $(this).parent().addClass('menu-open');
	        $(this).parent().parent().addClass('active');
	      }
	    }
	  });
	
	  $('.sidebar-menu ul.treeview-menu').each(function () {
	
	    var menuItems = $(this).find(".menuItem");
	    var hide = true;
	    for (var i = 0; i < menuItems.length; i++) {
	      var menuItem = menuItems.get(i);
	      if ($(menuItem).css('display') != 'none') {
	        hide = false;
	      }
	    }
	
	    hide ? $(this).hide() : $(this).show();
	  });
	
	  //menuSub
	  $('.sidebar-menu .menuSub').each(function () {
	
	    var menuItems = $(this).find(".menuItem");
	    var hide = true;
	    for (var i = 0; i < menuItems.length; i++) {
	      var menuItem = menuItems.get(i);
	      if ($(menuItem).css('display') != 'none') {
	        hide = false;
	      }
	    }
	
	    hide ? $(this).hide() : $(this).show(), $(this).parent().addClass('menu-open'), $(this).parent().parent().addClass('active');
	  });
	
	  //menu
	  $('.sidebar-menu>li.treeview').each(function () {
	    var menuItems = $(this).find(".menuItem");
	    var hide = true;
	    for (var i = 0; i < menuItems.length; i++) {
	      var menuItem = menuItems.get(i);
	      if ($(menuItem).css('display') != 'none') {
	        hide = false;
	      }
	    }
	
	    hide ? $(this).hide() : $(this).show();
	  });
	}
	
	window.showPasswordModal = function () {
	  $("#passwordModal").show();
	  $('#but_PasswordModalClose').css('display', '');
	  $('#but_PasswordModalCancel').css('display', '');
	};
	
	window.hidePasswordModal = function () {
	  $("#passwordModal").hide();
	};
	
	window.hideOverallSituationModel = function () {
	  $("#overallSituationDialog").hide();
	};
	
	window.showLicenseModal = function () {
	
	  if (!window.licenseIsShow) {
	    var license = userInfos.licenseInfo;
	    var doc = new DOMParser().parseFromString(license, "application/xml");
	    var gongqiLicenses = doc.getElementsByTagName("license")[0].childNodes;
	    if (gongqiLicenses.length > 0) {
	      for (var _i21 in gongqiLicenses) {
	        if (gongqiLicenses[_i21].attributes) {
	          var labelName = gongqiLicenses[_i21].attributes.display.nodeValue;
	          var labelContext = gongqiLicenses[_i21].textContent;
	          $("<p></p>").html(labelName + "：" + labelContext).appendTo($("#licenseModal .modal-body"));
	        }
	      }
	    }
	    window.licenseIsShow = true;
	  }
	  $("#licenseModal").show();
	};
	
	window.upDownLicenseModal = function () {
	  //ReactDOM.render(<LicenseUpLoad  />, document.getElementById('licenseUpLoadModal'));
	  var task = { arg: { 'url': window.parent.window.userInfos.serviceURL + '/web/platformlicense/upload' } };
	  _LicenseUpLoad2.default.doFileUpload(task);
	};
	
	window.verificationLicenseModal = function () {
	  var license = userInfos.licenseInfo;
	  var doc = new DOMParser().parseFromString(license, "application/xml");
	  var gongqiLicenses = doc.getElementsByTagName("license")[0].childNodes;
	  var reData = {};
	  if (gongqiLicenses.length > 0) {
	    for (var _i22 in gongqiLicenses) {
	      if (gongqiLicenses[_i22].attributes) {
	        var labelName = gongqiLicenses[_i22].attributes.display.nodeValue;
	        var labelContext = gongqiLicenses[_i22].textContent;
	        if (labelName == '数字签名') {
	          //reData['secretKey'] = 'MCwCFFdqcFPeHtt/Y+lC3MxxdKtsV2bxAhQonKIzE8pRTsZrXzAQ4P+IFAjZsg==';
	          reData['secretKey'] = labelContext;
	        }
	      }
	    }
	  }
	  var url = 'http://ims.gongqi.info:55208/web/apps/gongqi.oa.yw/operation/originalEffectiveness?_dataarea=dynamic';
	  $.ajax({
	    type: 'post',
	    url: url,
	    data: reData,
	    //headers:{'_dataarea':'dynamic'},
	    xhrFields: { withCredentials: true },
	    success: function success(data) {
	      console.log(data);
	      if (data.content == null) {
	        alert('没有查询到License信息');
	      } else {
	        alert('验证成功');
	      }
	    },
	    error: function error(data) {
	
	      if (errorHandler != undefined) {
	        errorHandler(data);
	      } else {
	        _Warn2.default.show({ text: "网络链接出问题了喔,请稍后再试" });
	      }
	    }
	  });
	};
	
	window.hideLicenseModal = function () {
	  $("#licenseModal").hide();
	};
	
	window.getLoginMsg = function () {
	  if (!window.isGetLoginMsg) {
	    var y = userInfos.loginDate.getFullYear();
	    var m = userInfos.loginDate.getMonth() + 1;
	    var d = userInfos.loginDate.getDate();
	
	    var licenseInfo = window.got.licenseInfo;
	    if (licenseInfo) {
	      var infoArray = licenseInfo.split("|");
	      var versionTxt = infoArray[0];
	      var _arr = versionTxt.split(" ");
	      $("#subSysIdPart").html(userInfos.userId + "&nbsp;" + userInfos.userName + '<br>' + '<div style="font-size:14px;">' + _arr[0] + '</div><div style="font-size:14px;">' + _arr[1] + '</div>');
	    } else {
	      $("#subSysIdPart").html(userInfos.userId + "&nbsp;" + userInfos.userName + '<br>' + userInfos.subSystem);
	    }
	    $("#subSysId").append("<small><div style='float:left;margin-right:10px;font-family: STSongti-SC-Regular;font-size: 14px;color: #69727A;letter-spacing: 0;'>会话标记:</div><p style='font-size:11px;margin-bottom:0px;'>" + userInfos.userSessionId + "</p></small>").append("<small><div style='float:left;margin-right:10px;font-family: STSongti-SC-Regular;font-size: 14px;color: #69727A;letter-spacing: 0;'>登录时间:</div>" + y + "年" + m + "月" + d + "日" + " " + userInfos.loginTime + "</small>").append("<small><div style='float:left;margin-right:10px;font-family: STSongti-SC-Regular;font-size: 14px;color: #69727A;letter-spacing: 0;'>在线时间:</div><label id='hours'></label>小时<label id='minutes'></label>分钟<label id='seconds'></label>秒</small>");
	    getLoginTime();
	    var interval = setInterval(getLoginTime, 1000);
	    window.isGetLoginMsg = true;
	
	    $(".user.user-menu>ul.dropdown-menu>li.user-header").on("click", function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	    });
	  }
	};
	
	window.getLoginTime = function () {
	  var myDate = new Date();
	  var y = userInfos.loginDate.getFullYear();
	  var m = userInfos.loginDate.getMonth() + 1;
	  var d = userInfos.loginDate.getDate();
	  var logDate = y + '-' + m + '-' + d + ' ' + userInfos.loginTime;
	  logDate = new Date(logDate);
	  var time = myDate.getTime() - logDate.getTime();
	  var hours = parseInt(time % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
	  var minutes = parseInt(time % (1000 * 60 * 60) / (1000 * 60));
	  var seconds = parseInt(time % (1000 * 60) / 1000);
	  $("#hours").html(hours);
	  $("#minutes").html(minutes);
	  $("#seconds").html(seconds);
	};
	
	window.showQueryForm = function () {
	
	  $("#queryFormDiv").load("query/queryForm.html");
	};
	
	window.showExportModal = function () {
	  $("#exportModal").load('export/export.html');
	};
	
	window.listMainMenuState = function () {
	  if ($("#listMainMenu").hasClass('listMainMenuShow')) {
	    $('.main-header').css('top', '0');
	    $('.main-sidebar').css('top', '0');
	
	    if (window.userSettingEntry.showLeftListMenu == true) {
	      if (window.userSettingEntry.hideToolBar == true) {
	        $(".listtree-sidebar").css('top', '0px');
	        $('.content-wrapper').css('top', '0px');
	      } else {
	        $(".listtree-sidebar").css('top', '42px');
	        $('.content-wrapper').css('top', '42px');
	      }
	    } else {
	      $('.content-wrapper').css('padding-top', '42px');
	    }
	
	    $("#listMainMenu").removeClass('listMainMenuShow').hide();
	    $("#toolMenuControl>i.menuControl-i").removeClass('fa-long-arrow-up').addClass('fa-long-arrow-down');
	  } else {
	    $('.main-header').css('top', '30px');
	    $('.main-sidebar').css('top', '30px');
	
	    if (window.userSettingEntry.showLeftListMenu == true) {
	      if (window.userSettingEntry.hideToolBar == true) {
	        $(".listtree-sidebar").css('top', '30px');
	        $('.content-wrapper').css('top', '30px');
	      } else {
	        $(".listtree-sidebar").css('top', '80px');
	        $('.content-wrapper').css('top', '80px');
	      }
	    } else {
	      $('.content-wrapper').css('padding-top', '80px');
	    }
	
	    $("#listMainMenu").addClass('listMainMenuShow').show();
	    $("#toolMenuControl>i.menuControl-i").removeClass('fa-long-arrow-down').addClass('fa-long-arrow-up');
	  }
	};
	
	window.logOut = function () {
	  var command = _Command2.default.createService("gongqi.erp.framework.services.UserSessionService", "logout", "void");
	  var _resultHandler = function _resultHandler(data) {
	    window.location.href = loginPath;
	  };
	  var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	var dataSetGlobalId = 0;
	window.dataSettingClick = function (e) {
	  var dataSetId = $(e.target).attr("data-SetId");
	  var menuLabel = $(e.target).attr("data-menuLabel");
	  var dataSetUniqueId = $(e.target).attr("data-SetUniqueId");
	  if (!dataSetId) {
	    dataSetId = $(e.target).parent().attr("data-SetId");
	    menuLabel = $(e.target).parent().attr("data-menuLabel");
	    dataSetUniqueId = $(e.target).parent().attr("data-SetUniqueId");
	  }
	
	  var _args = { label: menuLabel, formId: "DataSetForm", menuItemId: "DataSetmMenuItem_" + ++dataSetGlobalId, fixedUrl: "dsform.html?dataSetId=" + dataSetId + "&dataSetUid=" + dataSetUniqueId };
	  testOpenForm(_args);
	  return;
	
	  if (!window.dataSetCache) window.dataSetCache = {};
	
	  if (window.dataSetCache.hasOwnProperty(dataSetId)) {
	    var _args2 = { label: menuLabel, formId: "DataSetForm", menuItemId: "DataSetmMenuItem", fixedUrl: "dsform.html?dataSetId=" + dataSetId + "&dataSetUid=" + dataSetUniqueId };
	    testOpenForm(_args2);
	    return;
	  }
	
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserDataSet", "String");
	
	  //command.appendArg(window.userInfos.userId);
	  command.appendArg("zyf");
	  command.appendArg(dataSetId);
	
	  _ServiceHelper2.default.addTokenWithCommand({
	    command: command, resultFunction: function resultFunction(event) {
	      var datasetstr = event.result;
	      var dataset = JSON.parse(datasetstr);
	      window.dataSetCache[dataSetId] = dataset;
	      //打开dsform页面
	      var args = { label: menuLabel, formId: "DataSetForm", menuItemId: "DataSetmMenuItem", fixedUrl: "dsform.html?dataSetId=" + dataSetId + "&dataSetUid=" + dataSetUniqueId };
	      testOpenForm(args);
	      return;
	
	      delete dataset.setRows;
	      delete dataset.query;
	
	      var command = _Command2.default.createService("gongqi.erp.layers.sys.services.ExportService", "exportExcel", "String");
	
	      command.appendArg(datasetstr);
	
	      _ServiceHelper2.default.addTokenWithCommand({
	        command: command, resultFunction: function resultFunction(data) {
	          if (data) {
	            var commandTask = new _CommandTask2.default();
	            commandTask.cmd = _Cmd2.default.FileDownload;
	            commandTask.arg = data.result;
	            _CommandResolver2.default.downLoad(commandTask, null);
	          }
	        }
	      });
	    }
	  });
	};
	
	window.rightSidebarClick = function () {
	  if (window.rightSidebarClicked) return;
	
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserDataSetSetting", "String");
	  var _resultHandler = function _resultHandler(data) {
	
	    var dataSettings = data.result;
	    if (!dataSettings) {
	      return;
	    }
	    dataSettings = JSON.parse(dataSettings);
	
	    /**
	     * <li>
	          <a href="javascript:void(0)" style="padding-top: 0px;">
	            <h6 class="control-sidebar-heading" style="font-size:14px;cursor:pointer;margin-top: 0px;">9点前打卡次数</h6>
	          </a>
	       </li>
	    */
	    window.userDataSettings = dataSettings;
	    for (var _i23 = 0; _i23 < dataSettings.length; _i23++) {
	      var ds = dataSettings[_i23];
	      var $h6 = $("<h6 class='control-sidebar-heading' style='font-size:14px;cursor:pointer;margin-top: 0px;'></h6>").html(ds.menuLabel);
	      var $a = $("<a  style='padding-top: 0px;'>").attr("dataSetId", ds.dataSetId).attr("menuLabel", ds.menuLabel).attr("dataSetUniqueId", ds.recId).append($h6).click(window.dataSettingClick);
	      $("#control-sidebar-home-tab .control-sidebar-menu").append($("<li>").append($a));
	    }
	    window.rightSidebarClicked = true;
	  };
	  var remoteArg = {
	    command: command, resultFunction: _resultHandler,
	    faultFunction: function faultFunction() {},
	    sync: false
	  };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	window.changePassword = function () {
	  var orgPwd = $('#orgPwd').val();
	  var newPwd = $('#newPwd').val();
	  var finPwd = $('#finPwd').val();
	  if (newPwd == '') {
	    alert('请填写新密码！');
	    return false;
	  }
	  if (newPwd != finPwd) {
	    alert('两次输入的新密码不一致！');
	    return false;
	  }
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.MixedService", "changePassword", "boolean");
	  command.appendArg(userInfos.userId);
	  command.appendArg(orgPwd);
	  command.appendArg(finPwd);
	  var _resultHandler = function _resultHandler(data) {
	    alert('密码修改成功！');
	    $('#orgPwd').val('');
	    $('#newPwd').val('');
	    $('#finPwd').val('');
	    $("#passwordModal").hide();
	  };
	  var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	
	  var data = {
	    'dataArea': 'dynamic',
	    'userId': window.userInfos.userId,
	    'userName': window.userInfos.userName,
	    'clientSessionId': window.userInfos.userSessionId,
	    'dateTime': new Date().getTime() + '',
	    'operationId': '009',
	    'formId': '',
	    'formDataSourceName': '',
	    'formItemName': '',
	    'remark': ''
	  };
	  window.setOperate(data);
	};
	
	window.updateAttachmentNum = function (num) {
	  if (num > 9) num = "9+";
	  $("#attachmentNum").html(num);
	  $("#attachmentNum2").html(num);
	  if (num == 0) {
	    $("#attachmentNum").css('display', 'none');
	    $("#attachmentNum2").css('display', 'none');
	  }
	};
	
	window.reInitForm = function () {
	  var popIframes = $("#formModal iframe");
	  if (popIframes.length > 0) {
	    iframe = popIframes.get(popIframes.length - 1);
	    win = iframe.window || iframe.contentWindow;
	    if (win && typeof win.reInit == "function") {
	      win.reInit();
	    }
	    return;
	  }
	
	  var arr = $("#g_tab_content>div.tab-pane.active iframe");
	  if (arr.length > 0) {
	    var iframe = arr.get(0);
	    var win = iframe.window || iframe.contentWindow;
	    if (win && typeof win.reInit == "function") {
	      win.reInit();
	    }
	  }
	};
	
	window.reInitGlobal = function () {
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "reInitGOT", "byte[]");
	  command.appendArg("false", "boolean");
	  var remoteArg = { command: command, resultFunction: rpc_result_reInitGlobal, sync: false, lockText: "正在全局初始化 请稍后..." };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	window.rpc_result_reInitGlobal = function (data) {
	  window.location.reload();
	};
	
	window.reInitAPP = function () {
	  /*let list = ["生产","采购","销售222222222222222222"];
	  $("#globalUserSetFormDiv").css("display", "flex");
	  ReactDOM.render(<ReInitAPPComponent appList={list}/>,document.getElementById('globalUserSetFormDiv'));
	  return;*/
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "getInitSolutions", "List");
	
	  var remoteArg = {
	    command: command,
	    resultFunction: window.rpc_result_getAppList,
	    sync: false
	  };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	window.rpc_result_getAppList = function (data) {
	  var list = data.result;
	  $("#globalUserSetFormDiv").css("display", "flex");
	  _reactDom2.default.render(_react2.default.createElement(_ReInitAPPComponent2.default, { appList: list }), document.getElementById('globalUserSetFormDiv'));
	};
	
	window.importManager = function () {
	  _FormLoadHelper2.default.openMenuItemByAuthority({ menuItemId: "50000016", popUp: false });
	};
	window.showUniversalViewSet = function () {
	  _FormLoadHelper2.default.openMenuItemByAuthority({ menuItemId: "50000034", popUp: false });
	};
	
	window.showUniversalView = function () {
	  var userId = window.userInfos.userId;
	  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
	  var iframe = $("<iframe>").css("border", "none").attr("id", "iframeUniversalViewForm").css("width", "100%").css("height", "100%").css("background", "none");
	  iframe.attr("src", "universalView.html?userId=" + userId);
	  $("#universalModal").append(modalDiv.append(iframe));
	
	  var remark = { "title": '打开万能视图查询器' };
	  var data = {
	    'dataArea': 'dynamic',
	    'userId': window.userInfos.userId,
	    'userName': window.userInfos.userName,
	    'clientSessionId': window.userInfos.userSessionId,
	    'dateTime': new Date().getTime() + '',
	    'operationId': '015',
	    'formId': '',
	    'formDataSourceName': '',
	    'formItemName': '',
	    'remark': JSON.stringify(remark)
	  };
	  window.setOperate(data);
	};
	
	window.showUniversalViewByForm = function () {
	  var currentWin = window.getCurrentWin();
	  if (!currentWin) return;
	  if (!currentWin.isDataSetView) {
	    _Warn2.default.show({ text: "当前页面不是数据集关联页面" });return;
	  }
	  var userId = window.userInfos.userId;
	  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
	  var iframe = $("<iframe>").css("border", "none").attr("id", "iframeUniversalViewForm").css("width", "100%").css("height", "100%").css("background", "none");
	  iframe.attr("src", "universalView.html?userId=" + userId + "&dataSetId=" + currentWin.formId);
	  $("#universalModal").append(modalDiv.append(iframe));
	
	  var remark = { "title": '打开万能视图查询器' };
	  var data = {
	    'dataArea': 'dynamic',
	    'userId': window.userInfos.userId,
	    'userName': window.userInfos.userName,
	    'clientSessionId': window.userInfos.userSessionId,
	    'dateTime': new Date().getTime() + '',
	    'operationId': '015',
	    'formId': '',
	    'formDataSourceName': '',
	    'formItemName': '',
	    'remark': JSON.stringify(remark)
	  };
	  window.setOperate(data);
	};
	
	window.fromOSopenDataSetViewes = function () {
	  var fileName = window.formOSopenDataSetViewId;
	  var userId = window.userInfos.userId;
	  var domain = window.didomain;
	  var url = window.osUrl + "/manage/dataSetLoadOnePer";
	  var _headers = {};
	  if (!window.loginToken) {
	    var _token = localStorage.getItem("userToken");
	    if (_token) _headers.token = _token;
	  }
	  var that = this;
	  $.ajax({
	    type: 'get',
	    url: url,
	    dataType: "json",
	    data: {
	      userId: userId,
	      doMain: domain,
	      datasetId: fileName
	    },
	    headers: _headers,
	    sync: true,
	    xhrFields: { withCredentials: true },
	    success: function success(data) {
	      if (data.code == 0) {
	        var _$$ajax;
	
	        var datar = JSON.parse(data.result);
	        if (!datar.content) {
	          var text = "当前用户无使用权限";
	          var options = { state: 'error', text: text };
	          _Fade2.default.show(options);
	        }
	        var content = JSON.parse(datar.content);
	        content.fileName = fileName;
	        var queryTableUtil = new _QueryTableUtil2.default();
	        queryTableUtil.getQueryTableParams(content.queryTable);
	        var tables = queryTableUtil.doMainTables;
	        var domains = new Set();
	        for (var inx in tables) {
	          if (window.didomain != tables[inx].doMain) {
	            domains.add(tables[inx].doMain);
	          }
	        }
	        domains.forEach(function (element, sameElement, set) {
	          window.initDoMainGotTable(element);
	        });
	        var _header = { "Content-type": "application/json" };
	        if (!window.parent.window.loginToken) {
	          var _token2 = localStorage.getItem("userToken");
	          if (_token2) {
	            _header.token = _token2;
	          } else {
	            _header.token = window.parent.window.localStorage.getItem("userToken");
	          }
	        }
	        var param = {
	          "queryTable": content
	        };
	        $.ajax((_$$ajax = {
	          type: 'post',
	          url: window.osUrl + "/" + "MIX" + "/web/apps/gongqi.tool.datasetDesign/dsDesign/getDirectGotTable",
	          dataType: "json",
	          headers: _headers,
	          data: JSON.stringify(param)
	        }, _defineProperty(_$$ajax, 'headers', _header), _defineProperty(_$$ajax, 'xhrFields', { withCredentials: true }), _defineProperty(_$$ajax, 'success', function success(data) {
	          if (data.errcode == 0) {
	            var con = data.content;
	            for (var _i24 in con) {
	              for (var k in con[_i24]) {
	                window.got.DataDictionary.Tables[k] = con[_i24][k];
	              }
	            }
	            var res = { "result": content };
	            window.rpc_result_reInitDataSetView(res);
	          }
	        }), _defineProperty(_$$ajax, 'error', function error(data) {}), _$$ajax));
	      } else {
	        var _text = data.errmsg ? data.message : "加载失败";
	        var options = { state: 'error', text: _text };
	        _Fade2.default.show(options);
	      }
	    },
	    error: function error(data) {}
	  });
	};
	
	window.initDoMainGotTable = function (doMain) {
	  var url = window.osUrl + "/GongqiERP/" + doMain + "/ServiceController";
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "getGOT", "byte[]");
	  var remoteArg = { command: command, resultFunction: window.gotDoMainSuccessHandler, sync: true, url: url, domain: doMain };
	  _ServiceHelper2.default.addTokenWithCommand2(remoteArg);
	};
	
	window.gotDoMainSuccessHandler = function (data, domain) {
	  if (data.status == 0) {
	    var compressedByteArray = base64js.toByteArray(data.result);
	    var s = pako.inflate(compressedByteArray, { to: 'string' });
	    var got = JSON.parse(s);
	    if (!window.doMainGot) {
	      window.doMainGot = [];
	    }
	    window.doMainGot.push({ 'doMain': domain, 'got': got, 'direct': false, 'shortName': "" });
	    for (var key in got.DataDictionary.Tables) {
	      window.got.DataDictionary.Tables[key] = got.DataDictionary.Tables[key];
	    }
	    for (var key1 in got.DataDictionary.DataTypes) {
	      window.got.DataDictionary.DataTypes[key1] = got.DataDictionary.DataTypes[key1];
	    }
	    for (var key2 in got.DataDictionary.Enums) {
	      window.got.DataDictionary.Enums[key2] = got.DataDictionary.Enums[key2];
	    }
	  }
	};
	
	window.rpc_result_reInitDataSetView = function (data) {
	  var args = {
	    fixedUrl: "dsform.html?popUp=true&isPreview=true",
	    formId: "DataSetForm",
	    label: "预览", menuItemId: "DataSetmMenuItemYL_2",
	    popUp: true,
	    isDataSetPreview: true
	  };
	  var dataset = data.result;
	  var dataSetRes = {
	    formObjectStandard: { formNodeList: [], formXML: JSON.stringify(dataset), listAggregateTable: [], listControlProperty: [], listRemoteMethods: [{ commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "beforeInit", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "afterInit", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "formClosing", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "formClosed", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "lookupRefresh", prefetch: true }],
	      listTmpTable: [], mapItemProperty: [], mapOverrideInners: null, mapQueryTable: {}, md5: "8b04cf4ed82ddae2661d649344edda42", swf: null },
	    formObjectUserSet: null,
	    formPrefetchCommandResult: { commandResults: { afterInit: { tasks: [{ arg: null, cmd: "executeQuery", control: null, group: "all" }] }, beforeInit: { tasks: [] }, formClosed: null, formClosing: null }, md5: "f0b1e34c771933181212e940b8f4c3ae" },
	    mapFormObjectAuthority: null,
	    mapSameFormObjectAuthority: null,
	    sameFormObjectStandard: false,
	    sameFormObjectUserSet: false,
	    sameFormPrefetchCommandResult: false
	  };
	
	  window.dataSetPreview = dataSetRes;
	  window.dataSetPreviewFordataset = dataset;
	  window.dataSetPreviewDataSet = _DataSetUtil2.default.strDataSet(dataset, []);
	
	  if (dataset.fileName && window.fromTB) {
	    window.pivotCacheDataSet = sessionStorage.getItem(dataset.fileName);
	  }
	  window.testOpenForm(args);
	};
	
	window.fromAppOpenDataSetViewes = function (domain, dataSetName, formModule) {
	  var userId = window.userInfos.userId;
	  var fileName = dataSetName;
	  var domain = window.didomain;
	  window.prientAppdataSetName = dataSetName;
	  var _headers = {};
	  if (!window.loginToken) {
	    var _token = localStorage.getItem("userToken");
	    if (_token) _headers.token = _token;
	  }
	  var url = window.osUrl + "/manage/dataSetLoadOnePer";
	  $.ajax({
	    type: 'get',
	    url: url,
	    dataType: "json",
	    data: {
	      doMain: domain,
	      userId: userId,
	      datasetId: fileName
	    },
	    headers: _headers,
	    sync: true,
	    xhrFields: { withCredentials: true },
	    success: function success(data) {
	      if (data.code == 0) {
	        var _$$ajax2;
	
	        var datar = JSON.parse(data.result);
	        if (!datar.content) {
	          var text = "当前用户无使用权限";
	          var options = { state: 'error', text: text };
	          _Fade2.default.show(options);
	        }
	        var content = JSON.parse(datar.content);
	        content.fileName = fileName;
	        var queryTableUtil = new _QueryTableUtil2.default();
	        queryTableUtil.getQueryTableParams(content.queryTable);
	        var tables = queryTableUtil.doMainTables;
	        var domains = new Set();
	        for (var inx in tables) {
	          if (window.didomain != tables[inx].doMain) {
	            domains.add(tables[inx].doMain);
	          }
	        }
	        domains.forEach(function (element, sameElement, set) {
	          window.initDoMainGotTable(element);
	        });
	
	        var _header = { "Content-type": "application/json" };
	        if (!window.parent.window.loginToken) {
	          var _token3 = localStorage.getItem("userToken");
	          if (_token3) {
	            _header.token = _token3;
	          } else {
	            _header.token = window.parent.window.localStorage.getItem("userToken");
	          }
	        }
	        var param = {
	          "queryTable": content
	        };
	        $.ajax((_$$ajax2 = {
	          type: 'post',
	          url: window.osUrl + "/" + "MIX" + "/web/apps/gongqi.tool.datasetDesign/dsDesign/getDirectGotTable",
	          dataType: "json",
	          headers: _headers,
	          data: JSON.stringify(param)
	        }, _defineProperty(_$$ajax2, 'headers', _header), _defineProperty(_$$ajax2, 'xhrFields', { withCredentials: true }), _defineProperty(_$$ajax2, 'success', function success(data) {
	          if (data.errcode == 0) {
	            var con = data.content;
	            for (var _i25 in con) {
	              for (var k in con[_i25]) {
	                window.got.DataDictionary.Tables[k] = con[_i25][k];
	              }
	            }
	            var args = {
	              fixedUrl: "dsform.html?popUp=true&isPreview=true",
	              formId: "DataSetForm",
	              label: "预览", menuItemId: "DataSetmMenuItemYL_2",
	              popUp: true,
	              isDataSetPreview: true
	            };
	            var dataSetRes = {
	              formObjectStandard: { formNodeList: [], formXML: JSON.stringify(content), listAggregateTable: [], listControlProperty: [], listRemoteMethods: [{ commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "beforeInit", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "afterInit", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "formClosing", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "formClosed", prefetch: true }, { commandResult: { tasks: [] }, editors: null, fetchOption: false, groups: null, joinGroup: null, methodName: "lookupRefresh", prefetch: true }],
	                listTmpTable: [], mapItemProperty: [], mapOverrideInners: null, mapQueryTable: {}, md5: "8b04cf4ed82ddae2661d649344edda42", swf: null },
	              formObjectUserSet: null,
	              formPrefetchCommandResult: { commandResults: { afterInit: { tasks: [{ arg: null, cmd: "executeQuery", control: null, group: "all" }] }, beforeInit: { tasks: [] }, formClosed: null, formClosing: null }, md5: "f0b1e34c771933181212e940b8f4c3ae" },
	              mapFormObjectAuthority: null,
	              mapSameFormObjectAuthority: null,
	              sameFormObjectStandard: false,
	              sameFormObjectUserSet: false,
	              sameFormPrefetchCommandResult: false
	            };
	
	            window.dataSetPreview = dataSetRes;
	            window.printAppformModuleInstance = formModule;
	            window.dataSetPreviewForPrintApp = true;
	            window.testOpenForm(args);
	          }
	        }), _defineProperty(_$$ajax2, 'error', function error(data) {}), _$$ajax2));
	      } else {
	        var _text2 = data.errmsg ? data.message : "加载失败";
	        var options = { state: 'error', text: _text2 };
	        _Fade2.default.show(options);
	      }
	    },
	    error: function error(data) {}
	  });
	};
	
	window.jobsOpen = function () {
	  // ReactDOM.render( < JobsForm / > , document.getElementById('JobsFormDiv'));
	  $("#JobsFormDiv").css("display", "flex");
	  window.jobsresult = [];
	  $(function () {
	    _reactDom2.default.render(_react2.default.createElement(_JobsForm2.default, null), document.getElementById('JobsFormDiv'));
	  });
	  // {/* var command: Command = Command.createService(
	  //   "gongqi.erp.gotmodel.services.JobService",
	  //   "jobs",
	  //   "List"
	  // );
	  // var _resultHandler = function(data) {
	  //       window.jobsresult = data.result;
	  //       ReactDOM.render(<JobsForm />,document.getElementById('JobsFormDiv'));
	  //       $("#JobsFormDiv").css("display","flex");
	  // };
	  // var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
	  //   ServiceHelper.addTokenWithCommand(remoteArg); */}
	
	};
	
	window.showOnLineUser = function () {
	  _ServiceHelper2.default.call("gongqi.erp.framework.services.UserSessionService", "findAllDetail", "List", window.rpc_result_getUserList, false, null);
	};
	
	window.showMenuSetting = function () {
	  //userInfos.menuCustomObject = JSON.parse(localStorage.getItem("tempTest"));
	
	  /*{
	    customItems:{"50112317.10034":{groupId:""},"50120019.10089":{groupId:""}},
	    groups:{"111":{name:"日常办公"},"111":{name:"日常办公"},"111":{name:"日常办公"},"111":{name:"日常办公"},"111":{name:"日常办公"}}//{uuid:{name:xxx}}
	  };*/
	  var menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
	  _reactDom2.default.render(_react2.default.createElement(_CustomMenu2.default, { extrals: [], menuCustomObject: menuCustomObject }), document.getElementById('exportModal'));
	};
	
	window.rpc_result_getUserList = function (data) {
	  var list = data.result;
	  _OnLineUser2.default.show(list, "在线用户");
	};
	
	window.globalUserSetOpen = function () {
	  $("#globalUserSetFormDiv").css("display", "flex");
	  $(function () {
	    _reactDom2.default.render(_react2.default.createElement(_GlobalUserSetForm2.default, null), document.getElementById('globalUserSetFormDiv'));
	  });
	
	  var data = {
	    'dataArea': 'dynamic',
	    'userId': window.userInfos.userId,
	    'userName': window.userInfos.userName,
	    'clientSessionId': window.userInfos.userSessionId,
	    'dateTime': new Date().getTime() + '',
	    'operationId': '002',
	    'formId': '',
	    'formDataSourceName': '',
	    'formItemName': '',
	    'remark': ''
	  };
	  window.setOperate(data);
	};
	window.sysAuthoritySetupOpen = function () {
	  // alert("1");
	  // window.SysmoduleListCollection =Object.assign({},window.got.MainMenu);
	  // $("#sysAuthoritySetupFormDiv").css("display", "flex");
	  // $(function() {
	  //   ReactDOM.render(<SysaAuthoritySetupFrom />,document.getElementById('sysAuthoritySetupFormDiv'));
	  // });
	
	  $("#sysAuthoritySetupFormDiv").load('sysAuthoritySetup/sysAuthoritySetupForm.html').css("display", "flex");
	};
	
	//查找当前画面并做定位
	window.globalCurrentFormFocus = function () {
	  var popIframes = $("#formModal iframe");
	  if (popIframes.length > 0) {
	    iframe = popIframes.get(popIframes.length - 1);
	    win = iframe.window || iframe.contentWindow;
	    if (win && typeof win.globalModalFormCloseToCurrent == "function") {
	      win.globalModalFormCloseToCurrent();
	    }
	    return;
	  }
	
	  var arr = $("#g_tab_content>div.tab-pane.active iframe");
	  if (arr.length > 0) {
	    var iframe = arr.get(0);
	    var win = iframe.window || iframe.contentWindow;
	    if (win && typeof win.globalModalFormCloseToCurrent == "function") {
	      win.globalModalFormCloseToCurrent();
	    }
	  }
	};
	
	window.getCurrentIframe = function () {
	  var popIframes = $("#formModal iframe");
	  if (popIframes.length > 0) {
	    iframe = popIframes.get(popIframes.length - 1);
	    return iframe;
	  }
	
	  var arr = $("#g_tab_content>div.tab-pane.active iframe");
	  if (arr.length > 0) {
	    var iframe = arr.get(0);
	    return iframe;
	  }
	};
	
	window.getCurrentWin = function () {
	  var popIframes = $("#formModal iframe");
	  if (popIframes.length > 0) {
	    iframe = popIframes.get(popIframes.length - 1);
	    win = iframe.window || iframe.contentWindow;
	    return win;
	  }
	
	  var arr = $("#g_tab_content>div.tab-pane.active iframe");
	  if (arr.length > 0) {
	    var iframe = arr.get(0);
	    var win = iframe.window || iframe.contentWindow;
	    return win;
	  }
	};
	
	//TODO
	window.getCurrentWinContent = function () {
	  var popIframes = $("#formModal iframe");
	  if (popIframes.length > 0) {
	    iframe = popIframes.get(popIframes.length - 1);
	    if (iframe.src.substr(0, 4) == "form") {
	      win = iframe.window || iframe.contentWindow;
	      return win;
	    }
	  }
	
	  var arr = $("#g_tab_content>div.tab-pane.active iframe");
	  if (arr.length > 0) {
	    var iframe = arr.get(0);
	    var win = iframe.window || iframe.contentWindow;
	    return win;
	  }
	};
	
	window.onGlobalKeyDown = function (e) {
	  //ctrl+s
	  if (e.ctrlKey && e.keyCode == 83) {
	    var arr = $("#g_tab_content>div.tab-pane.active iframe");
	    if (arr.length > 0) {
	      var iframe = arr.get(0);
	      var win = iframe.window || iframe.contentWindow;
	      if (win && typeof win.recordSave == "function") {
	        win.recordSave();
	      }
	    }
	  } else if (e.ctrlKey && e.keyCode == 70) {
	    var arr = $("#g_tab_content>div.tab-pane.active iframe");
	    if (arr.length > 0) {
	      var iframe = arr.get(0);
	      var win = iframe.window || iframe.contentWindow;
	      if (win && typeof win.find == "function") {
	        win.find();
	      }
	    }
	  } else if (e.ctrlKey && e.keyCode == 79) {
	    window.toobarFunc(e, 'groupExport', '');
	    e.preventDefault();
	  }
	  //Ctrl + I
	  else if (e.ctrlKey && e.keyCode == 73) {
	      window.toobarFunc(e, 'da', '');
	      e.preventDefault();
	    }
	    //Ctrl + Q
	    else if (e.ctrlKey && e.keyCode == 81) {
	        window.toobarFunc(e, 'queryOpen', '');
	        e.preventDefault();
	      }
	      //Ctrl + P
	      else if (e.ctrlKey && e.keyCode == 80) {
	          //alert("打印");
	          window.toobarFunc(e, 'print', '');
	          e.preventDefault();
	        }
	        //Ctrl + W
	        else if (e.ctrlKey && e.keyCode == 69) {
	            //alert("删除");
	            window.toobarFunc(e, 'queryRemove', '');
	            e.preventDefault();
	            e.stopPropagation();
	          } else if (e.ctrlKey && e.keyCode == 82) {
	            window.toobarFunc(e, 'recordRestore', '');
	            e.preventDefault();
	            e.stopPropagation();
	          } else if (e.keyCode == 27) {
	            if ($("#globalUserSetFormDiv").is(":visible")) {
	              var $reactComponentContainer = $("#globalUserSetFormDiv");
	              _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	              $("#globalUserSetFormDiv").empty().css("display", "none");
	              window.globalCurrentFormFocus();
	              return;
	            }
	
	            if ($("#exportModal #customMenuModalContainer").length > 0) {
	              $("#exportModal").empty();
	              window.globalCurrentFormFocus();
	              return;
	            }
	
	            if ($("#netWorkErrorInfoModal").is(":visible")) {
	              var _$reactComponentContainer = $("#netWorkErrorInfoModal");
	              _reactDom2.default.unmountComponentAtNode(_$reactComponentContainer[0]);
	              $("#netWorkErrorInfoModal").css("display", "none");
	              window.globalCurrentFormFocus();
	              return;
	            }
	
	            if ($("#passwordModal").is(":visible")) {
	              $("#passwordModal").hide();
	              window.globalCurrentFormFocus();
	              return;
	            }
	
	            if ($("#licenseModal").is(":visible")) {
	              $("#licenseModal").hide();
	              window.globalCurrentFormFocus();
	              return;
	            }
	
	            var globalCurrentWin = window.getCurrentWin();
	
	            if (globalCurrentWin && globalCurrentWin.closeDialogFormIfExsist) {
	              if (globalCurrentWin.closeDialogFormIfExsist()) return;
	            }
	
	            if (globalCurrentWin && globalCurrentWin.closeAttachmentIfExsist) {
	              if (globalCurrentWin.closeAttachmentIfExsist()) return;
	            }
	
	            if (globalCurrentWin && globalCurrentWin.closeQueryFormIfExsist) {
	              if (globalCurrentWin.closeQueryFormIfExsist()) return;
	            }
	          } else {
	            //alert(e.keyCode);
	          }
	};
	
	window.FormsWholeObjectCache = {};
	
	window.getFormWholeObjectStore = function (key) {
	  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
	    return window.FormsWholeObjectCache[key];
	  }
	  return null;
	};
	
	window.getFormWholeObjectCache = function (menuItemId, formId) {
	  var key = menuItemId + "." + formId;
	  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
	    return window.FormsWholeObjectCache[key];
	  }
	  return null;
	};
	
	window.clearFormWholeObjectCache = function (menuItemId, formId) {
	  var key = menuItemId + "." + formId;
	  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
	    window.FormsWholeObjectCache[key] = null;
	    delete window.FormsWholeObjectCache[key];
	    return true;
	  }
	  return false;
	};
	
	window.setFormWholeObjectCache = function (menuItemId, formId, obj) {
	  var key = menuItemId + "." + formId;
	  window.FormsWholeObjectCache[key] = obj;
	  addFormWholeObjectData({ id: key, data: obj });
	};
	
	$('body').keydown(window.onGlobalKeyDown);
	
	window.addDBPivotData = function (data) {
	  _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name2, data);
	};
	
	window.addClientLogNetWorkErrorData = function (data) {
	  _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name3, data);
	};
	
	window.getClientLogNetWorkErrorData = function (callBack) {
	  _IndexedDBUtil2.default.getAllDataAndDelete(_IndexedDBUtil2.default.DB.name3, callBack);
	};
	
	window.addFormWholeObjectData = function (data) {
	  _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name, data);
	};
	
	window.getFormWholeObjectDataById = function (id, callBack) {
	  _IndexedDBUtil2.default.getDataById(id, _IndexedDBUtil2.default.DB.name, callBack);
	};
	
	window.initFormWholeObjectCache = function (menuItemId, formId, callBack) {
	  var key = menuItemId + "." + formId;
	  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
	    callBack();
	  } else {
	    var _window = window;
	    _IndexedDBUtil2.default.getDataById(key, _IndexedDBUtil2.default.DB.name, function (e) {
	      var data = e.target.result;
	      if (data) _window.FormsWholeObjectCache[key] = data.data;
	      callBack();
	    });
	  }
	};
	
	window.openMessageCenter = function (e, type) {
	  if (type == 'unreadedAll') {
	    var arg = new _CommandArg2.default();
	    var command = _CommandHelper2.default.createFormInstance("Form_SysMessageCenter", "buttonOK_ButtonMarkAll", "CommandResult");
	    command.appendArg(arg, "CommandArg");
	
	    _ServiceHelper2.default.addTokenWithCommand({
	      command: command,
	      sync: true,
	      resultFunction: window.readunReadMessagesResultHandler
	    });
	  } else {
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.services.MixedService", "openForm", "void");
	    command.appendArg(null);command.appendArg(window.userInfos.userId);
	    command.appendArg(window.userInfos.userSessionId);
	    command.appendArg("50000027");
	    command.appendArg(type);
	    // ServiceHelper.addTokenWithCommand({ command: command, resultFunction: window.readAllMessagGOT.DWINDOesResultHandler });
	    _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: window.readAllMessagesResultHandler });
	  }
	};
	
	window.readAllMessagesResultHandler = function (data) {
	  if (data.result && data.result.task) {
	    _WebSocketManager2.default.getUnReadCounts();
	    _WebSocketManager2.default.getUnReadList();
	  }
	};
	window.readunReadMessagesResultHandler = function (data) {};
	
	window.openDoMainAppInfo = function () {
	  if (window.parent.window.allAppList) {
	    var param = {
	      "version": "",
	      "clientVersion": "",
	      "frameworkVersion": ""
	    };
	    for (var _i26 in window.parent.window.allAppList) {
	      var appinfo = window.parent.window.allAppList[_i26];
	      var app_Id = window.appId.replace(/[\.]/g, "_");
	      if (appinfo.doMain == window.didomain && (appinfo.appId == app_Id || appinfo.appId == window.appId || appinfo.appId == app_Id + "_osdev" || appinfo.appId == window.appId + "_osdev")) {
	        param.version = appinfo.version;
	        param.clientVersion = appinfo.clientVersion;
	        param.frameworkVersion = appinfo.doMainframework;
	      }
	    }
	    _reactDom2.default.render(_react2.default.createElement(_DoMainAppInfo2.default, { param: param }), document.getElementById('doMainAppInfoModel'));
	  }
	};
	
	window.setFirstForm = function (form) {
	  window.got.DataDictionary["Forms"] = [form];
	};
	
	window.openNetWorkLogErrorLogCallBack = function (datas) {
	  _NetWorkErrorLog2.default.show(datas, "网络错误日志");
	};
	
	window.openNetWorkLogErrorLog = function () {
	  _IndexedDBUtil2.default.getAllData(_IndexedDBUtil2.default.DB.name3, window.openNetWorkLogErrorLogCallBack);
	};
	
	window.changeToCaculator = function () {
	  $("#jqCalculatorDiv .container").removeAttr("style");
	  $("#jqCalculatorDiv_titleBar").show();
	  $("#jqCalculatorDiv_content_firstLine").show();
	  $("#jqCalculatorDiv_content_secondLine").show();
	
	  $("#jqCalculatorDiv #jqcalculator_multiply").show();
	  $("#jqCalculatorDiv #jqcalculator_subtract").show();
	  $("#jqCalculatorDiv #jqcalculator_add").show();
	  $("#jqCalculatorDiv #jqcalculator_equal").show();
	
	  $("#jqCalculatorDiv form.form-light").removeAttr("style");
	  $("#jqCalculatorDiv #jqcalculator_display1").removeAttr("style");
	  $("#jqCalculatorDiv #jqcalculator_display2").removeAttr("style");
	
	  $("#jqcalculator_backspace2").hide();
	};
	
	window.changeToNumKeyBoard = function (offset1, offset2, _inputwidth, _inputheight) {
	
	  var _gwidth = $("body").width();
	  var _gheight = $("body").height();
	
	  var _y = offset1.top + offset2.top;
	  var _x = offset1.left + offset2.left;
	  var _top = _y;
	  var _iframeheight = 350;
	  var _center = false;
	  //下方屏幕放不下
	  if (_top + _iframeheight > _gheight) {
	    //上下都放不下 考虑考虑放中间
	    if (_iframeheight > _y) {
	      _center = true;
	    } else //下拉框置于上方
	      {
	        _top = _y - _iframeheight;
	      }
	  }
	  if (!_center) {
	    var _iframewidth = 250;
	    var _left = _x - (_iframewidth - _inputwidth) / 2;
	    if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 5;
	    if (_left < 0) _left = 0;
	    $("#jqCalculatorDiv .container").css({ position: 'absolute', top: _top + _inputheight + "px", left: _left + "px", width: '249px' });
	  }
	
	  $("#jqCalculatorDiv_titleBar").hide();
	  $("#jqCalculatorDiv_content_firstLine").hide();
	  $("#jqCalculatorDiv_content_secondLine").hide();
	
	  $("#jqCalculatorDiv #jqcalculator_multiply").hide();
	  $("#jqCalculatorDiv #jqcalculator_subtract").hide();
	  $("#jqCalculatorDiv #jqcalculator_add").hide();
	  $("#jqCalculatorDiv #jqcalculator_equal").hide();
	
	  $("#jqCalculatorDiv form.form-light").css("width", "222px");
	  $("#jqCalculatorDiv #jqcalculator_display1").css("width", "222px").css("height", "20px");
	  $("#jqCalculatorDiv #jqcalculator_display2").css("width", "222px");
	
	  $("#jqcalculator_backspace2").show();
	};
	
	window.showNumKeyBoard = function (value, offset1, offset2, _inputwidth, _inputheight, callback) {
	  window.cacResultCallBack = callback;
	  changeToNumKeyBoard(offset1, offset2, _inputwidth, _inputheight);
	  if (value == "clear") {
	    jqcalculator_display1.operation = "", jqcalculator_display1.evaluation = "", $('#jqcalculator_display1').val("");
	    $('#jqcalculator_display2').val("");
	  } else {
	    $("#jqcalculator_display1").val(value);
	  }
	  $("#jqCalculatorDiv").css("display", "flex");
	};
	
	window.showCaculator = function (value, callback) {
	  window.cacResultCallBack = callback;
	  changeToCaculator();
	  if (value == "clear") {
	    jqcalculator_display1.operation = "", jqcalculator_display1.evaluation = "", $('#jqcalculator_display1').val("");
	    $('#jqcalculator_display2').val("");
	  } else {
	    $("#jqcalculator_display1").val(value);
	  }
	  $("#jqCalculatorDiv").css("display", "flex");
	};
	
	window.closeCaculator = function (e) {
	  $("#jqCalculatorDiv").css("display", "none");
	  if (window.cacResultCallBack && typeof window.cacResultCallBack == "function") {
	    window.cacResultCallBack(null);
	  }
	  window.cacResultCallBack = null;
	};
	
	window.returnCacResult = function () {
	  if (window.cacResultCallBack && typeof window.cacResultCallBack == "function") {
	    var result = $("#jqcalculator_display2").val();
	    if (!result) result = $("#jqcalculator_display1").val();
	    window.cacResultCallBack(result);
	    window.cacResultCallBack = null;
	  }
	  $("#jqCalculatorDiv").css("display", "none");
	};
	
	window.delay500backforward = function () {
	  var scrollLeft = $("#g_nav_tabs").scrollLeft();
	  if (!scrollLeft) scrollLeft = 0;
	  $("#g_nav_tabs").scrollLeft(scrollLeft - 5);
	  var _id = setTimeout(function () {
	    clearTimeout(_id);
	    if (window.tabs_forward_pressing == true) {
	      window.delay500backforward();
	    }
	  }, 10);
	};
	
	window.delay500forward = function () {
	  var scrollLeft = $("#g_nav_tabs").scrollLeft();
	  if (!scrollLeft) scrollLeft = 0;
	  $("#g_nav_tabs").scrollLeft(scrollLeft + 5);
	  var _id = setTimeout(function () {
	    clearTimeout(_id);
	    if (window.tabs_forward_pressing == true) {
	      window.delay500forward();
	    }
	  }, 10);
	};
	
	window.g_navtabs_backforward = function () {
	  var scrollLeft = $("#g_nav_tabs").scrollLeft();
	  if (!scrollLeft) scrollLeft = 0;
	  $("#g_nav_tabs").scrollLeft(scrollLeft - 10);
	
	  $('body').one("mouseup", function () {
	
	    window.tabs_forward_pressing = false;
	  });
	  window.tabs_forward_pressing = true;
	
	  var _id = setTimeout(function () {
	    clearTimeout(_id);
	    if (window.tabs_forward_pressing == true) {
	      window.delay500backforward();
	    }
	  }, 500);
	};
	
	window.g_navtabs_forward = function () {
	  var scrollLeft = $("#g_nav_tabs").scrollLeft();
	  if (!scrollLeft) scrollLeft = 0;
	  $("#g_nav_tabs").scrollLeft(scrollLeft + 10);
	
	  $('body').one("mouseup", function () {
	
	    window.tabs_forward_pressing = false;
	  });
	  window.tabs_forward_pressing = true;
	
	  var _id = setTimeout(function () {
	    clearTimeout(_id);
	    if (window.tabs_forward_pressing == true) {
	      window.delay500forward();
	    }
	  }, 500);
	};
	
	window.g_nav_tabs_childChanges = function (e) {
	  var removeChild = false;
	  if (e && e.data && e.data.removeChild == true) removeChild = true;
	  var element = document.getElementById("g_nav_tabs");
	  var _scrollWidth = $("#g_nav_tabs").outerWidth(true);
	  if (removeChild) _scrollWidth += $(e.target).width();
	  if (element.scrollWidth > _scrollWidth) {
	    if (window.userSettingEntry.showToolMenu == true) {
	      $("#g_nav_tabs").css({ marginLeft: '20px', marginRight: '20px' });
	    } else {
	      $("#g_nav_tabs").css({ marginLeft: '50px', marginRight: '20px' });
	    }
	    $("#g_nav_tabs_backforward").show();
	    $("#g_nav_tabs_forward").show();
	  } else {
	    if (window.userSettingEntry.showToolMenu == true) {
	      $("#g_nav_tabs").css({ marginLeft: '0px', marginRight: '0px' });
	    } else {
	      $("#g_nav_tabs").css({ marginLeft: '30px', marginRight: '0px' });
	    }
	    $("#g_nav_tabs_backforward").hide();
	    $("#g_nav_tabs_forward").hide();
	  }
	};
	
	$("#g_nav_tabs").bind("DOMNodeInserted", g_nav_tabs_childChanges);
	$("#g_nav_tabs").bind("DOMNodeRemoved", { removeChild: true }, g_nav_tabs_childChanges);
	
	Date.prototype.Format = function (fmt) {
	  var o = {
	    "M+": this.getMonth() + 1, //月份
	    "d+": this.getDate(), //日
	    "h+": this.getHours(), //小时
	    "m+": this.getMinutes(), //分
	    "s+": this.getSeconds(), //秒
	    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
	    "S": this.getMilliseconds() //毫秒
	  };
	  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	  for (var k in o) {
	    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	  }return fmt;
	};
	
	$('body').contextPopup({});
	
	document.body.ondragstart = function (e) {
	  //二级弹出页面拖动
	  if ($(e.target).parent().hasClass("modal-header")) return true;
	  if ($(e.target).hasClass("ui-draggable")) return true;
	  if ($.contains(document.getElementById("g_nav_tabs"), e.target)) //如果拖动的是全局标签页
	    return true;
	  return false;
	};
	//didomain有两种情况 一种是操作系统 一种是通过操作系统在域里自动登录
	//总共有三种情况 一种是操作系统 一种是单体应用 一种是在操作系统环境中使用工位机 
	//操作系统 有didomain 没有loginToken 需要hook  单体应用 没有domain不需要hook 工位机 都有 不需要hook
	try {
	  if (window.didomain && !loginToken && !loginDataArea) {
	    _HookUtil2.default.hookAJAX();
	    _HookUtil2.default.hookOpen();
	    _HookUtil2.default.hookImg();
	    $("#indexLoginDiv").hide();
	    $("#mainFooterId").css("display", "none");
	    $("#contentWrapper").css("bottom", "0px");
	    $("#messagesSuccess").removeAttr("style");
	    var node = document.getElementById("messagesSuccess");
	
	    // $("#indexRightSideBar").removeAttr("style");
	    var appInfo = sessionStorage.getItem("appInfo");
	    appInfo = JSON.parse(appInfo);
	    var applabel = appInfo['label'];
	    var appDoMain = sessionStorage.getItem('doMainInfo') ? sessionStorage.getItem('doMainInfo') : "";
	    appDoMain = appDoMain.replace(/\"/g, "");
	    var appIcon = appInfo['icon'];
	    var imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
	    var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
	    var arr = appIcon.match(imgReg); //筛选出所有的img
	    var srcArr = [];
	    for (var _i27 = 0; _i27 < arr.length; _i27++) {
	      var src = arr[_i27].match(srcReg);
	      // 获取图片地址
	      srcArr.push(src[1]);
	    }
	    var titlearea = "";
	    if (srcArr && srcArr[0].indexOf("default.png") != -1) {
	      appIcon = "<div class='winui-icon winui-icon-img' ><img src='/osweb/appIcons/img/gongqi.tool.datasetDesign.png'></img></div>";
	    }
	    if (!window.formOSopenDataSetView && srcArr.length > 0) {
	      //titlearea ="<div style='width: 30%;height: 80%;background-size: cover;background-image:url("+srcArr[0]+")'></div>"+"<div style='display: flex;align-items: center;'><span style='font-size: 1.4rem;color: #000;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;margin-left:10px'>"+applabel+"</span></div>";
	      titlearea = "<div style='display: flex; padding-left: 10px;align-items: center;'>" + "<span class='appSpan' style='text-align: start;font-size: 1.4rem;color: white;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;margin-left:5px;font-weight: 400;width:80px' title=" + applabel + ">" + applabel + "</span>" + "</div>" + "<div style='display: flex;width: 100%;align-items: center;justify-content: flex-end;padding-right: 10px;'>" + "<span class='doMainSpan' style='padding-top:2px;font-size:0.5rem;color:#eae4e4db;overflow: hidden;text-overflow: ellipsis;width: 65px;height: 50px;white-space:nowrap;' title=" + appDoMain + ">" + appDoMain + "</span>" + "<div title='点此查看版本信息' style='display: flex; padding-top:4px;align-items: center;margin-Left:5px;cursor: pointer;' class='winui-icon ' onClick='openDoMainAppInfo(event)' ><i class='iconfont icon-xinxi' style='color:white'></i></div>";
	      "</div>";
	    }
	    if (titlearea) {
	      window.titlearea = titlearea;
	      window.appIcon = appIcon;
	      window.applabel = applabel;
	      window.appDoMain = appDoMain;
	    };
	    $("#g_title_area").html(titlearea);
	
	    var tabsClass = $('#g_nav_tabs').attr('class');
	    if (tabsClass.indexOf('OSNav_tabs') == -1) {
	      $('#g_nav_tabs').addClass('OSNav_tabs');
	    }
	    $("#g_main_header").mousedown(function (e) {
	      if ($(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin')[0] != null) {
	        window.mainHeaderisDown = false;
	        return;
	      }
	      window.mainHeaderisDown = true;
	      window.mainHeadermoveLocation = {
	        x: e.clientX,
	        y: e.clientY
	      };
	    });
	    $("#g_main_header").mouseup(function (e) {
	      window.mainHeaderisDown = false;
	    });
	    $("#g_main_header").mousemove(function (e) {
	      if ($(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin')[0] != null) {
	        return;
	      }
	      if (window.mainHeaderisDown) {
	        var newappId = window.appId.replaceAll(".", "_");
	        var domain_appId = window.didomain + "-" + newappId;
	        var layer = window.parent.document.getElementById(domain_appId).parentNode;
	        var layerTop = Number(layer.style.top.split('px')[0]);
	        var layerLeft = void 0;
	        if (layer.style.left.indexOf("%") != -1) {
	          layerLeft = window.parent.document.body.offsetWidth * Number(layer.style.left.split('%')[0]) / 100;
	        } else if (layer.style.left.indexOf("px") != -1) {
	          layerLeft = Number(layer.style.left.split('px')[0]);
	        }
	        var x = layerLeft + (e.clientX - window.mainHeadermoveLocation.x);
	        var y = layerTop + (e.clientY - window.mainHeadermoveLocation.y);
	        if (layerTop <= 0 && y <= 0) {
	          layer.style.left = x + 'px';
	        } else {
	          layer.style.top = y + 'px';
	          layer.style.left = x + 'px';
	        }
	      }
	    });
	    $("#g_main_header").mouseleave(function (e) {
	      window.mainHeaderisDown = false;
	    });
	  }
	} catch (e) {}
	
	window.measureNetDownSpeed = function (e) {
	  return navigator.connection.downlink * 1024 / 8; //单位为KB/sec
	};
	
	setInterval(function (e) {
	
	  $("#netDownLoadSpeed").text("网络下载速度:" + measureNetDownSpeed() + "KB/秒");
	}, 5000);
	
	window.netSpeedTest = function (e) {
	  _FormLoadHelper2.default.openHtml('./netspeedtest/index.html', "");
	};
	
	window.showPerformanceTiming = function (e) {
	  var userId = window.userInfos.userId;
	  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
	  var iframe = $("<iframe>").css("border", "none").attr("id", "iframePerformanceTimingForm").css("width", "100%").css("height", "100%").css("background", "none");
	  iframe.attr("src", "./externals/performanceTiming/PerformanceTimingView.html?userId=" + userId);
	  $("#performanceTimingModel").append(modalDiv.append(iframe));
	};
	window.showPerformanceMemory = function (e) {
	  var userId = window.userInfos.userId;
	  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
	  var iframe = $("<iframe>").css("border", "none").attr("id", "iframePerformanceMemoryForm").css("width", "100%").css("height", "100%").css("background", "none");
	  iframe.attr("src", "./externals/performanceTiming/PerformanceMemoryView.html?userId=" + userId);
	  $("#performanceMemoryModel").append(modalDiv.append(iframe));
	};
	window.showPerformanceResource = function (e) {
	  var userId = window.userInfos.userId;
	  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
	  var iframe = $("<iframe>").css("border", "none").attr("id", "iframePerformanceResourceForm").css("width", "100%").css("height", "100%").css("background", "none");
	  iframe.attr("src", "./externals/performanceTiming/PerformanceHttpRequest.html?userId=" + userId);
	  $("#performanceResourceModel").append(modalDiv.append(iframe));
	};
	
	window.treeViewMainMenuKeyDownHandler = function (e) {
	  if (e.keyCode == 13) {
	    e.preventDefault();
	  }
	};
	
	window.addIndexedDBData = function (data) {
	  _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name4, data);
	};
	
	/////////////////////////////////////////////////////////////
	var allMenuLength;
	var testAllMenuNumTag = 0;
	window.testOpenAllWindowAndDelayClose = function () {
	  var menuItemList = [];
	  listAllMenuItem(window.got.MainMenu, menuItemList);
	  allMenuLength = menuItemList.length;
	  window.openAllMenuItem(menuItemList);
	};
	
	window.openAllMenuItem = function (menuItemList) {
	  if (testAllMenuNumTag >= allMenuLength || testAllMenuNumTag >= 30) {
	    closeAllMenuItem();
	    testAllMenuNumTag = 0;
	    return;
	  }
	
	  var menuItem = menuItemList[testAllMenuNumTag];
	  var label = menuItem.Properties.Label.V ? menuItem.Properties.Label.V : menuItem.name;
	  _FormLoadHelper2.default.openMenuItem({ menuItemId: menuItem.id, label: label, checkHas: true, fromMainMenu: true });
	
	  testAllMenuNumTag++;
	  var _id = setTimeout(function () {
	    clearTimeout(_id);
	    window.openAllMenuItem(menuItemList);
	  }, 10000);
	};
	window.listAllMenuItem = function (menu, menuItemList) {
	  if (menu.qname == "MenuItem") {
	    menuItemList.push(menu);
	  }
	  if (menu.items) {
	    for (var _i28 = 0; _i28 < menu.items.length; _i28++) {
	      var subItem = menu.items[_i28];
	      listAllMenuItem(subItem, menuItemList);
	    }
	  }
	};
	
	window.closeAllMenuItem = function () {
	  window.closeAllForm();
	};
	
	setInterval(function () {
	  if (window.formOSopenDataSetViewId) {
	    return;
	  }
	  _PerformancTiming2.default.deletePerformeTiming();
	}, 300000);
	
	window.performanceData = { 'tim': [], 'mem': [] };
	
	setInterval(function () {
	  if (window.formOSopenDataSetViewId) {
	    return;
	  }
	  _PerformancTiming2.default.sendTimingAndMemoryToServer(performanceData['tim'], performanceData['mem']);
	}, 120000);
	//module.exports.testlayer = function(){alert('222')};
	
	
	//Warning.show({text:"您现在使用的是任务系统 飞速体验版",state:"info"})
	
	window.onePrintReropt = function (e) {
	  if (!e) return;
	  var id = $(e.target).attr("taskid");
	  var reid = $(e.target).attr("reportid");
	  if (!id) {
	    id = $(e.target)[0].parentElement.attributes[1].value;
	    reid = $(e.target)[0].parentElement.attributes[2].value;
	  }
	  if (id && reid) {
	    var command = _Command2.default.createService("gongqi.erp.layers.sys.services.PrintService", "preparePrint", "CommandResult");
	    command.appendArg(id);
	    command.appendArg(reid);
	    var remoteArg = { command: command, resultFunction: window.rpc_doPrintReportSuccess, faultFunction: window.rpc_doPrintReportError, sync: false };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    window.printReportTaskId = id;
	  }
	};
	
	window.dropPrintReport = function (task, formModule) {
	  $('#toolbarPrintLi .dropdown-menu').remove();
	  var _content = "<li style='line-height: 25px; display: flex;justify-content: flex-start;font-size: 12px;border-bottom: 1px solid rgb(205,205,205);padding-left: 12px;'>报表方案</li>";
	  if (task.arg && task.arg.reportList.length >= 1) {
	    for (var _i29 in task.arg.reportList) {
	      _content = _content + " <li style=' display: flex;justify-content: flex-start;'>" + "<a style='width:100%' onclick='onePrintReropt(event)' taskId=" + task.arg.printTaskId + " reportId=" + task.arg.reportList[_i29]['id'] + ">" + "<i class='iconfont icon-fangan3'></i>" + "<span class='menubtnLable' title=" + task.arg.reportList[_i29]['name'] + ">" + task.arg.reportList[_i29]['name'] + "</span>" + "</a>" + "</li>";
	    }
	    if ($('#toolbarPrintLi .dropdown-menu').length == 0) {
	      var _menuDrop = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarPrintLiDrop');
	      var aHeight = $('#toolbar_print').outerHeight() + 1.5;
	      _menuDrop.css({ top: aHeight });
	      var _liDrop = $("<li >");
	      var _menuDrop2 = $("<ul>").addClass('menu').html(_content);
	      $('#toolbarPrintLi').append(_menuDrop.append(_liDrop.append(_menuDrop2)));
	    } else {
	      $('#toolbarPrintLi .dropdown-menu').remove();
	      $('#toolbarPrintLi').append(menuDrop.append(liDrop.append(menuDrop2)));
	    }
	  } else {
	    var _aHeight = $('#toolbar_print').outerHeight() + 1.5;
	    var _menuDrop3 = $("<ul>").addClass('dropdown-menu').css({
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center',
	      top: _aHeight
	    }).attr('id', 'toolbarPrintLiDrop');
	    var _liDrop2 = $("<span>").css('color', 'gray').html('暂无数据');
	    var _menuDrop4 = $("<ul>").addClass('menu');
	    $('#toolbarPrintLi').append(_menuDrop3.append(_content).append(_liDrop2.append(_menuDrop4)));
	  }
	  $('#toolbarPrintLi .dropdown-menu').show();
	  if (window.toolPrintDrop) {
	    window.toolPrintDrop = false;
	  } else {
	    window.toolPrintDrop = true;
	  }
	};
	window.dropPrintReportError = function (data) {
	  $('#toolbarPrintLi .dropdown-menu').remove();
	  var _content = "<li style='line-height: 25px; display: flex;justify-content: flex-start;font-size: 12px;border-bottom: 1px solid rgb(205,205,205);padding-left: 12px;'>报表方案</li>";
	
	  var aHeight = $("#toolbar_print").outerHeight();
	  if ($('#toolbar_print').hasClass("toolbarBig")) {
	    var innerDivHeight = $("#toolbar_print div.toolbar_print_big").outerHeight();
	    aHeight = aHeight - (aHeight - innerDivHeight) / 2 - 0.5;
	  } else {
	    aHeight += 0.5;
	  }
	  var menuDrop = $("<ul>").addClass('dropdown-menu').css('top', aHeight).attr('id', 'toolbarPrintLiDrop');
	  var liDrop = $("<span>").css('color', 'gray').html('暂无数据');
	  var menuDrop2 = $("<ul>").addClass('menu');
	  var menuDrop3 = $("<div>").css({
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    minHeight: '175px'
	  });
	  $('#toolbarPrintLi').append(menuDrop.append(_content).append(menuDrop3.append(liDrop.append(menuDrop2))));
	
	  $('#toolbarPrintLi .dropdown-menu').show();
	  if (window.toolPrintDrop) {
	    window.toolPrintDrop = false;
	  } else {
	    window.toolPrintDrop = true;
	  }
	};
	
	window.doPrintReport = function (task, formModule) {
	  if (task.arg && task.arg.reportList.length > 1) {
	    _reactDom2.default.render(_react2.default.createElement(_PrintReportDialog2.default, { reportList: task.arg.reportList, printTaskId: task.arg.printTaskId }), document.getElementById('printReportDialogModel'));
	  } else if (task.arg && task.arg.reportList.length == 1) {
	    var command = _Command2.default.createService("gongqi.erp.layers.sys.services.PrintService", "preparePrint", "CommandResult");
	    command.appendArg(task.arg.printTaskId);
	    command.appendArg(task.arg.reportList[0]['id']);
	    var remoteArg = { command: command, resultFunction: window.rpc_doPrintReportSuccess, faultFunction: window.rpc_doPrintReportError, sync: false };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    window.printReportTaskId = task.arg.printTaskId;
	  }
	  if (task.taskId && task.reportId) {
	    var command = _Command2.default.createService("gongqi.erp.layers.sys.services.PrintService", "preparePrint", "CommandResult");
	    command.appendArg(task.taskId);
	    command.appendArg(task.reportId);
	    var remoteArg = { command: command, resultFunction: window.rpc_doPrintReportSuccess, faultFunction: window.rpc_doPrintReportError, sync: false };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    window.printReportTaskId = task.taskId;
	  }
	};
	
	window.rpc_doPrintReportSuccess = function (data) {
	  var tasks = data.result.tasks;
	  for (var _i30 = 0; _i30 < tasks.length; _i30++) {
	    var task = tasks[_i30];
	    if (task.cmd == "refreshPlugin" && task.control == "SupcanPrint") {
	      var funcName = task.arg.arg;
	      var funcArg = task.arg.iframeFuncArg;
	      var iframe = document.getElementById('SupcanFrame');
	      var iframeWin = iframe.contentWindow;
	      var func = iframeWin.eval(funcName);
	      if (funcArg.length == 0) {
	        new func();
	      } else if (funcArg.length == 1) {
	        new func(funcArg[0]);
	      } else {
	        new func(funcArg[0], funcArg[1]);
	      }
	      delete tasks[_i30];
	    }
	  }
	  _CommandResolver2.default.resolve(tasks);
	};
	window.rpc_doPrintReportError = function (data) {
	  console.log("发生错误", data);
	};
	
	window.doFinishPrint = function () {
	  var command = _Command2.default.createService("gongqi.erp.layers.sys.services.PrintService", "finishPrint", "CommandResult");
	  command.appendArg(window.printReportTaskId);
	  var remoteArg = { command: command, resultFunction: window.rpc_doFinishPrintSuccess, faultFunction: window.rpc_doFinishPrintError, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	window.doOnReady = function (data) {
	  var command = _Command2.default.createService("gongqi.erp.layers.sys.services.PrintService", "onReady", "CommandResult");
	  command.appendArg(data);
	  var remoteArg = { command: command, resultFunction: window.rpc_doFinishPrintSuccess, faultFunction: window.rpc_doFinishPrintError, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	
	window.rpc_doFinishPrintSuccess = function (data) {
	  var tasks = data.result.tasks;
	  for (var _i31 = 0; _i31 < tasks.length; _i31++) {
	    var task = tasks[_i31];
	    if (task.cmd == "refreshPlugin" && task.control == "SupcanPrint") {
	      var funcName = task.arg.arg;
	      var funcArg = task.arg.iframeFuncArg;
	      var iframe = document.getElementById('SupcanFrame');
	      var iframeWin = iframe.contentWindow;
	      var func = iframeWin.eval(funcName);
	      if (funcArg.length == 0) {
	        new func();
	      } else if (funcArg.length == 1) {
	        new func(funcArg[0]);
	      } else {
	        new func(funcArg[0], funcArg[1]);
	      }
	      delete tasks[_i31];
	    }
	  }
	  _CommandResolver2.default.resolve(tasks);
	};
	window.rpc_doFinishPrintError = function (data) {
	  console.log("发生错误", data);
	};
	
	window.toolbarOpen = function (data) {
	  if (window.toolbarBig) {
	    $(".toolbar_print_sml").css('display', 'flex');
	    $(".toolbar_print_big").css('display', 'none');
	    $(".toolbar_print_big2").css('display', 'none');
	    $("#messagesSuccess").removeClass('big');
	    $('#indexLoginDiv').removeClass('big');
	
	    $('#toolbarMoreLi').removeClass('big');
	
	    $("#main-header-div").css('height', '42px');
	    $("#g_title_area").css('height', '42px');
	    $("#g_title_area").removeClass("bigTool");
	    $("#toolbarShowBigLi").removeClass("bigTool");
	    $("#g_main_header #main-header-div .toolbar ").css("height", "42px");
	    $(".navbar.navbar-static-top").removeClass('navbar-static-top-bigIcon-height');
	    $("#main-sidebar-seadiv").css("marginTop", "42px");
	    $(".dropdown-toggle.toolbarA").removeClass('toolbarBig');
	    $("#contentWrapper").css('paddingTop', '42px');
	    if (!window.formOSopenDataSetView && window.titlearea) {
	      $("#g_title_area").html(window.titlearea);
	    }
	    if (window.appId && window.didomain) {
	      if ($(window.frameElement).is('iframe')) {
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin ').css('display', 'block');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display', 'inline-block').css('height', '42px');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin').css('display', 'inline-block').css('height', '42px').addClass('layui-layer-ico');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-closetrue').css('display', 'inline-block').css('height', '42px').addClass('layui-layer-ico');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display', 'inline-block').css('height', '42px').addClass('layui-layer-ico');
	      }
	    }
	    window.toolbarBig = false;
	  } else {
	    $(".toolbar_print_sml").css('display', 'none');
	    $(".toolbar_print_big").css({ 'display': 'flex', 'flex-direction': 'column', 'justify-content': 'center', 'align-items': 'stretch' });
	    $(".toolbar_print_big2").css('display', 'flex');
	    $("#messagesSuccess").addClass('big');
	    $('#indexLoginDiv').addClass('big');
	
	    $('#toolbarMoreLi').addClass('big');
	
	    $("#main-header-div").css('height', '58px');
	    $(".navbar.navbar-static-top").addClass('navbar-static-top-bigIcon-height');
	    $("#g_title_area").css('height', '58px');
	    $("#g_title_area").addClass("bigTool");
	    $("#toolbarShowBigLi").addClass("bigTool");
	    $("#g_main_header #main-header-div .toolbar ").css("height", "58px");
	    $("#main-sidebar-seadiv").css("marginTop", "58px");
	    $(".dropdown-toggle.toolbarA").addClass('toolbarBig');
	    $("#contentWrapper").css('paddingTop', '58px');
	
	    if (window.appId && window.didomain) {
	      if ($(window.frameElement).is('iframe')) {
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin ').css('display', 'flex');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display', 'flex').css('align-items', 'center').css('height', '58px');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin').css('display', 'flex').css('align-items', 'center').css('height', '58px').removeClass('layui-layer-ico');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-closetrue').css('display', 'flex').css('align-items', 'center').css('height', '58px').removeClass('layui-layer-ico');
	        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display', 'flex').css('align-items', 'center').css('height', '58px').removeClass('layui-layer-ico');
	      }
	    }
	    if (!window.formOSopenDataSetView && window.titlearea) {
	      //titlearea ="<div style='width: 30%;height: 80%;background-size: cover;background-image:url("+srcArr[0]+")'></div>"+"<div style='display: flex;align-items: center;'><span style='font-size: 1.4rem;color: #000;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;margin-left:10px'>"+applabel+"</span></div>";
	      var _titlearea = "<div style='display: flex;flex-flow: column;line-height: normal;align-items: flex-start;margin-left: 10px;'>" + "<span style='text-align: start;font-size: 1.6rem;color: white;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;font-weight: 400;line-height: normal;width:160px' title=" + window.applabel + ">" + window.applabel + "</span>" + "<span style='text-align: start;padding-top:2px;font-size:1.2rem;color:#eae4e4db;width: 160px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;' title=" + window.appDoMain + ">" + window.appDoMain + "</span>" + "</div>" + "<div title='点此查看版本信息' style='display: flex; padding-top:4px;align-items: center;width: 100%;justify-content: flex-end;cursor: pointer;    margin-right: 10px;' class='winui-icon ' onClick='openDoMainAppInfo(event)' ><i class='iconfont icon-xinxi' style='color:white'></i></div>";
	      $("#g_title_area").html(_titlearea);
	    }
	    window.toolbarBig = true;
	  }
	};
	window.toolbar_extendLiHover = function (data) {
	  $("#toolbarMoreLi .menu2").css('display', 'block');
	};
	window.toolbar_extendLiLeave = function (data) {
	  $("#toolbarMoreLi .menu2").css('display', 'none');
	};
	
	window.toolbar_Sort_SelfBtn = function (data) {
	  if (event && event.isTrigger == 3) return;
	  var popIframes = $("#formModal iframe");
	  var _id_;
	  if (popIframes.length > 0) {
	    var iframe = popIframes.get(popIframes.length - 1);
	    _id_ = $(iframe).attr("id");
	  } else {
	    _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  }
	  if (_id_) {
	    callIFrameFunc(_id_, 'queryOpen', { sortSelf: true });
	  }
	};
	window.toobarDropFunc = function (event, funcName, funcArg) {
	  // if($(event.target).hasClass("menubtnLable")||$(event.target).hasClass("icon-container")){
	  //   return;
	  // }
	  try {
	    if ("#g_tab_content>.active>iframe"[0] && $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0]) {
	      $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0].remove();
	    }
	  } catch (err) {}
	
	  if (event && event.isTrigger == 3) return;
	  var popIframes = $("#formModal iframe");
	  var _id_;
	  if (popIframes.length > 0) {
	    var iframe = popIframes.get(popIframes.length - 1);
	    _id_ = $(iframe).attr("id");
	  } else {
	    _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  }
	  if (_id_) {
	
	    if (funcName == "groupExport") {
	      if (window.toolbarBig) {
	        $("#toolbar_export .toolbar_print_big").addClass('drop');
	        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
	      } else {
	        $("#toolbar_export .toolbar_print_sml .icon-drop").addClass('drop');
	        $("#toolbar_export .toolbar_print_sml").addClass('drop');
	      }
	
	      callIFrameFunc(_id_, funcName, 'drop');
	    }
	    if (funcName == 'da') {
	      if (window.toolbarBig) {
	        $("#toolbar_Da .toolbar_print_big").addClass('drop');
	        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
	      } else {
	        $("#toolbar_Da .toolbar_print_sml .icon-drop").addClass('drop');
	        $("#toolbar_Da .toolbar_print_sml").addClass('drop');
	      }
	
	      callIFrameFunc(_id_, funcName, 'drop');
	    }
	    if (funcName == 'queryOpen') {
	
	      if (window.toolbarBig) {
	        $("#toolbar_Queryopen .toolbar_print_big").addClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
	      } else {
	        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").addClass('drop');
	        $("#toolbar_Queryopen .toolbar_print_sml").addClass('drop');
	      }
	
	      callIFrameFunc(_id_, funcName, 'drop');
	    }
	    if (funcName == 'find') {
	
	      if (window.toolbarBig) {
	        $("#toolbar_find .toolbar_print_big").addClass('drop');
	        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
	      } else {
	        $("#toolbar_find .toolbar_print_sml .icon-drop").addClass('drop');
	        $("#toolbar_find .toolbar_print_sml").addClass('drop');
	      }
	
	      var aHeight = $("#toolbar_find").outerHeight();
	      if ($('#toolbar_find').hasClass("toolbarBig")) {
	        var innerDivHeight = $("#toolbar_find div.toolbar_print_big").outerHeight();
	        aHeight = aHeight - (aHeight - innerDivHeight) / 2 - 0.5;
	      } else {
	        aHeight += 0.5;
	      }
	      $('#selectT .dropdown-menu').css('display', 'block').css('top', aHeight);
	
	      if (window.openFindDrop) {
	        window.openFindDrop = false;
	      } else {
	        window.openFindDrop = true;
	      };
	    }
	
	    if (funcName == 'attchment') {
	      if ($("#toolbar_Attchment").hasClass('disable')) return;
	
	      if (window.toolbarBig) {
	        $("#toolbar_Attchment .toolbar_print_big").addClass('drop');
	        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
	      } else {
	        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").addClass('drop');
	        $("#toolbar_Attchment .toolbar_print_sml").addClass('drop');
	      }
	      callIFrameFunc(_id_, 'dropAttcheMnet', '');
	    }
	  }
	};
	
	window.toolbarExportDrop = function (key) {
	  if (window.toolExportDrop) {
	    window.toolExportDropRemove = true;
	    window.toolExportDrop = false;
	    return;
	  }
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "getUserFormExportsWithDefault", "List");
	  command.appendArg(key);
	  command.appendArg(window.userInfos.userId);
	  var _resultHandler = function _resultHandler(data) {
	    window.initExportDropList(data, key);
	  };
	  var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	window.initExportDropList = function (data, key) {
	
	  $('#toolbarExportLi .dropdown-menu').remove();
	  var result = data.result;
	  var _content = "<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>导出方案</li>";
	  if (result.length > 0) {
	    var item = result[0];
	    var defName = '';
	    if (item) {
	      var itemArr = item.split(" ");
	      _content = _content + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarExportDropFunc(event)' fileName=" + itemArr[1] + " label=" + itemArr[1] + ">" + "<i class='iconfont  icon-Micon-querenfangan'></i>" + "<span class='menubtnLable' title=" + itemArr[1] + ">" + itemArr[1] + "</span>" + "</a>" + "</li>";
	      defName = itemArr[1];
	    }
	
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "getUserFormExports", "List");
	    command.appendArg(key);
	    command.appendArg(window.userInfos.userId);
	    var _resultHandler = function _resultHandler(data) {
	      var result = data.result;
	      if (result.length > 0) {
	        for (var _i32 in result) {
	          var item = result[_i32];
	          var itemArr = item.split(" ");
	          if (defName == itemArr[1]) {
	            continue;
	          };
	          _content = _content + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarExportDropFunc(event)' fileName=" + itemArr[1] + " label=" + itemArr[1] + ">" + "<i class='iconfont icon-fangan3'></i>" + "<span class='menubtnLable' title=" + itemArr[1] + ">" + itemArr[1] + "</span>" + "</a>" + "</li>";
	        }
	        var _menuDrop5 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarExportLiDrop');
	        var aHeight = $("#toolbar_export").outerHeight();
	        if ($('#toolbar_export').hasClass("toolbarBig")) {
	          var innerDivHeight = $("#toolbar_export div.toolbar_print_big").outerHeight();
	          aHeight = aHeight - (aHeight - innerDivHeight) / 2 - 0.5;
	        } else {
	          aHeight += 0.5;
	        }
	
	        _menuDrop5.css({ top: aHeight });
	        var _liDrop3 = $("<li>");
	        var _menuDrop6 = $("<ul>").addClass('menu').html(_content);
	        if ($('#toolbarExportLi .dropdown-menu').length == 0) {
	          $('#toolbarExportLi').append(_menuDrop5.append(_liDrop3.append(_menuDrop6)));
	        } else {
	          $('#toolbarExportLi .dropdown-menu').remove();
	          $('#toolbarExportLi').append(_menuDrop5.append(_liDrop3.append(_menuDrop6)));
	        }
	      } else {
	        var _menuDrop7 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarExportLiDrop');
	        var _aHeight2 = $("#toolbar_export").outerHeight();
	        if ($('#toolbar_export').hasClass("toolbarBig")) {
	          var _innerDivHeight = $("#toolbar_export div.toolbar_print_big").outerHeight();
	          _aHeight2 = _aHeight2 - (_aHeight2 - _innerDivHeight) / 2 - 0.5;
	        } else {
	          _aHeight2 += 0.5;
	        }
	        _menuDrop7.css({ top: _aHeight2 });
	        var _liDrop4 = $("<span>").css('color', 'gray').html('暂无方案');
	        var _menuDrop8 = $("<div>").css({
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'center',
	          minHeight: '175px'
	        });
	
	        $('#toolbarExportLi').append(_menuDrop7.append(_content).append(_menuDrop8.append(_liDrop4)));
	      }
	      $('#toolbarExportLi .dropdown-menu').show();
	      if (window.toolExportDrop) {
	        window.toolExportDrop = false;
	      } else {
	        window.toolExportDrop = true;
	      }
	    };
	  };
	  var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	window.toobarExportDropFunc = function (event) {
	  if (!event) return;
	  var fileName = $(event.target).attr("filename");
	  var label = $(event.target).attr("label");
	  if (!fileName) {
	    fileName = $(event.target)[0].parentElement.attributes[1].value;
	    label = $(event.target)[0].parentElement.attributes[2].value;
	  }
	  if (event && event.isTrigger == 3) return;
	  var popIframes = $("#formModal iframe");
	  var _id_;
	  if (popIframes.length > 0) {
	    var iframe = popIframes.get(popIframes.length - 1);
	    _id_ = $(iframe).attr("id");
	  } else {
	    _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  }
	  if (_id_) {
	    callIFrameFunc(_id_, "groupExport", fileName);
	  }
	};
	
	window.toolbarPivotDrop = function (key) {
	  if (window.toolPivotDrop) {
	    window.toolPivotDrop = false;
	    window.toolPivotDropRemove = true;
	    return;
	  }
	  var serviceURL = key.serviceURL;
	  var _dataarea = window.userInfos.subSysId;
	  var configkey = key.configKey;
	  var userId = window.userInfos.userId;
	
	  if (window.didomain && window.appId) {
	    var _header = { "Content-type": "application/json" };
	    if (!window.parent.window.loginToken) {
	      var _token = localStorage.getItem("userToken");
	      if (_token) {
	        _header.token = _token;
	      } else {
	        _header.token = window.parent.window.localStorage.getItem("userToken");
	      }
	    }
	    $.ajax({
	      type: "get",
	      url: window.osUrl + "/" + "MIX" + "/web/apps/gongqi.tool.dataAnalysis/dataAnalysis/getAnalysisScheme",
	      data: {
	        key: configkey,
	        userId: userId
	      },
	      dataType: "json",
	      headers: _header,
	      success: function success(data) {
	        window.initPivotDropList(data, true);
	      },
	      error: function error(data) {
	        window.initPivotDropList(data, true);
	      }
	    });
	  } else {
	    $.ajax({
	      type: "get",
	      url: serviceURL + "/web/sys/pivot/allConfigWithDefault",
	      data: { _dataarea: _dataarea,
	        key: configkey,
	        userId: userId
	      },
	      dataType: "json",
	      success: function success(data) {
	        window.initPivotDropList(data, false);
	      }
	    });
	  }
	};
	
	window.initPivotDropList = function (data) {
	  var isOS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  $('#toolbarPivotLi .dropdown-menu').remove();
	
	  if (isOS) {
	    if (!data || !data.content || data.content.length == 0) {
	      var _menuDrop9 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarPivotLiDrop');
	      var aHeight = $("#toolbar_Da").outerHeight();
	      if ($('#toolbar_Da').hasClass("toolbarBig")) {
	        var innerDivHeight = $("#toolbar_Da div.toolbar_print_big").outerHeight();
	        aHeight = aHeight - (aHeight - innerDivHeight) / 2 - 0.5;
	      } else {
	        aHeight += 0.5;
	      }
	      _menuDrop9.css({ top: aHeight });
	      var _menuDrop10 = $("<div>").css({
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        minHeight: '175px'
	      });
	      var _liDrop5 = $("<span>").css('color', 'gray').html('暂无方案');
	      $('#toolbarPivotLi').append(_menuDrop9.append(_content).append(_menuDrop10.append(_liDrop5)));
	    } else {
	      var _content2 = "<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>图表方案</li>";
	      var result = data.content;
	      for (var i = 0, l = result.length; i < l; i++) {
	        if (i == 0 && result[0]) {
	          var item = [result[i].id, result[i].name];
	          if (item[1] == undefined || item[1] == 'undefined') {
	            continue;
	          }
	          _content2 = _content2 + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName=" + item[1] + " user=" + item[0] + ">" + "<i class='iconfont  icon-Micon-querenfangan' style='margin-left:12px'></i>" + "<span class='menubtnLable' title=" + item[1] + ">" + item[1] + "</span>" + "</a>" + "</li>";
	        } else {
	          var item = [result[i].id, result[i].name];
	          if (item[1] == undefined || item[1] == 'undefined') {
	            continue;
	          }
	          _content2 = _content2 + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName=" + item[1] + " user=" + item[0] + ">" + "<i class='iconfont icon-fangan3' style='margin-left:12px'></i>" + "<span class='menubtnLable'>" + item[1] + "</span>" + "</a>" + "</li>";
	        }
	      }
	      var _menuDrop11 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarPivotLiDrop');
	      //let aHeight=$('#toolbar_Da').outerHeight()+0.5;
	
	
	      var _aHeight3 = $("#toolbar_Da").outerHeight();
	      if ($('#toolbar_Da').hasClass("toolbarBig")) {
	        var _innerDivHeight2 = $("#toolbar_Da div.toolbar_print_big").outerHeight();
	        _aHeight3 = _aHeight3 - (_aHeight3 - _innerDivHeight2) / 2 - 0.5;
	      } else {
	        _aHeight3 += 0.5;
	      }
	
	      _menuDrop11.css({ top: _aHeight3 });
	      var _liDrop6 = $("<li>");
	      var _menuDrop12 = $("<ul>").addClass('menu').html(_content2);
	      if ($('#toolbarPivotLi .dropdown-menu').length == 0) {
	        $('#toolbarPivotLi').append(_menuDrop11.append(_liDrop6.append(_menuDrop12)));
	      } else {
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarPivotLi').append(_menuDrop11.append(_liDrop6.append(_menuDrop12)));
	      }
	    }
	  } else {
	    var result = data.result;
	    var _content3 = "<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>图表方案</li>";
	    if (data.ReturnCode == "101") {
	      var result = data.ReturnValue.result;
	      for (var i = 0, l = result.length; i < l; i++) {
	        if (i == 0 && result[0]) {
	          var item = result[i].split(" ");
	          if (item[1] == undefined || item[1] == 'undefined') {
	            continue;
	          }
	          _content3 = _content3 + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName=" + item[1] + " user=" + item[0] + ">" + "<i class='iconfont  icon-Micon-querenfangan' style='margin-left:12px'></i>" + "<span class='menubtnLable' title=" + item[1] + ">" + item[1] + "</span>" + "</a>" + "</li>";
	        } else {
	          var item = result[i].split(" ");
	          if (item[1] == undefined || item[1] == 'undefined') {
	            continue;
	          }
	          _content3 = _content3 + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName=" + item[1] + " user=" + item[0] + ">" + "<i class='iconfont icon-fangan3' style='margin-left:12px'></i>" + "<span class='menubtnLable'>" + item[1] + "</span>" + "</a>" + "</li>";
	        }
	      }
	      var _menuDrop13 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarPivotLiDrop');
	      //let aHeight=$('#toolbar_Da').outerHeight()+0.5;
	
	
	      var _aHeight4 = $("#toolbar_Da").outerHeight();
	      if ($('#toolbar_Da').hasClass("toolbarBig")) {
	        var _innerDivHeight3 = $("#toolbar_Da div.toolbar_print_big").outerHeight();
	        _aHeight4 = _aHeight4 - (_aHeight4 - _innerDivHeight3) / 2 - 0.5;
	      } else {
	        _aHeight4 += 0.5;
	      }
	
	      _menuDrop13.css({ top: _aHeight4 });
	      var _liDrop7 = $("<li>");
	      var _menuDrop14 = $("<ul>").addClass('menu').html(_content3);
	      if ($('#toolbarPivotLi .dropdown-menu').length == 0) {
	        $('#toolbarPivotLi').append(_menuDrop13.append(_liDrop7.append(_menuDrop14)));
	      } else {
	        $('#toolbarPivotLi .dropdown-menu').remove();
	        $('#toolbarPivotLi').append(_menuDrop13.append(_liDrop7.append(_menuDrop14)));
	      }
	    }
	    if (!result || result.length == 0) {
	
	      var _menuDrop15 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarPivotLiDrop');
	      var _aHeight5 = $("#toolbar_Da").outerHeight();
	      if ($('#toolbar_Da').hasClass("toolbarBig")) {
	        var _innerDivHeight4 = $("#toolbar_Da div.toolbar_print_big").outerHeight();
	        _aHeight5 = _aHeight5 - (_aHeight5 - _innerDivHeight4) / 2 - 0.5;
	      } else {
	        _aHeight5 += 0.5;
	      }
	      _menuDrop15.css({ top: _aHeight5 });
	      var _menuDrop16 = $("<div>").css({
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        minHeight: '175px'
	      });
	      var _liDrop8 = $("<span>").css('color', 'gray').html('暂无方案');
	      $('#toolbarPivotLi').append(_menuDrop15.append(_content3).append(_menuDrop16.append(_liDrop8)));
	    }
	  }
	
	  $('#toolbarPivotLi .dropdown-menu').show();
	  if (window.toolPivotDrop) {
	    window.toolPivotDrop = false;
	  } else {
	    window.toolPivotDrop = true;
	  }
	};
	window.toobarPivotDropFunc = function (event) {
	  if (!event) return;
	  var fileName = $(event.target).attr("filename");
	  var user = $(event.target).attr("label");
	  if (!fileName) {
	    fileName = $(event.target)[0].parentElement.attributes[1].value;
	    user = $(event.target)[0].parentElement.attributes[2].value;
	  }
	  if (event && event.isTrigger == 3) return;
	  var popIframes = $("#formModal iframe");
	  var _id_;
	  if (popIframes.length > 0) {
	    var iframe = popIframes.get(popIframes.length - 1);
	    _id_ = $(iframe).attr("id");
	  } else {
	    _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  }
	  if (_id_) {
	    callIFrameFunc(_id_, "da", { fileName: fileName, user: user });
	  }
	};
	
	window.toolbarQueryDrop = function (key) {
	  try {
	    $('#toolbarQueryLi .dropdown-menu').remove();
	  } catch (e) {}
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "getUserFormQueriesWithDefault", "List");
	  command.appendArg(key);
	  command.appendArg(window.userInfos.userId);
	  _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: window.initQueryDropList.bind(this) });
	};
	window.initQueryDropList = function (data) {
	  var ac = data.result;
	  if (!ac) return;
	  var array = [];
	  var index = 0;
	  for (var _i33 = 0; _i33 < ac.length; _i33++) {
	    var _key = ac[_i33];
	    if (_key == null) continue;
	    var has = false;
	    var _arr = _key.split(" ");
	    var _userId = _arr[0];
	    if (_userId != window.userInfos.userId) continue;
	    var _label = _arr[1];
	    for (var k = 0; k < array.length; k++) {
	      var _item3 = array[k];
	      if (_item3.label == _label) {
	        has = true;break;
	      }
	    }
	    if (has) continue;
	    var o = {};
	    o.label = _label;
	    o.childIndex = index;
	    array.push(o);
	    index++;
	  }
	  var _content = "<li style='display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>筛选方案</li>";
	  if (ac.length > 0 && ac[0] || ac.length > 1) {
	    var defName = '';
	    for (var _i34 in ac) {
	      if (_i34 == 0 && ac[0]) {
	        var res = ac[_i34].split(" ");
	        var _item4 = { label: res[1] };
	        defName = _item4.label;
	        _content = _content + " <li style=' display: flex;justify-content: flex-start;'>" + "<a style='width:100%' onclick='toobarQueryDropFunc(event)' fileName=" + _item4.label + " label=" + _item4.label + ">" + "<i class='iconfont icon-Micon-querenfangan'></i>" + "<span class='menubtnLable' title=" + _item4.label + ">" + _item4.label + "</span>" + "</a>" + "</li>";
	      } else {
	        if (!ac[_i34]) continue;
	        var _res = ac[_i34].split(" ");
	        var _item5 = { label: _res[1] };
	        if (defName == _item5.label) {
	          continue;
	        }
	        _content = _content + " <li style=' display: flex;justify-content: flex-start;'>" + "<a style='width:100%' onclick='toobarQueryDropFunc(event)' fileName=" + _item5.label + " label=" + _item5.label + ">" + "<i class='iconfont icon-fangan3'></i>" + "<span class='menubtnLable' title=" + _item5.label + ">" + _item5.label + "</span>" + "</a>" + "</li>";
	      }
	    }
	    if ($('#toolbarQueryLi .dropdown-menu').length == 0) {
	      var _menuDrop17 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarQueryLiDrop');
	      //let aHeight=$('#toolbar_Queryopen').outerHeight()+0.5;
	
	      var aHeight = $("#toolbar_Queryopen").outerHeight();
	      if ($('#toolbar_Queryopen').hasClass("toolbarBig")) {
	        var innerDivHeight = $("#toolbar_Queryopen div.toolbar_print_big").outerHeight();
	        aHeight = aHeight - (aHeight - innerDivHeight) / 2 - 0.5;
	      } else {
	        aHeight += 0.5;
	      }
	
	      _menuDrop17.css({ top: aHeight });
	      var _liDrop9 = $("<li>");
	      var _menuDrop18 = $("<ul>").addClass('menu').html(_content);
	      $('#toolbarQueryLi').append(_menuDrop17.append(_liDrop9.append(_menuDrop18)));
	    } else {
	      $('#toolbarQueryLi .dropdown-menu').remove();
	      $('#toolbarQueryLi').append(menuDrop.append(liDrop.append(menuDrop2)));
	    }
	  } else {
	
	    //_content += "暂无方案";
	
	    var _menuDrop19 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarQueryLiDrop');
	    var _aHeight6 = $("#toolbar_Queryopen").outerHeight();
	    if ($('#toolbar_Queryopen').hasClass("toolbarBig")) {
	      var _innerDivHeight5 = $("#toolbar_Queryopen div.toolbar_print_big").outerHeight();
	      _aHeight6 = _aHeight6 - (_aHeight6 - _innerDivHeight5) / 2 - 0.5;
	    } else {
	      _aHeight6 += 0.5;
	    }
	    _menuDrop19.css({ top: _aHeight6 });
	    var _liDrop10 = $("<span>").css('color', 'gray').html("暂无方案");
	    var _menuDrop20 = $("<ul>").css({
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center',
	      minHeight: '175px',
	      paddingLeft: '0px'
	    });
	    $('#toolbarQueryLi').append(_menuDrop19.append(_content).append(_menuDrop20.append(_liDrop10)));
	  }
	  $('#toolbarQueryLi .dropdown-menu').show();
	  if (window.toolQueryDrop) {
	    window.toolQueryDrop = false;
	  } else {
	    window.toolQueryDrop = true;
	  }
	};
	window.toobarQueryDropFunc = function (event) {
	  if (!event) return;
	  var fileName = $(event.target).attr("filename");
	  var label = $(event.target).attr("label");
	  if (!fileName) {
	    fileName = $(event.target)[0].parentElement.attributes[1].value;
	    label = $(event.target)[0].parentElement.attributes[2].value;
	  }
	  if (event && event.isTrigger == 3) return;
	  var popIframes = $("#formModal iframe");
	  var _id_;
	  if (popIframes.length > 0) {
	    var iframe = popIframes.get(popIframes.length - 1);
	    _id_ = $(iframe).attr("id");
	  } else {
	    _id_ = $("#g_tab_content>.active>iframe").attr("id");
	  }
	  if (_id_) {
	    callIFrameFunc(_id_, "queryOpen", { fileName: fileName });
	  }
	};
	
	window.toobarMenuDropFunc = function (e, funcN, args) {
	  if (funcN == 'sort') {
	    //let aHeight=$('#toolbar_Sort').outerHeight()+0.5;
	
	    var aHeight = $("#toolbar_Sort").outerHeight();
	    if ($('#toolbar_Sort').hasClass("toolbarBig")) {
	      var innerDivHeight = $("#toolbar_Sort div.toolbar_print_big").outerHeight();
	      aHeight = aHeight - (aHeight - innerDivHeight) / 2;
	    }
	    /*else
	    {
	      aHeight += 0.5;
	    }*/
	
	    $("#toolbarSortLi .dropdown-menu").css('top', aHeight);
	  }
	  if (funcN == 'action') {
	    //let aHeight=$('#toolbar_Action').outerHeight()+0.5;
	
	    var _aHeight7 = $("#toolbar_Action").outerHeight();
	    if ($('#toolbar_Action').hasClass("toolbarBig")) {
	      var _innerDivHeight6 = $("#toolbar_Action div.toolbar_print_big").outerHeight();
	      _aHeight7 = _aHeight7 - (_aHeight7 - _innerDivHeight6) / 2;
	    }
	
	    $("#toolbarActionLi .dropdown-menu").css('top', _aHeight7);
	  }
	};
	window.toolbarAttachmentDrop = function (tableId, recId, formId, aukey) {
	
	  var title = "附件:" + tableId + "/" + recId;
	  window.AttachmentTableId = tableId;
	  window.AttachmentRecId = recId;
	  var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "listAttachments", "List");
	  command.appendArg(tableId + "/" + recId);
	  var remoteArg = { command: command, resultFunction: window.rpc_result_getAttachmentHandler.bind(this), sync: false };
	  _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	};
	window.getFileTypeIcon = function (type, url) {};
	window.rpc_result_getAttachmentHandler = function (data) {
	  if (window.toolAttachmentDrop) return;
	  var tableId = window.AttachmentTableId;
	  var recId = window.AttachmentRecId;
	  var base = window.userInfos.resourceURL;
	  $('#toolbarAttchmentLi .dropdown-menu').remove();
	  var fileList = data.result;
	  var _content = "<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>附件列表</li>";
	  for (var i = 0, l = fileList.length; i < l; i++) {
	    var item = fileList[i];
	    var fileType = void 0;
	    if (item) {
	      fileType = item.substr(item.indexOf(".") + 1, fileType);
	    }
	    var dataOriginal = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(item);
	    var fileTypeIcon = this.getFileTypeIcon(fileType, dataOriginal);
	    _content = _content + " <li style=' display: flex;justify-content:  flex-start;'>" + "<a style='width:100%' onclick='toobarAttachmentDropFunc(event)' fileName=" + item + " >" + fileTypeIcon + "<span class='menubtnLable' title=" + item + ">" + item + "</span>" + "</a>" + "</li>";
	  }
	
	  if (!fileList || fileList.length == 0) {
	
	    var _menuDrop21 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarAttachmentLiDrop');
	    var aHeight = $('#toolbar_Attchment').outerHeight() - 0.5;
	    _menuDrop21.css({ top: aHeight });
	    var _menuDrop22 = $("<div>").css({
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center',
	      minHeight: '175px'
	    });
	    var _liDrop11 = $("<span>").css('color', 'gray').html('暂无附件');
	    $('#toolbarAttchmentLi').append(_menuDrop21.append(_content).append(_menuDrop22.append(_liDrop11)));
	  } else {
	    var _menuDrop23 = $("<ul>").addClass('dropdown-menu').attr('id', 'toolbarAttachmentLiDrop');
	    var _aHeight8 = $('#toolbar_Attchment').outerHeight() - 0.5;
	    _menuDrop23.css({ top: _aHeight8 });
	    var _liDrop12 = $("<li>");
	    var _menuDrop24 = $("<ul>").addClass('menu').html(_content);
	    if ($('#toolbarAttchmentLi .dropdown-menu').length == 0) {
	      $('#toolbarAttchmentLi').append(_menuDrop23.append(_liDrop12.append(_menuDrop24)));
	    } else {
	      $('#toolbarAttchmentLi .dropdown-menu').remove();
	      $('#toolbarAttchmentLi').append(_menuDrop23.append(_liDrop12.append(_menuDrop24)));
	    }
	  }
	  $('#toolbarAttchmentLi .dropdown-menu').show();
	  if (window.toolAttachmentDrop) {
	    window.toolAttachmentDrop = false;
	  } else {
	    window.toolAttachmentDrop = true;
	  }
	};
	window.getFileTypeIcon = function (fileType) {
	  var dataOriginal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (!fileType) {
	    return "<div style=background:url(images/doccopy.png);width:20px;height:20px;margin:5px;margin-right:20px;background-size:cover></div>";
	  }
	  if (fileType.indexOf("xls") != -1) {
	    return "<svg t='1685321168118' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4584' xmlns:xlink='http://www.w3.org/1999/xlink' width='21' height='25'><path d='M901.851653 926.484607a48.255937 48.255937 0 0 1-14.274541 34.442195 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.220097 48.220097 0 0 1-34.457555-14.279661 48.844737 48.844737 0 0 1-14.279662-34.442195V48.846068a48.317377 48.317377 0 0 1 14.279662-34.467795A48.844737 48.844737 0 0 1 170.419644 0.001331h418.800096a48.742337 48.742337 0 0 1 34.662355 14.131182l263.858857 263.910057a48.844737 48.844737 0 0 1 14.110701 34.667475z' fill='#EBECF0' p-id='4585'></path><path d='M901.851653 926.484607v48.767936a48.317377 48.317377 0 0 1-14.274541 34.467796 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.844737 48.844737 0 0 1-48.788417-48.844737v-48.721856a48.204737 48.204737 0 0 0 14.279662 34.442195 48.844737 48.844737 0 0 0 34.457555 14.279661h682.648713a48.844737 48.844737 0 0 0 48.773056-48.783296z' fill='#C1C7D0' p-id='4586'></path><path d='M24.167034 536.423034h975.153932v243.849923a48.921536 48.921536 0 0 1-48.721856 48.844736H73.011771a48.342977 48.342977 0 0 1-34.467796-14.274541 48.844737 48.844737 0 0 1-14.376941-34.570195z' fill='#0AC905' p-id='4587'></path><path d='M121.733627 536.412794V438.856441L24.167034 536.412794z m780.118026 0l0.926719-97.556353 97.039234 97.556353z' fill='#168E2D' p-id='4588'></path><path d='M901.851653 312.628125v6.860791h-263.833257a48.844737 48.844737 0 0 1-48.844736-48.844737V0.001331a48.732097 48.732097 0 0 1 34.662355 14.115822l264.268456 263.751337a49.459136 49.459136 0 0 1 13.701102 34.754515z' fill='#C1C7D0' p-id='4589'></path><path d='M265.190721 764.037458H136.346088v-153.94284h126.335836v35.978193H187.382182v21.749732h63.590317v35.973073h-63.590317v24.268769h77.808539zM358.05716 720.532875l-25.098207 43.504583H276.065587l54.384569-80.322456-49.366976-73.620384h56.893366l21.754852 39.321549 22.589411-39.321549h56.888246L386.508963 683.725242l52.705212 80.317336H382.320809zM599.843726 668.662222h-47.682498q-3.353596-24.268768-27.612124-25.103327-27.612124 0.839679-28.446683 45.178821 0 41.845706 30.120921 41.830345 22.584291 0 25.937886-25.932766h48.522177q-8.376309 59.417523-73.625505 61.91096-78.648218-2.508797-81.151894-79.482777 4.177915-76.124061 76.96886-81.151894 69.43735 0.839679 76.96886 62.750638zM752.112328 764.037458h-128.844633v-153.94284h126.335836v35.978193H674.303789v21.749732h63.590317v35.973073H674.303789v24.268769h77.808539zM897.694219 764.037458H777.215655v-153.94284h51.036094v117.964647h69.44247z' fill='#FFFFFF' p-id='4590'></path></svg>";
	  } else if (fileType.indexOf("pdf") != -1) {
	    return "<svg t='1685259963555' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4613' width='21' height='25'><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='4614'></path><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='4615'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#FF5630' p-id='4616'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#DE350B' p-id='4617'></path><path d='M267.946434 585.143275h84.845634a57.051374 57.051374 0 0 1 41.935198 15.603795 55.1009 55.1009 0 0 1 16.091413 40.959961 55.588518 55.588518 0 0 1-16.091413 40.959961 59.001849 59.001849 0 0 1-43.398054 16.091413h-48.761858v76.556118H267.946434z m32.670446 81.919922h43.885672a42.422817 42.422817 0 0 0 25.843785-6.339041 23.893311 23.893311 0 0 0 7.801897-19.992362q0-24.868548-32.670445-24.868548h-44.860909zM434.71199 588.068987H511.755726a73.142787 73.142787 0 0 1 58.51423 25.356166 100.937047 100.937047 0 0 1 21.942836 68.266602 110.689418 110.689418 0 0 1-20.967599 69.729457A71.679932 71.679932 0 0 1 511.755726 780.190708H434.71199z m32.670445 158.963658H511.755726a43.398054 43.398054 0 0 0 36.083775-17.066651A75.093262 75.093262 0 0 0 560.517584 682.666992a70.704695 70.704695 0 0 0-13.65332-48.761859 48.761858 48.761858 0 0 0-37.546631-16.579031h-41.935198zM755.565018 618.788957h-100.937047v45.348529H755.565018v31.207589h-100.937047v81.919922h-32.670445v-190.171248H755.565018z' fill='#FFFFFF' p-id='4618'></path><path d='M901.850593 312.564487v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 13.653321 34.620919z' fill='#C1C7D0' p-id='4619'></path></svg>";
	  } else if (fileType.indexOf("ppt") != -1) {
	    return "<svg t='1685668273836' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='12012' width='21' height='25'><path d='M901.851653 926.484607a48.255937 48.255937 0 0 1-14.274541 34.442195 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.220097 48.220097 0 0 1-34.457555-14.279661 48.844737 48.844737 0 0 1-14.279662-34.442195V48.846068a48.317377 48.317377 0 0 1 14.279662-34.467795A48.844737 48.844737 0 0 1 170.419644 0.001331h418.800096a48.742337 48.742337 0 0 1 34.662355 14.131182l263.858857 263.910057a48.844737 48.844737 0 0 1 14.110701 34.667475z' fill='#EBECF0' p-id='12013'></path><path d='M901.851653 926.484607v48.767936a48.317377 48.317377 0 0 1-14.274541 34.467796 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.844737 48.844737 0 0 1-48.788417-48.844737v-48.721856a48.204737 48.204737 0 0 0 14.279662 34.442195 48.844737 48.844737 0 0 0 34.457555 14.279661h682.648713a48.844737 48.844737 0 0 0 48.773056-48.783296z' fill='#C1C7D0' p-id='12014'></path><path d='M24.167034 536.423034h975.153932v243.849923a48.921536 48.921536 0 0 1-48.721856 48.844736H73.011771a48.342977 48.342977 0 0 1-34.467796-14.274541 48.844737 48.844737 0 0 1-14.376941-34.570195z' fill='#1B8ADD' p-id='12015'></path><path d='M121.733627 536.412794V438.856441L24.167034 536.412794z m780.118026 0l0.926719-97.556353 97.039234 97.556353z' fill='#425AE8' p-id='12016'></path><path d='M901.851653 312.628125v6.860791h-263.833257a48.844737 48.844737 0 0 1-48.844736-48.844737V0.001331a48.732097 48.732097 0 0 1 34.662355 14.115822l264.268456 263.751337a49.459136 49.459136 0 0 1 13.701102 34.754515z' fill='#C1C7D0' p-id='12017'></path><path d='M314.240257 780.119357h-59.033523V599.091752h86.579087q75.755422 0.988159 77.731739 60.999601-0.993279 62.970798-75.760541 63.948717h-29.516762z m0-98.385792h24.601568q23.608289 0 23.608289-21.642212 0-18.687976-31.482839-18.698216h-16.727018zM495.278102 780.119357h-59.033524V599.091752h86.584208q75.750302 0.988159 77.721499 60.999601-0.988159 62.970798-75.760542 63.948717h-29.511641z m0-98.385792h24.591328q23.623649 0 23.618529-21.642212 0-18.687976-31.487959-18.698216h-16.721898zM610.390912 646.313451v-47.221699h166.266664v47.221699h-53.130171v133.805906h-60.006322v-133.805906z' fill='#FFFFFF' p-id='12018'></path></svg>";
	  } else if (fileType.indexOf("doc") != -1) {
	    return "<svg t='1685260317135' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4911' width='21' height='25'><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='4912'></path><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='4913'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#0747A6' p-id='4914'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#063266' p-id='4915'></path><path d='M236.251227 592.457554H311.832107a71.192313 71.192313 0 0 1 56.563756 24.868548A97.523717 97.523717 0 0 1 389.85108 682.666992a107.763707 107.763707 0 0 1-20.47998 67.778983 69.729457 69.729457 0 0 1-58.51423 26.331403H236.251227zM267.946434 747.032645h41.44758a41.935198 41.935198 0 0 0 35.596157-15.603795 73.142787 73.142787 0 0 0 12.678083-48.761858 68.75422 68.75422 0 0 0-13.653321-45.348528 44.86091 44.86091 0 0 0-36.571393-16.091414H267.946434zM511.755726 585.143275a83.870396 83.870396 0 0 1 65.34089 26.819022 97.523717 97.523717 0 0 1 23.893311 70.704695 103.37514 103.37514 0 0 1-24.380929 70.704694A82.407541 82.407541 0 0 1 511.755726 780.190708a83.870396 83.870396 0 0 1-65.34089-27.30664A100.937047 100.937047 0 0 1 421.546288 682.666992a100.449428 100.449428 0 0 1 24.868548-70.217076A83.382778 83.382778 0 0 1 511.755726 585.143275z m0 163.839844a52.662807 52.662807 0 0 0 42.422817-18.041888 73.142787 73.142787 0 0 0 15.116176-48.761858 70.217076 70.217076 0 0 0-16.091413-48.761858 53.638044 53.638044 0 0 0-41.935199-18.041888 52.662807 52.662807 0 0 0-41.935198 18.041888 71.192313 71.192313 0 0 0-15.603794 48.761858 70.704695 70.704695 0 0 0 16.091413 48.761858 53.150426 53.150426 0 0 0 41.935198 18.529507zM787.260226 701.196498a155.062709 155.062709 0 0 1-28.281878 58.026611 69.241839 69.241839 0 0 1-56.076137 20.967599 74.605643 74.605643 0 0 1-59.977086-25.356166 106.300851 106.300851 0 0 1-22.430455-72.16755 104.837995 104.837995 0 0 1 22.918074-71.679932A78.506592 78.506592 0 0 1 706.803159 585.143275q57.051374 0 76.556118 67.291365h-32.670445a48.761858 48.761858 0 0 0-43.885673-35.596157 48.761858 48.761858 0 0 0-39.009486 17.06665 69.729457 69.729457 0 0 0-14.628558 48.761859q0 66.803746 51.68757 66.803746a40.472342 40.472342 0 0 0 30.719971-11.215228 85.820871 85.820871 0 0 0 17.554269-35.596156z' fill='#FFFFFF' p-id='4916'></path><path d='M905.263923 312.564487v6.82666h-264.289272a48.761858 48.761858 0 0 1-48.761859-48.761858V0.000975a48.761858 48.761858 0 0 1 34.62092 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919z' fill='#C1C7D0' p-id='4917'></path></svg>";
	  } else if (fileType.indexOf(".png") != -1 || fileType == "png") {
	    // let src = 'images/jpg.png';
	    // return <img data-original={dataOriginal}   src={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></img>
	    return "<svg t='1685260081356' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4762' width='21' height='25'><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='4763'></path><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='4764'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#5E6C84' p-id='4765'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#172B4D' p-id='4766'></path><path d='M792.62403 752.884068a120.44179 120.44179 0 0 1-78.506592 29.257115 93.622768 93.622768 0 0 1-97.523717-97.523717 97.523717 97.523717 0 0 1 97.523717-97.523717 101.912284 101.912284 0 0 1 72.655169 25.356167l-20.967599 24.868548a74.118025 74.118025 0 0 0-52.662807-19.992362A63.878034 63.878034 0 0 0 650.727022 682.666992a62.902797 62.902797 0 0 0 63.878035 67.778983 77.043736 77.043736 0 0 0 45.348528-14.140939v-35.108538h-40.472342a7.801897 7.801897 0 0 1-7.801898-7.801897V682.666992a7.801897 7.801897 0 0 1 7.801898-7.801898h65.34089a7.801897 7.801897 0 0 1 7.801897 7.801898z m-249.173096-32.182827v-122.392264a7.801897 7.801897 0 0 1 7.801897-7.801897h17.066651a7.801897 7.801897 0 0 1 7.801897 7.801897v173.104597a7.801897 7.801897 0 0 1-7.801897 7.801897h-16.091414a7.801897 7.801897 0 0 1-6.339041-2.925711l-101.912284-131.169399v126.293213a7.801897 7.801897 0 0 1-7.801897 7.801897H419.108195a7.801897 7.801897 0 0 1-7.801897-7.801897v-173.104597a7.801897 7.801897 0 0 1 7.801897-7.801897h19.504744a7.801897 7.801897 0 0 1 6.339041 2.925711z m-199.436001-65.828508c0-22.430455-16.091413-34.133301-40.472342-34.133301h-39.009487v67.778983h38.521868c25.356166 0 40.959961-13.65332 40.959961-33.645682z m33.645683 0a66.316127 66.316127 0 0 1-75.580881 63.878034h-37.546631v52.662807a7.801897 7.801897 0 0 1-7.801897 7.801897h-17.554269a7.801897 7.801897 0 0 1-7.801897-7.801897v-173.104597a7.801897 7.801897 0 0 1 7.801897-7.801897h66.803746a63.390416 63.390416 0 0 1 71.679932 63.390415z' fill='#FFFFFF' p-id='4767'></path><path d='M901.850593 313.052106v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.628558l264.289272 263.801653a48.761858 48.761858 0 0 1 13.653321 34.62092z' fill='#C1C7D0' p-id='4768'></path></svg>";
	  } else if (fileType == "jpg" || fileType.indexOf(".jpg") != -1) {
	    // return <img data-original={dataOriginal} src={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></img>
	    return "<svg t='1685260377506' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5060' width='21' height='25'><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='5061'></path><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='5062'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#FFAB00' p-id='5063'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#FF8B00' p-id='5064'></path><path d='M770.681194 750.933593a120.44179 120.44179 0 0 1-78.506592 29.257115 93.622768 93.622768 0 0 1-97.523717-97.523716 97.523717 97.523717 0 0 1 97.523717-97.523717 101.912284 101.912284 0 0 1 72.655169 25.356166l-20.967599 24.868548a74.118025 74.118025 0 0 0-52.662807-19.992362A63.878034 63.878034 0 0 0 628.784186 682.666992a62.902797 62.902797 0 0 0 63.878034 67.778983 77.043736 77.043736 0 0 0 45.348529-14.140939v-35.108538h-34.62092a7.314279 7.314279 0 0 1-7.314278-7.314279v-14.628557a7.314279 7.314279 0 0 1 7.314278-7.314279h59.489467a7.314279 7.314279 0 0 1 7.314279 7.314279z m-235.519776-97.523716c0-22.430455-16.091413-34.133301-40.472342-34.133301h-39.009487v67.778983h38.521868c24.868548-0.487619 40.472342-14.140939 40.472342-34.620919z m33.645682 0a66.316127 66.316127 0 0 1-75.58088 64.853271h-37.546631v53.638044a7.314279 7.314279 0 0 1-7.314279 7.314279h-18.529506a7.314279 7.314279 0 0 1-7.314279-7.314279v-176.517927a7.314279 7.314279 0 0 1 7.314279-7.314278H497.127169a63.390416 63.390416 0 0 1 71.679931 63.390415z m-191.634103 59.489467A59.489467 59.489467 0 0 1 313.782581 780.190708a71.192313 71.192313 0 0 1-60.464704-30.232352l21.942836-22.430455a48.761858 48.761858 0 0 0 38.03425 21.942837c17.554269 0 29.744734-11.702846 29.744733-37.059013v-117.02846a7.314279 7.314279 0 0 1 7.314279-7.314278h19.504743a7.314279 7.314279 0 0 1 7.314279 7.314278z' fill='#FFFFFF' p-id='5065'></path><path d='M901.850593 312.564487v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 13.653321 34.620919z' fill='#C1C7D0' p-id='5066'></path></svg>";
	  } else if (fileType == "bpm") {
	    return "<div style=background:'url(images/jpg.png)';width:'24px';height:'27px';margin-right:'10px'></div>";
	  } else if (fileType.indexOf("txt") != -1) {
	    return "<svg t='1685260439242' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5209' width='21' height='25'><path d='M901.632 926.72c0 12.8-5.12 25.088-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.304V48.64c0-12.8 5.12-25.6 14.336-34.304C144.896 5.12 157.696 0 170.496 0h418.816c12.8 0 25.6 5.12 34.816 14.336l263.68 263.68c9.216 9.216 14.336 21.504 14.336 34.816V926.72z' fill='#EBECF0' p-id='5210'></path><path d='M901.632 926.72v48.64c0 12.8-5.12 25.6-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-27.136 0-48.64-22.016-48.64-48.64V926.72c0 12.8 5.12 25.088 14.336 34.304 9.216 9.216 21.504 14.336 34.304 14.336h682.496c27.136 0 48.64-22.016 48.64-48.64z' fill='#C1C7D0' p-id='5211'></path><path d='M24.064 536.576h975.36v243.712c0 27.136-22.016 48.64-48.64 48.64H73.216c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.816v-243.2z' fill='#A8A1A0' p-id='5212'></path><path d='M121.856 536.576V438.784L24.064 536.576h97.792z m779.776 0l1.024-97.792 97.28 97.792h-98.304z' fill='#777777' p-id='5213'></path><path d='M901.632 312.832v6.656h-263.68c-27.136 0-48.64-22.016-48.64-48.64V0c12.8 0 25.6 5.12 34.816 14.336l264.192 263.68c8.704 9.216 13.824 21.504 13.312 34.816z' fill='#C1C7D0' p-id='5214'></path><path d='M228.864 629.76v-49.152h173.568v49.152H347.136v139.776H284.16V629.76H228.864zM512.512 715.776l-30.72 53.248H411.648l66.56-98.816-60.416-90.624h69.632l26.624 48.128 27.648-48.128h70.144L547.328 670.72l64.512 98.816h-70.144l-29.184-53.76zM622.592 629.76v-49.152h173.568v49.152h-55.296v139.776h-62.464V629.76h-55.808z' fill='#FFFFFF' p-id='5215'></path></svg>";
	  } else {
	    return "<svg t='1685260598593' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6403' width='21' height='25'><path d='M887.6 911.3c0 12.5-4.9 24.4-13.8 33.2-8.8 8.8-20.8 13.8-33.2 13.8H182.9c-12.5 0-24.4-4.9-33.2-13.8-8.8-8.8-13.8-20.8-13.8-33.2V65.7c0-12.5 4.9-24.4 13.8-33.2 8.8-8.8 20.8-13.8 33.2-13.8h403.5c12.5-0.1 24.5 4.8 33.4 13.6l254.1 254.1c8.8 8.9 13.7 20.9 13.6 33.4v591.5z m0 0' fill='#EBECF0' p-id='6404'></path><path d='M887.6 911.3v47c0 12.5-4.9 24.4-13.8 33.2-8.8 8.8-20.8 13.8-33.2 13.8H182.9c-25.9 0-47-21-47-47v-47c0 12.5 4.9 24.4 13.8 33.2 8.8 8.8 20.8 13.8 33.2 13.8h657.7c12.5 0 24.4-4.9 33.2-13.8 8.8-8.8 13.8-20.7 13.8-33.2z m0 0' fill='#C1C7D0' p-id='6405'></path><path d='M42.5 535.1H982V770c0 12.5-5 24.4-13.8 33.2-8.8 8.8-20.8 13.8-33.2 13.8H89.5c-12.5 0-24.4-4.9-33.2-13.8-8.8-8.8-13.8-20.8-13.8-33.2V535.1z m0 0' fill='#59A6FD' p-id='6406'></path><path d='M136 535.5v-94l-94 94h94z m751.6 0l0.9-94 93.5 94h-94.4z m0 0' fill='#318AD3' p-id='6407'></path><path d='M887.6 319.9v6.6H633.4c-25.9 0-47-21-47-47V18.8c12.5-0.1 24.5 4.8 33.4 13.6l254.6 254.1c8.6 9 13.4 21 13.2 33.4z m0 0' fill='#C1C7D0' p-id='6408'></path><path d='M523.7 720.6h-32c-0.1-4.6-0.1-7.4-0.1-8.4 0-10.4 1.7-18.9 5.2-25.6 3.4-6.7 10.3-14.2 20.6-22.6 10.3-8.4 16.4-13.8 18.5-16.4 3.1-4.1 4.7-8.6 4.7-13.6 0-6.9-2.7-12.7-8.2-17.6-5.5-4.9-12.9-7.3-22.2-7.3-9 0-16.5 2.5-22.5 7.7-6 5.1-10.2 12.9-12.4 23.4l-32.4-4c0.9-15 7.3-27.7 19.2-38.2 11.8-10.5 27.4-15.7 46.7-15.7 20.3 0 36.4 5.3 48.3 15.9 12 10.6 18 22.9 18 37 0 7.8-2.2 15.2-6.6 22.1-4.4 6.9-13.8 16.4-28.2 28.4-7.5 6.2-12.1 11.2-13.9 15-2 3.4-2.8 10.2-2.7 19.9z m-32 47.4v-35.3H527V768h-35.3z' fill='#FFFFFF' p-id='6409'></path></svg>";
	  }
	};
	window.toobarAttachmentDropFunc = function (event) {
	  if (!event) return;
	  var fileName = $(event.target).attr("fileName");
	  if (!fileName) {
	    fileName = $(event.target)[0].parentElement.attributes[2].value;
	  }
	
	  var tableId = window.AttachmentTableId;
	  var recId = window.AttachmentRecId;
	  var base = window.userInfos.resourceURL;
	
	  var url = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(fileName);
	
	  window.open(url);
	};
	
	window.logOutTets = function () {
	  var browser = {
	    ie: 0,
	    firefox: 0,
	    safari: 0,
	    konq: 0,
	    opera: 0,
	    chrome: 0
	  };
	  var ua = navigator.userAgent;
	  if (window.opera) {
	    browser.opera = window.opera.version();
	  } else if (/AppleWebKit\/(\S+)/.test(ua)) {
	    // 判断是 Chrome 还是 safari
	    if (/Chrome\/(\S+)/.test(ua)) {
	      browser.chrome = RegExp['$1'];
	    } else if (/Version\/(\S+)/.test(ua)) {
	      // 仅使用于 safari 3 及其更高版本
	      browser.safari = RegExp['$1'];
	    } else {
	      // 个别情况-未获取到 safari 版本号的处理
	    }
	  } else if (/KHTML\/(\S+)/.test(ua) || /Konqueror\/([^;]+)/.test(ua)) {
	    browser.konq = RegExp['$1'];
	  } else if (/rv:([^\)]+)\) Gecko\/\d{8}/.test(ua)) {
	    if (/Firefox\/(\S+)/.test(ua)) {
	      // 火狐浏览器
	      browser.firefox = RegExp['$1'];
	    } else {
	      // 其他情况
	    }
	  } else if (/MSIE ([^;]+)/.test(ua)) {
	    browser.ie = RegExp['$1'];
	  }
	  console.log("浏览器信息：" + JSON.stringify(browser));
	};
	
	// window.dataSetViewDSExp = function(){
	//   alert("1111");
	// }
	
	// window.dataSetViewRSelect = function(){
	//   alert("2222");
	// }
	
	//在线表格 与 自主数据分析 所用到的 DATASET构造 
	// window.structureDataSet = function(data){
	//   var dataSet = {'id':CommonUtil.guid(),"dataTables":[]};
	//   var dataTable ={'schema':{},'data':[]};
	//   dataTable.schema.id = CommonUtil.guid();
	//   dataTable.schema.name = data.queryTable.tableName.substr(data.queryTable.tableName.lastIndexOf(".")+1);
	//   dataTable.schema.label = 'columnsArray';
	//   dataTable.schema.type = 'Simple';
	//   dataTable.schema.columns = [];
	//   for(let i in data.dataColumn.columnsArray){
	//     let column = data.dataColumn.columnsArray[i];
	//     let schemaCol = {
	//       name:dataTable.schema.name+"."+column.columnId,
	//       label:column.label,
	//       visible:true,
	//       helpText:column.helpText,
	//       displayLength:column.displayLength,
	//       alignment:'left',
	//       stringSize:column.stringSize,
	//     };
	//     dataTable.schema.columns.push(schemaCol);
	//   }
	//   if(window.osDataSetViewRecords){
	//     dataTable.data = window.osDataSetViewRecords;
	//   }
	//   dataSet.dataTables.push(dataTable);
	//   return dataSet;
	// }

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormItemButton = __webpack_require__(92);
	
	var _FormItemButton2 = _interopRequireDefault(_FormItemButton);
	
	var _FormItemMenuItemButton = __webpack_require__(133);
	
	var _FormItemMenuItemButton2 = _interopRequireDefault(_FormItemMenuItemButton);
	
	var _FormItemGroup = __webpack_require__(129);
	
	var _FormItemGroup2 = _interopRequireDefault(_FormItemGroup);
	
	var _FormItemTab = __webpack_require__(135);
	
	var _FormItemTab2 = _interopRequireDefault(_FormItemTab);
	
	var _FormItemDataGrid = __webpack_require__(122);
	
	var _FormItemDataGrid2 = _interopRequireDefault(_FormItemDataGrid);
	
	var _FormItemButtonGroup = __webpack_require__(121);
	
	var _FormItemButtonGroup2 = _interopRequireDefault(_FormItemButtonGroup);
	
	var _FormItemFieldGroup = __webpack_require__(94);
	
	var _FormItemFieldGroup2 = _interopRequireDefault(_FormItemFieldGroup);
	
	var _FormItemImage = __webpack_require__(130);
	
	var _FormItemImage2 = _interopRequireDefault(_FormItemImage);
	
	var _FormItemStringEditor = __webpack_require__(95);
	
	var _FormItemStringEditor2 = _interopRequireDefault(_FormItemStringEditor);
	
	var _FormItemDateEditor = __webpack_require__(93);
	
	var _FormItemDateEditor2 = _interopRequireDefault(_FormItemDateEditor);
	
	var _FormItemTimeEditor = __webpack_require__(96);
	
	var _FormItemTimeEditor2 = _interopRequireDefault(_FormItemTimeEditor);
	
	var _FormItemEnumEditor = __webpack_require__(72);
	
	var _FormItemEnumEditor2 = _interopRequireDefault(_FormItemEnumEditor);
	
	var _FormItemBooleanEditor = __webpack_require__(120);
	
	var _FormItemBooleanEditor2 = _interopRequireDefault(_FormItemBooleanEditor);
	
	var _FormItemDesignControl = __webpack_require__(218);
	
	var _FormItemDesignControl2 = _interopRequireDefault(_FormItemDesignControl);
	
	var _FormItemGroupControl = __webpack_require__(222);
	
	var _FormItemGroupControl2 = _interopRequireDefault(_FormItemGroupControl);
	
	var _FormItemTabControl = __webpack_require__(229);
	
	var _FormItemTabControl2 = _interopRequireDefault(_FormItemTabControl);
	
	var _FormItemTabPageControl = __webpack_require__(230);
	
	var _FormItemTabPageControl2 = _interopRequireDefault(_FormItemTabPageControl);
	
	var _FormItemDataGridControl = __webpack_require__(214);
	
	var _FormItemDataGridControl2 = _interopRequireDefault(_FormItemDataGridControl);
	
	var _FormItemButtonGroupControl = __webpack_require__(212);
	
	var _FormItemButtonGroupControl2 = _interopRequireDefault(_FormItemButtonGroupControl);
	
	var _FormItemFieldGroupControl = __webpack_require__(221);
	
	var _FormItemFieldGroupControl2 = _interopRequireDefault(_FormItemFieldGroupControl);
	
	var _FormItemStringEditorControl = __webpack_require__(227);
	
	var _FormItemStringEditorControl2 = _interopRequireDefault(_FormItemStringEditorControl);
	
	var _FormItemDateEditorControl = __webpack_require__(215);
	
	var _FormItemDateEditorControl2 = _interopRequireDefault(_FormItemDateEditorControl);
	
	var _FormItemTimeEditorControl = __webpack_require__(235);
	
	var _FormItemTimeEditorControl2 = _interopRequireDefault(_FormItemTimeEditorControl);
	
	var _FormItemDateTimeEditorControl = __webpack_require__(216);
	
	var _FormItemDateTimeEditorControl2 = _interopRequireDefault(_FormItemDateTimeEditorControl);
	
	var _FormItemEnumEditorControl = __webpack_require__(220);
	
	var _FormItemEnumEditorControl2 = _interopRequireDefault(_FormItemEnumEditorControl);
	
	var _FormItemBooleanEditorControl = __webpack_require__(210);
	
	var _FormItemBooleanEditorControl2 = _interopRequireDefault(_FormItemBooleanEditorControl);
	
	var _FormItemDecimalEditorControl = __webpack_require__(217);
	
	var _FormItemDecimalEditorControl2 = _interopRequireDefault(_FormItemDecimalEditorControl);
	
	var _FormItemLongEditorControl = __webpack_require__(224);
	
	var _FormItemLongEditorControl2 = _interopRequireDefault(_FormItemLongEditorControl);
	
	var _FormItemButtonControl = __webpack_require__(211);
	
	var _FormItemButtonControl2 = _interopRequireDefault(_FormItemButtonControl);
	
	var _FormItemButtonMenuControl = __webpack_require__(213);
	
	var _FormItemButtonMenuControl2 = _interopRequireDefault(_FormItemButtonMenuControl);
	
	var _FormItemMenuItemButtonControl = __webpack_require__(225);
	
	var _FormItemMenuItemButtonControl2 = _interopRequireDefault(_FormItemMenuItemButtonControl);
	
	var _FormItemDividedBoxControl = __webpack_require__(219);
	
	var _FormItemDividedBoxControl2 = _interopRequireDefault(_FormItemDividedBoxControl);
	
	var _FormItemImageControl = __webpack_require__(223);
	
	var _FormItemImageControl2 = _interopRequireDefault(_FormItemImageControl);
	
	var _FormItemPluginControl = __webpack_require__(226);
	
	var _FormItemPluginControl2 = _interopRequireDefault(_FormItemPluginControl);
	
	var _FormItemTextControl = __webpack_require__(234);
	
	var _FormItemTextControl2 = _interopRequireDefault(_FormItemTextControl);
	
	var _FormItemTableCellControl = __webpack_require__(231);
	
	var _FormItemTableCellControl2 = _interopRequireDefault(_FormItemTableCellControl);
	
	var _FormItemTableRowControl = __webpack_require__(233);
	
	var _FormItemTableRowControl2 = _interopRequireDefault(_FormItemTableRowControl);
	
	var _FormItemTableControl = __webpack_require__(232);
	
	var _FormItemTableControl2 = _interopRequireDefault(_FormItemTableControl);
	
	var _FormItemStringEditorForDataGrid = __webpack_require__(134);
	
	var _FormItemStringEditorForDataGrid2 = _interopRequireDefault(_FormItemStringEditorForDataGrid);
	
	var _FormItemDateEditorForDataGrid = __webpack_require__(123);
	
	var _FormItemDateEditorForDataGrid2 = _interopRequireDefault(_FormItemDateEditorForDataGrid);
	
	var _FormItemTimeEditorForDataGrid = __webpack_require__(136);
	
	var _FormItemTimeEditorForDataGrid2 = _interopRequireDefault(_FormItemTimeEditorForDataGrid);
	
	var _FormItemBooleanRender = __webpack_require__(137);
	
	var _FormItemBooleanRender2 = _interopRequireDefault(_FormItemBooleanRender);
	
	var _FormItemEnumEditorForDataGrid = __webpack_require__(128);
	
	var _FormItemEnumEditorForDataGrid2 = _interopRequireDefault(_FormItemEnumEditorForDataGrid);
	
	var _FormItemLongEditorForDataGrid = __webpack_require__(132);
	
	var _FormItemLongEditorForDataGrid2 = _interopRequireDefault(_FormItemLongEditorForDataGrid);
	
	var _FormItemDecimalEditorForDataGrid = __webpack_require__(126);
	
	var _FormItemDecimalEditorForDataGrid2 = _interopRequireDefault(_FormItemDecimalEditorForDataGrid);
	
	var _FormItemDividedBox = __webpack_require__(127);
	
	var _FormItemDividedBox2 = _interopRequireDefault(_FormItemDividedBox);
	
	var _ArrayUtil = __webpack_require__(70);
	
	var _ArrayUtil2 = _interopRequireDefault(_ArrayUtil);
	
	var _FormItemSubFormButtonControl = __webpack_require__(228);
	
	var _FormItemSubFormButtonControl2 = _interopRequireDefault(_FormItemSubFormButtonControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var React = __webpack_require__(1);
	//import FormItemTabPage from '../formItem/FormItemTabPage';
	
	//import FormItemDateTimeEditorForDataGrid from '../formItem/FormItemDateTimeEditorForDataGrid';
	
	var FormItemUtil
	//module.exports = 
	= function () {
	      function FormItemUtil() {
	            _classCallCheck(this, FormItemUtil);
	      }
	
	      _createClass(FormItemUtil, null, [{
	            key: 'initFormItemControls',
	            value: function initFormItemControls(menuItemId, formId, parent, formItem, formDataSources, forLookup) {
	                  //console.log(formItem);
	                  var dataSourceName = "";
	                  if (formItem.Properties.hasOwnProperty("DataSource")) dataSourceName = formItem.Properties.DataSource.Value;
	
	                  if (formItem.type == "DataGrid") {
	                        window.formHasDataGrid = true;
	                  }
	
	                  if (formItem.type == "DataGrid" && dataSourceName == "") {
	                        if (formItem.FormItem.length > 0) {
	                              var dataGridColItem = formItem.FormItem[0];
	                              dataSourceName = dataGridColItem.Properties.DataSource.Value;
	                        }
	                  }
	                  var formDataSource;
	                  if (formDataSources.sources.hasOwnProperty(dataSourceName)) formDataSource = formDataSources.sources[dataSourceName];
	
	                  var control = FormItemUtil.getFormItemControls(menuItemId, formId, parent, formItem, formDataSource != undefined && formDataSource != null ? formDataSource.group : null, formDataSources.formModule, forLookup);
	                  if (forLookup) {
	                        FormItemUtil.moduleLookupControls[menuItemId + "." + formId + "." + formItem.id] = control;
	                        FormItemUtil.moduleLookupControls[menuItemId + "." + formId + "." + formItem.name] = control;
	                  } else {
	                        FormItemUtil.formItemControls[menuItemId + "." + formId + "." + formItem.id] = control;
	                        FormItemUtil.formItemControls[menuItemId + "." + formId + "." + formItem.name] = control;
	                        FormItemUtil.formItemControls[control.controlId] = control;
	                        FormItemUtil.formItemControlsForFor[control.controlId] = control;
	                  }
	
	                  if (formItem.hasOwnProperty("FormItem")) {
	                        for (var i in formItem.FormItem) {
	                              var item = formItem.FormItem[i];
	                              var childControl = FormItemUtil.initFormItemControls(menuItemId, formId, formItem, item, formDataSources, forLookup);
	                              childControl.parentControl = control;
	                              control.childrenControl.push(childControl);
	                        }
	                  }
	                  return control;
	            }
	      }, {
	            key: 'getFormItemControlByDataField',
	            value: function getFormItemControlByDataField(dataField) {
	                  for (var key in FormItemUtil.formItemControlsForFor) {
	                        var formItemControl = FormItemUtil.formItemControlsForFor[key];
	                        if (typeof formItemControl.getDataField == "function") {
	                              var controlDataField = formItemControl.dataField;
	                              if (controlDataField == dataField) return formItemControl;
	                        }
	                  }
	                  return null;
	            }
	      }, {
	            key: 'hasUpDownDataGrid',
	            value: function hasUpDownDataGrid() {
	                  for (var key in FormItemUtil.formItemControlsForFor) {
	                        var formItemControl = FormItemUtil.formItemControlsForFor[key];
	                        if (formItemControl.classAlias == "FormItemDataGridControl") {
	                              var bool = FormItemUtil.doHasUpDownDataGrid(formItemControl.parentControl);
	                              if (bool == true) return true;
	                        }
	                  }
	                  return false;
	            }
	      }, {
	            key: 'hasDividedBox',
	            value: function hasDividedBox() {
	                  for (var key in FormItemUtil.formItemControlsForFor) {
	                        var formItemControl = FormItemUtil.formItemControlsForFor[key];
	                        if (formItemControl.classAlias == "FormItemDividedBoxControl") {
	                              return true;
	                        }
	                  }
	                  return false;
	            }
	      }, {
	            key: 'doHasUpDownDataGrid',
	            value: function doHasUpDownDataGrid(parentControl) {
	                  if (!parentControl) return false;
	                  if (parentControl.getProperty_Layout() == "vertical") {
	                        var result = [];
	                        FormItemUtil.descendantsTowGrid(parentControl, result);
	                        if (result.length > 1) return true;
	                        //if(FormItemUtil.descendantsTowGrid(parentControl,0))
	                        //      return true;
	                  }
	                  return FormItemUtil.doHasUpDownDataGrid(parentControl.parentControl);
	            }
	
	            //TODO Tab下面一定是TabPage 所以在向上索引父级的时候 跳过Tab 因为TabPage这一级已经可以完成该判断
	
	      }, {
	            key: 'descendantsTowGrid',
	            value: function descendantsTowGrid(parentControl, result) {
	                  var children = parentControl.childrenControl;
	                  if (children) {
	                        for (var i = 0; i < children.length; i++) {
	                              var childControl = children[i];
	                              if (childControl.classAlias == "FormItemDataGridControl") {
	                                    if (!FormItemUtil.test(result, childControl)) result.push(childControl);
	                              }
	                              if (result.length > 1) return;
	                              FormItemUtil.descendantsTowGrid(childControl, result);
	                        }
	                  }
	            }
	
	            //判断datagrid是否在同一个tab的不同选项卡上 
	
	      }, {
	            key: 'test',
	            value: function test(array, gridControl) {
	                  if (array.length == 0) return false;
	                  var sourceGridControl = array[array.length - 1];
	                  var sourceTabControl = void 0;var sourceTabPageControl = void 0;
	                  var parentControl = sourceGridControl.parentControl;
	                  while (parentControl.classAlias != "FormItemDesignControl") {
	                        if (parentControl.classAlias == "FormItemTabPageControl") sourceTabPageControl = parentControl;
	                        if (parentControl.classAlias == "FormItemTabControl") {
	                              sourceTabControl = parentControl;
	                              break;
	                        }
	                        parentControl = parentControl.parentControl;
	                  }
	                  if (!sourceTabControl) return false;
	
	                  var targetTabControl = void 0;var targetTabPageControl = void 0;
	                  parentControl = gridControl.parentControl;
	                  while (parentControl.classAlias != "FormItemDesignControl") {
	                        if (parentControl.classAlias == "FormItemTabPageControl") targetTabPageControl = parentControl;
	                        if (parentControl.classAlias == "FormItemTabControl") {
	                              targetTabControl = parentControl;
	                              break;
	                        }
	                        parentControl = parentControl.parentControl;
	                  }
	
	                  if (!targetTabControl) return false;
	
	                  if (sourceTabControl == targetTabControl && sourceTabPageControl != targetTabPageControl) return true;
	                  return false;
	            }
	
	            //menuItemId+"."+formId+"."+formItem.id
	
	      }, {
	            key: 'getFormItemControl',
	            value: function getFormItemControl(key, forLookup) {
	                  if (forLookup) {
	                        return FormItemUtil.moduleLookupControls[key];
	                  } else {
	                        return FormItemUtil.formItemControls[key];
	                  }
	            }
	      }, {
	            key: 'getFormItemControls',
	            value: function getFormItemControls(menuItemId, formId, parent, item, groupAlias, module, forLookup) {
	                  if (item.name == "Design") return new _FormItemDesignControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	                  var type = item.type;
	                  if (type == "Group") return new _FormItemGroupControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	                  if (type == "Tab") return new _FormItemTabControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	                  if (type == "TabPage") return new _FormItemTabPageControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	                  if (type == "DataGrid") return new _FormItemDataGridControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	                  if (type == "Image") return new _FormItemImageControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "Button") return new _FormItemButtonControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "SubFormButton") return new _FormItemSubFormButtonControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "ButtonMenu") return new _FormItemButtonMenuControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "MenuItemButton") return new _FormItemMenuItemButtonControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "ButtonGroup") return new _FormItemButtonGroupControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "FieldGroup") return new _FormItemFieldGroupControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "StringEditor") return new _FormItemStringEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "DateEditor") return new _FormItemDateEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "TimeEditor") return new _FormItemTimeEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "DateTimeEditor") return new _FormItemDateTimeEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "EnumEditor") return new _FormItemEnumEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "BooleanEditor") return new _FormItemBooleanEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "DecimalEditor") return new _FormItemDecimalEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "LongEditor") return new _FormItemLongEditorControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "DividedBox") return new _FormItemDividedBoxControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "Plugin") return new _FormItemPluginControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "Text") return new _FormItemTextControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "TableCell") return new _FormItemTableCellControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "TableRow") return new _FormItemTableRowControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);else if (type == "Table") return new _FormItemTableControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	                  return new _FormItemButtonControl2.default(menuItemId, formId, parent, item, groupAlias, module, forLookup);
	            }
	      }, {
	            key: 'getFormStoresKey',
	            value: function getFormStoresKey(menuItemId, formId) {
	                  return menuItemId + "." + formId;
	            }
	      }, {
	            key: 'getFormItemControlKey',
	            value: function getFormItemControlKey(menuItemId, formId, itemId) {
	                  return menuItemId + "." + formId + "." + itemId;
	            }
	      }, {
	            key: 'getFormModuleCallerKey',
	            value: function getFormModuleCallerKey(menuItem, itemId) {
	                  return menuItemId + "." + itemId;
	            }
	      }, {
	            key: 'getFormItemInstanceForDataGrid',
	            value: function getFormItemInstanceForDataGrid(item, forLookup) {
	                  var type = item.type;
	                  if (type == "StringEditor") {
	                        //return new FormItemStringEditorForDataGrid();
	                        return React.createElement(_FormItemStringEditorForDataGrid2.default, { key: item.id, xml: item, forLookup: forLookup });
	                  } else if (type == "DateEditor") {
	                        return React.createElement(_FormItemDateEditorForDataGrid2.default, { key: item.id, xml: item, forLookup: forLookup });
	                  } else if (type == "TimeEditor") {
	                        return React.createElement(_FormItemTimeEditorForDataGrid2.default, { key: item.id, xml: item, forLookup: forLookup });
	                  } else if (type == "DateTimeEditor") {
	                        // return <FormItemDateTimeEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
	                  } else if (type == "LongEditor") {
	                        return React.createElement(_FormItemLongEditorForDataGrid2.default, { key: item.id, xml: item, forLookup: forLookup });
	                  } else if (type == "DecimalEditor") {
	                        return React.createElement(_FormItemDecimalEditorForDataGrid2.default, { key: item.id, xml: item, forLookup: forLookup });
	                  }
	                  //对于Boolean类型的DataGrid列 无项编辑器 由BooleanRenderer类替代
	                  else if (type == "BooleanEditor") {
	                              return React.createElement(_FormItemBooleanRender2.default, { test: 1 });
	                        } else if (type == "EnumEditor") {
	                              return React.createElement(_FormItemEnumEditorForDataGrid2.default, { key: item.id, xml: item, forLookup: forLookup });
	                        }
	            }
	      }, {
	            key: 'getFormItemInstance',
	            value: function getFormItemInstance(menuItemId, formId, item, parent, forLookup) {
	                  //console.log(FormItemUtil.formItemControls);
	                  var control = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(menuItemId, formId, item.id), forLookup);
	                  return control.getComponentInstance(parent, forLookup);
	            }
	      }, {
	            key: 'setControlStyles',
	            value: function setControlStyles(menuItemId, formId, innerId, styles) {
	                  if (!window.controlStyles) window.controlStyles = {};
	                  var value = void 0;
	                  if (Array.isArray(styles)) value = styles;else value = [styles];
	                  var key = menuItemId + "." + formId + "." + innerId;
	                  window.controlStyles[key] = value;
	            }
	      }, {
	            key: 'setControlNoBindStyle',
	            value: function setControlNoBindStyle(menuItemId, formId, innerId, styles) {
	                  if (!window.controlStyles) window.controlStyles = {};
	                  var key = menuItemId + "." + formId + "." + innerId;
	                  window.controlStyles[key] = styles;
	            }
	      }, {
	            key: 'getControlStyles',
	            value: function getControlStyles(menuItemId, formId, innerId) {
	                  var result = void 0;
	                  if (window.controlStyles) {
	                        var key = menuItemId + "." + formId + "." + innerId;
	                        if (!window.controlStyles.hasOwnProperty(key)) result = null;else result = window.controlStyles[key];
	                  }
	                  return result;
	            }
	      }, {
	            key: 'getDataGridUnderFormItem',
	            value: function getDataGridUnderFormItem(itemControl, grids) {
	                  if (itemControl.classAlias == "FormItemDataGridControl") {
	                        grids.push(itemControl);
	                        return;
	                  }
	                  if (itemControl.childrenControl) {
	                        for (var i = 0; i < itemControl.childrenControl.length; i++) {
	                              var childControl = itemControl.childrenControl[i];
	                              FormItemUtil.getDataGridUnderFormItem(childControl, grids);
	                        }
	                  }
	            }
	      }]);
	
	      return FormItemUtil;
	}();
	
	FormItemUtil.formItemControlsForFor = {};
	FormItemUtil.formItemControls = {};
	FormItemUtil.moduleLookupControls = {};
	;
	
	FormItemUtil.defaultProps = {};
	
	exports.default = FormItemUtil;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemConst = function () {
		function FormItemConst() {
			_classCallCheck(this, FormItemConst);
		}
	
		_createClass(FormItemConst, null, [{
			key: "getDisplayLengthWidth",
	
	
			// static BUTTON_PROPERTY_QUERYTYPE_DATASETRESET_VALUE = "DataSetReset";
	
			// static BUTTON_PROPERTY_QUERYTYPE_DATASETEXPORT_VALUE = "DataSetExport";
	
			//static EDITOR_NOTEDIT_COLOR = "#F1F1F1";
			//22;//25
	
			value: function getDisplayLengthWidth(length) {
				return length * 15.6 + 10;
			}
		}, {
			key: "isMaxControl",
			value: function isMaxControl(item) {
				var _type = item.type;
				return _type == "Tab" || _type == "DataGrid" || _type == "Plugin";
			}
	
			//layout 主轴方向
	
		}, {
			key: "containsMaxControl",
			value: function containsMaxControl(item, layout) {
				var children = item.FormItem;
				if (children == null || children == undefined) return false;
				for (var i = 0; i < children.length; i++) {
					var child = children[i];
					if (child.type == "Tab" || child.type == "DataGrid") return true;
					//TODO 需要根据Plugin实际情况来判断是否属于最大化控件
					if (child.type == "Plugin") {
						if (layout == "vertical") {
							var _height = _GOTUtil2.default.getPropertyValue(item, "Height");
							if (!_height) return true;
						} else {
							var _width = _GOTUtil2.default.getPropertyValue(item, "Width");
							if (!_width) return true;
						}
					}
					return FormItemConst.containsMaxControl(child);
				}
				return false;
			}
		}]);
	
		return FormItemConst;
	}();
	
	FormItemConst.MAX_DATAGRIDWIDTH = 500;
	FormItemConst.displayLength_EN = 6;
	FormItemConst.displayLength_CH = 15;
	FormItemConst.displayLength_ENAddon = 5;
	FormItemConst.displayLength_CHAddon = 7;
	FormItemConst.DATAGRID_HEADER_HEIGHT = 25;
	FormItemConst.DATAGRID_ROW_HEIGHT = 25;
	FormItemConst.EDITOR_HEIGHT = 22;
	FormItemConst.BUTTON_HEIGHT = 22;
	FormItemConst.EDITOR_NOTEDIT_COLOR = "#F6F7FB";
	FormItemConst.ARROWDOWN_BUTTON_WIDTH = 22;
	FormItemConst.DATAEDITOR_DATAGRID_ADDON_FOCUS = 2;
	FormItemConst.PLUGIN_TYPE_TREE = "Tree";
	FormItemConst.PLUGIN_TYPE_HTML = "Html";
	FormItemConst.PLUGIN_TYPE_RADIO = "Radio";
	FormItemConst.PLUGIN_TYPE_COMMENT = "BPMComment";
	FormItemConst.PLUGIN_TYPE_ATTACHMENT = "BPMAttachment";
	FormItemConst.BUTTON_SUBMIT_GROUPTYPE_QUERY_LABEL = "查询";
	FormItemConst.BUTTON_RESET_GROUPTYPE_QUERY_LABEL = "重置";
	FormItemConst.BUTTON_PROPERTY_QUERYTYPE_SUBMIT_VALUE = "QuerySubmit";
	FormItemConst.BUTTON_PROPERTY_QUERYTYPE_RESET_VALUE = "QueryReset";
	FormItemConst.DISPLAYLENGTH_DATE_DEFAULT = 13;
	FormItemConst.DECIMALEDITOR_DROPDOWN_NONE = "None";
	FormItemConst.DECIMALEDITOR_DROPDOWN_CACL = "Calculator";
	FormItemConst.DECIMALEDITOR_DROPDOWN_NUMKEYBOARD = "NumKeyBoard";
	FormItemConst.ALLOWEDIT_ALWAYS = "Always";
	FormItemConst.ALLOWEDIT_NEVER = "Never";
	FormItemConst.ALLOWEDIT_ONLYONCREATE = "OnlyOnCreate";
	FormItemConst.PROPERTY_MAINFORM_NAME = "MainForm";
	FormItemConst.PROPERTY_MAINFORM_NAME2 = "RefMenuItem";
	FormItemConst.PROPERTY_FORMTYPE_WORKFLOW = "WorkFlow";
	FormItemConst.PROPERTY_FORMTYPE_NORMAL = "Normal";
	FormItemConst.PROPERTY_FORMTYPE_REPORT = "Report";
	FormItemConst.PROPERTY_FORMTYPE_LOOKUP = "Lookup";
	FormItemConst.PROPERTY_FORMTYPE_SUBFORM = "SubForm";
	FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH = 12;
	FormItemConst.EDITOR_VALUE_CHANGED_ERROR = 0;
	FormItemConst.EDITOR_VALUE_CHANGED_SUC = 1;
	FormItemConst.WILDCARD = "*";
	exports.default = FormItemConst;

/***/ },
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StringUtil = function () {
		function StringUtil() {
			_classCallCheck(this, StringUtil);
		}
	
		_createClass(StringUtil, null, [{
			key: "convertToAllLowerCase",
			value: function convertToAllLowerCase(str) {
				if (str == null || str == "") return str;
	
				return str.toLowerCase();
			}
		}, {
			key: "convertToFirstLowerCase",
			value: function convertToFirstLowerCase(str) {
				if (str == null || str == "") return str;
	
				return str.charAt(0).toLowerCase() + str.substring(1);
			}
		}, {
			key: "convertToFirstUpperCase",
			value: function convertToFirstUpperCase(str) {
				if (str == null || str == "") return str;
	
				return str.charAt(0).toUpperCase() + str.substring(1);
			}
		}, {
			key: "convertToEachFirstLowerCase",
			value: function convertToEachFirstLowerCase(str) {
				if (str == null || str == "") return str;
	
				var result;
				var ss = str.split(".");
				for (var i = 0; i < ss.length; i++) {
					if (i == 0) result = StringUtil.convertToFirstLowerCase(ss[i]);else result += "." + StringUtil.convertToFirstLowerCase(ss[i]);
				}
	
				return result;
			}
		}, {
			key: "convertToEachFirstUpperCase",
			value: function convertToEachFirstUpperCase(str) {
				if (str == null || str == "") return str;
	
				var result;
				var ss = str.split(".");
				for (var i = 0; i < ss.length; i++) {
					if (i == 0) result = StringUtil.convertToFirstUpperCase(ss[i]);else result += "." + StringUtil.convertToFirstUpperCase(ss[i]);
				}
	
				return result;
			}
		}, {
			key: "convertStyleToReactStyle",
			value: function convertStyleToReactStyle(str) {
				var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
	
				if (str == null || str == "") return str;
	
				var result;
				var ss = str.split(splitter);
				for (var i = 0; i < ss.length; i++) {
					if (i == 0) result = ss[i];else result += StringUtil.convertToFirstUpperCase(ss[i]);
				}
	
				return result;
			}
		}, {
			key: "trimLeft",
			value: function trimLeft(input) {
				var trimer1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
				var trimer2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "　";
	
				var i = 0;
				var tmp = input.charAt(i);
				while (tmp == trimer1 || tmp == trimer2) {
					i++;
					if (i > input.length - 1) return "";
					tmp = input.charAt(i);
				}
				return input.substr(i);
			}
		}, {
			key: "trimRight",
			value: function trimRight(input) {
				var trimer1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
				var trimer2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "　";
	
				var i = input.length - 1;
				var tmp = input.charAt(i);
				while (tmp == trimer1 || tmp == trimer2) {
					i--;
					if (i < 0) return "";
					tmp = input.charAt(i);
				}
				return input.substring(0, i + 1);
			}
		}, {
			key: "trimLeftRight",
			value: function trimLeftRight(input) {
				var trimer1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
				var trimer2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "　";
	
				var result = StringUtil.trimLeft(input);
				result = StringUtil.trimRight(result);
				return result;
			}
		}, {
			key: "trimThrough",
			value: function trimThrough(input) {
				var replaceChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
				var result = StringUtil.trimLeftRight(input);
				var reg = /\s+/g;
				result = result.replace(reg, replaceChar);
				return result;
			}
		}, {
			key: "toColorStyleString",
			value: function toColorStyleString(color) {
				var str = color.toString(16);
				while (str && str.length < 6) {
					str = "0" + str;
				}
				return str;
			}
	
			/**    
	   * replaceAll    
	   * @param source:String 源数据    
	   * @param find:String 替换对象    
	   * @param replacement:Sring 替换内容    
	   * @return String    
	   * **/
	
		}, {
			key: "replaceAll",
			value: function replaceAll(source, find, replacement) {
				if (!source) return null;
	
				return source.split(find).join(replacement);
			}
		}, {
			key: "evalLEString",
			value: function evalLEString(LEstr) {
				//操作符栈
				var opArray = [];
	
				//@表示栈底
				opArray[0] = "@";
				var opPtr = 1;
				//操作数栈
				var numArray = [];
				var numPtr = 0;
	
				//计算结果
				var res = "";
	
				var i;
				var j;
				var tempString = "";
	
				//计算 计算完的操作数清空 结果留在栈底以参与后续计算
				function caculate(operater) {
					if (operater.toLowerCase() == "or") {
						if (numArray[numPtr - 1] == "1" || numArray[numPtr - 2] == "1") res = "1";else res = "0";
					} else if (operater.toLowerCase() == "and") {
						if (numArray[numPtr - 1] == "0" || numArray[numPtr - 2] == "0") res = "0";else res = "1";
					}
	
					numArray[numPtr - 1] = "";
					numArray[numPtr - 2] = res;
					numPtr--;
				}
	
				//表达式
				for (i = 0; i < LEstr.length; i++) {
					//使用选择语句代替算符优先级表
					switch (LEstr.charAt(i)) {
						//左括号直接入运算符栈
						case "(":
							opArray[opPtr] = LEstr.charAt(i);
							opPtr++;
							break;
						//右括号退栈计算，直到遇见一个左括号，以算出括号内的表达式
						case ")":
							for (j = opPtr - 1; j > 0; j--) {
								if (opArray[j] != "(") {
									caculate(opArray[j]);
									//栈顶下一个元素为# 指针按照一般约定在栈顶下一个元素
									opArray[j] = "#";
								} else {
									opArray[j] = "#";
									break;
								}
							}
							opPtr = j;
							break;
						case "a":
						case "A":
							//跳过运算符
							i = i + 2;
							//如果原栈顶也为and 则先计算原来的and再将新运算符入栈 同样的运算符从左到右依次计算 否则将and入栈 下次扫描到or会先运算  
							if (opArray[opPtr - 1] == "and") {
								opPtr--;
								caculate(opArray[opPtr]);
								opArray[opPtr] = "#";
							}
							opArray[opPtr] = "and";
							opPtr++;
							break;
	
						case "o":
						case "O":
							i = i + 1;
							//or为低优先级 如果栈顶的运算符不是左括号也不是栈底，无论是or还是and 都先退栈计算
							if (opArray[opPtr - 1] != "(" && opArray[opPtr - 1] != "@") {
								opPtr--;
								caculate(opArray[opPtr]);
								opArray[opPtr] = "#";
							}
							opArray[opPtr] = "or";
							opPtr++;
							break;
						default:
							//运算数进栈
							var num = LEstr.charAt(i);
							if (num == "0" || num == "1") {
								numArray[numPtr] = num;
								numPtr++;
							} else {
								throw new Error("非法操作数");
							}
					}
				}
	
				for (j = opPtr - 1; j > 0; j--) {
					if (opArray[j] != "@") {
						caculate(opArray[j]);
						opArray[j] = "#";
					} else {
						break;
					}
				}
	
				return numArray[0] == "1" ? true : false;
			}
		}]);
	
		return StringUtil;
	}();
	
	exports.default = StringUtil;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UpdateDropDownContentStore = exports.SelectRecordsStore = exports.UpdateGroupCollapseStateStore = exports.RefreshPluginStore = exports.SetContainerStore = exports.SetTextStyleStore = exports.SetButtonStyleStore = exports.BindStyleStore = exports.SwitchTabPageStore = exports.DsAllowEditStore = exports.CmdButtonOk = exports.CmdWriteControlStore = exports.CmdUpdateShowDecimalStore = exports.CmdUpdateControlVisibleStore = exports.CmdUpdateControlLabelStore = exports.CmdUpdateControlPropertyStore = exports.CmdUpdateControlAllowEditStore = exports.CmdExecuteQueryStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CmdExecuteQueryStore = exports.CmdExecuteQueryStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.executeQuery, 'onExecuteQuery');
		},
		onExecuteQuery: function onExecuteQuery(queryType, groupAlias, xml, onlyFetch) {
			this.trigger(queryType, groupAlias, xml, onlyFetch);
		}
	});
	
	var CmdUpdateControlAllowEditStore = exports.CmdUpdateControlAllowEditStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateControlAllowEdit, 'onUpdateControlAllowEdit');
		},
		onUpdateControlAllowEdit: function onUpdateControlAllowEdit(name, allowEdit, _id) {
			this.trigger(name, allowEdit, _id);
		}
	});
	
	var CmdUpdateControlPropertyStore = exports.CmdUpdateControlPropertyStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateControlProperty, 'onUpdateControlProperty');
		},
		onUpdateControlProperty: function onUpdateControlProperty(name, property, value, moduleInstanceId) {
			this.trigger(name, property, value, moduleInstanceId);
		}
	});
	
	var CmdUpdateControlLabelStore = exports.CmdUpdateControlLabelStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateControlLabel, 'onUpdateControlLabel');
		},
		onUpdateControlLabel: function onUpdateControlLabel(name, label, moduleInstanceId) {
			this.trigger(name, label, moduleInstanceId);
		}
	});
	
	var CmdUpdateControlVisibleStore = exports.CmdUpdateControlVisibleStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateControlVisible, 'onUpdateControlVisible');
		},
		onUpdateControlVisible: function onUpdateControlVisible(menuItemId, formId, names, isLookup) {
			this.trigger(menuItemId, formId, names, isLookup);
		}
	});
	
	var CmdUpdateShowDecimalStore = exports.CmdUpdateShowDecimalStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateControlShowDecimal, 'onUpdateControlShowDecimal');
		},
		onUpdateControlShowDecimal: function onUpdateControlShowDecimal(name, label, moduleInstanceId) {
			this.trigger(name, label, moduleInstanceId);
		}
	});
	
	var CmdWriteControlStore = exports.CmdWriteControlStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.writeControl, "onWriteControl");
		},
		onWriteControl: function onWriteControl(arg, moduleInstanceId, triggerModify) {
			this.trigger(arg, moduleInstanceId, triggerModify);
		}
	});
	
	var CmdButtonOk = exports.CmdButtonOk = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.buttonOk, 'onButtonOk');
		},
		onButtonOk: function onButtonOk(arg, tasks) {
			this.trigger(arg, tasks);
		}
	});
	
	var DsAllowEditStore = exports.DsAllowEditStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.dsAllowEdit, 'onDsAllowEdit');
		},
		onDsAllowEdit: function onDsAllowEdit(arg) {
			this.trigger(arg);
		}
	});
	
	var SwitchTabPageStore = exports.SwitchTabPageStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.switchTabPage, 'onSwitchTabPage');
		},
		onSwitchTabPage: function onSwitchTabPage(arg) {
			this.trigger(arg);
		}
	});
	
	var BindStyleStore = exports.BindStyleStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.bindStyle, 'onBindStyle');
		},
		onBindStyle: function onBindStyle(formId, name) {
			this.trigger(formId, name);
		}
	});
	
	var SetButtonStyleStore = exports.SetButtonStyleStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.setButtonStyle, 'onSetButtonStyle');
		},
		onSetButtonStyle: function onSetButtonStyle(formId, name) {
			this.trigger(formId, name);
		}
	});
	
	var SetTextStyleStore = exports.SetTextStyleStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.setTextStyle, 'onSetTextStyle');
		},
		onSetTextStyle: function onSetTextStyle(formId, name) {
			this.trigger(formId, name);
		}
	});
	
	var SetContainerStore = exports.SetContainerStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.setContainerStyle, 'onSetContainerStyle');
		},
		onSetContainerStyle: function onSetContainerStyle(formId, name) {
			this.trigger(formId, name);
		}
	});
	
	var RefreshPluginStore = exports.RefreshPluginStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.refreshPlugin, 'onRefreshPlugin');
		},
		onRefreshPlugin: function onRefreshPlugin(task, pluginName, formId, result) {
			this.trigger(task, pluginName, formId, result);
		}
	});
	
	var UpdateGroupCollapseStateStore = exports.UpdateGroupCollapseStateStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateGroupCollapseState, 'onUpdateGroupCollapseState');
		},
		onUpdateGroupCollapseState: function onUpdateGroupCollapseState(arg, tasks) {
			this.trigger(arg, tasks);
		}
	});
	
	var SelectRecordsStore = exports.SelectRecordsStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.selectRecords, 'onSelectRecords');
		},
		onSelectRecords: function onSelectRecords(arg) {
			this.trigger(arg);
		}
	});
	
	var UpdateDropDownContentStore = exports.UpdateDropDownContentStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_CmdTypeActions2.default.updateDropDownContent, 'onUpdateDropDownContent');
		},
		onUpdateDropDownContent: function onUpdateDropDownContent(type, control, formModuleInstanceuuId) {
			this.trigger(type, control, formModuleInstanceuuId);
		}
	});

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Warning = function () {
		function Warning() {
			_classCallCheck(this, Warning);
		}
	
		_createClass(Warning, null, [{
			key: "show",
			value: function show(options) {
	
				var defaults = {
					state: "info",
					backgroundColor: '#fff',
					color: "#000",
					text: "是否执行该操作？",
					cornerRadius: "10",
					fontSize: '14px',
					title: '',
					interacdestroy: false,
					confirm: {
						isShow: true,
						event: '',
						text: ''
					},
					cancel: {
						isShow: false,
						event: ''
					},
					mutiLine: false
	
				};
	
				// var stateColor={
				// 	info:'alert-info',
				// 	warn:'alert-warning',
				// 	error:'alert-danger',
				// 	success:'alert-success'
				// }
	
				// var stateIcon={
				// 	info:'fa-info',
				// 	warn:'fa-warning',
				// 	error:'fa-ban',
				// 	success:'fa-check'
				// }
	
				// var stateMsg={
				// 	info:'提示',
				// 	warn:'警告',
				// 	error:'错误',
				// 	success:'成功'
				// }
	
				// var btnState={
				// 	info:'btn-info',
				// 	warn:'btn-warning',
				// 	error:'btn-danger',
				// 	success:'btn-success'
				// }
	
				// var fontColor={
				// 	info:'#00c0ef',
				// 	warn:'#f39c12',
				// 	error:'#dd4b39',
				// 	success:'#008d4c'
				// }
	
				var titleMsg = {
					info: 'INFO',
					warn: 'WARN',
					error: 'ERROR',
					success: 'SUCCESS'
				};
	
				var btnStyle = {
					info: {
						color: '#fff',
						backgroundColor: '#f39c12',
						width: '80px',
						height: '28px',
						padding: '3px',
						fontSize: '14px',
						iconMainClass: "fa fa-info-circle",
						iconClass: 'text-blue',
						border: '1px solid #f39c12'
					},
					warn: {
						color: '#fff',
						backgroundColor: '#f39c12',
						width: '80px',
						height: '28px',
						padding: '3px',
						fontSize: '14px',
						iconMainClass: "fa fa-exclamation-circle",
						iconClass: 'text-yellow',
						border: '1px solid #f39c12'
					},
					error: {
						color: '#fff',
						backgroundColor: '#f39c12',
						width: '80px',
						height: '28px',
						padding: '3px',
						fontSize: '14px',
						iconMainClass: "fa fa-times-circle",
						iconClass: 'text-red',
						border: '1px solid #f39c12'
					},
					success: {
						color: '#fff',
						backgroundColor: '#f39c12',
						width: '80px',
						height: '28px',
						padding: '3px',
						fontSize: '14px',
						iconMainClass: "fa fa-check-circle",
						iconClass: 'text-green',
						border: '1px solid #f39c12'
					}
				};
	
				var btnContent = {
					info: '确认',
					warn: '确认',
					error: '关闭',
					success: '关闭'
				};
	
				$.extend(true, defaults, options);
	
				var $2 = $;
				if (!window.isSelfFrameRoot) {
					$2 = parent.$;
				}
	
				var closeBtn = $2('<div class="modal-close"></div>');
				//.on('click',function(){alert(1111111);$(alertDiv).remove();});
	
				var titleH = $2('<h5></h5>').addClass('modal-title').html(defaults.title ? defaults.title : titleMsg[defaults.state]); //判断显示内容
				var headerDiv = $2('<div></div>').addClass('modal-header').append(closeBtn).append(titleH);
	
				var bodyIcon = $2('<i class="' + btnStyle[defaults.state].iconMainClass + " " + btnStyle[defaults.state].iconClass + '" aria-hidden="true" style="font-size: 33px;margin-right: 9px;"></i>');
				var textStyle = { 'font-size': defaults.fontSize, 'font-family': 'STSongti-SC-Regular', color: '#000000', 'margin-bottom': '0px', 'margin-top': '6px' };
				if (!defaults.mutiLine) {
					textStyle['white-space'] = 'pre';
				}
				var bodyP = $2('<p>' + defaults.text + '</p>').css(textStyle);
				var _maxHeight = '300px';
				if (defaults.mutiLine == true) {
					_maxHeight = '';
				}
				var bodyDiv = $2('<div></div>').addClass('modal-body').append(bodyIcon).append(bodyP).css({ 'overflow': 'auto', 'max-height': _maxHeight, 'display': 'flex', paddingTop: '30px', paddingBottom: '30px' });
	
				var cancelBtn = $2('<button></button>').attr('type', 'button').addClass('btn btn-default').html('取消').css({ 'width': '80px', height: '28px', padding: '3px', 'font-size': '14px' });
				var confirmBtn = $2('<button></button>').attr('type', 'button').addClass('btn').css(btnStyle[defaults.state]).html(defaults.confirm.text ? defaults.confirm.text : btnContent[defaults.state]).css('margin-right', '10px');
				//判断是否显示取消确定按钮
				var footerDiv = $2('<div></div>').addClass('modal-footer').css({ 'border-top': 'none', padding: '10px', borderTop: '1px solid rgba(0,0,0,0.10)' });
	
				if (defaults.cancel.isShow) footerDiv.append(cancelBtn);
	
				if (defaults.confirm.isShow) footerDiv.append(confirmBtn);
	
				confirmBtn.on('click', function () {
					if (typeof defaults.confirm.event == "function") {
						defaults.confirm.event();
					}
					window.testWarnShowedToRemove = true;
					window.testWarnShowing = false;
					if (options.rowrowChangeAutoSaveWarn) {
						window.rowrowChangeAutoSaveWarn = false;
					}
					$2(alertDiv).remove();
	
					//if(typeof(window.restoreLastFocus) == "function")
					//		window.restoreLastFocus();
				}).one('keydown', function (e) {
	
					if (e.keyCode == 17) {
						if (typeof defaults.confirm.event == "function") {
							defaults.confirm.event();
						}
						window.testWarnShowedToRemove = true;
						window.testWarnShowing = false;
						$2(alertDiv).remove();
					}
				});
	
				if (defaults.cancel.event == '') {
					cancelBtn.one('click', function () {
						window.testWarnShowedToRemove = true;
						window.testWarnShowing = false;
						$2(alertDiv).remove();
						//if(typeof(window.restoreLastFocus) == "function")
						//	window.restoreLastFocus();
					});
				}
				var contentDiv = $('<div></div>').addClass('modal-content').append(headerDiv).append(bodyDiv).append(footerDiv);
	
				var dialogDiv = $('<div></div>').append(contentDiv).css({ 'position': 'relative', minWidth: '508px', background: '#FFFFFF', border: '0 solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' });
	
				var alertDiv = $('<div></div>').addClass('modal gongqi-warn').append(dialogDiv).css({ 'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'z-index': '2001' });
				alertDiv.one('keydown', function (e) {
					if (e.keyCode == 27) {
						e.preventDefault();
						e.stopImmediatePropagation();
						window.testWarnShowing = false;
						alertDiv.remove();
						if (typeof window.restoreLastFocus == "function") window.restoreLastFocus();
					}
				});
	
				$2("body").append(alertDiv);
	
				$2(closeBtn).on('click', function () {
					if (options.rowrowChangeAutoSaveWarn) {
						window.rowrowChangeAutoSaveWarn = false;
					}
					$2(alertDiv).remove();
				});
	
				confirmBtn.focus();
				window.testWarnShowing = true;
			}
		}]);
	
		return Warning;
	}();
	
	exports.default = Warning;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GOTUtil = function () {
		function GOTUtil() {
			_classCallCheck(this, GOTUtil);
		}
	
		_createClass(GOTUtil, null, [{
			key: "getNormalRelationItem",
	
			//static flatMainMenuToMenuItem = {};
	
			value: function getNormalRelationItem(dataType) {
				/**
	    *新版本中 DataTypeRelatioItem Normal没有了
	    * 
	    **/
				var items = dataType.DataTypeRelation.DataTypeRelationItems;
				if (!items || items.length == 0) {
					return { Properties: { Field: dataType.DataTypeRelation.Properties.Field } };
				}
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.type == "Normal") return item;
				}
				return null;
			}
		}, {
			key: "getFixedRelationItem",
			value: function getFixedRelationItem(dataType) {
				var result = [];
				var items = dataType.DataTypeRelation.DataTypeRelationItems;
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.type == "Fixed") result.push(item);
				}
				return result;
			}
		}, {
			key: "getShortCut",
			value: function getShortCut(table) {
				if (table == null) return null;
				var results = null;
				var shortcutPro = table.Properties.ShortCutField;
				if (shortcutPro && shortcutPro.hasOwnProperty("innerid")) {
					var innerid = shortcutPro.innerid;
					for (var i in table.TableFields) {
						var tableField = table.TableFields[i];
						if (tableField.id == innerid) return tableField;
					}
				}
	
				return null;
			}
		}, {
			key: "isTableFieldShortCut",
			value: function isTableFieldShortCut(tableField) {
				var extendsPro = tableField.Properties.Field;
				if (extendsPro.hasOwnProperty("refentityid")) {
					var entityid = extendsPro.refentityid;
					var innerid = extendsPro.refinnerid;
					var table = _GOT2.default.getTable(entityid);
					var shortcutPro = table.Properties.ShortCutField;
					if (shortcutPro && shortcutPro.innerid == innerid) {
						return true;
					}
				}
	
				return false;
			}
		}, {
			key: "isFormItemShortCut",
			value: function isFormItemShortCut(formItem) {
				var extendsPro = formItem.Properties.Extends;
				if (extendsPro.hasOwnProperty("refentityid")) {
					var entityid = extendsPro.refentityid;
					var innerid = extendsPro.refinnerid;
					var table = _GOT2.default.getTable(entityid);
					var shortcutPro = table.Properties.ShortCutField;
					if (shortcutPro && shortcutPro.innerid == innerid) {
						return true;
					}
				}
	
				return false;
			}
		}, {
			key: "getDataTypePropertyValueFromFormItem",
			value: function getDataTypePropertyValueFromFormItem(formItem, propertyName) {
				//本方法针对FormItem_Editor 但不支持Enum类型
				var pFormItem = formItem.Properties.Extends;
				if (pFormItem == null) return null;
	
				if (!pFormItem.hasOwnProperty("refentityid")) return null;
	
				if (pFormItem.hasOwnProperty("refinnerid")) {
					var table = _GOT2.default.getTable(pFormItem.refentityid);
					if (table != null) {
						var tableField = _GOT2.default.getTableField(table, pFormItem.refinnerid);
						var pTableField = tableField.Properties.Extends;
						if (!pTableField.hasOwnProperty("refentityid")) return null;
	
						var dataType = _GOT2.default.getDataType(pTableField.refentityid);
					} else {
						return null;
					}
				} else {
					dataType = _GOT2.default.getDataType(pFormItem.refentityid);
				}
	
				if (dataType.type == "Component") {
					var itemName = pFormItem.V.split(".")[1];
					var arrayItem = _GOT2.default.getDataTypeArrayItem(itemName);
					var refentityId = arrayItem.Properties.RefDataType.refentityid;
					dataType = _GOT2.default.getDataType(refentityId);
				}
				var value = dataType.Properties[propertyName].Value;
				while (value == "") {
					var _refentityId2 = dataType.Properties["Extends"].refentityid;
					dataType = _GOT2.default.getDataType(_refentityId2);
					value = dataType.Properties[propertyName].Value;
				}
	
				if (value == "") return null;else return value;
			}
	
			// static getItemEntity(item)
			// {
			// 	if(item.hasOwnProperty("version"))
			// 		return item;
			// 	else
			// 		return getItemEntity(item.parent());
			// }
	
		}, {
			key: "isFindQueryField",
			value: function isFindQueryField(propertyName) {
				if (propertyName == "Label" || propertyName == "NumOfDecimal" || propertyName == "StringSize") return true;
				return false;
			}
		}, {
			key: "getPropertyValueStepByStep",
			value: function getPropertyValueStepByStep(item, entity, propertyName, validateString, validateEquals, findFormDataSourceField) {
				var value;
	
				if (item.qname == "FormItem") {
					value = item.Properties[propertyName].Value;
					//item.Properties.Property.(Name==propertyName).Value;
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
	
					var pFormItem_Extends;
					if (item.type == "FieldGroup") {
						pFormItem_Extends = item.Properties["Component"];
						if (!pFormItem_Extends.hasOwnProperty("refentityid")) {
							//pFormItem_Extends = getProperty(item,"FieldGroup");
							return value;
						}
					} else {
						pFormItem_Extends = item.Properties["Extends"];
					}
	
					if (pFormItem_Extends == null) throw new Error("FromItem上找不到Extends");
	
					var isQueryField = false;
					if (!pFormItem_Extends.hasOwnProperty("refentityid") && isFindQueryField(propertyName)) {
						pFormItem_Extends = item.Properties["QueryField"];
						if (pFormItem_Extends == null || !pFormItem_Extends.hasOwnProperty("refentityid")) return value;
						isQueryField = true;
					}
					if (pFormItem_Extends.hasOwnProperty("refinnerid")) {
						if (pFormItem_Extends.Value == "") return "";
						if (findFormDataSourceField) {
							if (isQueryField == false) {
								var pFormItem_DataSource = item.Properties["DataSource"];
							} else {
								pFormItem_DataSource = item.Properties["QuerySource"];
							}
	
							if (pFormItem_DataSource == null || !pFormItem_DataSource.hasOwnProperty("innerid")) return value;
							var innerid = pFormItem_DataSource.innerid;
							//TODO form
							var formDataSource = _GOT2.default.getFormDataSource(window.formXML, innerid);
							var formDataSourceFieldName = pFormItem_Extends.Value;
							item = _GOT2.default.getFormDataSourceField(formDataSource, formDataSourceFieldName);
							/*item = XML(getItemEntity(item).FormDataSources.FormDataSource.(@id==pFormItem_DataSource.@innerid)[0])
	      	.FormDataSourceFields.FormDataSourceField.(@name==pFormItem_Extends.Value)[0];*/
						} else {
							var refentityId = pFormItem_Extends.refentityid;
							var refinnerId = pFormItem_Extends.refinnerid;
							var table = _GOT2.default.getTable(refentityId);
							item = _GOT2.default.getTableField(table, refinnerId);
							//item = GOT.getTable(pFormItem_Extends.@refentityid).TableFields.TableField.(@id==pFormItem_Extends.@refinnerid)[0];
						}
					} else if (pFormItem_Extends.hasOwnProperty("refentityid")) {
						item = _GOT2.default.getDataType(pFormItem_Extends.refentityid);
						if (item == null) item = _GOT2.default.getEnum(pFormItem_Extends.refentityid);
					}
				}
	
				if (item.qname == "FormDataSourceField") {
					value = item.Properties.hasOwnProperty(propertyName) ? item.Properties[propertyName].Value : "";
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
	
					var pFormDataSourceField_Field = item.Properties["Field"];
					var _refentityId = pFormDataSourceField_Field.refentityid;
					var _refinnerId = pFormDataSourceField_Field.refinnerid;
					var _table = _GOT2.default.getTable(_refentityId);
					item = _GOT2.default.getTableField(_table, _refinnerId);
					//item = GOT.getTable(pFormDataSourceField_Field.@refentityid).TableFields.TableField.(@id==pFormDataSourceField_Field.@refinnerid)[0];
				}
	
				if (item.qname == "TableField") {
					value = item.Properties.hasOwnProperty(propertyName) ? item.Properties[propertyName].V : "";
					if (propertyName == "Visible") //即使碰到Component，也不展开，直接返回
						return value;
	
					if (propertyName == "AllowEdit" || propertyName == "NotNull") {
						return value;
					}
	
					if (item.type == "Component") {
						if (pFormItem_Extends && pFormItem_Extends.Value.indexOf(".") != -1) {
							pTableField_Extends = item.Properties["Extends"];
							var _refentityId3 = pTableField_Extends.refentityid;
							var componentDataType = _GOT2.default.getDataType(_refentityId3);
							var arrayItemName = pFormItem_Extends.Value.split(".")[1];
							var dataTypeArrayItem = _GOT2.default.getDataTypeArrayItem(componentDataType, arrayItemName);
							_refentityId3 = dataTypeArrayItem.Properties["RefDataType"].refentityid;
							item = _GOT2.default.getDataType(_refentityId3);
							/*item = GOT.getDataType(
	      GOT.getDataType().DataTypeArray.DataTypeArrayItem
	      	.(@name==String(pFormItem_Extends.Value).split(".")[1])
	      	.Properties.Property.(Name=="RefDataType").@refentityid);	*/
						} else if (pFormDataSourceField_Field && pFormDataSourceField_Field.Value.indexOf(".") != -1) {
							pTableField_Extends = item.Properties["Extends"];
							var t = _GOT2.default.getDataType(pTableField_Extends.refentityid);
							var _arrayItemName = pFormDataSourceField_Field.Value.split(".")[1];
							var arrayItem = _GOT2.default.getDataTypeArrayItem(t, _arrayItemName);
							var _refentityId4 = arrayItem.Properties["RefDataType"].refentityid;
							item = _GOT2.default.getDataType(_refentityId4);
							/*item = GOT.getDataType(
	      	t.DataTypeArray.DataTypeArrayItem.(@name==String(pFormDataSourceField_Field.Value).split(".")[1])
	      	.Properties.Property.(Name=="RefDataType").@refentityid);*/
						} else {
							if (validateEquals) {
								if (value == validateString) return value;
							} else {
								if (value != validateString) return value;
							}
							pTableField_Extends = item.Properties["Extends"];
							if (!pTableField_Extends.hasOwnProperty("refentityid")) return value;
							item = _GOT2.default.getDataType(pTableField_Extends.refentityid);
						}
					} else {
						if (validateEquals) {
							if (value == validateString) return value;
						} else {
							if (value != validateString) return value;
						}
						var pTableField_Extends = item.Properties["Extends"];
						if (!pTableField_Extends.hasOwnProperty("refentityid")) return value;
						item = _GOT2.default.getDataType(pTableField_Extends.refentityid);
						if (item == null) item = _GOT2.default.getEnum(pTableField_Extends.refentityid);
					}
				}
	
				while (item.qname == "DataType") {
					var tmp = item.Properties[propertyName];
					if (tmp == null) return value;
					value = tmp.V;
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
	
					var pDataType_Extends = item.Properties["Extends"];
					if (pDataType_Extends == null) return value;
					if (!pDataType_Extends.hasOwnProperty("refentityid")) return value;
					item = _GOT2.default.getDataType(pDataType_Extends.refentityid);
					if (item == null) item = _GOT2.default.getEnum(pDataType_Extends.refentityid);
				}
	
				if (item.qname == "Enum") {
					tmp = item.Properties[propertyName];
					if (tmp == null) return value;
					value = tmp.V;
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
				}
	
				return value;
			}
		}, {
			key: "hasProperty",
			value: function hasProperty(reportField, property) {
				if (reportField.Properties.hasOwnProperty(property)) return true;else return false;
			}
		}, {
			key: "getReprotFinalValue",
			value: function getReprotFinalValue(item, property) {
				var nodeName = item.qname;
				if (nodeName == "ReportField") {
					if (property == "Extends" || property == "Source") return item.Properties[property].V;
	
					var hasProperty = GOTUtil.hasProperty(item, property);
					if (hasProperty) {
						var value = item.Properties[property].V;
						if (value != "") return value;
					}
	
					var extendsPro = item.Properties["Extends"];
					if (extendsPro.hasOwnProperty("refentityid")) {
						var refId = extendsPro.refentityid;
						if (refId.substr(0, 2) == "20") var entity = _GOT2.default.getDataType(refId);else entity = _GOT2.default.getEnum(refId);
						return GOTUtil.getFinalValue(entity, entity, property);
					}
	
					if (property == "Label") return item.name;
	
					//如果是ReportField 并且该属性在这个ReportField上没有并且它又不继承任何DataType
					//或者这个属性在这个ReportField上有但是值是空
	
					if ("Regular" == property) {
						return "";
					} else if ("NotNull" == property) {
						return "false";
					} else if ("AllowEdit" == property) {
						return "true";
					} else if ("AllowEditOnCreate" == property) {
						return "true";
					} else if ("Default" == property) {
						return "";
					} else if ("SkipTab" == property) {
						return "false";
					} else if ("DisplayHeight" == property) {
						return "1";
					} else if ("Seperator" == property) {
						return "-";
					} else if ("NumOfYear" == property) {
						return "4";
					} else if ("NumOfMonth" == property) {
						return "2";
					} else if ("NumOfDay" == property) {
						return "2";
					} else if ("Show1970" == property) {
						return "true";
					} else if ("ShowZero" == property) {
						return "true";
					} else if ("ThousandSeperator" == property) {
						return ",";
					} else if ("AllowNegative" == property) {
						return "true";
					} else if ("ShowDecimals" == property) {
						return "true";
					} else if ("RoundOff" == property) {
						return "HalfUp";
					} else if ("Trim" == property) {
						return "LeftRight";
					} else if ("ChangeCase" == property) {
						return "None";
					} else if ("ShowHour" == property) {
						return "true";
					} else if ("ShowMinute" == property) {
						return "true";
					} else if ("ShowSecond" == property) {
						return "true";
					}
	
					return "";
				}
	
				if (nodeName == "ReportQuery") {
					return item.Properties[property].V;
				}
	
				if (nodeName == "Report") {
					var label = item.Properties[property].V;
					if (label == "") return item.name;
					return label;
				}
	
				if (nodeName == "Query" && property == "Title") {
					value = item.Properties[property].V;
					if (value == "") {
						var queryTable = item.QueryTable;
						if (queryTable == undefined || queryTable == null) return item.name;
						extendsPro = item.Properties["Table"];
						if (extendsPro.hasOwnProperty("refentityid")) var table = _GOT2.default.getTable(extendsPro.refentityid);
						if (table != null) {
							value = GOTUtil.getFinalValue(table, table, "Label");
							if (value == "") value = item.name;
						}
					}
					return value;
				}
	
				return null;
			}
		}, {
			key: "getFilterFieldFromFormItem",
			value: function getFilterFieldFromFormItem(item) {
				var result = null;
				if (item.type == "StringEditor") {
					var dataSource = item.Properties["DataSource"].V;
					if (dataSource != "") {
						var extendsPro = item.Properties["Extends"];
						if (extendsPro.hasOwnProperty("refentityid") && extendsPro.hasOwnProperty("refinnerid")) {
							var entityid = extendsPro.refentityid;
							var innerid = extendsPro.refinnerid;
							var tableField = _GOT2.default.getTableField(entityid, innerid);
							if (tableField != null) {
								var filterField = tableField.Properties["FilterField"].V;
								if (filterField != "") return filterField;
							}
						}
					}
				}
	
				return result;
			}
		}, {
			key: "getFinalValue",
			value: function getFinalValue(item, entity, property) {
				var value;
				var p;
				var nodeName = item.qname;
	
				if (nodeName == "FormItem") {
	
					if (property == "X" || property == "Y" || property == "Width" || property == "Height" || property == "HideInvisible" || property == "Layout" || property == "Icon" || property == "DisabledIcon" || property == "ShortCut" || property == "DisplayMode" || property == "SaveRecord" || property == "MultiSelect" || property == "DisplayHeight" || property == "ShowLabel" || property == "LabelPosition" || property == "LabelAlignment" || property == "SearchMode" || property == "ReturnLookup" || property == "Source" || property == "DataSource" || property == "DataMethod" || property == "Extends" || property == "FieldGroup" || property == "Component" || property == "MenuItem" || property == "ShowHeader" || property == "SkipTab" || property == "LabelLength" || property == "HeaderAlign" || property == "Rows" || property == "URL" || property == "Suffix" || property == "Popup" || property == "LayoutMode" || property == "ControlType" || property == "ClassName" || property == "FailureImage" || property == "QueryType" || property == "ButtonType" || property == "GroupType" || property == "QuerySource" || property == "QueryField" || property == "QueryFilter"
					//Button
					|| property == "DisabledIcon" || property == "SearchMode" || property == "AuthorityLevel" || property == "AlignBase") {
						return item.Properties[property].Value;
					}
	
					if (property == "FilterField") {
						value = GOTUtil.getFilterFieldFromFormItem(item);
						if (value != null) return value;else return "";
					}
	
					if (property == "Trim") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "LeftRight";
					} else if (property == "ChangeCase") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "None";
					} else if (property == "ShowZero") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "true";
					} else if (property == "AllowNegative") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "true";
					} else if (property == "ThousandSeperator") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "false";
					} else if (property == "ShowDecimals") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "2";
					} else if (property == "RoundOff") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "HalfUp";
					} else if (property == "Seperator") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "-";
					} else if (property == "NumOfYear") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "4";
					} else if (property == "NumOfMonth") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "2";
					} else if (property == "NumOfDay") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "2";
					} else if (property == "Show1970") {
						return true;
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "false";
					} else if (property == "ShowHour" || property == "ShowMinute" || property == "ShowSecond") {
						return true;
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "true";
					}
					//下面两个TextTrue TextFalse 目前用不上，在画面上只是CheckBox，没有显示文字的时候
					else if (property == "TextTrue") {
							value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
							if (value != null) return value;else return "是";
						} else if (property == "TextFalse") {
							value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
							if (value != null) return value;else return "否";
						}
	
					var formItemType = item.type;
	
					if (formItemType == "Text") return item.Properties[property].Value;
	
					if (property == "Label" && formItemType == "FieldGroup") {
						//self
						value = item.Properties[property].Value;
						if (value != "") return value;
	
						//FormItem --> TableFieldGroup
						p = item.Properties["FieldGroup"];
						if (p.hasOwnProperty("refentityid")) {
							var refentityId = p.refentityid;
							var table = _GOT2.default.getTable(refentityId);
							var tableFieldGroup = _GOT2.default.getTableFieldGroup(table, p.refinnerid);
							value = tableFieldGroup.Properties[property].V;
							/*value = GOT.getTable(p.@refentityid).TableFieldGroups.TableFieldGroup
	      	.(@id==p.@refinnerid).Properties.Property
	      	.(Name==property).Value;*/
							if (value != "") return value;else return "";
						}
	
						//FormItem -->FormDataSourceField_Component
						p = item.Properties["Component"];
						if (p.hasOwnProperty("refinnerid")) {
							var _table2 = _GOT2.default.getTable(p.refinnerid);
							var refinnerId = p.refinnerid;
							var tmp = _GOT2.default.getTableField(_table2, refinnerId);
							value = tmp.Properties[property].V;
							if (value != "") {
								return value;
							} else {
								var _refentityId5 = tmp.Properties["Extends"].refentityid;
								var dataType = _GOT2.default.getDataType(_refentityId5);
								value = dataType.Properties[property].Value;
								if (value != "") return value;else return "";
							}
						}
	
						//FormItem --> Component
						p = item.Properties["Component"];
						if (p.hasOwnProperty("refentityid")) {
							var _refentityId6 = p.refentityid;
							var _dataType = _GOT2.default.getDataType(_refentityId6);
							value = _dataType.Properties[property].V;
							if (value != "") return value;else return "";
						}
	
						return value;
						/*
	     if(value=="")
	     	return item.@name;
	     else
	     	return value;*/
					}
	
					if (formItemType.indexOf("Editor") == -1) {
						if (property == "AllowEdit" || property == "Visible") {
							if (formItemType == "FieldGroup") {
								return GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
							} else {
								return item.Properties[property].Value;
							}
						} else if (property == "Label") {
							value = item.Properties[property].Value;
							if (value != "") return value;else return item.name;
						} else return null; //前面都已经判断完了，这种情况应该不存在
					}
	
					if (property == "AllowEditOnCreate") {
						var allowEdit = item.Properties["AllowEdit"].Value;
						if (allowEdit == "false") return "false";
						p = item.Properties["Extends"];
						if (!p.hasOwnProperty("refentityid") || !p.hasOwnProperty("refinnerid")) return "true";
						var pFormItem_DataSource = item.Properties["DataSource"];
						var innerId = pFormItem_DataSource.innerid;
						var formDataSource = _GOT2.default.getFormDataSource(entity, innerId);
						var formDataSourceFieldName = p.Value;
						item = _GOT2.default.getFormDataSourceField(formDataSource, formDataSourceFieldName);
						/*item = XML(getItemEntity(item).FormDataSources.FormDataSource.(@id==pFormItem_DataSource.@innerid)[0])
	     	.FormDataSourceFields.FormDataSourceField.(@name==p.Value)[0];*/
						allowEdit = item.Properties["AllowEdit"].Value;
						if (allowEdit == "false") return "false";
						var _table = _GOT2.default.getTable(p.refentityid);
						var _istmp = _table.Properties["Temporary"].V;
						if (_istmp == "true") return "false";
						var tableField = _GOT2.default.getTableField(_table, p.refinnerid);
						return tableField.Properties[property].V;
					}
	
					if (property == "Label") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
						if (value != "" && value != null) return value;else {
							return item.name;
						}
					} else if (property == "HelpText" || property == "DisplayLength" || property == "Regular" || property == "Default") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					} else if (property == "Alignment" || property == "StringSize" || property == "FormLookup"
					//|| property=="ValidateLookup"
					|| property == "NumOfDecimals") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, false);
					} else if (property == "AllowEdit") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "Visible") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "NotNull") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					}
					return null; //FormItem应该在上面 全覆盖了 到此为null异常	
				}
	
				if (nodeName == "FormDataSource" && property == "Label") {
					var _tablePro = item.Properties["Table"];
					if (_tablePro.hasOwnProperty("refentityid")) {
						var _refentityid = _tablePro.refentityid;
						_tablePro = _GOT2.default.getTable(_refentityid);
						var _label = _tablePro.Properties["Label"].V;
						if (_label != "") return _label;
						return item.name;
					}
				}
	
				if (nodeName == "FormDataSourceField" || nodeName == "TableField" || nodeName == "DataType" || nodeName == "Enum") {
	
					if (property == "AllowEdit") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "Visible") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "NotNull") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					} else {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					}
	
					if (value == "") {
						if (property == "Label") return item.name;
					} else {
						return value == null ? "" : value;
					}
				}
	
				if (nodeName == "FormDataSourceFieldGroup" && property == "Label") {
					var pFormDataSourceFieldGroup_FieldGroup = item.Properties["FieldGroup"];
					var _refentityId7 = pFormDataSourceFieldGroup_FieldGroup.refentityid;
					var _table3 = _GOT2.default.getTable(_refentityId7);
					var _refinnerId2 = pFormDataSourceFieldGroup_FieldGroup.refinnerid;
					var _tableFieldGroup = _GOT2.default.getTableFieldGroup(_table3, _refinnerId2);
					value = _tableFieldGroup.Properties[property].V;
					/*value = GOT.getTable(pFormDataSourceFieldGroup_FieldGroup.@refentityid)
	    	.TableFieldGroups.TableFieldGroup.(@id==pFormDataSourceFieldGroup_FieldGroup.@refinnerid)
	    	.Properties.Property.(Name==property).Value;*/
					if (value == "") return item.name;else return value;
				}
	
				value = item.Properties.hasOwnProperty(property) ? item.Properties[property].Value || item.Properties[property].V : "";
	
				if (value == "") {
					if (property == "Label" && nodeName != "EnumItem") return item.name;else if (property == "DefaultOrderBy") return "RecIdx";
				}
	
				return value;
	
				//TODO HashMap做缓存 propertyValueHash[valueKey] = value;
			}
		}, {
			key: "getTitleFormDataSource",
			value: function getTitleFormDataSource(form) {
				var formDesign = form.FormDesign;
				var titleDataSourcePro = formDesign.Properties["TitleDataSource"];
				var formDesignDataSourcePro = formDesign.Properties["DataSource"];
	
				var dataSource = null;
				if (titleDataSourcePro && titleDataSourcePro.hasOwnProperty("innerid")) {
					var innerId = titleDataSourcePro.innerid;
					dataSource = _GOT2.default.getFormDataSource(form, innerId);
					//dataSource = form.FormDataSources.FormDataSource.(@id == String(titleDataSourcePro.@innerid));
				} else if (formDesignDataSourcePro && formDesignDataSourcePro.hasOwnProperty("innerid")) {
					var _innerId2 = formDesignDataSourcePro.innerid;
					dataSource = _GOT2.default.getFormDataSource(form, _innerId2);
					//dataSource = form.FormDataSources.FormDataSource.(@id == String(formDesignDataSourcePro.@innerid));
				} else if (form.FormDataSources.DataSources.length > 0) {
					dataSource = form.FormDataSources.DataSources[0];
				}
	
				return dataSource;
			}
		}, {
			key: "getFormDataSourceTable",
			value: function getFormDataSourceTable(dataSource) {
				var tablePro = dataSource.Properties["Table"];
				if (tablePro.hasOwnProperty("refentityid")) {
					var table = _GOT2.default.getTable(tablePro.refentityid);
					if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
					return table;
				} else {
					throw new Error("GOT错误 在DataSource上的Table属性没有继承自表");
				}
			}
		}, {
			key: "getLabelByForm",
			value: function getLabelByForm(form, firstGroup) {
				var findMenuItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
				var label = "";
	
				if (finedMenuItem == true) {
					var menuItemid = form.menuItemId;
					if (menuItemid != "") {
						var menuItem = _GOT2.default.getMenuItem(menuItemid);
						if (menuItem != null) {
							label = menuItem.Properties["Label"].V;
							if (label != "") return label;
						}
					}
				}
	
				var titlePro = form.Properties["Title"];
				label = titlePro.Value;
				if (label != "") return label;
	
				var labelPro;
				var dataSource = GOTUtil.getTitleFormDataSource(form);
				if (dataSource) {
					var tablePro = dataSource.Properties["Table"];
					if (tablePro.hasOwnProperty("refentityid")) {
						var table = _GOT2.default.getTable(tablePro.refentityid);
						if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
						labelPro = table.Properties["Label"];
						label = labelPro.V;
						if (label != "") return label;
					}
				}
				if (firstGroup != null) {
					var mainSource = firstGroup.mainSource;
					tablePro = mainSource.xml.Properties["Table"];
					if (tablePro != null && tablePro.hasOwnProperty("refentityid")) {
						table = _GOT2.default.getTable(tablePro.refentityid);
						if (table != null) {
							label = table.Properties["Label"].V;
							if (label != "") return label;
						}
					}
				}
	
				if (menuItem != null) return menuItem.name;
	
				return form.name;
			}
		}, {
			key: "getLabelByFormOrig",
			value: function getLabelByFormOrig(form) {
				var label = "";
	
				var titlePro = form.Properties["Title"];
				label = titlePro.Value;
				if (label != "") return label;
				var formDesign = form.FormDesign;
	
				var labelPro = formDesign.Properties["Label"];
				label = labelPro.Value;
				if (label != "") return label;
	
				var dataSource = GOTUtil.getTitleFormDataSource(form);
				if (dataSource) {
					var tablePro = dataSource.Properties["Table"];
					if (tablePro.hasOwnProperty("refentityid")) {
						var table = _GOT2.default.getTable(tablePro.refentityid);
						if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
						labelPro = table.Properties["Label"];
						label = labelPro.V;
						if (label != "") return label;
					}
				}
	
				return form.name;
			}
		}, {
			key: "getMenuItemLabel",
			value: function getMenuItemLabel(menuItem) {
				var labelPro = menuItem.Properties["Label"];
				if (labelPro.V == "") {
					var sourceTypePro = menuItem.Properties["SourceType"] || menuItem.Properties["Source"];
					var sourceType = sourceTypePro.V;
					var refObjectPro = menuItem.Properties["RefObject"] || menuItem.Properties["Source"];
	
					var id = "";
					var refObject;
	
					if (sourceType == "Form") {
	
						if (refObjectPro.hasOwnProperty("refentityid")) {
							id = refObjectPro.refentityid;
							refObject = _GOT2.default.getForm(id);
							if (refObject == null) throw new Error("GOT閿欒 鍦╮efObject涓婃壘涓嶅埌Form");
							return GOTUtil.getLabelByFormOrig(refObject);
						}
					} else if (sourceType == "Report") {
						if (refObjectPro.hasOwnProperty("refentityid")) {
							id = refObjectPro.refentityid;
							refObject = _GOT2.default.getReport(id);
							if (refObject == null) throw new Error("从MenuItem上找不到对应的Report");
							return GOTUtil.getFinalValue(refObject, refObject, "Label");
						}
					}
				}
				return labelPro.V;
			}
		}, {
			key: "getMainTable",
			value: function getMainTable(dname) {
				var dataType = _GOT2.default.getDataType(dname);
				if (dataType == null) {
					//alert("没有找到DataType" + dname);
					return null;
				}
				var dataTypeRelation = dataType.DataTypeRelation;
				if (dataTypeRelation == null) return null;
				var tablepro = dataTypeRelation.Properties["Table"];
				//var pro:XMLList = dataTypeRelation.Properties.Property.(Name == "Table");
				var obj = new Object();
				obj.mainTable = tablepro.V;
				obj.dataType = dataType;
				return obj;
			}
		}, {
			key: "getAutoLookupFields",
			value: function getAutoLookupFields(mainTable, dataTypeRelation) {
				var tableFields = [];
				var tableField;
				var fieldPro;
				var allTableFields = mainTable.TableFields;
				var autoLookUp = _GOT2.default.getTableFieldGroup("AutoLookup");
				for (var i in autoLookUp.FieldGroupItems) {
					var tableFieldGroupItem = autoLookUp.FieldGroupItems[i];
					fieldPro = tableFieldGroupItem.Properties["Field"];
					var innerId = fieldPro.innerid;
					tableField = _GOT2.default.getTableField(innerId);
					if (!tableField) throw new Error("GOT设置错误 在AutoLookup的GroupItem上找不到TableField");
					tableFields.push(tableField);
				}
	
				if (tableFields.length == 0) {
					fieldPro = mainTable.Properties["TitleField1"];
	
					if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
						var _innerId3 = fieldPro.innerid;
						tableField = _GOT2.default.getTableField(_innerId3);
						if (!tableField) throw new Error("GOT设置错误 在TitleField1上找不到TableField");
						tableFields.push(tableField);
					}
					fieldPro = mainTable.Properties["TitleField2"];
					if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
						var _innerId4 = fieldPro.innerid;
						tableField = _GOT2.default.getTableField(_innerId4);
						if (!tableField) throw new Error("GOT设置错误 在TitleField2上找不到TableField(存在innerid)");
						tableFields.push(tableField);
					}
				}
	
				var index;
				var indexItem;
				var indexes;
				if (tableFields.length == 0) {
					fieldPro = mainTable.Properties["ClusterIndex"];
					if (fieldPro.hasOwnProperty("innerid")) {
						var _innerId5 = fieldPro.innerid;
						index = _GOT2.default.getTableIndex(mainTable, _innerId5);
						for (var i in index.IndexItems) {
							var indexItem = index.IndexItems[i];
							fieldPro = indexItem.Properties["Field"];
							if (fieldPro.hasOwnProperty("innerid")) {
								var _innerId6 = fieldPro.innerid;
								tableField = _GOT2.default.getTableField(_innerId6);
								if (!tableField) throw new Error("GOT设置错误 在TableIndexItem上找不到TableField(存在innerid)");
								tableFields.push(tableField);
							}
						}
					}
				}
	
				if (tableFields.length == 0) {
					if (dataTypeRelation != null) {
						var normalItem = _GOT2.default.getDataTypeRelationNormalItem(dataTypeRelation);
						if (normalItem != null) {
							fieldPro = normalItem.Properties["Field"];
							if (fieldPro.hasOwnProperty("refinnerid")) {
								var refinnerId = fieldPro.refinnerid;
								tableField = _GOT2.default.getTableField(mainTable, refinnerId);
								if (!tableField) throw new Error("GOT设置错误 在RelationItem上找不到TableField(存在refinnerid)");
								tableFields.push(tableField);
							}
						}
					}
				}
	
				return tableFields;
			}
		}, {
			key: "getComponentItemName",
			value: function getComponentItemName(dataField) {
				if (dataField == null) return null;
	
				var array = dataField.split(".");
				if (array.length == 3) {
					var s = array[2];
					return s.substr(0, 1).toUpperCase() + s.substring(1);
				}
	
				return null;
			}
		}, {
			key: "getDataType2",
			value: function getDataType2(_entityId, _innerId) {
				// if(window.isDataSetView == true)
				// {
				// 	return null;//对于数据集统计查询页面 不需要主表下拉框一类的查询
				// }
				if (!_entityId) {
					throw new Error("unknown type of StringEditor");
				}
	
				var _entityIdArr = _entityId.split(".");
				var entityIdtmp = _entityIdArr[_entityIdArr.length - 1];
	
				if (entityIdtmp && entityIdtmp.indexOf(".") != -1) {
					var entityIdtmpArr = entityIdtmp.split(".");
					var lastId = entityIdtmpArr[entityIdtmpArr.length - 1];
					entityIdtmp = lastId;
				}
				var first = entityIdtmp.substr(0, 2);
				if (first == "40" && _innerId != null) {
					return GOTUtil.getDataTypeByFormItem(_entityId, _innerId);
				} else if (first == "73" && _innerId != null) {
					return GOTUtil.getDataTypeByReportField(_entityId, _innerId);
				} else if (first == "30" && _innerId != null) {
					return GOTUtil.getDataTypeByTableField(_entityId, _innerId);
				} else if (first == "20" && _innerId == null) {
					return GOTUtil.getDataTypeByDataType(_entityId);
				} else if (window.isDataSetView == true) {
					return GOTUtil.getDataTypeByFormItem(_entityId, _innerId);
				} else {
	
					throw new Error("unknown type of StringEditor");
				}
			}
		}, {
			key: "getDataTypeByReportField",
			value: function getDataTypeByReportField(entityId, innerId) {
				var dataType;
				var reportField = GOTUtil.getItemXML(entityId, innerId);
	
				var extendsPro = reportField.Properties["Extends"];
				if (extendsPro.hasOwnProperty("refentityid")) {
					dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
				}
				return dataType;
			}
		}, {
			key: "getDataTypeByFormItem",
			value: function getDataTypeByFormItem(entityId, innerId) {
				var dataType;
				var form = _GOT2.default.getForm(entityId);
				var formItem = _GOT2.default.getFormItem(form, innerId);
				//var formItem = GOT.getForm(entityId).descendants("FormItem").(@id == innerId);
				if (formItem == null) throw new Error("multi formitem to StringEditor");
				var extendsPro = formItem.Properties["Extends"];
				if (extendsPro && extendsPro.hasOwnProperty("refentityid")) {
					if (extendsPro.hasOwnProperty("refinnerid")) {
						var tableId = extendsPro.refentityid;
						var tableFieldId = extendsPro.refinnerid;
						dataType = GOTUtil.getDataTypeByTableField(tableId, tableFieldId);
					} else {
						dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
					}
				}
				return dataType;
			}
		}, {
			key: "getDataTypeByTableField",
			value: function getDataTypeByTableField(tableId, tableFieldId) {
				var table = _GOT2.default.getTable(tableId);
				var dataType;
				if (table) {
					var tableField = _GOT2.default.getTableField(table, tableFieldId);
					var extendsPro = tableField.Properties["Extends"];
					if (extendsPro.hasOwnProperty("refentityid")) dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
				}
				return dataType;
			}
		}, {
			key: "getDataTypeByDataType",
			value: function getDataTypeByDataType(entityId) {
				var dataType = _GOT2.default.getDataType(entityId);
				return dataType;
			}
	
			//TODO Inner节点目前只支持TableField 发现错误应该再加 比如Report Flex版由于e4x都支持
	
		}, {
			key: "getItemXML",
			value: function getItemXML(entityId, innerId) {
				var entity = GOTUtil.getEntityXML(entityId);
				if (innerId) {
					return GOTUtil.getInnerXML(entity, innerId);
				}
	
				return entity;
			}
		}, {
			key: "getEntityType",
			value: function getEntityType(entityId) {
				var type;
	
				if (!entityId) {
					return null;
				}
	
				var _entityIdArr = entityId.split(".");
				entityId = _entityIdArr[_entityIdArr.length - 1];
				var first = parseInt(entityId.substr(0, 2));
				if (first == 10) type = "Enum";else if (first == 20) type = "DataType";else if (first == 30) type = "Table";else if (first == 40) type = "Form";else if (first == 50) type = "MenuItem";else if (first == 60) type = "Menu";else if (first == 71) type = "Map";else if (first == 72) type = "Query";else if (first == 73) type = "Report";else type = null;
	
				return type;
			}
		}, {
			key: "getEntityXML",
			value: function getEntityXML(_id) {
				if (_id == null) return null;
	
				var type = GOTUtil.getEntityType(_id);
	
				switch (type) {
					case "Enum":
						return _GOT2.default.getEnum(_id);
					case "DataType":
						return _GOT2.default.getDataType(_id);
					case "Table":
						return _GOT2.default.getTable(_id);
					case "MenuItem":
						return _GOT2.default.getMenuItem(_id);
					case "Menu":
						return _GOT2.default.getMenu(_id);
					case "Form":
						return _GOT2.default.getForm(_id);
					case "Query":
						return _GOT2.default.getQuery(_id);
					case "Report":
						return _GOT2.default.getReport(_id);
					default:
						throw new Error("非法的Entity Type");
				}
			}
	
			/*private static var innerCache:Object = {};
	  public static function clearInnerCache(entityid:String = null):void
	  {
	  	if(entityid == null)
	  	{
	  		innerCache = {};
	  	}
	  	else
	  	{
	  		var temp:Vector.<String> = new Vector.<String>();
	  		for (var key:String in innerCache)
	  		{
	  			if(key.split(".")[0] == entityid)
	  			{
	  				temp.push(key);
	  			}
	  		}
	  		
	  		for each(key in temp)
	  		{
	  			innerCache[key] = null;
	  			delete innerCache[key];
	  		}
	  	}
	  }*/
	
		}, {
			key: "getInnerXML",
			value: function getInnerXML(entity, innerId) {
				var id = entity.id;
				if (!id) return;
				var _entityIdArr = id.split(".");
				id = _entityIdArr[_entityIdArr.length - 1];
				if (id.indexOf("3") == 0) {
					return _GOT2.default.getTableField(entity, innerId);
				}
			}
	
			/*public static function getInnerXML(entity, _innerId)
	  {
	  	
	  	let qname = (entity.hasOwnProperty("FormDesign")?"Form":"");
	  	if(qname == "Form")
	  	{
	  		return GOT.getFormItem(entity,_innerId);
	  	}
	  	else
	  	{
	  		list = entity.descendants().(hasOwnProperty("@id")&&@id==_innerId);
	  	}
	  	
	  }*/
	
		}, {
			key: "getFormItemInnerXML",
			value: function getFormItemInnerXML(entity, _innerId) {
				return _GOT2.default.getFormItem(entity, _innerId);
			}
		}, {
			key: "parseUserForm2Form",
			value: function parseUserForm2Form(formXML, root) {
				var parent = GOTUtil.parseUserForm2FormItem(formXML, root);
				var childs = root.children;
				for (var i = 0; i < childs.length; i++) {
					var item = childs[i];
					parent.appendChild(GOTUtil.parseUserForm2Form(formXML, item));
				}
				return parent;
			}
	
			//for Form JSON
	
		}, {
			key: "getFormItemInnerXMLByCache2",
			value: function getFormItemInnerXMLByCache2(entity, _innerId) {
				if (!GOTUtil.formItemCache2[entity.id + "_" + _innerId]) {
					var list = GOTUtil.elementsFormHasId(entity);
					for (var i = 0; i < list.length; i++) {
						var node = list[i];
						GOTUtil.formItemCache2[entity.id + "_" + node.id] = node;
						GOTUtil.getFormItemInnerXMLByCache2(node, _innerId);
					}
				}
	
				return GOTUtil.formItemCache2[entity.id + "_" + _innerId];
			}
	
			//for Form XML
	
		}, {
			key: "getFormItemInnerXMLByCache",
			value: function getFormItemInnerXMLByCache(entity, _innerId) {
				if (!GOTUtil.formItemCache[entity.id + "_" + _innerId]) {
					var list = entity.getElementsByTagName("FormItem");
					for (var i = 0; i < list.length; i++) {
						var node = list[i];
						GOTUtil.formItemCache[entity.id + "_" + node.id] = node;
					}
				}
	
				return GOTUtil.formItemCache[entity.id + "_" + _innerId];
			}
		}, {
			key: "parseUserForm2FormItem",
			value: function parseUserForm2FormItem(formXML, item) {
				var innerId = item.id;
				var formItem = void 0;
				if (!innerId || innerId == "FormDesign") {
					formItem = formXML.children[2].cloneNode(true);
				} else {
					formItem = GOTUtil.getFormItemInnerXMLByCache(formXML, innerId).cloneNode(true);
				}
	
				var userProperties = {};
				var atts = item.attributes;
				for (var k = 0; k < atts.length; k++) {
					var att = atts[k];
					if (att.nodeName != "id") userProperties[att.nodeName] = att.nodeValue;
				}
	
				var _parentWindow = window.parent.window;
				if (!_parentWindow.userProperties) _parentWindow.userProperties = {};
				if (!_parentWindow.userProperties[window.menuItemId + "." + window.formId]) _parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
				var allUserProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
				if (!allUserProperties.hasOwnProperty(innerId)) allUserProperties[innerId] = {};
				Object.assign(allUserProperties[innerId], userProperties);
	
				var childs = formItem.childNodes;
				for (var i = childs.length - 1; i >= 0; i--) {
					var child = childs[i];
					if (child.nodeName != "Properties") formItem.removeChild(childs[i]);
				}
				return formItem;
			}
		}, {
			key: "descendantsFormHasIdItem",
			value: function descendantsFormHasIdItem(item, result) {
				var qname = item.qname;
				if (qname == "FormDataSources") {
					GOTUtil.descendantsFormDataSourcesHasId(item, result);
				} else if (qname == "FormDataSource") {
					GOTUtil.descendantsFormDataSourceHasId(item, result);
				} else if (qname == "FormDataSourceFieldGroup" || qname == "FormDataSourceField") {
					result.push(item);
				} else if (qname == "FormItem" || qname == "FormDesign") {
					GOTUtil.descendantsFormDesignHasId(item, result);
				}
			}
		}, {
			key: "descendantsFormHasId",
			value: function descendantsFormHasId(form, result) {
				var formDataSources = form.FormDataSources;
				result.push(formDataSources);
				GOTUtil.descendantsFormDataSourcesHasId(formDataSources, result);
				var formDesign = form.FormDesign;
				result.push(formDesign);
				GOTUtil.descendantsFormDesignHasId(formDesign, result);
			}
		}, {
			key: "elementsFormHasId",
			value: function elementsFormHasId(item) {
				var qname = item.qname;
				if (qname == "Form") {
					return [item.FormDataSources, item.FormDesign];
				}
				if (qname == "FormDataSources") {
					return item.DataSources;
				} else if (qname == "FormDataSource") {
					return item.FormDataSourceFieldGroups.concat(item.FormDataSourceFields);
				} else if (qname == "FormDataSourceFieldGroup" || qname == "FormDataSourceField") {
					return [];
				} else if (qname == "FormItem" || qname == "FormDesign") {
					return item.FormItem;
				}
				return [];
			}
		}, {
			key: "descendantsFormDesignHasId",
			value: function descendantsFormDesignHasId(item, result) {
				var formItems = item.FormItem;
				for (var i = 0; i < formItems.length; i++) {
					var formItem = formItems[i];
					result.push(formItem);
					GOTUtil.descendantsFormDesignHasId(formItem, result);
				}
			}
		}, {
			key: "descendantsFormDataSourcesHasId",
			value: function descendantsFormDataSourcesHasId(item, result) {
				var dataSources = item.DataSources;
				for (var i = 0; i < dataSources.length; i++) {
					var dataSource = dataSources[i];
					result.push(dataSource);
					GOTUtil.descendantsFormDataSourceHasId(dataSource, result);
				}
			}
		}, {
			key: "descendantsFormDataSourceHasId",
			value: function descendantsFormDataSourceHasId(item, result) {
				var formDataSourceFieldGroups = item.formDataSourceFieldGroups;
				for (var i = 0; i < formDataSourceFieldGroups.length; i++) {
					var formDataSourceFieldGroup = formDataSourceFieldGroups[i];
					GOTUtil.descendantsFormDataSourceFieldGroupHasId(formDataSourceFieldGroup);
				}
				var formDataSourceFields = item.FormDataSourceFields;
				for (var _i = 0; _i < formDataSourceFields.length; _i++) {
					var formDataSourceField = formDataSourceFields[_i];
					GOTUtil.descendantsFormDataSourceFieldHasId(formDataSourceField, result);
				}
			}
		}, {
			key: "descendantsFormDataSourceFieldHasId",
			value: function descendantsFormDataSourceFieldHasId(item, result) {
				result.push(item);
			}
		}, {
			key: "descendantsFormDataSourceFieldGroupHasId",
			value: function descendantsFormDataSourceFieldGroupHasId(item, result) {
				result.push(item);
			}
	
			/////////////////////////////////////////////////////////////////////////////////
	
		}, {
			key: "getArrayItemByName",
			value: function getArrayItemByName(dataType, itemName) {
				return _GOT2.default.getDataTypeArrayItem(dataType, itemName);
			}
		}, {
			key: "getDataSourceByDataSource",
			value: function getDataSourceByDataSource(extendsPro) {
				if (!extendsPro.hasOwnProperty("refentityid")) return [];
				var tableId = extendsPro.refentityid;
				var tableFieldId = extendsPro.refinnerid;
				var _table = _GOT2.default.getTable(tableId);
				var tableField = _GOT2.default.getTableField(_table, tableFieldId);
	
				if (tableField.type == "Component") {
					var textendsPro = tableField.Properties["Extends"];
					if (!textendsPro.hasOwnProperty("refentityid")) throw new Error("GOT错误:Component类型的TableField没有正确关联到一个对应的DataType");
					var cdataTypeId = textendsPro.refentityid;
					var cdataType = _GOT2.default.getDataType(cdataTypeId);
					var value = extendsPro.V;
					var arrayItemName = value.split(".")[1];
					var arrayItem = _GOT2.default.getDataTypeArrayItem(cdataType, arrayItemName);
					var refDataTypePro = arrayItem.Properties["RefDataType"];
					if (!refDataTypePro.hasOwnProperty("refentityid")) throw new Error("GOT错误:" + cdataType.name + "." + arrayItemName + "没有关联到DataType");
	
					return GOTUtil.getDataSourceByDataType(refDataTypePro);
				} else {
					return GOTUtil.getDataSourceByTableField(tableField);
				}
			}
		}, {
			key: "getDataSourceByTableField",
			value: function getDataSourceByTableField(tableField) {
				var sourcePro = tableField.Properties["Source"];
	
				var extendsPro = tableField.Properties["Extends"];
	
				if (!extendsPro.hasOwnProperty("refentityid")) return GOTUtil.getDataSourceByRegular(tableField);
	
				if (sourcePro.V == "Enum") {
					return GOTUtil.getDataSourceByEnum(extendsPro);
				} else {
					return GOTUtil.getDataSourceByDataType(extendsPro);
				}
			}
		}, {
			key: "getDataSourceByReportField",
			value: function getDataSourceByReportField(reportField) {
				var sourcePro = reportField.Properties["Source"];
				var extendsPro = reportField.Properties["Extends"];
				//tableField.Properties.Property.(Name == "Extends");
	
				if (!extendsPro.hasOwnProperty("refentityid")) return GOTUtil.getDataSourceByRegular(reportField);
	
				if (sourcePro.V == "Enum") {
					return GOTUtil.getDataSourceByEnum(extendsPro);
				} else {
					return GOTUtil.getDataSourceByDataType(extendsPro);
				}
			}
		}, {
			key: "getDataSourceByEnum",
			value: function getDataSourceByEnum(extendsPro) {
				if (!extendsPro.hasOwnProperty("refentityid")) return [];
				var enumId = extendsPro.refentityid;
	
				var entityEnum = _GOT2.default.getEnum(enumId);
	
				var collection = [];
	
				var label;
	
				var value;
	
				for (var i in entityEnum.EnumItems) {
					var item = entityEnum.EnumItems[i];
					label = item.Properties["Label"].V;
					value = item.Properties["Value"].V;
	
					collection.push({ label: label, value: value });
				}
	
				return collection;
			}
		}, {
			key: "getDataSourceByDataType",
			value: function getDataSourceByDataType(extendsPro) {
				if (!extendsPro.hasOwnProperty("refentityid")) return [];
	
				var dataType = _GOT2.default.getDataType(extendsPro.refentityid);
				var extendsPro = dataType.Properties["Extends"];
	
				var sourcePro;
				while (extendsPro.hasOwnProperty("refentityid")) {
					sourcePro = dataType.Properties["Source"];
					if (sourcePro == undefined) throw new Error("从EnumEditor到DataType的继承链上存在非Enum类型的DataType");
	
					if (sourcePro.V == "Enum") {
						return GOTUtil.getDataSourceByEnum(extendsPro);
					}
					dataType = _GOT2.default.getDataType(extendsPro.refentityid);
					extendsPro = dataType.Properties["Extends"];
				}
	
				return GOTUtil.getDataSourceByRegular(dataType);
			}
		}, {
			key: "getDataSourceByRegular",
			value: function getDataSourceByRegular(node) {
				var regularPro = node.Properties["Regular"];
	
				if (regularPro == null) return null;
	
				var regular = regularPro.hasOwnProperty("Value") ? regularPro.Value : regularPro.V;
	
				var collection = [];
	
				var value;
	
				var label;
	
				if (regular != "") {
					var array = regular.split("|");
					for (var i in array) {
						var item = array[i];
						if (item.indexOf(":") > -1) {
							value = item.split(":")[0];
							label = item.split(":")[1];
						} else {
							value = item;
							label = item;
						}
	
						collection.push({ label: label, value: value });
					}
				}
	
				return collection;
			}
		}, {
			key: "getQueryTableByName",
			value: function getQueryTableByName(query, name) {
				var queryTables = query.QueryTable.QueryJoins.Items;
				for (var i = 0; i < queryTables.length; i++) {
					var queryTable = queryTables[i];
					if (queryTable.name == name) return queryTable;
				}
				return null;
			}
		}, {
			key: "getQueryRelationItemByProperty",
			value: function getQueryRelationItemByProperty(queryRelation, propertyName) {
				var items = queryRelation.Items;
				var result = [];
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.hasOwnProperty(propertyName)) result.push(item);
				}
				return result;
			}
		}, {
			key: "getQueryRelationItemByPropertyQuery",
			value: function getQueryRelationItemByPropertyQuery(query, propertyName) {
				var result = [];
				var queryTableItems = query.QueryTable.QueryJoins.Items;
				for (var i = 0; i < queryTableItems.length; i++) {
					var queryTable = queryTableItems[i];
					var queryRelation = queryTable.QueryRelation;
					var items = queryRelation.Items;
	
					for (var k = 0; k < items.length; k++) {
						var item = items[k];
						if (item.hasOwnProperty(propertyName)) result.push({ parent: queryRelation, item: item });
					}
				}
				return result;
			}
		}, {
			key: "getQueryWhereItemByPropertyValue",
			value: function getQueryWhereItemByPropertyValue(query, propertyName, propertyValue) {
				var result = [];
				var queryWhereItems = query.hasOwnProperty("QueryWhere") ? query.QueryWhere.Items : query.QueryTable.QueryWhere.Items;
				for (var i = 0; i < queryWhereItems.length; i++) {
					var queryWhereItem = queryWhereItems[i];
					var _value = GOTUtil.getPropertyValue(queryWhereItem, propertyName);
					if (_value == propertyValue) {
						result.push(queryWhereItem);
					}
				}
				return result;
			}
		}, {
			key: "getQueryTableByAlias",
			value: function getQueryTableByAlias(alias, query) {
				var queryTable = GOTUtil.getQueryTableByAlias2(alias, query.QueryTable);
				if (queryTable == null) throw new Error("queryTable can't find");
	
				return queryTable;
			}
		}, {
			key: "getQueryTableByAlias2",
			value: function getQueryTableByAlias2(alias, queryTable) {
				if (alias == null || queryTable == null) return null;
	
				var _alias = queryTable.Properties.Alias.V;
				if (_alias == alias) return queryTable;
	
				if (queryTable.QueryJoins == null) return null;
	
				var list = queryTable.QueryJoins.Items;
				if (list == null || list.length == 0) return null;
	
				for (var i = 0; i < list.length; i++) {
					var qt = list[i];
					var result = GOTUtil.getQueryTableByAlias2(alias, qt);
					if (result != null) return result;
				}
	
				return null;
			}
		}, {
			key: "getTitleFormDataSource",
			value: function getTitleFormDataSource(form) {
				var formDesign = form.FormDesign;
				var titleDataSourcePro = formDesign.Properties.TitleDataSource;
				var formDesignDataSourcePro = formDesign.Properties.DataSource;
	
				var dataSource = null;
				if (titleDataSourcePro && titleDataSourcePro.hasOwnProperty("innerid")) {
					dataSource = _GOT2.default.getFormDataSource(form, titleDataSourcePro.innerid);
				} else if (formDesignDataSourcePro && formDesignDataSourcePro.hasOwnProperty("innerid")) {
					dataSource = _GOT2.default.getFormDataSource(form, formDesignDataSourcePro.innerid);
				} else {
					dataSource = form.FormDataSources.DataSources.length > 0 ? form.FormDataSources.DataSources[0] : null;
				}
	
				if (dataSource) {
					return dataSource;
				}
	
				return null;
			}
		}, {
			key: "getLabelByForm",
			value: function getLabelByForm(form, firstGroup, menuItemid) {
				var label = "";
				if (!menuItemid) menuItemid = window.menuItemId;
				if (menuItemid) {
					var menuItem = _GOT2.default.getMenuItem(menuItemid);
					if (menuItem) {
						label = menuItem.Properties.Label.V;
						if (label != "") return label;
					}
				}
				var titlePro = form.Properties.Title;
				label = titlePro.Value;
				if (label != "") return label;
	
				var labelPro;
				var dataSource = GOTUtil.getTitleFormDataSource(form);
				if (dataSource) {
					var tablePro = dataSource.Properties.Table;
					if (tablePro.hasOwnProperty("refentityid")) {
						var table = _GOT2.default.getTable(tablePro.refentityid);
						if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
						labelPro = table.Properties.Label;
						label = labelPro.V;
						if (label != "") return label;
					}
				}
				if (firstGroup) {
					var mainSource = firstGroup.mainSource;
					tablePro = mainSource.xml.Properties.Table;
					if (tablePro && tablePro.hasOwnProperty("refentityid")) {
						table = _GOT2.default.getTable(tablePro.refentityid);
						if (table != null) {
							label = table.Properties.Label.V;
							if (label != "") return label;
						}
					}
				}
	
				if (menuItem) return menuItem.name;
	
				return form.name;
			}
		}, {
			key: "getPropertyValue",
			value: function getPropertyValue(xml, property) {
				if (xml.hasOwnProperty("Properties")) {
					var properties = xml.Properties;
					if (properties.hasOwnProperty(property)) {
						var propertyEntity = properties[property];
						var result = propertyEntity.V || propertyEntity.Value;
						if (!result) result = "";
						return result;
					}
				}
				return null;
			}
		}, {
			key: "getProperty",
			value: function getProperty(xml, property) {
				if (xml.hasOwnProperty("Properties")) {
					var properties = xml.Properties;
					if (properties.hasOwnProperty(property)) {
						return properties[property];
					}
				}
				return null;
			}
		}, {
			key: "getShortCut",
			value: function getShortCut(table) {
				if (table == null) return null;
				var result = null;
				var shortcutPro = table.Properties.ShortCutField;
				if (shortcutPro && shortcutPro.hasOwnProperty("innerid")) {
					var innerid = shortcutPro.innerid;
					result = _GOT2.default.getTableField(table, innerid);
					return result;
				}
	
				return null;
			}
		}, {
			key: "getNotComponentFormDataSourceFields",
			value: function getNotComponentFormDataSourceFields(dataSource) {
				var result = [];
				for (var i = 0; i < dataSource.FormDataSourceFields.length; i++) {
					var dataSourceField = dataSource.FormDataSourceFields[i];
					if (dataSourceField.type != "Component") result.push(dataSourceField);
				}
				return result;
			}
		}]);
	
		return GOTUtil;
	}();
	
	GOTUtil.formItemCache2 = {};
	GOTUtil.formItemCache = {};
	exports.default = GOTUtil;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ServiceHelper = function () {
		function ServiceHelper() {
			_classCallCheck(this, ServiceHelper);
		}
	
		_createClass(ServiceHelper, null, [{
			key: 'addTokenWithCommand',
			value: function addTokenWithCommand(options) {
				var defaults = {
					command: null, resultFunction: null, sync: true, faultFunction: null, autoLock: true,
					autoUnlock: true, localLock: true, autoCreateGongqiSession: true, _ishttps: false, logArgs: null,
					_iszhiding: false, fixCallFaultFunc: false, successIngnoreStatus: false, lockText: "系统正在拉取数据 请稍后..."
				};
	
				Object.assign(defaults, options);
				if (defaults.command) defaults.command.requestUUID = _CommonUtil2.default.guid();
				var obj = void 0;
				var userInfos = void 0;
				try {
					userInfos = window.userInfos || window.parent.window.userInfos;
				} catch (e) {
					//如果是跨域 如外链应用 需要自动登录 则该接口日志记录不需要用户信息 自动登录完成以后  window.userInfos自然会获取用户信息
				}
				if (!userInfos) userInfos = {};
				if (defaults.command && userInfos) {
					if (!(defaults.command.classType == "service" && defaults.command.className == "gongqi.erp.framework.services.ClientLoggingService" && defaults.command.methodName == "saveLog")) {
						var command = defaults.command;
						obj = { remoteClass: "java.util.Map" };
						obj.requestId = command.requestUUID;
						obj.dataArea = userInfos.subSysId;
						obj.userId = userInfos.userId;
						obj.userName = userInfos.userName;
						obj.clientSessionId = userInfos.userSessionId;
						obj.startDateTime = new Date().getTime();
						obj.classType = command.classType;
						obj.className = command.className;
						obj.methodName = command.methodName;
						obj.remark = command.logArgs && command.logArgs.length > 0 ? JSON.stringify(command.logArgs) : "";
					}
				}
	
				var url = void 0;var domain = window.didomain;
				var loginToken = window.loginToken;
				var loginDataArea = window.loginDataArea;
				try //zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
				{
					if (!domain && window.parent && window.parent.window) domain = window.parent.window.didomain;
					if (domain) url = "/GongqiERP/" + domain + "/ServiceController";else url = "/GongqiERP/ServiceController";
	
					if (window.parent && window.parent.window) {
						if (!loginToken) loginToken = window.parent.window.loginToken;
						if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
					}
				} catch (e) {
					url = "/GongqiERP/ServiceController";
				}
	
				var cache = [];
				var data = JSON.stringify(defaults.command, function (key, value) {
					if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
						if (cache.indexOf(value) !== -1) {
							// Circular reference found, discard key
							var valueCpy = {};
							for (var innerKey in value) {
								//alert(typeof(value[innerKey]));
								if (_typeof(value[innerKey]) != "object") {
									valueCpy[innerKey] = value[innerKey];
								}
							}
							/*JSON.parse(JSON.stringify(value,function(key,value){
	      	if(innerCache.indexOf(value) !== -1)
	      	{
	      			}
	      	return;
	      }));*/
							return valueCpy;
						}
						// Store value in our collection
						cache.push(value);
					}
					return value;
				});
				cache = null; // Enable garbage collection
	
				//let data = JSON.stringify(command);
				var postdata = { request: data };
				var resultType = "json";
				return _AjaxRemoteUtil2.default.ajaxPost(url, postdata, resultType, defaults.sync, defaults.resultFunction, defaults.faultFunction, defaults.successIngnoreStatus, {
					autoLock: defaults.autoLock, autoUnlock: defaults.autoUnlock, localLock: defaults.localLock,
					lockText: defaults.lockText, logArg: obj, domain: domain, loginToken: loginToken, loginDataArea: loginDataArea
				});
			}
		}, {
			key: 'addTokenWithCommand2',
			value: function addTokenWithCommand2(options) {
				var defaults = {
					command: null, resultFunction: null, sync: true, faultFunction: null, autoLock: true,
					autoUnlock: true, localLock: true, autoCreateGongqiSession: true, _ishttps: false, logArgs: null,
					_iszhiding: false, fixCallFaultFunc: false, successIngnoreStatus: false, lockText: "系统正在拉取数据 请稍后...", relativeUrl: false
				};
	
				Object.assign(defaults, options);
				if (defaults.command) defaults.command.requestUUID = _CommonUtil2.default.guid();
				var obj = void 0;
				var userInfos = void 0;
				try {
					userInfos = window.userInfos || window.parent.window.userInfos;
				} catch (e) {
					//如果是跨域 如外链应用 需要自动登录 则该接口日志记录不需要用户信息 自动登录完成以后  window.userInfos自然会获取用户信息
				}
				if (!userInfos) userInfos = {};
				if (defaults.command && userInfos) {
					if (!(defaults.command.classType == "service" && defaults.command.className == "gongqi.erp.framework.services.ClientLoggingService" && defaults.command.methodName == "saveLog")) {
						var command = defaults.command;
						obj = { remoteClass: "java.util.Map" };
						obj.requestId = command.requestUUID;
						obj.dataArea = userInfos.subSysId;
						obj.userId = userInfos.userId;
						obj.userName = userInfos.userName;
						obj.clientSessionId = userInfos.userSessionId;
						obj.startDateTime = new Date().getTime();
						obj.classType = command.classType;
						obj.className = command.className;
						obj.methodName = command.methodName;
						obj.remark = command.logArgs && command.logArgs.length > 0 ? JSON.stringify(command.logArgs) : "";
					}
				}
	
				var url = options.url;
				var loginToken = window.parent.loginToken;
				var loginDataArea = window.parent.loginDataArea;
				var domain = void 0;
				var cache = [];
				var data = JSON.stringify(defaults.command, function (key, value) {
					if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
						if (cache.indexOf(value) !== -1) {
							// Circular reference found, discard key
							var valueCpy = {};
							for (var innerKey in value) {
								//alert(typeof(value[innerKey]));
								if (_typeof(value[innerKey]) != "object") {
									valueCpy[innerKey] = value[innerKey];
								}
							}
	
							return valueCpy;
						}
						cache.push(value);
					}
					return value;
				});
				cache = null;
	
				var postdata = { request: data };
				var resultType = "json";
				return _AjaxRemoteUtil2.default.ajaxPost2(url, postdata, resultType, defaults.sync, defaults.resultFunction, defaults.faultFunction, defaults.successIngnoreStatus, {
					autoLock: defaults.autoLock, autoUnlock: defaults.autoUnlock, localLock: defaults.localLock,
					lockText: defaults.lockText, logArg: obj, loginToken: loginToken, loginDataArea: loginDataArea, relativeUrl: true, domain: options.domain, shortName: options.shortdomain
				});
			}
		}, {
			key: 'call',
			value: function call(className, methodName, returnType, result_Handler, sync, fault_Handler) {
	
				var command = _Command2.default.createService(className, methodName, returnType);
	
				for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
					args[_key - 6] = arguments[_key];
				}
	
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var arg = _step.value;
	
						command.appendArg(arg);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				var remoteArg = { command: command, resultFunction: result_Handler, sync: sync, faultFunction: fault_Handler };
				ServiceHelper.addTokenWithCommand(remoteArg);
			}
		}]);
	
		return ServiceHelper;
	}();
	
	exports.default = ServiceHelper;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOTUtil = __webpack_require__(268);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GOT = function () {
		function GOT() {
			_classCallCheck(this, GOT);
		}
	
		_createClass(GOT, null, [{
			key: "getForm",
			value: function getForm(formId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var forms = _parentWindow.got.DataDictionary.Forms;
					for (var i in forms) {
						var form = forms[i];
						if (form.id == formId || form.name == formId) return form;
					}
				}
				return null;
			}
		}, {
			key: "setForm",
			value: function setForm(form) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var forms = _parentWindow.got.DataDictionary.Forms;
					if (forms == null)
						//_parentWindow.setFirstForm(form);
						_parentWindow.got.DataDictionary["Forms"] = [form];else forms.push(form);
				}
				return null;
			}
		}, {
			key: "deleteForm",
			value: function deleteForm(_id) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var forms = _parentWindow.got.DataDictionary.Forms;
					if (forms) {
						for (var i = 0; i < forms.length; i++) {
							var form = forms[i];
							if (form.id == _id) {
								forms.splice(i, 1);
							}
						}
					}
				}
			}
		}, {
			key: "getTable",
			value: function getTable(tableId) {
				var _parentWindow = window.parent.window;
				if (window.parent.window.formOSopenAllUniversal) {
					var gots = _parentWindow.doMainGot;
					for (var j in gots) {
						var tables = gots[j].got.DataDictionary.Tables;
						for (var i in tables) {
							var table = tables[i];
							if (table.id == tableId || table.name == tableId) return table;
						}
					}
				} else {
					if (_parentWindow) {
						var tables = _parentWindow.got.DataDictionary.Tables;
						for (var i in tables) {
							var table = tables[i];
							if (table.id == tableId || table.name == tableId) return table;
						}
					}
					return null;
				}
			}
		}, {
			key: "getdoMainTable",
			value: function getdoMainTable(tableId, domain) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var gots = _parentWindow.doMainGot;
					for (var j in gots) {
						if (domain && domain == gots[j].doMain) {
							var tables = gots[j].got.DataDictionary.Tables;
							for (var i in tables) {
								var table = tables[i];
								if (table.id == tableId || table.name == tableId) return table;
							}
						}
					}
				}
				return null;
			}
		}, {
			key: "getTableFieldById",
			value: function getTableFieldById(tableId, fieldId) {
				var table = GOT.getTable(tableId);
				if (!table) return null;
				var tableField = GOT.getTableField(table, fieldId);
				return tableField;
			}
		}, {
			key: "getdoMainTableFieldById",
			value: function getdoMainTableFieldById(tableId, fieldId, domain) {
				var table = GOT.getdoMainTable(tableId, domain);
				if (!table) return null;
				var tableField = GOT.getTableField(table, fieldId);
				return tableField;
			}
		}, {
			key: "getTableField",
			value: function getTableField(table, fieldId) {
				for (var i in table.TableFields) {
					var tableField = table.TableFields[i];
					if (tableField.id == fieldId || tableField.name == fieldId) return tableField;
				}
				return null;
			}
		}, {
			key: "getTableFieldComponentItems",
			value: function getTableFieldComponentItems(tableField) {
				var extendPro = tableField.Properties.Extends;
				if (extendPro.hasOwnProperty("refentityid")) {
					var refentityid = extendPro.refentityid;
					var compDataType = GOT.getDataType(refentityid);
					return compDataType.DataTypeArrayItems;
				}
				return null;
			}
		}, {
			key: "getTableIndex",
			value: function getTableIndex(table, innerid) {
				for (var i in table.TableIndexes) {
					var tableIndex = table.TableIndexes[i];
					if (tableIndex.id == innerid || tableIndex.name == innerid) return tableIndex;
				}
				return null;
			}
		}, {
			key: "getAutoTableFieldGroup",
			value: function getAutoTableFieldGroup(table) {
				var tableFieldGroups = table.TableFieldGroups.FieldGroups;
				for (var i in tableFieldGroups) {
					var tableFieldGroup = tableFieldGroups[i];
					if (tableFieldGroup.name == "AutoLookup") {
						return tableFieldGroup;
					}
				}
				return null;
			}
		}, {
			key: "getEnum",
			value: function getEnum(enumId) {
				var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				var _parentWindow = window.parent.window;
				if (!domain && window.parent.initDomain && !window.parent.TableCheckDoMain) {
					domain = window.parent.initDomain;
				} else if (!domain && window.parent.TableCheckDoMain) {
					domain = window.parent.TableCheckDoMain;
				}
				if (window.parent.window.formOSopenAllUniversal) {
					var gots = _parentWindow.doMainGot;
					for (var j in gots) {
						if (domain && gots[j].doMain == domain) {
							var enums = gots[j].got.DataDictionary.Enums;
							for (var i in enums) {
								var enumItem = enums[i];
								if (enumItem.id == enumId) return enumItem;
							}
						} else {
							var enums = gots[j].got.DataDictionary.Enums;
							for (var i in enums) {
								var enumItem = enums[i];
								if (enumItem.id == enumId) return enumItem;
							}
						}
					}
				} else {
					if (_parentWindow) {
						var enums = _parentWindow.got.DataDictionary.Enums;
						for (var i in enums) {
							var enumItem = enums[i];
							if (enumItem.id == enumId) return enumItem;
						}
					}
				}
				return null;
			}
		}, {
			key: "getDataType",
			value: function getDataType(dataTypeId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var dataTypes = _parentWindow.got.DataDictionary.DataTypes;
					for (var i in dataTypes) {
						var dataType = dataTypes[i];
						if (dataType.id == dataTypeId || dataType.name == dataTypeId) return dataType;
					}
				}
				return null;
			}
		}, {
			key: "getMenuItem",
			value: function getMenuItem(menuItemId) {
				var _parentWindow; //window.parent.window;
				if (window.got && window.got.MenuItems) _parentWindow = window;else _parentWindow = window.parent.window;
				if (_parentWindow) {
					var menuItems = _parentWindow.got.MenuItems;
					for (var i in menuItems) {
						var menuItem = menuItems[i]; //TODO GOT属性容错
						if (menuItem.id == menuItemId || menuItem.name == menuItemId) return menuItem;
					}
				}
				return null;
			}
		}, {
			key: "getMenu",
			value: function getMenu(menuId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var menus = _parentWindow.got.DataDictionary.Menus;
					for (var i in menus) {
						var menu = menus[i];
						if (menu.id == menuId || menu.name == menuId) return menu;
					}
				}
				return null;
			}
		}, {
			key: "getDataTypeArrayItem",
			value: function getDataTypeArrayItem(dataType, id) {
				for (var i in dataType.DataTypeArrayItems) {
					var dataTypeArrayItem = dataType.DataTypeArrayItems[i];
					if (dataTypeArrayItem.id == id || dataTypeArrayItem.name == id) return dataTypeArrayItem;
				}
				return null;
			}
		}, {
			key: "getFormDataSource",
			value: function getFormDataSource(form, innerid) {
				for (var i in form.FormDataSources.DataSources) {
					var formDataSource = form.FormDataSources.DataSources[i];
					if (formDataSource.id == innerid || formDataSource.name == innerid) return formDataSource;
				}
				return null;
			}
		}, {
			key: "getFormDataSourceField",
			value: function getFormDataSourceField(formDataSource, innerid) {
				var exname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
				var ingoreCase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
				for (var i in formDataSource.FormDataSourceFields) {
					var formDataSourceField = formDataSource.FormDataSourceFields[i];
					if (formDataSourceField.id == innerid || formDataSourceField.name == innerid) {
						return formDataSourceField;
					} else if (exname) {
						if (ingoreCase == false) {
							if (formDataSourceField.id == exname || formDataSourceField.name == exname) return formDataSourceField;
						} else {
							var keyid = _StringUtil2.default.convertToAllLowerCase(formDataSourceField.id);
							var keyname = _StringUtil2.default.convertToAllLowerCase(formDataSourceField.name);
							exname = _StringUtil2.default.convertToAllLowerCase(exname);
							if (keyid == exname || keyname == exname) {
								return formDataSourceField;
							}
						}
					}
				}
				return null;
			}
		}, {
			key: "getFormDataSourceFieldByName",
			value: function getFormDataSourceFieldByName(form, dataSource, dataSourceField) {
				var dss = form.FormDataSources.DataSources;
				for (var i = 0; i < dss.length; i++) {
					var ds = dss[i];
					if (ds.name == dataSource) break;
				}
	
				if (ds) {
					return GOT.getFormDataSourceField(ds, dataSourceField);
				}
			}
		}, {
			key: "getTableFieldGroup",
			value: function getTableFieldGroup(table, id) {
				var fieldGroups = table.TableFieldGroups.FieldGroups;
				for (var i in fieldGroups) {
					var fieldGroup = fieldGroups[i];
					if (fieldGroup.id == id || fieldGroup.name == id) return fieldGroup;
				}
				return null;
			}
		}, {
			key: "getTableIndex",
			value: function getTableIndex(table, id) {
				var indexes = table.TableIndexes.Indexes;
				for (var i in indexes) {
					var tableIndex = indexes[i];
					if (tableIndex.id == id || tableIndex.name == id) return tableIndex;
				}
				return null;
			}
		}, {
			key: "getDataTypeRelationNormalItem",
			value: function getDataTypeRelationNormalItem(dataTypeRelation) {
				for (var i in dataTypeRelation.DataTypeRelationItems) {
					var _dataTypeRelationItem = dataTypeRelation.DataTypeRelationItems[i];
					if (_dataTypeRelationItem.type == "Normal") return _dataTypeRelationItem;
				}
				var fieldPro = _GOTUtil2.default.getProperty(dataTypeRelation, "Field");
				if (!fieldPro) return null;
				var dataTypeRelationItem = { Properties: {
						Field: fieldPro
					}
				};
				return dataTypeRelationItem;
			}
		}, {
			key: "getDataTypeRelationFixedItem",
			value: function getDataTypeRelationFixedItem(dataTypeRelation) {
				var fixedItems = [];
				for (var i in dataTypeRelation.DataTypeRelationItems) {
					var dataTypeRelationItem = dataTypeRelation.DataTypeRelationItems[i];
					if (dataTypeRelationItem.type == "Fixed") fixedItem.push(dataTypeRelationItem);
				}
				return fixedItems;
			}
		}, {
			key: "getFormItem",
			value: function getFormItem(form, id) {
				var formItems = form.FormDesign.FormItem;
				for (var i in formItems) {
					var item = formItems[i];
					if (item.id == id || item.name == id) return item;
					var result = GOT.getFormItemByFormItem(item, id);
					if (result != null) return result;
				}
				return null;
			}
		}, {
			key: "getFormItemByFormItem",
			value: function getFormItemByFormItem(formItem, id) {
				for (var i in formItem.FormItem) {
					var item = formItem.FormItem[i];
					if (item.id == id || item.name == id) return item;
					var result = GOT.getFormItemByFormItem(item, id);
					if (result != null) return result;
				}
				return null;
			}
		}, {
			key: "descendantsFormItemJsonType",
			value: function descendantsFormItemJsonType(jo, type, result) {
				if (!result) result = [];
				if (jo.type && jo.type.indexOf(type) != -1) {
					result.push(jo);
				} else if (jo.FormItem) {
					for (var i = 0; i < jo.FormItem.length; i++) {
						var item = jo.FormItem[i];
						GOT.descendantsJson(item, type, result);
					}
				}
			}
		}, {
			key: "descendantsJson",
			value: function descendantsJson(jo, qname, result) {
				if (!result) result = [];
				if (jo.qname == qname) {
					result.push(jo);
				} else if (jo.items) {
					for (var i = 0; i < jo.items.length; i++) {
						var item = jo.items[i];
						GOT.descendantsJson(item, qname, result);
					}
				}
			}
		}, {
			key: "descendantsMainMenu",
			value: function descendantsMainMenu(jo, qname, id, menuId) {
				if (jo.qname == qname && jo.id == id) {
					if (qname == "MenuItem") {
						jo.entityId = menuId;
					}
					return jo;
				} else if (jo.items) {
					for (var i = 0; i < jo.items.length; i++) {
						var item = jo.items[i];
						var _menuId = menuId;
						//TODO 由于MainMenu下面的Menu无明确标识 而主菜单开发时结构判断逻辑不严谨又不能加入qname
						//所以 暂时先这样判断其实Menu
						if (!item.hasOwnProperty("qname") && item.hasOwnProperty("version")) {
							_menuId = item.id;
						}
						var result = GOT.descendantsMainMenu(item, qname, id, _menuId);
						if (result) return result;
					}
				}
				return null;
			}
		}, {
			key: "getMainMenuMenuItemById",
			value: function getMainMenuMenuItemById(mainMenu, id) {
				if (mainMenu.qname == "MenuItem" && mainMenu.id == id) return mainMenu;
				if (mainMenu.items) {
					for (var i = 0; i < mainMenu.items.length; i++) {
						var item = mainMenu.items[i];
						var result = GOT.getMainMenuMenuItemById(item, id);
						if (result) return result;
					}
				}
				return null;
			}
		}, {
			key: "getComponentItems",
			value: function getComponentItems(tableField) {
				var extendPro = _GOTUtil2.default.getProperty(tableField, "Extends");
				if (extendPro.hasOwnProperty("refentityid")) {
					var compDataType = GOT.getDataType(extendPro.refentityid);
					return compDataType.DataTypeArrayItems;
				}
				return null;
			}
		}]);
	
		return GOT;
	}();
	
	GOT.INDEP_FORM_ID = "60000000";
	exports.default = GOT;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['focusChange', 'focusSet', 'currentGroupSet', 'currentGroupGet', 'afterNewRecordDataGridFocusSet', 'switchToCurrentSetSelect', 'notifyDataGridCurrentGroup', 'holdFocusIn', 'afterActiveRecord', 'scrollToAndFocus', 'clearSigned', 'globalClick']);

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _CommandArg = __webpack_require__(156);
	
	var _CommandArg2 = _interopRequireDefault(_CommandArg);
	
	var _FormParam = __webpack_require__(163);
	
	var _FormParam2 = _interopRequireDefault(_FormParam);
	
	var _ContextMapArg = __webpack_require__(253);
	
	var _ContextMapArg2 = _interopRequireDefault(_ContextMapArg);
	
	var _ArgCallerType = __webpack_require__(58);
	
	var _ArgCallerType2 = _interopRequireDefault(_ArgCallerType);
	
	var _CommandArgGroupInfo = __webpack_require__(252);
	
	var _CommandArgGroupInfo2 = _interopRequireDefault(_CommandArgGroupInfo);
	
	var _DialogForm = __webpack_require__(168);
	
	var _DialogForm2 = _interopRequireDefault(_DialogForm);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _RecordsUtil = __webpack_require__(64);
	
	var _RecordsUtil2 = _interopRequireDefault(_RecordsUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _FormParamCondition = __webpack_require__(254);
	
	var _FormParamCondition2 = _interopRequireDefault(_FormParamCondition);
	
	var _TimerTasksUtil = __webpack_require__(288);
	
	var _TimerTasksUtil2 = _interopRequireDefault(_TimerTasksUtil);
	
	var _FormDataSourceGroupArg = __webpack_require__(140);
	
	var _FormDataSourceGroupArg2 = _interopRequireDefault(_FormDataSourceGroupArg);
	
	var _FocusController = __webpack_require__(106);
	
	var _FocusController2 = _interopRequireDefault(_FocusController);
	
	var _RemotePasteDialog = __webpack_require__(174);
	
	var _RemotePasteDialog2 = _interopRequireDefault(_RemotePasteDialog);
	
	var _LayerManager = __webpack_require__(51);
	
	var _LayerManager2 = _interopRequireDefault(_LayerManager);
	
	var _Attachment = __webpack_require__(111);
	
	var _Attachment2 = _interopRequireDefault(_Attachment);
	
	var _ResizeActions = __webpack_require__(53);
	
	var _ResizeActions2 = _interopRequireDefault(_ResizeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandResolver = function () {
		function CommandResolver() {
			_classCallCheck(this, CommandResolver);
		}
	
		_createClass(CommandResolver, null, [{
			key: 'getParentFormModule',
			value: function getParentFormModule(calleruuId) {
				var parentFormModuleObj = {};
				$("#g_tab_content .tab-pane iframe", window.parent.document).each(function () {
					var iframeSrc = this.src;
					if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
						return true;
					}
					if (this.contentWindow.formModuleInstanceuuId == calleruuId) {
						parentFormModuleObj.parentFormModule = this.contentWindow.formModuleInstance;
						parentFormModuleObj.window = this.contentWindow;
						return false;
					}
				});
				if (parentFormModuleObj.parentFormModule) return parentFormModuleObj;
				var popIframes = $("#formModal iframe", window.parent.document);
				for (var i = 0; i < popIframes.length; i++) {
					var iframe = popIframes.get(i);
					var iframeSrc = iframe.src;
					if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
						continue;
					}
					if (iframe.contentWindow.formModuleInstanceuuId == calleruuId) {
						parentFormModuleObj.parentFormModule = iframe.contentWindow.formModuleInstance;
						parentFormModuleObj.window = iframe.contentWindow;
					}
				}
	
				return parentFormModuleObj;
			}
		}, {
			key: 'getFormParam',
			value: function getFormParam(formModule, defaultGroupAlias) {
				var formParam = new _FormParam2.default();
				var isForLookup = formModule.classAlias == "FormModuleLookup";
				formParam.menuItemId = isForLookup ? "FormLookup" : window.menuItemId;
				formParam.formId = formModule.props.formId;
				var argCaller = isForLookup ? formModule.props.argCaller : window.argCaller;
				if (argCaller) {
					formParam.callerFormId = argCaller.callerFormId;
					formParam.callerMenuItemId = argCaller.callerMenuItemId;
					formParam.callerType = argCaller.callerType;
					formParam.callerKey = argCaller.callerKey;
	
					formParam.joinTableAlias = argCaller.joinGroupAlias;
					formParam.joinTableName = argCaller.joinTableName;
	
					formParam.paramString = argCaller.parameters;
					formParam.paramObject = argCaller.paramObject;
					if (formParam.paramObject && _typeof(formParam.paramObject) == "object") {
						formParam.paramObject = Object.assign({ remoteClass: "java.util.Map" }, formParam.paramObject);
					}
					//if(argCaller.type==ArgCallerType.StringEditor)
					//{
					//TODO 下拉指定画面时 要存入当前current(3)的CommandArg到sessionStorage
					//key为menuItemId+formId
					if (argCaller.calleruuId) {
						var parentModuleObj = CommandResolver.getParentFormModule(argCaller.calleruuId);
						var parentModule = parentModuleObj.parentFormModule;
						if (parentModule) {
							var parentMethodinfo = { remoteClass: "gongqi.erp.gotmodel.form.remote.CommandArgMethodInfo" };
							parentMethodinfo.fetchOption = true;
							if (argCaller.commandArgInfo) {
								parentMethodinfo.groups = argCaller.commandArgInfo;
							} else {
								parentMethodinfo.groups = "all(4)";
							}
							parentMethodinfo.editors = "all";
							parentMethodinfo.joinGroup = "yes";
							defaultGroupAlias = null;
							if (parentModule.formDataSources && parentModule.formDataSources.currentGroup) {
								defaultGroupAlias = parentModule.formDataSources.currentGroup.groupAlias;
							}
							var parentArg = parentModuleObj.window.getSendCmd(parentModule, defaultGroupAlias, parentMethodinfo);
	
							//CommandResolver.getSendCmd(parentModule,defaultGroupAlias,parentMethodinfo,parentModuleObj.window);
							formParam.callerCommandArg = parentArg;
						}
	
						if (argCaller.type == _ArgCallerType2.default.StringEditor) formParam.callerLookupField = argCaller.callerDataField;
					}
	
					//}
				}
	
				return formParam;
			}
		}, {
			key: 'numToReg',
			value: function numToReg(num, _group, formModule, arg) {
				var isJoinGroup = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
				if (_group == null) return;
				if (num == "0") {
					CommandResolver.regCmdArgGroup(formModule, arg, _group, isJoinGroup, false, false, false, false, false);
				} else if (num == "1") {
					CommandResolver.regCmdArgGroup(formModule, arg, _group, isJoinGroup, true, false, false, false, false);
				} else if (num == "2") {
					CommandResolver.regCmdArgGroup(formModule, arg, _group, isJoinGroup, true, true, false, false, false);
				} else if (num == "3") {
					CommandResolver.regCmdArgGroup(formModule, arg, _group, isJoinGroup, true, false, false, true, true);
				} else if (num == "4") {
					CommandResolver.regCmdArgGroup(formModule, arg, _group, isJoinGroup, true, true, false, true, true);
				} else {
					var nums = num.split(",");
					var currentRecord = false;
					var selectedsRecords = false;
					var allRecords = false;
					var currentQuery = false;
					var formQuery = false;
	
					if (nums.indexOf("cr") != -1) {
						currentRecord = true;
					}
					if (num.indexOf("sr") != -1) {
						selectedsRecords = true;
					}
					if (num.indexOf("ar") != -1) {
						allRecords = true;
					}
					if (num.indexOf("cq") != -1) {
						currentQuery = true;
					}
					if (num.indexOf("fq") != -1) {
						formQuery = true;
					}
	
					CommandResolver.regCmdArgGroup(formModule, arg, _group, isJoinGroup, currentRecord, selectedsRecords, allRecords, currentQuery, formQuery);
				}
			}
		}, {
			key: 'regCmdArgGroup',
			value: function regCmdArgGroup(formModule, arg, _group, isJoinGroup, currentRecord, selectedRecords, allRecords, currentQuery, formQuery) {
				if (_group == null) return;
				var gi = new _CommandArgGroupInfo2.default();
				if (isJoinGroup == true) arg.joinGroup = gi;else arg.mapGroups[_group.groupAlias] = gi;
	
				gi.formId = formModule.classAlias == "FormModuleLookup" ? formModule.props.formId : window.formId;
				gi.groupAlias = _group.groupAlias;
				gi.mainSourceTableName = _group.tableName;
				if (window.lastEditedDataFields) {
					gi.currentDataField = window.lastEditedDataFields[_group.groupAlias];
				}
	
				if (currentRecord) {
					var _currentRecord = { remoteClass: "java.util.HashMap" };
					var hasSecond = false;
					for (var _i = 0; _i < _group.sources.length; _i++) {
						var sourceName = _group.sources[_i].sourceName;
						var secondRec = _RecordsUtil2.default.getSecondaryRecord(_group.currentRecord, sourceName);
						if (secondRec) hasSecond = true;
						_currentRecord[sourceName] = secondRec;
					}
					gi.currentRecord = hasSecond ? _currentRecord : null;
				}
	
				// TODO 对于不在同画面的关联数据源 joinGroup中dataProvider的处理待定 有可能取消 因为
				// 只在浮动式下比较有意义
				if (selectedRecords) {
					var _selectRecordsKeys = [];
					_CommandActions2.default.getSelectRecordsKey(_selectRecordsKeys, _group.groupAlias, formModule.menuItemId, formModule.formId, formModule.instanceUUId);
					var _selectRecordsKey = _selectRecordsKeys.length > 0 ? _selectRecordsKeys[0] : null;
	
					if (_selectRecordsKey) {
						gi.selectedRecords = [];gi.hasColumnAsSysSelectRecords = true;
						for (var i = 0; i < _group.records.length; i++) {
							var item = _group.records[i];
							var value = item[_selectRecordsKeys];
							if (value == true || value == "true") {
	
								var _currentRecord2 = { remoteClass: "java.util.HashMap" };
								for (var _i2 = 0; _i2 < _group.sources.length; _i2++) {
									var _sourceName = _group.sources[_i2].sourceName;
									_currentRecord2[_sourceName] = _RecordsUtil2.default.getSecondaryRecord(item, _sourceName);
								}
								gi.selectedRecords.push(_currentRecord2);
							}
						}
					} else {
						var _selectedRecords = [];
						_CommandActions2.default.getSelectRecords(_selectedRecords, _group.groupAlias, formModule.instanceUUId);
						var _remoteClassRecords = [];
						for (var _i3 = 0; _i3 < _selectedRecords.length; _i3++) {
							var _record = _selectedRecords[_i3];
							if (!_record) continue;
							var _currentRecord3 = { remoteClass: "java.util.HashMap" };
	
							for (var _i4 = 0; _i4 < _group.sources.length; _i4++) {
								var sourceName = _group.sources[_i4].sourceName;
								var _secondRec = _RecordsUtil2.default.getSecondaryRecord(_record, sourceName);
								_currentRecord3[sourceName] = _secondRec;
							}
							_remoteClassRecords.push(_currentRecord3);
						}
	
						gi.selectedRecords = _remoteClassRecords; //.length==0?null:_remoteClassRecords;
					}
				}
	
				if (allRecords) {
					var _remoteClassRecords2 = [];
					if (_group.records) {
						for (var key in _group.records) {
							var _record2 = _group.records[key];
							var _currentRecord4 = { remoteClass: "java.util.HashMap" };
	
							for (var _i5 = 0; _i5 < _group.sources.length; _i5++) {
								var sourceName = _group.sources[_i5].sourceName;
								_currentRecord4[sourceName] = _RecordsUtil2.default.getSecondaryRecord(_record2, sourceName);
							}
	
							_remoteClassRecords2.push(_currentRecord4);
						}
	
						gi.allRecords = _remoteClassRecords2.length == 0 ? null : _remoteClassRecords2;
					} else {
						gi.allRecords = null;
					}
				}
	
				if (currentQuery) {
					//alert("currentQuery  1");
					gi.currentQuery = _group.getCurrentQueryTable();
					if (gi.currentQuery) {
						//alert("currentQuery  2");
						gi.currentQuery.parentProperty = null;
						gi.currentQuery.queryRelations = null;
					}
				}
	
				if (formQuery) {
					gi.formQuery = _QueryUtil2.default.convertXML2QueryTable(_group.formQuery);
					if (gi.formQuery) {
						gi.formQuery.parentProperty = null;
						gi.formQuery.queryRelations = null;
					}
				}
	
				//TODOcalcHasColumnAsSysSelectRecords(gi, _group, formDesign);
			}
		}, {
			key: 'getSendCmd',
			value: function getSendCmd(formModule, defaultGroupAlias, argInfo) {
				var parms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	
				if (argInfo == null || !parms.ignoreFetchOption && argInfo.fetchOption == false) return null;
				var arg = new _CommandArg2.default();
	
				arg.formParam = CommandResolver.getFormParam(formModule, defaultGroupAlias);
				arg.contextMap = formModule.contextMap;
	
				arg.argObject = null; //在plugin二次开发时会传入plugin中指定的obj
				arg.defaultGroupAlias = defaultGroupAlias;
	
				arg.mapGroups = {};
				var _fds = formModule.formDataSources;
	
				var list;
				if (parms.ignoreFetchOption == true && argInfo.groups == null) argInfo.groups = "current(3)";
				if (argInfo.groups != null) {
					var s = _StringUtil2.default.trimThrough(argInfo.groups);
					var _group;
	
					if (s.indexOf("current") == 0) {
						if (_fds != null) {
							if (defaultGroupAlias != null) _group = _fds.groups[defaultGroupAlias];
							if (_group == null) _group = _fds.firstGroup;
						}
	
						var num;
	
						if (_fds != null) {
							if (s.indexOf("(") != -1) {
								num = s.substring(s.indexOf("(") + 1, s.indexOf(")"));
								CommandResolver.numToReg(num, _group, formModule, arg, false);
							} else {
								CommandResolver.numToReg("2", _group, formModule, arg, false);
							}
						}
					} else if (s.indexOf("all") == 0) {
						if (formModule.formDataSources != null) {
							for (var key in formModule.formDataSources.groups) {
								var _group = formModule.formDataSources.groups[key];
								if (s.indexOf("(") != -1) {
									num = s.substring(s.indexOf("(") + 1, s.indexOf(")"));
									CommandResolver.numToReg(num, _group, formModule, arg, false);
								} else {
									CommandResolver.numToReg("2", _group, formModule, arg, false);
								}
							}
						}
					} else if (s == "none") {
						arg.mapGroups = null;
					} else {
						if (formModule.formDataSources != null) {
							var groupAlias;
							if (s.indexOf("(") != -1) {
								num = s.substring(s.indexOf("(") + 1, s.indexOf(")"));
								groupAlias = s.substring(0, s.indexOf("("));
							} else {
								num = "2";
								groupAlias = s;
							}
	
							if (formModule.formDataSources.groups != null) _group = formModule.formDataSources.groups[groupAlias];
	
							CommandResolver.numToReg(num, _group, formModule, arg, false);
						}
					}
				}
	
				if (argInfo.editors == null) list = [];else list = _StringUtil2.default.trimThrough(argInfo.editors).split(",");
				arg.mapEditors = {};
				for (var i = 0; i < list.length; i++) {
					var s = list[i];
					if (s == "all") {
						_CommandActions2.default.commandArgMapEditors("all", arg.mapEditors, formModule.instanceUUId);
					} else if (s == "none") {
						arg.mapEditors = null;
					} else {
						if (s == "") //后台代码中有editor=""这种写法 会导致解析报错
							continue;
						_CommandActions2.default.commandArgMapEditors(s, arg.mapEditors, formModule.instanceUUId);
					}
				}
	
				s = argInfo.joinGroup;
				if (s != null && s.indexOf("yes") == 0) {
					var _argCaller = window.argCaller;
					if (_argCaller && _argCaller.joinGroupAlias != "" && _argCaller.joinGroupAlias) {
						var _parentWindow = window.parent.window;
						var _joinGroup = _parentWindow.getJoinGroupObject(_argCaller.joinGroupAlias, _argCaller.calleruuId);
						//var joinGroupObject = {groupAlias:_argCaller.joinGroupAlias,tableName:_argCaller.joinTableName,currentRecord:_argCaller.joinRecord};
						if (s.indexOf("(") != -1) {
							//不支持joinGroup的records及query
							num = s.substring(s.indexOf("(") + 1, s.indexOf(")"));
							CommandResolver.numToReg("1", _joinGroup, formModule, arg, true);
						} else {
							CommandResolver.numToReg("1", _joinGroup, formModule, arg, true);
						}
					} else {
						if (defaultGroupAlias != null && _fds) _group = _fds.groups[defaultGroupAlias];
						if (_group == null && _fds) _group = _fds.firstGroup;
						if (_group && _group.linkGroup) {
							if (s.indexOf("(") != -1) {
								num = s.substring(s.indexOf("(") + 1, s.indexOf(")"));
								CommandResolver.numToReg(num, _group.linkGroup, formModule, arg, true);
							} else {
								CommandResolver.numToReg("1", _group.linkGroup, formModule, arg, true);
							}
						}
					}
				}
				return arg;
			}
		}, {
			key: 'getTaskGroup',
			value: function getTaskGroup(task, fm) {
				if (task == null || fm == null || fm.formDataSources == null) return null;
	
				if (task.group != null) var group = fm.formDataSources.groups[task.group];
	
				if (group == null) group = fm.formDataSources.firstGroup;
	
				return group;
			}
		}, {
			key: 'doResolveTask',
			value: function doResolveTask(task, formModule, tasks) {
				switch (task.cmd) {
					case _Cmd2.default.ExecuteQuery:
						{
	
							CommandResolver.doExecuteQuery(task.group, formModule, CommandResolver.getTaskGroup(task, formModule), tasks, task);
	
							return;
						}
					case _Cmd2.default.FadeInfo:
						{
							if (typeof task.arg == "string") {
								if (window.fadeInfo) window.fadeInfo({ text: task.arg });else window.parent.window.fadeInfo({ text: task.arg });
							} else if (_typeof(task.arg) == "object") {
								task.arg.backgroundColor = task.arg.bgColor;task.arg.text = task.arg.label;task.arg.color = task.arg.labelColor;
								if (window.fadeInfo) window.fadeInfo({ text: task.arg });else window.parent.window.fadeInfo(task.arg);
							}
							var task2 = tasks.shift();
							if (task2) CommandResolver.doResolveTask(task2, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateControlAllowEdit:
						{
							CommandResolver.updateControlAllowEdit(task, formModule);
							var _task2 = tasks.shift();
							if (_task2) CommandResolver.doResolveTask(_task2, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateControlVisible:
						{
							CommandResolver.updateControlVisible(task, formModule);
							var _task3 = tasks.shift();
							if (_task3) CommandResolver.doResolveTask(_task3, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateControlLabel:
						{
							CommandResolver.updateControlLabel(task, formModule);
							var _task4 = tasks.shift();
							if (_task4) CommandResolver.doResolveTask(_task4, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateControlShowDecimal:
						{
							CommandResolver.updateControlShowDecimal(task, formModule);
							var _task5 = tasks.shift();
							if (_task5) CommandResolver.doResolveTask(_task5, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateControlSkipTab:
						{
							CommandResolver.updateControlSkipTab(task, formModule);
							var _task6 = tasks.shift();
							if (_task6) CommandResolver.doResolveTask(_task6, formModule, tasks);
							return;
						}
					case "lookupRefresh":
						//服务端CommandTaskCMD中不需要出现，所以写死字符串
						{
							CommandResolver.doLookupRefresh(task, formModule);
							var _task7 = tasks.shift();
							if (_task7) CommandResolver.doResolveTask(_task7, formModule, tasks);
							return;
						}
					case _Cmd2.default.LookupReturn:
						{
							CommandResolver.lookupReturn(task, formModule);
							var _task8 = tasks.shift();
							if (_task8) CommandResolver.doResolveTask(_task8, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateEditorShowLookup:
						{
							CommandResolver.updateEditorShowLookup(task, formModule);
							var _task9 = tasks.shift();
							if (_task9) CommandResolver.doResolveTask(_task9, formModule, tasks);
							return;
						}
					case _Cmd2.default.FormCmd:
						{
							CommandResolver.formCmd(task, formModule, tasks);
							var _task10 = tasks.shift();
							if (_task10) CommandResolver.doResolveTask(_task10, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateQueryForm:
						{
							CommandResolver.changeQuery(task, CommandResolver.getTaskGroup(task, formModule), formModule);
							var _task11 = tasks.shift();
							if (_task11) CommandResolver.doResolveTask(_task11, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateQueryCurrent:
						{
							CommandResolver.changeQuery(task, CommandResolver.getTaskGroup(task, formModule), formModule);
							var _task12 = tasks.shift();
							if (_task12) CommandResolver.doResolveTask(_task12, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateQuery:
						{
							CommandResolver.changeQuery(task, CommandResolver.getTaskGroup(task, formModule), formModule);
							CommandResolver.doExecuteQuery(task.group, formModule, CommandResolver.getTaskGroup(task, formModule), tasks, task);
							return;
						}
					case _Cmd2.default.RefreshPlugin:
						{
							CommandResolver.doRefreshPlugin(task, formModule);
							var _task13 = tasks.shift();
							if (_task13) CommandResolver.doResolveTask(_task13, formModule, tasks);
							return;
						}
					case _Cmd2.default.TmpRecordAdd:
						{
							CommandResolver.addTempRecord(task, formModule);
							var _task14 = tasks.shift();
							if (_task14) CommandResolver.doResolveTask(_task14, formModule, tasks);
							return;
						}
					case _Cmd2.default.TmpRecordClear:
						{
							CommandResolver.clearTempRecord(task, formModule);
							var _task15 = tasks.shift();
							if (_task15) CommandResolver.doResolveTask(_task15, formModule, tasks);
							return;
						}
					case _Cmd2.default.TmpRecordRefresh:
						{
							CommandResolver.refreshTempRecord(task, formModule);
							var _task16 = tasks.shift();
							if (_task16) CommandResolver.doResolveTask(_task16, formModule, tasks);
							return;
						}
					case _Cmd2.default.WriteEditor:
					case _Cmd2.default.WriteImage:
						{
							CommandResolver.writeControl(task, formModule);
							var _task17 = tasks.shift();
							if (_task17) CommandResolver.doResolveTask(_task17, formModule, tasks);
							return;
						}
					case _Cmd2.default.DoWriteEditor:
						{
							CommandResolver.doWriteControl(task, formModule);
							var _task18 = tasks.shift();
							if (_task18) CommandResolver.doResolveTask(_task18, formModule, tasks);
							return;
						}
					case _Cmd2.default.ButtonOk:
						{
							window.remainTasks = tasks;
							CommandResolver.doRemoteButtonOk(task, formModule);
							return;
						}
					case _Cmd2.default.OpenForm:
					case _Cmd2.default.OpenMainForm:
						{
							CommandResolver.openForm(task, formModule);
							var _task19 = tasks.shift();
							if (_task19) CommandResolver.doResolveTask(_task19, formModule, tasks);
							return;
						}
					case _Cmd2.default.OpenSubForm:
						{
							CommandResolver.openSubForm(task, formModule);
							var _task20 = tasks.shift();
							if (_task20) CommandResolver.doResolveTask(_task20, formModule, tasks);
							return;
						}
					case _Cmd2.default.RestoreParent:
						{
							var _result = CommandResolver.restoreParent(task, formModule, tasks);
							if (!_result) {
								var _task21 = tasks.shift();
								if (_task21) CommandResolver.doResolveTask(_task21, formModule, tasks);
							}
							return;
						}
					case _Cmd2.default.ParentCmdResult:
						{
							CommandResolver.exeParentCmdResult(task, formModule);
							var _task22 = tasks.shift();
							if (_task22) CommandResolver.doResolveTask(_task22, formModule, tasks);
							return;
						}
					case _Cmd2.default.OpenResource:
						{
							var _url = task.arg;
							if (_url) {
								_url = _CommonUtil2.default.calcResourcePath(_url);
								var n = _url.length > 20 ? _url.substr(0, 20) : _url;
	
								window.open(_url, n);
							}
							var _task23 = tasks.shift();
							if (_task23) CommandResolver.doResolveTask(_task23, formModule, tasks);
							return;
						}
					case _Cmd2.default.OpenURL:
						//TODO 打开相对于客户端html的一个网页，或者全路径，  待修正 
						{
							var openurlarg = task.arg;
							if (!openurlarg) _Warn2.default.show({ text: "OpenURL命令的参数为空" });
							var _url2 = openurlarg.url;
							if (!_url2) _Warn2.default.show({ text: "OpenURL命令没有给出一个有效的URL" });
							if (!(_url2.indexOf("http://") == 0 || _url2.indexOf("https://") == 0)) {
								_url2 = "html/" + _url2;
							}
							_FormLoadHelper2.default.openHtml(_url2, !openurlarg.parameters ? "" : openurlarg.parameters);
							var _task24 = tasks.shift();
							if (_task24) CommandResolver.doResolveTask(_task24, formModule, tasks);
							return;
						}
					case _Cmd2.default.RecordRestore:
						{
							window.remainTasks = tasks;
							CommandResolver.doRecordRestore(task, formModule);
							return;
						}
					case _Cmd2.default.DS_AllowAdd:
						{
							CommandResolver.doDsAllowAdd(task, formModule);
							var _task25 = tasks.shift();
							if (_task25) CommandResolver.doResolveTask(_task25, formModule, tasks);
							return;
						}
					case _Cmd2.default.DS_AllowAttachment:
						{
							CommandResolver.doDsAllowAttachment(task, formModule);
							var _task26 = tasks.shift();
							if (_task26) CommandResolver.doResolveTask(_task26, formModule, tasks);
							return;
						}
					case _Cmd2.default.DS_AllowDelete:
						{
							CommandResolver.doDsAllowDelete(task, formModule);
							var _task27 = tasks.shift();
							if (_task27) CommandResolver.doResolveTask(_task27, formModule, tasks);
							return;
						}
					case _Cmd2.default.DS_AllowExport:
						{
							CommandResolver.doDsAllowExport(task, formModule);
							var _task28 = tasks.shift();
							if (_task28) CommandResolver.doResolveTask(_task28, formModule, tasks);
							return;
						}
					case _Cmd2.default.DS_AllowQuery:
					case _Cmd2.default.DS_AllowChangeQuery:
						{
							CommandResolver.doDsAllowQuery(task, formModule);
							var _task29 = tasks.shift();
							if (_task29) CommandResolver.doResolveTask(_task29, formModule, tasks);
							return;
						}
					case _Cmd2.default.DS_AllowSave:
						{
							CommandResolver.doDsAllowSave(task, formModule);
							var _task30 = tasks.shift();
							if (_task30) CommandResolver.doResolveTask(_task30, formModule, tasks);
							return;
						}
					case _Cmd2.default.DS_AllowEdit:
						{
							CommandResolver.doDsAllowEdit(task, formModule);
							var _task31 = tasks.shift();
							if (_task31) CommandResolver.doResolveTask(_task31, formModule, tasks);
							return;
						}
					/*case Cmd.CloseForm:
	    {
	    	window.parent.window.closeForm(window.formModuleInstanceuuId,true)
	    	return;
	    }
	    case Cmd.DoCloseForm:
	    {
	    	if(window.isPopUp)
	    		window.parent.window.closePopUpForm();
	    	else
	    		window.parent.window.closeForm(window.formModuleInstanceuuId)
	    	return;
	    }*/
					case _Cmd2.default.SwitchToTabPage:
						{
							CommandResolver.changeTabPage(task, formModule);
							var _task32 = tasks.shift();
							if (_task32) CommandResolver.doResolveTask(_task32, formModule, tasks);
							return;
						}
					case _Cmd2.default.FocusIn:
						{
							CommandResolver.setControlFocus(task, formModule);
							var _task33 = tasks.shift();
							if (_task33) CommandResolver.doResolveTask(_task33, formModule, tasks);
							return;
						}
					case _Cmd2.default.BindRowStyle:
						{
							CommandResolver.setControlStyle(task, formModule);
							var _task34 = tasks.shift();
							if (_task34) CommandResolver.doResolveTask(_task34, formModule, tasks);
							return;
						}
					case _Cmd2.default.BindEditorStyle:
						{
							CommandResolver.setControlStyle(task, formModule);
							var _task35 = tasks.shift();
							if (_task35) CommandResolver.doResolveTask(_task35, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetButtonStyle:
						{
							CommandResolver.setButtonStyle(task, formModule);
							var _task36 = tasks.shift();
							if (_task36) CommandResolver.doResolveTask(_task36, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetTextStyle:
						{
							CommandResolver.setTextStyle(task, formModule);
							var _task37 = tasks.shift();
							if (_task37) CommandResolver.doResolveTask(_task37, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetContainerStyle:
						{
							CommandResolver.setContainerStyle(task, formModule);
							var _task38 = tasks.shift();
							if (_task38) CommandResolver.doResolveTask(_task38, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetRecordConditionTask:
						{
							CommandResolver.doRecordConditionTask(task, formModule);
							var _task39 = tasks.shift();
							if (_task39) CommandResolver.doResolveTask(_task39, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetFormParamConditionTask:
						//TODO 参照上面Cmd.RecordConditionTasks改造
						{
							CommandResolver.doFormParamConditionTasks(task, formModule);
							var _task40 = tasks.shift();
							if (_task40) CommandResolver.doResolveTask(_task40, formModule, tasks);
							return;
						}
					case _Cmd2.default.ContextMap:
						{
							CommandResolver.doFormContext(task, formModule);
							var _task41 = tasks.shift();
							if (_task41) CommandResolver.doResolveTask(_task41, formModule, tasks);
							return;
						}
					case _Cmd2.default.ShowDialog:
						{
							CommandResolver.showDialog(task, formModule);
							var _task42 = tasks.shift();
							if (_task42) CommandResolver.doResolveTask(_task42, formModule, tasks);
							return;
						}
					case _Cmd2.default.Alert:
						{
							var defaults = {
								state: "warn",
								backgroundColor: undefined,
								color: "#fff",
								text: task.arg,
								cornerRadius: "10",
								interacdestroy: true,
								cancel: {
									isShow: false,
									event: ''
								}
							};
							if (window.parent.window && window.parent.window.showWarn) window.parent.window.showWarn(defaults);else _Warn2.default.show(defaults);
							var _task43 = tasks.shift();
							if (_task43) CommandResolver.doResolveTask(_task43, formModule, tasks);
							return;
						}
					case _Cmd2.default.Js:
						{
							var js = task.arg;
							eval(js);
							var _task44 = tasks.shift();
							if (_task44) CommandResolver.doResolveTask(_task44, formModule, tasks);
							return;
						}
					case _Cmd2.default.FileDownload:
						{
							CommandResolver.downLoad(task, formModule);
							var _task45 = tasks.shift();
							if (_task45) CommandResolver.doResolveTask(_task45, formModule, tasks);
							return;
						}
					case _Cmd2.default.FileUploadCmd:
						{
							CommandResolver.fileUpload(task, formModule, tasks);
							return;
						}
					case _Cmd2.default.CreateTimer:
						{
							CommandResolver.addTimer(task, formModule);
							var _task46 = tasks.shift();
							if (_task46) CommandResolver.doResolveTask(_task46, formModule, tasks);
							return;
						}
					case _Cmd2.default.CancelTimer:
						{
							CommandResolver.cancelTimer(task, formModule);
							var _task47 = tasks.shift();
							if (_task47) CommandResolver.doResolveTask(_task47, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetFormTitle:
						{
							CommandResolver.doSetFormTitle(task, formModule);
							var _task48 = tasks.shift();
							if (_task48) CommandResolver.doResolveTask(_task48, formModule, tasks);
							return;
						}
					case _Cmd2.default.SetControlProperty:
						{
							CommandResolver.doSetControlProperty(task, formModule);
							var _task49 = tasks.shift();
							if (_task49) CommandResolver.doResolveTask(_task49, formModule, tasks);
							return;
						}
					case _Cmd2.default.ClientRecordRemove:
						{
							CommandResolver.doClientRecordRemove(task, formModule);
							var _task50 = tasks.shift();
							if (_task50) CommandResolver.doResolveTask(_task50, formModule, tasks);
							return;
						}
					case _Cmd2.default.DimSortFormItem:
						{
							CommandResolver.doSortComponent(task, formModule);
							var _task51 = tasks.shift();
							if (_task51) CommandResolver.doResolveTask(_task51, formModule, tasks);
							return;
						}
					case _Cmd2.default.SortFormItem:
						{
							CommandResolver.doSortFormItem(task, formModule);
							var _task52 = tasks.shift();
							if (_task52) CommandResolver.doResolveTask(_task52, formModule, tasks);
							return;
						}
					case _Cmd2.default.DimAdjustFormDataSourceField:
						{
							CommandResolver.doDimAdjustFormDataSourceField(task, formModule);
							var _task53 = tasks.shift();
							if (_task53) CommandResolver.doResolveTask(_task53, formModule, tasks);
							return;
						}
					case _Cmd2.default.CloseForm:
						{
							if (window.isPopUp) window.parent.window.closePopUpFormByUUId(window.formModuleInstanceuuId, true);else window.parent.window.closeForm(window.formModuleInstanceuuId, true);
							return;
						}
					case _Cmd2.default.DoCloseForm:
						{
							if (window.isPopUp) window.parent.window.closePopUpFormByUUId(window.formModuleInstanceuuId, false);else window.parent.window.closeForm(window.formModuleInstanceuuId, false);
							return;
						}
					case _Cmd2.default.ShowInfo:
						{
							CommandResolver.doShowInfo(task);
							var _task54 = tasks.shift();
							if (_task54) CommandResolver.doResolveTask(_task54, formModule, tasks);
							return;
						}
					case _Cmd2.default.TmpRecordDelete:
						{
							CommandResolver.deleteTempRecord(task, formModule);
							var _task55 = tasks.shift();
							if (_task55) CommandResolver.doResolveTask(_task55, formModule, tasks);
							return;
						}
					case _Cmd2.default.ActiveRecord:
						{
							CommandResolver.activeRecord(task, formModule);
							var _task56 = tasks.shift();
							if (_task56) CommandResolver.doResolveTask(_task56, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateToolBar:
						{
							CommandResolver.updateToolBar(task, formModule);
							var _task57 = tasks.shift();
							if (_task57) CommandResolver.doResolveTask(_task57, formModule, tasks);
							return;
						}
					case _Cmd2.default.LocateToRecord:
						{
							CommandResolver.doLocateToRecord(task, formModule);
							var _task58 = tasks.shift();
							if (_task58) CommandResolver.doResolveTask(_task58, formModule, tasks);
							return;
						}
					case _Cmd2.default.LocateRecord:
						{
							CommandResolver.doLocateRecord(task, formModule);
							var _task59 = tasks.shift();
							if (_task59) CommandResolver.doResolveTask(_task59, formModule, tasks);
							return;
						}
					case _Cmd2.default.RecordNew:
						{
							CommandResolver.doRecordNew(task, formModule);
							var _task60 = tasks.shift();
							if (_task60) CommandResolver.doResolveTask(_task60, formModule, tasks);
							return;
						}
					case _Cmd2.default.RecordDelete:
						{
							CommandResolver.doRecordDelete(task, formModule);
							var _task61 = tasks.shift();
							if (_task61) CommandResolver.doResolveTask(_task61, formModule, tasks);
							return;
						}
					case _Cmd2.default.RecordSave:
						{
							CommandResolver.doRecordSave(task, formModule);
							var _task62 = tasks.shift();
							if (_task62) CommandResolver.doResolveTask(_task62, formModule, tasks);
							return;
						}
					case _Cmd2.default.ClientRecordRefresh:
						{
							CommandResolver.doClientRecordRefresh(task, formModule);
							var _task63 = tasks.shift();
							if (_task63) CommandResolver.doResolveTask(_task63, formModule, tasks);
							return;
						}
					case _Cmd2.default.ClientRecordAdd:
						{
							CommandResolver.doClientRecordAdd(task, formModule);
							var _task64 = tasks.shift();
							if (_task64) CommandResolver.doResolveTask(_task64, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateGroupCollapseState:
						{
							CommandResolver.doUpdateGroupCollapseState(task, formModule);
							var _task65 = tasks.shift();
							if (_task65) CommandResolver.doResolveTask(_task65, formModule, tasks);
							return;
						}
					case _Cmd2.default.WriteField:
						{
							CommandResolver.writeField(task, formModule);
							var _task66 = tasks.shift();
							if (_task66) CommandResolver.doResolveTask(_task66, formModule, tasks);
							return;
						}
					case _Cmd2.default.DoWriteField:
						{
							CommandResolver.doWriteField(task, formModule);
							var _task67 = tasks.shift();
							if (_task67) CommandResolver.doResolveTask(_task67, formModule, tasks);
							return;
						}
					case _Cmd2.default.HoldFocusIn:
						{
							CommandResolver.holdFocusIn(task, formModule);
							var _task68 = tasks.shift();
							if (_task68) CommandResolver.doResolveTask(_task68, formModule, tasks);
							return;
						}
					case _Cmd2.default.RegisterRender:
						{
							CommandResolver.registerRender(task, formModule);
							var _task69 = tasks.shift();
							if (_task69) CommandResolver.doResolveTask(_task69, formModule, tasks);
							return;
						}
					case _Cmd2.default.DragStart:
						{
							CommandResolver.dragStart(task, formModule);
							var _task70 = tasks.shift();
							if (_task70) CommandResolver.doResolveTask(_task70, formModule, tasks);
							return;
						}
					case _Cmd2.default.ShowCalculator:
						{
							CommandResolver.showCalculator(task, formModule);
							var _task71 = tasks.shift();
							if (_task71) CommandResolver.doResolveTask(_task71, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateDropDownContent:
						{
							CommandResolver.updateDropDownContent(task, formModule);
							var _task72 = tasks.shift();
							if (_task72) CommandResolver.doResolveTask(_task72, formModule, tasks);
							return;
						}
					case _Cmd2.default.SysReinitForm:
						{
							CommandResolver.doSysReinitForm(task, formModule, tasks);
							return;
						}
					case _Cmd2.default.ShowClipboard:
						{
							CommandResolver.showClipboard(task, formModule);
							var _task73 = tasks.shift();
							if (_task73) CommandResolver.doResolveTask(_task73, formModule, tasks);
							return;
						}
					case _Cmd2.default.ShowImage:
						{
							CommandResolver.showImage(task, formModule);
							var _task74 = tasks.shift();
							if (_task74) CommandResolver.doResolveTask(_task74, formModule, tasks);
							return;
						}
					case _Cmd2.default.FetchAll:
						{
							CommandResolver.doFetchAll(task, formModule, tasks);
							return;
						}
					case _Cmd2.default.WriteDataMethodField:
						{
							CommandResolver.doWriteDataMethodField(task, formModule);
							var _task75 = tasks.shift();
							if (_task75) CommandResolver.doResolveTask(_task75, formModule, tasks);
							return;
						}
					case _Cmd2.default.CallClientMethod:
						{
							CommandResolver.CallClientMethod(task, formModule);
							var _task76 = tasks.shift();
							if (_task76) CommandResolver.doResolveTask(_task76, formModule, tasks);
							return;
						}
					case _Cmd2.default.SelectRecords:
						{
							CommandResolver.clientSelectRecords(task, formModule);
							var _task77 = tasks.shift();
							if (_task77) CommandResolver.doResolveTask(_task77, formModule, tasks);
							return;
						}
					case _Cmd2.default.Ds_AttachmentAllowDelete:
						{
							CommandResolver.dsAttachmentAllowDelete(task, formModule);
							var _task78 = tasks.shift();
							if (_task78) CommandResolver.doResolveTask(_task78, formModule, tasks);
							return;
						}
					case _Cmd2.default.Ds_AttachmentAllowRename:
						{
							CommandResolver.dsAttachmentAllowRename(task, formModule);
							var _task79 = tasks.shift();
							if (_task79) CommandResolver.doResolveTask(_task79, formModule, tasks);
							return;
						}
					case _Cmd2.default.Ds_AttachmentAllowUpload:
						{
							CommandResolver.dsAttachmentAllowUpload(task, formModule);
							var _task80 = tasks.shift();
							if (_task80) CommandResolver.doResolveTask(_task80, formModule, tasks);
							return;
						}
					case _Cmd2.default.Ds_AttachmentAllowVisible:
						{
							CommandResolver.dsAttachmentAllowVisible(task, formModule);
							var _task81 = tasks.shift();
							if (_task81) CommandResolver.doResolveTask(_task81, formModule, tasks);
							return;
						}
					case _Cmd2.default.OpenLuckySheet:
						{
							CommandResolver.doOpenLuckySheet(task, formModule);
							var _task82 = tasks.shift();
							if (_task82) CommandResolver.doResolveTask(_task82, formModule, tasks);
							return;
						}
					case _Cmd2.default.UpdateAllowEditorNotSelectAll:
						{
							CommandResolver.doUpdateAllowEditorNotSelectAll(task, formModule);
							var _task83 = tasks.shift();
							if (_task83) CommandResolver.doResolveTask(_task83, formModule, tasks);
							return;
						}
					case _Cmd2.default.PrintReport:
						{
							CommandResolver.doPrintReport(task, formModule);
							var _task84 = tasks.shift();
							if (_task84) CommandResolver.doResolveTask(_task84, formModule, tasks);
							return;
						}
					default:
						{
							alert("未能解析的指令:" + task.cmd);
							return;
						}
				}
			}
		}, {
			key: 'resolve',
			value: function resolve(tasks, formModule) {
				var group = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
				if (!tasks || !Array.isArray(tasks)) return;
				tasks = tasks.concat();
				var closeFormIndex = -1;
				for (var i = 0; i < tasks.length; i++) {
					var _task85 = tasks[i];
					if (!_task85) continue;
					if (_task85.group == null) {
						_task85.group = group == null ? null : group.groupAlias;
						if (_task85.group == null && formModule) {
							var _fds = formModule.formDataSources;
							if (_fds && _fds.firstGroup) _task85.group = _fds.firstGroup.groupAlias;
						}
					}
					if (_task85.cmd == _Cmd2.default.CloseForm || _task85.cmd == _Cmd2.default.DoCloseForm) closeFormIndex = i;
				}
	
				//TODO 为了防止closeForm命令卸载程序而导致某些代码无法执行 暂时把命令中的closeForm放置最后执行
				//比如 原来有大量的 closeForm->parentCommandResult命令组合 这在多页面应用程序中不好支持
	
				if (closeFormIndex != -1) {
					var deleteArr = tasks.splice(closeFormIndex, 1);
					if (deleteArr.length > 0) tasks.push(deleteArr[0]);
				}
				var oldTasks = JSON.stringify(tasks);
				var task = tasks.shift();
				if (task) CommandResolver.doResolveTask(task, formModule, tasks);
	
				if (oldTasks) {
					var oldts = JSON.parse(oldTasks);
					var needRefFildGroup = [];
					var cdmCom = void 0;
					for (var _i6 = 0; _i6 < oldts.length; _i6++) {
						var _task86 = oldts[_i6];
						if (!_task86) continue;
						if (_task86.cmd == "updateControlVisible") {
							if (_task86.control) {
								var isLookup = formModule.classAlias == "FormModuleLookup";
								var keyBase = formModule.menuItemId + "." + formModule.formId + ".";
								var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + _task86.control, isLookup);
								if (itemControl) {
									if (itemControl.parentControl && itemControl.parentControl.classAlias == "FormItemFieldGroupControl") {
										// ResizeActions.groupRefersh(task.control);
										if (needRefFildGroup.length == 0) {
											needRefFildGroup.push(itemControl.parentControl.innerId);
										} else {
											if (needRefFildGroup.indexOf(itemControl.parentControl.innerId) == -1) {
												needRefFildGroup.push(itemControl.parentControl.innerId);
											}
										}
									}
								}
							}
						}
					}
					for (var _i7 in needRefFildGroup) {
						var innerId = needRefFildGroup[_i7];
						var arg = { innerId: innerId, formId: formModule.formId };
						_ResizeActions2.default.groupRefersh(arg);
					}
				}
			}
		}, {
			key: 'fileUpload',
			value: function fileUpload(task, formModule, tasks) {
				var arg = {
					state: "info",
					text: "确认要上传文件",
					confirm: {
						isShow: true,
						event: function event(e) {
							CommandResolver.doFileUpload(task, formModule, tasks);
						}
					},
					cancel: {
						isShow: true,
						event: ''
					}
	
				};
				if (task.arg && task.arg.title) arg.title = task.arg.title;
				if (task.arg && task.arg.info) arg.text = task.arg.info;
				_Warn2.default.show(arg);
			}
		}, {
			key: 'doFileUpload',
			value: function doFileUpload(task, formModule, laterTasks) {
				var fileUploadArg = task.arg;
				if (!fileUploadArg.url) fileUploadArg.url = "";
				fileUploadArg.url = window.parent.window.userInfos.serviceURL + "/FileUpLoad?path=" + fileUploadArg.url;
	
				$("#commonFileInput").off("change").on("change", function (event) {
					CommandResolver.fieldUploadFileSelected(event, fileUploadArg, laterTasks, formModule);
				});
	
				if (fileUploadArg.type) $("#commonFileInput").attr("accept", fileUploadArg.type);else $("#commonFileInput").attr("accept", "*");
	
				$("#commonFileInput").click();
			}
		}, {
			key: 'fieldUploadFileSelected',
	
			//只给后台fileUpload上传命令使用 License的上传功能在LicenseUpLoad中 不调用该方法
			value: function fieldUploadFileSelected(e, fileUploadArg, laterTasks, formModule) {
				var uploadFiles = e.target.files || e.dataTransfer.files;
				var uploadFile = uploadFiles[0];
	
				if (fileUploadArg.maxSize && uploadFile.size > fileUploadArg.maxSize) {
					_Warn2.default.show({ text: fileUploadArg.sizeLimitInfo });
					return;
				}
	
				/*if(Array.isArray(fileUploadArg.types) && fileUploadArg.types.indexOf(uploadFile.type) == -1)
	   {
	   	Warning.show({text:fileUploadArg.typeLimitInfo});
	   	return;
	   }*/
	
				var url = fileUploadArg.url;
				url = encodeURI(url);
				/*var domain = window.didomain;
	   try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
	   {
	   	if(!domain && window.parent && window.parent.window)
	   		domain = window.parent.window.didomain;
	   			if(domain)
	   	{
	   		url+=("&token="+localStorage.getItem("userToken"));
	   	}
	   		
	   }
	   catch(e)
	   {
	   	
	   }*/
				var oMyForm = new FormData();
				oMyForm.append("file", uploadFile);
	
				var progressBar = $('<progress></progress>').css({ 'width': '15em', 'height': '2.1em' }).html('您的浏览器不支持progress元素');
	
				var progressA = $('<a></a>').css({ 'background-color': '#fff', 'color': '#ff0000', 'font-size': '1.5em' }).click(function () {
					that.client.abort();
				}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
				var progressBtn = $('<div></div>').append(progressA);
				var progressDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '40.5%', 'left': '40%', 'display': 'flex' }).append(progressBar).append(progressBtn);
				var percentageDiv = $('<span></span>');
				var time = $("<span></span>");
				var percentDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '41%', 'left': '40.5%', 'font-size': '0.8em' }).append(percentageDiv).append(time);
				var progressBorder = $("<div></div>").append(progressDiv).append(percentDiv).attr('id', 'progressBorder').addClass('modal');
				$('body').append(progressBorder);
	
				if (CommandResolver.tmpXMLHttpRequest == null) {
					CommandResolver.tmpXMLHttpRequest = new XMLHttpRequest();
				}
	
				CommandResolver.tmpXMLHttpRequest.upload.onprogress = function (pe) {
					if (pe.lengthComputable) {
						progressBorder.css('display', 'block');
						progressBar.attr('max', pe.total);
						progressBar.attr('value', pe.loaded);
						percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
					}
					var nt = new Date().getTime(); //获取当前时间
					var pertime = (nt - this.ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
					this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
					var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
					this.oloaded = pe.loaded; //重新赋值已上传文件大小，用以下次计算
	
					//上传速度计算
					var speed = perload / pertime; //单位b/s
					var bspeed = speed;
					var units = 'b/s'; //单位名称
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'k/s';
					}
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'M/s';
					}
					speed = speed.toFixed(1);
					//剩余时间
					var resttime = ((pe.total - pe.loaded) / bspeed).toFixed(1);
	
					var timeContent = ' ' + speed + units + '，剩余时间：' + resttime + 's';
					time.html(timeContent);
				};
	
				CommandResolver.tmpXMLHttpRequest.upload.onloadstart = function () {
					//上传开始执行方法
					this.ot = new Date().getTime(); //设置上传开始时间
					this.oloaded = 0; //设置上传开始时，以上传的文件大小为0
				};
				CommandResolver.tmpXMLHttpRequest.onreadystatechange = function () {
					if (CommandResolver.tmpXMLHttpRequest.readyState == 4) {
						if (CommandResolver.tmpXMLHttpRequest.status == 200) {
							var options = { state: 'success', text: '上传成功！' };_Fade2.default.show(options);
						} else {
							var _options = { state: 'error', text: '上传失败！' };_Fade2.default.show(_options);
						}
						$('#commonFileInput').val('');
	
						if (fileUploadArg && fileUploadArg.callBack) {
							var arg = {};
							arg["methodName"] = fileUploadArg.callBack;
							var callBackArg = { remoteClass: "java.util.Map" };
							if (uploadFile) {
								callBackArg.name = uploadFile.name;
								callBackArg.lastModified = uploadFile.lastModified;
								callBackArg.size = uploadFile.size;
								callBackArg.type = uploadFile.type;
								callBackArg.webkitRelativePath = uploadFile.webkitRelativePath;
							}
	
							arg["methodArg"] = callBackArg;
	
							var commandTask = new _CommandTask2.default();
							commandTask.cmd = _Cmd2.default.FormCmd;
							commandTask.arg = arg;
							CommandResolver.formCmd(commandTask, formModule);
						}
	
						var task2 = laterTasks.shift();
						if (task2) CommandResolver.doResolveTask(task2, formModule, laterTasks);
					}
				};
				CommandResolver.tmpXMLHttpRequest.onloadend = function (pe) {
					//alert("end");
					$('#progressBorder').remove();
				};
	
				CommandResolver.tmpXMLHttpRequest.open("POST", url, false); //+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
				CommandResolver.tmpXMLHttpRequest.withCredentials = true;
	
				CommandResolver.tmpXMLHttpRequest.send(oMyForm);
			}
		}, {
			key: 'calcResourcePath',
			value: function calcResourcePath(url) {
				var _url;
				if (url.substr(0, 5) == "@tmp/") {
	
					_url = window.parent.window.userInfos.serviceURL + "/tmp/" + url.substr(5);
				} else {
					_url = window.parent.window.userInfos.resourceURL + "/" + url;
				}
	
				return _url;
			}
		}, {
			key: 'downLoad',
			value: function downLoad(task, formModule) {
				var url = void 0;var fname = void 0;
				if (typeof task.arg == "string") {
					url = task.arg;
					if (!url) {
						alert("未填写下载路径");
						return;
					}
					fname = url.substr(url.lastIndexOf("/") + 1);
				} else if (_typeof(task.arg) == "object") {
					url = task.arg.url;
					if (!url) {
						alert("未填写下载路径");
						return;
					}
					fname = task.arg.defaultName ? task.arg.defaultName : url.substr(url.lastIndexOf("/") + 1);
				}
	
				url = CommandResolver.calcResourcePath(url);
	
				/*var blob=new Blob([''], {type:'application/octet-stream'});
	      var urlobj = URL.createObjectURL(blob);
	      var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
	      a.href = url;
	      a.download = fname; 
	      var e = document.createEvent('MouseEvents');
	      e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	      a.dispatchEvent(e);
	      URL.revokeObjectURL(urlobj);*/
				/*window.didomain = "OA";
	   if(window.didomain)
	   {
	   	fetch(url, {
	   		method: 'GET',
	   		headers: new Headers({
	   		  'token':localStorage.getItem("userToken")
	   		})
	   	  })
	   		.then(res => res.blob())
	   		.then(data => {
	   		  const blobUrl = window.URL.createObjectURL(data);
	   		  CommandResolver.adownload(blobUrl);
	   	});
	   }
	   else
	   {
	   	CommandResolver.adownload(url);
	   }*/
	
				var domain = window.didomain;
				try //zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
				{
					if (!domain && window.parent && window.parent.window) domain = window.parent.window.didomain;
	
					if (domain) {
						var loginToken = window.loginToken;
						var loginDataArea = window.loginDataArea;
						if (window.parent && window.parent.window) {
							if (!loginToken) loginToken = window.parent.window.loginToken;
							if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
						}
						if (!loginToken) url += "?token=" + localStorage.getItem("userToken");
					}
				} catch (e) {}
	
				var a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
				a.href = url;
				a.download = fname;
	
				var e = document.createEvent('MouseEvents');
				e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				a.dispatchEvent(e);
			}
		}, {
			key: 'adownload',
			value: function adownload(url) {
				var a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
				a.href = url;
				a.download = fname;
	
				var e = document.createEvent('MouseEvents');
				e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				a.dispatchEvent(e);
			}
		}, {
			key: 'setControlStyle',
			value: function setControlStyle(task, formModule) {
				var isLookup = formModule.classAlias == "FormModuleLookup";
				var keyBase = formModule.menuItemId + "." + formModule.formId + ".";
				var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + task.control, isLookup);
				if (itemControl) {
					var innerId = itemControl.xml.id;
					_FormItemUtil2.default.setControlStyles(isLookup ? "FormLookup" : window.menuItemId, formModule.formId, innerId, task.arg);
					_CmdTypeActions2.default.bindStyle(formModule.formId, task.control);
				}
			}
		}, {
			key: 'setButtonStyle',
			value: function setButtonStyle(task, formModule) {
				var isLookup = formModule.classAlias == "FormModuleLookup";
				var keyBase = formModule.menuItemId + "." + formModule.formId + ".";
				var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + task.control, isLookup);
				if (itemControl) {
					var innerId = itemControl.xml.id;
					var _style = task.arg.map;
					if (_style.color && _style.color != -1) _style.color = "#" + _style.color.toString(16);
					if (_style.backgroundColor && _style.backgroundColor != -1) _style.backgroundColor = "#" + _style.backgroundColor.toString(16);
					_FormItemUtil2.default.setControlStyles(isLookup ? "FormLookup" : window.menuItemId, formModule.formId, innerId, _style);
					_CmdTypeActions2.default.setButtonStyle(formModule.formId, task.control);
				}
			}
		}, {
			key: 'setTextStyle',
			value: function setTextStyle(task, formModule) {
				var isLookup = formModule.classAlias == "FormModuleLookup";
				var keyBase = formModule.menuItemId + "." + formModule.formId + ".";
				var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + task.control, isLookup);
				if (itemControl) {
					var innerId = itemControl.xml.id;
					var _style = task.arg.map;
					if (_style.color && typeof _style.color != "string" && _style.color != -1) _style.color = "#" + _style.color.toString(16);
					if (_style.backgroundColor && _style.backgroundColor != -1) _style.backgroundColor = "#" + _style.backgroundColor.toString(16);
					_FormItemUtil2.default.setControlNoBindStyle(isLookup ? "FormLookup" : window.menuItemId, formModule.formId, innerId, _style);
	
					_CmdTypeActions2.default.setTextStyle(formModule.formId, task.control);
				}
			}
		}, {
			key: 'setContainerStyle',
			value: function setContainerStyle(task, formModule) {
				var isLookup = formModule.classAlias == "FormModuleLookup";
				var keyBase = formModule.menuItemId + "." + formModule.formId + ".";
				var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + task.control, isLookup);
				if (itemControl) {
					var innerId = itemControl.xml.id;
					var _style = task.arg.map;
					_FormItemUtil2.default.setControlNoBindStyle(isLookup ? "FormLookup" : window.menuItemId, formModule.formId, innerId, _style);
	
					_CmdTypeActions2.default.setContainerStyle(formModule.formId, task.control);
				}
			}
		}, {
			key: 'openSubForm',
			value: function openSubForm(task, formModule) {
				if (typeof task.arg == "string") {
					_FormLoadHelper2.default.openFormDirectly({ formId: task.arg });
				} else if (task.arg) {
					var ofa = task.arg;
					var fm = formModule;
					var group;
	
					var addJoin = true;
					var _autoJoinParentArg = { autoJoinParent: true };
					if (ofa.addFixedGroupRelation == true && fm) {
						if (fm.formDataSources && fm.formDataSources.groups.hasOwnProperty(ofa.linkGroupAlias)) {
							group = fm.formDataSources.groups[ofa.linkGroupAlias];
							_autoJoinParentArg.autoJoinParent = false;
							_autoJoinParentArg.autoJoinParentAlias = ofa.linkGroupAlias;
						}
					} else if (ofa.addAutoGroupRelation == true && fm) {
						group = CommandResolver.getTaskGroup(task, fm);
					} else {
						addJoin = false;
					}
	
					var ofa_paramObject = ofa.paramObject;
					if ((typeof ofa_paramObject === 'undefined' ? 'undefined' : _typeof(ofa_paramObject)) == "object" && ofa_paramObject && !ofa_paramObject.hasOwnProperty("remoteClass")) ofa_paramObject = Object.assign({ remoteClass: "java.util.Map" }, ofa_paramObject);
	
					_FormLoadHelper2.default.openFormDirectly({ formId: ofa.subFormId, menuItemId: "-1", parm: ofa.paramString, fm: fm,
						group: group, callerKey: ofa.callerKey, paramObject: ofa_paramObject, popUp: ofa.isPopUp, addJoin: addJoin,
						autoJoinParentArg: _autoJoinParentArg, ingnoreAu: ofa.ingnoreAu
					});
				}
			}
		}, {
			key: 'openForm',
			value: function openForm(task, formModule) {
				if (typeof task.arg == "string") {
					_FormLoadHelper2.default.openMenuItemByAuthority({ menuItemId: task.arg });
				} else if (task.arg) {
					var ofa = task.arg; //ofa.addAutoGroupRelation = true;
					var fm = formModule;
					var group;
					var serverSepcLinkType = "";
					var addJoin = true;
					var _autoJoinParentArg = { autoJoinParent: true };
					if (ofa.addFixedGroupRelation == true && fm) {
						if (fm.formDataSources && fm.formDataSources.groups.hasOwnProperty(ofa.linkGroupAlias)) {
							group = fm.formDataSources.groups[ofa.linkGroupAlias];
							_autoJoinParentArg.autoJoinParent = false;
							_autoJoinParentArg.autoJoinParentAlias = ofa.linkGroupAlias;
						}
					} else if (ofa.addAutoGroupRelation == true && fm) {
						group = CommandResolver.getTaskGroup(task, fm);
					} else {
						addJoin = false;
					}
	
					var mainTableWhereValues;
					var ofa_paramObject = ofa.paramObject;
					if ((typeof ofa_paramObject === 'undefined' ? 'undefined' : _typeof(ofa_paramObject)) == "object" && ofa_paramObject && !ofa_paramObject.hasOwnProperty("remoteClass")) ofa_paramObject = Object.assign({ remoteClass: "java.util.Map" }, ofa_paramObject);
	
					_FormLoadHelper2.default.openMenuItemByAuthority({ menuItemId: ofa.menuItemId, parm: ofa.paramString, fm: fm,
						group: group, callerKey: ofa.callerKey, paramObject: ofa_paramObject, popUp: ofa.isPopUp, addJoin: addJoin,
						autoJoinParentArg: _autoJoinParentArg, ingnoreAu: ofa.ingnoreAu, commandArgInfo: ofa.commandArgInfo
					});
				}
				// else if(task.arg is OpenMainFormArg)
				// {
	
				// 	fm = formDesign.formModule;
				// 	var mainFormArg:OpenMainFormArg = task.arg as OpenMainFormArg;
				// 	ofa = mainFormArg.switchToOpenFormArg();
				// 	FormLoadHelper.openMenuItemByAuthority(ofa.menuItemId, ofa.paramString, fm, null, ofa.mainFormWhereValues);
	
				// }
			}
		}, {
			key: 'updateEditorShowLookup',
			value: function updateEditorShowLookup(task, formModule) {
				var _key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, task.control);
				if (task.control) {
					var control = _FormItemUtil2.default.getFormItemControl(_key);
					if (control) {
						control.serverHasLookup = task.arg;
					}
				} else {
					if (task.arg) {
						for (var key in task.arg) {
							if (typeof task.arg[key] == "boolean") {
								var lookupVisible = task.arg[key];
								var control = _FormItemUtil2.default.getFormItemControl(_key);
								if (control.classAlias == "FormItemStringEditorControl") control.serverHasLookup = lookupVisible;
							}
						}
					}
				}
			}
		}, {
			key: 'doFetchAll',
			value: function doFetchAll(task, formModule, tasks) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) {
					_group.recordFetchAllForCmd(tasks);
				} else {
					if (tasks) {
						var _task = tasks.shift();
						if (task) CommandResolver.doResolveTask(_task, formModule, tasks);
					}
				}
			}
		}, {
			key: 'doExecuteQuery',
			value: function doExecuteQuery(groupAlias, formModule, group, tasks, task) {
				if (formModule.formDataSources == null) return false;
	
				var _group;var executed = false;
				var sync = false;
				if (task.arg && task.arg.hasOwnProperty("sync")) sync = task.arg.sync;
				if (groupAlias == null) {
					if (group != null) {
						group.reExecuteQuery(sync, tasks);executed = true;
					}
				} else if (groupAlias == "all") {
					var flag = false;
					for (var key in formModule.formDataSources.groups) {
						var _group = formModule.formDataSources.groups[key];
						if (_group.linkGroup == null || _group.linkGroup.formDataSources != group.formDataSources) {
							_group.reExecuteQuery(sync, tasks);executed = true;
						}
					}
				} else {
					_group = formModule.formDataSources.groups[groupAlias];
					if (_group != null) {
						_group.reExecuteQuery(sync, tasks);executed = true;
					}
				}
	
				if (executed == false) if (tasks) {
					var _task87 = tasks.shift();
					if (_task87) CommandResolver.doResolveTask(_task87, formModule, tasks);
				}
			}
		}, {
			key: 'updateControlVisible',
			value: function updateControlVisible(task, formModule) {
				var isLookup = formModule.classAlias == "FormModuleLookup";
				var keyBase = formModule.menuItemId + "." + formModule.formId + ".";
				if (task.control) {
					var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + task.control, isLookup);
					if (itemControl) {
						itemControl._cmdVisibleFalse = !task.arg;
						//if(itemControl.finalVisibleInited == true)
						//	itemControl.finalVisibleInited = false;
						//TODO_YL 临时修改 当Editor 存在DATAGrid里面的时候 隐藏失效
						if (itemControl.parentXML && itemControl.parentXML.type == "DataGrid" && itemControl.dataField) {
							task.control = itemControl.dataField.substring(0, itemControl.dataField.lastIndexOf(".")) + "_" + _StringUtil2.default.convertToFirstUpperCase(itemControl.dataField.substring(itemControl.dataField.lastIndexOf(".") + 1));
						}
						_CmdTypeActions2.default.updateControlVisible(formModule.menuItemId, formModule.formId, [task.control], isLookup);
					}
				} else {
					if (task.arg) {
						var controlNames = [];
						for (var key in task.arg) {
							if (typeof task.arg[key] == "boolean") {
								var allowEdit = task.arg[key];
								var itemControl = _FormItemUtil2.default.getFormItemControl(keyBase + key, isLookup);
								if (itemControl) {
									itemControl._cmdVisibleFalse = !allowEdit;
									//if(itemControl.finalVisibleInited == true)
									//	itemControl.finalVisibleInited = false;
									if (itemControl.componentDim) {
										controlNames.push(key);
									} else {
										//TODO_YL 临时修改 当Editor 存在DATAGrid里面的时候 隐藏失效
										if (itemControl.parentXML && itemControl.parentXML.type == "DataGrid" && itemControl.dataField) {
											key = itemControl.dataField.substring(0, itemControl.dataField.lastIndexOf(".")) + "_" + _StringUtil2.default.convertToFirstUpperCase(itemControl.dataField.substring(itemControl.dataField.lastIndexOf(".") + 1));
										}
										controlNames.push(key);
									}
								}
							}
						}
						_CmdTypeActions2.default.updateControlVisible(formModule.menuItemId, formModule.formId, controlNames, isLookup);
					}
				}
			}
		}, {
			key: 'updateControlSkipTab',
			value: function updateControlSkipTab(task, formModule) {
				if (task.control) {
					var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + task.control, false);
					if (itemControl) itemControl.setControlSkipTabCmd(task.arg);
				} else {
					if (task.arg) {
						for (var key in task.arg) {
							if (typeof task.arg[key] == "boolean") {
								var skipTab = task.arg[key];
								var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + key, false);
								if (itemControl) {
									itemControl.setControlSkipTabCmd(skipTab);
								}
							}
						}
					}
				}
			}
		}, {
			key: 'updateControlLabel',
			value: function updateControlLabel(task, formModule) {
				if (task.control) {
					if (formModule && formModule.classAlias == "FormModuleLookup") {
						var itemControl = _FormItemUtil2.default.getFormItemControl(formModule.menuItemId + "." + formModule.formId + "." + task.control, true);
						if (itemControl) itemControl.setControlLabelCmd(task.arg);
					} else {
						var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + task.control, false);
						if (itemControl) itemControl.setControlLabelCmd(task.arg);
					}
				} else {
					if (task.arg) {
						for (var key in task.arg) {
	
							var _label = task.arg[key];
							var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + key, false);
							if (itemControl) {
								itemControl.setControlLabelCmd(_label);
							} else {
								if (formModule && formModule.classAlias == "FormModuleLookup") {
									itemControl = _FormItemUtil2.default.getFormItemControl(formModule.menuItemId + "." + formModule.formId + "." + key, true);
									if (itemControl) itemControl.setControlLabelCmd(_label);
								}
							}
						}
					}
				}
			}
		}, {
			key: 'updateControlShowDecimal',
			value: function updateControlShowDecimal(task, formModule) {
				if (task.control) {
					if (formModule && formModule.classAlias == "FormModuleLookup") {
						var itemControl = _FormItemUtil2.default.getFormItemControl(formModule.menuItemId + "." + formModule.formId + "." + task.control, true);
						if (itemControl) itemControl.setControlShowDecimalCmd(task.arg);
					} else {
						var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + task.control, false);
						if (itemControl) itemControl.setControlShowDecimalCmd(task.arg);
					}
				} else {
					if (task.arg) {
						for (var key in task.arg) {
	
							var _value = task.arg[key];
							var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + key, false);
							if (itemControl) {
								itemControl.setControlShowDecimalCmd(_value);
							} else {
								if (formModule && formModule.classAlias == "FormModuleLookup") {
									itemControl = _FormItemUtil2.default.getFormItemControl(formModule.menuItemId + "." + formModule.formId + "." + key, true);
									if (itemControl) itemControl.setControlShowDecimalCmd(_value);
								}
							}
						}
					}
				}
			}
		}, {
			key: 'updateControlAllowEdit',
			value: function updateControlAllowEdit(task, formModule) {
				if (task.control) {
					var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + task.control, false);
					if (itemControl) itemControl.doSetEnableCmd(task.arg);
					//CmdTypeActions.updateControlAllowEdit(_arg);
				} else {
					if (task.arg) {
						for (var key in task.arg) {
							if (typeof task.arg[key] == "boolean") {
								var allowEdit = task.arg[key];
								var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + key, false);
								if (itemControl) {
									itemControl.doSetEnableCmd(allowEdit);
								}
							}
						}
						//CmdTypeActions.updateControlAllowEdit(task.arg);
					}
				}
			}
		}, {
			key: 'doWriteControl',
			value: function doWriteControl(task, formModule) {
				if (task.control) {
					var _arg = {};
					_arg[task.control] = task.arg;
					_CmdTypeActions2.default.writeControl(_arg, formModule.instanceUUId, false);
				} else {
					if (task.arg) {
						_CmdTypeActions2.default.writeControl(task.arg, formModule.instanceUUId, false);
					}
				}
			}
		}, {
			key: 'writeControl',
			value: function writeControl(task, formModule) {
				if (task.control) {
					var _arg = {};
					_arg[task.control] = task.arg;
					_CmdTypeActions2.default.writeControl(_arg, formModule.instanceUUId, true);
				} else {
					if (task.arg) {
						_CmdTypeActions2.default.writeControl(task.arg, formModule.instanceUUId, true);
					}
				}
			}
		}, {
			key: 'doRemoteButtonOk',
			value: function doRemoteButtonOk(task, formModule) {
				if (task.control) {
					var _arg = {};
					_arg[task.control] = task.arg;
					_CmdTypeActions2.default.buttonOk(_arg);
				} else {
					if (task.arg) {
						_CmdTypeActions2.default.buttonOk(task.arg);
					}
				}
			}
		}, {
			key: 'doLookupRefresh',
			value: function doLookupRefresh(task, formModule) {
				var fm = formModule;
				if (!fm || fm.classAlias != "FormModuleLookup") //当该form被直接拖到menuItem，作为独立窗口打开时
					{
						alert("不能将标记为FormLookup的页面作为菜单项打开");
						return;
					}
				fm.doLookupRefresh(task);
			}
		}, {
			key: 'lookupReturn',
			value: function lookupReturn(task, formModule) {
	
				//仅在自定义的下拉画面中有效，返回值回填到StringEditor
				//public CommandTask lookupReturn(String value)		
	
				//仅在自定义的下拉画面中有效，返回值按map中的key对应到dataField，按value回填值
				//当前单元格的字段会触发modifieldField_或者modifiedEditor_方法，其他字段不会触发
				//value需要统一转换成String
				//public CommandTask lookupReturn(Map<String, String> map)	
	
	
				//仅在自定义的下拉画面中有效，根据returnFields回填到主画面
				//当前单元格的字段会触发modifieldField_或者modifiedEditor_方法，其他字段不会触发
				//public CommandTask lookupReturn(List<FormLookupReturnField> returnFields) //仅在自定义的下拉画面中有效，根据returnFields回填到主画面，第1个字段会触发modifieldField_或者modifiedEditor_方法，从第2个字段起不会触发
	
				//TODO
	
				if (formModule.classAlias == "FormModuleLookup") {
					formModule.lookupReturnServer(task.arg);
				}
			}
		}, {
			key: 'formCmd',
			value: function formCmd(task, formModule, tasks) {
				var methodName;
				var methodArg;
				if (typeof task.arg == "string") {
					methodName = task.arg;
					methodArg = null;
				} else {
					var obj = task.arg;
					methodName = obj["methodName"];
					methodArg = obj["methodArg"];
				}
	
				if (methodName.indexOf(".") != -1) return;
				var isLookup = formModule.classAlias == "FormModuleLookup";
				var argInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, isLookup ? "FormLookup" : formModule.menuItemId, formModule.props.formId);
				if (!argInfo) return;
	
				if (argInfo.prefetch == true) {
					if (!argInfo.commandResult) return;
					var newTasks = argInfo.commandResult.tasks;
					CommandResolver.resolve(newTasks, formModule);
				} else {
					var _alias = null;
					var _group = CommandResolver.getTaskGroup(task, formModule);
					if (_group) {
						_alias = _group.groupAlias;
					}
	
					var cmdarg = CommandResolver.getSendCmd(formModule, _alias, argInfo);
					cmdarg.argObject = methodArg;
					var command = _CommandHelper2.default.createFormInstance(formModule.formName, methodName, "CommandResult");
					command.appendArg(cmdarg, "CommandArg");
	
					var _resultHandler = function _resultHandler(data) {
						var newCr = data.result;
						if (newCr && newCr.tasks && newCr.tasks.length > 0) {
							var newTasks = newCr.tasks.reverse();
							if (!tasks) tasks = [];
							for (var i = 0; i < newTasks.length; i++) {
								tasks.unshift(newTasks[i]);
							}
						}
						if (tasks) var task = tasks.shift();
						if (task) CommandResolver.doResolveTask(task, formModule, tasks);
					};
					var remoteArg = { command: command, resultFunction: _resultHandler };
					if (!tasks || tasks.length == 0) remoteArg.sync = false;
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			}
		}, {
			key: 'changeQuery',
			value: function changeQuery(task, group, formModule) {
				var queryTable = task.arg;
				if (!queryTable) return;
				var query = {
					nextInnerId: 10000, qname: "Query", Properties: {
						Title: { V: "" }, Status: { V: "Open" }, Literals: { V: "forcePlaceholders" },
						UseCache: { V: true }, FetchType: { V: "List" }, CreatedDate: { V: "" },
						CreatedTime: { V: "" }, CreatedBy: { V: "" }, ModifiedDate: { V: "" },
						ModifiedTime: { V: "" }, ModifiedBy: { V: "" }
					}
				};
				var queryCopy = query;
				var targetGroup;
	
				if (group && group.groupAlias == queryTable.aliasName) {
					targetGroup = group;
				} else {
					for (var _key in formModule.formDataSources.groups) {
						var item = formModule.formDataSources.groups[_key];
						if (item.groupAlias == queryTable.aliasName) {
							targetGroup = item;
							break;
						}
					}
				}
	
				if (!targetGroup) {
	
					return;
				}
				queryCopy.QueryTable = _QueryUtil2.default.convertQueryTable2XML(queryTable, queryCopy);
				var targetQuery = queryCopy;
				var type = task.cmd;
	
				if (type == _Cmd2.default.UpdateQueryCurrent) {
					targetGroup.reSetCurrentQuery(targetQuery);
				} else if (type == _Cmd2.default.UpdateQueryForm) {
					targetGroup.formQuery = targetQuery;
				} else if (type == _Cmd2.default.UpdateQuery) {
					targetGroup.reSetCurrentQuery(targetQuery);
					targetGroup.formQuery = JSON.parse(JSON.stringify(targetQuery));
				}
			}
		}, {
			key: 'addTempRecord',
			value: function addTempRecord(task, formModule) {
				var ac = task.arg;
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.addTempRecords(ac);
			}
		}, {
			key: 'refreshTempRecord',
			value: function refreshTempRecord(task, formModule) {
				setTimeout(function () {
					var ac = task.arg;
					var _group = CommandResolver.getTaskGroup(task, formModule);
					if (_group) {
						_group.refreshTempRecordPartly(ac);
						/*if(task.control == "refreshPart")
	     {
	     	_group.refreshTempRecordPartly(ac);
	     }
	     else
	     {
	     	_group.refreshTempRecord(ac);
	     }*/
					}
				}, 500);
			}
		}, {
			key: 'clearTempRecord',
			value: function clearTempRecord(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.clearTempRecord();
			}
		}, {
			key: 'doLocateToRecord',
			value: function doLocateToRecord(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) {
					if (task.arg) _group.locateRecord(task.arg);
				}
			}
		}, {
			key: 'doLocateRecord',
			value: function doLocateRecord(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				var type = task.arg;
				if (_group) {
					if (type == "NextPage") _group.recordNextPage(false, _group.groupAlias, _group.formDataSources.formModule.instanceUUId);else if (type == "PrevPage") _group.recordPrevPage(false, _group.groupAlias, _group.formDataSources.formModule.instanceUUId);else if (type == "Prev") _group.doRecordPrev();else if (type == "Next") _group.doRecordNext();else if (type == "First") _group.recordFirst(_group.groupAlias, _group.formDataSources.formModule.instanceUUId);else if (type == "Last") _group.recordLast(_group.groupAlias, _group.formDataSources.formModule.instanceUUId);
				}
			}
		}, {
			key: 'doRecordNew',
			value: function doRecordNew(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.doRecordNew();
			}
		}, {
			key: 'doRecordDelete',
			value: function doRecordDelete(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.doRecordDelete(true, false);
			}
		}, {
			key: 'doRecordSave',
			value: function doRecordSave(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.doRecordSave(true);
			}
		}, {
			key: 'doClientRecordRefresh',
			value: function doClientRecordRefresh(task, formModule) {
				if (!task.arg) return;
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.doRefreshOnClient(task.arg);
			}
		}, {
			key: 'doUpdateGroupCollapseState',
			value: function doUpdateGroupCollapseState(task, formModule) {
				if (task.control) {
					var _arg = {};
					_arg[task.control] = task.arg;
					_CmdTypeActions2.default.updateGroupCollapseState(_arg);
				} else {
					if (task.arg) {
						_CmdTypeActions2.default.updateGroupCollapseState(task.arg);
					}
				}
			}
		}, {
			key: 'exeParentCmdResult',
			value: function exeParentCmdResult(task, formModule) {
				var _parentWindow = window.parent.window;
				_parentWindow.exeParentCommandResult(argCaller.calleruuId, task.arg);
			}
	
			//TODO 目前一些需要远程的函数 都由命令调用 且目前全部为异步 其可以支持是否同步 命令在调用时应该做一些判断 尽量异步 
	
		}, {
			key: 'doRecordRestore',
			value: function doRecordRestore(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (!_group) return;
				var sync = false;
				var updateRelate = true;
				if (task) {
					if (typeof task.arg == "boolean") {
						updateRelate = task.arg;
					} else if (_typeof(task.arg) == "object") {
						if (task.arg.hasOwnProperty("sync")) sync = task.arg.sync;
						if (task.arg.hasOwnProperty("updateRelate")) updateRelate = task.arg.updateRelate;
					}
				}
				_group.doRecordRestore(sync, updateRelate, false);
			}
		}, {
			key: 'refreshToolBar',
			value: function refreshToolBar(group) {
				if (group.formDataSources.formModule.classAlias != "FormModuleLookup") group.activeToolBarByRecord(group.currentRecord);
			}
		}, {
			key: 'doDsAllowEdit',
			value: function doDsAllowEdit(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				if (group) {
					group.ds_AllowEdit = task.arg;
					_CmdTypeActions2.default.dsAllowEdit(group.groupAlias);
				}
			}
		}, {
			key: 'doDsAllowAdd',
			value: function doDsAllowAdd(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				group.ds_AllowAdd = task.arg;
				CommandResolver.refreshToolBar(group);
			}
		}, {
			key: 'doDsAllowAttachment',
			value: function doDsAllowAttachment(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				group.ds_AllowAttachment = task.arg;
				CommandResolver.refreshToolBar(group);
			}
		}, {
			key: 'doDsAllowDelete',
			value: function doDsAllowDelete(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				group.ds_AllowDelete = task.arg;
				CommandResolver.refreshToolBar(group);
			}
		}, {
			key: 'doDsAllowExport',
			value: function doDsAllowExport(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				group.ds_AllowExport = task.arg;
				CommandResolver.refreshToolBar(group);
			}
		}, {
			key: 'doDsAllowQuery',
			value: function doDsAllowQuery(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				group.ds_AllowQuery = task.arg;
				CommandResolver.refreshToolBar(group);
			}
		}, {
			key: 'doDsAllowSave',
			value: function doDsAllowSave(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				group.ds_AllowSave = task.arg;
				CommandResolver.refreshToolBar(group);
			}
		}, {
			key: 'setControlFocus',
			value: function setControlFocus(task, formModule) {
				var controlItem = _FormItemUtil2.default.getFormItemControl("ctrl_" + task.control, formModule.classAlias == "FormModuleLookup" ? true : false);
				_FocusActions2.default.focusSet(formModule.formId, controlItem.xml.id);
				formModule.setBeforeInitFocusInControlId(controlItem.xml.id);
				/*
	   var formItem:GongqiFormItem = formDesign.items["ctrl_"+id] as GongqiFormItem;
	   if(formItem && formItem.control == null)
	   {
	   	formDesign.formModule.setBeforeInitFocusInControlId("ctrl_"+id);
	   }
	   else
	   {
	   	formDesign.formModule.focusController.findControlAndSetFocus("ctrl_"+id);
	   }*/
			}
		}, {
			key: 'changeTabPage',
			value: function changeTabPage(task, formModule) {
				var newIndex = 0;
				var tabPageName = task.control;
				var formitemtabpage = _FormItemUtil2.default.getFormItemControl("ctrl_" + tabPageName, false);
				if (!formitemtabpage) return;
				var formItem = formitemtabpage.parentControl;
				newIndex = formItem.childrenControl.indexOf(formitemtabpage);
	
				if (formItem.classAlias == "FormItemTabControl") {
					/*var tab:TabNavigator = TabNavigator(FormItem_Tab(formItem).control);
	    if(tab)
	    {
	    	var index:int = tab.selectedIndex;
	    	if(newIndex == index)
	    		return;
	    	var total:int = tab.numChildren;
	    	if(total == 0)
	    		return;
	    	if(newIndex>=total)
	    		newIndex = 0;
	    }*/
	
					var switchArg = { tabName: formItem.xml.name, moduleInstanceId: formModule.instanceUUId, newIndex: newIndex, complete: false };
					_CmdTypeActions2.default.switchTabPage(switchArg);
					if (!switchArg.complete) {
						var wrapindex = newIndex;
						var formitem_tabpage = formItem.childrenControl[wrapindex];
						if (formitem_tabpage && formitem_tabpage.getProperty_Visible_Final() == false) return;
	
						formItem.setInitSelectIndex(newIndex);
						//TODO 如果是在beforeInit中做二次开发 是否考虑对于自动定位的影响
						//formDesign.formModule.setBeforeInitChangeTabPage(true);
					}
				}
			}
		}, {
			key: 'doRecordConditionTask',
			value: function doRecordConditionTask(task, formModule) {
				var jca = task.arg;
				if (!jca) return;
				var group = CommandResolver.getTaskGroup(task, formModule);
				if (!group) return;
				if (!jca.isNull) {
					// currentRecord
					if (group.analysisConditionSingleRecord(null, jca)) {
						CommandResolver.resolve(jca.trueCommandResult.tasks.concat(), formModule);
					} else if (jca.falseCommandResult && jca.falseCommandResult.tasks && jca.falseCommandResult.tasks.length > 0) {
						CommandResolver.resolve(jca.falseCommandResult.tasks.concat(), formModule);
					}
				} else {
					group.afterRecordConditionTask = task.arg;
				}
			}
		}, {
			key: 'analysisConditionSingleValue',
			value: function analysisConditionSingleValue(callerDataField, callerMenuItemId, menuItemId, value, formParamCondition) {
				if (!formParamCondition) return true;
				if (!formParamCondition.getSqlWhereStr) formParamCondition.getSqlWhereStr = _FormParamCondition2.default.getSqlWhereStr;
				var ws = formParamCondition.getSqlWhereStr();
				//对象中的函数要删掉 如果在beforeInit中执行 逻辑执行会在存储到H5Storage之前 则造成Storage put失败 因为函数无法clone
				delete formParamCondition.getSqlWhereStr;
				if (ws == "") return true;
				var wsa = ws.split(" ");
				var wsr = "";
				for (var i = 0; i < wsa.length; i++) {
					var s = wsa[i];
					if (s.indexOf("=") == -1) {
						wsr += s;
					} else {
						var fn = _StringUtil2.default.convertToFirstLowerCase(s.substring(0, s.indexOf("=")));
						var fv = s.substr(s.indexOf("=") + 1);
	
						if (fn.indexOf(".") != 0) //fn == .fieldName
							continue;
						if (_RecordsUtil2.default.analysisValue(fn == ".menuItemId" ? menuItemId : fn == ".callerMenuItemId" ? callerMenuItemId : fn == ".callerLookupField" ? callerDataField : value, fv))
							//if(RecordsUtil.analysisValue((fn==".menuItemId"?menuItemId:value),fv))
							{
								wsr += "1";
							} else {
							wsr += "0";
						}
					}
				}
	
				return _StringUtil2.default.evalLEString(_StringUtil2.default.trimThrough(wsr));
			}
		}, {
			key: 'doFormParamConditionTasks',
			value: function doFormParamConditionTasks(task, formModule) {
				var list;
				if (Array.isArray(task.arg)) list = task.arg;else list = [task.arg];
				for (var i = 0; i < list.length; i++) {
					var ca = list[i];
					var menuItemId = formModule.menuItemId;
					//不支持自定义下拉框
					var parameters = window.argCaller ? window.argCaller.parameters : null;
					if (!menuItemId && !parameters) return;
					var isLookup = formModule.classAlias == "FormModuleLookup";
					var caller = isLookup ? formModule.props.argCaller : window.argCaller;
					//formDesign.formModule.argCaller.caller as FormModule; 
	
					var callerMenuItemId = caller ? caller.callerMenuItemId : "null";
					var callerDataField = caller ? caller.callerDataField : "null";
					if (!menuItemId && !parameters && !callerMenuItemId && !callerDataField) return;
	
					var bool = CommandResolver.analysisConditionSingleValue(callerDataField, callerMenuItemId, menuItemId, parameters, ca.formParamCondition);
					if (bool) {
						var commandResult = ca.trueCommandResult;
					} else {
						commandResult = ca.falseCommandResult;
					}
	
					if (!commandResult) continue;else if (commandResult.tasks) CommandResolver.resolve(commandResult.tasks.concat(), formModule);
				}
			}
		}, {
			key: 'doFormContext',
			value: function doFormContext(task, formModule) {
				if (_typeof(task.arg) == "object") {
					var fca = task.arg;
					if (fca.cmdType == _ContextMapArg2.default.PUT) {
						formModule.contextMap[fca.key] = fca.value;
					} else if (fca.cmdType == _ContextMapArg2.default.REMOVE) {
						delete formModule.contextMap[fca.key];
					} else if (fca.cmdType == _ContextMapArg2.default.CLEAR) {
						formModule.contextMap = {};
					}
				}
			}
		}, {
			key: 'showDialog',
			value: function showDialog(task, formModule) {
				var $dialogModal = $("#dialogModal");
				var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("align-items", "center").css("justify-content", "center").appendTo($dialogModal);
				_reactDom2.default.render(_react2.default.createElement(_DialogForm2.default, { dialogArg: task.arg }), modalDiv[0]);
			}
		}, {
			key: 'doRefreshPlugin',
			value: function doRefreshPlugin(task, formModule) {
				var result = [];
				_CmdTypeActions2.default.refreshPlugin(task, task.control, formModule.formId, result);
				if (result.length == 0) {
					var key = "pluginLaterArg." + formModule.formId + "." + task.control;
					if (!window[key]) window[key] = { tasks: [task] };
					window[key].tasks.push(task);
				}
			}
		}, {
			key: 'addTimer',
			value: function addTimer(task, formModule) {
				var timerTaskRemote = task.arg;
				var timerHandlerFunction = function timerHandlerFunction() {
					CommandResolver.timerHandler(timerTaskRemote.formCmd, timerTaskRemote.formCmdArgObject, formModule);
				};
	
				_TimerTasksUtil2.default.addTimer(timerTaskRemote.timerId, timerTaskRemote.delay, timerHandlerFunction, timerTaskRemote.repeatCount);
			}
		}, {
			key: 'cancelTimer',
			value: function cancelTimer(task, formModule) {
				var timerId = task.arg;
				_TimerTasksUtil2.default.cancelTimer(timerId);
			}
		}, {
			key: 'timerHandler',
			value: function timerHandler(formCmdMethodName, formCmdArgObject, formModule) {
				var arg = {};
				arg["methodName"] = formCmdMethodName;
				arg["methodArg"] = formCmdArgObject;
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				commandTask.arg = arg;
				CommandResolver.formCmd(commandTask, formModule);
			}
		}, {
			key: 'doSetFormTitle',
			value: function doSetFormTitle(task, formModule) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					if (!window.isPopUp) {
						_parentWindow.setFormLabel(window.formModuleInstanceuuId, task.arg);
					} else {
						formModule.formLabel = task.arg;
						var propFormName = formModule.formName;
						if (propFormName) {
							var formNameChanged = propFormName.replace(/\./g, "_");
							var titleDomSelector = "#app>#" + formNameChanged + " .modal-title";
							$(titleDomSelector).text(task.arg);
						}
					}
				}
			}
		}, {
			key: 'restoreParent',
			value: function restoreParent(task, formModule, tasks) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (!_group && formModule.formDataSources) {
					_group = formModule.formDataSources.currentGroup;
				}
	
				if (_group && _group.linkGroup && _group.linkGroup.currentRecord) {
					var _parentGroup = _group.linkGroup;
					//TODO 原来Flex在这个命令中只恢复currentRecord 没有考虑到selectedRecords的情况CommandResolver.setFormDataSourceGroupArg(_parent, _arg);
					//if(_arg.recordCounts==1)
					window.remainTasks = tasks;
					_parentGroup.doRecordRestore(true, task.arg, false);
					var formModule1 = _parentGroup.formDataSources.formModule;
					var formModule2 = window.formModuleInstance;
					if (formModule1 && formModule2) {
						if (formModule1.instanceUUId != formModule2.instanceUUId) return false;
					}
					return true;
				} else {
					if (window.argCaller && window.argCaller.joinGroupAlias) {
						var _parentWindow = window.parent.window;
						var formInstance = _parentWindow.getFormInstanceByUUID(argCaller.calleruuId);
	
						if (formInstance && formInstance.formDataSources && formInstance.formDataSources.sources) {
							var _parentGroup2 = formInstance.formDataSources.groups[window.argCaller.joinGroupAlias];
							if (_parentGroup2) {
								_parentGroup2.doRecordRestore(true, task.arg, false);
							} else {
								_Warn2.default.show({ text: "由于找不到父页面或没有找到父页面的数据源 所以无法执行RestoreParent" });
							}
						} else {
							_Warn2.default.show({ text: "由于找不到父页面或没有找到父页面的数据源 所以无法执行RestoreParent" });
						}
					} else {
						_Warn2.default.show({ text: "由于找不到父页面 所以无法执行RestoreParent" });
					}
				}
			}
		}, {
			key: 'doClientRecordRemove',
			value: function doClientRecordRemove(task, formModule) {
				var group = CommandResolver.getTaskGroup(task, formModule);
				if (Array.isArray(task.arg)) group.deleteRecordOnClient(task.arg);else group.deleteRecordOnClient([task.arg]);
			}
		}, {
			key: 'doSetControlProperty',
			value: function doSetControlProperty(task, formModule) {
				if (Array.isArray(task.arg)) {
					for (var i = 0; i < task.arg.length; i++) {
						var cpi = task.arg[i];
						var key = void 0;
						if (formModule.classAlias == "FormModuleLookup") {
							key = "FormLookup." + formModule.formId + "." + cpi.controlName;
						} else {
							key = "ctrl_" + cpi.controlName;
						}
	
						var gongqiFormItem = _FormItemUtil2.default.getFormItemControl(key, formModule.classAlias == "FormModuleLookup" ? true : false);
						if (gongqiFormItem) {
							gongqiFormItem.setControlProperty(cpi.propertyName, cpi.propertyValue);
						}
					}
				} else {
					var _cpi = task.arg;
					var _key2 = void 0;
					if (formModule.classAlias == "FormModuleLookup") {
						_key2 = "FormLookup." + formModule.formId + "." + _cpi.controlName;
					} else {
						_key2 = "ctrl_" + _cpi.controlName;
					}
					var _gongqiFormItem = _FormItemUtil2.default.getFormItemControl(_key2, formModule.classAlias == "FormModuleLookup" ? true : false);
					if (_gongqiFormItem) {
						_gongqiFormItem.setControlProperty(_cpi.propertyName, _cpi.propertyValue);
					}
				}
			}
		}, {
			key: 'isExtendsDataTypeArrayItem',
			value: function isExtendsDataTypeArrayItem(formItem, ainame, fieldgroupxml) {
				var cmpPro = _GOTUtil2.default.getProperty(fieldgroupxml, "Component");
				if (cmpPro.hasOwnProperty("refinnerid") || cmpPro.hasOwnProperty("refentityid")) {
					var extendsValue = formItem.xml.name; //GOTHelper.getPropertyValue(formItem.xml,"Extends");
					if (extendsValue) {
						var _index = extendsValue.lastIndexOf("_");
						if (_index != -1) {
							var datatypearrayitemname = extendsValue.substr(_index + 1);
						} else {
							datatypearrayitemname = extendsValue;
						}
						if (datatypearrayitemname == ainame) return true;
					}
				} else {
					var _name = fieldgroupxml.name;
					if (_name.indexOf("DimSelect_") == 0) {
						var itemName = formItem.xml.name;
						if (itemName.indexOf(_name) == 0) {
							if (itemName == ainame) return true;
						}
					}
				}
				return false;
			}
		}, {
			key: 'doSortFormItem',
			value: function doSortFormItem(task, formModule) {
				var key = void 0;
				if (formModule.classAlias == "FormModuleLookup") {
					key = "FormLookup." + formModule.formId + "." + task.control;
				} else {
					key = "ctrl_" + task.control;
				}
				var parentControl = _FormItemUtil2.default.getFormItemControl(key, formModule.classAlias == "FormModuleLookup" ? true : false);
				if (parentControl) {
					var fieldgroupxml = parentControl.xml;
					fieldgroupxml.FormItem = [];
					var array = task.arg; //array = ["Grade","Config","Color","Size","Serial","Batch"];
					var bak = parentControl.childrenControl;
	
					var nvector = [];
					for (var i = 0; i < array.length; i++) {
						var item = array[i];
						for (var j = 0; j < bak.length; j++) {
							var bakitem = bak[j];
							if (bakitem && bakitem.xml.name == item) {
								nvector.push(bakitem);
								fieldgroupxml.FormItem.push(bakitem.xml);
								bak[j] = null;
							}
						}
					}
	
					for (var _i8 = 0; _i8 < bak.length; _i8++) {
						var _bakitem = bak[_i8];
						if (_bakitem) {
							nvector.push(_bakitem);
							fieldgroupxml.FormItem.push(_bakitem.xml);
						}
					}
	
					parentControl.childrenControl = nvector;
					//重新赋值 原因应该为重新构造焦点管理 默认设置已经被改变 不需要删除
					formModule.focusController = new _FocusController2.default(formModule.props.xml.FormDesign, formModule);
				}
			}
		}, {
			key: 'doSortComponent',
			value: function doSortComponent(task, formModule) {
				var key = void 0;
				if (formModule.classAlias == "FormModuleLookup") {
					key = "FormLookup." + formModule.formId + "." + task.control;
				} else {
					key = "ctrl_" + task.control;
				}
				var fieldgroup = _FormItemUtil2.default.getFormItemControl(key, formModule.classAlias == "FormModuleLookup" ? true : false);
				if (fieldgroup) {
					var fieldgroupxml = fieldgroup.xml;
					fieldgroupxml.FormItem = [];
					var array = task.arg;
					//array = ["Grade","Config","Color","Size","Serial","Batch"];
					var bak = fieldgroup.childrenControl;
	
					var nvector = [];
					for (var i = 0; i < array.length; i++) {
						var item = array[i];
						for (var j = 0; j < bak.length; j++) {
							var bakitem = bak[j];
							if (bakitem && CommandResolver.isExtendsDataTypeArrayItem(bakitem, item, fieldgroupxml)) {
								nvector.push(bakitem);
								fieldgroupxml.FormItem.push(bakitem.xml);
								bak[j] = null;
							}
						}
					}
	
					for (var _i9 = 0; _i9 < bak.length; _i9++) {
						var _bakitem2 = bak[_i9];
						if (_bakitem2) {
							nvector.push(_bakitem2);
							fieldgroupxml.FormItem.push(_bakitem2.xml);
						}
					}
	
					fieldgroup.childrenControl = nvector;
					//重新赋值 原因应该为重新构造焦点管理 默认设置已经被改变 不需要删除
					formModule.focusController = new _FocusController2.default(formModule.props.xml.FormDesign, formModule);
				}
			}
		}, {
			key: 'doDimAdjustFormDataSourceField',
			value: function doDimAdjustFormDataSourceField(task, formModule) {
				if (!formModule.dimAdjustFormDataSourceField) {
					formModule.dimAdjustFormDataSourceField = task.arg;
				} else {
					for (var i in formModule.dimAdjustFormDataSourceField) {
						var map = formModule.dimAdjustFormDataSourceField[i];
						var map2 = task.arg[i];
						for (var dataSource in map2) {
							if (map && map[dataSource]) {
								Object.assign(map[dataSource], map2[dataSource]);
							} else if (!map) {
								map = {};
								map[dataSource] = {};
								Object.assign(map[dataSource], map2[dataSource]);
								formModule.dimAdjustFormDataSourceField[i] = map;
							} else {
								if (!map[dataSource]) {
									map[dataSource] = {};
								}
								Object.assign(map[dataSource], map2[dataSource]);
							}
						}
						// for(let j in task.arg){
						// 	if(i == j ){
						// 		if(map || task.arg[j]){
						// 			if(!map)map={};
						// 			if(!task.arg[j])task.arg[j]={};
						// 			Object.assign(map,task.arg[j])
						// 		}
						// 	}
						// }
					}
				};
			}
		}, {
			key: 'doShowInfo',
			value: function doShowInfo(task) {
				var arg = task.arg;
				_Warn2.default.show({ text: arg.info, state: "info", title: arg.title });
				//GlobalInfoDisplayer.show(task.arg as ShowInfoArg);
			}
		}, {
			key: 'deleteTempRecord',
			value: function deleteTempRecord(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) {
					var queryTable = task.arg;
					if (queryTable) {
						_group.deleteTempRecords(queryTable);
					}
				}
			}
		}, {
			key: 'activeRecord',
			value: function activeRecord(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) _group.activeRecordRemote();
			}
		}, {
			key: 'updateToolBar',
			value: function updateToolBar(task, formModule) {
				if (formModule) formModule.updateToolBar(task.arg);
			}
		}, {
			key: 'doClientRecordAdd',
			value: function doClientRecordAdd(task, formModule) {
				//alert("clientRecordAdd");
				if (!task.arg) return;
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) {
					if (task.arg.location) _group.rpc_result_doRecordNew2({ result: task.arg.data, location: task.arg.location });else _group.rpc_result_doRecordNew2({ result: task.arg });
				}
			}
		}, {
			key: 'writeField',
			value: function writeField(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) {
					var resultValue = {};
					if (task.control) {
						resultValue[task.control] = task.arg;
					} else {
						resultValue = task.arg;
					}
					_group.doWriteField(resultValue, true);
				}
			}
		}, {
			key: 'doWriteField',
			value: function doWriteField(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group) {
					var resultValue = {};
					if (task.control) {
						resultValue[task.control] = task.arg;
					} else {
						resultValue = task.arg;
					}
					_group.doWriteField(resultValue, false);
				}
			}
		}, {
			key: 'doWriteDataMethodField',
			value: function doWriteDataMethodField(task, formModule) {
				var _group = CommandResolver.getTaskGroup(task, formModule);
				if (_group && task.arg) {
					_group.updateDataMethodFieldValue(task.arg);
				}
			}
		}, {
			key: 'holdFocusIn',
			value: function holdFocusIn(task, formModule) {
				var controlItem = _FormItemUtil2.default.getFormItemControl("ctrl_" + task.control, formModule.classAlias == "FormModuleLookup" ? true : false);
				_FocusActions2.default.holdFocusIn(formModule.formId, controlItem.xml.id);
				controlItem.holdFocus = true;
			}
		}, {
			key: 'registerRender',
			value: function registerRender(task, formModule) {
				var resultValue = {};
				if (task.control) {
					resultValue[task.control] = { render: task.arg, editable: task.editorEditable };
				} else {
					resultValue = task.arg;
				}
				Object.assign(formModule.rendersObject, resultValue);
			}
		}, {
			key: 'dragStart',
			value: function dragStart(task, formModule) {
				var dragStartHandler = task.arg;
				var resultValue = {};
				var columnName = task.control;
				if (columnName) {
					resultValue[columnName] = { handler: dragStartHandler };
				}
	
				Object.assign(formModule.dragStartObjects, resultValue);
			}
		}, {
			key: 'showCalculator',
			value: function showCalculator(task, formModule) {
				if (task.arg && typeof task.arg == "function") window.parent.window.showCaculator("clear", task.arg);
			}
		}, {
			key: 'updateDropDownContent',
			value: function updateDropDownContent(task, formModule) {
				if (task.arg) {
					_CmdTypeActions2.default.updateDropDownContent(task.arg, task.control, formModule.instanceUUId);
				}
			}
		}, {
			key: 'doSysReinitForm',
			value: function doSysReinitForm(task, formModule, tasks) {
				if (task.arg) {
					var _formId = task.arg;
					if (window.doReinitForm1) window.doReinitForm1(_formId, formModule, tasks);
				}
			}
		}, {
			key: 'showClipboard',
			value: function showClipboard(task, formModule) {
				if (task.arg) {
					var container = document.getElementById('remotePasteDialogModal');
					//if(window.parent){window.parent.window.showClipboard(task);return;}
					//container = window.parent.document.getElementById('remotePasteDialogModal');
					_reactDom2.default.render(_react2.default.createElement(_RemotePasteDialog2.default, { remotearg: task.arg, task: task }), container);
					$(container).css("display", "flex");
				}
			}
		}, {
			key: 'showImage',
			value: function showImage(task, formModule) {
				var source = task.arg;
				/*if(typeof(source) == "string")
	   {
	   	var controlItem = FormItemUtil.getFormItemControl("ctrl_"+task.arg,false);
	   	if(controlItem && controlItem.classAlias == "FormItemImageControl")
	   	{
	   		return;
	   	}
	   }*/
	
				if (source) {
					if (source.indexOf("http://") == 0) {
						$("#global_ShowImageCmdHelpImg").attr("src", source);
					} else if (source.indexOf("data:image/") == 0) {
						$("#global_ShowImageCmdHelpImg").attr("src", source);
					} else {
						$("#global_ShowImageCmdHelpImg").attr("src", "data:image/jpeg;base64," + source);
					}
	
					//$("#global_ShowImageCmdHelpDiv").viewer({url: 'data-original',navbar:false,fullscreen:false});
					$("#global_ShowImageCmdHelpDiv").viewer("show");
				}
			}
		}, {
			key: 'CallClientMethod',
			value: function CallClientMethod(task, formModule) {
				_LayerManager2.default.executeLayerMethod(formModule, null, task.control, task.arg);
			}
		}, {
			key: 'clientSelectRecords',
			value: function clientSelectRecords(task, formModule) {
				_CmdTypeActions2.default.selectRecords(task);
			}
		}, {
			key: 'dsAttachmentAllowDelete',
			value: function dsAttachmentAllowDelete(task, formModule) {
				formModule.dsAttachmentAu["del"] = task.arg;
			}
		}, {
			key: 'dsAttachmentAllowRename',
			value: function dsAttachmentAllowRename(task, formModule) {
				formModule.dsAttachmentAu["rename"] = task.arg;
			}
		}, {
			key: 'dsAttachmentAllowUpload',
			value: function dsAttachmentAllowUpload(task, formModule) {
				formModule.dsAttachmentAu["upload"] = task.arg;
			}
		}, {
			key: 'dsAttachmentAllowVisible',
			value: function dsAttachmentAllowVisible(task, formModule) {
				formModule.dsAttachmentAu["visible"] = task.arg;
			}
		}, {
			key: 'doOpenLuckySheet',
			value: function doOpenLuckySheet(task, formModule) {
				if (task.arg) {
					var _fileId = JSON.parse(task.arg);
					var _parentWindow = window.didomain ? window : window.parent.window;
					if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea) {
						if (typeof window.openTemplateDesign() == 'function') {
							_parentWindow = window;
						} else if (typeof window.parent.window.openTemplateDesign() == 'function') {
							_parentWindow = window.parent.window;
						} else {
							_parentWindow = window.parent.parent.window;
						}
						_parentWindow.openTemplateDesign(_fileId);
					} else {
	
						if (window.openLuckySheet && typeof window.openLuckySheet == 'function') {
							_parentWindow = window;
						} else if (window.parent.openLuckySheet && typeof window.parent.window.openLuckySheet == 'function') {
							_parentWindow = window.parent.window;
						} else {
							_parentWindow = window.parent.parent.window;
						}
						_parentWindow.menuItemId = formModule.menuItemId;
						_parentWindow.formModuleInstance = formModule;
						_parentWindow.openLuckySheet(_fileId);
					}
				}
			}
		}, {
			key: 'doUpdateAllowEditorNotSelectAll',
			value: function doUpdateAllowEditorNotSelectAll(task, formModule) {
	
				var _parentWindow = window;
				if (window.notClickFocusEditors && typeof window.updateEditorNotClickFocus == 'function') {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditors && typeof window.parent.window.updateEditorNotClickFocus == 'function') {
					_parentWindow = window.parent.window;
				} else {
					_parentWindow = window.parent.parent.window;
				}
				_parentWindow.menuItemId = formModule.menuItemId;
				_parentWindow.formModuleInstance = formModule;
				if (_parentWindow.notClickFocusEditors) {
					_parentWindow.updateEditorNotClickFocus(task.arg, formModule);
				}
			}
		}, {
			key: 'doPrintReport',
			value: function doPrintReport(task, formModule) {
				var _parentWindow = window;
				if (window.doPrintReport && typeof window.doPrintReport == 'function') {
					_parentWindow = window;
				} else if (window.parent.window.doPrintReport && typeof window.parent.window.doPrintReport == 'function') {
					_parentWindow = window.parent.window;
				} else {
					_parentWindow = window.parent.parent.window;
				}
				if (_parentWindow.doPrintReport) {
					_parentWindow.doPrintReport(task, formModule);
				}
			}
		}]);
	
		return CommandResolver;
	}();
	
	CommandResolver.tmpXMLHttpRequest = null;
	exports.default = CommandResolver;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupCurrentRecordChangedNotGridUserOpStore = exports.GroupCurrentRecordChangedStore = exports.AutoSaveBeforeStore = exports.RecordNewStore = exports.RecordFetchAllStore = exports.RecordRefreshStore = exports.RecordPrevStore = exports.RecordLastStore = exports.RecordFirstStore = exports.RecordPrevPageStore = exports.RecordNextPageStore = exports.RecordNextStore = exports.RecordsRestoreCmpStore = exports.RenderUpdateModifiedTagStore = exports.RecordAutoSaveCmpStore = exports.RecordAutoSaveStore = exports.RecordDataMethodFieldChangedStore = exports.RecordFieldChangeStore = exports.DataGridUserChangeStore = exports.RecordsCmpStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecordsCmpStore = exports.RecordsCmpStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.recordsCmp, 'onRecordsCmp');
	    },
	    onRecordsCmp: function onRecordsCmp(data, groupAlias, groupSource, immediately) {
	        this.trigger(data, groupAlias, groupSource, immediately);
	    }
	});
	
	var DataGridUserChangeStore = exports.DataGridUserChangeStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.dataGridUserChanged, 'onDataGridUserChanged');
	    },
	    onDataGridUserChanged: function onDataGridUserChanged(currentRecord, groupAlias, gridId, moduleInstanceId) {
	        var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	        this.trigger(currentRecord, groupAlias, gridId, moduleInstanceId, delay);
	    }
	});
	
	var RecordFieldChangeStore = exports.RecordFieldChangeStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordFieldChanged, 'onRecordFieldChanged');
	    },
	    onRecordFieldChanged: function onRecordFieldChanged(record, dataField, oldValue, newValue, observer) {
	        this.trigger(record, dataField, oldValue, newValue, observer);
	    }
	});
	
	var RecordDataMethodFieldChangedStore = exports.RecordDataMethodFieldChangedStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordDataMethodFieldChanged, 'onRecordDataMethodFieldChanged');
	    },
	    onRecordDataMethodFieldChanged: function onRecordDataMethodFieldChanged(dataField) {
	        this.trigger(dataField);
	    }
	});
	
	var RecordAutoSaveStore = exports.RecordAutoSaveStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordAutoSave, 'onRecordAutoSave');
	    },
	    onRecordAutoSave: function onRecordAutoSave(groupAlias, results) {
	        this.trigger(groupAlias, results);
	    }
	});
	
	var RecordAutoSaveCmpStore = exports.RecordAutoSaveCmpStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordAutoSaveCmp, 'onRecordAutoSaveCmp');
	    },
	    onRecordAutoSaveCmp: function onRecordAutoSaveCmp(groupAlias, record) {
	        this.trigger(groupAlias, record);
	    }
	});
	
	var RenderUpdateModifiedTagStore = exports.RenderUpdateModifiedTagStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RenderUpdateModifiedTag, 'onRenderUpdateModifiedTag');
	    },
	    onRenderUpdateModifiedTag: function onRenderUpdateModifiedTag(groupAlias, record) {
	        this.trigger(groupAlias, record);
	    }
	});
	
	var RecordsRestoreCmpStore = exports.RecordsRestoreCmpStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordsRestoreCmp, 'onRecordsRestoreCmp');
	    },
	    onRecordsRestoreCmp: function onRecordsRestoreCmp(groupAlias, records, moduleInstanceId) {
	        this.trigger(groupAlias, records, moduleInstanceId);
	    }
	});
	
	var RecordNextStore = exports.RecordNextStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordNext, 'onRecordNext');
	    },
	    onRecordNext: function onRecordNext(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordNextPageStore = exports.RecordNextPageStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordNextPage, 'onRecordNextPage');
	    },
	    onRecordNextPage: function onRecordNextPage(onlyFetch, groupAlias, moduleInstanceId) {
	        this.trigger(onlyFetch, groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordPrevPageStore = exports.RecordPrevPageStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordPrevPage, 'onRecordPrevPage');
	    },
	    onRecordPrevPage: function onRecordPrevPage(onlyFetch, groupAlias, moduleInstanceId) {
	        this.trigger(onlyFetch, groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordFirstStore = exports.RecordFirstStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordFirst, 'onRecordFirst');
	    },
	    onRecordFirst: function onRecordFirst(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordLastStore = exports.RecordLastStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordLast, 'onRecordLast');
	    },
	    onRecordLast: function onRecordLast(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordPrevStore = exports.RecordPrevStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordPrev, 'onRecordPrev');
	    },
	    onRecordPrev: function onRecordPrev(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordRefreshStore = exports.RecordRefreshStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordRefresh, 'onRecordRefresh');
	    },
	    onRecordRefresh: function onRecordRefresh(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordFetchAllStore = exports.RecordFetchAllStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordFetchAll, 'onRecordFetchAll');
	    },
	    onRecordFetchAll: function onRecordFetchAll(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var RecordNewStore = exports.RecordNewStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.RecordNew, 'onRecordNew');
	    },
	    onRecordNew: function onRecordNew(groupAlias, moduleInstanceId) {
	        this.trigger(groupAlias, moduleInstanceId);
	    }
	});
	
	var AutoSaveBeforeStore = exports.AutoSaveBeforeStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.autoSaveBefore, 'onAutoSaveBefore');
	    },
	    onAutoSaveBefore: function onAutoSaveBefore(groupAlias) {
	        this.trigger(groupAlias);
	    }
	});
	
	var GroupCurrentRecordChangedStore = exports.GroupCurrentRecordChangedStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.groupCurrentRecordChanged, 'onGroupCurrentRecordChanged');
	    },
	    onGroupCurrentRecordChanged: function onGroupCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId, causeId, groupSource, parms) {
	        this.trigger(records, currentRecord, groupAlias, moduleInstanceId, causeId, groupSource, parms);
	    }
	});
	
	var GroupCurrentRecordChangedNotGridUserOpStore = exports.GroupCurrentRecordChangedNotGridUserOpStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_RecordsActions2.default.groupCurrentRecordChangedNotGridUserOp, 'onGroupCurrentRecordChangedNotGridUserOp');
	    },
	    onGroupCurrentRecordChangedNotGridUserOp: function onGroupCurrentRecordChangedNotGridUserOp(groupAlias) {
	        this.trigger(groupAlias);
	    }
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['recordsCmp', 'currentRecordChanged', 'dataGridUserChanged', 'RecordFieldChanged', 'RecordDataMethodFieldChanged', 'groupCurrentRecordChanged', 'RecordAutoSave', 'RecordAutoSaveCmp', 'RecordsRestoreCmp', 'LinkGroupActive', 'RecordNext', 'RecordNextPage', 'RecordPrev', 'RecordPrevPage', 'RecordFirst', 'RecordLast', 'RecordRefresh', 'RecordFetchAll', 'RecordNew', 'autoSaveBefore', 'RenderUpdateModifiedTag', 'groupCurrentRecordChangedNotGridUserOp']);

/***/ },
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GetColumnLengthProperties = exports.ButtonShortCutStore = exports.CallComponentFuncStore = exports.ReverseSelectRecordsStore = exports.SelectRecordsStore2 = exports.SelectAllRecordsStore = exports.GetSelectRecordsStore = exports.GetSelectRecordsKeyStore = exports.CommandMapEditorsStore = exports.DiaLogMapEditorsStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiaLogMapEditorsStore = exports.DiaLogMapEditorsStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.diaLogMapEditors, 'onDiaLogMapEditors');
		},
		onDiaLogMapEditors: function onDiaLogMapEditors(diaLogId, result) {
			this.trigger(diaLogId, result);
		}
	});
	
	var CommandMapEditorsStore = exports.CommandMapEditorsStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.commandArgMapEditors, 'onCommandArgMapEditors');
		},
		onCommandArgMapEditors: function onCommandArgMapEditors(name, map, moduleInstanceId) {
			this.trigger(name, map, moduleInstanceId);
		}
	});
	
	var GetSelectRecordsKeyStore = exports.GetSelectRecordsKeyStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.getSelectRecordsKey, 'onGetSelectRecordsKey');
		},
		onGetSelectRecordsKey: function onGetSelectRecordsKey(keys, groupAlias, menuItemId, formId, moduleInstanceId) {
			this.trigger(keys, groupAlias, menuItemId, formId, moduleInstanceId);
		}
	});
	
	var GetSelectRecordsStore = exports.GetSelectRecordsStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.getSelectRecords, 'onGetSelectRecords');
		},
		onGetSelectRecords: function onGetSelectRecords(selectedRecords, groupAlias, moduleInstanceId) {
			var containsSelectedRecordKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
			this.trigger(selectedRecords, groupAlias, moduleInstanceId, containsSelectedRecordKey);
		}
	});
	
	var SelectAllRecordsStore = exports.SelectAllRecordsStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.selectAllRecords, 'onSelectAllRecords');
		},
		onSelectAllRecords: function onSelectAllRecords(value, groupAlias, moduleInstanceId) {
			this.trigger(value, groupAlias, moduleInstanceId);
		}
	});
	
	/*export var SelectRecordsStore2 = Reflux.createStore(
	{
		init:function()
		{
			this.listenTo(CommandActions.selectedRecords2,'onSelectRecords2');
		},
		onSelectRecords2(value,groupAlias,moduleInstanceId,records)
		{
			this.trigger(value,groupAlias,moduleInstanceId,records);
		}
	});*/
	
	var SelectRecordsStore2 = exports.SelectRecordsStore2 = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.selectRecords2, 'onSelectRecords2');
		},
		onSelectRecords2: function onSelectRecords2(value, groupAlias, moduleInstanceId, records) {
			this.trigger(value, groupAlias, moduleInstanceId, records);
		}
	});
	
	var ReverseSelectRecordsStore = exports.ReverseSelectRecordsStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.reverseSelectedRecords, 'onReverseSelectedRecords');
		},
		onReverseSelectedRecords: function onReverseSelectedRecords(groupAlias) {
			this.trigger(groupAlias);
		}
	});
	
	var CallComponentFuncStore = exports.CallComponentFuncStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.callComponentFunc, 'onCallComponentFunc');
		},
		onCallComponentFunc: function onCallComponentFunc(entityId, innerId, funcName, funcArg, result) {
			this.trigger(entityId, innerId, funcName, funcArg, result);
		}
	});
	
	var ButtonShortCutStore = exports.ButtonShortCutStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_CommandActions2.default.buttonShortCut, 'onButtonShortCut');
		},
		onButtonShortCut: function onButtonShortCut(shortCut, moduleInstanceId) {
			this.trigger(shortCut, moduleInstanceId);
		}
	});
	
	var GetColumnLengthProperties = exports.GetColumnLengthProperties = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_CommandActions2.default.getColumnLengthProperties, 'onGetColumnLengthProperties');
		},
		onGetColumnLengthProperties: function onGetColumnLengthProperties(arg) {
			this.trigger(arg);
		}
	});

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommonUtil = function () {
		function CommonUtil() {
			_classCallCheck(this, CommonUtil);
		}
	
		_createClass(CommonUtil, [{
			key: "assignDisplayStyle",
			value: function assignDisplayStyle(_style, _displayStyle) {
				if (_displayStyle.Color) _style.color = _displayStyle.Color;
				if (_displayStyle.cssStyle) Object.assign(_style, _displayStyle.cssStyle);
				return _style;
			}
	
			/**
	    * 动态加载JS
	    * @param {string} url 脚本地址
	    * @param {function} callback  回调函数
	    */
	
		}], [{
			key: "calcResourcePath",
			value: function calcResourcePath(url) {
				var _url;
				if (url.substr(0, 5) == "@tmp/") {
					_url = window.parent.window.userInfos.serviceURL + "/tmp/" + url.substr(5);
				} else {
					_url = window.parent.window.userInfos.resourceURL + "/" + url;
				}
	
				return _url;
			}
		}, {
			key: "delayFunc",
			value: function delayFunc(delay, thisObj, f) {
				for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
					args[_key - 3] = arguments[_key];
				}
	
				var id = setTimeout(function () {
					clearTimeout(id);f.apply(thisObj, args);
				}, delay);
			}
		}, {
			key: "guid",
			value: function guid() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = Math.random() * 16 | 0,
					    v = c == 'x' ? r : r & 0x3 | 0x8;
					return v.toString(16);
				});
			}
		}, {
			key: "getUrlParam",
			value: function getUrlParam(token) {
				var reg = new RegExp("(^|&)" + token + "=([^&]*)(&|$)", "i");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);else return null;
			}
		}, {
			key: "getUrlParam2",
			value: function getUrlParam2(token, queryString) {
				if (!queryString) return null;
				var reg = new RegExp("(^|&)" + token + "=([^&]*)(&|$)", "i");
				var r = queryString.match(reg);
				if (r != null) return unescape(r[2]);else return null;
			}
		}, {
			key: "getLayerClassName",
			value: function getLayerClassName(formName, groupAlias) {
				if (groupAlias) return formName + "_DataSource_" + groupAlias;else return formName;
			}
		}, {
			key: "getClientLayerRowStyles",
			value: function getClientLayerRowStyles(formModule, group, methodName, args) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var layerLevels = _parentWindow.layerLevelConfig;
					//let formModule = this.formDataSources.formModule;
					for (var i = layerLevels.length - 1; i > -1; i--) {
						var layerName = layerLevels[i].name;
						var layerConfig = _parentWindow.layerConfigs[layerName];
						if (layerConfig) {
							var clsName = CommonUtil.getLayerClassName(formModule.formName, group ? group.mainSource.alias : null);
							if (layerConfig.hasOwnProperty(clsName)) {
								var classConfig = layerConfig[clsName];
								var _cls = classConfig.classDef;
								var result = void 0;
								var mathodInfo = { fetchOption: true, groups: "all(cr,sr,ar,fq,cq)", editors: "all", joinGroup: "yes" };
								if (typeof _cls == "function") {
									var instance = new _cls();
									var func = instance[methodName];
									if (!func || typeof func != "function") continue;
	
									//cmdResult = instance.activeRecord(commandArg);
									result = func.apply(instance, args);
								} else if (_typeof(_cls == "Object")) {
									var _instance = _cls;
									var _func = _instance[methodName];
									if (!_func || typeof _func != "function") continue;
	
									result = _func.apply(_instance, args);
								}
								if (result) {
									return result;
								}
								break;
							}
						}
					}
				}
			}
		}, {
			key: "dynamicLoadJs",
			value: function dynamicLoadJs(url, callback) {
				var head = document.getElementsByTagName('head')[0];
				var script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = url;
				if (typeof callback == 'function') {
					script.onload = script.onreadystatechange = function () {
						if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
							if (callback) callback();
							script.onload = script.onreadystatechange = null;
						}
					};
				}
				head.appendChild(script);
			}
	
			/**
	  * 动态加载Css
	  * @param {string} url 脚本地址
	  * @param {function} callback  回调函数
	  */
	
		}, {
			key: "dynamicLoadCss",
			value: function dynamicLoadCss(url, callback) {
				//<link rel="stylesheet" href="externals/styles/GongqiERP6.css"></link>
				var head = document.getElementsByTagName('head')[0];
				var _css_ = document.createElement('link');
				_css_.rel = "stylesheet";
				_css_.href = url;
				if (typeof callback == 'function') {
					script.onload = script.onreadystatechange = function () {
						if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
							if (callback) callback();
							script.onload = script.onreadystatechange = null;
						}
					};
				}
				head.appendChild(_css_);
			}
		}, {
			key: "drawCanvas",
			value: function drawCanvas(data, _idp, _id) {
				console.log(data, '=====>data');
				var c = document.getElementById(_id);
				var ctx = c.getContext("2d");
				CommonUtil.resizeCanvas(_idp, _id);
				data.forEach(function (item) {
					var spaceLength = 5;
					if (item.shape === 'rect') {
						// 节点部分
	
						CommonUtil.creatdiv(item, _idp, _id);
						ctx.strokeStyle = "#000";
						var leftTop = {
							x: item.position.x,
							y: item.position.y
						};
						var leftBottom = {
							x: item.position.x,
							y: item.position.y + item.size.height
						};
						// 绘制节点框
						ctx.fillStyle = "#fff";
						ctx.fillRect(item.position.x + spaceLength, item.position.y + spaceLength, item.size.width - spaceLength * 2, item.size.height - spaceLength * 2);
						// 绘制名称
						ctx.fillStyle = "#000";
						ctx.font = "12px Arial";
						ctx.textAlign = 'center';
						ctx.fillText(item.attrs.label.text, item.position.x + item.size.width / 2, leftBottom.y - 10);
						// 绘制图片
						var image = new Image();
						image.src = "./images/box.png";
						image.onload = function () {
							var x = leftTop.x + item.size.width / 2 - item.size.height / 4;
							var y = leftTop.y + item.size.height / 2 - item.size.height / 3;
							ctx.drawImage(this, x, y, item.size.height / 2, item.size.height / 2);
						};
					} else {
						// 连接线部分
						var pointS = {
							x: 0,
							y: 0
						};
						var pointE = {
							x: 0,
							y: 0
						};
						var targetWidth = 0;
						var targetHeight = 0;
						// 定位起始点，结束点位置
						data.find(function (i) {
							if (i.id === item.source.cell) {
								pointS = {
									x: i.position.x + i.size.width / 2,
									y: i.position.y + i.size.height / 2
								};
							}
							if (i.id === item.target.cell) {
								pointE = {
									x: i.position.x + i.size.width / 2,
									y: i.position.y + i.size.height / 2
								};
								targetWidth = i.size.width;
								targetHeight = i.size.height;
							}
						});
	
						// 绘制连接线
						ctx.strokeStyle = "#000";
						ctx.fillStyle = "#000";
						var direction = '';
						var turn1 = {
							x: 0,
							y: 0
						};
						var turn2 = {
							x: 0,
							y: 0
						};
						if (pointS.x !== pointE.x && pointS.y !== pointE.y) {
							if (Math.abs(pointS.x - pointE.x) > Math.abs(pointS.y - pointE.y)) {
								// 转折点1
								turn1 = {
									x: (pointE.x < pointS.x ? pointE.x : pointS.x) + Math.abs(pointS.x - pointE.x) / 2,
									y: pointS.y
								};
								// 转折点2
								turn2 = {
									x: (pointE.x < pointS.x ? pointE.x : pointS.x) + Math.abs(pointS.x - pointE.x) / 2,
									y: pointE.y
								};
								// 折线连接
								ctx.moveTo(pointS.x, pointS.y);
								ctx.lineTo(turn1.x, turn1.y);
								ctx.lineTo(turn2.x, turn2.y);
								ctx.lineTo(pointE.x, pointE.y);
								ctx.stroke();
							} else {
								// 转折点1
								turn1 = {
									x: pointS.x,
									y: (pointE.y < pointS.y ? pointE.y : pointS.y) + Math.abs(pointS.y - pointE.y) / 2
								};
								// 转折点2
								turn2 = {
									x: pointE.x,
									y: (pointE.y < pointS.y ? pointE.y : pointS.y) + Math.abs(pointS.y - pointE.y) / 2
								};
								// 折线连接
								ctx.moveTo(pointS.x, pointS.y);
								ctx.lineTo(turn1.x, turn1.y);
								ctx.lineTo(turn2.x, turn2.y);
								ctx.lineTo(pointE.x, pointE.y);
								ctx.stroke();
							}
							// 判断箭头方向
							if (turn2.x > pointE.x) {
								direction = 'left';
							} else if (turn2.x < pointE.x) {
								direction = 'right';
							} else if (turn2.y > pointE.y) {
								direction = 'top';
							} else if (turn2.y < pointE.y) {
								direction = 'bottom';
							}
						} else {
							// 直线连接
							ctx.moveTo(pointS.x, pointS.y);
							ctx.lineTo(pointE.x, pointE.y);
							ctx.stroke();
							// 判断箭头方向
							if (pointS.x > pointE.x) {
								direction = 'left';
							} else if (pointS.x < pointE.x) {
								direction = 'right';
							} else if (pointS.y > pointE.y) {
								direction = 'top';
							} else if (pointS.y < pointE.y) {
								direction = 'bottom';
							}
						}
						// 绘制箭头
						var len = 3;
						switch (direction) {
							case 'right':
								ctx.beginPath();
								ctx.moveTo(pointE.x - targetWidth / 2 - len, pointE.y - len);
								ctx.lineTo(pointE.x - targetWidth / 2 + spaceLength, pointE.y);
								ctx.lineTo(pointE.x - targetWidth / 2 - len, pointE.y + len);
								ctx.lineTo(pointE.x - targetWidth / 2 - len, pointE.y - len);
								ctx.fill();
								ctx.stroke();
								ctx.closePath();
								break;
							case 'left':
								ctx.beginPath();
								ctx.moveTo(pointE.x + targetWidth / 2 + len, pointE.y - len);
								ctx.lineTo(pointE.x + targetWidth / 2 - spaceLength, pointE.y);
								ctx.lineTo(pointE.x + targetWidth / 2 + len, pointE.y + len);
								ctx.fill();
								ctx.stroke();
								ctx.closePath();
								break;
							case 'bottom':
								ctx.beginPath();
								ctx.moveTo(pointE.x - len, pointE.y - targetHeight / 2 - len);
								ctx.lineTo(pointE.x, pointE.y - targetHeight / 2 + spaceLength);
								ctx.lineTo(pointE.x + len, pointE.y - targetHeight / 2 - len);
								ctx.fill();
								ctx.stroke();
								ctx.closePath();
								break;
							case 'top':
								ctx.beginPath();
								ctx.moveTo(pointE.x - len, pointE.y + targetHeight / 2 + len);
								ctx.lineTo(pointE.x, pointE.y + targetHeight / 2 - spaceLength);
								ctx.lineTo(pointE.x + len, pointE.y + targetHeight / 2 + len);
								ctx.fill();
								ctx.stroke();
								ctx.closePath();
								break;
						}
					}
				});
			}
		}, {
			key: "creatdiv",
			value: function creatdiv(item, _idp, _id) {
				var div = document.createElement('div');
				div.id = item.attrs.label.id;
				div.style.position = "absolute";
				div.style.width = item.size.width + 'px';
				div.style.height = item.size.height + 'px';
				div.style.left = item.position.x + 'px';
				div.style.top = item.position.y + 'px';
				div.onclick = function () {
					//console.log(item.attrs.label.id, '=====id');
					_FormLoadHelper2.default.openMenuItem({ menuItemId: item.attrs.label.id,
						onlyQuery: false, label: item.attrs.label.text, checkHas: false, fromMainMenu: true });
				};
				div.onmouseover = function () {
					div.style.cursor = 'pointer';
				};
				div.onmouseout = function () {};
				var content = document.getElementById(_idp);
				content.appendChild(div);
			}
		}, {
			key: "resizeCanvas",
			value: function resizeCanvas(_idp, _id) {
				var contentWidth = document.getElementById(_idp).clientWidth;
				var contentHeight = document.getElementById(_idp).clientHeight;
				var c = document.getElementById(_id);
				c.width = contentWidth;
				c.height = contentHeight;
			}
		}]);
	
		return CommonUtil;
	}();
	
	exports.default = CommonUtil;

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Command = function () {
		function Command() {
			_classCallCheck(this, Command);
	
			this.remoteClass = "gongqi.erp.framework.core.Command";
		}
	
		_createClass(Command, [{
			key: "appendArg",
			//String
	
			//String
			//String
			//String
			//String
			//String
			//Array
			//Array
			value: function appendArg(value) {
				var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "String";
	
				if (this.argType == null) this.argType = [];
	
				if (this.argValue == null) this.argValue = [];
	
				this.argType.push(type);
				this.argValue.push(value);
	
				return this;
			}
		}], [{
			key: "create",
			value: function create(classType, className, instanceType, instanceId, methodName, returnType) {
				var command = new Command();
				command.classType = classType;
				command.className = className;
				command.instanceType = instanceType;
				command.instanceId = instanceId;
				command.methodName = methodName;
				command.returnType = returnType;
				return command;
			}
		}, {
			key: "createService",
			value: function createService(className, methodName) {
				var returnType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "String";
	
				return Command.create("service", className, null, null, methodName, returnType);
			}
		}, {
			key: "createNew",
			value: function createNew(className, methodName) {
				var returnType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "String";
	
				return Command.create("new", className, null, null, methodName, returnType);
			}
		}]);
	
		return Command;
	}();
	
	exports.default = Command;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['executeQuery', 'updateControlAllowEdit', 'updateControlVisible', 'updateControlLabel', 'updateControlShowDecimal', 'updateControlProperty', 'writeControl', 'buttonOk', 'dsAllowEdit', 'switchTabPage', 'bindStyle', 'setButtonStyle', 'setTextStyle', 'setContainerStyle', 'selectRecords', 'refreshPlugin', 'updateGroupCollapseState', 'updateDropDownContent']);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormResourceUtil = function () {
		function FormResourceUtil() {
			_classCallCheck(this, FormResourceUtil);
		}
	
		_createClass(FormResourceUtil, null, [{
			key: 'getCommandArgMethodInfo',
			value: function getCommandArgMethodInfo(methodName, menuItemId, formId) {
				if (!menuItemId) menuItemId = window.menuItemId;if (!formId) formId = window.formId;
				var _key = _FormItemUtil2.default.getFormStoresKey(menuItemId, formId);
				var methods = null;
				try {
					methods = window.parent.window[_key].listRemoteMethods;
				} catch (e) {
					methods = window[_key] ? window[_key].listRemoteMethods : null;
				}
				if (!methods || !methodName) return null;
	
				for (var i = 0; i < methods.length; i++) {
					var mi = methods[i];
					if (mi.methodName == methodName) return mi;
				}
	
				return null;
			}
		}, {
			key: 'getEditorPromptArray',
			value: function getEditorPromptArray(key) {
				var parentWindow = window.parent.window;
				if (!parentWindow.editorPromptCache) {
					parentWindow.editorPromptCache = {};
				}
				if (parentWindow.editorPromptCache[key] == null) parentWindow.editorPromptCache[key] = [];
				return parentWindow.editorPromptCache[key];
			}
		}]);
	
		return FormResourceUtil;
	}();
	
	exports.default = FormResourceUtil;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandHelper = function () {
		function CommandHelper() {
			_classCallCheck(this, CommandHelper);
		}
	
		_createClass(CommandHelper, null, [{
			key: "createFormInstance",
			value: function createFormInstance(className, methodName) {
				var returnType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "FormDataSourceGroupResult";
	
				return _Command2.default.create("layerForm", className, null, null, methodName, returnType);
			}
		}, {
			key: "createReportInstance",
			value: function createReportInstance(className, methodName, returnType) {
				return _Command2.default.create("layerReport", className, null, null, methodName, returnType);
			}
		}, {
			key: "createJobInstance",
			value: function createJobInstance(className, methodName, returnType) {
				return _Command2.default.create("job", className, null, null, methodName, returnType);
			}
		}]);
	
		return CommandHelper;
	}();
	
	exports.default = CommandHelper;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _ResizeActions = __webpack_require__(53);
	
	var _ResizeActions2 = _interopRequireDefault(_ResizeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import FormItemButton from './FormItemButton';
	
	
	var GongqiFormItem = function (_React$Component) {
		_inherits(GongqiFormItem, _React$Component);
	
		function GongqiFormItem(props) {
			_classCallCheck(this, GongqiFormItem);
	
			var _this = _possibleConstructorReturn(this, (GongqiFormItem.__proto__ || Object.getPrototypeOf(GongqiFormItem)).call(this, props));
	
			_this.state = {
				visible: _this.props.controlVisible,
				hideInVisible: _this.props.hideInVisible
			};
			_this.unsubcribeCmdUpdateControlVisibleStore = _CmdTypeStore.CmdUpdateControlVisibleStore.listen(_this.onCmdUpdateControlVisible.bind(_this));
	
			return _this;
		}
	
		_createClass(GongqiFormItem, [{
			key: 'onCmdUpdateControlVisible',
			value: function onCmdUpdateControlVisible(menuItemId, formId, names, isLookup) {
				if (this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId && this.props.formId == formId) {
					if (names.indexOf(this.props.xml.name) != -1) {
						var nowVisible = this.state.visible;
						var finalVisible = this.props.control.getProperty_Visible_Final();
						this.setState({ visible: finalVisible });
						if (this.props.control.parentControl && this.props.control.parentControl.classAlias == "FormItemFieldGroupControl") {
							// let filedGroup = this.props.control.parentControl.getComponentInstance(this.props.control.parentControl.parentXML,isLookup);
							// this.props.control.parentControl.module.setState({})
							// this.props.control.parentControl.component.componentRefresh();
							// ResizeActions.groupRefersh(this.props.control.parentControl );
						}
	
						if (finalVisible != nowVisible) {
							if (nowVisible == false && finalVisible == true) {
								this.visibleFlaseToTrue();
							}
						}
					}
				}
			}
		}, {
			key: 'visibleFlaseToTrue',
			value: function visibleFlaseToTrue() {
				//ResizeActions.visibleFalseToTrue();
			}
		}]);
	
		return GongqiFormItem;
	}(_react2.default.Component);
	
	;
	
	GongqiFormItem.defaultProps = {};
	
	exports.default = GongqiFormItem;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['lookupReturn', 'lookupasteriskRefresh', 'renderCmp', 'lookupRefresh', 'lookupHostKeydown', 'lookupReturnMutiField', 'lookupReturnMutiEditor', 'popDropDownClose', 'lookupAutoQuery', 'lookupUnmount']);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Fade = function () {
		function Fade() {
			_classCallCheck(this, Fade);
		}
	
		_createClass(Fade, null, [{
			key: 'show',
			value: function show(options) {
	
				var defaults = {
					state: "info",
					backgroundColor: '#ffffff',
					color: "#fff",
					duration: 2000,
					pause: 2000,
					fontSize: '20px',
					text: "操作成功！",
					cornerRadius: "10",
					interacdestroy: false,
					fademodalmask: true,
					zindex: 1050
				};
	
				// var stateColor={
				// 	info:'alert-info',
				// 	warn:'alert-warning',
				// 	error:'alert-danger',
				// 	success:'alert-success'
				// }
				var stateStyle = {
					info: {
						width: '31px',
						fontSize: '31px',
						color: '#2196F3'
					},
					warn: {
						width: '31px',
						fontSize: '31px',
						color: '#F5A623'
					},
					error: {
						width: '31px',
						fontSize: '31px',
						color: '#EA1E1E'
	
					},
					success: {
						width: '31px',
						fontSize: '31px',
						color: '#26BD71'
					}
				};
				var stateIcon = {
					info: "fa fa-info-circle",
					warn: "fa fa-exclamation-circle",
					error: "fa fa-times-circle",
					success: "fa fa-check-circle"
				};
	
				$.extend(true, defaults, options);
	
				if (defaults.interacdestroy) {
					$(document).on("mousedown", function (e) {
						if ($(alertDiv)) {
							if (!$(alertDiv).is(e.target)) {
								$(document).off("mousedown");
								$(alertDiv).remove();
								if (typeof window.restoreLastFocus == "function") window.restoreLastFocus();
							}
						}
					});
				}
	
				var maskbackground = "rgba(0, 0, 0, 0.3);";
				if (!defaults.fademodalmask) {
					maskbackground = "none";
				}
	
				var titleMsg = {
					info: '提示',
					warn: '警告',
					error: '错误',
					success: '成功'
				};
	
				var titleIcon = $('<i style="margin-right:10px"></i>').addClass(stateIcon[defaults.state]).css(stateStyle[defaults.state]);
				var titleH = $('<h4></h4>').addClass('modal-title').css({ 'font-weight': '700' }).append(titleMsg[defaults.state]); //判断显示内容
	
				var headerDiv = $('<div></div>').addClass('modal-header').append(titleH);
	
				var bodyP = $('<p></p>').html(defaults.text).css({ 'font-size': defaults.fontSize, 'margin-bottom': '0px' });
				if (typeof defaults.color == 'number') {
					bodyP.css("color", "#" + defaults.color.toString(16).toUpperCase().padStart(6, '0'));
				}
				var bodyDiv = $('<div></div>').addClass('modal-body').append(titleIcon).append(bodyP).css({ 'min-height': '105px', 'display': 'flex', 'align-items': 'center', 'padding-top': '10px', 'padding-bottom': '10px' });
	
				var contentDiv = $('<div></div>').addClass('modal-content').append(headerDiv).append(bodyDiv).css({ background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' });
				if (defaults.cornerRadius != "10") {
					contentDiv.css("borderRadius", defaults.cornerRadius + "px");
				}
	
				var dialogDiv = $('<div></div>').append(contentDiv).css({ 'margin': '18% auto', 'position': 'relative', 'width': '508px', 'min-width': '475px' });
	
				var alertDiv = $('<div id="fademodal"></div>').addClass('modal').append(dialogDiv).css({ "background": maskbackground, "z-index": defaults.zindex });
				//parent.$("body").append(alertDiv);
	
	
				if (window.isSelfFrameRoot == true) {
					$("body").append(alertDiv);
				} else {
					parent.$("body").append(alertDiv);
				}
	
				// 		var alertIcon=$("<i></i>").addClass("icon fa").addClass(stateIcon[defaults.state]);
				// 		var alertDiv=$("<div></div>").addClass('alert alert-dismissible').append(alertIcon).append(defaults.text)
				// 			.css({'color':defaults.color,'border-radius':defaults.cornerRadius,'position':'absolute',
				// 				'z-index':'3000','top':'40%','left':'40%','width':'20%','padding':'20px',
				// 				'text-align':'center','display':'none','font-size':'24px'
				// 			})
	
				// 		if(defaults.backgroundColor){
				// 	alertDiv.css("background-color",defaults.backgroundColor)
				// }else{
				// 	alertDiv.addClass(stateColor[defaults.state])
				// }
	
				// 		$('body').append(alertDiv);
				if (defaults.backgroundColor) {
					var _backgroundColor = typeof defaults.backgroundColor == "number" ? "#" + _StringUtil2.default.toColorStyleString(defaults.backgroundColor) : defaults.backgroundColor;
					$(contentDiv).css("background-color", _backgroundColor);
				}
				if (window.fadeduration) {
					$(alertDiv).fadeIn(window.fadeduration);
				} else {
					$(alertDiv).fadeIn(defaults.duration);
				}
	
				//鼠标点击后立刻去除弹出框
				if (defaults.interacdestroy == false) {
					try {
						var mousedownHandler = window.parent.window.document;
						if (window.didomain) mousedownHandler = window.document;
						$(mousedownHandler).on("mousedown", function (e) {
							if ($(alertDiv)) {
								// if(!($(alertDiv).is(e.target))){
								$(mousedownHandler).off("mousedown");
								$(alertDiv).remove();
								if (typeof window.restoreLastFocus == "function") window.restoreLastFocus();
								// }
							}
						});
					} catch (e) //如果存在跨域引入等问题
					{
						$(window.document).on("mousedown", function (e) {
							if ($(alertDiv)) {
								// if(!($(alertDiv).is(e.target))){
								$(document).off("mousedown");
								$(alertDiv).remove();
								if (typeof window.restoreLastFocus == "function") window.restoreLastFocus();
								// }
							}
						});
					}
				}
	
				var pausetime = defaults.pause;
				if (window.fadepause) {
					pausetime = window.fadepause;
				}
				var t = setTimeout(function () {
					//alert("去掉");
					if (window.fadepause) {
						$(alertDiv).fadeOut(window.fadepause);
					} else {
						$(alertDiv).fadeOut(defaults.pause);
					}
	
					if (defaults.interacdestroy) {
						$(document).off("mousedown");
						$(alertDiv).remove();
						if (typeof window.restoreLastFocus == "function") window.restoreLastFocus();
					}
				}, pausetime);
			}
		}]);
	
		return Fade;
	}();
	
	exports.default = Fade;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(305);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemRender.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemRender.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GlobalClickStore = exports.ClearGridSignedStore = exports.ScrollToAndFocusStore = exports.AfterActiveRecordStore = exports.SwitchToCurrentSetSelectStore = exports.NotifyDataGridCurrentGroupStore = exports.AfterNewRecordDataGridFocusSetStore = exports.CurrentGroupGetStore = exports.CurrentGroupSetStore = exports.FocusSetStore = exports.FocusChangeStore = exports.HoldFousStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HoldFousStore = exports.HoldFousStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.holdFocusIn, 'onHoldFocus');
		},
		onHoldFocus: function onHoldFocus(formId, itemId) {
			this.trigger(formId, itemId);
		}
	});
	
	var FocusChangeStore = exports.FocusChangeStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.focusChange, 'onFocusChange');
		},
		onFocusChange: function onFocusChange(item, pre) {
			this.trigger(item, pre);
		}
	});
	
	var FocusSetStore = exports.FocusSetStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.focusSet, 'onFocusSet');
		},
		onFocusSet: function onFocusSet(formId, itemId, pre, init, recordChange) {
			this.trigger(formId, itemId, pre, init, recordChange);
		}
	});
	
	var CurrentGroupSetStore = exports.CurrentGroupSetStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.currentGroupSet, 'onGroupSet');
		},
		onGroupSet: function onGroupSet(groupAlias, formId, focusedId) {
			this.trigger(groupAlias, formId, focusedId);
		}
	});
	
	var CurrentGroupGetStore = exports.CurrentGroupGetStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.currentGroupGet, 'onGroupGet');
		},
		onGroupGet: function onGroupGet(result) {
			this.trigger(result);
		}
	});
	
	var AfterNewRecordDataGridFocusSetStore = exports.AfterNewRecordDataGridFocusSetStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.afterNewRecordDataGridFocusSet, 'onAfterNewRecordDataGridFocusSet');
		},
		onAfterNewRecordDataGridFocusSet: function onAfterNewRecordDataGridFocusSet(formId, itemId) {
			this.trigger(formId, itemId);
		}
	});
	
	var NotifyDataGridCurrentGroupStore = exports.NotifyDataGridCurrentGroupStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.notifyDataGridCurrentGroup, 'onNotifyDataGridCurrentGroup');
		},
		onNotifyDataGridCurrentGroup: function onNotifyDataGridCurrentGroup(groupAlias, formModule) {
			this.trigger(groupAlias, formModule);
		}
	});
	
	//废弃
	var SwitchToCurrentSetSelectStore = exports.SwitchToCurrentSetSelectStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_FocusActions2.default.switchToCurrentSetSelect, "onSwitchToCurrentSetSelect");
		},
		onSwitchToCurrentSetSelect: function onSwitchToCurrentSetSelect() {
			this.trigger();
		}
	});
	
	var AfterActiveRecordStore = exports.AfterActiveRecordStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_FocusActions2.default.afterActiveRecord, 'onAfterActiveRecord');
		},
		onAfterActiveRecord: function onAfterActiveRecord(groupAlias) {
			this.trigger(groupAlias);
		}
	});
	
	var ScrollToAndFocusStore = exports.ScrollToAndFocusStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.scrollToAndFocus, 'onScrollToAndFocus');
		},
		onScrollToAndFocus: function onScrollToAndFocus(arg) {
			this.trigger(arg);
		}
	});
	
	var ClearGridSignedStore = exports.ClearGridSignedStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_FocusActions2.default.clearSigned, 'onClearSigned');
		},
		onClearSigned: function onClearSigned(arg) {
			this.trigger(arg);
		}
	});
	
	var GlobalClickStore = exports.GlobalClickStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_FocusActions2.default.globalClick, 'onGlobalClick');
		},
		onGlobalClick: function onGlobalClick(arg) {
			this.trigger(arg);
		}
	});

/***/ },
/* 29 */,
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryTable = __webpack_require__(142);
	
	var _QueryTable2 = _interopRequireDefault(_QueryTable);
	
	var _QueryTableStatus = __webpack_require__(143);
	
	var _QueryTableStatus2 = _interopRequireDefault(_QueryTableStatus);
	
	var _QueryRelationJoinMode = __webpack_require__(264);
	
	var _QueryRelationJoinMode2 = _interopRequireDefault(_QueryRelationJoinMode);
	
	var _QueryRelationItem = __webpack_require__(263);
	
	var _QueryRelationItem2 = _interopRequireDefault(_QueryRelationItem);
	
	var _QueryWhereItem = __webpack_require__(265);
	
	var _QueryWhereItem2 = _interopRequireDefault(_QueryWhereItem);
	
	var _QueryWhereAndOr = __webpack_require__(144);
	
	var _QueryWhereAndOr2 = _interopRequireDefault(_QueryWhereAndOr);
	
	var _QueryWhereStatus = __webpack_require__(157);
	
	var _QueryWhereStatus2 = _interopRequireDefault(_QueryWhereStatus);
	
	var _QueryWhereLeftBracket = __webpack_require__(56);
	
	var _QueryWhereLeftBracket2 = _interopRequireDefault(_QueryWhereLeftBracket);
	
	var _QueryWhereRightBracket = __webpack_require__(57);
	
	var _QueryWhereRightBracket2 = _interopRequireDefault(_QueryWhereRightBracket);
	
	var _QueryOrderByItem = __webpack_require__(260);
	
	var _QueryOrderByItem2 = _interopRequireDefault(_QueryOrderByItem);
	
	var _QueryOrderByType = __webpack_require__(141);
	
	var _QueryOrderByType2 = _interopRequireDefault(_QueryOrderByType);
	
	var _QueryRelation1N = __webpack_require__(262);
	
	var _QueryRelation1N2 = _interopRequireDefault(_QueryRelation1N);
	
	var _FormItemTimeResolver = __webpack_require__(61);
	
	var _FormItemTimeResolver2 = _interopRequireDefault(_FormItemTimeResolver);
	
	var _FormItemDateResolver = __webpack_require__(55);
	
	var _FormItemDateResolver2 = _interopRequireDefault(_FormItemDateResolver);
	
	var _GongqiDataType = __webpack_require__(107);
	
	var _GongqiDataType2 = _interopRequireDefault(_GongqiDataType);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _GOTPropertiesUtil = __webpack_require__(62);
	
	var _GOTPropertiesUtil2 = _interopRequireDefault(_GOTPropertiesUtil);
	
	var _QueryParentProperty = __webpack_require__(261);
	
	var _QueryParentProperty2 = _interopRequireDefault(_QueryParentProperty);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _QueryAggregationItem = __webpack_require__(259);
	
	var _QueryAggregationItem2 = _interopRequireDefault(_QueryAggregationItem);
	
	var _QueryWhereItem3 = __webpack_require__(108);
	
	var _QueryWhereItem4 = _interopRequireDefault(_QueryWhereItem3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryUtil = function () {
		function QueryUtil() {
			_classCallCheck(this, QueryUtil);
		}
	
		_createClass(QueryUtil, null, [{
			key: 'deleteUserQueryList',
			value: function deleteUserQueryList(key) {
				var userQueryList = window.userQueryList;
				if (!userQueryList) {
					userQueryList = window.parent.window.userQueryList;
				}
	
				delete userQueryList[key];
			}
		}, {
			key: 'setUserQueryList',
			value: function setUserQueryList(key, value) {
				var userQueryList = window.userQueryList;
				if (!userQueryList) {
					userQueryList = window.parent.window.userQueryList;
				}
	
				userQueryList[key] = value;
			}
		}, {
			key: 'getQueryList',
			value: function getQueryList(key) {
				var userQueryList = window.userQueryList;
				if (!userQueryList) {
					userQueryList = window.parent.window.userQueryList;
				}
	
				return userQueryList[key];
			}
		}, {
			key: 'hasQueryList',
			value: function hasQueryList(key) {
				var userQueryList = window.userQueryList;
				if (!userQueryList) {
					userQueryList = window.parent.window.userQueryList;
				}
	
				return userQueryList.hasOwnProperty(key);
			}
		}, {
			key: 'isGroupJoin',
			value: function isGroupJoin(type) {
				if (type == "InnerJoin" || type == "ExistJoin" || type == "NotExistJoin") {
					return true;
				} else {
					return false;
				}
			}
		}, {
			key: 'buildBaseQueryTable',
			value: function buildBaseQueryTable(formDataSource, formDataSources) {
				var queryTable = { name: "A_QueryTable", id: "1",
					Properties: {
						Table: { V: "" },
						Alias: { V: "" },
						UserUpdate: { V: true },
						Output: { V: true },
						Status: { V: "Open" }
					},
					QueryRelation: {
						Properties: {
							Auto: { V: false },
							JoinMode: { V: "None" },
							Relation1N: { V: "ManyToOne" }
						},
						Items: []
					},
					QueryFields: {
						Properties: {
							Auto: { V: true }
						},
						Items: []
					},
					QueryGroupBy: { name: "GroupBy" },
					QueryOrderBy: { name: "OrderBy", Items: [] },
					QueryWhere: {
						name: "Where",
						Items: []
					},
					QueryAggregations: {
						name: "Aggregations",
						Items: []
					},
					QueryJoins: {
						name: "Joins",
						Items: []
					}
	
				};
				var joins = [];
				for (var i in formDataSources.DataSources) {
					var fds = formDataSources.DataSources[i];
					if (fds.Properties.JoinSource.Value == formDataSource.name && QueryUtil.isGroupJoin(fds.Properties.JoinType.Value)) {
						joins.push(fds);
					}
				}
	
				var tablePro = queryTable.Properties.Table;
				var aliasPro = queryTable.Properties.Alias;
				var outPutPro = queryTable.Properties.Output;
	
				var formTablePro = formDataSource.Properties.Table;
	
				if (!formTablePro.hasOwnProperty("refentityid")) throw new Error("GOT错误:FormDataSource没有与Table关联");
	
				tablePro.V = formTablePro.Value;
				aliasPro.V = formDataSource.name;
	
				tablePro.refentityid = formTablePro.refentityid;
				queryTable.id = formDataSource.id;
				queryTable.name = formDataSource.name;
	
				var queryRelation = queryTable.QueryRelation;
				var joinModePro = queryRelation.Properties.JoinMode;
	
				var formJoinTypeValue = formDataSource.Properties.JoinType.Value;
	
				if (formJoinTypeValue == "InnerJoin" || formJoinTypeValue == "ExistJoin" || formJoinTypeValue == "NotExistJoin") {
					joinModePro.V = formJoinTypeValue;
				} else {
					joinModePro.V = _QueryRelationJoinMode2.default.None;
				}
	
				if (joinModePro.V == "InnerJoin" || joinModePro.V == _QueryRelationJoinMode2.default.None) {
					outPutPro.V = "true";
				} else {
					outPutPro.V = "false";
				}
	
				var queryRelation1NPro = queryRelation.Properties.Relation1N;
	
				if (joinModePro.V == "InnerJoin" || joinModePro.V == _QueryRelationJoinMode2.default.None) {
					queryRelation1NPro.V = "ManyToOne";
				} else {
					queryRelation1NPro.V = "OneToMany";
				}
	
				if (joinModePro.V != "" && joinModePro.V != _QueryRelationJoinMode2.default.None) //仅针对InnerJoin ExistJoin NotExistJoin
					{
						var relationItems = formDataSource.FormDataSourceRelation;
						for (var _i = 0; _i < relationItems.length; _i++) {
							var relationItem = relationItems[_i];
							var rtemp = {
								name: "A_QueryRelationItem", id: "2",
								Properties: {
									Field: { V: "" }, ParentField: { V: "" }, FieldValue: { V: "" }, RelatedValue: { V: "" }
								}
							};
							rtemp.id = relationItem;
							QueryUtil.setQueryRelationByFormRelation(rtemp, relationItem, formDataSource);
							queryRelation.Items.push(rtemp);
						}
					}
				//当joinModePro.Value==""时，即 "" Delayed Active Passived时，relation关系不加在当前节点下，而是加到Auto_JoinParent的QueryRelation上
	
				var defaultOrderByPro = formDataSource.Properties.DefaultOrderBy;
	
				var queryOrderBy = queryTable.QueryOrderBy;
	
				var reverse = formDataSource.Properties.Reverse.Value;
	
				if (defaultOrderByPro.hasOwnProperty("refentityid")) {
					var tableId = defaultOrderByPro.refentityid;
					var tableIndexId = defaultOrderByPro.refinnerid;
					var tableIndex = _GOT2.default.getTableIndex(_GOT2.default.getTable(tableId), tableIndexId);
					var tableIndexItems = tableIndex.IndexItems;
					//order = 
				} else {
					var table = _GOT2.default.getTable(formTablePro.refentityid);
					var tableDefaultOrderByPro = table.Properties.DefaultOrderBy;
					if (tableDefaultOrderByPro.hasOwnProperty("innerid")) {
						tableId = table.id;
						tableIndexId = tableDefaultOrderByPro.innerid;
						tableIndex = _GOT2.default.getTableIndex(table, tableIndexId);
						tableIndexItems = tableIndex.IndexItems;
					}
				}
	
				var itemorder = "";
				if (tableIndexItems) {
					for (var _i2 = 0; _i2 < tableIndexItems.length; _i2++) {
						var tableIndexItem = tableIndexItems[_i2];
	
						var queryOrderByItem = {
							name: "A_QueryOrderByItem", id: "5",
							Properties: { Field: { V: "" }, OrderBy: { V: "ASC" } }
						};
	
						var queryOrderByItemFieldPro = queryOrderByItem.Properties.Field;
						var orderByPro = queryOrderByItem.Properties.OrderBy;
						queryOrderByItemFieldPro.V = tableIndexItem.Properties.Field.V;
						//TODO 根据Table索引排序
						if (tableIndexItem.Properties.ArrayItem && tableIndexItem.Properties.ArrayItem.V) queryOrderByItemFieldPro.V += "." + tableIndexItem.Properties.ArrayItem.V;
						queryOrderByItemFieldPro.refentityid = tableId;
						queryOrderByItemFieldPro.refinnerid = tableIndexItem.Properties.Field.innerid;
	
						itemorder = tableIndexItem.Properties.SortOrder.V;
	
						if (reverse == "true" || reverse == true) itemorder = itemorder == "ASC" ? "DESC" : "ASC";
						orderByPro.V = itemorder;
						queryOrderByItem.name = queryOrderByItemFieldPro.V + " # " + itemorder;
	
						queryOrderBy.Items.push(queryOrderByItem);
					}
				}
	
				var queryJoins = queryTable.QueryJoins;
				for (var _i3 = 0; _i3 < joins.length; _i3++) {
					var _formDataSource = joins[_i3];
					queryJoins.Items.push(QueryUtil.buildBaseQueryTable(_formDataSource, formDataSources));
				}
	
				return queryTable;
			}
		}, {
			key: 'setQueryRelationByFormRelation',
			value: function setQueryRelationByFormRelation(queryRelation, formRelation, formDataSource) {
				queryRelation.name = formRelation.name;
				var queryRelationFieldPro = queryRelation.Properties.Field;
				var queryRelationRelatedFieldPro = queryRelation.Properties.RelatedField || queryRelation.Properties.ParentField;
	
				var formRelationFieldPro = formRelation.Properties.Field;
				var formRelationRelatedFieldPro = formRelation.Properties.RelatedField || formRelation.Properties.ParentField;
				if (!formRelationFieldPro) formRelaionFieldPro = {};
				if (!formRelationRelatedFieldPro) formRelationRelatedFieldPro = {};
				var fieldRefEntityId = formRelationFieldPro.refentityid;
				var fieldRefInnerId = formRelationFieldPro.refinnerid;
				var relatedRefEntityId = formRelationRelatedFieldPro.refentityid;
				var relatedRefInnerId = formRelationRelatedFieldPro.refinnerid;
	
				if (formRelation.type == "Normal") {
					queryRelationFieldPro.V = formRelationRelatedFieldPro.Value;
					queryRelationFieldPro.refentityid = relatedRefEntityId;
					queryRelationFieldPro.refinnerid = relatedRefInnerId;
					queryRelationRelatedFieldPro.V = formRelationFieldPro.Value;
					queryRelationRelatedFieldPro.refentityid = fieldRefEntityId;
					queryRelationRelatedFieldPro.refinnerid = fieldRefInnerId;
				} else if (formRelation.type == "Fixed") {
					formRelationFieldPro = formRelation.Properties.Field;
					//queryRelationFieldPro.V = formRelationFieldPro.Value;
					queryRelationRelatedFieldPro.V = formRelationFieldPro.Value;
					//queryRelationFieldPro.refentityid = fieldRefEntityId;
					queryRelationRelatedFieldPro.refentityid = fieldRefEntityId;
					//queryRelationFieldPro.refinnerid = fieldRefInnerId;
					queryRelationRelatedFieldPro.refinnerid = fieldRefInnerId;
	
					var formRelationValuePro = _GOTUtil2.default.getProperty(formRelation, "Value");
					var queryRelationFixedPro = _GOTUtil2.default.getProperty(queryRelation, "RelatedValue");
					queryRelationFixedPro.V = formRelationValuePro.Value;
				} else if (formRelation.type == "RelatedFixed") {
					formRelationRelatedFieldPro = formRelation.Properties.ParentField || formRelation.Properties.RelatedField;
					//queryRelationRelatedFieldPro.V = formRelationRelatedFieldPro.Value;
					queryRelationFieldPro.V = formRelationRelatedFieldPro.Value;
					//queryRelationRelatedFieldPro.refentityid = relatedRefEntityId;
					queryRelationFieldPro.refentityid = relatedRefEntityId;
					//queryRelationRelatedFieldPro.innerid = relatedRefInnerId;
					queryRealtionFieldPro.innerid = relatedRefInnerId;
	
					formRelationValuePro = GOTHelper.getProperty(formRelation, "Value");
					var queryRelationRelatedValuePro = GOTHelper.getProperty(queryRelation, "FieldValue");
					queryRelationRelatedValuePro.V = formRelationValuePro.Value;
				}
			}
		}, {
			key: 'formatTimeValue',
			value: function formatTimeValue(time) {
				var reg = /\d([:\d]*)\d/g;
				return time.replace(reg, QueryUtil.replFunTime);
			}
		}, {
			key: 'replFunTime',
			value: function replFunTime(time) {
				return _FormItemTimeResolver2.default.getResult(time);
			}
		}, {
			key: 'formatDateValue',
			value: function formatDateValue(date) {
				var reg = /\d([-\d]*)\d/g;
				return date.replace(reg, QueryUtil.replFunDate);
			}
		}, {
			key: 'formatBooleanValue',
			value: function formatBooleanValue(value) {
				if (typeof value == "string") {
					value = value.replace("是", "true");
					value = value.replace("1", "true");
					value = value.replace("否", "false");
					value = value.replace("0", "false");
				}
				return value;
			}
		}, {
			key: 'formatEnumValue',
			value: function formatEnumValue(value, entityId, innerId) {
				if (typeof value != "string") return value;
				var array = [];
				var array1 = value.split(",");
				for (var i = 0; i < array1.length; i++) {
					var s1 = array1[i];
					var array2 = s1.split("..");
					for (var k = 0; k < array2.length; k++) {
						var s2 = array2[k];
						if (isNaN(parseInt(s2))) {
							array.push(s2);
						}
					}
				}
	
				for (var _i4 = 0; _i4 < array.length; _i4++) {
					var a = array[_i4];
					//var _key = FormItemUtil.getFormStoresKey(window.menuItemId,entityId);
					//var formStore = window[_key];
					var _properties = _GOTPropertiesUtil2.default.getItemPropertyFinalValue(window.menuItemId, entityId, innerId);
					//formStore.mapItemProperty[entityId+"_"+innerId];
					var _dataProvider = _properties.DataProvider;
					for (var _k = 0; _k < _dataProvider.length; _k++) {
						var item = _dataProvider[_k];
						if (item.hasOwnProperty("label") && item.label == a) {
							value = value.replace(a, item.value);
						}
					}
				}
	
				return value;
			}
		}, {
			key: 'replFunDate',
			value: function replFunDate(date) {
				return _FormItemDateResolver2.default.getResult(date);
			}
		}, {
			key: 'formatValue',
			value: function formatValue(fieldValue, property) {
				var entityId = property.refentityid;
				var innerId = property.refinnerid;
				var table = _GOT2.default.getTable(entityId);
				var tableField = _GOT2.default.getTableField(table, innerId);
				if (tableField != null) {
					if (tableField.type == "Time") return QueryUtil.formatTimeValue(fieldValue);else if (tableField.type == "Date") return QueryUtil.formatDateValue(fieldValue);else if (tableField.type == "Boolean") return QueryUtil.formatBooleanValue(fieldValue);else if (tableField.type == "Enum") return QueryUtil.formatEnumValue(fieldValue, entityId, innerId);
				}
				return fieldValue;
			}
		}, {
			key: 'getFieldType',
			value: function getFieldType(propertyXML) {
				var entityId = propertyXML.refentityid;
				var innerId = propertyXML.refinnerid;
				var table = _GOT2.default.getTable(entityId);
				var tableField = _GOT2.default.getTableField(table, innerId);
				if (tableField == null) return "";
	
				var type = tableField.type;
				if (type == _GongqiDataType2.default.TypeComponent) {
					type = _GongqiDataType2.default.TypeString;
				}
				return "Type" + type;
			}
		}, {
			key: 'convertXML2QueryTable',
			value: function convertXML2QueryTable(query) {
				var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				if (query == null) return null;
	
				var queryTable = new _QueryTable2.default();
				var queryParentProperty = null;
				if (parent) {
					queryParentProperty = new _QueryParentProperty2.default();
					queryParentProperty.tableId = parent.tableId;
					queryParentProperty.tableName = parent.tableName;
					queryParentProperty.aliasName = parent.aliasName;
				}
	
				queryTable.parentProperty = queryParentProperty;
				var eQueryTable;
	
				if (query.qname == "Query") eQueryTable = query.QueryTable;else eQueryTable = query;
	
				var pTable = eQueryTable.Properties.Table;
				queryTable.tableId = pTable.refentityid;
				queryTable.tableName = pTable.V;
				queryTable.aliasName = eQueryTable.Properties.Alias.V;
	
				queryTable.output = eQueryTable.Properties.Output.V;
				queryTable.isTempTable = eQueryTable.tempTable;
				queryTable.status = _QueryTableStatus2.default.valueOf(eQueryTable.Properties.Status.V);
	
				var eQueryRelation = eQueryTable.QueryRelation;
	
				queryTable.relationJoinMode = _QueryRelationJoinMode2.default.valueOf(eQueryRelation.Properties.JoinMode.V);
				queryTable.relation1N = _QueryRelation1N2.default.valueOf(eQueryRelation.Properties.Relation1N.V);
	
				var entityId;
				var innerId;
				var table;
				var tableField;
				var listRelations = eQueryRelation.Items;
				var fieldValue;
				var propertyXML;
				var queryRelations = [];
				if (listRelations.length > 0) {
					for (var i in listRelations) {
						var eRelation = listRelations[i];
						var queryRelationItem = new _QueryRelationItem2.default();
	
						propertyXML = eRelation.Properties.Field;
						queryRelationItem.tableId = propertyXML.refentityid;
						queryRelationItem.fieldId = propertyXML.refinnerid;
	
						if (eRelation.hasOwnProperty("dataField")) queryRelationItem.dataField = eRelation.dataField;
	
						queryRelationItem.fieldName = propertyXML.V;
						fieldValue = eRelation.Properties.FieldValue.V;
						if (queryRelationItem.fieldName != "") {
							fieldValue = QueryUtil.formatValue(fieldValue, propertyXML);
							queryRelationItem.fieldType = QueryUtil.getFieldType(propertyXML);
						}
						queryRelationItem.fieldValue = fieldValue == "null" ? null : fieldValue;
	
						propertyXML = eRelation.Properties.ParentField || eRelation.Properties.RelatedField;
						queryRelationItem.relatedTableId = propertyXML.refentityid;
						queryRelationItem.relatedFieldId = propertyXML.refinnerid;
						queryRelationItem.relatedFieldName = propertyXML.V;
						fieldValue = eRelation.Properties.RelatedValue.V;
						if (queryRelationItem.relatedFieldName != "") {
							fieldValue = QueryUtil.formatValue(fieldValue, propertyXML);
							queryRelationItem.fieldType = QueryUtil.getFieldType(propertyXML);
						}
						queryRelationItem.relatedFieldValue = fieldValue == "null" ? null : fieldValue;
	
						queryRelations.push(queryRelationItem);
					}
				}
				queryTable.queryRelations = queryRelations;
	
				var listWhere = eQueryTable.QueryWhere.Items;
				var queryWhereItems = [];
	
				for (var i = 0; i < listWhere.length; i++) {
					var eWhere = listWhere[i];
					var queryWhereItem = new _QueryWhereItem2.default();
					propertyXML = eWhere.Properties.Field;
					queryWhereItem.tableId = propertyXML.refentityid;
					queryWhereItem.fieldId = propertyXML.refinnerid;
					queryWhereItem.fieldName = propertyXML.V;
					fieldValue = eWhere.Properties.Value.V;
					if (queryWhereItem.fieldName != "") {
						fieldValue = QueryUtil.formatValue(fieldValue, propertyXML);
						queryWhereItem.fieldType = QueryUtil.getFieldType(propertyXML);
					}
					queryWhereItem.fieldValue = fieldValue;
					queryWhereItem.andOr = _QueryWhereAndOr2.default.valueOf(eWhere.Properties.AndOr.V);
					queryWhereItem.leftBracket = _QueryWhereLeftBracket2.default.valueOf(eWhere.Properties.LeftBracket.V);
					queryWhereItem.rightBracket = _QueryWhereRightBracket2.default.valueOf(eWhere.Properties.RightBracket.V);
					queryWhereItem.label = eWhere.Properties.Label.V;
					queryWhereItem.status = _QueryWhereStatus2.default.valueOf(eWhere.Properties.Status.V);
					queryWhereItem.tag = eWhere.tag;
					if (queryWhereItem.tag == null) queryWhereItem.tag = "";
					//queryWhereItems.push(queryWhereItem);
					queryWhereItems.push(queryWhereItem);
				}
				queryTable.queryWhere = queryWhereItems;
	
				var listOrderByItems = eQueryTable.QueryOrderBy.Items;
				var queryOrderByItems = [];
				if (listOrderByItems.length > 0) {
					for (var i = 0; i < listOrderByItems.length; i++) {
						var eOrderBy = listOrderByItems[i];
						var queryOrderByItem = new _QueryOrderByItem2.default();
						propertyXML = eOrderBy.Properties.Field;
						queryOrderByItem.tableId = propertyXML.refentityid;
						queryOrderByItem.fieldId = propertyXML.refinnerid;
						queryOrderByItem.fieldName = propertyXML.V;
						queryOrderByItem.orderBy = _QueryOrderByType2.default.valueOf(eOrderBy.Properties.OrderBy.V);
						queryOrderByItems.push(queryOrderByItem);
					}
				}
				queryTable.queryOrderBy = queryOrderByItems;
	
				var listAggregationItems = eQueryTable.QueryAggregations.Items;
				var queryAggregationItems = [];
				if (listAggregationItems.length > 0) {
					for (var _i5 = 0; _i5 < listAggregationItems.length; _i5++) {
						var eQueryAggregationItem = listAggregationItems[_i5];
						//eQueryAggregationItem.remoteClass = "gongqi.erp.gotmodel.query.QueryAggregationItem";
						var queryAggregationItem = new _QueryAggregationItem2.default();
						Object.assign(queryAggregationItem, eQueryAggregationItem);
						queryAggregationItems.push(queryAggregationItem);
					}
				}
				queryTable.queryAggregation = queryAggregationItems;
	
				var listJoins = eQueryTable.QueryJoins.Items;
				var queryJoins = [];
				if (listJoins.length > 0) {
					for (var i = 0; i < listJoins.length; i++) {
						var eJoinQueryTable = listJoins[i];
						var cQueryTable = QueryUtil.convertXML2QueryTable(eJoinQueryTable, queryTable);
						queryJoins.push(cQueryTable);
					}
				}
				queryTable.queryJoins = queryJoins;
	
				return queryTable;
			}
		}, {
			key: 'getInnerId',
			value: function getInnerId(base) {
				var nextInnerId = base.nextInnerId;
				base.nextInnerId = nextInnerId + 1;
				return nextInnerId;
			}
		}, {
			key: 'convertQueryTable2XML',
			value: function convertQueryTable2XML(queryTable, base) {
				if (!queryTable) return null;
	
				var eQueryTable;
				eQueryTable = { name: "A_QueryTable", id: "1",
					Properties: {
						Table: { V: "" },
						Alias: { V: "" },
						UserUpdate: { V: true },
						Output: { V: true },
						Status: { V: "Open" }
					},
					QueryRelation: {
						Properties: {
							Auto: { V: false },
							JoinMode: { V: "None" },
							Relation1N: { V: "ManyToOne" }
						},
						Items: []
					},
					QueryFields: {
						Properties: {
							Auto: { V: true }
						},
						Items: []
					},
					QueryGroupBy: { name: "GroupBy" },
					QueryOrderBy: { name: "OrderBy", Items: [] },
					QueryWhere: {
						name: "Where",
						Items: []
					},
					QueryAggregations: {
						name: "Aggregations",
						Items: []
					},
					QueryJoins: {
						name: "Joins",
						Items: []
					}
	
				};
	
				_GOTUtil2.default.getProperty(eQueryTable, "Table").V = queryTable.tableName;
				_GOTUtil2.default.getProperty(eQueryTable, "Table").refentityid = queryTable.tableId;
				_GOTUtil2.default.getProperty(eQueryTable, "Alias").V = queryTable.aliasName;
	
				_GOTUtil2.default.getProperty(eQueryTable, "Output").V = queryTable.output;
				_GOTUtil2.default.getProperty(eQueryTable, "Status").V = _QueryTableStatus2.default.getLabel(queryTable.status);
	
				eQueryTable.id = QueryUtil.getInnerId(base);
				eQueryTable.name = queryTable.aliasName;
				eQueryTable.tempTable = queryTable.isTempTable;
	
				var eQueryRelation = eQueryTable.QueryRelation;
	
				_GOTUtil2.default.getProperty(eQueryRelation, "JoinMode").V = _QueryRelationJoinMode2.default.labelOf(queryTable.relationJoinMode);
				_GOTUtil2.default.getProperty(eQueryRelation, "Relation1N").V = _QueryRelation1N2.default.labelOf(queryTable.relation1N);
	
				var innerId;
				var tableField;
				var fieldValue;
				var propertyXML;
	
				if (queryTable.queryRelations && queryTable.queryRelations.length > 0) {
					for (var i = 0; i < queryTable.queryRelations.length; i++) {
						var queryRelationItem = queryTable.queryRelations[i];
						var eRelationItem = { qname: "QueryRelationItem", name: "A_QueryRelationItem", id: "2",
							Properties: { Field: { V: "" }, ParentField: { V: "" }, FieldValue: { V: "" }, RelatedValue: { V: "" } }
						};
						var name;
	
						if (queryRelationItem.fieldName) _GOTUtil2.default.getProperty(eRelationItem, "Field").V = queryRelationItem.fieldName;
						if (queryRelationItem.fieldValue) _GOTUtil2.default.getProperty(eRelationItem, "FieldValue").V = queryRelationItem.fieldValue;
						if (queryRelationItem.tableId) _GOTUtil2.default.getProperty(eRelationItem, "Field").refentityid = queryRelationItem.tableId;
						if (queryRelationItem.fieldId) _GOTUtil2.default.getProperty(eRelationItem, "Field").refinnerid = queryRelationItem.fieldId;
						if (queryRelationItem.relatedFieldName) _GOTUtil2.default.getProperty(eRelationItem, "ParentField").V = queryRelationItem.relatedFieldName;
						if (queryRelationItem.relatedFieldValue) _GOTUtil2.default.getProperty(eRelationItem, "RelatedValue").V = queryRelationItem.relatedFieldValue;
						if (queryRelationItem.relatedTableId) _GOTUtil2.default.getProperty(eRelationItem, "ParentField").refentityid = queryRelationItem.relatedTableId;
						if (queryRelationItem.relatedFieldId) _GOTUtil2.default.getProperty(eRelationItem, "ParentField").refinnerid = queryRelationItem.relatedFieldId;
						if (queryRelationItem.dataField) eRelationItem.dataField = queryRelationItem.dataField;
	
						eQueryRelation.Items.push(eRelationItem);
						eRelationItem.id = QueryUtil.getInnerId(base);
	
						if (queryRelationItem.fieldName && queryRelationItem.fieldName != "" && queryRelationItem.fieldValue && queryRelationItem.fieldValue != "") {
							eRelationItem.name = queryTable.tableName + "." + queryRelationItem.fieldName + "=" + queryRelationItem.fieldValue;
						} else if (queryRelationItem.fieldName && queryRelationItem.fieldName != "" && queryRelationItem.relatedFieldName && queryRelationItem.relatedFieldName != "") {
							eRelationItem.name = queryTable.tableName + "." + queryRelationItem.fieldName + "=" + queryTable.parentProperty.tableName + "." + queryRelationItem.relatedFieldName;
						} else if (queryRelationItem.relatedFieldName && queryRelationItem.relatedFieldName != "" && queryRelationItem.relatedFieldValue && queryRelationItem.relatedFieldValue != "") {
							eRelationItem.name = queryTable.parentProperty.tableName + "." + queryRelationItem.relatedFieldName + "=" + queryRelationItem.relatedFieldValue;
						}
					}
				}
	
				var eQueryWhere = eQueryTable.QueryWhere;
	
				if (queryTable.queryWhere && queryTable.queryWhere.length > 0) {
	
					for (var _i6 = 0; _i6 < queryTable.queryWhere.length; _i6++) {
						var queryWhereItem = queryTable.queryWhere[_i6];
						var eWhereItem = { qname: _QueryWhereItem2.default, name: "A_QueryWhereItem", id: 6, Properties: {
								Field: { V: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" }, RightBracket: { V: "None" },
								Label: { V: "" }, Status: { V: "Open" }, Enabled: { V: true }
							} };
						_GOTUtil2.default.getProperty(eWhereItem, "Field").V = queryWhereItem.fieldName;
	
						if (queryWhereItem.fieldValue) _GOTUtil2.default.getProperty(eWhereItem, "Value").V = queryWhereItem.fieldValue;
	
						_GOTUtil2.default.getProperty(eWhereItem, "Field").refentityid = queryWhereItem.tableId;
						_GOTUtil2.default.getProperty(eWhereItem, "Field").refinnerid = queryWhereItem.fieldId;
	
						_GOTUtil2.default.getProperty(eWhereItem, "AndOr").V = _QueryWhereAndOr2.default.labelOf(queryWhereItem.andOr);
						_GOTUtil2.default.getProperty(eWhereItem, "LeftBracket").V = _QueryWhereLeftBracket2.default.labelOf(queryWhereItem.leftBracket);
						_GOTUtil2.default.getProperty(eWhereItem, "RightBracket").V = _QueryWhereRightBracket2.default.labelOf(queryWhereItem.rightBracket);
	
						if (queryWhereItem.label) _GOTUtil2.default.getProperty(eWhereItem, "Label").V = queryWhereItem.label;
	
						_GOTUtil2.default.getProperty(eWhereItem, "Status").V = _QueryWhereStatus2.default.getLabel(queryWhereItem.status);
						eQueryWhere.Items.push(eWhereItem);
						eWhereItem.id = QueryUtil.getInnerId(base);
	
						eWhereItem.name = queryWhereItem.fieldName + "#" + queryWhereItem.fieldValue;
	
						if (queryWhereItem.tag) {
							eWhereItem.tag = queryWhereItem.tag;
						} else {
							eWhereItem.tag = "";
						}
					}
				}
	
				var eQueryOrderBy = eQueryTable.QueryOrderBy;
	
				if (queryTable.queryOrderBy && queryTable.queryOrderBy.length > 0) {
	
					for (var _i7 = 0; _i7 < queryTable.queryOrderBy.length; _i7++) {
						var queryOrderByItem = queryTable.queryOrderBy[_i7];
						var eOrderByItem = {
							name: "A_QueryOrderByItem", id: 5, Properties: { Field: { V: "" }, OrderBy: { V: "ASC" } }
						};
						_GOTUtil2.default.getProperty(eOrderByItem, "Field").V = queryOrderByItem.fieldName;
						var orderByType;
						if (queryOrderByItem.orderBy == _QueryOrderByType2.default.DESC) {
							orderByType = "DESC";
						} else {
							orderByType = "ASC";
						}
						_GOTUtil2.default.getProperty(eOrderByItem, "OrderBy").V = orderByType;
						_GOTUtil2.default.getProperty(eOrderByItem, "Field").refentityid = queryOrderByItem.tableId;
						_GOTUtil2.default.getProperty(eOrderByItem, "Field").refinnerid = queryOrderByItem.fieldId;
	
						eQueryOrderBy.Items.push(eOrderByItem);
						eOrderByItem.id = QueryUtil.getInnerId(base);
	
						eOrderByItem.name = queryOrderByItem.fieldName + "#" + orderByType;
					}
				}
	
				//aggregation 客户端不会使用 直接原样保存并返回给后台
				var eQueryAggregations = eQueryTable.QueryAggregations;
	
				if (queryTable.queryAggregation && queryTable.queryAggregation.length > 0) {
					for (var _i8 = 0; _i8 < queryTable.queryAggregation.length; _i8++) {
						var queryAggregationItem = queryTable.queryAggregation[_i8];
						eQueryAggregations.Items.push(queryAggregationItem);
					}
				}
	
				var eQueryJions = eQueryTable.QueryJoins;
	
				if (queryTable.queryJoins && queryTable.queryJoins.length > 0) {
	
					for (var _i9 = 0; _i9 < queryTable.queryJoins.length; _i9++) {
						var queryJion = queryTable.queryJoins[_i9];
						eQueryJions.Items.push(QueryUtil.convertQueryTable2XML(queryJion, base));
					}
				}
				return eQueryTable;
			}
		}, {
			key: 'createWhereItemByField',
			value: function createWhereItemByField(tableField, field, alias, query) {
				var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
				var queryTable = _GOTUtil2.default.getQueryTableByAlias(alias, query);
				var queryTableTablePro = queryTable.Properties.Table;
				var queryWhere = queryTable.QueryWhere;
	
				var queryWhereItem = { qname: _QueryWhereItem2.default, name: "A_QueryWhereItem", id: 6, Properties: {
						Field: { V: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" }, RightBracket: { V: "None" },
						Label: { V: "" }, Status: { V: "Open" }, Enabled: { V: true }
					} };
	
				var fieldPro = queryWhereItem.Properties.Field;
	
				var temp = query.nextInnerId;
				queryWhereItem.id = temp;
				temp++;
				query.nextInnerId = temp;
				queryWhereItem.name = field + " # " + value;
				fieldPro.V = field;
				fieldPro.refentityid = queryTableTablePro.refentityid;
				var _table = _GOT2.default.getTable(queryTableTablePro.refentityid);
				var refTableField = _GOT2.default.getTableField(_table, tableField);
				fieldPro.refinnerid = refTableField ? refTableField.id : "";
				if (value != null) {
					var valuePro = queryWhereItem.Properties.Value;
					if (value == "" && typeof value == "string") {
						value = "''";
					}
					if (refTableField && (refTableField.type == 'Date' || refTableField.type == 'Time') && value == "''") {
						value = "#null";
					}
					valuePro.V = value;
				}
				queryWhere.Items.push(queryWhereItem);
			}
		}, {
			key: 'dataSetViewcreateWhereItemByField',
			value: function dataSetViewcreateWhereItemByField(tableField, field, alias, query) {
				var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
				for (var j in query.QueryInteraction.Items) {
					var queryWhereItem = new _QueryWhereItem4.default();
					var item = query.QueryInteraction.Items[j];
					if (tableField == item.Properties.Field.V || tableField == item.Properties.Alias.V) {
						queryWhereItem.qname = _QueryWhereItem2.default;
						queryWhereItem.tableId = item.Properties.TableId.V; //String
						queryWhereItem.fieldId = item.Properties.Field.refinnerid; //String
						var tableFiled = _GOT2.default.getTableFieldById(item.Properties.Field.refentityid, item.Properties.Field.refinnerid);
						if (item.Properties.Field.V && item.Properties.Field.V.indexOf(".") == -1) {
							queryWhereItem.fieldName = tableFiled.name; //String
						} else {
							var sp = item.Properties.Field.V.split(".");
							var newfile = '';
							for (var k = 0; k < sp.length; k++) {
								if (newfile == '') {
									newfile = sp[k];
								} else {
									newfile = newfile + "_" + sp[k];
								}
							}
							queryWhereItem.fieldName = newfile;
						}
	
						// if(value.indexOf(">=") != -1 || value.indexOf("<=") != -1  || value.indexOf("<>") != -1 ) {
						// 	value = value.slice(0,2)+"\'"+value.slice(2)+"\'"; 
						// }
						queryWhereItem.value = value; //String
						queryWhereItem.andOr = "And"; //String
						queryWhereItem.leftBracket = "None"; //String	//QueryWhereLeftBracket
						queryWhereItem.rightBracket = "None"; //String	//QueryWhereRightBracket
	
						queryWhereItem.label = ""; //String
						queryWhereItem.status = "Open"; //String			//QueryWhereStatus
						queryWhereItem.fieldType = "Type" + tableFiled.type; //String	//QueryWhereFieldType
						queryWhereItem.tag = ""; //String
						//queryWhereItem.type="";
						//queryWhereItem.fieldValue = value;
						for (var i in query.queryWhere) {
							if (query.queryWhere[i].tableId === query.tableId && query.queryWhere[i].fieldId === item.Properties.Field.refinnerid && query.queryWhere[i].andOr === "And") {
								if (query.queryWhere[i].fieldType == "TypeDate") {
									if (value.indexOf(">=") != -1 && query.queryWhere[i].value.indexOf(">=") != -1 || value.indexOf("<=") != -1 && query.queryWhere[i].value.indexOf("<=") != -1 || value.indexOf("<>") != -1 && query.queryWhere[i].value.indexOf("<>") != -1) {
										query.queryWhere.splice(i, 1);
									}
								} else {
									query.queryWhere.splice(i, 1);
								}
							}
						}
						if (query.tableId == item.Properties.TableId.V) {
							if (value.indexOf("<>") == -1) {
								query.queryWhere.push(queryWhereItem);
							}
						} else if (query.queryJoins.length > 0) {
							for (var h in query.queryJoins) {
								query.queryJoins[h]["QueryInteraction"] = query.QueryInteraction;
								this.dataSetViewcreateWhereItemByField(item.Properties.Field.V, item.Properties.Field.V, alias, query.queryJoins[h], value);
							}
						}
					}
				}
			}
		}, {
			key: 'reverseOrderBy',
			value: function reverseOrderBy(queryOrderByCollection) {
				if (!queryOrderByCollection) return;
	
				for (var i = 0; i < queryOrderByCollection.length; i++) {
					var queryOrderByItem = queryOrderByCollection[i];
					if (queryOrderByItem.orderBy == _QueryOrderByType2.default.ASC) queryOrderByItem.orderBy = _QueryOrderByType2.default.DESC;else queryOrderByItem.orderBy = _QueryOrderByType2.default.ASC;
				}
			}
		}, {
			key: 'getQueryTableByName',
			value: function getQueryTableByName(query, name) {
				var items = query.QueryTable.QueryJoins.Items;
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.name == name) return item;
				}
				return null;
			}
		}, {
			key: 'getQueryTableByAlias2',
			value: function getQueryTableByAlias2(alias, queryTable) {
				if (!alias || !queryTable) return null;
	
				var _alias = _GOTUtil2.default.getPropertyValue(queryTable, "Alias");
				if (_alias == alias) return queryTable;
				var _alias2 = _GOTUtil2.default.getPropertyValue(queryTable, "Table");
				if (_alias2 == alias) return queryTable;
				if (!queryTable.QueryJoins) return null;
	
				var list = queryTable.QueryJoins.Items;
				if (!list || list.length == 0) return null;
	
				for (var i = 0; i < list.length; i++) {
					var qt = list[i];
					var result = QueryUtil.getQueryTableByAlias2(alias, qt);
					if (result) return result;
				}
	
				return null;
			}
		}, {
			key: 'getQueryTableByAlias',
			value: function getQueryTableByAlias(alias, query) {
				var queryTable = QueryUtil.getQueryTableByAlias2(alias, query.QueryTable);
				if (!queryTable) throw new Error("queryTable can't find");
	
				return queryTable;
			}
		}, {
			key: 'getQueryTableById2',
			value: function getQueryTableById2(id, queryTable) {
				if (!id || !queryTable) return null;
	
				if (id == queryTable.id) return queryTable;
	
				if (!queryTable.QueryJoins) return null;
	
				var list = queryTable.QueryJoins.Items;
				if (!list || list.length == 0) return null;
	
				for (var i = 0; i < list.length; i++) {
					var qt = list[i];
					var result = QueryUtil.getQueryTableById2(id, qt);
					if (result) return result;
				}
	
				return null;
			}
		}, {
			key: 'getQueryTableById',
			value: function getQueryTableById(id, query) {
				var queryTable = QueryUtil.getQueryTableById2(id, query.QueryTable);
				return queryTable;
			}
		}, {
			key: 'getQueryRelationItemByProperty',
			value: function getQueryRelationItemByProperty(queryTable, dataField) {
				var result = [];
				var items = queryTable.QueryRelation.Items;
				for (var i = 0; i < items.length; i++) {
					var queryRelationItem = items[i];
					if (queryRelationItem.hasOwnProperty(dataField)) {
						result.push(queryRelationItem);
					}
				}
				return result;
			}
		}, {
			key: 'consQueryByQuery',
			value: function consQueryByQuery(formQuery) {
				var query = formQuery;
				var queryTable1 = QueryUtil.getQueryTableByName(query, "Auto_JoinParent");
				var refentityid = queryTable1.Properties.Table.refentityid;
				var tableR1 = _GOT2.default.getTable(refentityid);
				var tableR1Id = tableR1.id;
	
				var tableRNPro = query.QueryTable.Properties.Table;
				if (!tableRNPro.hasOwnProperty("refentityid")) throw new Error("DataSource没有关联Table");
				var tableRNId = tableRNPro.refentityid;
				var tableRN = _GOT2.default.getTable(tableRNId);
	
				// add RelationItem
				var queryTable1Relation = queryTable1.QueryRelation;
				//var tableRNRelations = tableRN.TableRelations.Relations;
				var fieldRelations = [];
				var queryTable1RelationItem;
				var flag = false;
				/*for(var i = 0;i<tableRNRelations.length;i++)
	   {
	   	var tableRNRelation = tableRNRelations[i];
	   	if(tableRNRelation.Properties.Table.V == tableR1.name)
	   	{
	   		var tableRelationItems = tableRNRelation.RelationItems;
	   		for(var k = 0;k<tableRelationItems.length;k++)
	   		{
	   			var tableRNRelationItem = tableRelationItems[k];
	   			var type = tableRNRelationItem.type;
	   					queryTable1RelationItem = {qname:"QueryRelationItem",name:"A_QueryRelationItem",id:"2",
	   				Properties:{Field:{V:""},ParentField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}}
	   			};
	   			if(type == "Normal")
	   			{
	   				flag = true;
	   				var fieldPro = tableRNRelationItem.Properties.Field;
	   				
	   				var relatedFieldPro = tableRNRelationItem.Properties.RelatedField
	   										|| tableRNRelationItem.Properties.ParentField;
	   					
	   				fieldRelations.push({id:relatedFieldPro.refinnerid,value:relatedFieldPro.V});
	   				
	   				queryTable1RelationItem.Properties.Field.V = relatedFieldPro.Value;
	   				queryTable1RelationItem.Properties.Field.refentityid = relatedFieldPro.refentityid;
	   				queryTable1RelationItem.Properties.Field.refinnerid = relatedFieldPro.refinnerid;
	   				queryTable1RelationItem.Properties.ParentField.V = fieldPro.V;
	   				
	   				queryTable1RelationItem.Properties.ParentField.refentityid = tableRN.id;
	   				queryTable1RelationItem.Properties.ParentField.refinnerid = fieldPro.innerid;
	   				queryTable1RelationItem.name = tableR1.name + "." + relatedFieldPro.V + "=" + tableRN.name + "." + fieldPro.V;
	   				
	   				
	   				
	   			}
	   			else if(type == "Fixed")
	   			{
	   				fieldPro = tableRNRelationItem.Properties.Field;
	   				valuePro = tableRNRelationItem.Properties.Value;
	   				queryTable1RelationItem.Properties.ParentField.V = fieldPro.V;
	   				queryTable1RelationItem.Properties.ParentField.refentityid = fieldPro.refentityid;
	   				queryTable1RelationItem.Properties.ParentField.refinnerid = fieldPro.refinnerid;
	   				queryTable1RelationItem.Properties.RelatedValue.V = valuePro.V;
	   				queryTable1RelationItem.name = tableRN.name + "." + fieldPro.V + "=" + valuePro.V;
	   			}
	   			else if(type == "RelatedFixed")
	   			{
	   				relatedFieldPro = tableRNRelationItem.Properties.RelatedField
	   									|| tableRNRelationItem.Properties.ParentField;
	   				var valuePro = tableRNRelationItem.Properties.Value;
	   				queryTable1RelationItem.Properties.Field.V = relatedFieldPro.V;
	   				queryTable1RelationItem.Properties.Field.refentityid = relatedFieldPro.refentityid;
	   				queryTable1RelationItem.Properties.Field.refinnerid = relatedFieldPro.refinnerid;
	   				queryTable1RelationItem.Properties.FieldValue.V = valuePro.V;
	   				queryTable1RelationItem.name = tableR1.name + "." + relatedFieldPro.V + "=" + valuePro.V;	
	   			}
	   			
	   			queryTable1Relation.Items.push(queryTable1RelationItem);
	   			if(type=="Normal")
	   			{
	   				var rtemp2 = JSON.parse(JSON.stringify(queryTable1RelationItem));
	   				
	   				var sDataField;
	   				var pFieldForDataField = rtemp2.Properties.Field;
	   				sDataField = pFieldForDataField.V;
	   				sDataField = sDataField.substr(0,1).toLowerCase() + sDataField.substring(1);
	   				rtemp2.dataField = sDataField;
	   				
	   				var pField = rtemp2.Properties.ParentField;
	   					
	   				pField.V = "";
	   				delete pField.refentityid;
	   				delete pField.refinnerid;
	   				
	   				queryTable1Relation.Items.push(rtemp2);
	   			}
	   			
	   		}
	   		
	   		break;
	   	}
	   }*/
	
				//find dataType
				if (!flag) {
					var tableRNFields = tableRN.TableFields;
					for (var i = 0; i < tableRNFields.length; i++) {
						var tableRNField = tableRNFields[i];
						var extendsDataType = tableRNField.Properties.Extends.V;
						if (extendsDataType != "") {
							var obj = _GOTUtil2.default.getMainTable(extendsDataType);
							if (obj && obj.mainTable === tableR1.name) {
								queryTable1RelationItem = { qname: "QueryRelationItem", name: "A_QueryRelationItem", id: "2",
									Properties: { Field: { V: "" }, ParentField: { V: "" }, FieldValue: { V: "" }, RelatedValue: { V: "" } }
								};
								var dataType = obj.dataType;
								var normalRelationItem = _GOTUtil2.default.getNormalRelationItem(dataType);
								if (!normalRelationItem) throw new Error("DataType的Relation中没有Normal（没有指明其关联到主表的哪个字段）");
	
								var fieldPro = normalRelationItem.Properties.Field;
	
								var tableR1Field = fieldPro.V;
								var tableR1FieldId = fieldPro.refinnerid;
								fieldRelations.push({ id: tableR1FieldId, value: tableR1Field });
								queryTable1RelationItem.Properties.Field.V = tableR1Field;
								queryTable1RelationItem.Properties.Field.refentityid = tableR1Id;
								queryTable1RelationItem.Properties.Field.refinnerid = tableR1FieldId;
								queryTable1RelationItem.Properties.ParentField.V = tableRNField.name;
								queryTable1RelationItem.Properties.ParentField.refentityid = tableRN.id;
								queryTable1RelationItem.Properties.ParentField.refinnerid = tableRNField.id;
								queryTable1RelationItem.name = tableR1.name + "." + tableR1Field + "=" + tableRN.name + "." + tableRNField.name;
	
								queryTable1Relation.Items.push(queryTable1RelationItem);
	
								var rtemp2 = JSON.parse(JSON.stringify(queryTable1RelationItem));
	
								var pFieldForDataField = rtemp2.Properties.Field;
								var sDataField = pFieldForDataField.V;
								sDataField = sDataField.substr(0, 1).toLowerCase() + sDataField.substring(1);
								rtemp2.dataField = sDataField;
	
								var pField = rtemp2.Properties.ParentField || rtemp2.Properties.RelatedField;
								pField.V = "";
								pField.refentityid;
								pField.refinnerid;
	
								queryTable1Relation.Items.push(rtemp2);
	
								var fixedItems = _GOTUtil2.default.getFixedRelationItem(dataType);
								for (var i = 0; i < fixedItems.length; i++) {
									var relationItem = fixedItems[i];
									queryTable1RelationItem = { qname: "QueryRelationItem", name: "A_QueryRelationItem", id: "2",
										Properties: { Field: { V: "" }, RelatedField: { V: "" }, FieldValue: { V: "" }, RelatedValue: { V: "" } }
									};
									fieldPro = relationItem.Properties.Field;
									valuePro = relationItem.Properties.FixedValue;
									queryTable1RelationItem.Properties.Field.V = fieldPro.V;
									queryTable1RelationItem.Properties.Field.refentityid = fieldPro.refentityid;
									queryTable1RelationItem.Properties.Field.refinnerid = fieldPro.refinnerid;
									queryTable1RelationItem.Properties.FieldValue.V = valuePro.V;
									queryTable1RelationItem.name = tableR1.name + "." + fieldPro.V + "=" + valuePro.V;
									queryTable1Relation.Items.push(queryTable1RelationItem);
								}
	
								break;
							}
						}
					}
				}
	
				return query;
			}
		}, {
			key: 'findWhereItemByField',
			value: function findWhereItemByField(field, alias, query) {
				var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
				var queryTable = QueryUtil.getQueryTableByAlias(alias, query);
				var queryTableTablePro = _GOTUtil2.default.getProperty(queryTable, "Table");
				var queryWhere = queryTable.QueryWhere;
				var queryWhereItem;
				var queryWhereItems = _GOTUtil2.default.getQueryWhereItemByPropertyValue(queryTable, "Field", field);
				if (queryWhereItems && queryWhereItems.length > 0) {
					queryWhereItem = queryWhereItems[0];
					var status = _GOTUtil2.default.getPropertyValue(queryWhereItem, "Status");
					if (status != _QueryWhereStatus2.default.OPENLABEL) return null;
				}
				return queryWhereItem;
			}
		}, {
			key: 'findOrCreateWhereItemByField',
			value: function findOrCreateWhereItemByField(tableField, field, alias, query) {
				var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
				var queryWhereItem = QueryUtil.findWhereItemByField(field, alias, query, value);
				if (value == ',') value = "','";
				if (queryWhereItem) {
					if (value != null) {
						var valuePro = _GOTUtil2.default.getProperty(queryWhereItem, "Value");
						if (value == "" || !value) {
							if (!(typeof value == "number" && value == 0)) value = "''";
						}
						valuePro.V = value;
					}
				} else {
					QueryUtil.createWhereItemByField(tableField, field, alias, query, value);
				}
			}
		}, {
			key: 'findOrCreateWhereItem',
			value: function findOrCreateWhereItem(dataField, query) {
				var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
				var dataFieldArray = dataField.split(".");
				var tableAlias = dataFieldArray[0];
				var lowerTableField = dataFieldArray[1];
				var tableField = _StringUtil2.default.convertToFirstUpperCase(lowerTableField);
				if (dataFieldArray.length > 3) {
					lowerTableField = dataField.substring(dataField.indexOf('.') + 1);
					tableField = lowerTableField;
				}
				var lowerComponentField = "";
				var componentField = "";
				if (dataFieldArray.length == 3) {
					lowerComponentField = dataFieldArray[2];
					componentField = _StringUtil2.default.convertToFirstUpperCase(lowerComponentField);
				}
				var field = componentField == "" ? tableField : tableField + "." + componentField;
	
				QueryUtil.findOrCreateWhereItemByField(tableField, field, tableAlias, query, value);
			}
		}, {
			key: 'getAllOrderByItems',
			value: function getAllOrderByItems(queryTable, array) {
				var del = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
				var orderBy = queryTable.QueryOrderBy;
				for (var i = 0; i < orderBy.Items.length; i++) {
					var item = orderBy.Items[i];
					if (!item.queryTableAlias) item.queryTableAlias = _GOTUtil2.default.getPropertyValue(queryTable, 'Alias');
				}
				array.push.apply(array, orderBy.Items);
				if (del) orderBy.Items = [];
				var list = queryTable.QueryJoins.Items;
				// if(!list)
				if (list.length == 0) return array;
				for (var _i10 = 0; _i10 < list.length; _i10++) {
					QueryUtil.getAllOrderByItems(list[_i10], array);
				}
			}
		}, {
			key: 'setCurrentQueryOrderByByDataField',
			value: function setCurrentQueryOrderByByDataField(dataField, query) {
				var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
				var byUser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
				var cover = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
				var dataFieldArray = dataField.split(".");
				var tableAlias = dataFieldArray[0];
				var lowerTableField = dataFieldArray[1];
				var tableField = _StringUtil2.default.convertToFirstUpperCase(lowerTableField);
				var lowerComponentField = "";var componentField = "";
				if (dataFieldArray.length == 3) {
					lowerComponentField = dataFieldArray[2];
					componentField = _StringUtil2.default.convertToFirstUpperCase(lowerComponentField);
				} else if (dataFieldArray.length > 3) {
					tableField = dataField.substring(dataField.indexOf(".") + 1);
				}
	
				var field = componentField == "" ? tableField : tableField + "." + componentField;
				var queryTable = QueryUtil.getQueryTableByAlias(tableAlias, query);
				var queryTableTablePro = _GOTUtil2.default.getProperty(queryTable, "Table");
				var orderBy = queryTable.QueryOrderBy;var orderByItems = orderBy.Items;var orderByItem = null;
				var allOrderByItems = [];
				QueryUtil.getAllOrderByItems(query.QueryTable, allOrderByItems, byUser);
	
				for (var i = 0; i < allOrderByItems.length; i++) {
					var item = allOrderByItems[i];
					if (item.hasOwnProperty("sorting")) delete item.sorting;
					if (!orderByItem && _GOTUtil2.default.getPropertyValue(item, "Field") == field && item.queryTableAlias == tableAlias) orderByItem = item;
				}
	
				var orderByType;
	
				//没有 加在第一个 若是点击的列头 那么固定为升序 若是右键菜单 则按照参数指定的
				if (!orderByItem) {
					if (sortType == null) return;
					if (sortType != null) orderByType = sortType;else orderByType = "ASC";
					orderByItem = {
						name: "A_QueryOrderByItem", id: 5, Properties: { Field: { V: "" }, OrderBy: { V: "ASC" } }
					};
	
					orderByItem.sorting = true;
					var fieldPro = _GOTUtil2.default.getProperty(orderByItem, "Field");
					var orderByPro = _GOTUtil2.default.getProperty(orderByItem, "OrderBy");
	
					var temp = query.nextInnerId;orderByItem.id = temp;temp++;
					query.nextInnerId = temp;
					orderByItem.name = tableField + " # " + orderByType;
					fieldPro.V = field;
					fieldPro.refentityid = queryTableTablePro.refentityid;
					var tableXML = _GOT2.default.getTable(queryTableTablePro.refentityid);
					var tableFieldXML = _GOT2.default.getTableField(tableXML, tableField);
					fieldPro.refinnerid = tableFieldXML ? tableFieldXML.id : "";
					orderByPro.V = orderByType;
					if (!orderBy.Items) orderBy.Items = [];
					orderBy.Items.push(orderByItem);
				}
				//存在 提前 若是点击的列头 那么反转排序属性 若是右键菜单 则按照参数指定
				else {
						if (sortType == null) {
							var _items = orderBy.Items;
							var childIndex = _items.indexOf(orderByItem);
							_items.splice(childIndex, 1);
						} else {
							var tempItem = JSON.parse(JSON.stringify(orderByItem));
							orderByPro = _GOTUtil2.default.getProperty(tempItem, "OrderBy");
							fieldPro = _GOTUtil2.default.getProperty(tempItem, "Field");
	
							if (sortType) orderByType = sortType;else {
								orderByType = orderByPro.V;
								orderByType = orderByType == "ASC" ? "DESC" : "ASC";
							}
							orderByPro.V = orderByType;
							tempItem.name = fieldPro.V + " # " + orderByType;
							tempItem.sorting = true;
							var _items = orderBy.Items;
							var childIndex = _items.indexOf(orderByItem);
							_items.splice(childIndex, 1);
							_items.unshift(tempItem);
						}
					}
			}
		}, {
			key: 'formatEnumLabel',
			value: function formatEnumLabel(value, entityId, innerId) {
				var property = _GOTPropertiesUtil2.default.getItemPropertyFinalValue(window.menuItemId, entityId, innerId);
				if (!property) return value;
				var dataProvider = [];
				if (property.hasOwnProperty("DataProvider")) dataProvider = property.DataProvider;
				var func = function func(args) {
					var a = "";
					if (args.length > 0) a = args[0];
					for (var k = 0; k < dataProvider.length; k++) {
						var item = dataProvider[k];
						if (item.hasOwnProperty("value") && item.value == a) {
							return item.label;
						}
					}
					return a;
				};
				value = value.replace(/\d+/g, func);
				return value;
	
				var array = [];
				value = value + "";
				var values = value.split(",");
				for (var i = 0; i < values.length; i++) {
					var s1 = values[i];
					var values1 = s1.split("..");
					for (var j = 0; j < values1.length; j++) {
						var s2 = values1[j];
						if (!isNaN(parseInt(s2))) {
							array.push(s2);
						}
					}
				}
				var property = _GOTPropertiesUtil2.default.getItemPropertyFinalValue(window.menuItemId, entityId, innerId);
				if (!property) return value;
				var dataProvider = [];
				if (property.hasOwnProperty("DataProvider")) dataProvider = property.DataProvider;
				for (var _i11 = 0; _i11 < array.length; _i11++) {
					var a = array[_i11];
					for (var k = 0; k < dataProvider.length; k++) {
						var item = dataProvider[k];
						if (item.hasOwnProperty("value") && item.value == a) {
							value = value.replace(a, item.label);
						}
					}
				}
	
				return value;
			}
		}, {
			key: 'descendantsQueryTables',
			value: function descendantsQueryTables(queryTable, results, parents) {
				results.push(queryTable);
				for (var i = 0; i < queryTable.QueryJoins.Items.length; i++) {
					var childQueryTable = queryTable.QueryJoins.Items[i];
					parents[childQueryTable.id] = queryTable;
					QueryUtil.descendantsQueryTables(childQueryTable, results, parents);
				}
			}
		}, {
			key: 'descendantsChildQueryTables',
			value: function descendantsChildQueryTables(queryTable, results, parents) {
				var self = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
				if (self) results.push(queryTable);
				for (var i = 0; i < queryTable.QueryJoins.Items.length; i++) {
					var childQueryTable = queryTable.QueryJoins.Items[i];
					parents[childQueryTable.id] = queryTable;
					QueryUtil.descendantsChildQueryTables(childQueryTable, results, parents, true);
				}
			}
		}, {
			key: 'isJSON_test',
			value: function isJSON_test(str) {
				if (typeof str == 'string') {
					try {
						var json = JSON.parse(str);
						if ((typeof json === 'undefined' ? 'undefined' : _typeof(json)) == "object") {
							return json;
						} else {
							return false;
						}
					} catch (e) {
						return false;
					}
				}
				return true;
			}
		}, {
			key: 'xmlQuery2JsonQuery',
			value: function xmlQuery2JsonQuery(xml) {
				var result = QueryUtil.isJSON_test(xml);
				if (result == false) {
					var x2js = new X2JS();
					xml = x2js.xml_str2json(xml).Query;
					var switchQueryTable = function switchQueryTable(queryTable) {
	
						if (queryTable.Properties.UserUpdate.V == "true") queryTable.Properties.UserUpdate.V = true;else if (queryTable.Properties.UserUpdate == "false") queryTable.Properties.UserUpdate.V = false;
	
						if (queryTable.Properties.Output.V == "true") queryTable.Properties.Output.V = true;else if (queryTable.Properties.Output == "false") queryTable.Properties.Output.V = false;
	
						if (queryTable.tempTable == "true") queryTable.tempTable = true;else if (queryTable.tempTable == "false") queryTable.tempTable = false;
	
						if (queryTable.QueryWhere) {
							var queryWhereItem = queryTable.QueryWhere.QueryWhereItem;
	
							if (!queryWhereItem) queryTable.QueryWhere.Items = [];else if (Array.isArray(queryWhereItem)) {
	
								for (var i = 0; i < queryWhereItem.length; i++) {
									var _queryWhereItem = queryWhereItem[i];
									_queryWhereItem.qname = "QueryWhereItem";
									if (_queryWhereItem.Properties.Enabled.V == "true") _queryWhereItem.Properties.Enabled.V = true;else if (_queryWhereItem.Properties.Enabled.V == "false") _queryWhereItem.Properties.Enabled.V = false;
								}
								queryTable.QueryWhere.Items = queryWhereItem;
							} else {
								queryWhereItem.qname = "QueryWhereItem";
								if (queryWhereItem.Properties.Enabled.V == "true") queryWhereItem.Properties.Enabled.V = true;else if (queryWhereItem.Properties.Enabled.V == "false") queryWhereItem.Properties.Enabled = false;
								queryTable.QueryWhere.Items = [queryWhereItem];
							}
							delete queryTable.QueryWhere.QueryWhereItem;
						}
						if (queryTable.QueryRelation) {
							var queryRelationItem = queryTable.QueryRelation.QueryRelationItem;
							if (!queryRelationItem) queryTable.QueryRelation.Items = [];else if (Array.isArray(queryRelationItem)) queryTable.QueryRelation.Items = queryRelationItem;else queryTable.QueryRelation.Items = [queryRelationItem];
							delete queryTable.QueryRelation.QueryRelationItem;
	
							if (queryTable.QueryRelation.Properties.Auto.V == "true") queryTable.QueryRelation.Properties.Auto.V = true;else if (queryTable.QueryRelation.Properties.Auto.V == "false") queryTable.QueryRelation.Properties.Auto.V = false;
	
							delete queryTable.QueryRelation.name;
						}
	
						if (queryTable.QueryOrderBy) {
							var queryOrderByItem = queryTable.QueryOrderBy.QueryOrderByItem;
							if (!queryOrderByItem) queryTable.QueryOrderBy.Items = [];else if (Array.isArray(queryOrderByItem)) queryTable.QueryOrderBy.Items = queryOrderByItem;else queryTable.QueryOrderBy.Items = [queryOrderByItem];
							delete queryTable.QueryOrderBy.QueryOrderByItem;
						}
	
						if (queryTable.QueryJoins) {
							var queryJoinTable = queryTable.QueryJoins.QueryTable;
							if (!queryJoinTable) queryTable.QueryJoins.Items = [];else if (Array.isArray(queryJoinTable)) queryTable.QueryJoins.Items = queryJoinTable;else queryTable.QueryJoins.Items = [queryJoinTable];
							delete queryTable.QueryJoins.QueryTable;
							for (var _i12 = 0; _i12 < queryTable.QueryJoins.Items.length; _i12++) {
								var queryJoinTableItem = queryTable.QueryJoins.Items[_i12];
								switchQueryTable(queryJoinTableItem);
							}
						}
	
						if (queryTable.QueryFields) {
							delete queryTable.QueryFields.name;
							if (queryTable.QueryFields.Properties.Auto.V == "true") queryTable.QueryFields.Properties.Auto.V = true;else if (queryTable.QueryFields.Properties.Auto.V == "false") queryTable.QueryFields.Properties.Auto.V = false;
							queryTable.QueryFields.Items = [];
						}
	
						if (queryTable.QueryAggregations) {
							queryTable.QueryAggregations.Items = [];
						}
					};
	
					switchQueryTable(xml.QueryTable);
				} else if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) == "object") {
					xml = result;
				}
	
				if (xml.Properties.UseCache) {
					if (xml.Properties.UseCache.V == "true") xml.Properties.UseCache.V = true;else if (xml.Properties.UseCache.V == "false") xml.Properties.UseCache.V = false;
				}
	
				var xmlCopy = JSON.parse(JSON.stringify(xml));
				QueryUtil.TempTest(xmlCopy);
				//Warn.show({text:JSON.stringify(xmlCopy)});
	
				return xml;
			}
		}, {
			key: 'TempTest',
			value: function TempTest(xml) {
				delete xml.name;
				delete xml.nextInnerId;
				delete xml.direction;
				delete xml.toEnd;
				delete xml.needRefresh;
				delete xml.name;
				delete xml.qname;
				delete xml.fileName;
				var switchQueryTable = function switchQueryTable(queryTable) {
					delete queryTable.name;
					delete queryTable.id;
	
					if (queryTable.QueryWhere) {
						var items = queryTable.QueryWhere.Items;
						for (var i = 0; i < items.length; i++) {
							var _queryWhereItem = items[i];
							delete _queryWhereItem.name;
							delete _queryWhereItem.qname;
							delete _queryWhereItem.tag;
							delete _queryWhereItem.id;
						}
					}
	
					if (queryTable.QueryOrderBy) {
						var _items2 = queryTable.QueryOrderBy.Items;
						for (var _i13 = 0; _i13 < _items2.length; _i13++) {
							var _queryOrderByItem = _items2[_i13];
							delete _queryOrderByItem.name;
							delete _queryOrderByItem.id;
						}
					}
	
					if (queryTable.QueryRelation) {
						for (var _i14 = 0; _i14 < queryTable.QueryRelation.Items.length; _i14++) {
							var queryRelationItem = queryTable.QueryRelation.Items[_i14];
							delete queryRelationItem.qname;
							delete queryRelationItem.name;
							delete queryRelationItem.id;
						}
					}
	
					if (queryTable.QueryJoins) {
						for (var _i15 = 0; _i15 < queryTable.QueryJoins.Items.length; _i15++) {
							var queryJoinTableItem = queryTable.QueryJoins.Items[_i15];
							switchQueryTable(queryJoinTableItem);
						}
					}
				};
	
				switchQueryTable(xml.QueryTable);
			}
		}, {
			key: 'queryCalculationOperator',
			value: function (_queryCalculationOperator) {
				function queryCalculationOperator(_x) {
					return _queryCalculationOperator.apply(this, arguments);
				}
	
				queryCalculationOperator.toString = function () {
					return _queryCalculationOperator.toString();
				};
	
				return queryCalculationOperator;
			}(function (query) {
	
				var queryTable = query.QueryTable;
				var tableName = _GOTUtil2.default.getPropertyValue(queryTable, "Table");
				var tablePro = _GOTUtil2.default.getProperty(queryTable, "Table");
				var userInfos = window.parent.window.userInfos ? window.parent.window.userInfos : window.userInfos;
				var queryWildcardCharacter = "*";
				if (userInfos.WILDCARD) {
					queryWildcardCharacter = userInfos.WILDCARD;
				}
	
				for (var i in queryTable.QueryWhere.Items) {
					var whereItem = queryTable.QueryWhere.Items[i];
					if (_GOTUtil2.default.getPropertyValue(whereItem, "Fieldflag")) {
						var tableFiled = _GOT2.default.getTableFieldById(tablePro.refentityid, _GOTUtil2.default.getProperty(whereItem, "Field").refinnerid);
						var type = tableFiled.type;
						var flag = _GOTUtil2.default.getPropertyValue(whereItem, "Fieldflag");
						if (flag == '开头是') {
							whereItem.Properties.Value.V = "#like(" + whereItem.Properties.Value.V + "%)";
						} else if (flag == '开头不是') {
							whereItem.Properties.Value.V = "!(" + whereItem.Properties.Value.V + queryWildcardCharacter + ")";
						} else if (flag == '结尾是') {
							whereItem.Properties.Value.V = "#like(%" + whereItem.Properties.Value.V + ")";
						} else if (flag == '结尾不是') {
							whereItem.Properties.Value.V = "!(" + queryWildcardCharacter + whereItem.Properties.Value.V + ")";
						} else if (flag == '包含') {
							whereItem.Properties.Value.V = "#like(%" + whereItem.Properties.Value.V + "%)";
						} else if (flag == '不包含') {
							whereItem.Properties.Value.V = "!(" + queryWildcardCharacter + whereItem.Properties.Value.V + queryWildcardCharacter + ")";
						} else if (flag == '为空' || flag == '空') {
							whereItem.Properties.Value.V = "#null";
						} else if (flag == '非空') {
							whereItem.Properties.Value.V = "#notNull";
						} else if (flag == '列表内') {
							whereItem.Properties.Value.V = "#in(" + whereItem.Properties.Value.V + ")";
						} else if (flag == '列表外') {
							whereItem.Properties.Value.V = "#notIn(" + whereItem.Properties.Value.V + ")";
						} else if (flag == '等于') {
							whereItem.Properties.Value.V = "=" + whereItem.Properties.Value.V;
						} else if (flag == '不等于') {
							if (type == "String") {
								whereItem.Properties.Value.V = "!=" + whereItem.Properties.Value.V;
							} else {
								whereItem.Properties.Value.V = "<>" + whereItem.Properties.Value.V;
							}
						} else if (flag == '大于') {
							whereItem.Properties.Value.V = ">" + whereItem.Properties.Value.V;
						} else if (flag == '大于等于') {
							whereItem.Properties.Value.V = ">=" + whereItem.Properties.Value.V;
						} else if (flag == '小于') {
							whereItem.Properties.Value.V = "<" + whereItem.Properties.Value.V;
						} else if (flag == '小于等于') {
							whereItem.Properties.Value.V = "<=" + whereItem.Properties.Value.V;
						} else if (flag == '介于') {
							// whereItem.Properties.Value.V = "#notLike(%"+whereItem.Properties.Value.V+")"
						} else if (flag == '今天') {
							if (type == 'Date') {
								var today = new Date();
								var formattedDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
								whereItem.Properties.Value.V = formattedDate;
							}
							if (type == "Time") {
								var now = new Date();
								var formattedTime = now.getHours() + '-' + pad(now.getMinutes(), 2) + '-' + pad(now.getSeconds(), 2);
								whereItem.Properties.Value.V = formattedTime;
							}
							if (type == "DateTime") {
								var _today = new Date();
								var _formattedDate = _today.getFullYear() + '-' + (_today.getMonth() + 1) + '-' + _today.getDate();
								var _formattedTime = _today.getHours() + '-' + pad(_today.getMinutes(), 2) + '-' + pad(_today.getSeconds(), 2);
								whereItem.Properties.Value.V = _formattedDate + " " + _formattedTime;
							}
						} else if (flag == '是') {
							if (type == "Boolean") {
								whereItem.Properties.Value.V = "true";
							}
						} else if (flag == '不是') {
							if (type == "Boolean") {
								whereItem.Properties.Value.V = "false";
							}
						}
					}
				}
				if (queryTable.QueryJoins) {
					for (var _i16 = 0; _i16 < queryTable.QueryJoins.Items.length; _i16++) {
						var queryJoinTableItem = queryTable.QueryJoins.Items[_i16];
						queryCalculationOperator(queryJoinTableItem);
					}
				}
			})
		}, {
			key: 'queryWhereItemRemoveFlag',
			value: function queryWhereItemRemoveFlag(whereItem, temp) {
				var userInfos = window.parent.window.userInfos ? window.parent.window.userInfos : window.userInfos;
				var queryWildcardCharacter = "*";
				if (userInfos.WILDCARD) {
					queryWildcardCharacter = userInfos.WILDCARD;
				}
				var flag = _GOTUtil2.default.getPropertyValue(whereItem, "Fieldflag");
				var value = _GOTUtil2.default.getPropertyValue(whereItem, "Value");
				if (value.startsWith("!=") || value.startsWith("<>") || value.startsWith("<=") || value.startsWith(">=")) {
					if (!flag) {
						if (value.startsWith("!=")) {
							temp.tfieldflag = "不等于";
						} else if (value.startsWith("<>")) {
							temp.tfieldflag = "不等于";
						} else if (value.startsWith("<=")) {
							temp.tfieldflag = "小于等于";
						} else if (value.startsWith(">=")) {
							temp.tfieldflag = "大于等于";
						}
					}
					value = value.substring(2, value.length);
				} else if (value.startsWith("<") || value.startsWith(">") || value.startsWith("=")) {
					if (!flag) {
						if (value.startsWith("=")) {
							temp.tfieldflag = "等于";
						} else if (value.startsWith("<")) {
							temp.tfieldflag = "小于";
						} else if (value.startsWith(">")) {
							temp.tfieldflag = "大于";
						}
					}
					value = value.substring(1, value.length);
				} else if (value.startsWith("#null") || value.startsWith("#notNull")) {
					if (!flag) {
						if (value.startsWith("#null")) {
							temp.tfieldflag = "为空";
						} else if (value.startsWith("#notNull")) {
							temp.tfieldflag = "非空";
						}
					}
					value = "";
				} else if (value.startsWith("#in")) {
					if (!flag) {
	
						temp.tfieldflag = "列表内";
					}
					value = value.substring(4, value.length - 1);
				} else if (value.startsWith("#notIn")) {
					if (!flag) {
						if (value.startsWith("#notIn")) {
							temp.tfieldflag = "列表外";
						}
					}
					value = value.substring(7, value.length - 1);
				} else if (value.startsWith("#like")) {
					if (!flag) {
						if (value.substring(5, 6) == queryWildcardCharacter && value.substring(value.length - 2, value.length - 1) != queryWildcardCharacter) {
							temp.tfieldflag = "开头是";
						} else if (value.substring(5, 6) != queryWildcardCharacter && value.substring(value.length - 2, value.length - 1) == queryWildcardCharacter) {
							temp.tfieldflag = "结尾是";
						} else if (value.substring(5, 6) == queryWildcardCharacter && value.substring(value.length - 2, value.length - 1) == queryWildcardCharacter) {
							temp.tfieldflag = "包含";
						}
					}
					if (flag == '开头是') {
						value = value.substring(6, value.length - 2);
					} else if (flag == '结尾是') {
						value = value.substring(7, value.length - 1);
					} else if (flag == '包含') {
						value = value.substring(7, value.length - 2);
					}
				} else if (value.startsWith("!(")) {
					if (!flag) {
						if (value.substring(2, 3) == queryWildcardCharacter && value.substring(value.length - 2, value.length - 1) != queryWildcardCharacter) {
							temp.tfieldflag = "开头不是";
						} else if (value.substring(2, 3) != queryWildcardCharacter && value.substring(value.length - 2, value.length - 1) == queryWildcardCharacter) {
							temp.tfieldflag = "结尾不是";
						} else if (value.substring(2, 3) == queryWildcardCharacter && value.substring(value.length - 2, value.length - 1) == queryWildcardCharacter) {
							temp.tfieldflag = "不包含";
						}
					}
					if (flag == '开头不是') {
						value = value.substring(2, value.length - 2);
					} else if (flag == '结尾不是') {
						value = value.substring(3, value.length - 1);
					} else if (flag == '不包含') {
						value = value.substring(3, value.length - 2);
					}
				} else if (value.length >= 3 && value.substring(value.length - 2, value.length) == queryWildcardCharacter + queryWildcardCharacter) {
					if (!flag) {
						temp.tfieldflag = "包含";
					}
					value = value.substring(0, value.length - 2);
				} else if (value.length >= 2 && value.substring(value.length - 1, value.length) == queryWildcardCharacter) {
					if (!flag) {
						temp.tfieldflag = "开头是";
					}
					value = value.substring(0, value.length - 1);
				} else if (value.length >= 2 && value.substring(value.length - 1, value.length) != queryWildcardCharacter && value.substring(0, 1) == queryWildcardCharacter) {
					if (!flag) {
						temp.tfieldflag = "结尾是";
					}
					value = value.substring(1, value.length);
				} else if (value.length >= 2 && value.substring(value.length - 1, value.length) == queryWildcardCharacter && value.substring(0, 1) == queryWildcardCharacter) {
					if (!flag) {
						temp.tfieldflag = "包含";
					}
					value = value.substring(1, value.length - 1);
				} else if (value == "true" || value == true) {
					if (!flag) {
						temp.tfieldflag = "是";
					}
				} else if (value == "false" || value == false) {
					if (!flag) {
						temp.tfieldflag = "不是";
					}
				}
				// }else if(value.startsWith("!(")  && value.substr(value.length-1,value.length)==")"){
				// 	value=value.substring(2,value.length-1);
				// }
	
				whereItem.Properties.Value.V = value;
			}
		}]);
	
		return QueryUtil;
	}();
	
	exports.default = QueryUtil;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['commandArgMapEditors', 'getSelectRecordsKey', "getSelectRecords", "callComponentFunc", "diaLogMapEditors", 'selectAllRecords', 'selectRecords2', 'reverseSelectedRecords', 'buttonShortCut', 'getColumnLengthProperties']);

/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cmd = function Cmd() {
		_classCallCheck(this, Cmd);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.remote.Cmd";
	} //TODO
	//TODO 
	//待调整
	//待调整
	//待调整
	//related createpolicy
	//related createpolicy
	//related createpolicy
	
	//				背景颜色			背景图片
	//Contianer-->backgroundColor,backgroundImage 
	//			最大大小			最小大小		最大宽度		最大高度			文件类型限制（仅上传）	最小宽度			最小高度			是否压缩
	//Image-->size,			sizeMin,		width,		height,			suffix,					widthMin,		heightMin,		compress
	//						是否密码框			是否禁用输入法		当为密码框时 密码显示的长度
	//StringEditor --> "displayAsPassword","imeEnable",			"passwordFixedLength"
	//related createpolicy
	
	//public final static String SetRecordConditionTask = "setRecordConditionTask";
	//public static const FormParamConditionTasks:String = "formParamConditionTasks";
	
	//private static const LockMode:String = "lockMode";	//待调整
	
	//public static const UpdateFieldShowLookup:String = "updateFieldShowLookup";
	
	//public static const UpdateFieldShowMainForm:String = "updateFieldShowMainForm";
	
	//public static const SelectAllRecords:String = "selectAllRecor"
	
	
	//public static const SetDataGridRowHeight:String = "setDataGridRowHeight";
	;
	
	Cmd.Alert = "alert";
	Cmd.CloseForm = "closeForm";
	Cmd.DoCloseForm = "doCloseForm";
	Cmd.OpenForm = "openForm";
	Cmd.OpenMainForm = "openMainForm";
	Cmd.RecordNew = "recordNew";
	Cmd.RecordSave = "recordSave";
	Cmd.RecordDelete = "recordDelete";
	Cmd.RecordRestore = "recordRestore";
	Cmd.ExecuteQuery = "executeQuery";
	Cmd.UpdateQuery = "updateQuery";
	Cmd.FetchAll = "fetchAll";
	Cmd.WriteField = "writeField";
	Cmd.DoWriteField = "doWriteField";
	Cmd.RestoreParent = "restoreParent";
	Cmd.OpenURL = "openURL";
	Cmd.OpenResource = "openResource";
	Cmd.FormCmd = "formCmd";
	Cmd.WriteEditor = "writeEditor";
	Cmd.DoWriteEditor = "doWriteEditor";
	Cmd.WriteImage = "writeImage";
	Cmd.Js = "js";
	Cmd.Npapi = "npapi";
	Cmd.ShowDialog = "showDialog";
	Cmd.FadeInfo = "fadeInfo";
	Cmd.UpdateControlVisible = "updateControlVisible";
	Cmd.UpdateControlShowDecimal = "updateControlShowDecimal";
	Cmd.UpdateControlAllowEdit = "updateControlAllowEdit";
	Cmd.UpdateControlLabel = "updateControlLabel";
	Cmd.UpdateControlSkipTab = "updateControlSkipTab";
	Cmd.DS_AllowAdd = "ds_AllowAdd";
	Cmd.DS_AllowDelete = "ds_AllowDelete";
	Cmd.DS_AllowQuery = "ds_AllowQuery";
	Cmd.DS_AllowChangeQuery = "ds_AllowChangeQuery";
	Cmd.DS_AllowSave = "ds_AllowSave";
	Cmd.DS_AllowExport = "ds_AllowExport";
	Cmd.DS_AllowAttachment = "ds_AllowAttachment";
	Cmd.DS_AllowEdit = "ds_AllowEdit";
	Cmd.TmpRecordAdd = "tmpRecordAdd";
	Cmd.TmpRecordDelete = "tmpRecordDelete";
	Cmd.TmpRecordClear = "tmpRecordClear";
	Cmd.TmpRecordRefresh = "tmpRecordRefresh";
	Cmd.SetControlProperty = "setControlProperty";
	Cmd.SetFormDataSourceGroupProperty = "setFormDataSourceGroupProperty";
	Cmd.UpdateQueryForm = "updateQueryForm";
	Cmd.UpdateQueryCurrent = "updateQueryCurrent";
	Cmd.ActiveRecord = "activeRecord";
	Cmd.ShowImage = "showImage";
	Cmd.FileUploadCmd = "fileUpload";
	Cmd.FileDownload = "fileDownload";
	Cmd.ShowInfo = "showInfo";
	Cmd.SetRecordConditionTask = "setRecordConditionTask";
	Cmd.SetFormParamConditionTask = "setFormParamConditionTask";
	Cmd.RefreshPlugin = "refreshPlugin";
	Cmd.FocusIn = "focusIn";
	Cmd.SwitchToTabPage = "switchToTabPage";
	Cmd.ParentCmdResult = "parentCmdResult";
	Cmd.LookupReturn = "lookupReturn";
	Cmd.ClientRecordRemove = "clientRecordRemove";
	Cmd.WriteDataMethodField = "writeDataMethodField";
	Cmd.LocateRecord = "locateRecord";
	Cmd.ButtonOk = "buttonOk";
	Cmd.ContextMap = "contextMap";
	Cmd.SortComponent = "sortComponent";
	Cmd.SortFormItem = "sortFormItem";
	Cmd.ShowClipboard = "showClipboard";
	Cmd.UpdateEditorShowLookup = "updateEditorShowLookup";
	Cmd.UpdateEditorShowMainForm = "updateEditorShowMainForm";
	Cmd.OpenLookup = "openLookup";
	Cmd.UpdateGroupCollapseState = "updateGroupCollapseState";
	Cmd.CreateTimer = "createTimer";
	Cmd.CancelTimer = "cancelTimer";
	Cmd.SelectRecords = "selectRecords";
	Cmd.LocateToRecord = "locateToRecord";
	Cmd.BindEditorStyle = "bindEditorStyle";
	Cmd.BindRowStyle = "bindRowStyle";
	Cmd.RemoveRowStyle = "removeRowStyle";
	Cmd.RemoveEditorStyle = "removeEditorStyle";
	Cmd.SetTextStyle = "setTextStyle";
	Cmd.SetButtonStyle = "setButtonStyle";
	Cmd.SetContainerStyle = "setContainerStyle";
	Cmd.ClientRecordAdd = "clientRecordAdd";
	Cmd.ClientRecordRefresh = "clientRecordRefresh";
	Cmd.SetFormTitle = "setFormTitle";
	Cmd.DimSortFormItem = "dimSortFormItem";
	Cmd.DimAdjustFormDataSourceField = "dimAdjustFormDataSourceField";
	Cmd.UpdateToolBar = "updateWorkflowToolBar";
	Cmd.HoldFocusIn = "holdFocusIn";
	Cmd.RegisterRender = "registerRender";
	Cmd.DragStart = "dragStart";
	Cmd.ShowCalculator = "showCalculator";
	Cmd.SysReinitForm = "sysReinitForm";
	Cmd.ShowClipboard = "showClipboard";
	Cmd.CallClientMethod = "callClientMethod";
	Cmd.UpdateDropDownContent = "updateDropDownContent";
	Cmd.OpenSubForm = "openSubForm";
	Cmd.Ds_AttachmentAllowVisible = "ds_AttachmentAllowVisible";
	Cmd.Ds_AttachmentAllowUpload = "ds_AttachmentAllowUpload";
	Cmd.Ds_AttachmentAllowRename = "ds_AttachmentAllowRename";
	Cmd.Ds_AttachmentAllowDelete = "ds_AttachmentAllowDelete";
	Cmd.OpenLuckySheet = "openLuckySheet";
	Cmd.UpdateAllowEditorNotSelectAll = 'updateAllowEditorNotSelectAll';
	Cmd.PrintReport = "printReport";
	exports.default = Cmd;

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandTask = function () {
		function CommandTask() {
			_classCallCheck(this, CommandTask);
	
			this.remoteClass = "gongqi.erp.gotmodel.form.remote.CommandTask";
		}
	
		_createClass(CommandTask, [{
			key: "setGroup",
			value: function setGroup(group) {
				this.group = group;
				return this;
			}
		}, {
			key: "setControl",
			value: function setControl(control) {
				this.control = control;
				return this;
			}
		}, {
			key: "setArg",
			value: function setArg(arg) {
				this.arg = arg;
				return this;
			}
		}]);
	
		return CommandTask;
	}();
	
	exports.default = CommandTask;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LookupAutoQueryStore = exports.LookupDropDownCloseStore = exports.LookupReturnMutiEditorStore = exports.LookupHostKeydownStore = exports.LookupasteriskRefreshStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LookupasteriskRefreshStore = exports.LookupasteriskRefreshStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_LookupActions2.default.lookupasteriskRefresh, 'onLookupAsteriskRefresh');
	    },
	    onLookupAsteriskRefresh: function onLookupAsteriskRefresh(formId, innerId, filter) {
	        this.trigger(formId, innerId, filter);
	    }
	});
	
	var LookupHostKeydownStore = exports.LookupHostKeydownStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_LookupActions2.default.lookupHostKeydown, 'onLookupHostKeydown');
	        //this.listenTo(LookupActions.lookupReturnMutiField,'onLookupReturnMutiField')
	    },
	    onLookupHostKeydown: function onLookupHostKeydown(lookupKey, keyCode) {
	        this.trigger(lookupKey, keyCode);
	    }
	    /*,
	    onLookupReturnMutiField(toDataField,value)
	    {
	    	this.trigger(toDataField,value);
	    }*/
	
	});
	
	var LookupReturnMutiEditorStore = exports.LookupReturnMutiEditorStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_LookupActions2.default.lookupReturnMutiEditor, 'onLookupReturnMutiEditor');
	    },
	    onLookupReturnMutiEditor: function onLookupReturnMutiEditor(editorName, value) {
	        this.trigger(editorName, value);
	    }
	});
	
	var LookupDropDownCloseStore = exports.LookupDropDownCloseStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_LookupActions2.default.popDropDownClose, 'onLookupPopDropDownClose');
	    },
	    onLookupPopDropDownClose: function onLookupPopDropDownClose(formId, innerId) {
	        this.trigger(formId, innerId);
	    }
	});
	
	var LookupAutoQueryStore = exports.LookupAutoQueryStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_LookupActions2.default.lookupAutoQuery, 'onLookupAutoQuery');
	    },
	    onLookupAutoQuery: function onLookupAutoQuery(key, args) {
	        this.trigger(key, args);
	    }
	});

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['getGridInfos', 'updateFetchAllIcon', 'updateInnerToolBar', 'keyDownCast', 'tabpageUserChanged', 'getDataGridColumnInfo', 'updateDataGrid', 'dynamicColumns', 'updateControlLabel']);

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Node的commonJS规范实现 import是ES6 node的这个规范与es6没有关系 将来要统一成ES6
	//暂时先用Node的commonJS模块化实现类似于面向对象编程中静态工具类方法的效果
	//const FormItemUtil = require("../utils/FormItemUtil");
	
	var FormItemContainer = function (_GongqiFormItem) {
		_inherits(FormItemContainer, _GongqiFormItem);
	
		function FormItemContainer(props) {
			_classCallCheck(this, FormItemContainer);
	
			var _this = _possibleConstructorReturn(this, (FormItemContainer.__proto__ || Object.getPrototypeOf(FormItemContainer)).call(this, props));
	
			_this.containsMaxControl = _this.containsMaxControl.bind(_this);
			return _this;
		}
	
		//判断子级是否包含诸如Tab DataGrid HtmlPlugin等固定百分百控件
	
	
		_createClass(FormItemContainer, [{
			key: 'containsMaxControl',
			value: function containsMaxControl(item) {
				var children = item.FormItem;
				if (children == null || children == undefined) return false;
				for (var i = 0; i < children.length; i++) {
					var child = children[i];
					if (child.type == "Tab" || child.type == "DataGrid" || child.type == "Plugin") return true;
					return this.containsMaxControl(child);
				}
				return false;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var layout = this.props.xml.Properties.Layout.Value;
				var parentLayout = this.props.parentLayout;
				var flexDirection = layout == "horizontal" ? "row" : "column";
				var style = {
					display: "flex",
					alignSelf: "stretch"
					//flex-direction:flexDirection,
					//align-items:"flex-start",
					//flex-grow:flexGrow
				};
				style["flexDirection"] = flexDirection;
				style["alignItems"] = "flex-start";
				var _containsMaxControl = this.containsMaxControl(this.props.xml);
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.props.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					var flexGrow = 0;
					var fixedWidth = false;
					if (_width == "" && _containsMaxControl) {
						flexGrow = 100;
					} else {
						var iex = _width.indexOf("%");
						if (iex != -1) {
							flexGrow = _width.substring(0, iex);
						}
	
						if (iex == -1 && _width != "") {
							flexGrow = _width + "px";
							fixedWidth = true;
						}
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;
	
					var _height = this.props.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
					if (_height == "" && _containsMaxControl) _height = "100%";
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.props.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 0;
						var fixedHeight = false;
						if (_height2 == "" && _containsMaxControl) {
							_flexGrow = 100;
						} else {
							var _iex = _height2.indexOf("%");
							if (_iex != -1) {
								_flexGrow = _height2.substring(0, _iex);
							}
							if (_iex == -1 && _height2 != "") {
								_flexGrow = _height2 + "px";
								fixedHeight = true;
							}
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;
	
						var _width2 = this.props.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "" && _containsMaxControl) _width2 = "100%";
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
	
				return style;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.containerComponent).contextPopup(this.props.contextMenuData);
			}
		}]);
	
		return FormItemContainer;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemContainer.defaultProps = {};
	
	exports.default = FormItemContainer;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemContainerControl = function (_GongqiFormItemContro) {
		_inherits(FormItemContainerControl, _GongqiFormItemContro);
	
		function FormItemContainerControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemContainerControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemContainerControl.__proto__ || Object.getPrototypeOf(FormItemContainerControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemContainerControl";
			return _this;
		}
	
		_createClass(FormItemContainerControl, [{
			key: 'getProperty_Layout',
			value: function getProperty_Layout() {
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && _properties.hasOwnProperty("layout")) return _properties["layout"];
				}
				return this.xml.Properties.Layout.Value;
			}
		}, {
			key: 'setControlProperty',
			value: function setControlProperty(property, value) {
				if (property == _ControlPropertyConst2.default.HASBORDER) {
					this.propertyHasBorder = value;
					this.hasBorderSetted = true;
					_CmdTypeActions2.default.updateControlProperty(this.xml.name, property, value, this.module.instanceUUId);
				}
			}
		}, {
			key: 'getFlexGrow100',
			value: function getFlexGrow100() {
				if (this.classAlias == "FormItemGroupControl" && !window.formHasDataGrid) {
					var parent = this.parentControl.xml;
					if (parent.id == "FormDesign") {
						var children = this.parentControl.childrenControl;
						if (children && children.indexOf(this) == children.length - 1) return true;
					}
				}
	
				return false;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var layout = this.getProperty_Layout(); //this.xml.Properties.Layout.Value;
				var parentLayout = this.parentControl.getProperty_Layout(); //this.parentXML.Properties.Layout.Value;
				var flexDirection = layout == "horizontal" ? "row" : "column";
				var style = {
					display: "flex",
					flex: 'none'
					//alignSelf:"stretch"
					//overflow:'auto'
				};
				if (this.parentControl && this.parentControl.classAlias == "FormItemDesignControl") style.alignSelf = "stretch";
				style["flexDirection"] = flexDirection;
				style["alignItems"] = "flex-start";
				var _containsMaxControl = this.containsMaxControl(this.xml, this.getProperty_Layout());
				//TODO由于某些情况 不能加入overflow为auto 但是去掉会导致某些分辨率低的情况页面超出 猜想是包含最大化控件的时候不能
				//加入 先加入留待后续观察
				if (!_containsMaxControl) style.overflow = 'auto';
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.getProperty_Width(); //this.xml.Properties.Width.Value;
					if (_width == undefined || _width == 0) _width = "";
					if (typeof _width == "number") _width = _width + "";
					var flexGrow = 0;
					var fixedWidth = false;
					var _containsMaxControl2 = this.containsMaxControlForWidth(this.xml);
					var _isFlexGrow = this.getFlexGrow100();
					if (_width == "" && !window.isPopUp && !window.isLookup && (_containsMaxControl2 || _isFlexGrow)) {
						flexGrow = 100;
					} else {
						var iex = _width.indexOf("%");
						if (iex != -1) {
							flexGrow = _width.substring(0, iex);
							style.width = _width;
						}
	
						if (iex == -1 && _width != "") {
							flexGrow = _width + "px";
							fixedWidth = true;
						}
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;else style["width"] = flexGrow;
	
					var _height = this.getProperty_Height(); //this.xml.Properties.Height.Value;
					if (_height == undefined || _height == 0) _height = "";
					if (_height == "" && !window.isPopUp && !window.isLookup) {
						var _containsMaxControl3 = this.containsMaxControlForHeight(this.xml);
						if (_containsMaxControl3) _height = "100%";
					}
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.getProperty_Height(); //this.xml.Properties.Height.Value;
						if (_height2 == undefined || _height2 == 0) _height2 = "";
						if (typeof _height2 == "number") _height2 = _height2 + "";
						var _flexGrow = 0;
						var fixedHeight = false;
						if (_height2 == "" && !window.isPopUp && !window.isLookup) {
							var _isFlexGrow2 = this.getFlexGrow100();
							if (_isFlexGrow2) _flexGrow = 100;else {
								var _containsMaxControl4 = this.containsMaxControlForHeight(this.xml);
								if (_containsMaxControl4) _flexGrow = 100;
							}
						} else {
							var _iex = _height2.indexOf("%");
							if (_iex != -1) {
								_flexGrow = _height2.substring(0, _iex);
								style.height = _height2;
							}
							if (_iex == -1 && _height2 != "") {
								_flexGrow = _height2 + "px";
								fixedHeight = true;
							}
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;else style["height"] = _flexGrow;
	
						var _width2 = this.getProperty_Width(); //this.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "" && !window.isPopUp && !window.isLookup) {
							var _containsMaxControl5 = this.containsMaxControlForWidth(this.xml);
							if (_containsMaxControl5) _width2 = "100%";
						}
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
				var _superStyle = _get(FormItemContainerControl.prototype.__proto__ || Object.getPrototypeOf(FormItemContainerControl.prototype), 'getStyle', this).call(this);
				if (_superStyle) {
					Object.assign(style, _superStyle);
				}
				return style;
			}
		}]);
	
		return FormItemContainerControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemContainerControl;

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditorFormType = function EditorFormType() {
		_classCallCheck(this, EditorFormType);
	};
	
	EditorFormType.Non = -1;
	EditorFormType.FormModule = 0;
	EditorFormType.QueryForm = 1;
	EditorFormType.Report = 2;
	EditorFormType.Dialog = 3;
	EditorFormType.FormLookup = 4;
	exports.default = EditorFormType;

/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DialogValue = function DialogValue() {
		_classCallCheck(this, DialogValue);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.dialog.DialogValue";
	};
	
	exports.default = DialogValue;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _FocusStore = __webpack_require__(28);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _LookupStores = __webpack_require__(34);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _ControlPropertyConst = __webpack_require__(91);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemEditor = function (_GongqiFormItem) {
		_inherits(FormItemEditor, _GongqiFormItem);
	
		function FormItemEditor(props) {
			_classCallCheck(this, FormItemEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemEditor.__proto__ || Object.getPrototypeOf(FormItemEditor)).call(this, props));
	
			_this.inQueryGroup = false;
	
			_this.record = "";
			_this.origRecord = null;
			_this.currentDataFieldChanged = false;
			_this.holdFocus = _this.props.holdFocus;
			_this.registerStores();
			//构造方法时 因为还没有记录 所以应该都不满足bind的style 所以初始state不用设置
			//只在currentRecordChanged时设置即可
			_this.state = {
				displayLength: _this.props.displayLength,
				displayHeight: _this.props.displayHeight,
				notNull: _this.props.notNull,
				visible: _this.props.controlVisible,
				hideInVisible: _this.props.hideInVisible,
				allowEdit: _this.props.underQueryGroup ? false : true,
				underQueryGroup: _this.props.underQueryGroup,
				label: _this.props.label
			};
			return _this;
		}
	
		_createClass(FormItemEditor, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
			}
		}, {
			key: 'distroyCommonStores',
			value: function distroyCommonStores() {
				if (!this.props.forLookup) {
					if (typeof this.unsubscribeRecordsCmpStore == "function") this.unsubscribeCmdUpdateControlAllowEditStore();
					if (typeof this.unsubscribeCmdDsAllowEditStore == "function") this.unsubscribeCmdDsAllowEditStore();
					if (typeof this.unsubscribeLookupReturnMutiEditorStore == "function") this.unsubscribeLookupReturnMutiEditorStore();
				}
	
				if (typeof this.unsubscribeGroupCurrentRecordChangedStore == "function") this.unsubscribeGroupCurrentRecordChangedStore();
				if (typeof this.unsubscribeFocusSetStore == "function") this.unsubscribeFocusSetStore();
				if (typeof this.unsubscribeCommandMapEditorsStore == "function") this.unsubscribeCommandMapEditorsStore();
				if (typeof this.unsubscribecallComponentFuncStore == "function") this.unsubscribecallComponentFuncStore();
				if (typeof this.unsubscribeCmdWriteControlStore == "function") this.unsubscribeCmdWriteControlStore();
				if (typeof this.unsubscribeCmdUpdateControlLabelStore == "function") this.unsubscribeCmdUpdateControlLabelStore();
				if (typeof this.unsubscribeCmdUpdateControlPropertyStore == "function") this.unsubscribeCmdUpdateControlPropertyStore();
				if (typeof this.unsubscribeBindStyleStore == "function") this.unsubscribeBindStyleStore();
				if (typeof this.unsubscribeRecordsCmpStore == "function") this.unsubscribeRecordsCmpStore();
				if (typeof this.unsubcribeRecordsRestoreCmpStore == "function") this.unsubcribeRecordsRestoreCmpStore();
				if (typeof this.unsubscribeRecordAutoSaveCmpStore == "function") this.unsubscribeRecordAutoSaveCmpStore();
				if (typeof this.unsubscribeRecordRefreshStore == "function") this.unsubscribeRecordRefreshStore();
				if (typeof this.unsubscribeHoldFocusStore == "function") this.unsubscribeHoldFocusStore();
			}
		}, {
			key: 'registerStores',
			value: function registerStores() {
				if (!this.props.forLookup) {
					this.unsubscribeCmdUpdateControlAllowEditStore = _CmdTypeStore.CmdUpdateControlAllowEditStore.listen(this.onCmdUpdateControlAllowEditStore.bind(this));
					this.unsubscribeCmdDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEdit.bind(this));
					this.unsubscribeLookupReturnMutiEditorStore = _LookupStores.LookupReturnMutiEditorStore.listen(this.onMutiEditorReturn.bind(this));
				}
				this.unsubscribeGroupCurrentRecordChangedStore = _RecordsStore.GroupCurrentRecordChangedStore.listen(this.onCurrentRecordChanged.bind(this));
				this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(this.onFocusSet.bind(this));
				this.unsubscribeCommandMapEditorsStore = _CommandStore.CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));
				this.unsubscribecallComponentFuncStore = _CommandStore.CallComponentFuncStore.listen(this.onCallFuncHandler.bind(this));
				this.unsubscribeCmdWriteControlStore = _CmdTypeStore.CmdWriteControlStore.listen(this.onCmdWriteControlStore.bind(this));
	
				this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
				this.unsubscribeCmdUpdateControlPropertyStore = _CmdTypeStore.CmdUpdateControlPropertyStore.listen(this.onCmdUpdateControlProperty.bind(this));
	
				this.unsubscribeBindStyleStore = _CmdTypeStore.BindStyleStore.listen(this.onBindStyle.bind(this));
				this.unsubscribeHoldFocusStore = _FocusStore.HoldFousStore.listen(this.onHoldFocus.bind(this));
				var dataMethod = this.props.control.getProperty_DataMethod();
				if (dataMethod && dataMethod.charAt(0) == "#") {
					this.unsubscribeRecordsCmpStore = _RecordsStore.RecordsCmpStore.listen(this.onExecuteRecordRefresh.bind(this));
					this.unsubcribeRecordsRestoreCmpStore = _RecordsStore.RecordsRestoreCmpStore.listen(this.onExecuteRecordRefresh.bind(this));
					this.unsubscribeRecordAutoSaveCmpStore = _RecordsStore.RecordAutoSaveCmpStore.listen(this.onExecuteRecordRefresh.bind(this));
					this.unsubscribeRecordRefreshStore = _RecordsStore.RecordRefreshStore.listen(this.onExecuteRecordRefresh.bind(this));
					this.unsubscribeRecordDataMethodFieldChangedStore = _RecordsStore.RecordDataMethodFieldChangedStore.listen(this.onExecuteRecordRefresh.bind(this));
				}
			}
		}, {
			key: 'onExecuteRecordRefresh',
			value: function onExecuteRecordRefresh() {
				var dataMethod = this.props.control.getProperty_DataMethod();
				var opr = dataMethod.substring(1, dataMethod.indexOf("("));
				var content = dataMethod.substring(dataMethod.indexOf("(") + 1, dataMethod.indexOf(")"));
				var mainSource, field;
				if (content.indexOf(".") != -1) {
					mainSource = content.split(".")[0];
					field = content.substr(content.indexOf(".") + 1);
				} else {
					mainSource = content;
					field = "";
				}
	
				if (!field) //count
					{
						var formModule = this.props.control.module;
						var group = formModule.formDataSources.groups[mainSource];
						var recordsNum = group.records.length;
						this.setDisplayFieldText(recordsNum);
					} else //sum
					{
						var sum = 0;
						var _formModule = this.props.control.module;
						var _group = _formModule.formDataSources.groups[mainSource];
						if (_group.records) {
							for (var i = 0; i < _group.records.length; i++) {
								var _record = _group.records[i];
								var _value = _record[mainSource + "." + _StringUtil2.default.convertToFirstLowerCase(field)];
								if (typeof _value != "number") _value = parseFloat(_value);
								sum += _value;
							}
						}
						this.setDisplayFieldText(sum);
					}
			}
		}, {
			key: 'onBindStyle',
			value: function onBindStyle(formId, name) {
				if (this.props.formId == formId && this.props.xml.name == name) {
					this.updateRecordCondition();
				}
			}
		}, {
			key: 'onHoldFocus',
			value: function onHoldFocus(formId, itemId) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.inputField).focus();
					$(this.inputField).select();
					this.holdFocus = true;
				} else {
					this.holdFocus = false;
				}
			}
		}, {
			key: 'onCallFuncHandler',
			value: function onCallFuncHandler(entityId, innerId, funcName, funcArg, result) {
				if (this.props.formId == entityId && this.props.xml.id == innerId) {
					if (typeof this[funcName] == 'function') {
						var ret = this[funcName].apply(this, funcArg);
						if (result) result.ret = ret;
					}
				}
			}
		}, {
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId, triggerModify) {
				if (arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId) {
					var value = arg[this.props.xml.name];
					this.setDisplayFieldText(value, triggerModify);
					if (this.props.underQueryGroup) {
						this.setQueryGroupEnable(true);
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlAllowEditStore',
			value: function onCmdUpdateControlAllowEditStore(name, _allowEdit) {
				//alert(name+":"+_allowEdit);
				if (name != this.props.xml.name) return;
				if (this.props.control) {
					/*var _allowEdit = true;
	    if(!this.record)
	    {
	    	_allowEdit = false;
	    }
	    else
	    {
	    	_allowEdit = this.props.control.getProperty_AllowEdit_Final();
	    }*/
					var finalValue = void 0;
					if (this.props.control.group && !this.props.control.group.currentRecord) finalValue = false;else finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState, snapshot) {
				if (this.state.label != prevState.label) {
					var control = this.props.control;
					var parentControl = control.parentControl;
					if (parentControl.classAlias == "FormItemFieldGroupControl") {
						_UtilActions2.default.updateControlLabel({ controlId: parentControl.xml.id });
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId) return;
				this.setState({ label: _label });
			}
		}, {
			key: 'onCmdUpdateControlProperty',
			value: function onCmdUpdateControlProperty(name, property, value, moduleInstanceId) {
				if (name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId) return;
				if (property == _ControlPropertyConst2.default.DISPLAYLENGTH) {
					this.setState({ displayLength: value });return true;
				} else if (property == _ControlPropertyConst2.default.NOTNULL) {
					this.setState({ notNull: value });return true;
				}
				return false;
			}
		}, {
			key: 'onDsAllowEdit',
			value: function onDsAllowEdit(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var _allowEdit = true;
					if (!this.record) {
						_allowEdit = false;
					} else {
						_allowEdit = this.props.control.getProperty_AllowEdit_Final();
					}
					this.doSetEnable(_allowEdit);
				}
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if ((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId) {
					if (selector != "all" && this.props.xml.name != selector) return;
					if (this.props.underQueryGroup && !this.getInQueryGroupNow()) return;
					if (this.props.underQueryGroup) {
						if (this.record == '-只查空值-') {
							mapEditorValues[this.props.xml.name] = "";
						} else {
							mapEditorValues[this.props.xml.name] = !this.record || this.record == "" ? this.props.defaultValueForCMD : this.record;
						}
					} else {
	
						mapEditorValues[this.props.xml.name] = !this.record || this.record == "" ? this.props.defaultValueForCMD : this.record;
					}
				}
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					var that = this;
					setTimeout(function () {
						$(that.inputField).focus();
						$(that.inputField).select();
					}, 200);
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
	
				var keyboardArg = this.props.control ? this.props.control.propertyKeyDownEvent : null;
				if (keyboardArg) {
					for (var i = 0; i < keyboardArg.keyCodeArgs.length; i++) {
						var keyCodeArg = keyboardArg.keyCodeArgs[i];
						if (keyCodeArg.ctrlKey == e.ctrlKey && keyCodeArg.shiftKey == e.shiftKey && (keyCodeArg.keyCode == e.keyCode || keyCodeArg.keyCode == e.charCode)) {
							e.preventDefault();
							var callBackArg = { remoteClass: "gongqi.erp.gotmodel.form.remote.KeyCodeResult" };
							callBackArg.ctrlKey = e.ctrlKey;
							callBackArg.shiftKey = e.shiftKey;
							callBackArg.keyCode = e.keyCode;
							setTimeout(this.doKeyBoardServer.bind(this), 500, callBackArg);
							return true;
						}
					}
				}
				//alert(e.keyCode);
				if (9 === e.keyCode || 13 === e.keyCode) {
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
					return true;
				}
	
				return false;
			}
		}, {
			key: 'doKeyBoardServer',
			value: function doKeyBoardServer(callBackArg) {
				var arg = {};
				arg["methodName"] = "keyDownEvent_" + this.props.xml.name;
	
				callBackArg.editorValue = this.getDisplayFieldText();
				arg["methodArg"] = callBackArg;
	
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				commandTask.arg = arg;
				_CommandResolver2.default.formCmd(commandTask, this.props.control.module);
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.record = currentRecord;
					if (this.props.dataField) {
						this.origRecord = Object.assign({}, currentRecord);
					}
					this.updateRecordCondition();
				}
			}
		}, {
			key: 'getEditorStyles',
			value: function getEditorStyles() {
				var menuItemId = this.props.menuItemId;
				var formId = this.props.formId;
				var innerId = this.props.xml.id;
				return _FormItemUtil2.default.getControlStyles(menuItemId, formId, innerId);
			}
		}, {
			key: 'updateRecordCondition',
			value: function updateRecordCondition() {
				if (!this.props.control) return;
				var _style = { color: -1, backgroundColor: -1, fontSize: -1, fontFamily: null, fontWeight: null };
				var group = this.props.control.group;
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var i = 0; i < colStyles.length; i++) {
						var colStyle = colStyles[i];
						var bool = false;
						if (group) bool = group.analysisConditionSingleRecord1(this.record, colStyle.recordCondition);else bool = this.props.control.analysisConditionSingleValue(this.record, colStyle.valueCondition);
						if (bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16);else _style.color = -1;
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + colStyle.backgroundColor.toString(16);else _style.backgroundColor = -1;
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;else _style.fontSize = -1;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;else _style.fontFamily = null;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;else _style.fontWeight = null;
						}
					}
					this.setState(_style);
				}
			}
		}, {
			key: 'setDisplayNoResolve',
			value: function setDisplayNoResolve(value) {
				this.setDisplay(value);
			}
	
			//设置显示的值 对于ForDataGrid无用
	
		}, {
			key: 'setDisplay',
			value: function setDisplay(_value) {}
		}, {
			key: 'updateModifiedTag',
			value: function updateModifiedTag() {
				if (this.props.groupAlias == "") return;
				if (this.record == null || this.record == undefined) return;
				if (this.origRecord == null || this.origRecord == undefined) return;
				var newValue = $(this.inputField).val();
				var origValue = this.origRecord[this.props.dataField];
				if (origValue != newValue) {
					//alert(origValue + "  " + newValue);
					this.currentDataFieldChanged = true;
					$(this.modifiedTag).css("display", "block");
				} else {
					this.currentDataFieldChanged = false;
					$(this.modifiedTag).css("display", "none");
				}
			}
		}, {
			key: 'getInQueryGroupNow',
			value: function getInQueryGroupNow() {
				return this.inQueryGroup;
			}
		}, {
			key: 'labelClickHandler',
			value: function labelClickHandler() {
				if (!this.state.underQueryGroup) return;
				// this.setQueryGroupEnable(!this.inQueryGroup);
			}
	
			//QueryGroup中的编辑框无法通过GOT record 权限等控制可编辑性
	
		}, {
			key: 'setQueryGroupEnable',
			value: function setQueryGroupEnable() {
				var _inQueryGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				this.inQueryGroup = _inQueryGroup;
				if (this.inQueryGroup) {
					//$(this.componentLabel).css("color","#000000");
					this.doSetEnable(true);
					$(this.inputField).focus();
					$(this.inputField).select();
				} else {
					//$(this.componentLabel).css("color","#CFCFCF");
					this.doSetEnable(false);
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				/*if(this.props.underQueryGroup)
	   {
	   	$(this.componentLabel).click(this.labelClickHandler.bind(this));
	   	$(this.componentLabel).css("cursor","pointer");
	   	$(this.componentLabel).css("color","#CFCFCF");
	   }*/
	
				//TODO_YL 改成 不触发modify 方法  会有什么问题？
				if (this.props.initEditorValue) {
					this.setDisplayFieldText(this.props.initEditorValue, false);
				}
	
				if (this.props.customStyle && this.props.customStyle.hasOwnProperty("visibility")) $("#Editor" + this.props.xml.id).css("display", "none");
			}
		}, {
			key: 'getDisplayFieldText',
			value: function getDisplayFieldText() {
				return $(this.inputField).val();
			}
		}, {
			key: 'getFormAutoQueryValue',
			value: function getFormAutoQueryValue() {
				var _text = this.getDisplayFieldText();
				_text = this.props.control.getQueryFilteredVaue(_text);
				return _text;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue() {}
	
			//TODO DataMethod等特殊情况会调用此方法 若非特殊情况调用 会重复setDisplay
	
		}, {
			key: 'setDisplayFieldText',
			value: function setDisplayFieldText(value) {
				var triggerModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				//$(this.inputField).val(value);
				//_displayField["text"] = value;
				this.setFinalValue(value, triggerModify);
				this.setDisplay();
				var curFocus = document.activeElement;
				if ($(this.inputField).is(curFocus) || $(this.inputField).find(curFocus).length) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'setDisplayFieldDefText',
			value: function setDisplayFieldDefText(value) {
				var triggerModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				this.setFinalValue(value, triggerModify);
			}
		}, {
			key: 'onMutiEditorReturn',
			value: function onMutiEditorReturn(editorName, value) {
				if (this.props.xml.name == editorName) {
					this.setDisplayFieldText(value, false);
				}
			}
		}, {
			key: 'doSetModifiedTagNone',
			value: function doSetModifiedTagNone() {
				$(this.modifiedTag).css("display", "none");
			}
		}, {
			key: 'doSetModifiedTagHas',
			value: function doSetModifiedTagHas() {
				$(this.modifiedTag).css("display", "block");
			}
		}, {
			key: 'render',
			value: function render() {}
		}]);
	
		return FormItemEditor;
	}(_GongqiFormItem3.default);
	
	exports.default = FormItemEditor;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _FindForm = __webpack_require__(284);
	
	var _FindForm2 = _interopRequireDefault(_FindForm);
	
	var _FindForm3 = __webpack_require__(285);
	
	var _FindForm4 = _interopRequireDefault(_FindForm3);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _QueryStores = __webpack_require__(78);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _ValueCondition = __webpack_require__(258);
	
	var _ValueCondition2 = _interopRequireDefault(_ValueCondition);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _LayerManager = __webpack_require__(51);
	
	var _LayerManager2 = _interopRequireDefault(_LayerManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemEditorControl = function (_GongqiFormItemContro) {
		_inherits(FormItemEditorControl, _GongqiFormItemContro);
	
		function FormItemEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemEditorControl.__proto__ || Object.getPrototypeOf(FormItemEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemEditorControl";
			_this.dataSource_Alias = _this.xml.Properties.DataSource.Value;
			_this.dataSource_Field = _this.xml.Properties.Extends.Value;
			_this.record = null;
			var _group = null;
			_this.isDataMethodField = false;
			_this.isAggregate = false;
			if (_this.xml.name && _this.xml.name.indexOf("_Aggregate_") != -1) {
				_this.isAggregate = true;
			}
			if (_this.dataSource_Alias != "") {
				var _exfield = null;
				var _datasource = module.formDataSources.sources[_this.dataSource_Alias];
				if (_this.dataSource_Field != "") {
					_group = _datasource.group;
					//去找FormDataSourceField 后边会用到
					_this.formDataSourceField = _GOT2.default.getFormDataSourceField(_datasource.xml, _this.dataSource_Field);
				} else {
					var dataMethod = _GOTUtil2.default.getPropertyValue(_this.xml, "DataMethod");
					if (dataMethod == "Normal" || dataMethod == "SelectRecords") {
						_exfield = _StringUtil2.default.convertToFirstLowerCase(_this.xml.name);
						_this.isDataMethodField = true;
						_group = _datasource.group;
						var _dataMethodDataField = _this.dataSource_Alias + "." + _exfield;
						var _type = _this.xml.type;
						_group.addTempDataMethodField(_dataMethodDataField, _dataMethodDataField, _type);
						_type = _type.substring(0, _type.length - "Editor".length);
						_datasource.addExtralFieldType(_exfield, _type);
						if (dataMethod == "SelectRecords") _this.isDataMethodSelectRecords = true;
					}
				}
	
				if (_exfield != null) {
					_this.dataSource_Field = _exfield;
					_this.dataField = _this.dataSource_Alias + "." + _exfield;
				}
			}
			_this.group = _group;_this.groupAlias = _this.group ? _this.group.groupAlias : "";
	
			var contextMenuItems = [];
	
			if (_this.isDataMethodField && _this.group && group.mainSource.isTempTable || !_this.isDataMethodField && !_this.isAggregate) {
				contextMenuItems.push({ label: '升序', icon: '', action: _this.ascOrder.bind(_this) }, { label: '降序', icon: '', action: _this.descOrder.bind(_this) }, { label: '过滤[Ctrl+T]', icon: '', action: _this.queryFilter.bind(_this) }, { label: '应用到筛选[Ctrl+G]', icon: '', action: _this.enterFind.bind(_this) }, { label: '查找[Ctrl+F]', icon: '', action: _this.findValue.bind(_this) }, { label: '逐个查找[Ctrl+E]', icon: '', action: _this.findValueStepByStep.bind(_this) }, { label: '跨列查找', icon: '', action: _this.findValueStepByStepForMore.bind(_this) });
			}
	
			if (window.isDataSetView) {
				contextMenuItems.push({ label: '查找[Ctrl+F]', icon: '', action: _this.findValue.bind(_this) }, { label: '过滤[Ctrl+T]', icon: '', action: _this.queryFilter.bind(_this) });
			} else {
				contextMenuItems.push({ label: '查看记录详情[Ctrl+D]', icon: '', action: _this.recordDetail.bind(_this) }, null, // divider
				//{label:'隐藏',icon:'',action:this.hide.bind(this)},
				//{label:'显示',icon:'',action:this.show.bind(this)},
				{ label: '调整布局', icon: '', action: _this.formAdjust.bind(_this) }
				// {label:'画面调整(含列宽)',icon:'',action:this.formAdjust2.bind(this)}
				);
			}
			_this.contextMenuData = {
				items: contextMenuItems
			};
	
			_this.unsubscribeGroupCurrentRecordChangedStore = _RecordsStore.GroupCurrentRecordChangedStore.listen(_this.onCurrentRecordChanged.bind(_this));
			_this.unsubscribeHeaderClickSortStore = _QueryStores.HeaderClickSortStore.listen(_this.onHeaderClickSortHandler.bind(_this));
			_this.unsubscribeCmdWriteControlStore = _CmdTypeStore.CmdWriteControlStore.listen(_this.onCmdWriteControlStore.bind(_this));
			_this.unsubscribeCommandMapEditorsStore = _CommandStore.CommandMapEditorsStore.listen(_this.onMapEditorsHandler.bind(_this));
	
			return _this;
		}
	
		_createClass(FormItemEditorControl, [{
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId) {
				if (arg && arg.hasOwnProperty(this.xml.name) && this.module.instanceUUId == moduleInstanceId) {
					var value = arg[this.xml.name];
					this.initEditorValue = value;
					this.hasInitEditorValue = true;
				}
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if (this.component) return;
				if (!this.groupAlias && this.module.instanceUUId == moduleInstanceId) {
					if (selector != "all" && this.xml.name != selector) return;
	
					mapEditorValues[this.xml.name] = this.hasInitEditorValue ? this.initEditorValue + "" : this.getProperty_DefaultForCMD();
				}
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
				_CmdTypeActions2.default.updateControlAllowEdit(this.xml.name, value, this.moduleInstanceId);
			}
		}, {
			key: 'setControlLabelCmd',
			value: function setControlLabelCmd(value) {
				this._cmdLabel = value;
				_CmdTypeActions2.default.updateControlLabel(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'setControlShowDecimalCmd',
			value: function setControlShowDecimalCmd(value) {
				this._cmdShowDecimal = value;
				_CmdTypeActions2.default.updateControlShowDecimal(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'setControlSkipTabCmd',
			value: function setControlSkipTabCmd(skip) {
				this._cmdSkipTab = skip;
			}
		}, {
			key: 'getInitialLabel',
			value: function getInitialLabel() {
				return this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
			}
		}, {
			key: 'getInitialNotNull',
			value: function getInitialNotNull() {
				return this.propertyNotNull != undefined ? this.propertyNotNull : this.getProperty_NotNull();
			}
		}, {
			key: 'getProperty_Label',
			value: function getProperty_Label() {
				var showLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				if (showLabel && !this.getProperty_ShowLabel()) return "";
				return _get(FormItemEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemEditorControl.prototype), 'getProperty_Label', this).call(this);
			}
		}, {
			key: 'getProperty_ShowLabel',
			value: function getProperty_ShowLabel() {
				return true;
				return this.properties.ShowLabel;
			}
		}, {
			key: 'getProperty_EnumType',
			value: function getProperty_EnumType() {
				return _get(FormItemEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemEditorControl.prototype), 'getProperty_EnumType', this).call(this);
			}
		}, {
			key: 'pasteselect',
			value: function pasteselect() {
				if (window.getSelection) {
					alert(window.getSelection().toString());
				} else if (document.selection && document.selection.createRange) {
					alert(document.selection.createRange().text);
				}
				return;
				document.execCommand("Copy", "false", null);
			}
		}, {
			key: 'copyselect',
			value: function copyselect() {
				document.execCommand("Copy", "false", null);
			}
		}, {
			key: 'doOrder',
			value: function doOrder() {
				var sortType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				if (!this.group) return;
				if (this.getISAggregate()) return;
				if (this.isDataMethodField && !this.group.mainSource.isTempTable && !this.group.sortOnClient) return;
				var _dataField = this.getDataField();
				if (!_dataField) return;
				this.group.sort(_dataField, sortType, true, true);
			}
		}, {
			key: 'onHeaderClickSortHandler',
			value: function onHeaderClickSortHandler(columnKey, sortDirection, moduleInstanceId) {
				if ((this.dataField == columnKey || this.groupAlias + "." + this.dataSource_Field == columnKey) && this.module.instanceUUId == moduleInstanceId) {
					this.doOrder(sortDirection);
				}
			}
		}, {
			key: 'ascOrder',
			value: function ascOrder() {
	
				this.doOrder("ASC");
			}
		}, {
			key: 'descOrder',
			value: function descOrder() {
				this.doOrder("DESC");
			}
		}, {
			key: 'queryFilter',
			value: function queryFilter() {
				if (!this.group) return;
				if (this.getISAggregate()) return;
				var _dataField = this.getDataField();
				if (_dataField && this.record && this.record.hasOwnProperty(_dataField)) {
					var value = this.record[_dataField];
					this.group.queryFilter(_dataField, value);
				}
			}
		}, {
			key: 'enterFind',
			value: function enterFind() {
				if (this.getISAggregate()) return;
				var _dataField = this.getDataField();
				_QueryUtil2.default.findOrCreateWhereItem(_dataField, this.group.currentQuery);
				window.queryOpen('enterFind');
				//alert(this.getProperty_Label());
			}
		}, {
			key: 'findValueStepByStep',
			value: function findValueStepByStep() {
				var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
				if (this.getISAggregate()) return;
	
				if (!flag || flag != 'findMore') {
					_FindForm4.default.show(this.findValueStepByStepHandler.bind(this), this.getProperty_Label(), this.getDataField(), { type: this.xml.type, innerId: this.xml.id, entityId: this.formId });
				} else {
					_FindForm4.default.show(this.findValueStepByStepHandler.bind(this), this.getProperty_Label(), this.getDataField(), { type: this.xml.type, innerId: this.xml.id, entityId: this.formId }, 'serchMore');
				}
			}
		}, {
			key: 'findValueStepByStepForMore',
			value: function findValueStepByStepForMore() {
				if (this.getISAggregate()) return;
	
				_FindForm4.default.show(this.findValueStepByStepHandler.bind(this), this.getProperty_Label(), this.getDataField(), { type: this.xml.type, innerId: this.xml.id, entityId: this.formId }, 'serchMore');
			}
		}, {
			key: 'findValueStepByStepHandler',
			value: function findValueStepByStepHandler(text, fromIndex, stepColumn) {
				var pre = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
				if (this.group) {
					var dataFields = void 0;
					if (stepColumn == true) {
						var gridControl = this.parentControl;
						if (gridControl.classAlias != "FormItemDataGridControl") {
							gridControl = gridControl.parentControl;
						}
						var columns = gridControl._columns;
						dataFields = [];
						for (var i = 0; i < columns.length; i++) {
							var column = columns[i];
							if (column.width != 0.1) {
								dataFields.push(column.key);
							}
						}
					}
	
					if (pre == false) {
						return this.group.findValueStepByStep({ dataFields: dataFields, value: text, dataField: this.getDataField(), fromIndex: fromIndex, stepColumn: stepColumn });
					} else {
						return this.group.findValueStepByStepPre({ dataFields: dataFields, value: text, dataField: this.getDataField(), fromIndex: fromIndex, stepColumn: stepColumn });
					}
				}
			}
		}, {
			key: 'getISAggregate',
			value: function getISAggregate() {
				if (this.dataSource_Field && this.dataSource_Alias && this.group && this.group.formDataSources) {
					var dataSource = this.group.formDataSources.sources[this.dataSource_Alias];
					var xml = dataSource.xml;
					var dataSourceField = _GOT2.default.getFormDataSourceField(xml, this.dataSource_Field);
					if (!dataSourceField) return false;
					var aggregateV = _GOTUtil2.default.getPropertyValue(dataSourceField, "AggregateType");
					return aggregateV;
				}
			}
		}, {
			key: 'findValue',
			value: function findValue() {
				if (this.getISAggregate()) return;
				if (this.isDataMethodField && this.group && this.group.mainSource.isTempTable || !this.isDataMethodField) {
					_FindForm2.default.show(this.findValueHandler.bind(this), this.getProperty_Label(), this.getDataField(), { type: this.xml.type });
				}
				if (window.isDataSetView) {
					_FindForm2.default.show(this.findValueHandler.bind(this), this.getProperty_Label(), this.getDataField(), { type: this.xml.type });
				}
				//alert(this.getProperty_Label());
			}
		}, {
			key: 'findValueHandler',
			value: function findValueHandler(text) {
				var dataField = this.getDataField();
				if (this.group) {
					this.group.findValue(dataField, text);
				}
			}
		}, {
			key: 'hide',
			value: function hide() {
				alert(this.getProperty_Label());
			}
		}, {
			key: 'recordDetail',
			value: function recordDetail() {
				//alert(this.getProperty_Label());
	
				if (this.group) {
					var filter = [];
					for (var key in _FormItemUtil2.default.formItemControlsForFor) {
						var item = _FormItemUtil2.default.formItemControlsForFor[key];
						if (item.classAlias == "FormItemStringEditorControl" && item.getDisplayAsPassword()) {
							var itemXML = item.xml;
							var dp = _GOTUtil2.default.getProperty(itemXML, "Extends");
							if (dp.hasOwnProperty("refinnerid")) {
								var _key = dp.refentityid + dp.refinnerid;
							}
							filter.push(_key);
						}
					}
	
					/*if(this.group.mainSource.isAggreateTable)
	    {
	    	this.group.showCurRecTotalAggreateTable(filter);	
	    }
	    else
	    {
	    	this.group.showCurRecTotal(filter);
	    }*/
					var fieldName = this.dataSource_Field;
					this.group.showCurRecTotal(filter, { field: fieldName });
				}
			}
		}, {
			key: 'show',
			value: function show() {
				alert(this.getProperty_Label());
			}
		}, {
			key: 'getProperty_DataMethod',
			value: function getProperty_DataMethod() {
				return this.properties.DataMethod;
			}
		}, {
			key: 'getProperty_QuerySource',
			value: function getProperty_QuerySource() {
				return this.properties.QuerySource;
			}
		}, {
			key: 'getProperty_Regular',
			value: function getProperty_Regular() {
				return this.properties.Regular;
			}
		}, {
			key: 'getProperty_QueryField',
			value: function getProperty_QueryField() {
				return this.properties.QueryField;
			}
		}, {
			key: 'getProperty_DefaultForCMD',
			value: function getProperty_DefaultForCMD() {
				return this.getProperty_Default();
			}
		}, {
			key: 'getProperty_DisplayStyle',
			value: function getProperty_DisplayStyle() {
				if (this._castedDisplayStyle) return this._castedDisplayStyle;
				var _displayStyle = this.properties.DisplayStyle;
				try {
					_displayStyle = JSON.parse(_displayStyle);
				} catch (e) {}
				this._castedDisplayStyle = _displayStyle;
				return this._castedDisplayStyle;
			}
		}, {
			key: 'getProperty_Alignment',
			value: function getProperty_Alignment() {
	
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.HorizontalAlignment) return displayStyle.HorizontalAlignment;
				if (this.properties.hasOwnProperty("Alignment")) return this.properties.Alignment;
				return "Center";
			}
		}, {
			key: 'getProperty_VAlignment',
			value: function getProperty_VAlignment() {
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.VerticalAlignment) return displayStyle.VerticalAlignment;
				return "";
			}
		}, {
			key: 'getProperty_CSSStyle_Display',
			value: function getProperty_CSSStyle_Display() {
				var displayStyle = this.getProperty_DisplayStyle();
	
				//displayStyle = {cssStyle:{fontFamily:"微软雅黑",fontStyle:"italic",fontWeight:"bold",fontSize:20}};
	
				if (displayStyle && displayStyle.cssStyle) return displayStyle.cssStyle;
				return "";
			}
		}, {
			key: 'getDefaultValue',
			value: function getDefaultValue() {
				var value = this.getProperty_Default();
				if (!value) value = "";
				return value;
			}
		}, {
			key: 'getProperty_Default',
			value: function getProperty_Default() {
				return this.properties.Default;
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId, causeId, groupInstance) {
				if (this.groupAlias == groupAlias && this.group == groupInstance) this.record = currentRecord;
			}
		}, {
			key: 'getDataField',
			value: function getDataField() {
				if (this.dataField != null) return this.dataField;
				var dataSource = this.dataSource_Alias;
				var extend = this.dataSource_Field;
				var strField = void 0;
				//插件内部节点带点号
				if (dataSource != "" && extend != "") {
					if (extend.indexOf(".") != -1) //插件内部节点带点 如果包含.号
						{
							var ss = extend.split(".");
	
							if (ss.length == 2) //插件内部节点带点 如果只有一个. 则表明是维度
								{
									strField = _StringUtil2.default.convertToFirstLowerCase(ss[0]) + "." + _StringUtil2.default.convertToFirstLowerCase(ss[1]);
								} else {
								strField = _StringUtil2.default.convertToFirstLowerCase(extend);
							}
						} else {
						strField = _StringUtil2.default.convertToFirstLowerCase(extend);
					}
					this.dataField = dataSource + "." + strField;
				}
	
				if ((this.dataField == null || this.dataField == undefined) && dataSource != "") {
					var dataMethod = this.xml.Properties.DataMethod.Value;
					var start = dataMethod.charAt(0);
					if (start == "@") {
						this.dataField = dataSource + "." + _StringUtil2.default.convertToFirstLowerCase(dataMethod.substr(1));
					} else if (start == "%") {
						this.dataField = dataSource + "." + _StringUtil2.default.convertToFirstLowerCase(this.xml.name);
					}
				}
				return this.dataField;
			}
		}, {
			key: 'validateNotNull',
			value: function validateNotNull() {
				var _dataField = this.getDataField();
				if (_dataField && this.group && this.group.currentRecord) {
					var value = this.group.currentRecord[_dataField];
					//TODO !0为true  0==""也为true Decimal等或许不用再覆盖
					if (value == undefined || value == null || value == "") {
						var _label = this.getProperty_Label();
						return _label;
					}
				}
				return null;
			}
		}, {
			key: 'getSelfNotNull',
			value: function getSelfNotNull() {
				var key = this.formId + this.xml.id + _ControlPropertyConst2.default.NOTNULL;
				var notnull = window.controlProperties[key];
				if (notnull) return notnull;
				if (this.propertyNotNull != undefined && this.propertyNotNull == true) return true;
				if (!this.xml.Properties.hasOwnProperty("NotNull")) return false;
				var notnull = this.xml.Properties.NotNull.Value;
				if (typeof notnull == "string") {
					return notnull == "true" ? true : false;
				} else {
					return notnull;
				}
				//return this.xml.Properties.NotNull.Value;
			}
		}, {
			key: 'getProperty_NotNull',
			value: function getProperty_NotNull() {
				if (this.group) {
					var mainSource = this.group.mainSource;
					if (mainSource.alias != this.dataSource_Alias) return false;
				}
				var key = this.formId + this.xml.id + _ControlPropertyConst2.default.NOTNULL;
				var notnull = window.controlProperties[key];
				if (notnull) return notnull;
				if (!this.properties.hasOwnProperty("NotNull")) return false;
				notnull = this.properties.NotNull;
				if (typeof notnull == "string") {
					return notnull == "true" ? true : false;
				} else {
					return notnull;
				}
			}
		}, {
			key: 'getProperty_AllowEdit_CurrentRecordLocked',
			value: function getProperty_AllowEdit_CurrentRecordLocked() {
				if (this.isDataMethodField) return false;
				if (this.group && this.group.ds_AllowEdit == false) return true;
				if (this.group && this.group.isCurrentRecordLocked()) return true;
				return false;
			}
		}, {
			key: 'getProperty_AllowEdit_Final',
			value: function getProperty_AllowEdit_Final(_record) {
				var dataMethod = this.getProperty_DataMethod();
				if (dataMethod && dataMethod.charAt(0) == "#") return false;
				if (this.forLookup && this.group) return false;
				if (this.dataSource_Field && _record) {
					var externalArgs = [_record];
					if (this.group && this.group.linkGroup) externalArgs.push(this.group.linkGroup.currentRecord);
					var allowEdit = _LayerManager2.default.executeLayerMethod(this.module, this.group, "recordAllowEdit_" + this.dataSource_Field, externalArgs);
					if (typeof allowEdit != "undefined" && allowEdit == false) return false;
				}
				return _get(FormItemEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemEditorControl.prototype), 'getProperty_AllowEdit_Final', this).call(this);
			}
		}, {
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 20;
			}
		}, {
			key: 'getDisplayLengthWidth',
			value: function getDisplayLengthWidth() {
				var _displayLength = this.getProperty_DisplayLength(); //从后台获取的全局属性集里获取具体值 该值是经过计算的
				//this.props.xml.Properties.DisplayLength.Value;
				if (_displayLength == "") _displayLength = this.getDefaultDisplayLength();
				return _displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;
			}
		}, {
			key: 'getFormDataSourceField',
			value: function getFormDataSourceField() {
				if (this.dataSource_Field == "" || this.dataSource_Alias == "") return null;
				var formDataSourceField = _GOT2.default.getFormDataSourceFieldByName(window.formXML, this.dataSource_Alias, this.dataSource_Field);
				return formDataSourceField;
			}
		}, {
			key: 'getProperty_AllowEditOnCreate',
			value: function getProperty_AllowEditOnCreate() {
				if (this.properties.hasOwnProperty("AllowEditOnCreate")) return this.properties.AllowEditOnCreate;
				if (this.properties.AllowEdit == _FormItemConst2.default.ALLOWEDIT_ONLYONCREATE) return true;
				return false;
			}
		}, {
			key: 'getProperty_Visible_FieldAu',
			value: function getProperty_Visible_FieldAu() {
				var formDataSourceField = this.getFormDataSourceField();
				if (!formDataSourceField) {
					return true;
				}
				var value = _GOTUtil2.default.getPropertyValue(formDataSourceField, "Visible");
	
				if (value == "false") return false;
				var _formXML = void 0;
				if (this.forLookup) _formXML = _GOT2.default.getForm(this.formId);else _formXML = window.formXML;
	
				var formDataSource = _GOT2.default.getFormDataSource(_formXML, this.dataSource_Alias);
				if (!formDataSource) return;
	
				value = _GOTUtil2.default.getPropertyValue(formDataSource, "Visible");
				if (value == "false") return false;
	
				var finalValue = true;var isForbidden = false;var finalValueSetted = false;
	
				var au = _AuthorityUtil2.default.getXmlType2SCacheItem(this.authorityKey, formDataSourceField.id, "visible");
	
				if (au["isDefault"] == false) {
					finalValue = au["result"];
					finalValueSetted = true;
					isForbidden = au["isForbidden"];
				}
	
				if (isForbidden) return false;
				//TODO自定义下拉画面?
				au = _AuthorityUtil2.default.getXmlType2SCacheItem(this.authorityKey, formDataSource.id, "visible");
	
				if (au["isDefault"] == false) {
					if (!finalValueSetted) {
						finalValue = au["result"];
						finalValueSetted = true;
					}
					isForbidden = au["isForbidden"];
				}
	
				if (isForbidden) return false;
	
				var formDataSources = window.formXML.FormDataSources;
	
				au = _AuthorityUtil2.default.getXmlType2SCacheItem(this.authorityKey, formDataSources.id, "visible");
	
				if (au["isDefault"] == false) {
					if (!finalValueSetted) {
						finalValue = au["result"];
						finalValueSetted = true;
					}
					isForbidden = au["isForbidden"];
				}
	
				return finalValue && !isForbidden;
			}
		}, {
			key: 'getProperty_AllowEdit_FieldAu',
			value: function getProperty_AllowEdit_FieldAu() {
				if (window.getIsQueryOnlyFromMenuItem() == true) return false;
				var formDataSourceField = this.getFormDataSourceField();
				if (!formDataSourceField) {
					return true;
				}
	
				var value = _GOTUtil2.default.getPropertyValue(formDataSourceField, "AllowEdit");
				if (value == "false") return false;
	
				var formDataSource = _GOT2.default.getFormDataSource(window.formXML, this.dataSource_Alias);
				if (!formDataSource) return;
	
				value = _GOTUtil2.default.getPropertyValue(formDataSource, "AllowEdit");
				if (value == "false") return false;
	
				if (this.group.mainSource.alias != formDataSource.name) return false;
	
				var finalValue = true;var isForbidden = false;var finalValueSetted = false;
	
				var au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId && window.menuItemId != "" ? window.menuItemId : window.formXML.name, formDataSourceField.id, "edit");
	
				if (au["isDefault"] == false) {
					finalValue = au["result"];
					finalValueSetted = true;
					isForbidden = au["isForbidden"];
				}
	
				if (isForbidden) return false;
	
				au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId && window.menuItemId != "" ? window.menuItemId : window.formXML.name, formDataSource.id, "edit");
	
				if (au["isDefault"] == false) {
					if (!finalValueSetted) {
						finalValue = au["result"];
						finalValueSetted = true;
					}
					isForbidden = au["isForbidden"];
				}
	
				if (isForbidden) return false;
	
				var formDataSources = window.formXML.FormDataSources;
	
				au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId && window.menuItemId != "" ? window.menuItemId : window.formXML.name, formDataSources.id, "edit");
	
				if (au["isDefault"] == false) {
					if (!finalValueSetted) {
						finalValue = au["result"];
						finalValueSetted = true;
					}
					isForbidden = au["isForbidden"];
				}
	
				if (finalValueSetted) return finalValue && !isForbidden;
	
				return true;
			}
		}, {
			key: 'getProperty_AllowEdit_GOTFinal',
			value: function getProperty_AllowEdit_GOTFinal() {
				var result = this.getProperty_AllowEdit_GOT();
	
				if (result == false) {
					if (this.group) {
						var recVersion = this.group.getCurRecVersion();
						if (isNaN(recVersion) == false && recVersion == -1) {
							result = this.getProperty_AllowEditOnCreate();
						}
					}
				}
				if (!result) return false;
				result = this.getProperty_AllowEdit_FieldAu();
				if (!result) return false;
				result = this.getProperty_AllowEdit_Loop();
				return result;
			}
		}, {
			key: 'getProperty_Visible_GOTFinal',
			value: function getProperty_Visible_GOTFinal() {
				var result = this.getProperty_Visible();
				if (!result) return false;
				result = this.getProperty_Visible_GOT();
				if (!result) return false;
				result = this.getProperty_Visible_FieldAu();
				if (!result) return false;
				//return result;
				result = this.getProperty_Visible_Loop();
	
				return result;
			}
		}, {
			key: 'getProperty_Label',
			value: function getProperty_Label() {
				var showLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				if (showLabel && !this.getProperty_ShowLabel()) return "";
				return _get(FormItemEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemEditorControl.prototype), 'getProperty_Label', this).call(this);
			}
		}, {
			key: 'getProperty_QueryFilter',
			value: function getProperty_QueryFilter() {
				return this.properties.QueryFilter;
			}
		}, {
			key: 'getProperty_DisplayHeight',
			value: function getProperty_DisplayHeight() {
				return this.properties.DisplayHeight;
			}
		}, {
			key: 'getProperty_DisplayLength',
			value: function getProperty_DisplayLength() {
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && (_properties.hasOwnProperty("displayLength") || _properties.hasOwnProperty("displaylength"))) return _properties["displayLength"] || _properties["displaylength"];
				}
	
				if (this.parentControl && this.parentControl.classAlias == "FormItemFieldGroupControl") {
					var displayLength = this.parentControl.getProperty_DisplayLength();
					if (displayLength && displayLength > 0) return displayLength;
				}
	
				return this.properties.DisplayLength;
			}
		}, {
			key: 'getQueryFilteredVaue',
			value: function getQueryFilteredVaue(value) {
				if (value == "*") return value;
				var filter = this.getProperty_QueryFilter();
				if (filter == "") filter = "=";
				return filter == "=" ? value : filter + value;
			}
		}, {
			key: 'doModifiedEditor',
			value: function doModifiedEditor(oldValue, newValue, component) {
				if (!this.module) return;
				var editorName = this.xml.name;
	
				_LayerManager2.default.executeLayerMethod(this.module, this.group, "modifiedEditor_" + editorName);
	
				var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("modifiedEditor_" + editorName, this.forLookup ? "FormLookup" : window.menuItemId, this.module.formId);
				if (mi) {
					if (mi.prefetch == true) {
						_CommandResolver2.default.resolve(mi.commandResult.tasks, this.module, this.group);
					} else {
						var defaultGroupAlias;
						if (this.group) {
							defaultGroupAlias = this.group.groupAlias;
						} else {
							if (this.module.formDataSources && this.module.formDataSources.firstGroup) {
								defaultGroupAlias = this.module.formDataSources.firstGroup.groupAlias;
							}
						}
						var arg = _CommandResolver2.default.getSendCmd(this.module, defaultGroupAlias, mi);
	
						var command = _CommandHelper2.default.createFormInstance(this.module.formName, "doModifiedEditor", "CommandResult");
	
						command.appendArg(editorName, "String").appendArg(oldValue + "", "Object").appendArg(newValue + "", "Object").appendArg(arg, "CommandArg");
						var _group = this.group;var _rpc_fault_doModifiedEditor = this.rpc_fault_doModifiedEditor.bind(this);var _module = this.module;
						var remoteArg = {
							command: command,
							resultFunction: function resultFunction(data) {
								_CommandResolver2.default.resolve(data.result.tasks, _module, _group);
							},
							faultFunction: function faultFunction(data) {
								_rpc_fault_doModifiedEditor(data, oldValue, newValue, component);
							}
						};
						_ServiceHelper2.default.addTokenWithCommand(remoteArg);
					}
				}
				/*TODO 何意?
	   var formModuleEvent:FormModuleEvent = new FormModuleEvent(FormModuleEvent.MODULE_FORMREINIT,true);
	   formModuleEvent.caller = fm;
	   formModuleEvent.callereditor = editorName;
	   formModuleEvent.callereditorNewValue = newValue;
	   formModuleEvent.callereditorOldValue = oldValue;
	   fm.dispatchEvent(formModuleEvent);
	   */
			}
		}, {
			key: 'rpc_fault_doModifiedEditor',
			value: function rpc_fault_doModifiedEditor(data, oldValue, newValue, component) {
				//TODO 此处data是否具有标准返回格式?
	
				var faultString;
				if (data && data.successButNot0) {
					faultString = data.errText;
					//Warning.show({text:data.errText,title:"画面初始查询失败"});
				} else {
					faultString = "可能是网络错误 请检查网络是否正常";
					//Warning.show({text:"请检查网络是否正常或联系管理员",title:"变更值失败"});
				}
	
				var info = "变更值失败：" + oldValue + " -> " + newValue + "<br/>" + "已恢复到：" + oldValue + "<br/>" + "失败原因为：" + faultString;
				_Warn2.default.show({ text: info, title: "此次操作未能成功" });
				this.record = oldValue;
				if (component && typeof component.restoreValue == "function") component.restoreValue(oldValue);
				return;
				if (this.component) {
					this.component.record = oldValue;
					this.component.setDisplayNoResolve(oldValue);
				}
			}
		}, {
			key: 'isSkipTab',
			value: function isSkipTab() {
				if (this.isUnderQueryGroup()) {
					var result = {};
					_CommandActions2.default.callComponentFunc(this.formId, this.xml.id, "getInQueryGroupNow", [], result);
					if (result.ret == false) return true;
				}
	
				//TODO折叠的Group要跳过焦点导航
				//if(getGroupParentFolded())
				//	return true;
	
				//TODO与Flex不一致 Flex端没有跳过隐藏的节点
				//if(!this.getProperty_Visible_FinalusersetLoopForSkip())
				//	return true;
				if (!this.getProperty_Visible_Final()) return true;
				if (this.getProperty_ActualSkipTab()) return true;
				if (this.getProperty_AllowEdit_Final() == false) return true;
				return false;
			}
		}, {
			key: 'doFieldModifiedRemote',
			value: function doFieldModifiedRemote(dataField, newValue, oldValue, record, comoponent) {
				var extralParms = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
				// if(this.group)
				// {
				// 	let arr = dataField.split(".");
				// 	let aliasName = arr[0];
				// 	let fieldName = arr[1];
				// 	let componentName = null;
				// 	if(arr.length>2)
				// 		componentName = arr[2];
				// 	extralParms.editorName = this.xml.name;
				// 	return this.group.doFieldModifiedRemote(aliasName,fieldName,componentName,oldValue,newValue,dataField,record,comoponent,extralParms);	
	
				// }
				// return true;
				if (this.group) {
	
					var arr = dataField.split(".");
					var aliasName = arr.shift();
					var fieldName = void 0;
					if (this.componentField) {
						fieldName = this.componentDim;
					} else {
						fieldName = arr.join(".");
					}
					var componentName = null;
					if (this.componentField) componentName = this.componentField;
					extralParms.editorName = this.xml.name;
					extralParms.formDataSourceField = this.formDataSourceField;
					return this.group.doFieldModifiedRemote(aliasName, fieldName, componentName, oldValue, newValue, dataField, record, comoponent, extralParms);
				}
				return true;
			}
		}, {
			key: 'setControlProperty',
			value: function setControlProperty(property, value) {
				if (property == _ControlPropertyConst2.default.DISPLAYLENGTH) {
					this.propertyDisplayLength = value;
					_CmdTypeActions2.default.updateControlProperty(this.xml.name, property, value, this.module.instanceUUId);
					return true;
				} else if (property == _ControlPropertyConst2.default.NOTNULL) {
					this.propertyNotNull = value;
					_CmdTypeActions2.default.updateControlProperty(this.xml.name, property, value, this.module.instanceUUId);
					return true;
				} else if (property == _ControlPropertyConst2.default.KEYDOWNEVNET) {
					this.propertyKeyDownEvent = value;
					return true;
				}
				return false;
			}
		}, {
			key: 'analysisConditionSingleValue',
			value: function analysisConditionSingleValue(value, valueCondition) {
				if (valueCondition == null) return true;
				if (value == null) return false;
				if (!valueCondition.getSqlWhereStr) valueCondition.getSqlWhereStr = _ValueCondition2.default.getSqlWhereStr;
				var ws = valueCondition.getSqlWhereStr();
				if (ws == "") return true;
				var wsa = ws.split(" ");
				var wsr = "";
				for (var i = 0; i < wsa.length; i++) {
					var s = wsa[i];
					if (s.indexOf("=") == -1) {
						wsr += s;
					} else {
						var fn = _StringUtil2.default.convertToFirstLowerCase(s.substring(0, s.indexOf("=")));
						var fv = s.substr(s.indexOf("=") + 1);
	
						if (fn.indexOf(".") != 0) //fn == .fieldName
							continue;
						//var value:String = anyRecordValue(fn,null,item);
						//对于无数据源 fv即ValueConditionItem中的value 不可能出现. 
						//if(fv.indexOf(".") == 0)
						//	fv = anyRecordValue(fv,null,item);
	
	
						if (RecordUtil.analysisValue(value, fv)) {
							wsr += "1";
						} else {
							wsr += "0";
						}
					}
				}
	
				return _StringUtil2.default.evalLEString(_StringUtil2.default.trimThrough(wsr));
			}
		}, {
			key: 'getCommonProps',
			value: function getCommonProps() {
				return { defaultValueForCMD: this.getProperty_DefaultForCMD(), initEditorValue: this.initEditorValue,
					controlVisible: this.getProperty_Visible_Final(), hideInVisible: this.getProperty_HideInVisible(),
					textAlign: this.getProperty_Alignment(), holdFocus: this.holdFocus, height: this.getProperty_Height() };
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {}
		}]);
	
		return FormItemEditorControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemEditorControl;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _UserFormSetForm = __webpack_require__(172);
	
	var _UserFormSetForm2 = _interopRequireDefault(_UserFormSetForm);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GongqiFormItemControl = function () {
		function GongqiFormItemControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, GongqiFormItemControl);
	
			this.finalVisible = true;
			this.finalVisibleInited = false;
			this.finalVisibleUsInited = false;
			this.finalVisibleUs = true;
	
			this.classAlias = "GongqiFormItemControl";
			this.menuItemId = menuItemId;
			this.formId = formId;
			this.authorityKey = forLookup ? module.formXML.name : menuItemId;
			this.parentXML = parent;
			this.xml = xml;
			this.innerId = xml.id;
			this.group = group;
			this.groupAlias = group != null ? group.groupAlias : "";
			this.parentControl = null;
			this.childrenControl = [];
			this.forLookup = forLookup;
			this.controlId = "ctrl_" + this.xml.name;
	
			this.module = module;
			var _key = _FormItemUtil2.default.getFormStoresKey(this.menuItemId, this.formId);
			var formStore = window.parent.window[_key];
			this.properties = formStore.mapItemProperty[this.formId + "_" + this.xml.id];
	
			this.contextMenuData = {
				items: [
				//{label:'隐藏',icon:'',action:this.hide.bind(this)},
				//{label:'显示',icon:'',action:this.show.bind(this)},
				{ label: '调整布局', icon: '', action: this.formAdjust.bind(this) }
				// {label:'画面调整(含列宽)',icon:'',action:this.formAdjust2.bind(this)}
				]
			};
		}
	
		_createClass(GongqiFormItemControl, [{
			key: 'setControlSkipTabCmd',
			value: function setControlSkipTabCmd(skip) {
				this._cmdSkipTab = skip;
				try {
					if (this.childrenControl) {
						for (var i = 0; i < this.childrenControl.length; i++) {
							var childControl = this.childrenControl[i];
							if (childControl && childControl.setControlSkipTabCmd) childControl.setControlSkipTabCmd(skip);
						}
					}
				} catch (e) {}
			}
		}, {
			key: 'hide',
			value: function hide() {
				alert("hide");
			}
		}, {
			key: 'show',
			value: function show() {
				alert("show");
			}
		}, {
			key: 'formAdjust',
			value: function formAdjust() {
				_reactDom2.default.render(_react2.default.createElement(_UserFormSetForm2.default, null), document.getElementById('userFormSetDiv'));
				$("#userFormSetDiv").css("display", "flex");
				//$("body").mLoading({text:"正在加载界面调整..."});
				//$("#userFormSetDiv").load("userformset/userformset.html").css("display","flex");
			}
		}, {
			key: 'formAdjust2',
			value: function formAdjust2() {
				//this.allUserProperties["50023"] = {displayLength:50};
				var columnProperties = {};
				_CommandActions2.default.getColumnLengthProperties(columnProperties);
				_reactDom2.default.render(_react2.default.createElement(_UserFormSetForm2.default, { columnProperties: columnProperties }), document.getElementById('userFormSetDiv'));
				$("#userFormSetDiv").css("display", "flex");
			}
		}, {
			key: 'getProperty_Width',
			value: function getProperty_Width() {
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && _properties.hasOwnProperty("width")) return _properties["width"];
				}
				if (!this.properties.Width || this.properties.Width == -1) return "";
				return this.properties.Width;
			}
		}, {
			key: 'getProperty_HelpText',
			value: function getProperty_HelpText() {
				return this.properties.HelpText;
			}
		}, {
			key: 'getProperty_EnumType',
			value: function getProperty_EnumType() {
				return _GOTUtil2.default.getPropertyValue(this.xml, "EnumType");
			}
		}, {
			key: 'getProperty_CSSStyle',
			value: function getProperty_CSSStyle() {
				if (this.properties.hasOwnProperty("CSSStyle")) return this.properties.CSSStyle;
				return "";
			}
		}, {
			key: 'getProperty_Height',
			value: function getProperty_Height() {
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && _properties.hasOwnProperty("height")) return _properties["height"];
				}
				if (!this.properties.Height || this.properties.Height == -1) return "";
				return this.properties.Height;
			}
		}, {
			key: 'getProperty_HideInVisible',
			value: function getProperty_HideInVisible() {
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && (_properties.hasOwnProperty("hideinvisible") || _properties.hasOwnProperty("hideInVisible"))) {
						var _value = _properties["hideinvisible"] || _properties["hideInVisible"];
						if (typeof _value == "string") return _value == "true" ? true : false;
					}
					//return _properties["hideInVisible"];
				}
				if (this.properties.hasOwnProperty("HideInvisible")) return this.properties.HideInvisible;
				return !this.properties.PlaceHolder;
			}
		}, {
			key: 'getProperty_Label',
			value: function getProperty_Label() {
				var showLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				if (this._cmdLabel) return this._cmdLabel;
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && _properties.hasOwnProperty("label")) return _properties["label"];
				}
				return this.properties.Label;
			}
		}, {
			key: 'getProperty_ShowLabel',
			value: function getProperty_ShowLabel() {
				return this.properties.ShowLabel;
			}
		}, {
			key: 'getProperty_AllowEdit_GOT',
			value: function getProperty_AllowEdit_GOT() {
				if (typeof this.properties.AllowEdit == "string") {
					if (this.properties.AllowEdit == _FormItemConst2.default.ALLOWEDIT_ALWAYS) return true;else if (this.properties.AllowEdit == _FormItemConst2.default.ALLOWEDIT_NEVER) return false;else if (this.properties.AllowEdit == _FormItemConst2.default.ALLOWEDIT_ONLYONCREATE) return false;
				}
	
				return this.properties.AllowEdit;
			}
		}, {
			key: 'getActualParentItemId',
			value: function getActualParentItemId() {
				return this.xml.parentId;
			}
		}, {
			key: 'getProperty_AllowEdit_Loop',
			value: function getProperty_AllowEdit_Loop() {
				var parentItemId = this.getActualParentItemId();
				var key = _FormItemUtil2.default.getFormItemControlKey(this.menuItemId, this.formId, parentItemId);
				var parentControl = _FormItemUtil2.default.getFormItemControl(key, this.forLookup);
	
				if (parentControl._cmdEditFalse == true) return false;
	
				return parentControl.getProperty_AllowEdit_GOTFinal();
			}
		}, {
			key: 'getProperty_AllowEdit_GOTFinal',
			value: function getProperty_AllowEdit_GOTFinal() {
				if (this.finalAllowEditGOT) return this.finalAllowEditGOT;
	
				var result = this.getProperty_AllowEdit_GOT();
				if (!result) return false;
	
				result = this.getProperty_AllowEdit_Loop();
				this.finalAllowEditGOT = result;
				return result;
			}
		}, {
			key: 'getProperty_AllowEdit_CurrentRecordLocked',
			value: function getProperty_AllowEdit_CurrentRecordLocked() {
				return false;
			}
		}, {
			key: 'getProperty_AllowEdit_UserSet',
			value: function getProperty_AllowEdit_UserSet() {
				var _parentWindow = window.parent.window;
				var _key = window.menuItemId + "." + window.formId;
				if (_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(_key)) {
					var allUserProperties = _parentWindow.userProperties[_key];
					if (allUserProperties) {
						var thisProperties = allUserProperties[this.xml.id];
						if (thisProperties) {
							var _value = "";
							if (thisProperties.hasOwnProperty("allowEdit")) {
								_value = thisProperties.allowEdit;
								if (_value == false || _value == "false") return false;
							} else if (thisProperties.hasOwnProperty("allowedit")) {
								_value = thisProperties.allowedit;
								if (_value == false || _value == "false") return false;
							}
						}
					}
				}
				//若没有进行过用户设置 则找寻GOT属性的代码应该在权限及用户覆写的下面
				return true;
			}
		}, {
			key: 'getProperty_Visible_UserSet',
			value: function getProperty_Visible_UserSet() {
				var _parentWindow = window.parent.window;
				var _key = window.menuItemId + "." + window.formId;
				if (_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(_key)) {
					var allUserProperties = _parentWindow.userProperties[_key];
					if (allUserProperties) {
						var thisProperties = allUserProperties[this.xml.id];
						if (thisProperties && thisProperties.hasOwnProperty("visible") && (thisProperties.visible == false || thisProperties.visible == "false")) return false;
					}
				}
				//若没有进行过用户设置 则找寻GOT属性的代码应该在权限及用户覆写的下面
				return true;
			}
		}, {
			key: 'getProperty_AllowEdit_UserSetLoop',
			value: function getProperty_AllowEdit_UserSetLoop() {
				var parentItemId = this.getActualParentItemId();
				var key = _FormItemUtil2.default.getFormItemControlKey(this.menuItemId, this.formId, parentItemId);
				var parentControl = _FormItemUtil2.default.getFormItemControl(key, this.forLookup);
				return parentControl.getProperty_AllowEdit_UserSetFinal();
			}
		}, {
			key: 'getProperty_AllowEdit_UserSetFinal',
			value: function getProperty_AllowEdit_UserSetFinal() {
				var result = this.getProperty_AllowEdit_UserSet();
				if (!result) {
					return false;
				}
				result = this.getProperty_AllowEdit_UserSetLoop();
				return result;
			}
		}, {
			key: 'getProperty_Visible_FinalWithOutUserSet',
			value: function getProperty_Visible_FinalWithOutUserSet() {
				if (this.finalVisibleInited) return this.finalVisible;
				var result = this.getProperty_AuFinal("visible");
				if (result) result = this.getProperty_Visible_GOTFinal();
	
				this.finalVisible = result;
				this.finalVisibleInited = true;
				return result;
			}
		}, {
			key: 'getProperty_Visible_GOTFinal',
			value: function getProperty_Visible_GOTFinal() {
				var result = this.getProperty_Visible();
				if (!result) return false;
				result = this.getProperty_Visible_GOT();
				if (!result) return false;
				if (this.classAlias != "FormItemDesignControl") result = this.getProperty_Visible_Loop();
				return result;
			}
		}, {
			key: 'getProperty_Visible_Loop',
			value: function getProperty_Visible_Loop() {
				var gongqiFormItemP = this.getActualParentItemControl();
				if (!gongqiFormItemP) return true;
				return gongqiFormItemP.getProperty_Visible_GOTFinal();
			}
		}, {
			key: 'getProperty_Visible',
			value: function getProperty_Visible() {
				return this.properties.Visible;
			}
		}, {
			key: 'getProperty_Visible_GOT',
			value: function getProperty_Visible_GOT() {
				return this.properties.Visible;
			}
		}, {
			key: 'getActualParentItemControl',
			value: function getActualParentItemControl() {
				var parentItemId = this.getActualParentItemId();
				var key = _FormItemUtil2.default.getFormItemControlKey(this.menuItemId, this.formId, parentItemId);
				var parentControl = _FormItemUtil2.default.getFormItemControl(key, this.forLookup);
				return parentControl;
			}
		}, {
			key: 'getProperty_AuFinal',
			value: function getProperty_AuFinal(type) {
				if (this && this.group && this.group.forLookup == true) {
					return true;
				}
				var _parentWindow = window.parent.window;
				if (_parentWindow.userInfos.isAdmin == true) return true;
	
				var finalValue = true;var isForbidden = false;var finalValueSetted = false;
				var au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId, this.xml.id, type);
	
				if (au["isDefault"] == false) {
					finalValue = au["result"];
					finalValueSetted = true;
					isForbidden = au["isForbidden"];
				}
	
				if (isForbidden) return false;
	
				var parentControl = this.getActualParentItemControl();
	
				while (parentControl) {
					au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId && window.menuItemId != "" ? window.menuItemId : window.formXML.name, parentControl.xml.id, type);
	
					if (au["isDefault"] == false) {
						if (!finalValueSetted) {
							finalValue = au["result"];
							finalValueSetted = true;
						}
	
						isForbidden = au["isForbidden"];
					}
	
					if (isForbidden) return false;
	
					parentControl = parentControl.getActualParentItemControl();
				}
	
				return finalValue && !isForbidden;
			}
		}, {
			key: 'getProperty_AllowEdit_Final',
			value: function getProperty_AllowEdit_Final() {
				//if(this.forLookup)return true;
				if (this.group && this.group.mainSource.isAggreateTable == true)
					//&& this.group.mainSource.isPivotTable == false)
					return false;
	
				if (this._cmdEditFalse == true) return false;
				if (this._cmdConditionTaskEditFalse == true) return false;
				//TODO EditMode调整
				// if(!getEditMode())
				// 	return false;
	
				if (this.getProperty_AllowEdit_CurrentRecordLocked() == true) return false;
	
				var result = this.getProperty_AllowEdit_UserSetFinal();
				if (!result) return false;
				result = this.getProperty_AuFinal("edit");
				if (result) {
					result = this.getProperty_AllowEdit_GOTFinal();
				}
				return result;
			}
		}, {
			key: 'getProperty_Visible_UserSetFinal',
			value: function getProperty_Visible_UserSetFinal() {
				var result = this.getProperty_Visible_UserSet();
				if (!result) {
					return false;
				}
				return result;
			}
		}, {
			key: 'getProperty_Visible_UserSetLoop',
			value: function getProperty_Visible_UserSetLoop() {
				var parentItemId = this.getActualParentItemId();
				var key = _FormItemUtil2.default.getFormItemControlKey(this.menuItemId, this.formId, parentItemId);
				var parentControl = _FormItemUtil2.default.getFormItemControl(key, this.forLookup);
				return parentControl.getProperty_Visible_UserSetFinal();
			}
		}, {
			key: 'getProperty_Visible_UserSetFinalLoop',
			value: function getProperty_Visible_UserSetFinalLoop() {
				var result = this.getProperty_Visible_UserSet();
				if (!result) return false;
				if (!(this.classAlias == "FormItemDesignControl")) {
					result = this.getProperty_Visible_UserSetLoop();
				}
				return result;
			}
		}, {
			key: 'getProperty_Visible_Final',
			value: function getProperty_Visible_Final() {
				if (this._cmdVisibleFalse == true) return false;
				var result = this.getProperty_Visible_UserSetFinalLoop();
				if (!result) return false;
				return this.getProperty_Visible_FinalWithOutUserSet();
			}
		}, {
			key: 'getProperty_Visible_FinalusersetLoopForSkip',
			value: function getProperty_Visible_FinalusersetLoopForSkip() {
				if (this.finalVisibleUsInited) return this.finalVisibleUs;
				var result = this.getProperty_Visible_UserSetFinalLoop();
				if (result) result = this.getProperty_Visible_GOTFinal();
				this.finalVisibleUs = result;
				this.finalVisibleUsInited = true;
				return result;
			}
		}, {
			key: 'isSkipTab',
			value: function isSkipTab() {
				return true;
			}
		}, {
			key: 'getProperty_SkipTab',
			value: function getProperty_SkipTab() {
				if (this._cmdSkipTab != undefined) return this._cmdSkipTab;
	
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && (_properties.hasOwnProperty("skiptab") || _properties.hasOwnProperty("skipTab"))) {
						var _value = void 0;
						if (_properties.hasOwnProperty("skiptab")) _value = _properties["skiptab"];else _value = _properties["skipTab"];
						if (typeof _value == "string") {
							return _value == "true" ? true : false;
						}
						return _value;
					}
				}
	
				if (this.properties.hasOwnProperty("SkipTab")) return this.properties.SkipTab;
				return false;
			}
		}, {
			key: 'getProperty_ActualSkipTab',
			value: function getProperty_ActualSkipTab() {
				if (this.getProperty_SkipTab()) return true;
	
				var parent = this.parentControl;
				while (parent) {
					if (parent.getProperty_SkipTab()) return true;
					parent = parent.parentControl;
				}
	
				return false;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {}
		}, {
			key: 'getCommonProps',
			value: function getCommonProps() {
				return { controlVisible: this.getProperty_Visible_Final(), hideInVisible: this.getProperty_HideInVisible() };
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var _style = {};
				//if(!this.getProperty_Visible_Final())
				//	_style["visibility"] = "hidden";
				var cssStylePro = this.getProperty_CSSStyle();
				//let jsonStyle = JSON.parse(cssStylePro);
				if (cssStylePro) {
					var cssStyleObject = {};
					var styles = cssStylePro.split(";");
					for (var i = 0; i < styles.length; i++) {
						var singleStyle = styles[i];
						if (singleStyle) {
							var singleStyles = singleStyle.split(":");
							var styleName = singleStyles[0];
							var styleValue = singleStyles[1];
							var origStyleName = _StringUtil2.default.trimThrough(styleName);
							styleName = _StringUtil2.default.convertStyleToReactStyle(origStyleName);
							cssStyleObject["orig-" + styleName] = origStyleName;
							cssStyleObject[styleName] = styleValue;
						}
					}
					Object.assign(_style, cssStyleObject);
				}
	
				return _style;
			}
	
			//判断子级是否包含诸如Tab DataGrid HtmlPlugin等固定百分百控件
	
		}, {
			key: 'containsMaxControl',
			value: function containsMaxControl(item, layout) {
				var children = item.FormItem;
				if (children == null || children == undefined) return false;
				for (var i = 0; i < children.length; i++) {
					var child = children[i];
					//if(child.type == "Tab")
					//	return true;
	
					if (child.type == "DataGrid") {
						if (layout == "vertical") {
							return _GOTUtil2.default.getPropertyValue(child, "Rows") == "";
						} else if (layout == "horizontal") return true;
					}
	
					if (child.type == "Plugin") {
						if (layout == "vertical") {
							var _height = _GOTUtil2.default.getPropertyValue(item, "Height");
							if (!_height) return true;
						} else {
							var _width = _GOTUtil2.default.getPropertyValue(item, "Width");
							if (!_width) return true;
						}
					}
					var childLayout = _GOTUtil2.default.getPropertyValue(child, "Layout");
					if (!childLayout) continue;
					if (this.containsMaxControl(child, childLayout)) return true;
				}
				return false;
			}
		}, {
			key: 'containsMaxControlForHeight',
			value: function containsMaxControlForHeight(item) {
				var children = item.FormItem;
				if (children == null || children == undefined) return false;
				for (var i = 0; i < children.length; i++) {
					var child = children[i];
					if (child.type == "DataGrid") {
						if (_GOTUtil2.default.getPropertyValue(child, "Rows") == "") return true;
						/*if(this.module.hasUpDownDataGrid)
	     {
	     	if(GOTUtil.getPropertyValue(child,"Rows") == "16")return true; 
	     }
	     else
	     {
	     	return true;
	     }*/
					}
					//TODO 需要根据Plugin实际情况来判断是否属于最大化控件
					if (child.type == "Plugin") {
						var pluginType = _GOTUtil2.default.getPropertyValue(child, "PluginType");
						if (pluginType == "Radio") continue;
						var _height = _GOTUtil2.default.getPropertyValue(child, "Height");
						if (!_height) return true;
					}
					if (this.containsMaxControlForHeight(child)) return true;
				}
				return false;
			}
		}, {
			key: 'containsMaxControlForWidth',
			value: function containsMaxControlForWidth(item) {
				var children = item.FormItem;
				if (children == null || children == undefined) return false;
				for (var i = 0; i < children.length; i++) {
					var child = children[i];
					if (child.type == "Tab" || child.type == "DataGrid") return true;
					//TODO 需要根据Plugin实际情况来判断是否属于最大化控件
					if (child.type == "Plugin") {
						var _width = _GOTUtil2.default.getPropertyValue(child, "Width");
						if (!_width) return true;
					}
					if (this.containsMaxControlForWidth(child)) return true;
				}
				return false;
			}
		}, {
			key: 'isVerticalNotFirst',
			value: function isVerticalNotFirst() {
				if (this.parentControl) {
					if (this.parentXML.Properties.Layout.Value == "vertical") {
						var firstItem = this.parentXML.FormItem[0];
						if (firstItem.id != this.xml.id && this.containsMaxControl(firstItem)) return true;
					}
					return this.parentControl.isVerticalNotFirst();
				}
				return false;
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
				if (this.childrenControl && this.childrenControl.length > 0) {
					var finalValue = this.getProperty_AllowEdit_Final();
					for (var i = 0; i < this.childrenControl.length; i++) {
						var item = this.childrenControl[i];
	
						if (item.classAlias && item.classAlias.indexOf("Editor") != -1) {
							_CmdTypeActions2.default.updateControlAllowEdit(item.xml.name, finalValue, this.moduleInstanceId);
						} else if (item.doSetEnableCmd) {
							item.doSetEnableCmd(value);
						}
					}
				}
			}
		}, {
			key: 'isUnderQueryGroup',
			value: function isUnderQueryGroup() {
				var targetParent = this.parentControl;
	
				while (targetParent && targetParent.classAlias && targetParent.classAlias != "FormItemDesignControl") {
					if (targetParent.classAlias == "FormItemGroupControl") {
						if (targetParent.getProperty_GroupType() == "Query") {
							return true;
						}
					}
	
					targetParent = targetParent.parentControl;
				}
				return false;
			}
		}, {
			key: 'isSameMainSource',
			value: function isSameMainSource(baseGroup) {
				if (this.group != baseGroup) return false;
				var datasourcepro = _GOTUtil2.default.getProperty(this.xml, "DataSource");
				if (!datasourcepro) return false;
				var datasource = datasourcepro.Value;
				return datasource == baseGroup.groupAlias ? true : false;
			}
		}, {
			key: 'setControlProperty',
			value: function setControlProperty(name, value) {}
		}]);
	
		return GongqiFormItemControl;
	}();
	
	exports.default = GongqiFormItemControl;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemEditorRender = function (_React$Component) {
		_inherits(FormItemEditorRender, _React$Component);
	
		function FormItemEditorRender(props) {
			_classCallCheck(this, FormItemEditorRender);
	
			var _this = _possibleConstructorReturn(this, (FormItemEditorRender.__proto__ || Object.getPrototypeOf(FormItemEditorRender)).call(this, props));
	
			_this.state = { recordValue: props.value };
			_this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(_this.onDataFieldChanged.bind(_this));
			_this.unsubscribeRecordDataMethodFieldChangedStore = _RecordsStore.RecordDataMethodFieldChangedStore.listen(_this.onRecordDataMethodChanged.bind(_this));
			if (!_this.props.forLookup) _this.unsubscribeRenderUpdateModifiedTagStore = _RecordsStore.RenderUpdateModifiedTagStore.listen(_this.onRenderUpdateModifiedTag.bind(_this));
			_this.unsbuscribeBindStyleStore = _CmdTypeStore.BindStyleStore.listen(_this.onBindStyleStore.bind(_this));
	
			return _this;
		}
	
		_createClass(FormItemEditorRender, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeRecordDataMethodFieldChangedStore();
				if (!this.props.forLookup) this.unsubscribeRenderUpdateModifiedTagStore();
				this.unsbuscribeBindStyleStore();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var copy = Object.assign({}, this.props.contextMenuData);
				if (copy.items) {
					for (var i = 0; i < copy.items.length; i++) {
						var item = copy.items[i];
						if (item && item.label == "过滤[Ctrl+T]") {
							item.action = this.queryFilter.bind(this);
							break;
						}
					}
					$(this.componentLabel).contextPopup(copy);
				} else {
					$(this.componentLabel).contextPopup(this.props.contextMenuData);
				}
			}
		}, {
			key: 'queryFilter',
			value: function queryFilter() {
				if (!this.props.group) return;
				var _dataField = this.props.dataField;
				if (_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField)) {
	
					var value = this.props.rowData[_dataField];
					this.props.group.queryFilter(_dataField, value, true);
				}
			}
	
			/*componentDidUpdate()
	  {
	  	let gridCellDrag = window.gridCellDrag;
	  	if(gridCellDrag)
	  	{
	  		//= {fromRow:fromRow,toRow:toRow,cellKey:cellKey,rows:rows};
	  		if(this.props.dataField == gridCellDrag.cellKey && this.props.gridXml.id == gridCellDrag.gridId)
	  		{
	  			let _index = this.props.group.records.indexOf(this.props.rowData);
	  			if(_index>gridCellDrag.fromRow && _index<=gridCellDrag.toRow)
	  				$(this.componentLabel).addClass("gridCellMutiSelected");
	  		}
	  	} 
	  }*/
	
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.rowData != this.props.rowData) {
					this.origRecord = Object.assign({}, nextProps.rowData);
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (record == this.props.rowData) {
					//alert(this.props.dataField + "   " + dataField);
					if (this.props.dataField == dataField) {
	
						//此处只更新UI 没有遵循react只关注当前状态的组件封装思想 但是等到下次失效时 由于数据已发生更改 所以这个逻辑没有问题
						/*$(this.componentLabel).html(this.getDisplay(newValue));
	     this.updateModifiedTag();*/
						this.setState({ recordValue: newValue });
					}
				}
			}
		}, {
			key: 'onRecordDataMethodChanged',
			value: function onRecordDataMethodChanged(record, dataField) {
				if (record == this.props.rowData) {
					if (this.props.dataField == dataField) {
						this.setState({ recordValue: this.props.rowData[dataField] });
					}
				}
			}
		}, {
			key: 'updateModifiedTag',
			value: function updateModifiedTag() {
				var newValue = this.props.rowData[this.props.dataField];
				var origValue = this.origRecord[this.props.dataField];
				if (origValue != newValue) {
					//alert(origValue + "  " + newValue);
					this.currentDataFieldChanged = true;
					$(this.modifiedTag).css("display", "block");
				} else {
					this.currentDataFieldChanged = false;
					$(this.modifiedTag).css("display", "none");
				}
			}
		}, {
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				return _value;
			}
		}, {
			key: 'onRenderUpdateModifiedTag',
			value: function onRenderUpdateModifiedTag(groupAlias, currentRecord) {
				if (this.props.group && this.props.group.groupAlias == groupAlias) {
					var key = groupAlias + ".recId";
					if (this.props.rowData[key] == currentRecord[key]) this.forceUpdate();
				}
			}
		}, {
			key: 'getRowStyles',
			value: function getRowStyles() {
				var menuItemId = this.props.menuItemId;
				var formId = this.props.formId;
				var gridId = this.props.gridXml.id;
				return _FormItemUtil2.default.getControlStyles(menuItemId, formId, gridId);
			}
		}, {
			key: 'getClientLayerRowStyles',
			value: function getClientLayerRowStyles() {}
		}, {
			key: 'getEditorStyles',
			value: function getEditorStyles() {
				var menuItemId = this.props.menuItemId;
				var formId = this.props.formId;
				var colId = this.props.colXml.id;
				return _FormItemUtil2.default.getControlStyles(menuItemId, formId, colId);
			}
		}, {
			key: 'onBindStyleStore',
			value: function onBindStyleStore(formId, name) {
				if (formId == this.props.formId && (this.props.colXml.name == name || this.props.gridXml.name == name)) {
					this.forceUpdate();
				}
			}
		}]);
	
		return FormItemEditorRender;
	}(_react2.default.Component);
	
	exports.default = FormItemEditorRender;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemEditorRenderForAutoLookup = function (_React$Component) {
		_inherits(FormItemEditorRenderForAutoLookup, _React$Component);
	
		function FormItemEditorRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemEditorRenderForAutoLookup);
	
			var _this = _possibleConstructorReturn(this, (FormItemEditorRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemEditorRenderForAutoLookup)).call(this, props));
	
			_this.state = { recordValue: props.value };
			return _this;
		}
	
		_createClass(FormItemEditorRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				return _value;
			}
		}]);
	
		return FormItemEditorRenderForAutoLookup;
	}(_react2.default.Component);
	
	exports.default = FormItemEditorRenderForAutoLookup;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _LogUtil = __webpack_require__(173);
	
	var _LogUtil2 = _interopRequireDefault(_LogUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _OverallSituationModelDiv = __webpack_require__(152);
	
	var _OverallSituationModelDiv2 = _interopRequireDefault(_OverallSituationModelDiv);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebSocketManager = __webpack_require__(109);
	
	var _WebSocketManager2 = _interopRequireDefault(_WebSocketManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var base64js = __webpack_require__(330);
	var pako = __webpack_require__(335);
	
	var AjaxRemoteUtil = function () {
		function AjaxRemoteUtil() {
			_classCallCheck(this, AjaxRemoteUtil);
		}
	
		_createClass(AjaxRemoteUtil, null, [{
			key: 'setRemoteDisable',
			value: function setRemoteDisable(params) {
	
				if (!params.autoLock) return;
				AjaxRemoteUtil.tokenNum++;
				if (AjaxRemoteUtil.tokenNum == 1) {
					AjaxRemoteUtil._setProcessID = setTimeout(function () {
						if (AjaxRemoteUtil._setProcessID) {
							if (window.menuItemId && window.formId) window.parent.$("body").mLoading({ text: params.lockText });else $('body').mLoading({ text: params.lockText });
						}
					}, 500);
				}
			}
		}, {
			key: 'setRemoteEnable',
			value: function setRemoteEnable(params) {
				if (!params.autoUnlock) return;
				AjaxRemoteUtil.tokenNum--;
				if (AjaxRemoteUtil.tokenNum < 0) {
					_Warn2.default.show({ text: "调用计数错误，如出现不能访问，请刷新浏览器" });
					AjaxRemoteUtil.tokenNum = 0;
				}
	
				if (AjaxRemoteUtil.tokenNum == 0) {
					clearTimeout(AjaxRemoteUtil._setProcessID);
					AjaxRemoteUtil._setProcessID = undefined;
					AjaxRemoteUtil._delay = false;
					if (document.readyState != "complete") return;
					if (window.menuItemId && window.formId) window.parent.$("body").mLoading("hide");else $('body').mLoading("hide");
				}
			}
		}, {
			key: 'getParsedErrText',
			value: function getParsedErrText(errText) {
				return errText;
			}
		}, {
			key: 'ajaxPost',
			value: function ajaxPost(url, data, resultType, sync, sucessHandler, errorHandler) {
				var successIngnoreStatus = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
				var params = arguments[7];
	
				if (!params.relativeUrl) {
					if (window.urlBase) url = urlBase + url;
				}
	
				//url+=("?t="+new Date().getTime())
				//params.autoLock = params.autoUnlock = false;
				//window.temp222 = JSON.parse(data.request);
				//if(window.formModuleInstanceuuId)
				//	window.parent.window.closeForm(window.formModuleInstanceuuId);
				var _headers = {};
				if (params.domain && !params.loginToken && !params.loginDataArea) {
					var _token = localStorage.getItem("userToken");
					if (_token) _headers.token = _token;
				}
				AjaxRemoteUtil.setRemoteDisable(params);
				return $.ajax({
					type: 'post',
					url: url,
					dataType: resultType,
					data: data,
					async: !sync,
					headers: _headers,
					//暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
					xhrFields: { withCredentials: true },
					//for fireFox
					/*beforeSend: function(xhr) {
	    xhr.withCredentials = true;
	    },*/
					success: function success(data) {
						//if(window.temp222.methodName != "reInitForm")
						//if(!window.reInitFormCalled)
						AjaxRemoteUtil.setRemoteEnable(params);
						//console.log(data);
	
						if (params.logArg) {
							params.logArg.duration = new Date().getTime() - params.logArg.startDateTime + "";
							params.logArg.startDateTime = params.logArg.startDateTime + "";
							try {
								if (typeof window.setRpcLog == "function") {
									//status 200
									window.setRpcLog(params.logArg);
								} else if (typeof window.parent.window.setRpcLog == "function") {
									window.parent.window.setRpcLog(params.logArg);
								}
							} catch (error) {}
						}
	
						if (data.status == 2) {
							var _parentWindow = window.didomain ? window : window.parent.window;
							if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea) {
								if (typeof window.layui.request.loginOut() == 'function') {
									_parentWindow = window;
								} else if (typeof window.parent.window.layui.request.loginOut() == 'function') {
									_parentWindow = window.parent.window;
								} else {
									_parentWindow = window.parent.parent.window;
								}
								_parentWindow.layui.request.loginOut();
								var UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
								_parentWindow.localStorage.removeItem("username");
								_parentWindow.localStorage.removeItem("userId");
								_parentWindow.localStorage.removeItem("permission");
								_parentWindow.localStorage.removeItem("userToken");
								_parentWindow.localStorage.removeItem(UserId_desktopData);
							} else {
								if (window.parent && window.parent.window) {
									window.parent.window.location.href = window.parent.window.loginPath;
								} else {
	
									window.location.href = loginPath;
								}
							}
						} else if (data.status == 3) {
							if (data.msg && data.msg.indexOf) {
	
								document.getElementById('overallSituationDiv').style = "width: 100%;height: 100%;position: absolute;top: 0;left: 0;z-index: 9999";
								_reactDom2.default.render(_react2.default.createElement(_OverallSituationModelDiv2.default, null), document.getElementById('overallSituationDiv'));
								return;
							}
						} else if (data.status != 0) {
							var errText = data.msg;
							if (errText && errText.indexOf("Invoke failed:") == 0) errText = errText.substr(15);
							errText = AjaxRemoteUtil.getParsedErrText(errText);
							if (!errorHandler) _Warn2.default.show({ text: errText });else errorHandler({ successButNot0: true, errText: errText });
							if (successIngnoreStatus) {
								sucessHandler(data);
							}
						} else {
							if (data.compress) {
								var compressedByteArray = base64js.toByteArray(data.result);
								var s = pako.inflate(compressedByteArray, { to: 'string' });
								data.result = JSON.parse(s);
							}
	
							if (data.msg && data.msg.indexOf) {
								if (data.msg.indexOf("system maintenance") != -1) {
									//TODO 弹出系统正在升级的框并return
								}
							}
							sucessHandler(data);
						}
					},
					error: function error(data) {
						AjaxRemoteUtil.setRemoteEnable(params);
						//Warning.show({text:"程序遇到了无法处理的问题,请检查网络是否正常或联系管理员解决"});
						if (params.logArg) {
							var nowDate = new Date();
							var _duration = nowDate.getTime() - params.logArg.startDateTime + "";
							params.logArg.duration = _duration;
							params.logArg.startDateTime = params.logArg.startDateTime + "";
							//params.logArg.duration2 = _duration/1000+"";
							//params.logArg.startDateTime = params.logArg.startDateTime+"";
	
							params.logArg.readyState = data.readyState + "";
							params.logArg.httpStatus = data.status + "";
							params.logArg.statusText = data.statusText + "";
							params.logArg.state = typeof data.state == "function" ? data.state() + "" : "";
							params.logArg.endDateTime = nowDate.getTime() + "";
	
							try {
	
								window.parent.window.addClientLogNetWorkErrorData({ id: params.logArg.requestId, data: params.logArg });
	
								if (typeof window.setRpcLog == "function") {
									//httpstatus 不是200
									window.setRpcLog(params.logArg);
								} else if (typeof window.parent.window.setRpcLog == "function") {
									window.parent.window.setRpcLog(params.logArg);
								}
							} catch (error) {}
						}
	
						if (errorHandler != undefined) {
							errorHandler(data);
						} else {
							//根据data统一处理 应该可以获取到相关异常信息
							_Warn2.default.show({ text: "网络链接出问题了喔,请稍后再试" });
						}
					}
				});
	
				/*var xmlhttp = new XMLHttpRequest();
	   xmlhttp.withCredentials = true;
	   
	   xmlhttp.open("POST", url,false);
	   //var oMyForm = new FormData();
	   //oMyForm.append("request",data.request);
	   xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	   xmlhttp.send("request="+data.request);
	   var result = xmlhttp.responseText;
	   var obj = JSON.parse(result);
	   AjaxRemoteUtil.ajaxSuccess(obj);*/
			}
		}, {
			key: 'ajaxPost2',
			value: function ajaxPost2(url, data, resultType, sync, sucessHandler, errorHandler) {
				var successIngnoreStatus = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
				var params = arguments[7];
	
				if (!params.relativeUrl) {
					if (window.urlBase) url = urlBase + url;
				}
				var _headers = {};
				if (params.domain && !params.loginToken && !params.loginDataArea) {
					var _token = localStorage.getItem("userToken");
					if (_token) _headers.token = _token;
				}
				AjaxRemoteUtil.setRemoteDisable(params);
				return $.ajax({
					type: 'post',
					url: url,
					dataType: resultType,
					data: data,
					async: !sync,
					headers: _headers,
					xhrFields: { withCredentials: true },
					success: function success(data) {
						AjaxRemoteUtil.setRemoteEnable(params);
						if (data.compress) {
							var compressedByteArray = base64js.toByteArray(data.result);
							var s = pako.inflate(compressedByteArray, { to: 'string' });
							data.result = JSON.parse(s);
						}
	
						sucessHandler(data, params.domain, params.shortName);
					},
					error: function error(data) {
						AjaxRemoteUtil.setRemoteEnable(params);
						if (errorHandler != undefined) {
							errorHandler(data);
						} else {
							// Warning.show({text:"网络链接出问题了喔,请稍后再试"});
						}
					}
				});
			}
		}, {
			key: 'ajaxSuccess',
			value: function ajaxSuccess(data) {
				$("#loading").css('display', 'none'); //console.log(data);
				if (data.status == 2) {
					var _parentWindow = window.didomain ? window : window.parent.window;
					if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea) {
						if (typeof window.layui.request.loginOut() == 'function') {
							_parentWindow = window;
						} else if (typeof window.parent.window.layui.request.loginOut() == 'function') {
							_parentWindow = window.parent.window;
						} else {
							_parentWindow = window.parent.parent.window;
						}
						_parentWindow.layui.request.loginOut();
						var UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
						_parentWindow.localStorage.removeItem("username");
						_parentWindow.localStorage.removeItem("userId");
						_parentWindow.localStorage.removeItem("permission");
						_parentWindow.localStorage.removeItem("userToken");
						_parentWindow.localStorage.removeItem(UserId_desktopData);
					} else {
						if (window.parent && window.parent.window) {
							window.parent.window.location.href = window.parent.window.loginPath;
						} else {
							window.location.href = loginPath;
						}
					}
				} else if (data.status == 1) {} else if (data.status != 0) {
					alert(data.msg);
				} else {
					sucessHandler(data);
				}
			}
		}, {
			key: 'ajaxSend',
			value: function ajaxSend(url, data, resultType, sync, sucessHandler, errorHandler) {
				var defer = $.Deferred();
				$.ajax({
					type: 'post',
					url: url,
					dataType: resultType,
					data: data,
					async: sync,
					//暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
					xhrFields: { withCredentials: true },
					success: function success(data) {
						defer.resolve(data);
					}
				});
				return defer.promise();
			}
		}, {
			key: 'ajax',
			value: function ajax(type, url, resultType, sync, sucessHandler, errorHandler) {
				if (window.urlBase) url = urlBase + url;
				$("#loading").css('display', 'block');
				//alert(url);
				$.ajax({
					type: type,
					url: url,
					dataType: resultType,
					async: !sync,
					//暂时在跨域请求时强制浏览器携带cookie
					xhrFields: { withCredentials: true },
					success: function success(data) {
						$("#loading").css('display', 'none');
						if (data.status == 2) {
							var _parentWindow = window.didomain ? window : window.parent.window;
							if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea) {
								if (typeof window.layui.request.loginOut() == 'function') {
									_parentWindow = window;
								} else if (typeof window.parent.window.layui.request.loginOut() == 'function') {
									_parentWindow = window.parent.window;
								} else {
									_parentWindow = window.parent.parent.window;
								}
								_parentWindow.layui.request.loginOut();
								var UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
								_parentWindow.localStorage.removeItem("username");
								_parentWindow.localStorage.removeItem("userId");
								_parentWindow.localStorage.removeItem("permission");
								_parentWindow.localStorage.removeItem("userToken");
								_parentWindow.localStorage.removeItem(UserId_desktopData);
							} else {
								// window.location.href=window.loginPath;
							}
						} else {
							sucessHandler(data);
						}
					},
					error: function error(data) {
						$("#loading").css('display', 'none');
						alert(JSON.stringify(data));
						if (errorHandler != undefined) {
							errorHandler(data);
						} else {
							//根据data统一处理 应该可以获取到相关异常信息
						}
					}
				});
			}
		}]);
	
		return AjaxRemoteUtil;
	}();
	
	AjaxRemoteUtil.delay = false;
	AjaxRemoteUtil.tokenNum = 0;
	AjaxRemoteUtil._setProcessID = undefined;
	exports.default = AjaxRemoteUtil;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(4);
	
	var _require = __webpack_require__(29),
	    ExcelColumn = _require.shapes.ExcelColumn;
	
	var EditorForDataGridMix = function EditorForDataGridMix(FormItemEditorForDataGrid) {
	  return function (_FormItemEditorForDat) {
	    _inherits(_class, _FormItemEditorForDat);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'getStyle',
	      value: function getStyle() {
	        return {
	          width: '100%'
	        };
	      }
	    }, {
	      key: 'registerStores',
	      value: function registerStores() {
	        return;
	      }
	    }, {
	      key: 'handleBlurCommit',
	      value: function handleBlurCommit() {
	        if (this.justCommit == true) {
	          this.justCommit = false;return false;
	        }
	        return true;
	      }
	    }, {
	      key: 'onKeyDownHandler',
	      value: function onKeyDownHandler(e) {
	        if (9 === e.keyCode) {
	          e.preventDefault();
	          return true;
	        }
	
	        if (13 == e.keyCode) {
	          /*TODO 这段不知道为什么加上了 暂时先去掉let formId = this.props.formId;
	          let gridId = this.props.gridXml.id;
	          FocusActions.focusSet(formId,gridId,false);*/
	          return true;
	        }
	        //禁用ctrl+A
	        if (e.ctrlKey && e.keyCode == 65) {
	          e.stopPropagation();
	          return true;
	        }
	        _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onKeyDownHandler', this).call(this, e);
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        var updated = {};
	        updated[this.props.column.key] = this.getInputNode().value;
	        return updated;
	      }
	    }, {
	      key: 'getInputNode',
	      value: function getInputNode() {
	        var domNode = ReactDOM.findDOMNode(this);
	        if (domNode.tagName === 'INPUT') {
	          return domNode;
	        }
	
	        return domNode.querySelector('input:not([type=hidden])');
	      }
	    }, {
	      key: 'getRowStyles',
	      value: function getRowStyles() {
	        var menuItemId = this.props.menuItemId;
	        var formId = this.props.formId;
	        var gridId = this.props.gridXml.id;
	        return _FormItemUtil2.default.getControlStyles(menuItemId, formId, gridId);
	      }
	    }, {
	      key: 'inheritContainerStyles',
	      value: function inheritContainerStyles() {
	        return true;
	      }
	    }, {
	      key: 'getRelatedTarget',
	      value: function getRelatedTarget(e) {
	        if (navigator.userAgent.indexOf("Firefox") > 0) if (!e.relatedTarget) if (e.nativeEvent) return e.nativeEvent.explicitOriginalTarget;
	        return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
	      }
	
	      /*FormItemEditorForDataGrid.propTypes = 
	      {
	       onKeyDown: React.PropTypes.func.isRequired,
	       value: React.PropTypes.any.isRequired,
	       onBlur: React.PropTypes.func.isRequired,
	       column: React.PropTypes.shape(ExcelColumn).isRequired,
	       commit: React.PropTypes.func.isRequired
	      }*/
	
	    }]);
	
	    return _class;
	  }(FormItemEditorForDataGrid);
	};
	exports.default = EditorForDataGridMix;

/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ControlPropertyConst = function ControlPropertyConst() {
		_classCallCheck(this, ControlPropertyConst);
	};
	
	ControlPropertyConst.DISPLAYASPASSWORD = "displayAsPassword";
	ControlPropertyConst.IMEENABLE = "imeEnable";
	ControlPropertyConst.PASSWORDFIXEDLENGTH = "passwordFixedLength";
	ControlPropertyConst.CACHEINPUT = "cacheInput";
	ControlPropertyConst.FOCUSINSELECTMODE = "focusInSelectMode";
	ControlPropertyConst.SHOWFIELD = "showField";
	ControlPropertyConst.DISPLAYLENGTH = "displayLength";
	ControlPropertyConst.NOTNULL = "notNull";
	ControlPropertyConst.BACKGROUNDCOLOR = "backgroundColor";
	ControlPropertyConst.BACKGROUNDIMAGE = "backgroundImage";
	ControlPropertyConst.PADDINGLEFT = "paddingLeft";
	ControlPropertyConst.PADDINGRIGHT = "paddingRight";
	ControlPropertyConst.PADDINGTOP = "paddingTop";
	ControlPropertyConst.PADDINGBOTTOM = "paddingBottom";
	ControlPropertyConst.HALIGN = "horizontalAlign";
	ControlPropertyConst.VALIGN = "verticalAlign";
	ControlPropertyConst.HASBORDER = "hasBorder";
	ControlPropertyConst.BORDERWEIGHT = "borderWeight";
	ControlPropertyConst.BORDERCOLOR = "borderColor";
	ControlPropertyConst.SIZE = "size";
	ControlPropertyConst.SIZEMIN = "sizeMin";
	ControlPropertyConst.WIDTH = "width";
	ControlPropertyConst.HEIGHT = "height";
	ControlPropertyConst.SUFFIX = "suffix";
	ControlPropertyConst.WIDTHMIN = "widthMin";
	ControlPropertyConst.HEIGHTMIN = "heightMin";
	ControlPropertyConst.COMPRESS = "compress";
	ControlPropertyConst.NUMOFDECIMALS = "numOfDecimals";
	ControlPropertyConst.SHOWDECIMALS = "showDecimals";
	ControlPropertyConst.FLICKTIME = "flickTime";
	ControlPropertyConst.FONT_SIZE = "fontSize";
	ControlPropertyConst.FONT_WEIGHT = "fontWeight";
	ControlPropertyConst.FONT_COLOR = "color";
	ControlPropertyConst.KEYDOWNEVNET = "KeyDownEvent";
	ControlPropertyConst.ROW_HEIGHT = "rowHeight";
	exports.default = ControlPropertyConst;

/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemDateDisplay = function () {
		function FormItemDateDisplay() {
			_classCallCheck(this, FormItemDateDisplay);
		}
	
		_createClass(FormItemDateDisplay, null, [{
			key: "getDisplayText",
			value: function getDisplayText(value, show1970, seperator, numOfDay, numOfMonth, numOfYear) {
				if (value == null) {
					return "";
				} else if (value == "") {
					return "";
					if (show1970) return "1970-01-01";else return "";
				}
				/*else if(value == "1970-01-01")
	   {
	   	if(show1970 == false)
	   		return "";
	   	else
	   		return value;
	   }*/
				else {
						var array = value.split("");
						var result = "";
						var sep = seperator;
	
						var numDay = numOfDay;
						var day = numDay;
						var numMonth = numOfMonth;
						var month = numMonth;
						var numYear = numOfYear;
						var year = numYear;
						var ptr = array.length - 1;
	
						while (numDay > 0) {
							result = array[ptr] + result;
							//formatString += "D";
							numDay--;
							ptr--;
						}
	
						if (day == 1) {
							var c = array[ptr];
							if (c != "0") result = c + result;
						}
	
						if (month > 0 && day > 0) {
							result = sep + result;
						}
	
						ptr = array.length - 4;
	
						while (numMonth > 0) {
							result = array[ptr] + result;
							numMonth--;
							ptr--;
						}
	
						if (month == 1) {
							c = array[ptr];
							if (c != "0") result = c + result;
						}
	
						if (year > 0 && (day > 0 || month > 0)) {
							result = sep + result;
						}
	
						ptr = array.length - 7;
	
						while (numYear > 0) {
							result = array[ptr] + result;
							numYear--;
							ptr--;
						}
	
						return result;
					}
			}
		}, {
			key: "getDisplayText2",
			value: function getDisplayText2(value, displayFormat) {
				if (!value) return value;
				var date = new Date(value);
				return FormItemDateDisplay.dateFormat2(displayFormat, date); //date.format(displayFormat);
			}
		}, {
			key: "dateFormat2",
			value: function dateFormat2(fmt, date) {
				var o = {
					"M+": date.getMonth() + 1, //月份 
					"D+": date.getDate(), //日 
					"h+": date.getHours(), //小时 
					"m+": date.getMinutes(), //分 
					"s+": date.getSeconds(), //秒 
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
					"S": date.getMilliseconds() //毫秒 
				};
				if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o) {
					if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}return fmt;
			}
		}]);
	
		return FormItemDateDisplay;
	}();
	
	FormItemDateDisplay.defaultSep = "-";
	FormItemDateDisplay.defaultNumOfYear = 4;
	FormItemDateDisplay.defaultNumOfDay = 2;
	FormItemDateDisplay.defaultNumOfMonth = 2;
	exports.default = FormItemDateDisplay;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RegularUtil = __webpack_require__(150);
	
	var _RegularUtil2 = _interopRequireDefault(_RegularUtil);
	
	var _FormItemDecimalResolver = __webpack_require__(63);
	
	var _FormItemDecimalResolver2 = _interopRequireDefault(_FormItemDecimalResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemDecimalDisplay = function () {
		function FormItemDecimalDisplay() {
			_classCallCheck(this, FormItemDecimalDisplay);
		}
	
		_createClass(FormItemDecimalDisplay, null, [{
			key: 'getDisplayText',
			value: function getDisplayText(value, showZero, showDecimals, thousandSeperator) {
				var parms = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
				if (value == null || value != 0 && value == "") {
					return "";
				} else {
	
					return FormItemDecimalDisplay.formatLabel(value, showZero, showDecimals, thousandSeperator, parms);
				}
			}
		}, {
			key: 'formatLabel',
			value: function formatLabel(value, showZero, showDecimals, thousandSeperator) {
				var parms = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	
				var integerPart;
				var decimalPart;
				value = value + "";
				if (Number(value) + "" == "0" && !showZero) return "";
	
				if (value.indexOf(".") != -1) {
					integerPart = value.substring(0, value.indexOf("."));
					decimalPart = value.substring(value.indexOf(".") + 1);
				} else {
					integerPart = value;
					decimalPart = "";
				}
	
				var formattedIntegerPart = FormItemDecimalDisplay.formatInteger(integerPart, thousandSeperator);
				var formattedDecimalPart = FormItemDecimalDisplay.formatDecimalPart(decimalPart, showDecimals);
	
				var suffix = "";var prefix = "";
				if (parms.type == "percent") {
					suffix = "%";
				} else if (parms.type == "prefix") {
					prefix = parms.prefix;
				}
	
				if (typeof formattedDecimalPart == "boolean" && formattedDecimalPart == false) {
					var halfupStr = _FormItemDecimalResolver2.default.getHalfUp(value, value, showDecimals);
					if (thousandSeperator == true && halfupStr) {
						try {
							halfupStr = parseFloat(halfupStr).toLocaleString("en-US");
							if (showDecimals > 0 && halfupStr.indexOf(".") == -1) {
								var tnum = showDecimals;halfupStr += ".";
								while (tnum > 0) {
									halfupStr += "0";
									tnum--;
								}
							}
						} catch (e) {}
					}
					return prefix + halfupStr + suffix;
				}
	
				if (formattedDecimalPart == "") {
					var firstDecimalStr = decimalPart.charAt(0);
					var firstDecimalNum = Number(firstDecimalStr);
					if (firstDecimalNum >= 5) {
						var num;
						if (formattedIntegerPart.charAt(0) == "-") {
							num = Number(formattedIntegerPart.substr(1));
							num++;
							return prefix + "-" + num + suffix;
						} else {
							num = Number(formattedIntegerPart);
							num++;
							return prefix + num + suffix;
						}
					} else {
						return prefix + formattedIntegerPart + suffix;
					}
				} else {
					if (formattedIntegerPart == "") formattedIntegerPart = "0";
					return prefix + formattedIntegerPart + "." + formattedDecimalPart + suffix;
				}
			}
		}, {
			key: 'filtZero',
			value: function filtZero(input) {
				var i = 0;
				var result;
				var flag = Number(input) < 0 ? true : false;
				if (flag) {
					while (input.charAt(i) == "-" || input.charAt(i) == "0") {
						i++;
					}
				} else {
					while (input.charAt(i) == "0") {
						i++;
					}
				}
	
				result = input.substr(i);
	
				if (flag) result = "-" + result;
	
				return result.split("");
			}
		}, {
			key: 'formatDecimalPart',
			value: function formatDecimalPart(value, showDecimals) {
				var decimalNum = showDecimals;
				if (decimalNum == 0) return "";
	
				if (decimalNum < value.length) {
					var end = value.charAt(decimalNum);
					var penult = value.charAt(decimalNum - 1);
					if (Number(end) < 5) {
						value = value.substr(0, decimalNum);
					} else {
						//389.497
						var penultNum = Number(penult) + 1;
						if (penultNum > 9) {
							return false;
							//value = value.substr(0,decimalNum-1) + Number(penult) + 1;
							//value = FormItemDecimalResolver.getHalfUp(value,value,showDecimals);
						} else {
							value = value.substr(0, decimalNum - 1) + penultNum;
						}
					}
				} else {
					while (value.length < decimalNum) {
						value += "0";
					}
				}
	
				return value;
			}
		}, {
			key: 'formatInteger',
			value: function formatInteger(value, thousandSeperator) {
				var chars = [];
	
				if (value == "") return "";
	
				if (!thousandSeperator) {
					return value;
				}
				var negative = Number(value) < 0;
				if (negative) {
					if (value.length < 5) {
						return value;
					} else {
						chars = FormItemDecimalDisplay.filtZero(value);
					}
				} else {
					if (value.length < 4) {
						return value;
					} else {
						chars = FormItemDecimalDisplay.filtZero(value);
					}
				}
	
				if (chars == null) {
					chars = value.split("");
				}
	
				return _RegularUtil2.default.setThounsandSeperator(chars, FormItemDecimalDisplay.THOUSANDSEPERATOR);
			}
		}]);
	
		return FormItemDecimalDisplay;
	}();
	
	FormItemDecimalDisplay.THOUSANDSEPERATOR = ",";
	exports.default = FormItemDecimalDisplay;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormDataSource = __webpack_require__(187);
	
	var _FormDataSource2 = _interopRequireDefault(_FormDataSource);
	
	var _FormDataSourceGroup = __webpack_require__(169);
	
	var _FormDataSourceGroup2 = _interopRequireDefault(_FormDataSourceGroup);
	
	var _FocusStore = __webpack_require__(28);
	
	var _ToolBarUtil = __webpack_require__(68);
	
	var _ToolBarUtil2 = _interopRequireDefault(_ToolBarUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _FormDataSourceGroupLinkType = __webpack_require__(162);
	
	var _FormDataSourceGroupLinkType2 = _interopRequireDefault(_FormDataSourceGroupLinkType);
	
	var _ArgCallerType = __webpack_require__(58);
	
	var _ArgCallerType2 = _interopRequireDefault(_ArgCallerType);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSources = function () {
		_createClass(FormDataSources, null, [{
			key: 'setUserDefaultExportList',
			value: function setUserDefaultExportList(setting, key) {
				var userExportList = window.userExportList ? window.userExportList : window.parent.window.userExportList;
				if (userExportList) {
					userExportList[key] = setting;
					if (setting == null) {
						delete userExportList[key];
					}
				}
			}
		}, {
			key: 'getUserDefaultExportList',
			value: function getUserDefaultExportList(key) {
				var userExportList = window.userExportList ? window.userExportList : window.parent.window.userExportList;
				if (!userExportList) return;
				return userExportList[key];
			}
		}, {
			key: 'updateUserDefaultExportListDupName',
			value: function updateUserDefaultExportListDupName(fileName, key, exportSetting) {
				var userExportList = window.userExportList ? window.userExportList : window.parent.window.userExportList;
				if (!userExportList) return;
				var defaultSetting = userExportList[key];
				var doc = new DOMParser().parseFromString(defaultSetting, "application/xml");
				var mainMsg = doc.getElementsByTagName("nodes")[0];
				if (defaultSetting && mainMsg.attributes.fileName.nodeValue == fileName) {
					userExportList[key] = exportSetting;
				}
			}
		}, {
			key: 'isLinkType',
			value: function isLinkType(value) {
				if (value == "Passive" || value == "Delayed" || value == "Active" || value == "") return true;
				return false;
			}
		}]);
	
		function FormDataSources(xml, formModule) {
			var forLookup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
			_classCallCheck(this, FormDataSources);
	
			this.groups = {};
			this.groupsInited = {};
			this.currentGroup = null;
	
			this.xml = xml;
			this.forLookup = forLookup;
			this.formModule = formModule;
	
			this.firstGroup = null;
			var ds = {};this.sources = ds;
			var datasources = this.xml.DataSources;
			if (datasources.length == 0) return;
			this.sortOnClient = false;
			if (this.xml.Properties.SortOnClient) this.sortOnClient = !(this.xml.Properties.SortOnClient.Value == "false");
			var firstSourceName = datasources[0].name;
			for (var i in datasources) {
				var item = datasources[i];
				var _mid = formModule.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId;
				var _fid = formModule.classAlias == "FormModuleLookup" ? formModule.props.formId : window.formId;
				ds[item.name] = new _FormDataSource2.default(item, _mid, _fid, forLookup);
			}
	
			for (var fdsName in ds) {
				var _fds = ds[fdsName];
				var sourceValue = _fds.xml.Properties.JoinSource.Value;
				if (sourceValue != "") _fds.joinSource = ds[sourceValue];
			}
			this.sources = ds;
	
			for (var dsName in ds) {
				var _fds2 = ds[dsName];
				if (FormDataSources.isLinkType(_fds2.joinType)) {
					var group = new _FormDataSourceGroup2.default(dsName, _fds2, this, forLookup);
					group.sortOnClient = this.sortOnClient;
					_fds2.group = group;
					this.groups[dsName] = group;
					this.groupsInited[dsName] = false;
				}
			}
	
			var flag = true;
			var outFlag = true;
			while (outFlag) {
				flag = true;
				for (var fdsName in ds) {
					var fds = ds[fdsName];
					if (fds.group == null) {
						if (fds.joinSource.group != null) {
							fds.group = fds.joinSource.group;
							fds.group.sources.push(fds);
						} else {
							flag = false;
						}
					}
				}
				if (flag) outFlag = false;
			}
	
			for (var groupName in this.groups) {
				var _group2 = this.groups[groupName];
				if (_group2.mainSource.joinSource != null) {
					_group2.linkGroup = _group2.mainSource.joinSource.group;
				} else {
					_group2.linkGroup = null;
					if (!this.forLookup && window.hasOwnProperty("argCaller") && _group2.allowExternalJoin) {
						var argCaller = window.argCaller;
						if (argCaller.type == "FormModule" && argCaller.joinGroupAlias != "") {
							_group2.externalJoinGroupAlias = argCaller.joinGroupAlias;
							var _parentWindow = window.parent.window;
							_group2.linkGroup = _parentWindow.getJoinGroupObject(_group2.externalJoinGroupAlias, argCaller.calleruuId);
						}
					}
				}
			}
			console.log(this.groups);
			if (firstSourceName != null) {
				this.firstGroup = this.sources[firstSourceName].group;
				if (this.firstGroup && this.formModule.classAlias == "FormModule" && window.argCaller && window.argCaller.enterMainForm) {
					this.firstGroup.flag_enterMainForm = true;
				}
			}
	
			this.currentGroup = null;
	
			this.unsubscribeCurrentGroupSetStore = _FocusStore.CurrentGroupSetStore.listen(this.onCurrentGroupSet.bind(this));
			this.unsubscribeCurrentGroupGetStore = _FocusStore.CurrentGroupGetStore.listen(this.onCurrentGroupGet.bind(this));
		}
	
		_createClass(FormDataSources, [{
			key: 'onCurrentGroupGet',
			value: function onCurrentGroupGet(result) {
				if (result) result.currentGroup = this.currentGroup;
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCurrentGroupSetStore();
				for (var key in this.groups) {
					var group = this.groups[key];
					group.componentWillUnmount();
				}
			}
		}, {
			key: 'onCurrentGroupSet',
			value: function onCurrentGroupSet(groupAlias, formId, focusedId) {
				/*TODO 本来想法是 Warn的弹出 销毁以后 保持弹出前的状态 不重复执行切换Group的动作
	   但是该想法在稍微复杂点的场景下不适用 比如 点击按钮 先弹出了dialog 此时currentGroup可能为空了 再回来 还是要执行currentGroup的切换的
	   也就是说 由于焦点情况比较复杂 而需求又得保证焦点实际位置与内存currentGroup变量的一致性
	   所以只能接受重复设置
	   if(window.testWarnShowedToRemove == true)
	   {
	   	window.testWarnShowedToRemove = false;
	   	return;
	   }*/
				if (this.formModule.classAlias == "FormLookup") return;
				if (this.formModule.formId != formId) return;
	
				if (this.currentGroup != null) {
					var targetGroup;
					if (groupAlias == null || groupAlias == "" || groupAlias == undefined) {
						targetGroup = null;
					} else {
						targetGroup = this.groups[groupAlias];
					}
	
					//console.log("targetGroup:"+targetGroup.groupAlias + "--currentGroup:" + this.currentGroup.groupAlias)
	
					if (this.currentGroup != targetGroup) {
						this.currentGroup.onRecordAutoSave(this.currentGroup.groupAlias);
						if (window.rowChangeAutoSaveFail) return;
						this.currentGroup = targetGroup;
						//存在两种情况需要强制更新toolbar 1.画面刚打开 时序上为先触发currentRecordChanged 再定位焦点 从而设置currentGroup 由于currentRecordChanged更新toolbar时currentGroup为空 所以不更新toolbar
						//2.从某个控件切换到另外一个控件 记录并未自动保存并且更新 需要强制更新toolbar
						//从代码上看Flex版执行了currentRecordChanged所有内容 但是理论上应该是不对的 所以先只执行更新toolbar的操作
						this.updateToolBarByCurrentGroup();
						if (this.currentGroup) this.currentGroup.activeAttachment();
						if (this.currentGroup && this.groupsInited[this.currentGroup.groupAlias] == false) {
							this.groupsInited[this.currentGroup.groupAlias] = true;
							//this.currentGroup.activeCurrentRecord(false,focusedId);
							this.currentGroup.activeRecordRemote();
						}
					}
				} else {
					if (groupAlias != null && groupAlias != "" && groupAlias != undefined) {
						this.currentGroup = this.groups[groupAlias];
						this.updateToolBarByCurrentGroup();
						if (this.currentGroup && this.groupsInited[groupAlias] == false) {
							this.groupsInited[groupAlias] = true;
							this.currentGroup.activeCurrentRecord(false);
						}
					}
				}
				_FocusActions2.default.notifyDataGridCurrentGroup(this.currentGroup ? this.currentGroup.groupAlias : null, this.formModule.instanceUUId);
			}
		}, {
			key: 'updateToolBarByCurrentGroup',
			value: function updateToolBarByCurrentGroup() {
				if (this.currentGroup == null) {
					var _parentWindow = window.parent.window;
					if (_parentWindow) {
						//window.toolBarObject.RecordNew = true;
						//window.toolBarObject.RecordSave = false;
						_ToolBarUtil2.default.setObjectGroupNull(window.toolBarObject);
						if (window.isDataSetView == true) {
							if (window.toolBarObject) {
								window.toolBarObject.Export = true;
							}
						}
						_parentWindow.setToolBar(window.toolBarObject);
						_UtilActions2.default.updateInnerToolBar(window.toolBarObject);
					}
				} else {
					this.currentGroup.activeToolBarByRecord();
				}
			}
		}, {
			key: 'updateLinkGroup',
			value: function updateLinkGroup(sourceGroup, formModuleInstanceuuId) {
				var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
				var updateRelatedPart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
				//此处原因与Timer本身无关 是变量作用域与程序逻辑的问题
				var cache = [];
				var _baseRecord = sourceGroup.currentRecord;
				var _formName = this.formModule.formName;
				//alert(_formName+"1");
				for (var key in this.groups) {
					var group = this.groups[key];
					var externalJoin = window.hasOwnProperty("argCaller") && window.argCaller.type == _ArgCallerType2.default.FormModule && formModuleInstanceuuId == window.argCaller.calleruuId && group.externalJoinGroupAlias == sourceGroup.groupAlias;
					if (group != sourceGroup && (group.linkGroup == sourceGroup || externalJoin) && (group.linkType == _FormDataSourceGroupLinkType2.default.DELAYED || group.linkType == _FormDataSourceGroupLinkType2.default.ACTIVE || group.linkType == _FormDataSourceGroupLinkType2.default.PASSIVE)) {
	
						var _group = group;
	
						//TODO 存在某些情况 新增完表头马上新增明细 如果此处延迟 会造成后台错误  所以如果比如保存完之后 此处activeRecord应该即时更新
						if (!delay) {
							this.callLinkGroup(_group, _baseRecord, sourceGroup, updateRelatedPart);
						} else if (_group.linkType == _FormDataSourceGroupLinkType2.default.DELAYED) {
							//alert(_formName+"2");
							cache.push(_group.groupAlias);
						} else if (_group.linkType == _FormDataSourceGroupLinkType2.default.ACTIVE || _group.linkType == _FormDataSourceGroupLinkType2.default.PASSIVE) {
							this.callLinkGroup(_group, _baseRecord, sourceGroup, updateRelatedPart);
						}
						//group.linkType=="" || "Passive" 不做自动变更
					}
				}
	
				if (cache.length > 0) {
					var _callLinkGroup = this.callLinkGroup.bind(this);
					var _groups = this.groups;
	
					var timerid = setTimeout(function () {
						clearTimeout(timerid);
						for (var i = 0; i < cache.length; i++) {
							var alias = cache[i];
							//GongqiAlert.show(String(cache.length));
							//alert(alias+"  "+_formName);
							_callLinkGroup(_groups[alias], _baseRecord, sourceGroup, updateRelatedPart);
						}
					}, 600);
				}
			}
		}, {
			key: 'callLinkGroup',
			value: function callLinkGroup(group, baseRecord, sourceGroup) {
				var updateRelatedPart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
				if (!group || !sourceGroup) return;
	
				var mainAlias = sourceGroup.mainSource.alias;
				if (sourceGroup.currentRecord != baseRecord) {
					//alert("不相等");
					return;
				}
	
				if (group.formQuery) {
					var joinQueryTable = _QueryUtil2.default.getQueryTableByName(group.formQuery, "Auto_JoinParent");
					if (joinQueryTable) {
						var list = _QueryUtil2.default.getQueryRelationItemByProperty(joinQueryTable, "dataField");
						var s = "";
						for (var i in list) {
							var item = list[i];
							if (!baseRecord) {
								item.Properties.FieldValue.V = "#null#";
							} else {
								var _key = mainAlias + "." + item.dataField;
								if (!baseRecord.hasOwnProperty(_key)) {
									s = "";
								} else {
									s = baseRecord[_key];
								}
								//TODO 如果是数字的 则认为肯定不是空
								if (typeof s == "number" || s != "") item.Properties.FieldValue.V = s;else item.Properties.FieldValue.V = "#null#";
							}
						}
						var formQueryCopy = JSON.parse(JSON.stringify(group.formQuery));
						group.reSetCurrentQuery(formQueryCopy);
						//如Passive 只更新query 不做实际查询
						if (updateRelatedPart) return;
						if (group.linkType != _FormDataSourceGroupLinkType2.default.PASSIVE) group.doLinkActive();
					}
				}
			}
		}]);
	
		return FormDataSources;
	}();
	
	FormDataSources.userExportList = {};
	exports.default = FormDataSources;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandArgFuncUtil = __webpack_require__(148);
	
	var _CommandArgFuncUtil2 = _interopRequireDefault(_CommandArgFuncUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LayerManager = function () {
		function LayerManager() {
			_classCallCheck(this, LayerManager);
		}
	
		_createClass(LayerManager, null, [{
			key: 'executeLayerMethod',
			value: function executeLayerMethod(formModule, group, methodName) {
				var externalArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var layerLevels = _parentWindow.layerLevelConfig;
					//let formModule = this.formDataSources.formModule;
					for (var i = layerLevels.length - 1; i > -1; i--) {
						var layerName = layerLevels[i].name;
						var layerConfig = _parentWindow.layerConfigs[layerName];
						if (layerConfig) {
							var clsName = _CommonUtil2.default.getLayerClassName(formModule.formName, group ? group.mainSource.alias : null);
							if (layerConfig.hasOwnProperty(clsName)) {
								var classConfig = layerConfig[clsName];
								var _cls = classConfig.classDef;
								var cmdResult = void 0;
								var mathodInfo = { fetchOption: true, groups: "all(cr,sr,ar,fq,cq)", editors: "all", joinGroup: "yes" };
								if (typeof _cls == "function") {
									var instance = new _cls();
									var func = instance[methodName];
									if (!func || typeof func != "function") continue;
									var commandArg = _CommandResolver2.default.getSendCmd(formModule, group ? group.groupAlias : null, mathodInfo);
									_CommandArgFuncUtil2.default.bindCommandArgFunc(commandArg);
									if (commandArg) commandArg.contextWindow = window;
									//cmdResult = instance.activeRecord(commandArg);
									cmdResult = func.apply(instance, [commandArg].concat(externalArgs));
								} else if (_typeof(_cls == "Object")) {
									var _instance = _cls;
									var _func = _instance[methodName];
									if (!_func || typeof _func != "function") continue;
									var _commandArg = _CommandResolver2.default.getSendCmd(formModule, group ? group.groupAlias : null, mathodInfo);
									//cmdResult = instance.activeRecord(commandArg);\
									_CommandArgFuncUtil2.default.bindCommandArgFunc(_commandArg);
									if (_commandArg) _commandArg.contextWindow = window;
									cmdResult = _func.apply(_instance, [_commandArg].concat(externalArgs));
								}
								if (typeof cmdResult == "string") return cmdResult;
								if (typeof cmdResult == "boolean") return cmdResult;
								if (cmdResult) {
									_CommandResolver2.default.resolve(cmdResult.tasks, formModule, group);
								}
								break;
							}
						}
					}
				}
			}
		}]);
	
		return LayerManager;
	}();
	
	exports.default = LayerManager;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthorityUtil = function () {
		function AuthorityUtil() {
			_classCallCheck(this, AuthorityUtil);
		}
	
		_createClass(AuthorityUtil, null, [{
			key: 'getXmlType2SCacheItem',
			value: function getXmlType2SCacheItem(menuItemId, innerId, type) {
				var auType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '2';
	
				var result = {};
				var userInfos = window.uesrInfos ? window.userInfos : window.parent.window.userInfos;
				if (userInfos) {
					var userAus = userInfos.userAus;
					if (userAus) {
						var userAu = userAus[menuItemId + "." + innerId];
						if (userAu) {
							var attr = type;
							result["isDefault"] = false;
							result["result"] = userAu[attr] || userAu[attr] == "true";
							result["isForbidden"] = userAu["isForbidden"] || userAu["isForbidden"] == "true";
							return result;
						}
					}
				}
	
				if (menuItemId == "-1") {
					result["isDefault"] = true;result["result"] = true;return result;
				}
				var formNode = AuthorityUtil.xmlType2SCache[menuItemId];
				if (formNode == null) {
					result["isDefault"] = true;result["result"] = true;return result;
				}
	
				var _key = auType + "_" + menuItemId + "." + innerId;
				var singleNode = formNode[_key];
				if (singleNode == null) {
					result["isDefault"] = true;
					result["result"] = true;
					return result;
				}
	
				var attr = type;
				result["isDefault"] = false;
				result["result"] = singleNode[attr] || singleNode[attr] == "true";
				result["isForbidden"] = singleNode["isForbidden"] || singleNode["isForbidden"] == "true";
	
				return result;
			}
		}, {
			key: 'mergeAuthorityList',
			value: function mergeAuthorityList(a) {
				var selfAuthMerge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				if (a == null || a.length == 0) return null;
	
				var xmlType2Cache = {};
				var visible;
				var query;
				var exp;
				var edit;
				var save;
				var _new;
				var del;
				for (var i = 0; i < a.length; i++) {
					var o = a[i];
					var type = o.authorityNodeType;
					var isForbidden = true;
					visible = o.authorityType_Visible;
					if (o.authorityType_Visible && isForbidden) isForbidden = false;
					query = o.authorityType_Query;
					if (o.authorityType_Query && isForbidden) isForbidden = false;
					exp = o.authorityType_Export;
					if (o.authorityType_Export && isForbidden) isForbidden = false;
					edit = o.authorityType_Edit;
					if (o.authorityType_Edit && isForbidden) isForbidden = false;
					save = o.authorityType_Save;
					if (o.authorityType_Save && isForbidden) isForbidden = false;
					_new = o.authorityType_New;
					if (o.authorityType_New && isForbidden) isForbidden = false;
					del = o.authorityType_Delete;
					if (o.authorityType_Delete && isForbidden) isForbidden = false;
					var _key;
	
					if (type == 2 || type == 3) {
						_key = type + "_" + o.authorityMenuItemId + "." + o.authorityFormItemId;
					} else {
						// throw new Error("initFormItemListCache type must be 2 or 3");
						continue;
					}
	
					if (!xmlType2Cache.hasOwnProperty(_key)) {
						var node = {};node.type = type;node.key = _key;node.visible = visible;
						node.query = query;node["exp"] = exp;node.edit = edit;node.save = save;node._new = _new;node.del = del;node.isForbidden = isForbidden;
	
						xmlType2Cache[_key] = node;
					} else {
						if (selfAuthMerge) {
							var node = {};node.type = type;node.key = _key;node.visible = visible;
							node.query = query;node["exp"] = exp;node.edit = edit;node.save = save;node._new = _new;node.del = del;node.isForbidden = isForbidden;
	
							xmlType2Cache[_key] = node;
						} else {
	
							AuthorityUtil.setUniqueKey(xmlType2Cache[_key], visible, query, exp, edit, save, _new, del);
						}
					}
				}
	
				return xmlType2Cache;
			}
		}, {
			key: 'setUniqueKey',
			value: function setUniqueKey(node, visible, query, exp, edit, save, _new, del) {
				if (visible == "true") {
					node.visible = visible;node.isForbidden = false;
				}
				if (query == "true") {
					node.query = query;node.isForbidden = false;
				}
				if (exp == "true") {
					node.exp = exp;node.isForbidden = false;
				}
				if (edit == "true") {
					node.edit = edit;node.isForbidden = false;
				}
				if (save == "true") {
					node.save = save;node.isForbidden = false;
				}
				if (_new == "true") {
					node._new = _new;node.isForbidden = false;
				}
				if (del == "true") {
					node.del = del;node.isForbidden = false;
				}
			}
		}, {
			key: 'setAuthorityMem',
			value: function setAuthorityMem(menuItemId, node) {
				AuthorityUtil.xmlType2SCache[menuItemId] = node;
			}
		}, {
			key: 'setUniqueKey',
			value: function setUniqueKey(node, visible, query, exp, edit, save, _new, del) {
				if (visible == true) {
					node.visible = visible;node.isForbidden = false;
				}
				if (query == true) {
					node.query = query;node.isForbidden = false;
				}
				if (exp == true) {
					node.exp = exp;node.isForbidden = false;
				}
				if (edit == true) {
					node.edit = edit;node.isForbidden = false;
				}
				if (save == true) {
					node.save = save;node.isForbidden = false;
				}
				if (_new == true) {
					node._new = _new;node.isForbidden = false;
				}
				if (del == true) {
					node.del = del;node.isForbidden = false;
				}
			}
		}, {
			key: 'initMenuListCache',
			value: function initMenuListCache(a) {
				var menuItemId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				if (!a) return;
				var xmlType0Cache = {};
				var xmlType1Cache = {};
				var xmlType1OrigCache = {};
				var xmlTypeuserOrigCache = [];
				var visible;
				var query;
				var exp;
				var edit;
				var save;
				var _new;
				var del;
				var userId;
				for (var i = 0; i < a.length; i++) {
					var o = a[i];
					var type = o.authorityNodeType;
					visible = o.authorityType_Visible;
					query = o.authorityType_Query;
					exp = o.authorityType_Export;
					edit = o.authorityType_Edit;
					save = o.authorityType_Save;
					_new = o.authorityType_New;
					del = o.authorityType_Delete;
					if (o.userId) {
						userId = o.userId;
						xmlTypeuserOrigCache.push(o);
					}
					var _key;var item;
					if (type == 0) {
						_key = o.authorityModuleId;
						item = xmlType0Cache[_key];
					} else if (type == 1) {
						_key = o.authorityModuleId + "." + o.authorityMenuItemId;
						item = xmlType1Cache[_key];
					}
	
					var _userGroupId = o.userGroupId;
					if (_userGroupId && !xmlType1OrigCache[_userGroupId]) {
						xmlType1OrigCache[_userGroupId] = {};
					}
	
					var node = {};node.visible = visible;node.query = query;node.exp = exp;node.edit = edit;
					node.save = save;node._new = _new;node.del = del;node.userGroupId = _userGroupId;
					if (_userGroupId) xmlType1OrigCache[_userGroupId][_key] = node;
	
					if (!item || !_userGroupId) {
						if (type == 0) xmlType0Cache[_key] = Object.assign({}, node);else if (type == 1) xmlType1Cache[_key] = Object.assign({}, node);
					} else {
						AuthorityUtil.setUniqueKey(item, visible, query, exp, edit, save, _new, del);
					}
				}
	
				xmlType1OrigCache[userId + "group"] = xmlType1Cache;
				window.xmlType0SCache = AuthorityUtil.xmlType0SCache = xmlType0Cache;
				window.xmlType1SCache = AuthorityUtil.xmlType1SCache = xmlType1Cache;
				window.xmlType1OrigCache = AuthorityUtil.xmlType1OrigCache = xmlType1OrigCache;
				window.xmlTypeuserOrigCache = xmlTypeuserOrigCache;
			}
			//保留没有经过权限合并的原始数据 用于画面权限合并之前判断是否该补全为查询权限 若为单用户组 则该缓存应无用
			//该用户组不含用户权限自动生成的组 用户权限自动生成的组为虚拟组
	
		}, {
			key: 'getXmlType0SCache',
			value: function getXmlType0SCache() {
				if (AuthorityUtil.xmlType0SCache) {
					return AuthorityUtil.xmlType0SCache;
				}
				return window.parent.window.xmlType0SCache;
			}
		}, {
			key: 'getXmlType1SCache',
			value: function getXmlType1SCache() {
				if (AuthorityUtil.xmlType1SCache) {
					return AuthorityUtil.xmlType1SCache;
				}
				return window.parent.window.xmlType1SCache;
			}
		}, {
			key: 'getXmlType1SCacheByUserGroup',
			value: function getXmlType1SCacheByUserGroup(userGroupId) {
				if (AuthorityUtil.xmlType1OrigCache) {
					return AuthorityUtil.xmlType1OrigCache[userGroupId];
				}
				return window.parent.window.xmlType1OrigCache ? window.parent.window.xmlType1OrigCache[userGroupId] : null;
			}
		}, {
			key: 'getAuthorityMenuItemByUserGroup',
			value: function getAuthorityMenuItemByUserGroup(menuItemId, userGroupId) {
				var _parentWindow = window.parent.window;
				var result = { del: false, query: false };
				if (!_parentWindow) return result;
	
				var userInfos = _parentWindow.userInfos || window.userInfos;
				if (!userInfos) return result;
				if (userInfos.isAdmin == true) return { del: true, query: true };
				var node = AuthorityUtil.getXmlType1SCacheByUserGroup(userGroupId);
				// var node =AuthorityUtil.getXmlType1SCache();
				if (!node) {
					//如果没有设置过第二列权限 返回null 调用者在补全画面权限时按合并后的权限补全
					return node;
				}
				var _key = _GOT2.default.INDEP_FORM_ID + "." + menuItemId;
				var userGroupNodeInDep = node[_key];
	
				if (userGroupNodeInDep) {
					if (userGroupNodeInDep.del == true) {
						result["del"] = true;
						result["query"] = true;
					} else if (userGroupNodeInDep.query == true) {
						result["query"] = true;
					}
	
					if (result["del"] == true) return result;
				}
	
				var mainMenu = window.got ? window.got.MainMenu : window.parent.window.got.MainMenu;
				var menuItem = _GOT2.default.descendantsMainMenu(mainMenu, "MenuItem", menuItemId);
	
				if (menuItem) {
					var _key = menuItem.entityId + "." + menuItem.idInMenu;
					var userGroupNode = node[_key];
					if (userGroupNode) {
						if (userGroupNode.del == true) {
							result.del = true;result.query = true;return result;
						} else if (userGroupNode.query == true) {
							result.query = true;return result;
						}
					} else {
						//如果没有设置过第二列权限 返回null 调用者在补全画面权限时按合并后的权限补全
						return userGroupNodeInDep ? result : null;
					}
				}
				//如果没有设置过第二列权限 返回null 调用者在补全画面权限时按合并后的权限补全
				return userGroupNodeInDep ? result : null;
			}
		}, {
			key: 'getAuthorityMenuItem',
			value: function getAuthorityMenuItem(menuItemId) {
				var _parentWindow = window.parent.window;
				var result = { del: false, query: false };
				if (!_parentWindow) return result;
				var userInfos = void 0;
				//zsg 任务系统定制开发
				try {
					userInfos = _parentWindow.userInfos || window.userInfos;
				} catch (e) {
					userInfos = window.userInfos;
				}
	
				if (!userInfos) return result;
				if (userInfos.isAdmin == true) return { del: true, query: true };
	
				var _key = _GOT2.default.INDEP_FORM_ID + "." + menuItemId;
				var node = AuthorityUtil.getXmlType1SCache()[_key];
	
				if (node) {
					if (node.del == true) {
						result["del"] = true;
						result["query"] = true;
					} else if (node.query == true) {
						result["query"] = true;
					}
				}
	
				if (result["del"] == true) return result;
	
				//var menuItems = [];
				var mainMenu = window.got ? window.got.MainMenu : window.parent.window.got.MainMenu;
				var menuItem = _GOT2.default.descendantsMainMenu(mainMenu, "MenuItem", menuItemId);
				//for(var i = 0;i<menuItems.length;i++)
				//{
				//var menuItem = menuItems[i];
				if (menuItem) {
					var _key = menuItem.entityId + "." + menuItem.idInMenu;
					var node = AuthorityUtil.getXmlType1SCache()[_key];
					if (node) {
						if (node.del == true) {
							result.del = true;result.query = true;return result;
						} else if (node.query == true) {
							result.query = true;
						}
					}
				}
				//}
				return result;
			}
		}]);
	
		return AuthorityUtil;
	}();
	
	AuthorityUtil.xmlType2SCache = {};
	exports.default = AuthorityUtil;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                                    value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['splitterResize', 'dividedBoxDidMount', 'mainMenuToggle', 'verticalSplitterResize', 'getSubFieldGroupMaxWidth', 'setSubFieldGroupMaxWidth', 'visibleFalseToTrue', 'groupSlide', 'groupRefersh']);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _FormDataSources = __webpack_require__(50);
	
	var _FormDataSources2 = _interopRequireDefault(_FormDataSources);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _LookupRefreshStore = __webpack_require__(77);
	
	var _LookupRefreshStore2 = _interopRequireDefault(_LookupRefreshStore);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _DomActions = __webpack_require__(86);
	
	var _DomActions2 = _interopRequireDefault(_DomActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(166);
	__webpack_require__(167);
	
	var FormModuleLookup = function (_React$Component) {
	  _inherits(FormModuleLookup, _React$Component);
	
	  function FormModuleLookup(props) {
	    _classCallCheck(this, FormModuleLookup);
	
	    var _this = _possibleConstructorReturn(this, (FormModuleLookup.__proto__ || Object.getPrototypeOf(FormModuleLookup)).call(this, props));
	
	    _this.entityId = props.entityId;
	    _this.innerId = props.innerId;
	    _this.instanceUUId = _CommonUtil2.default.guid();
	    _this.classAlias = "FormModuleLookup";
	    _this.autoReturn = true;
	    //this.formDataSources = new FormDataSources(this.props.xml.FormDataSources,this,true);
	    //console.log(this.formDataSources);
	    _this.formXML = props.xml;
	    _this.formId = _this.props.formId;
	    _this.menuItemId = _this.props.menuItemId;
	    _this.formName = "Form_" + _this.props.xml.name;
	    //new FormDataSources中 要构建FormDataSourceGroup 会反过来找formId menuItemId等基础属性，所以
	    //创建FormDataSources要放在基础属性赋值完毕
	    _this.formDataSources = new _FormDataSources2.default(_this.props.xml.FormDataSources, _this, true);
	    _FormItemUtil2.default.initFormItemControls(_this.props.menuItemId, _this.props.formId, _this.props.xml, _this.props.xml.FormDesign, _this.formDataSources, true);
	
	    _this.unsubscribeLookupCmpStore = _LookupRefreshStore2.default.listen(_this.onDataProviderRefresh.bind(_this));
	
	    var ds = props.xml.FormDataSources;
	    var returnTable = _GOTUtil2.default.getPropertyValue(ds, "ReturnTable");
	    var returnField = _GOTUtil2.default.getPropertyValue(ds, "ReturnField");
	    _this.returnTable = null;_this.fieldName = null;_this.returnField = null;
	    if (returnTable == "" || returnField == "") {
	      _this.autoReturn = false;
	    } else {
	      _this.returnTable = returnTable;
	      _this.fieldName = returnField;
	      _this.returnField = returnTable + "." + returnField.substr(0, 1).toLowerCase() + returnField.substr(1);
	    }
	
	    _this.doLookupRefresh = _this.doLookupRefresh.bind(_this);
	    _this.lookupReturnServer = _this.lookupReturnServer.bind(_this);
	    _this.formLabel = "";
	    _this.contextMap = { remoteClass: "java.util.HashMap" };
	    if (_this.props.isPop) {
	      var helperGroup = _this.formDataSources ? _this.formDataSources.firstGroup : null;
	      var _label = _GOTUtil2.default.getLabelByForm(_this.props.xml, helperGroup, _this.menuItemId);
	      _this.formLabel = _label;
	    }
	    //console.log(FormItemUtil.formItemControls);
	    return _this;
	  }
	
	  _createClass(FormModuleLookup, [{
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var $parent = $("#" + this.formName).parent();
	      var _left = $parent.position().left;
	      var _width = $parent.width();
	      var max_Width = $(window).outerWidth(true);
	      var diff = max_Width - (_left + _width);
	      if (diff < 0) {
	        var newLeft = _left + diff - 10;
	        if (newLeft < 0) newLeft = 0;
	        $parent.css('left', newLeft + 'px');
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("beforeInit", "FormLookup", this.props.formId);
	      //var mi = FormResourceUtil.getCommandArgMethodInfo("afterInit","FormLookup",this.props.formId);
	      if (mi) {
	        if (!this.formDataSources) var group = null;else group = this.formDataSources.firstGroup;
	
	        if (mi.prefetch == true) {
	          if (mi.commandResult) _CommandResolver2.default.resolve(mi.commandResult.tasks, this, group);
	        } else {
	          var arg = _CommandResolver2.default.getSendCmd(this, group == null ? null : group.groupAlias, mi);
	
	          var command = _CommandHelper2.default.createFormInstance(this.formName, "doBeforeInit", "CommandResult");
	          command.appendArg(arg, "CommandArg");
	
	          var fm = this;
	          var remoteArg = { command: command, resultFunction: function resultFunction(data) {
	              _CommandResolver2.default.resolve(data.result.tasks, fm, group);
	            } };
	          _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unsubscribeLookupCmpStore();
	      this.formDataSources.componentWillUnmount();
	    }
	  }, {
	    key: 'addRecord',
	    value: function addRecord() {
	      Actions.addRecord('3333');
	    }
	  }, {
	    key: 'beforeClose',
	    value: function beforeClose() {
	      //let canvas = $(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Canvas")[0];
	      //if(canvas)canvas.scrollTop=0;
	      _DomActions2.default.lookupBeforeClose(this.entityId, this.innerId);
	    }
	  }, {
	    key: 'onDataProviderRefresh',
	    value: function onDataProviderRefresh(entityId, innerId) {
	      if (this.entityId != entityId || this.innerId != innerId) return;
	
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("afterInit", "FormLookup", this.props.formId);
	      if (mi != null) {
	        var group;
	        if (this.formDataSources != null) {
	          group = this.formDataSources.firstGroup;
	        }
	
	        if (mi.prefetch == true) {
	          _CommandResolver2.default.resolve(mi.commandResult.tasks, this);
	        } else {
	
	          var arg = _CommandResolver2.default.getSendCmd(this, group == null ? null : group.groupAlias, mi);
	
	          var command = _CommandHelper2.default.createFormInstance(this.formName, "doAfterInit", "CommandResult");
	          command.appendArg(arg, "CommandArg");
	
	          var fm = this;
	          var remoteArg = { command: command, resultFunction: function resultFunction(data) {
	              if (data && data.result) {
	                _CommandResolver2.default.resolve(data.result.tasks, fm, group);
	              }
	            }, sync: false };
	          _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	        }
	      }
	    }
	
	    //TODO 是否同步 来自命令
	
	  }, {
	    key: 'doLookupRefresh',
	    value: function doLookupRefresh(task) {
	      var _group;
	      if (this.autoReturn == true) {
	        _group = this.formDataSources.groups[this.returnTable];
	        if (!_group && this.formDataSources.sources) {
	          var source = this.formDataSources.sources[this.returnTable];
	          if (source) _group = source.group;
	        }
	      } else {
	        _group = _CommandResolver2.default.getTaskGroup(task, this);
	      }
	
	      var _alias;
	      if (_group) _alias = _group.groupAlias;
	
	      var methodName = "lookupRefresh";
	
	      var argInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, "FormLookup", this.formId);
	      var cmdarg = argInfo == null ? null : _CommandResolver2.default.getSendCmd(this, _group == null ? null : _group.groupAlias, argInfo);
	      var groupAlias;var baseTableName;var baseRecord;var filterFieldName;var baseFilter;
	
	      var queryTable;var dataPaging;var pageSize;var fieldName = this.fieldName;
	
	      if (!_group) {
	        groupAlias = null;
	        queryTable = null;
	        dataPaging = false;
	        pageSize = 0;
	      } else {
	        groupAlias = _group.groupAlias;
	        queryTable = _QueryUtil2.default.convertXML2QueryTable(_group.formQuery);
	        dataPaging = !_group.mainSource.fetchAll;
	        pageSize = _group.dataPageSize;
	      }
	
	      baseTableName = this.lookupArg["baseTableName"];
	      baseRecord = this.lookupArg["baseRecord"];
	      filterFieldName = this.lookupArg["filterFieldName"];
	      baseFilter = this.lookupArg["baseFilter"];
	
	      try {
	        if (_group && filterFieldName && baseFilter && baseFilter.indexOf("*") != -1) {
	          _QueryUtil2.default.findOrCreateWhereItemByField(this.lookupArg["fieldName"], this.lookupArg["fieldName"], queryTable.aliasName, _group.formQuery, baseFilter);
	        }
	        if (_group) {
	          queryTable = _QueryUtil2.default.convertXML2QueryTable(_group.formQuery);
	        }
	      } catch (error) {}
	
	      var command = _CommandHelper2.default.createFormInstance(this.formName, "doLookupRefresh", "Object");
	      command.appendArg(cmdarg, "CommandArg").appendArg(_alias).appendArg(this.fieldName).appendArg(baseTableName).appendArg(baseRecord, "Object").appendArg(filterFieldName).appendArg(baseFilter).appendArg(queryTable, "QueryTable").appendArg(dataPaging, "boolean").appendArg(pageSize, "int");
	      var that = this;
	      var resultFunction = function resultFunction(data) {
	        var obj = data.result;
	        if (!obj) return;
	        if (obj.hasOwnProperty("commandResult")) {
	          var fr = obj;
	          if (fr.commandResult && fr.commandResult.tasks && fr.commandResult.tasks.length > 0) {
	            _CommandResolver2.default.resolve(fr.commandResult.tasks, this);
	          }
	
	          _group.reSetCurrentQuery();
	          _group.rpc_result_executeQuery(data, _group.currentQuery.direction, false);
	        } else if (obj.hasOwnProperty("tasks")) {
	          _CommandResolver2.default.resolve(obj.tasks, that);
	        }
	      };
	      var remoteArg = { command: command, resultFunction: resultFunction };
	      _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //alert($("#app").width() + "   " + $("#app").height());
	      for (var key in this.formDataSources.groups) {
	        var group = this.formDataSources.groups[key];
	        group.initFormQuery();
	        group.initCurrentQuery();
	      }
	    }
	  }, {
	    key: 'findGroupBySourceName',
	    value: function findGroupBySourceName(source) {
	      for (var key in this.formDataSources.groups) {
	        var group = this.formDataSources.groups[key];
	        for (var i = 0; i < group.sources.length; i++) {
	          var ds = group.sources[i];
	          if (ds.alias == source) return group;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'castLookupReturnFields',
	    value: function castLookupReturnFields(returnFields) {
	      for (var i = 0; i < returnFields.length; i++) {
	        var flrf = returnFields[i];
	        var group = this.findGroupBySourceName(flrf.fromGroupAlias);
	        if (!group) group = this.formDataSources.currentGroup;
	        if (!group) group = this.formDataSources.firstGroup;
	        if (!group) continue;
	        var fromRecord = group.currentRecord;
	        var _from = group.groupAlias + "." + _StringUtil2.default.convertToEachFirstLowerCase(flrf.fromDataField);
	        flrf.fromValue = fromRecord[_from];
	      }
	      return returnFields;
	    }
	  }, {
	    key: 'lookupReturnServer',
	    value: function lookupReturnServer(data) {
	      if (!data) return;
	      var obj = data;
	      if (Array.isArray(obj) == true && obj.length > 0) {
	        obj = this.castLookupReturnFields(obj);
	      }
	      _LookupActions2.default.lookupReturn(obj, this.props.entityId, this.props.innerId);
	    }
	  }, {
	    key: 'autoReturnHandler',
	    value: function autoReturnHandler(obj) {
	      //for LookupServerSpecify
	      if (this.returnFields && this.returnFields.length > 0) {
	        var _returnFields = this.castLookupReturnFields(this.returnFields);
	      } else if (this.returnField) {
	        var returnValue = obj[this.returnField];
	        _LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var key = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, "FormDesign");
	      var control = _FormItemUtil2.default.getFormItemControl(key, true);
	      var formItemDesign = control.getComponentInstance(this.props.xml, true, this.formLabel, this.formName, this.props.isPop, this.entityId, this.innerId);
	      return formItemDesign;
	    }
	  }]);
	
	  return FormModuleLookup;
	}(_react2.default.Component);
	
	;
	
	FormModuleLookup.defaultProps = {};
	
	exports.default = FormModuleLookup;

/***/ },
/* 55 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemDateResolver = function () {
		function FormItemDateResolver() {
			_classCallCheck(this, FormItemDateResolver);
		}
	
		_createClass(FormItemDateResolver, null, [{
			key: "getResult_Step1",
	
			//非法值
			value: function getResult_Step1(dateInput) {
				if (dateInput == "" || dateInput == null) {
					return "";
				}
	
				if (dateInput.toLowerCase() == "t" || dateInput == "0") {
					return FormItemDateResolver.dataStyle(new Date());
				}
	
				var length = dateInput.length;
				if (FormItemDateResolver.IsInt(dateInput)) {
					if (dateInput.indexOf("-") != -1) {
						return FormItemDateResolver.convertToDateLenIs8(FormItemDateResolver.returnFormDate(dateInput));
					} else {
						if (length > 8) return "false:格式错误";
					}
					switch (length) {
						case 1:
							{
								return FormItemDateResolver.convertToDateLenIs1(dateInput);
								break;
							}
						case 2:
							{
								return FormItemDateResolver.convertToDateLenIs2(dateInput);
								break;
							}
						case 3:
							{
								return FormItemDateResolver.convertToDateLenIs3(dateInput);
								break;
							}
						case 4:
							{
								return FormItemDateResolver.convertToDateLenIs4(dateInput);
								break;
							}
						case 5:
							{
								return FormItemDateResolver.convertToDateLenIs5(dateInput);
								break;
							}
						case 6:
							{
								return FormItemDateResolver.convertToDateLenIs6(dateInput);
								break;
							}
						case 7:
							{
								return FormItemDateResolver.convertToDateLenIs7(dateInput);
								break;
							}
						case 8:
							{
								return FormItemDateResolver.convertToDateLenIs8(dateInput);
								break;
							}
						default:
							{
								return "false:格式错误";
								//throw new Error("the reg is not correct");
							}
					}
				} else {
	
					return "false:格式错误";
				}
			}
			//defaultValue
	
		}, {
			key: "getResult",
			value: function getResult() {
				var dateInput = arguments[0];
				var result = FormItemDateResolver.getResult_Step1(dateInput);
				if (arguments.length > 0 && arguments[1] == true) {
					if (result == "" || result == "1970-01-01") {
						return "false:不允许空值";
					}
				}
				for (var i in FormItemDateResolver._invalidValues) {
					var invalidValue = FormItemDateResolver._invalidValues[i];
					if (result == invalidValue) {
						return _defaultValue;
					}
				}
	
				return result;
			}
		}, {
			key: "getFullYear",
			value: function getFullYear(year) {
				var fullYear = new Date().getFullYear();
				return (fullYear + "").substr(0, 4 - year.length) + year;
			}
	
			//将输入的--年份补成八位
	
		}, {
			key: "returnFormDate",
			value: function returnFormDate(dateInput) {
				var inputArray = dateInput.split("-");
				var year;
				var month = inputArray[1];
				var day = inputArray[2];
				year = FormItemDateResolver.getFullYear(inputArray[0]);
	
				if (month.length == 1) {
					month = "0" + month;
				}
				if (day.length == 1) {
					day = "0" + day;
				}
				return year + month + day;
			}
	
			//判断字符串是否由数字组成
	
		}, {
			key: "IsInt",
			value: function IsInt(dateInput) {
				var pattern = /^-?\d+$/;
				var patternDate = /^(\d{1,4})(-)?(\d{1,2})\2(\d{1,2})$/;
				var result = pattern.exec(dateInput);
				if (result == null) {
					if (patternDate.exec(dateInput) == null) {
						return false;
					}
				}
				return true;
			}
	
			//1 to 2
	
		}, {
			key: "convertToDateLenIs1",
			value: function convertToDateLenIs1(dateInput) {
	
				return FormItemDateResolver.convertToDateLenIs2("0" + dateInput);
			}
	
			//2 to 4
	
		}, {
			key: "convertToDateLenIs2",
			value: function convertToDateLenIs2(dateInput) {
				var month = new Date().getMonth() + 1;
				if ((month + "").length == 1) {
					month = "0" + month;
				}
				return FormItemDateResolver.convertToDateLenIs4(month + dateInput);
			}
	
			//3 to 4
	
		}, {
			key: "convertToDateLenIs3",
			value: function convertToDateLenIs3(dateInput) {
				return FormItemDateResolver.convertToDateLenIs4("0" + dateInput);
			}
	
			//4 to 8
	
		}, {
			key: "convertToDateLenIs4",
			value: function convertToDateLenIs4(dateInput) {
				var fullYear = new Date().getFullYear();
				return FormItemDateResolver.convertToDateLenIs8(fullYear + dateInput);
			}
	
			// 5 to 8
	
		}, {
			key: "convertToDateLenIs5",
			value: function convertToDateLenIs5(dateInput) {
				var fullYear = new Date().getFullYear();
				return FormItemDateResolver.convertToDateLenIs8((fullYear + "").substr(0, 3) + dateInput);
			}
	
			// 6 to 8
	
		}, {
			key: "convertToDateLenIs6",
			value: function convertToDateLenIs6(dateInput) {
				var fullYear = new Date().getFullYear();
				return FormItemDateResolver.convertToDateLenIs8((fullYear + "").substr(0, 2) + dateInput);
			}
	
			//7 to 8
	
		}, {
			key: "convertToDateLenIs7",
			value: function convertToDateLenIs7(dateInput) {
				return FormItemDateResolver.convertToDateLenIs8("0" + dateInput);
			}
		}, {
			key: "convertToDateLenIs8",
			value: function convertToDateLenIs8(dateInput) {
				var month;
				var day;
				var fullYear = FormItemDateResolver.returnYears(dateInput);
	
				month = parseInt(dateInput.charAt(4) + dateInput.charAt(5));
				day = parseInt(dateInput.substr(6, 7));
	
				if (month > 12) month = 12;
				if (month <= 0) month = 1;
	
				var totalDay = FormItemDateResolver.countDays(month, fullYear);
				if (day > totalDay) {
					day = totalDay;
				}
				if (day <= 0) {
					day = 1;
				}
				var fullYearS = fullYear + "";
				while (fullYearS.length < 4) {
					fullYearS = "0" + fullYearS;
				}
				if (fullYearS == "0000") {
					fullYearS = new Date().getFullYear();
				}
				var months = month + "";
				while (months.length < 2) {
					months = "0" + months;
				}
	
				var days = day + "";
				while (days.length < 2) {
					days = "0" + days;
				}
				return fullYearS + "-" + months + "-" + days;
			}
	
			//TODO format有时不是函数 则采用替代方式 理论上要在原型链上注册自定义的format函数 日期以年月日输出
			/*
	  Date.prototype.Format = function (fmt) { //author: meizz 
	     var o = {
	         "M+": this.getMonth() + 1, //月份 
	         "d+": this.getDate(), //日 
	         "h+": this.getHours(), //小时 
	         "m+": this.getMinutes(), //分 
	         "s+": this.getSeconds(), //秒 
	         "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
	         "S": this.getMilliseconds() //毫秒 
	     };
	     if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	     for (var k in o)
	     if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	     return fmt;
	  }
	  */
	
		}, {
			key: "dataStyle",
			value: function dataStyle(date) {
				if (typeof date.format == "function") {
					return date.format("yyyy-MM-dd");
				} else {
					var isoString = date.toISOString();
					return isoString.split("T")[0];
				}
			}
	
			//计算一个月的天数
	
		}, {
			key: "countDays",
			value: function countDays(month, year) {
	
				var days31 = ['01', '03', '05', '07', '08', '10', '12', '1', '3', '5', '7', '8'];
				var days30 = ['04', '06', '09', '11', '4', '6', '9'];
	
				for (var i = 0; i < days31.length; i++) {
					if (month == Number(days31[i])) {
						return 31;
					}
				}
	
				for (i = 0; i < days30.length; i++) {
					if (month == Number(days30[i])) {
						return 30;
					}
				}
	
				if (month == 2) {
	
					if (year % 400 == 0 || year % 4 == 0 && year % 100 != 0) {
						return 29;
					} else {
						return 28;
					}
				}
				throw new Error("the input is not valid");
			}
	
			//返回年份
	
		}, {
			key: "returnYears",
			value: function returnYears(dateInput) {
				var length = dateInput.length;
				var year;
				var nowYear;
				var _date = FormItemDateResolver.dataStyle(new Date());
				switch (length) {
					case 5:
						{
							year = dateInput.substr(0, 1);
							nowYear = _date.substr(0, 3);
							nowYear = nowYear.concat(year);
							return parseInt(nowYear);
							break;
						}
					case 6:
						{
							year = dateInput.substr(0, 2);
							nowYear = _date.substr(0, 2);
							nowYear = nowYear.concat(year);
							return parseInt(nowYear);
							break;
						}
					case 7:
						{
							year = dateInput.substr(0, 3);
							nowYear = _date.substr(0, 1);
							nowYear = nowYear.concat(year);
							return parseInt(nowYear);
							break;
						}
					case 8:
						{
							year = dateInput.substr(0, 4);
							return parseInt(year);
							break;
						}
					default:
						{
							break;
						}
				}
				return length;
			}
		}]);
	
		return FormItemDateResolver;
	}();
	
	FormItemDateResolver._invalidValues = [];
	FormItemDateResolver._defaultValue = "";
	exports.default = FormItemDateResolver;

/***/ },
/* 56 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryWhereLeftBracket = function () {
		function QueryWhereLeftBracket() {
			_classCallCheck(this, QueryWhereLeftBracket);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryWhereLeftBracket";
		}
	
		_createClass(QueryWhereLeftBracket, null, [{
			key: "valueOf",
			value: function valueOf(value) {
				if (value == "None") return QueryWhereLeftBracket.None;else if (value == "(") return QueryWhereLeftBracket.Bracket1;else if (value == "((") return QueryWhereLeftBracket.Bracket2;else if (value == "(((") return QueryWhereLeftBracket.Bracket3;else if (value == "((((") return QueryWhereLeftBracket.Bracket4;
	
				throw new Error("错误的枚举类型");
			}
		}, {
			key: "labelOf",
			value: function labelOf(value) {
				if (value == QueryWhereLeftBracket.None || value == null) return "None";else if (value == QueryWhereLeftBracket.Bracket1) return "(";else if (value == QueryWhereLeftBracket.Bracket2) return "((";else if (value == QueryWhereLeftBracket.Bracket3) return "(((";else if (value == QueryWhereLeftBracket.Bracket4) return "((((";
	
				throw new Error("错误的枚举类型");
			}
		}]);
	
		return QueryWhereLeftBracket;
	}();
	
	QueryWhereLeftBracket.None = "None";
	QueryWhereLeftBracket.Bracket1 = "Bracket1";
	QueryWhereLeftBracket.Bracket2 = "Bracket2";
	QueryWhereLeftBracket.Bracket3 = "Bracket3";
	QueryWhereLeftBracket.Bracket4 = "Bracket4";
	exports.default = QueryWhereLeftBracket;

/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryWhereRightBracket = function () {
		function QueryWhereRightBracket() {
			_classCallCheck(this, QueryWhereRightBracket);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryWhereRightBracket";
		}
	
		_createClass(QueryWhereRightBracket, null, [{
			key: "valueOf",
			value: function valueOf(value) {
				if (value == "None") return QueryWhereRightBracket.None;else if (value == ")") return QueryWhereRightBracket.Bracket1;else if (value == "))") return QueryWhereRightBracket.Bracket2;else if (value == ")))") return QueryWhereRightBracket.Bracket3;else if (value == "))))") return QueryWhereRightBracket.Bracket4;
	
				throw new Error("错误的枚举类型");
			}
		}, {
			key: "labelOf",
			value: function labelOf(value) {
				if (value == QueryWhereRightBracket.None || value == null) return "None";else if (value == QueryWhereRightBracket.Bracket1) return ")";else if (value == QueryWhereRightBracket.Bracket2) return "))";else if (value == QueryWhereRightBracket.Bracket3) return ")))";else if (value == QueryWhereRightBracket.Bracket4) return "))))";
	
				throw new Error("错误的枚举类型");
			}
		}]);
	
		return QueryWhereRightBracket;
	}();
	
	QueryWhereRightBracket.None = "None";
	QueryWhereRightBracket.Bracket1 = "Bracket1";
	QueryWhereRightBracket.Bracket2 = "Bracket2";
	QueryWhereRightBracket.Bracket3 = "Bracket3";
	QueryWhereRightBracket.Bracket4 = "Bracket4";
	exports.default = QueryWhereRightBracket;

/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArgCallerType = function ArgCallerType() {
		_classCallCheck(this, ArgCallerType);
	};
	
	ArgCallerType.FormModule = "FormModule";
	ArgCallerType.StringEditor = "StringEditor";
	ArgCallerType.MainMenu = "MainMenu";
	ArgCallerType.MainForm = "MainForm";
	exports.default = ArgCallerType;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _ArgCallerType = __webpack_require__(58);
	
	var _ArgCallerType2 = _interopRequireDefault(_ArgCallerType);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormLoadHelper = function () {
		function FormLoadHelper() {
			_classCallCheck(this, FormLoadHelper);
		}
	
		_createClass(FormLoadHelper, null, [{
			key: 'openFormDirectly',
			value: function openFormDirectly(options) {
				var defaults = {
					parm: null,
					fm: null,
					group: null,
					mainTableWhereValues: null,
					callerKey: null,
					paramObject: null,
					popUp: false,
					checkHas: true,
					addJoin: true,
					onlyQuery: false,
					label: ""
				};
				var extendArg = Object.assign(defaults, options);
				if (extendArg.checkHas) {
					var _parentWindow = typeof window.switchToRelatedForm == "function" ? window : window.parent.window;
					if (_parentWindow) {
						var has = _parentWindow.switchToRelatedForm(extendArg.callerKey, window.formModuleInstanceuuId);
						if (has) return;
					}
				}
	
				var formId = defaults.formId;
	
				var argCaller = {};
				argCaller.authorityObject = extendArg.authorityArg;
				if (extendArg.fm) {
					argCaller.type = _ArgCallerType2.default.FormModule;
					argCaller.calleruuId = window.formModuleInstanceuuId;
					argCaller.callerMenuItemId = window.menuItemId;
					argCaller.callerFormId = window.formId;
					argCaller.callerKey = extendArg.callerKey;
					if (extendArg.parm) argCaller.parameters = extendArg.parm;else argCaller.parameters = "";
	
					argCaller.paramObject = extendArg.paramObject;
					argCaller.autoJoinParentArg = extendArg.autoJoinParentArg;
					if (extendArg.addJoin && !extendArg.group) {
						if (extendArg.fm.formDataSources) extendArg.group = extendArg.fm.formDataSources.currentGroup;
					}
	
					if (extendArg.group) {
						argCaller.joinGroupAlias = extendArg.group.mainSource.alias;
					}
				} else {
					argCaller.type = _ArgCallerType2.default.MainMenu;
					if (extendArg.parm) argCaller.parameters = extendArg.parm;else argCaller.parameters = "";
					argCaller.paramObject = extendArg.paramObject;
				}
	
				if (extendArg.mainTableWhereValues) {
					argCaller.enterMainForm = true;
					argCaller.mainTableWhereValues = extendArg.mainTableWhereValues;
					argCaller.callerType = _ArgCallerType2.default.MainForm;
				}
				var _parentWindow = typeof window.openMenuItem == 'function' ? window : window.parent.window;
				if (_parentWindow) {
					if (typeof _parentWindow.openMenuItem == 'function') {
						_parentWindow.openMenuItem({ menuItemId: extendArg.menuItemId, formId: formId, argCaller: argCaller, onlyQuery: extendArg.onlyQuery,
							popUp: extendArg.popUp, label: extendArg.label, fixedUrl: '', manual: extendArg.manual,
							menuItem: extendArg.menuItem, fromMainMenu: extendArg.fromMainMenu });
					}
				}
			}
		}, {
			key: 'openMenuItemByAuthority',
			value: function openMenuItemByAuthority(options) {
				var defaults = {
					parm: null,
					fm: null,
					group: null,
					mainTableWhereValues: null,
					callerKey: null,
					paramObject: null,
					popUp: false,
					checkHas: true,
					addJoin: true,
					onlyQuery: false,
					label: ""
				};
				var extendArg = Object.assign(defaults, options);
				if (extendArg.checkHas) {
					var _parentWindow = typeof window.switchToRelatedForm == "function" ? window : window.parent.window;
					if (_parentWindow) {
						var has = _parentWindow.switchToRelatedForm(extendArg.callerKey, window.formModuleInstanceuuId);
						if (has) return;
					}
				}
				if (extendArg.parm && extendArg.parm.ingnoreAu) {
					FormLoadHelper.openMenuItem(extendArg);
				} else {
					var authorityObject = _AuthorityUtil2.default.getAuthorityMenuItem(extendArg.menuItemId);
					if (authorityObject["query"] == true)
						//if(ClientSessionAuthority.getAuthorityMenuItem(menuItemId)==true)
						{
							if (authorityObject["del"] == false) extendArg.onlyQuery = true;
							FormLoadHelper.openMenuItem(extendArg);
						} else {
						var _formName = extendArg.label;
						if (extendArg.fm) _formName = extendArg.fm.formLabel;
						_Warn2.default.show({ text: "您所在的用户组没有打开该页面的权限<br>页面名称：" + _formName + "<br>菜单项ID：" + extendArg.menuItemId });
					}
				}
			}
		}, {
			key: 'openHtml',
			value: function openHtml(url, params) {
				if (params.indexOf("newwindow=true") != -1 || params.indexOf("newWindow=true") != -1) {
					window.open(url);
					return;
				}
	
				var width, height;
				if (params.indexOf("width=") == -1) {
					params += ",width=800";width = 800;
				} else {
					var reg = new RegExp("(^|,)" + "width" + "=([^,]*)(,|$)");
					var r = params.match(reg);
					if (r != null) {
						width = unescape(r[2]);
					}
				}
				if (params.indexOf("height=") == -1) {
					params += ",height=600";height = 600;
				} else {
					var reg = new RegExp("(^|,)" + "height" + "=([^,]*)(,|$)");
					var r = params.match(reg);
					if (r != null) {
						height = unescape(r[2]);
					}
				}
				if (height != undefined && params.indexOf("top=") == -1) {
					var atop = (screen.availHeight - height) / 2;
					params += ",top=" + atop;
				}
				if (width != undefined && params.indexOf("left=") == -1) {
					var aleft = (screen.availWidth - width) / 2;
					params += ",left=" + aleft;
				}
				if (params.indexOf(",") == 0) params = params.substr(1);
				var name = "";
				if (params.indexOf('name=') != -1) {
					name = params.split('name=')[1];
					name = name.split(",")[0];
				}
				window.open(url, name, params);
			}
		}, {
			key: 'openMenuItem',
			value: function openMenuItem(options) {
				var defaults = {
					menuItemId: "", parm: null, fm: null, group: null, mainTableWhereValues: null, authorityArg: null,
					callerKey: null, paramObject: null, popUp: false, addJoin: true, onlyQuery: false, label: ""
				};
				var extendArg = Object.assign(defaults, options);
				var menuItem = _GOT2.default.getMenuItem(extendArg.menuItemId);
				if (!menuItem) return;
	
				var refPro = menuItem.Properties.RefObject || menuItem.Properties.Source;
				var source = menuItem.Properties.RefObject ? menuItem.Properties.Source.V : menuItem.Properties.SourceType.V;
				if (menuItem.Properties.Popup && menuItem.Properties.Popup.V == "true") extendArg.popUp = true;
	
				var formId = refPro.refentityid;
				var formName = refPro.V;
				var fixedUrl = "";
				if (source == "Html") {
					try {
						if (menuItem.Properties.URL) formName = menuItem.Properties.URL.V;
	
						if (window.didomain && !window.loginToken && !window.loginDataArea) {
							//如果不是http或者https开头
							if (formName.indexOf("http://") != 0 && formName.indexOf("https://") != 0) {
								formName = formName;
							}
						} else {
							if (formName.indexOf("http://") != 0 && formName.indexOf("https://") != 0) {
								//TODO_YL  修正
								//formName = "html/"+formName;	//TODO是否有效URL及安全性问题
								formName = formName;
							}
						}
						var _parentWindow = window.hasOwnProperty("userInfos") ? window : window.parent.window;
						var userInfos = _parentWindow.userInfos;var _key;var onlyQuery = false;
						if (!userInfos.isAdmin) {
							var got = window.got || window.parent.window.got;
							var menuItemInMain = _GOT2.default.getMainMenuMenuItemById(got.MainMenu, menuItem.id);
							if (menuItemInMain) {
								var moduleId = menuItemInMain.entityId;
								if (menuItemInMain.hasOwnProperty("idInMenu")) {
									_key = moduleId + "." + menuItemInMain.idInMenu;
								} else {
									_key = moduleId + "." + menuItemInMain.id;
								}
	
								var aus = _AuthorityUtil2.default.getXmlType1SCache()[_key];
								if (aus && aus.query && aus.del) {
									onlyQuery = true;
								}
							}
						}
	
						var userId = userInfos.userId;
						var userGroups = userInfos.userGroups;
						var htmlsessionobj = { userId: userId, userGroups: userGroups, onlyQuery: onlyQuery };
						var htmlsessionjson = JSON.stringify(htmlsessionobj);
						sessionStorage.setItem(menuItem.id + ".aus", htmlsessionjson);
						var params = menuItem.Properties.Parameters ? menuItem.Properties.Parameters.V : menuItem.Properties.URL.V;
						if (!params) params = "";
						params = _StringUtil2.default.trimThrough(params).toLowerCase();
						FormLoadHelper.openHtml(formName, params);
					} catch (e) {}
					return;
				} else if (source == "Report") {
					if (window.menuItemToUrl && window.menuItemToUrl.hasOwnProperty(extendArg.menuItemId)) {
						fixedUrl = window.menuItemToUrl[extendArg.menuItemId];
					}
				}
	
				var argCaller = {};
				argCaller.authorityObject = extendArg.authorityArg;
				if (extendArg.fm) {
					argCaller.type = _ArgCallerType2.default.FormModule;
					argCaller.calleruuId = window.formModuleInstanceuuId;
					argCaller.callerMenuItemId = window.menuItemId;
					argCaller.callerFormId = window.formId;
					argCaller.callerKey = extendArg.callerKey;
					argCaller.commandArgInfo = extendArg.commandArgInfo;
					if (!extendArg.parm) argCaller.parameters = menuItem.Properties.Parameters ? menuItem.Properties.Parameters.V : menuItem.Properties.URL.V;else argCaller.parameters = extendArg.parm;
	
					argCaller.paramObject = extendArg.paramObject;
					argCaller.autoJoinParentArg = extendArg.autoJoinParentArg;
					if (extendArg.addJoin && !extendArg.group) {
						if (extendArg.fm.formDataSources) extendArg.group = extendArg.fm.formDataSources.currentGroup;
					}
	
					if (extendArg.group) {
						//argCaller.joinGroup = group;
						argCaller.joinGroupAlias = extendArg.group.mainSource.alias;
					}
				} else {
					argCaller.type = _ArgCallerType2.default.MainMenu;
					var parameters;
					if (!extendArg.parm) argCaller.parameters = menuItem.Properties.Parameters ? menuItem.Properties.Parameters.V : menuItem.Properties.URL.V;else argCaller.parameters = extendArg.parm;
	
					argCaller.paramObject = extendArg.paramObject;
				}
	
				if (extendArg.mainTableWhereValues) {
					argCaller.enterMainForm = true;
					argCaller.mainTableWhereValues = extendArg.mainTableWhereValues;
					argCaller.callerType = _ArgCallerType2.default.MainForm;
				}
				var _parentWindow = typeof window.openMenuItem == 'function' ? window : window.parent.window;
				if (menuItem.name == "SysAuthoritySetup")
					//if(menuItem.Properties.LoadType && menuItem.Properties.LoadType == "Manual")
					{
						extendArg.manual = true;extendArg.menuItem = menuItem;extendArg.popUp = true;
						if (!_parentWindow.manualArgs) _parentWindow.manualArgs = {};
						var key = extendArg.menuItemId;
						_parentWindow.manualArgs[key] = extendArg.commandArg;
					}
				//window.openMenuItem(extendArg.menuItemId,formId,argCaller,extendArg.onlyQuery,extendArg.popUp,extendArg.label,fixedUrl);
	
				if (_parentWindow) {
					if (typeof _parentWindow.openMenuItem == 'function') {
						_parentWindow.openMenuItem({ menuItemId: extendArg.menuItemId, formId: formId, argCaller: argCaller, onlyQuery: extendArg.onlyQuery,
							popUp: extendArg.popUp, label: extendArg.label, fixedUrl: fixedUrl, manual: extendArg.manual,
							menuItem: extendArg.menuItem, fromMainMenu: extendArg.fromMainMenu });
					}
				}
				var _parentWindow2 = typeof window.setOperate == 'function' ? window : window.parent.window;
				if (_parentWindow2.setOperate) {
					var remark = { 'title': '打开画面', "menuItemId": menuItem['id'] };
					var data = {
						'dataArea': 'dynamic',
						'userId': _parentWindow2.userInfos.userId,
						'userName': _parentWindow2.userInfos.userName,
						'clientSessionId': _parentWindow2.userInfos.userSessionId,
						'dateTime': new Date().getTime() + '',
						'operationId': '001',
						'formId': formId,
						'formDataSourceName': '',
						'formItemName': '',
						'remark': JSON.stringify(remark)
					};
					_parentWindow2.setOperate(data);
				}
			}
		}]);
	
		return FormLoadHelper;
	}();
	
	exports.default = FormLoadHelper;

/***/ },
/* 60 */,
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemTimeResolver = function () {
		function FormItemTimeResolver() {
			_classCallCheck(this, FormItemTimeResolver);
		}
	
		_createClass(FormItemTimeResolver, null, [{
			key: "IsNum",
	
	
			//判断字符串是否由数字组成且符合时间格式
			value: function IsNum(dateInput) {
				var patternNum = /^-?\d+$/;
				var patternTime = /^(\d{1,2})(:)?(\d{1,2})\2(\d{1,2})$/;
				var result = patternNum.exec(dateInput);
				if (result == null) {
					if (patternTime.exec(dateInput) == null) {
						return false;
					}
				}
				return true;
			}
	
			//		输入字符串的长度为0
	
		}, {
			key: "convertToDateLenIsNull",
			value: function convertToDateLenIsNull() {
				var date = new Date();
				return FormItemTimeResolver.dataStyle(date);
			}
	
			//如果用户输入字符串长度为1&2
	
		}, {
			key: "convertToDateLenIs1",
			value: function convertToDateLenIs1(dateInput) {
				var today = new Date();
				var date = parseInt(dateInput);
	
				if (date <= 23 && date >= 0) {
					today.setHours(date);
					today.setSeconds(0);
					today.setMinutes(0);
				} else {
					today.setHours(0);
					today.setMinutes(0);
					today.setSeconds(0);
				}
	
				return FormItemTimeResolver.dataStyle(today);
			}
			//		输入字符串的长度为3&4
	
		}, {
			key: "convertToDateLenIs4",
			value: function convertToDateLenIs4(dateInput) {
				var _date = new Date();
				var hour;
				var day;
				if (dateInput.length == 3) dateInput = "0" + dateInput;
	
				hour = parseInt(dateInput.charAt(0) + dateInput.charAt(1));
				day = parseInt(dateInput.charAt(2) + dateInput.charAt(3));
	
				if (hour <= 23 && hour >= 0) {
					_date.setHours(hour);
				} else {
					_date.setHours(0);
				}
				if (day >= 0 && day < 59) {
					_date.setMinutes(day);
				} else {
					_date.setMinutes(59);
				}
	
				_date.setSeconds(0);
	
				return FormItemTimeResolver.dataStyle(_date);
			}
	
			//若果用户输入5&6个字符
	
		}, {
			key: "convertToDateLenIs6",
			value: function convertToDateLenIs6(dateInput) {
				var dateOutput = new Date();
				var hour;
				var min;
				var seconds;
	
				if (dateInput.length == 5) dateInput = "0" + dateInput;
	
				hour = parseInt(dateInput.charAt(0) + dateInput.charAt(1)); //hours
				min = parseInt(dateInput.charAt(2) + dateInput.charAt(3)); //minutes
				seconds = parseInt(dateInput.charAt(4) + dateInput.charAt(5)); //seconds
	
				if (hour <= 23 && hour >= 0) {
					dateOutput.setHours(hour);
				} else {
					dateOutput.setHours(0);
				}
				if (min >= 0 && min <= 59) {
					dateOutput.setMinutes(min);
				} else {
					dateOutput.setMinutes(59);
				}
				if (seconds >= 0 && seconds <= 59) {
					dateOutput.setSeconds(seconds);
				} else {
					dateOutput.setSeconds(59);
				}
	
				return FormItemTimeResolver.dataStyle(dateOutput);
			}
	
			//日期以HHNNSS输出
	
		}, {
			key: "dataStyle",
			value: function dataStyle(date) {
				return date.format(FormItemTimeResolver.TIMEFORMATSTRING);
			}
		}, {
			key: "getFormattedTime",
			value: function getFormattedTime(_time) {
				var array = _time.split(":");
				var hour = array[0];
				var min = array[1];
				var second = array[2];
	
				if (hour.length == 1) hour = "0" + hour;
	
				if (min.length == 1) min = "0" + min;
	
				if (second.length == 1) second = "0" + second;
	
				return hour + min + second;
			}
	
			//对用户输入的时间进行验证
	
		}, {
			key: "getResult",
			value: function getResult() {
				var timeInput = arguments[0];
				if (timeInput.indexOf('.') != -1) {
					timeInput = timeInput.substr(0, timeInput.indexOf('.')).trim();
				}
				var notnull = arguments[1];
				if (timeInput == "") {
					if (notnull) return "false:不允许为空";else return timeInput;
				}
	
				if (timeInput == "t") {
					return FormItemTimeResolver.dataStyle(new Date());
				}
	
				var length = timeInput.length;
	
				if (FormItemTimeResolver.IsNum(timeInput)) {
					if (timeInput.indexOf(":") != -1) {
						return FormItemTimeResolver.convertToDateLenIs6(FormItemTimeResolver.getFormattedTime(timeInput));
					} else {
						if (length > 6) return "false:长度不能超过8位";
					}
	
					switch (length) {
						case 1:
							{
								return FormItemTimeResolver.convertToDateLenIs1(timeInput);
								break;
							}
						case 2:
							{
								return FormItemTimeResolver.convertToDateLenIs1(timeInput);
								break;
							}
						case 3:
							{
								return FormItemTimeResolver.convertToDateLenIs4(timeInput);
								break;
							}
						case 4:
							{
								return FormItemTimeResolver.convertToDateLenIs4(timeInput);
								break;
							}
						case 5:
							{
								return FormItemTimeResolver.convertToDateLenIs6(timeInput);
								break;
							}
						case 6:
							{
								return FormItemTimeResolver.convertToDateLenIs6(timeInput);
								break;
							}
						default:
							{
								return FormItemTimeResolver.convertToDateLenIsNull();
								break;
							}
					}
				}
				/*else
	   {
	   	if(timeInput=="")
	   		return "00:00:00";
	   }
	   return "false:not valid!";*/
				return "false:格式有误";
			}
		}]);
	
		return FormItemTimeResolver;
	}();
	
	FormItemTimeResolver.TIMEFORMATSTRING = "hh:mm:ss";
	exports.default = FormItemTimeResolver;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _PropertyValueType = __webpack_require__(287);
	
	var _PropertyValueType2 = _interopRequireDefault(_PropertyValueType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GOTPropertiesUtil = function () {
		function GOTPropertiesUtil() {
			_classCallCheck(this, GOTPropertiesUtil);
		}
	
		_createClass(GOTPropertiesUtil, null, [{
			key: 'getItemPropertyFinalValue',
	
			//TODO全局初始化时 已清除？
			value: function getItemPropertyFinalValue(menuItemId, entityId, innerId, entity) {
				var _key = _FormItemUtil2.default.getFormStoresKey(menuItemId, entityId);
				var formStore = window.parent.window[_key];
				var hasPart = false;
				if (formStore) {
					hasPart = true;
					var _properties = formStore.mapItemProperty[entityId + "_" + innerId];
					if (_properties) return _properties;
				}
				var item = _GOTUtil2.default.getItemXML(entityId, innerId);
				var properties = GOTPropertiesUtil.createNoFormPropertiesObject(item, entityId, innerId, entity);
				if (hasPart) {
					formStore.mapItemProperty[entityId + "_" + innerId] = properties;
				} else {
					var mapItemProperty = {};
					mapItemProperty[entityId + "_" + innerId] = properties;
					window.parent.window[_key] = { mapItemProperty: mapItemProperty };
				}
	
				return properties;
			}
		}, {
			key: 'setPropertyValue',
			value: function setPropertyValue(item, propertyName, properties, entity) {
				var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
				var defaultValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
	
				if (properties.hasOwnProperty(propertyName)) return properties[propertyName];
	
				if (type == _PropertyValueType2.default.PROPERTY_XML) {
					var xml = _GOTUtil2.default.getProperty(item, propertyName);
					if (!xml) {
						properties[propertyName] = xml;
						return properties[propertyName];
					} else {
						return null;
					}
				}
	
				var name = item.name;
				if (name == "ReportField" || name == "Report" || name == "ReportQuery") value = _GOTUtil2.default.getReprotFinalValue(item, propertyName);else var value = _GOTUtil2.default.getFinalValue(item, entity, propertyName);
	
				if (value != null) {
					if (value == "") {
						if (defaultValue != undefined) {
							properties[propertyName] = defaultValue;
							return properties[propertyName];
						}
					}
	
					switch (type) {
						case _PropertyValueType2.default.STRING:
							properties[propertyName] = value;
							break;
						case _PropertyValueType2.default.BOOLEAN:
							properties[propertyName] = value == "true" ? true : false;
							break;
						case _PropertyValueType2.default.INT:
							properties[propertyName] = parseInt(value == "" ? "0" : value);
							break;
						default:
							throw new Error("undefined PropertyValueType");
					}
	
					return properties[propertyName];
				} else {
					return null;
				}
			}
		}, {
			key: 'createNoFormPropertiesObject',
			value: function createNoFormPropertiesObject(item, entityId, innerId, entity) {
				if (!item) return null;
	
				var itemName = item.qname;
				var itemType;
				if (item.hasOwnProperty("type")) {
					itemType = item.type;
				}
	
				var propertyName;
				var properties = {};
				if (["String", "Long", "Decimal", "Date", "Time", "Boolean", "Enum"].indexOf(itemType) != -1) {
					propertyName = "Alignment";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "Regular";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "NotNull";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "AllowEdit";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "AllowEditOnCreate";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "Default";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "SkipTab";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "DisplayHeight";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT, 1);
	
					propertyName = "DisplayLength";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT);
	
					propertyName = "Label";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
				}
	
				if (itemType == "Date") {
					propertyName = "Seperator";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.STRING, "-");
	
					propertyName = "NumOfYear";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT, 4);
	
					propertyName = "NumOfMonth";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT, 2);
	
					propertyName = "NumOfDay";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT, 2);
	
					propertyName = "Show1970";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN, false);
				}
	
				if (itemType == "Long" || itemType == "Decimal") {
					propertyName = "ShowZero";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "ThousandSeperator";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "AllowNegative";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
				}
	
				if (itemType == "Decimal") {
					propertyName = "NumOfDecimals";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT, 2);
	
					propertyName = "ShowDecimals";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT);
	
					propertyName = "RoundOff";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "ThousandSeperator";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "AllowNegative";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "ShowZero";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
				}
	
				if (itemType == "String") {
					propertyName = "StringSize";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT, 32);
	
					propertyName = "Trim";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "ChangeCase";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "FormLookup";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					if (itemType == "StringEditor") {
						propertyName = "ReturnLookup";
						GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
						//propertyName = "ValidateLookup";
						//GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
					}
				}
	
				if (itemType == "Time") {
					propertyName = "ShowHour";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "ShowMinute";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
	
					propertyName = "ShowSecond";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.BOOLEAN);
				}
	
				var dataProvider;
				if (itemType == "Enum") {
					if (itemName == "TableField") {
						dataProvider = _GOTUtil2.default.getDataSourceByTableField(item);
					} else if (itemName == "ReportField") {
						dataProvider = _GOTUtil2.default.getDataSourceByReportField(item);
					} else {
						dataProvider = _GOTUtil2.default.getDataSourceByDataType({ refentityid: item.id });
					}
	
					properties["DataProvider"] = dataProvider;
				}
	
				if (itemName == "Enum") {
					dataProvider = _GOTUtil2.default.getDataSourceByEnum({ refentityid: item.id });
					properties["DataProvider"] = dataProvider;
	
					propertyName = "Label";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "HelpText";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity);
	
					propertyName = "DisplayLength";
					GOTPropertiesUtil.setPropertyValue(item, propertyName, properties, entity, _PropertyValueType2.default.INT);
				}
	
				return properties;
			}
		}]);
	
		return GOTPropertiesUtil;
	}();
	
	exports.default = GOTPropertiesUtil;

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemDecimalResolver = function () {
		function FormItemDecimalResolver() {
			_classCallCheck(this, FormItemDecimalResolver);
		}
	
		_createClass(FormItemDecimalResolver, null, [{
			key: "getInstance",
			value: function getInstance() {
				if (FormItemDecimalResolver.resolverInstance == null) FormItemDecimalResolver.resolverInstance = new FormItemDecimalResolver();
				return resolverInstance;
			}
		}, {
			key: "filtZero",
			value: function filtZero(value) {
				var index = 0;
				var isNegtive = false;
				if (value.charAt(index) == "-") {
					index++;
					isNegtive = true;
				}
				while (value.charAt(index) == "0" && value.charAt(index + 1) != ".") {
					index++;
				}
				return isNegtive ? "-" + value.substr(index) : value.substr(index);
			}
		}, {
			key: "getResult",
			value: function getResult() {
				var value = arguments[0];
				var reg1 = /^-0+$/;
				var reg2 = /^0+$/;
				var numOfDecimals = parseInt(arguments[3]);
				if (isNaN(numOfDecimals)) throw new Error("小数位数在FormItem中为不合法的非数字");
				if (value == "") value = "0";
				if (typeof value == "number") {
					value = value + "";
				}
				var temp = value.charAt(0) == "-" ? value.substr(1) : value;
				var maxprecision = 15 - temp.split(".")[0].length;
				if (maxprecision < numOfDecimals) return "false:超过支持精度";
	
				var notNull = arguments[1];
				if (reg1.exec(value) != null || reg2.exec(value) != null) {
					if (notNull == true) return "false:不允许空值";
					var result = "0";
					var numOfDecimalsCopy = numOfDecimals;
					if (numOfDecimalsCopy > 0) result += ".";
					while (numOfDecimalsCopy != 0) {
						result += "0";
						numOfDecimalsCopy--;
					}
					return result;
				}
	
				var allowNegative = arguments[2];
				//var numOfDecimals:uint = args[2] as uint;
				var roundOff = arguments[4];
				var regu = /^(\-|\+)?\d+(\.\d+)?$/;
				if (regu.test(value)) {
					if (value.indexOf(".") != -1) {
						if (value.charAt(0) == ".") value = "0" + value;else if (value.charAt(1) == "." && (value.charAt(0) == "-" || value.charAt(0) == "+")) value = value.charAt(0) + "0" + value.substr(1);
	
						if (Number(value) == 0 && notNull == true) return "false:不允许空值";
	
						var chars = value.split(".")[1];
	
						if (Number(value) < 0 && !allowNegative) {
							value = Math.abs(Number(value)) + "";
							if (value.indexOf(".") == -1) value += "." + chars;
						}
	
						while (chars.length < numOfDecimals) {
							value += "0";
							chars = value.split(".")[1];
						}
	
						if (chars.length == numOfDecimals) {
							//return String(parseFloat(value));
							return FormItemDecimalResolver.filtZero(value);
						}
	
						if (chars.length > numOfDecimals) {
							if (roundOff == FormItemDecimalResolver.ROUNOFF_UP) {
								return FormItemDecimalResolver.getUp(value, chars, numOfDecimals);
							}
	
							if (roundOff == FormItemDecimalResolver.ROUNOFF_DOWN) {
								return FormItemDecimalResolver.getDown(value, chars, numOfDecimals);
							}
	
							if (roundOff == FormItemDecimalResolver.ROUNOFF_HALFDOWN) {
								return FormItemDecimalResolver.getHalfDown(value, chars, numOfDecimals);
							}
	
							if (roundOff == FormItemDecimalResolver.ROUNOFF_HALFUP) {
								return FormItemDecimalResolver.getHalfUp(value, chars, numOfDecimals);
							}
	
							if (roundOff == FormItemDecimalResolver.ROUNOFF_HALFEVEN) {
								return FormItemDecimalResolver.getHalfEven(value, chars, numOfDecimals);
							}
	
							if (roundOff == FormItemDecimalResolver.ROUNOFF_CEILING) {
								return FormItemDecimalResolver.getCeiling(value, chars, numOfDecimals);
							}
	
							if (roundOff == FormItemDecimalResolver.ROUNOFF_FLOOR) {
								return FormItemDecimalResolver.getFloor(value, chars, numOfDecimals);
							} else {
								return FormItemDecimalResolver.getUnNecessary(value, chars, numOfDecimals);
							}
						}
					} else {
						value = FormItemDecimalResolver.filtZero(value);
						if (Number(value) == 0 && notNull == true) return "false:不允许空值";
						if (Number(value) < 0 && !allowNegative) {
							value = value.substr(1);
						}
						if (numOfDecimals > 0) {
							var i = 0;
							value += ".";
							while (i < numOfDecimals) {
								value += "0";
								i++;
							}
						}
						return value;
					}
				} else {
					return "false:不是有效的小数格式";
				}
	
				throw new Error("decimal validate");
			}
		}, {
			key: "getUp",
			value: function getUp(value, chars, numOfDecimals) {
				var temp;
				value = FormItemDecimalResolver.filtZero(value);
				if (chars.length == 1 || numOfDecimals == 0) {
					var endChar = value.split(".")[0].substr(-1);
					temp = endChar;
					temp++;
					endChar = temp;
					value = value.split(".")[0];
					var result = value.substr(0, value.length - 1) + endChar;
					return result;
				} else {
					endChar = chars.charAt(numOfDecimals - 1);
					temp = endChar;
					temp++;
	
					endChar = temp;
					chars = chars.substr(0, numOfDecimals - 1) + endChar;
					result = value.split(".")[0] + "." + chars;
					return result;
				}
			}
		}, {
			key: "getDown",
			value: function getDown(value, chars, numOfDecimals) {
				value = FormItemDecimalResolver.filtZero(value);
				if (chars.length == 1 || numOfDecimals == 0) {
					return value.split(".")[0];
				} else {
					chars = chars.substr(0, numOfDecimals);
					return value.split(".")[0] + "." + chars;
				}
			}
		}, {
			key: "getHalfDown",
			value: function getHalfDown(value, chars, numOfDecimals) {
				if (numOfDecimals == 0) {
					endChar = value.charAt(value.indexOf(".") + 1);
				} else {
					var endChar = chars.charAt(numOfDecimals);
				}
	
				if (endChar == "5") {
					return FormItemDecimalResolver.getDown(value, chars, numOfDecimals);
				} else {
					return FormItemDecimalResolver.getHalfUp(value, chars, numOfDecimals);
				}
			}
		}, {
			key: "getHalfUp",
			value: function getHalfUp(value, chars, numOfDecimals) {
				var temp = 1;
				var i = numOfDecimals;
				while (i > 0) {
					temp = temp * 10;
					i--;
				}
				if (typeof value == "string") {
					value = parseFloat(value);
				}
				var valueTemp = value * temp + 0.0000000001;
				var roundValueTemp = Math.round(valueTemp);
				var result = roundValueTemp / temp + "";
				if (numOfDecimals > 0 && result.indexOf(".") != -1) {
					var endChars = result.substring(result.indexOf(".") + 1, result.length);
					while (endChars.length < numOfDecimals) {
						endChars += "0";
						result += '0';
						numOfDecimals--;
					}
				}
				// 当保留2位小数 入 0.998 时  只显示1  TODO_YL 修正
				if (numOfDecimals > 0 && result.indexOf(".") == -1) {
					var zeor = ".";
					for (var _i = 0; _i < numOfDecimals; _i++) {
						zeor = zeor + "0";
					}
					result = result + zeor;
				}
	
				return result;
	
				value = FormItemDecimalResolver.filtZero(value);
	
				if (numOfDecimals == 0) {
					var endChar = value.charAt(value.indexOf(".") + 1);
				} else {
					endChar = chars.charAt(numOfDecimals);
				}
	
				if (endChar == "5") {
					return FormItemDecimalResolver.getUp(value, chars, numOfDecimals);
				} else {
					var num = Number(value);
	
					return num.toFixed(numOfDecimals);
				}
			}
		}, {
			key: "getHalfEven",
			value: function getHalfEven(value, chars, numOfDecimals) {
				//保证numOfDecimals<chars.length
				if (numOfDecimals == 0) {
					var endChar = value.charAt(value.indexOf(".") - 1);
				} else {
					endChar = chars.charAt(numOfDecimals - 1);
				}
				var num = Number(endChar);
				if (num % 2 == 0) {
					return FormItemDecimalResolver.getHalfDown(value, chars, numOfDecimals);
				} else {
					return FormItemDecimalResolver.getHalfUp(value, chars, numOfDecimals);
				}
			}
		}, {
			key: "getCeiling",
			value: function getCeiling(value, chars, numOfDecimals) {
				//value = filtZero(value);
				var num = Number(value);
				if (num < 0) {
					return FormItemDecimalResolver.getDown(value, chars, numOfDecimals);
				} else {
					return FormItemDecimalResolver.getUp(value, chars, numOfDecimals);
				}
			}
		}, {
			key: "getFloor",
			value: function getFloor(value, chars, numOfDecimals) {
				//value = filtZero(value);
				var num = Number(value);
				if (num < 0) {
					return FormItemDecimalResolver.getUp(value, chars, numOfDecimals);
				} else {
					return FormItemDecimalResolver.getDown(value, chars, numOfDecimals);
				}
			}
		}, {
			key: "getUnNecessary",
			value: function getUnNecessary(value, chars, numOfDecimals) {
				if (chars.length > numOfDecimals) {
					chars = chars.substr(0, numOfDecimals);
				}
	
				return value.split(".")[0] + chars;
			}
		}]);
	
		return FormItemDecimalResolver;
	}();
	
	FormItemDecimalResolver.ROUNOFF_HALFUP = "HalfUp";
	FormItemDecimalResolver.ROUNOFF_HALFDOWN = "HalfDown";
	FormItemDecimalResolver.ROUNOFF_UP = "Up";
	FormItemDecimalResolver.ROUNOFF_DOWN = "Down";
	FormItemDecimalResolver.ROUNOFF_CEILING = "Ceiling";
	FormItemDecimalResolver.ROUNOFF_FLOOR = "Floor";
	FormItemDecimalResolver.ROUNOFF_HALFEVEN = "HalfEven";
	exports.default = FormItemDecimalResolver;

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecordsUtil = function () {
	  function RecordsUtil() {
	    _classCallCheck(this, RecordsUtil);
	  }
	
	  _createClass(RecordsUtil, null, [{
	    key: "getOneLevelDatas",
	    value: function getOneLevelDatas(formDataSourceGroupResult, groupAlias) {
	      var dataResult = formDataSourceGroupResult.dataResult;
	      var isArray = Array.isArray(dataResult);
	      var finalDatas = [];
	      var proKey = void 0;
	      var now = new Date().getTime();
	      if (isArray) {
	        for (var i in formDataSourceGroupResult.dataResult) {
	          var finalData = {};
	          var item = formDataSourceGroupResult.dataResult[i];
	          //console.log(typeof(item));
	          if (formDataSourceGroupResult.aliasList.length > 1) {
	
	            for (var k in item) {
	              var innerItem = item[k];
	              for (var key in innerItem) {
	                proKey = formDataSourceGroupResult.aliasList[k] + "." + key;
	                finalData[proKey] = innerItem[key];
	              }
	            }
	          } else {
	            for (var _key in item) {
	              proKey = groupAlias + "." + _key;
	              finalData[proKey] = item[_key];
	            }
	          }
	
	          finalDatas.push(finalData);
	        }
	      } else {
	        var _finalData = {};
	        if (formDataSourceGroupResult.aliasList.length > 1) {
	          for (var _key2 in dataResult) {}
	        } else {
	          for (var _key3 in dataResult) {
	            _finalData[groupAlias + "." + _key3] = dataResult[_key3];
	          }
	        }
	
	        finalDatas.push(_finalData);
	      }
	
	      return finalDatas;
	    }
	  }, {
	    key: "getSecondaryRecord1",
	    value: function getSecondaryRecord1(record, groupAlias, fieldName, componentItemName, newValue) {
	      if (record == null) return null;
	      var secondaryRecord = { remoteClass: "java.util.HashMap" };
	      for (var key in record) {
	        var value = record[key];
	        var arr = key.split(".");
	        if (arr.length == 1) {
	          secondaryRecord[arr[0]] = value;
	        } else if (arr.length == 2) {
	          if (arr[0] == groupAlias) {
	            if (arr[1] == fieldName) value = newValue;
	            secondaryRecord[arr[1]] = value;
	          }
	        } else if (arr.length == 3) {
	          if (arr[0] == groupAlias) {
	            if (!secondaryRecord.hasOwnProperty(arr[1])) secondaryRecord[arr[1]] = { remoteClass: "java.util.HashMap" };
	            if (arr[1] == fieldName && arr[2] == componentItemName) value = newValue;
	            secondaryRecord[arr[1]][arr[2]] = value;
	          }
	        } else if (arr.length > 3) //插件内部节点带点 如果包含.号 如果大于3个点 则认为是带点号字段
	          {
	            var arr0str = arr[0];
	            if (arr0str == groupAlias) {
	              var firstDotIndex = key.indexOf(".");
	              var arr1str = key.substr(firstDotIndex + 1);
	              if (secondaryRecord[arr1str] && secondaryRecord[arr1str].remoteClass == "java.util.HashMap" && (typeof value === "undefined" ? "undefined" : _typeof(value)) == "object") continue;
	              secondaryRecord[arr1str] = value;
	            }
	          }
	      }
	      return secondaryRecord;
	    }
	  }, {
	    key: "getSecondaryRecord",
	    value: function getSecondaryRecord(record, groupAlias) {
	      if (record == null) return null;
	      var origGroupAlias = "";
	      if (groupAlias && groupAlias.indexOf(".") != -1) {
	        var groupAliasArr = groupAlias.split(".");
	        origGroupAlias = groupAliasArr[groupAliasArr.length - 1];
	      }
	      var secondaryRecord = { remoteClass: "java.util.HashMap" };
	      for (var key in record) {
	        var value = record[key];
	        var arr = key.split(".");
	        if (origGroupAlias) {
	          var groupAliasIndex = arr.indexOf(origGroupAlias);
	          arr = arr.slice(groupAliasIndex);
	        }
	
	        if (arr.length == 1) {
	          secondaryRecord[arr[0]] = value;
	        } else if (arr.length == 2) {
	          if (arr[0] == groupAlias || arr[0] == origGroupAlias) {
	            if (secondaryRecord[arr[1]] && secondaryRecord[arr[1]].remoteClass == "java.util.HashMap" && (typeof value === "undefined" ? "undefined" : _typeof(value)) == "object") continue;
	            secondaryRecord[arr[1]] = value;
	          }
	        } else if (arr.length == 3) //插件内部节点带点 如果包含.号 有3个点 认为是维度
	          {
	            if (arr[0] == groupAlias || arr[0] == origGroupAlias) {
	              if (!secondaryRecord.hasOwnProperty(arr[1])) secondaryRecord[arr[1]] = { remoteClass: "java.util.HashMap" };
	              secondaryRecord[arr[1]][arr[2]] = value;
	            }
	          } else if (arr.length > 3) //插件内部节点带点 如果包含.号 如果大于3个点 则认为是带点号字段
	          {
	            var arr0str = arr[0];
	            if (arr0str == groupAlias || arr0str == origGroupAlias) {
	              var firstDotIndex = key.indexOf(".");
	              var arr1str = key.substr(firstDotIndex + 1);
	              if (secondaryRecord[arr1str] && secondaryRecord[arr1str].remoteClass == "java.util.HashMap" && (typeof value === "undefined" ? "undefined" : _typeof(value)) == "object") continue;
	              secondaryRecord[arr1str] = value;
	            }
	          }
	      }
	      return secondaryRecord;
	    }
	
	    //(..DataSource.fileName=a*
	
	  }, {
	    key: "analysisValue",
	    value: function analysisValue(value, fv) {
	      var isNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var isRightContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      //if(isRightContext == true)
	      //  return value == fv;
	      var start1 = fv.charAt(0);
	      var start2 = fv.substr(0, 2);
	      var end1 = fv.charAt(fv.length - 1);
	      var tempv;
	      if (start1 == "#") {
	        if (isNumber) return false;
	        if (fv.substr(0, 4).toLowerCase() == "#in(") {
	          if (end1 != ")") tempv = fv.substring(4);else tempv = fv.substring(4, fv.length - 1);
	          return value == tempv;
	        } else if (fv.substr(0, 5).toLowerCase() == "#not(" && end1 == ")") {
	          tempv = fv.substring(5, fv.length - 1);
	          return value != tempv;
	        } else if (fv.substr(0, 7).toLowerCase() == "#null()" || fv.substr(0, 5).toLowerCase() == "#null") {
	          return value == null || value == "";
	        } else if (fv.substr(0, 10).toLowerCase() == "#notnull()" || fv.substr(0, 8).toLowerCase() == "#notnull") {
	          return !(value == null || value == "");
	        } else if (fv.substr(0, 9).toLowerCase() == "#between:") {
	          tempv = fv.substr(9);
	          if (tempv.indexOf("|") == -1) return false;
	          var tempa = tempv.split("|");
	          return RecordsUtil.anaysisBetween(value, tempa[1], tempa[0]);
	        } else if (fv.substr(0, 12).toLowerCase() == "#notbetween:") {
	          tempv = fv.substr(12);
	          if (tempv.indexOf("|") == -1) return false;
	          tempa = tempv.split("|");
	          return !RecordsUtil.anaysisBetween(value, tempa[1], tempa[0]);
	        } else if (fv.substr(0, 6).toLowerCase() == "#like:") {
	          tempv = fv.substr(6);
	
	          return RecordsUtil.anaysisLike(value, tempv);
	        } else if (fv.substr(0, 9).toLowerCase() == "#notlike:") {
	          tempv = fv.substr(9);
	
	          return !RecordsUtil.anaysisLike(value, tempv);
	        }
	      } else if (start2 == "!=" || start2 == "<>") {
	        tempv = fv.substr(2);
	        if (isNumber) {
	          var numvalue = parseFloat(value);
	          var numtempv = parseFloat(tempv);
	          if (isNaN(numvalue) || isNaN(numtempv)) return true;
	          return numvalue != numtempv;
	        } else {
	          return value != tempv;
	        }
	      } else if (start2 == "!(" && end1 == ")") {
	        tempv = fv.substring(2, fv.length - 1);
	        if (fv.indexOf("..") == -1) {
	          if (isNumber) {
	            numvalue = parseFloat(value);
	            numtempv = parseFloat(tempv);
	            if (isNaN(numvalue) || isNaN(numtempv)) return true;
	            return numvalue != numtempv;
	          } else {
	            return value != tempv;
	          }
	        } else {
	          tempa = tempv.split("..");
	          return !RecordsUtil.anaysisBetween(value, tempa[1], tempa[0]);
	        }
	      } else if (start2 == "<=") {
	        tempv = fv.substr(2);
	        return value == tempv || RecordsUtil.analysisLess(value, tempv);
	      } else if (start2 == ">=") {
	        tempv = fv.substr(2);
	        return value == tempv || RecordsUtil.anaysisMore(value, tempv);
	      } else if (start1 == "<") {
	        tempv = fv.substr(1);
	        return RecordsUtil.analysisLess(value, tempv);
	      } else if (start1 == ">") {
	        tempv = fv.substr(1);
	        return RecordsUtil.anaysisMore(value, tempv);
	      } else if (fv.indexOf("..") != -1) {
	        tempa = fv.split("..");
	        return RecordsUtil.anaysisBetween(value, tempa[1], tempa[0]);
	      } else if (fv.indexOf("*") != -1 || fv.indexOf("?") != -1) {
	        return RecordsUtil.anaysisLike(value, fv);
	      } else {
	        if ((value == "true" || value == "1") && (fv == "true" || fv == "1")) return true;
	        if ((value == "false" || value == "0") && (fv == "false" || fv == "0")) return true;
	        // if(end1 == ")")
	        //   fv = fv.substring(0,fv.length-1);
	        return RecordsUtil.analysisEQ(fv, value);
	      }
	
	      return false;
	    }
	  }, {
	    key: "analysisEQ",
	    value: function analysisEQ(exp, value) {
	      if (exp == "''") return value == null || value == "";
	      if (typeof value == "number") return value == parseFloat(exp);
	      return value == exp;
	    }
	  }, {
	    key: "anaysisBetween",
	    value: function anaysisBetween(value, vMax, vMin) {
	      var isNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      return value == vMax || value == vMin || RecordsUtil.analysisLess(value, vMax) && RecordsUtil.anaysisMore(value, vMin);
	    }
	  }, {
	    key: "anaysisLike",
	    value: function anaysisLike(value, v) {
	      if (v.indexOf("*") != -1) {
	        var first = v.charAt(0);
	        var end = v.charAt(v.length - 1);
	        var end2 = void 0;
	        if (v.length >= 2) {
	          end2 = v.charAt(v.length - 2);
	        }
	        if (first == '*' && end == '*') {
	          var s = "[\\s\\S]*";
	          var reg = /\*/g;
	          v = v.replace(reg, s);
	          var result = value.match(new RegExp(v, "i"));
	          return result == null ? false : result.length > 0;
	        } else {
	          if (end2 == '*' && end == '*') {
	            var s = "[\\s\\S]*";
	            var reg = /\*/g;
	            v = v.replace(reg, s);
	            var result = value.match(new RegExp(v, "i"));
	            return result == null ? false : result.length > 0;
	          }
	          if (first == '*') {
	            var reg = /\*/g;
	            var vl = v.replace(reg, "");
	            return value.toLowerCase().endsWith(vl.toLowerCase()) ? true : false;
	          }
	          if (end == '*') {
	            var reg = /\*/g;
	            var _vl = v.replace(reg, "");
	            return value.toLowerCase().startsWith(_vl.toLowerCase()) ? true : false;
	          }
	        }
	      } else if (v.indexOf("?") != -1) {
	        if (v.charAt(0) == "?") {
	          return value.indexOf(v.substr(1)) == 1;
	        } else if (v.charAt(v.length - 1) == "?") {
	          return value.indexOf(v.substring(0, v.length - 1)) == 0 && value.length == v.length;
	        } else {
	          if (value.length != v.length) return false;
	          var s1 = v.substring(0, v.indexOf("?"));
	          if (value.substring(0, v.indexOf("?")) != s1) return false;
	          var s2 = v.substr(v.indexOf("?") + 1);
	          if (value.substr(v.indexOf("?") + 1) != s2) return false;
	        }
	      } else {
	        return false;
	      }
	
	      return false;
	    }
	  }, {
	    key: "analysisLess",
	    value: function analysisLess(value, v) {
	      var num2 = parseFloat(v);
	
	      if (isNaN(num2) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null) {
	        return value < v;
	      }
	
	      var num1 = parseFloat(value);
	      if (isNaN(num1) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null) {
	        return value < v;
	      }
	
	      return num1 < num2;
	    }
	  }, {
	    key: "anaysisNQ",
	    value: function anaysisNQ(value, v) {
	      return value != v;
	    }
	  }, {
	    key: "anaysisMore",
	    value: function anaysisMore(value, v) {
	      var num2 = parseFloat(v);
	      if (isNaN(num2) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null) {
	        return value > v;
	      }
	
	      var num1 = parseFloat(value);
	      if (isNaN(num1) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null) {
	        return value > v;
	      }
	
	      return num1 > num2;
	    }
	  }]);
	
	  return RecordsUtil;
	}();
	
	RecordsUtil.regFloat = /^(-?\d+)(\.\d+)?$/;
	RecordsUtil.regInteger = /^-?\d+$/;
	exports.default = RecordsUtil;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EditorFormType = __webpack_require__(194);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _ArgCallerType = __webpack_require__(193);
	
	var _ArgCallerType2 = _interopRequireDefault(_ArgCallerType);
	
	var _ArgCaller = __webpack_require__(192);
	
	var _ArgCaller2 = _interopRequireDefault(_ArgCaller);
	
	var _FormLookup = __webpack_require__(176);
	
	var _FormLookup2 = _interopRequireDefault(_FormLookup);
	
	var _FormLookupServerAllSpec = __webpack_require__(177);
	
	var _FormLookupServerAllSpec2 = _interopRequireDefault(_FormLookupServerAllSpec);
	
	var _FormLookupServerSpec = __webpack_require__(178);
	
	var _FormLookupServerSpec2 = _interopRequireDefault(_FormLookupServerSpec);
	
	var _FormModuleLookup = __webpack_require__(54);
	
	var _FormModuleLookup2 = _interopRequireDefault(_FormModuleLookup);
	
	var _FormLookupFixed = __webpack_require__(110);
	
	var _FormLookupFixed2 = _interopRequireDefault(_FormLookupFixed);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _GOTXML2Json = __webpack_require__(104);
	
	var _GOTXML2Json2 = _interopRequireDefault(_GOTXML2Json);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormLookupFactory = function () {
		function FormLookupFactory() {
			_classCallCheck(this, FormLookupFactory);
		}
	
		_createClass(FormLookupFactory, null, [{
			key: 'clearFormLookupCache',
			value: function clearFormLookupCache(entityid) {
				if (entityid == null) {
					mapFormLookup = {};
					mapHasFormLookup = {};
				} else {
					var temp = [];
					for (var key in FormLookupFactory.mapFormLookup) {
						if (key.split(".")[0] == entityid) {
							temp.push(key);
						}
					}
	
					for (var i in temp) {
						var _key2 = temp[i];
						mapFormLookup[_key2] = null;
						delete mapFormLookup[_key2];
					}
	
					temp.splice(0, temp.length);
					for (var _key3 in FormLookupFactory.mapHasFormLookup) {
						if (_key3.split(".")[0] == entityid) {
							temp.push(_key3);
						}
					}
	
					for (var _i in temp) {
						var _key4 = temp[_i];
						mapHasFormLookup[_key4] = null;
						delete mapHasFormLookup[_key4];
					}
				}
			}
		}, {
			key: 'hasFormLookup',
			value: function hasFormLookup(base, ownerEntityId, ownerGroup) {
				if (!ownerEntityId) return false;
	
				var key = FormLookupFactory.getKey(base);
				if (key == null) return false;
	
				var result;
	
				////TODO 去取beforeInit缓存下来的内容，如果二次开发指定了 那么就按照二次开发指定的 而不再执行原来逻辑
				////由于从时序上 权限以及GOT allowEdit的设定是在前面  所以这么做的优先级顺序是 权限或者allowEdit属性设置-->二次开发-->GOT树
	
				if (this.mapHasFormLookup.hasOwnProperty(key)) {
					result = this.mapHasFormLookup[key];
				} else {
					result = FormLookupFactory.getResult(base);
					this.mapHasFormLookup[key] = result;
				}
	
				if (result == null) {
					return false;
				} else {
					var ownerForm = _GOT2.default.getForm(ownerEntityId);
					if (ownerForm == null) {
						return true;
					} else {
						var ownerFormName = ownerForm.name;
					}
	
					var lookupFormName;
					if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) == "object") {
						var dataTypeRelation = result.DataTypeRelation;
						var mainTablePro = dataTypeRelation.Properties["Table"];
						var _mainTable = _GOT2.default.getTable(mainTablePro.refentityid);
	
						if (base.hasOwnProperty("refentityid")) {
							if (base["refentityid"] == mainTablePro.refentityid) {
								if (base.hasOwnProperty("refinnerid")) {
									if (base["refinnerid"] == FormLookupFactory.getMainFieldId(dataTypeRelation)) return false;
								}
							}
						}
						return true;
					} else if (typeof result == "string") {
						if (result == "isEnum" || result == "isBoolean" || result == "isServerSpecify") return true;
						if (base.hasOwnProperty("refentityid") && base.hasOwnProperty("refinnerid")) {
							var _table = _GOT2.default.getTable(base["refentityid"]);
							if (_table != null) {
								var _tableField = _GOT2.default.getTableField(_table, base["refinnerid"]);
								if (_tableField != null) {
									var extendsPro = _tableField.Properties["Extends"];
									if (extendsPro.hasOwnProperty("refentityid")) {
										var _dataType = _GOT2.default.getDataType(extendsPro.refentityid);
										if (_dataType != null) {
											var _dataTypeType = _dataType.type;
											if (_dataTypeType == "String") {
												var _relation = _dataType.DataTypeRelation;
												if (_relation != null) {
													var _mainForm2;
													if (_relation.Properties.hasOwnProperty(_FormItemConst2.default.PROPERTY_MAINFORM_NAME)) _mainForm2 = _relation.Properties[_FormItemConst2.default.PROPERTY_MAINFORM_NAME].V;else _mainForm2 = _relation.Properties[_FormItemConst2.default.PROPERTY_MAINFORM_NAME2].V;
													var _mainFieldId = FormLookupFactory.getMainFieldId(_relation);
												}
											} else if (_dataTypeType == "Component") {
												var componentItemName = base["componentItemName"];
												var dataTypeArrayItem = _GOT2.default.getDataTypeArrayItem(_dataType, componentItemName);
												if (dataTypeArrayItem != null) {
													extendsPro = dataTypeArrayItem.Properties["RefDataType"];
													if (extendsPro.hasOwnProperty("refentityid")) {
														_dataType = _GOT2.default.getDataType(extendsPro.refentityid);
														if (_dataType != null) {
															_relation = _dataType.DataTypeRelation;
															if (_relation != null) {
																if (_relation.Properties.hasOwnProperty(_FormItemConst2.default.PROPERTY_MAINFORM_NAME)) _mainForm2 = _relation.Properties[_FormItemConst2.default.PROPERTY_MAINFORM_NAME].V;else _mainForm2 = _relation.Properties[_FormItemConst2.default.PROPERTY_MAINFORM_NAME2].V;
																//_mainForm2 = _relation.Properties["MainForm"].V;
																_mainFieldId = FormLookupFactory.getMainFieldId(_relation);
															}
														}
													}
												}
											}
										}
									}
								}
	
								if (_mainForm2 == ownerFormName && base["refinnerid"] == _mainFieldId) {
									return false;
								}
							}
						}
	
						return true;
					}
	
					return true;
				}
			}
		}, {
			key: 'getMainFieldId',
			value: function getMainFieldId(dataTypeRelation) {
				var dataTypeRelationItem = _GOT2.default.getDataTypeRelationNormalItem(dataTypeRelation);
	
				var fieldPro = dataTypeRelationItem.Properties["Field"];
				if (!fieldPro.hasOwnProperty("refentityid")) {
					throw new Error("GOT错误 the Field Pro of DataTypeRelationItem is null");
				}
				return fieldPro.refinnerid;
			}
		}, {
			key: 'getKey',
			value: function getKey(base) {
				if (base == null) return null;
	
				var key;
	
				var assignedLookupName = base["assignedLookup"];
				if (assignedLookupName == null || assignedLookupName == "" || assignedLookupName == "isEnum" || assignedLookupName == "isServerSpecify") {
					key = base["entityId"] + "." + base["innerId"] + "." + base["componentItemName"];
				} else {
					key = assignedLookupName;
				}
	
				return key;
			}
		}, {
			key: 'getResult',
			value: function getResult(base) {
				var result;
	
				var assignedLookupName = base["assignedLookup"];
	
				/*if(assignedLookupName && typeof(assignedLookupName) == "object")
	   	return null;*/
	
				if (assignedLookupName == "isBoolean" || assignedLookupName == "isEnum") {
					return assignedLookupName;
				}
	
				if (!assignedLookupName) {
					result = FormLookupFactory.getLookupFormStepByStep(_GOTUtil2.default.getDataType2(base["entityId"], base["innerId"]), base["formType"], base["componentItemName"]);
	
					if (typeof result == "string") {
						assignedLookupName = result;
					}
				}
	
				while (assignedLookupName != null && assignedLookupName.indexOf("dt:") == 0) {
					try {
						var dataType = _GOTUtil2.default.getDataType2(assignedLookupName.substring(3), null);
					} catch (e) {
						// var event:EditorErrorMessageEvent = new EditorErrorMessageEvent(EditorErrorMessageEvent.MESSAGETYPE,true);
						// event.info = "建议检查FormLookup属性是否填写正确";
						// event.messageType = EditorMessageType.ERROR;
						// GongqiERP.getSingleton().dispatchEvent(event);
						assignedLookupName = null;
						break;
					}
					result = _GOTUtil2.default.getLookupFormStepByStep(dataType, null);
					if (typeof result == "string") assignedLookupName = result;else assignedLookupName = null;
				}
	
				if (assignedLookupName != null && assignedLookupName != "") {
					if (!assignedLookupName.indexOf("lookup:") == 0) {
						result = "gongqi/erp/layers/sys/forms/" + assignedLookupName + ".swf";
					} else {
						result = "gongqi/erp/layers/sys/lookup/" + assignedLookupName.substring(7) + ".swf";
					}
				}
	
				return result;
			}
		}, {
			key: 'createFormLookup',
			value: function createFormLookup(base, pop) {
				var key = FormLookupFactory.getKey(base);
				if (key == null) return;
	
				var result;
				if (FormLookupFactory.mapFormLookup.hasOwnProperty(key)) {
					//alert("返回缓存");
					return FormLookupFactory.mapFormLookup[key];
				}
	
				//var isQueryForm = (base["formType"] == EditorFormType.QueryForm);
	
				if (FormLookupFactory.mapHasFormLookup.hasOwnProperty(key)) {
					result = FormLookupFactory.mapHasFormLookup[key];
				} else {
					result = FormLookupFactory.getResult(base);
					FormLookupFactory.mapHasFormLookup[key] = result;
				}
	
				// if(window.isDataSetView){
				// 	// let tableField = GOT.getTableFieldById(base,base);
				// 	let itemdataType = GOT.getDataType(base.extends.refentityid);
				// 	result = itemdataType;
				// }
	
	
				if (!result) {
					//后台指定
					if (!base["formLookup"]) return null;
					return _react2.default.createElement(_FormLookupServerAllSpec2.default, { entityId: base["entityId"], innerId: base["innerId"],
						lookupKey: key, groupAlias: base["groupAlias"], fieldName: base["fieldName"],
						remoteArg: base["formLookup"], minWidth: base["minWidth"] });
				} else if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) == "object") {
					var argCaller = new _ArgCaller2.default();
					argCaller.type = _ArgCallerType2.default.StringEditor;
					var lookUp;
					if (base["formLookup"]) {
						//lookUp = new FormLookupServerSpec(result as XML,formLookup);
						lookUp = _react2.default.createElement(_FormLookupServerSpec2.default, { dataType: result, argCaller: argCaller, lookupAlias: "FormLookup",
							entityId: base["entityId"], innerId: base["innerId"], lookupKey: key, isPop: base["isPop"],
							formLookupRemote: base["formLookup"] });
					} else {
						lookUp = _react2.default.createElement(_FormLookup2.default, { formType: base["formType"], dataType: result, argCaller: argCaller, lookupAlias: "FormLookup",
							entityId: base["entityId"], innerId: base["innerId"], lookupKey: key, isPop: base["isPop"] });
					}
					if (base["formType"] == _EditorFormType2.default.QueryForm) lookUp.lookupForQuery = true;
	
					if (!FormLookupFactory.mapFormLookup.hasOwnProperty(key)) {
						FormLookupFactory.mapFormLookup[key] = lookUp;
					}
					return lookUp;
				} else if (typeof result == "string") {
					if (result == "isBoolean") {
						var lookUpFixed = _react2.default.createElement(_FormLookupFixed2.default, { dataProvider: [{ label: "是", value: "true" }, { label: "否", value: "false" }],
							lookupForQuery: true, returnField: "value" });
	
						FormLookupFactory.mapFormLookup[key] = lookUpFixed;
	
						return lookUpFixed;
					} else if (result == "isServerSpecify") {
						var lookupserverspecify = _react2.default.createElement(FormLookupServerSpecify, null);
						FormLookupFactory.mapFormLookup[key] = lookupserverspecify;
						return lookupserverspecify;
					} else if (result == "isEnum") {
						var entityId = base["entityId"];
						var innerId = base["innerId"];
						var property = _GOTUtil2.default.getItemPropertyFinalValue(entityId, innerId);
						if (property.hasOwnProperty("DataProvider")) {
							lookUpFixed = _react2.default.createElement(_FormLookupFixed2.default, { lookupForQuery: true, dataProvider: property.DataProvider });
							/*var providerHeight = property.DataProvider.length * 25 + 50;
	      var fixedHeight = providerHeight > 300?300:providerHeight;
	      lookUpFixed.dataProvider = property.DataProvider;*/
						} else {
							throw new Error("property dont has property DataProvider");
						}
	
						FormLookupFactory.mapFormLookup[key] = lookUpFixed;
						return lookUpFixed;
					} else {
						var url = result;
						//"gongqi/erp/layers/sys/forms/gongqi.erp.baseform.LookUp_ProjectLine.swf"
						var formName;
						if (url.indexOf(".swf") != -1) formName = url.substring(url.lastIndexOf("/") + 1, url.indexOf(".swf"));else formName = url;
						//还是采用在同一window域下存在多个form
						//return {isCustom:true,formName:formName};
	
						var formXML = _GOT2.default.getForm(formName);
						if (formXML == null) {
							var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "loadFormWhole", "FormWholeObject");
							command.appendArg(null);command.appendArg(formName);command.appendArg(null);command.appendArg(null);command.appendArg(null);command.appendArg(null);
							command.appendArg(null, "java.util.Map");
							var _result = null;
							var _resultHandler = function _resultHandler(data) {
								var xmlDoc = _GOTXML2Json2.default.getXMLDoc(data.result.formObjectStandard.formXML);
								var formXML = _GOTXML2Json2.default.parseForm(xmlDoc);
	
								//window.formXML = formXML;
								_GOT2.default.setForm(formXML);
								var _key = _FormItemUtil2.default.getFormStoresKey("FormLookup", formXML.id);
								window.parent.window[_key] = {
									mapItemProperty: data.result.formObjectStandard.mapItemProperty,
									listRemoteMethods: data.result.formObjectStandard.listRemoteMethods,
									listTmpTable: data.result.formObjectStandard.listTmpTable,
									listAggregateTable: data.result.formObjectStandard.listAggregateTable,
									mapQueryTable: data.result.formObjectStandard.mapQueryTable
								};
								var formPrefetchCommandResult = data.result.formPrefetchCommandResult;
								if (formPrefetchCommandResult && formPrefetchCommandResult.commandResults) {
									var listRemoteMethods = window.parent.window[_key].listRemoteMethods;
									if (listRemoteMethods) {
										for (var i = 0; i < listRemoteMethods.length; i++) {
											var remoteMethod = listRemoteMethods[i];
											if (formPrefetchCommandResult.commandResults.hasOwnProperty(remoteMethod.methodName)) {
												remoteMethod.commandResult = formPrefetchCommandResult.commandResults[remoteMethod.methodName];
											}
										}
									}
								}
								var argCaller = new _ArgCaller2.default();
								argCaller.type = "StringEditor";
								argCaller.calleruuId = window.formModuleInstanceuuId;
								argCaller.callerMenuItemId = window.menuItemId;
								argCaller.callerFormId = window.formId;
								argCaller.callerDataField = base["editorDataField"];
								argCaller.callerKey = base["entityId"];
								_result = _react2.default.createElement(_FormModuleLookup2.default, { argCaller: argCaller, isPop: base["isPop"], entityId: base["entityId"], innerId: base["innerId"], xml: formXML, formId: formXML.id, menuItemId: "FormLookup" });
							};
							var _faultHandler = function _faultHandler(data) {
								var faultString;
								if (data && data.successButNot0) {
									faultString = data.errText;
								} else {
									faultString = "可能是网络错误 请检查网络是否正常";
								}
								_Warn2.default.show({ text: faultString, title: "未能正确打开下拉框" });
							};
							var remoteArg = { command: command, resultFunction: _resultHandler, faultFunction: _faultHandler };
							_ServiceHelper2.default.addTokenWithCommand(remoteArg);
							return _result;
						} else {
							var _argCaller = new _ArgCaller2.default();
							_argCaller.type = "StringEditor";
							_argCaller.calleruuId = window.formModuleInstanceuuId;
							_argCaller.callerMenuItemId = window.menuItemId;
							_argCaller.callerFormId = window.formId;
							_argCaller.callerDataField = base["editorDataField"];
							_argCaller.callerKey = base["entityId"];
							return _react2.default.createElement(_FormModuleLookup2.default, { argCaller: _argCaller, isPop: base["isPop"], entityId: base["entityId"], innerId: base["innerId"], xml: formXML, formId: formXML.id, menuItemId: "FormLookup" });
						}
					}
				}
			}
		}, {
			key: 'getLookupFormStepByStep',
			value: function getLookupFormStepByStep(dataType, formType, componentItemName) {
				if (dataType == null) return null;
	
				if (formType == "FormModule" || formType == "Query") {
					var formLookupProValue = _GOTUtil2.default.getPropertyValue(dataType, "FormLookup");
					if (formLookupProValue) {
						return formLookupProValue;
					}
				}
	
				if (dataType.type == "Component") {
					if (componentItemName != null && componentItemName != undefined) {
						var componentItemList = dataType.DataTypeArrayItems;
						for (var i in componentItemList) {
							var componentItem = componentItemList[i];
							if (componentItem.name == componentItemName) {
								return FormLookupFactory.getLookupFormStepByStep(_GOTUtil2.default.getDataType2(componentItem.Properties.RefDataType.refentityid, null), formType);
							}
						}
						return null;
					} else {
						return null;
					}
				} else {
					var dataTypeRelation = dataType.DataTypeRelation;
					if (dataTypeRelation) var mainTablePro = dataTypeRelation.Properties.Table;
					if (mainTablePro && mainTablePro.hasOwnProperty("refentityid")) {
						return dataType;
					} else {
						var ex = dataType.Properties.Extends;
						if (ex.hasOwnProperty("refentityid")) {
							return FormLookupFactory.getLookupFormStepByStep(_GOTUtil2.default.getDataType2(ex.refentityid, null), formType);
						} else {
							return null;
						}
					}
				}
			}
		}]);
	
		return FormLookupFactory;
	}();
	
	FormLookupFactory.mapFormLookup = {};
	FormLookupFactory.mapHasFormLookup = {};
	FormLookupFactory.formLookupXMLTemplate = {
		FormDataSources: { qname: "FormDataSources", name: "DataSources", Properties: { DefaultQuery: { Value: "" } },
			DataSources: [{
				name: "", id: "3", Properties: {
					Table: { Value: "" }, FetchAll: { Value: false }, DefaultOrderBy: { Value: "" },
					Reverse: { Value: false }, StartPosition: { Value: "First" }, InsertAt: { Value: "First" },
					OnlyFetchActive: { Value: false }, JoinSource: { Value: "" }, JoinType: { Value: "Delayed" },
					DelayActive: { Value: true }, AllowQuery: { Value: true }, AllowExport: { Value: true },
					AllowEdit: { Value: true }, AllowAdd: { Value: true }, AllowDelete: { Value: true },
					AllowAttachment: { Value: false }, ExternalJoin: { Value: true }
				}, FormDataSourceFields: [], FormDataSourceFieldGroups: [], FormDataSourceRelation: []
			}]
		},
		Properties: { Design: { Value: true } },
		id: "",
		name: "",
		nextInnerId: "4",
		qname: "Form"
	};
	exports.default = FormLookupFactory;

/***/ },
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ToolBarUtil = function () {
		function ToolBarUtil() {
			_classCallCheck(this, ToolBarUtil);
		}
	
		_createClass(ToolBarUtil, null, [{
			key: "createToolBarObj_Form_FormLookup",
			value: function createToolBarObj_Form_FormLookup() {
				var obj = new Object();
				obj.Print = false;
				obj.Preview = false;
				obj.Export = false;
				obj.Da = false;
				obj.RecordNew = false;
				obj.RecordSave = false;
				obj.RecordDelete = false;
				obj.RecordRestore = true;
				obj.QueryOpen = true;
				obj.QueryRemove = false;
				obj.FindOpen = true;
				obj.Refresh = false;
				obj.CursorFirst = true;
				obj.CursorLast = true;
				obj.CursorPrev = true;
				obj.CursorNext = true;
				obj.CursorPrevPage = true;
				obj.CursorNextPage = true;
				obj.FetchAll = true;
				obj.Attachment = false;
				obj.WorkFlowDetail = true;
				obj.EditModeChange = true;
				obj.MainMenu = true;
				obj.GOT = true;
				obj.Help = true;
				//obj.ReInitForm = true;
	
				return obj;
			}
		}, {
			key: "createToolBarObj_Default",
			value: function createToolBarObj_Default() {
				var obj = new Object();
				obj.Print = false;
				obj.Preview = false;
				obj.Export = false;
				obj.Da = true;
				obj.RecordNew = false;
				obj.RecordSave = false;
				obj.RecordDelete = false;
				obj.RecordRestore = false;
				obj.QueryOpen = false;
				obj.QueryRemove = false;
				obj.FindOpen = false;
				obj.Refresh = false;
				obj.CursorFirst = false;
				obj.CursorLast = false;
				obj.CursorPrev = false;
				obj.CursorNext = false;
				obj.CursorPrevPage = false;
				obj.CursorNextPage = false;
				obj.FetchAll = false;
				obj.Attachment = false;
				obj.WorkFlowDetail = false;
				obj.EditModeChange = false;
				obj.MainMenu = true;
				obj.GOT = true;
				obj.Help = true;
				//obj.ReInitForm = true;
	
				return obj;
			}
		}, {
			key: "setObjectExport",
			value: function setObjectExport(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.Print = enable;
				obj.Preview = enable;
				obj.Export = enable;
			}
		}, {
			key: "setObjectPrint",
			value: function setObjectPrint(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.Print = enable;
			}
		}, {
			key: "getObjectPrint",
			value: function getObjectPrint(obj) {
				if (obj) return obj.Print;
				return false;
			}
		}, {
			key: "getObjectExport",
			value: function getObjectExport(obj) {
				if (obj) return obj.Export;
				return false;
			}
		}, {
			key: "setObjectNew",
			value: function setObjectNew(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.RecordNew = enable;
			}
		}, {
			key: "setObjectAttachment",
			value: function setObjectAttachment(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.Attachment = enable;
			}
		}, {
			key: "getObjectAttachment",
			value: function getObjectAttachment(obj) {
				return obj.Attachment;
			}
		}, {
			key: "getObjectNew",
			value: function getObjectNew(obj) {
				if (obj) return obj.RecordNew;
				return false;
			}
		}, {
			key: "setObjectSave",
			value: function setObjectSave(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.RecordSave = enable;
			}
		}, {
			key: "getObjectSave",
			value: function getObjectSave(obj) {
				if (obj) return obj.RecordSave;
				return false;
			}
		}, {
			key: "setObjectDelete",
			value: function setObjectDelete(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.RecordDelete = enable;
			}
		}, {
			key: "getObjectDelete",
			value: function getObjectDelete(obj) {
				if (obj) return obj.RecordDelete;
				return false;
			}
		}, {
			key: "setObjectQueryRemove",
			value: function setObjectQueryRemove(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (obj) obj.QueryRemove = enable;
			}
		}, {
			key: "setObjectQuery",
			value: function setObjectQuery(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	
				obj.RecordRestore = enable;
				obj.QueryOpen = enable;
				if (!enable) obj.QueryRemove = enable;
				obj.FindOpen = enable;
				obj.Refresh = enable;
				this.setObjectCursorOpr(obj);
				obj.FetchAll = enable;
				obj.Attachment = enable;
				obj.WorkFlowDetail = enable;
			}
		}, {
			key: "setObjectRestore",
			value: function setObjectRestore(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.RecordRestore = enable;
			}
		}, {
			key: "getObjectQuery",
			value: function getObjectQuery(obj) {
				if (obj) return obj.QueryOpen;
				return false;
			}
		}, {
			key: "setObjectCursorOpr",
			value: function setObjectCursorOpr(obj) {
				var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				obj.CursorFirst = enable;
				obj.CursorLast = enable;
				obj.CursorPrev = enable;
				obj.CursorNext = enable;
				obj.CursorPrevPage = enable;
				obj.CursorNextPage = enable;
			}
		}, {
			key: "setObjectGroupNull",
			value: function setObjectGroupNull(obj) {
				obj.Print = false;
				obj.Preview = false;
				obj.Export = false;
	
				obj.RecordNew = false;
				obj.RecordSave = false;
				obj.RecordDelete = false;
	
				obj.RecordRestore = false;
				obj.QueryOpen = false;
	
				obj.QueryRemove = false;
				obj.FindOpen = false;
				obj.CursorFirst = false;
				obj.CursorLast = false;
				obj.CursorPrev = false;
				obj.CursorNext = false;
				obj.CursorPrevPage = false;
				obj.CursorNextPage = false;
				obj.FetchAll = false;
				obj.Attachment = false;
	
				obj.Refresh = false;
			}
		}]);
	
		return ToolBarUtil;
	}();
	
	exports.default = ToolBarUtil;

/***/ },
/* 69 */,
/* 70 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrayUtil = function () {
		function ArrayUtil() {
			_classCallCheck(this, ArrayUtil);
		}
	
		_createClass(ArrayUtil, null, [{
			key: "indexOf",
			value: function indexOf(arr, el) {
				for (var i = 0, n = arr.length; i < n; i++) {
					if (arr[i] === el) {
						return i;
					}
				}
				return -1;
			}
		}, {
			key: "removeByValue",
			value: function removeByValue(arr, val) {
				for (var i = 0; i < arr.length; i++) {
					if (arr[i] == val) {
						arr.splice(i, 1);
						break;
					}
				}
			}
		}, {
			key: "swapItems",
			value: function swapItems(arr, index1, index2) {
				arr[index1] = arr.splice(index2, 1, arr[index1])[0];
				return arr;
			}
	
			// 上移
	
		}, {
			key: "upRecord",
			value: function upRecord(arr, $index) {
				if ($index == 0) {
					return;
				}
				ArrayUtil.swapItems(arr, $index, $index - 1);
			}
	
			// 下移
	
		}, {
			key: "downRecord",
			value: function downRecord(arr, $index) {
				if ($index == arr.length - 1) {
					return;
				}
				ArrayUtil.swapItems(arr, $index, $index + 1);
			}
		}]);
	
		return ArrayUtil;
	}();
	
	exports.default = ArrayUtil;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['updateSortDirection', 'gridHeaderClickSort', 'autoFormLookupGridHeaderClickSort']);

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(66);
	__webpack_require__(153);
	__webpack_require__(101);
	
	var FormItemEnumEditor = function (_FormItemEditor) {
		_inherits(FormItemEnumEditor, _FormItemEditor);
	
		function FormItemEnumEditor(props) {
			_classCallCheck(this, FormItemEnumEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemEnumEditor.__proto__ || Object.getPrototypeOf(FormItemEnumEditor)).call(this, props));
	
			if (!_this.props.forLookup) _this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(_this.onDataFieldChanged.bind(_this));
			return _this;
		}
	
		_createClass(FormItemEnumEditor, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemEnumEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemEnumEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
	
					$(this.inputField).selectpicker('val', _value);
	
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
					//$(this.inputField).val(_value);
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus(e) {
				window.lastFocusUI = this.inputField;
				if (this.props.underQueryGroup) {
					this.setState({ allowEdit: true });
				}
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				//alert("EnumEditor inputFieldFocus");
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					//$(this.inputField).val(newValue);
					$(this.inputField).selectpicker('val', newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (_get(FormItemEnumEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemEnumEditor.prototype), 'onKeyDownHandler', this).call(this, e) == false) {
					if (e.ctrlKey && e.keyCode == 40) {
						$(this.inputField).selectpicker('show');
					}
				}
			}
		}, {
			key: 'inputFieldBtnClick',
			value: function inputFieldBtnClick() {
				if (this.state.allowEdit) {
					return;
				}
				this.setState({ allowEdit: true });
				this.inQueryGroup = true;
				$(this.inputField).parent().find("button.btn").click();
			}
			// inputFieldBlur(){
			// 	let value = $(this.inputField).val();
			// 	if(value=='' || !value || value==['']){
			// 		this.setState({allowEdit:false});
			// 		this.inQueryGroup=false;
			// 	}
			// }
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemEnumEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemEnumEditor.prototype), 'componentDidMount', this).call(this);
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
				if (this.props.height) {
					$(this.contextMenuHandler).children('div.bootstrap-select').css("height", this.props.height + 'px');
				}
	
				//var sid = $(this.inputField).select2();
				//sid.val("12").trigger("change").on('change',this.selectedChanged.bind(this));
				var inputWidth = this.props.displayLengthWidth + "px";
				var displayLength = this.props.displayLength;
				var widthProValue = this.props.control.getProperty_Width();
	
				var _width = void 0;
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					_width = widthProValue;
				} else {
					_width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				}
				if (this.props.underQueryGroup) {
					_width = _width.replace('px', '');
					_width = parseInt(_width) + 25 + 'px';
					$(this.inputField).selectpicker({ width: _width, height: (this.props.height ? this.props.height : '22.5') + 'px', noneSelectedText: '-点此填值-', container: 'body',
						liveSearch: false, noneResultsText: '没有找到匹配项' });
					$(this.inputField).parent().find("button.btn").keydown(this.onKeyDownHandler.bind(this))
					//只有在点击的时候才出发focus
					.focus(this.inputFieldFocus.bind(this)).click(this.inputFieldBtnClick.bind(this));
				} else {
					$(this.inputField).selectpicker({ width: _width, height: (this.props.height ? this.props.height : '22.5') + 'px', noneSelectedText: '未选中', container: 'body',
						liveSearch: false, noneResultsText: '没有找到匹配项' });
					$(this.inputField).parent().find("button.btn").keydown(this.onKeyDownHandler.bind(this))
					//只有在点击的时候才出发focus
					.focus(this.inputFieldFocus.bind(this));
				}
				//,style:"text-align:"+this.props.textAlign.toLowerCase()TODO有需求再通过修改源代码支持EnumEditor对AlignMent的支持
				//$(this.inputField).parent().focus(this.inputFieldFocus.bind(this));
	
				if (this.props.underQueryGroup) {
	
					this.doSetEnable(false);
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
	
				//this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
				if (!this.props.groupAlias) {
					this.doUpdateAllowEditByJquery(this.state.allowEdit);
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				this.setState({ allowEdit: enable });
				/*var nowAllowEdit = $(this.inputField).attr("disabled")==undefined;
	   if(nowAllowEdit == true && enable == false)
	   {
	   	this.setState({allowEdit:false});
	   }
	   else if(nowAllowEdit == false && enable == true)
	   {
	   	this.setState({allowEdit:true});
	   }*/
			}
		}, {
			key: 'doUpdateAllowEditByJquery',
			value: function doUpdateAllowEditByJquery(allowEdit) {
				if (allowEdit == false) {
					var $dom = $(this.inputField).parent().find("button.btn");
					$dom.css("background-color", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR).css("cursor", "not-allowed");
					$(this.inputField).attr("disabled", "");
	
					if (this.state.color && this.state.color != -1) $dom.css("color", this.state.color);else $dom.css("color", "");
					if (this.state.fontSize && this.state.fontSize != -1) {
						$dom.find(".filter-option").css("font-size", this.state.fontSize);
					} else {
						$dom.find(".filter-option").css("font-size", "");
					}
					$(this.inputFieldIcon).css('display', 'none');
					if (this.state.fontFamily) $dom.css("font-family", this.state.fontFamily);else $dom.css("font-family", "");
					if (this.state.fontWeight) $dom.css("font-weight", this.state.fontWeight);else $dom.css("font-weight", "");
					if (this.props.underQueryGroup) {
						$(this.inputFieldIcon).css('display', 'none');
						if (!$(this.inputField).val() || !$(this.inputField).val()[0]) {
							$dom.find(".filter-option").text("-点此填值-");
						}
					}
					//$(this.inputField).parent().find("button.btn>span.pull-left").css("text-align","left");
				} else {
					var _$dom = $(this.inputField).parent().find("button.btn");
					_$dom.css("cursor", "pointer");
					$(this.inputField).removeAttr("disabled");
					if (this.state.color && this.state.color != -1) _$dom.css("color", this.state.color);else _$dom.css("color", "");
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _$dom.css("backgroundColor", this.state.backgroundColor);else _$dom.css("backgroundColor", "");
					if (this.state.fontSize && this.state.fontSize != -1) {
						_$dom.find(".filter-option").css("font-size", this.state.fontSize);
					} else {
						_$dom.find(".filter-option").css("font-size", "");
					}
	
					if (this.state.fontFamily) _$dom.css("font-family", this.state.fontFamily);else _$dom.css("font-family", "");
					if (this.state.fontWeight) _$dom.css("font-weight", this.state.fontWeight);else _$dom.css("font-weight", "");
					if (this.props.underQueryGroup) {
						$(this.inputFieldIcon).css('display', '');
						if (!$(this.inputField).val() || !$(this.inputField).val()[0]) {
							_$dom.find(".filter-option").text("");
						}
					}
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.doUpdateAllowEditByJquery(this.state.allowEdit);
				if (this.props.height) {
					$(this.contextMenuHandler).children('div.bootstrap-select').css("height", this.props.height + 'px');
				}
			}
		}, {
			key: 'selectedChanged',
			value: function selectedChanged(e) {
				//todo 校验 需要考虑是否可编辑 将来有可能被放到Dialog及查询器上
				this.setFinalValue();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				$(this.inputField).selectpicker('val', value);
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					var elem = $(this.inputField).parent().find("button.btn");
	
					elem.focus();
					//由于不会触发focus事件 所以要手动调用
					this.inputFieldFocus();
					//setTimeout(function(){elem.focus();},100);
				}
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (!value) value = $(this.inputField).val();
				if (this.props.underQueryGroup && !this.state.oldQueryValue) {
					this.state.oldQueryValue = value;
				}
				if (!this.props.dataField) {
					if (this.props.underQueryGroup) {
						if (this.state.oldQueryValue.indexOf('null') == -1 && value.indexOf('null') != -1) {
							$(this.inputField).val(['null']);
							value = ['null'];
							$(this.inputField).selectpicker('val', ['null']);
						}
						if (this.state.oldQueryValue.indexOf('null') != -1 && value.length > 1) {
							value.splice(0, 1);
							$(this.inputField).val(value);
							$(this.inputField).selectpicker('val', value);
						}
						if (this.props.underQueryGroup) {
							this.state.oldQueryValue = value;
						}
					}
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var oldValue = this.record;var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue);
						}
					}
					this.record = value;
				} else {
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "");
					}
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (value == 0 || value) {
					if (Array.isArray(value)) {
						$(this.inputField).selectpicker('val', value);
					} else {
						if (typeof value == 'string' && value.indexOf(',') != -1) {
							$(this.inputField).selectpicker('val', value.split(','));
							return;
						}
						var list = this.props.control.getProperty_DataProvider();
						for (var i = 0; i < list.length; i++) {
							var item = list[i];
							if (item.value == value || item.value == value + "") {
								$(this.inputField).selectpicker('val', value);
								//$(this.inputField).val(value);
								this.setFinalValue(item.value, triggerModified);
								return;
							}
						}
					}
				} else {
					throw new Error("EnumEditor.setValue not String");
				}
			}
		}, {
			key: 'setDisplayFieldText',
			value: function setDisplayFieldText(value) {
				var triggerModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				this.setValue(value, triggerModify);
			}
		}, {
			key: 'setdeselectAll',
			value: function setdeselectAll() {
				if (this.props.underQueryGroup) {
					$(this.inputField).val('-点此填值-');
				} else {
					$(this.inputField).selectpicker('deselectAll');
				}
			}
		}, {
			key: 'getFormAutoQueryValue',
			value: function getFormAutoQueryValue() {
				var _text = this.getDisplayFieldText();
				if (Array.isArray(_text)) _text = _text.join(",");
				_text = this.props.control.getQueryFilteredVaue(_text);
				return _text;
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if ((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId) {
					if (selector != "all" && this.props.xml.name != selector) return;
					if (this.props.underQueryGroup && !this.getInQueryGroupNow()) return;
					//alert(this.record+"---------"+this.props.defaultValueForCMD);
					if (!this.record || this.record == "") {
						mapEditorValues[this.props.xml.name] = this.props.defaultValueForCMD;
					} else {
						var _record = this.record;
						if (Array.isArray(this.record)) {
							_record = this.record.join(",");
						}
						mapEditorValues[this.props.xml.name] = _record;
					}
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				$(this.inputField).selectpicker('val', '');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				this.inQueryGroup = false;
			}
		}, {
			key: 'getSelectDom',
			value: function getSelectDom() {
				var _this2 = this;
	
				var _options = this.props.options;
				if (this.props.xml.Properties.Regular.Value) {
					var regular = this.props.xml.Properties.Regular.Value;
					var enumv = regular.split('|');
					var _optionsN = [];
					enumv.forEach(function (eItem) {
						_options.forEach(function (item) {
							if (Number(item.value) == eItem) {
								_optionsN.push(item);
							}
						});
					});
				}
				if (this.props.underQueryGroup) {
					if (_optionsN) {
						if (_optionsN[0] && _optionsN[0].value != 'null' || !_optionsN[0]) {
	
							_optionsN.unshift({ label: '-只查空值-', value: 'null' });
						}
					} else {
						if (_options[0] && _options[0].value != 'null' || !_options[0]) {
	
							_options.unshift({ label: '-只查空值-', value: 'null' });
						}
					}
				}
				if (_optionsN) {
					var list = _optionsN.map(function (item) {
						var _value = item.value;
						return _react2.default.createElement(
							'option',
							{ key: _value, value: _value },
							item.label
						);
					});
				} else {
					var list = _options.map(function (item) {
						var _value = item.value;
						return _react2.default.createElement(
							'option',
							{ key: _value, value: _value },
							item.label
						);
					});
				}
	
				var _style = { padding: '2px !important', height: (this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT) + 'px' };
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (this.props.multiple && !this.props.dataField) {
					//selectpicker
					if (this.props.underQueryGroup) {
	
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'select',
								{ multiple: true, className: 'FormItemEnumEditor selectpicker form-control', 'data-live-search': 'true', ref: function ref(node) {
										return _this2.inputField = node;
									}, id: "select" + this.props.xml.id, style: _style,
									onChange: this.selectedChanged.bind(this) },
								list
							),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', ref: function ref(node) {
									return _this2.inputFieldIcon = node;
								}, style: { position: 'relative', right: '25px', top: '3px', zIndex: '1000', fontSize: '1px', color: 'gray' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement(
							'select',
							{ multiple: true, className: 'FormItemEnumEditor selectpicker form-control', 'data-live-search': 'true', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "select" + this.props.xml.id, style: _style,
								onChange: this.selectedChanged.bind(this) },
							list
						);
					}
				} else {
					if (this.props.underQueryGroup) {
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'select',
								{ className: 'FormItemEnumEditor selectpicker form-control', 'data-live-search': 'true', ref: function ref(node) {
										return _this2.inputField = node;
									}, id: "select" + this.props.xml.id, style: _style,
									onChange: this.selectedChanged.bind(this) },
								list
							),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', ref: function ref(node) {
									return _this2.inputFieldIcon = node;
								}, style: { position: 'relative', right: '25px', top: '3px', zIndex: '1000', fontSize: '1px', color: 'gray' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement(
							'select',
							{ className: 'FormItemEnumEditor selectpicker form-control', 'data-live-search': 'true', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "select" + this.props.xml.id, style: _style,
								onChange: this.selectedChanged.bind(this) },
							list
						);
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var inputWidth = this.props.displayLengthWidth + "px";
	
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: "12px" };
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
	
				var widthProValue = this.props.control.getProperty_Width();
	
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					editorStyle.width = "100%";
				}
	
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				// if(this.state.underQueryGroup && !this.inQueryGroup)
				// {
				// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				// }
				if (!this.state.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				}
				var _selectDom = this.getSelectDom();
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, className: 'editorGroup', ref: function ref(node) {
							return _this3.contextMenuHandler = node;
						}, style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "select" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_selectDom,
					_react2.default.createElement(
						'div',
						{ style: { position: 'relative', alignSelf: "stretch" } },
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this3.modifiedTag = node;
							}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
					)
				);
			}
		}]);
	
		return FormItemEnumEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemEnumEditor;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemButtonBaseControl = function (_GongqiFormItemContro) {
		_inherits(FormItemButtonBaseControl, _GongqiFormItemContro);
	
		function FormItemButtonBaseControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemButtonBaseControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemButtonBaseControl.__proto__ || Object.getPrototypeOf(FormItemButtonBaseControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemButtonBaseControl";
			return _this;
		}
	
		_createClass(FormItemButtonBaseControl, [{
			key: 'isSkipTab',
			value: function isSkipTab() {
				//TODO Group折叠考虑
				//if(getGroupParentFolded())
				//	return true;
	
	
				if (!this.getProperty_Visible_FinalusersetLoopForSkip()) return true;
				if (this.getProperty_ActualSkipTab()) return true;
	
				return false;
			}
		}, {
			key: 'getProperty_ShortCut',
			value: function getProperty_ShortCut() {
				var _parentWindow = window.parent.window;
				if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[this.xml.id];
					if (_properties && (_properties.hasOwnProperty("shortcut") || _properties.hasOwnProperty("shortCut"))) return _properties["shortcut"] || _properties["shortCut"];
				}
				return this.properties.ShortCut;
			}
		}, {
			key: 'getProperty_SaveRecord',
			value: function getProperty_SaveRecord() {
				if (this.properties.hasOwnProperty("SaveRecord")) return this.properties.SaveRecord;
				return this.properties.AutoSaveRecord;
			}
		}, {
			key: 'getProperty_Icon',
			value: function getProperty_Icon() {
				if (this.properties.hasOwnProperty("Icon")) return this.properties.Icon;
				return this.properties.HasIcon;
			}
		}, {
			key: 'setControlLabelCmd',
			value: function setControlLabelCmd(value) {
				this._cmdLabel = value;
				_CmdTypeActions2.default.updateControlLabel(this.xml.name, value, this.module.instanceUUId);
			}
		}]);
	
		return FormItemButtonBaseControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemButtonBaseControl;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RegularUtil = __webpack_require__(150);
	
	var _RegularUtil2 = _interopRequireDefault(_RegularUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemLongDisplay = function () {
		function FormItemLongDisplay() {
			_classCallCheck(this, FormItemLongDisplay);
		}
	
		_createClass(FormItemLongDisplay, null, [{
			key: "getDisplayText",
			value: function getDisplayText(value, showZero, thousandSeperator) {
				value = value + "";
				if (value == null || value == "") {
					return "";
				} else {
					return FormItemLongDisplay.formatLabel(value, showZero, thousandSeperator);
				}
			}
	
			//数字前面的零在getResult中已经被过滤掉
	
		}, {
			key: "filtZero",
			value: function filtZero(input) {
				var i = 0;
				var result;
				var flag = Number(input) < 0 ? true : false;
				if (flag) {
					while (input.charAt(i) == "-" || input.charAt(i) == "0") {
						i++;
					}
				} else {
					while (input.charAt(i) == "0") {
						i++;
					}
				}
	
				result = input.substr(i);
	
				if (flag) result = "-" + result;
	
				return result.split("");
			}
		}, {
			key: "formatLabel",
			value: function formatLabel(value, showZero, thousandSeperator) {
	
				if (value == null) return "";
				var chars;
				if (value == "0") {
					if (showZero) {
						return value;
					} else {
						return "";
					}
				}
	
				if (!thousandSeperator) return value;
	
				if (Number(value) < 0) {
					if (value.length < 5) {
						return value;
					} else {
						chars = FormItemLongDisplay.filtZero(value);
					}
				} else {
					if (value.length < 4) {
						return value;
					} else {
						chars = FormItemLongDisplay.filtZero(value);
					}
				}
	
				if (chars == null) {
					chars = value.split("");
				}
	
				return _RegularUtil2.default.setThounsandSeperator(chars, FormItemLongDisplay.THOUSANDSEPERATORCHAR);
			}
		}]);
	
		return FormItemLongDisplay;
	}();
	
	FormItemLongDisplay.THOUSANDSEPERATORCHAR = ",";
	exports.default = FormItemLongDisplay;

/***/ },
/* 75 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemTimeDisplay = function () {
		function FormItemTimeDisplay() {
			_classCallCheck(this, FormItemTimeDisplay);
		}
	
		_createClass(FormItemTimeDisplay, null, [{
			key: "getDisplayText",
			value: function getDisplayText(value, showHour, showMinute, showSecond) {
				if (value == "" || value == " ") {
					return "";
				} else if (value == null) {
					return "00:00:00";
				} else if (value == "00:00:00") {
					return "";
				} else {
					var array = value.split(":");
					if (array.length != 3) {
						throw new Error("time value error:" + value);
					}
					if (!showHour) {
						array[0] = "";
					}
					if (!showMinute) {
						array[1] = "";
					}
					if (!showSecond) {
						array[2] = "";
					}
	
					return array[0] + (array[0] == "" || array[1] == "" ? "" : ":") + array[1] + (array[2] == "" ? "" : ":") + array[2];
				}
			}
		}, {
			key: "getDisplayText2",
			value: function getDisplayText2(value, displayFormat) {
				if (!value) return value;
				var date = new Date("2020-12-12 " + value);
				return FormItemTimeDisplay.dateFormat2(displayFormat, date); //date.format(displayFormat);
			}
		}, {
			key: "dateFormat2",
			value: function dateFormat2(fmt, date) {
				var o = {
					"H+": date.getHours(), //小时 
					"N+": date.getMinutes(), //分 
					"S+": date.getSeconds() //秒
				};
				for (var k in o) {
					if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}return fmt;
			}
		}]);
	
		return FormItemTimeDisplay;
	}();
	
	FormItemTimeDisplay.defaultShowHour = true;
	FormItemTimeDisplay.defaultShowMin = true;
	FormItemTimeDisplay.defaultShowSeconds = true;
	exports.default = FormItemTimeDisplay;

/***/ },
/* 76 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TreeRefreshArg = function TreeRefreshArg() {
		_classCallCheck(this, TreeRefreshArg);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.plugins.tree.TreeRefreshArg";
	};
	
	TreeRefreshArg.SET_DATA = "SET_DATA";
	TreeRefreshArg.SET_ICONS = "SET_ICONS";
	TreeRefreshArg.ADD_NODE = "ADD_NODE";
	TreeRefreshArg.DELETE_NODE = "DELETE_NODE";
	TreeRefreshArg.SELECT_NODE = "SELECT_NODE";
	TreeRefreshArg.UPDATE_NODE = "UPDATE_NODE";
	exports.default = TreeRefreshArg;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.LookupRefreshStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LookupRefreshStore = exports.LookupRefreshStore = _reflux2.default.createStore({
	   init: function init() {
	      this.listenTo(_LookupActions2.default.lookupRefresh, 'lookupRefresh');
	   },
	   lookupRefresh: function lookupRefresh(formId, innerId) {
	      this.trigger(formId, innerId);
	   }
	});
	
	exports.default = LookupRefreshStore;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AutoFormLookupHeaderClickSortStore = exports.HeaderClickSortStore = exports.SortDirectionStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _QueryActions = __webpack_require__(71);
	
	var _QueryActions2 = _interopRequireDefault(_QueryActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SortDirectionStore = exports.SortDirectionStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_QueryActions2.default.updateSortDirection, 'onUpdateSortDirection');
		},
		onUpdateSortDirection: function onUpdateSortDirection(groupAlias, arg) {
			this.trigger(groupAlias, arg);
		}
	});
	
	var HeaderClickSortStore = exports.HeaderClickSortStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_QueryActions2.default.gridHeaderClickSort, 'onGridHeaderClickSort');
		},
		onGridHeaderClickSort: function onGridHeaderClickSort(columnKey, sortDirection, moduleInstanceId) {
			this.trigger(columnKey, sortDirection, moduleInstanceId);
		}
	});
	
	var AutoFormLookupHeaderClickSortStore = exports.AutoFormLookupHeaderClickSortStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_QueryActions2.default.autoFormLookupGridHeaderClickSort, 'onAutoFormLookupGridHeaderClickSort');
		},
		onAutoFormLookupGridHeaderClickSort: function onAutoFormLookupGridHeaderClickSort(columnKey, sortDirection, moduleInstanceId) {
			this.trigger(columnKey, sortDirection, moduleInstanceId);
		}
	});

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupRefersheStore = exports.GroupSlideStore = exports.VisibleFalseToTrueStore = exports.SetSubFieldGroupMaxWidthStore = exports.GetSubFieldGroupMaxWidthStore = exports.VerticalSplitterStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ResizeActions = __webpack_require__(53);
	
	var _ResizeActions2 = _interopRequireDefault(_ResizeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*var ResizeStore = Reflux.createStore(
	{
		init:function()
		{
			this.listenTo(ResizeActions.splitterResize,'onSplitterResize');
			this.listenTo(ResizeActions.dividedBoxDidMount,'onDividedBoxDidMount');
		},
	    onSplitterResize(_id,_value,addon)
	    {
	        //this.values.push(_value);
			this.trigger(_id,_value,addon);
	    },
	    onDividedBoxDidMount(_id,_value,addon)
	    {
	    	this.trigger(_id,_value,addon);
	    }
	});*/
	var VerticalSplitterStore = exports.VerticalSplitterStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.verticalSplitterResize, 'onVerticalSplitterResize');
	    },
	    onVerticalSplitterResize: function onVerticalSplitterResize(_id, addon) {
	        this.trigger(_id, addon);
	    }
	});
	
	var GetSubFieldGroupMaxWidthStore = exports.GetSubFieldGroupMaxWidthStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.getSubFieldGroupMaxWidth, 'onGetSubFieldGroupMaxWidthStore');
	    },
	    onGetSubFieldGroupMaxWidthStore: function onGetSubFieldGroupMaxWidthStore(_id, maxWidths) {
	        this.trigger(_id, maxWidths);
	    }
	});
	
	var SetSubFieldGroupMaxWidthStore = exports.SetSubFieldGroupMaxWidthStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.setSubFieldGroupMaxWidth, 'onSetSubFieldGroupMaxWidthStore');
	    },
	    onSetSubFieldGroupMaxWidthStore: function onSetSubFieldGroupMaxWidthStore(_id, maxWidth) {
	        this.trigger(_id, maxWidth);
	    }
	});
	
	var VisibleFalseToTrueStore = exports.VisibleFalseToTrueStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.visibleFalseToTrue, 'onVisibleFalseToTrue');
	    },
	    onVisibleFalseToTrue: function onVisibleFalseToTrue() {
	        this.trigger();
	    }
	});
	
	var GroupSlideStore = exports.GroupSlideStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.groupSlide, 'onGroupSlideStore');
	    },
	    onGroupSlideStore: function onGroupSlideStore(arg) {
	        this.trigger(arg);
	    }
	});
	
	var GroupRefersheStore = exports.GroupRefersheStore = _reflux2.default.createStore({
	
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.groupRefersh, 'onGroupRefersheStore');
	    },
	    onGroupRefersheStore: function onGroupRefersheStore(arg) {
	        this.trigger(arg);
	    }
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UtilStore = exports.DynamicColumnStore = exports.UpdateDataGridStore = exports.GetDataGridColumnInfoStore = exports.TabpageUserChangedStore = exports.KeyDownHelperStore = exports.UpdateInnerToolBarStore = exports.UpdateFetchAllIconStore = exports.GetGridInfosStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetGridInfosStore = exports.GetGridInfosStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_UtilActions2.default.getGridInfos, 'onGetGridInfos');
		},
		onGetGridInfos: function onGetGridInfos(groupAlias, result, moduleInstanceId) {
			this.trigger(groupAlias, result, moduleInstanceId);
		}
	});
	
	var UpdateFetchAllIconStore = exports.UpdateFetchAllIconStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_UtilActions2.default.updateFetchAllIcon, 'onUpdateFetchAllIcon');
		},
		onUpdateFetchAllIcon: function onUpdateFetchAllIcon(groupAlias, end, moduleInstanceId) {
			this.trigger(groupAlias, end, moduleInstanceId);
		}
	});
	
	var UpdateInnerToolBarStore = exports.UpdateInnerToolBarStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_UtilActions2.default.updateInnerToolBar, 'onUpdateInnerToolBar');
		},
		onUpdateInnerToolBar: function onUpdateInnerToolBar(obj) {
			this.trigger(obj);
		}
	});
	
	var KeyDownHelperStore = exports.KeyDownHelperStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_UtilActions2.default.keyDownCast, 'onKeyDownCast');
		},
		onKeyDownCast: function onKeyDownCast(e, arg) {
			this.trigger(e, arg);
		}
	});
	
	var TabpageUserChangedStore = exports.TabpageUserChangedStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_UtilActions2.default.tabpageUserChanged, 'onTabPageUserChanged');
		},
		onTabPageUserChanged: function onTabPageUserChanged(arg) {
			this.trigger(arg);
		}
	});
	
	var GetDataGridColumnInfoStore = exports.GetDataGridColumnInfoStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_UtilActions2.default.getDataGridColumnInfo, 'onGetDataGridColumnInfo');
		},
		onGetDataGridColumnInfo: function onGetDataGridColumnInfo(arg) {
			this.trigger(arg);
		}
	});
	
	var UpdateDataGridStore = exports.UpdateDataGridStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_UtilActions2.default.updateDataGrid, 'onUpdateDataGrid');
		},
		onUpdateDataGrid: function onUpdateDataGrid(formId, gridId) {
			this.trigger(formId, gridId);
		}
	});
	
	var DynamicColumnStore = exports.DynamicColumnStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_UtilActions2.default.dynamicColumns, 'onDynamicColumns');
		},
		onDynamicColumns: function onDynamicColumns(arg) {
			this.trigger(arg);
		}
	});
	
	var UtilStore = exports.UtilStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_UtilActions2.default.updateControlLabel, 'onUpdateControlLabel');
		},
		onUpdateControlLabel: function onUpdateControlLabel(arg) {
			this.trigger(arg);
		}
	});

/***/ },
/* 81 */,
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(297);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemButton.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemButton.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemPluginStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemPluginStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LookupReturnStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_LookupActions2.default.lookupReturn, 'lookupReturn');
	    },
	    lookupReturn: function lookupReturn(_value, entityId, innerId) {
	        //this.values.push(_value);
	        if (typeof _value == 'number') _value = _value + ""; //TODO_YL 下拉返回 都是以String？
	        this.trigger(_value, entityId, innerId);
	    }
	});
	
	exports.default = LookupReturnStore;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(309);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./UserFormSetForm.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./UserFormSetForm.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['domReady', 'test', 'popUpDomReady', 'lookupBeforeClose']);

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['print', 'updateGridToolBar']);

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(310);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./bootstrap-select.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./bootstrap-select.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 89 */,
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['userSetFormTreeChanged', 'treeLabelChanged']);

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ControlPropertyConst = function ControlPropertyConst() {
		_classCallCheck(this, ControlPropertyConst);
	};
	
	ControlPropertyConst.DISPLAYASPASSWORD = "displayAsPassword";
	ControlPropertyConst.IMEENABLE = "imeEnable";
	ControlPropertyConst.PASSWORDFIXEDLENGTH = "passwordFixedLength";
	ControlPropertyConst.CACHEINPUT = "cacheInput";
	ControlPropertyConst.FOCUSINSELECTMODE = "focusInSelectMode";
	ControlPropertyConst.SHOWFIELD = "showField";
	ControlPropertyConst.DISPLAYLENGTH = "displayLength";
	ControlPropertyConst.NOTNULL = "notNull";
	ControlPropertyConst.BACKGROUNDCOLOR = "backgroundColor";
	ControlPropertyConst.BACKGROUNDIMAGE = "backgroundImage";
	ControlPropertyConst.PADDINGLEFT = "paddingLeft";
	ControlPropertyConst.PADDINGRIGHT = "paddingRight";
	ControlPropertyConst.PADDINGTOP = "paddingTop";
	ControlPropertyConst.PADDINGBOTTOM = "paddingBottom";
	ControlPropertyConst.HALIGN = "horizontalAlign";
	ControlPropertyConst.VALIGN = "verticalAlign";
	ControlPropertyConst.HASBORDER = "hasBorder";
	ControlPropertyConst.BORDERWEIGHT = "borderWeight";
	ControlPropertyConst.BORDERCOLOR = "borderColor";
	ControlPropertyConst.SIZE = "size";
	ControlPropertyConst.SIZEMIN = "sizeMin";
	ControlPropertyConst.WIDTH = "width";
	ControlPropertyConst.HEIGHT = "height";
	ControlPropertyConst.SUFFIX = "suffix";
	ControlPropertyConst.WIDTHMIN = "widthMin";
	ControlPropertyConst.HEIGHTMIN = "heightMin";
	ControlPropertyConst.COMPRESS = "compress";
	ControlPropertyConst.NUMOFDECIMALS = "numOfDecimals";
	ControlPropertyConst.SHOWDECIMALS = "showDecimals";
	ControlPropertyConst.FLICKTIME = "flickTime";
	ControlPropertyConst.FONT_SIZE = "fontSize";
	ControlPropertyConst.FONT_WEIGHT = "fontWeight";
	ControlPropertyConst.FONT_COLOR = "color";
	ControlPropertyConst.KEYDOWNEVNET = "KeyDownEvent";
	ControlPropertyConst.ROW_HEIGHT = "rowHeight";
	ControlPropertyConst.DISABLERROLLOVERCOLOR = "disableRollOverColor";
	ControlPropertyConst.DISABLESELECTIONCOLOR = "disableSelectionColor";
	exports.default = ControlPropertyConst;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(103);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _FocusStore = __webpack_require__(28);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _CommandStore = __webpack_require__(18);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _FormLookupFixed = __webpack_require__(110);
	
	var _FormLookupFixed2 = _interopRequireDefault(_FormLookupFixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(82);
	/*{this.props.xml.name}*/
	
	var FormItemButton = function (_GongqiFormItem) {
		_inherits(FormItemButton, _GongqiFormItem);
	
		function FormItemButton(props) {
			_classCallCheck(this, FormItemButton);
	
			var _this = _possibleConstructorReturn(this, (FormItemButton.__proto__ || Object.getPrototypeOf(FormItemButton)).call(this, props));
	
			if (!_this.props.forLookup) {
				_this.unsubscribeCmdUpdateControlAllowEditStore = _CmdTypeStore.CmdUpdateControlAllowEditStore.listen(_this.onCmdUpdateControlAllowEditStore.bind(_this));
				_this.unsubscribeCmdDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(_this.onDsAllowEdit.bind(_this));
				_this.unsubscribeCmdButtonOk = _CmdTypeStore.CmdButtonOk.listen(_this.onButtonOk.bind(_this));
				_this.unsubscribeButtonShortCutStore = _CommandStore.ButtonShortCutStore.listen(_this.onShortCut.bind(_this));
			}
			_this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this.onFocusSet.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			_this.unsubscribeSetButtonStyleStore = _CmdTypeStore.SetButtonStyleStore.listen(_this.onSetButtonStyle.bind(_this));
			var buttonStyles = _this.getButtonStyles();
			if (buttonStyles) _this.state.devStyles = Object.assign({}, buttonStyles);else _this.state.devStyles = {};
			_this.state.label = _this.props.label;
			return _this;
		}
	
		_createClass(FormItemButton, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (!this.props.forLookup) {
					this.unsubscribeCmdUpdateControlAllowEditStore();
					this.unsubscribeCmdDsAllowEditStore();
					this.unsubscribeCmdButtonOk();
					this.unsubscribeButtonShortCutStore();
				}
				this.unsubscribeFocusSetStore();
				this.unsubscribeCmdUpdateControlLabelStore();
				this.unsubscribeSetButtonStyleStore();
			}
	
			//命令调用buttonOK 作为shortCut处理
	
		}, {
			key: 'onButtonOk',
			value: function onButtonOk(arg) {
				if (arg && arg.hasOwnProperty(this.props.xml.name)) {
					this.testIframeToParentAction({ target: this.btn }, true);
				}
			}
		}, {
			key: 'getButtonStyles',
			value: function getButtonStyles() {
				var menuItemId = this.props.menuItemId;
				var formId = this.props.formId;
				var innerId = this.props.xml.id;
				return _FormItemUtil2.default.getControlStyles(menuItemId, formId, innerId);
			}
		}, {
			key: 'onSetButtonStyle',
			value: function onSetButtonStyle(formId, name) {
				if (this.props.xml.name == name && this.props.formId == formId) {
					var buttonStyles = this.getButtonStyles();
					if (buttonStyles) {
						if (Array.isArray(buttonStyles)) {
							var tempObject = {};
							for (var i = 0; i < buttonStyles.length; i++) {
								Object.assign(tempObject, buttonStyles[i]);
								this.setState({ devStyles: tempObject });
							}
						} else {
							this.setState({ devStyles: buttonStyles });
						}
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlAllowEditStore',
			value: function onCmdUpdateControlAllowEditStore(name, _allowEdit) {
				if (name == this.props.xml.name) {
					var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
					if (finalAllowEdit) $(this.btn).removeClass("disabled");else $(this.btn).addClass("disabled");
				}
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				}
			}
		}, {
			key: 'onDsAllowEdit',
			value: function onDsAllowEdit(groupAlias) {
				if (groupAlias == this.props.groupAlias) {
					var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
					if (finalAllowEdit) $(this.btn).removeClass("disabled");else $(this.btn).addClass("disabled");
				}
			}
		}, {
			key: 'onShortCut',
			value: function onShortCut(keyCodeStr) {
				var shortCut = this.props.control.getProperty_ShortCut();
				if (shortCut == keyCodeStr) {
					this.testIframeToParentAction({ target: this.btn }, true);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
				if (_allowEdit) {
					if (this.props.initButtonOkCmd) {
						this.testIframeToParentAction({ target: this.btn }, true);
					}
					$(this.btn).removeClass("disabled");
				} else $(this.btn).addClass("disabled");
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				//alert(itemId + "  " + this.props.xml.id);
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.btn).focus();
					//$(this.inputField).select();
				}
			}
		}, {
			key: 'onPrint',
			value: function onPrint(_value) {
				alert(_value);
			}
		}, {
			key: 'restoreClikingFlag',
			value: function restoreClikingFlag() {
				if (this.clickingId) clearTimeout(this.clickingId);
				this.isclicking = false;
				//console.log("恢复标记位：--》"+this.props.xml.name);
			}
		}, {
			key: 'testAjax',
			value: function testAjax(num, url) {
				return $.ajax({
					type: 'post',
					url: urlBase + "/GongqiERP/web" + url,
					data: num,
					async: true
	
				});
			}
		}, {
			key: 'testSync',
			value: function () {
				var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cmds) {
					var i, cmd, cmd2;
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									i = 0;
	
								case 1:
									if (!(i < cmds.length)) {
										_context.next = 15;
										break;
									}
	
									cmd = cmds[i];
	
									if (!(cmd == "2")) {
										_context.next = 11;
										break;
									}
	
									//执行远程调用
									console.log("执行本地操作  " + cmd + "  并引发远程调用");
									_context.next = 7;
									return this.testAjax(cmd, "/test/test" + cmd);
	
								case 7:
									cmd2 = _context.sent;
	
									this.testSync([cmd2]);
									_context.next = 12;
									break;
	
								case 11:
									console.log("执行本地操作  " + cmd);
	
								case 12:
									i++;
									_context.next = 1;
									break;
	
								case 15:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this);
				}));
	
				function testSync(_x) {
					return _ref.apply(this, arguments);
				}
	
				return testSync;
			}()
	
			//当时此button在下拉框上 属于第三极IFrame vv
	
		}, {
			key: 'testIframeToParentAction',
			value: function () {
				var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
					var shortCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
					var tasks, task, that;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!$(this.btn).hasClass("disabled")) {
										_context2.next = 3;
										break;
									}
	
									if (window.remainTasks) {
										tasks = window.remainTasks;
	
										window.remainTasks = null;
										task = tasks.shift();
	
										if (task) CommandResolver.doResolveTask(task, this.props.control.module, tasks);
									}
									return _context2.abrupt('return');
	
								case 3:
									if (!(this.isclicking == true)) {
										_context2.next = 5;
										break;
									}
	
									return _context2.abrupt('return');
	
								case 5:
									this.isclicking = true;
									_context2.next = 8;
									return this.props.control.beforeOK(event, shortCut);
	
								case 8:
									that = this;
	
									setTimeout(function () {
										that.isclicking = false;
									}, 250);
	
									return _context2.abrupt('return');
	
								case 12:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, this);
				}));
	
				function testIframeToParentAction(_x2) {
					return _ref2.apply(this, arguments);
				}
	
				return testIframeToParentAction;
			}()
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {
					//alert(e.shiftKey)
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				window.lastFocusUI = this.btn;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				if (!_style) _style = {};
				_style['margin'] = '2px';
				if (this.state.visible == false) {
					if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				}
				Object.assign(_style, this.state.devStyles, this.props.displayStyle, this.props.cssStyle);
				var label = this.state.label;
	
				var labels = label.split(/\\n/g);
				var list = [];
				for (var i = 0; i < labels.length; i++) {
					if (i == labels.length - 1) list.push(labels[i]);else list.push(labels[i], _react2.default.createElement('br', null));
				}
				var helpText = this.props.helpText;
				if (!helpText) helpText = "";
	
				//TODO 修改GOT DisplayStyle 上按钮的排列， 可能存在问题 
				var buttonAlinStyle = "";
				var buttonVerticalAlignment = "";
				var HorizontalAlignment = "";
				if (_style.VerticalAlignment) {
					if (_style.VerticalAlignment == "Top") {
						buttonVerticalAlignment = "flex-start";
					} else if (_style.VerticalAlignment == "Center") {
						buttonVerticalAlignment = "center";
					} else if (_style.VerticalAlignment == "Bottom") {
						buttonVerticalAlignment = "flex-end";
					}
				}
				if (_style.HorizontalAlignment) {
					if (_style.HorizontalAlignment == "Left") {
						HorizontalAlignment = "flex-start";
					} else if (_style.HorizontalAlignment == "Center") {
						HorizontalAlignment = "center";
					} else if (_style.HorizontalAlignment == "Right") {
						HorizontalAlignment = "flex-end";
					}
				}
				if (buttonVerticalAlignment || HorizontalAlignment) {
					buttonAlinStyle = { "width": "100%", "height": "100%", "display": "flex", "justify-content": buttonVerticalAlignment, "align-items": HorizontalAlignment, "flex-direction": "column", "overflow": "auto" };
				}
				if (this.props.iconClass) {
	
					if (_style.display != "none") {
						_style.display = "flex";_style.alignItems = "center";
					}
					if (buttonAlinStyle) {
						return _react2.default.createElement(
							'div',
							{ style: buttonAlinStyle },
							_react2.default.createElement(
								'button',
								{ title: helpText, id: this.props.xml.name, ref: function ref(node) {
										return _this2.btn = node;
									}, className: 'btn btn-info GongqiFormItemButton', onKeyDown: this.onKeyDownHandler.bind(this),
									onClick: this.testIframeToParentAction.bind(this), style: _style, onFocus: this.inputFieldFocus.bind(this) },
								_react2.default.createElement('i', { className: this.props.iconClass }),
								_react2.default.createElement(
									'div',
									{ className: 'buttonIconOccupied' },
									list
								)
							)
						);
					} else {
						return _react2.default.createElement(
							'button',
							{ title: helpText, id: this.props.xml.name, ref: function ref(node) {
									return _this2.btn = node;
								}, className: 'btn btn-info GongqiFormItemButton', onKeyDown: this.onKeyDownHandler.bind(this),
								onClick: this.testIframeToParentAction.bind(this), style: _style, onFocus: this.inputFieldFocus.bind(this) },
							_react2.default.createElement('i', { className: this.props.iconClass }),
							_react2.default.createElement(
								'div',
								{ className: 'buttonIconOccupied' },
								list
							)
						);
					}
				} else {
					if (buttonAlinStyle) {
						return _react2.default.createElement(
							'div',
							{ style: buttonAlinStyle },
							_react2.default.createElement(
								'button',
								{ title: helpText, id: this.props.xml.name, ref: function ref(node) {
										return _this2.btn = node;
									}, className: 'btn btn-info GongqiFormItemButton', onKeyDown: this.onKeyDownHandler.bind(this),
									onClick: this.testIframeToParentAction.bind(this), style: _style, onFocus: this.inputFieldFocus.bind(this) },
								list
							)
						);
					} else {
						return _react2.default.createElement(
							'button',
							{ title: helpText, id: this.props.xml.name, ref: function ref(node) {
									return _this2.btn = node;
								}, className: 'btn btn-info GongqiFormItemButton', onKeyDown: this.onKeyDownHandler.bind(this),
								onClick: this.testIframeToParentAction.bind(this), style: _style, onFocus: this.inputFieldFocus.bind(this) },
							list
						);
					}
				}
			}
		}]);
	
		return FormItemButton;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemButton.defaultProps = {};
	
	exports.default = FormItemButton;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemDateResolver = __webpack_require__(55);
	
	var _FormItemDateResolver2 = _interopRequireDefault(_FormItemDateResolver);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDateEditor = function (_FormItemEditor) {
		_inherits(FormItemDateEditor, _FormItemEditor);
	
		function FormItemDateEditor(props) {
			_classCallCheck(this, FormItemDateEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemDateEditor.__proto__ || Object.getPrototypeOf(FormItemDateEditor)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false
			};
	
			_this.initMembers();
			_this.initStores();
			return _this;
		}
	
		_createClass(FormItemDateEditor, [{
			key: 'initMembers',
			value: function initMembers() {}
		}, {
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore();
					this.unsubscribeAutoSaveBeforeStore();
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId, triggerModify) {
				if (arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId) {
					var value = arg[this.props.xml.name];
					if (value == "1970-01-01") value = "";
					this.setDisplayFieldText(value, triggerModify);
					if (this.props.underQueryGroup) {
						this.setQueryGroupEnable(true);
					}
				}
			}
		}, {
			key: 'dateSelectChange',
			value: function dateSelectChange() {
				alert('select changeDate');
			}
		}, {
			key: 'showDateDropDown',
			value: function showDateDropDown() {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				var $pickerdropdown = $("div.datepicker");
				this.inQueryGroup = true;
	
				var _displayStyle = this.props.control.getProperty_DisplayStyle();
				var dataFormat = void 0;
				if (_displayStyle && _displayStyle.DisplayFormat) {
					dataFormat = _displayStyle.DisplayFormat;
				} else {
					// dataFormat = _displayStyle.DisplayFormat;
				}
	
				if ($pickerdropdown.is(':visible')) {
					this.lookupStates.isShowed = false;
					$(this.inputField).datepicker('hide', true);
				} else {
					this.lookupStates.isShowed = true;
					$(this.inputField).datepicker('show');
					if (dataFormat) {
						$(this.inputField).datepicker({
							format: 'yyyy-mm',
							startView: 3,
							minView: 3
						});
					}
				}
			}
		}, {
			key: 'showDateDropDownEditor',
			value: function showDateDropDownEditor() {
				if (this.props.underQueryGroup) {
					this.setState({ allowEdit: true });
					$(this.inputField).val('');
					this.record = '';
					$(this.inputField).removeAttr("readonly");
					this.showDateDropDown();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemDateEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDateEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
					//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:"";
					this.setDisplay(_value);
	
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'onDatePanelClose',
			value: function onDatePanelClose() {
				this.lookupStates.isShowed = false;
				//this.setFinalValue();
				//this.setDisplay();
			}
		}, {
			key: 'selectChangeDate',
			value: function selectChangeDate() {
				//alert($(this.inputField).val());
				this.setFinalValue();
				this.setDisplay();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemDateEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDateEditor.prototype), 'componentDidMount', this).call(this);
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
	
				var _displayStyle = this.props.control.getProperty_DisplayStyle();
				var dataFormat = void 0;
				if (_displayStyle && _displayStyle.DisplayFormat) {
					dataFormat = _displayStyle.DisplayFormat;
				} else {
					// dataFormat = _displayStyle.DisplayFormat;
				}
				var startView = 0;
				var minViewMode = 0;
				var format = "yyyy-mm-dd";
				if (!dataFormat || dataFormat == "yyyy-MM-dd" || dataFormat == "MM-dd") {
					startView = 0;
					minViewMode = 0;
				} else if (dataFormat == "yyyy-MM") {
					startView = 1;
					minViewMode = 1;
				} else if (dataFormat == "yyyy") {
					startView = 2;
					minViewMode = 2;
				}
	
				$(this.inputField).datepicker({
					language: 'zh-CN',
					autoclose: true, //选中之后自动隐藏日期选择框
					clearBtn: true, //清除按钮
					todayBtn: true, //今日按钮
					todayHighlight: true,
					format: format,
					buttonImageOnly: true,
					startView: startView,
					minViewMode: minViewMode,
					hide: this.onDatePanelClose.bind(this)
	
				}).on('selectChangeDate', this.selectChangeDate.bind(this));
	
				//此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
				//不能获得焦点的比如下拉框div仍然可以使得input失去焦点
				$(this.inputField).blur(function (event) {
					/*if(event.relatedTarget!=null && event.relatedTarget == this.refs.inputpicker)
	    {
	    	return;
	    }*/
					//$(this).val("06-06");
				});
	
				if (this.props.underQueryGroup) {
	
					this.doSetEnable(false);
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
						//_initRecord = this.props.initEditorValue;
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
	
				if (this.props.initEditorValue && !this.props.dataField) {
					this.setFinalValue(this.props.initEditorValue, false);
					this.setDisplay();
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					this.setState({ allowEdit: false });
				} else if (nowAllowEdit == false && enable == true) {
					this.setState({ allowEdit: true });
				}
			}
		}, {
			key: 'onBeforeAutoSave',
			value: function onBeforeAutoSave(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					if ($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length) {
						var text = $(this.inputField).val();
						var _val = void 0;
						_val = _FormItemDateResolver2.default.getResult(text, false);
						if (_val.indexOf("false:") == 0) {
							//alert(_val.substr(6));
							return false;
						}
						if (this.props.groupAlias == "") {
							this.record = _val;
						} else {
							var changed = false;
							var oldValue = this.record[this.props.dataField];
							var newValue = _val;
							if (oldValue != newValue) changed = true;
							this.record[this.props.dataField] = newValue;
							//alert("派发");	
							if (changed) {
								_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
								if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
							}
							this.updateModifiedTag();
						}
					}
				}
				return true;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (this.props.underQueryGroup) {
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test($(this.inputField).val())) {
						$(this.inputField).val('-只查空值-');
						this.record = '-只查空值-';
						value = '-只查空值-';
						this.state.nullValue = true;
					} else if ($(this.inputField).val() == '-只查空值-' || $(this.inputField).val() == '-') {
						$(this.inputField).val('-只查空值-');
						value = '-只查空值-';
					} else if (value == '-点此填值-') {
						$(this.inputField).val('-点此填值-');
						value = '';
					} else {
						if (value == undefined || value == null) value = $(this.inputField).val();
						if (value == "t" || value == "T") {
							var today = new Date();
							value = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
						}
						if (value) {
							value = _FormItemDateResolver2.default.getResult(value, false);
							if (value.indexOf("false:") == 0) {
								_Warn2.default.show({ text: value.substr(6) });
								return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
							}
						}
					}
				} else {
					if (value == undefined || value == null) value = $(this.inputField).val();
					if (value == "t" || value == "T") {
						var today = new Date();
						value = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
					}
					if (value) {
						value = _FormItemDateResolver2.default.getResult(value, false);
						if (value.indexOf("false:") == 0) {
							_Warn2.default.show({ text: value.substr(6) });
							return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
						}
					}
				}
	
				if (!this.props.dataField) {
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var oldValue = this.record;var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue, this);
						}
					}
					//TODO_YL 修改报错回正
					// this.record = value;
				} else {
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "", null, this);
					}
					this.updateModifiedTag();
				}
	
				return _FormItemConst2.default.EDITOR_VALUE_CHANGED_SUC;
			}
	
			//新框架避免增加复杂条件判断 所以该类只表示Form上FormItem
	
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
	
				if (this.lookupStates.isShowed) return;
				if (this.props.underQueryGroup && $(this.inputField).val() == "") {
					this.state.notNull = false;
					this.setState({ allowEdit: false, nullValue: false });
					this.inQueryGroup = false;
				} else {
					if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) {
						//todo 值回送数据完成以后 严格按照显示要求再进行显示
						this.setFinalValue();
						this.setDisplay();
					}
					if (this.props.control && this.props.xml.createdLayer == 'bug') {
						this.setFinalValue();
						this.setDisplay();
					}
				}
	
				if (this.holdFocus) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'restoreValue',
			value: function restoreValue(_value) {
				if (!this.props.dataField) {
					this.record = _value;
				} else if (this.record) {
					this.record[this.props.dataField] = _value;
				}
				this.setDisplay();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (this.props.underQueryGroup && this.record == '-只查空值-') {
					return;
				}
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				if (document.activeElement && document.activeElement == this.inputField) {} else {
					var _displayStyle = this.props.control.getProperty_DisplayStyle();
					if (_displayStyle && _displayStyle.DisplayFormat) {
						value = _FormItemDateDisplay2.default.getDisplayText2(value, _displayStyle.DisplayFormat.toUpperCase());
					} else {
						value = _FormItemDateDisplay2.default.getDisplayText(value, this.props.show1970, this.props.seperator, this.props.numOfDay, this.props.numOfMonth, this.props.numOfYear);
					}
				}
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				//return;
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
				if (this.lookupStates.isShowed) return;
				if (!this.props.dataField) {
					$(this.inputField).val(this.record);
				} else {
					var _recordValue = this.record == null ? "" : this.record[this.props.dataField];
					$(this.inputField).val(_recordValue);
				}
				if (this.state.underQueryGroup) {
					if ($(this.inputField).val() == '-只查空值-') {
						$(this.inputField).val('');
						this.record = '';
					}
				}
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (_get(FormItemDateEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDateEditor.prototype), 'onKeyDownHandler', this).call(this, e)) return;
				if (!e.ctrlKey && e.keyCode > 64 && e.keyCode < 91 && e.keyCode != 84) {
					e.preventDefault();
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				this.inQueryGroup = false;
			}
		}, {
			key: 'inputFieldOnClick',
			value: function inputFieldOnClick() {
				if (this.props.underQueryGroup) {
					this.state.notNull = false;
					this.setState({ allowEdit: true, nullValue: false });
					this.inQueryGroup = true;
				}
			}
		}, {
			key: 'inputFieldDbClick',
			value: function inputFieldDbClick() {
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				if (this.state.allowEdit) {
					var height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style = { padding: '2px', paddingRight: '13px', height: height + 'px', width: _width, fontSize: "12px" };
					_style.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
	
						_style.border = 'none';
						_style.height = parseInt(height) - 2 + 'px';
						_width = _width.replace('px', '');
						_style.width = parseInt(_width) + 11 + 'px';
						return _react2.default.createElement(
							'div',
							{ style: { position: 'relative', width: '100%', height: '22px', marginRight: '12px', border: '1px solid #ccc' } },
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "input" + this.props.xml.id,
								type: 'text', className: 'form-control', style: _style,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '14px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
						);
						// return 	<input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} 
						//     	   type="text" className="form-control pull-right" style={_style}
						//     	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
					} else {
	
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "input" + this.props.xml.id,
							type: 'text', className: 'form-control pull-right', style: _style,
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				} else {
					var _height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						_height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style2 = { padding: '2px', paddingRight: '13px', height: _height + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px", cursor: 'text' };
					_style2.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style2, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style2.color = this.state.color;
					if (this.state.fontSize && this.state.fontSize != -1) _style2.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style2.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style2.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style2, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
						_width = _width.replace('px', '');
						_style2.width = parseInt(_width) + 25 + 'px';
						var defaultValue = '-点此填值-';
						_style2.textAlign = 'center';
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "input" + this.props.xml.id, readOnly: 'readonly',
								type: 'text', className: 'form-control pull-right', style: _style2,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this), value: defaultValue, onClick: this.inputFieldOnClick.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '14px', top: '3px', zIndex: '1000', display: 'none' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
	
						_style2.paddingRight = '2px';
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "input" + this.props.xml.id, readOnly: 'readonly',
							type: 'text', className: 'form-control pull-right', style: _style2,
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				}
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this3 = this;
	
				if (this.state.allowEdit) {
	
					if (this.props.underQueryGroup) {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this3.downArrowButton = node;
							}, onMouseDown: this.showDateDropDown.bind(this), className: 'fa fa-calendar', style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					} else {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this3.downArrowButton = node;
							}, onMouseDown: this.showDateDropDown.bind(this), className: 'fa fa-calendar', style: { display: 'none', position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					}
	
					//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
				} else {
					if (this.props.underQueryGroup) {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this3.downArrowButton = node;
							}, onMouseDown: this.showDateDropDownEditor.bind(this), className: 'fa fa-calendar', style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					} else {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this3.downArrowButton = node;
							}, className: 'fa fa-calendar', style: { display: 'none', position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					}
	
					//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
				}
			}
		}, {
			key: 'showDownArrow',
			value: function showDownArrow() {
				if (this.props.underQueryGroup) {
					return;
				}
				if (this.state.allowEdit) {
					$(this.downArrowButton).show();
				}
			}
		}, {
			key: 'hideDownArrow',
			value: function hideDownArrow() {
				if (this.props.underQueryGroup) {
					return;
				}
				if (this.state.allowEdit) {
					$(this.downArrowButton).hide();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var inputgroupWidth = this.props.displayLengthWidth + 30 + "px";
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var displayLength = this.state.displayLength;
				var paddingRightValue = 0;
				if (displayLength == _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH) displayLength = _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH + 1;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + paddingRightValue + 'px';
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) {
					_notNullStyle['visibility'] = 'hidden';
				} else if (this.props.underQueryGroup) {
					_notNullStyle['visibility'] = 'hidden';
				}
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				if (_display == "block") editorStyle.backgroundColor = "#f8e8b7";
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
	
				// _notNullStyle['display']='none';
				var widthProValue = this.props.control.getProperty_Width();
				var middleStyle = {};
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
				}
	
				var inputdom = this.getInputDom(_width);
				var downArrowButtonDom = this.getDownArrowButtonDom();
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				// if(this.state.underQueryGroup && !this.inQueryGroup)
				// {
				// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				// }
				if (!this.props.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				}
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, className: 'editorGroup', ref: function ref(node) {
							return _this4.contextMenuHandler = node;
						}, style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ className: 'input-group date', style: middleStyle, onMouseEnter: this.showDownArrow.bind(this), onMouseLeave: this.hideDownArrow.bind(this) },
						inputdom,
						downArrowButtonDom,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this4.modifiedTag = node;
							}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
					)
				)
	
				/*
	   	<div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
	   		<label htmlFor={"input"+this.props.xml.id} 
	   			style={{paddingLeft:'5px',paddingRight:'5px',width:'auto'}}>{this.props.xml.name}</label>
	   		<div className="input-group" style={{width:inputgroupWidth}} ref='inputgroup'>
	   	        <input ref='inputdom' id={"input"+this.props.xml.id} type="text" className="form-control" style={{padding:'2px'}}/>
	   	        <span className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px'}} onClick={this.buttonDownClick.bind(this)}><i className="fa fa-sort-desc"></i></span>
	   	    </div>
	   	</div>
	   */
				;
			}
		}]);
	
		return FormItemDateEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemDateEditor;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _ResizeStore = __webpack_require__(79);
	
	var _UtilStores = __webpack_require__(80);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(155);
	
	__webpack_require__(319);
	
	var FormItemFieldGroup = function (_FormItemContainer) {
		_inherits(FormItemFieldGroup, _FormItemContainer);
	
		function FormItemFieldGroup(props) {
			_classCallCheck(this, FormItemFieldGroup);
	
			var _this = _possibleConstructorReturn(this, (FormItemFieldGroup.__proto__ || Object.getPrototypeOf(FormItemFieldGroup)).call(this, props));
	
			_this.state.label = _this.props.label;
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			_this.unsubscribeCmdUpdateControlPropertyStore = _CmdTypeStore.CmdUpdateControlPropertyStore.listen(_this.onCmdUpdateControlProperty.bind(_this));
			_this.unsubscribeGetSubFieldGroupMaxWidthStore = _ResizeStore.GetSubFieldGroupMaxWidthStore.listen(_this.onGetSubFieldGroupMaxWidth.bind(_this));
			_this.unsubscribeSetSubFieldGroupMaxWidthStore = _ResizeStore.SetSubFieldGroupMaxWidthStore.listen(_this.onSetSubFieldGroupMaxWidth.bind(_this));
			_this.unsubcribeUpdateControlLabelStore = _UtilStores.UtilStore.listen(_this.onUpdateControlLabel.bind(_this));
	
			_this.unsubscribeRefershSetStore = _ResizeStore.GroupRefersheStore.listen(_this.componentRefresh.bind(_this));
			return _this;
		}
	
		_createClass(FormItemFieldGroup, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCmdUpdateControlLabelStore();
				this.unsubscribeCmdUpdateControlPropertyStore();
			}
		}, {
			key: 'onGetSubFieldGroupMaxWidth',
			value: function onGetSubFieldGroupMaxWidth(_id, maxWidths) {
				if (this.props.parentXMLId != _id) return;
				maxWidths.push(this.labelMaxWidth);
			}
		}, {
			key: 'onSetSubFieldGroupMaxWidth',
			value: function onSetSubFieldGroupMaxWidth(_id, maxWidth) {
				if (this.props.parentXMLId != _id) return;
				if (this.isSingleForm()) {
					$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(function () {
						$(this).width(maxWidth);
					});
	
					if (this.titleDiv) {
						var titleWidth = this.labelMaxWidth;
						var dv = maxWidth - titleWidth;
	
						$(this.leftLineDiv).width($(this.leftLineDiv).width() + dv);
					}
				} else {
					$(this.refs.fieldGroupMutiRowDom).find(".form-vertical").each(function () {
						$(this).find(".fieldGroupLabel").each(function () {
							$(this).width(maxWidth);
						});
					});
				}
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				}
			}
		}, {
			key: 'onUpdateControlLabel',
			value: function onUpdateControlLabel(arg) {
				if (arg.controlId == this.props.xml.id) {
					var maxWidth = 0;
					if (this.isSingleForm()) {
						$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(function () {
							//alert($(this).width());
							$(this).width("auto");
	
							var thisWidth = $(this).width();
							if (thisWidth <= 0) {
								var _text = $(this).text();
								thisWidth = _text.visualLength();
							}
	
							if (thisWidth > maxWidth) maxWidth = thisWidth;
						});
	
						if (this.titleDiv) {
							var titleWidth = $(this.titleDiv).outerWidth();
							maxWidth = Math.max(titleWidth + 10, maxWidth);
						}
	
						//alert(maxWidth);
						$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(function () {
							$(this).width(maxWidth);
						});
	
						if (this.titleDiv) {
							var _titleWidth = $(this.titleDiv).outerWidth();
							var dv = maxWidth - _titleWidth;
							if (dv > 0) {
								$(this.leftLineDiv).width($(this.leftLineDiv).width() + dv);
							}
						}
					} else {
						$(this.refs.fieldGroupMutiRowDom).find(".form-vertical").each(function () {
							$(this).find(".fieldGroupLabel").each(function () {
								$(this).width("auto");
	
								var thisWidth = $(this).width();
								if (thisWidth <= 0) {
									var _text = $(this).text();
									thisWidth = _text.visualLength();
								}
	
								if (thisWidth > maxWidth) maxWidth = thisWidth;
							});
	
							$(this).find(".fieldGroupLabel").each(function () {
								$(this).width(maxWidth);
							});
						});
					}
	
					this.labelMaxWidth = maxWidth;
				}
			}
		}, {
			key: 'onCmdUpdateControlProperty',
			value: function onCmdUpdateControlProperty(name, property, value, moduleInstanceId) {
				if (name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId) return;
				if (property == ControlPropertyConst.HASBORDER) {
					if (value) {
						$(this.containerComponent).css({ border: "solid 1px #ccc", margin: "1px" });
					} else {
						$(this.containerComponent).css({ border: "none", margin: "1px" });
					}
				}
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var parentLayout = this.props.parentLayout;
				var style = {
					//width:'auto'
				};
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.props.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					var flexGrow = 0;
					var fixedWidth = false;
					var iex = _width.indexOf("%");
					if (iex != -1) {
						flexGrow = _width.substring(0, iex);
					}
	
					if (iex == -1 && _width != "") {
						style['width'] = _width + "px";
						fixedWidth = true;
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;
	
					var _height = this.props.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.props.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 0;
						var fixedHeight = false;
						var _iex = _height2.indexOf("%");
						if (_iex != -1) {
							_flexGrow = _height2.substring(0, _iex);
						}
						if (_iex == -1 && _height2 != "") {
							//flexGrow = _height+"px";
							style['height'] = _height2 + "px";
							fixedHeight = true;
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;
	
						var _width2 = this.props.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
	
				return style;
			}
		}, {
			key: 'componentRefresh',
			value: function componentRefresh(arrg) {
				if (arrg && arrg.formId == this.props.formId && this.props.xml.id == arrg.innerId) {
					this.setState({});
					// this.updateAllLabelWidth(false);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemFieldGroup.prototype.__proto__ || Object.getPrototypeOf(FormItemFieldGroup.prototype), 'componentDidMount', this).call(this);
				//$(document).ready(this.test.bind(this));
				//$(this.refs.boxdom).css("min-width",($(this.refs.boxdom).width()+10)+"px");
				this.updateAllLabelWidth();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//TODO_YL 切换tabpage或控制显隐性的 时候 重新计算 宽度 单 title 宽度 不在做增加
				this.updateAllLabelWidth(false);
			}
		}, {
			key: 'updateAllLabelWidth',
			value: function updateAllLabelWidth() {
				var titleWidthAdd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				var maxWidth = 0;
				if (this.isSingleForm()) {
					$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(function () {
						//alert($(this).width());
						var thisWidth = $(this).width();
						if (thisWidth <= 0) {
							var _text = $(this).text();
							thisWidth = _text.visualLength();
						}
	
						if (thisWidth > maxWidth) maxWidth = thisWidth;
					});
					if (titleWidthAdd) {
						if (this.titleDiv) {
							var titleWidth = $(this.titleDiv).outerWidth();
							maxWidth = Math.max(titleWidth + 10, maxWidth);
						}
					}
	
					//alert(maxWidth);
					$(this.refs.fieldGroupdom).find(".fieldGroupLabel").each(function () {
						$(this).width(maxWidth);
					});
					if (titleWidthAdd) {
						if (this.titleDiv) {
							var _titleWidth2 = $(this.titleDiv).outerWidth();
							var dv = maxWidth - _titleWidth2;
							if (dv > 0) {
								$(this.leftLineDiv).width($(this.leftLineDiv).width() + dv);
							}
						}
					}
				} else {
					$(this.refs.fieldGroupMutiRowDom).find(".form-vertical").each(function () {
						$(this).find(".fieldGroupLabel").each(function () {
							if ($(this).width() > maxWidth) maxWidth = $(this).width();
						});
	
						$(this).find(".fieldGroupLabel").each(function () {
							$(this).width(maxWidth);
						});
					});
				}
	
				this.labelMaxWidth = maxWidth;
			}
		}, {
			key: 'isSingleForm',
			value: function isSingleForm() {
				var children = this.props.xml.FormItem;
				if (!children) return true;
				var childLength = children.length;
				if (childLength < 2) return true;
				var count = this.props.columns;
				var layout = this.props.layout; //this.props.parentLayout;
				if (layout == "vertical" && count == 1) return true;
				return false;
			}
		}, {
			key: 'getSingleFormChildren',
			value: function getSingleFormChildren() {
				var parent = this.props.xml;
				var children = parent.FormItem;
				var list = [];
				var that = this;
				if (children) {
					list = children.map(function (item) {
						return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
					});
				}
				return list;
			}
		}, {
			key: 'getMutiRowColChildren',
			value: function getMutiRowColChildren() {
				var _layout = this.props.layout;
				var children = this.props.control.childrenControl;
				var length = children.length;
				if (_layout == "vertical" || _layout == "horizontal" && this.props.columns == 1) {
					var count = this.props.columns;
					//var _form:GongqiFormBox = new GongqiFormBox();
					var flatChildren = [];
					var columnChildren = [];
					var _num = 0;
					var _visnum = 0;
					for (var _i = 0; _i < length; _i++) {
						var child = children[_i];
						if (_num < count) {
							var uiChild = child.getComponentInstance(this.props.xml, this.props.forLookup);
							//TODO_YL 
							if (!uiChild.props.controlVisible && uiChild.props.hideInVisible) {
								count++;
								_visnum++;
							};
							columnChildren.push(uiChild);
							_num++;
							if (_i == length - 1) {
								flatChildren.push(columnChildren);
								//(control as Container).addElement(_form);
							}
						} else {
							count = this.props.columns;
							_visnum = 0;
							_num = 0;
							_i--;
							//(control as Container).addElement(_form);
							flatChildren.push(columnChildren);
							columnChildren = [];
						}
					}
					var resultArr = [];
					for (var i = 0; i < flatChildren.length; i++) {
						var itemArray = flatChildren[i];
						resultArr.push(_react2.default.createElement(
							'div',
							{ key: i, style: { display: "flex", flexDirection: "column", alignItems: "stretch" }, className: 'form-vertical' },
							itemArray
						));
					}
					return resultArr;
				} else {
					var count = this.props.columns;
					var rowNum = length / count;
					var remainder = length % count;
					if (remainder > 0) rowNum++;
	
					_num = 0;
					var arr = [];
					var _visnum = 0;
					for (var _i2 = 0; _i2 < count; _i2++) {
						var subarr = [];
						arr.push(subarr);
					}
					for (var _i3 = 0; _i3 < length; _i3++) {
						child = children[_i3];
						if (_num < count) {
							var _uiChild = child.getComponentInstance(this.props.xml, this.props.forLookup);
							arr[_num].push(_uiChild);
							if (!_uiChild.props.controlVisible && _uiChild.props.hideInVisible) {
								_visnum++;
								_num--;
							};
							_num++;
						} else {
							count = this.props.columns;
							_visnum = 0;
							_num = 0;
							_i3--;
						}
					}
					var _resultArr = [];
					for (var _i4 = 0; _i4 < arr.length; _i4++) {
						var _subarr = arr[_i4];
						_resultArr.push(_react2.default.createElement(
							'div',
							{ key: _i4, style: { display: "flex", flexDirection: "column", alignItems: "stretch" }, className: 'form-vertical' },
							_subarr
						));
					}
					return _resultArr;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				if (!_style) _style = {};
				_style.paddingLeft = '7px';
				if (!_style.hasOwnProperty('width')) {
					_style.width = 'auto';
				}
				_style.marginBottom = '2px';
	
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
	
				var list = void 0;var component = void 0;
				var _id = this.props.xml.name ? this.props.xml.name : this.props.xml.id;
				if (this.isSingleForm()) {
					list = this.getSingleFormChildren();
					component = _react2.default.createElement(
						'form',
						{ className: 'form-vertical', ref: 'fieldGroupdom' },
						list
					);
				} else {
					list = this.getMutiRowColChildren();
					component = _react2.default.createElement(
						'div',
						{ style: { display: "flex", flexDirection: "row", alignItems: "stretch" }, className: 'form-wrap fieldGroupMutiRow', ref: 'fieldGroupMutiRowDom' },
						list
					);
				}
	
				var showLabel = this.props.showLabel;
	
				if (showLabel && this.state.label) {
	
					//let _titleAlign = this.props.titleAlign;
					var _titleStyle = { fontSize: "15px", paddingLeft: '5px', paddingRight: '5px' };
					var _titleBoxStyle = { marginBottom: '9px', display: 'flex', flexDirection: 'row', alignItems: 'center' };
					/*if(_titleAlign == "Left")
	    {
	    	_titleStyle.paddingLeft = "10px";_titleStyle.borderLeft = "3px solid #555";_titleBoxStyle.textAlign = "left";
	    }
	    else if(_titleAlign == "Center")
	    {
	    	_titleBoxStyle.textAlign = "center";
	    }
	    else
	    {
	    	_titleStyle.paddingRight = "10px";_titleStyle.borderRight = "3px solid #555";_titleBoxStyle.textAlign = "right";
	    }*/
					return _react2.default.createElement(
						'div',
						_defineProperty({ id: _id, className: 'FormItemFieldGroup FormItemFieldGroupWidthTitle box box-info', style: _style, ref: function ref(node) {
								return _this2.containerComponent = node;
							} }, 'ref', 'boxdom'),
						_react2.default.createElement(
							'div',
							{ className: 'box-header with-border', style: _titleBoxStyle },
							_react2.default.createElement('div', { ref: function ref(node) {
									return _this2.leftLineDiv = node;
								}, style: { height: '1px', backgroundColor: '#D8D8D8', width: '10px' } }),
							_react2.default.createElement(
								'h4',
								{ ref: function ref(node) {
										return _this2.titleDiv = node;
									}, className: 'box-title', style: _titleStyle },
								this.state.label
							),
							_react2.default.createElement('div', { style: { height: '1px', backgroundColor: '#D8D8D8', flexGrow: '1' } })
						),
						component
					);
				} else {
					_style.borderTop = '0px';
					return _react2.default.createElement(
						'div',
						_defineProperty({ id: _id, className: 'FormItemFieldGroup box box-info', style: _style, ref: function ref(node) {
								return _this2.containerComponent = node;
							} }, 'ref', 'boxdom'),
						component
					);
				}
			}
		}]);
	
		return FormItemFieldGroup;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemFieldGroup.defaultProps = {};
	
	exports.default = FormItemFieldGroup;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormModuleLookup = __webpack_require__(54);
	
	var _FormModuleLookup2 = _interopRequireDefault(_FormModuleLookup);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	var _LookupReturnStore = __webpack_require__(84);
	
	var _LookupReturnStore2 = _interopRequireDefault(_LookupReturnStore);
	
	var _LookupStores = __webpack_require__(34);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _RecordsUtil = __webpack_require__(64);
	
	var _RecordsUtil2 = _interopRequireDefault(_RecordsUtil);
	
	var _ToolBarUtil = __webpack_require__(68);
	
	var _ToolBarUtil2 = _interopRequireDefault(_ToolBarUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _FormLookupFactory = __webpack_require__(65);
	
	var _FormLookupFactory2 = _interopRequireDefault(_FormLookupFactory);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _LayerManager = __webpack_require__(51);
	
	var _LayerManager2 = _interopRequireDefault(_LayerManager);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FormItemStringResolver = __webpack_require__(99);
	
	var _FormItemStringResolver2 = _interopRequireDefault(_FormItemStringResolver);
	
	var _FormDataSources = __webpack_require__(50);
	
	var _FormDataSources2 = _interopRequireDefault(_FormDataSources);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _ReactDOMFactories = __webpack_require__(160);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import ItemEditorMix from './ItemEditorCacheInputMix';
	
	var FormItemStringEditor = function (_FormItemEditor) {
		_inherits(FormItemStringEditor, _FormItemEditor);
	
		function FormItemStringEditor(props) {
			_classCallCheck(this, FormItemStringEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemStringEditor.__proto__ || Object.getPrototypeOf(FormItemStringEditor)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false,
				dropdownform: null,
				lookup: null
			};
	
			_this.initMembers();
			_this.initStores();
			_this.hasLookup = true;
			_this.classAlias = "FormItemStringEditor";
			_this.state.imeEnabel = true;
			_this.state.nullValue = false;
			_this.state.dropDownNumKeyBoard = _this.props.dropDownNumKeyBoard || _this.props.control.dropDownNumKeyBoard || _this.props.control.getProperty_DropDownContent();
			return _this;
		}
	
		_createClass(FormItemStringEditor, [{
			key: 'initMembers',
			value: function initMembers() {
				this.lookupEvents = [[$(document), {
					'mousedown touchstart': $.proxy(function (e) {
						if (!($(this.inputgroup).is(e.target) || $(this.inputgroup).find(e.target).length || this.lookupStates.dropdownform.is(e.target) || this.lookupStates.dropdownform.find(e.target).length || $(".datepicker.datepicker-dropdown").find(e.target).length)) {
							this.closeDropDown();
						}
					}, this)
				}]];
				this.toolBarObject = _ToolBarUtil2.default.createToolBarObj_Form_FormLookup();
			}
		}, {
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeLookupReturnStore = _LookupReturnStore2.default.listen(this.onLookupReturn.bind(this));
					//this.unsubscribeLookupCmpStore = LookupCmpStore.listen(this.onLookupCmp.bind(this));
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeRecordNextStore = _RecordsStore.RecordNextStore.listen(this.onRecordNext.bind(this));
					this.unsubscribeRecordPrevStore = _RecordsStore.RecordPrevStore.listen(this.onRecordPrev.bind(this));
					this.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
					this.unsubscribeLookupDropDownCloseStore = _LookupStores.LookupDropDownCloseStore.listen(this.onLookupDropDownClose.bind(this));
	
					this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				//alert("FormItemStringEditor 卸载");
				if (!this.props.forLookup) {
					this.unsubscribeLookupReturnStore();
					this.unsubscribeRecordFieldChangeStore();
					this.unsubscribeRecordNextStore();
					this.unsubscribeRecordPrevStore();
					this.unsubscribeAutoSaveBeforeStore();
					this.unsubscribeLookupDropDownCloseStore();
					this.closeDropDown();
					var lookupdiv = this.lookupStates.dropdownform;
	
					if (lookupdiv) {
						_reactDom2.default.unmountComponentAtNode(lookupdiv.get(0));
						lookupdiv.remove();
					}
					this.unsubscribeUpdateDropDownContenStore();
				}
			}
		}, {
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name) {
					if (type == "NumKeyBoard") {
						this.setState({ dropDownNumKeyBoard: true });
					} else if (type == "normal") {
						this.setState({ dropDownNumKeyBoard: false });
					}
				}
			}
		}, {
			key: 'onRecordNext',
			value: function onRecordNext() {
				if (this.lookupStates.isShowed) {
					_LookupActions2.default.lookupHostKeydown(this.lookupKey, { keyCode: 40, key: "ArrowDown" });
				}
				//alert('formLookup');
			}
		}, {
			key: 'onRecordPrev',
			value: function onRecordPrev() {
				if (this.lookupStates.isShowed) {
					_LookupActions2.default.lookupHostKeydown(this.lookupKey, { keyCode: 38, key: "ArrowUp" });
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemStringEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record != null && this.record != undefined ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
					//var _value = (this.record!=null&&this.record!=undefined&&this.props.dataField)?this.record[this.props.dataField]:"";
					$(this.inputField).val(_value);
					if (this.props.control) {
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
			}
	
			//目前测试下来 react生命周期方法只有在超类显式定义才可以调用super
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemStringEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditor.prototype), 'componentDidMount', this).call(this);
	
				if (this.props.underQueryGroup) {
	
					this.doSetEnable(false);
				} else {
					this.onCurrentRecordChanged(null, this.props.initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
	
				this.checkDropDownHas();
				$(this.element).contextPopup(this.props.contextMenuData);
	
				if (this.props.initEditorValue && !this.props.dataField) {
					this.setFinalValue(this.props.initEditorValue, false);
					this.setDisplay();
				}
				this.initToolTip();
	
				if (this.inputField && typeof this.props.allowKeyIn == "boolean" && this.props.allowKeyIn == false) {
					var _inputField = this.inputField;
					$(this.inputField).keyup(function () {
						if (_inputField.value) _inputField.value = _inputField.value.replace(/[\W]/g, '');
					});
				}
			}
		}, {
			key: 'initToolTip',
			value: function initToolTip() {
				//alert(232);
				//return;
				var self = this;
				$(this.inputField).poshytip({
	
					className: 'tip-yellowsimple',
					//showOn: 'focus',
					dontOverwriteOption: true, //由于每次content都需要一个固定函数 所以修改源代码加入该配置
					alignTo: 'target',
					alignX: 'inner-left',
					alignY: 'bottom',
					offsetX: 0,
					offsetY: 5,
					ctrlKeyActive: false,
					content: function content(callBackFunc) {
						self.remoteCallToolTip(callBackFunc);
					}, //"[title]"
					showTimeout: 500
	
				});
			}
		}, {
			key: 'remoteCallToolTip',
			value: function remoteCallToolTip(callBackFunc) {
	
				var mi;
				var command = void 0;var commandArg = void 0;
				if (!this.props.control.group) {
					var result = _LayerManager2.default.executeLayerMethod(this.props.control.module, this.props.control.group, "dataTip_" + this.props.xml.name);
					if (result) {
						setTimeout(function () {
							callBackFunc(result);
						}, 100);
						return;
					}
	
					mi = _FormResourceUtil2.default.getCommandArgMethodInfo("dataTip_" + this.props.xml.name, window.menuItemId, window.formId);
					command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doDataTip", "String");
					commandArg = _CommandResolver2.default.getSendCmd(this.props.control.module, this.props.groupAlias, mi);
					command.appendArg(null, "String").appendArg(this.props.xml.name, "String").appendArg(commandArg, "CommandArg");
				} else {
					var _result = _LayerManager2.default.executeLayerMethod(this.props.control.module, this.props.control.group, "dataTip_" + this.props.xml.name);
					if (_result) {
						setTimeout(function () {
							callBackFunc(_result);
						}, 100);
						return;
					}
					var _methodName = this.props.dataField;
					if (!_methodName) return;
	
					_methodName = _methodName.substr(_methodName.indexOf(".") + 1);
					var _fieldName = _methodName;
					_fieldName = _StringUtil2.default.convertToEachFirstUpperCase(_fieldName);
					_methodName = _StringUtil2.default.convertToEachFirstUpperCase(_methodName);
					_methodName = _StringUtil2.default.replaceAll(_methodName, ".", "_");
					mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.props.groupAlias + ".dataTip_" + _methodName, window.menuItemId, window.formId);
					command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doDataTip", "String");
					commandArg = _CommandResolver2.default.getSendCmd(this.props.control.module, this.props.groupAlias, mi);
					command.appendArg(this.props.groupAlias, "String").appendArg(_fieldName, "String").appendArg(commandArg, "CommandArg");
				}
	
				var remoteArg = { command: command, sync: false,
					resultFunction: function resultFunction(data) {
						//alert(JSON.stringify(data));
						if (data.result) {
							callBackFunc(data.result);
						}
					}
				};
				if (window.isDataSetView) {
					return;
				}
				if (this.props.control.group && this.props.control.group.forLookup || this.props.forLookup) {
					return;
				}
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		}, {
			key: 'checkDropDownHas',
			value: function checkDropDownHas() {
				//如果是下拉框 则一定无
				if (this.props.forLookup) {
					$(this.downArrowButton).hide();
					this.hasLookup = false;return;
				}
				if (this.props.control.serverHasLookup == null || this.props.control.serverHasLookup == undefined) {
					if (this.props.serverSpecify) return;
					if (window.isDataSetView) return;
					var base = this.getLookupBase();
					if (!_FormLookupFactory2.default.hasFormLookup(base, this.props.formId, this.props.group)) //如果GOT没有 则设置为false
						{
							$(this.downArrowButton).hide();this.hasLookup = false;
						}
				} else //update指定是否显示
					{
						if (this.props.control.serverHasLookup == false) {
							$(this.downArrowButton).hide();this.hasLookup = false;
						}
					}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				this.setState({ allowEdit: enable });
				/*var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
	   if(nowAllowEdit == true && enable == false)
	   {
	   	this.setState({allowEdit:false});
	   }
	   else if(nowAllowEdit == false && enable == true)
	   {
	   	this.setState({allowEdit:true});
	   }*/
			}
		}, {
			key: 'doMutiFieldReturn',
			value: function doMutiFieldReturn(returnFields) {
				var v = null;
				for (var _i = 0; _i < returnFields.length; _i++) {
					var flrf = returnFields[_i];
					if (flrf.fromValue != null && flrf.fromValue != undefined) {
						if (this.props.groupAlias == "" || !this.props.groupAlias) {
							var value = flrf.fromValue;
	
							var editorName = flrf.toDataField;
							if (editorName != this.props.xml.name) {
								_LookupActions2.default.lookupReturnMutiEditor(editorName, value);
								//$(this.inputField).focus();$(this.inputField).select();
							} else {
								v = value;
							}
							continue;
						}
						var _to = this.props.groupAlias + "." + _StringUtil2.default.convertToEachFirstLowerCase(flrf.toDataField);
						var toRecord = this.props.rowData ? this.props.rowData : this.record;
						if (!toRecord.hasOwnProperty(_to)) {
							_Warn2.default.show({ text: "当前记录中不含" + _to + "  请检查lookupSelect二次开发方法" });
							continue;
						}
						if (this.props.dataField == _to) {
							v = flrf.fromValue;
							//$(this.inputField).val(flrf.fromValue);
						} else {
							toRecord[_to] = flrf.fromValue;
						}
					}
				}
				return v;
			}
		}, {
			key: 'doMutiFieldReturn1',
			value: function doMutiFieldReturn1(returnFieldsMap) {
				if (this.props.groupAlias == "" || !this.props.groupAlias) return null;
				var toRecord = this.props.rowData ? this.props.rowData : this.record;
				var v = null;
				for (var _dataField in returnFieldsMap) {
					var _to = this.props.groupAlias + "." + _StringUtil2.default.convertToEachFirstLowerCase(_dataField);
					if (!toRecord.hasOwnProperty(_to)) {
						alert("当前记录中不含" + _to + "  请检查lookupSelect二次开发方法");
						continue;
					}
					if (this.props.dataField == _to) {
						v = flrf.fromValue;
						//$(this.inputField).val(flrf.fromValue);
					} else {
						toRecord[_to] = flrf.fromValue;
					}
				}
				return v;
			}
		}, {
			key: 'onLookupReturn',
			value: function onLookupReturn(value, entityId, innerId) {
				if (this.props.formId == entityId && this.props.xml.id == innerId) {
					if (Array.isArray(value) == true) {
						value = this.doMutiFieldReturn(value);
					} else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == "object") {
						value = this.doMutiFieldReturn1(value);
					}
	
					// if(this.lookupStates.isShowed)
					// {
					//lookupdiv.remove();
					//this.lookupStates.isShowed = false;
					var _replace = this.props.returnLookup == "Replace";
					if (_replace) {
						this.closeDropDown();
						this.onLookupReturning = true;
						this.setFinalValue(value);
						//todo 值回送数据完成以后 严格按照显示要求再进行显示
						this.setDisplay();
	
						this.inputField.focus();
	
						this.inputField.select();
					} else {
						this.onLookupReturning = true;
						var $t = this.inputField;
						if ($t.selectionStart || $t.selectionStart == '0') {
							var startPos = $t.selectionStart;
							var endPos = $t.selectionEnd;
							var scrollTop = $t.scrollTop;
							$t.value = $t.value.substring(0, startPos) + value + $t.value.substring(endPos, $t.value.length);
							this.inputField.focus();
							$t.selectionStart = startPos + value.length;
							$t.selectionEnd = startPos + value.length;
							$t.scrollTop = scrollTop;
						} else {
							this.inputField.value += value;
							this.inputField.focus();
						}
						this.closeDropDown();
					}
	
					this.onLookupReturning = false;
	
					// $(this.inputField).val(value);
					return false;
					// }
				}
			}
		}, {
			key: 'onLookupCmp',
			value: function onLookupCmp() {
				var lookupdiv = this.lookupStates.dropdownform;
				var _inputwidth = $(this.inputgroup).width(); //this.props.displayLengthWidth;
				var _iframewidth = lookupdiv.outerWidth();
	
				var _iframeheight = lookupdiv.outerHeight();
	
				var _gwidth = $("#app").width();
				var _gheight = $("#app").height();
	
				if (_iframewidth > _gwidth) {
					_iframewidth = _gwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				}
				var _offset = $(this.inputgroup).offset();
				var _y = _offset.top;
				var _x = _offset.left;
				var _top = _y + $(this.inputgroup).height();
				//alert('x:'+_x+'y:'+_y);
				//下方屏幕放不下
				if (_top + _iframeheight > _gheight) {
					//上下都放不下 考虑缩减高度
					if (_iframeheight > _y) {
						//上方空间大
						if (_y > _gheight / 2) {
							var _newdivheight = _y - 1 + 'px';
							//lookupdiv.css("height":_newdivheight);
							lookupdiv.height(_y - 2);
							//alert(_newdivheight);
							_top = '0px';
							//'-'+_newdivheight+'px';
						} else //下方空间大
							{
								//let _newdivheight = (_gheight-_y)+'px';
								lookupdiv.css("height", _gheight - _top + 'px');
							}
					} else //下拉框置于上方
						{
							_top = _y - _iframeheight + 'px';
							//'-'+_iframeheight+'px';
						}
				}
				var _left = _x - (_iframewidth - _inputwidth) / 2;
				//(_iframewidth-_inputwidth)/2;
				if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 5;
				if (_left < 0) _left = 0;
	
				lookupdiv.css({ left: _left + 'px', top: _top });
				//lookupdiv.css({left:'860px',top:'200px'});
	
				this.lookupStates.isShowed = true;
			}
		}, {
			key: 'closeDropDown',
			value: function closeDropDown() {
				if (this.lookupStates.isShowed) {
	
					if (this.lookupStates.lookup && this.lookupStates.lookup.beforeClose && typeof this.lookupStates.lookup.beforeClose == "function") {
						this.lookupStates.lookup.beforeClose();
					}
	
					var lookupdiv = this.lookupStates.dropdownform;
					if (lookupdiv == null) return;
					this.detachEventListeners();
	
					// lookupdiv.remove();
					lookupdiv.css("display", "none");
					this.moduleLookup = null;
	
					this.lookupStates.isShowed = false;
	
					//this.refs.inputdom.focus();this.refs.inputdom.select();
					this.inputField.focus();
					this.inputField.select();
	
					window.lookupShowing = false;
					window.nowLookupInstance = null;
					window.toolBarObject = Object.assign({}, this.dropDownBakToolBarObject);
					var _parentWindow = window.parent.window;
					if (_parentWindow) {
						_parentWindow.setToolBar(this.dropDownBakToolBarObject);
					}
	
					_UtilActions2.default.updateInnerToolBar(this.dropDownBakToolBarObject);
	
					return false;
				}
			}
		}, {
			key: 'buildLookupArg',
			value: function buildLookupArg(lookup) {
				var lookupAlias = lookup.classAlias;
				if (lookupAlias == "FormModuleLookup" || lookupAlias == "FormLookup") {
					lookup.lookupArg = {};
	
					if (this.props.groupAlias != "") {
						lookup.lookupArg["groupAlias"] = this.props.groupAlias;
						var filterFieldName = _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField);
						filterFieldName = filterFieldName.substring(filterFieldName.indexOf(".") + 1);
						lookup.lookupArg["baseTableName"] = this.props.group.mainSource.tableName;
						lookup.lookupArg["filterFieldName"] = filterFieldName;
						lookup.lookupArg["baseRecord"] = _RecordsUtil2.default.getSecondaryRecord(this.props.rowData ? this.props.rowData : this.record, this.props.groupAlias);
						lookup.lookupArg["baseFormId"] = this.props.formId;
					} else if (this.props.groupAlias == "") {
						lookup.lookupArg["groupAlias"] = null;
						if (this.props.formType != _EditorFormType2.default.FormModule) {
							lookup.lookupArg["filterFieldName"] = null;
							lookup.lookupArg["baseFormId"] = null;
						} else {
							lookup.lookupArg["filterFieldName"] = this.props.xml.name;
							lookup.lookupArg["baseFormId"] = this.props.formId;
						}
						lookup.lookupArg["baseTableName"] = null;
						lookup.lookupArg["baseRecord"] = null;
					}
					if (lookup.autoReturn == true) {
						var _returnField = lookup.returnField;
						var splitArr = _returnField.split(".");
						var lastField = splitArr[splitArr.length - 1];
						lookup.lookupArg["fieldName"] = _StringUtil2.default.convertToFirstUpperCase(lastField);
					} else {
						lookup.lookupArg["fieldName"] = null;
					}
	
					if (this.laterFitlerText) {
						_text = this.laterFitlerText;
						this.laterFitlerText = null;
						//用来标记是输入*号导致了下拉
						lookup.lookupArg["asteriskLookupQuery"] = true;
					} else {
						var _text = $(this.inputField).val();
					}
	
					if (this.props.queryOnTextChanging == true) _text = "*" + _text + "*";
	
					lookup.lookupArg["baseFilter"] = _text;
				} else if (lookupAlias == "FormLookupServerAllSpec") {
					lookup.lookupArg = {};
	
					if (this.props.groupAlias != "") {
						lookup.lookupArg["groupAlias"] = this.props.groupAlias;
						var filterFieldName = _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField);
						filterFieldName = filterFieldName.substring(filterFieldName.indexOf(".") + 1);
						lookup.lookupArg["baseTableName"] = this.props.group.mainSource.tableName;
						lookup.lookupArg["filterFieldName"] = filterFieldName;
						var _baseRecord = this.record;
						if (!_baseRecord && this.props && this.props.rowData) {
							_baseRecord = this.props.rowData;
						}
						lookup.lookupArg["baseRecord"] = _RecordsUtil2.default.getSecondaryRecord(_baseRecord, this.props.groupAlias);
						lookup.lookupArg["baseFormId"] = this.props.formId;
					} else {
						lookup.lookupArg["groupAlias"] = null;
						if (this.props.formType != _EditorFormType2.default.FormModule) {
							lookup.lookupArg["filterFieldName"] = null;
							lookup.lookupArg["baseFormId"] = null;
						} else {
							lookup.lookupArg["filterFieldName"] = this.props.xml.name;
							lookup.lookupArg["baseFormId"] = this.props.formId;
						}
						lookup.lookupArg["baseTableName"] = null;
						lookup.lookupArg["baseRecord"] = null;
					}
	
					lookup.lookupArg["fieldName"] = null;
					if (this.laterFitlerText) {
						_text = this.laterFitlerText;this.laterFitlerText = null;
					} else {
						var _text = $(this.inputField).val();
					}
	
					if (this.props.queryOnTextChanging == true) _text = "*" + _text + "*";
	
					lookup.lookupArg["baseFilter"] = _text;
				} else {
					//TODO 目前这种情况有还待测试 
					var filter = {};
					filter["record"] = this.record;
					filter["text"] = $(this.inputField).val();
					lookup.lookupFilter = filter;
				}
				lookup.toolBarObject = this.toolBarObject;
			}
		}, {
			key: 'buildExtralWhereItem',
			value: function buildExtralWhereItem(lookup) {
				if (this.props.groupAlias != "" && typeof lookup.setExtralWhereItemValueForRefresh == "function") {
					var filterField = this.props.filterField;
					if (filterField) {
						var alias = this.props.groupAlias;
						filterField = _StringUtil2.default.convertToFirstLowerCase(filterField);
						var filterfieldvalue = this.record[alias + "." + filterField];
						if (filterfieldvalue && filterfieldvalue != "") {
							lookup.setExtralWhereItemValueForRefresh(false, filterfieldvalue);
						} else {
							// lookup.setExtralWhereItemValueForRefresh(false,"#NULL_FILTER_FIELD#");
							lookup.setExtralWhereItemValueForRefresh(false, "");
						}
					}
				} else if (!this.props.groupAlias && typeof lookup.setExtralWhereItemValueForRefresh == "function") {
					var filterEditorPro = this.props.filterEditor;
					if (filterEditorPro) {
						var filterEditor = filterEditorPro.V || filterEditorPro.Value;
						if (!filterEditor) return;
						var innerId = filterEditorPro.innerid;
	
						var arg = {};
						_CommandActions2.default.commandArgMapEditors(filterEditor, arg, this.props.moduleInstanceId);
	
						var filterEditorValue = arg[filterEditor];
						if (filterEditorValue && filterEditorValue != "") {
							if (filterEditorValue.indexOf("*") != -1 || filterEditorValue.indexOf("?") != -1) {
								lookup.setExtralAggregationItemValueForRefresh(false, "Distinct");
								lookup.setExtralWhereItemValueForRefresh(false, filterEditorValue);
							} else {
								lookup.setExtralWhereItemValueForRefresh(false, filterEditorValue);
							}
						} else {//TODO_YL 暂时不添加聚合  2022/11/15
							//lookup.setExtralAggregationItemValueForRefresh(false,"Distinct");
						}
					}
				}
			}
		}, {
			key: 'getLookupBase',
			value: function getLookupBase() {
				var base = {};
				if (this.props.isBoolean == true) {
					base["assignedLookup"] = "isBoolean";
				} else if (this.props.isEnum == true) {
					base["assignedLookup"] = "isEnum";
				} else if (this.props.serverSpecify) //methodarg object
					{
						base["assignedLookup"] = "";
					} else {
					base["assignedLookup"] = this.props.assignedFormLookup;
				}
				base["entityId"] = this.props.formId;
				base["innerId"] = this.props.xml.id;
				base["componentItemName"] = _GOTUtil2.default.getComponentItemName(this.props.dataField);
				base["editorDataField"] = this.props.dataField ? _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField) : this.props.xml.name;
				if (this.props.control) {
					base["isMainGroup"] = this.props.control.isMainGroup();
					base["refentityid"] = this.props.control.getRefEntityId();
					base["refinnerid"] = this.props.control.getRefInnerId();
				}
				base["formType"] = "FormModule";
				return base;
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				if (this.lookupStates.isShowed) {
					this.closeDropDown();
					return;
				}
				var lookupdiv = this.lookupStates.dropdownform;
				window.lookupShowing = true;
				//暂时把下拉框缓存在项目编辑器实例 由于项目编辑器实例会由reactdatagrid销毁
				//所以缓存对于FormItemStringEditorForDataGrid不适用 应该跟flex一样缓存到全局
				if (lookupdiv == null || !this.lookupStates.lookup) {
					if (this.props.dropDownMode == "pop") {
						lookupdiv = $("<div>").addClass("modal").css("display", "flex").css("align-items", "center").css("justify-content", "center");
						this.lookupStates.dropdownform = lookupdiv;
					} else {
						lookupdiv = $("<div>").css({ position: 'absolute', padding: '1px', backgroundColor: '#ffffff', border: 'solid 1px #d2d2d2', /*float:'left',*/zIndex: 800, overflow: 'auto' });
						this.lookupStates.dropdownform = lookupdiv;
					}
	
					if (this.props.dropDownMode == "pop") {
						lookupdiv.appendTo($("#dialogModal"));
					} else {
						lookupdiv.appendTo($('body'));
					}
					//lookupdiv.show();
	
					var base = {};
					if (this.props.isBoolean == true) {
						base["assignedLookup"] = "isBoolean";
					} else if (this.props.isEnum == true) {
						base["assignedLookup"] = "isEnum";
					} else if (this.props.serverSpecify) {
						var fieldName = null;
						var _groupAlias = this.props.groupAlias;
						if (this.props.dataField != null) {
							var temp = _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField);
							fieldName = temp.substr(temp.indexOf(".") + 1);
						} else {
							fieldName = this.props.xml.name;
						}
	
						var mi = this.props.control.getServerSpecify();
						//在自定义下拉框上无该操作
						var commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, this.props.groupAlias, mi);
						var command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doOpenLookup", "CommandResult").appendArg(this.props.group ? this.props.group.groupAlias : null).appendArg(fieldName).appendArg(commandArg, "CommandArg");
						var _resultHandler = function _resultHandler(data) {
							var commandResult = data.result;
							var task = commandResult.tasks[0];
							//针对返回空result可能认为没有openlookup  场景：底层有写这个 上层不要想用默认的autolookup效果
							if (!task) {
								return;
							}
							if (task && task.cmd != _Cmd2.default.OpenLookup) {
								alert("openLookup_二次开发方法中只能使用openLookup命令");
								return;
							}
							if (typeof task.arg == "string") {
								base["assignedLookup"] = task.arg;
							} else {
								base["formLookup"] = task.arg;
							}
							base["fieldName"] = fieldName;
							base["groupAlias"] = _groupAlias;
						};
						var remoteArg = { command: command, resultFunction: _resultHandler };
						_ServiceHelper2.default.addTokenWithCommand(remoteArg);
	
						/*调用二次开发var commandArg:CommandArg = CommandResolver.getSendCmd(gongqiFormItem.formDesign, group?group.groupAlias:null, serverSpecMI);
	     var command:Command = CommandHelper.createFormInstance(gongqiFormItem.formDesign.formModule.formName, "doOpenLookup", "CommandResult")
	     	.appendArg(group?group.groupAlias:null)
	     	.appendArg(fieldName)
	     	.appendArg(commandArg, "CommandArg");
	     ServiceHelper.addTokenWithCommand(command,rpc_result_formLookup);*/
					} else {
						base["assignedLookup"] = this.props.assignedFormLookup;
					}
					//base["formType"] = this.formType;
					base["entityId"] = this.props.formId;
					base["editorDataField"] = this.props.dataField ? _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField) : this.props.xml.name;
					base["innerId"] = this.props.xml.id;
					base["componentItemName"] = _GOTUtil2.default.getComponentItemName(this.props.dataField);
					base["minWidth"] = $(this.inputgroup).width();
					base["isPop"] = this.props.dropDownMode == "pop";
					base["formType"] = "FormModule";
					// if(window.isDataSetView && this.props.xml.Properties.Extends){
					// 	base["extends"] = this.props.xml.Properties.Extends;
					// }
					this.lookupKey = _FormLookupFactory2.default.getKey(base);
					var moduleLookup = _FormLookupFactory2.default.createFormLookup(base, this.props.dropDownMode);
					//this.moduleLookup = moduleLookup;
					if (!moduleLookup) return;
					if (moduleLookup.isCustom) {
						this.isCustomDropDown = true;
						var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + moduleLookup.formName);
						iframe.attr("src", "form.html?menuItemId=FormLookup&formId=" + moduleLookup.formName + "&lookUp=true&lookUpPop=" + base["isPop"] + "&fromEntity=" + base["entityId"] + "&fromInnerId=" + base["innerId"]);
						window.parent.window.$("#noPopLookupForm").append(iframe);
						window.parent.window.nowStringEditorInstance = this;
						return;
					}
					// if(window.isDataSetView ){
					// 	window.hasDataSetViewLookup = true;
					// }
					this.lookupStates.lookup = _reactDom2.default.render(moduleLookup, lookupdiv.get(0));
				}
	
				//lookupdiv.css("display","none");
				var lookup = this.lookupStates.lookup;
	
				this.buildLookupArg(lookup);
				this.buildExtralWhereItem(lookup);
	
				if (window.isDataSetView) {
					var form = _GOT2.default.getForm(this.props.formId);
					var entity = _GOTUtil2.default.getFormItemInnerXML(form, this.props.xml.id);
					window.parent.window.lookupEditorDoMain = entity.Properties.doMain;
				}
				_LookupActions2.default.lookupRefresh(this.props.formId, this.props.xml.id);
	
				if (typeof lookup.queryBoxClear === "function") {
					lookup.queryBoxClear();
				}
	
				window.nowLookupInstance = lookup;
	
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					this.dropDownBakToolBarObject = Object.assign({}, _parentWindow.lastToolBarObject);
					_parentWindow.setToolBar(this.toolBarObject);
				}
				_UtilActions2.default.updateInnerToolBar(this.toolBarObject);
				if (this.props.dropDownMode == "pop") {
					this.lookupStates.isShowed = true;
				} else {
					this.onLookupCmp();
				}
				if (lookupdiv.hasClass("modal")) lookupdiv.css("display", "flex");else lookupdiv.css("display", "block");
				this.attachEventListeners();
				//this.setFocusDropDown = true;
				this.inputField.focus();
				return true;
			}
		}, {
			key: 'buttonDownClick',
			value: function buttonDownClick(e) {
				if (!($(this.inputgroup).is(document.activeElement) || $(this.inputgroup).find(document.activeElement).length)) e.preventDefault();
	
				/*let result = {};
	   FocusActions.currentGroupGet(result);
	   
	   		if(result.currentGroup != this.props.control.group)
	   {
	   	if(result.currentGroup)
	   		result.currentGroup.onRecordAutoSave(result.currentGroup.groupAlias);
	   	if(window.rowChangeAutoSaveFail)
	   		return;
	   }*/
				return this.showDropDown();
			}
		}, {
			key: 'attachEventListeners',
			value: function attachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
				this.applyEvents(this.lookupEvents);
			}
		}, {
			key: 'detachEventListeners',
			value: function detachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
			}
		}, {
			key: 'applyEvents',
			value: function applyEvents(evs) {
				for (var i = 0, el, ch, ev; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			}
		}, {
			key: 'unapplyEvents',
			value: function unapplyEvents(evs) {
				for (var i = 0, el, ev, ch; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			}
		}, {
			key: 'onBeforeAutoSave',
			value: function onBeforeAutoSave(groupAlias, results) {
				if (this.props.groupAlias != groupAlias) return true;
				if ($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length) {
					var text = $(this.inputField).val();
					var _val = _FormItemStringResolver2.default.getResult(text, this.props.trim, this.props.changeCase, this.props.stringSize, this.props.regular);
					if (_val.indexOf(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG) == 0) {
						return false;
					}
					if (this.props.groupAlias == "") {
						this.record = _val;
					} else {
						var changed = false;
						var oldValue = this.record[this.props.dataField];
						var newValue = _val;
						if (oldValue != newValue) changed = true;
						this.record[this.props.dataField] = newValue;
						//alert("派发");	
						if (changed) {
							_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
							if (this.props.control) {
								var result = this.props.control.doFieldModifiedRemote(this.props.dataField, newValue, oldValue, this.record, this);
								if (results) results.put(result);
							}
						}
						this.updateModifiedTag();
					}
				}
				return true;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (value == '-点此填值-') {
					$(this.inputField).val('');
					value = '';
				}
				if (value == null || value == undefined) value = $(this.inputField).val();
	
				value = _FormItemStringResolver2.default.getResult(value, this.props.trim, this.props.changeCase, this.props.stringSize, this.props.regular);
				if (value.indexOf(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG) == 0) {
					_Warn2.default.show({ text: value.substr(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG.length) });
					return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
				}
				if (!this.props.dataField) {
					var oldValue = this.record;
					if (this.props.stringSize && this.props.stringSize > 0 && this.props.stringSize < value.length) {
						_Warn2.default.show({ text: "字段：" + this.props.label + ' 所输入内容超出字段设定长度 ' + this.props.stringSize + " 请重新输入！！" });
					}
					this.record = value;
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var newValue = value;this.record = value;
						if (this.props.control && oldValue != newValue && triggerModified) {
							if (this.state.underQueryGroup) {
								//TODO 在QueryGroup下的时候 此处如果返回命令中存在wirteEditor到别的文本框
								//会导致当前文本框失去焦点并写入空值  而此时还没有进行setDisplay回显 所以加个延迟
								var control = this.props.control;
								setTimeout(function () {
									control.doModifiedEditor(oldValue, newValue, this);
								}, 100);
							} else {
								this.props.control.doModifiedEditor(oldValue, newValue, this);
							}
						}
					}
				} else {
					if (!this.record) return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
	
					if (this.props.stringSize && this.props.stringSize > 0 && this.props.stringSize < _newValue.length) {
						_Warn2.default.show({ text: "字段：" + this.props.label + ' 所输入内容超出字段设定长度 ' + this.props.stringSize + " 请重新输入！！" });
					}
	
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue, _oldValue, null, this);
					}
					this.updateModifiedTag();
				}
				return _FormItemConst2.default.EDITOR_VALUE_CHANGED_SUC;
			}
		}, {
			key: 'restoreValue',
			value: function restoreValue(_value) {
				if (!this.props.dataField) {
					this.record = _value;
				} else if (this.record) {
					this.record[this.props.dataField] = _value;
				}
				this.setDisplay();
				this.updateModifiedTag();
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				if (this.lookupStates.isShowed) return;
	
				//console.log("失去焦点");
				if (this.state.underQueryGroup) {
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test($(this.inputField).val())) {
						$(this.inputField).val('-只查空值-');
						this.record = '-只查空值-';
						this.state.nullValue = true;
						this.inQueryGroup = true;
					} else {
						if ($(this.inputField).val() == '') {
							this.setState({ allowEdit: false, nullValue: false });
							this.inQueryGroup = false;
						} else {
							this.inQueryGroup = true;
						}
					}
					this.state.notNull = false;
				}
				if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) {
					this.setFinalValue();
					//todo 值回送数据完成以后 严格按照显示要求再进行显示
					this.setDisplay();
	
					//this.getInputMsg();
				}
				if (this.holdFocus) {
					var $inputField = $(this.inputField);
					//setTimeout(function(){$inputField.focus();}, 0);
					$(window).focus();
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				$(this.inputField).val(value);
			}
		}, {
			key: 'inputContentFocus',
			value: function inputContentFocus() {
				$(this.inputField).focus();
				$(this.inputField).select();
			}
		}, {
			key: 'inputContentBlur',
			value: function inputContentBlur() {
				if (this.props.underQueryGroup) {
					this.setState({ allowEdit: false });
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				//alert(this.props.label+"触发了");
				if (window.rowChangeAutoSaveFail == true) return;
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				if (this.onLookupReturning == true) return;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
				//alert('focus');
				if (window.rowChangeAutoSaveFail == true) return;
				if (!this.props.dataField) {
	
					$(this.inputField).val(this.record);
				} else {
					var _recordValue = this.record == null ? "" : this.record[this.props.dataField];
					$(this.inputField).val(_recordValue);
				}
				if (this.state.underQueryGroup) {
					if ($(this.inputField).val() == '-只查空值-') {
						$(this.inputField).val('');
						this.record = '';
					}
				}
	
				if (this.state.displayHeight < 2) {
					var _parentWindow = window;
					if (_parentWindow.notClickFocusEditor) {
						_parentWindow = window;
					} else if (window.parent.window.notClickFocusEditor) {
						_parentWindow = window.parent.window;
					}
					if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
						$(this.inputField).select();
					}
				}
			}
		}, {
			key: 'inputFieldDbClick',
			value: function inputFieldDbClick() {
				$(this.inputField).select();
				if (this.props.underQueryGroup) {
					this.setState({ allowEdit: true, nullValue: false });
				}
			}
		}, {
			key: 'inputFieldOnClick',
			value: function inputFieldOnClick() {
				if (this.props.underQueryGroup) {
					this.state.notNull = false;
					this.setState({ allowEdit: true, nullValue: false });
					this.inQueryGroup = true;
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				this.inQueryGroup = false;
			}
		}, {
			key: 'textOnChange',
			value: function textOnChange(e) {
				this.state.nullValue = false;
				var nowTxt = $(this.inputField).val();
				if (!this.props.queryOnTextChanging) {
					//alert(FormItemConst.WILDCARD);
					if (nowTxt.indexOf(_FormItemConst2.default.WILDCARD) != -1) {
						var _id = _CommonUtil2.default.delayFunc(500, this, this.doAsteriskRefresh, nowTxt);
					}
				} else {
					_CommonUtil2.default.delayFunc(1000, this, this.queryOnTypingSlow, nowTxt);
				}
				//LookupActions.lookupRefresh(this.props.formId,this.props.xml.id);
			}
		}, {
			key: 'queryOnTypingSlow',
			value: function queryOnTypingSlow(historyText) {
				if ($(this.inputField).val() == historyText) {
					if (historyText.indexOf(_FormItemConst2.default.WILDCARD) == -1) historyText = _FormItemConst2.default.WILDCARD + historyText + _FormItemConst2.default.WILDCARD;
					if (this.lookupStates.isShowed) {
						_LookupActions2.default.lookupasteriskRefresh(this.props.formId, this.props.xml.id, historyText);
					} else {
						this.showDropDown();
					}
				}
			}
		}, {
			key: 'doAsteriskRefresh',
			value: function doAsteriskRefresh(historyText) {
				if ($(this.inputField).val() == historyText) {
					//如果一个星号的话 跟原来一样 如果有两个星号 分四种情况 **xxx-->*xxx*  xxx**-->*xxx*  xx**xx-->*xx*xx*  ***->* 四种情况已测
					var result = historyText;
					var dtag = _FormItemConst2.default.WILDCARD + _FormItemConst2.default.WILDCARD;
					var flag = false;var dindex = result.indexOf(dtag);
					if (dindex != -1) {
						var reg = new RegExp("[\\" + _FormItemConst2.default.WILDCARD + "]{2,}", "g");
						result = result.replace(reg, _FormItemConst2.default.WILDCARD);
						//result = result.replace(/[\*]{2,}/g,"*");//2个及以上替换成一个
						if (result.charAt(0) != _FormItemConst2.default.WILDCARD) result = _FormItemConst2.default.WILDCARD + result;
						if (result.charAt(result.length - 1) != _FormItemConst2.default.WILDCARD) result = result + _FormItemConst2.default.WILDCARD;
					}
	
					if (this.lookupStates.isShowed) {
						_LookupActions2.default.lookupasteriskRefresh(this.props.formId, this.props.xml.id, result);
					} else {
						this.laterFitlerText = result;
						this.showDropDown();
					}
				} else {}
			}
		}, {
			key: 'onLookupDropDownClose',
			value: function onLookupDropDownClose(formId, innerId) {
				if (this.props.formId == formId && this.props.xml.id == innerId) {
					this.closeDropDown();
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (13 == e.keyCode && this.lookupStates.isShowed) {
					return;
				}
				if (13 == e.keyCode && this.state.displayHeight > 1 && this.state.allowEdit) {
					var keyboardArg = this.props.control ? this.props.control.propertyKeyDownEvent : null;
					if (keyboardArg) {
						for (var _i2 = 0; _i2 < keyboardArg.keyCodeArgs.length; _i2++) {
							var keyCodeArg = keyboardArg.keyCodeArgs[_i2];
							if (keyCodeArg.ctrlKey == e.ctrlKey && keyCodeArg.shiftKey == e.shiftKey && (keyCodeArg.keyCode == e.keyCode || keyCodeArg.keyCode == e.charCode)) {
								e.preventDefault();
								var callBackArg = { remoteClass: "gongqi.erp.gotmodel.form.remote.KeyCodeResult" };
								callBackArg.ctrlKey = e.ctrlKey;
								callBackArg.shiftKey = e.shiftKey;
								callBackArg.keyCode = e.keyCode;
								setTimeout(this.doKeyBoardServer.bind(this), 1000, callBackArg);
							}
						}
					}
					return;
				}
				if (_get(FormItemStringEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditor.prototype), 'onKeyDownHandler', this).call(this, e)) return;
				if (40 === e.keyCode || 38 === e.keyCode) {
					//let ne = e["nativeEvent"];
					if (this.lookupStates.isShowed) {
						e.preventDefault();
						e.stopPropagation();
						if (e.ctrlKey && e.keyCode == 38) {
							this.closeDropDown();
						} else {
							_LookupActions2.default.lookupHostKeydown(this.lookupKey, e);
						}
					} else if (e.ctrlKey && e.keyCode == 40) {
						e.preventDefault();
						e.stopPropagation();
						if ($(this.downArrowButton).is(":visible")) this.showDropDown();
					}
				} else if (13 == e.keyCode && this.lookupStates.isShowed) {
					e.preventDefault();
					e.stopPropagation();
					_LookupActions2.default.lookupHostKeydown(this.lookupKey, e);
				} else if (27 == e.keyCode && this.lookupStates.isShowed) {
					e.preventDefault();
					e.stopPropagation();
					this.closeDropDown();
				} else if (!this.props.allowKeyIn) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
			}
		}, {
			key: 'onCmdUpdateControlProperty',
			value: function onCmdUpdateControlProperty(name, property, value, moduleInstanceId) {
				var result = _get(FormItemStringEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditor.prototype), 'onCmdUpdateControlProperty', this).call(this, name, property, value, moduleInstanceId);
				if (name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId) return;
				if (property == _ControlPropertyConst2.default.IMEENABLE) {
					this.setState({ imeEnabel: value });return true;
				}
				return false;
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					if (this.state.displayHeight > 1) {
						var that = this;
						setTimeout(function () {
							$(that.inputField).focus();
							that.inputField.setSelectionRange(0, 0);
						}, 200);
					} else {
						var _that = this;
						setTimeout(function () {
							$(_that.inputField).focus();
							$(_that.inputField).select();
						}, 200);
					}
				}
			}
		}, {
			key: 'getTextAreaDom',
			value: function getTextAreaDom(displayHeight) {
				var _this2 = this;
	
				var _style = { resize: 'none', padding: '2px', backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR };
				if (this.state.allowEdit) {
					_style = { resize: 'none', padding: '2px' };
					var heightProValue = this.props.control.getProperty_Height(); //heightProValue = "100%";
					if (heightProValue == "100%") _style.height = "100%";
					if (heightProValue) _style.height = heightProValue + "px";
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (!this.state.imeEnabel) _style.imeMode = 'disabled';
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
					return _react2.default.createElement('textarea', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.props.xml.id,
						className: 'form-control', rows: displayHeight, style: _style, onKeyDown: this.onKeyDownHandler.bind(this),
						onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this)
					});
				} else {
	
					var _heightProValue = this.props.control.getProperty_Height();
					if (_heightProValue) _style.height = _heightProValue + "px";
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (!this.state.imeEnabel) _style.imeMode = 'disabled';
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
					return _react2.default.createElement('textarea', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.props.xml.id, readOnly: 'readonly',
						className: 'form-control', rows: displayHeight, style: _style, onKeyDown: this.onKeyDownHandler.bind(this),
						onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this)
					});
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this3 = this;
	
				if (this.state.allowEdit) {
					var _style = { padding: '2px', paddingRight: '13px', height: (this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT) + 'px', fontSize: "12px", width: _width };
					_style.textAlign = this.props.textAlign.toLowerCase();
					if (this.state.dropDownNumKeyBoard) {
						_style.paddingRight = '24px';
					}
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (!this.state.imeEnabel) _style.imeMode = 'disabled';
					var _type = this.props.control.getDisplayAsPassword() ? "password" : "text";
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
					var helpText = this.props.control.getProperty_HelpText();
					if (this.props.underQueryGroup) {
						if (this.props.initRecord && typeof this.props.initRecord == 'string') {
							var _defaultValue = this.props.initRecord;
							if (this.hasLookup) {
								_style.paddingRight = '24px';
								return _react2.default.createElement(
									'div',
									{ style: { position: 'relative', width: '100%', height: '100%' } },
									_react2.default.createElement('input', { title: helpText, spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
											return _this3.inputField = node;
										}, className: 'form-control', id: "input" + this.props.xml.id, type: _type, style: _style,
										onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
										onChange: this.textOnChange.bind(this), onDoubleClick: this.inputFieldDbClick.bind(this), value: _defaultValue }),
									_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '12px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
								);
							} else {
								return _react2.default.createElement(
									'div',
									{ style: { position: 'relative', width: '100%', height: '100%' } },
									_react2.default.createElement('input', { title: helpText, spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
											return _this3.inputField = node;
										}, className: 'form-control', id: "input" + this.props.xml.id, type: _type, style: _style,
										onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
										onChange: this.textOnChange.bind(this), onDoubleClick: this.inputFieldDbClick.bind(this), value: _defaultValue }),
									_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '3px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
								);
							}
						} else {
	
							// onFocus={this.inputContentFocus.bind(this)} onBlur={this.inputContentBlur.bind(this)}
							if (this.hasLookup) {
								_style.paddingRight = '24px';
								return _react2.default.createElement(
									'div',
									{ style: { position: 'relative', width: '100%', height: '100%' } },
									_react2.default.createElement('input', { title: helpText, ref: function ref(node) {
											return _this3.inputField = node;
										}, className: 'form-control', id: "input" + this.props.xml.id, type: _type, style: _style,
										onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
										onChange: this.textOnChange.bind(this), onDoubleClick: this.inputFieldDbClick.bind(this) }),
									_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '12px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
								);
							} else {
								return _react2.default.createElement(
									'div',
									{ style: { position: 'relative', width: '100%', height: '100%' } },
									_react2.default.createElement('input', { title: helpText, ref: function ref(node) {
											return _this3.inputField = node;
										}, className: 'form-control', id: "input" + this.props.xml.id, type: _type, style: _style,
										onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
										onChange: this.textOnChange.bind(this), onDoubleClick: this.inputFieldDbClick.bind(this) }),
									_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '3px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
								);
							}
						}
					} else {
						if (this.props.initRecord && typeof this.props.initRecord == 'string') {
							var _defaultValue2 = this.props.initRecord;
							return _react2.default.createElement('input', { title: helpText, spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this3.inputField = node;
								}, className: 'form-control', id: "input" + this.props.xml.id, type: _type, style: _style,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
								onChange: this.textOnChange.bind(this), onDoubleClick: this.inputFieldDbClick.bind(this), value: _defaultValue2 });
						} else {
							return _react2.default.createElement('input', { title: helpText, spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this3.inputField = node;
								}, className: 'form-control', id: "input" + this.props.xml.id, type: _type, style: _style,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
								onChange: this.textOnChange.bind(this), onDoubleClick: this.inputFieldDbClick.bind(this) });
						}
					}
				} else {
					var _style2 = { padding: '2px', paddingRight: '13px', height: (this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT) + 'px', backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px", width: _width };
					_style2.textAlign = this.props.textAlign.toLowerCase();
					if (this.state.dropDownNumKeyBoard) {
						_style2.paddingRight = '24px';
					}
					if (this.props.cssStyle) {
						Object.assign(_style2, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style2.color = this.state.color;
					// TODO_YL 修改  根据 bindStyle 命令 改变 不可编辑字段的背景颜色
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style2.backgroundColor = this.state.backgroundColor;
	
					if (this.state.fontSize && this.state.fontSize != -1) _style2.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style2.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style2.fontWeight = this.state.fontWeight;
					if (!this.state.imeEnabel) _style2.imeMode = 'disabled';
					if (this.props.customStyle) Object.assign(_style2, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
	
						if (this.props.initRecord && typeof this.props.initRecord == 'string') {
							var defaultValue = this.props.initRecord;
							return _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
										return _this3.inputField = node;
									}, className: 'form-control', id: "input" + this.props.xml.id, type: 'text', style: _style2,
									onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
									readOnly: 'readonly', autoComplete: 'off', onDoubleClick: this.inputFieldDbClick.bind(this), value: defaultValue, onClick: this.inputFieldOnClick.bind(this) })
							);
						} else {
							_style2.textAlign = 'center';
							var defaultValue = "-点此填值-";
							return _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
										return _this3.inputField = node;
									}, className: 'form-control', id: "input" + this.props.xml.id, type: 'text', style: _style2,
									onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
									readOnly: 'readonly', autoComplete: 'off', onDoubleClick: this.inputFieldDbClick.bind(this), value: defaultValue, onClick: this.inputFieldOnClick.bind(this) })
							);
						}
					} else {
						if (this.props.initRecord && typeof this.props.initRecord == 'string') {
							var defaultValue = this.props.initRecord;
							return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
									return _this3.inputField = node;
								}, className: 'form-control', id: "input" + this.props.xml.id, type: 'text', style: _style2,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
								readOnly: 'readonly', autoComplete: 'off', onDoubleClick: this.inputFieldDbClick.bind(this), value: defaultValue });
						} else {
							return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
									return _this3.inputField = node;
								}, className: 'form-control', id: "input" + this.props.xml.id, type: 'text', style: _style2,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this),
								readOnly: 'readonly', autoComplete: 'off', onDoubleClick: this.inputFieldDbClick.bind(this) });
						}
					}
				}
			}
		}, {
			key: 'showNumKeyBoard',
			value: function showNumKeyBoard() {
				var _offset1 = $(this.inputField).offset();
				var _offset2 = $(window.frameElement).offset();
				var _inputwidth = $(this.inputField).width();
				var _inputheight = $(this.inputField).height() + 7;
				window.parent.window.showNumKeyBoard("clear", _offset1, _offset2, _inputwidth, _inputheight, this.calculatorReturnHandler.bind(this));
	
				$(window.parent.document).find("#jqcalculator_percentage").css('display', 'block');
				$(window.parent.document).find("#jqcalculator_decimal").css('display', 'block');
			}
		}, {
			key: 'calculatorReturnHandler',
			value: function calculatorReturnHandler(result) {
				if (result && this.state.allowEdit) {
					this.setFinalValue(result);
					//值回送数据完成以后 严格按照显示要求再进行显示
					this.setDisplay();
				}
	
				$(this.inputField).focus();
				$(this.inputField).select();
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this4 = this;
	
				// if(this.state.dropDownNumKeyBoard)
				// {
				// 	if(this.state.allowEdit)
				// 		return <i ref={node => this.downArrowButton = node} onMouseDown={this.showNumKeyBoard.bind(this)} className="fa fa-keyboard-o"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
				// 	else
				// 		return null;
				// }
	
				if (this.state.allowEdit && this.hasLookup) {
					/*return	({has:true,dom:<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 4px 4px'}}  onMouseDown={this.buttonDownClick.bind(this)}>
	          			<i className="fa fa-sort-desc"></i>
	    		</span>});*/
	
					if (this.state.dropDownNumKeyBoard) {
	
						return { has: true, dom: _react2.default.createElement('i', { ref: function ref(node) {
									return _this4.downArrowButton = node;
								}, onMouseDown: this.buttonDownClick.bind(this), className: 'fa fa-sort-desc', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 24px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } }) };
					} else {
	
						return { has: true, dom: _react2.default.createElement('i', { ref: function ref(node) {
									return _this4.downArrowButton = node;
								}, onMouseDown: this.buttonDownClick.bind(this), className: 'fa fa-sort-desc', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 11px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } }) };
					}
				} else if (!this.state.allowEdit && this.hasLookup) {
					/*return	({has:false,dom:<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 4px 4px',display:"none"}}  onMouseDown={this.buttonDownClick.bind(this)}>
	          			<i className="fa fa-sort-desc"></i>
	    		</span>});*/
					if (this.state.dropDownNumKeyBoard) {
						return { has: false, dom: _react2.default.createElement('i', { ref: function ref(node) {
									return _this4.downArrowButton = node;
								}, onMouseDown: this.buttonDownClick.bind(this), className: 'fa fa-sort-desc', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 24px)', fontSize: '11px', cursor: 'pointer', display: 'none', zIndex: 3 } }) };
					} else {
	
						return { has: false, dom: _react2.default.createElement('i', { ref: function ref(node) {
									return _this4.downArrowButton = node;
								}, onMouseDown: this.buttonDownClick.bind(this), className: 'fa fa-sort-desc', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 11px)', fontSize: '11px', cursor: 'pointer', display: 'none', zIndex: 3 } }) };
					}
				}
	
				return undefined;
			}
		}, {
			key: 'getNumKeyBoardDom',
			value: function getNumKeyBoardDom() {
				var _this5 = this;
	
				if (this.state.dropDownNumKeyBoard) {
					if (this.state.allowEdit) return _react2.default.createElement('i', { ref: function ref(node) {
							return _this5.downArrowButtonNum = node;
						}, onMouseDown: this.showNumKeyBoard.bind(this), className: 'fa fa-keyboard-o', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });else return null;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				//let inputgroupWidth = this.props.displayLengthWidth+"px";
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var displayHeight = this.state.displayHeight;
				var displayLength = this.state.displayLength;
	
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) {
					_notNullStyle['visibility'] = 'hidden';
				} else if (this.props.underQueryGroup) {
					_notNullStyle['visibility'] = 'hidden';
				}
				var editorStyle = { display: 'flex', flexShrink: 0, flexDirection: 'row', alignItems: 'center' };
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
	
				// _notNullStyle['display']='none';
				if (displayHeight > 1) {
					var textAreaDom = this.getTextAreaDom(displayHeight);
					var downArrowButtonDomObj = this.getDownArrowButtonDom();
					var downArrowButtonDom = downArrowButtonDomObj ? downArrowButtonDomObj.dom : downArrowButtonDomObj;
					var keyborddom = this.getNumKeyBoardDom();
					var widthProValue = this.props.control.getProperty_Width();
					var heightProValue = this.props.control.getProperty_Height();
					//widthProValue = "100%";heightProValue = "100%";
					var inputgroupStyle = { width: _width + "px" };
	
					if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
						inputgroupStyle.width = widthProValue;editorStyle.width = "100%";
					}
	
					//if(widthProValue == "100%"){editorStyle.width = "100%";inputgroupStyle.width = "100%"}
					if (heightProValue == "100%") {
						editorStyle.height = "100%";inputgroupStyle.height = "100%";
					}
					var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
					if (!this.state.label) {
						labelStyle.display = "none";_notNullStyle.display = "none";
					}
					return _react2.default.createElement(
						'div',
						{ id: this.props.xml.name, ref: function ref(node) {
								return _this6.element = node;
							}, className: 'editorGroup', style: editorStyle },
						_react2.default.createElement(
							'label',
							{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
									return _this6.componentLabel = node;
								},
								style: labelStyle },
							this.state.label
						),
						_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
						_react2.default.createElement(
							'div',
							{ className: 'input-group', ref: function ref(node) {
									return _this6.inputgroup = node;
								}, style: inputgroupStyle },
							textAreaDom,
							downArrowButtonDom,
							keyborddom,
							_react2.default.createElement('i', { ref: function ref(node) {
									return _this6.modifiedTag = node;
								}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display }, alt: '\u5DF2\u4FEE\u6539' })
						)
					);
				} else {
	
					var _downArrowButtonDomObj = this.getDownArrowButtonDom();
					var _downArrowButtonDom = _downArrowButtonDomObj ? _downArrowButtonDomObj.dom : _downArrowButtonDomObj;
					var _widthProValue = this.props.control.getProperty_Width();
					var middleStyle = {};
					if (_widthProValue && _widthProValue.indexOf && _widthProValue.indexOf("%") != -1) {
						_width = "100%";middleStyle.width = _widthProValue;editorStyle.width = "100%";
					} else {
						_width += "px";
					}
					var inputdom = this.getInputDom(_width);
					var _keyborddom = this.getNumKeyBoardDom();
					/*if(this.hasLookup && this.state.allowEdit)//有下拉框并且可编辑的情况下
	    	inputdom = this.getInputDom(_width-18+'px');
	    else
	    	inputdom = this.getInputDom(_width+'px')
	    let inputgroupWidth = _width;*/
	
					var _labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
					// if(this.state.underQueryGroup)
					// {
					// 	labelStyle.cursor = "pointer";
					// 	if(!this.inQueryGroup && !this.props.underQueryGroup)
					// 		labelStyle.color = "#CFCFCF";
					// }
					if (!this.state.label) {
						_labelStyle.display = "none";_notNullStyle.display = "none";
					}
					return _react2.default.createElement(
						'div',
						{ id: this.props.xml.name, ref: function ref(node) {
								return _this6.element = node;
							}, className: 'editorGroup', style: editorStyle },
						_react2.default.createElement(
							'label',
							{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
									return _this6.componentLabel = node;
								},
								style: _labelStyle, onClick: this.labelClickHandler.bind(this) },
							this.state.label
						),
						_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
						_react2.default.createElement(
							'div',
							{ className: 'input-group', ref: function ref(node) {
									return _this6.inputgroup = node;
								}, style: middleStyle },
							inputdom,
							_downArrowButtonDom,
							_keyborddom,
							_react2.default.createElement('i', { ref: function ref(node) {
									return _this6.modifiedTag = node;
								}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
						)
					);
				}
			}
		}]);
	
		return FormItemStringEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemStringEditor;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _FormItemTimeResolver = __webpack_require__(61);
	
	var _FormItemTimeResolver2 = _interopRequireDefault(_FormItemTimeResolver);
	
	var _FormItemTimeDisplay = __webpack_require__(75);
	
	var _FormItemTimeDisplay2 = _interopRequireDefault(_FormItemTimeDisplay);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(323);
	
	var FormItemTimeEditor = function (_FormItemEditor) {
		_inherits(FormItemTimeEditor, _FormItemEditor);
	
		function FormItemTimeEditor(props) {
			_classCallCheck(this, FormItemTimeEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemTimeEditor.__proto__ || Object.getPrototypeOf(FormItemTimeEditor)).call(this, props));
	
			_this.initMembers();
			_this.initStores();
			return _this;
		}
	
		_createClass(FormItemTimeEditor, [{
			key: 'initMembers',
			value: function initMembers() {
	
				this.lookupEvents = [[$(document), {
					'mousedown touchstart': $.proxy(function (e) {
						console.log("执行到了注册的事件侦听 是否已卸载");
						if (!($(this.inputFieldContainer).is(e.target) || $(this.inputFieldContainer).find(e.target).length || this.dropdownform.is(e.target) || this.dropdownform.find(e.target).length)) {
							this.closeDropDown();
						}
					}, this)
				}]];
			}
		}, {
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) {
					if (typeof this.unsubscribeRecordFieldChangeStore == "function") this.unsubscribeRecordFieldChangeStore();
					if (typeof this.unsubscribeAutoSaveBeforeStore == "function") this.unsubscribeAutoSaveBeforeStore();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemTimeEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemTimeEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.underQueryGroup) {
					return;
				}
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
					//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:"";
					this.setDisplay(_value);
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
				//else 
				//	alert("observer is this!");
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemTimeEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemTimeEditor.prototype), 'componentDidMount', this).call(this);
				//super.componentDidMount();
				//此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
				//不能获得焦点的比如下拉框div仍然可以使得input失去焦点
				/*$(this.refs.inputdomtime).blur(function(event){
	   	  
	    	  $(this).val("06-06");
	   });*/
				var _initRecord = void 0;
				if (this.props.dataField) {
					_initRecord = this.props.initRecord;
				} else {
					if (this.props.control.hasInitEditorValue) {
						_initRecord = this.props.initEditorValue;
					} else {
						_initRecord = this.props.initRecord;
					}
					//_initRecord = this.props.initEditorValue;
				}
				this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					this.setState({ allowEdit: false });
				} else if (nowAllowEdit == false && enable == true) {
					this.setState({ allowEdit: true });
				}
			}
		}, {
			key: 'onBeforeAutoSave',
			value: function onBeforeAutoSave(groupAlias) {
				if (this.props.groupAlias != groupAlias) return;
				if ($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length) {
					var text = $(this.inputField).val();
					var _val = _FormItemTimeResolver2.default.getResult(text, false);
					if (_val.indexOf("false:") == 0) {
						alert(_val.substr(6));
						return;
					}
					if (this.props.groupAlias == "") {
						this.record = _val;
					} else {
						var changed = false;
						var oldValue = this.record[this.props.dataField];
						var newValue = _val;
						if (oldValue != newValue) changed = true;
						this.record[this.props.dataField] = newValue;
						//alert("派发");	
						if (changed) {
							_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
							if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
						}
						this.updateModifiedTag();
					}
				}
				return true;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (this.props.underQueryGroup) {
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test($(this.inputField).val())) {
						$(this.inputField).val('-只查空值-');
						this.record = '-只查空值-';
						value = '-只查空值-';
						this.state.nullValue = true;
					} else if ($(this.inputField).val() == '-只查空值-' || $(this.inputField).val() == '-') {
						$(this.inputField).val('-只查空值-');
						value = '-只查空值-';
					} else if (value == '-点此填值-') {
						$(this.inputField).val('-点此填值-');
						value = '';
					} else {
						if (!value) value = $(this.inputField).val();
						value = _FormItemTimeResolver2.default.getResult(value, false);
					}
				} else {
					if (!value) value = $(this.inputField).val();
					value = _FormItemTimeResolver2.default.getResult(value, false);
				}
				if (value.indexOf("false:") == 0) {
					_Fade2.default.show(value.substr(6));
					return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
				}
				if (!this.props.dataField) {
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var oldValue = this.record;var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue);
						}
					}
					this.record = value;
				} else {
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "");
					}
					this.updateModifiedTag();
				}
	
				return _FormItemConst2.default.EDITOR_VALUE_CHANGED_SUC;
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				if (this.lookupStates && this.lookupStates.isShowed) {
					return;
				}
				if (this.props.underQueryGroup && $(this.inputField).val() == "") {
					this.state.notNull = false;
					this.setState({ allowEdit: false, nullValue: false });
					this.inQueryGroup = false;
				} else {
					if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) {
						this.setFinalValue();
						//todo 值回送数据完成以后 严格按照显示要求再进行显示
						this.setDisplay();
					}
				}
	
				if (this.holdFocus) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (this.props.underQueryGroup && this.record == '-只查空值-') {
					return;
				}
				if (value == undefined || value == null) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
	
				//let _displayStyle = this.props.control.getProperty_DisplayStyle();
				var _dislayFormat = this.props.displayFormat;
				if (_dislayFormat) {
					value = _FormItemTimeDisplay2.default.getDisplayText2(value, _dislayFormat);
				} else {
					value = _FormItemTimeDisplay2.default.getDisplayText(value, this.props.showHour, this.props.showMinute, this.props.showSecond);
				}
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'closeDropDown',
			value: function closeDropDown() {
				if (this.dropDownShowed) {
	
					var lookupdiv = this.dropdownform;
					if (lookupdiv == null) return;
					this.detachEventListeners();
	
					lookupdiv.remove();
					this.dropDownShowed = false;
					this.dropdownform = null;
					this.focusByCloseDropDrown = true;
					this.inputField.focus();
					this.inputField.select();
					return false;
				}
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				if (this.dropDownShowed == true) {
					this.closeDropDown();
					return;
				}
				var $dropdown = this.getDropDownHtml();
				$('body').append($dropdown);
	
				var nowVal = this.record;
				if (this.record && typeof this.record == "string") {
					var hourLis = $(".dateTimeWrap #selHour>ol>li");
					var minuteList = $(".dateTimeWrap #selMinute>ol>li");
					var secondsList = $(".dateTimeWrap #selSecond>ol>li");
					var _arr = nowVal.split(":");
					var nowHour = _arr[0];var nowMinute = _arr[1];var nowSecond = _arr[2];
					for (var i = 0; i < hourLis.length; i++) {
						var item = hourLis[i];
						if ($(item).html() == nowHour) {
							hourLis.removeClass("cur");
							$(item).addClass("cur");
							$(item).parent().scrollTop($(item).offset().top - $(item).height());
							break;
						}
					}
	
					for (var k = 0; k < minuteList.length; k++) {
						var _item = minuteList[k];
						if ($(_item).html() == nowMinute) {
							minuteList.removeClass("cur");
							$(_item).addClass("cur");
							$(_item).parent().scrollTop($(_item).offset().top - $(_item).height());
							break;
						}
					}
					for (var _k = 0; _k < secondsList.length; _k++) {
						var _item2 = secondsList[_k];
						if ($(_item2).html() == nowSecond) {
							secondsList.removeClass("cur");
							$(_item2).addClass("cur");
							$(_item2).parent().scrollTop($(_item2).offset().top - $(_item2).height());
							break;
						}
					}
				}
	
				this.dropdownform = $dropdown;
				var lookupdiv = $dropdown;
				var _inputwidth = $(this.inputField).width(); //this.props.displayLengthWidth;
				var _iframewidth = lookupdiv.outerWidth();
	
				var _iframeheight = lookupdiv.outerHeight();
	
				var _gwidth = $("#app").width();
				var _gheight = $("#app").height();
	
				if (_iframewidth > _gwidth) {
					_iframewidth = _gwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				}
				var _offset = $(this.inputField).offset();
				var _y = _offset.top;
				var _x = _offset.left;
				var _top = _y + $(this.inputField).height();
				//alert('x:'+_x+'y:'+_y);
				//下方屏幕放不下
				if (_top + _iframeheight > _gheight) {
					//上下都放不下 考虑缩减高度
					if (_iframeheight > _y) {
						//上方空间大
						if (_y > _gheight / 2) {
							lookupdiv.height(_y - 2);
							_top = '0px';
						} else //下方空间大
							{
								lookupdiv.css("height", _gheight - _top + 'px');
							}
					} else //下拉框置于上方
						{
							_top = _y - _iframeheight + 'px';
						}
				}
				var _left = _x - (_iframewidth - _inputwidth) / 2;
				//(_iframewidth-_inputwidth)/2;
				if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 5;
				if (_left < 0) _left = 0;
	
				lookupdiv.css({ left: _left + 'px', top: _top });
				this.dropDownShowed = true;
				this.inQueryGroup = true;
				this.attachEventListeners();
			}
		}, {
			key: 'attachEventListeners',
			value: function attachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
				this.applyEvents(this.lookupEvents);
	
				this.dropdownform.find("ul>li>ol>li").on("click", this.timeLiClickHandler.bind(this));
				this.dropdownform.find("#ensure").on("click", this.timeEnsureHandler.bind(this));
				this.dropdownform.find("#curTime").on("click", this.timeNowEnsureHandler.bind(this));
			}
		}, {
			key: 'detachEventListeners',
			value: function detachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
				this.dropdownform.find("ul>li>ol>li").off();
				this.dropdownform.find("#ensure").off();
				this.dropdownform.find("#curTime").off();
			}
		}, {
			key: 'timeLiClickHandler',
			value: function timeLiClickHandler(e) {
				$(e.target).parent().find("li").removeClass("cur");
				$(e.target).addClass("cur");
			}
		}, {
			key: 'timeEnsureHandler',
			value: function timeEnsureHandler(e) {
				var selectedLi = this.dropdownform.find("li.cur");
				var timeStr = "";
				for (var i = 0; i < selectedLi.length; i++) {
					var li = $(selectedLi[i]);
					timeStr = timeStr + li.text() + ":";
				}
				timeStr = timeStr.substring(0, timeStr.length - 1);
				if (timeStr.split(":").length < 3) {
					timeStr += ":00";
				}
				$(this.inputField).val(timeStr);
				this.closeDropDown();
			}
		}, {
			key: 'timeNowEnsureHandler',
			value: function timeNowEnsureHandler(e) {
				var _date = new Date();
	
				var hours = _date.getHours();
				if (hours < 10) hours = "0" + hours;
				var minutes = _date.getMinutes();
				if (minutes < 10) minutes = "0" + minutes;
				var seconds = _date.getSeconds();
				if (seconds < 10) seconds = "0" + seconds;
				var timeStr = hours + ":" + minutes + ":" + seconds;
				$(this.inputField).val(timeStr);
				this.closeDropDown();
			}
		}, {
			key: 'applyEvents',
			value: function applyEvents(evs) {
				for (var i = 0, el, ch, ev; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			}
		}, {
			key: 'unapplyEvents',
			value: function unapplyEvents(evs) {
				for (var i = 0, el, ev, ch; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				if (this.focusByCloseDropDrown == true) {
					this.focusByCloseDropDrown = false;
					return;
				}
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
				if (this.props.underQueryGroup && this.record == '00:00:00') {
					this.record = '';
				}
				if (!this.props.dataField) {
					$(this.inputField).val(this.record);
				} else {
					var _recordValue = this.record == null ? "" : this.record[this.props.dataField];
					$(this.inputField).val(_recordValue);
				}
				if (this.state.underQueryGroup) {
					if ($(this.inputField).val() == '-只查空值-') {
						$(this.inputField).val('');
						this.record = '';
					}
				}
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (_get(FormItemTimeEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemTimeEditor.prototype), 'onKeyDownHandler', this).call(this, e)) return;
				if (!e.ctrlKey && e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'getDropDownHtml',
			value: function getDropDownHtml() {
				return $('<div class="dateTimeWrap" style="padding-top:0px;background: #FFFFFF;border: 1px solid #CDCDCD;box-shadow: 0 2px 6px 0 rgba(0,0,0,0.14);border-radius: 2px;display: block;height: 240px; width: 180px;"><div class="timePart" style=""><ul style="display:flex;padding-left: 0px;border-top:none;margin-bottom:7px"><li id="selHour"><p>时</p><ol style="border-right:none;"><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li></ol></li><li id="selMinute"><p>分</p><ol><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li><li>24</li><li>25</li><li>26</li><li>27</li><li>28</li><li>29</li><li>30</li><li>31</li><li>32</li><li>33</li><li>34</li><li>35</li><li>36</li><li>37</li><li>38</li><li>39</li><li>40</li><li>41</li><li>42</li><li>43</li><li>44</li><li>45</li><li>46</li><li>47</li><li>48</li><li>49</li><li>50</li><li>51</li><li>52</li><li>53</li><li>54</li><li>55</li><li>56</li><li>57</li><li>58</li><li>59</li></ol></li><li id="selSecond"><p>秒</p><ol><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li><li>24</li><li>25</li><li>26</li><li>27</li><li>28</li><li>29</li><li>30</li><li>31</li><li>32</li><li>33</li><li>34</li><li>35</li><li>36</li><li>37</li><li>38</li><li>39</li><li>40</li><li>41</li><li>42</li><li>43</li><li>44</li><li>45</li><li>46</li><li>47</li><li>48</li><li>49</li><li>50</li><li>51</li><li>52</li><li>53</li><li>54</li><li>55</li><li>56</li><li>57</li><li>58</li><li>59</li></ol></li></ul><div class="timeFooter"><span id="ensure">确定</span><span id="curTime">当前时间</span></div></div></div>');
			}
		}, {
			key: 'showDropFocus',
			value: function showDropFocus() {
				if (this.props.underQueryGroup) {
					this.setState({ allowEdit: true });
					$(this.inputField).val('');
					this.record = '';
					this.showDropDown();
				}
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this2 = this;
	
				if (this.state.allowEdit) {
					if (this.props.underQueryGroup) {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this2.downArrowButton = node;
							}, onClick: this.showDropDown.bind(this), className: 'fa fa-clock-o', style: { position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					} else {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this2.downArrowButton = node;
							}, onClick: this.showDropDown.bind(this), className: 'fa fa-clock-o', style: { display: 'none', position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					}
				} else {
					if (this.props.underQueryGroup) {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this2.downArrowButton = node;
							}, onClick: this.showDropFocus.bind(this), className: 'fa fa-clock-o', style: { position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					} else {
						return _react2.default.createElement('i', { ref: function ref(node) {
								return _this2.downArrowButton = node;
							}, onClick: this.showDropFocus.bind(this), className: 'fa fa-clock-o', style: { display: 'none', position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					}
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				this.inQueryGroup = false;
			}
		}, {
			key: 'inputFieldOnClick',
			value: function inputFieldOnClick() {
				if (this.props.underQueryGroup) {
					this.state.notNull = false;
					this.setState({ allowEdit: true, nullValue: false });
					this.inQueryGroup = true;
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this3 = this;
	
				if (this.state.allowEdit) {
					var height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style = { padding: '2px 13px 2px 2px', height: height + 'px', width: _width, fontSize: "12px" };
					_style.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
	
						_style.border = 'none';
						_style.height = parseInt(height) - 2 + 'px';
						_width = _width.replace('px', '');
						_style.width = parseInt(_width) + 11 + 'px';
	
						return _react2.default.createElement(
							'div',
							{ style: { position: 'relative', width: '100%', height: '22px', marginRight: '12px', border: '1px solid #ccc' } },
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this3.inputField = node;
								}, id: "input" + this.props.xml.id, type: 'text',
								className: 'form-control', style: _style,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '14px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this3.inputField = node;
							}, id: "input" + this.props.xml.id, type: 'text',
							className: 'form-control', style: _style,
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				} else {
					var _height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						_height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style2 = { padding: '2px 13px 2px 2px', height: _height + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
					_style2.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style2, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style2.color = this.state.color;
					if (this.state.fontSize && this.state.fontSize != -1) _style2.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style2.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style2.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style2, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
						_width = _width.replace('px', '');
						_style2.width = parseInt(_width) + 25 + 'px';
						var defaultValue = '-点此填值-';
						_style2.textAlign = 'center';
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this3.inputField = node;
								}, id: "input" + this.props.xml.id, type: 'text', readOnly: 'readonly',
								className: 'form-control', style: _style2,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this), value: defaultValue, onClick: this.inputFieldOnClick.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '14px', top: '3px', zIndex: '1000', display: 'none' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
						_style2.paddingRight = '2px';
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this3.inputField = node;
							}, id: "input" + this.props.xml.id, type: 'text', readOnly: 'readonly',
							className: 'form-control', style: _style2,
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				}
			}
		}, {
			key: 'showDownArrow',
			value: function showDownArrow() {
				if (this.props.underQueryGroup) {
					return;
				}
				if (this.state.allowEdit) {
					$(this.downArrowButton).show();
				}
			}
		}, {
			key: 'hideDownArrow',
			value: function hideDownArrow() {
				if (this.props.underQueryGroup) {
					return;
				}
				if (this.state.allowEdit) {
					$(this.downArrowButton).hide();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var inputWidth = this.props.displayLengthWidth + "px";
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var displayLength = this.state.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) {
					_notNullStyle['visibility'] = 'hidden';
				} else if (this.props.underQueryGroup) {
					_notNullStyle['visibility'] = 'hidden';
				}
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
	
				var widthProValue = this.props.control.getProperty_Width();
				var middleStyle = { position: "relative" };
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
				}
	
				var inputdom = this.getInputDom(_width);
				var dropDownButton = this.getDownArrowButtonDom();
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				// if(this.state.underQueryGroup && !this.inQueryGroup)
				// {
				// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				// }
				if (!this.state.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				}
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, ref: function ref(node) {
							return _this4.contextMenuHandler = node;
						}, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ style: middleStyle, ref: function ref(node) {
								return _this4.inputFieldContainer = node;
							}, onMouseEnter: this.showDownArrow.bind(this), onMouseLeave: this.hideDownArrow.bind(this) },
						inputdom,
						dropDownButton,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this4.modifiedTag = node;
							}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
					)
				)
	
				/*<div className="form-group" style={{marginRight:'auto'}}>
	     <label className="col-sm-2 control-label" style={{paddingLeft:'5px',paddingRight:'5px',width:'auto'}}>{this.props.xml.name}</label>
	     <div className="col-sm-10" style={{width:'auto',paddingLeft:'5px'}}>
	          <input ref='inputdomtime' type="text" className="form-control" style={{padding:'2px',width:inputWidth}}></input>
	     </div>
	   </div>*/
				;
			}
		}]);
	
		return FormItemTimeEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemTimeEditor;

/***/ },
/* 97 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemDateTimeDisplay = function () {
					function FormItemDateTimeDisplay() {
									_classCallCheck(this, FormItemDateTimeDisplay);
					}
	
					_createClass(FormItemDateTimeDisplay, null, [{
									key: "getDisplayText",
									value: function getDisplayText(value) {
													return value;
									}
					}, {
									key: "getDisplayText2",
									value: function getDisplayText2(value, displayFormat) {
													if (!value) return value;
													var date = new Date(value);
													return FormItemDateTimeDisplay.dateFormat2(displayFormat, date); //date.format(displayFormat);
									}
					}, {
									key: "dateFormat2",
									value: function dateFormat2(fmt, date) {
													var o = {
																	"M+": date.getMonth() + 1, //月份 
																	"D+": date.getDate(), //日 
																	"H+": date.getHours(), //小时 
																	"N+": date.getMinutes(), //分 
																	"S+": date.getSeconds() //秒 
													};
													if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
													for (var k in o) {
																	if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
													}return fmt;
									}
					}]);
	
					return FormItemDateTimeDisplay;
	}();
	
	exports.default = FormItemDateTimeDisplay;

/***/ },
/* 98 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemLongResolver = function () {
		function FormItemLongResolver() {
			_classCallCheck(this, FormItemLongResolver);
		}
	
		_createClass(FormItemLongResolver, null, [{
			key: "formatResult",
			value: function formatResult(value) {
				var reg1 = /^-0+$/;
				var reg2 = /^0+$/;
	
				if (reg1.exec(value) != null) {
					return "0";
				}
	
				if (reg2.exec(value) != null) {
					return "0";
				}
				return value;
			}
		}, {
			key: "getResult",
			value: function getResult() {
				var input = arguments[0];
				var notnull = arguments[1];
				var allowNegative = arguments[2];
				if (input == "") input = "0";
				if (typeof input == "number") {
					input = input + "";
				}
				var regFloat = /^(-?\d+)(\.\d+)?$/;
				var regInteger = /^-?\d+$/;
				var result;
	
				if (regInteger.exec(input) != null) {
	
					//匹配整数成功
	
					if (input.charAt(0) == "-") {
						if (!allowNegative) {
							result = Math.abs(Number(input));
							if (result > FormItemLongResolver.LONG_MAX) return "false:max";
							if (result == 0 && notnull) return "false:不允许为空";
							return input.substr(1);
							//String(Math.abs(Number(input)));
						} else {
							result = Number(input);
							if (result < FormItemLongResolver.LONG_MIN) return "false:min";
						}
					}
	
					result = Number(input);
					if (result > FormItemLongResolver.LONG_MAX) return "false:max";
					if (result == 0 && notnull) return "false:不允许为空";
					return FormItemLongResolver.formatResult(input);
					//return value;
				}
	
				if (regFloat.exec(input) != null) {
					//匹配浮点数
					if (input.charAt(0) == "-") {
						if (!allowNegative) {
							result = Math.abs(Number(input));
							if (result > FormItemLongResolver.LONG_MAX) return "false:max";
							//var number:Number = Math.abs(Number(value));
							if (result == 0 && notnull) return "false:不允许为空";
							return input.substr(1);
						} else {
							result = Number(input);
							if (result < FormItemLongResolver.LONG_MIN) return "false:min";
						}
					}
	
					result = Number(input);
					if (result > FormItemLongResolver.LONG_MAX) return "false:max";
					if (result == 0 && notnull) return "false:不允许为空";
					return input;
				}
	
				return "false:输入格式有误";
			}
		}]);
	
		return FormItemLongResolver;
	}();
	
	FormItemLongResolver.LONG_MAX = 999999999999999;
	FormItemLongResolver.LONG_MIN = -999999999999999;
	exports.default = FormItemLongResolver;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemStringResolver = function () {
		function FormItemStringResolver() {
			_classCallCheck(this, FormItemStringResolver);
		}
	
		_createClass(FormItemStringResolver, null, [{
			key: "getResult",
			value: function getResult() {
				var input = arguments[0];
				//0-->Trim
				var _trim = arguments[1];
				/*//1-->Intercept
	   var _intercept:String = agrs[1] as String;*/
				//2-->ChangeCase
				var _changeCase = arguments[2];
				//3 --> StringSize
				var _stringSize = arguments[3];
				//4 --> Reg
				var regPro = arguments[4];
				//5 --> notNull
				var _notNull = arguments[5];
	
				var result = FormItemStringResolver.trim(_trim, input);
	
				result = FormItemStringResolver.changeCase(_changeCase, result);
	
				if (_notNull == true && (result == "" || result == null)) return FormItemStringResolver.RESOLVER_FALSE_TAG + "不允许空值";
	
				if (regPro.indexOf("##") != -1) {
					var a = regPro.split("##");
					var regResult = a[0];
					var regStr = a[1];
				} else {
					regResult = result + "不符合正则表达式:" + regPro;
					regStr = regPro;
				}
	
				if (regStr != null && regStr != "") {
					var partten = new RegExp(regStr);
					//"^((([1-9]\\d*\\.?\\d*)|(0\\.\\d*[1-9]))\\*?[1-9]\\d*((,?)|(\\+?)))*");
					var partternArr = partten.exec(result);
					//if(partten.exec(result) == null)
					//if(result.search(partten) == -1)
					//alert(JSON.stringify(partternArr));
					if (partternArr == null) {
						return FormItemStringResolver.RESOLVER_FALSE_TAG + regResult;
					} else {
						if (partternArr[0] != result) return FormItemStringResolver.RESOLVER_FALSE_TAG + regResult;
					}
				}
	
				return result;
			}
		}, {
			key: "changeCase",
			value: function changeCase(type, input) {
				switch (type) {
					case "None":
						return input;
					case "Lower":
						return input.toLowerCase();
					case "Upper":
						return input.toUpperCase();
					default:
						return input;
				}
			}
		}, {
			key: "trim",
			value: function trim(type, input) {
				switch (type) {
					case "None":
						return input;
					case "Left":
						return _StringUtil2.default.trimLeft(input);
					case "Right":
						return _StringUtil2.default.trimRight(input);
					case "LeftRight":
						return _StringUtil2.default.trimLeftRight(input);
					case "Through":
						return _StringUtil2.default.trimThrough(input, " ");
					default:
						return input;
				}
			}
		}]);
	
		return FormItemStringResolver;
	}();
	
	FormItemStringResolver.RESOLVER_FALSE_TAG = "fase!@#)l:";
	exports.default = FormItemStringResolver;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ToolBarActions = __webpack_require__(87);
	
	var _ToolBarActions2 = _interopRequireDefault(_ToolBarActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToolBarPrintStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_ToolBarActions2.default.print, 'print');
	    },
	    print: function print(_value) {
	        //this.values.push(_value);
	        this.trigger(_value);
	    }
	});
	
	exports.default = ToolBarPrintStore;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(300);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemEnumStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemEnumStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 102 */,
/* 103 */,
/* 104 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GOTXML2Json = function () {
		function GOTXML2Json() {
			_classCallCheck(this, GOTXML2Json);
		}
	
		_createClass(GOTXML2Json, null, [{
			key: "getXMLDoc",
			value: function getXMLDoc(str) {
				var element;
				if (window.DOMParser) {
					var getxml = new DOMParser();
					var xmlDoc = getxml.parseFromString(str, "text/xml");
					element = xmlDoc.childNodes[0];
				}
				return element;
			}
		}, {
			key: "parseAttributes",
			value: function parseAttributes(xml, jo) {
				var atts = xml.attributes;
				for (var k = 0; k < atts.length; k++) {
					var att = atts[k];
					//alert(att.nodeName + att.textContent);
					jo[att.nodeName] = att.nodeValue || att.textContent;
				}
			}
		}, {
			key: "parseProperties",
			value: function parseProperties(xml, jo) {
				var objs = {};
				jo["Properties"] = objs;
	
				var ps = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
				for (var k = 0; k < ps.length; k++) {
					var p = ps[k];
					if (p.nodeName == "Property") {
						var obj = {};
						GOTXML2Json.parseAttributes(p, obj);
						var pChildren = p.children || function () {
							// 兼容IE
							var pChildren = [];
							$.each(p.childNodes, function (i, e) {
								if (Object.prototype.toString.call(e) === "[object Element]") {
									// 判断是元素节点
									pChildren.push(e);
								}
							});
							return pChildren;
						}();
						var name = pChildren[0].innerHTML || pChildren[0].textContent.replace(/[\r\n]/g, "").replace(/\ +/g, "");
						var value = pChildren[1].innerHTML || pChildren[1].textContent.replace(/[\r\n]/g, "").replace(/\ +/g, "");
						//alert(name + value);
						obj["Value"] = value;
						objs[name] = obj;
						//alert(JSON.stringify(objs));
					}
				}
	
				return ps;
			}
		}, {
			key: "parseFormDataSources",
			value: function parseFormDataSources(xml) {
				var jo = {};
				jo["qname"] = "FormDataSources";
				GOTXML2Json.parseAttributes(xml, jo);
				jo["id"] = "FormDataSources";
	
				var jarray = [];
				jo["DataSources"] = jarray;
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
	
				for (var i = 0; i < childs.length; i++) {
					var child = childs[i];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					} else if (nodeName == "FormDataSource") {
						jarray.push(GOTXML2Json.parseFormDataSource(child));
					}
				}
	
				return jo;
			}
		}, {
			key: "parseFormDataSourceField",
			value: function parseFormDataSourceField(xml) {
				var jo = {};
				jo["qname"] = "FormDataSourceField";
				GOTXML2Json.parseAttributes(xml, jo);
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
				for (var x = 0; x < childs.length; x++) {
					var child = childs[x];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					}
				}
	
				return jo;
			}
		}, {
			key: "parseFormDataSourceFieldGroups",
			value: function parseFormDataSourceFieldGroups(xml) {
				var jo = {};
				jo["qname"] = "FormDataSourceFieldGroups";
				GOTXML2Json.parseAttributes(xml, jo);
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
	
				for (var x = 0; x < childs.length; x++) {
					var child = childs[x];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					}
				}
	
				return jo;
			}
		}, {
			key: "parseFormDataSource",
			value: function parseFormDataSource(xml) {
				var jo = {};
				jo["qname"] = "FormDataSource";
				GOTXML2Json.parseAttributes(xml, jo);
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
				for (var i = 0; i < childs.length; i++) {
					var child = childs[i];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					} else if (nodeName == "FormDataSourceFields") {
						var jarray = [];
						jo["FormDataSourceFields"] = jarray;
						var ffs = child.children || function () {
							// 兼容IE
							var children = [];
							$.each(child.childNodes, function (i, e) {
								if (Object.prototype.toString.call(e) === "[object Element]") {
									// 判断是元素节点
									children.push(e);
								}
							});
							return children;
						}();
						for (var j = 0; j < ffs.length; j++) {
							var ff = ffs[j];
							var ffNodeName = ff["nodeName"];
							if (ffNodeName == "Properties") {
								GOTXML2Json.parseProperties(ff, jo);
							} else {
								jarray.push(GOTXML2Json.parseFormDataSourceField(ff));
							}
						}
					} else if (nodeName == "FormDataSourceFieldGroups") {
						var jarray = [];
						jo["FormDataSourceFieldGroups"] = jarray;
						var ffs = child.children || function () {
							// 兼容IE
							var children = [];
							$.each(xml.childNodes, function (i, e) {
								if (Object.prototype.toString.call(e) === "[object Element]") {
									// 判断是元素节点
									children.push(e);
								}
							});
							return children;
						}();
						for (var j = 0; j < ffs.length; j++) {
							var ff = ffs[j];
							var ffNodeName = ff["nodeName"];
							if (ffNodeName == "Properties") {
								GOTXML2Json.parseProperties(ff, jo);
							} else {
								jarray.push(GOTXML2Json.parseFormDataSourceFieldGroups(ff));
							}
						}
					} else if (nodeName == "FormDataSourceRelation") {
						var jarray = [];
						jo["FormDataSourceRelation"] = jarray;
						var ffs = child.children || function () {
							// 兼容IE
							var children = [];
							$.each(child.childNodes, function (i, e) {
								if (Object.prototype.toString.call(e) === "[object Element]") {
									// 判断是元素节点
									children.push(e);
								}
							});
							return children;
						}();
						for (var j = 0; j < ffs.length; j++) {
							var ff = ffs[j];
							var ffNodeName = ff["nodeName"];
							if (ffNodeName == "Properties") {
								GOTXML2Json.parseProperties(ff, jo);
							} else {
								jarray.push(GOTXML2Json.parseFormDataSourceField(ff));
							}
						}
					}
				}
	
				return jo;
			}
		}, {
			key: "parseFormDesign",
			value: function parseFormDesign(xml) {
				var jo = {};
				jo["qname"] = "FormDesign";
				GOTXML2Json.parseAttributes(xml, jo);
				jo["id"] = "FormDesign";
				jo["parentId"] = 0;
				var jarray = [];
				jo["FormItem"] = jarray;
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
				for (var i = 0; i < childs.length; i++) {
					var child = childs[i];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					} else {
						jarray.push(GOTXML2Json.parseFormItem(child, "FormDesign"));
					}
				}
	
				return jo;
			}
		}, {
			key: "parseFormItem",
			value: function parseFormItem(xml, parentId) {
				var jo = {};
				jo["qname"] = "FormItem";
				jo["parentId"] = parentId;
				GOTXML2Json.parseAttributes(xml, jo);
	
				var jarray = [];
				jo["FormItem"] = jarray;
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
				for (var i = 0; i < childs.length; i++) {
					var child = childs[i];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					} else {
						jarray.push(GOTXML2Json.parseFormItem(child, jo["id"]));
					}
				}
	
				return jo;
			}
		}, {
			key: "parseForm",
			value: function parseForm(xml) {
				var jo = {};
				jo["qname"] = "Form";
				GOTXML2Json.parseAttributes(xml, jo);
	
				var childs = xml.children || function () {
					// 兼容IE
					var children = [];
					$.each(xml.childNodes, function (i, e) {
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
				}();
	
				for (var i = 0; i < childs.length; i++) {
					var child = childs[i];
					var nodeName = child.nodeName;
					if (nodeName == "Properties") {
						GOTXML2Json.parseProperties(child, jo);
					} else if (nodeName == "FormDataSources") {
						jo[nodeName] = GOTXML2Json.parseFormDataSources(child);
					} else if (child.nodeName == "FormDesign") {
						jo[nodeName] = GOTXML2Json.parseFormDesign(child);
					}
				}
	
				return jo;
			}
		}]);
	
		return GOTXML2Json;
	}();
	
	exports.default = GOTXML2Json;

/***/ },
/* 105 */,
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _ArrayUtil = __webpack_require__(70);
	
	var _ArrayUtil2 = _interopRequireDefault(_ArrayUtil);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FocusController = function () {
	      function FocusController(itemDesign, formModule) {
	            _classCallCheck(this, FocusController);
	
	            this.focusableItemsQue = [];
	            this.focusableItemsQue1 = [];
	
	            this.formModule = formModule;
	            this.consQue(itemDesign);
	      }
	
	      _createClass(FocusController, [{
	            key: 'isLocationSkip',
	            value: function isLocationSkip(baseGroup, target) {
	                  var type = target.type;
	                  if (type != "DataGrid" && type.indexOf("Editor") == -1) return true;
	                  if ($("#Editor" + target.id).is(":hidden")) return true;
	
	                  var _menuItemId = this.formModule.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId;
	
	                  var targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(_menuItemId, this.formModule.formId, target.id));
	
	                  if (typeof targetFormItemControl.isUnderQueryGroup == "function" && targetFormItemControl.isUnderQueryGroup()) return true;
	
	                  if (typeof targetFormItemControl.isSameMainSource == "function" && !targetFormItemControl.isSameMainSource(baseGroup)) return true;
	
	                  if (targetFormItemControl.getProperty_ActualSkipTab()) return true;
	
	                  return false;
	            }
	      }, {
	            key: 'setFocusAfterNewRecord',
	            value: function setFocusAfterNewRecord(baseGroup) {
	                  if (this.focusableItemsQue == null || this.focusableItemsQue.length == 0) return;
	                  var isLookup = this.formModule.classAlias == "FormModuleLookup";
	                  for (var i = 0; i < this.focusableItemsQue.length; i++) {
	                        var focusableItem = this.focusableItemsQue[i];
	                        if (focusableItem.type == "DataGrid") {
	                              var _menuItemId = isLookup ? "FormLookup" : window.menuItemId;
	                              var targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(_menuItemId, this.formModule.props.formId, focusableItem.id));
	                              if (targetFormItemControl.group == baseGroup) {
	                                    //alert("有DataGrid");
	                                    _FocusActions2.default.afterNewRecordDataGridFocusSet(this.formModule.props.formId, focusableItem.id);
	                                    return;
	                              }
	                        }
	                  }
	                  var target = this.focusableItemsQue[0];
	                  var tempIndex = 0;
	                  while (this.isLocationSkip(baseGroup, target)) {
	                        tempIndex++;
	                        if (tempIndex >= this.focusableItemsQue.length) {
	                              break;
	                        } else if (tempIndex < 0) {
	                              tempIndex = this.focusableItemsQue.length - 1;
	                        }
	
	                        target = this.focusableItemsQue[tempIndex];
	                  }
	                  if (target.type == "DataGrid") {
	                        _FocusActions2.default.afterNewRecordDataGridFocusSet(this.formModule.props.formId, target.id);
	                  } else {
	                        _FocusActions2.default.focusSet(this.formModule.props.formId, target.id, false, false, true);
	                  }
	            }
	      }, {
	            key: 'isUnderBase',
	            value: function isUnderBase(baseControl, targetFormItemControl) {
	                  //null是最顶层
	                  if (!baseControl || !targetFormItemControl) return true;
	                  var parentControl = targetFormItemControl;
	                  while (parentControl && parentControl.classAlias != "FormItemDesignControl") {
	                        if (parentControl == baseControl) return true;
	                        parentControl = parentControl.parentControl;
	                  }
	                  return false;
	            }
	      }, {
	            key: 'initFocus',
	            value: function initFocus() {
	                  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	                  var baseControl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	                  if (this.focusableItemsQue.length > 0) {
	                        var formId = this.formModule.props.formId;
	                        var menuItemId = this.formModule.props.menuItemId;
	                        var targetItem = this.focusableItemsQue[0];
	
	                        var targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, targetItem.id));
	                        var tempIndex = 0;
	                        while (!this.isUnderBase(baseControl, targetFormItemControl) || this.isFocusSkip({ targetFormItemControl: targetFormItemControl, skipPlugin: true })) {
	                              tempIndex++;
	                              //tempIndex = index + i;
	                              if (tempIndex >= this.focusableItemsQue.length) return;
	                              targetItem = this.focusableItemsQue[tempIndex];
	                              targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, targetItem.id));
	                        }
	
	                        _FocusActions2.default.focusSet(formId, targetItem.id, false, init);
	                        //FocusActions.focusSet(formId,"10029",false);
	                  }
	            }
	
	            /*initFocusTabChanged(tabpagexml)
	            {
	               
	            }*/
	
	      }, {
	            key: 'isFocusablePlugin',
	            value: function isFocusablePlugin(item) {
	                  if (item.Properties.PluginType) return item.Properties.PluginType.Value == _FormItemConst2.default.PLUGIN_TYPE_RADIO || item.Properties.PluginType.V == _FormItemConst2.default.PLUGIN_TYPE_RADIO || item.Properties.PluginType.Value == _FormItemConst2.default.PLUGIN_TYPE_TREE || item.Properties.PluginType.V == _FormItemConst2.default.PLUGIN_TYPE_TREE;
	                  if (item.Properties.ControlType) return item.Properties.ControlType.Value == _FormItemConst2.default.PLUGIN_TYPE_RADIO || item.Properties.ControlType.V == _FormItemConst2.default.PLUGIN_TYPE_RADIO || item.Properties.ControlType.Value == _FormItemConst2.default.PLUGIN_TYPE_TREE || item.Properties.ControlType.V == _FormItemConst2.default.PLUGIN_TYPE_TREE;
	            }
	      }, {
	            key: 'consQue',
	            value: function consQue(parentItem, pparentItem) {
	                  for (var i in parentItem.FormItem) {
	                        var item = parentItem.FormItem[i];
	
	                        //所有的Editor
	                        if (item.type.indexOf("Editor") != -1) this.focusableItemsQue1.push(item);
	
	                        if (item.type.indexOf("Editor") != -1 && parentItem.type != "DataGrid" && (!pparentItem || pparentItem && pparentItem.type != "DataGrid") || item.type != "ButtonGroup" && item.type.indexOf("Button") != -1 && parentItem.type != "ButtonMenu" || item.type == "DataGrid" || item.type == "Plugin" && this.isFocusablePlugin(item)) this.focusableItemsQue.push(item);
	
	                        this.consQue(item, parentItem);
	                  }
	            }
	      }, {
	            key: 'isFocusSkip',
	            value: function isFocusSkip(args) {
	                  var targetFormItemControl = args.targetFormItemControl,
	                      skipPlugin = args.skipPlugin;
	
	                  var _name = targetFormItemControl.xml.name;
	                  if ($("#" + _name).length > 0) {
	                        if ($("#" + _name).is(":hidden")) return true;
	                  }
	
	                  if (targetFormItemControl.isSkipTab()) return true;
	                  if (skipPlugin) {
	                        if (targetFormItemControl.classAlias == "FormItemPluginControl") {
	                              return true;
	                              /*let controlType = targetFormItemControl.getProperty_ControlType();
	                              if(controlType == FormItemConst.PLUGIN_TYPE_RADIO)
	                              {
	                                    return false;
	                              }
	                              if(controlType == FormItemConst.PLUGIN_TYPE_TREE)
	                              {
	                                    return false;
	                              }*/
	                        }
	                  }
	
	                  var parentControl = targetFormItemControl.parentControl;
	                  var tabPageControl = null;
	                  while (parentControl != undefined && parentControl != null) {
	                        if (parentControl.xml && parentControl.xml.type == "TabPage") tabPageControl = parentControl;
	                        parentControl = parentControl.parentControl;
	                  }
	                  if (tabPageControl != null) {
	                        var pageId = tabPageControl.xml.name; //"tabpage"+tabPageControl.formId+tabPageControl.xml.id;
	                        var $tabpage = $("#" + pageId);
	                        if ($tabpage.length == 0 || $tabpage.css("display") == "none") return true;
	                  }
	
	                  return false;
	            }
	      }, {
	            key: 'changeFocus',
	            value: function changeFocus(item, pre) {
	                  //console.log(FormItemUtil.formItemControls);
	                  var menuItemId = this.formModule.props.menuItemId;
	                  var formId = this.formModule.props.formId;
	                  var index = _ArrayUtil2.default.indexOf(this.focusableItemsQue, item);
	                  var i = 1;
	                  var tempIndex = pre ? index - 1 : index + 1;
	                  if (tempIndex >= this.focusableItemsQue.length) {
	                        tempIndex = 0;
	                  } else if (tempIndex < 0) {
	                        tempIndex = this.focusableItemsQue.length - 1;
	                  }
	                  var targetItem = this.focusableItemsQue[tempIndex];
	                  var baseFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, item.id));
	                  var targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, targetItem.id));
	                  while (this.isFocusSkip({ targetFormItemControl: targetFormItemControl })) {
	                        pre ? tempIndex-- : tempIndex++;
	                        //tempIndex = index + i;
	                        if (tempIndex >= this.focusableItemsQue.length) {
	                              tempIndex = 0;
	                        } else if (tempIndex < 0) {
	                              tempIndex = this.focusableItemsQue.length - 1;
	                        }
	
	                        targetItem = this.focusableItemsQue[tempIndex];
	                        if (targetItem == item) {
	                              break;
	                        }
	                        targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, targetItem.id));
	                  }
	
	                  targetFormItemControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, targetItem.id));
	                  var targetGroupAlias = targetFormItemControl.groupAlias;
	
	                  var formDataSources = this.formModule.formDataSources;
	                  var currentGroup = formDataSources == null ? null : formDataSources.currentGroup;
	                  var targetGroup = targetFormItemControl.group;
	
	                  var isChangeGroup = currentGroup != targetGroup;
	
	                  var newValue;
	
	                  if (isChangeGroup && currentGroup != null) {
	                        //todo group发生切换 记录如果发生更改要先保存
	                        currentGroup.doRecordSave(true);
	                  }
	
	                  //todo 当只有一个元素的时候 要回填数据
	
	                  /*if(baseGongqiFormItem is FormItem_Editor && gongqiFormItem==baseGongqiFormItem && baseGongqiFormItem.control != null)
	                  {
	                        GongqiEditor(baseGongqiFormItem.control).setFinalValue();
	                  }
	                  formModule.focusController.findControlAndSetFocus("ctrl_"+String(target.@name));    */
	                  //alert(JSON.stringify(targetFormItemControl.xml))
	                  //targetFormItemControl.setFocus();
	                  //alert(JSON.stringify(targetItem));
	                  //alert(JSON.stringify(targetFormItemControl.xml));
	                  _FocusActions2.default.focusSet(targetFormItemControl.formId, targetItem.id, pre);
	            }
	      }]);
	
	      return FocusController;
	}();
	
	exports.default = FocusController;

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GongqiDataType = function GongqiDataType() {
		_classCallCheck(this, GongqiDataType);
	
		this.remoteClass = "gongqi.erp.gotmodel.datatype.GongqiDataType";
	};
	
	GongqiDataType.TypeString = "String";
	GongqiDataType.TypeLong = "Long";
	GongqiDataType.TypeDecimal = "Decimal";
	GongqiDataType.TypeDate = "Date";
	GongqiDataType.TypeTime = "Time";
	GongqiDataType.TypeBoolean = "Boolean";
	GongqiDataType.TypeEnum = "Enum";
	GongqiDataType.TypeComponent = "Component";
	GongqiDataType.TTypeString = "TypeString";
	GongqiDataType.TTypeLong = "TypeLong";
	GongqiDataType.TTypeDecimal = "TypeDecimal";
	GongqiDataType.TypeStringLabel = "String";
	GongqiDataType.TypeLongLabel = "Long";
	GongqiDataType.TypeDecimalLabel = "Decimal";
	GongqiDataType.TypeDateLabel = "Date";
	GongqiDataType.TypeTimeLabel = "Time";
	GongqiDataType.TypeBooleanLabel = "Boolean";
	GongqiDataType.TypeEnumLabel = "Enum";
	GongqiDataType.TypeComponentLabel = "Component";
	exports.default = GongqiDataType;

/***/ },
/* 108 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryWhereItem = //String
	//String
	//String
	//String
	
	//String
	//String	//QueryWhereLeftBracket
	//String	//QueryWhereRightBracket
	
	//String
	//String			//QueryWhereStatus
	//String	//QueryWhereFieldType
	
	//String
	function QueryWhereItem() {
		_classCallCheck(this, QueryWhereItem);
	
		this.remoteClass = "gongqi.erp.gotmodel.sqlquery.QueryWhereItem";
	};
	
	exports.default = QueryWhereItem;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageWarning = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _OpenFormArg = __webpack_require__(255);
	
	var _OpenFormArg2 = _interopRequireDefault(_OpenFormArg);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _Gongqi_ProgressBar = __webpack_require__(151);
	
	var _Gongqi_ProgressBar2 = _interopRequireDefault(_Gongqi_ProgressBar);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _OverallSituationModelDiv = __webpack_require__(152);
	
	var _OverallSituationModelDiv2 = _interopRequireDefault(_OverallSituationModelDiv);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebSocketManager = function () {
	  function WebSocketManager() {
	    _classCallCheck(this, WebSocketManager);
	  }
	
	  _createClass(WebSocketManager, null, [{
	    key: 'initWebSocket',
	    value: function initWebSocket() {
	      /*let domain = "";
	      if(window.didomain)
	        domain = "/"+didomain;*/
	      var url = window.userInfos.serviceURL.replace("http", "ws") + "/websocket_erp";
	      if ('WebSocket' in window) {
	        WebSocketManager.websocket = new WebSocket(url);
	        //websocket = new WebSocket("ws://www.gongqi.info:10201/GongqiERP/websocket_erp");
	      } else {
	        _Warn2.default.show({ text: "浏览器版本过低 不支持消息" });
	        return;
	      }
	
	      //连接发生错误的回调方法
	      WebSocketManager.websocket.onerror = WebSocketManager.webSocketOnError;
	
	      //连接成功建立的回调方法
	      WebSocketManager.websocket.onopen = WebSocketManager.webSocketOnOpen;
	
	      //接收到消息的回调方法
	      WebSocketManager.websocket.onmessage = WebSocketManager.webSocketOnMessage;
	
	      //连接关闭的回调方法
	      WebSocketManager.websocket.onclose = WebSocketManager.webSocketOnClose;
	    }
	  }, {
	    key: 'webSocketOnError',
	    value: function webSocketOnError() {
	      if (WebSocketManager.closeKey < WebSocketManager.TimeArray.length - 1) {
	        $("#messagesError").css("display", "block");
	        $("#messagesSuccess").css("display", "none");
	      } else if (WebSocketManager.closeKey == WebSocketManager.TimeArray.length - 1) {
	        _Warn2.default.show({ text: "消息连接发生错误！您可能无法正常收到消息提示，请联系管理员以免影响正常使用" });
	      }
	    }
	  }, {
	    key: 'webSocketOnOpen',
	    value: function webSocketOnOpen() {
	      WebSocketManager.heartCheck.start();
	      WebSocketManager.closeKey = 0;
	      WebSocketManager.getUnReadCounts();
	      WebSocketManager.getUnReadList();
	    }
	  }, {
	    key: 'getUnReadCounts',
	    value: function getUnReadCounts() {
	      var command = _Command2.default.createService("gongqi.erp.framework.services.MessageService", "getUnReadedCounts", "int");
	      _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: WebSocketManager.getUnReadCountsResultHandler });
	    }
	  }, {
	    key: 'getUnReadCountsResultHandler',
	    value: function getUnReadCountsResultHandler(data) {
	      if (data.status == 0) {
	        var UnReadMessageCount = data.result;
	        $("#MessageDropDownMenuContainer #Message-Number-Num").html(UnReadMessageCount);
	        if (UnReadMessageCount == 0 || UnReadMessageCount == '0') {
	          $("#Message-Number-Icon").css("display", "none");
	        } else {
	          $("#Message-Number-Icon").css("display", "block");
	        }
	        $("#Message-Number-Icon").text(UnReadMessageCount);
	        $("#Message-Number-Num").text(UnReadMessageCount);
	        if (UnReadMessageCount != WebSocketManager.oldmessagenum) {
	          WebSocketManager.oldmessagenum = UnReadMessageCount;
	          $("#famessageIcon").addClass("faa-horizontal animated");
	          $("#Message-Number-Icon").addClass("faa-bounce animated");
	          var x = setTimeout(function () {
	            clearTimeout(x);
	            $("#famessageIcon").removeClass("faa-horizontal animated");
	            $("#Message-Number-Icon").removeClass("faa-bounce animated");
	          }, 8000);
	        }
	      }
	    }
	  }, {
	    key: 'getUnReadList',
	    value: function getUnReadList() {
	      var command = _Command2.default.createService("gongqi.erp.framework.services.MessageService", "getSysMessageUnReadList", "List");
	      command.appendArg(5, "int");
	      _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: WebSocketManager.getUnReadListHandler });
	    }
	  }, {
	    key: 'getUnReadListHandler',
	    value: function getUnReadListHandler(data) {
	      /**
	       * <li>
	                      <!-- start message -->
	                      <a href="#">
	                        <div class="pull-left">
	                          zxx
	                        </div>
	                        <h4>
	                          Support Team
	                          <small><i class="fa fa-clock-o"></i> 5 mins</small>
	                        </h4>
	                        <p>Why not buy a new awesome theme?</p>
	                      </a>
	                    </li>
	       */
	
	      $("#MessageDropDownMenuContainer .menu li").remove();
	
	      var _loop = function _loop(i) {
	        var mItem = data.result[i];
	        var fromUserId = mItem.from.split(",")[1];
	        var time = mItem.time;
	        //fromUserId = "89565656448-dfd-7878";
	        if (fromUserId && fromUserId.length > 7) fromUserId = fromUserId.substr(0, 7) + "...";
	        var $div = $("<div class='pull-left' style='float: right !important;'>").html(fromUserId);
	        var small = $("<small style='color: #999999;'><i class='fa fa-clock-o'></i>" + time + "</small>");
	        var _msgLabel = mItem.bodyLabel;
	        if (_msgLabel && _msgLabel.length > 15) {
	          _msgLabel = _msgLabel.substr(0, 15) + "...";
	        }
	        var $h4 = $("<h4 style='font-weight: bold;font-size: 12px;'>").text(_msgLabel ? _msgLabel : "您有新的消息请点击阅读");
	        var $a = $("<a style='cursor:pointer'>").append($div).append($h4).append(small);
	        $a.click(function (e) {
	          window.openMessageCenter(e, mItem.messageId);
	        });
	        $("<li>").append($a).appendTo($("#MessageDropDownMenuContainer .menu"));
	      };
	
	      for (var i in data.result) {
	        _loop(i);
	      }
	    }
	  }, {
	    key: 'readSingleMessage',
	    value: function readSingleMessage() {}
	  }, {
	    key: 'webSocketOnMessage',
	    value: function webSocketOnMessage() {
	      $("#messagesError").css("display", "none");
	      $("#messagesSuccess").css("display", "block");
	      if (event.data == "HeartBeat") {
	        WebSocketManager.heartCheck.reset();
	        return;
	      }
	
	      var data_ = event.data;
	      data_ = JSON.parse(data_);
	      if (data_.type == "SysMessageTable") //接收到消息
	        {
	
	          try {
	            var _body = JSON.parse(data_.body);
	            if (_body.type == "CommandResult") {
	              var commandResult = _body.commandResult;
	              var modalList = $("#formModal .modal");
	              var formModule = null;
	              if (modalList.length > 0) {
	                var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
	              } else {
	                var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
	              }
	
	              if (nextIframe.length != 0) {
	                var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
	                formModule = win.formModuleInstance;
	                if (!formModule) return;
	                if (!commandResult.tasks) return;
	                if (commandResult.tasks.length == 0) return;
	                _CommandResolver2.default.resolve(commandResult.tasks, formModule);
	              }
	            }
	            return;
	          } catch (e) {}
	
	          //当有一般类型的消息 如果有自定义 则自定义与系统本身消息记录及数量更新都要执行
	          if (window.messageHandler) {
	            sessionStorage.setItem("new_message", event.data);
	            $("#messageContainer").load(window.messageHandler);
	          }
	          WebSocketManager.getUnReadCounts();
	          WebSocketManager.getUnReadList();
	
	          if (data_.modal == true) {
	            _Warn2.default.show({ text: data_.body, title: "管理员重要通知" });
	          }
	        }
	      if (data_.type == "SysMessageCountsChanged") //接收到消息
	        {
	          WebSocketManager.getUnReadCounts();
	          WebSocketManager.getUnReadList();
	        } else if (data_.MessageType == "Content") {
	        MessageWarning.show({
	          text: data_.body
	        });
	      } else if (data_.messageType == "openForm") {
	        var openFormArg = new _OpenFormArg2.default();
	        openFormArg.menuItemId = data_.menuItemId;
	        openFormArg.paramString = data_.parameters;
	        if (openFormArg.menuItemId == "50000027" || data_.ingnoreAu) openFormArg.ingnoreAu = true;
	
	        _CommandResolver2.default.openForm({ arg: openFormArg }, null);
	      } else if (data_.messageType == "callFormCmd" || data_.type == "callFormCmd") {
	        var dataObj = data_;
	        var menuItemId = dataObj.menuItemId;
	        var methodName = dataObj.methodName;
	        var methodArg = dataObj.argObject;
	        var arg = { methodName: methodName, methodArg: methodArg };
	
	        var commandTask = new _CommandTask2.default();
	        commandTask.cmd = _Cmd2.default.FormCmd;
	        var tasks = [commandTask];
	
	        commandTask.arg = arg;
	
	        window.toobarFunc(null, "callFormCmd", tasks);
	      } else if (data_.messageType == "ProgressBar" || data_.type == "ProgressBar") {
	        var body = JSON.parse(data_.body);
	        if (body.cmd == "popUp") {
	
	          if (!WebSocketManager.progressBar) {
	            WebSocketManager.closeMLoading();
	            WebSocketManager.progressBar = _Gongqi_ProgressBar2.default.show(body);
	          }
	
	          /*if($("#gongqi_globalProgress").length == 0)
	          {
	            let progressBar=$('<progress></progress>').css({'width':'15em','height':'2.1em'}).html('您的浏览器不支持progress元素').attr("max",body.total).attr("value",body.loaded>0?body.loaded:0);
	            let progressA=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
	            let progressBtn=$('<div></div>').append(progressA);
	            let progressDiv=$('<div></div>').css({'position':'absolute','top':'40.5%','left':'40%','display':'flex','height':'100px','align-items':'flex-end'}).append(progressBar).append(progressBtn);
	            let percentageDiv=$("<span class='globalProgress_precent'></span>").html(body.text?body.text:"");
	            let time=$("<span class='globalProgress_time'></span>");
	            let percentDiv=$('<div></div>').css({'position':'absolute','top':'79%','width':'calc(100% - 20px)','display':'flex',
	            'justify-content':'center','font-size':'0.8em'}).append(percentageDiv).append(time).appendTo(progressDiv);
	            let progressBorder=$("<div id='gongqi_globalProgress' style='display:block'></div>").append(progressDiv).addClass('modal');
	            $('body').append(progressBorder);
	          }*/
	        } else if (body.cmd == "update") {
	          if (WebSocketManager.progressBar) {
	            WebSocketManager.closeMLoading();
	            WebSocketManager.progressBar.setState({
	              title: body.title,
	              total: body.total,
	              loaded: body.loaded,
	              text: body.text
	            });
	          }
	          /*let progressBar = $("#gongqi_globalProgress progress");
	           //progressBar.attr('max',body.total);
	          progressBar.attr('value',body.loaded);
	           if(body.total>0 && (progressBar.attr('max')+"") != (body.total+""))
	            progressBar.attr('max',body.total);
	           let percentageDiv = $("#gongqi_globalProgress .globalProgress_precent")
	           if(percentageDiv.text() != body.text)
	            percentageDiv.html(body.text);*/
	        } else if (body.cmd == "close") {
	          if (WebSocketManager.progressBar) {
	            WebSocketManager.progressBar.closeHandler();
	          }
	
	          /*let progressBorder = $("#gongqi_globalProgress");
	          progressBorder.remove();*/
	        }
	      } else if (data_.type == 'SystemMaintain' && data_.body == "true") {
	        var _parentWindow = window.parent.window;
	        var userInfos = _parentWindow.userInfos || window.userInfos;
	
	        if (!userInfos.isAdmin) {
	          document.getElementById('overallSituationDiv').style = "width: 100%;height: 100%;position: absolute;top: 0;left: 0;z-index: 9999";
	          _reactDom2.default.render(_react2.default.createElement(_OverallSituationModelDiv2.default, null), document.getElementById('overallSituationDiv'));
	        }
	      } else if (data_.type == 'SystemMaintain' && data_.body == "false") {
	        document.getElementById('overallSituationDiv').style = "display:none !important";
	      }
	    }
	  }, {
	    key: 'closeMLoading',
	    value: function closeMLoading() {
	      var popIframes = $("#formModal iframe");
	      if (popIframes.length > 0) {
	        iframe = popIframes.get(popIframes.length - 1);
	        var win = void 0;
	        try {
	          win = iframe.window || iframe.contentWindow;
	        } catch (e) {}
	        if (win) {
	          win.$("body").mLoading("hide");
	        }
	      } else {
	        var arr = $("#g_tab_content>div.tab-pane.active iframe");
	        if (arr.length > 0) {
	          var iframe = arr.get(0);
	          var _win = void 0;
	          try {
	            _win = iframe.window || iframe.contentWindow;
	          } catch (e) {}
	          if (_win) {
	            _win.$("body").mLoading("hide");
	          }
	        }
	      }
	
	      window.$("body").mLoading("hide");
	    }
	  }, {
	    key: 'webSocketOnClose',
	    value: function webSocketOnClose() {
	
	      if (WebSocketManager.closeKey < WebSocketManager.TimeArray.length) {
	        setTimeout(function () {
	
	          WebSocketManager.heartCheck.stop();
	
	          WebSocketManager.initWebSocket();
	
	          WebSocketManager.closeKey += 1;
	        }, WebSocketManager.TimeArray[WebSocketManager.closeKey - 1]);
	      } else {
	        _Warn2.default.show({ text: "消息连接已关闭！您可能无法正常收到消息提示，请联系管理员以免影响正常使用" });
	      }
	    }
	  }]);
	
	  return WebSocketManager;
	}();
	
	WebSocketManager.closeKey = 0;
	WebSocketManager.TimeArray = [3000, 10000, 15000, 30000, 60000, 120000, 180000, 300000, 600000, 900000, 1800000, 3600000, 7200000];
	WebSocketManager.heartCheck = {
	  timeout: 2000, //60s
	  timeoutObj: null,
	  reset: function reset() {
	    clearTimeout(this.timeoutObj);
	    this.start();
	  },
	  start: function start() {
	    this.timeoutObj = setTimeout(function () {
	      WebSocketManager.websocket.send("HeartBeat");
	    }, this.timeout);
	  },
	  stop: function stop() {
	    clearTimeout(this.timeoutObj);
	  }
	};
	WebSocketManager.oldmessagenum = 0;
	WebSocketManager.progressBar = null;
	exports.default = WebSocketManager;
	
	var MessageWarning = exports.MessageWarning = function () {
	  function MessageWarning() {
	    _classCallCheck(this, MessageWarning);
	  }
	
	  _createClass(MessageWarning, null, [{
	    key: 'show',
	    value: function show(options) {
	
	      var defaults = {
	        state: "info",
	        backgroundColor: '#fff',
	        color: "#000",
	        text: "",
	        cornerRadius: "10",
	        fontSize: '14px',
	        interacdestroy: false,
	        confirm: {
	          isShow: true,
	          event: ''
	        },
	        cancel: {
	          isShow: false,
	          event: ''
	        }
	
	      };
	
	      var titleMsg = {
	        info: '提示信息'
	      };
	
	      var btnStyle = {
	        info: {
	          color: '#fff',
	          backgroundColor: '#3c8dbc',
	          width: '70px',
	          height: '35px',
	          padding: '5px 5px',
	          fontSize: '14px'
	        }
	      };
	
	      var btnContent = {
	        info: '确认'
	      };
	
	      $.extend(true, defaults, options);
	
	      var closeSpan = $('<span></span>').html('×').css({ 'font-size': '25px' });
	      var closeBtn = $('<button></button>').addClass('close').attr('type', 'button').append(closeSpan);
	      closeBtn.on('click', function () {
	        $(alertDiv).remove();
	      });
	      var titleH = $('<h4></h4>').addClass('modal-title').html(titleMsg[defaults.state]).css({ 'font-weight': '500' }); //判断显示内容
	      var headerDiv = $('<div></div>').addClass('modal-header').append(closeBtn).append(titleH).css({ 'padding': '10px' });
	
	      var bodyP = $('<p></p>').html(text).css({ 'font-size': defaults.fontSize });
	      var bodyDiv = $('<div></div>').addClass('modal-body').append(bodyP);
	
	      // var cancelBtn=$('<button></button>').attr('type','button').addClass('btn btn-default').html('取消').css({'width':'70px','height':'35px','padding':'5px 5px','font-size':'16px'});
	      var confirmBtn = $('<button></button>').attr('type', 'button').addClass('btn').css(btnStyle[defaults.state]).html(btnContent[defaults.state]).css('margin-right', '20px');
	      //判断是否显示取消确定按钮
	      var footerDiv = $('<div></div>').addClass('modal-footer').css({ 'border-top': 'none', 'padding-right': '30px', 'padding-bottom': '30px' });
	
	      if (defaults.confirm.isShow) footerDiv.append(confirmBtn);
	
	      if (defaults.cancel.isShow) footerDiv.append(cancelBtn);
	
	      confirmBtn.on('click', function () {
	        if (typeof defaults.confirm.event == "function") {
	          defaults.confirm.event();
	        }
	        $(alertDiv).remove();
	      });
	
	      if (defaults.cancel.event == '') {
	        cancelBtn.on('click', function () {
	          $(alertDiv).remove();
	        });
	      }
	      var contentDiv = $('<div></div>').addClass('modal-content').append(headerDiv).append(bodyDiv).append(footerDiv);
	
	      var dialogDiv = $('<div></div>').append(contentDiv).css({ 'margin': '18% auto', 'position': 'relative', 'width': 'auto', 'min-width': '390px' });
	
	      var alertDiv = $('<div></div>').addClass('modal').append(dialogDiv).css({ 'display': 'flex' });
	
	      parent.$("body").append(alertDiv);
	    }
	  }]);

	  return MessageWarning;
	}();

/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormLookupFixed = function FormLookupFixed() {
		_classCallCheck(this, FormLookupFixed);
	};
	
	exports.default = FormLookupFixed;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(313);
	
	var Attachment = function (_React$Component) {
		_inherits(Attachment, _React$Component);
	
		function Attachment(props) {
			_classCallCheck(this, Attachment);
	
			var _this = _possibleConstructorReturn(this, (Attachment.__proto__ || Object.getPrototypeOf(Attachment)).call(this, props));
	
			_this.resourceURL = window.parent.window.userInfos.resourceURL;
			_this.serviceURL = window.parent.window.userInfos.serviceURL;
			var btnState = {
				upload: true,
				download: true,
				delete: true,
				rename: true,
				open: true
			};
			_this.state = {
				tableId: _this.props.tableId,
				recId: _this.props.recId,
				formId: _this.props.formId,
				aukey: _this.props.aukey,
				btnState: btnState,
				fileList: [],
				selectedIndex: '0',
				renameIsShow: false,
				coverIsShow: false
			};
	
			return _this;
		}
	
		_createClass(Attachment, [{
			key: 'closeAttachmentHandler',
			value: function closeAttachmentHandler() {
	
				//关掉要卸载
				var $reactComponentContainer = $("#attachmentModal .modal");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				$reactComponentContainer.remove();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$("#attachmentModal .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
	
				this.doRefresh();
			}
		}, {
			key: 'doRefreshButton',
			value: function doRefreshButton() {
				//3_50000004.3
				var xmlType2SCache = _AuthorityUtil2.default.xmlType2SCache;
				if (xmlType2SCache && xmlType2SCache.hasOwnProperty(window.menuItemId)) {
					xmlType2SCache = xmlType2SCache[window.menuItemId];
					if (xmlType2SCache && xmlType2SCache.hasOwnProperty(this.props.aukey)) {
						var auNode = xmlType2SCache[this.props.aukey];
						if (auNode) {
							var btnState = {
								upload: auNode.visible + '' == "true" ? true : false,
								download: auNode.query + '' == "true" ? true : false,
								delete: auNode.exp + '' == "true" ? true : false,
								rename: auNode.edit + '' == "true" ? true : false,
								open: auNode.save + '' == "true" ? true : false
							};
							var currentWin = void 0;
							try {
								currentWin = window.getCurrentWin();
							} catch (error) {
								currentWin = window.parent.getCurrentWin();
							}
							var formModule = currentWin.formModuleInstance;
							if (formModule) {
								if (btnState.upload == true && formModule.dsAttachmentAu.hasOwnProperty("upload")) {
									btnState.upload = formModule.dsAttachmentAu["upload"];
								}
								if (btnState.rename == true && formModule.dsAttachmentAu.hasOwnProperty("rename")) {
									btnState.rename = formModule.dsAttachmentAu["rename"];
								}
								if (btnState.delete == true && formModule.dsAttachmentAu.hasOwnProperty("del")) {
									btnState.delete = formModule.dsAttachmentAu["del"];
								}
							}
	
							this.setState({ btnState: btnState });
						}
					}
				}
	
				/*var xml:XML = ClientSessionAuthority.getXmlType2SCacheItemByKey(aukey);
	   if(xml != null)
	   {
	   	btnUpLoad.enabled = String(xml.@visible) == "true"?true:false;
	   	btnDownLoad.enabled = String(xml.@query) == "true"?true:false;
	   	btnDelete.enabled = String(xml.@export) == "true"?true:false;
	   	btnRename.enabled = String(xml.@edit) == "true"?true:false;
	   	btnOpenFile.enabled = String(xml.@save) == "true"?true:false;
	   }
	   else
	   {
	   	btnUpLoad.enabled = true;
	   	btnDownLoad.enabled = true;
	   	btnDelete.enabled = true;
	   	btnRename.enabled = true;
	   	btnOpenFile.enabled = true;
	   }*/
			}
		}, {
			key: 'doRefresh',
			value: function doRefresh() {
				// if(btnUpLoad == null){上传为null
				// 	callLater(doRefreshButton,[aukey]);	
				// }else{
				// 	doRefreshButton(aukey);
				// }
	
				this.doRefreshButton();
	
				var tableId = this.state.tableId;
	
				var recId = this.state.recId;
	
				if (tableId == null || recId == null) {
					var title = "附件：";
					this.setState({
						fileList: []
					});
				} else {
					var title = "附件:" + tableId + "/" + recId;
	
					// if(lb!=null)
					// 	lb.text = "";????
	
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "listAttachments", "List");
					command.appendArg(tableId + "/" + recId);
					var that = this;
					var remoteArg = { command: command, resultFunction: this.rpc_result_getAttachmentHandler.bind(this), sync: false };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			}
		}, {
			key: 'rpc_result_getAttachmentHandler',
			value: function rpc_result_getAttachmentHandler(data) {
				this.setState({
					fileList: data.result
				});
				$(this.attachMentComponentTB).viewer({
					fullscreen: false
				});
			}
		}, {
			key: 'btnUpLoad_clickHandler',
			value: function btnUpLoad_clickHandler() {
				if (this.state.btnState.upload == false) return;
				$(this.uploaderInput).click();
			}
		}, {
			key: 'preventDe',
			value: function preventDe(e) {
				e.preventDefault();
			}
		}, {
			key: 'onDragLeaveHandler',
			value: function onDragLeaveHandler(e) {
				e.preventDefault();
				$(this.uploadPrompt).html("上传");
			}
		}, {
			key: 'onDragOverHandler',
			value: function onDragOverHandler(e) {
				e.preventDefault();
				$(this.uploadPrompt).html("松开鼠标上传");
			}
		}, {
			key: 'onDragEnterHandler',
			value: function onDragEnterHandler(e) {
				e.preventDefault();
				$(this.uploadPrompt).html("松开鼠标上传");
			}
		}, {
			key: 'onDragDrop',
			value: function onDragDrop(e) {
				e.preventDefault();
				var uploadFiles = e.target.files || e.dataTransfer.files;
				this.fileSelectedHandler(uploadFiles);
			}
		}, {
			key: 'upLoaderChangeHandler',
			value: function upLoaderChangeHandler(e) {
				var uploadFiles = e.target.files || e.dataTransfer.files;
				//var uploadFile = uploadFiles[0];
				this.fileSelectedHandler(uploadFiles);
			}
		}, {
			key: 'doFileSelected',
			value: function doFileSelected(uploadFiles) {
				var fileList = this.state.fileList;
				var fileName = uploadFiles[0].name;
				this.uploadFiles = uploadFiles;
				if (fileList.length > 0 && fileList.indexOf(fileName) > -1) {
					this.setState({ coverIsShow: true });
				} else {
					this.upLoadFileHandler();
				}
			}
		}, {
			key: 'changeUploadFileName',
			value: function changeUploadFileName(file) {
				var uploadFile = this.uploadFiles[0];
	
				var type = uploadFile.type;
	
				//上传的时候重名，更改名字
				var fileName = uploadFile.name;
				var fileList = this.state.fileList;
				if (fileName.lastIndexOf('.') != -1) {
					fileName = fileName.substring(0, fileName.lastIndexOf(".")) + "(1)" + fileName.substr(fileName.lastIndexOf("."));
				} else {
					fileName = fileName + "(1)";
				}
				while (fileList.length > 0 && fileList.indexOf(fileName) != -1) {
					if (fileName.lastIndexOf(".") != -1) {
						fileName = fileName.substring(0, fileName.lastIndexOf(".")) + "(1)" + fileName.substr(fileName.lastIndexOf("."));
					} else {
						fileName = fileName + "(1)";
					}
				}
				var finalFile = new File([uploadFile], fileName, { type: type });
				//this.uploadFiles[0]=finalFile;
				this.reNameUploadFile = finalFile;
				this.upLoadFileHandler();
			}
		}, {
			key: 'upLoadFileHandler',
			value: function upLoadFileHandler() {
				var uploadFiles = this.uploadFiles;
				var fileNames = [];
				for (var i = 0; i < uploadFiles.length; i++) {
					var upLoadFile = uploadFiles[i];
					if (i == 0 && this.reNameUploadFile) {
						upLoadFile = this.reNameUploadFile;
						this.reNameUploadFile = null;
					}
					fileNames.push(upLoadFile.name);
				}
				this.setState({ coverIsShow: false });
	
				var tableId = this.state.tableId;
				var recId = this.state.recId;
				var path = "attachments/" + tableId + "/" + recId + "/" + fileNames[0];
				var serviceURL = this.serviceURL;
				var url = serviceURL + "/FileUpLoad?path=" + encodeURIComponent(path);
	
				var domain = window.didomain;
				try //zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
				{
					if (!domain && window.parent && window.parent.window) domain = window.parent.window.didomain;
	
					if (domain) {
						var loginToken = window.loginToken;
						var loginDataArea = window.loginDataArea;
						if (window.parent && window.parent.window) {
							if (!loginToken) loginToken = window.parent.window.loginToken;
							if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
						}
						if (!loginToken) url += "&token=" + localStorage.getItem("userToken");
					}
				} catch (e) {}
	
				var oMyForm = new FormData();
				//oMyForm.append("path",path);
				for (var _i = 0; _i < uploadFiles.length; _i++) {
					var uploadFile = uploadFiles[_i];
					oMyForm.append("file" + _i, uploadFile);
				}
	
				this.client = new XMLHttpRequest();
				var progressBar = $('<progress></progress>').css({ 'width': '15em', 'height': '2.1em' }).html('您的浏览器不支持progress元素');
				var that = this;
				var progressA = $('<a></a>').css({ 'background-color': '#fff', 'color': '#ff0000', 'font-size': '1.5em' }).click(function () {
					that.client.abort();
				}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
				var progressBtn = $('<div></div>').append(progressA);
				var progressDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '40.5%', 'left': '40%', 'display': 'flex' }).append(progressBar).append(progressBtn);
				var percentageDiv = $('<span></span>');
				var time = $("<span></span>");
				var percentDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '41%', 'left': '40.5%', 'font-size': '0.8em' }).append(percentageDiv).append(time);
				var progressBorder = $("<div></div>").append(progressDiv).append(percentDiv).attr('id', 'progressBorder').addClass('modal');
				$('body').append(progressBorder);
	
				this.client.upload.onprogress = function (pe) {
	
					if (pe.lengthComputable) {
						progressBorder.css('display', 'block');
						progressBar.attr('max', pe.total);
						progressBar.attr('value', pe.loaded);
						percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
					}
					var nt = new Date().getTime(); //获取当前时间
					var pertime = (nt - this.ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
					this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
					var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
					this.oloaded = pe.loaded; //重新赋值已上传文件大小，用以下次计算
	
					//上传速度计算
					var speed = perload / pertime; //单位b/s
					var bspeed = speed;
					var units = 'b/s'; //单位名称
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'k/s';
					}
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'M/s';
					}
					speed = speed.toFixed(1);
					//剩余时间
					var resttime = ((pe.total - pe.loaded) / bspeed).toFixed(1);
	
					var timeContent = ' ' + speed + units + '，剩余时间：' + resttime + 's';
					time.html(timeContent);
				};
	
				this.client.upload.onloadstart = function () {
					//上传开始执行方法
					this.ot = new Date().getTime(); //设置上传开始时间
					this.oloaded = 0; //设置上传开始时，以上传的文件大小为0
				};
				this.client.onreadystatechange = this.uploadStateChangeHandler.bind(this, fileNames);
	
				this.client.open("POST", url, true); //+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
				this.client.withCredentials = true;
	
				this.client.onloadend = function (pe) {
					// document.getElementById('progressDiv').style.display='none';
					$('#progressBorder').remove();
				};
				this.client.send(oMyForm);
			}
		}, {
			key: 'uploadStateChangeHandler',
			value: function uploadStateChangeHandler(fileNames) {
				var that = this;
				if (this.client.readyState == 4) {
					// 4 = "loaded"
					if (this.client.status == 200) {
						var options = {
							state: 'success',
							text: '上传成功！'
						};
						_Fade2.default.show(options);
						window.afterAttachment({
							methodName: "doAttachmentUpload",
							methodArgs: [{ value: fileNames.join(), type: "String" }],
							methodName2: "attachmentUpload"
						});
						//更新列表
						//this.doRefresh();
						var fileList = this.state.fileList;
						var fileListChanged = false;
						for (var i = 0; i < fileNames.length; i++) {
							var fileName = fileNames[i];
							if (fileList.indexOf(fileName) == -1) {
								fileList.push(fileName);
								fileListChanged = true;
							}
						}
						if (fileListChanged == true) this.setState({ fileList: fileList });
	
						/*if(fileList.indexOf(fileName)==-1){
	     	fileList.push(fileName);
	     	this.setState({fileList:fileList});
	     }*/
						var _parentWindow = window.parent.window;
						if (_parentWindow) {
							_parentWindow.updateAttachmentNum(fileList.length);
						}
						window.updateAttachmentNum(fileList.length);
					} else {
						var options = {
							state: 'error',
							text: '上传失败！'
						};
						_Fade2.default.show(options);
					}
				}
				$(this.uploaderInput).val('');
			}
		}, {
			key: 'upLoadCancelHandler',
			value: function upLoadCancelHandler() {
				//取消上传
				//上传过程中取消上传
				//重名 直接取消上传
				//this.client.abort();
				if (this.client) {
					this.client.abort();
				} else {
					this.setState({
						coverIsShow: false
					});
				}
				$(this.uploaderInput).val('');
			}
		}, {
			key: 'fileSelectedHandler',
			value: function fileSelectedHandler(uploadFiles) {
	
				for (var i = 0; i < uploadFiles.length; i++) {
					var uploadFile = uploadFiles[i];
					if (uploadFile.size > 500 * 1024 * 1024) {
						var options = {
							text: '要上传的文件不允许超过500M'
						};
						_Fade2.default.show(options);
						return;
					}
				}
				this.doFileSelected(uploadFiles);
			}
		}, {
			key: 'btnDownLoad_clickHandler',
			value: function btnDownLoad_clickHandler() {
				//下载
				if (this.state.btnState.download == false) return;
	
				var selectedIndex = this.state.selectedIndex;
				var fileList = this.state.fileList;
				var selectedItem = fileList[selectedIndex];
				if (selectedItem == null || selectedItem == "") return;
				var base = this.resourceURL;
				var tableId = this.state.tableId;
				var recId = this.state.recId;
				var url = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(selectedItem);
				var domain = window.didomain;
				try //zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
				{
					if (!domain && window.parent && window.parent.window) domain = window.parent.window.didomain;
	
					if (domain) {
						var loginToken = window.loginToken;
						var loginDataArea = window.loginDataArea;
						if (window.parent && window.parent.window) {
							if (!loginToken) loginToken = window.parent.window.loginToken;
							if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
						}
						if (!loginToken) url += "?token=" + localStorage.getItem("userToken");
					}
				} catch (e) {}
	
				// /GongqiERP/resource/attachments/30102106/1993897950/loading.gif
				// var url='http://www.gongqi.info:10208/bin/'+selectedItem;
				if ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) == 'object' && url instanceof Blob) {
					url = URL.createObjectURL(url); // 创建blob地址
				}
				var a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
				a.href = url;
				a.download = selectedItem;
	
				var e = document.createEvent('MouseEvents');
				e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				a.dispatchEvent(e);
				URL.revokeObjectURL(url);
			}
		}, {
			key: 'btnDownLoad_AllAttachments',
			value: function btnDownLoad_AllAttachments() {
				//下载
				if (this.state.btnState.download == false) return;
	
				var selectedIndex = this.state.selectedIndex;
				var fileList = this.state.fileList;
				for (var i in fileList) {
					var selectedItem = fileList[i];
					if (selectedItem == null || selectedItem == "") return;
					var base = this.resourceURL;
					var tableId = this.state.tableId;
					var recId = this.state.recId;
					var url = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(selectedItem);
					var domain = window.didomain;
					try //zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
					{
						if (!domain && window.parent && window.parent.window) domain = window.parent.window.didomain;
	
						if (domain) {
							var loginToken = window.loginToken;
							var loginDataArea = window.loginDataArea;
							if (window.parent && window.parent.window) {
								if (!loginToken) loginToken = window.parent.window.loginToken;
								if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
							}
							if (!loginToken) url += "?token=" + localStorage.getItem("userToken");
						}
					} catch (e) {}
	
					// /GongqiERP/resource/attachments/30102106/1993897950/loading.gif
					// var url='http://www.gongqi.info:10208/bin/'+selectedItem;
					if ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) == 'object' && url instanceof Blob) {
						url = URL.createObjectURL(url); // 创建blob地址
					}
					var a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
					a.href = url;
					a.download = selectedItem;
	
					var e = document.createEvent('MouseEvents');
					e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
					a.dispatchEvent(e);
					URL.revokeObjectURL(url);
				}
			}
		}, {
			key: 'btnDelete_clickHandler',
			value: function btnDelete_clickHandler() {
				if (this.state.btnState.delete == false) return;
				if (!this.state.fileList || this.state.fileList.length == 0) return;
				var that = this;
				_Warn2.default.show({ text: "确定要删除该附件吗？", state: "warn",
					confirm: {
						isShow: true,
						event: function event() {
							that.doDeleteAttachment();
						}
					},
	
					cancel: {
						isShow: true
					}
				});
			}
		}, {
			key: 'doDeleteAttachment',
			value: function doDeleteAttachment() {
				//删除
				var selectedIndex = this.state.selectedIndex;
				var fileList = this.state.fileList;
				var selectedItem = fileList[selectedIndex];
				if (selectedItem != null && selectedItem != "") {
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "deleteFile", "boolean");
					var tableId = this.state.tableId;
					var recId = this.state.recId;
					command.appendArg("attachments/" + tableId + "/" + recId + "/" + selectedItem);
					var that = this;
					var remoteArg = { command: command, resultFunction: function resultFunction(data) {
							that.rpc_result_DeleteHandler(data, selectedIndex);
						}, sync: false };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			}
		}, {
			key: 'rpc_result_DeleteHandler',
			value: function rpc_result_DeleteHandler(data, selectedIndex) {
				if (data.result) {
					var fileList = this.state.fileList;
					var file = fileList.splice(selectedIndex, 1);
					this.setState({ fileList: fileList });
					var _parentWindow = window.parent.window;
					if (_parentWindow) {
						_parentWindow.updateAttachmentNum(fileList.length);
						window.updateAttachmentNum(fileList.length);
						if (Array.isArray(file)) {
							file = file.join();
						}
	
						window.afterAttachment({
							methodName: "doAttachmentDelete", methodArgs: [{ value: file, type: "String" }],
							argInfoMethod: "attachmentDelete",
							methodName2: "attachmentDelete"
						});
					}
				} else {
					var options = {
						text: '删除失败'
					};
					_Fade2.default.show(options);
				}
			}
		}, {
			key: 'btnRename_clickHandler',
			value: function btnRename_clickHandler() {
				if (this.state.btnState.rename == false) return;
				//重命名
				var selectedIndex = this.state.selectedIndex;
				var fileList = this.state.fileList;
				var selectedItem = fileList[selectedIndex];
	
				if (selectedItem != null) {
					this.setState({
						renameIsShow: true
					});
					var fileList = this.state.fileList;
					var selectedItem = fileList[selectedIndex];
					$(this.renameInput).val(selectedItem);
					$(this.renameInput).select();
				}
			}
		}, {
			key: 'doRename',
			value: function doRename() {
				var selectedIndex = this.state.selectedIndex;
				var fileList = this.state.fileList;
				var selectedItem = fileList[selectedIndex];
				if (selectedItem != null && selectedItem != "") {
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "renameFile", "boolean");
					var tableId = this.state.tableId;
					var recId = this.state.recId;
					var name = $(this.renameInput).val();
					command.appendArg("attachments/" + tableId + "/" + recId + "/" + selectedItem);
					command.appendArg(name);
					var that = this;
					var remoteArg = { command: command, resultFunction: function resultFunction(data) {
							that.rpc_result_RenameHandler(data, name, selectedIndex);
						}, sync: false };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			}
		}, {
			key: 'rpc_result_RenameHandler',
			value: function rpc_result_RenameHandler(data, name, selectedIndex) {
				if (data.result) {
					var fileList = this.state.fileList;
					var origName = fileList[selectedIndex];
					fileList[selectedIndex] = name;
	
					window.afterAttachment({
						methodName: "doAttachmentRename",
						methodArgs: [{ value: origName, type: "String" }, { value: name, type: "String" }],
						methodName2: "attachmentRename"
					});
				} else {
					var options = {
						text: '操作失败'
					};
					_Fade2.default.show(options);
				}
				this.setState({
					renameIsShow: false
				});
				$(this.renameInput).val('');
			}
		}, {
			key: 'cancelRename',
			value: function cancelRename() {
				this.setState({
					renameIsShow: false
				});
				$(this.renameInput).val('');
			}
		}, {
			key: 'cancelRename2',
			value: function cancelRename2() {
				this.setState({
					coverIsShow: false
				});
				$(this.renameInput).val('');
				$(this.uploaderInput).val('');
			}
	
			//打开
	
		}, {
			key: 'btnOpenFile_clickHandler',
			value: function btnOpenFile_clickHandler() {
	
				if (this.state.btnState.open == false) return;
	
				var selectedIndex = this.state.selectedIndex;
				var fileList = this.state.fileList;
				var selectedItem = fileList[selectedIndex];
				if (selectedItem == null) return;
	
				var tableId = this.state.tableId;
				var recId = this.state.recId;
				var base = this.resourceURL;
	
				var url = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(selectedItem);
	
				window.open(url);
			}
		}, {
			key: 'getFileTypeIcon',
			value: function getFileTypeIcon(fileType) {
				var dataOriginal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				if (!fileType) {
					return _react2.default.createElement('div', { style: { background: 'url(images/doccopy.png)', width: '24px', height: '27px', marginRight: '10px' } });
				}
				if (fileType.indexOf("xls") != -1) {
					return _react2.default.createElement('div', { style: { background: 'url(images/xls.png)', width: '24px', height: '27px', marginRight: '10px' } });
				} else if (fileType.indexOf("pdf") != -1) {
					return _react2.default.createElement('div', { style: { background: 'url(images/pdf.png)', width: '24px', height: '27px', marginRight: '10px' } });
				} else if (fileType.indexOf("ppt") != -1) {
					return _react2.default.createElement('div', { style: { background: 'url(images/ppt.png)', width: '24px', height: '27px', marginRight: '10px' } });
				} else if (fileType.indexOf("doc") != -1) {
					return _react2.default.createElement('div', { style: { background: 'url(images/doc.png)', width: '24px', height: '27px', marginRight: '10px' } });
				} else if (fileType.indexOf(".png") != -1 || fileType == "png") {
					// let src = 'images/jpg.png';
					return _react2.default.createElement('img', { 'data-original': dataOriginal, src: dataOriginal, style: { background: 'url(images/jpg.png)', width: '24px', height: '27px', marginRight: '10px' } });
					// return <div data-original={dataOriginal} style={{background:'url(images/png.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
				} else if (fileType == "jpg" || fileType.indexOf(".jpg") != -1) {
					return _react2.default.createElement('img', { 'data-original': dataOriginal, src: dataOriginal, style: { background: 'url(images/jpg.png)', width: '24px', height: '27px', marginRight: '10px' } });
					// return <div data-original={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></div>
				} else if (fileType == "bpm") {
					return _react2.default.createElement('div', { style: { background: 'url(images/jpg.png)', width: '24px', height: '27px', marginRight: '10px' } });
				} else if (fileType.indexOf("txt") != -1) {
					return _react2.default.createElement('div', { style: { background: 'url(images/txt.png)', width: '24px', height: '27px', marginRight: '10px' } });
				} else {
					return _react2.default.createElement('div', { style: { background: 'url(images/doccopy.png)', width: '24px', height: '27px', marginRight: '10px' } });
				}
			}
		}, {
			key: 'getTableContent',
			value: function getTableContent() {
				var fileList = this.state.fileList;
				var tableContent = [];
				var that = this;
				var selectedIndex = this.state.selectedIndex;
				if (fileList.length == 0) {} else {
					for (var i = 0; i < fileList.length; i++) {
						var fileName = fileList[i];
						if (i == selectedIndex) {
							var fileType = void 0;
							if (fileName) {
								fileType = fileName.substr(fileName.indexOf(".") + 1, fileType);
							}
							var tableId = this.state.tableId;
							var recId = this.state.recId;
							var base = this.resourceURL;
							var dataOriginal = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(fileList[i]);
							var fileTypeIcon = this.getFileTypeIcon(fileType, dataOriginal);
	
							tableContent.push(_react2.default.createElement(
								'tr',
								{ onClick: that.selectedChange.bind(this, i), key: i, className: 'selectedFile' },
								_react2.default.createElement(
									'th',
									{ style: { paddingTop: '10px', paddingBottom: '10px', fontFamily: 'PingFang-SC-Regular',
											fontSize: '14px', color: '#000000', fontWeight: 'normal', display: 'flex', alignItems: 'center', borderTop: 'none',
											borderBottom: '1px solid rgba(0,0,0,0.10)' } },
									fileTypeIcon,
									_react2.default.createElement(
										'div',
										{ style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } },
										fileName
									)
								)
							));
						} else {
							var _fileType = void 0;
							if (fileName) {
								_fileType = fileName.substr(fileName.indexOf(".") + 1, _fileType);
							}
							var tableId = this.state.tableId;
							var recId = this.state.recId;
							var base = this.resourceURL;
							var dataOriginal = base + "/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(fileList[i]);
							var _fileTypeIcon = this.getFileTypeIcon(_fileType, dataOriginal);
							tableContent.push(_react2.default.createElement(
								'tr',
								{ onClick: that.selectedChange.bind(this, i), key: i },
								_react2.default.createElement(
									'th',
									{ style: { paddingTop: '10px', paddingBottom: '10px', fontFamily: 'PingFang-SC-Regular', fontSize: '14px',
											color: '#000000', fontWeight: 'normal', display: 'flex', alignItems: 'center', borderTop: 'none',
											borderBottom: '1px solid rgba(0,0,0,0.10)'
										} },
									_fileTypeIcon,
									_react2.default.createElement(
										'div',
										{ style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } },
										fileName
									)
								)
							));
						}
					}
				}
				return tableContent;
			}
		}, {
			key: 'selectedChange',
			value: function selectedChange(index) {
				console.log(index);
				this.setState({
					selectedIndex: index
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _ref,
				    _this2 = this;
	
				var _style = { display: "flex", backgroundColor: "#ffffff", flexDirection: "column", flexGrow: '1', overflow: 'auto' };
				var _className = void 0;
				var btnState = this.state.btnState;
	
				var uploadColor = btnState['upload'] == true ? "#0178D4" : "#919191";
				var downloadColor = btnState['download'] == true ? "#4A90E2" : "#919191";
				var deleteColor = btnState['delete'] == true ? "#F84F59" : "#919191";
				var renameColor = btnState['rename'] == true ? "#F5A623" : "#919191";
				var openColor = btnState['open'] == true ? "#1AA95E" : "#919191";
	
				var btnStyle = { alignSelf: 'stretch', padding: '1px 6px', margin: '3px' };
				var renameIsShow = this.state.renameIsShow;
				var coverIsShow = this.state.coverIsShow;
				var tableContent = this.getTableContent();
	
				return _react2.default.createElement(
					'div',
					{ style: (_ref = { alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff" }, _defineProperty(_ref, 'background', '#FFFFFF'), _defineProperty(_ref, 'border', '1px solid #9B9B9B'), _defineProperty(_ref, 'boxShadow', '0 0 41px 5px rgba(0,0,0,0.25)'), _defineProperty(_ref, 'borderRadius', '2px'), _defineProperty(_ref, 'width', '508px'), _defineProperty(_ref, 'height', '399px'), _ref) },
					_react2.default.createElement(
						'div',
						{ className: 'modal-header', style: { position: "relative" } },
						_react2.default.createElement('div', { className: 'modal-close', onClick: this.closeAttachmentHandler.bind(this) }),
						_react2.default.createElement(
							'h5',
							{ className: 'modal-title' },
							'\u9644\u4EF6'
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { cursor: 'pointer', height: '55px', margin: '12px', background: '#FFFFFF', border: '1px dashed #E0E0E0', borderRadius: '6px', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' },
							onClick: this.btnUpLoad_clickHandler.bind(this), onDrop: this.onDragDrop.bind(this), onDragLeave: this.onDragLeaveHandler.bind(this), onDragOver: this.onDragOverHandler.bind(this), onDragEnter: this.onDragEnterHandler.bind(this)
						},
						_react2.default.createElement('i', { className: 'fa fa-cloud-upload', style: { color: uploadColor, fontSize: '22px' } }),
						_react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this2.uploadPrompt = node;
								}, style: { color: uploadColor, fontFamily: 'PingFang-SC-Bold', fontSize: '14px' } },
							'\u4E0A\u4F20'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: function ref(node) {
								return _this2.attachMentComponent = node;
							}, style: _style, className: _className },
						_react2.default.createElement(
							'div',
							{ style: { overflowY: 'auto', minWidth: '400px', paddingLeft: '10px', paddingRight: '10px', flexGrow: '1' } },
							_react2.default.createElement(
								'table',
								{ className: 'table table-condensed', ref: function ref(node) {
										return _this2.attachMentComponentTB = node;
									} },
								_react2.default.createElement(
									'tbody',
									null,
									tableContent
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: "flex", flexDirection: "row", justifyContent: "flex-end", paddingTop: '14px', paddingBottom: '10px', borderTop: '1px solid rgba(0,0,0,0.10)' } },
							_react2.default.createElement('input', { type: 'file', accept: '*', multiple: 'true', style: { display: 'none' }, ref: function ref(node) {
									return _this2.uploaderInput = node;
								}, onChange: this.upLoaderChangeHandler.bind(this) }),
							_react2.default.createElement(
								'div',
								{ onClick: this.btnDownLoad_clickHandler.bind(this), style: { display: 'flex', fontFamily: 'PingFang-SC-Regular', fontSize: '14px', color: downloadColor, alignItems: 'center', paddingRight: '15px', cursor: 'pointer' } },
								_react2.default.createElement('i', { className: 'fa fa-cloud-download', style: { color: downloadColor, fontSize: '17px', paddingRight: '5px', marginBottom: '1px' } }),
								'\u4E0B\u8F7D'
							),
							_react2.default.createElement(
								'div',
								{ onClick: this.btnDelete_clickHandler.bind(this), style: { display: 'flex', fontFamily: 'PingFang-SC-Regular', fontSize: '14px', color: deleteColor, alignItems: 'center', paddingRight: '15px', cursor: 'pointer' } },
								_react2.default.createElement('i', { className: 'fa fa-trash-o', style: { color: deleteColor, fontSize: '17px', paddingRight: '5px', marginBottom: '1px' } }),
								'\u5220\u9664'
							),
							_react2.default.createElement(
								'div',
								{ onClick: this.btnRename_clickHandler.bind(this), style: { display: 'flex', fontFamily: 'PingFang-SC-Regular', fontSize: '14px', color: renameColor, alignItems: 'center', paddingRight: '15px', cursor: 'pointer' } },
								_react2.default.createElement('i', { className: 'fa fa-pencil-square-o', style: { color: renameColor, fontSize: '17px', paddingRight: '5px', marginBottom: '1px' }, 'aria-hidden': 'true' }),
								'\u91CD\u547D\u540D'
							),
							_react2.default.createElement(
								'div',
								{ onClick: this.btnOpenFile_clickHandler.bind(this), style: { display: 'flex', fontFamily: 'PingFang-SC-Regular', fontSize: '14px', color: openColor, alignItems: 'center', paddingRight: '15px', cursor: 'pointer' } },
								_react2.default.createElement('i', { className: 'fa fa-folder-open-o', style: { color: openColor, fontSize: '17px', paddingRight: '5px', marginBottom: '1px' }, 'aria-hidden': 'true' }),
								'\u6253\u5F00'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ hidden: !renameIsShow, style: { position: 'absolute', top: '45%', border: '2px solid rgb(229, 229, 229)', left: '42%' } },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header', style: { background: "#ffffff", padding: "5px", position: "relative" } },
							_react2.default.createElement('i', { className: 'fa fa-close', style: { position: "absolute", top: "7px", right: "10px", fontSize: "15px", cursor: "pointer" }, onClick: this.cancelRename.bind(this) }),
							_react2.default.createElement(
								'h5',
								{ className: 'modal-title' },
								'\u91CD\u547D\u540D'
							)
						),
						_react2.default.createElement(
							'div',
							{ style: _style, className: _className },
							_react2.default.createElement(
								'label',
								null,
								'\u65B0\u540D\u5B57',
								_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: { fontSize: '8px', color: 'red' } })
							),
							_react2.default.createElement('input', { spellCheck: 'false', style: { minWidth: '200px' }, ref: function ref(node) {
									return _this2.renameInput = node;
								} })
						),
						_react2.default.createElement(
							'div',
							{ style: { display: "flex", padding: "10px", backgroundColor: "#ffffff", flexDirection: "row", justifyContent: "flex-end" }, className: _className },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: btnStyle, onClick: this.doRename.bind(this) },
								'\u786E\u5B9A'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: btnStyle, onClick: this.cancelRename.bind(this) },
								'\u53D6\u6D88'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ hidden: !coverIsShow, style: { position: 'absolute', top: '45%', border: '2px solid rgb(229, 229, 229)', left: '42%' } },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header', style: { background: "#ffffff", padding: "5px", position: "relative" } },
							_react2.default.createElement('i', { className: 'fa fa-close', style: { position: "absolute", top: "7px", right: "10px", fontSize: "15px", cursor: "pointer" }, onClick: this.cancelRename2.bind(this) }),
							_react2.default.createElement(
								'h5',
								{ className: 'modal-title' },
								'\u63D0\u793A'
							)
						),
						_react2.default.createElement(
							'div',
							{ style: _style, className: _className },
							'\u5DF2\u4E0A\u4F20\u8FC7\u540C\u6837\u6587\u4EF6\u540D\u7684\u6587\u4EF6'
						),
						_react2.default.createElement(
							'div',
							{ style: { display: "flex", padding: "10px", backgroundColor: "#ffffff", flexDirection: "row", justifyContent: "flex-end" }, className: _className },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: btnStyle, onClick: this.upLoadFileHandler.bind(this) },
								'\u8986\u76D6'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: btnStyle, onClick: this.changeUploadFileName.bind(this) },
								'\u91CD\u547D\u540D'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: btnStyle, onClick: this.cancelRename2.bind(this) },
								'\u53D6\u6D88'
							)
						)
					)
				);
			}
		}]);
	
		return Attachment;
	}(_react2.default.Component);
	
	;
	
	Attachment.defaultProps = {};
	
	exports.default = Attachment;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldBooleanEditor = function (_React$Component) {
		_inherits(DialogFieldBooleanEditor, _React$Component);
	
		function DialogFieldBooleanEditor(props) {
			_classCallCheck(this, DialogFieldBooleanEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldBooleanEditor.__proto__ || Object.getPrototypeOf(DialogFieldBooleanEditor)).call(this, props));
	
			_this.record = _this.props.data.defaultValue;
			if (_this.record == undefined || _this.record == null) {
				_this.record = false;
			}
			_this.state = { data: _this.props.data };
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldBooleanEditor, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = this.record + "";dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'selectedChanged',
			value: function selectedChanged(value) {
				this.record = value;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.inputField).on('ifChecked', this.selectedChanged.bind(this, true));
				$(this.inputField).on('ifUnchecked', this.selectedChanged.bind(this, false));
				$(this.inputField).iCheck({
					checkboxClass: 'icheckbox_minimal-blue'
				});
				if (this.record == true) $(this.inputField).iCheck("check");
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom() {
				var _this2 = this;
	
				var allowEdit = this.state.data.allowEdit;
				if (allowEdit) {
					return _react2.default.createElement('input', { type: 'checkbox', className: 'minimal', ref: function ref(node) {
							return _this2.inputField = node;
						} });
				} else {
					return _react2.default.createElement('input', { type: 'checkbox', className: 'minimal', ref: function ref(node) {
							return _this2.inputField = node;
						}, disabled: true });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var notNull = this.state.data.notNull;
				var _id = this.state.data.id;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'flex-start' };
	
				var inputdom = this.getInputDom();
				var labelStyle = { paddingLeft: '5px', width: 'auto', whiteSpace: 'nowrap', textAlign: 'right' };
	
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + _id, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "inputDialog" + _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							}, style: labelStyle },
						this.state.data.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					inputdom
				);
			}
		}]);
	
		return DialogFieldBooleanEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldBooleanEditor;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _FormItemDateResolver = __webpack_require__(55);
	
	var _FormItemDateResolver2 = _interopRequireDefault(_FormItemDateResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldDateEditor = function (_React$Component) {
		_inherits(DialogFieldDateEditor, _React$Component);
	
		function DialogFieldDateEditor(props) {
			_classCallCheck(this, DialogFieldDateEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldDateEditor.__proto__ || Object.getPrototypeOf(DialogFieldDateEditor)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false
			};
	
			_this.state = { data: _this.props.data };
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldDateEditor, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.inputField).datepicker({
					language: 'zh-CN',
					autoclose: true, //选中之后自动隐藏日期选择框
					clearBtn: true, //清除按钮
					todayBtn: true, //今日按钮
					format: "yyyy-mm-dd",
					buttonImageOnly: true,
					hide: this.onDatePanelClose.bind(this)
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeDiaLogMapEditorsStore();
			}
		}, {
			key: 'onDatePanelClose',
			value: function onDatePanelClose() {
				this.lookupStates.isShowed = false;
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				var value = $(this.inputField).val();
				if (!value) return;
				if (value == "t" || value == "T") {
					var today = new Date();
					value = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
				}
				if (value) {
					value = _FormItemDateResolver2.default.getResult(value, false);
					if (value.indexOf("false:") == 0) {
						_Fade2.default.show({ text: value.substr(6) });
						return false;
					}
				}
				$(this.inputField).val(value);
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				/*alert(e.keyCode);
	   //0-9 t -
	   if(
	   	(e.keyCode>95&&e.keyCode<106) ||
	   	(e.keyCode == 189) ||
	   	(e.keyCode == 84)
	   )
	   {
	   		}
	   else
	   {
	   	e.preventDefault();
	   }*/
				if (e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				var allowEdit = this.state.data.allowEdit;
				var _id = this.state.data.id;
				var _defaultValue = this.state.data.defaultValue;
				if (!_defaultValue) _defaultValue = "";
				if (allowEdit != false) {
					var _style = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, fontSize: "12px" };
					return _react2.default.createElement('input', { spellCheck: 'false', id: "inputDialog" + _id, ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'text',
						className: 'form-control pull-right', style: _style, defaultValue: _defaultValue,
						onBlur: this.inputFieldBlur.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
				} else {
					var _style2 = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
					return _react2.default.createElement('input', { spellCheck: 'false', id: "inputDialog" + _id, ref: function ref(node) {
							return _this2.inputField = node;
						}, readOnly: 'readonly', type: 'text',
						className: 'form-control pull-right', style: _style2, defaultValue: _defaultValue,
						onBlur: this.inputFieldBlur.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
				}
			}
		}, {
			key: 'showDateDropDown',
			value: function showDateDropDown() {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				var $pickerdropdown = $("div.datepicker");
				if ($pickerdropdown.is(':visible')) {
					this.lookupStates.isShowed = false;
					$(this.inputField).datepicker('hide');
				} else {
					this.lookupStates.isShowed = true;
					$(this.inputField).datepicker('show');
				}
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this3 = this;
	
				var allowEdit = this.state.data.allowEdit;
				if (allowEdit != false) {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, onMouseDown: this.showDateDropDown.bind(this), className: 'fa fa-calendar', style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					//<div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'33px',paddingLeft:'6px',paddingRight:'6px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
				} else {
					//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'33px',paddingLeft:'6px',paddingRight:'6px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, className: 'fa fa-calendar', style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var displayLength = this.state.data.displayLength;
				var _width = 100;
				if (this.state.data.width > 0) {
					_width = this.state.data.width;
				} else {
					if (displayLength == 0) displayLength = _FormItemConst2.default.DISPLAYLENGTH_DATE_DEFAULT;
					_width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				}
	
				var notNull = this.state.data.notNull;
				var _label = this.state.data.label;
				var _id = this.state.data.id;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				var inputdom = this.getInputDom(_width);
				var downArrowButtonDom = this.getDownArrowButtonDom();
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + _id, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "inputDialog" + _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							},
							style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
						_label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ className: 'input-group date' },
						inputdom,
						downArrowButtonDom
					)
				);
			}
		}]);
	
		return DialogFieldDateEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldDateEditor;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemDecimalResolver = __webpack_require__(63);
	
	var _FormItemDecimalResolver2 = _interopRequireDefault(_FormItemDecimalResolver);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldDecimalEditor = function (_React$Component) {
		_inherits(DialogFieldDecimalEditor, _React$Component);
	
		function DialogFieldDecimalEditor(props) {
			_classCallCheck(this, DialogFieldDecimalEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldDecimalEditor.__proto__ || Object.getPrototypeOf(DialogFieldDecimalEditor)).call(this, props));
	
			_this.state = { data: _this.props.data };
			_this.decimalProperties = {};
			//allowNegative:true,numOfDecimals:2,roundOff:"HalfUp",showDecimals:2,showZero:true,thousandSeperator:false
			if (_this.props.data.editorType == "TypeDecimal") {
				var entityId = _this.props.data.entityId;
				if (entityId) {
					var decimalDataType = _GOT2.default.getDataType(entityId);
					if (decimalDataType) {
						_this.decimalProperties.allowNegative = true; //GOTUtil.getPropertyValue(decimalDataType,"AllowNegative");
						_this.decimalProperties.numOfDecimals = _GOTUtil2.default.getPropertyValueStepByStep(decimalDataType, decimalDataType, "NumOfDecimals", "", false, false); //GOTUtil.getPropertyValue(decimalDataType,"NumOfDecimals");
						_this.decimalProperties.roundOff = _GOTUtil2.default.getPropertyValueStepByStep(decimalDataType, decimalDataType, "RoundOff", "", false, false); //GOTUtil.getPropertyValue(decimalDataType,"RoundOff");
						_this.decimalProperties.showDecimals = _GOTUtil2.default.getPropertyValueStepByStep(decimalDataType, decimalDataType, "DisplayDecimals", "", false, false); // GOTUtil.getPropertyValue(decimalDataType,"DisplayDecimals")
						//|| GOTUtil.getPropertyValue(decimalDataType,"ShowDecimals");
						_this.decimalProperties.showZero = _GOTUtil2.default.getPropertyValueStepByStep(decimalDataType, decimalDataType, "ShowZero", "", false, false); //GOTUtil.getPropertyValue(decimalDataType,"ShowZero");
						_this.decimalProperties.thousandSeperator = _GOTUtil2.default.getPropertyValueStepByStep(decimalDataType, decimalDataType, "ThousandSeperator", "", false, false); //GOTUtil.getPropertyValue(decimalDataType,"ThousandSeperator");
						_this.decimalProperties.fromDataType = true;
					}
				}
			}
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldDecimalEditor, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = this.record ? this.record + "" : $(this.inputField).val();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'onKeyPressHandler',
			value: function onKeyPressHandler(event) {
				return (/[\d|\.|\-]/.test(String.fromCharCode(event.charCode))
				);
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				var value = $(this.inputField).val();
				if (!this.decimalProperties.fromDataType) {
					var regu = /^(\-|\+)?\d+(\.\d+)?$/;
					if (!regu.test(value)) {
						$(this.inputField).val(this.record ? this.record : "0");
					}
					return;
				}
	
				value = _FormItemDecimalResolver2.default.getResult(value, false, this.decimalProperties.allowNegative, this.decimalProperties.numOfDecimals, this.decimalProperties.roundOff);
				if (value && value.indexOf("false:") == 0) {
					_Warn2.default.show({ text: value.substr(6) });
					return;
				}
				this.record = value;
				this.setDisplay();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					value = this.record;
				}
	
				if (value == null) value = "";
				if (value != "") {
					var parms = {};
					if (this.decimalProperties.displayStyle == "%") parms.percent = true;
					value = _FormItemDecimalDisplay2.default.getDisplayText(value, this.decimalProperties.showZero, this.decimalProperties.showDecimals, this.decimalProperties.thousandSeperator, parms);
				}
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				var allowEdit = this.state.data.allowEdit;
				var _id = this.state.data.id;
				var _defaultValue = this.state.data.defaultValue;
				if (!_defaultValue) _defaultValue = "";
				if (allowEdit) {
					var _style = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, fontSize: "12px" };
	
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'number', onBlur: this.inputFieldBlur.bind(this),
						className: 'form-control', style: _style, defaultValue: _defaultValue, onKeyPress: this.onKeyPressHandler.bind(this) });
				} else {
					var _style2 = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
	
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'text', readOnly: 'readonly',
						className: 'form-control', style: _style2, defaultValue: _defaultValue, onKeyPress: this.onKeyPressHandler.bind(this) });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var displayLength = this.state.data.displayLength;
				if (displayLength == 0) displayLength = _FormItemConst2.default.DISPLAYLENGTH_DATE_DEFAULT;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
	
				var notNull = this.state.data.notNull;
				var _label = this.state.data.label;
				var _id = this.state.data.id;
	
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
	
				var inputdom = this.getInputDom(_width);
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + _id, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "inputDialog" + _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							}, style: labelStyle },
						_label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ style: { position: "relative" } },
						inputdom
					)
				);
			}
		}]);
	
		return DialogFieldDecimalEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldDecimalEditor;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _GOTPropertiesUtil = __webpack_require__(62);
	
	var _GOTPropertiesUtil2 = _interopRequireDefault(_GOTPropertiesUtil);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	var _CommandStore = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(66);
	__webpack_require__(153);
	__webpack_require__(101);
	
	var DialogFieldEnumEditor = function (_React$Component) {
		_inherits(DialogFieldEnumEditor, _React$Component);
	
		function DialogFieldEnumEditor(props) {
			_classCallCheck(this, DialogFieldEnumEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldEnumEditor.__proto__ || Object.getPrototypeOf(DialogFieldEnumEditor)).call(this, props));
	
			var _data = Object.assign({}, _this.props.data);
			var _properties = void 0;
			try {
				_properties = _GOTPropertiesUtil2.default.getItemPropertyFinalValue(null, _data.entityId, null);
			} catch (e) {
				alert("类型为Enum的DialogField可能未填写正确的entityId,它必须指向一个Enum或者Enum类型的DataType");
			}
			if (_properties) {
				_data.options = _properties.DataProvider;
			} else {
				_data.options = [];
				alert("类型为Enum的DialogField必须指向一个Enum或者Enum类型的DataType");
			}
	
			_this.state = { data: _data };
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldEnumEditor, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var displayLength = this.state.data.displayLength;
				if (displayLength == 0) displayLength = 10;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 20 + 'px';
				$(this.inputField).selectpicker({ width: _width, noneSelectedText: '未选中', noneResultsText: '没有找到匹配项' });
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.allowEdit == false) {
					var $dom = $(this.inputField).parent().find("button.btn");
					$dom.css("background-color", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR).css("cursor", "not-allowed");
					$(this.inputField).attr("disabled", "");
				} else {
					var _$dom = $(this.inputField).parent().find("button.btn");
					_$dom.css("cursor", "pointer");
					$(this.inputField).removeAttr("disabled");
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeDiaLogMapEditorsStore();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _options = this.state.data.options;
				var _defaultValue = this.state.data.defaultValue;
				var list = _options.map(function (item) {
					var _value = item.value;
					if (_defaultValue && _defaultValue == _value) return _react2.default.createElement(
						'option',
						{ key: _value, value: _value, selected: 'selected' },
						item.label
					);
					return _react2.default.createElement(
						'option',
						{ key: _value, value: _value },
						item.label
					);
				});
	
				var notNull = this.state.data.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: "12px" };
	
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + this.state.data.id, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "select" + this.state.data.id, className: 'fieldGroupLabel',
							style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
						this.state.data.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'select',
						{ className: 'selectpicker form-control', 'data-live-search': 'true', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "select" + this.state.data.id, style: { padding: '2px !important', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px' } },
						list
					)
				);
			}
		}]);
	
		return DialogFieldEnumEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldEnumEditor;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldLabel = function (_React$Component) {
		_inherits(DialogFieldLabel, _React$Component);
	
		function DialogFieldLabel(props) {
			_classCallCheck(this, DialogFieldLabel);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldLabel.__proto__ || Object.getPrototypeOf(DialogFieldLabel)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false
			};
	
			_this.state = { data: _this.props.data };
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldLabel, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = $(this.inputField).html();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeDiaLogMapEditorsStore();
			}
		}, {
			key: 'render',
			value: function render() {
				var _label = this.state.data.label;
				var _id = this.state.data.id;
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center', whiteSpace: 'pre' };
	
				var displayLength = this.state.data.displayLength;
				if (displayLength != 0) {
					var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';editorStyle.width = _width;
				}
	
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + _id, className: 'editorGroup', style: editorStyle },
					_label
				);
			}
		}]);
	
		return DialogFieldLabel;
	}(_react2.default.Component);
	
	exports.default = DialogFieldLabel;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldLongEditor = function (_React$Component) {
		_inherits(DialogFieldLongEditor, _React$Component);
	
		function DialogFieldLongEditor(props) {
			_classCallCheck(this, DialogFieldLongEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldLongEditor.__proto__ || Object.getPrototypeOf(DialogFieldLongEditor)).call(this, props));
	
			_this.state = { data: _this.props.data };
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldLongEditor, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				var allowEdit = this.state.data.allowEdit;
				var _id = this.state.data.id;
				var _defaultValue = this.state.data.defaultValue;
				if (!_defaultValue) _defaultValue = "";
				if (allowEdit) {
					var _style = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, fontSize: "12px" };
	
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'text',
						className: 'form-control', style: _style, defaultValue: _defaultValue });
				} else {
					var _style2 = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
	
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'text', readOnly: 'readonly',
						className: 'form-control', style: _style2, defaultValue: _defaultValue });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var displayLength = this.state.data.displayLength;
				if (displayLength == 0) displayLength = _FormItemConst2.default.DISPLAYLENGTH_DATE_DEFAULT;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
	
				var notNull = this.state.data.notNull;
				var _label = this.state.data.label;
				var _id = this.state.data.id;
	
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
	
				var inputdom = this.getInputDom(_width);
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + _id, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "inputDialog" + _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							}, style: labelStyle },
						_label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ style: { position: "relative" } },
						inputdom
					)
				);
			}
		}]);
	
		return DialogFieldLongEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldLongEditor;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _FormLookupFactory = __webpack_require__(65);
	
	var _FormLookupFactory2 = _interopRequireDefault(_FormLookupFactory);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _ToolBarUtil = __webpack_require__(68);
	
	var _ToolBarUtil2 = _interopRequireDefault(_ToolBarUtil);
	
	var _LookupReturnStore = __webpack_require__(84);
	
	var _LookupReturnStore2 = _interopRequireDefault(_LookupReturnStore);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldStringEditor = function (_React$Component) {
		_inherits(DialogFieldStringEditor, _React$Component);
	
		function DialogFieldStringEditor(props) {
			_classCallCheck(this, DialogFieldStringEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldStringEditor.__proto__ || Object.getPrototypeOf(DialogFieldStringEditor)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false,
				dropdownform: null
			};
	
			_this.initMembers();
			_this.classAlias = "DialogFieldStringEditor";
			_this.state = { data: _this.props.data };
			_this.hasLookup = true;
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldStringEditor, [{
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					//alert("侦听到了");
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'onLookupReturn',
			value: function onLookupReturn(value, entityId, innerId) {
				if (this.state.data.entityId == entityId && null == innerId) {
					//alert("侦听到");
					this.closeDropDown();
	
					this.onLookupReturning = true;
					$(this.inputField).val(value);
					this.inputField.focus();
					this.inputField.select();
					this.onLookupReturning = false;
					return false;
				}
			}
		}, {
			key: 'initMembers',
			value: function initMembers() {
				this.lookupEvents = [[$(document), {
					'mousedown touchstart': $.proxy(function (e) {
						if (!($(this.inputgroup).is(e.target) || $(this.inputgroup).find(e.target).length || this.lookupStates.dropdownform.is(e.target) || this.lookupStates.dropdownform.find(e.target).length)) {
							this.closeDropDown();
						}
					}, this)
				}]];
				this.toolBarObject = _ToolBarUtil2.default.createToolBarObj_Form_FormLookup();
			}
		}, {
			key: 'getTextAreaDom',
			value: function getTextAreaDom(displayHeight) {
				var _this2 = this;
	
				var _defaultValue = this.state.data.defaultValue;
				if (!_defaultValue) _defaultValue = "";
				if (this.state.data.allowEdit) {
					var _style = { resize: 'none', padding: '2px' };
					return _react2.default.createElement('textarea', { ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.state.data.id, defaultValue: _defaultValue,
						className: 'form-control', rows: displayHeight, style: _style });
				} else {
					var _style2 = { resize: 'none', padding: '2px', backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR };
					return _react2.default.createElement('textarea', { ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.state.data.id, readOnly: 'readonly',
						className: 'form-control', rows: displayHeight, style: _style2, defaultValue: _defaultValue });
				}
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur(e) {
				if (this.lookupStates.isShowed) return;
				var oldValue = this.record;
				if (!oldValue) oldValue = "";
				var value = $(this.inputField).val();
				this.record = value;
				var newValue = value;
				this.doModifiedEditor(oldValue, newValue);
			}
		}, {
			key: 'doModifiedEditor',
			value: function doModifiedEditor(oldValue, newValue) {
				var editorName = this.props.data.id;
				var mi = { groups: "current(3)", editors: "all", joinGroup: null, fetchOption: true };
				var formmodule = window.formModuleInstance;
				var defaultGroupAlias = "";
				if (formmodule.formDataSources && formmodule.formDataSources.firstGroup) {
					defaultGroupAlias = formmodule.formDataSources.firstGroup.groupAlias;
				}
				var arg = _CommandResolver2.default.getSendCmd(formmodule, defaultGroupAlias, mi);
	
				var command = _CommandHelper2.default.createFormInstance(formmodule.formName, "doDialogModifiedEditor", "Object");
	
				command.appendArg("String", "String").appendArg(oldValue + "", "Object").appendArg(newValue + "", "Object").appendArg(this.props.data.entityId, "String").appendArg(arg, "CommandArg");
				var _group = formmodule.formDataSources ? formmodule.formDataSources.firstGroup : null;
				var _rpc_fault_doModifiedEditor = this.rpc_fault_doModifiedEditor.bind(this);
	
				var remoteArg = {
					command: command,
					resultFunction: function resultFunction(data) {
						$(this.inputField).val(data.result);
						//CommandResolver.resolve(data.result.tasks, formmodule,_group);
					},
					faultFunction: function faultFunction(data) {
						_rpc_fault_doModifiedEditor(data, oldValue, newValue);
					}
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		}, {
			key: 'rpc_fault_doModifiedEditor',
			value: function rpc_fault_doModifiedEditor(data, oldValue, newValue) {
				var faultString;
				if (data && data.successButNot0) {
					faultString = data.errText;
				} else {
					faultString = "可能是网络错误 请检查网络是否正常";
				}
	
				var info = "变更值失败：" + oldValue + " -> " + newValue + "<br/>" + "已恢复到：" + oldValue + "<br/>" + "失败原因为：" + faultString;
				_Warn2.default.show({ text: info, title: "此次操作未能成功" });
				this.record = oldValue;
				$(this.inputField).val(oldValue);
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this3 = this;
	
				var _allowEdit = this.state.data.allowEdit;
				var _defaultValue = this.state.data.defaultValue;
				if (!_defaultValue) _defaultValue = "";
				this.record = _defaultValue;
				var _type = "text";
				var _id = this.state.data.id;
				if (typeof _id == "string") {
					if (_id.indexOf("password") != -1) _type = "password";
				}
				if (_allowEdit) {
					var _style = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', fontSize: "12px", width: _width };
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this3.inputField = node;
						}, className: 'form-control',
						id: "input" + this.state.data.id, type: _type, style: _style,
						defaultValue: _defaultValue, onKeyDown: this.onKeyDownHandler.bind(this),
						onBlur: this.inputFieldBlur.bind(this) });
				} else {
					var _style3 = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px", width: _width };
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this3.inputField = node;
						}, className: 'form-control',
						id: "input" + this.state.data.id, type: _type, style: _style3,
						defaultValue: _defaultValue, readOnly: 'readonly' });
				}
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this4 = this;
	
				var _allowEdit = this.state.data.allowEdit;
				if (_allowEdit && this.hasLookup) {
					/*return	(<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 6px 4px'}}  onMouseDown={this.buttonDownClick.bind(this)}>
	          			<i className="fa fa-sort-desc"></i>
	    		</span>);*/
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this4.downArrowButton = node;
						}, onMouseDown: this.buttonDownClick.bind(this), className: 'fa fa-sort-desc', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 11px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				} else if (_allowEdit) {
					/*return	(<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 6px 4px',display:"none"}}  onMouseDown={this.buttonDownClick.bind(this)}>
	          			<i className="fa fa-sort-desc"></i>
	    		</span>);*/
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this4.downArrowButton = node;
						}, onMouseDown: this.buttonDownClick.bind(this), className: 'fa fa-sort-desc', style: { position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 11px)', fontSize: '11px', cursor: 'pointer', display: 'none', zIndex: 3 } });
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (40 === e.keyCode || 38 === e.keyCode) {
					//let ne = e["nativeEvent"];
					if (this.lookupStates.isShowed) {
						e.preventDefault();
						e.stopPropagation();
						if (e.ctrlKey && e.keyCode == 38) {
							this.closeDropDown();
						}
					} else if (e.ctrlKey && e.keyCode == 40) {
						e.preventDefault();
						e.stopPropagation();
						if ($(this.downArrowButton).is(":visible")) this.showDropDown();
					}
				} else if (27 == e.keyCode && this.lookupStates.isShowed) {
					e.preventDefault();
					e.stopPropagation();
					this.closeDropDown();
				}
			}
		}, {
			key: 'getLookupBase',
			value: function getLookupBase() {
				var base = {};
				base["entityId"] = this.state.data.entityId;
				base["innerId"] = null;
				base["formType"] = "Dialog";
				return base;
			}
		}, {
			key: 'checkDropDownHas',
			value: function checkDropDownHas() {
				var base = this.getLookupBase();
				var _group = null;
				if (this.state.data.groupId) {
					if (window.formModuleInstance.formDataSources) _group = window.formModuleInstance.formDataSources.groups[this.state.data.groupId];
				}
	
				if (!_FormLookupFactory2.default.hasFormLookup(base, this.state.data.entityId, _group)) //如果GOT没有 则设置为false
					{
						$(this.downArrowButton).hide();this.hasLookup = false;
					}
			}
		}, {
			key: 'buttonDownClick',
			value: function buttonDownClick(e) {
				if (!($(this.inputgroup).is(document.activeElement) || $(this.inputgroup).find(document.activeElement).length)) e.preventDefault();
				return this.showDropDown();
			}
		}, {
			key: 'detachEventListeners',
			value: function detachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				//alert("DialogFieldStringEditor unMount");
				this.unsubscribeDiaLogMapEditorsStore();
				this.closeDropDown();
			}
		}, {
			key: 'closeDropDown',
			value: function closeDropDown() {
	
				if (this.lookupStates.isShowed) {
					var lookupdiv = this.lookupStates.dropdownform;
					if (lookupdiv == null) return;
					this.detachEventListeners();
					this.unsubscribeLookupReturnStore();
					lookupdiv.remove();
	
					this.moduleLookup = null;
	
					this.lookupStates.isShowed = false;
	
					//this.refs.inputdom.focus();this.refs.inputdom.select();
					this.inputField.focus();
					this.inputField.select();
	
					window.lookupShowing = false;
					/*var _parentWindow = window.parent.window;
	       if(_parentWindow)
	       {
	          _parentWindow.setToolBar(window.toolBarObject);
	       }*/
	
					return false;
				}
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				var lookupdiv = this.lookupStates.dropdownform;
	
				//暂时把下拉框缓存在项目编辑器实例 由于项目编辑器实例会由reactdatagrid销毁
				//所以缓存对于FormItemStringEditorForDataGrid不适用 应该跟flex一样缓存到全局
				if (lookupdiv == null) {
					lookupdiv = $("<div>").css({ position: 'absolute', padding: '1px', backgroundColor: '#ffffff', border: 'solid 1px #d2d2d2', /*float:'left',*/zIndex: 1051 });
					this.lookupStates.dropdownform = lookupdiv;
				}
				if (this.lookupStates.isShowed) {
					this.closeDropDown();
					return;
				}
				lookupdiv.appendTo($('body'));
				var base = {};
				base["entityId"] = this.state.data.entityId;
				base["innerId"] = null;
				base["componentItemName"] = null;
				base["formType"] = "Dialog";
				this.lookupKey = _FormLookupFactory2.default.getKey(base);
				var moduleLookup = _FormLookupFactory2.default.createFormLookup(base, "PullDown");
	
				var lookup = _reactDom2.default.render(moduleLookup, lookupdiv.get(0));
	
				this.buildLookupArg(lookup);
	
				lookup.doDataProviderRefresh();
	
				if (typeof lookup.queryBoxClear === "function") {
					lookup.queryBoxClear();
				}
	
				/*var _parentWindow = window.parent.window;
	      if(_parentWindow)
	      {
	         _parentWindow.setToolBar(this.toolBarObject);
	      }*/
	
				this.onLookupCmp();
				this.attachEventListeners();
				this.inputField.focus();
				this.unsubscribeLookupReturnStore = _LookupReturnStore2.default.listen(this.onLookupReturn.bind(this));
				return true;
			}
		}, {
			key: 'buildLookupArg',
			value: function buildLookupArg(lookup) {
				lookup.lookupArg = {};
				lookup.lookupArg["editorFormType"] = "Dialog";
				lookup.lookupArg["groupAlias"] = null;
				lookup.lookupArg["baseTableName"] = null;
				lookup.lookupArg["filterFieldName"] = null;
				lookup.lookupArg["baseRecord"] = null;
				lookup.lookupArg["baseFormId"] = null;
	
				lookup.lookupArg["fieldName"] = _StringUtil2.default.convertToFirstUpperCase(lookup.returnField.split(".")[1]);
			}
		}, {
			key: 'onLookupCmp',
			value: function onLookupCmp() {
				var lookupdiv = this.lookupStates.dropdownform;
				var _inputwidth = $(this.inputgroup).width(); //this.props.displayLengthWidth;
				var _iframewidth = lookupdiv.outerWidth();
	
				var _iframeheight = lookupdiv.outerHeight();
	
				var _gwidth = $("#app").width();
				var _gheight = $("#app").height();
	
				if (_iframewidth > _gwidth) {
					_iframewidth = _gwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				}
				var _offset = $(this.inputgroup).offset();
				var _y = _offset.top;
				var _x = _offset.left;
				var _top = _y + $(this.inputgroup).height();
				//alert('x:'+_x+'y:'+_y);
				//下方屏幕放不下
				if (_y + _iframeheight > _gheight) {
					//上下都放不下 考虑缩减高度
					if (_iframeheight > _y) {
						//上方空间大
						if (_y > _gheight / 2) {
							var _newdivheight = _y - 1 + 'px';
							//lookupdiv.css("height":_newdivheight);
							lookupdiv.height(_y - 2);
							//alert(_newdivheight);
							_top = '0px';
							//'-'+_newdivheight+'px';
						} else //下方空间大
							{
								//let _newdivheight = (_gheight-_y)+'px';
								lookupdiv.height(_gheight - _y);
							}
					} else //下拉框置于上方
						{
							_top = _y - _iframeheight + 'px';
							//'-'+_iframeheight+'px';
						}
				}
				var _left = _x - (_iframewidth - _inputwidth) / 2;
				//(_iframewidth-_inputwidth)/2;
				if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 5;
				if (_left < 0) _left = 0;
	
				lookupdiv.css({ left: _left + 'px', top: _top });
				//lookupdiv.css({left:'860px',top:'200px'});
	
				this.lookupStates.isShowed = true;
			}
		}, {
			key: 'attachEventListeners',
			value: function attachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
				this.applyEvents(this.lookupEvents);
			}
		}, {
			key: 'unapplyEvents',
			value: function unapplyEvents(evs) {
				for (var i = 0, el, ev, ch; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			}
		}, {
			key: 'applyEvents',
			value: function applyEvents(evs) {
				for (var i = 0, el, ch, ev; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			}
	
			//目前测试下来 react生命周期方法只有在超类显式定义才可以调用super
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.checkDropDownHas();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var displayHeight = this.state.data.displayHeight;
				if (!displayHeight) displayHeight = 1;
				var displayLength = this.state.data.displayLength;
				if (!displayLength) displayLength = 20;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				var notNull = this.state.data.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				var label = this.state.data.label;
				if (displayHeight > 1) {
					var textAreaDom = this.getTextAreaDom(displayHeight);
					return _react2.default.createElement(
						'div',
						{ id: "Editor" + this.state.data.id, ref: function ref(node) {
								return _this5.element = node;
							}, className: 'editorGroup', style: editorStyle },
						_react2.default.createElement(
							'label',
							{ htmlFor: "input" + this.state.data.id, className: 'fieldGroupLabel', ref: function ref(node) {
									return _this5.componentLabel = node;
								},
								style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
							label
						),
						_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
						_react2.default.createElement(
							'div',
							{ className: 'input-group', ref: function ref(node) {
									return _this5.inputgroup = node;
								}, style: { width: _width } },
							textAreaDom
						)
					);
				} else {
					var inputdom = this.getInputDom(_width);
					var downArrowButtonDom = this.getDownArrowButtonDom();
					return _react2.default.createElement(
						'div',
						{ id: "Editor" + this.state.data.id, ref: function ref(node) {
								return _this5.element = node;
							}, className: 'editorGroup', style: editorStyle },
						_react2.default.createElement(
							'label',
							{ htmlFor: "input" + this.state.data.id, className: 'fieldGroupLabel', ref: function ref(node) {
									return _this5.componentLabel = node;
								},
								style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
							label
						),
						_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
						_react2.default.createElement(
							'div',
							{ className: 'input-group', ref: function ref(node) {
									return _this5.inputgroup = node;
								} },
							inputdom,
							downArrowButtonDom
						)
					);
				}
			}
		}]);
	
		return DialogFieldStringEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldStringEditor;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DialogValue = __webpack_require__(39);
	
	var _DialogValue2 = _interopRequireDefault(_DialogValue);
	
	var _FormItemTimeResolver = __webpack_require__(61);
	
	var _FormItemTimeResolver2 = _interopRequireDefault(_FormItemTimeResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldTimeEditor = function (_React$Component) {
		_inherits(DialogFieldTimeEditor, _React$Component);
	
		function DialogFieldTimeEditor(props) {
			_classCallCheck(this, DialogFieldTimeEditor);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldTimeEditor.__proto__ || Object.getPrototypeOf(DialogFieldTimeEditor)).call(this, props));
	
			_this.initMembers();
			_this.state = { data: _this.props.data };
			_this.unsubscribeDiaLogMapEditorsStore = _CommandStore.DiaLogMapEditorsStore.listen(_this.onDiaLogMapEditors.bind(_this));
			return _this;
		}
	
		_createClass(DialogFieldTimeEditor, [{
			key: 'initMembers',
			value: function initMembers() {
	
				this.lookupEvents = [[$(document), {
					'mousedown touchstart': $.proxy(function (e) {
						console.log("执行到了注册的事件侦听 是否已卸载");
						if (!($(this.inputFieldContainer).is(e.target) || $(this.inputFieldContainer).find(e.target).length || this.dropdownform.is(e.target) || this.dropdownform.find(e.target).length)) {
							this.closeDropDown();
						}
					}, this)
				}]];
			}
		}, {
			key: 'onDiaLogMapEditors',
			value: function onDiaLogMapEditors(dialogId, result) {
				if (this.props.dialogId == dialogId) {
					var dv = new _DialogValue2.default();
					dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
					dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
					//alert("DialogFieldStringEditor侦听");
					result[this.props.data.id] = dv;
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeDiaLogMapEditorsStore();
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				var value = $(this.inputField).val();
				if (!value) return;
				var newValue = _FormItemTimeResolver2.default.getResult(value, false);
				if (newValue.indexOf("false:") == 0) {
					$(this.inputField).val("00:00:00");
					_Fade2.default.show({ text: newValue.substr(6) });
					return;
				}
				$(this.inputField).val(newValue);
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				var allowEdit = this.state.data.allowEdit;
				var _id = this.state.data.id;
				var _defaultValue = this.state.data.defaultValue;
				if (!_defaultValue) _defaultValue = "";
				if (allowEdit) {
					var _style = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, fontSize: "12px" };
	
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'text',
						className: 'form-control', style: _style, defaultValue: _defaultValue,
						onBlur: this.inputFieldBlur.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
				} else {
					var _style2 = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
	
					return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, type: 'text', readOnly: 'readonly',
						className: 'form-control', style: _style2, defaultValue: _defaultValue,
						onBlur: this.inputFieldBlur.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
				}
			}
		}, {
			key: 'getDropDownHtml',
			value: function getDropDownHtml() {
				return $('<div class="dateTimeWrap" style="padding-top:0px;background: #FFFFFF;border: 1px solid #CDCDCD;box-shadow: 0 2px 6px 0 rgba(0,0,0,0.14);border-radius: 2px;display: block;height: 240px; width: 180px;z-index: 6666;"><div class="timePart" style=""><ul style="display:flex;padding-left: 0px;border-top:none;margin-bottom:7px"><li id="selHour"><p>时</p><ol style="border-right:none;"><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li></ol></li><li id="selMinute"><p>分</p><ol><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li><li>24</li><li>25</li><li>26</li><li>27</li><li>28</li><li>29</li><li>30</li><li>31</li><li>32</li><li>33</li><li>34</li><li>35</li><li>36</li><li>37</li><li>38</li><li>39</li><li>40</li><li>41</li><li>42</li><li>43</li><li>44</li><li>45</li><li>46</li><li>47</li><li>48</li><li>49</li><li>50</li><li>51</li><li>52</li><li>53</li><li>54</li><li>55</li><li>56</li><li>57</li><li>58</li><li>59</li></ol></li></ul><div class="timeFooter"><span id="ensure">确定</span><span id="curTime">当前时间</span></div></div></div>');
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this3 = this;
	
				var allowEdit = this.state.data.allowEdit;
				if (allowEdit) {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, onClick: this.showDropDown.bind(this), className: 'fa fa-clock-o', style: { position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				} else {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, className: 'fa fa-clock-o', style: { position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				}
			}
		}, {
			key: 'closeDropDown',
			value: function closeDropDown() {
				if (this.dropDownShowed) {
	
					var lookupdiv = this.dropdownform;
					if (lookupdiv == null) return;
					this.detachEventListeners();
	
					lookupdiv.remove();
					this.dropDownShowed = false;
					this.dropdownform = null;
					this.focusByCloseDropDrown = true;
					this.inputField.focus();
					this.inputField.select();
					return false;
				}
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				if (this.dropDownShowed == true) {
					this.closeDropDown();
					return;
				}
				var $dropdown = this.getDropDownHtml();
				$('body').append($dropdown);
	
				var nowVal = $(this.inputField).val();
				if (nowVal && typeof nowVal == "string") {
					var hourLis = $(".dateTimeWrap #selHour>ol>li");
					var minuteList = $(".dateTimeWrap #selMinute>ol>li");
					var _arr = nowVal.split(":");
					var nowHour = _arr[0];var nowMinute = _arr[1];
					for (var i = 0; i < hourLis.length; i++) {
						var item = hourLis[i];
						if ($(item).html() == nowHour) {
							hourLis.removeClass("cur");
							$(item).addClass("cur");
							$(item).parent().scrollTop($(item).offset().top - $(item).height());
							break;
						}
					}
	
					for (var k = 0; k < minuteList.length; k++) {
						var _item = minuteList[k];
						if ($(_item).html() == nowMinute) {
							minuteList.removeClass("cur");
							$(_item).addClass("cur");
							$(_item).parent().scrollTop($(_item).offset().top - $(_item).height());
							break;
						}
					}
				}
	
				this.dropdownform = $dropdown;
				var lookupdiv = $dropdown;
				var _inputwidth = $(this.inputField).width(); //this.props.displayLengthWidth;
				var _iframewidth = lookupdiv.outerWidth();
	
				var _iframeheight = lookupdiv.outerHeight();
	
				var _gwidth = $("#app").width();
				var _gheight = $("#app").height();
	
				if (_iframewidth > _gwidth) {
					_iframewidth = _gwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				}
				var _offset = $(this.inputField).offset();
				var _y = _offset.top;
				var _x = _offset.left;
				var _top = _y + $(this.inputField).height() + 5;
				//alert('x:'+_x+'y:'+_y);
				//下方屏幕放不下
				if (_top + _iframeheight > _gheight) {
					//上下都放不下 考虑缩减高度
					if (_iframeheight > _y) {
						//上方空间大
						if (_y > _gheight / 2) {
							lookupdiv.height(_y - 2);
							_top = '0px';
						} else //下方空间大
							{
								lookupdiv.css("height", _gheight - _top + 'px');
							}
					} else //下拉框置于上方
						{
							_top = _y - _iframeheight + 'px';
						}
				}
				var _left = _x - (_iframewidth - _inputwidth) / 2;
				//(_iframewidth-_inputwidth)/2;
				if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 5;
				if (_left < 0) _left = 0;
	
				lookupdiv.css({ left: _left + 'px', top: _top });
				this.dropDownShowed = true;
				this.attachEventListeners();
			}
		}, {
			key: 'attachEventListeners',
			value: function attachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
				this.applyEvents(this.lookupEvents);
	
				this.dropdownform.find("ul>li>ol>li").on("click", this.timeLiClickHandler.bind(this));
				this.dropdownform.find("#ensure").on("click", this.timeEnsureHandler.bind(this));
				this.dropdownform.find("#curTime").on("click", this.timeNowEnsureHandler.bind(this));
			}
		}, {
			key: 'detachEventListeners',
			value: function detachEventListeners() {
				this.unapplyEvents(this.lookupEvents);
				this.dropdownform.find("ul>li>ol>li").off();
				this.dropdownform.find("#ensure").off();
				this.dropdownform.find("#curTime").off();
			}
		}, {
			key: 'timeLiClickHandler',
			value: function timeLiClickHandler(e) {
				$(e.target).parent().find("li").removeClass("cur");
				$(e.target).addClass("cur");
			}
		}, {
			key: 'timeEnsureHandler',
			value: function timeEnsureHandler(e) {
				var selectedLi = this.dropdownform.find("li.cur");
				var timeStr = "";
				for (var i = 0; i < selectedLi.length; i++) {
					var li = $(selectedLi[i]);
					timeStr = timeStr + li.text() + ":";
				}
				timeStr += "00";
				$(this.inputField).val(timeStr);
				this.closeDropDown();
			}
		}, {
			key: 'timeNowEnsureHandler',
			value: function timeNowEnsureHandler(e) {
				var _date = new Date();
	
				var hours = _date.getHours();
				if (hours < 10) hours = "0" + hours;
				var minutes = _date.getMinutes();
				if (minutes < 10) minutes = "0" + minutes;
				var seconds = _date.getSeconds();
				if (seconds < 10) seconds = "0" + seconds;
				var timeStr = hours + ":" + minutes + ":" + seconds;
				$(this.inputField).val(timeStr);
				this.closeDropDown();
			}
		}, {
			key: 'applyEvents',
			value: function applyEvents(evs) {
				for (var i = 0, el, ch, ev; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			}
		}, {
			key: 'unapplyEvents',
			value: function unapplyEvents(evs) {
				for (var i = 0, el, ev, ch; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var displayLength = this.state.data.displayLength;
				if (displayLength == 0) displayLength = _FormItemConst2.default.DISPLAYLENGTH_DATE_DEFAULT;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				var notNull = this.state.data.notNull;
				var _label = this.state.data.label;
				var _id = this.state.data.id;
	
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
	
				var inputdom = this.getInputDom(_width);
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				var dropDownButton = this.getDownArrowButtonDom();
				return _react2.default.createElement(
					'div',
					{ id: "EditorDialog" + _id, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "inputDialog" + _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							}, style: labelStyle },
						_label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ style: { position: "relative" } },
						inputdom,
						dropDownButton
					)
				);
			}
		}]);
	
		return DialogFieldTimeEditor;
	}(_react2.default.Component);
	
	exports.default = DialogFieldTimeEditor;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(154);
	
	var FormItemBooleanEditor = function (_FormItemEditor) {
		_inherits(FormItemBooleanEditor, _FormItemEditor);
	
		function FormItemBooleanEditor(props) {
			_classCallCheck(this, FormItemBooleanEditor);
	
			var _this2 = _possibleConstructorReturn(this, (FormItemBooleanEditor.__proto__ || Object.getPrototypeOf(FormItemBooleanEditor)).call(this, props));
	
			if (!_this2.props.forLookup) _this2.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(_this2.onDataFieldChanged.bind(_this2));
			return _this2;
		}
	
		_createClass(FormItemBooleanEditor, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) this.unsubscribeRecordFieldChangeStore();
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) this.setDisplay(newValue);
				//else 
				//	alert("observer is this!");
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if ((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId) {
					if (selector != "all" && this.props.xml.name != selector) return;
					if (this.props.underQueryGroup && !this.getInQueryGroupNow()) return;
					if (typeof this.record == "boolean") {
						mapEditorValues[this.props.xml.name] = this.record + "";
					} else {
						mapEditorValues[this.props.xml.name] = !this.record || this.record == "" ? this.props.defaultValueForCMD + "" : this.record + "";
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlProperty',
			value: function onCmdUpdateControlProperty(name, property, value, moduleInstanceId) {
				if (name != this.props.xml.name || this.props.moduleInstanceId) return;
				if (property == ControlPropertyConst.NOTNULL) this.setState({ notNull: value });
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.inputField).focus();
					//$(this.inputField).select();
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus(e) {
				//alert("focus");
				$(this.editorGroup).find(".icheckbox_minimal-blue14").css({ outline: '2px solid #66afe9', outlineOffset: '1px' });
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				$(this.editorGroup).find(".icheckbox_minimal-blue14").css({ outline: "none" });
				if (this.holdFocus) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'inputFieldOnClick',
			value: function inputFieldOnClick() {
				if (this.props.underQueryGroup) {
					this.inQueryGroup = true;
					this.state.notNull = false;
					this.setState({ allowEdit: true, nullValue: false });
					$(this.inputField).parent().removeClass("disabled");
					var _value = this.record && _typeof(this.record) == "object" && this.props.dataField ? this.record[this.props.dataField] : this.record;
					var boolvalue = _value == "true" || _value == true || _value == "1";
					if (!boolvalue) {
						//update this.inputField.checked = true;
						$(this.inputField).iCheck('check'); //将输入框的状态设置为checked 
					} else {
						//update this.inputField.checked = false;
						$(this.inputField).iCheck('uncheck');
					}
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				$(this.inputField).parent().addClass("disabled");
				$(this.inputField).iCheck('uncheck');
				this.inQueryGroup = false;
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemBooleanEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemBooleanEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				//alert(this.props.groupAlias + groupAlias);
				if (this.props.groupAlias == groupAlias && moduleInstanceId == this.props.moduleInstanceId) {
					var _value = this.record && _typeof(this.record) == "object" && this.props.dataField ? this.record[this.props.dataField] : this.record;
					var boolvalue = _value == "true" || _value == true || _value == "1";
					if (boolvalue) {
						//update this.inputField.checked = true;
						$(this.inputField).iCheck('check'); //将输入框的状态设置为checked 
					} else {
						//update this.inputField.checked = false;
						$(this.inputField).iCheck('uncheck');
					}
	
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final();
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
	
			//TODO setFinalValue继承自了超类
	
		}, {
			key: 'selectedChanged',
			value: function selectedChanged(value) {
				//todo 校验 需要考虑是否可编辑 将来有可能被放到Dialog及查询器上
				if (this.errorRecord != undefined) {
					this.errorRecord = undefined;
					return;
				}
				if (!this.props.dataField) {
					//update var value = this.inputField.checked;
					if (this.record == value) return;
					this.record = value;
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						if (this.props.control) {
							this.props.control.doModifiedEditor(!value, value, this);
						}
					}
				} else {
					var changed = false;
					var oldValue = this.record[this.props.dataField];
					//update let newValue = this.inputField.checked;
					var newValue = value;
					if (oldValue != newValue) changed = true;
					this.record[this.props.dataField] = newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "", null, this);
					}
				}
	
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				//对于boolean 与 Enum 不存在显示要求 所以不需要重新显示
				//this.setDisplay();
			}
		}, {
			key: 'restoreValue',
			value: function restoreValue(value) {
				if (value == undefined || value == null) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				var boolvalue = value == "true" || value == true || value == "1";
	
				//update this.inputField.checked = value;
				var _this = this;
				setTimeout(function (e) {
					if (_this.props.dataField && _this.record) {
						_this.record[_this.props.dataField] = Boolean(value);
					} else {
						_this.record = value;
					}
					_this.errorRecord = value;
					if (boolvalue) {
						$(_this.inputField).iCheck("check");
					} else {
						$(_this.inputField).iCheck("uncheck");
					};
				}, 400);
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == undefined || value == null) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				var boolvalue = value == "true" || value == true || value == "1";
				//update this.inputField.checked = value;
				if (boolvalue) $(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
			}
		}, {
			key: 'setDisplayFieldText',
			value: function setDisplayFieldText(value) {
				var triggerModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				var boolvalue = value == "true" || value == true || value == "1";
				//update this.inputField.checked = value;
				if (boolvalue) $(this.inputField).iCheck("check");else {
					//todo 由于iCheck源代码在执行uncheck指令时会判断checked属性 如果没有该属性或者有并且值为false则不做处理
					//所以在执行该指令之前 要先设置该属性为true
					$(this.inputField).prop("checked", true);
					$(this.inputField).iCheck("uncheck");
				}
				//this.setFinalValue(value,triggerModify);
	
				if (!this.props.dataField) {
					//update var value = this.inputField.checked;
					if (this.record == value) return;
					this.record = value;
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						if (this.props.control && triggerModify) {
							this.props.control.doModifiedEditor(!value, value);
						}
					}
				} else {
					var changed = false;
					var oldValue = this.record[this.props.dataField];
					//update let newValue = this.inputField.checked;
					var newValue = value;
					if (oldValue != newValue) changed = true;
					this.record[this.props.dataField] = newValue;
					//alert("派发");	
					if (changed && triggerModify) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
					}
				}
			}
		}, {
			key: 'setDisplayFieldBooleanText',
			value: function setDisplayFieldBooleanText(value) {
				var triggerModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				var boolvalue = value == "true" || value == true || value == "1";
				//update this.inputField.checked = value;
				if (boolvalue) $(this.inputField).iCheck("check");else {
					//todo 由于iCheck源代码在执行uncheck指令时会判断checked属性 如果没有该属性或者有并且值为false则不做处理
					//所以在执行该指令之前 要先设置该属性为true
					$(this.inputField).prop("checked", true);
					$(this.inputField).iCheck("uncheck");
				}
				//this.setFinalValue(value,triggerModify);
	
				if (!this.props.dataField) {
					//update var value = this.inputField.checked;
					if (this.record == value) return;
					this.record = value;
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						if (this.props.control && triggerModify) {
							this.props.control.doModifiedEditor(!value, value);
						}
					}
				} else {
					var changed = false;
					var oldValue = this.record[this.props.dataField];
					//update let newValue = this.inputField.checked;
					var newValue = value;
					if (oldValue != newValue) changed = true;
					this.record[this.props.dataField] = newValue;
					//alert("派发");	
					if (changed && triggerModify) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
					}
				}
				$(this.inputField).parent().addClass("disabled");
				this.inQueryGroup = false;
			}
		}, {
			key: 'inputFieldClick',
			value: function inputFieldClick() {
				$(this.inputField).focus();
				if (this.props.underQueryGroup) {
					$(this.inputField).parent().removeClass("disabled");
					this.inQueryGroup = true;
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemBooleanEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemBooleanEditor.prototype), 'componentDidMount', this).call(this);
				$(this.editorGroup).contextPopup(this.props.contextMenuData);
				if (this.props.underQueryGroup) {
					this.doSetEnable(false);
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
				$(this.inputField).on('ifChecked', this.selectedChanged.bind(this, true));
				$(this.inputField).on('ifClicked', this.inputFieldClick.bind(this));
				$(this.inputField).on('ifUnchecked', this.selectedChanged.bind(this, false));
				var _checkboxClass = 'icheckbox_minimal-blue14 outDataGrid_checkbox';
				//if(!this.state.allowEdit)
				//_checkboxClass += ' disabled';
				$(this.inputField).iCheck({
					checkboxClass: _checkboxClass
				});
				if (this.props.underQueryGroup) {
					return;
				}
				if (!this.state.allowEdit) $(this.inputField).iCheck('disable');
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("disabled") == undefined;
				if (nowAllowEdit == true && enable == false) {
					this.setState({ allowEdit: false });
					//$(this.inputField).attr("disabled",true);
				} else if (nowAllowEdit == false && enable == true) {
					this.setState({ allowEdit: true });
					//$(this.inputField).removeAttr("disabled");
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.props.underQueryGroup) {
					return;
				}
				if (this.state.allowEdit) {
					$(this.inputField).parent().removeClass("disabled");
					//$(this.inputField).iCheck('enable');
				} else {
					$(this.inputField).parent().addClass("disabled");
	
					//$(this.inputField).iCheck('disable');
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode || 13 === e.keyCode) {
					//alert(e.shiftKey)
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
				}
			}
		}, {
			key: 'getDisplayFieldText',
			value: function getDisplayFieldText() {
				return this.inputField.checked;
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom() {
				var _this3 = this;
	
				var _style = {};
				if (this.props.customStyle) Object.assign({}, _style);
				if (this.state.allowEdit) {
	
					if (this.props.underQueryGroup) {
						return _react2.default.createElement(
							'div',
							{ style: { marginRight: '10px' } },
							_react2.default.createElement('input', { type: 'checkbox', className: 'minimal', ref: function ref(node) {
									return _this3.inputField = node;
								}, style: _style,
								onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
								onBlur: this.inputFieldBlur.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', top: '10px', marginLeft: '2px', zIndex: '1000', fontSize: '1px', color: 'gray' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement('input', { type: 'checkbox', className: 'minimal', ref: function ref(node) {
								return _this3.inputField = node;
							}, style: _style,
							onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
							onBlur: this.inputFieldBlur.bind(this) });
					}
				} else {
					//disabled={true} 
					if (this.props.underQueryGroup) {
						return _react2.default.createElement(
							'div',
							{ onClick: this.inputFieldOnClick.bind(this) },
							_react2.default.createElement('input', { type: 'checkbox', className: 'minimal', ref: function ref(node) {
									return _this3.inputField = node;
								}, style: _style,
								onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
								disabled: true, onBlur: this.inputFieldBlur.bind(this), onClick: this.inputFieldOnClick.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { display: 'none', position: 'absolute', top: '10px', marginLeft: '2px', zIndex: '1000', fontSize: '3px' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
	
						return _react2.default.createElement('input', { type: 'checkbox', className: 'minimal', ref: function ref(node) {
								return _this3.inputField = node;
							}, style: _style,
							onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
							disabled: true, onBlur: this.inputFieldBlur.bind(this) });
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				/*let _inputdivstyle = {width:'auto',paddingLeft:'5px'};
	   if(this.props.underFieldGroup)
	   	_inputdivstyle.top = '6px';*/
				var notNull = this.props.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				/*let displayHeight = this.props.control.getProperty_DisplayHeight();
	   if(displayHeight == 1)
	   	editorStyle.height = "27px";*/
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
				var inputdom = this.getInputDom();
				var labelStyle = { paddingLeft: '5px', width: 'auto', whiteSpace: 'nowrap', textAlign: 'right', marginBottom: '-2px',
					height: '24px', lineHeight: '24px' };
				// if(this.state.underQueryGroup && !this.inQueryGroup)
				// {
				// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				// }
				if (!this.state.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				}
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, className: 'editorGroup', style: editorStyle, ref: function ref(node) {
							return _this4.editorGroup = node;
						} },
					_react2.default.createElement(
						'label',
						{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					inputdom
				)
	
				/*
	   	<div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
	   		<label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel"
	   			style={{paddingLeft:'5px',paddingRight:'5px',width:'auto'}}>{this.props.xml.name}</label>
	   		<div>
	   	        <input ref='inputdomtime' id={"input"+this.props.xml.id} type="text" className="form-control" style={{padding:'2px',width:inputWidth}}/>
	   	    </div>
	   	</div>
	   */
				;
			}
		}]);
	
		return FormItemBooleanEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemBooleanEditor;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemButton = __webpack_require__(92);
	
	var _FormItemButton2 = _interopRequireDefault(_FormItemButton);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(155);
	
	var FormItemButtonGroup = function (_FormItemContainer) {
		_inherits(FormItemButtonGroup, _FormItemContainer);
	
		function FormItemButtonGroup(props) {
			_classCallCheck(this, FormItemButtonGroup);
	
			return _possibleConstructorReturn(this, (FormItemButtonGroup.__proto__ || Object.getPrototypeOf(FormItemButtonGroup)).call(this, props));
		}
	
		_createClass(FormItemButtonGroup, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var parent = this.props.xml;
				var children = parent.FormItem;
				var that = this;
				var list = children.map(function (item) {
					return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
				});
	
				var _style = Object.assign({}, this.props.customStyle);
				if (!_style) _style = {};
	
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
	
				return _react2.default.createElement(
					'div',
					{ className: "GongqiFormItemButtonGroup", id: this.props.xml.name, ref: function ref(node) {
							return _this2.containerComponent = node;
						}, style: _style },
					list
				);
			}
		}]);
	
		return FormItemButtonGroup;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemButtonGroup.defaultProps = {};
	
	exports.default = FormItemButtonGroup;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _copyToClipboard = __webpack_require__(165);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CommandStore = __webpack_require__(18);
	
	var _DomStores = __webpack_require__(145);
	
	var _UtilStores = __webpack_require__(80);
	
	var _ResizeStore = __webpack_require__(79);
	
	var _FocusStore = __webpack_require__(28);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _MainMenuToggleStore = __webpack_require__(266);
	
	var _MainMenuToggleStore2 = _interopRequireDefault(_MainMenuToggleStore);
	
	var _ToolBarUpdateGridToolBarStore = __webpack_require__(267);
	
	var _ToolBarUpdateGridToolBarStore2 = _interopRequireDefault(_ToolBarUpdateGridToolBarStore);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _LookupStores = __webpack_require__(34);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _ArrayUtil = __webpack_require__(70);
	
	var _ArrayUtil2 = _interopRequireDefault(_ArrayUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _crypto = __webpack_require__(349);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var React = __webpack_require__(1);
	
	__webpack_require__(317);
	
	var xmlstring = {
	  id: "00025",
	  name: "创建人",
	  type: "StringEditor",
	  Properties: {
	    Width: { Value: "" },
	    Height: { Value: "" },
	    DisplayLength: { Value: 20 }
	  }
	};
	
	var xmldate = {
	  id: "00026",
	  name: "创建日期",
	  type: "DateEditor",
	  Properties: {
	    Width: { Value: "" },
	    Height: { Value: "" },
	    DisplayLength: { Value: 20 }
	  }
	};
	
	//对于Flex的DataGrid来讲 即使只设置了百分比宽度 那么也会根据列计算出初始宽度
	//ReactDataGri整体始终根据外层div来确定初始宽度 列宽度按设置
	
	var FormItemDataGrid = function (_GongqiFormItem) {
	  _inherits(FormItemDataGrid, _GongqiFormItem);
	
	  function FormItemDataGrid(props) {
	    _classCallCheck(this, FormItemDataGrid);
	
	    var _this2 = _possibleConstructorReturn(this, (FormItemDataGrid.__proto__ || Object.getPrototypeOf(FormItemDataGrid)).call(this, props));
	
	    _this2.scrollState = {
	      scrollTop: 0, scrollLeft: 0
	    };
	
	    _this2.classAlias = "FormItemDataGrid";
	    _this2._columns = _this2.props.columns;
	
	    _this2.deleteEnabled = true;
	    _this2.addEnabled = true;
	    _this2.saveEnabled = true;_this2.refreshEnabled = true;_this2.fetchAllEnabled = true;
	    _this2.state = { rows: props.initRecords ? props.initRecords : [], selectedIndexes: [0], scrollmax: 0,
	      visible: _this2.props.controlVisible, hideInVisible: _this2.props.hideInVisible,
	      updateMinHeight: -1, containerWidth100: false, columns: _this2._columns, heightAddon: 0, heightAddonDiffer: 0 };
	    _this2.bottomBarSettings = { selectedRows: true, obtainRows: true, sum: false, count: false };
	    //this.unsubscribeResizeStore = ResizeStore.listen(this.onContainerResize.bind(this));
	    _this2.unsubscribeVerticalSplitterStore = _ResizeStore.VerticalSplitterStore.listen(_this2.onVerticalSplitterReisze.bind(_this2));
	    _this2.unsubscribeRecordsCmpStore = _RecordsStore.RecordsCmpStore.listen(_this2.onExecuteCmp.bind(_this2));
	    _this2.unsubscribeGetSelectRecordsStore = _CommandStore.GetSelectRecordsStore.listen(_this2.onGetSelectRecords.bind(_this2));
	    _this2.unsubscribeGroupCurrentRecordChangedStore = _RecordsStore.GroupCurrentRecordChangedStore.listen(_this2.onCurrentRecordChanged.bind(_this2));
	    _this2.unsubscribeDomStore = _DomStores.DomReadyStore.listen(_this2.domReady.bind(_this2));
	
	    _this2.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this2.onFocusSet.bind(_this2));
	    _this2.unsubcribeRecordsRestoreCmpStore = _RecordsStore.RecordsRestoreCmpStore.listen(_this2.onRecordsRestoreCmp.bind(_this2));
	    _this2.unsubscribeNotifyDataGridCurrentGroupStore = _FocusStore.NotifyDataGridCurrentGroupStore.listen(_this2.onNotifyDataGridCurrentGroup.bind(_this2));
	    _this2.unsubscribeGetGridInfosStore = _UtilStores.GetGridInfosStore.listen(_this2.onGetGridInfos.bind(_this2));
	    _this2.unsubscribeUpdateFetchAllIconStore = _UtilStores.UpdateFetchAllIconStore.listen(_this2.onUpdateFetchAllIcon.bind(_this2));
	    _this2.unsubscribeTabpageUserChangedStore = _UtilStores.TabpageUserChangedStore.listen(_this2.onTabpageUserChanged.bind(_this2));
	
	    _this2.unsubscribeVisibleFalseToTrueStore = _ResizeStore.VisibleFalseToTrueStore.listen(_this2.onVisibleFalseToTrue.bind(_this2));
	    _this2.unsubscribeGroupSlideStore = _ResizeStore.GroupSlideStore.listen(_this2.onGroupSlide.bind(_this2));
	    _this2.unsubscribeGetDataGridColumnInfoStore = _UtilStores.GetDataGridColumnInfoStore.listen(_this2.onGetDataGridColumnInfo.bind(_this2));
	
	    if (!_this2.props.forLookup) {
	      _this2.unsubscribeRecordAutoSaveCmpStore = _RecordsStore.RecordAutoSaveCmpStore.listen(_this2.onRecordAutoSaveCmp.bind(_this2));
	      _this2.unsubscribeAfterNewRecordDataGridFocusSetStore = _FocusStore.AfterNewRecordDataGridFocusSetStore.listen(_this2.onAfterNewRecordDataGridFocus.bind(_this2));
	      _this2.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(_this2.onBeforeAutoSave.bind(_this2));
	      _this2.unsubscribeMainMenuToggleStore = _MainMenuToggleStore2.default.listen(_this2.onMainMenuToggleStore.bind(_this2));
	      _this2.unsubscribeSelectAllRecordsStore = _CommandStore.SelectAllRecordsStore.listen(_this2.onSelectAllRecords.bind(_this2));
	      _this2.unsubscribeToolBarUpdateGridToolBarStore = _ToolBarUpdateGridToolBarStore2.default.listen(_this2.onUpdateGridToolBar.bind(_this2));
	      _this2.unsubscribeSelectRecordsStore = _CmdTypeStore.SelectRecordsStore.listen(_this2.onCmdSelectRecords.bind(_this2));
	
	      _this2.unsubscribeAfterActiveRecordStore = _FocusStore.AfterActiveRecordStore.listen(_this2.onAfterActiveRecord.bind(_this2));
	
	      _this2.unsubscribeGetColumnLengthProperties = _CommandStore.GetColumnLengthProperties.listen(_this2.onGetColumnLengthProperties.bind(_this2));
	      _this2.unsubscribeScrollToAndFocusStore = _FocusStore.ScrollToAndFocusStore.listen(_this2.onScrollToAndFocus.bind(_this2));
	
	      _this2.unsubscribeClearGridSignedStore = _FocusStore.ClearGridSignedStore.listen(_this2.onClearGridSigned.bind(_this2));
	    } else {
	      _this2.unsubscribeLookupasteriskRefreshStore = _LookupStores.LookupasteriskRefreshStore.listen(_this2.onAsteriskRefresh.bind(_this2));
	      _this2.unsubscribeLookupBeforeCloseStore = _DomStores.LookupBeforeCloseStore.listen(_this2.onLookupBeforeClose.bind(_this2));
	    }
	
	    if (window.isPopUp && !_this2.props.forLookup || _this2.props.isPop && _this2.props.forLookup) {
	      _this2.unsubscribePopUpDomReadySotre = _DomStores.PopUpDomReadySotre.listen(_this2.onPopUpDomReady.bind(_this2));
	    }
	
	    _this2.unsubscribeUpdateDataGridStore = _UtilStores.UpdateDataGridStore.listen(_this2.onUpdateDataGrid.bind(_this2));
	    _this2.unsubscribeDynamicColumnStore = _UtilStores.DynamicColumnStore.listen(_this2.onDynamicColumns.bind(_this2));
	
	    _this2.unsubscribeRefreshPluginStore = _CmdTypeStore.RefreshPluginStore.listen(_this2.onRefreshRadioPlugin.bind(_this2));
	    return _this2;
	  }
	
	  _createClass(FormItemDataGrid, [{
	    key: 'onRefreshRadioPlugin',
	    value: function onRefreshRadioPlugin() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        _this3.state['radioRef'] = true;
	        _this3.forceUpdate();
	        try {
	          if (_this3.props.hasDividedBox) {
	            if ($(_this3.datagridContainer).find(".react-grid-Grid") && $(_this3.datagridContainer).find(".react-grid-Grid").length != 0) {
	              if (_this3.containerMulFixedHeight) {
	                $(_this3.datagridContainer).css("height", _this3.containerFixedHeight);
	              } else {
	                var _containerFinalHeight = $(_this3.datagridContainer).find(".react-grid-Grid").css('min-height');
	                _containerFinalHeight = _containerFinalHeight.substring(0, _containerFinalHeight.length - 2);
	                if ($("#app")[0].scrollHeight > $("#app")[0].clientHeight) {
	                  _containerFinalHeight = _containerFinalHeight - ($("#app")[0].scrollHeight - $("#app")[0].clientHeight) - 2;
	                }
	                $(_this3.datagridContainer).css("height", Number(_containerFinalHeight) + 50);
	                _this3.containerMulFixedHeight = Number(_containerFinalHeight) + 50;
	                _this3.containerFixedHeight = Number(_containerFinalHeight) + 50;
	              }
	            }
	          }
	        } catch (error) {}
	        _this3.state['radioRef'] = false;
	      }, 200);
	    }
	  }, {
	    key: 'onDynamicColumns',
	    value: function onDynamicColumns(args) {
	      if (args) {
	        if (args.key != this.props.groupAlias) return;
	        var columns = [];
	        var dynamicColumnId = void 0;
	        for (var i = 0; i < this.state.columns.length; i++) {
	          var column = this.state.columns[i];
	          if (column.isdynamic == true) {
	            dynamicColumnId = column.id;
	            continue;
	          }
	          columns.push(column);
	        }
	        var origColumnControl = void 0;
	        var origColumn = args.origColumn;
	        var dynamicColumnName = this.props.control.getDynamicColumnName();
	        if (dynamicColumnId) {
	          var controlKey = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, dynamicColumnId);
	          origColumnControl = _FormItemUtil2.default.getFormItemControl(controlKey);
	        } else {
	          origColumnControl = _FormItemUtil2.default.formItemControls[menuItemId + "." + formId + "." + dynamicColumnName];
	        }
	
	        for (var _i = 0; _i < args.dynamicColumns.length; _i++) {
	          var columnObj = args.dynamicColumns[_i];
	          var columnLabel = columnObj.columnLabel;
	          var columnDataKey = columnObj.dataKey;
	          var _column2 = {};
	          _column2.editable = true;
	          _column2.isdynamic = true;
	          _column2.key = args.key + "." + columnDataKey;
	          _column2.name = columnLabel;
	          _column2.skipTab = false;
	          _column2.isDataMethodField = false;
	          _column2.xmlName = origColumnControl.xml.name;
	          _column2.uid = dynamicColumnId + _i;
	          _column2.id = dynamicColumnId;
	          var _width = origColumnControl.getProperty_Width();
	
	          if (_width != "" && typeof _width == "string") _width = parseInt(_width);
	          if (!_width) {
	            var _displayLength = origColumnControl.propertyDisplayLength ? origColumnControl.propertyDisplayLength : origColumnControl.getProperty_DisplayLength();
	            if (_displayLength == _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH) _displayLength = _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH + 1;
	            _column2.width = _displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;
	          } else {
	            _column2.width = _width;
	          }
	          _column2.widthBak = _column2.width;
	          _column2.resizable = true;
	          _column2.editorType = origColumnControl.xml.type;
	          _column2.formatter = origColumnControl.getRenderForDynamicColumn(_column2.key);
	          _column2.editor = origColumnControl.getComponentInstanceForDataGrid(null, false);
	          _column2.dynamicFieldName = args.key + "." + origColumn;
	          _column2.dynamicFieldLabel = columnLabel;
	          columns.push(_column2);
	        }
	        this.setState({ columns: columns });
	      }
	    }
	  }, {
	    key: 'onGetDataFields',
	    value: function onGetDataFields() {}
	  }, {
	    key: 'onUpdateDataGrid',
	    value: function onUpdateDataGrid(formId, innerId) {
	      if (this.props.formId == formId && this.props.xml.id == innerId) this.forceUpdate();
	      var record = this.props.group.currentRecord;
	      _RecordsActions2.default.dataGridUserChanged(record, this.props.groupAlias, this.props.xml.id, this.props.moduleInstanceId, false);
	    }
	  }, {
	    key: 'onScrollToAndFocus',
	    value: function onScrollToAndFocus(arg) {
	      if (!arg) return;
	      var groupAlias = arg.groupAlias;
	      if (this.props.groupAlias != groupAlias) return;
	      var toIndex = arg.toIndex;
	      var dataField = arg.dataField;
	
	      var $container = $(this.datagridContainer);
	      var canvas = $container.find(".react-grid-Canvas")[0];
	      if (this.checkSelectedIndexOutScreen(toIndex)) {
	        var rowHeight = this.props.rowHeight ? this.props.rowHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
	        var scrollTopNum = toIndex * rowHeight;
	        canvas.scrollTop = scrollTopNum;
	      }
	
	      var hscroll = this.getSelectDataFieldOutScreenOffset(dataField);
	      if (hscroll != 0) {
	        canvas.scrollLeft += hscroll;
	      }
	
	      //this.grid.forceUpdate();
	      //this.grid.doOnSelect({idx:idx,rowIdx:toIndex,active:false});
	      //let _this = this;
	
	      setTimeout(function () {
	        //_this.grid.doOnSelect({idx:idx,rowIdx:toIndex,active:true});
	        //_this.grid.doOnSelect({idx:idx,rowIdx:toIndex,active:false});
	        $(canvas).find(".react-grid-Cell.react-grid-cell-signed").removeClass("react-grid-cell-signed");
	        var selectedRow = $(canvas).find(".react-grid-Row[data-index=" + toIndex + "]");
	        var cells = $(selectedRow).find(".react-grid-Cell");
	        for (var i = 0; i < cells.length; i++) {
	          var dataColumnKey = $(cells[i]).attr("data-columnkey");
	          if (dataColumnKey == dataField) {
	            $(cells[i]).addClass("react-grid-cell-signed");
	            return;
	          }
	        }
	
	        /*let domRows = $(canvas).find(".react-grid-Row");
	        let selectedRow = domRows.get(toIndex);
	        let cells = $(selectedRow).find(".react-grid-Cell");
	          cells[idx].focus();*/
	      }, 200);
	
	      /*if(selectedRow)
	      {
	        selectedRows[idx].focus();
	      }
	      else
	      {
	          canvas.scrollTo(canvas.scrollLeft,canvas.scrollTop+1);
	          let _this = this;
	          
	          setTimeout(function(){
	              let selectedRows = $(_this.datagridContainer).find(".react-grid-Cell.row-selected");
	            if(selectedRows.length>0)
	            {
	              selectedRows[idx].focus();
	            }
	          }
	          ,200);
	        }*/
	    }
	  }, {
	    key: 'onClearGridSigned',
	    value: function onClearGridSigned() {
	      $(this.datagridContainer).find(".react-grid-Cell.react-grid-cell-signed").removeClass("react-grid-cell-signed");
	    }
	  }, {
	    key: 'onGetDataGridColumnInfo',
	    value: function onGetDataGridColumnInfo(arg) {
	      if (this.props.xml.id != arg.gridId) return;
	      var _key = arg.key;var _last = false;var flag = false;
	      for (var i = 0; i < this.state.columns.length; i++) {
	        var _column = this.state.columns[i];
	        if (flag == true) {
	          if (_column.width != -1) {
	            _last = false;break;
	          }
	        }
	        if (_column.key == _key) {
	          flag = true;
	          if (i == this.state.columns.length - 1) _last = true;
	        }
	      }
	      arg.last = _last;
	    }
	  }, {
	    key: 'onPopUpDomReady',
	    value: function onPopUpDomReady() {
	      $(this.datagridContainer).css('width', '').css('min-width', '');
	    }
	  }, {
	    key: 'onGetColumnLengthProperties',
	    value: function onGetColumnLengthProperties(arg) {
	      var _this4 = this;
	
	      if (this._columns) {
	        var _loop = function _loop(i) {
	          var _column = _this4._columns[i];
	          var key = _column.key;
	          var $columnDoms = $(_this4.datagridContainer).find(".react-grid-HeaderCell>div");
	          $columnDoms.each(function (index) {
	            if ($(this).attr("data-xmlname") == key) {
	              arg[_column.uid] = { width: $(this).width() + 4 };
	              return false;
	            }
	          });
	        };
	
	        for (var i = 0; i < this._columns.length; i++) {
	          _loop(i);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      //this.unsubscribeResizeStore();
	
	      this.unsubscribeRecordsCmpStore();
	      this.unsubscribeGetSelectRecordsStore();
	      this.unsubscribeGroupCurrentRecordChangedStore();
	      this.unsubscribeDomStore();
	      this.unsubscribeFocusSetStore();
	
	      this.unsubcribeRecordsRestoreCmpStore();
	
	      this.unsubscribeNotifyDataGridCurrentGroupStore();
	      this.unsubscribeGetGridInfosStore();
	      this.unsubscribeUpdateFetchAllIconStore();
	      this.unsubscribeVerticalSplitterStore();
	
	      if (!this.props.forLookup) {
	        this.unsubscribeRecordAutoSaveCmpStore();
	        this.unsubscribeAfterNewRecordDataGridFocusSetStore();
	        this.unsubscribeAutoSaveBeforeStore();
	        this.unsubscribeMainMenuToggleStore();
	        this.unsubscribeSelectAllRecordsStore();
	        this.unsubscribeToolBarUpdateGridToolBarStore();
	
	        this.unsubscribeAfterActiveRecordStore();
	        this.unsubscribeSelectRecordsStore();
	        this.unsubscribeGetColumnLengthProperties();
	      } else {
	        this.unsubscribeLookupasteriskRefreshStore();
	        this.unsubscribeLookupBeforeCloseStore();
	      }
	
	      if (window.isPopUp && !this.props.forLookup || this.props.isPop && this.props.forLookup) {
	        this.unsubscribePopUpDomReadySotre();
	      }
	    }
	  }, {
	    key: 'onLookupBeforeClose',
	    value: function onLookupBeforeClose(entityId, innerId) {
	      var _module = this.props.control.module;
	      if (!_module) return;
	      var _entityId = _module.entityId;
	      var _innerId = _module.innerId;
	      if (_entityId != entityId || _innerId != innerId) return;
	      var canvas = $(this.datagridContainer).find(".react-grid-Canvas")[0];
	      if (canvas) canvas.scrollTop = 0;
	
	      $(this.recordsInfoLabel).html("");
	    }
	  }, {
	    key: 'onAsteriskRefresh',
	    value: function onAsteriskRefresh(entityId, innerId, filter) {
	      var _module = this.props.control.module;
	      if (!_module) return;
	      var _entityId = _module.entityId;
	      var _innerId = _module.innerId;
	      if (_entityId != entityId || _innerId != innerId) return;
	      _module.lookupArg["baseFilter"] = filter;
	      var _groupAlias = void 0;
	      if (this.props.group) _groupAlias = this.props.group.groupAlias;
	
	      _module.doLookupRefresh({ group: _groupAlias, appendFilter: true });
	    }
	  }, {
	    key: 'onCmdUpdateParentControlVisible',
	    value: function onCmdUpdateParentControlVisible(menuItemId, formId, names, isLookup) {
	      if (this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId && this.props.formId == formId) {
	        if (names.indexOf(this.props.xml.name) != -1) {
	          if (this.grid) this.grid.updateMetrics();
	        }
	      }
	    }
	  }, {
	    key: 'isParentControl',
	    value: function isParentControl(names) {
	      var control = this.props.control;
	      var parentControl = control.parentControl;
	      while (parentControl && parentControl.classAlias != "FormItemDesignControl") {
	        if (names.indexOf(parentControl.xml.name) != -1) {
	          return true;
	        }
	        parentControl = parentControl.parentControl;
	      }
	      return false;
	    }
	  }, {
	    key: 'onCmdUpdateControlVisible',
	    value: function onCmdUpdateControlVisible(menuItemId, formId, names, isLookup) {
	      if (this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId && this.props.formId == formId) {
	
	        if (names.indexOf(this.props.xml.name) != -1) {
	          var finalVisible = this.props.control.getProperty_Visible_Final();
	
	          if (finalVisible == true) {
	            if (this.state.hideInVisible == true) {
	              $(this.datagridContainer).css("display", "flex");
	            } else {
	              $(this.datagridContainer).css("visibility", "visible");
	            }
	          } else {
	            if (this.state.hideInVisible == true) {
	              $(this.datagridContainer).css("display", "none");
	            } else {
	              $(this.datagridContainer).css("visibility", "hidden");
	            }
	          }
	          this.grid.updateMetrics();
	          this.setState({ visible: finalVisible });
	          //this.forceUpdate();
	        } else {
	          var _columns = this.state.columns.slice();
	          var flag = false;
	          for (var i = 0; i < _columns.length; i++) {
	            var _column3 = _columns[i];
	            var _key = _column3.key;
	            if (_column3.isDataMethodField) {
	              _key = _column3.xmlName;
	            } else {
	              _key = _StringUtil2.default.convertToEachFirstUpperCase(_key);
	              _key = _key.replace(/\./g, "_");
	            }
	            if (names.indexOf(_key) != -1) {
	              var controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, _column3.uid);
	              var columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	              var _finalVisible = columnControl.getProperty_Visible_Final();
	              if (!_finalVisible) {
	                _column3.width = 0.1;
	                _column3.visible = false;
	                flag = true;
	              } else {
	                _column3.width = _column3.widthBak;
	                _column3.visible = true;
	                flag = true;
	              }
	            }
	          }
	
	          if (flag) {
	            this.setState({ columns: _columns });
	            //let that = this;
	            //setTimeout(function(){that.grid.forceUpdate();},1000);
	            this._columns = _columns;
	          }
	        }
	
	        if (this.isParentControl(names)) {
	          if (this.grid) {
	            var _grid = this.grid;
	            setTimeout(function () {
	              _grid.updateMetrics();
	            }, 100);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'onBeforeAutoSave',
	    value: function onBeforeAutoSave(groupAlias) {
	      if (groupAlias == this.props.groupAlias) {
	        if (this.grid && this.grid.state.selected && this.grid.state.selected.idx != -1 && this.grid.state.selected.rowIdx != -1) this.grid.setInactive();
	      }
	    }
	  }, {
	    key: 'onNotifyDataGridCurrentGroup',
	    value: function onNotifyDataGridCurrentGroup(groupAlias, moduleId) {
	      if (this.props.moduleInstanceId != moduleId) return;
	      /*let $headerCell = $(this.datagridContainer).find(".react-grid-HeaderCell");
	      if(groupAlias == this.props.groupAlias)
	      {
	        $headerCell.addClass("dataGridCurrentGroup");
	       
	        $headerCell.find(".pull-right").removeClass("dataGridPullRightNotCurrentGroup").addClass("dataGridPullRightCurrentGroup");
	      }
	      else
	      {
	        $headerCell.removeClass("dataGridCurrentGroup");
	       
	        $headerCell.find(".pull-right").removeClass("dataGridPullRightCurrentGroup").addClass("dataGridPullRightNotCurrentGroup");
	      }*/
	      var $headerCell = $(this.datagridContainer).find(".GongqiDataGridNumColHeaderCell");
	      if (groupAlias == this.props.groupAlias) {
	        $headerCell.text("*");
	      } else {
	        $headerCell.text(" ");
	      }
	    }
	  }, {
	    key: 'onAfterNewRecordDataGridFocus',
	    value: function onAfterNewRecordDataGridFocus(formId, itemId) {
	      if (this._columns.length == 0) return;
	      if (this.props.formId == formId && this.props.xml.id == itemId) {
	        var _doAfterNewRecordDataGridFocus = this.doAfterNewRecordDataGridFocus.bind(this);
	        setTimeout(function () {
	
	          _doAfterNewRecordDataGridFocus();
	        }, 100);
	      }
	    }
	  }, {
	    key: 'onAfterActiveRecord',
	    value: function onAfterActiveRecord(groupAlias) {
	      if (this.props.groupAlias == groupAlias && this.grid) {
	        var tmp = window.groupActiveRecordStateObj[groupAlias];
	        if (tmp.cutClickEnter == true) {
	          tmp.cutClickEnter = false;
	          this.grid.doOnSelect({ rowIdx: tmp.rowIdx, idx: tmp.idx, active: true });
	        }
	      }
	    }
	  }, {
	    key: 'onUpdateGridToolBar',
	    value: function onUpdateGridToolBar(obj) {
	      if (obj.groupAlias != this.props.groupAlias) return;
	      if (obj.del) {
	        $(this.deleteBtn).css({ background: 'url(./images/icons/da-del.svg) ', backgroundSize: '110%' });
	        this.deleteEnabled = true;
	      } else {
	        $(this.deleteBtn).css({ background: 'url(./images/icons/da-del-not.svg) ', backgroundSize: '110%' });
	        this.deleteEnabled = false;
	      }
	
	      if (obj.add) {
	        $(this.addBtn).css({ background: 'url(./images/icons/da-add.svg) ', backgroundSize: '110%' });
	        this.addEnabled = true;
	      } else {
	        $(this.addBtn).css({ background: 'url(./images/icons/da-add-not.svg) ', backgroundSize: '110%' });
	        this.addEnabled = false;
	      }
	
	      if (obj.save) {
	        $(this.saveBtn).css({ background: 'url(./images/icons/da-save.svg) ', backgroundSize: '100%' });
	        this.saveEnabled = true;
	      } else {
	        $(this.saveBtn).css({ background: 'url(./images/icons/da-save-not.svg) ', backgroundSize: '100%' });
	        this.saveEnabled = false;
	      }
	
	      if (obj.query) {
	        // $(this.refreshBtn).css({backgroundPositionX:'0px'});
	        // $(this.fetchAllBtn).css({backgroundPositionX:'-33px'});
	        this.refreshEnabled = true;this.fetchAllEnabled = true;
	      } else {
	        // $(this.refreshBtn).css({backgroundPositionX:'-179px'});
	        // $(this.fetchAllBtn).css({backgroundPositionX:'-213px'});
	        this.refreshEnabled = false;this.fetchAllEnabled = false;
	      }
	
	      if (obj.query) {
	        $(this.refreshBtnI).css({ background: 'url(./images/icons/ze-refsh.svg) 0px 2px', backgroundSize: '90%' });
	        $(this.refreshBtnSpan).css({ color: 'black' });
	        if ($(window.parent.document).find('#toolbar_recordRef .icon-container')) {
	          $(window.parent.document).find('#toolbar_recordRef .icon-container').css({ background: 'url(./images/icons/ze-ref.svg) 0px 2px no-repeat' });
	          $(window.parent.document).find('#toolbar_recordRef .menubtnLable').css({ color: 'black' });
	        }
	      } else {
	        $(this.refreshBtnI).css({ background: 'url(./images/icons/da-ref-not.svg) -4px 0px no-repeat' });
	        $(this.refreshBtnSpan).css({ color: '#9A9A9A' });
	        if ($(window.parent.document).find('#toolbar_recordRef .icon-container')) {
	          $(window.parent.document).find('#toolbar_recordRef .icon-container').css({ background: 'url(./images/icons/ze-ref-not.svg) 0px 2px no-repeat' });
	          $(window.parent.document).find('#toolbar_recordRef .menubtnLable').css({ color: '#9A9A9A' });
	        }
	      }
	    }
	  }, {
	    key: 'doAfterNewRecordDataGridFocus',
	    value: function doAfterNewRecordDataGridFocus() {
	      var column = void 0;var idx = void 0;
	      idx = 0;
	      column = this._columns[0];
	      //TODO_ DataGrid 字段 支持 updateControlSkipTab
	      var controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, column.uid);
	      var columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	      var sk = false;
	      if (columnControl) {
	        sk = columnControl.getProperty_ActualSkipTab();
	      } else {
	        sk = column.skipTab;
	      }
	      var nowIdx = idx;
	      while (column.width == 0.1 || sk) {
	        idx += 1;
	        if (idx == nowIdx) {
	          _FocusActions2.default.focusChange(this.props.xml, false);
	          return;
	        }
	
	        if (idx >= this._columns.length) {
	          _FocusActions2.default.focusChange(this.props.xml, false);
	          return;
	        } else if (idx < 0) {
	          _FocusActions2.default.focusChange(this.props.xml, false);
	          return;
	        }
	        column = this._columns[idx];
	        controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, column.uid);
	        columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	        sk = false;
	        if (columnControl) {
	          sk = columnControl.getProperty_ActualSkipTab();
	        } else {
	          sk = column.skipTab;
	        }
	      }
	
	      var rowIdx = this.state.selectedIndexes.length > 0 ? this.state.selectedIndexes[0] : 0;
	      //alert("onAfterNewRecordDataGridFocus   "+rowIdx);
	      var _parentWindow = window.parent.window;
	      //TODO自动进入列表之前 grid必须强制update 会造成性能问题 但是如果不这样做 创建出的项编辑器中props的value是上一选中行的
	      if (_parentWindow.userSettingEntry.autoEnterList && !window.disableAutoEnterList) {
	        this.grid.forceUpdate();
	        this.grid.doOnSelect({ idx: idx + 1, rowIdx: rowIdx, active: true });
	        return;
	      } else {
	        this.grid.doOnSelect({ idx: idx + 1, rowIdx: rowIdx, active: false });
	        var $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	        var columnKey = column.key;
	        for (var i = 0; i < $selectedCells.length; i++) {
	          var selectedCell = $selectedCells[i];
	          if ($(selectedCell).attr("data-columnKey") == columnKey) selectedCell.focus();
	        }
	      }
	    }
	  }, {
	    key: 'onFocusSet',
	    value: function onFocusSet(formId, itemId, pre, init) {
	      //TODO 对于程序设置焦点来讲 此代码会先发生 而后发生监听的focus事件 而两者均需要设置当前group
	      if (this._columns.length == 0) return;
	      var rowIdx = this.grid.state.selected.rowIdx;
	      if (this.props.formId == formId && this.props.xml.id == itemId) {
	        _FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId, this.props.xml.id);
	        var column = void 0;var idx = void 0;
	        if (pre) {
	          idx = this._columns.length - 1;
	          column = this._columns[idx];
	        } else {
	          idx = 0;
	          column = this._columns[0];
	        }
	        var nowIdx = idx;
	        while (column.width == 0.1 || column.skipTab) {
	          idx += pre ? -1 : 1;
	          if (idx == nowIdx) {
	            _FocusActions2.default.focusChange(this.props.xml, pre);
	            return;
	          }
	
	          if (idx >= this._columns.length) {
	            _FocusActions2.default.focusChange(this.props.xml, pre);
	            return;
	          } else if (idx < 0) {
	            _FocusActions2.default.focusChange(this.props.xml, pre);
	            return;
	          }
	          column = this._columns[idx];
	        }
	        //idx++;
	        if (init) {
	          this.initFocus(idx, rowIdx);
	          return;
	        }
	
	        //模拟react datagrid源代码定位流程
	        var _parentWindow = window.parent.window;
	        if (_parentWindow.userSettingEntry.autoEnterList && !window.disableAutoEnterList && column.editorType != "BooleanEditor") {
	          var _this = this;
	
	          setTimeout(function () {
	            var selectedRows = $(_this.datagridContainer).find(".react-grid-Cell.row-selected");
	            if (selectedRows.length == 0) {
	              var canvas = $(_this.datagridContainer).find(".react-grid-Canvas")[0];
	              if (canvas && typeof canvas.scrollTo == "function") {
	                canvas.scrollTo(canvas.scrollLeft, canvas.scrollTop + 1);
	              }
	            }
	            _this.grid.doOnSelect({ idx: idx + 1, rowIdx: rowIdx, active: true });
	          }, 200);
	          return;
	        } else {
	          this.grid.doOnSelect({ idx: idx + 1, rowIdx: rowIdx, active: false });
	        }
	
	        var selectedRows = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	        if (selectedRows.length > 0) {
	          selectedRows[idx].focus();
	        } else {
	          var canvas = $(this.datagridContainer).find(".react-grid-Canvas")[0];
	          if (canvas && typeof canvas.scrollTo == "function") {
	            canvas.scrollTo(canvas.scrollLeft, canvas.scrollTop + 1);
	            var _this5 = this;
	
	            setTimeout(function () {
	
	              var selectedRows = $(_this5.datagridContainer).find(".react-grid-Cell.row-selected");
	              if (selectedRows.length > 0) {
	                selectedRows[idx].focus();
	              }
	            }, 200);
	          }
	          /*f(this.grid && this.grid.state && this.grid.state.selected)
	          {
	            selectedRows = $(this.datagridContainer).find(".react-grid-Row");
	            if(selectedRows.length>this.grid.state.selected.rowIdx)
	            {
	              let cell = selectedRows[this.grid.state.selected.rowIdx];
	              if(cell)
	                cell.focus();
	              else
	                this.forceUpdate();
	            }
	            else
	            {
	              this.forceUpdate();
	            }
	          }
	          else
	          {
	            this.forceUpdate();
	          }*/
	
	          /*
	          this.waitingInitFocus = true;
	          this.waitingInitIdx = idx;
	          this.waitingInitRowIdx = rowIdx;*/
	        }
	      }
	    }
	  }, {
	    key: 'initFocus',
	    value: function initFocus(idx, rowIdx) {
	      this.waitingInitFocus = true;
	      this.waitingInitIdx = idx;
	      this.waitingInitRowIdx = rowIdx;
	    }
	
	    //DATAGRID的初始定位要在DataGrid完成第一次render 并且数据获取 所以要侦听didupdate方法
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.waitingInitFocus == true) {
	
	        this.waitingInitFocus = false;
	        var selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	        //当首次update但是无焦点 说明XML自动定位到别的控件 此时应该避免选中
	        if (selectedCells.length == 0) {
	          //TODO div在datagrid没有数据的情况下 无法获得焦点 只能通过js来复杂实现 是否有必要？
	          //$(this.refs["datagridcontainer"+this.props.xml.id]).focus();
	
	          if (this.props.forLookup) {
	            //this.grid.doOnSelect({idx:1,rowIdx:0,active:false});
	            //setTimeout(function(){selectedCells[0].focus();},200);
	            this.waitingInitFocus = true; //如果没有定位成功 则继续等待下次更新后定位 由于下拉框 所以风险应该较小
	          }
	
	          return;
	        }
	
	        var idx = this.waitingInitIdx;
	        var rowIdx = this.waitingInitRowIdx;
	
	        this.grid.doOnSelect({ idx: idx + 1, rowIdx: rowIdx, active: false });
	        selectedCells[idx].focus();
	      }
	
	      /*var containerId = "#datagridcontainer"+this.props.xml.id;
	      var reactgridGridId = containerId+" .react-grid-Grid";
	      if($(containerId).height() - $(reactgridGridId).height() > 10)
	      {
	        this.setState({updateMinHeight:$(containerId).height()-2});
	      }*/
	
	      var ele = $(this.datagridContainer).find(".react-grid-Canvas")[0];
	      if (ele) {
	        if (ele.scrollHeight > (ele.innerHeight || ele.clientHeight)) {
	          $(this.recordFirstBtn).show();$(this.recordLastBtn).show();
	        } else {
	          $(this.recordFirstBtn).hide();$(this.recordLastBtn).hide();
	        }
	      }
	
	      /*if(this.state.selectedIndexes && this.state.rows)
	      {
	        let length = this.state.selectedIndexes.length;
	        if(length>0)
	        {
	          let selectedIndex = this.state.selectedIndexes[length-1];
	          let record = this.state.rows[selectedIndex];
	          if(record && this.props.control.group.currentRecord != record)
	          {
	            
	          }
	        }
	        
	      }*/
	      // $(this.datagridContainer).on('resize', function() {
	      //   console.log('Div size changed');
	      // })
	    }
	  }, {
	    key: 'onExecuteCmp',
	    value: function onExecuteCmp(data, groupAlias, groupInstance, immediatelyUpdate) {
	      if (this.props.group == groupInstance && this.props.groupAlias == groupAlias) {
	
	        if (this.props.forLookup) {
	          this.waitingInitFocus = true;
	          this.waitingInitIdx = 0;
	          this.waitingInitRowIdx = 0;
	        }
	
	        if (this.testDataGridHideBecauseTabpageHide() == true) {
	          this.displayNoneingRows = data;
	        }
	        /*if(data && data.length > 0)
	        {
	          let item = data[0];
	          alert(item.day01);
	        }*/
	        this.setState({ rows: data, scrollmax: 0 });
	
	        if (immediatelyUpdate) this.forceUpdate();
	      }
	    }
	
	    /*onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	    {
	      this.setState(this.state);
	    }*/
	
	  }, {
	    key: 'onCurrentRecordChanged',
	    value: function onCurrentRecordChanged(records, record, groupAlias, moduleInstanceId, causeId, groupSource, parms) {
	      //alert(causeId + this.props.xml.id);
	      if (this.props.xml.id == causeId) {
	        //alert("causeId相等 直接返回"); 
	        return;
	      }
	
	      _RecordsActions2.default.groupCurrentRecordChangedNotGridUserOp(this.props.groupAlias);
	
	      if (this.props.groupAlias != groupAlias || moduleInstanceId != this.props.moduleInstanceId) return;
	
	      var selectIndex = this.state.rows.indexOf(record);
	      if (selectIndex == -1) selectIndex = records ? records.indexOf(record) : -1;
	      var length = this.state.selectedIndexes.length;
	      var nowSelectIndex = length > 0 ? this.state.selectedIndexes[length - 1] : -1;
	      //alert("currentRecordChange-->"+selectIndex);
	      if (selectIndex != -1 && selectIndex != nowSelectIndex) {
	        this.setState({ selectedIndexes: [selectIndex] });
	        this.selectedIndexesList = [selectIndex];
	        this.forceUpdate();
	      }
	      if (this.checkSelectedIndexOutScreen(selectIndex)) {
	        var $container = $(this.datagridContainer);
	        var rowHeight = this.props.rowHeight ? this.props.rowHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
	        var scrollTopNum = selectIndex * rowHeight;
	        $container.find(".react-grid-Canvas")[0].scrollTop = scrollTopNum;
	      }
	      if (parms && parms.hasOwnProperty("focus")) {
	        if (parms.focus == false) return;
	      }
	      //TODO 查询完成在record_First Last中定位要首先确定selectIndex 
	      if (this.props.group.isGlobalForehandGroup() && (this.isFocusedOnBody() || this.datagridContainer.contains(document.activeElement))) {
	        var idx = this.grid.state.selected.idx;
	        if (idx <= 0) idx = 1;
	        if (selectIndex < 0) selectIndex = 0;
	        //$(this.grid).focus();
	        var column = this.state.columns[idx - 1];
	        //this.grid.doOnSelect({idx:idx,rowIdx:selectIndex});
	
	        //TODO 考虑所有锁定列
	        /*let $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	        if($selectedCells[idx])
	          $selectedCells[idx].focus();*/
	
	        var $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	        var columnKey = column.key;
	        for (var i = 0; i < $selectedCells.length; i++) {
	          var selectedCell = $selectedCells[i];
	          if ($(selectedCell).attr("data-columnKey") == columnKey) selectedCell.focus();
	        }
	        return;
	        if (idx > 0) {
	          var _$selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	          if (_$selectedCells[idx - 1]) _$selectedCells[idx - 1].focus();
	        } else {
	
	          var _$selectedCells2 = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	          if (_$selectedCells2[_$selectedCells2.length - 1]) _$selectedCells2[_$selectedCells2.length - 1].focus();
	        }
	      }
	    }
	  }, {
	    key: 'isFocusedOnBody',
	    value: function isFocusedOnBody() {
	      return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
	    }
	  }, {
	    key: 'checkSelectedIndexOutScreen',
	    value: function checkSelectedIndexOutScreen(selectIndex) {
	      var $container = $(this.datagridContainer);
	      var $canvas = $container.find(".react-grid-Canvas");
	      var nowScrollTop = $canvas[0].scrollTop;
	      var rowHeight = this.props.rowHeight ? this.props.rowHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
	      var topOffsetRows = nowScrollTop / rowHeight;
	      if (selectIndex > topOffsetRows) {
	        var onScreenRows = $canvas.height() / rowHeight - 1;
	        return selectIndex > topOffsetRows + onScreenRows - 1;
	      }
	      return true;
	    }
	  }, {
	    key: 'getSelectDataFieldOutScreenOffset',
	    value: function getSelectDataFieldOutScreenOffset(dataField) {
	      var firstRow = $(this.datagridContainer).find(".react-grid-Row")[0];
	      var _columns = this.state.columns;
	      var offset = 0;
	      var $canvas = $(this.datagridContainer).find(".react-grid-Canvas");
	      var canvasWidth = $canvas.width();
	      var nowScrollLeft = $canvas[0].scrollLeft;
	      for (var i = 0; i < _columns.length; i++) {
	        var column = _columns[i];
	        var width = column.width;
	
	        var cellDataField = column.key;
	        offset += width;
	        if (cellDataField == dataField) {
	
	          if (offset < nowScrollLeft) {
	            return offset - nowScrollLeft - 120;
	          }
	          if (offset > nowScrollLeft + canvasWidth) {
	            return offset - (nowScrollLeft + canvasWidth) + 60;
	          }
	          break;
	        }
	      }
	      return 0;
	    }
	  }, {
	    key: 'gridKeyDown',
	    value: function gridKeyDown(proxy) {
	      //console.log(arguments);
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	
	        if (this.props.forLookup) {
	          //if(ne.keyCode == 27 && this.grid && this.grid.state.selected && this.grid.state.selected.active)
	          //    return;
	          if (ne.keyCode == 27 || ne.ctrlKey && ne.keyCode == 38) {
	            var _module2 = this.props.control.module;
	            var _entityId = _module2.props.entityId;
	            var _innerId = _module2.props.innerId;
	            _LookupActions2.default.popDropDownClose(_entityId, _innerId);
	            return false;
	          }
	        }
	
	        //alert(ne.keyCode);
	        if (ne.keyCode == 13) {
	          if (this.grid.state.selected) {
	            var selectedRowIdx = this.grid.state.selected.rowIdx;
	            if (selectedRowIdx != -1 && this.state.selectedIndexes.indexOf(selectedRowIdx) == -1) return false;
	          }
	        }
	
	        if (ne.keyCode == 40 || ne.keyCode == 38) {
	          //if(this.grid.isActive())
	          //  return false;
	          if (ne.ctrlKey) return false;
	          var record = null;
	          var newSelectIndexes = this.state.selectedIndexes.slice();
	          if (newSelectIndexes.length == 0) {
	            if (this.state.rows.length > 0) {
	              record = ne.keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
	              newSelectIndexes.push(0);
	            }
	          } else {
	            var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	            var newIndex = ne.keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
	            var total = this.state.rows.length;
	            if (newIndex >= 0 && newIndex < total) {
	              record = this.state.rows[newIndex];
	              newSelectIndexes = [newIndex];
	            }
	          }
	
	          var oldSelectIndexes = this.state.selectedIndexes;
	          var changed = oldSelectIndexes.toString() != newSelectIndexes.toString();
	          if (changed) {
	            // if(this.grid.isActive())
	            // {
	            //   this.updateSelectAfterRowUpdate = true;
	            //   this.tmpUpdateSelectArg = {selectedIndexes:newSelectIndexes,removed:false,record:record,changed:changed};
	            //   return;
	            // }
	
	            _RecordsActions2.default.RecordAutoSave(this.props.groupAlias);
	            if (window.rowChangeAutoSaveFail == true) {
	              window.rowChangeAutoSaveFail = false;
	              return;
	            }
	            //alert("开始换行");
	          }
	
	          this.setState({ selectedIndexes: newSelectIndexes });
	          this.selectedIndexesList = newSelectIndexes;
	          if (record != null) _RecordsActions2.default.dataGridUserChanged(record, this.props.groupAlias, this.props.xml.id, this.props.moduleInstanceId);
	          return true;
	        } else if (ne.ctrlKey && ne.keyCode == 65) {
	          var allSelectedIndex = [];
	          for (var i = 0; i < this.state.rows.length; i++) {
	            allSelectedIndex[i] = i;
	          }
	          this.setState({ selectedIndexes: allSelectedIndex });
	          this.selectedIndexesList = allSelectedIndex;
	          ne.preventDefault();
	          ne.stopPropagation();
	        } else if (ne.ctrlKey && ne.keyCode == 67) {
	          //this.copyText("ddddddddddddddddddddddddddddddddd");
	          if (this.grid && this.grid.isActive()) return;
	          var _selectedRecords = [];
	          var selectedIndexes = this.selectedIndexesList ? this.selectedIndexesList.slice() : this.state.selectedIndexes.slice();
	          selectedIndexes.sort(function (a, b) {
	            return a - b;
	          });
	          var rows = this.state.rows;
	          var _records = this.props.group.isTempTable ? rows : this.props.group.records;
	          for (var _i2 = 0; _i2 < selectedIndexes.length; _i2++) {
	            var _record = _records[selectedIndexes[_i2]];
	            _selectedRecords.push(_record);
	          }
	          var text = this.props.group.getSpecExportData(_selectedRecords);
	          if (text) {
	            var copyHandler = function copyHandler(e) {
	              e.clipboardData.setData('text/plain', text);
	              e.preventDefault();
	            };
	            document.addEventListener('copy', copyHandler);
	            (0, _copyToClipboard2.default)(text);
	            document.removeEventListener('copy', copyHandler);
	          }
	        }
	
	        if (ne.keyCode == 32) {
	          if (this.grid && !this.grid.isActive()) {
	            if (ne.preventDefault) {
	              ne.preventDefault();
	            } else if (window.event) {
	              window.event.returnValue = false;
	            }
	          }
	        }
	
	        _UtilActions2.default.keyDownCast(ne);
	      }
	    }
	  }, {
	    key: 'copyText',
	    value: function copyText(text, callback) {
	      var tag = document.createElement('input');
	      tag.setAttribute('id', 'cp_hgz_input');
	      tag.value = text;
	      document.getElementsByTagName('body')[0].appendChild(tag);
	      document.getElementById('cp_hgz_input').select();
	      document.execCommand('copy');
	      document.getElementById('cp_hgz_input').remove();
	      if (callback) {
	        callback(text);
	      }
	    }
	  }, {
	    key: 'onSelectAllRecords',
	    value: function onSelectAllRecords(value, groupAlias, moduleInstanceId) {
	      if (this.props.groupAlias != groupAlias) return;
	      var allSelectedIndex = [];
	      if (value == true) {
	        for (var i = 0; i < this.state.rows.length; i++) {
	          allSelectedIndex[i] = i;
	        }
	        this.setState({ selectedIndexes: allSelectedIndex });
	        this.selectedIndexesList = allSelectedIndex;
	      } else {
	        this.setState({ selectedIndexes: [] });
	        this.selectedIndexesList = [];
	      }
	    }
	
	    //dataGridUserChanged->FormDataSourceGroup 的 onDataGridUserChanged -> FormDataGrid又侦听到因为要切换当前选中记录
	    //    携带gridId                        gridId                                           判断是由自己引起的
	
	  }, {
	    key: 'rowClick',
	    value: function rowClick(index, record, proxy, selected) {
	      if (index == -1) return;
	      window.lastFocusUI = this;
	      window.lastFocusDataGrid = this;
	      if (_AjaxRemoteUtil2.default.tokenNum > 0) {
	        //alert("正在远程 rowClick被阻止");
	        return;
	      }
	      /*let nowTime = new Date().getTime();
	      let firstClick = false;
	      if(!this.rowClickTimeCache)
	      {
	        firstClick = true;
	        this.rowClickTimeCache = nowTime;
	      }
	        if(!firstClick && (nowTime - this.rowClickTimeCache < 500))
	      {
	        this.rowClickTimeCache = nowTime;
	        return;
	      }
	      this.rowClickTimeCache = nowTime;*/
	      this.lastSelected = selected;
	      var newSelectIndexes;
	      var removed = false;
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	
	        if (ne.shiftKey) {
	          //let origSelectIndexes = this.state.selectedIndexes;
	          if (this.state.selectedIndexes.length > 0) {
	            newSelectIndexes = this.state.selectedIndexes.slice();
	            var minIndex = newSelectIndexes[0];var maxIndex = newSelectIndexes[0];
	            for (var i in newSelectIndexes) {
	              if (newSelectIndexes[i] > maxIndex) maxIndex = newSelectIndexes[i];
	              if (newSelectIndexes[i] < minIndex) minIndex = newSelectIndexes[i];
	            }
	
	            if (index > maxIndex) {
	              for (i = maxIndex + 1; i <= index; i++) {
	                newSelectIndexes.push(i);
	              }
	            } else if (index < minIndex) {
	              for (i = minIndex - 1; i >= index; i--) {
	                newSelectIndexes.push(i);
	              }
	            } else {
	              if (newSelectIndexes.indexOf(index) == -1) {
	                var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	                newSelectIndexes.push(index);
	                for (i = 0; i < Math.abs(index - lastIndex); i++) {
	                  if (index < lastIndex) {
	                    newSelectIndexes.push(index + i);
	                  } else if (lastIndex > index) {
	                    newSelectIndexes.push(lastIndex + i);
	                  }
	                }
	              }
	            }
	          } else {
	            newSelectIndexes.push(index);
	          }
	        } else if (ne.ctrlKey) {
	          newSelectIndexes = this.state.selectedIndexes.slice();
	          if (newSelectIndexes.indexOf(index) == -1) {
	            newSelectIndexes.push(index);
	          } else {
	            _ArrayUtil2.default.removeByValue(newSelectIndexes, index);removed = true;
	          }
	          //禁止完全取消选中 因为很多功能流程都依赖于选中项 如果去掉可能造成很多不可预知的bug 如保存记录时recId重复
	          //新增记录 然后取消选中 换行 此时会导致保存成功 但是DataGrid控件并没有把保存成功的记录更新到状态因为已没有选中项
	          if (newSelectIndexes.length == 0) newSelectIndexes = [index];
	        } else {
	          newSelectIndexes = [index];
	        }
	        //alert(ne.ctrlKey);alert(ne.shiftKey);
	      } else {
	        newSelectIndexes = [index];
	      }
	
	      var oldSelectIndexes = this.state.selectedIndexes;
	      var changed = oldSelectIndexes.toString() != newSelectIndexes.toString();
	      if (changed && !this.props.forLookup) {
	        if (this.grid && this.grid.isActive()) {
	          //let editorDom = $("#datagridcontainer"+this.props.xml.id).find(".react-grid-Cell.row-selected input.editor-main");
	          //this.grid.forceUpdate();
	          this.updateSelectAfterRowUpdate = true;
	          this.tmpUpdateSelectArg = { selectedIndexes: newSelectIndexes, removed: removed, record: record, changed: changed };
	          return;
	        }
	        //let disable_autoSave = this.props.control.getProperty_DisableAutoSave();
	        /*let disable_autoSave = false;
	        if(this.props.group && this.props.group.isTempTable == true)
	        {
	          disable_autoSave = true;
	        }
	        disable_autoSave = false;
	        let autoSave = true;
	        
	        if(disable_autoSave == "true" || (typeof(disable_autoSave) == "boolean" && disable_autoSave == true))
	        {
	          autoSave = false;
	        }*/
	        var autoSave = true;
	        if (autoSave) {
	          _RecordsActions2.default.RecordAutoSave(this.props.groupAlias);
	          if (window.rowChangeAutoSaveFail == true) {
	            window.rowChangeAutoSaveFail = false;
	            return;
	          }
	
	          /*if(this.state.rows != this.props.control.group.records)
	          {
	            alert("错误纠正");
	          }*/
	          //TODO 此处不知为何要做记录的纠正 不知道何种情况会出现state.rows和group.records的不同步
	          //但是需要判断临时表的tempRecordsFilter 否则纠正过的record会和state.rows中的record不一样
	          //group的currentRecord会和界面上选中的记录不一致,造成严重bug 比如右键详细信息查看的详情跟当前
	          //界面上选中记录不一致。
	          try {
	            if (this.state.rows && this.props.control.group.records) {
	              var recordIndex = this.state.rows.indexOf(record);
	              if (recordIndex != -1) {
	                var _groupRecords = this.props.control.group.records;
	                if (this.props.control.group.isTempTable == true) {
	                  if (this.props.control.group.tempRecordsFilter) _groupRecords = this.props.control.group.tempRecordsFilter;
	                }
	                var nowRecord = _groupRecords[recordIndex];
	                if (nowRecord && nowRecord != record) {
	                  record = nowRecord;
	                  //alert("记录纠正");
	                }
	              }
	            }
	          } catch (e) {}
	        }
	
	        //alert("开始换行");
	      }
	
	      this.setState({ selectedIndexes: newSelectIndexes });
	      this.selectedIndexesList = newSelectIndexes;
	      if (removed) {
	        var _lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	        record = this.state.rows[_lastIndex];
	      }
	      if (changed) {
	        //let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
	        //let _record = this.state.rows[lastIndex];
	        _RecordsActions2.default.dataGridUserChanged(record, this.props.groupAlias, this.props.xml.id, this.props.moduleInstanceId, false);
	      }
	
	      if (this.props.forLookup) {
	        if (this.props.remoteReturnHandler) {
	          if (this.props.remoteReturnHandler(record)) return;
	        }
	
	        if (this.props.autoReturnHandler) {
	          if (this.props.autoReturnHandler(record)) return;
	        }
	      }
	    }
	  }, {
	    key: 'getColumns',
	    value: function getColumns() {
	      var _this6 = this;
	
	      var clonedColumns = this._columns.slice();
	      clonedColumns[2].events = {
	        onClick: function onClick(ev, args) {
	          var idx = args.idx;
	          var rowIdx = args.rowIdx;
	          _this6.grid.openCellEditor(rowIdx, idx);
	        }
	      };
	
	      return clonedColumns;
	    }
	  }, {
	    key: 'rowGetter',
	    value: function rowGetter(i) {
	      return this.state.rows[i];
	    }
	  }, {
	    key: 'onGetSelectRecords',
	    value: function onGetSelectRecords(selectedRecords, groupAlias, moduleInstanceId) {
	      var containsSelectedRecordKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
	
	        if (containsSelectedRecordKey == true) {
	          if (!selectedRecords || selectedRecords.length == 0) {
	            var _selectRecordsKeys = [];
	            _CommandActions2.default.getSelectRecordsKey(_selectRecordsKeys, groupAlias, this.props.menuItemId, this.props.formId, moduleInstanceId);
	            var _selectRecordsKey = _selectRecordsKeys.length > 0 ? _selectRecordsKeys[0] : null;
	
	            if (_selectRecordsKey) {
	              for (var i = 0; i < this.state.rows.length; i++) {
	                var item = this.state.rows[i];
	                var value = item[_selectRecordsKeys];
	                if (value == true || value == "true") {
	                  selectedRecords.push(item);
	                }
	              }
	            }
	          }
	        }
	
	        if (!selectedRecords || selectedRecords.length == 0) {
	          // var selectedIndexes = this.state.selectedIndexes;
	          var selectedIndexes = this.selectedIndexesList ? this.selectedIndexesList : this.state.selectedIndexes;
	          var rows = this.state.rows;
	
	          var _records = this.props.group.isTempTable ? rows : this.props.group.records;
	          for (var _i3 = 0; _i3 < selectedIndexes.length; _i3++) {
	            //TODO检查临时表客户端过滤时 rows是否与group.records一致 如果使用rows 则可能存在
	            //自动保存完调用后台二次开发的时候不一致的情况 如buttonOk的recordsave
	            var _record = _records[selectedIndexes[_i3]]; //rows[selectedIndexes[i]];
	            selectedRecords.push(_record);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'onRowsSelected',
	    value: function onRowsSelected(rows) {
	      alert("trigger rowSelect");
	      var newSelectIndexes = [];
	      if (!this.props.allowMutiSelect) {
	        if (rows.length > 0) {
	          var currentRow = rows[rows.length - 1];
	          //alert(JSON.stringif(currentRow));
	          _RecordsActions2.default.dataGridUserChanged(currentRow.row, this.props.groupAlias, this.props.xml.id, this.props.moduleInstanceId);
	        }
	        newSelectIndexes = this.state.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }));
	      } else {
	        var newSelectIndexes = [];
	        if (rows.length > 0) newSelectIndexes.push(rows[rows.length - 1].rowIdx);
	      }
	
	      this.setState({ selectedIndexes: newSelectIndexes });
	      this.selectedIndexesList = newSelectIndexes;
	    }
	  }, {
	    key: 'onRowsDeselected',
	    value: function onRowsDeselected(rows) {
	      var rowIndexes = rows.map(function (r) {
	        return r.rowIdx;
	      });
	      var nowSelectIndexes = this.state.selectedIndexes.filter(function (i) {
	        return rowIndexes.indexOf(i) === -1;
	      });
	      this.setState({ selectedIndexes: nowSelectIndexes });
	      this.selectedIndexesList = nowSelectIndexes;
	      if (nowSelectIndexes.length > 0) {
	        var records = this.state.rows;
	        var nowSelectIndex = nowSelectIndexes[nowSelectIndexes.length - 1];
	        var record = records[nowSelectIndex];
	        _RecordsActions2.default.dataGridUserChanged(record, this.props.groupAlias, this.props.xml.id, this.props.moduleInstanceId);
	      }
	    }
	  }, {
	    key: 'updateReactDataGridHeight',
	    value: function updateReactDataGridHeight(addon) {
	      return;
	      //alert('updateReactDataGridHeight');
	      if (addon == undefined) addon = 0;
	
	      var _height = $(this.datagridContainer).outerHeight();
	
	      _height += addon;
	
	      $("#" + containerId + " .react-grid-Grid").css("min-height", _height);
	      $("#" + containerId + " .react-grid-Canvas").css("height", _height);
	      this.grid.base.updateMetrics();
	    }
	  }, {
	    key: 'updateReactDataGridWidth',
	    value: function updateReactDataGridWidth() {
	      this.grid.updateMetrics();
	    }
	  }, {
	    key: 'domReady',
	    value: function domReady() {
	      //this.updateReactDataGridHeight();
	      //alert("domready");
	
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //组件完成Dom渲染时会被调用
	      //this.inertvalId = setInterval(this.updateReactDataGridHeight.bind(this),10);
	      // var containerId = 'datagridcontainer'+this.props.xml.id;
	      // $(this.refs[containerId]).resize(function(){alert("resize");this.updateReactDataGridHeight();})
	      /*var containerId = 'datagridcontainer'+this.props.xml.id;
	      var _height =  $(this.refs[containerId]).height();
	        var _rows = this.props.xml.Properties.Rows.Value;
	      var _initHeight = parseInt(_rows)*35+35;
	      if(_height<_initHeight)
	         _height = _initHeight;
	      $("#"+containerId+" .react-grid-Grid").css("min-height",_height);
	      $("#"+containerId+" .react-grid-Canvas").css("height",_height);
	      this.grid.base.updateMetrics();*/
	      //this.grid.updateMetrics();
	
	      //this.updateReactDataGridHeight();
	
	      //this.grid.base.viewport.setProps({minHeight:_height});
	      //this.grid.base.viewport.metricsUpdated();
	      //this.grid.base.viewport.canvas.componentDidUpdate();
	      //setState(this.grid.base.viewport.getGridState({minHeight:_height}));
	      //this.grid.base.viewport.setState({});
	      //canvas.setProps({height:_height});
	      // this.grid.setProps({minHeight:_height});
	      // this.grid.setState({});
	      //this.grid.minHeight = _height;
	      var _parentWindow = window.parent.window;
	      this.grid.clickEnter = _parentWindow.userSettingEntry.autoEnterList && !window.disableAutoEnterList;
	      this.grid.groupAlias = this.props.groupAlias;
	      $(this.datagridContainer).find(".react-grid-Canvas").contextPopup(this.props.contextMenuData).css({ 'overflow-y': 'auto', 'overflow-x': 'scroll' });
	      // console.log(document.body.offsetWidth);
	      if (this.props.updateHeightPercent100) {
	
	        $(this.datagridContainer).css("height", "100%");
	        setTimeout(this.updateReactDataGridHeight.bind(this), 100);
	      }
	      //let $datagridContainer = $(this.datagridContainer);
	      //alert($datagridContainer.height());
	      //TODO 在DivideBox 下面 高度暂时不给 给了会出滚动条
	      if (this.props.hasDividedBox) {
	        var that = this;
	        setTimeout(function () {
	          var _containerFinalHeight = $(that.datagridContainer).height();
	
	          $(that.datagridContainer).height(_containerFinalHeight - 2);
	          that.containerFixedHeight = _containerFinalHeight - 2;
	        }, 200);
	      }
	
	      if (!this.props.showToolbar) {
	        $(this.bottombarNode).css("display", "none");
	      }
	      /*var containerId = "#datagridcontainer"+this.props.xml.id;
	      var reactgridGridId = containerId+" .react-grid-Grid";
	      alert($(containerId).height() + "  " + $(reactgridGridId).height());*/
	
	      /*if (window.addEventListener) {
	       window.addEventListener('resize', this.updateMetrics.bind(this));
	      } else {
	       window.attachEvent('resize', this.updateMetrics.bind(this));
	      }*/
	
	      $(this.datagridContainer);
	      {
	        /*let _outerWidth = $(this.datagridContainer).outerWidth(true);
	        let _acWidth = $(this.datagridContainer).width();
	        let _offset = _outerWidth - _acWidth;*/
	
	        var rightStr = $(this.datagridContainer).css("padding-right");
	
	        if (!rightStr) rightStr = "0px";
	        var rightNum = rightStr.substr(0, rightStr.length - 2);
	
	        $(this.recordFirstBtn).css("right", rightNum + "px");
	        $(this.recordLastBtn).css("right", rightNum + "px");
	      }
	
	      $(this.bottombarNode).contextPopup({
	        selectTag: true,
	        items: [{ label: '已获取行', icon: '', action: this.bottomBarCalc.bind(this, 'obtainRows'), checked: true }, { label: '选中行', icon: '', action: this.bottomBarCalc.bind(this, 'selectedRows'), checked: true },
	        //{label:'所有行',icon:'',action:this.bottomBarCalc.bind(this,'allRows'),checked:false},
	        null, { label: '计数', icon: '', action: this.bottomBarCalc.bind(this, 'count'), checked: this.bottomBarSettings.count }, { label: '求和', icon: '', action: this.bottomBarCalc.bind(this, 'sum'), checked: this.bottomBarSettings.sum }, { label: '平均值', icon: '', action: this.bottomBarCalc.bind(this, 'avg'), checked: false }, { label: '最大值', icon: '', action: this.bottomBarCalc.bind(this, 'max'), checked: false }, { label: '最小值', icon: '', action: this.bottomBarCalc.bind(this, 'min'), checked: false }]
	      });
	    }
	  }, {
	    key: 'bottomBarCalc',
	    value: function bottomBarCalc(key) {
	      this.bottomBarSettings[key] = !this.bottomBarSettings[key];
	      this.updateBottomBar();
	    }
	  }, {
	    key: 'updateMetrics',
	    value: function updateMetrics() {
	      //var containerId = 'datagridcontainer'+this.props.xml.id;
	      //al/ert($(this.datagridContainer).width() + "   " + this.refs[containerId].offsetWidth);
	    }
	  }, {
	    key: 'onMainMenuToggleStore',
	    value: function onMainMenuToggleStore() {
	      this.setState({ containerWidth100: true });
	    }
	  }, {
	    key: 'onVerticalSplitterReisze',
	    value: function onVerticalSplitterReisze(_id, addon) {
	      if (_id != this.props.xml.id) return;
	
	      //如果是由于纵向分隔拖动导致该DataGrid高度发生变化 并且 该DataGrid为高度发生变化的最外层且已经由DividedBox设置了高度 则标记一下
	      //以免后续render冲掉该直接操作dom节点设置的高度
	      var heightCss = $(this.datagridContainer).css("height");
	      if (heightCss) this.dividedBoxSplitFixedHeight = heightCss;
	
	      this.containerFixedHeight += addon;
	      this.forceUpdate();
	      //var that = this;
	      //setTimeout(function(){this.grid.base.updateMetrics();},1000);
	    }
	  }, {
	    key: 'onContainerResize',
	    value: function onContainerResize(_id, flayout, addon) {
	      if (_id != this.props.xml.id) return;
	      if (this.grid != null) {
	        if (flayout == "horizontal") {
	          this.updateReactDataGridWidth();
	        } else if (flayout == "vertical") {
	          this.forceUpdate();
	          if (addon == undefined) addon = 0;
	          this.updateReactDataGridHeight(addon);
	        }
	      }
	    }
	  }, {
	    key: 'onRecordsRestoreCmp',
	    value: function onRecordsRestoreCmp(groupAlias, records, moduleInstanceId) {
	      if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
	        this.setState({ rows: records });
	      }
	    }
	  }, {
	    key: 'onRecordAutoSaveCmp',
	    value: function onRecordAutoSaveCmp(groupAlias, record) {
	      if (this.props.groupAlias != groupAlias) return;
	      var rows = this.state.rows.slice();
	      var nowSelectIndexes = this.state.selectedIndexes;
	      var index = nowSelectIndexes[nowSelectIndexes.length - 1];
	      rows[index] = record;
	
	      this.setState({ rows: rows });
	      //alert(JSON.stringify("自动保存返回"));
	    }
	
	    //用来编辑
	
	  }, {
	    key: 'handleGridRowsUpdated',
	    value: function handleGridRowsUpdated(_ref) {
	      var cellKey = _ref.cellKey,
	          fromRow = _ref.fromRow,
	          toRow = _ref.toRow,
	          fromRowId = _ref.fromRowId,
	          toRowId = _ref.toRowId,
	          rowIds = _ref.rowIds,
	          updated = _ref.updated,
	          action = _ref.action;
	
	
	      /*if(action == "CELL_DRAG")
	      {
	        window.gridCellDrag = {fromRow:fromRow,toRow:toRow,cellKey:cellKey,gridId:this.props.xml.id,rows:this.state.rows};
	        this.forceUpdate();
	        return;
	      }*/
	
	      //slice为浅表克隆 虽然不会直接修改rows,但此处会修改rows中的元素的字段 即group中的currentRecord
	      //所以 如果需要延迟换行做自动保存时 可以判断记录是否已经发生更改
	      var rows = this.state.rows.slice(0);
	      for (var i = fromRow; i <= toRow; i++) {
	        var rowToUpdate = rows[i];
	        var updatedRow = $.extend(rowToUpdate, updated);
	        //React.addons.update(rowToUpdate, {$merge: updated});
	        rows[i] = updatedRow;
	      }
	
	      if (this.updateSelectAfterRowUpdate) {
	        //this.tmpUpdateSelectArg = {selectedIndexes:newSelectIndexes,removed:removed,record:record};
	        var newSelectIndexes = this.tmpUpdateSelectArg.selectedIndexes;
	        var removed = this.tmpUpdateSelectArg.removed;
	        var record = this.tmpUpdateSelectArg.record;
	        var changed = this.tmpUpdateSelectArg.changed;
	        this.updateSelectAfterRowUpdate = false;
	        _RecordsActions2.default.RecordAutoSave(this.props.groupAlias);
	
	        if (window.rowChangeAutoSaveFail == true) {
	          window.rowChangeAutoSaveFail = false;
	          return;
	        }
	
	        this.setState({ selectedIndexes: newSelectIndexes });
	        this.selectedIndexesList = newSelectIndexes;
	        //alert("延迟换行");
	        if (removed) {
	          var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	          record = this.state.rows[lastIndex];
	        }
	        if (changed) _RecordsActions2.default.dataGridUserChanged(record, this.props.groupAlias, this.props.xml.id, this.props.moduleInstanceId);
	      } else {
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'programSelectRecord',
	    value: function programSelectRecord() {
	      var selectedIndexes = this.state.selectedIndexes.slice();
	      selectedIndexes.push(1);
	      this.setState({ selectedIndexes: selectedIndexes });
	    }
	  }, {
	    key: 'getCurrentRecords',
	    value: function getCurrentRecords() {
	      var selectedRows = [];
	      for (var i = 0; i < this.state.selectedIndexes.length; i++) {
	        var value = this.state.selectedIndexes[i];
	        var row = this.state.rows[value];
	        selectedRows.push(row);
	      }
	      alert(JSON.stringify(selectedRows));
	    }
	  }, {
	    key: 'triggerEdit',
	    value: function triggerEdit() {
	      this.grid.openCellEditor(1, 4);
	    }
	  }, {
	    key: 'scrollToIndex',
	    value: function scrollToIndex(index) {
	      //alert(this.grid.props.rowHeight);
	      if (index == undefined) index = 30;
	      var targetTop = this.grid.props.rowHeight * (index + 1);
	      var _dom = this.grid.base.viewport.canvas.rowsContainerDiv;
	      //var scroll_offset = $(_dom).offset(); //得到pos 这个div层的offset，包含两个值，top和left
	
	      var screenFirstRow = _dom.scrollTop / this.grid.props.rowHeight;
	      var screenLastRow = screenFirstRow + _dom.clientHeight / this.grid.props.rowHeight;
	      if (index > screenLastRow) targetTop -= _dom.clientHeight;else if (index > screenFirstRow) return;else targetTop -= this.grid.props.rowHeight;
	      var maxScroll = _dom.scrollHeight - _dom.clientHeight;
	      if (targetTop > maxScroll) targetTop = maxScroll;
	
	      setTimeout(function () {
	        $(_dom).animate({
	          scrollTop: targetTop //让body的scrollTop等于pos的top，就实现了滚动 
	        }, 10);
	      }, 100);
	    }
	  }, {
	    key: 'scrolling',
	    value: function scrolling(arg) {
	      //TODO 当时为了解决在DataGrid只有3行或者4行的情况下，弟4行或者弟5行滚动到 但是会引起滚动条乱跳及滚动时页面闪烁的问题 所以去掉了
	      /*if(this.stopOneScroll == true)
	      {
	        this.stopOneScroll = false;return;
	      }*/
	      this.canvasScrollBottom = false;
	      if (arg.scrollLeft != this.scrollState.scrollLeft) {
	        //是横向滚动条 不需要动态加载数据
	        this.scrollState.scrollLeft = arg.scrollLeft;
	        return;
	      }
	      // return;
	      console.log("scrolling", arg);
	      var _divdom = arg.dom;
	      if (_divdom) {
	        var scrollTop,
	            maxScroll,
	            minScroll = 0;
	        scrollTop = _divdom.scrollTop;
	        maxScroll = _divdom.scrollHeight - _divdom.clientHeight;
	        console.log(scrollTop + "------------" + maxScroll);
	        if (scrollTop >= maxScroll - 1) {
	          this.canvasScrollBottom = true;
	          console.log("到底了应该加仓");
	          // var addrows = this.createRows(50,50);
	          // var rows = this.state.rows.slice();
	          // var newrows = rows.concat(addrows);
	          // this.setState({rows:newrows,scrollmax:0}); 
	        } else if (scrollTop <= 0) {
	          //alert("滚动到顶了");
	          this.canvasScrollUp = true;
	        }
	        /*else
	        {
	          let event = arg.scrollEvent;
	          //event.preventDefault();
	          //event.stopPropagation();
	          this.stopOneScroll = true;
	          let rowHeight=this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT;
	          let detail = 3*rowHeight;
	          if(scrollTop + detail > maxScroll)
	          {
	            detail = maxScroll-scrollTop-1;
	          }
	          if(this.mouseWheelDetalY>0)
	            _divdom.scrollTop += detail;
	          else if(this.mouseWheelDetalY<0)
	            _divdom.scrollTop -= detail;
	          }*/
	      }
	    }
	  }, {
	    key: 'doEnterTab',
	    value: function doEnterTab(proxy) {
	      proxy.preventDefault();
	      proxy.stopPropagation();
	      var rowIdx = this.grid.state.selected.rowIdx;
	      var nowIdx = this.grid.state.selected.idx;
	      var nowIdx2 = nowIdx - 1;
	      var step = 1;
	      var pre = false;
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	        ne.preventDefault();
	        //ne.onTab
	        if (ne.shiftKey) {
	          step = -1;pre = true;
	        }
	      }
	      var idx = nowIdx2 + step;
	
	      if (idx >= this._columns.length) {
	        idx = 0;
	      } else if (idx < 0) {
	        idx = this._columns.length - 1;
	      }
	
	      var column = this._columns[idx];
	      var controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, column.uid);
	      var columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	      //对于column 显示隐藏及是否在查询Group下都不用判断 所以直接调用getProperty_ActualSkipTab
	      while (column.width == 0.1 || column.skipTab || columnControl.getProperty_ActualSkipTab()) {
	        idx += step;
	        if (idx == nowIdx) {
	          _FocusActions2.default.focusChange(this.props.xml, pre);
	          return;
	        }
	
	        if (idx >= this._columns.length) {
	          idx = 0;
	          return;
	        } else if (idx < 0) {
	          idx = this._columns.length - 1;
	          return;
	        }
	        column = this._columns[idx];
	        controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, column.uid);
	        columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	      }
	      var _parentWindow = window.parent.window;
	
	      // this.grid.onSelect({ idx: idx+1, rowIdx: rowIdx, active:true });
	
	      if ($('.tip-yellowsimple')) {
	        $('.tip-yellowsimple').remove();
	      }
	      this.grid.onSelect({ idx: idx + 1, rowIdx: rowIdx, active: columnControl.classAlias == "FormItemBooleanEditorControl" || !_parentWindow.userSettingEntry.autoEnterList ? false : true });
	    }
	  }, {
	    key: 'onEnter',
	    value: function onEnter(proxy) {
	
	      if (this.props.forLookup && this.state.selectedIndexes && this.state.selectedIndexes.length > 0) {
	
	        if (!proxy.ctrlKey) {
	          var selectedIndex = this.state.selectedIndexes[0];
	          var record = this.state.rows[selectedIndex];
	          if (record) {
	            if (this.props.remoteReturnHandler) {
	              if (this.props.remoteReturnHandler(record)) return true;
	            }
	            if (this.props.autoReturnHandler) {
	              if (this.props.autoReturnHandler(record)) return true;
	            }
	          }
	        } else {
	          this.grid.setActive(proxy.key);
	          return true;
	        }
	
	        return false;
	      }
	
	      var idx = this.grid.state.selected.idx;
	      var column = this.grid.getColumn(idx);
	
	      if (column.hasOwnProperty("editable") && !column.editable || this.grid.isActive()) {
	        this.doEnterTab(proxy);
	      } else {
	        this.grid.setActive(proxy.key);
	      }
	    }
	  }, {
	    key: 'onTab',
	    value: function onTab(proxy) {
	      console.log(proxy);
	      proxy.preventDefault();
	      proxy.stopPropagation();
	      var rowIdx = this.grid.state.selected.rowIdx;
	      var nowIdx = this.grid.state.selected.idx;
	      var nowIdx2 = nowIdx - 1;
	      var step = 1;
	      var pre = false;
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	        ne.preventDefault();
	        //ne.onTab
	        if (ne.shiftKey) {
	          step = -1;pre = true;
	        }
	      }
	      var idx = nowIdx2 + step;
	
	      //if(this.grid.isAtLastCellInRow(this.grid.getNbrColumns())) 
	      if (idx >= this._columns.length) {
	        _FocusActions2.default.focusChange(this.props.xml, pre);
	        return;
	      } else if (idx < 0) {
	        _FocusActions2.default.focusChange(this.props.xml, pre);
	        return;
	      }
	
	      var column = this._columns[idx];
	      var controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, column.uid);
	      var columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	      //对于column 显示隐藏及是否在查询Group下都不用判断 所以直接调用getProperty_ActualSkipTab
	      while (column.width == 0.1 || column.skipTab || columnControl.getProperty_ActualSkipTab()) {
	        idx += step;
	        if (idx == nowIdx) {
	          _FocusActions2.default.focusChange(this.props.xml, pre);
	          return;
	        }
	
	        if (idx >= this._columns.length) {
	          _FocusActions2.default.focusChange(this.props.xml, pre);
	          return;
	        } else if (idx < 0) {
	          _FocusActions2.default.focusChange(this.props.xml, pre);
	          return;
	        }
	        column = this._columns[idx];
	        controlKey = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, column.uid);
	        columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.props.forLookup);
	      }
	      /*if(column.editable == false)
	      {
	        this.grid.onSelect({ idx: idx, rowIdx: rowIdx });
	      }
	      else
	      {
	        this.grid.openCellEditor(rowIdx,idx);  
	      }*/
	      var _parentWindow = window.parent.window;
	      this.grid.onSelect({ idx: idx + 1, rowIdx: rowIdx, active: columnControl.classAlias == "FormItemBooleanEditorControl" || !_parentWindow.userSettingEntry.autoEnterList ? false : true });
	    }
	  }, {
	    key: 'testFocus',
	    value: function testFocus() {
	      $(this.refs['testFocusBtn'])[0].focus();
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var parentLayout = this.props.parentLayout;
	
	      var style = {
	        //align-items:flex-start,
	        //flex-grow:flexGrow
	      };
	      if (this.props.judgeWidthByColumn) {
	        var columnWidth = this._columns.length * 200 - 120;
	        if (columnWidth > _FormItemConst2.default.MAX_DATAGRIDWIDTH) columnWidth = _FormItemConst2.default.MAX_DATAGRIDWIDTH;
	        //alert(FormItemConst.MAX_DATAGRIDWIDTH);
	        style["width"] = columnWidth + "px";
	      }
	      if (parentLayout == "horizontal") {
	
	        var _width = this.props.xml.Properties.Width.Value;
	        if (_width == undefined) _width = "";
	        var flexGrow = 100;
	        var iex = _width.indexOf("%");
	        if (iex != -1) {
	          flexGrow = _width.substring(0, iex);
	        }
	
	        if (iex == -1 && _width != "") {
	          style["width"] = _width + "px";
	        } else {
	          style["flexGrow"] = flexGrow;
	        }
	
	        var _height = this.props.xml.Properties.Height.Value;
	        if (_height == undefined) _height = "";
	        if (_height == "100%" || _height == "") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
	      } else //vertical 暂不考虑absolute
	        {
	          var _height2 = this.props.xml.Properties.Height.Value;
	          if (_height2 == undefined) _height2 = "";
	          var _flexGrow = 100; //this.props.xml.Properties.Rows.Value;
	          var _iex = _height2.indexOf("%");
	          if (_iex != -1) {
	            _flexGrow = _height2.substring(0, _iex);
	          }
	          if (_iex == -1 && _height2 != "") {
	            _flexGrow = _height2 + "px";
	          }
	          style["flexGrow"] = _flexGrow;
	
	          var _width2 = this.props.xml.Properties.Width.Value;
	          if (_width2 == undefined) _width2 = "";
	          if (_width2 == "100%" || _width2 == "") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
	        }
	
	      return style;
	    }
	  }, {
	    key: 'testShowHide',
	    value: function testShowHide() {
	      this.grid.doOnSelect({ idx: 0, rowIdx: 0, active: true });
	      var grid = this.grid;
	      setTimeout(function () {
	        grid.doOnSelect({ idx: 0, rowIdx: 0, active: false });
	      }, 100);
	      return;
	      this._columns = this._columns.slice(0);
	      var column = this._columns[1];
	      if (column.width == 0.1) {
	        column.width = 100;
	        //alert("show");
	      } else {
	        column.width = 0.1;
	        //alert("hide");
	      }
	
	      this.forceUpdate();
	      //this.setState();
	    }
	  }, {
	    key: 'onGridCellSelected',
	    value: function onGridCellSelected(selected) {
	      if (this.props.forLookup) return;
	      window.lastFocusUI = this;
	      window.lastFocusDataGrid = this;
	      this.lastSelected = selected;
	      if (selected) {
	        //alert(JSON.stringify(selected));
	        var idx = selected.idx - 1;
	        if (idx < 0) idx = 0;
	        var dataField = this.state.columns[idx].key;
	        window.lastEditedDataFields[this.props.groupAlias] = dataField;
	      }
	
	      //window.gridCellDrag = null;
	      //$(".gridCellMutiSelected").removeClass("gridCellMutiSelected")
	      //alert("onCellSelected");
	      if (this.grid.state && this.grid.state.dragged && this.grid.state.dragged.complete == true) {
	        this.grid.setState({ dragged: null });
	        $(this.draggedResultLabel).text('');
	        //alert("设置complelete null");
	      } else if (this.grid.state && this.grid.state.dragged) {
	        //alert("设置compelete true");
	        this.grid.setState({ dragged: { complete: true } });
	        $(this.draggedResultLabel).text('');
	      }
	    }
	  }, {
	    key: 'enterMainForm',
	    value: function enterMainForm() {
	      this.props.control && this.lastSelected;
	      {
	        var idx = this.lastSelected.idx;
	        var columnItem = this._columns[idx - 1];
	        if (columnItem) {
	          var _key = columnItem.key;
	          var _rowIdx = this.lastSelected.rowIdx;
	          var _row = this.state.rows[_rowIdx];
	          var _value = _row[_key];
	          this.props.control.enterMainForm(this.lastSelected.idx, _value);
	        }
	      }
	    }
	  }, {
	    key: 'ascOrder',
	    value: function ascOrder() {
	      if (this.props.control && this.lastSelected) this.props.control.ascOrder(this.lastSelected.idx);
	    }
	  }, {
	    key: 'descOrder',
	    value: function descOrder() {
	      if (this.props.control && this.lastSelected) this.props.control.descOrder(this.lastSelected.idx);
	    }
	  }, {
	    key: 'findValue',
	    value: function findValue() {
	      if (this.props.control && this.lastSelected) this.props.control.findValue(this.lastSelected.idx);
	    }
	  }, {
	    key: 'findValue2',
	    value: function findValue2() {
	      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (this.props.control && this.lastSelected) this.props.control.findValue2(this.lastSelected.idx, flag);
	    }
	  }, {
	    key: 'enterFind',
	    value: function enterFind() {
	      if (this.props.control && this.lastSelected) this.props.control.enterFind(this.lastSelected.idx);
	    }
	  }, {
	    key: 'test',
	    value: function test() {
	      alert(this.grid == null);
	    }
	  }, {
	    key: 'setLastSelected',
	    value: function setLastSelected() {
	      if (this.lastSelected) {
	        this.lastSelected.active = false;
	        this.grid.doOnSelect(this.lastSelected);
	        var selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
	        if (selectedCells.length == 0) return;
	
	        var idx = this.lastSelected.idx - 1;
	        if (idx < 0) idx = 0;
	        var column = this._columns[idx];
	        if (!column) return;
	
	        var columnKey = column.key;
	        for (var i = 0; i < selectedCells.length; i++) {
	          var selectedCell = selectedCells[i];
	          if ($(selectedCell).attr("data-columnKey") == columnKey) selectedCell.focus();
	        }
	      }
	    }
	  }, {
	    key: 'testOnFocus',
	    value: function testOnFocus() {
	      //TODO 对于tab键导航等程序触发的焦点 存在重复设置当前Group 但无任何影响
	      //理论上  程序触发与用户触发都派发该事件 前者情况可以不设置CurrentGroup
	      //但是由于前者逻辑较复杂 所以先不改 留待以后观察情况
	      //alert("datagrid-focus");
	      //console.log("datagrid-focus");
	      if (window.testWarnShowedToRemove == true) {
	        window.testWarnShowedToRemove = false;
	        return;
	      }
	
	      if (window.testWarnShowing == true) {
	        return;
	      }
	      //console.log("ccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc");
	      _FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
	      window.lastFocusDataGrid = this;
	    }
	
	    //风险 由mouseDown改为了click 发生时序延后了
	
	  }, {
	    key: 'onMouseDownHandler',
	    value: function onMouseDownHandler(e) {
	      _FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
	      if ($(e.target).hasClass("GongqiDataGridNumColHeaderCell")) {
	        var allSelectedIndex = [];
	        for (var i = 0; i < this.state.rows.length; i++) {
	          allSelectedIndex[i] = i;
	        }
	        if (this.props.group && this.state.rows.length > 0) {
	          this.props.group.currentRecord = this.state.rows[this.state.rows.length - 1];
	        }
	        this.setState({ selectedIndexes: allSelectedIndex });
	        this.selectedIndexesList = allSelectedIndex;
	      }
	      if (!$(e.target).hasClass("datagridcontainer_bottombar_more")) {
	        $(this.moreModelBtns).hide();
	      }
	    }
	  }, {
	    key: 'onMouseWheel',
	    value: function onMouseWheel(e) {
	      if (e.type == "touchmove") {
	        //let moveEndX = e.changedTouches[0].pageX;
	        var moveEndY = e.changedTouches[0].pageY;
	        //let X = moveEndX - this.touchStartX;
	        var Y = this.touchStartY - moveEndY;
	        this.mouseWheelDetalY = Y;
	      } else {
	        this.mouseWheelDetalY = e.deltaY;
	      }
	      if (this.canvasScrollBottom == true && this.mouseWheelDetalY > 0) {
	        this.canvasScrollBottom = false;
	        if (this.props.group) {
	          if (e.altKey == true) {
	            this.props.group.recordLast(this.props.groupAlias, this.props.moduleInstanceId);
	          } else {
	            this.props.group.scrollEndNextPage();
	          }
	        }
	      } else if (this.canvasScrollUp == true && this.mouseWheelDetalY < 0) {
	        this.canvasScrollUp = false;
	        if (e.altKey == true) {
	          this.props.group.recordFirst(this.props.groupAlias, this.props.moduleInstanceId);
	        } else {
	          this.props.group.recordPrevPage(false, this.props.groupAlias, this.props.moduleInstanceId);
	        }
	      }
	    }
	  }, {
	    key: 'nextPageHandler',
	    value: function nextPageHandler() {
	      _RecordsActions2.default.RecordNextPage(false, this.props.groupAlias, this.props.moduleInstanceId);
	    }
	  }, {
	    key: 'prePageHandler',
	    value: function prePageHandler() {
	      _RecordsActions2.default.RecordPrevPage(false, this.props.groupAlias, this.props.moduleInstanceId);
	    }
	  }, {
	    key: 'recordFirstHandler',
	    value: function recordFirstHandler() {
	      _RecordsActions2.default.RecordFirst(this.props.groupAlias, this.props.moduleInstanceId);
	    }
	  }, {
	    key: 'recordLastHandler',
	    value: function recordLastHandler() {
	      _RecordsActions2.default.RecordLast(this.props.groupAlias, this.props.moduleInstanceId);
	    }
	  }, {
	    key: 'recordRefreshHandler',
	    value: function recordRefreshHandler() {
	      if (!this.refreshEnabled) return;
	      _RecordsActions2.default.RecordRefresh(this.props.groupAlias, this.props.moduleInstanceId);
	    }
	  }, {
	    key: 'recordFetchAllHandler',
	    value: function recordFetchAllHandler() {
	      /*var options = 
	      {
	        text:"确认要获取全部记录吗",
	        interacdestroy:false,
	        confirm:{isShow:true,event:this.doRecordFetchAll.bind(this)},
	        cancel:{isShow:true,event:''}
	      };
	      Warning.show(options);*/
	      if (!this.fetchAllEnabled) return;
	      this.doRecordFetchAll();
	    }
	  }, {
	    key: 'recordRestore',
	    value: function recordRestore() {
	      var group = window.prepareGroupForDoRecord();
	      if (group) group.doRecordRestore();
	    }
	  }, {
	    key: 'doRecordFetchAll',
	    value: function doRecordFetchAll() {
	      _RecordsActions2.default.RecordFetchAll(this.props.groupAlias, this.props.moduleInstanceId);
	    }
	  }, {
	    key: 'onGetGridInfos',
	    value: function onGetGridInfos(groupAlias, result, moduleInstanceId) {
	      if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
	        var linesOnScreen = 0;var $container = $(this.datagridContainer);
	        var th = $container.find(".react-grid-Canvas").height();
	        var _rowHeight = this.props.rowHeight ? this.props.rowHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
	        linesOnScreen = th / _rowHeight - 1;
	        if (!result) result = {};
	        result.linesOnScreen = linesOnScreen;
	        var verticalPosition = $container.find(".react-grid-Canvas")[0].scrollTop;
	        result.verticalScrollPosition = Math.ceil(verticalPosition / _rowHeight);
	      }
	    }
	  }, {
	    key: 'onGroupSlide',
	    value: function onGroupSlide(arg) {
	      if (this.grid) {
	        $(this.datagridContainer).find(".react-grid-Grid").css("min-height", 0);
	        if (arg != "pre") this.grid.updateMetrics();
	      }
	    }
	  }, {
	    key: 'onVisibleFalseToTrue',
	    value: function onVisibleFalseToTrue() {
	      this.grid.updateMetrics();
	    }
	  }, {
	    key: 'onTabpageUserChanged',
	    value: function onTabpageUserChanged(arg) {
	      if (this.props.moduleInstanceId == arg.moduleInstanceId && this.props.xml.id == arg.gridId) {
	        //有在隐藏期间发生update
	        if (this.displayBeforeNoneState) {
	          //隐藏期间发生过rows的改变
	          if (this.displayNoneingRows) {
	            this.setState({ rows: this.displayNoneingRows });
	            this.displayNoneingRows = null;
	          } else {}
	          this.displayBeforeNoneState = null;
	          /*if(this.displayBeforeNoneState.rows != this.state.rows)
	          {
	            this.forceUpdate();
	            this.displayBeforeNoneState = null;
	          }*/
	        }
	      }
	      //this.forceUpdate();
	    }
	  }, {
	    key: 'onUpdateFetchAllIcon',
	    value: function onUpdateFetchAllIcon(groupAlias, end, moduleInstanceId) {
	      if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
	        if (end == true) //
	          {
	            $(this.iconFetchAll).removeAttr("style");
	            $(this.iconFetchAll).removeClass().addClass("fa fa-check");
	            $(this.Btnofall).css("padding", "0 0.2em");
	          } else {
	          $(this.iconFetchAll).css("font-size", "1.5em");
	          $(this.iconFetchAll).removeClass("fa fa-check").addClass("fa fa-level-down");
	          $(this.Btnofall).css("padding", "0 0.5em");
	        }
	      }
	    }
	  }, {
	    key: 'gridMouseMove',
	    value: function gridMouseMove(e) {
	      if (e && e.ctrlKey && $(e.target).hasClass("react-grid-HeaderCell")) {}
	    }
	  }, {
	    key: 'onHeaderCellMove',
	    value: function onHeaderCellMove(e, col) {
	      var field = col.key;var totalnum = 0;var _min = 0;var _max = 0;var index = 0;
	      var selectedNumtotal = 0;
	      var _selectedIndexes = this.state.selectedIndexes;
	      var _selectRecordsKeys = [];var formModule = this.props.control.module;
	      _CommandActions2.default.getSelectRecordsKey(_selectRecordsKeys, this.props.groupAlias, formModule.menuItemId, formModule.formId, formModule.instanceUUId);
	      if (!_selectedIndexes) _selectedIndexes = [];
	      var selectedKey = void 0;
	      if (_selectRecordsKeys && _selectRecordsKeys.length > 0) {
	        selectedKey = _selectRecordsKeys[0];
	      }
	      for (var i = 0; i < this.state.rows.length; i++) {
	        var row = this.state.rows[i];
	        var value = row[field];
	        var num = void 0;
	        try {
	          if (value == null) {
	            num = 0;
	          } else {
	            if (typeof value == "string") {
	              if (value.indexOf(',') != -1) {
	                value = value.replace(/,/g, "");
	              }
	              num = parseFloat(value);
	            } else {
	              num = value;
	            }
	          }
	        } catch (e) {
	          console.log('errror');
	          num = 0;
	        }
	
	        totalnum += num;
	        if (index == 0) _min = _max = num;
	        _min = Math.min(_min, num);
	        _max = Math.max(_max, num);
	        if (selectedKey) {
	          if (row[selectedKey] == true) {
	            selectedNumtotal += num;
	          }
	        } else if (_selectedIndexes.indexOf(i) != -1) {
	          selectedNumtotal += num;
	        }
	        index++;
	      }
	      var _numofdecimals = col.numofdecimals;
	      if (_numofdecimals == -1 || !_numofdecimals) _numofdecimals = 0;
	
	      //TODO  如果字段显示千分符  合计也要显示
	      var sumv = totalnum.toFixed(_numofdecimals);
	      var slsumv = selectedNumtotal.toFixed(_numofdecimals);
	      var avgv = (totalnum / (this.state.rows.length > 0 ? this.state.rows.length : 1)).toFixed(_numofdecimals);
	      var maxv = _max.toFixed(_numofdecimals);
	      var minv = _min.toFixed(_numofdecimals);
	      var length = this.state.rows.length;
	      if (col && col.editorType == "DecimalEditor" && col.formatter.props.thousandSeperator) {
	        sumv = _FormItemDecimalDisplay2.default.getDisplayText(sumv, true, _numofdecimals, true, {});
	        slsumv = _FormItemDecimalDisplay2.default.getDisplayText(slsumv, true, _numofdecimals, true, {});
	        avgv = _FormItemDecimalDisplay2.default.getDisplayText(avgv, true, _numofdecimals, true, {});
	        maxv = _FormItemDecimalDisplay2.default.getDisplayText(maxv, true, _numofdecimals, true, {});
	        minv = _FormItemDecimalDisplay2.default.getDisplayText(minv, true, _numofdecimals, true, {});
	        length = _FormItemDecimalDisplay2.default.getDisplayText(length, true, _numofdecimals, true, {});
	      }
	      var _text = "当前列总和:" + sumv;
	      _text += "\n选中行总和:" + slsumv;
	      _text += "\n平均值" + avgv;
	      _text += "\n最大值" + maxv;
	      _text += "\n最小值" + minv;
	      _text += "\n总记录数" + length;
	      return _text;
	    }
	  }, {
	    key: 'onCellsVerticalDragged',
	    value: function onCellsVerticalDragged(dragged) {
	      this.lastDraggedObject = dragged;
	      this.displayCellDraggedResult(dragged);
	    }
	  }, {
	    key: 'onDragHandleDoubleClick',
	    value: function onDragHandleDoubleClick(dragged) {
	      this.lastDraggedObject = dragged;
	      this.displayCellDraggedResult(dragged);
	    }
	  }, {
	    key: 'displayCellDraggedResult',
	    value: function displayCellDraggedResult(args) {
	      if (!args) return;
	      var cellKey = args.cellKey,
	          fromRow = args.fromRow,
	          toRow = args.toRow,
	          column = args.column,
	          value = args.value;
	
	      var isNum = column.editorType == "LongEditor" || column.editorType == "DecimalEditor";
	      var _text = '';
	      if (this.bottomBarSettings.count) _text += "计数=" + (toRow - fromRow + 1);
	      if (isNum) {
	        var total = 0;
	        var numofdecimals = 2;
	        if (column.editorType == "DecimalEditor") {
	          var columnControlKey = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, column.uid);
	          var columnControl = _FormItemUtil2.default.getFormItemControl(columnControlKey, false);
	          if (columnControl) numofdecimals = columnControl.getProperty_NumOfDecimals();
	        }
	        var min = 0;var max = 0;
	        for (var i = fromRow; i <= toRow; i++) {
	          var row = this.state.rows[i];
	          var _value2 = parseFloat(row[cellKey]);
	          if (_value2 < min) min = _value2;
	          if (_value2 > max) max = _value2;
	          total += _value2;
	        }
	        if (column.editorType == "DecimalEditor") total = total.toFixed(numofdecimals);
	        if (this.bottomBarSettings.sum) {
	          _text += "  求和=" + total;
	        }
	
	        if (this.bottomBarSettings.avg) {
	          var count = toRow - fromRow + 1;
	          var avg = (total / count).toFixed(2);
	          _text += "  平均值=" + avg;
	        }
	        if (this.bottomBarSettings.min) {
	          _text += "  最小值=" + min;
	        }
	        if (this.bottomBarSettings.max) {
	          _text += "  最大值=" + max;
	        }
	      }
	
	      $(this.draggedResultLabel).text(_text);
	    }
	  }, {
	    key: 'recordNewHandler',
	    value: function recordNewHandler() {
	      if (!this.addEnabled) return;
	      this.props.group.doRecordNew();
	
	      var _parentWindow = typeof window.setOperate == 'function' ? window : window.parent.window;
	      if (_parentWindow.setOperate) {
	        var remark = { "title": '表格新增内容' };
	        var data = {
	          'dataArea': 'dynamic',
	          'userId': _parentWindow.userInfos.userId,
	          'userName': _parentWindow.userInfos.userName,
	          'clientSessionId': _parentWindow.userInfos.userSessionId,
	          'dateTime': new Date().getTime() + '',
	          'operationId': '011',
	          'formId': formId,
	          'formDataSourceName': this.props.groupAlias,
	          'formItemName': '',
	          'remark': JSON.stringify(remark)
	        };
	        _parentWindow.setOperate(data);
	      }
	    }
	  }, {
	    key: 'recordSaveHandler',
	    value: function recordSaveHandler() {
	      if (!this.saveEnabled) return;
	      this.props.group.doRecordSave();
	      var _parentWindow = typeof window.setOperate == 'function' ? window : window.parent.window;
	      if (_parentWindow.setOperate) {
	        var remark = { "title": '表格保存内容' };
	        var data = {
	          'dataArea': 'dynamic',
	          'userId': _parentWindow.userInfos.userId,
	          'userName': _parentWindow.userInfos.userName,
	          'clientSessionId': _parentWindow.userInfos.userSessionId,
	          'dateTime': new Date().getTime() + '',
	          'operationId': '012',
	          'formId': formId,
	          'formDataSourceName': this.props.groupAlias,
	          'formItemName': '',
	          'remark': JSON.stringify(remark)
	        };
	        _parentWindow.setOperate(data);
	      }
	    }
	  }, {
	    key: 'recordDeleteHandler',
	    value: function recordDeleteHandler() {
	
	      if (!this.deleteEnabled) return;
	      this.props.group.doRecordDelete();
	      var _parentWindow = typeof window.setOperate == 'function' ? window : window.parent.window;
	      if (_parentWindow.setOperate) {
	        var remark = { "title": '表格删除内容' };
	        var data = {
	          'dataArea': 'dynamic',
	          'userId': _parentWindow.userInfos.userId,
	          'userName': _parentWindow.userInfos.userName,
	          'clientSessionId': _parentWindow.userInfos.userSessionId,
	          'dateTime': new Date().getTime() + '',
	          'operationId': '013',
	          'formId': formId,
	          'formDataSourceName': this.props.groupAlias,
	          'formItemName': '',
	          'remark': JSON.stringify(remark)
	        };
	        _parentWindow.setOperate(data);
	      }
	    }
	  }, {
	    key: 'dataGridToolbar',
	    value: function dataGridToolbar() {
	      $(this.moreModelBtns).show();
	    }
	  }, {
	    key: 'onHeaderDragHandleDoubleClick',
	    value: function onHeaderDragHandleDoubleClick(column) {
	      var max = column.name.visualLength();
	      //let fontSizeRequired = false;
	      for (var i = 0; i < this.state.rows.length; i++) {
	        var item = this.state.rows[i];
	        var value = item[column.key];
	        if (value) {
	          var width = value.visualLength();
	          if (width > max) max = width;
	        }
	      }
	      return max > 0 ? max + 20 : 0;
	    }
	  }, {
	    key: 'testDataGridHideBecauseTabpageHide',
	    value: function testDataGridHideBecauseTabpageHide() {
	      var parent = $(this.datagridContainer).parent();
	      while (parent.length > 0 && parent[0].localName && parent[0].localName != 'body' && parent[0].id != "app") {
	        if (parent.hasClass("FormItemTabPage") && parent.css("display") == "none" && parent.is(":hidden")) {
	          return true;
	        }
	        if (typeof parent.parent == "function") parent = parent.parent();else return false;
	      }
	      return false;
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.testDataGridHideBecauseTabpageHide() == true) {
	        if (!this.displayBeforeNoneState) {
	          this.displayBeforeNoneState = this.state;
	        }
	
	        //有查询等导致rows改变的情况 要先清空
	        if (this.state.rows.length > 0 && this.displayNoneingRows) {
	          //this.displayNoneingRows = nextState.rows;
	          nextState.rows = [];
	          return true;
	        }
	
	        //this.displayNoneState = nextState;
	        return false;
	      } else {
	        //1、正常情况 应该更新 2、由于切换的时候先发生shouldUpdate 再发生tabChanged tabChanged会判断displayBeforeNoneState 所以清空
	        //3、如果是切换的时候 之前有保存的displayNoneingRows 则应该更新掉
	        if (this.displayNoneingRows) nextState.rows = this.displayNoneingRows;
	        this.displayBeforeNoneState = this.displayNoneingRows = null;
	      }
	      return true;
	    }
	  }, {
	    key: 'resizeUpdateAssist',
	    value: function resizeUpdateAssist(type) {
	      if (type == "resize") {
	        if ($(this.datagridContainer).is(":hidden")) return false;
	      }
	
	      return true;
	    }
	
	    //TODO计划排程 客户端选中记录 为何要延时已经记不清
	
	  }, {
	    key: 'onCmdSelectRecords',
	    value: function onCmdSelectRecords(task) {
	      //alert(JSON.stringify(task));
	      var _this = this;
	      setTimeout(function () {
	
	        var _groupAlias = task.group;
	        if (_this.props.group.groupAlias == _groupAlias) {
	          var recIds = task.arg;
	
	          if (typeof recIds == "string") {
	            if (recIds == "all") {
	              var newIndexes = [];var newSelectedRecords = _this.state.rows;
	              for (var i = 0; i < _this.state.rows.length; i++) {
	                newIndexes.push(i);
	              }
	
	              if (newIndexes.length > 0) {
	                _this.setState({ selectedIndexes: newIndexes });
	                _this.selectedIndexesList = newIndexes;
	              }
	
	              var updated = _this.props.group.selectRecords(true, newSelectedRecords);
	              //if(updated == true)
	              //  _this.grid.forceUpdate();
	
	              return;
	            } else if (recIds == "none") {
	              var _newIndexes = [];var _newSelectedRecords = _this.state.rows;
	              _this.setState({ selectedIndexes: _newIndexes });
	              _this.selectedIndexesList = _newIndexes;
	              _this.props.group.selectRecords(false, _newSelectedRecords);
	              return;
	            } else if (recIds == "reverse") {
	              var _newIndexes2 = [];var _newSelectedRecords2 = _this.state.rows;
	              for (var _i4 = 0; _i4 < _this.state.rows.length; _i4++) {
	                if (_this.state.selectedIndexes.indexOf(_i4) == -1) {
	                  _newIndexes2.push(_i4);
	                }
	              }
	              _this.setState({ selectedIndexes: _newIndexes2 });
	              _this.selectedIndexesList = _newIndexes2;
	              _this.props.group.reverseSelectedRecords(_newSelectedRecords2);
	              return;
	            }
	          }
	
	          if (recIds && recIds.length > 0) {
	            var _newIndexes3 = [];var _newSelectedRecords3 = [];
	            for (var _i5 = 0; _i5 < _this.state.rows.length; _i5++) {
	              var row = _this.state.rows[_i5];
	              var recIdKey = _groupAlias + ".recId";
	              var recordRecId = row[recIdKey];
	              if (recIds.indexOf(recordRecId) != -1) {
	                var newIndex = _this.state.rows.indexOf(row);
	                if (newIndex > -1) {
	                  _newSelectedRecords3.push(row);
	                  _newIndexes3.push(newIndex);
	                }
	              }
	            }
	
	            if (_newIndexes3.length > 0) {
	              _this.setState({ selectedIndexes: _newIndexes3 });
	              _this.selectedIndexesList = _newIndexes3;
	              _this.props.group.doSelectRecords = _newIndexes3;
	            }
	            var _updated = _this.props.group.selectRecords(true, _newSelectedRecords3);
	            //if(updated == true)
	            //  _this.grid.forceUpdate();
	          }
	        }
	      }, 500);
	    }
	  }, {
	    key: 'onRowDragStart',
	    value: function onRowDragStart() {
	      alert("223");
	    }
	  }, {
	    key: 'updateBottomBar',
	    value: function updateBottomBar() {
	      var labelContent = '';
	      if (this.bottomBarSettings.obtainRows) labelContent += '已获取' + this.state.rows.slice().length + '行';
	      if (this.bottomBarSettings.selectedRows) labelContent += (labelContent ? '，选中' : '选中') + this.state.selectedIndexes.length + '行';
	      if (this.bottomBarSettings.allRows) {}
	      $(this.recordsInfoLabel).text(labelContent);
	      this.displayCellDraggedResult(this.lastDraggedObject);
	    }
	  }, {
	    key: 'copyDataCell',
	    value: function copyDataCell() {
	      var div = document.getElementById('a');
	      if (document.body.createTextRange) {
	        var range = document.body.createTextRange();
	        range.moveToElementText(div);
	        range.select();
	      } else if (window.getSelection) {
	        var selection = window.getSelection();
	        var range = document.createRange();
	        range.selectNodeContents(div);
	        selection.removeAllRanges();
	        selection.addRange(range);
	        /*if(selection.setBaseAndExtent){
	            selection.setBaseAndExtent(text, 0, text, 1);
	        }*/
	      } else {
	        console.warn("none");
	      }
	      document.execCommand("Copy"); // 执行浏览器复制命令
	
	      alert("已复制好，可贴粘。");
	    }
	  }, {
	    key: 'onTouchStartHandler',
	    value: function onTouchStartHandler(e) {
	      this.touchStartX = e.touches[0].pageX;
	      this.touchStartY = e.touches[0].pageY;
	    }
	  }, {
	    key: 'onTouchMoveHandler',
	    value: function onTouchMoveHandler(e) {}
	  }, {
	    key: 'onTouchEndHandler',
	    value: function onTouchEndHandler(e) {}
	  }, {
	    key: 'datagridmorebtn',
	    value: function datagridmorebtn() {
	      $(this.moreModelBtns).hide();
	    }
	  }, {
	    key: 'bottomToolBar',
	    value: function bottomToolBar(labelContent, update) {
	      var _this7 = this;
	
	      if (update && document.getElementById(this.props.xml.name).offsetWidth <= 280) {
	        return React.createElement(
	          'div',
	          { ref: function ref(node) {
	              return _this7.bottombarNode = node;
	            }, className: 'datagridcontainer_bottombar', style: { display: 'flex', flexDirection: 'row', borderLeft: 'solid 1px #ddd', borderBottom: 'solid 1px #ddd', borderRight: 'solid 1px #ddd', minWidth: '190px' } },
	          React.createElement('label', { className: 'datagridcontainer_bottombar_more', ref: function ref(node) {
	              return _this7.moreBtn = node;
	            }, style: { marginTop: '6px', marginLeft: '10px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '17px', background: 'url(./images/icons/mb-ellipsis-v-filled.svg)' }, title: '', onClick: this.dataGridToolbar.bind(this) }),
	          React.createElement(
	            'label',
	            { style: { fontWeight: '400', 'paddingLeft': '10px', marginTop: '10px', marginBottom: '5px', marginRight: '10px', whiteSpace: 'nowrap', overflow: 'hidden' }, className: 'jon-recorder', ref: function ref(node) {
	                return _this7.recordsInfoLabel = node;
	              } },
	            labelContent
	          ),
	          React.createElement('label', { style: { fontWeight: '400', 'flexGrow': '100', 'textAlign': 'right', 'paddingLeft': '20px', marginTop: '3px', marginBottom: '5px' }, className: 'jon-recorder', ref: function ref(node) {
	              return _this7.draggedResultLabel = node;
	            } }),
	          React.createElement(
	            'div',
	            { className: 'moreModelBtnsClass', ref: function ref(node) {
	                return _this7.moreModelBtns = node;
	              }, onClick: this.datagridmorebtn.bind(this), onBlur: this.datagridmorebtn.bind(this), style: { display: 'none', position: 'absolute', bottom: '26px', left: '30px', border: '1px solid #d4d4d4', padding: '10px 0px', backgroundColor: 'white', width: '140px' } },
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { style: { display: 'flex', cursor: 'pointer' }, onClick: this.recordNewHandler.bind(this), title: '\u65B0\u589E' },
	                React.createElement('i', { ref: function ref(node) {
	                    return _this7.addBtn = node;
	                  }, 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/da-add.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u65B0\u589E'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { style: { display: 'flex', cursor: 'pointer' }, onClick: this.recordSaveHandler.bind(this), title: '\u4FDD\u5B58' },
	                React.createElement('i', { ref: function ref(node) {
	                    return _this7.saveBtn = node;
	                  }, 'class': 'icon-container', style: { width: '18px', height: '18px', marginLeft: '2px', marginTop: '2px', background: 'url(./images/icons/da-save.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u4FDD\u5B58'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { style: { display: 'flex', cursor: 'pointer' }, onClick: this.recordDeleteHandler.bind(this), title: '\u5220\u9664' },
	                React.createElement('i', { ref: function ref(node) {
	                    return _this7.deleteBtn = node;
	                  }, 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/da-del.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u5220\u9664'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.reStroeBtnH = node;
	                  }, style: { display: 'flex', cursor: 'pointer' }, onClick: this.recordRestore.bind(this), title: '\u6062\u590D' },
	                React.createElement('i', { 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/ze-restore.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u6062\u590D\u9009\u4E2D\u8BB0\u5F55'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.refreshBtnH = node;
	                  }, style: { display: 'flex', marginTop: '5px', cursor: 'pointer' }, onClick: this.recordRefreshHandler.bind(this), title: '\u5237\u65B0' },
	                React.createElement('i', { ref: function ref(node) {
	                    return _this7.refreshBtnI = node;
	                  }, 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/ze-refsh.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { ref: function ref(node) {
	                      return _this7.refreshBtnSpan = node;
	                    }, 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u91CD\u65B0\u6267\u884C\u67E5\u8BE2'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.fetchAllBtn = node;
	                  }, style: { display: 'flex', marginTop: '5px', cursor: 'pointer' }, onClick: this.recordFetchAllHandler.bind(this), title: '\u5168\u53D6' },
	                React.createElement('i', { 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/za-all.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u83B7\u53D6\u5168\u90E8\u8BB0\u5F55'
	                )
	              )
	            )
	          )
	        );
	      } else if (update && document.getElementById(this.props.xml.name).offsetWidth <= 400) {
	        return React.createElement(
	          'div',
	          { ref: function ref(node) {
	              return _this7.bottombarNode = node;
	            }, className: 'datagridcontainer_bottombar', style: { display: 'flex', flexDirection: 'row', borderLeft: 'solid 1px #ddd', borderBottom: 'solid 1px #ddd', borderRight: 'solid 1px #ddd', minWidth: '221px' } },
	          React.createElement('label', { className: 'datagridcontainer_bottombar_recordnew', ref: function ref(node) {
	              return _this7.addBtn = node;
	            }, style: { marginLeft: '10px', marginTop: '7px', marginBottom: '5px', marginRight: '15px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '20px', background: 'url(./images/icons/da-add.svg)', backgroundSize: '110%' }, title: '\u65B0\u589E', onClick: this.recordNewHandler.bind(this) }),
	          React.createElement('label', { className: 'datagridcontainer_bottombar_recordsave', ref: function ref(node) {
	              return _this7.saveBtn = node;
	            }, style: { marginTop: '9px', marginBottom: '5px', marginRight: '15px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '18px', background: 'url(./images/icons/da-save.svg)', backgroundSize: '100%' }, title: '\u4FDD\u5B58', onClick: this.recordSaveHandler.bind(this) }),
	          React.createElement('label', { className: 'datagridcontainer_bottombar_recorddelelte', ref: function ref(node) {
	              return _this7.deleteBtn = node;
	            }, style: { marginTop: '7px', marginBottom: '5px', marginRight: '15px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '20px', background: 'url(./images/icons/da-del.svg)', backgroundSize: '110%' }, title: '\u5220\u9664', onClick: this.recordDeleteHandler.bind(this) }),
	          React.createElement('label', { className: 'datagridcontainer_bottombar_more', ref: function ref(node) {
	              return _this7.moreBtn = node;
	            }, style: { marginTop: '6px', marginLeft: '-5px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '17px', background: 'url(./images/icons/mb-ellipsis-v-filled.svg)' }, title: '', onClick: this.dataGridToolbar.bind(this) }),
	          React.createElement(
	            'label',
	            { style: { fontWeight: '400', 'paddingLeft': '10px', marginTop: '10px', marginBottom: '5px', marginRight: '10px', whiteSpace: 'nowrap', overflow: 'hidden' }, className: 'jon-recorder', ref: function ref(node) {
	                return _this7.recordsInfoLabel = node;
	              } },
	            labelContent
	          ),
	          React.createElement('label', { style: { fontWeight: '400', 'flexGrow': '100', 'textAlign': 'right', 'paddingLeft': '20px', paddingRight: '20px', marginTop: '3px', marginBottom: '5px' }, className: 'jon-recorder', ref: function ref(node) {
	              return _this7.draggedResultLabel = node;
	            } }),
	          React.createElement(
	            'div',
	            { className: 'moreModelBtnsClass', ref: function ref(node) {
	                return _this7.moreModelBtns = node;
	              }, onClick: this.datagridmorebtn.bind(this), onBlur: this.datagridmorebtn.bind(this), style: { display: 'none', position: 'absolute', bottom: '26px', left: '123px', border: '1px solid #d4d4d4', padding: '10px 0px', backgroundColor: 'white', width: '140px' } },
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.reStroeBtnH = node;
	                  }, style: { display: 'flex', cursor: 'pointer' }, onClick: this.recordRestore.bind(this), title: '\u6062\u590D' },
	                React.createElement('i', { 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/ze-restore.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u6062\u590D\u9009\u4E2D\u8BB0\u5F55'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.refreshBtnH = node;
	                  }, style: { display: 'flex', marginTop: '5px', cursor: 'pointer' }, onClick: this.recordRefreshHandler.bind(this), title: '\u5237\u65B0' },
	                React.createElement('i', { ref: function ref(node) {
	                    return _this7.refreshBtnI = node;
	                  }, 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/ze-refsh.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { ref: function ref(node) {
	                      return _this7.refreshBtnSpan = node;
	                    }, 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u91CD\u65B0\u6267\u884C\u67E5\u8BE2'
	                )
	              )
	            ),
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.fetchAllBtn = node;
	                  }, style: { display: 'flex', marginTop: '5px', cursor: 'pointer' }, onClick: this.recordFetchAllHandler.bind(this), title: '\u5168\u53D6' },
	                React.createElement('i', { 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/za-all.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u83B7\u53D6\u5168\u90E8\u8BB0\u5F55'
	                )
	              )
	            )
	          )
	        );
	      } else {
	
	        return React.createElement(
	          'div',
	          { ref: function ref(node) {
	              return _this7.bottombarNode = node;
	            }, className: 'datagridcontainer_bottombar', style: { display: 'flex', flexDirection: 'row', borderLeft: 'solid 1px #ddd', borderBottom: 'solid 1px #ddd', borderRight: 'solid 1px #ddd', minWidth: '321px' } },
	          React.createElement('label', { className: 'datagridcontainer_bottombar_recordnew', ref: function ref(node) {
	              return _this7.addBtn = node;
	            }, style: { marginLeft: '10px', marginTop: '7px', marginBottom: '5px', marginRight: '15px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '20px', background: 'url(./images/icons/da-add.svg)', backgroundSize: '110%' }, title: '\u65B0\u589E', onClick: this.recordNewHandler.bind(this) }),
	          React.createElement('label', { className: 'datagridcontainer_bottombar_recordsave', ref: function ref(node) {
	              return _this7.saveBtn = node;
	            }, style: { marginTop: '9px', marginBottom: '5px', marginRight: '15px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '18px', background: 'url(./images/icons/da-save.svg)', backgroundSize: '100%' }, title: '\u4FDD\u5B58', onClick: this.recordSaveHandler.bind(this) }),
	          React.createElement('label', { className: 'datagridcontainer_bottombar_recorddelelte', ref: function ref(node) {
	              return _this7.deleteBtn = node;
	            }, style: { marginTop: '7px', marginBottom: '5px', marginRight: '15px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '20px', background: 'url(./images/icons/da-del.svg)', backgroundSize: '110%' }, title: '\u5220\u9664', onClick: this.recordDeleteHandler.bind(this) }),
	          React.createElement(
	            'a',
	            { ref: function ref(node) {
	                return _this7.reStroeBtn = node;
	              }, style: { display: 'flex', cursor: 'pointer', marginRight: '2px' }, onClick: this.recordRestore.bind(this), title: '\u6062\u590D\u9009\u4E2D\u8BB0\u5F55' },
	            React.createElement('i', { 'class': 'icon-container', style: { width: '25px', background: 'url(./images/icons/ze-restore.svg) 0px 7px no-repeat', backgroundSize: '85%', marginRight: '5px' } })
	          ),
	          React.createElement(
	            'a',
	            { ref: function ref(node) {
	                return _this7.refreshBtn = node;
	              }, style: { display: 'flex', marginTop: '5px', cursor: 'pointer' }, onClick: this.recordRefreshHandler.bind(this), title: '\u91CD\u65B0\u6267\u884C\u67E5\u8BE2' },
	            React.createElement('i', { ref: function ref(node) {
	                return _this7.refreshBtnI = node;
	              }, 'class': 'icon-container', style: { width: '25px', background: 'url(./images/icons/ze-refsh.svg)  0px 2px ', backgroundSize: '90%', marginRight: '5px', height: '22px' } })
	          ),
	          React.createElement('label', { className: 'datagridcontainer_bottombar_more', ref: function ref(node) {
	              return _this7.moreBtn = node;
	            }, style: { marginTop: '6px', marginLeft: '-5px', cursor: 'pointer', display: this.props.forLookup ? 'none' : '', width: '17px', background: 'url(./images/icons/mb-ellipsis-v-filled.svg)' }, title: '', onClick: this.dataGridToolbar.bind(this) }),
	          React.createElement(
	            'label',
	            { style: { fontWeight: '400', 'paddingLeft': '10px', marginTop: '10px', marginBottom: '5px', marginRight: '10px', whiteSpace: 'nowrap', overflow: 'hidden' }, className: 'jon-recorder', ref: function ref(node) {
	                return _this7.recordsInfoLabel = node;
	              } },
	            labelContent
	          ),
	          React.createElement('label', { style: { fontWeight: '400', 'flexGrow': '100', 'textAlign': 'right', 'paddingLeft': '20px', paddingRight: '20px', marginTop: '3px', marginBottom: '5px' }, className: 'jon-recorder', ref: function ref(node) {
	              return _this7.draggedResultLabel = node;
	            } }),
	          React.createElement(
	            'div',
	            { className: 'moreModelBtnsClass', ref: function ref(node) {
	                return _this7.moreModelBtns = node;
	              }, onClick: this.datagridmorebtn.bind(this), onBlur: this.datagridmorebtn.bind(this), style: { display: 'none', position: 'absolute', bottom: '26px', left: '183px', border: '1px solid #d4d4d4', padding: '10px 0px', backgroundColor: 'white', width: '140px' } },
	            React.createElement(
	              'li',
	              { className: 'Ali toolbar_FormSetRf', style: { padding: '4px 10px' } },
	              React.createElement(
	                'a',
	                { ref: function ref(node) {
	                    return _this7.fetchAllBtn = node;
	                  }, style: { display: 'flex', marginTop: '5px', cursor: 'pointer' }, onClick: this.recordFetchAllHandler.bind(this), title: '\u5168\u53D6' },
	                React.createElement('i', { 'class': 'icon-container', style: { width: '20px', background: 'url(./images/icons/za-all.svg)', backgroundSize: '96%', marginRight: '5px' } }),
	                React.createElement(
	                  'span',
	                  { 'class': 'menubtnLable', style: { color: 'black', fontSize: '15px' } },
	                  '\u83B7\u53D6\u5168\u90E8\u8BB0\u5F55'
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      //<button onClick={this.testShowHide.bind(this)}>测试显示隐藏列</button>
	      var rowText = this.state.selectedIndexes.length === 1 ? 'row' : 'rows';
	      var _style = Object.assign({}, this.props.customStyle);
	      _style['position'] = 'relative';
	      _style.display = "flex";
	
	      if (this.state.visible == false) if (this.state.hideInVisible == true) {
	        _style.display = "none";
	      } else {
	        _style.visibility = "hidden";
	      }
	
	      /*var btnsDivStyle={height:'20px'};
	      
	      btnsDivStyle['bottom']='0.1em';
	      btnsDivStyle['display']='flex';
	      btnsDivStyle['alignItems']='flex-end';
	      btnsDivStyle['flexDirection']= 'row';
	      
	      var btnxxs={};
	      btnxxs['padding']='0em 0.3em';
	      btnxxs['flexGrow']='0';
	      btnxxs['fontSize']='0.5em';
	      btnxxs['marginBottom']='0px';
	      var btnnext={};
	      btnnext['padding'] = '0em 0.3em 0 0.4em';
	      btnnext['flexGrow'] = '0';
	      btnnext['fontSize'] = '0.5em';
	      btnnext['marginBottom'] = '0px';
	      var btnlast = {};
	      btnlast['padding'] = '0em 0.4em 0 0.3em';
	      btnlast['flexGrow'] = '0';
	      btnlast['fontSize'] = '0.5em';
	      btnlast['marginBottom'] = '0px';
	      var btnsmall = {};
	      btnsmall['padding'] = '0em 0.4em';
	      btnsmall['flexGrow'] = '0';
	      btnsmall['fontSize'] = '0.5em';
	      btnsmall['marginBottom'] = '0px';<button className={'btn gridToolBox-btn'} style={btnxxs} onClick={this.recordFirstHandler.bind(this)} title="第一条">
	              <i className={'fa fa-fast-backward jon-footer-c'}></i>
	            </button>
	            <button className={'btn gridToolBox-btn'} style={btnlast} onClick={this.prePageHandler.bind(this)} title="上一页">
	              <i className={'fa fa-backward jon-footer-c'}></i>
	            </button>
	            <button className={'btn gridToolBox-btn'} style={btnnext} onClick={this.nextPageHandler.bind(this)} title="下一页">
	              <i className={'fa fa-forward jon-footer-c'}></i>
	            </button>
	            <button className={'btn gridToolBox-btn'} style={btnxxs} onClick={this.recordLastHandler.bind(this)} title="最末条">
	              <i className={'fa fa-fast-forward jon-footer-c'}></i>
	            </button>
	            <button className={'btn gridToolBox-btn'} style={btnsmall} onClick={this.recordRefreshHandler.bind(this)} title="刷新">
	              <i className={'fa fa-refresh jon-footer-c'}></i>
	            </button>
	           
	            <button ref={node=>this.Btnofall = node} className={'btn gridToolBox-btn '} onClick={this.recordFetchAllHandler.bind(this)} title="获取全部" style={{ 'padding':'0 0.4em','flexGrow':'0','fontSize':'0.5em','marginBottom':'0px'}}>
	                <i className={'fa  fa-level-down jon-footer-c'} style={{'fontSize':'1.5em'}} ref={node => this.iconFetchAll = node}></i>
	            </button>*/
	
	      var newSelectIndexes = [];
	      var selectedIndexes = this.state.selectedIndexes.slice();
	      for (var i = 0; i < selectedIndexes.length; i++) {
	        if (newSelectIndexes.indexOf(selectedIndexes[i]) == -1) newSelectIndexes.push(selectedIndexes[i]);
	      }
	      var _minHeight = -1;
	      if (this.state.updateMinHeight != -1) {
	        _minHeight = this.state.updateMinHeight;
	      }
	
	      var labelContent = '';
	      if (this.bottomBarSettings.obtainRows) labelContent += '已获取' + this.state.rows.slice().length + '行';
	      if (this.bottomBarSettings.selectedRows) {
	        if (this.state.rows.slice().length == 0) {
	          labelContent += '，选中' + 0 + '行';
	        } else {
	          labelContent += '，选中' + newSelectIndexes.length + '行';
	        }
	      }
	      if (this.bottomBarSettings.allRows) {}
	      _style.flexDirection = "column";
	      /*let _rowHeight = FormItemConst.DATAGRID_ROW_HEIGHT;
	      for(let i in this._columns)
	      {
	        let _column = this._columns[i];
	        if(_column.columnDisplayHeight && _column.columnDisplayHeight>_rowHeight)
	          _rowHeight = _column.columnDisplayHeight;
	        }*/
	      /*if(this.state.heightAddon!=0 && typeof(_style.height)=="string" && _style.height.indexOf("px") != -1)
	      {
	        let intHeight = parseInt(_style.height.substring(0,_style.height.length-2));
	        _style.height = (intHeight+this.state.heightAddonDiffer)+"px";
	        this.containerFixedHeight = _style.height;
	        this.grid.parentDivUpdateHeight = true;
	        this.state.heightAddon = 0;
	      }*/
	      /*else if(this.state.heightAddon != 0 && this.datagridContainer.style && this.datagridContainer.style.height)
	      {
	        let intHeight = parseInt(this.datagridContainer.style.height.substring(0,this.datagridContainer.style.height.length-2));
	        _style.height = (intHeight+this.state.heightAddon)+"px";
	        this.grid.parentDivUpdateHeight = true;
	        this.state.heightAddon = 0;
	      }*/
	      /*else if(this.state.heightAddon != 0)
	      {
	        _style.height = $(this.datagridContainer).height()+this.state.heightAddon+"px";
	        this.grid.parentDivUpdateHeight = true;
	        this.containerFixedHeight = _style.height;
	        this.state.heightAddon = 0;
	      }*/
	
	      if (this.containerFixedHeight) // && this.props.customStyle && this.props.customStyle.hasOwnProperty("height"))
	        {
	          _style.height = this.containerFixedHeight + "px";
	          if (this.grid) this.grid.parentDivUpdateHeight = true;
	        }
	
	      //如果是由于dividedBox分隔拖动导致DataGrid的高度发生变化 则 暂时以此为最高优先级 高于GOT设置固定高度等
	      /*if(this.dividedBoxSplitFixedHeight)
	      {
	        _style.height = this.dividedBoxSplitFixedHeight;
	      }*/
	
	      var headerHeightPro = this.props.headerRowHeightPro;
	      var _headerRowHeight = void 0;
	      if (headerHeightPro == "Row") {
	        _headerRowHeight = this.props.rowHeight ? this.props.rowHeight : _FormItemConst2.default.DATAGRID_HEADER_HEIGHT;
	      } else {
	        _headerRowHeight = _FormItemConst2.default.DATAGRID_HEADER_HEIGHT;
	      }
	
	      var _parentWindow = window.hasOwnProperty("userInfos") ? window : window.parent.window;
	      var userSettingEntry = _parentWindow.userSettingEntry;
	      var pressEdit = false;
	      if (userSettingEntry) {
	        pressEdit = userSettingEntry.pressEditList;
	      }
	      var lastcursorStyle = { cursor: 'pointer', position: 'absolute', bottom: '22px', right: '0px', width: '9px', height: '16px', background: 'url(images/DataGridToolBar2.png)', backgroundPositionX: '-384px', display: 'none' };
	      if (!this.props.showToolbar) {
	        lastcursorStyle = { cursor: 'pointer', position: 'absolute', bottom: '0px', right: '0px', width: '9px', height: '16px', marginBottom: '0px', background: 'url(images/DataGridToolBar2.png)', backgroundPositionX: '-384px', display: 'none' };
	      }
	      var refishMinHeight = false;
	      if (this.state['radioRef']) {
	        refishMinHeight = true;
	      }
	      //_style.alignSelf='stretch';_style.flexGrow = 100;
	      //onMouseDown={this.onMouseDownHandler.bind(this)}
	      //  <div style={{display:'flex',flex:'100 0 auto',flexDirection:'column',alignItems:'flex-start',alignSelf:'stretch',justifyContent:'flex-start'}}> </div>
	
	      var _bottomBar = this.bottomToolBar(labelContent, false);
	      if (document.getElementById(this.props.xml.name) && document.getElementById(this.props.xml.name).offsetWidth) {
	        _bottomBar = this.bottomToolBar(labelContent, true);
	      }
	
	      return React.createElement(
	        'div',
	        { className: 'datagridcontainer', style: _style, onFocus: this.testOnFocus.bind(this),
	          ref: function ref(node) {
	            return _this8.datagridContainer = node;
	          }, id: this.props.xml.name, 'data-xmlid': this.props.xml.id,
	          onClick: this.onMouseDownHandler.bind(this),
	          onWheel: this.onMouseWheel.bind(this),
	          onTouchMove: this.onMouseWheel.bind(this),
	          onTouchStart: this.onTouchStartHandler.bind(this),
	          onTouchEnd: this.onTouchEndHandler.bind(this) },
	        React.createElement(ReactDataGrid, {
	          onCellsDragged: this.onCellsVerticalDragged.bind(this),
	          onDragHandleDoubleClick: this.onDragHandleDoubleClick.bind(this),
	          numColumn: true,
	          numColumnKeyId: this.props.xml.id,
	          ref: function ref(node) {
	            return _this8.grid = node;
	          },
	          onRowClick: this.rowClick.bind(this),
	          onRowDragStart: this.onRowDragStart.bind(this),
	          onGridKeyDown: this.gridKeyDown.bind(this),
	          rowKey: 'id',
	          columns: this.state.columns,
	          enableCellSelect: true,
	          rowGetter: this.rowGetter.bind(this),
	          rowsCount: this.state.rows.length,
	          rowHeight: this.props.rowHeight ? this.props.rowHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT,
	          headerRowHeight: _headerRowHeight,
	          onGridRowsUpdated: this.handleGridRowsUpdated.bind(this),
	          onCellSelected: this.onGridCellSelected.bind(this),
	          onScroll: this.scrolling.bind(this),
	          resizeUpdateAssist: this.resizeUpdateAssist.bind(this)
	          //TODO 原来是直接使用minHeight为-1 到ReactDataGrid的render中去计算高度 在如采购订单(有两个flexShrik为0的div)这样的画面上计算不准确
	          //现在改为不适用minHeight minHeight只设置两行 可能对其余情况有影响 需要再行观察
	          //minHeight={FormItemConst.DATAGRID_HEADER_HEIGHT+(this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT)}
	
	          //TODO由于ReactDataGrid源代码中是以null来判断有误cellCopyPaste功能 所以此处必须传入null 否则默认会被定义为有
	          //启用该功能会导致rowData及props的value在项目编辑器存在的情况下被改变 导致无法触发modified相关开发方法
	          , onCellCopyPaste: null,
	          minHeight: _minHeight,
	          cellNavigationMode: "loopOverRow",
	          holeCustomTab: !this.props.forLookup,
	          onTab: this.onTab.bind(this),
	          holeCustomEnter: true,
	          onEnter: this.onEnter.bind(this),
	          onHeaderCellMove: this.onHeaderCellMove.bind(this),
	          onDoubleClickToFit: this.onHeaderDragHandleDoubleClick.bind(this),
	          containerWidth100: true,
	          pressEdit: pressEdit,
	
	          refishMinHeight: refishMinHeight,
	          rowSelection: {
	            showCheckbox: false,
	            enableShiftSelect: true,
	            onRowsSelected: this.onRowsSelected.bind(this),
	            onRowsDeselected: this.onRowsDeselected.bind(this),
	            selectBy: {
	              indexes: this.state.selectedIndexes
	            }
	
	          }
	        }),
	        React.createElement('label', { ref: function ref(node) {
	            return _this8.recordFirstBtn = node;
	          }, onClick: this.recordFirstHandler.bind(this), style: { cursor: 'pointer', position: 'absolute', top: '14px', right: '0px', width: '9px', height: '16px', background: 'url(images/DataGridToolBar2.png)', backgroundPositionX: '-356px', display: 'none' }, title: '\u7B2C\u4E00\u6761' }),
	        React.createElement('label', { ref: function ref(node) {
	            return _this8.recordLastBtn = node;
	          }, onClick: this.recordLastHandler.bind(this), style: lastcursorStyle, title: '\u6700\u672B\u6761' }),
	        _bottomBar
	      );
	    }
	  }]);
	
	  return FormItemDataGrid;
	}(_GongqiFormItem3.default);
	
	FormItemDataGrid.defaultProps = {};
	
	module.exports = FormItemDataGrid;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormModuleLookup = __webpack_require__(54);
	
	var _FormModuleLookup2 = _interopRequireDefault(_FormModuleLookup);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemDateEditor = __webpack_require__(93);
	
	var _FormItemDateEditor2 = _interopRequireDefault(_FormItemDateEditor);
	
	var _FormItemDateResolver = __webpack_require__(55);
	
	var _FormItemDateResolver2 = _interopRequireDefault(_FormItemDateResolver);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDateEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemDateEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemDateEditorForDataGrid() {
			_classCallCheck(this, FormItemDateEditorForDataGrid);
	
			return _possibleConstructorReturn(this, (FormItemDateEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemDateEditorForDataGrid)).apply(this, arguments));
		}
	
		_createClass(FormItemDateEditorForDataGrid, [{
			key: 'initStores',
			value: function initStores() {
				this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
				this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeDsAllowEditStore();
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
				console.log(this.props.column.key);
				var updated = {};
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				this.justCommit = true;
				var text = this.getInputNode().value;
				var _val = _FormItemDateResolver2.default.getResult(text, false);
	
				if (_val.indexOf("false:") == 0) {
					_Warn2.default.show({ text: _val.substr(6) });
					_val = this.props.value;
				}
	
				updated[this.props.column.key] = _val;
	
				if (this.props.value != updated[this.props.column.key]) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, this.props.value, null, null, { dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, this.props.value);
						}
	
						if (!result && !this.props.control.isDataMethodField) {
							return {};
						}
						if (this.props.rowData[this.props.column.key] != this.props.value && this.props.rowData[this.props.column.key] != _val) {
							_val = this.props.rowData[this.props.column.key];
							updated[this.props.column.key] = _val;
						}
					}
				}
				return updated;
			}
	
			//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
			//下拉框是否销毁由项目编辑器决定
	
		}, {
			key: 'handleBlurCommit',
			value: function handleBlurCommit() {
				if (this.justCommit == true) {
					this.justCommit = false;return false;
				}
				if (this.lookupStates.isShowed) return false;
				return true;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				var _displayStyle = this.props.control.getProperty_DisplayStyle();
				var dataFormat = void 0;
				if (_displayStyle && _displayStyle.DisplayFormat) {
					dataFormat = _displayStyle.DisplayFormat;
				} else {
					dataFormat = _displayStyle.DisplayFormat;
				}
				var startView = 0;
				var minViewMode = 0;
				var format = "yyyy-mm-dd";
				if (!dataFormat || dataFormat == "yyyy-MM-dd" || dataFormat == "MM-dd") {
					startView = 0;
					minViewMode = 0;
				} else if (dataFormat == "yyyy-MM") {
					startView = 1;
					minViewMode = 1;
				} else if (dataFormat == "yyyy") {
					startView = 2;
					minViewMode = 2;
				}
				$(this.inputField).datepicker({
					language: 'zh-CN',
					autoclose: true, //选中之后自动隐藏日期选择框
					clearBtn: true, //清除按钮
					todayBtn: true, //今日按钮
					format: "yyyy-mm-dd",
					buttonImageOnly: true,
					todayHighlight: true,
					startView: startView,
					minViewMode: minViewMode,
					hide: this.onDatePanelClose.bind(this)
				});
	
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
					this.doSetEnable(_allowEdit);
				}
				var copy = Object.assign({}, this.props.contextMenuData);
				if (copy.items) {
					for (var i = 0; i < copy.items.length; i++) {
						var item = copy.items[i];
						if (item && item.label == "过滤[Ctrl+T]") {
							item.action = this.queryFilter.bind(this);
							break;
						}
					}
					$(this.inputField).contextPopup(copy);
				} else {
					$(this.inputField).contextPopup(this.props.contextMenuData);
				}
			}
		}, {
			key: 'queryFilter',
			value: function queryFilter() {
				if (!this.props.control || !this.props.control.group) return;
				var _dataField = this.props.dataField;
				if (_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField)) {
	
					var value = this.props.rowData[_dataField];
					this.props.control.group.queryFilter(_dataField, value);
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.inputField).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
					$(this.inputField).attr("readonly", "readonly");
					$(this.downArrowButton).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
				} else if (nowAllowEdit == false && enable == true) {
					$(this.inputField).css("backgroundColor", "#FFFFFF");
					$(this.inputField).removeAttr("readonly");
					$(this.downArrowButton).css("backgroundColor", "#FFFFFF");
				}
			}
		}, {
			key: 'onKeyDownHandler2',
			value: function onKeyDownHandler2(e) {
				if (e.ctrlKey && e.keyCode == 65) {
					e.stopPropagation();
					return true;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '2px', backgroundColor: '#ffffff', fontSize: "12px", cursor: 'text', paddingRight: '13px' };
				var _textAlign = this.props.control.getProperty_Alignment();
				_style.textAlign = _textAlign.toLowerCase();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				if (this.props.height) {
					_style.maxHeight = this.props.height - 2;
				}
				var _v = this.props.value;
				/*if(this.props.hasInitialValue == true && this.props.control)
	   {
	   	var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
	   			if(_allowEdit == false)
	   	{
	   		if(this.props.column && this.props.column.key)
	   		{
	   			let _value = this.props.rowData[this.props.column.key];
	   			_v = _value;
	   		}
	   	}
	   }*/
				//<div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',paddingLeft:'2px',paddingRight:'2px',paddingBottom:'1px'}} onClick={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>
				return _react2.default.createElement(
					'div',
					{ className: 'input-group date', style: { width: '100%' } },
					_react2.default.createElement('input', { spellCheck: 'false', id: "input" + this.props.xml.id, type: 'text', className: 'form-control pull-right', defaultValue: _v, ref: function ref(node) {
							return _this2.inputField = node;
						}, style: _style, onKeyDown: this.onKeyDownHandler2.bind(this) }),
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.downArrowButton = node;
						}, className: 'fa fa-calendar', onClick: this.showDateDropDown.bind(this), style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } })
				);
			}
		}]);
	
		return FormItemDateEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemDateEditor2.default));
	
	exports.default = FormItemDateEditorForDataGrid;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _FormItemDateTimeDisplay = __webpack_require__(97);
	
	var _FormItemDateTimeDisplay2 = _interopRequireDefault(_FormItemDateTimeDisplay);
	
	var _FormItemDateTimeResolver = __webpack_require__(139);
	
	var _FormItemDateTimeResolver2 = _interopRequireDefault(_FormItemDateTimeResolver);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDateTimeEditor = function (_FormItemEditor) {
		_inherits(FormItemDateTimeEditor, _FormItemEditor);
	
		function FormItemDateTimeEditor(props) {
			_classCallCheck(this, FormItemDateTimeEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemDateTimeEditor.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditor)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false
			};
	
			_this.initMembers();
			_this.initStores();
			return _this;
		}
	
		_createClass(FormItemDateTimeEditor, [{
			key: 'initMembers',
			value: function initMembers() {}
		}, {
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore();
					this.unsubscribeAutoSaveBeforeStore();
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId, triggerModify) {
				if (arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId) {
					var value = arg[this.props.xml.name];
					this.setDisplayFieldText(value, triggerModify);
					if (this.props.underQueryGroup) {
						this.setQueryGroupEnable(true);
					}
				}
			}
		}, {
			key: 'dateSelectChange',
			value: function dateSelectChange() {
				alert('select changeDate');
			}
		}, {
			key: 'showDateDropDown',
			value: function showDateDropDown() {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				var pickerObj = $(this.flatpickrDom)[0]._flatpickr;
				if (!pickerObj) return;
	
				if (pickerObj.isOpen) {
					this.lookupStates.isShowed = false;
					pickerObj.close();
				} else {
					this.lookupStates.isShowed = true;
					pickerObj.open();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemDateTimeEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
					//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:"";
					this.setDisplay(_value);
	
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'onDatePanelClose',
			value: function onDatePanelClose() {
				this.lookupStates.isShowed = false;
				$(this.inputField).select().focus();
			}
		}, {
			key: 'onDatePanelChange',
			value: function onDatePanelChange() {
				this.setFinalValue();
				this.setDisplay();
			}
		}, {
			key: 'selectChangeDate',
			value: function selectChangeDate() {
				this.setFinalValue();
				this.setDisplay();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemDateTimeEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditor.prototype), 'componentDidMount', this).call(this);
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
	
				//CommonUtil.dynamicLoadJs("")
	
				window.Flatpickr.l10n.weekdays = {
					shorthand: ["三", "一", "二", "三", "四", "五", "六"],
					longhand: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"]
				};
	
				window.Flatpickr.l10n.months = {
					shorthand: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
					longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
				}, $(this.flatpickrDom).flatpickr({ enableTime: true, allowInput: true, onChange: this.onDatePanelChange.bind(this),
					onClose: this.onDatePanelClose.bind(this), time_24hr: true,
					minuteIncrement: 1, clickOpens: false, wrap: true, enableSeconds: true });
	
				if (this.props.underQueryGroup) {
					this.doSetEnable(true);
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
						//_initRecord = this.props.initEditorValue;
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
	
				if (this.props.initEditorValue && !this.props.dataField) {
					this.setFinalValue(this.props.initEditorValue, false);
					this.setDisplay();
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					this.setState({ allowEdit: false });
				} else if (nowAllowEdit == false && enable == true) {
					this.setState({ allowEdit: true });
				}
			}
		}, {
			key: 'onBeforeAutoSave',
			value: function onBeforeAutoSave(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					if ($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length) {
						var text = $(this.inputField).val();
						var _val = void 0;
						_val = _FormItemDateTimeResolver2.default.getResult(text, false);
						if (_val.indexOf("false:") == 0) {
							//alert(_val.substr(6));
							return false;
						}
						if (this.props.groupAlias == "") {
							this.record = _val;
						} else {
							var changed = false;
							var oldValue = this.record[this.props.dataField];
							var newValue = _val;
							if (oldValue != newValue) changed = true;
							this.record[this.props.dataField] = newValue;
							//alert("派发");	
							if (changed) {
								_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
								if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
							}
							this.updateModifiedTag();
						}
					}
				}
				return true;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (value == undefined || value == null) value = $(this.inputField).val();
				if (value == "t" || value == "T") {
					var today = new Date();
					var fullYear = today.getFullYear();
					var fullMonth = today.getMonth() + 1;
					var fullDate = today.getDate();
					if (fullMonth < 10) fullMonth = "0" + fullMonth;
					if (fullDate < 10) fullDate = "0" + fullDate;
	
					value = fullYear + "" + fullMonth + "" + fullDate + "120000";
				}
				if (value) {
					value = _FormItemDateTimeResolver2.default.getResult(value, false);
					if (value.indexOf("false:") == 0) {
						_Warn2.default.show({ text: value.substr(6) });
						return false;
					}
				}
	
				if (!this.props.dataField) {
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var oldValue = this.record;var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue, this);
						}
					}
					this.record = value;
				} else {
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "", null, this);
					}
					this.updateModifiedTag();
				}
				var pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
				var formatedDate = value.replace(pattern, '$1/$2/$3 $4:$5:$6');
				var ddate = new Date(formatedDate);
				$(this.flatpickrDom)[0]._flatpickr.setDate(ddate);
	
				return true;
			}
	
			//新框架避免增加复杂条件判断 所以该类只表示Form上FormItem
	
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				if (this.lookupStates.isShowed) return;
				if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) {
					//todo 值回送数据完成以后 严格按照显示要求再进行显示
					this.setFinalValue();
					this.setDisplay();
				}
	
				if (this.holdFocus) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				if (document.activeElement && document.activeElement == this.inputField) {} else {
					//let _displayStyle = this.props.control.getProperty_DisplayStyle();
					var _dislayFormat = this.props.displayFormat;
					if (_dislayFormat) {
						value = _FormItemDateTimeDisplay2.default.getDisplayText2(value, _dislayFormat);
					} else {
						value = _FormItemDateTimeDisplay2.default.getDisplayText(value);
					}
				}
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				//return;
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
				if (this.lookupStates.isShowed) return;
				if (!this.props.dataField) {
					$(this.inputField).val(this.record);
				} else {
					var _recordValue = this.record == null ? "" : this.record[this.props.dataField];
					$(this.inputField).val(_recordValue);
				}
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (_get(FormItemDateTimeEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditor.prototype), 'onKeyDownHandler', this).call(this, e)) return;
				if (e.keyCode > 64 && e.keyCode < 91 && e.keyCode != 84) {
					e.preventDefault();
				}
				if (e.ctrlKey && e.keyCode == 40) {
					var pickerObj = $(this.flatpickrDom)[0]._flatpickr;
					if (!pickerObj) return;
					pickerObj.open();this.lookupStates.isShowed = true;
				} else if (e.ctrlKey && e.keyCode == 38) {
					var _pickerObj = $(this.flatpickrDom)[0]._flatpickr;
					if (!_pickerObj) return;
					_pickerObj.close();this.lookupStates.isShowed = false;
				}
			}
		}, {
			key: 'inputFieldDbClick',
			value: function inputFieldDbClick() {
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				if (this.state.allowEdit) {
					var height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style = { padding: '2px', paddingRight: '13px', height: height + 'px', width: _width, fontSize: "12px" };
					_style.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
					return _react2.default.createElement('input', { 'data-input': true, spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.props.xml.id,
						type: 'text', className: 'form-control pull-right', style: _style,
						onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
				} else {
					var _height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						_height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style2 = { padding: '2px', paddingRight: '13px', height: _height + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px", cursor: 'text' };
					_style2.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style2, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style2.color = this.state.color;
					if (this.state.fontSize && this.state.fontSize != -1) _style2.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style2.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style2.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style2, this.props.customStyle);
					return _react2.default.createElement('input', { 'data-input': true, spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.props.xml.id, readOnly: 'readonly',
						type: 'text', className: 'form-control pull-right', style: _style2,
						onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
				}
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this3 = this;
	
				if (this.state.allowEdit) {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, onClick: this.showDateDropDown.bind(this), className: 'fa fa-calendar', style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
				} else {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, className: 'fa fa-calendar', style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
					//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var displayLength = this.state.displayLength;
				var paddingRightValue = 0;
				if (displayLength == _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH) displayLength = _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH + 1;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + paddingRightValue + 'px';
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				if (_display == "block") editorStyle.backgroundColor = "#f8e8b7";
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
	
				// _notNullStyle['display']='none';
				var widthProValue = this.props.control.getProperty_Width();
				var middleStyle = {};
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
				}
	
				var inputdom = this.getInputDom(_width);
				var downArrowButtonDom = this.getDownArrowButtonDom();
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				if (this.state.underQueryGroup && !this.inQueryGroup) {
					labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				}
				if (!this.props.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				}
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, className: 'editorGroup', ref: function ref(node) {
							return _this4.contextMenuHandler = node;
						}, style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ className: 'input-group date', style: middleStyle, ref: function ref(node) {
								return _this4.flatpickrDom = node;
							} },
						inputdom,
						downArrowButtonDom,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this4.modifiedTag = node;
							}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
					)
				);
			}
		}]);
	
		return FormItemDateTimeEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemDateTimeEditor;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemDecimalResolver = __webpack_require__(63);
	
	var _FormItemDecimalResolver2 = _interopRequireDefault(_FormItemDecimalResolver);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDecimalEditor = function (_FormItemEditor) {
		_inherits(FormItemDecimalEditor, _FormItemEditor);
	
		function FormItemDecimalEditor(props) {
			_classCallCheck(this, FormItemDecimalEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemDecimalEditor.__proto__ || Object.getPrototypeOf(FormItemDecimalEditor)).call(this, props));
	
			_this.initMembers();
			_this.initStores();
	
			_this.state.dropDownContent = _this.props.dropDownContent || _this.props.control.dropDownContent || _this.props.control.getProperty_DropDownContent();
			return _this;
		}
	
		_createClass(FormItemDecimalEditor, [{
			key: 'initMembers',
			value: function initMembers() {}
		}, {
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
					this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
					this.unsubcribeCmdUpdateControlVisibleStore = _CmdTypeStore.CmdUpdateShowDecimalStore.listen(this.onCmdUpdateShowDecimal.bind(this));
				}
			}
		}, {
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name) {
	
					this.setState({ dropDownContent: type });
				}
			}
		}, {
			key: 'onCmdUpdateShowDecimal',
			value: function onCmdUpdateShowDecimal(name, _value, moduleInstanceId) {
				if (this.props.moduleInstanceId == moduleInstanceId && name == this.props.xml.name) {
					if (!window.doUpformItemShowDecimalValueMap) {
						window.doUpformItemShowDecimalValueMap = {};
						window.doUpformItemShowDecimalValueMap[name] = _value;
					} else {
						window.doUpformItemShowDecimalValueMap[name] = _value;
					}
					this.setState({});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore();
					this.unsubscribeAutoSaveBeforeStore();
				}
				this.inputField.removeEventListener("mousewheel", this.stopScrollFun.bind(this), { passive: false });
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemDecimalEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDecimalEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
					//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
					this.setDisplay(_value);
	
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemDecimalEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDecimalEditor.prototype), 'componentDidMount', this).call(this);
				//此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
				//不能获得焦点的比如下拉框div仍然可以使得input失去焦点
				/*$(this.refs.inputdomtime).blur(function(event){
	   	  
	    	  $(this).val("06-06");
	   });*/
				if (this.props.underQueryGroup) {
	
					this.doSetEnable(false);
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
	
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
				this.inputField.addEventListener("mousewheel", this.stopScrollFun.bind(this), { passive: false });
			}
		}, {
			key: 'labelClickHandler',
			value: function labelClickHandler() {}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					this.setState({ allowEdit: false });
				} else if (nowAllowEdit == false && enable == true) {
					this.setState({ allowEdit: true });
				}
			}
		}, {
			key: 'setDisplayError',
			value: function setDisplayError() {}
		}, {
			key: 'onBeforeAutoSave',
			value: function onBeforeAutoSave(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					if ($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length) {
						var text = $(this.inputField).val();
						var _val = void 0;
						try {
							_val = _FormItemDecimalResolver2.default.getResult(text, false, this.props.allowNegative, this.props.numOfDecimals, this.props.roundOff);
						} catch (e) {
							alert(e.message);
							return;
						}
	
						if (_val.indexOf("false:") == 0) {
							return false;
						}
						if (this.props.groupAlias == "") {
							this.record = _val;
						} else {
							var changed = false;
							var oldValue = this.record[this.props.dataField];
							var newValue = _val;
							if (oldValue != newValue) changed = true;
							this.record[this.props.dataField] = newValue;
							//alert("派发");	
							if (changed) {
								_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
								if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
							}
							this.updateModifiedTag();
						}
					}
				}
				return true;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (this.props.underQueryGroup) {
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test($(this.inputField).val())) {
						$(this.inputField).val('-只查空值-');
						this.record = '-只查空值-';
						this.state.nullValue = true;
						value = '-只查空值-';
					} else if ($(this.inputField).val() == '-只查空值-' || $(this.inputField).val() == '-') {
						$(this.inputField).val('-只查空值-');
						value = '-只查空值-';
					} else if (value == '-点此填值-') {
						$(this.inputField).val('-点此填值-');
						value = '';
					} else {
						if (typeof value != "number" && (value == "" || value == null || value == undefined)) value = $(this.inputField).val();
	
						value = _FormItemDecimalResolver2.default.getResult(value, false, this.props.allowNegative, this.props.numOfDecimals, this.props.roundOff);
					}
				} else {
					if (typeof value != "number" && (value == "" || value == null || value == undefined)) value = $(this.inputField).val();
	
					//try
					//{
					value = _FormItemDecimalResolver2.default.getResult(value, false, this.props.allowNegative, this.props.numOfDecimals, this.props.roundOff);
					//}
					//catch(e)
					//{
					//	alert(e.message);
					//	return;
					//}
				}
	
				if (value.indexOf("false:") == 0) {
					_Warn2.default.show({ text: value.substr(6) });
					return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
				}
				if (!this.props.dataField) {
					var oldValue = this.record;
					this.record = value;
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue, this);
						}
					}
				} else {
					var changed = false;
	
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					if (this.record && this.record.hasOwnProperty(this.props.dataField)) this.record[this.props.dataField] = _newValue;
	
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "", null, this);
					}
					this.updateModifiedTag();
				}
				return _FormItemConst2.default.EDITOR_VALUE_CHANGED_SUC;
			}
	
			//新版框架为了避免复杂判断 该类仅表示Form上的FormItem
	
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				if (this.props.underQueryGroup && $(this.inputField).val() == "") {
					this.state.notNull = false;
					this.setState({ allowEdit: false, nullValue: false });
					this.inQueryGroup = false;
				} else {
					//if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
					if (this.state.allowEdit) {
						this.setFinalValue();
						//todo 值回送数据完成以后 严格按照显示要求再进行显示
						this.setDisplay();
					}
				}
				if (this.holdFocus) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				this.inQueryGroup = false;
			}
		}, {
			key: 'textOnChange',
			value: function textOnChange() {
				// this.state.nullValue = false
				// let nowTxt = $(this.inputField).val();
				// if(this.state.underQueryGroup){
				// 	var reg = "^[ ]+$";
				// 	var rege = new RegExp(reg);
				// 	if(rege.test(nowTxt)){
				// 		$(this.inputField).val('-只查空值-');
				// 		this.record = '-只查空值-';
				// 		this.state.nullValue = true;
				// 	}
				// }
			}
		}, {
			key: 'inputFieldOnClick',
			value: function inputFieldOnClick() {
				if (this.props.underQueryGroup) {
					this.state.notNull = false;
					this.setState({ allowEdit: true, nullValue: false });
					this.inQueryGroup = true;
				}
			}
		}, {
			key: 'restoreValue',
			value: function restoreValue(_value) {
				var that = this;
	
				if (!this.props.dataField) {
					this.record = _value;
				} else if (this.record) {
					this.record[this.props.dataField] = _value;
				}
				this.setDisplay();
				this.updateModifiedTag();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
	
				if (value == null) value = "";
				if (value != "") {
					var parms = {};
					if (this.props.displayStyle) {
						var _displayStyle = this.props.displayStyle;
						if (_displayStyle.IsPercent == true) {
							parms.type = "percent";
						} else if (_displayStyle.CurrencyPrefix) {
							parms.type = "prefix";
							parms.prefix = _displayStyle.CurrencyPrefix;
						} else {
							parms.type = "normal";
						}
					}
	
					var sname = this.props.xml.name;
					if (window.doUpformItemShowDecimalValueMap && window.doUpformItemShowDecimalValueMap[sname]) {
						value = _FormItemDecimalDisplay2.default.getDisplayText(value, this.props.showZero, window.doUpformItemShowDecimalValueMap[sname], this.props.thousandSeperator, parms);
					} else {
						value = _FormItemDecimalDisplay2.default.getDisplayText(value, this.props.showZero, this.props.showDecimals, this.props.thousandSeperator, parms);
					}
				}
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
				if (this.props.underQueryGroup && this.record == '0.00') {
					this.record = "";
				}
				if (!this.props.dataField) {
					$(this.inputField).val(this.record);
				} else {
					var _recordValue = this.record == null ? "" : this.record[this.props.dataField];
					$(this.inputField).val(_recordValue);
				}
				if (this.state.underQueryGroup) {
					if ($(this.inputField).val() == '-只查空值-') {
						$(this.inputField).val('');
						this.record = '';
					}
				}
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onKeyUpHandler',
			value: function onKeyUpHandler(e) {
				var _val = $(this.inputField).val();
				$(this.inputField).val(_val.replace(/[^\-?\d.]/g, ''));
			}
		}, {
			key: 'onKeyPressHandler',
			value: function onKeyPressHandler(event) {
				return (/[\d|\.|\-]/.test(String.fromCharCode(event.charCode))
				);
			}
		}, {
			key: 'stopScrollFun',
			value: function stopScrollFun(evt) {
				evt = evt || window.event;
				if (evt.preventDefault) {
					// Firefox  
					evt.preventDefault();
					evt.stopPropagation();
				} else {
					// IE  
					evt.cancelBubble = true;
					evt.returnValue = false;
				}
				return false;
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (_get(FormItemDecimalEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemDecimalEditor.prototype), 'onKeyDownHandler', this).call(this, e)) return;
	
				if (!e.ctrlKey && e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'onKeyUpHandler',
			value: function onKeyUpHandler(e) {
				if (this.inputField.value) {
	
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test(this.inputField.value)) {
						this.inputField.value = " ";
						$(this.inputField).val(" ");
					} else if (this.inputField.value.length == 1) {
						this.inputField.value = this.inputField.value.replace(/[^0-9\-\.]/g, '');
					} else {
						this.inputField.value = this.inputField.value.replace(/^[^\d.]+$/g, '');
						return;
						var isNegtive = this.inputField.value.indexOf("-") == 0;
						if (isNegtive) {
							this.inputField.value = "-" + this.inputField.value.replace(/^[^\d.]+$/g, ''); //(/\D/g,'');
						} else {
							this.inputField.value = this.inputField.value.replace(/^[^\d.]+$/g, '');
						}
					}
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width, cacltagdom) {
				var _this2 = this;
	
				if (this.state.allowEdit) {
					var height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style = { padding: '2px', height: height + 'px', width: _width, fontSize: "12px" };
					_style.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					_style.imeMode = "disabled";
					if (this.state.dropDownContent != _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_NONE) _style.paddingRight = "13px";
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
					//if(cacltagdom)_style.paddingRight = "17px";
					if (this.props.underQueryGroup) {
						_style.border = 'none';
						_style.height = parseInt(height) - 2 + 'px';
						_width = _width.replace('px', '');
						_style.width = parseInt(_width) + 5 + 'px';
						return _react2.default.createElement(
							'div',
							{ style: { position: 'relative', width: '100%', height: '100%', marginRight: '12px', border: '1px solid #ccc' } },
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "input" + this.props.xml.id,
								className: 'form-control', style: _style, onKeyUp: this.onKeyUpHandler.bind(this), onChange: this.textOnChange.bind(this),
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '1px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "input" + this.props.xml.id,
							className: 'form-control', style: _style, onKeyUp: this.onKeyUpHandler.bind(this),
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				} else {
					var _height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						_height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style2 = { padding: '2px', height: _height + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
					_style2.textAlign = this.props.textAlign.toLowerCase();_style2.imeMode = "disabled";
					if (this.props.cssStyle) {
						Object.assign(_style2, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style2.color = this.state.color;
					if (this.state.fontSize && this.state.fontSize != -1) _style2.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style2.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style2.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style2, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
						_width = _width.replace('px', '');
						_style2.width = parseInt(_width) + 19 + 'px';
						var defaultValue = '-点此填值-';
						_style2.textAlign = 'center';
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "input" + this.props.xml.id, type: 'text', readOnly: 'readonly',
								className: 'form-control', style: _style2,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this), value: defaultValue, onClick: this.inputFieldOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "input" + this.props.xml.id,
							className: 'form-control', style: _style2,
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this), onClick: this.inputFieldOnClick.bind(this), readOnly: 'readonly' });
					}
				}
			}
		}, {
			key: 'calculatorReturnHandler',
			value: function calculatorReturnHandler(result) {
				if (result && this.state.allowEdit) {
					this.setFinalValue(result);
					//值回送数据完成以后 严格按照显示要求再进行显示
					this.setDisplay();
				}
	
				$(this.inputField).focus();
				$(this.inputField).select();
			}
		}, {
			key: 'showCalculator',
			value: function showCalculator() {
				window.parent.window.showCaculator("clear", this.calculatorReturnHandler.bind(this));
			}
		}, {
			key: 'showNumKeyBoard',
			value: function showNumKeyBoard() {
				var _offset1 = $(this.inputField).offset();
				var _offset2 = $(window.frameElement).offset();
				var _inputwidth = $(this.inputField).width();
				var _inputheight = $(this.inputField).height() + 7;
				window.parent.window.showNumKeyBoard("clear", _offset1, _offset2, _inputwidth, _inputheight, this.calculatorReturnHandler.bind(this));
	
				$(window.parent.document).find("#jqcalculator_percentage").css('display', 'block');
				$(window.parent.document).find("#jqcalculator_decimal").css('display', 'block');
			}
		}, {
			key: 'getCacltagdom',
			value: function getCacltagdom() {
				var display = "none";
				if (this.state.dropDownContent == _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_CACL) {
					display = "block";
				}
				return _react2.default.createElement('i', { className: 'fa fa-calculator', onClick: this.showCalculator.bind(this), style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', display: display } });
			}
		}, {
			key: 'getNumKeyBoardDom',
			value: function getNumKeyBoardDom() {
				var display = "none";
				if (this.state.dropDownContent == _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_NUMKEYBOARD) {
					display = "block";
				}
				return _react2.default.createElement('i', { className: 'fa fa-keyboard-o', onClick: this.showNumKeyBoard.bind(this), style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', display: display } });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var inputWidth = this.props.displayLengthWidth + "px";
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var displayLength = this.state.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
				var cacltagdom = this.getCacltagdom();
				var keyborddom = this.getNumKeyBoardDom();
				var widthProValue = this.props.control.getProperty_Width();
				var middleStyle = { position: "relative" };
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
				}
	
				var inputdom = this.getInputDom(_width, cacltagdom);
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				// if(this.state.underQueryGroup && !this.inQueryGroup)
				// {
				// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				// }
				if (!this.state.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				};
				var _displayStyleClassName = "editorGroup";
				if (this.props.displayStyle) {
					if (this.props.displayStyle._class) {
						_displayStyleClassName += " " + this.props.displayStyle._class;
					}
				}
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.contextMenuHandler = node;
						}, id: this.props.xml.name, className: _displayStyleClassName, style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ style: middleStyle },
						inputdom,
						cacltagdom,
						keyborddom,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this3.modifiedTag = node;
							}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
					)
				);
			}
		}]);
	
		return FormItemDecimalEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemDecimalEditor;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormModuleLookup = __webpack_require__(54);
	
	var _FormModuleLookup2 = _interopRequireDefault(_FormModuleLookup);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _FormItemDecimalEditor = __webpack_require__(125);
	
	var _FormItemDecimalEditor2 = _interopRequireDefault(_FormItemDecimalEditor);
	
	var _FormItemDecimalResolver = __webpack_require__(63);
	
	var _FormItemDecimalResolver2 = _interopRequireDefault(_FormItemDecimalResolver);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDecimalEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemDecimalEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemDecimalEditorForDataGrid() {
			_classCallCheck(this, FormItemDecimalEditorForDataGrid);
	
			return _possibleConstructorReturn(this, (FormItemDecimalEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemDecimalEditorForDataGrid)).apply(this, arguments));
		}
	
		_createClass(FormItemDecimalEditorForDataGrid, [{
			key: 'initStores',
			value: function initStores() {
				this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
				this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
				this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
			}
		}, {
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name) {
					this.setState({ dropDownContent: type });
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeDsAllowEditStore();
				this.inputField.removeEventListener("mousewheel", this.stopScrollFun.bind(this), { passive: false });
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
				var updated = {};
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				this.justCommit = true;
				var text = this.getInputNode().value;
				var _val;
				try {
					_val = _FormItemDecimalResolver2.default.getResult(text, false, this.props.allowNegative, this.props.numOfDecimals, this.props.roundOff);
				} catch (e) {
					alert(e.message);
					return;
				}
				var _oldValue = this.props.value;
				if (_val.indexOf("false:") == 0) {
					_Warn2.default.show({ text: _val.substr(6) });
					_val = _oldValue;
				}
	
				updated[this.props.column.key] = _val;
	
				if (_oldValue != updated[this.props.column.key]) {
					var propValue = this.props.value;
					var columnKey = this.props.column.key;
					var propRowData = this.props.rowData;
					var _control = this.props.control;
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						//let modifiedObject = {propValue:propValue,columnKey:columnKey,propRowData:propRowData,_val:_val};
						//if(!window.modifiedObjectQCache)
						//	window.modifiedObjectQCache = [];
						//window.modifiedObjectQCache.push(modifiedObject)
						/*
	     //TODO 张永芳：任务系统排期 临时表 modifieldField后替换整行 与 自动保存冲突 此应为测试代码
	     //由于临时表不需要保存 故最初策略为加禁用自动保存的属性 后调整为临时表弃用自动保存
	     setTimeout(function(){
	      			//let _modifiedObjectItem = window.modifiedObjectQCache.shift();
	      			_control.doFieldModifiedRemote(columnKey,_val,propValue,propRowData);
	     		},500);*/
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, _oldValue, null, null, { async: true, dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, _oldValue, null, null, { async: true });
						}
	
						if (!result && !this.props.control.isDataMethodField) {
							return {};
						}
						if (result && !this.props.control.isDataMethodField) {
							if (this.props.rowData[this.props.column.key] != _oldValue && this.props.rowData[this.props.column.key] != _val) {
								_val = this.props.rowData[this.props.column.key];
								updated[this.props.column.key] = _val;
							}
						}
					}
				}
				return updated;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
					this.doSetEnable(_allowEdit);
				}
	
				if (this.props.contextMenuData) $(this.inputField).contextPopup(this.props.contextMenuData);
				this.inputField.addEventListener("mousewheel", this.stopScrollFun.bind(this), { passive: false });
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.inputField).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
					$(this.inputField).attr("readonly", "readonly");
				} else if (nowAllowEdit == false && enable == true) {
					$(this.inputField).css("backgroundColor", "#FFFFFF");
					$(this.inputField).removeAttr("readonly");
				}
			}
		}, {
			key: 'onKeyPressHandler',
			value: function onKeyPressHandler(event) {
				return (/[\d|\.|\-]/.test(String.fromCharCode(event.charCode))
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '2px', width: '100%', backgroundColor: '#ffffff', fontSize: "12px", cursor: 'text' };
				if (this.state.dropDownContent != _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_NONE) _style.paddingRight = "13px";
				var _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				if (this.props.height) {
					_style.maxHeight = this.props.height - 2;
				}
	
				var cacltagdom = this.getCacltagdom();
				var numKeyBoardDom = this.getNumKeyBoardDom();
				var _v = this.props.value;
				/*if(this.props.hasInitialValue == true && this.props.control)
	   {
	   	var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
	   			if(_allowEdit == false)
	   	{
	   		if(this.props.column && this.props.column.key)
	   		{
	   			let _value = this.props.rowData[this.props.column.key];
	   			_v = _value;
	   		}
	   	}
	   }*/
				return _react2.default.createElement(
					'div',
					{ className: 'FormItem_DecimalEditor_DataGrid' },
					_react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this2.inputField = node;
						}, id: "input" + this.props.xml.id, type: 'number',
						className: 'form-control', style: _style, defaultValue: _v, onKeyPress: this.onKeyPressHandler.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) }),
					cacltagdom,
					numKeyBoardDom
				);
			}
		}]);
	
		return FormItemDecimalEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemDecimalEditor2.default));
	
	exports.default = FormItemDecimalEditorForDataGrid;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _ResizeActions = __webpack_require__(53);
	
	var _ResizeActions2 = _interopRequireDefault(_ResizeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(318);
	
	var FormItemDividedBox = function (_FormItemContainer) {
		_inherits(FormItemDividedBox, _FormItemContainer);
	
		function FormItemDividedBox(props) {
			_classCallCheck(this, FormItemDividedBox);
	
			var _this = _possibleConstructorReturn(this, (FormItemDividedBox.__proto__ || Object.getPrototypeOf(FormItemDividedBox)).call(this, props));
	
			_this.splitterStates = {
				sliderMoving: false,
				splitterIndex: 0
			};
	
			if (_this.state) _this.state = Object.assign({}, _this.state);else _this.state = _this.getInitialState();
			return _this;
		}
	
		_createClass(FormItemDividedBox, [{
			key: 'getInitialState',
			value: function getInitialState() {
				console.log(this.props.xml);
				var parent = this.props.xml;
				var children = parent.FormItem;
				var result = { childrengrow: [] };
				for (var i in children) {
					result.childrengrow.push(parseInt(i));
				}
				return result;
			}
		}, {
			key: 'mousePosition',
			value: function mousePosition(ev) {
				if (!ev) ev = window.event;
				if (ev.pageX || ev.pageY) {
					return { x: ev.pageX, y: ev.pageY };
				}
				return { x: ev.clientX + document.documentElement.scrollLeft - document.body.clientLeft,
					y: ev.clientY + document.documentElement.scrollTop - document.body.clientTop };
			}
	
			//获取一个DIV的绝对坐标的功能函数,即使是非绝对定位,一样能获取到      
	
		}, {
			key: 'getElCoordinate',
			value: function getElCoordinate(dom) {
				var t = dom.offsetTop;
				var l = dom.offsetLeft;
				dom = dom.offsetParent;
				while (dom) {
					t += dom.offsetTop;
					l += dom.offsetLeft;
					dom = dom.offsetParent;
				};
				return { top: t, left: l };
			}
		}, {
			key: 'sliderGhostMoving',
	
	
			//分隔条幽灵左右拖动(mousemove)      
			value: function sliderGhostMoving(e) {
				var layout = this.props.xml.Properties.Layout.Value;
				if (layout == 'horizontal') {
					var _left = this.mousePosition(e).x - 2; //height:$(e.target).height()+'px'
					$(this.refs.splitterproxy).css({ left: _left, display: "block", height: '100%' });
				} else {
					var _top = this.mousePosition(e).y - 2;
					$(this.refs.splitterproxy).css({ top: _top, display: "block", width: '100%' });
				}
			}
		}, {
			key: 'sliderHorizontalMove',
	
	
			//完成分隔条左右拖动(mouseup)      
			value: function sliderHorizontalMove(e) {
				/*var lWidth = getElCoordinate($(this.refs.splitterproxy)[0]).left - 2;        
	   var rWidth = $(window).width() - lWidth - 6;        
	   $("#divLeft").css("width", lWidth + "px");        
	   $("#divRight").css("width", rWidth + "px");*/
				if (!this.splitterStates.splitterIndex) {
					$(this.refs.splitterproxy).css("display", "none");
					return;
				}
				var layout = this.props.xml.Properties.Layout.Value;
				var proxyPosition = this.getElCoordinate($(this.refs.splitterproxy)[0]);
				if (this.startProxyPosition) {
					if (layout == "horizontal") {
						if (Math.abs(proxyPosition.left - this.startProxyPosition.left) < 2) {
							$(this.refs.splitterproxy).css("display", "none");
							return;
						}
					} else if (layout == "vertical") {
						if (Math.abs(proxyPosition.top - this.startProxyPosition.top) < 2) {
							$(this.refs.splitterproxy).css("display", "none");
							return;
						}
					}
				}
	
				var _index = parseInt(this.splitterStates.splitterIndex);
	
				var nowSplitter = $(this.refs['splitter' + _index]);
				var splitterPosition = this.getElCoordinate(nowSplitter[0]);
	
				if (layout == "horizontal") {
					//当前分隔条左边还有分隔条
					if (_index > 0 && this.refs.hasOwnProperty('splitter' + (_index - 1))) {
						var leftSplitterPosition = this.getElCoordinate($(this.refs['splitter' + (_index - 1)])[0]);
						if (proxyPosition.left < leftSplitterPosition.left) proxyPosition.left = leftSplitterPosition.left;
					}
					//当前分隔条右边还有分隔条
					if (this.refs.hasOwnProperty('splitter' + (_index + 1))) {
						var _leftSplitterPosition = this.getElCoordinate($(this.refs['splitter' + (_index + 1)])[0]);
						if (proxyPosition.left > _leftSplitterPosition.left) proxyPosition.left = _leftSplitterPosition.left;
					}
	
					var differ = proxyPosition.left - splitterPosition.left;
					var nowSplitterChildIndex = _index * 2 + 1;
					var leftCon = $(this.containerComponent).children()[nowSplitterChildIndex - 1];
					var rightCon = $(this.containerComponent).children()[nowSplitterChildIndex + 1];
	
					if ($(leftCon).is(":hidden") || $(rightCon).is(":hidden")) {
						$(this.refs.splitterproxy).css("display", "none");
						return;
					}
	
					var leftConFlexGrow = $(leftCon).css("flex-grow");
					if (leftConFlexGrow == "0" || !leftConFlexGrow) $(leftCon).width($(leftCon).outerWidth() + differ);
					var rightConFlexGrow = $(rightCon).css("flex-grow");
					if (rightConFlexGrow == "0" || !rightConFlexGrow) $(rightCon).width($(rightCon).outerWidth() - differ);
				} else {
					//当前分隔条上边还有分隔条
					if (_index > 0 && this.refs.hasOwnProperty('splitter' + (_index - 1))) {
						var _leftSplitterPosition2 = this.getElCoordinate($(this.refs['splitter' + (_index - 1)])[0]);
						if (proxyPosition.top < _leftSplitterPosition2.top) proxyPosition.top = _leftSplitterPosition2.top;
					}
					//当前分隔条下边还有分隔条
					if (this.refs.hasOwnProperty('splitter' + (_index + 1))) {
						var _leftSplitterPosition3 = this.getElCoordinate($(this.refs['splitter' + (_index + 1)])[0]);
						if (proxyPosition.top > _leftSplitterPosition3.top) proxyPosition.top = _leftSplitterPosition3.top;
					}
	
					var differ = proxyPosition.top - splitterPosition.top;
	
					var nowSplitterChildIndex = _index * 2 + 1;
					var upCon = $(this.containerComponent).children()[nowSplitterChildIndex - 1];
					var downCon = $(this.containerComponent).children()[nowSplitterChildIndex + 1];
	
					if ($(upCon).is(":hidden") || $(downCon).is(":hidden")) {
						$(this.refs.splitterproxy).css("display", "none");
						return;
					}
					var upConFlexGrow = $(upCon).css("flex-grow");
					//if(upConFlexGrow == "0" || !upConFlexGrow)
					//{
					if (upConFlexGrow != "0") $(upCon).css("flex-grow", "0");
					$(upCon).css('height', upCon.offsetHeight + differ + 'px');
					var upConId = $(upCon).attr("data-xmlid");
	
					var upParentControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, upConId));
					if (upParentControl.xml.type == "DataGrid") {
						_ResizeActions2.default.verticalSplitterResize(upConId, differ);
					} else if (upParentControl.xml.type == "Tab") {
						_ResizeActions2.default.verticalSplitterResize(upConId, differ);
					}
					this.dispatchVerticalResize(upParentControl.xml, differ);
					//}
	
					/*else if(upConFlexGrow == "100")
	    {
	    	var upParentControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,$(upCon).attr("id")));
	    	this.dispatchVerticalResize(upParentControl.xml,0);
	    }*/
					var downConFlexGrow = $(downCon).css("flex-grow");
					//if(downConFlexGrow == "0" || !downConFlexGrow)
					//{
					if (downConFlexGrow != "0") $(downCon).css("flex-grow", "0");
					$(downCon).css('height', downCon.offsetHeight - differ + 'px');
					var downConId = $(downCon).attr("data-xmlid");
					var downParentControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, downConId));
					if (downParentControl.xml.type == "DataGrid") {
						_ResizeActions2.default.verticalSplitterResize(downConId, 0 - differ);
					} else if (downParentControl.xml.type == "Tab") {
						_ResizeActions2.default.verticalSplitterResize(downConId, 0 - differ);
					}
					this.dispatchVerticalResize(downParentControl.xml, 0 - differ);
					//}
					/*else if(downConFlexGrow == "100")
	    {
	    	var downParentControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,$(downCon).attr("id")));
	    	this.dispatchVerticalResize(downParentControl.xml,0);
	    }*/
				}
	
				var addon = layout == 'horizontal' ? proxyPosition.left - splitterPosition.left : proxyPosition.top - splitterPosition.top;
	
				var $leftcon = $(this.refs['con' + _index]);
				var $rightcon = $(this.refs['con' + (_index + 1)]);
				if (layout == 'horizontal') {
					$leftcon.css("width", $leftcon.width() + addon + 'px');
					$rightcon.css("width", $rightcon.width() - addon + 'px');
				} else {
					$leftcon.css("height", $leftcon.height() + addon + 'px');
					$rightcon.css("height", $rightcon.height() - addon + 'px');
				}
	
				$(this.refs.splitterproxy).css("display", "none");
			}
		}, {
			key: 'dispatchVerticalResize',
			value: function dispatchVerticalResize(parent, addon) {
				var children = parent.FormItem;
				for (var i in children) {
					var child = children[i];
					if (child.type == "DataGrid") {
						_ResizeActions2.default.verticalSplitterResize(child.id, addon);
					} else if (child.type == "Tab") {
						_ResizeActions2.default.verticalSplitterResize(child.id, addon);
					}
					this.dispatchVerticalResize(child, addon);
				}
			}
		}, {
			key: 'onSplitterMouseDown',
			value: function onSplitterMouseDown(e) {
				this.splitterStates.splitterIndex = $(e.target).attr('data-index');
				if (!this.splitterStates.splitterIndex) return;
				this.splitterStates.sliderMoving = true;
	
				this.startProxyPosition = this.getElCoordinate($(this.refs.splitterproxy)[0]);
				var layout = this.props.xml.Properties.Layout.Value;
				if (layout == "horizontal") {
					$(this.refs.dividedbox).css("cursor", "w-resize");
				} else {
					$(this.refs.dividedbox).css("cursor", "s-resize");
				}
			}
		}, {
			key: 'onSplitterMouseMoving',
			value: function onSplitterMouseMoving(e) {
				//alert('move1');
				if (this.splitterStates.sliderMoving) {
					//alert('move2');
					this.sliderGhostMoving(e);
				}
			}
		}, {
			key: 'onSplitterMouseUp',
			value: function onSplitterMouseUp(e) {
				if (this.splitterStates.sliderMoving) {
					this.splitterStates.sliderMoving = false;
					this.sliderHorizontalMove(e);
					$(this.refs.dividedbox).css("cursor", "default");
					//let layout = this.props.xml.Properties.Layout.Value;
					//this.desDataGrid(this.props.xml,'splitterResize',layout);
				}
			}
	
			/*desDataGrid(xml,type,layout)
	  {
	  	let children = xml.FormItem;
	  	for(var i in children)
	  	{
	  		let child = children[i];
	  		if(child.type == "DataGrid")
	  		{
	  			if(type == 'splitterResize')
	  			{
	  				//alert('splitterResize');
	  				ResizeActions.splitterResize(child.id,layout);
	  			}
	  			else
	  				ResizeActions.dividedBoxDidMount(child.id,"vertical",8);
	  		}
	  		this.desDataGrid(child,type,layout);
	  	}        
	  }*/
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				/* onMouseDown={this.onSplitterMouseDown.bind(this)}
	    onMouseMove={this.onSplitterMouseMoving.bind(this)}
	    onMouseUp={this.onSplitterMouseUp.bind(this)}
	   let that = this;
	   $(this.refs.splitter).on("mousedown",this.onSplitterMouseDown.bind(this));          
	   $(this.refs.dividedbox).on("mousemove",function(e){that.onSplitterMouseMoving.bind(that)(e)});          
	   $(this.refs.dividedbox).on("mouseup", function (e){that.onSplitterMouseUp.bind(that)(e)});*/
				_get(FormItemDividedBox.prototype.__proto__ || Object.getPrototypeOf(FormItemDividedBox.prototype), 'componentDidMount', this).call(this);
				var layout = this.props.xml.Properties.Layout.Value;
				if (layout == "vertical") {
					//this.desDataGrid(this.props.xml,'didMount',layout);
					/*let children = this.props.xml.FormItem;
	    for(var i in children)
	    {
	    	let child = children[i];
	    	
	    	if(child.type == "DataGrid")
	    	{
	    		
	    		ResizeActions.dividedBoxDidMount(child.id,"vertical",-8);
	    	}
	    }*/
				}
			}
		}, {
			key: 'getSplitChildren',
			value: function getSplitChildren() {
				var parent = this.props.xml;
				var children = parent.FormItem;
				var layout = this.props.xml.Properties.Layout.Value;
				var result = [];var num = 0;
				var divInSplitterStyle = { position: 'absolute', overflow: 'visible', display: 'flex' };
				var splitterStyle = { alignSelf: 'stretch', position: 'relative' /*,flexShrink:0*/ };
				var leftAStyle = { cursor: 'pointer' };
				var rightAStyle = { overflow: 'hidden', display: 'block', cursor: 'pointer' };
				if (layout == 'horizontal') {
					splitterStyle.width = '5px';splitterStyle.cursor = 'w-resize';
					divInSplitterStyle.marginTop = '-35px';divInSplitterStyle.left = 0;divInSplitterStyle.top = '50%';divInSplitterStyle.width = '100%';divInSplitterStyle.flexDirection = 'column';
					leftAStyle.marginTop = '-35px';leftAStyle.background = 'url(images/miniLeft.png) no-repeat 50% 50%';leftAStyle.height = '35px';
					rightAStyle.height = '35px';rightAStyle.background = 'url(images/miniRight.png) no-repeat 50% 50%';
				} else {
					splitterStyle.height = '5px';splitterStyle.cursor = 's-resize';
					divInSplitterStyle.marginLeft = '-35px';divInSplitterStyle.top = 0;divInSplitterStyle.left = '50%';divInSplitterStyle.height = '100%';divInSplitterStyle.flexDirection = 'row';
					leftAStyle.marginLeft = '-35px';leftAStyle.background = 'url(images/miniLeftH.png) no-repeat 50% 50%';leftAStyle.width = '35px';
					rightAStyle.width = '35px';rightAStyle.background = 'url(images/miniRightH.png) no-repeat 50% 50%';
				}
	
				for (var i in children) {
					var child = children[i];
					var formItemChild = _FormItemUtil2.default.getFormItemInstance(this.props.menuItemId, this.props.formId, child, parent, this.props.forLookup);
					var flexDirection = layout == 'horizontal' ? 'row' : 'column';
					var conStyle = { display: 'flex', flexDirection: flexDirection, alignSelf: 'stretch', overflow: 'auto', padding: '0px' /*,flexShrink:0*/ };
	
					if (_FormItemConst2.default.isMaxControl(child, layout)) {
						conStyle.flexGrow = 100;
					} else if (_FormItemConst2.default.containsMaxControl(child, layout)) {
						conStyle.flexGrow = 100;
					} else {
						conStyle.flexGrow = 0;
					}
					//result.push(<div key={'con'+i} ref={"con"+i} style={conStyle}>{formItemChild}</div>);
					result.push(formItemChild);
					if (num < children.length - 1) {
						var _splitterStyle = Object.assign({}, splitterStyle);
						if (formItemChild.props.controlVisible == false) _splitterStyle.display = "none";
						result.push(_react2.default.createElement(
							'div',
							{ ref: "splitter" + i, 'data-index': i, key: 'splitter' + i, style: _splitterStyle,
								onMouseDown: this.onSplitterMouseDown.bind(this)
							},
							_react2.default.createElement(
								'div',
								{ style: divInSplitterStyle },
								_react2.default.createElement('a', { title: '', style: leftAStyle, onClick: this.onSplitterLeftConClick.bind(this, i) }),
								_react2.default.createElement('a', { title: '', style: rightAStyle, onClick: this.onSplitterRightConClick.bind(this, i) })
							)
						));
					} else {
						var proxyStyle = {};
						if (layout == "horizontal") proxyStyle.cursor = "w-resize;";else proxyStyle.cursor = "s-resize";
						result.push(_react2.default.createElement('div', { key: 'splitterproxy', ref: 'splitterproxy', style: proxyStyle, className: 'dividedbox_splitter_proxy' }));
					}
					num++;
				}
				return result;
			}
		}, {
			key: 'onSplitterLeftConClick',
			value: function onSplitterLeftConClick(count, event) {
				var nowSplitterChildIndex = count * 2 + 1;
				var rightCon = $(this.containerComponent).children()[nowSplitterChildIndex + 1];
	
				if ($(rightCon).is(":hidden")) {
					$(rightCon).show();
				} else {
					var leftCon = $(this.containerComponent).children()[nowSplitterChildIndex - 1];
	
					$(leftCon).hide();
				}
			}
		}, {
			key: 'onSplitterRightConClick',
			value: function onSplitterRightConClick(count, event) {
				var nowSplitterChildIndex = count * 2 + 1;
				var leftCon = $(this.containerComponent).children()[nowSplitterChildIndex - 1];
				if ($(leftCon).is(":hidden")) {
					$(leftCon).show();
				} else {
					var rightCon = $(this.containerComponent).children()[nowSplitterChildIndex + 1];
					$(rightCon).hide();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this,
				    _React$createElement;
	
				var _style = Object.assign({}, this.props.customStyle);
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				var list = this.getSplitChildren();
				return _react2.default.createElement(
					'div',
					(_React$createElement = { style: _style, ref: 'dividedbox', className: "FormItemDividedBox", id: this.props.xml.name }, _defineProperty(_React$createElement, 'ref', function ref(node) {
						return _this2.containerComponent = node;
					}), _defineProperty(_React$createElement, 'onMouseMove', this.onSplitterMouseMoving.bind(this)), _defineProperty(_React$createElement, 'onMouseUp', this.onSplitterMouseUp.bind(this)), _React$createElement),
					list
				);
			}
		}]);
	
		return FormItemDividedBox;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemDividedBox.defaultProps = {};
	
	exports.default = FormItemDividedBox;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEnumEditor = __webpack_require__(72);
	
	var _FormItemEnumEditor2 = _interopRequireDefault(_FormItemEnumEditor);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusStore = __webpack_require__(28);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(101);
	__webpack_require__(88);
	__webpack_require__(66);
	
	var FormItemEnumEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemEnumEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemEnumEditorForDataGrid() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FormItemEnumEditorForDataGrid);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormItemEnumEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemEnumEditorForDataGrid)).call.apply(_ref, [this].concat(args))), _this), _this.lookupStates = {
				isShowed: false
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FormItemEnumEditorForDataGrid, [{
			key: 'registerStores',
			value: function registerStores() {
				//this.unsubcribeSwitchToCurrentSetSelectStore = SwitchToCurrentSetSelectStore.listen(this.switchToCurrentSetSelectedHandler.bind(this));
				this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
			}
	
			// var A = function(params) {
	
			// }
			// var a = new A();
			// a.c = function(){alert("b")}
			// A.prototype.c = function(){
			// 	alert("c");
			// }
	
			// a.c();
	
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
	
				//this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeDsAllowEditStore();
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
				var updated = {};
				var _val = this.getInputNode().value + "";
				updated[this.props.column.key] = _val;
				this.justCommit = true;
				if (this.props.value != updated[this.props.column.key]) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, this.props.value + "", null, null, { dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							var _oldValue = this.props.value;
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, _oldValue + "");
						}
	
						if (!result && !this.props.control.isDataMethodField) {
							return {};
						}
						if (result && !this.props.control.isDataMethodField) {
							if (this.props.rowData[this.props.column.key] != this.props.value && this.props.rowData[this.props.column.key] != _val) {
								_val = this.props.rowData[this.props.column.key];
								updated[this.props.column.key] = _val;
							}
						}
					}
				}
				return updated;
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {}
	
			//项目编辑器只在销毁时回送数据
	
		}, {
			key: 'selectedChanged',
			value: function selectedChanged() {}
	
			/*componentDidMount()
	  {
	  	//super.componentDidMount();
	  	
	  	
	  	$(this.inputField).selectpicker('val',this.props.value);
	  	$(this.inputField).parent().find("button.btn").keydown(this.onKeyDownHandler.bind(this));
	  
	  	if(this.props.underQueryGroup)
	  	{
	  		this.doSetEnable(false);
	  	}
	  	else
	  	{
	  		this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
	  	}
	  
	  	//this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
	  	if(!this.props.groupAlias)
	  	{
	  		this.doUpdateAllowEditByJquery(this.state.allowEdit);
	  	}
	  }*/
	
		}, {
			key: 'dropdownHideHandler',
			value: function dropdownHideHandler() {
				this.lookupStates.isShowed = false;
				var elem = $(this.inputField).parent().find("button.btn");
				elem.focus();
				//setTimeout(function(){elem.focus();},100);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.inputField).selectpicker({ container: 'body', liveSearch: false });
				$(this.inputField).selectpicker('val', this.props.value);
				var _lookupStates = this.lookupStates;
				$(this.inputField).on("show.bs.select", function () {
					_lookupStates.isShowed = true;
				});
				$(this.inputField).on("hide.bs.select", this.dropdownHideHandler.bind(this));
				var allowEdit = true;
				if (!allowEdit) {
					$(this.inputField).parent().find("button.btn").css("background-color", "#dddddd").css("cursor", "not-allowed");
					$(this.inputField).attr("disabled", "");
					$(this.inputField).parent().find("button.btn>span.pull-left").css("text-align", "left");
				}
				var elem = $(this.inputField).parent().find("button.btn");
	
				setTimeout(function () {
					elem.focus();
				}, 100);
	
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
					this.doSetEnable(_allowEdit);
				}
	
				if (this.props.contextMenuData) $(this.inputField).contextPopup(this.props.contextMenuData);
			}
	
			//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
			//下拉框是否销毁由项目编辑器决定
	
		}, {
			key: 'handleBlurCommit',
			value: function handleBlurCommit() {
				if (this.justCommit == true) {
					this.justCommit = false;return false;
				}
				if (this.lookupStates.isShowed) return false;
	
				if (arguments[0] && arguments[0].relatedTarget) {
					if ($(arguments[0].relatedTarget).isChildAndSelfOf($(this.inputField).parent())) return false;
				}
	
				return true;
			}
		}, {
			key: 'getInputNode',
			value: function getInputNode() {
				return this.inputField;
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("disabled") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.inputField).parent().find("button.btn").css("background-color", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR).css("cursor", "not-allowed");
					$(this.inputField).attr("disabled", "");
					//$(this.inputField).parent().find("button.btn>span.pull-left").css("text-align","left");
				} else if (nowAllowEdit == false && enable == true) {
					$(this.inputField).parent().find("button.btn").css("background-color", "#FFFFFF").css("cursor", "pointer");
					$(this.inputField).removeAttr("disabled");
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$(this.inputField).selectpicker('destroy');
				//this.unsubcribeSwitchToCurrentSetSelectStore();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '0px', width: '100%', height: '100%', paddingTop: '0px', backgroundColor: '#ffffff', cursor: 'text' };
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
	
				var _options = this.props.options;
				if (this.props.xml.Properties.Regular.Value) {
					var regular = this.props.xml.Properties.Regular.Value;
					var enumv = regular.split('|');
					var _optionsN = [];
					enumv.forEach(function (eItem) {
						_options.forEach(function (item) {
							if (Number(item.value) == eItem) {
								_optionsN.push(item);
							}
						});
					});
				}
	
				if (_optionsN) {
					var list = _optionsN.map(function (item) {
						return _react2.default.createElement(
							'option',
							{ key: item.value, value: item.value },
							item.label
						);
					});
				} else {
					var list = _options.map(function (item) {
						return _react2.default.createElement(
							'option',
							{ key: item.value, value: item.value },
							item.label
						);
					});
				}
				return _react2.default.createElement(
					'select',
					{ ref: function ref(node) {
							return _this2.inputField = node;
						}, 'data-live-search': 'true',
						id: "select" + this.props.xml.id, className: 'FormItemEnumEditorForDataGrid selectpicker form-control',
						style: _style
					},
					list
				);
			}
		}]);
	
		return FormItemEnumEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemEnumEditor2.default));
	
	exports.default = FormItemEnumEditorForDataGrid;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _ResizeActions = __webpack_require__(53);
	
	var _ResizeActions2 = _interopRequireDefault(_ResizeActions);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(320);
	
	var FormItemGroup = function (_FormItemContainer) {
		_inherits(FormItemGroup, _FormItemContainer);
	
		function FormItemGroup(props) {
			_classCallCheck(this, FormItemGroup);
	
			var _this = _possibleConstructorReturn(this, (FormItemGroup.__proto__ || Object.getPrototypeOf(FormItemGroup)).call(this, props));
	
			_this.state.label = _this.props.label;
			_this.state.hasBorder = _this.props.hasBorder;
			_this.unsubscribeCmdUpdateControlPropertyStore = _CmdTypeStore.CmdUpdateControlPropertyStore.listen(_this.onCmdUpdateControlProperty.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			_this.unsubscribeUpdateGroupCollapseStateStore = _CmdTypeStore.UpdateGroupCollapseStateStore.listen(_this.onUpdateGroupCollapseStateStore.bind(_this));
			return _this;
		}
	
		_createClass(FormItemGroup, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCmdUpdateControlPropertyStore();
				this.unsubscribeCmdUpdateControlLabelStore();
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (this.props.showLabel && name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				}
			}
		}, {
			key: 'onUpdateGroupCollapseStateStore',
			value: function onUpdateGroupCollapseStateStore(arg) {
				if (arg && arg.hasOwnProperty(this.props.xml.name)) {
					var value = arg[this.props.xml.name];
					if ($(this.containerComponent).hasClass("expand") && value == false) {
						$(this.containerComponent).removeClass("expand").css("flex-grow", 0);
						$(this.titleNode).css("width", $(this.titleNode).width() + 'px');
						$(this.caretNode).attr("class", "fa fa-caret-left");
						$(this.gotGroupNode).slideUp(function () {
							_ResizeActions2.default.groupSlide();
						});
					} else if (!$(this.containerComponent).hasClass("expand") && value == true) {
						$(this.containerComponent).addClass("expand").css("flex-grow", this.origFlexGrow);
						$(this.titleNode).css("width", '');
						$(this.caretNode).attr("class", "fa fa-caret-down");
						_ResizeActions2.default.groupSlide("pre");
						$(this.gotGroupNode).slideDown(function () {
							_ResizeActions2.default.groupSlide();
						});
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlProperty',
			value: function onCmdUpdateControlProperty(name, property, value, moduleInstanceId) {
				if (name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId) return;
				if (property == ControlPropertyConst.HASBORDER) {
					this.setState({ hasBorder: value });
					/*if(value)
	    {
	    	$(this.containerComponent).css({border:"solid 1px #ccc",margin:"1px"});
	    }
	    else
	    {
	    	$(this.containerComponent).css({border:"none",margin:"1px"});
	    }*/
				}
			}
			//因折叠不属于状态(动态效果) label等改变最好不支持或者不使用setState
	
		}, {
			key: 'fold',
			value: function fold() {
				if ($(this.containerComponent).hasClass("expand")) {
					$(this.containerComponent).removeClass("expand").css("flex-grow", 0);
					$(this.titleNode).css("width", $(this.titleNode).width() + 'px');
					$(this.caretNode).attr("class", "fa fa-caret-left");
					$(this.gotGroupNode).slideUp(function () {
						_ResizeActions2.default.groupSlide();
					});
				} else {
					$(this.containerComponent).addClass("expand").css("flex-grow", this.origFlexGrow);
					$(this.titleNode).css("width", '');
					$(this.caretNode).attr("class", "fa fa-caret-down");
					_ResizeActions2.default.groupSlide("pre");
					$(this.gotGroupNode).slideDown(function () {
						_ResizeActions2.default.groupSlide();
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemGroup.prototype.__proto__ || Object.getPrototypeOf(FormItemGroup.prototype), 'componentDidMount', this).call(this);
				var layout = this.props.xml.Properties.Layout.Value;
				if (layout != 'vertical') return;
				var maxWidths = [];
				_ResizeActions2.default.getSubFieldGroupMaxWidth(this.props.xml.id, maxWidths);
				if (maxWidths.length > 1) {
					var maxWidth = 0;
					for (var i = 0; i < maxWidths.length; i++) {
						if (maxWidths[i] > maxWidth) {
							maxWidth = maxWidths[i];
						}
					}
					_ResizeActions2.default.setSubFieldGroupMaxWidth(this.props.xml.id, maxWidth);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var parent = this.props.xml;
				var _id = parent.name ? parent.name : parent.id;
				var children = parent.FormItem;
				var layout = parent.Properties.Layout.Value;
				var that = this;
				var list = children.map(function (item) {
					return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
				});
	
				var _style = Object.assign({}, this.props.customStyle);
	
				if (!this.props.showLabel) {
					if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
					if (this.state.hasBorder) {
						_style.border = "solid 1px #ccc";
						if (this.props.parentLayout == "vertical") {
							_style.marginTop = _style.marginBottom = this.props.isGroupQuery ? '4px' : '1px';
						} else {
							_style.marginLeft = _style.marginRight = this.props.isGroupQuery ? '4px' : '1px';
						}
					} else {
						_style.border = "none";
					}
					//_style.borderTop = "solid 1px #ccc !important";
					return _react2.default.createElement(
						'div',
						{ 'data-xmlid': this.props.xml.id, id: _id,
							ref: function ref(node) {
								try {
									for (var styleK in _style) {
										var styleV = _style[styleK];
										var importantIndex = styleV.indexOf("!important");
										if (importantIndex != -1) {
											node.style.setProperty(_style["orig-" + styleK], styleV.substr(0, importantIndex), 'important');
										}
									}
								} catch (e) {
									console.log("当前页面行内自定义css未能生效");
								}
								_this2.containerComponent = node;
							},
							style: _style, className: layout == "vertical" ? "verticalList FormItemGroup" : "horizontalList FormItemGroup" },
						list
					);
				} else {
					var outStyle = { display: 'flex', flex: '0 0 auto', overflow: 'auto', flexDirection: 'column' };
					if (this.state.visible == false) if (this.state.hideInVisible == true) outStyle.display = "none";else outStyle.visibility = "hidden";
					if (_style && _style.flexGrow) outStyle.flexGrow = _style.flexGrow;
					if (_style && _style.width) outStyle.width = _style.width;
					if (_style && _style.height) outStyle.height = _style.height;
					if (_style && _style.alignSelf) outStyle.alignSelf = _style.alignSelf;
					if (_style) _style.paddingTop = "6px";
					this.origFlexGrow = outStyle.flexGrow ? outStyle.flexGrow : 0;
					var h4Style = { fontSize: '15px', paddingLeft: '10px', borderLeft: '3px solid rgb(85, 85, 85)', marginBottom: '2px' };
					var innerStyle = { textAlign: 'left', borderBottom: 'solid 1px #ccc' };
	
					if (this.state.hasBorder) {
						outStyle.border = "solid 1px #ccc";
						outStyle.margin = this.props.isGroupQuery ? '2px' : '1px';
					}
					if (this.props.foldable) {
						var _className = "";var caretNodeClass = "";
						if (this.props.expand) {
							_className = "expand";caretNodeClass = "fa fa-caret-down";
						} else {
							outStyle.flexGrow = 0;caretNodeClass = "fa fa-caret-left";
						}
						delete _style.width;_style.flexGrow = 100;
						return _react2.default.createElement(
							'div',
							{ id: _id, 'data-xmlid': this.props.xml.id, className: "FormItemGroupFoldable " + _className, ref: function ref(node) {
									return _this2.containerComponent = node;
								}, style: outStyle },
							_react2.default.createElement(
								'div',
								{ className: 'box-header with-border', style: innerStyle, ref: function ref(node) {
										return _this2.titleNode = node;
									} },
								_react2.default.createElement(
									'h4',
									{ className: 'box-title', style: h4Style },
									this.state.label
								),
								_react2.default.createElement('i', { className: caretNodeClass, onClick: this.fold.bind(this), ref: function ref(node) {
										return _this2.caretNode = node;
									}, style: { fontSize: '1.2em', position: 'absolute', right: '2px', cursor: 'pointer' } })
							),
							_react2.default.createElement(
								'div',
								{ style: _style, ref: function ref(node) {
										return _this2.gotGroupNode = node;
									}, className: layout == "vertical" ? "verticalList" : "horizontalList" },
								list
							)
						);
					} else {
						delete _style.width;_style.flexGrow = 100;
						return _react2.default.createElement(
							'div',
							{ id: _id, 'data-xmlid': this.props.xml.id, className: "FormItemGroup", ref: function ref(node) {
									return _this2.containerComponent = node;
								}, style: outStyle },
							_react2.default.createElement(
								'div',
								{ className: 'box-header with-border', style: innerStyle },
								_react2.default.createElement(
									'h4',
									{ className: 'box-title', style: h4Style },
									this.state.label
								)
							),
							_react2.default.createElement(
								'div',
								{ style: _style, className: layout == "vertical" ? "verticalList" : "horizontalList" },
								list
							)
						);
					}
				}
			}
		}]);
	
		return FormItemGroup;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemGroup.defaultProps = {};
	
	exports.default = FormItemGroup;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FocusStore = __webpack_require__(28);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Gongqi_ProgressBar = __webpack_require__(151);
	
	var _Gongqi_ProgressBar2 = _interopRequireDefault(_Gongqi_ProgressBar);
	
	var _FormItemImageDialog = __webpack_require__(198);
	
	var _FormItemImageDialog2 = _interopRequireDefault(_FormItemImageDialog);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(321);
	
	var FormItemImage = function (_GongqiFormItem) {
		_inherits(FormItemImage, _GongqiFormItem);
	
		function FormItemImage(props) {
			_classCallCheck(this, FormItemImage);
	
			var _this = _possibleConstructorReturn(this, (FormItemImage.__proto__ || Object.getPrototypeOf(FormItemImage)).call(this, props));
	
			_this.record = null;
			_this.origRecord = null;
			_this.imgPathURL = null;
			_this.registerStores();
			_this.props.contextMenuData.items.push({ label: '另存为', icon: '', action: _this.saveAs.bind(_this) }, { label: '上传', icon: '', action: _this.chooseImg.bind(_this) }, { label: '删除', icon: '', action: _this.deleteImg.bind(_this) });
			_this.props.contextMenuData.beforeMenuShow = _this.beforeContextMenuShow.bind(_this);
			_this.resourceURL = window.parent.window.userInfos.resourceURL;
			_this.serviceURL = window.parent.window.userInfos.serviceURL;
			_this.conditions = {
				requestUrl: _this.serviceURL + "/FileUpLoad",
				fileFilters: '',
				sizeLimit: 500000000000,
				sizeMin: 0,
				heightMin: 0,
				height: 0,
				width: 0,
				widthMin: 0,
				compress: true,
				_selected: null
			};
			_this.imgUrl = '';
			_this.deletedImgArr = [];
			_this.unsubscribeCmdWriteControlStore = _CmdTypeStore.CmdWriteControlStore.listen(_this.onCmdWriteControlStore.bind(_this));
			return _this;
		}
	
		_createClass(FormItemImage, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCmdWriteControlStore();
			}
		}, {
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId) {
				if (arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId) {
					var value = arg[this.props.xml.name];
					value = this.resourceURL + "/" + value;
					this.displayImage(value);
				}
			}
	
			//只支持谷歌浏览器
	
		}, {
			key: 'saveAsUrl',
			value: function saveAsUrl(Url, filename) {
				var blob = new Blob([''], { type: 'application/octet-stream' });
				var url = URL.createObjectURL(blob);
				var a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
				a.href = Url;
				a.download = filename;
				var e = document.createEvent('MouseEvents');
				e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				a.dispatchEvent(e);
				URL.revokeObjectURL(url);
			}
		}, {
			key: 'saveText',
			value: function saveText(t, filename) {
				var mime = 'text/plain';
				saveAs('data:' + mime + ';charset=utf-8;base64,' + Base64.encode(t), filename);
			}
		}, {
			key: 'saveAs',
			value: function saveAs() {
				if (this.imgPathURL == null) return;
				if (this.props.multiple == true) {
					var imgList = this.state.imageList;
					if (!imgList || imgList.length == 0) {
						return;
					}
					var imgName = imgList[imgList.length - 1];
					var imgPath = this.state.dataurl + "/" + imgName;
					this.saveAsUrl(imgPath, imgName);
				} else {
					this.saveAsUrl(this.imgPathURL, "2.jpg");
				}
	
				return;
				//如果隐藏IFRAME不存在，则添加
				if (!document.getElementById("IframeReportImg")) {
					window.doSaveAsIMG = this.doSaveAsIMG.bind(this);
					$('<iframe style="display:none;" id="IframeReportImg" name="IframeReportImg" onload="doSaveAsIMG();" width="0" height="0" src="about:blank"></iframe>').appendTo("body");
				}
	
				if (document.all.IframeReportImg.src != this.imgPathURL) {
					//加载图片
					document.all.IframeReportImg.src = this.imgPathURL;
				} else {
					//图片直接另存为
					this.doSaveAsIMG();
				}
			}
		}, {
			key: 'onDelete',
			value: function onDelete(event) {
				var x = $(this.uploaderContainer).find('.viewer-container').hasClass("viewer-in");
				if (x) {
					//event.stopPropagation();
					//alert("1");
					if (event.nativeEvent) {
						event.nativeEvent.stopImmediatePropagation();
						return;
					}
				}
	
				if (!(event.keyCode == 86 && event.ctrlKey)) {
					event.preventDefault();
					return false;
				}
				/*alert(event.keyCode);
	   if(event.keyCode == 46||event.keyCode == 8)
	   {
	   	//del&backspace
	   event.preventDefault();
	        return false;
	      }*/
			}
		}, {
			key: 'doSaveAsIMG',
			value: function doSaveAsIMG() {
				if (document.all.IframeReportImg.src != "about:blank") document.getElementById("IframeReportImg").contentDocument.execCommand("SaveAs");
			}
		}, {
			key: 'registerStores',
			value: function registerStores() {
				this.unsubscribeGroupCurrentRecordChangedStore = _RecordsStore.GroupCurrentRecordChangedStore.listen(this.onCurrentRecordChanged.bind(this));
				this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(this.onFocusSet.bind(this));
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias) {
				if (this.props.groupAlias) {
					if (this.props.groupAlias == groupAlias) {
						this.record = currentRecord;
						this.origRecord = Object.assign({}, currentRecord);
	
						var _url = this.props.url;
						var sourceName = this.url2resName(_url);
	
						// let resourceURL=parent.window.userInfos.resourceURL;
						var resourceURL = this.resourceURL;
						if (sourceName.startsWith("@tmp")) {
							resourceURL = this.serviceURL + "/tmp";
						}
						this.sourceName = sourceName;
						this.uploadPath = sourceName;
						var finalUrl = resourceURL + "/" + sourceName;
						this.imgPathURL = finalUrl;
						//$(this.uploadImg).attr("src",'../images/imgError.jpg').attr('alt','暂无图片');
						this.displayImage(finalUrl);
	
						// var reader = new FileReader();
						// let that = this;
						// reader.onload = function(e){that.displayImage(e.target.result)};
						// if(window.testblob)
						// 	reader.readAsDataURL(window.testblob);
					}
				}
			}
	
			/*isUrlExist(_url)
	  {
	  	if(this.xmlhttp == null || this.xmlhttp == undefined)
	  	{
	  		this.xmlhttp = new XMLHttpRequest();
	  		//this.xmlhttp.onreadystatechange=this.uploadStateChangeHandler.bind(this);
	  	}
	  	this.xmlhttp.open("GET", _url,true);
	  	this.xmlhttp.send();
	  	return this.xmlhttp.status == 0;
	  }*/
	
			//应该首先请求后台 得到返回结果后做相应处理 如果成功 则返回一个url 否则 返回自定义错误信息
	
		}, {
			key: 'displayImage',
			value: function displayImage(dataurl) {
				var domain = window.domain;
				var dataurlbak = dataurl;
				try //zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
				{
					if (!domain && window.parent && window.parent.window) domain = window.parent.window.didomain;
					if (domain) {
						var loginToken = window.loginToken;
						var loginDataArea = window.loginDataArea;
						if (window.parent && window.parent.window) {
							if (!loginToken) loginToken = window.parent.window.loginToken;
							if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
						}
						if (!loginToken) {
							if (dataurl.indexOf("?") != -1) {
								dataurl += "&token=" + localStorage.getItem("userToken");
							} else {
								dataurl += "?token=" + localStorage.getItem("userToken");
							}
						}
					}
				} catch (e) {}
	
				if (this.props.multiple) {
					var _urlBase = "";
					if (window.urlBase) _urlBase = window.urlBase;
					var _headers = {};
					if (window.didomain) {
						var loginToken = window.loginToken;
						var loginDataArea = window.loginDataArea;
						if (window.parent && window.parent.window) {
							if (!loginToken) loginToken = window.parent.window.loginToken;
							if (!loginDataArea) loginDataArea = window.parent.window.loginDataArea;
						}
						if (!loginToken) {
							var _token = localStorage.getItem("userToken");
							if (_token) _headers.token = _token;
						}
					}
					$.ajax({
						type: 'post',
						url: this.serviceURL + "/GongqiERP/resource/list?path=" + this.uploadPath,
						dataType: "json",
						headers: _headers,
						//暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
						xhrFields: { withCredentials: true },
	
						success: this.getImageList.bind(this, dataurl),
						error: this.getImageListError.bind(this)
					});
				} else {
					$(this.uploadImg).css("opacity", "0");
					$(this.noImageContainer).css("display", "none");
					//let finalUrl=resourceURL+"/"+sourceName;
					if (this.deletedImgArr && this.deletedImgArr.indexOf(dataurlbak) == -1) {
						$(this.uploadImg).attr('src', dataurl).show(); //+=('?t='+new Date()));
					} else {
						var now = new Date();
						$(this.uploadImg).attr('src', dataurl + ('?t=' + now.getTime())).show();
					}
				}
			}
		}, {
			key: 'getImageList',
			value: function getImageList(dataurl, result) {
				//alert(JSON.stringify(data));
				var imageList = result.data;
				this.setState({ imageList: imageList, dataurl: dataurl });
			}
		}, {
			key: 'getImageListError',
			value: function getImageListError(data) {}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.props.multiple) {
					$(this.uploaderContainer).viewer('destroy');
					$(this.uploaderContainer).viewer({
						fullscreen: false
					});
					if (this.state.imageList && this.state.imageList.length > 0) $(this.noImageContainer).css("display", "none");
	
					/*$(this.uploadImg).css("opacity","0");
	    $(this.noImageContainer).css("display","none");
	    $(this.uploadImg).attr('src',dataurl).show();//+=('?t='+new Date()));*/
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.uploaderContainer).contextPopup(this.props.contextMenuData);
				if (!this.props.multiple) {
					$(this.uploaderContainer).viewer({
						url: 'data-original',
						navbar: false,
						fullscreen: false
					});
				}
	
				var suffix = this.props.suffix;
				var accept = "";
				if (suffix != "") {
					var suffixArray = suffix.split(",");
					for (var i in suffixArray) {
						if (i == suffixArray.length - 1) accept += "image/" + suffixArray[i];else accept += "image/" + suffixArray[i] + ",";
					}
					$(this.uploaderInput).attr("accept", accept);
				}
				if (this.props.initRecord) {
					this.onCurrentRecordChanged(null, this.props.initRecord, this.props.groupAlias);
				} else if (!this.props.groupAlias) {
					var _url = this.props.url;
					var sourceName = this.url2resName(_url);
					var resourceURL = this.resourceURL;
					this.sourceName = sourceName;
					this.uploadPath = sourceName;
					var finalUrl = resourceURL + "/" + sourceName;
					this.imgPathURL = finalUrl;
					this.displayImage(finalUrl);
				}
			}
		}, {
			key: 'displayNoneImage',
			value: function displayNoneImage() {}
		}, {
			key: 'url2resName',
			value: function url2resName(url) {
				var temp = "";
				var flag = false;
				var sourceName = "";
	
				if (true) {
					var array = url.split("");
					for (var i in array) {
						var s = array[i];
						if (s == "(") {
							temp += s;
							flag = true;
							continue;
						}
	
						if (s == ")") {
							temp = temp.substr(1);
							var group = this.props.group;
							if (group == null) return "";
							var index = 0;
	
							while (temp.charAt(index) == ".") {
								if (index == 0) {
									index++;
									continue;
								}
								if (group == null) {
									alert("对于Image控件 点号与实际的FormDataSource不对应");
									return "";
								}
								group = group.linkGroup;
	
								index++;
							}
	
							//temp = temp.substr(index);
							temp = _StringUtil2.default.convertToEachFirstLowerCase(temp.substr(index));
							temp = _StringUtil2.default.convertToFirstUpperCase(temp);
							if (temp.indexOf(".") == -1) {} else {
								var a = temp.split(".");
	
								if (group == null) {
									alert("对于Image控件 点号与实际的FormDataSource不对应");
									return "";
								}
								var obj = group.currentRecord;
								if (obj == null) return "";
	
								var _value = obj[temp];
	
								if (_value != null) sourceName += _value;
							}
							temp = "";
							flag = false;
							continue;
						}
	
						if (flag) {
							temp += s;
							continue;
						}
	
						sourceName += s;
					}
				} else {
					sourceName = url;
				}
	
				return sourceName;
			}
		}, {
			key: 'imageLoaderOnLoadHandler',
			value: function imageLoaderOnLoadHandler() {
				// var img=e.target.result;
				// $(this.uploaderContainer).removeClass("imageUploaderContainer");
				// $(this.uploaderContainer).css("background-image",'url('+this.imgUrl+')');
				// $(this.uploaderContainer).css("background-repeat","round");
	
				if (this.props.multiple == true) {
					var _url = this.props.url;
					var sourceName = this.url2resName(_url);
					var finalUrl = this.resourceURL + "/" + sourceName;
					this.displayImage(finalUrl);
					return;
				}
	
				if (this.imgUrl == '') {
					//$(this.uploadImg).attr("src",'../images/imgError.jpg').attr('alt','暂无图片');
					if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) $(this.noImageContainer).css("display", "flex");else $(this.noImageContainer).css("display", "none");
					$(this.uploadImg).hide();
					this.sourceName = "";
				} else {
					$(this.noImageContainer).css("display", "none");
					$(this.uploadImg).attr('src', this.imgUrl).attr('alt', '').show();
				}
			}
		}, {
			key: 'chooseImg',
			value: function chooseImg() {
				$(this.uploaderInput).attr('accept', this.conditions.fileFilters);
				$(this.uploaderInput).click();
			}
		}, {
			key: 'deleteImgAfterSelected',
			value: function deleteImgAfterSelected(imgNames) {
				for (var i = 0; i < imgNames.length; i++) {
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "deleteFile", "boolean");
					command.appendArg(this.sourceName + "/" + imgNames[i]);
					if (i == imgNames.length - 1) {
						_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_result_deleteImageHandler.bind(this) });
					} else {
						_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_result_deleteImageHandlers.bind(this) });
					}
				}
			}
			//循环删除 防止多个Fade.show()
	
		}, {
			key: 'rpc_result_deleteImageHandlers',
			value: function rpc_result_deleteImageHandlers(data) {
				if (data.result) {
	
					if (this.props.multiple == true) {
						this.displayImage(this.state.dataurl);
					} else {
						this.imgError();
					}
				} else {
					_Warn2.default.show({ text: "删除失败" });
				}
			}
		}, {
			key: 'deleteImg',
			value: function deleteImg() {
				if (this.props.multiple == true && this.state.imageList && this.state.imageList.length > 1) {
					var imgPath = this.state.dataurl + "/";
					var le = this.state.imageList.length;
					_reactDom2.default.render(_react2.default.createElement(_FormItemImageDialog2.default, { imgPath: imgPath, imgName: this.sourceName, imgNum: le, imgs: this.state.imageList, deleteImgs: this.deleteImgAfterSelected.bind(this) }), this.FormItemImage_Dialog);
				} else {
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "deleteFile", "boolean");
					if (!this.props.multiple) {
						command.appendArg(this.sourceName);
					} else {
						if (this.state.imageList && this.state.imageList.length > 0) {
							var lastItem = this.state.imageList[this.state.imageList.length - 1];
							//alert(lastItem);
							command.appendArg(this.sourceName + "/" + lastItem);
						} else {
							command.appendArg(this.sourceName);
						}
					}
					_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_result_deleteImageHandler.bind(this) });
				}
			}
		}, {
			key: 'rpc_result_deleteImageHandler',
			value: function rpc_result_deleteImageHandler(data) {
				if (data.result) {
	
					if (this.props.multiple == true) {
						this.displayImage(this.state.dataurl);
					} else {
						this.deletedImgArr.push(this.resourceURL + "/" + this.sourceName);
						this.imgError();
					}
	
					_Fade2.default.show({ text: "删除成功", state: "info" });
				} else {
					_Warn2.default.show({ text: "删除失败" });
				}
			}
		}, {
			key: 'upLoaderChangeHandler',
			value: function upLoaderChangeHandler(e) {
				var uploadFiles = e.target.files || e.dataTransfer.files;
				var uploadFile = uploadFiles[0];
				//this.checkUploadFile(uploadFile);
				var type = uploadFile.type;
				var _selected = this.conditions._selected;
				var fileName;
				var file;
				var selected = this.selected.bind(this);
				if (_selected != null) {
					fileName = selected();
					file = new File([uploadFile], fileName, { type: type });
				} else {
					file = uploadFile;
				}
				var imgHeight = this.conditions.height;
				var imgWidth = this.conditions.width;
				var heightMin = this.conditions.heightMin;
				var widthMin = this.conditions.widthMin;
				var sizeLimit = this.conditions.sizeLimit;
				var sizeMin = this.conditions.sizeMin;
				var reader = new FileReader();
				var fileFilters = this.conditions.fileFilters;
				var fileSize = file.size;
				var uploadFile = this.uploadFile.bind(this);
				this.imgUrl = '';
				var that = this;
				reader.readAsDataURL(file);
				var data;
				reader.onloadend = function (e) {
					data = e.target.result;
					if (type.indexOf('image') > -1) {
						that.imgUrl = data;
					}
				};
	
				if (fileFilters.indexOf('image') > -1) {
					var image = new Image();
					image.src = data;
					image.onload = function () {
						var width = image.width;
						var height = image.height;
						if (imgHeight != 0 && height > imgHeight || heightMin != 0 && height < heightMin) {
							_Warn2.default.show({ text: "图片高度不符合要求！" });
						} else if (imgWidth != 0 && width > imgWidth || widthMin != 0 && width < widthMin) {
							_Warn2.default.show({ text: "图片宽度不符合要求！" });
						} else if (sizeLimit != 0 && fileSize > sizeLimit) {
							_Warn2.default.show({ text: "超过上传文件最大限制：" + (sizeLimit / 1024).toFixed(1) + "K" });
						} else if (sizeMin != 0 && fileSize < sizeMin) {
							_Warn2.default.show({ text: '上传文件不得小于' + (sizeMin / 1024).toFixed(1) + 'K' });
						} else {
							uploadFile(file);
						}
					};
				} else {
					if (sizeLimit != 0 && fileSize > sizeLimit) {
						_Warn2.default.show({ text: "超过上传文件最大限制：" + (sizeLimit / 1024).toFixed(1) + "K" });
					} else if (sizeMin != 0 && fileSize < sizeMin) {
						_Warn2.default.show({ text: '上传文件不得小于' + (sizeMin / 1024).toFixed(1) + 'K' });
					} else {
						this.uploadFile(file);
					}
				}
				$(this.uploaderInput).val("");
			}
		}, {
			key: 'selected',
			value: function selected() {}
		}, {
			key: 'onDragDrop',
			value: function onDragDrop(e) {
				e.stopPropagation();
				//阻止浏览器默认打开文件的操作
				e.preventDefault();
				var files = e.dataTransfer.files;
				var file = files ? files[0] : null;
				if (file) this.checkUploadFile(file);
			}
		}, {
			key: 'checkUploadFile',
			value: function checkUploadFile(uploadFile, from) {
				if (this.props.groupAlias && this.record) {
					var recVersion = this.record[this.props.groupAlias + ".recVersion"];
					if (recVersion == -1 || recVersion == "-1") {
						_Warn2.default.show({ text: "该记录从未保存过，因此无法基于该记录上传图片" });
						return;
					}
				}
	
				var _enable = this.props.control.getProperty_AllowEdit_Final();
				if (_enable == false) {
					_Warn2.default.show({ text: "当前状态下图片不可编辑" });
					return;
				}
				var type = uploadFile.type;
				var _selected = this.conditions._selected;
				var fileName;
				var file;
				var selected = this.selected.bind(this);
				if (_selected != null) {
					fileName = selected();
					file = new File([uploadFile], fileName, { type: type });
				} else {
					file = uploadFile;
					if (from == "paste") {
						file = new File([uploadFile], file.lastModified + file.name, { type: type });
						//file.name = file.lastModified+file.name;
					}
				}
				var imgHeight = this.conditions.height;
				var imgWidth = this.conditions.width;
				var heightMin = this.conditions.heightMin;
				var widthMin = this.conditions.widthMin;
				var sizeLimit = this.conditions.sizeLimit;
				var sizeMin = this.conditions.sizeMin;
				var reader = new FileReader();
				var fileFilters = this.conditions.fileFilters;
				var fileSize = file.size;
				var uploadFile = this.uploadFile.bind(this);
				this.imgUrl = '';
				var that = this;
				reader.readAsDataURL(file);
				var data;
				reader.onloadend = function (e) {
					data = e.target.result;
					if (type.indexOf('image') > -1) {
						that.imgUrl = data;
					}
				};
	
				if (fileFilters.indexOf('image') > -1) {
					var image = new Image();
					image.src = data;
					image.onload = function () {
						var width = image.width;
						var height = image.height;
						if (imgHeight != 0 && height > imgHeight || heightMin != 0 && height < heightMin) {
							_Warn2.default.show({ text: "图片高度不符合要求！" });
						} else if (imgWidth != 0 && width > imgWidth || widthMin != 0 && width < widthMin) {
							_Warn2.default.show({ text: "图片宽度不符合要求！" });
						} else if (sizeLimit != 0 && fileSize > sizeLimit) {
							_Warn2.default.show({ text: "超过上传文件最大限制：" + (sizeLimit / 1024).toFixed(1) + "K" });
						} else if (sizeMin != 0 && fileSize < sizeMin) {
							_Warn2.default.show({ text: '上传文件不得小于' + (sizeMin / 1024).toFixed(1) + 'K' });
						} else {
							uploadFile(file);
						}
					};
				} else {
					if (sizeLimit != 0 && fileSize > sizeLimit) {
						_Warn2.default.show({ text: "超过上传文件最大限制：" + (sizeLimit / 1024).toFixed(1) + "K" });
					} else if (sizeMin != 0 && fileSize < sizeMin) {
						_Warn2.default.show({ text: '上传文件不得小于' + (sizeMin / 1024).toFixed(1) + 'K' });
					} else {
						this.uploadFile(file);
					}
				}
				$(this.uploaderInput).val("");
			}
		}, {
			key: 'uploadFile',
			value: function uploadFile(file) {
				var _path = this.uploadPath;
				if (this.props.multiple) _path += "/" + file.name;
				var serviceURL = this.conditions.requestUrl + "?path=" + _path + "&img=true";
				var oMyForm = new FormData();
				oMyForm.append("file", file);
				this.client = new XMLHttpRequest();
				/*var progressBar=$('<progress></progress>').css({'width':'15em','height':'1.2em'}).html('您的浏览器不支持progress元素');
	   var that=this;
	   var progressBtn=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
	   var progressDiv=$('<div></div>').css({'position':'absolute','top':'40%','left':'40%'}).append(progressBar).append(progressBtn);
	   var percentageDiv=$('<span></span>');
	   var time=$("<span></span>");
	   var percentDiv=$('<div></div>').css({'position':'absolute','top':'41%','left':'40%','font-size':'0.8em'}).append(percentageDiv).append(time);
	   var progressBorder=$("<div></div>").append(progressDiv).append(percentDiv).css('display','none').attr('id','progressBorder');
	   $('body').append(progressBorder);*/
				var progressArg = { modal: "modalSelf", title: "正在上传图片,请稍后...", total: 1, loaded: 1, closeable: false, text: "" };
				var progressBar = _Gongqi_ProgressBar2.default.show(progressArg, window);
	
				this.client.upload.onprogress = function (pe) {
					var updatedState = {};
					if (pe.lengthComputable) {
						/*progressBorder.css('display','block');
	     	progressBar.attr('max',pe.total);
	     progressBar.attr('value',pe.loaded);
	     percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");*/
						updatedState.total = pe.total;
						updatedState.loaded = pe.loaded;
						updatedState.text = Math.round(pe.loaded / pe.total * 100) + "%";
						//progressBar.setState({total:pe.total,loaded:pe.loaded,text:Math.round(pe.loaded / pe.total * 100) + "%"});
					}
					var nt = new Date().getTime(); //获取当前时间
					var pertime = (nt - this.ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
					this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
					var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b
					this.oloaded = pe.loaded; //重新赋值已上传文件大小，用以下次计算
	
					//上传速度计算
					var speed = perload / pertime; //单位b/s
					var bspeed = speed;
					var units = 'b/s'; //单位名称
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'k/s';
					}
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'M/s';
					}
					speed = speed.toFixed(1);
					//剩余时间
					var resttime = ((pe.total - pe.loaded) / bspeed).toFixed(1);
	
					var timeContent = ' ' + speed + units + ' 剩余时间:' + resttime + 's';
					//time.html(timeContent);
					updatedState.text += timeContent;
					progressBar.setState(updatedState);
				};
				this.client.upload.onloadstart = function () {
					//上传开始执行方法
					this.ot = new Date().getTime(); //设置上传开始时间
					this.oloaded = 0; //设置上传开始时，以上传的文件大小为0
				};
				this.client.onreadystatechange = this.uploadStateChangeHandler.bind(this);
	
				this.client.open("POST", serviceURL, true); //+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
				this.client.withCredentials = true;
	
				this.client.onloadend = function (pe) {
					// document.getElementById('progressDiv').style.display='none';
					//$('#progressBorder').remove();
					progressBar.closeHandler();
				};
				this.client.send(oMyForm);
			}
		}, {
			key: 'uploadStateChangeHandler',
			value: function uploadStateChangeHandler() {
				var that = this;
				if (this.client.readyState == 4) {
					// 4 = "loaded"
					if (this.client.status == 200) {
						var options = {
							state: 'success',
							text: '上传成功！'
						};
						_Fade2.default.show(options);
						this.imageLoaderOnLoadHandler();
					} else {
						var options = {
							state: 'error',
							text: '上传失败！'
						};
						_Fade2.default.show(options);
					}
				}
			}
		}, {
			key: 'imgError',
			value: function imgError() {
				//1.要获取getProperty_FailureImage 如果这个有 就用这个
				if (this.props.failureImage) {
					var newSrc = "customdev/" + this.props.failureImage;
					var origSrc = $(this.uploadImg).attr("src");
					if (newSrc != origSrc) {
						$(this.noImageContainer).css("display", "none");
						$(this.uploadImg).attr("src", newSrc).show();
					} else {
						if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) $(this.noImageContainer).css("display", "flex");else $(this.noImageContainer).css("display", "none");
						$(this.uploadImg).hide();
					}
					//$(this.uploadImg).attr("src",'../customdev/images/imgError.png').attr('alt','暂无图片');
				} else {
					if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) $(this.noImageContainer).css("display", "flex");else $(this.noImageContainer).css("display", "none");
					$(this.uploadImg).hide();
					//$(this.uploadImg).attr("src",'../customdev/images/imgError.png').attr('alt','暂无图片');
				}
				this.sourceName = "";
				$(this.uploadImg).css("opacity", "1");
			}
		}, {
			key: 'cancelUpload',
			value: function cancelUpload() {
				this.client.abort();
			}
		}, {
			key: 'beforeContextMenuShow',
			value: function beforeContextMenuShow(items) {
				var _enable = this.props.control.getProperty_AllowEdit_Final();
				var delItem = null;var upLoadItem = null;
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (!item) continue;
					if (item.label == "上传") upLoadItem = item;else if (item.label == "删除") delItem = item;
				}
	
				if (upLoadItem) upLoadItem.enable = _enable;
				if (delItem) delItem.enable = this.sourceName == "" || this.sourceName == null ? false : _enable;
			}
		}, {
			key: 'uploadFromClipboardHandler',
			value: function uploadFromClipboardHandler(event) {
				var clipboardData = event.clipboardData,
				    i = 0,
				    items,
				    item,
				    types;
	
				if (clipboardData) {
					items = clipboardData.items;
					if (!items) {
						return;
					}
					item = items[0];
					// 保存在剪贴板中的数据类型
					types = clipboardData.types || [];
					for (; i < types.length; i++) {
						if (types[i] === 'Files') {
							item = items[i];
							break;
						}
					}
					// 判断是否为图片数据
					if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
						this.imgReader(item, "paste");
					} else {
						event.preventDefault();
					}
				}
			}
		}, {
			key: 'imgReader',
			value: function imgReader(item, from) {
				var blob = item.getAsFile();
				this.checkUploadFile(blob, from);
				/*reader = new FileReader();
	   // 读取文件后将其显示在网页中
	   reader.onload = function( e ){
	   var img = new Image();
	    img.src = e.target.result;
	   document.body.appendChild( img );
	   };
	   // 读取文件
	   reader.readAsDataURL( blob );*/
			}
		}, {
			key: 'imgLoaded',
			value: function imgLoaded(e) {
				if (!e.target) return;
				var outterWidth = $(this.outterDiv).width();
				var outterHeight = $(this.outterDiv).height();
				var dv = 0;var rate = 0;var tmp = 0;
				//8为padding+margin * 2
				if (e.target.width > outterWidth - 8) {
					//rate = e.target.height / e.target.width;
					//dv = e.target.width - (outterWidth - 8);
					e.target.width = outterWidth - 8;
					//e.target.height -= (dv*rate);
				} else if (e.target.height > outterHeight - 8) {
					//rate = e.target.width / e.target.height;
					//dv = e.target.height - (outterHeight - 8);
					e.target.height = outterHeight - 8;
					//tmp = Math.ceil(e.target.width-(dv*rate));
					//e.target.width = tmp;
				}
				$(this.uploadImg).css("opacity", "1");
				//e.target.width = 162;
			}
		}, {
			key: 'getImageRenderList',
			value: function getImageRenderList() {
				var _this2 = this;
	
				var layoutMode = this.props.control.getProperty_LayoutMode();
				var imageStyle = { alignSelf: 'strech', maxWidth: '100%', maxHeight: '100%' };
				if (layoutMode == "Scale") {
					imageStyle.height = imageStyle.width = "100%";
				}
				if (!this.props.multiple) return _react2.default.createElement('img', { className: 'uploadImg', style: imageStyle, ref: function ref(node) {
						return _this2.uploadImg = node;
					}, onError: this.imgError.bind(this), onLoad: this.imgLoaded.bind(this) });
	
				var imgList = this.state.imageList;
				if (!imgList || imgList.length == 0) {
					return _react2.default.createElement('img', { className: 'uploadImg', src: this.state.dataurl, style: imageStyle, ref: function ref(node) {
							return _this2.uploadImg = node;
						}, onError: this.imgError.bind(this), onLoad: this.imgLoaded.bind(this) });
				}
				var renderList = [];
	
				for (var i = 0; i < imgList.length; i++) {
					var imgPath = this.state.dataurl + "/" + imgList[i];
					if (this.props.multiple) {
						if (window.parent.didomain) {
							if (this.state.dataurl.indexOf("?") != -1) {
								imgPath = this.state.dataurl.substr(0, this.state.dataurl.indexOf("?")) + "/" + imgList[i] + this.state.dataurl.substr(this.state.dataurl.indexOf("?"));
							}
						}
					}
					if (i == imgList.length - 1) {
						var imageStyle2 = { alignSelf: 'strech', maxWidth: '100%', maxHeight: '100%' };
						renderList.push(_react2.default.createElement('img', { src: imgPath, key: i, className: 'uploadImg', style: imageStyle2, ref: function ref(node) {
								return _this2.uploadImg = node;
							},
							onError: this.imgError.bind(this), onLoad: this.imgLoaded.bind(this) }));
					} else {
						var _imageStyle = { alignSelf: 'strech', maxWidth: '100%', maxHeight: '100%', display: 'none' };
						renderList.push(_react2.default.createElement('img', { src: imgPath, key: i, className: 'uploadImg', style: _imageStyle }));
					}
				}
				return renderList;
			}
		}, {
			key: 'getPromptDiv',
			value: function getPromptDiv() {
				var _enable = this.props.control.getProperty_AllowEdit_Final();
				if (_enable) {
					return _react2.default.createElement(
						'div',
						{ style: { fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#333333', letterSpacing: 0, textAlign: 'center', marginTop: '5px' } },
						'\u62D6\u62FD\u4E0A\u4F20 \u6216 \u7C98\u8D34'
					);
				}
				return null;
			}
	
			//contenteditable={true} onkeyDown={this.onDelete.bind(this)}
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				_style.display = 'flex';_style.flexDirection = 'column';
				//alert(JSON.stringify(_style));
				//不一定固定居中 Scale是固定居中 Clip Repeat Fit
				var innerStyle = {};
				//innerStyle["border"] = "1px solid #uploadD9D9D9";
				innerStyle["position"] = "relative";
				innerStyle["margin"] = "3px";
				innerStyle["display"] = "flex";
				innerStyle["alignItems"] = "center";
				innerStyle["flexDirection"] = "row";
				innerStyle["justifyContent"] = "center";
				innerStyle["flexGrow"] = 100;
				innerStyle["overflow"] = "auto";
				innerStyle["cursor"] = "pointer";
				innerStyle["color"] = "white"; //为了在编辑时不显示光标
				/*innerStyle["background"] = "#FAFAFA";
	   innerStyle["border"] = "1px dashed #D9D9D9";
	   innerStyle["borderRadius"] = "3px";*/
				innerStyle["padding"] = "10px";
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
	
				var imgList = this.getImageRenderList();
				var cornerFlag = null;
				var outerClassName = "FormItemImageContainer";
				if (imgList.length > 1) {
					outerClassName += " FormItemImageMutiple";
					cornerFlag = _react2.default.createElement(
						'div',
						{ style: { position: 'absolute', right: '12px', zIndex: 1, bottom: '9px', fontSize: '10px', display: 'flex' } },
						_react2.default.createElement('i', { className: 'fa fa-paperclip', style: { marginTop: '2px', fontSize: '13px', transform: 'rotate(45deg)' } }),
						_react2.default.createElement(
							'div',
							{ style: { marginLeft: '3px', fontSize: '14px', fontWeight: 'bold' } },
							imgList.length
						)
					);
				}
	
				//let promptDiv = this.getPromptDiv();
	
				return _react2.default.createElement(
					'div',
					{ className: outerClassName, style: _style, ref: function ref(node) {
							return _this3.outterDiv = node;
						}, id: this.props.xml.name, onDrop: this.onDragDrop.bind(this) },
					cornerFlag,
					_react2.default.createElement('input', { type: 'file', accept: 'image/jpg,image/jpeg,image/png,image/gif', multiple: false, style: { display: 'none' }, ref: function ref(node) {
							return _this3.uploaderInput = node;
						}, onChange: this.upLoaderChangeHandler.bind(this) }),
					_react2.default.createElement(
						'div',
						{ style: innerStyle, className: 'FormItemImage', ref: function ref(node) {
								return _this3.uploaderContainer = node;
							}, contentEditable: true, onPaste: this.uploadFromClipboardHandler.bind(this) },
						imgList,
						_react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this3.noImageContainer = node;
								}, style: { display: 'none', flexDirection: 'column', alignItems: 'center' } },
							_react2.default.createElement('i', { className: 'fa fa-picture-o', style: { color: '#40A9FF', fontSize: '32px' } }),
							_react2.default.createElement(
								'div',
								{ style: { fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#333333', letterSpacing: 0, textAlign: 'center', marginTop: '5px' } },
								'\u62D6\u62FD\u4E0A\u4F20 \u6216 \u7C98\u8D34'
							),
							';'
						)
					),
					_react2.default.createElement('div', { ref: function ref(node) {
							return _this3.FormItemImage_Dialog = node;
						} })
				);
			}
		}]);
	
		return FormItemImage;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemImage.defaultProps = {};
	
	exports.default = FormItemImage;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormItemEditor2 = __webpack_require__(40);
	
	var _FormItemEditor3 = _interopRequireDefault(_FormItemEditor2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemLongResolver = __webpack_require__(98);
	
	var _FormItemLongResolver2 = _interopRequireDefault(_FormItemLongResolver);
	
	var _FormItemLongDisplay = __webpack_require__(74);
	
	var _FormItemLongDisplay2 = _interopRequireDefault(_FormItemLongDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemLongEditor = function (_FormItemEditor) {
		_inherits(FormItemLongEditor, _FormItemEditor);
	
		function FormItemLongEditor(props) {
			_classCallCheck(this, FormItemLongEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemLongEditor.__proto__ || Object.getPrototypeOf(FormItemLongEditor)).call(this, props));
	
			_this.initMembers();
			_this.initStores();
			return _this;
		}
	
		_createClass(FormItemLongEditor, [{
			key: 'initMembers',
			value: function initMembers() {}
		}, {
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeAutoSaveBeforeStore = _RecordsStore.AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
					this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
				}
			}
		}, {
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name) {
					this.setState({ dropDownContent: type });
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.distroyCommonStores();
				if (!this.props.forLookup) {
					this.unsubscribeRecordFieldChangeStore();
					this.unsubscribeAutoSaveBeforeStore();
				}
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					//alert(formId + "  " + itemId);
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemLongEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemLongEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record != null && this.record != undefined ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
					//var _value = (this.record!=null&&this.record!=undefined&&this.props.dataField)?this.record[this.props.dataField]:"";
					this.setDisplay(_value);
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemLongEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemLongEditor.prototype), 'componentDidMount', this).call(this);
				//此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
				//不能获得焦点的比如下拉框div仍然可以使得input失去焦点
				/*$(this.refs.inputdomtime).blur(function(event){
	   	  
	    	  $(this).val("06-06");
	   });*/
				if (this.props.underQueryGroup) {
	
					this.doSetEnable(false);
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					this.setState({ allowEdit: false });
				} else if (nowAllowEdit == false && enable == true) {
					this.setState({ allowEdit: true });
				}
			}
		}, {
			key: 'onBeforeAutoSave',
			value: function onBeforeAutoSave(groupAlias) {
				if (this.props.groupAlias != groupAlias) return true;
				if ($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length) {
					var text = $(this.inputField).val();
					var _val = _FormItemLongResolver2.default.getResult(text, false, this.props.allowNegative);
					if (_val.indexOf("false:") == 0) {
						return;
					}
					if (this.props.groupAlias == "") {
						this.record = _val;
					} else {
						var changed = false;
						var oldValue = this.record[this.props.dataField];
						var newValue = _val;
						if (oldValue != newValue) changed = true;
						this.record[this.props.dataField] = newValue;
						//alert("派发");	
						if (changed) {
							_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, oldValue, newValue, this);
							if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, newValue + "", oldValue + "");
						}
						this.updateModifiedTag();
					}
				}
				return true;
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (this.props.underQueryGroup) {
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test($(this.inputField).val())) {
						$(this.inputField).val('-只查空值-');
						this.record = '-只查空值-';
						this.state.nullValue = true;
					} else if ($(this.inputField).val() == '-只查空值-' || $(this.inputField).val() == '-') {
						$(this.inputField).val('-只查空值-');
						value = '-只查空值-';
					} else if (value == '-点此填值-') {
						$(this.inputField).val('-点此填值-');
						value = '';
					} else {
						if (typeof value != "number" && !value) value = $(this.inputField).val();
						value = _FormItemLongResolver2.default.getResult(value, false, this.props.allowNegative);
					}
				} else {
					if (typeof value != "number" && !value) value = $(this.inputField).val();
					value = _FormItemLongResolver2.default.getResult(value, false, this.props.allowNegative);
				}
				if (value.indexOf("false:") == 0) {
					_Warn2.default.show({ text: value.substr(6) });
					return _FormItemConst2.default.EDITOR_VALUE_CHANGED_ERROR;
				}
				if (!this.props.dataField) {
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var oldValue = this.record;var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue, this);
						}
					}
					this.record = value;
				} else {
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "", null, this);
					}
					this.updateModifiedTag();
				}
				return _FormItemConst2.default.EDITOR_VALUE_CHANGED_SUC;
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				if (this.props.underQueryGroup && $(this.inputField).val() == "") {
					this.state.notNull = false;
					this.setState({ allowEdit: false, nullValue: false });
					this.inQueryGroup = false;
				} else {
					if (this.props.control && this.props.control.getProperty_AllowEdit_Final() == true) {
						this.setFinalValue();
						//todo 值回送数据完成以后 严格按照显示要求再进行显示
						this.setDisplay();
					}
				}
				if (this.holdFocus) {
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'inputFieldOnClick',
			value: function inputFieldOnClick() {
				if (this.props.underQueryGroup) {
					this.state.notNull = false;
					this.setState({ allowEdit: true, nullValue: false });
					this.inQueryGroup = true;
				}
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
	
				value = _FormItemLongDisplay2.default.getDisplayText(value, this.props.showZero, this.props.thousandSeperator);
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				window.lastFocusUI = this.inputField;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
				if (this.props.underQueryGroup && this.record == '0') {
					this.record = "";
				}
				if (!this.props.dataField) {
					$(this.inputField).val(this.record);
				} else {
					var _recordValue = this.record == null ? "" : this.record[this.props.dataField];
					$(this.inputField).val(_recordValue);
				}
				if (this.state.underQueryGroup) {
					if ($(this.inputField).val() == '-只查空值-') {
						$(this.inputField).val('');
						this.record = '';
					}
				}
				var _parentWindow = window;
				if (_parentWindow.notClickFocusEditor) {
					_parentWindow = window;
				} else if (window.parent.window.notClickFocusEditor) {
					_parentWindow = window.parent.window;
				}
				if (_parentWindow.notClickFocusEditor == undefined || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '' || !_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1) {
					$(this.inputField).select();
				}
			}
		}, {
			key: 'inputCloseOnClick',
			value: function inputCloseOnClick() {
				$(this.inputField).val('');
				this.record = '';
				this.setState({ allowEdit: false, nullValue: false });
				this.inQueryGroup = false;
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (_get(FormItemLongEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemLongEditor.prototype), 'onKeyDownHandler', this).call(this, e)) return;
				/*let valid = !e.shiftKey && !e.ctrlKey &&  
	   		( 
	   			(e.keyCode>95 && e.keyCode<106) ||
	   			e.keyCode == 109
	   		)
	   ;
	   if(!valid)
	   {
	   	e.preventDefault();
	   }*/
				if (!e.ctrlKey && e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'onKeyUpHandler',
			value: function onKeyUpHandler(e) {
				if (this.inputField.value) {
					if (this.inputField.value.length == 1) {
						this.inputField.value = this.inputField.value.replace(/[^1-9\-]/g, '');
					} else {
						var isNegtive = this.inputField.value.indexOf("-") == 0;
						if (isNegtive) {
							this.inputField.value = "-" + this.inputField.value.replace(/\D/g, '');
						} else {
							this.inputField.value = this.inputField.value.replace(/\D/g, '');
						}
					}
				}
			}
		}, {
			key: 'textOnChange',
			value: function textOnChange() {
				this.state.nullValue = false;
				var nowTxt = $(this.inputField).val();
				if (this.state.underQueryGroup) {
					var reg = "^[ ]+$";
					var rege = new RegExp(reg);
					if (rege.test(nowTxt)) {
						$(this.inputField).val('-只查空值-');
						this.record = '-只查空值-';
						this.state.nullValue = true;
					}
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				if (this.state.allowEdit) {
					var height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style = { padding: '2px 4px 2px 2px', height: height + 'px', width: _width, fontSize: "12px" };
					if (this.state.dropDownContent == _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_NUMKEYBOARD) {
						_style.paddingRight = "14px";
					}
					_style.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style.color = this.state.color;
					if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
					if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style, this.props.customStyle);
	
					if (this.props.underQueryGroup) {
	
						_style.border = 'none';
						_style.height = parseInt(height) - 2 + 'px';
						_width = _width.replace('px', '');
						_style.width = parseInt(_width) + 11 + 'px';
						return _react2.default.createElement(
							'div',
							{ style: { position: 'relative', width: '100%', height: '100%', marginRight: '12px', border: '1px solid #ccc' } },
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "input" + this.props.xml.id, type: 'text',
								className: 'form-control', style: _style,
								onKeyUp: this.onKeyUpHandler.bind(this), onChange: this.textOnChange.bind(this),
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) }),
							_react2.default.createElement('i', { className: 'fa fa-times-circle', style: { position: 'absolute', right: '1px', top: '5px', zIndex: '1000', color: 'gray', fontSize: '1px' }, onClick: this.inputCloseOnClick.bind(this) })
						);
					} else {
	
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "input" + this.props.xml.id, type: 'text',
							className: 'form-control', style: _style,
							onKeyUp: this.onKeyUpHandler.bind(this),
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				} else {
					var _height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT;
					if (this.props.displayHeight) {
						_height = this.props.height ? this.props.height : _FormItemConst2.default.EDITOR_HEIGHT * Number(this.props.displayHeight);
					}
					var _style2 = { padding: '2px', height: _height + 'px', width: _width, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, fontSize: "12px" };
					if (this.state.dropDownContent == _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_NUMKEYBOARD) {
						_style2.paddingRight = "14px";
					}
					_style2.textAlign = this.props.textAlign.toLowerCase();
					if (this.props.cssStyle) {
						Object.assign(_style2, this.props.cssStyle);
					}
					if (this.state.color && this.state.color != -1) _style2.color = this.state.color;
					if (this.state.fontSize && this.state.fontSize != -1) _style2.fontSize = this.state.fontSize;
					if (this.state.fontFamily) _style2.fontFamily = this.state.fontFamily;
					if (this.state.fontWeight) _style2.fontWeight = this.state.fontWeight;
					if (this.props.customStyle) Object.assign(_style2, this.props.customStyle);
					if (this.props.underQueryGroup) {
						_width = _width.replace('px', '');
						_style2.width = parseInt(_width) + 25 + 'px';
						var defaultValue = '-点此填值-';
						_style2.textAlign = 'center';
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
									return _this2.inputField = node;
								}, id: "input" + this.props.xml.id, type: 'text', readOnly: 'readonly',
								className: 'form-control', style: _style2,
								onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this), value: defaultValue, onClick: this.inputFieldOnClick.bind(this) })
						);
					} else {
						return _react2.default.createElement('input', { spellCheck: 'false', autoComplete: 'off', ref: function ref(node) {
								return _this2.inputField = node;
							}, id: "input" + this.props.xml.id, type: 'text', readOnly: 'readonly',
							className: 'form-control', style: _style2,
							onBlur: this.inputFieldBlur.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
					}
				}
			}
		}, {
			key: 'getNumKeyBoardDom',
			value: function getNumKeyBoardDom() {
				var display = "none";
				if (this.state.dropDownContent == _FormItemConst2.default.DECIMALEDITOR_DROPDOWN_NUMKEYBOARD) {
					display = "block";
				}
				return _react2.default.createElement('i', { className: 'fa fa-keyboard-o', onClick: this.showNumKeyBoard.bind(this), style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', display: display } });
			}
		}, {
			key: 'calculatorReturnHandler',
			value: function calculatorReturnHandler(result) {
				if (result && this.state.allowEdit) {
					this.setFinalValue(result);
					//值回送数据完成以后 严格按照显示要求再进行显示
					this.setDisplay();
				}
	
				$(this.inputField).focus();
				$(this.inputField).select();
			}
		}, {
			key: 'showNumKeyBoard',
			value: function showNumKeyBoard() {
				var _offset1 = $(this.inputField).offset();
				var _offset2 = $(window.frameElement).offset();
				var _inputwidth = $(this.inputField).width();
				var _inputheight = $(this.inputField).height() + 7;
				window.parent.window.showNumKeyBoard("clear", _offset1, _offset2, _inputwidth, _inputheight, this.calculatorReturnHandler.bind(this));
	
				// $(window.parent.document).find("#jqcalculator_percentage").css('display','none');
				// $(window.parent.document).find("#jqcalculator_decimal").css('display','none');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				//let inputWidth = this.props.displayLengthWidth+"px";
				var _display = this.currentDataFieldChanged ? "block" : "none";
				var displayLength = this.state.displayLength;
				var displayHeight = this.state.displayHeight;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				var notNull = this.state.notNull;
				var _notNullStyle = {};
				_notNullStyle['fontSize'] = '8px';
				_notNullStyle['color'] = 'red';
				if (!notNull) _notNullStyle['visibility'] = 'hidden';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				if (this.state.visible == false) if (this.state.hideInVisible == true) editorStyle.display = "none";else editorStyle.visibility = "hidden";
	
				var widthProValue = this.props.control.getProperty_Width();
				var middleStyle = { position: "relative" };
				if (widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1) {
					_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
				}
	
				var inputdom = this.getInputDom(_width);
				var keyborddom = this.getNumKeyBoardDom();
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				// if(this.state.underQueryGroup && !this.inQueryGroup)
				// {
				// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
				// }
				if (!this.state.label) {
					labelStyle.display = "none";_notNullStyle.display = "none";
				}
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, ref: function ref(node) {
							return _this3.contextMenuHandler = node;
						}, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "input" + this.props.xml.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.state.label
					),
					_react2.default.createElement('i', { className: 'fa fa-snowflake-o', style: _notNullStyle }),
					_react2.default.createElement(
						'div',
						{ style: middleStyle },
						inputdom,
						keyborddom,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this3.modifiedTag = node;
							}, className: 'fa fa-sort-asc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-5px", right: "-3px", fontSize: "11px", transform: 'rotate(45deg)', zIndex: "100", marginRight: '4.5px', marginTop: '4px', display: _display } })
					)
				);
			}
		}]);
	
		return FormItemLongEditor;
	}(_FormItemEditor3.default);
	
	exports.default = FormItemLongEditor;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemLongEditor = __webpack_require__(131);
	
	var _FormItemLongEditor2 = _interopRequireDefault(_FormItemLongEditor);
	
	var _FormItemLongResolver = __webpack_require__(98);
	
	var _FormItemLongResolver2 = _interopRequireDefault(_FormItemLongResolver);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemLongEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemLongEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemLongEditorForDataGrid() {
			_classCallCheck(this, FormItemLongEditorForDataGrid);
	
			return _possibleConstructorReturn(this, (FormItemLongEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemLongEditorForDataGrid)).apply(this, arguments));
		}
	
		_createClass(FormItemLongEditorForDataGrid, [{
			key: 'initStores',
			value: function initStores() {
				this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
				this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeDsAllowEditStore();
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
				var updated = {};
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				this.justCommit = true;
				var text = this.getInputNode().value;
				var _val = _FormItemLongResolver2.default.getResult(text, false, this.props.allowNegative);
				if (_val.indexOf("false:") == 0) {
					_Warn2.default.show({ text: _val.substr(6) });
					_val = this.props.value;
				}
				updated[this.props.column.key] = _val;
	
				if (this.props.value != updated[this.props.column.key]) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, this.props.value, null, null, { dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							var _oldValue = this.props.value;
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, _oldValue);
						}
	
						if (!result && !this.props.control.isDataMethodField) {
							return {};
						}
						if (result && !this.props.control.isDataMethodField) {
							if (this.props.rowData[this.props.column.key] != this.props.value && this.props.rowData[this.props.column.key] != _val) {
								_val = this.props.rowData[this.props.column.key];
								updated[this.props.column.key] = _val;
							}
						}
					}
				}
				return updated;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
					this.doSetEnable(_allowEdit);
				}
	
				if (this.props.contextMenuData) $(this.inputField).contextPopup(this.props.contextMenuData);
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.inputField).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
					$(this.inputField).attr("readonly", "readonly");
				} else if (nowAllowEdit == false && enable == true) {
					$(this.inputField).css("backgroundColor", "#FFFFFF");
					$(this.inputField).removeAttr("readonly");
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '2px', width: '100%', backgroundColor: '#ffffff', fontSize: "12px", cursor: 'text' };
				var _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				if (this.props.height) {
					_style.maxHeight = this.props.height - 2;
				}
	
				var _v = this.props.value;
				/*if(this.props.hasInitialValue == true && this.props.control)
	   {
	   	var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
	   			if(_allowEdit == false)
	   	{
	   		if(this.props.column && this.props.column.key)
	   		{
	   			let _value = this.props.rowData[this.props.column.key];
	   			_v = _value;
	   		}
	   	}
	   }*/
	
				return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
						return _this2.inputField = node;
					}, id: "input" + this.props.xml.id, type: 'text',
					className: 'form-control', style: _style, onKeyDown: this.onKeyDownHandler.bind(this),
					defaultValue: _v });
			}
		}]);
	
		return FormItemLongEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemLongEditor2.default));
	
	exports.default = FormItemLongEditorForDataGrid;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _ToolBarPrintStore = __webpack_require__(100);
	
	var _ToolBarPrintStore2 = _interopRequireDefault(_ToolBarPrintStore);
	
	var _FocusStore = __webpack_require__(28);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(82);
	
	var FormItemMenuItemButton = function (_GongqiFormItem) {
		_inherits(FormItemMenuItemButton, _GongqiFormItem);
	
		function FormItemMenuItemButton(props) {
			_classCallCheck(this, FormItemMenuItemButton);
	
			var _this = _possibleConstructorReturn(this, (FormItemMenuItemButton.__proto__ || Object.getPrototypeOf(FormItemMenuItemButton)).call(this, props));
	
			_this.unsubscribeTestStore = _ToolBarPrintStore2.default.listen(_this.onPrint.bind(_this));
			_this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this.onFocusSet.bind(_this));
			_this.unsubscribeSetButtonStyleStore = _CmdTypeStore.SetButtonStyleStore.listen(_this.onSetButtonStyle.bind(_this));
			_this.unsubscribeCmdUpdateControlAllowEditStore = _CmdTypeStore.CmdUpdateControlAllowEditStore.listen(_this.onCmdUpdateControlAllowEditStore.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			_this.state.devStyles = {};
			_this.state.label = _this.props.label;
			return _this;
		}
	
		_createClass(FormItemMenuItemButton, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeTestStore();
				this.unsubscribeFocusSetStore();
				this.unsubscribeSetButtonStyleStore();
				this.unsubscribeCmdUpdateControlAllowEditStore();
				this.unsubscribeCmdUpdateControlLabelStore();
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				}
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				//alert(itemId + "  " + this.props.xml.id);
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.btn).focus();
					//$(this.inputField).select();
				}
			}
		}, {
			key: 'onSetButtonStyle',
			value: function onSetButtonStyle(formId, name, buttonStyle) {
				if (this.props.xml.name == name && this.props.formId == formId) {
					this.setState({ devStyles: buttonStyle });
				}
			}
		}, {
			key: 'onCmdUpdateControlAllowEditStore',
			value: function onCmdUpdateControlAllowEditStore(name, _allowEdit, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
					if (!finalAllowEdit) $(this.btn).attr("disabled", true);else $(this.btn).removeAttr("disabled");
				}
			}
		}, {
			key: 'onPrint',
			value: function onPrint(_value) {
				alert(_value);
			}
	
			//当时此button在下拉框上 属于第三极IFrame
	
		}, {
			key: 'testIframeToParentAction',
			value: function testIframeToParentAction() {
				if (this.isclicking == true) {
					return;
				}
	
				this.isclicking = true;
				var _that = this;
				var _id = setTimeout(function (e) {
	
					clearTimeout(_id);
					_that.isclicking = false;
				}, 1000);
	
				if (typeof this.props.clickHandler == "function") this.props.clickHandler();
				return;
				alert(window.menuItemId + window.formId);
				return;
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					if (typeof _parentWindow.lookupReturnTest == 'function') _parentWindow.lookupReturnTest();
				}
				//window.parent.window.filterNodesBySubPage("SJLJ")
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {
					//alert(e.shiftKey)
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				window.lastFocusUI = this.btn;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
				if (!_allowEdit) $(this.btn).attr("disabled", "disabled");else $(this.btn).removeAttr("disabled");
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				if (_style != undefined) {
					_style['margin'] = '3px';_style.position = 'relative';
				}
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				Object.assign(_style, this.state.devStyles);
				if (this.props.iconClass) {
					return _react2.default.createElement(
						'button',
						{ id: this.props.xml.name, ref: function ref(node) {
								return _this2.btn = node;
							}, className: 'btn btn-info GongqiFormItemMenuItemButton', onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
							onClick: this.testIframeToParentAction.bind(this), style: _style },
						_react2.default.createElement('i', { className: this.props.iconClass }),
						'\xA0',
						this.state.label,
						_react2.default.createElement('i', { className: "fa fa-angle-right", 'aria-hidden': 'true', style: { position: 'absolute', right: '8px' } })
					);
				} else {
					return _react2.default.createElement(
						'button',
						{ id: this.props.xml.name, ref: function ref(node) {
								return _this2.btn = node;
							}, className: 'btn btn-info GongqiFormItemMenuItemButton', onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
							onClick: this.testIframeToParentAction.bind(this), style: _style },
						this.state.label,
						_react2.default.createElement('i', { className: "fa fa-angle-right", 'aria-hidden': 'true', style: { position: 'absolute', right: '8px' } })
					);
				}
			}
		}]);
	
		return FormItemMenuItemButton;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemMenuItemButton.defaultProps = {};
	
	exports.default = FormItemMenuItemButton;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormModuleLookup = __webpack_require__(54);
	
	var _FormModuleLookup2 = _interopRequireDefault(_FormModuleLookup);
	
	var _FormItemStringEditor = __webpack_require__(95);
	
	var _FormItemStringEditor2 = _interopRequireDefault(_FormItemStringEditor);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	var _LookupReturnStore = __webpack_require__(84);
	
	var _LookupReturnStore2 = _interopRequireDefault(_LookupReturnStore);
	
	var _LookupStores = __webpack_require__(34);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _FormItemStringResolver = __webpack_require__(99);
	
	var _FormItemStringResolver2 = _interopRequireDefault(_FormItemStringResolver);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FocusStore = __webpack_require__(28);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _GOT = __webpack_require__(147);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemStringEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemStringEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemStringEditorForDataGrid() {
			_classCallCheck(this, FormItemStringEditorForDataGrid);
	
			return _possibleConstructorReturn(this, (FormItemStringEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid)).apply(this, arguments));
		}
	
		_createClass(FormItemStringEditorForDataGrid, [{
			key: 'initStores',
			value: function initStores() {
				if (!this.props.forLookup) {
					this.unsubscribeLookupReturnStore = _LookupReturnStore2.default.listen(this.onLookupReturn.bind(this));
					this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
					this.unsubscribeRecordNextStore = _RecordsStore.RecordNextStore.listen(this.onRecordNext.bind(this));
					this.unsubscribeRecordPrevStore = _RecordsStore.RecordPrevStore.listen(this.onRecordPrev.bind(this));
					this.unsubscribeLookupDropDownCloseStore = _LookupStores.LookupDropDownCloseStore.listen(this.onLookupDropDownClose.bind(this));
					this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
	
					this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
	
					this.unsubscribeGlobalClickStore = _FocusStore.GlobalClickStore.listen(this.onGlobalClickHandler.bind(this));
				}
			}
		}, {
			key: 'isClickInisdeEditor',
			value: function isClickInisdeEditor(e) {
				var relatedTarget = this.getRelatedTarget(e);
				return this.inputgroup.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
			}
		}, {
			key: 'onGlobalClickHandler',
			value: function onGlobalClickHandler(e) {
				if ($(this.inputField).attr("contenteditable") == "false" && !this.isClickInisdeEditor(e)) this.props.onCommit({ key: 'Enter' });
			}
		}, {
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name) {
					if (type == "numKeyBoard") {
						this.setState({ dropDownNumKeyBoard: true });
					} else if (type == "normal") {
						this.setState({ dropDownNumKeyBoard: false });
					}
				}
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'onLookupReturn',
			value: function onLookupReturn(value, entityId, innerId) {
				if (this.props.formId == entityId && this.props.xml.id == innerId) {
					if (Array.isArray(value) == true) {
						value = this.doMutiFieldReturn(value);
						// UtilActions.updateDataGrid(this.props.formId,this.props.gridXml.id);
					} else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == "object") {
						value = this.doMutiFieldReturn1(value);
						// UtilActions.updateDataGrid(this.props.formId,this.props.gridXml.id);
					}
	
					var replace = this.props.returnLookup == "Replace";
					if (replace) {
						this.closeDropDown();
	
						this.onLookupReturning = true;
						$(this.inputField).val(value);
						this.inputField.focus();
						this.inputField.select();
						// UtilActions.updateDataGrid(this.props.formId,this.props.gridXml.id);
					} else {
						this.onLookupReturning = true;
						var $t = this.inputField;
						if ($t.selectionStart || $t.selectionStart == '0') {
							var startPos = $t.selectionStart;
							var endPos = $t.selectionEnd;
							var scrollTop = $t.scrollTop;
							$t.value = $t.value.substring(0, startPos) + value + $t.value.substring(endPos, $t.value.length);
							this.inputField.focus();
							$t.selectionStart = startPos + value.length;
							$t.selectionEnd = startPos + value.length;
							$t.scrollTop = scrollTop;
						} else {
							this.inputField.value += value;
							this.inputField.focus();
						}
						this.closeDropDown();
					}
	
					this.onLookupReturning = false;
	
					return false;
				}
			}
		}, {
			key: 'calculatorReturnHandler',
			value: function calculatorReturnHandler(result) {
				if (result && this.state.allowEdit) {
					$(this.inputField).val(result);
					$(this.inputField).focus();
					$(this.inputField).select();
				}
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.props.rowData) {
					this.setDisplay(newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				//super.componentWillUnmount();
				//alert("FormItemStringEditorForDataGrid 卸载");
				if (!this.props.forLookup) {
					this.unsubscribeLookupReturnStore();
					this.unsubscribeRecordFieldChangeStore();
					this.unsubscribeRecordNextStore();
					this.unsubscribeRecordPrevStore();
					this.unsubscribeLookupDropDownCloseStore();
					this.unsubscribeDsAllowEditStore();
					this.unsubscribeUpdateDropDownContenStore();
					this.unsubscribeGlobalClickStore();
					this.closeDropDown();
					var lookupdiv = this.lookupStates.dropdownform;
					if (lookupdiv) {
						_reactDom2.default.unmountComponentAtNode(lookupdiv.get(0));
						lookupdiv.remove();
					}
				}
			}
		}, {
			key: 'onLookupDropDownClose',
			value: function onLookupDropDownClose(formId, innerId) {
				if (this.props.formId == formId && this.props.xml.id == innerId) {
					this.closeDropDown();
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
	
				/*try {
	   	throw new Error();
	   } catch(e) {
	   	console.log("Print Stack: ", e.stack);
	   }*/
	
				var updated = {};
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				this.justCommit = true;
				var text = void 0;
				if (this.excelEditor) text = $(this.getInputNode()).text();else text = this.getInputNode().value;
				var _val = _FormItemStringResolver2.default.getResult(text, this.props.trim, this.props.changeCase, this.props.stringSize, this.props.regular);
				if (_val.indexOf(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG) == 0) {
					_Warn2.default.show({ text: _val.substr(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG.length) });
					return updated;
				}
	
				updated[this.props.column.key] = _val;
	
				if (this.props.value != updated[this.props.column.key]) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, this.props.value, null, null, { dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							var _oldValue = this.props.value;
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, _oldValue);
							var _newValue = void 0;
							if (this.excelEditor) {
								//TODO_YL  修改 modifiedfied 修改本身字段 不生效 
								_newValue = $(this.getInputNode()).text();
								if (this.props.rowData[this.props.dataField] != _oldValue && this.props.rowData[this.props.dataField] != _newValue) {
									_newValue = this.props.rowData[this.props.dataField];
								}
							} else {
								_newValue = this.getInputNode().value;
							}
	
							if (text != _newValue) updated[this.props.column.key] = _newValue;
						}
						if (!result) // && !this.props.control.isDataMethodField)
							{
								return {};
							}
					}
				}
				if (this.props.stringSize && this.props.stringSize > 0 && this.props.stringSize < updated[this.props.column.key].length) {
					_Warn2.default.show({ text: '所输入内容超出字段设定长度 ' + this.props.stringSize + " 请重新输入！！" });
					return {};
				}
				return updated;
			}
	
			//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
			//zsg 由于按Tab键导航会导致重复提交问题（同时出发pressTab和blur） 所以通过一个justCommit属性来判断是否刚刚提交过
			//下拉框是否销毁由项目编辑器决定
	
		}, {
			key: 'handleBlurCommit',
			value: function handleBlurCommit() {
				if (this.justCommit == true) {
					this.justCommit = false;return false;
				}
	
				if (this.lookupStates.isShowed) return false;
				return true;
			}
		}, {
			key: 'buttonDownClick',
			value: function buttonDownClick(e) {
				return _get(FormItemStringEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid.prototype), 'buttonDownClick', this).call(this, e);
	
				var droped = _get(FormItemStringEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid.prototype), 'buttonDownClick', this).call(this);
				if (droped) {
					_LookupActions2.default.renderCmp(this.props.gridId);
				}
				return droped;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
	
					/*if(this.props.hasInitialValue == true && _allowEdit == false && this.props.dataField && this.props.rowData)
	    {
	    	let _value = this.props.rowData[this.props.dataField];
	    	$(this.inputField).val(_value);
	    }*/
	
					this.doSetEnable(_allowEdit);
				}
	
				var copy = Object.assign({}, this.props.contextMenuData);
				if (copy.items) {
					for (var i = 0; i < copy.items.length; i++) {
						var item = copy.items[i];
						if (item && item.label == "过滤[Ctrl+T]") {
							item.action = this.queryFilter.bind(this);
							break;
						}
					}
					$(this.inputField).contextPopup(copy);
				} else {
					$(this.inputField).contextPopup(this.props.contextMenuData);
				}
				if (this.excelEditor == true) {
					try {
						if (window.getSelection) {
							var range = window.getSelection(); // 创建range
							range.selectAllChildren(this.inputField); // range 选择obj下所有子内容
							range.collapseToEnd(); // 光标移至最后
						}
					} catch (e) {}
				}
				this.initToolTip();
			}
		}, {
			key: 'checkDropDownHas',
			value: function checkDropDownHas() {
				_get(FormItemStringEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid.prototype), 'checkDropDownHas', this).call(this);
	
				if (this.state.dropDownNumKeyBoard) {
					var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
					if (nowAllowEdit) $(this.downArrowButton).show();
				}
			}
		}, {
			key: 'queryFilter',
			value: function queryFilter() {
				if (!this.props.group) return;
				var _dataField = this.props.dataField;
				if (_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField)) {
	
					var value = this.props.rowData[_dataField];
					this.props.group.queryFilter(_dataField, value);
				}
			}
		}, {
			key: 'buildExtralWhereItem',
			value: function buildExtralWhereItem(lookup) {
				if (this.props.groupAlias != "" && typeof lookup.setExtralWhereItemValueForRefresh == "function") {
					var filterField = this.props.filterField;
					if (filterField) {
						var alias = this.props.groupAlias;
						filterField = _StringUtil2.default.convertToFirstLowerCase(filterField);
						var _record = this.props.rowData;
						var _key = alias + "." + filterField;
						var spit = this.props.dataField.split(".");
						if (spit.length == 3) {
							_key = alias + "." + spit[1] + "." + filterField;
						}
						var filterfieldvalue = _record && _record.hasOwnProperty(_key) ? _record[_key] : null; //this.record[alias+"."+filterField];
						//TODO YL 修改 
						if (filterfieldvalue == undefined || filterfieldvalue == null) {
							filterfieldvalue = _record[alias + "." + filterField];
						}
						if (filterfieldvalue && filterfieldvalue != "") {
							lookup.setExtralWhereItemValueForRefresh(false, filterfieldvalue);
						} else {
							// lookup.setExtralWhereItemValueForRefresh(false,"#NULL_FILTER_FIELD#");
							lookup.setExtralWhereItemValueForRefresh(false, "");
						}
					}
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.downArrowButton).hide(); //css("display","none");
					$(this.inputField).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
					$(this.inputField).attr("readonly", "readonly");
					if (this.excelEditor == true) {
						this.excelEditorAllowEdit = false;
						$(this.inputField).attr("contenteditable", "false");
	
						/*if(!this.props.value)
	     {
	     	//$(this.inputField).css("height","33px");
	     	//alert(this.inputField.style.getPropertyValue("height"));
	     	//$(this.inputField).removeClass("stringEditorExcel").removeClass("stringEditorExcel2").addClass("stringEditorExcel3");
	     }*/
					} else {
						this.setState({ excelEditor: true });
					}
				} else if (nowAllowEdit == false && enable == true) {
					if (this.hasLookup) $(this.downArrowButton).show(); //css("display","block");
					$(this.inputField).css("backgroundColor", "#FFFFFF");
					$(this.inputField).removeAttr("readonly");
					if (this.excelEditor == true) {
						$(this.inputField).attr("contenteditable", "true");
						this.excelEditorAllowEdit = true;
					}
				}
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				_get(FormItemStringEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid.prototype), 'showDropDown', this).call(this);
			}
		}, {
			key: 'onKeyDownHandler2',
			value: function onKeyDownHandler2(e) {
	
				if (13 === e.keyCode) {
					e.stopPropagation();
					return;
				}
	
				_get(FormItemStringEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid.prototype), 'onKeyDownHandler', this).call(this, e);
			}
		}, {
			key: 'getInputNode',
			value: function getInputNode() {
				if (this.isMutiRow()) {
					var domNode = _reactDom2.default.findDOMNode(this);
					if (domNode.tagName === 'TEXTAREA') {
						return domNode;
					}
	
					return domNode.querySelector('textarea:not([type=hidden])');
				} else {
					var _domNode = _reactDom2.default.findDOMNode(this);
					if (_domNode.tagName === 'INPUT' || _domNode.tagName === 'TEXTAREA') {
						return _domNode;
					}
	
					return _domNode.querySelector('input:not([type=hidden])') || _domNode.querySelector('textarea:not([type=hidden])') || _domNode.querySelector('div.stringEditorExcel') || _domNode.querySelector('div.stringEditorExcel2');
				}
			}
		}, {
			key: 'isMutiRow',
			value: function isMutiRow() {
				var displayHeight = this.state.displayHeight;
				return displayHeight > 1;
			}
		}, {
			key: 'isLastColumn',
			value: function isLastColumn() {
				var arg = { key: this.props.column.key, gridId: this.props.gridXml.id, last: false };
				_UtilActions2.default.getDataGridColumnInfo(arg);
				return arg.last;
			}
		}, {
			key: 'onKeyDownHandler2',
			value: function onKeyDownHandler2(e) {
				if (this.excelEditorAllowEdit == false) {
					e.preventDefault();
					//e.stopPropagation();
					return;
				}
				if (9 === e.keyCode) {
					e.preventDefault();
					return true;
				}
	
				if (13 == e.keyCode) {
					/*TODO 这段不知道为什么加上了 暂时先去掉let formId = this.props.formId;
	    let gridId = this.props.gridXml.id;
	    FocusActions.focusSet(formId,gridId,false);*/
					return true;
				}
				//禁用ctrl+A
				if (e.ctrlKey && e.keyCode == 65) {
					e.stopPropagation();
					return true;
				}
				_get(FormItemStringEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorForDataGrid.prototype), 'onKeyDownHandler', this).call(this, e);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '2px', paddingRight: '13px', backgroundColor: '#ffffff', fontSize: "12px", cursor: 'text' };
				var _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
	
				var dropDownButton = null;
				this.checkDropDownHas();
				var _display = this.hasLookup ? "block" : "none";
				this.excelEditor = false;
				if (this.state.dropDownNumKeyBoard) {
					if (this.state.allowEdit) dropDownButton = _react2.default.createElement('i', { ref: function ref(node) {
							return _this2.downArrowButton = node;
						}, onMouseDown: this.showNumKeyBoard.bind(this), className: 'fa fa-keyboard-o',
						style: { display: _display, position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 11px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				} else {
					dropDownButton = _react2.default.createElement('i', { ref: function ref(node) {
							return _this2.downArrowButton = node;
						}, className: 'fa fa-sort-desc', onMouseDown: this.buttonDownClick.bind(this), style: { display: _display, position: 'absolute', top: 'calc(100% / 2 - 7px)', left: 'calc(100% - 11px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				}
	
				if (this.isMutiRow()) {
					return _react2.default.createElement(
						'div',
						{ className: 'input-group', ref: function ref(node) {
								return _this2.inputgroup = node;
							}, style: { width: '100%' } },
						_react2.default.createElement('textarea', { spellCheck: 'false', ref: function ref(node) {
								return _this2.inputField = node;
							}, className: 'form-control', style: _style, defaultValue: this.props.value, onKeyDown: this.onKeyDownHandler2.bind(this) }),
						dropDownButton
					);
				}
				if (_display == "none" || this.state.excelEditor == true) {
					//_style.height = "auto";
					this.excelEditor = true;_style.paddingRight = "2px";
					var _minWidth = Math.max(this.props.column.width, 20);
					_style.minWidth = _minWidth + "px";
					_style.minHeight = this.props.height + "px";
					/*_style.maxWidth = "300px";
	    if(this.props.value)
	    {
	    	let length = this.props.value.visualLength(_style.fontSize);
	    	let _columnWidth = this.props.column.width;
	    	if(length>(_columnWidth-25))
	    	{
	    		_style.width = (length+25)+"px";
	    	}
	    }*/
					var _className = "form-control stringEditorExcel";
					var isLastColumn = this.isLastColumn();
					if (isLastColumn) _className = "form-control stringEditorExcel2";
					var _contentEditable = "true";
					if (this.state.excelEditor == true) {
						_style.backgroundColor = _FormItemConst2.default.EDITOR_NOTEDIT_COLOR;_contentEditable = "false";
					}
	
					//TODO_Yl 如果存在换行 需要换行
					_style.whiteSpace = "pre-wrap";
					var _v = this.props.value;
	
					/*if(this.props.hasInitialValue == true && this.props.control)
	    {
	    	var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
	    			if(_allowEdit == false)
	    	{
	    		if(this.props.dataField && this.props.rowData)
	    		{
	    			let _value = this.props.rowData[this.props.dataField];
	    			_v = _value;
	    		}
	    	}
	    	else
	    	{
	    		_v = null;
	    	}
	    }*/
					return _react2.default.createElement(
						'div',
						{ className: 'input-group', ref: function ref(node) {
								return _this2.inputgroup = node;
							}, style: { width: "100%" } },
						_react2.default.createElement(
							'div',
							{ contentEditable: _contentEditable, spellCheck: 'false', ref: function ref(node) {
									return _this2.inputField = node;
								},
								type: 'text', className: _className, style: _style, defaultValue: _v, onKeyDown: this.onKeyDownHandler.bind(this) },
							_v
						),
						dropDownButton
					);
				} else {
					if (this.props.height) {
						_style.maxHeight = this.props.height - 2;
					}
					return _react2.default.createElement(
						'div',
						{ className: 'input-group', ref: function ref(node) {
								return _this2.inputgroup = node;
							}, style: { width: '100%' } },
						_react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
								return _this2.inputField = node;
							}, type: 'text', className: 'form-control', style: _style, defaultValue: this.props.value, onChange: this.textOnChange.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) }),
						dropDownButton
					);
				}
				//<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'0px',paddingBottom:'3px',paddingLeft:'6px',paddingRight:'6px'}} onMouseDown={this.buttonDownClick.bind(this)}><i className="fa fa-sort-desc"></i></span>
			}
		}]);
	
		return FormItemStringEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemStringEditor2.default));
	
	exports.default = FormItemStringEditorForDataGrid;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemTabPage = __webpack_require__(205);
	
	var _FormItemTabPage2 = _interopRequireDefault(_FormItemTabPage);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _ResizeStore = __webpack_require__(79);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _DomStores = __webpack_require__(145);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(322);
	
	var FormItemTab = function (_GongqiFormItem) {
		_inherits(FormItemTab, _GongqiFormItem);
	
		function FormItemTab(props) {
			_classCallCheck(this, FormItemTab);
	
			var _this = _possibleConstructorReturn(this, (FormItemTab.__proto__ || Object.getPrototypeOf(FormItemTab)).call(this, props));
	
			var index = _this.props.initSelectIndex ? _this.props.initSelectIndex : 0;
	
			_this.state = { indexes: [index], currentIndex: index, unVisiblePages: _this.props.unVisiblePages,
				visible: _this.props.controlVisible, hideInVisible: _this.props.hideInVisible };
			_this.unsubscribeVerticalSplitterStore = _ResizeStore.VerticalSplitterStore.listen(_this.onVerticalSplitterReisze.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			if (!_this.props.forLookup) _this.unsubscribeSwitchTabPageStore = _CmdTypeStore.SwitchTabPageStore.listen(_this.onSwitchTabPage.bind(_this));
			if (window.isPopUp || _this.props.forLookup) {
				_this.unsubscribePopUpDomReadySotre = _DomStores.PopUpDomReadySotre.listen(_this.onPopUpDomReady.bind(_this));
			}
			return _this;
		}
	
		_createClass(FormItemTab, [{
			key: 'onPopUpDomReady',
			value: function onPopUpDomReady() {
				//$(this.containerComponent).css("flex")
			}
		}, {
			key: 'onVerticalSplitterReisze',
			value: function onVerticalSplitterReisze(_id, addon) {
				if (_id != this.props.xml.id) return;
				this.pageHeight += addon;
				//this.setState({heightAddon:addon,heightAddonDiffer:addon+this.state.heightAddonDiffer});		
				this.forceUpdate();
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (this.props.moduleInstanceId != moduleInstanceId) return;
				var parent = this.props.xml;
				var children = parent.FormItem;
				var has = false;
				for (var i in children) {
					var child = children[i];
					if (child.name == name) {
						has = true;
						break;
					}
				}
				if (!has) return;
				this.forceUpdate();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (!this.props.forLookup) {
					this.unsubscribeSwitchTabPageStore();
				}
				this.unsubscribeVerticalSplitterStore();
				this.unsubscribeCmdUpdateControlLabelStore();
				if (typeof this.unsubscribePopUpDomReadySotre == "function") this.unsubscribePopUpDomReadySotre();
			}
		}, {
			key: 'onSwitchTabPage',
			value: function onSwitchTabPage(arg) {
				if (arg.tabName == this.props.xml.name && this.props.moduleInstanceId == arg.moduleInstanceId) {
					var parent = this.props.xml;
					var children = parent.FormItem;
					var _intIndex = parseInt(arg.newIndex);
	
					if (_intIndex < 0 || _intIndex >= children.length) {
						alert("switchTabPage 未能传入有效的标签页索引");
						return;
					}
	
					var _newState = { indexes: this.state.indexes, currentIndex: _intIndex };
					if (this.state.currentIndex != _intIndex) {
						this.pageChanged = true;
					}
					if (_newState.indexes.indexOf(_intIndex) == -1) {
						_newState.indexes.push(_intIndex);
						_newState.renderNewPage = true;
					} else {
	
						var lis = $(this.containerComponent).find(">ul>li").removeClass("active");
						if (lis[_newState.currentIndex]) $(lis[_newState.currentIndex]).addClass("active");
	
						_newState.renderNewPage = false;
					}
					this.setState(_newState);
					arg.complete = true;
				}
			}
		}, {
			key: 'tabpageOnclick',
			value: function tabpageOnclick(event) {
				//console.log(event);
	
				/*let pageId = $(event.target).attr("href");
	   
	   let selector = ".tab-content .tab-pane";
	   $(selector).hide();
	   selector = ".tab-content "+pageId;
	   $(selector).css('display','flex');*/
				var _index = $(event.target).attr("data-index");
				var _intIndex = parseInt(_index);
	
				var _newState = { indexes: this.state.indexes, currentIndex: _intIndex };
				if (this.state.currentIndex != _intIndex) {
					this.pageChanged = true;
				}
				if (_newState.indexes.indexOf(_intIndex) == -1) {
					_newState.renderNewPage = true;
					_newState.indexes.push(_intIndex);
				} else {
					_newState.renderNewPage = false;
				}
	
				this.userClickChange = true;
				this.setState(_newState);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.pageChanged == true) {
					this.pageChanged = false;
					var tabPageXML = this.props.xml.FormItem[this.state.currentIndex];
					//let tabPageName = this.props.xml.FormItem[this.state.currentIndex].name;
					if (this.props.control) this.props.control.tabPageChanged(tabPageXML);
				}
				/*
	   if(this.userClickChange == true)
	   {
	   	this.userClickChange = false;
	   	UtilActions.tabpageUserChanged();
	   }*/
	
				if (this.props.forLookup) {
					//alert("计算width");
					if (!this.pageWidth) this.pageWidth = 0;
					var _pageWidth = this.tabContent.offsetWidth;
					if (_pageWidth > this.pageWidth) {
						this.pageWidth = _pageWidth;
					}
	
					$(this.tabContent).css("width", this.pageWidth + "px");
					this.props.control.module.updatePosition();
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				if (this.props.forLookup) $(this.tabContent).css("width", "");
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return true;
				var pages = $(this.tabContent).find(">.FormItemTabPage");
				if (nextState.renderNewPage) {
					//TODO 此处 如果不把现有的都设置为none 则react不会去更新旧的TabPage的样式 不知道为什么
					for (var i = 0; i < pages.length; i++) {
						var page = pages[i];
						$(page).css("display", "none");
					}
					return true;
				}
	
				if (nextState.unVisiblePages) {
					var lis = $(this.tabLabels).find(">li");
					var nowUnVisiblePagesJson = JSON.stringify(this.state.unVisiblePages);
					var nextUnVisiblePagesJson = JSON.stringify(nextState.unVisiblePages);
					if (nowUnVisiblePagesJson != nextUnVisiblePagesJson) {
						for (var _i = 0; _i < nextState.unVisiblePages.length; _i++) {
							var _index = nextState.unVisiblePages[_i];
							if (_index < lis.length) {
								$(lis[_index]).css("display", "none");
							}
						}
					}
				}
	
				//let pages = $(this.tabContent).find(">.FormItemTabPage");
				for (var _i2 = 0; _i2 < pages.length; _i2++) {
					var _page = pages[_i2];
					var dataIndex = $(_page).attr("data-index");
					dataIndex = parseInt(dataIndex);
					if (dataIndex == nextState.currentIndex)
						//if(i == nextState.currentIndex)
						{
							$(_page).css("display", "flex");
						} else {
						$(_page).css("display", "none");
					}
				}
	
				if (nextState.currentIndex == this.state.currentIndex) return false;
	
				if (this.pageChanged == true) {
					this.pageChanged = false;
					var tabPageXML = this.props.xml.FormItem[nextState.currentIndex];
					//let tabPageName = this.props.xml.FormItem[nextState.currentIndex].name;
					if (this.props.control) {
						var control = this.props.control;
						var _timeoutId = setTimeout(function () {
	
							clearTimeout(_timeoutId);
							control.tabPageChanged(tabPageXML);
						}, 200);
					}
				}
				if (this.props.forLookup) {
					//alert("计算width");
					if (!this.pageWidth) this.pageWidth = 0;
					var _pageWidth = this.tabContent.offsetWidth;
					if (_pageWidth > this.pageWidth) {
						this.pageWidth = _pageWidth;
					}
	
					$(this.tabContent).css("width", this.pageWidth + "px");
					this.props.control.module.updatePosition();
				}
	
				//this.state = nextState;
	
				return false;
			}
		}, {
			key: 'getTabPages',
			value: function getTabPages() {
				var result = { pages: [], contents: [] };
				var parent = this.props.xml;
				var children = parent.FormItem;
				var layout = parent.Properties.Layout.Value;
				var index = 0;
				var unVisiblePages = this.state.unVisiblePages;
				for (var i in children) {
					var current = index == this.state.currentIndex;
					var _className = current ? "active" : "";
					var _visible = unVisiblePages.indexOf(index) != -1 ? false : current;
	
					//index>0?false:true;
					var child = children[i];
					var tabPageControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, child.id), this.props.forLookup);
					var childLabel = tabPageControl._cmdLabel ? tabPageControl._cmdLabel : tabPageControl.getProperty_Label(); //child.name;
					var pageName = "#" + child.id;
					// let pageStyle = {textAlign: 'center',cursor: 'pointer',boxSizing: 'content-box',position:'relative',margin:'0px',paddingTop:'2px',border: 'none',borderBottom: '1px solid rgb(204,204,204)'};
					var pageStyle = { textAlign: 'center', cursor: 'pointer', boxSizing: 'content-box', position: 'relative', margin: '0px', paddingTop: '2px', border: 'none' };
					if (unVisiblePages.indexOf(index) != -1) {
						pageStyle.display = "none";
						_className = "no-active-" + _visible;
					}
	
					result.pages.push(_react2.default.createElement(
						'li',
						{ 'data-index': i, className: _className, style: pageStyle, onClick: this.tabpageOnclick.bind(this), key: "li" + child.id },
						_react2.default.createElement(
							'a',
							{ href: pageName, className: 'gongqi_tabpage', 'data-index': i, 'data-toggle': 'tab', 'aria-expanded': 'true', style: { background: 'transparent' } },
							childLabel
						)
					));
	
					if (this.state.indexes.indexOf(index) != -1) {
						/*if(!this.pageHeight)
	     {
	     	if(this.refs["page"+this.state.currentIndex])
	     		this.pageHeight = $(this.refs["page"+this.state.currentIndex].getPageDiv()).height();
	     }heightFromTab={this.pageHeight-3}*/
						result.contents.push(_react2.default.createElement(_FormItemTabPage2.default, { xmlChildIndex: i, control: tabPageControl, menuItemId: this.props.menuItemId, formId: this.props.formId, ref: "page" + index, visible: _visible, key: child.id, xml: child, parentLayout: layout, forLookup: this.props.forLookup, contextMenuData: this.props.contextMenuData }));
					}
					index++;
				}
				return result;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				//console.log(this.refs["page"+this.state.currentIndex].getPageDiv());
				//TODO 当画面存在radio时候 datagrid自动计算高度 由于Tabpage存在height导致计算不准确    故 先去掉
				// 之前为什么加上 已经遗忘
				if (!this.pageHeight) {
					setTimeout(this.laterSetFixedPageHeight.bind(this), 100);
				}
				//alert(this.pageHeight);
			}
		}, {
			key: 'laterSetFixedPageHeight',
			value: function laterSetFixedPageHeight() {
				//TODO 当画面存在radio时候 datagrid自动计算高度 由于Tabpage存在height导致计算不准确    故 先去掉
				// 之前为什么加上 已经遗忘
				// this.pageHeight = this.tabContent.offsetHeight;
				// if(this.props.forLookup)
				// {
				// 	if(this.pageHeight && this.pageHeight>0)
				// 		$(this.tabContent).css("height",this.pageHeight+"px");
				// }
				// else
				// {
				// 	$(this.tabContent).css("height",this.pageHeight+"px");
				// }
	
				if (this.props.forLookup) {
					//alert("计算width");
					if (!this.pageWidth) this.pageWidth = 0;
					var _pageWidth = this.tabContent.offsetWidth;
					if (_pageWidth > this.pageWidth) {
						this.pageWidth = _pageWidth;
						$(this.tabContent).css("width", this.pageWidth + "px");
					}
				}
	
				//alert("初始pageHeight"+this.pageHeight);
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				//对于Tab本身没有任何布局 所以只关心父级布局情况
				var parentLayout = this.props.parentLayout;
				//本身固定布局为flex 纵向 因为要布局下面的标签选项卡与内容区域 内容区域填充剩余空间
				var style = {
					display: 'flex',
					flexDirection: 'column'
				};
	
				//如果设置了Width或者Height属性 则按照属性设置 否则为百分百 与Flex版框架保持一致	   
				//但是存在其余控件包含tab而设置成百分百的情况 此情况在Flex版框架中也没有考虑 但是在实际
				//使用过程中并未提出此问题 所以暂不考虑
	
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.props.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					var flexGrow = 0;
					var fixedWidth = false;
					if (_width == "") {
						flexGrow = 100;
					} else {
						var iex = _width.indexOf("%");
						if (iex != -1) {
							flexGrow = _width.substring(0, iex);
						}
	
						if (iex == -1 && _width != "") {
							flexGrow = _width + "px";
							fixedWidth = true;
						}
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;
	
					var _height = this.props.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
					if (_height == "") _height = "100%";
					if (_height == "100%" && !window.isPopUp && !window.isLookup) style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.props.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 0;
						var fixedHeight = false;
						if (_height2 == "") {
							_flexGrow = 100;
						} else {
							var _iex = _height2.indexOf("%");
							if (_iex != -1) {
								_flexGrow = _height2.substring(0, _iex);
							}
							if (_iex == -1 && _height2 != "") {
								_flexGrow = _height2 + "px";
								fixedHeight = true;
							}
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;
	
						var _width2 = this.props.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "") _width2 = "100%";
						if (_width2 == "100%" && !window.isPopUp && !window.isLookup) style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
	
				return style;
			}
		}, {
			key: 'onCmdUpdateControlVisible',
			value: function onCmdUpdateControlVisible(menuItemId, formId, names, isLookup) {
				//return;
				if (this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId && this.props.formId == formId) {
	
					if (names.indexOf(this.props.xml.name) != -1) {
						var finalVisible = this.props.control.getProperty_Visible_Final();
						this.setState({ visible: finalVisible });
					}
					var parent = this.props.xml;
					var children = parent.FormItem;
					var unVisiblePages = this.state.unVisiblePages.concat();
					var deal = false;
					for (var i = 0; i < children.length; i++) {
						var child = children[i];
						//只更改可见性经过二次开发命令设置过的
						if (names.indexOf(child.name) != -1) {
							deal = true;
							var tabPageControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, child.id), this.props.forLookup);
							var _visible = tabPageControl.getProperty_Visible_Final();
							if (!_visible && unVisiblePages.indexOf(i) == -1) {
								unVisiblePages.push(i);
							} else if (_visible) {
								var index = unVisiblePages.indexOf(i);
								if (index != -1) unVisiblePages.splice(index, 1);
							}
						}
					}
					if (!deal) return;
					var currentIndex = this.state.currentIndex;
					var currentIndexBak = currentIndex;
					while (unVisiblePages.indexOf(currentIndex) != -1) {
						currentIndex++;
						if (currentIndex > children.length - 1) {
							currentIndex = 0;
						}
						if (currentIndex == currentIndexBak) {
							break;
							/*alert("GOT设置或二次开发逻辑导致无可显示的TabPage");
	      this.setState({unVisiblePages:unVisiblePages});
	      return;*/
						}
					}
					var indexes = this.state.indexes;
					var renderNewPage = false;
					if (indexes.indexOf(currentIndex) == -1) {
						indexes.push(currentIndex);renderNewPage = true;
					}
					this.state.unVisiblePages = unVisiblePages;
					this.setState({ unVisiblePages: unVisiblePages,
						currentIndex: currentIndex, indexes: indexes,
						renderNewPage: renderNewPage
					});
					this.forceUpdate();
				}
			}
	
			//对于tab-content来讲 子节点只有单一显示的tabpane 为了解决chrome浏览器在某一父节点没有采用百分比而子节点
			//设置height为百分比不起作用的问题 所以tab-content采用flex布局 并且子节点全部延伸
	
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				_style["marginBottom"] = 0;
				var _content = this.getTabPages();
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
	
				var _contentStyle = { display: 'flex', alignItems: 'stretch', flexGrow: 100, border: 'solid 1px #ccc', borderTop: 'none' };
				if (this.pageHeight) _contentStyle.height = this.pageHeight + 'px';
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, 'data-xmlid': this.props.xml.id, className: 'FormItemTab nav-tabs-custom', ref: function ref(node) {
							return _this2.containerComponent = node;
						}, style: _style },
					_react2.default.createElement(
						'ul',
						{ className: 'nav nav-tabs', ref: function ref(node) {
								return _this2.tabLabels = node;
							}, style: { marginBottom: '0px', display: 'flex' } },
						_content.pages,
						_react2.default.createElement('div', { style: { flexGrow: '1', borderBottom: '1px solid rgb(205,205,205)' } })
					),
					_react2.default.createElement(
						'div',
						{ className: 'tab-content', ref: function ref(node) {
								return _this2.tabContent = node;
							}, style: _contentStyle },
						_content.contents
					)
				);
			}
		}]);
	
		return FormItemTab;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemTab.defaultProps = {};
	
	exports.default = FormItemTab;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormModuleLookup = __webpack_require__(54);
	
	var _FormModuleLookup2 = _interopRequireDefault(_FormModuleLookup);
	
	var _FormItemTimeEditor = __webpack_require__(96);
	
	var _FormItemTimeEditor2 = _interopRequireDefault(_FormItemTimeEditor);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FormItemTimeResolver = __webpack_require__(61);
	
	var _FormItemTimeResolver2 = _interopRequireDefault(_FormItemTimeResolver);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTimeEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemTimeEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemTimeEditorForDataGrid() {
			_classCallCheck(this, FormItemTimeEditorForDataGrid);
	
			return _possibleConstructorReturn(this, (FormItemTimeEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemTimeEditorForDataGrid)).apply(this, arguments));
		}
	
		_createClass(FormItemTimeEditorForDataGrid, [{
			key: 'initStores',
			value: function initStores() {
				this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
				this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeDsAllowEditStore();
				this.closeDropDown();
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
				var updated = {};
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				this.justCommit = true;
				var text = this.getInputNode().value;
				var _val = _FormItemTimeResolver2.default.getResult(text, false);
				if (_val.indexOf("false:") == 0) {
					alert(_val.substr(6));
					_val = this.props.value;
				}
	
				updated[this.props.column.key] = _val;
	
				if (this.props.value != updated[this.props.column.key]) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, this.props.value, null, null, { dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							var _oldValue = this.props.value;
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, _oldValue);
						}
	
						if (!result) {
							return {};
						}
					}
				}
				return updated;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
					this.doSetEnable(_allowEdit);
				}
	
				if (this.props.contextMenuData) $(this.inputField).contextPopup(this.props.contextMenuData);
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.inputField).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
					$(this.inputField).attr("readonly", "readonly");
					$(this.downArrowButton).css("display", "none");
				} else if (nowAllowEdit == false && enable == true) {
					$(this.inputField).css("backgroundColor", "#FFFFFF");
					$(this.inputField).removeAttr("readonly");
					$(this.downArrowButton).css("display", "block");
				}
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this2 = this;
	
				if (this.state.allowEdit) {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this2.downArrowButton = node;
						}, onClick: this.showDropDown.bind(this), className: 'fa fa-clock-o', style: { position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				} else {
					return _react2.default.createElement('i', { ref: function ref(node) {
							return _this2.downArrowButton = node;
						}, className: 'fa fa-clock-o', style: { position: 'absolute', top: 'calc(100% / 2 - 5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } });
				}
			}
		}, {
			key: 'handleBlurCommit',
			value: function handleBlurCommit() {
				if (this.justCommit == true) {
					this.justCommit = false;return false;
				}
				if (this.dropDownShowed) return false;
				return true;
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				//禁用ctrl+A
				if (e.ctrlKey && e.keyCode == 65) {
					e.stopPropagation();
					return true;
				}
				_get(FormItemTimeEditorForDataGrid.prototype.__proto__ || Object.getPrototypeOf(FormItemTimeEditorForDataGrid.prototype), 'onKeyDownHandler', this).call(this, e);
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				if (this.dropDownShowed == true) {
					this.closeDropDown();
					return;
				}
				var $dropdown = this.getDropDownHtml();
				$('body').append($dropdown);
				this.dropdownform = $dropdown;
				var lookupdiv = $dropdown;
	
				if (this.inputField.defaultValue && typeof this.inputField.defaultValue == "string") {
					var nowVal = this.inputField.defaultValue;
					var hourLis = $(".dateTimeWrap #selHour>ol>li");
					var minuteList = $(".dateTimeWrap #selMinute>ol>li");
					var secondsList = $(".dateTimeWrap #selSecond>ol>li");
					var _arr = nowVal.split(":");
					var nowHour = _arr[0];var nowMinute = _arr[1];var nowSecond = _arr[2];
					for (var i = 0; i < hourLis.length; i++) {
						var item = hourLis[i];
						if ($(item).html() == nowHour) {
							hourLis.removeClass("cur");
							$(item).addClass("cur");
							$(item).parent().scrollTop($(item).offset().top - $(item).height());
							break;
						}
					}
	
					for (var k = 0; k < minuteList.length; k++) {
						var _item = minuteList[k];
						if ($(_item).html() == nowMinute) {
							minuteList.removeClass("cur");
							$(_item).addClass("cur");
							$(_item).parent().scrollTop($(_item).offset().top - $(_item).height());
							break;
						}
					}
					for (var _k = 0; _k < secondsList.length; _k++) {
						var _item2 = secondsList[_k];
						if ($(_item2).html() == nowSecond) {
							secondsList.removeClass("cur");
							$(_item2).addClass("cur");
							$(_item2).parent().scrollTop($(_item2).offset().top - $(_item2).height());
							break;
						}
					}
				}
	
				var _inputwidth = $(this.inputField).width(); //this.props.displayLengthWidth;
				var _iframewidth = lookupdiv.outerWidth();
	
				var _iframeheight = lookupdiv.outerHeight();
	
				var _gwidth = $("#app").width();
				var _gheight = $("#app").height();
	
				if (_iframewidth > _gwidth) {
					_iframewidth = _gwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				}
				var _offset = $(this.inputField).offset();
				var _y = _offset.top;
				var _x = _offset.left;
				var _top = _y + $(this.inputField).height() + 8;
				//alert('x:'+_x+'y:'+_y);
				//下方屏幕放不下
				if (_top + _iframeheight > _gheight) {
					//上下都放不下 考虑缩减高度
					if (_iframeheight > _y) {
						//上方空间大
						if (_y > _gheight / 2) {
							lookupdiv.height(_y - 2);
							_top = '0px';
						} else //下方空间大
							{
								lookupdiv.css("height", _gheight - _top + 'px');
							}
					} else //下拉框置于上方
						{
							_top = _y - _iframeheight + 'px';
						}
				}
				var _left = _x - (_iframewidth - _inputwidth) / 2;
				//(_iframewidth-_inputwidth)/2;
				if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 5;
				if (_left < 0) _left = 0;
	
				lookupdiv.css({ left: _left + 'px', top: _top });
				this.dropDownShowed = true;
				this.attachEventListeners();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '2px 13px 2px 2px', width: '100%', backgroundColor: '#ffffff', fontSize: "12px", cursor: 'text' };
				var _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				if (this.props.height) {
					_style.maxHeight = this.props.height - 2;
				}
				var dropdown = this.getDownArrowButtonDom();
	
				var _v = this.props.value;
				/*if(this.props.hasInitialValue == true && this.props.control)
	   {
	   	var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
	   			if(_allowEdit == false)
	   	{
	   		if(this.props.column && this.props.column.key)
	   		{
	   			let _value = this.props.rowData[this.props.column.key];
	   			_v = _value;
	   		}
	   	}
	   }*/
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.inputFieldContainer = node;
						} },
					_react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
							return _this3.inputField = node;
						}, id: "input" + this.props.xml.id, type: 'text',
						className: 'form-control', style: _style, defaultValue: _v }),
					dropdown
				);
			}
		}]);
	
		return FormItemTimeEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemTimeEditor2.default));
	
	exports.default = FormItemTimeEditorForDataGrid;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _UtilStores = __webpack_require__(80);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _CommandStore = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(154);
	
	var FormItemBooleanRender = function (_FormItemEditorRender) {
		_inherits(FormItemBooleanRender, _FormItemEditorRender);
	
		function FormItemBooleanRender(props) {
			_classCallCheck(this, FormItemBooleanRender);
	
			var _this2 = _possibleConstructorReturn(this, (FormItemBooleanRender.__proto__ || Object.getPrototypeOf(FormItemBooleanRender)).call(this, props));
	
			if (_this2.props.isSelectedRecords) {
				_this2.unsubscribeSelectAllRecordsStore = _CommandStore.SelectAllRecordsStore.listen(_this2.onSelectAllRecords.bind(_this2));
	
				_this2.unsubscribeSelectRecordsStore2 = _CommandStore.SelectRecordsStore2.listen(_this2.onSelectRecords2.bind(_this2));
	
				_this2.unsubscribeReverseSelectRecordsStore = _CommandStore.ReverseSelectRecordsStore.listen(_this2.onReverseSelectRecords.bind(_this2));
			}
	
			_this2.unsubscribeUtilStores = _UtilStores.KeyDownHelperStore.listen(_this2.onKeyDownHandler.bind(_this2));
			_this2.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(_this2.onDsAllowEditStore.bind(_this2));
			//Q21096256this.unsubscirbeGroupCurrentRecordChangedNotGridUserOpStore = GroupCurrentRecordChangedNotGridUserOpStore.listen(this.test.bind(this));
			return _this2;
		}
	
		_createClass(FormItemBooleanRender, [{
			key: 'test',
			value: function test(groupAlias) {
				if (groupAlias == this.props.groupAlias) {
					this.forceUpdate();
				}
			}
		}, {
			key: 'onReverseSelectRecords',
			value: function onReverseSelectRecords(groupAlias) {
				if (groupAlias == this.props.groupAlias) {
					this.onlyUpdateUIChecked = true;
	
					this.componentDidUpdate();
				}
			}
		}, {
			key: 'onSelectRecords2',
			value: function onSelectRecords2(value, groupAlias, moduleInstanceId, records) {
				if (groupAlias == this.props.groupAlias) {
					if (records.indexOf(this.props.rowData) == -1) return;
					this.onlyUpdateUIChecked = true;
					if (value) $(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
				}
			}
		}, {
			key: 'onSelectAllRecords',
			value: function onSelectAllRecords(value, groupAlias, moduleInstanceId) {
				if (groupAlias == this.props.groupAlias) {
					this.onlyUpdateUIChecked = true;
					if (value) $(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
				}
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					this.forceUpdate();
					//let finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					//this.doSetEnable(finalValue);	
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_get(FormItemBooleanRender.prototype.__proto__ || Object.getPrototypeOf(FormItemBooleanRender.prototype), 'componentWillUnmount', this).call(this);
				if (this.props.isSelectedRecords) {
					this.unsubscribeSelectAllRecordsStore();
				}
				this.unsubscribeUtilStores();
			}
		}, {
			key: 'restoreValue',
			value: function restoreValue(oldValue) {
				var boolvalue = false;
				if (typeof oldValue == "boolean") boolvalue = oldValue;else if (oldValue == "true" || oldValue == "1") boolvalue = true;
				this.stopChangedOnce = true;
				this.props.rowData[this.props.dataField] = boolvalue;
				var _this = this;
				setTimeout(function (e) {
					if (boolvalue) $(_this.inputField).iCheck("check");else $(_this.inputField).iCheck("uncheck");
				}, 500);
			}
		}, {
			key: 'checkChangeHandler',
			value: function checkChangeHandler(value) {
				if (this.stopChangedOnce == true) {
					this.stopChangedOnce = false;
					return;
				}
				//alert(JSON.stringify(this.props.rowData));
	
				//alert("changed");
				var changed = false;
				if (this.props.dataField != undefined && this.props.dataField != null) {
					var checked = value;
					var origChecked = this.props.rowData[this.props.dataField];
					if (checked != origChecked) changed = true;
					/*if(this.props.rowData != this.props.group.currentRecord)
	    {
	    		}*/
					//alert("checkbox赋值");
					//存在直接点击DataGrid中的booleanRender换行的情况 如果使用onClick 则先更改 再换行触发当前记录变化
					//这会造成currentRecordBak未更改从而再换行时没有自动保存 而使用onChange事件 则先换行 再执行更改
					//感觉自动保存等需求会使得程序存在很大风险 
					this.props.rowData[this.props.dataField] = checked;
				}
	
				if (changed) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.dataField, origChecked, checked, this);
					if (this.props.control) {
						var result = this.props.control.doFieldModifiedRemote(this.props.column.key, checked, origChecked, this.props.rowData, this);
						if (!result) {
							return {};
						}
					}
				}
	
				//alert("dataField changed");
				this.stopPropagation();
				//console.log(this.props.rowData);
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (record == this.props.rowData) {
					//alert(this.props.dataField + "   " + dataField);
					if (this.props.dataField == dataField) {
						//let boolvalue = (newValue == "true" || newValue || newValue == "1");
						//if(boolvalue)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
						this.forceUpdate();
					}
				}
			}
			//TODO先去掉 当时为什么加上原因未知
	
		}, {
			key: 'stopPropagation',
			value: function stopPropagation(e) {
				return;
				e = e || window.event;
				if (e.stopPropagation) {
					//W3C阻止冒泡方法  
					e.stopPropagation();
				} else {
					e.cancelBubble = true; //IE阻止冒泡方法  
				}
			}
		}, {
			key: 'checkboxDiveClick',
			value: function checkboxDiveClick(e) {
				//if(e && !$(e.target).hasClass("gongqi_render_select"))
				//Q21096256this.clickOnDisable = true;//记录在不可用的情况下被点击 随后将由于本次点击触发render方法
				return;
				var checkboxTemp = void 0;
				var x = this.inputField.checked;
				if (x == false) {
					checkboxTemp = true;
				} else {
					checkboxTemp = false;
				}
	
				if (checkboxTemp == true) {
					this.checkChangeHandler(true, 2);
				} else {
					this.checkChangeHandler(false, 2);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemBooleanRender.prototype.__proto__ || Object.getPrototypeOf(FormItemBooleanRender.prototype), 'componentDidMount', this).call(this);
				$(this.inputField).iCheck({
					checkboxClass: this.props.big ? 'icheckbox_minimal-blue28' : 'icheckbox_minimal-blue14',
					downFocus: true
				});
	
				var _value = this.props.value;
				//let boolvalue = (_value == "true" || _value || _value == "1");
				var boolvalue = false;
				if (typeof _value == "boolean") boolvalue = _value;else if (_value == "true" || _value == "1") boolvalue = true;
				if (boolvalue) $(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
				$(this.inputField).on('ifChecked', this.checkChangeHandler.bind(this, true));
				$(this.inputField).on('ifUnchecked', this.checkChangeHandler.bind(this, false));
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				var _value = this.props.rowData[this.props.dataField];
				//let boolvalue = (_value == "true" || _value || _value == "1");
				var boolvalue = false;
				if (typeof _value == "boolean") boolvalue = _value;else if (_value == "true" || _value == "1") boolvalue = true;
				if (boolvalue) $(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
	
				/*Q21096256if(this.renderAllowEdit == true)
	   {
	   	if(this.disableToAllowEdit == true)
	   	{
	   		this.disableToAllowEdit = false;
	   		if(boolvalue)$(this.inputField).iCheck("uncheck");else $(this.inputField).iCheck("check");	
	   	}
	   			$(this.componentLabel).find(this.props.big?'.icheckbox_minimal-blue28':'.icheckbox_minimal-blue14').removeClass("disabled");
	   }*/
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e, arg) {
				if (!e) return;
				if (e.keyCode != 32) return;
				if ($(this.inputField).attr("disabled") == "disabled") return;
				if ($(e.target).hasClass("react-grid-Cell row-selected")) {
					var cellContainer = $(this.componentLabel).parent().parent().parent();
					if (cellContainer.length > 0) {
						cellContainer = cellContainer[0];
						if (cellContainer == e.target) {
							if ($(this.inputField).is(":checked")) {
								$(this.inputField).iCheck("uncheck");
							} else {
								$(this.inputField).iCheck("check");
							}
						}
					}
				}
			}
		}, {
			key: 'onMouseDown',
			value: function onMouseDown() {
				$(this.inputField).focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _allowEdit = true;var _display = "none";var _style = { textAlign: 'center', margin: '0px' };
	
				if (!this.props.isSelectedRecords) {
					var _key = _FormItemUtil2.default.getFormItemControlKey(this.props.menuItemId, this.props.formId, this.props.colXml.id);
					var control = _FormItemUtil2.default.getFormItemControl(_key, this.props.forLookup);
					_allowEdit = control.getProperty_AllowEdit_Final(this.props.rowData, this.props.group.afterRecordConditionTask);
					if (this.props.forLookup) _display = "none";else {
						// if(this.props.rowData && this.props.group)
						// {
						// 	let dsAlias = this.props.group.groupAlias;
						// 	let recVerKey = dsAlias+'.recVersion';
						// 	let recVer = this.props.rowData[recVerKey];
						// 	if(recVer && typeof(recVer) == "number")
						// 	{
						// 		if(recVer > -1)
						// 			_display = "none";
						// 	}
						// }
						// if(!_display)
						_display = this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
					}
					if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
					var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
					if (clientStyle) {
						_style = Object.assign(_style, clientStyle);
					}
	
					var rowStyles = this.getRowStyles();
	
					if (rowStyles) {
						for (var i = 0; i < rowStyles.length; i++) {
							var rowStyle = rowStyles[i];
							var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
							if (bool) {
								if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color); //rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
								if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor); //rowStyle.backgroundColor.toString(16);
								if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
								if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
								if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
							}
						}
					}
	
					var colStyles = this.getEditorStyles();
					if (colStyles) {
						for (var _i = 0; _i < colStyles.length; _i++) {
							var colStyle = colStyles[_i];
							var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
							if (_bool) {
								if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color); //colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
								if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor); //colStyle.backgroundColor.toString(16);
								if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
								if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
								if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
							}
						}
					}
				}
				var _clsName = "dataGridrender gongqi_render_select gongqi_render_boolean gongqi_render_" + this.props.colXml.name;
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (_display == "block") _clsName += " gongqi_render_version0";
				/*Q21096256this.renderAllowEdit = _allowEdit;
	   if(this.clickOnDisable == true)
	   {
	   	this.clickOnDisable = false;
	   	
	   	if(this.renderAllowEdit == true)
	   	{
	   		this.disableToAllowEdit = true;
	   	}
	   }*/
	
				if (_allowEdit) {
					return _react2.default.createElement(
						'div',
						{ className: _clsName, style: _style, ref: function ref(node) {
								return _this3.componentLabel = node;
							}, onMouseDown: this.onMouseDown.bind(this), render: 'true' },
						_react2.default.createElement('input', { type: 'checkbox', ref: function ref(node) {
								return _this3.inputField = node;
							}, className: 'minimal' }),
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this3.modifiedTag = node;
							}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: _clsName + " disabled", style: _style, ref: function ref(node) {
								return _this3.componentLabel = node;
							},
							onMouseDown: this.onMouseDown.bind(this), onClick: this.checkboxDiveClick.bind(this), render: 'true' },
						_react2.default.createElement('input', { type: 'checkbox', disabled: true, ref: function ref(node) {
								return _this3.inputField = node;
							}, className: 'minimal' }),
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this3.modifiedTag = node;
							}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
					);
				}
			}
		}]);
	
		return FormItemBooleanRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemBooleanRender;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemStringRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemStringRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemStringRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemStringRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemStringRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemStringRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemStringRenderForAutoLookup, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				if (_value == true || _value == false) {
					_value = _value + "";
				}
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					_value
				);
			}
		}]);
	
		return FormItemStringRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemStringRenderForAutoLookup;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormItemDateResolver = __webpack_require__(55);
	
	var _FormItemDateResolver2 = _interopRequireDefault(_FormItemDateResolver);
	
	var _FormItemTimeResolver = __webpack_require__(61);
	
	var _FormItemTimeResolver2 = _interopRequireDefault(_FormItemTimeResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormItemDateTimeResolver = function () {
	    function FormItemDateTimeResolver() {
	        _classCallCheck(this, FormItemDateTimeResolver);
	    }
	
	    _createClass(FormItemDateTimeResolver, null, [{
	        key: 'getResult',
	        value: function getResult() {
	            var dateInput = arguments[0];
	            if (!dateInput) return "";
	
	            var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
	            var regExp = new RegExp(reg);
	            if (regExp.test(dateInput)) {
	                return dateInput;
	            }
	
	            var length = dateInput.length;
	
	            if (length > 6) {
	                var dateStr = void 0;var timeStr = void 0;
	                if (length > 12 && length < 18) {
	                    dateStr = dateInput.substr(0, 8);
	                    timeStr = dateInput.substring(8);
	                } else if (length <= 12) {
	                    dateStr = dateInput.substr(0, 6);
	                    timeStr = dateInput.substring(6);
	                } else {
	                    dateStr = dateInput.substr(0, 10);
	                    timeStr = dateInput.substring(10);
	                }
	                var dateResult = _FormItemDateResolver2.default.getResult(dateStr);
	                if (dateResult.indexOf("false:") == 0) return dateResult;
	                var timeResult = _FormItemTimeResolver2.default.getResult(timeStr);
	                if (timeResult.indexOf("false:") == 0) return timeResult;
	                return dateResult + " " + timeResult;
	            } else {
	                return _FormItemDateResolver2.default.getResult(dateInput);
	            }
	        }
	    }]);
	
	    return FormItemDateTimeResolver;
	}();
	
	exports.default = FormItemDateTimeResolver;

/***/ },
/* 140 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSourceGroupArg = //int
	//String
	//ArrayList
	//Object
	function FormDataSourceGroupArg() {
		_classCallCheck(this, FormDataSourceGroupArg);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.datasource.FormDataSourceGroupArg";
	} //int
	;
	
	exports.default = FormDataSourceGroupArg;

/***/ },
/* 141 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryOrderByType = function () {
		function QueryOrderByType() {
			_classCallCheck(this, QueryOrderByType);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryOrderByType";
		}
	
		_createClass(QueryOrderByType, null, [{
			key: "valueOf",
			value: function valueOf(value) {
				if (value == "ASC") return QueryOrderByType.ASC;else if (value == "DESC") return QueryOrderByType.DESC;
	
				throw new Error("枚举类型错误");
			}
		}]);
	
		return QueryOrderByType;
	}();
	
	QueryOrderByType.ASC = "ASC";
	QueryOrderByType.DESC = "DESC";
	exports.default = QueryOrderByType;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryWhereLeftBracket = __webpack_require__(56);
	
	var _QueryWhereLeftBracket2 = _interopRequireDefault(_QueryWhereLeftBracket);
	
	var _QueryWhereRightBracket = __webpack_require__(57);
	
	var _QueryWhereRightBracket2 = _interopRequireDefault(_QueryWhereRightBracket);
	
	var _QueryWhereAndOr = __webpack_require__(144);
	
	var _QueryWhereAndOr2 = _interopRequireDefault(_QueryWhereAndOr);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryTable = function () {
		function QueryTable() {
			_classCallCheck(this, QueryTable);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryTable";
		}
	
		_createClass(QueryTable, null, [{
			key: 'getSqlWhereStr',
			//ArrayCollection 	//QueryRelationItem
			//ArrayCollection	//QueryOrderByItem
			//ArrayCollection	//QueryWhereItem
			//ArrayCollection	//QueryGroupByItem
			//ArrayCollection	//QueryAggregationItem
			//ArrayCollection		//QueryTable
	
			//String
			//String
			//String
	
			//Boolean
			//String
	
			//String		//QueryRelationJoinMode
			//String			//QueryRelation1N
	
			//QueryTable
			//Boolean
	
			value: function getSqlWhereStr() {
				if (this._sqlWhereStr != null) return this._sqlWhereStr;
				var result = "";
				var leftBracket = _QueryWhereLeftBracket2.default.None;
				var rightBracket = _QueryWhereRightBracket2.default.None;
				for (var i = 0; i < this.queryWhere.length; i++) {
					var item = this.queryWhere[i];
					if (i > 0) {
						item.andOr = _QueryWhereAndOr2.default.And;
						result += " " + _QueryWhereAndOr2.default.labelOf(item.andOr);
					}
	
					if (item.leftBracket != _QueryWhereLeftBracket2.default.None) item.leftBracket = _QueryWhereLeftBracket2.default.None;
	
					if (item.leftBracket != _QueryWhereLeftBracket2.default.None) {
						result += " " + _QueryWhereLeftBracket2.default.labelOf(item.leftBracket);
						leftBracket += item.leftBracket;
					}
	
					if (typeof item.fieldValue == "boolean") {
						item.fieldValue = item.fieldValue + "";
					}
	
					if (item.fieldValue == null) item.fieldValue = "";
	
					if (item.fieldValue && item.fieldValue.indexOf && item.fieldValue.indexOf(",") != -1) var fieldValues = item.fieldValue.split(",");else fieldValues = [item.fieldValue];
	
					if (fieldValues.length > 1) result += " (";
	
					for (var j = 0; j < fieldValues.length; j++) {
						var _fv = fieldValues[j];
	
						if (j > 0) {
							result += " or " + item.fieldName + "=" + "\"" + _fv + "\"";
						} else {
							result += " " + item.fieldName + "=" + "\"" + _fv + "\"";
						}
	
						/*if(j > 0)
	     {
	     	result += (" or " + item.fieldName+"="+StringUtil.trimThrough(_fv));	
	     }
	     else
	     {
	     	result += (" "+item.fieldName+"="+StringUtil.trimThrough(_fv));
	     }*/
						j++;
					}
	
					if (fieldValues.length > 1) result += " )";
	
					if (item.rightBracket != _QueryWhereRightBracket2.default.None) item.rightBracket = _QueryWhereRightBracket2.default.None;
	
					if (item.rightBracket != _QueryWhereRightBracket2.default.None) {
						result += " " + _QueryWhereRightBracket2.default.labelOf(item.rightBracket);
						rightBracket += item.rightBracket;
					}
				}
	
				if (leftBracket != rightBracket) {
					//GongqiAlert.show("括号不匹配");
					return "";
				}
	
				this._sqlWhereStr = result;
				return result;
			}
		}]);
	
		return QueryTable;
	}();
	
	exports.default = QueryTable;

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryTableStatus = function () {
		function QueryTableStatus() {
			_classCallCheck(this, QueryTableStatus);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryTableStatus";
		}
	
		_createClass(QueryTableStatus, null, [{
			key: "valueOf",
			value: function valueOf(value) {
				if (value == QueryTableStatus.OPENLABEL || value == "") return QueryTableStatus.Open;else if (value == QueryTableStatus.LOCKLABEL) return QueryTableStatus.Lock;else if (value == QueryTableStatus.HIDELABEL) return QueryTableStatus.Hide;
	
				throw new Error("错误的枚举类型");
			}
		}, {
			key: "getLabel",
			value: function getLabel(value) {
				if (value == QueryTableStatus.Open) return QueryTableStatus.OPENLABEL;else if (value == QueryTableStatus.Lock) return QueryTableStatus.LOCKLABEL;else if (value == QueryTableStatus.Hide) return QueryTableStatus.HIDELABEL;
	
				throw new Error("错误的枚举类型");
			}
		}]);
	
		return QueryTableStatus;
	}();
	
	QueryTableStatus.Open = "Open";
	QueryTableStatus.Lock = "Lock";
	QueryTableStatus.Hide = "Hide";
	QueryTableStatus.OPENLABEL = "Open";
	QueryTableStatus.LOCKLABEL = "Lock";
	QueryTableStatus.HIDELABEL = "Hide";
	exports.default = QueryTableStatus;

/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryWhereAndOr = function () {
		function QueryWhereAndOr() {
			_classCallCheck(this, QueryWhereAndOr);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryWhereAndOr";
		}
	
		_createClass(QueryWhereAndOr, null, [{
			key: "labelOf",
			value: function labelOf(value) {
				if (value == "And") return "And";else if (value == "Or") return "Or";
	
				throw new Error("枚举错误");
			}
		}, {
			key: "valueOf",
			value: function valueOf(value) {
				if (value == "And") return "And";else if (value == "Or") return "Or";
	
				throw new Error("枚举错误");
			}
		}]);
	
		return QueryWhereAndOr;
	}();
	
	QueryWhereAndOr.And = "And";
	QueryWhereAndOr.Or = "Or";
	exports.default = QueryWhereAndOr;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LookupBeforeCloseStore = exports.PopUpDomReadySotre = exports.DomReadyStore = undefined;
	
	var _DomActions = __webpack_require__(86);
	
	var _DomActions2 = _interopRequireDefault(_DomActions);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DomReadyStore = exports.DomReadyStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_DomActions2.default.domReady, 'onDomReady');
		},
		onDomReady: function onDomReady() {
			this.trigger();
		}
	});
	
	var PopUpDomReadySotre = exports.PopUpDomReadySotre = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_DomActions2.default.popUpDomReady, 'onPopUpDomReady');
		},
		onPopUpDomReady: function onPopUpDomReady() {
			this.trigger();
		}
	});
	
	var LookupBeforeCloseStore = exports.LookupBeforeCloseStore = _reflux2.default.createStore({
	
		init: function init() {
			this.listenTo(_DomActions2.default.lookupBeforeClose, 'onLookupBeforeClose');
		},
		onLookupBeforeClose: function onLookupBeforeClose(entityId, innerId) {
			this.trigger(entityId, innerId);
		}
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UserSetTreeLabelChangedStore = exports.UserSetFormTreeChangedStore = undefined;
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _UserSetActions = __webpack_require__(90);
	
	var _UserSetActions2 = _interopRequireDefault(_UserSetActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserSetFormTreeChangedStore = exports.UserSetFormTreeChangedStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_UserSetActions2.default.userSetFormTreeChanged, 'onUserSetFormTreeChanged');
		},
		onUserSetFormTreeChanged: function onUserSetFormTreeChanged(properties) {
			this.trigger(properties);
		}
	});
	
	var UserSetTreeLabelChangedStore = exports.UserSetTreeLabelChangedStore = _reflux2.default.createStore({
		init: function init() {
			this.listenTo(_UserSetActions2.default.treeLabelChanged, 'onUserSetTreeLabelChanged');
		},
		onUserSetTreeLabelChanged: function onUserSetTreeLabelChanged(label) {
			this.trigger(label);
		}
	});

/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GOT = function () {
		function GOT() {
			_classCallCheck(this, GOT);
		}
	
		_createClass(GOT, null, [{
			key: "getForm",
			value: function getForm(formId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var forms = got.DataDictionary.Forms;
					for (var i in forms) {
						var form = forms[i];
						if (form.id == formId || form.name == formId) return form;
					}
				}
				return null;
			}
		}, {
			key: "setForm",
			value: function setForm(form) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var forms = got.DataDictionary.Forms;
					if (forms == null)
						//_parentWindow.setFirstForm(form);
						got.DataDictionary["Forms"] = [form];else forms.push(form);
				}
				return null;
			}
		}, {
			key: "deleteForm",
			value: function deleteForm(_id) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var forms = got.DataDictionary.Forms;
					if (forms) {
						for (var i = 0; i < forms.length; i++) {
							var form = forms[i];
							if (form.id == _id) {
								forms.splice(i, 1);
							}
						}
					}
				}
			}
		}, {
			key: "getTable",
			value: function getTable(tableId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var tables = got.DataDictionary.Tables;
					for (var i in tables) {
						var table = tables[i];
						if (table.id == tableId || table.name == tableId) return table;
					}
				}
				return null;
			}
		}, {
			key: "getTableField",
			value: function getTableField(table, fieldId) {
				for (var i in table.TableFields) {
					var tableField = table.TableFields[i];
					if (tableField.id == fieldId || tableField.name == fieldId) return tableField;
				}
				return null;
			}
		}, {
			key: "getTableFieldComponentItems",
			value: function getTableFieldComponentItems(tableField) {
				var extendPro = tableField.Properties.Extends;
				if (extendPro.hasOwnProperty("refentityid")) {
					var refentityid = extendPro.refentityid;
					var compDataType = GOT.getDataType(refentityid);
					return compDataType.DataTypeArrayItem;
				}
				return null;
			}
		}, {
			key: "getTableIndex",
			value: function getTableIndex(table, innerid) {
				for (var i in table.TableIndexes) {
					var tableIndex = table.TableIndexes[i];
					if (tableIndex.id == innerid || tableIndex.name == innerid) return tableIndex;
				}
				return null;
			}
		}, {
			key: "getAutoTableFieldGroup",
			value: function getAutoTableFieldGroup(table) {
				var tableFieldGroups = table.TableFieldGroups.FieldGroups;
				for (var i in tableFieldGroups) {
					var tableFieldGroup = tableFieldGroups[i];
					if (tableFieldGroup.name == "AutoLookup") {
						return tableFieldGroup;
					}
				}
				return null;
			}
		}, {
			key: "getEnum",
			value: function getEnum(enumId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var enums = got.DataDictionary.Enums;
					for (var i in enums) {
						var enumItem = enums[i];
						if (enumItem.id == enumId) return enumItem;
					}
				}
				return null;
			}
		}, {
			key: "getDataType",
			value: function getDataType(dataTypeId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var dataTypes = got.DataDictionary.DataTypes;
					for (var i in dataTypes) {
						var dataType = dataTypes[i];
						if (dataType.id == dataTypeId || dataType.name == dataTypeId) return dataType;
					}
				}
				return null;
			}
		}, {
			key: "getMenuItem",
			value: function getMenuItem(menuItemId) {
				var _parentWindow; //window.parent.window;
	
				_parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var menuItems = got.MenuItems;
					for (var i in menuItems) {
						var menuItem = menuItems[i];
						if (menuItem.id == menuItemId) return menuItem;
					}
				}
				return null;
			}
		}, {
			key: "getMenu",
			value: function getMenu(menuId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					var got = _parentWindow.got;
					if (!got) {
						var _pparentWindow = _parentWindow.parent.window;
						got = _pparentWindow.got;
					}
					var menus = got.DataDictionary.Menus;
					for (var i in menus) {
						var menu = menus[i];
						if (menu.id == menuId || menu.name == menuId) return menu;
					}
				}
				return null;
			}
		}, {
			key: "getDataTypeArrayItem",
			value: function getDataTypeArrayItem(dataType, id) {
				for (var i in dataType.DataTypeArrayItems) {
					var dataTypeArrayItem = dataType.DataTypeArrayItems[i];
					if (dataTypeArrayItem.id == id || dataTypeArrayItem.name == id) return dataTypeArrayItem;
				}
				return null;
			}
		}, {
			key: "getFormDataSource",
			value: function getFormDataSource(form, innerid) {
				for (var i in form.FormDataSources.DataSources) {
					var formDataSource = form.FormDataSources.DataSources[i];
					if (formDataSource.id == innerid || formDataSource.name == innerid) return formDataSource;
				}
				return null;
			}
		}, {
			key: "getFormDataSourceField",
			value: function getFormDataSourceField(formDataSource, innerid) {
				var exname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
				for (var i in formDataSource.FormDataSourceFields) {
					var formDataSourceField = formDataSource.FormDataSourceFields[i];
					if (formDataSourceField.id == innerid || formDataSourceField.name == innerid) {
						return formDataSourceField;
					} else if (exname) {
						if (formDataSourceField.id == exname || formDataSourceField.name == exname) return formDataSourceField;
					}
				}
				return null;
			}
		}, {
			key: "getFormDataSourceFieldByName",
			value: function getFormDataSourceFieldByName(form, dataSource, dataSourceField) {
				var dss = form.FormDataSources.DataSources;
				for (var i = 0; i < dss.length; i++) {
					var ds = dss[i];
					if (ds.name == dataSource) break;
				}
	
				if (ds) {
					return GOT.getFormDataSourceField(ds, dataSourceField);
				}
			}
		}, {
			key: "getTableFieldGroup",
			value: function getTableFieldGroup(table, id) {
				var fieldGroups = table.TableFieldGroups.FieldGroups;
				for (var i in fieldGroups) {
					var fieldGroup = fieldGroups[i];
					if (fieldGroup.id == id || fieldGroup.name == id) return fieldGroup;
				}
				return null;
			}
		}, {
			key: "getTableIndex",
			value: function getTableIndex(table, id) {
				var indexes = table.TableIndexes.Indexes;
				for (var i in indexes) {
					var tableIndex = indexes[i];
					if (tableIndex.id == id || tableIndex.name == id) return tableIndex;
				}
				return null;
			}
		}, {
			key: "getDataTypeRelationNormalItem",
			value: function getDataTypeRelationNormalItem(dataTypeRelation) {
				for (var i in dataTypeRelation.DataTypeRelationItems) {
					var dataTypeRelationItem = dataTypeRelation.DataTypeRelationItems[i];
					if (dataTypeRelationItem.type == "Normal") return dataTypeRelationItem;
				}
				return null;
			}
		}, {
			key: "getDataTypeRelationFixedItem",
			value: function getDataTypeRelationFixedItem(dataTypeRelation) {
				var fixedItems = [];
				for (var i in dataTypeRelation.DataTypeRelationItems) {
					var dataTypeRelationItem = dataTypeRelation.DataTypeRelationItems[i];
					if (dataTypeRelationItem.type == "Fixed") fixedItem.push(dataTypeRelationItem);
				}
				return fixedItems;
			}
		}, {
			key: "getFormItem",
			value: function getFormItem(form, id) {
				var formItems = form.FormDesign.FormItem;
				for (var i in formItems) {
					var item = formItems[i];
					if (item.id == id || item.name == id) return item;
					var result = GOT.getFormItemByFormItem(item, id);
					if (result != null) return result;
				}
				return null;
			}
		}, {
			key: "getFormItemByFormItem",
			value: function getFormItemByFormItem(formItem, id) {
				for (var i in formItem.FormItem) {
					var item = formItem.FormItem[i];
					if (item.id == id || item.name == id) return item;
					var result = GOT.getFormItemByFormItem(item, id);
					if (result != null) return result;
				}
				return null;
			}
		}, {
			key: "descendantsFormItemJsonType",
			value: function descendantsFormItemJsonType(jo, type, result) {
				if (!result) result = [];
				if (jo.type && jo.type.indexOf(type) != -1) {
					result.push(jo);
				} else if (jo.FormItem) {
					for (var i = 0; i < jo.FormItem.length; i++) {
						var item = jo.FormItem[i];
						GOT.descendantsJson(item, type, result);
					}
				}
			}
		}, {
			key: "descendantsJson",
			value: function descendantsJson(jo, qname, result) {
				if (!result) result = [];
				if (jo.qname == qname) {
					result.push(jo);
				} else if (jo.items) {
					for (var i = 0; i < jo.items.length; i++) {
						var item = jo.items[i];
						GOT.descendantsJson(item, qname, result);
					}
				}
			}
		}, {
			key: "getMainMenuMenuItemById",
			value: function getMainMenuMenuItemById(mainMenu, id) {
				if (mainMenu.qname == "MenuItem" && mainMenu.id == id) return mainMenu;
				if (mainMenu.items) {
					for (var i = 0; i < mainMenu.items.length; i++) {
						var item = mainMenu.items[i];
						var result = GOT.getMainMenuMenuItemById(item, id);
						if (result) return result;
					}
				}
				return null;
			}
		}]);
	
		return GOT;
	}();
	
	GOT.INDEP_FORM_ID = "60000000";
	exports.default = GOT;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CommandArgGroupInfoFuncUtil = __webpack_require__(283);
	
	var _CommandArgGroupInfoFuncUtil2 = _interopRequireDefault(_CommandArgGroupInfoFuncUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandArgFuncUtil = function () {
	    function CommandArgFuncUtil() {
	        _classCallCheck(this, CommandArgFuncUtil);
	    }
	
	    _createClass(CommandArgFuncUtil, null, [{
	        key: 'bindCommandArgFunc',
	        value: function bindCommandArgFunc(commandArg) {
	            commandArg.getEditorValue = CommandArgFuncUtil.getEditorValue.bind(commandArg);
	            commandArg.getGroupInfo = CommandArgFuncUtil.getGroupInfo.bind(commandArg);
	            commandArg.getCurrentRecord = CommandArgFuncUtil.getCurrentRecord.bind(commandArg);
	            commandArg.getJoinGroupRecord = CommandArgFuncUtil.getJoinGroupRecord.bind(commandArg);
	            commandArg.getSelectedRecords = CommandArgFuncUtil.getSelectedRecords.bind(commandArg);
	            commandArg.getAllRecords = CommandArgFuncUtil.getAllRecords.bind(commandArg);
	            commandArg.getAllMaps = CommandArgFuncUtil.getAllMaps.bind(commandArg);
	            commandArg.getSelectedMaps = CommandArgFuncUtil.getSelectedMaps.bind(commandArg);
	            commandArg.getCurrentMap = CommandArgFuncUtil.getCurrentMap.bind(commandArg);
	            commandArg.getCurrentQuery = CommandArgFuncUtil.getCurrentQuery.bind(commandArg);
	            commandArg.getFormQuery = CommandArgFuncUtil.getFormQuery.bind(commandArg);
	            commandArg.getDialogFieldValue = CommandArgFuncUtil.getDialogFieldValue.bind(commandArg);
	            for (var key in commandArg.mapGroups) {
	                var argInfo = commandArg.mapGroups[key];
	                if (argInfo) {
	                    argInfo.getCurrentRecord = _CommandArgGroupInfoFuncUtil2.default.getCurrentRecord.bind(argInfo);
	                    argInfo.getCurrentMap = _CommandArgGroupInfoFuncUtil2.default.getCurrentMap.bind(argInfo);
	                    argInfo.getSelectedRecordsByCurrentRecord = _CommandArgGroupInfoFuncUtil2.default.getSelectedRecordsByCurrentRecord.bind(argInfo);
	                    argInfo.getSelectedMapsByCurrentRecord = _CommandArgGroupInfoFuncUtil2.default.getSelectedMapsByCurrentRecord.bind(argInfo);
	                    argInfo.getSelectedRecords = _CommandArgGroupInfoFuncUtil2.default.getSelectedRecords.bind(argInfo);
	                    argInfo.getAllRecords = _CommandArgGroupInfoFuncUtil2.default.getAllRecords.bind(argInfo);
	
	                    argInfo.getAllMaps = _CommandArgGroupInfoFuncUtil2.default.getAllMaps.bind(argInfo);
	                    argInfo.getCurrentQuery = _CommandArgGroupInfoFuncUtil2.default.getCurrentQuery.bind(argInfo);
	                    argInfo.getFormQuery = _CommandArgGroupInfoFuncUtil2.default.getFormQuery.bind(argInfo);
	                }
	            }
	
	            if (commandArg.joinGroup) {
	                var _argInfo = commandArg.joinGroup;
	                _argInfo.getCurrentRecord = _CommandArgGroupInfoFuncUtil2.default.getCurrentRecord.bind(_argInfo);
	                _argInfo.getCurrentMap = _CommandArgGroupInfoFuncUtil2.default.getCurrentMap.bind(_argInfo);
	                _argInfo.getSelectedRecordsByCurrentRecord = _CommandArgGroupInfoFuncUtil2.default.getSelectedRecordsByCurrentRecord.bind(_argInfo);
	                _argInfo.getSelectedMapsByCurrentRecord = _CommandArgGroupInfoFuncUtil2.default.getSelectedMapsByCurrentRecord.bind(_argInfo);
	                _argInfo.getSelectedRecords = _CommandArgGroupInfoFuncUtil2.default.getSelectedRecords.bind(_argInfo);
	                _argInfo.getAllRecords = _CommandArgGroupInfoFuncUtil2.default.getAllRecords.bind(_argInfo);
	
	                _argInfo.getAllMaps = _CommandArgGroupInfoFuncUtil2.default.getAllMaps.bind(_argInfo);
	                _argInfo.getCurrentQuery = _CommandArgGroupInfoFuncUtil2.default.getCurrentQuery.bind(_argInfo);
	                _argInfo.getFormQuery = _CommandArgGroupInfoFuncUtil2.default.getFormQuery.bind(_argInfo);
	            }
	        }
	    }, {
	        key: 'getEditorValue',
	        value: function getEditorValue(controlName) {
	            if (!this.mapEditors) return null;
	            if (!controlName) return null;
	            if (!this.mapEditors.hasOwnProperty(controlName)) {
	                return null;
	            }
	            var value = this.mapEditors[controlName];
	            return value;
	        }
	    }, {
	        key: 'getGroupInfo',
	        value: function getGroupInfo(groupAlias) {
	            if (!this.mapGroups) return null;
	            if (groupAlias) {
	                return this.mapGroups[groupAlias];
	            }
	            if (this.defaultGroupAlias) {
	                return this.mapGroups[this.defaultGroupAlias];
	            }
	            for (var key in this.mapGroups) {
	                return this.mapGroups[key];
	            }
	            return null;
	        }
	    }, {
	        key: 'getCurrentRecord',
	        value: function getCurrentRecord() {
	            var gi = this.getGroupInfo();
	            if (!gi) return null;
	            return gi.getCurrentRecord();
	        }
	    }, {
	        key: 'getJoinGroupRecord',
	        value: function getJoinGroupRecord() {
	            if (!this.joinGroup) return null;
	            return this.joinGroup.getCurrentRecord();
	        }
	    }, {
	        key: 'getSelectedRecords',
	        value: function getSelectedRecords() {
	            var gi = this.getGroupInfo();
	            if (!gi) return [];
	            return gi.getSelectedRecords();
	        }
	    }, {
	        key: 'getAllRecords',
	        value: function getAllRecords() {
	            var gi = this.getGroupInfo();
	            if (!gi) return [];
	            return gi.getAllRecords();
	        }
	    }, {
	        key: 'getAllMaps',
	        value: function getAllMaps() {
	            var gi = this.getGroupInfo();
	            if (!gi) return [];
	            return gi.getAllMaps();
	        }
	    }, {
	        key: 'getSelectedMaps',
	        value: function getSelectedMaps() {
	            var gi = this.getGroupInfo();
	            if (!gi) return [];
	            return gi.getSelectedMaps();
	        }
	    }, {
	        key: 'getCurrentMap',
	        value: function getCurrentMap() {
	            var gi = this.getGroupInfo();
	            if (!gi) return null;
	            return gi.getCurrentMap();
	        }
	    }, {
	        key: 'getCurrentQuery',
	        value: function getCurrentQuery() {
	            var gi = this.getGroupInfo();
	            if (!gi) return null;
	            return gi.getCurrentQuery();
	        }
	    }, {
	        key: 'getFormQuery',
	        value: function getFormQuery() {
	            var gi = this.getGroupInfo();
	            if (!gi) return null;
	            return gi.getFormQuery();
	        }
	    }, {
	        key: 'getDialogFieldValue',
	        value: function getDialogFieldValue(dialogFieldId) {
	            if (!this.argObject) return null;
	            if (!dialogFieldId) return null;
	            return this.argObject[dialogFieldId];
	        }
	    }]);
	
	    return CommandArgFuncUtil;
	}();
	
	exports.default = CommandArgFuncUtil;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _FormItemDateRenderForAutoLookup = __webpack_require__(238);
	
	var _FormItemDateRenderForAutoLookup2 = _interopRequireDefault(_FormItemDateRenderForAutoLookup);
	
	var _FormItemDateTimeRenderForAutoLookup = __webpack_require__(240);
	
	var _FormItemDateTimeRenderForAutoLookup2 = _interopRequireDefault(_FormItemDateTimeRenderForAutoLookup);
	
	var _FormItemTimeRenderForAutoLookup = __webpack_require__(249);
	
	var _FormItemTimeRenderForAutoLookup2 = _interopRequireDefault(_FormItemTimeRenderForAutoLookup);
	
	var _FormItemLongRenderForAutoLookup = __webpack_require__(246);
	
	var _FormItemLongRenderForAutoLookup2 = _interopRequireDefault(_FormItemLongRenderForAutoLookup);
	
	var _FormItemDecimalRenderForAutoLookup = __webpack_require__(242);
	
	var _FormItemDecimalRenderForAutoLookup2 = _interopRequireDefault(_FormItemDecimalRenderForAutoLookup);
	
	var _FormItemEnumRenderForAutoLookup = __webpack_require__(244);
	
	var _FormItemEnumRenderForAutoLookup2 = _interopRequireDefault(_FormItemEnumRenderForAutoLookup);
	
	var _FormItemBooleanRenderForAutoLookup = __webpack_require__(236);
	
	var _FormItemBooleanRenderForAutoLookup2 = _interopRequireDefault(_FormItemBooleanRenderForAutoLookup);
	
	var _FormItemStringRenderForAutoLookup = __webpack_require__(138);
	
	var _FormItemStringRenderForAutoLookup2 = _interopRequireDefault(_FormItemStringRenderForAutoLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var React = __webpack_require__(1);
	
	var FormLookupRenderFactory = function () {
		function FormLookupRenderFactory() {
			_classCallCheck(this, FormLookupRenderFactory);
		}
	
		_createClass(FormLookupRenderFactory, null, [{
			key: 'getLookupRender',
			value: function getLookupRender(type, dataField, entityId, innerId) {
				var entity = _GOTUtil2.default.getEntityXML(entityId);
				var item = void 0;
				if (type == "Date") {
					item = _GOTUtil2.default.getItemXML(entityId, innerId);
					/*let numOfDay = GOTUtil.getFinalValue(item,entity,"NumOfDay");
	    let numOfMonth = GOTUtil.getFinalValue(item,entity,"NumOfMonth");
	    let show1970 = true;//GOTUtil.getFinalValue(item,entity,"Show1970");
	    let numOfYear = GOTUtil.getFinalValue(item,entity,"NumOfYear");*/
					var seperator = _GOTUtil2.default.getFinalValue(item, entity, "Seperator");
	
					/*if(!numOfDay)numOfDay = 2;
	    if(!numOfMonth)numOfMonth = 2;
	    if(!numOfYear)numOfYear = 4;*/
	
					return React.createElement(_FormItemDateRenderForAutoLookup2.default, { dataField: dataField, numOfDay: 2, numOfMonth: 2, show1970: true,
						numOfYear: 4, seperator: seperator });
				} else if (type == "Time") {
					item = _GOTUtil2.default.getItemXML(entityId, innerId);
					/*let showHour = GOTUtil.getFinalValue(item,entity,"ShowHour");
	    let showMinute = GOTUtil.getFinalValue(item,entity,"ShowMinute");
	    let showSecond = GOTUtil.getFinalValue(item,entity,"ShowSecond");*/
					return React.createElement(_FormItemTimeRenderForAutoLookup2.default, { dataField: dataField, showHour: true, showMinute: true, showSecond: true });
				} else if (type == "DateTime") {
					return React.createElement(_FormItemDateTimeRenderForAutoLookup2.default, { dataField: dataField });
				} else if (type == "Long") {
					item = _GOTUtil2.default.getItemXML(entityId, innerId);
					var showZero = _GOTUtil2.default.getFinalValue(item, entity, "ShowZero");
					var thousandSeperator = _GOTUtil2.default.getFinalValue(item, "ThousandSeperator");
					return React.createElement(_FormItemLongRenderForAutoLookup2.default, { dataField: dataField, showZero: showZero, thousandSeperator: thousandSeperator });
				} else if (type == "Decimal") {
					item = _GOTUtil2.default.getItemXML(entityId, innerId);
					var _showZero = _GOTUtil2.default.getFinalValue(item, entity, "ShowZero");
					var showDecimals = _GOTUtil2.default.getFinalValue(item, entity, "ShowDecimals");
					if (typeof showDecimals == "string" && !showDecimals) showDecimals = 2;
					var _thousandSeperator = _GOTUtil2.default.getFinalValue(item, entity, "ThousandSeperator");
					return React.createElement(_FormItemDecimalRenderForAutoLookup2.default, { dataField: dataField, showZero: _showZero, showDecimals: showDecimals, thousandSeperator: _thousandSeperator });
				} else if (type == "String") {
					return React.createElement(_FormItemStringRenderForAutoLookup2.default, { dataField: dataField });
				} else if (type == "Boolean") {
					return React.createElement(_FormItemBooleanRenderForAutoLookup2.default, { dataField: dataField });
				} else if (type == "Enum") {
					item = _GOTUtil2.default.getItemXML(entityId, innerId);
					var dataProvider = _GOTUtil2.default.getDataSourceByTableField(item); //GOTUtil.getFinalValue(item,entity,"DataProvider");
	
					return React.createElement(_FormItemEnumRenderForAutoLookup2.default, { options: dataProvider, dataField: dataField });
				}
			}
		}]);
	
		return FormLookupRenderFactory;
	}();
	
	exports.default = FormLookupRenderFactory;

/***/ },
/* 150 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegularHelper = function () {
		function RegularHelper() {
			_classCallCheck(this, RegularHelper);
		}
	
		_createClass(RegularHelper, null, [{
			key: "castStringPatternToRegularPattern",
			value: function castStringPatternToRegularPattern(str) {
				var reg;
	
				if (str.indexOf("*") != 0) {
					reg = "^" + str;
				} else {
					reg = str;
				}
	
				if (str.lastIndexOf("*") != str.length - 1 && str.lastIndexOf("?") != str.length - 1) {
					reg += "$";
				}
	
				reg = reg.replace(/\*/g, ".*");
				//reg = reg.replace("*",".*");
				reg = reg.replace(/\?/g, ".{0,1}");
	
				return reg;
			}
		}, {
			key: "setThounsandSeperator",
			value: function setThounsandSeperator(chars) {
				var sptor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
	
				var result = "";
				var reverseChar = chars.reverse();
				var i = 1;
				for (var k in reverseChar) {
					var c = reverseChar[k];
					if (c == "-") {
						result = c + result;
						continue;
					}
	
					result = c + result;
	
					if (i % 3 == 0 && i != reverseChar.length) result = sptor + result;
					i++;
				}
	
				if (result.charAt(0) == "-" && result.charAt(1) == sptor) result = result.substr(0, 1) + result.substr(2);
	
				return result;
			}
		}]);
	
		return RegularHelper;
	}();
	
	exports.default = RegularHelper;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _WebSocketManager = __webpack_require__(109);
	
	var _WebSocketManager2 = _interopRequireDefault(_WebSocketManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gongqi_ProgressBar = function (_React$Component) {
		_inherits(Gongqi_ProgressBar, _React$Component);
	
		_createClass(Gongqi_ProgressBar, null, [{
			key: 'show',
			value: function show(body) {
				var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				if (body.modal == "modalGlobal" || body.modal == "modalNone") {
					Gongqi_ProgressBar.parentDiv = document.getElementById("gongqi_globalProgress");
					return _reactDom2.default.render(_react2.default.createElement(Gongqi_ProgressBar, { body: body }), Gongqi_ProgressBar.parentDiv);
				} else if (body.modal == "modalSelf") {
	
					if (win) {
						Gongqi_ProgressBar.parentDiv = win.document.getElementById("gongqi_globalProgress");
						return _reactDom2.default.render(_react2.default.createElement(Gongqi_ProgressBar, { body: body }), Gongqi_ProgressBar.parentDiv);
					}
	
					var popIframes = $("#formModal iframe");
					if (popIframes.length > 0) {
						iframe = popIframes.get(popIframes.length - 1);
						var _win = void 0;
						try {
							_win = iframe.window || iframe.contentWindow;
						} catch (e) {}
						if (_win) {
							Gongqi_ProgressBar.parentDiv = _win.document.getElementById("gongqi_globalProgress");
							return _reactDom2.default.render(_react2.default.createElement(Gongqi_ProgressBar, { body: body }), Gongqi_ProgressBar.parentDiv);
						}
					} else {
						var arr = $("#g_tab_content>div.tab-pane.active iframe");
						if (arr.length > 0) {
							var iframe = arr.get(0);
							var _win2 = void 0;
							try {
								_win2 = iframe.window || iframe.contentWindow;
							} catch (e) {}
							if (_win2) {
								Gongqi_ProgressBar.parentDiv = _win2.document.getElementById("gongqi_globalProgress");
								return _reactDom2.default.render(_react2.default.createElement(Gongqi_ProgressBar, { body: body }), Gongqi_ProgressBar.parentDiv);
							}
						}
					}
				}
			}
		}]);
	
		function Gongqi_ProgressBar(props) {
			_classCallCheck(this, Gongqi_ProgressBar);
	
			var _this = _possibleConstructorReturn(this, (Gongqi_ProgressBar.__proto__ || Object.getPrototypeOf(Gongqi_ProgressBar)).call(this, props));
	
			_this.keyDownHandler = function (e) {
				return;
				if (e.keyCode == 13) _this.query();else if (e.keyCode == 27) {
					_this.closeHandler(true);
					e.preventDefault();
					e.stopImmediatePropagation();
				}
			};
	
			_this.state = {
				title: _this.props.body.title,
				total: _this.props.body.total,
				loaded: _this.props.body.loaded,
				text: _this.props.body.text,
				modal: _this.props.body.modal,
				closeable: _this.props.body.closeable,
				size: "normal"
			};
	
			return _this;
		}
	
		_createClass(Gongqi_ProgressBar, [{
			key: 'closeHandler',
			value: function closeHandler() {
				var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				_WebSocketManager2.default.progressBar = null;
	
				_reactDom2.default.unmountComponentAtNode(Gongqi_ProgressBar.parentDiv);
				$(this.modalDiv).remove();
	
				if (focus && typeof window.switchToCurrent == "function") window.switchToCurrent();
			}
		}, {
			key: 'minHandler',
			value: function minHandler(e) {
				this.setState({ size: "min" });
			}
		}, {
			key: 'restoreHandler',
			value: function restoreHandler() {
				this.setState({ size: "normal" });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				//$(this.modalDiv).draggable({handle: ".modal-header"});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				//TODO如果没有unmountComponentAtNode手动调用，通过remove并没有调用卸载询问函数 对于该类场景 应如何设计？
	
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				if (!nextState.title) nextState.title = this.state.title;
				if (!nextState.text) nextState.text = this.state.text;
				if (!nextState.total) nextState.total = this.state.total;
				if (!nextState.loaded) nextState.loaded = this.state.loaded;
				return true;
			}
		}, {
			key: 'findKeyDownHandler',
			value: function findKeyDownHandler(e) {}
		}, {
			key: 'getIconDom',
			value: function getIconDom() {
				return this.state.closeable ? _react2.default.createElement('i', { className: 'fa fa-close', style: { fontSize: "15px", cursor: "pointer", position: "absolute", top: "4px", right: "3px" }, onClick: this.closeHandler.bind(this) }) : this.state.size == "normal" ? _react2.default.createElement('i', { className: 'fa fa-minus', style: { fontSize: "15px", cursor: "pointer", position: "absolute", top: "4px", right: "3px" }, onClick: this.minHandler.bind(this) }) : _react2.default.createElement('i', { className: 'fa fa-reply', style: { fontSize: "15px", cursor: "pointer", position: "absolute", top: "4px", right: "3px" }, onClick: this.restoreHandler.bind(this) });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (this.state.modal != "modalNone") {
					return _react2.default.createElement(
						'div',
						{ className: 'modal', style: { display: "flex", justifyContent: "center" }, ref: function ref(node) {
								return _this2.modalDiv = node;
							}, onKeyDown: this.findKeyDownHandler.bind(this) },
						_react2.default.createElement(
							'div',
							{ style: { alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px", width: '200px' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header', style: _defineProperty({ background: "#ffffff", position: "relative", width: "auto", paddingLeft: "3px", paddingTop: "3px", paddingBottom: "5px" }, 'position', "relative") },
								_react2.default.createElement(
									'h5',
									{ className: 'modal-title', style: { marginRight: "10px" } },
									this.state.title
								),
								this.state.closeable ? _react2.default.createElement('i', { className: 'fa fa-close', style: { fontSize: "15px", cursor: "pointer", position: "absolute", top: "4px", right: "3px" }, onClick: this.closeHandler.bind(this) }) : null
							),
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'column', alignItems: 'stretch', backgroundColor: '#fff' } },
								_react2.default.createElement('div', { style: { background: 'url("./images/30.gif") no-repeat', marginTop: '10px', marginBottom: '10px', height: '25px' } }),
								_react2.default.createElement(
									'div',
									{ style: { position: 'relative' } },
									_react2.default.createElement(
										'progress',
										{ style: { width: '100%', height: '20px' }, max: this.state.total ? this.state.total : 0, value: this.state.loaded > 0 ? this.state.loaded : 0 },
										'\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301progress\u5143\u7D20'
									),
									_react2.default.createElement(
										'div',
										{ style: { position: 'absolute', bottom: '5px', left: '0px', right: '0px', textAlign: 'center' } },
										this.state.text ? this.state.text : this.state.loaded + "/" + this.state.total
									)
								)
							)
						)
					);
				} else {
					var outterStyle = this.state.size == "normal" ? { display: "flex", justifyContent: "center", position: 'absolute', top: '40%', left: '40%' } : { display: "flex", justifyContent: "center", position: 'absolute', bottom: '30px', right: '3px' };
					var bodyStyle = this.state.size == "normal" ? { display: 'flex', flexDirection: 'column', alignItems: 'stretch', backgroundColor: '#fff' } : { display: 'none', flexDirection: 'column', alignItems: 'stretch', backgroundColor: '#fff' };
					var iconDom = this.getIconDom();
					return _react2.default.createElement(
						'div',
						{ style: outterStyle, ref: function ref(node) {
								return _this2.modalDiv = node;
							}, onKeyDown: this.findKeyDownHandler.bind(this) },
						_react2.default.createElement(
							'div',
							{ style: { alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px", width: '200px' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header', style: _defineProperty({ background: "#ffffff", position: "relative", width: "auto", paddingLeft: "3px", paddingTop: "3px", paddingBottom: "5px" }, 'position', "relative") },
								_react2.default.createElement(
									'h5',
									{ className: 'modal-title', style: { marginRight: "10px" } },
									this.state.title
								),
								iconDom
							),
							_react2.default.createElement(
								'div',
								{ style: bodyStyle },
								_react2.default.createElement('div', { style: { background: 'url("./images/30.gif") no-repeat', marginTop: '10px', marginBottom: '10px', height: '25px' } }),
								_react2.default.createElement(
									'div',
									{ style: { position: 'relative' } },
									_react2.default.createElement(
										'progress',
										{ style: { width: '100%', height: '20px' }, max: this.state.total ? this.state.total : 0, value: this.state.loaded > 0 ? this.state.loaded : 0 },
										'\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301progress\u5143\u7D20'
									),
									_react2.default.createElement(
										'div',
										{ style: { position: 'absolute', bottom: '5px', left: '0px', right: '0px', textAlign: 'center' } },
										this.state.text ? this.state.text : this.state.loaded + "/" + this.state.total
									)
								)
							)
						)
					);
				}
			}
		}]);
	
		return Gongqi_ProgressBar;
	}(_react2.default.Component);
	
	exports.default = Gongqi_ProgressBar;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(324);
	
	var OverallSituationModelDiv = function (_React$Component) {
	  _inherits(OverallSituationModelDiv, _React$Component);
	
	  function OverallSituationModelDiv(props) {
	    _classCallCheck(this, OverallSituationModelDiv);
	
	    return _possibleConstructorReturn(this, (OverallSituationModelDiv.__proto__ || Object.getPrototypeOf(OverallSituationModelDiv)).call(this, props));
	  }
	
	  _createClass(OverallSituationModelDiv, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '100%', height: '100%', backgroundColor: 'rgb(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	        _react2.default.createElement('img', { src: '../images/overllImge.png', style: { width: '40%' } })
	      );
	    }
	  }]);
	
	  return OverallSituationModelDiv;
	}(_react2.default.Component);
	
	OverallSituationModelDiv.defaultProps = {};
	exports.default = OverallSituationModelDiv;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(289);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./bootstrap-select.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./bootstrap-select.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(296);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemBoolean.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemBoolean.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(308);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./Form_layout.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./Form_layout.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 156 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandArg = function CommandArg() {
		_classCallCheck(this, CommandArg);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.remote.CommandArg";
	};
	
	exports.default = CommandArg;

/***/ },
/* 157 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryWhereStatus = function () {
		function QueryWhereStatus() {
			_classCallCheck(this, QueryWhereStatus);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryWhereStatus";
		}
	
		_createClass(QueryWhereStatus, null, [{
			key: "valueOf",
			value: function valueOf(value) {
				if (value == QueryWhereStatus.OPENLABEL || value == "") return QueryWhereStatus.Open;else if (value == QueryWhereStatus.LOCKLABEL) return QueryWhereStatus.Lock;else if (value == QueryWhereStatus.HIDELABEL) return QueryWhereStatus.Hide;
	
				throw new Error("错误的枚举类型");
			}
		}, {
			key: "getLabel",
			value: function getLabel(value) {
				if (value == QueryWhereStatus.Open) return QueryWhereStatus.OPENLABEL;else if (value == QueryWhereStatus.Lock) return QueryWhereStatus.LOCKLABEL;else if (value == QueryWhereStatus.Hide) return QueryWhereStatus.HIDELABEL;
	
				throw new Error("错误的枚举类型");
			}
		}]);
	
		return QueryWhereStatus;
	}();
	
	QueryWhereStatus.Open = "Open";
	QueryWhereStatus.Lock = "Lock";
	QueryWhereStatus.Hide = "Hide";
	QueryWhereStatus.OPENLABEL = "Open";
	QueryWhereStatus.LOCKLABEL = "Lock";
	QueryWhereStatus.HIDELABEL = "Hide";
	exports.default = QueryWhereStatus;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserFormUtil = function () {
		function UserFormUtil() {
			_classCallCheck(this, UserFormUtil);
		}
	
		_createClass(UserFormUtil, null, [{
			key: 'findUserXMLNodeById',
			value: function findUserXMLNodeById(userXML, id) {
				var list = userXML.getElementsByTagName("node");
				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					if (item.id == id) return item;
				}
				return null;
			}
		}, {
			key: 'findFormXMLNodeById',
			value: function findFormXMLNodeById(formXML, id) {
				var list = formXML.getElementsByTagName("node");
				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					if (item.id == id) return item;
				}
				return null;
			}
		}, {
			key: 'mergeXML',
			value: function mergeXML(userXML, formXML, formNodeList) {
	
				if (formNodeList == null) formNodeList = UserFormUtil.getFormNodeList(formXML);
	
				userXML = userXML.cloneNode(true);
	
				var i = void 0;
				var j = void 0;
				var userNodeList = UserFormUtil.getUserNodeList(userXML);
				delete userXML.nodeList;
	
				var isSame = true;
				if (userNodeList.length != formNodeList.length) {
					isSame = false;
				} else {
					for (i = 0; i < userNodeList.length; i++) {
						if (userNodeList[i] != formNodeList[i]) {
							isSame = false;
							break;
						}
					}
				}
	
				if (isSame) return userXML;
	
				var uList, uItem, uParent, uBrother;
				var fList, fItem, fParent, fBrother;
	
				fList = formNodeList;
				uList = userNodeList;
	
				//根据uList，到fList中找对应节点，如果找不到，则删除UserXML中相应的node
				//遍历之后，根据新的usrXML重新计算uList
				var uItemList = void 0;var uId = void 0;var fId = void 0;var isIn = void 0;var isChange = false;
				for (var _i = 0; _i < uList.length; _i++) {
					uId = uList[_i];
					isIn = false;
					for (j = 0; j < fList.length; j++) {
						fId = fList[j];
						if (fId == uId) {
							isIn = true;
							break;
						} else if (fId > uId) {
							break;
						}
					}
	
					if (isIn == false) {
						uItem = UserFormUtil.findUserXMLNodeById(userXML, uId);
						if (uItem) {
							uItem.parentNode.removeChild(uItem);
							//XMLHelper.deleteNode(uItem);
							isChange = true;
						}
					}
				}
	
				if (isChange) {
					uList = UserFormUtil.getUserNodeList(userXML);
				}
	
				//根据fList,到uList中找对应的节点，如果找不到，则在userXML中补充相应的节点
				var nnn = 0;
				while (uList.length < fList.length) {
					if (nnn > 100000) {
						_Warn2.default.show({ text: "之前保存的页面调整默认方案由于更新已完成失效 请于管理员联系" });
						return false;
					}
					nnn++;
					for (var _i2 = 0; _i2 < fList.length; _i2++) {
						fId = fList[_i2];
						isIn = false;
						for (j = 0; j < uList.length; j++) {
							uId = uList[j];
							if (uId == fId) {
								isIn = true;
								break;
							}
						}
						if (isIn == false) {
							fItem = _GOTUtil2.default.getFormItemInnerXMLByCache(formXML, fId);
							//fItem = formXML.FormDesign..FormItem.(@id==String(fId))[0];
							fParent = fItem.parentNode;
							var fChildIndex = void 0;
							for (var n = 0; n < fParent.children.length; n++) {
								if (fParent.children[n].id == fItem.id) fChildIndex = n;
							}
							var fParentId = fParent.id;
							var fLeftId;
							var fRightId;
	
							if (fChildIndex == 1) //原来应该是0  因为有Properties存在，所以1为第1个
								{
									fLeftId = "null";
								} else {
								fLeftId = fParent.children[fChildIndex - 1].id;
							}
	
							if (fChildIndex == fParent.children.length - 1) {
								fRightId = "null";
							} else {
								fRightId = fParent.children[fChildIndex + 1].id;
							}
	
							var newUItem = userXML.ownerDocument.createElement("node");
							newUItem.id = fId;
	
							uParent = null;
							if (fParentId == "") {
								uParent = userXML;
							} else {
								uParent = UserFormUtil.findUserXMLNodeById(userXML, fParentId);
							}
	
							if (uParent) {
								if (fLeftId == "null") {
									uParent.insertBefore(newUItem, uParent.children[0]);
									//uParent.prependChild(newUItem);
									isChange = true;
								} else if (fRightId == "null") {
									uParent.appendChild(newUItem);
									isChange = true;
								} else {
									//var uLeftList:XMLList = uParent.node.(@id==fLeftId);
									var uLeft = UserFormUtil.findUserXMLNodeById(uParent, fLeftId);
									if (uLeft) {
										if (uLeft.nextSibling) uParent.insertBefore(newUItem, uLeft.nextSibling);else uParent.appendChild(newUItem);
										isChange = true;
									} else {
										var uRight = UserFormUtil.findUserXMLNodeById(uParent, fRightId);
										if (uRight) {
											uParent.insertBefore(newUItem, uRight);
											isChange = true;
										} else {
											isChange = false;
										}
									}
								}
							} else {
								isChange = false;
							}
	
							if (isChange == true) {
								uList.push(fId);
							}
						}
					}
				}
	
				//var toTime:Date = new Date();
				//GongqiAlert.show((toTime.milliseconds - fromTime.milliseconds).toString());
	
				//TODO_YL  自动拟合完成之后不提醒
				// Warning.show({text:"用户自定义画面与最新版本不一致，已自动拟合，请与管理员联系!!!"});
	
				return userXML;
			}
		}, {
			key: 'getUserNodeList',
			value: function getUserNodeList(userXML) {
				var list = userXML.getElementsByTagName("node");
				var array = [];
				for (var i = 0; i < list.length; i++) {
					var child = list[i];
					array.push(child.id);
				}
				array.sort(function sortNumber(a, b) {
					return a - b;
				});
				return array;
			}
		}, {
			key: 'getFormNodeList',
			value: function getFormNodeList(formXML) {
				var formDesign = formXML.children[2];
				var list = formDesign.getElementsByTagName("FormItem");
	
				var array = [];
				for (var i = 0; i < list.length; i++) {
					var child = list[i];
					array.push(child.id);
				}
				array.sort(function sortNumber(a, b) {
					return a - b;
				});
				//array.sort(Array.NUMERIC);
				return array;
			}
		}]);
	
		return UserFormUtil;
	}();
	
	exports.default = UserFormUtil;

/***/ },
/* 159 */,
/* 160 */,
/* 161 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSourceAuthorityType = function () {
		function FormDataSourceAuthorityType() {
			_classCallCheck(this, FormDataSourceAuthorityType);
		}
	
		_createClass(FormDataSourceAuthorityType, null, [{
			key: "getDSName",
			value: function getDSName(type) {
				var result = null;
				if (type == FormDataSourceAuthorityType.Query) result = "ds_AllowQuery";else if (type == FormDataSourceAuthorityType.Export) result = "ds_AllowExport";else if (type == FormDataSourceAuthorityType.Add) result = "ds_AllowAdd";else if (type == FormDataSourceAuthorityType.Save) result = "ds_AllowSave";else if (type == FormDataSourceAuthorityType.Delete) result = "ds_AllowDelete";else if (type == FormDataSourceAuthorityType.Edit) result = "ds_AllowEdit";else if (type == FormDataSourceAuthorityType.Attachment) result = "ds_AllowAttachment";
	
				return result;
			}
		}, {
			key: "getXMLName",
			value: function getXMLName(type) {
				var result = null;
				if (type == FormDataSourceAuthorityType.Query) result = "query";else if (type == FormDataSourceAuthorityType.Export) result = "exp";else if (type == FormDataSourceAuthorityType.Add) result = "_new";else if (type == FormDataSourceAuthorityType.Save) result = "save";else if (type == FormDataSourceAuthorityType.Delete) result = "del";else if (type == FormDataSourceAuthorityType.Edit) result = "edit";else if (type == FormDataSourceAuthorityType.Attachment) result = "ds_AllowAttachment";
	
				return result;
			}
		}]);
	
		return FormDataSourceAuthorityType;
	}();
	
	FormDataSourceAuthorityType.Visible = 0;
	FormDataSourceAuthorityType.Query = 1;
	FormDataSourceAuthorityType.Export = 2;
	FormDataSourceAuthorityType.Edit = 3;
	FormDataSourceAuthorityType.Save = 4;
	FormDataSourceAuthorityType.Add = 5;
	FormDataSourceAuthorityType.Delete = 6;
	FormDataSourceAuthorityType.Attachment = 7;
	FormDataSourceAuthorityType.queryStr = "query";
	FormDataSourceAuthorityType.exportStr = "exp";
	FormDataSourceAuthorityType.newStr = "_new";
	FormDataSourceAuthorityType.saveStr = "save";
	FormDataSourceAuthorityType.delStr = "del";
	FormDataSourceAuthorityType.editStr = "edit";
	exports.default = FormDataSourceAuthorityType;

/***/ },
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSourceGroupLinkType = function () {
		function FormDataSourceGroupLinkType() {
			_classCallCheck(this, FormDataSourceGroupLinkType);
		}
	
		_createClass(FormDataSourceGroupLinkType, null, [{
			key: "isLinkType",
			value: function isLinkType(value) {
				if (value == FormDataSourceGroupLinkType.PASSIVE || value == FormDataSourceGroupLinkType.DELAYED || value == FormDataSourceGroupLinkType.ACTIVE || value == "") return true;
				return false;
			}
		}]);
	
		return FormDataSourceGroupLinkType;
	}();
	
	FormDataSourceGroupLinkType.PASSIVE = "Passive";
	FormDataSourceGroupLinkType.DELAYED = "Delayed";
	FormDataSourceGroupLinkType.ACTIVE = "Active";
	exports.default = FormDataSourceGroupLinkType;

/***/ },
/* 163 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormParam = function FormParam() {
		_classCallCheck(this, FormParam);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.remote.FormParam";
	} //目前只有当自定义的lookup被下拉出来时，才有效
	;
	
	exports.default = FormParam;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataSet = __webpack_require__(269);
	
	var _DataSet2 = _interopRequireDefault(_DataSet);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _DataTable = __webpack_require__(278);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _DataTableSchema = __webpack_require__(279);
	
	var _DataTableSchema2 = _interopRequireDefault(_DataTableSchema);
	
	var _DataSetColDateTimeEditor = __webpack_require__(272);
	
	var _DataSetColDateTimeEditor2 = _interopRequireDefault(_DataSetColDateTimeEditor);
	
	var _DataSetColLongEditor = __webpack_require__(275);
	
	var _DataSetColLongEditor2 = _interopRequireDefault(_DataSetColLongEditor);
	
	var _DataSetColStringEditor = __webpack_require__(276);
	
	var _DataSetColStringEditor2 = _interopRequireDefault(_DataSetColStringEditor);
	
	var _DataSetColTimeEditor = __webpack_require__(277);
	
	var _DataSetColTimeEditor2 = _interopRequireDefault(_DataSetColTimeEditor);
	
	var _DataSetColDateEditor = __webpack_require__(271);
	
	var _DataSetColDateEditor2 = _interopRequireDefault(_DataSetColDateEditor);
	
	var _DataSetColEnumEditor = __webpack_require__(274);
	
	var _DataSetColEnumEditor2 = _interopRequireDefault(_DataSetColEnumEditor);
	
	var _DataSetColBooleanEditor = __webpack_require__(270);
	
	var _DataSetColBooleanEditor2 = _interopRequireDefault(_DataSetColBooleanEditor);
	
	var _DataSetColDecimalEditor = __webpack_require__(273);
	
	var _DataSetColDecimalEditor2 = _interopRequireDefault(_DataSetColDecimalEditor);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _ReactDOMFactories = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetUtil = function () {
	    function DataSetUtil() {
	        _classCallCheck(this, DataSetUtil);
	    }
	
	    _createClass(DataSetUtil, null, [{
	        key: "strDataSet",
	        value: function strDataSet(dataSetStr, dataArray) {
	            var dataSet = new _DataSet2.default();
	            dataSet.id = _CommonUtil2.default.guid();
	            dataSet.dataTables = [];
	            var dataTable = new _DataTable2.default();
	            dataTable.data = [];
	            var dataTableSchema = new _DataTableSchema2.default();
	            dataTableSchema.id = _CommonUtil2.default.guid();
	            dataTableSchema.type = "Simple";
	            dataTableSchema.name = dataSetStr.queryTable.tableName.substr(dataSetStr.queryTable.tableName.lastIndexOf(".") + 1);
	            dataTableSchema.label = "columnsArray";
	            dataTableSchema.columns = [];
	            dataTableSchema.fileName = dataSetStr.fileName; //数据集名称
	            dataTable.schema = dataTableSchema;
	            for (var i in dataSetStr.dataColumn.columnsArray) {
	                var column = dataSetStr.dataColumn.columnsArray[i];
	                if (column.dataType == "String") {
	                    var dataSetColStringEditor = new _DataSetColStringEditor2.default();
	                    dataSetColStringEditor.label = column.label;
	                    dataSetColStringEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColStringEditor.helpText = column.helpText;
	                    dataSetColStringEditor.displayLength = column.displayLength;
	                    dataSetColStringEditor.stringSize = column.stringSize;
	                    dataTable.schema.columns.push(dataSetColStringEditor);
	                }
	                if (column.dataType == "Long") {
	                    var dataSetColLongEditor = new _DataSetColLongEditor2.default();
	                    dataSetColLongEditor.label = column.label;
	                    dataSetColLongEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColLongEditor.showZero = column.showZero;
	                    dataSetColLongEditor.thousandSeperator = column.thousandSeperator;
	                    dataSetColLongEditor.helpText = column.helpText;
	                    dataSetColLongEditor.displayLength = column.displayLength;
	                    dataTable.schema.columns.push(dataSetColLongEditor);
	                }
	                if (column.dataType == "Boolean") {
	                    var dataSetBooleanEditor = new _DataSetColBooleanEditor2.default();
	                    dataSetBooleanEditor.label = column.label;
	                    dataSetBooleanEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetBooleanEditor.textFalse = column.textTrue;
	                    dataSetBooleanEditor.textTrue = column.textTrue;
	                    dataSetBooleanEditor.helpText = column.helpText;
	                    dataSetBooleanEditor.displayLength = column.displayLength;
	                    dataTable.schema.columns.push(dataSetBooleanEditor);
	                }
	                if (column.dataType == "Decimal") {
	                    var dataSetColDecimalEditor = new _DataSetColDecimalEditor2.default();
	                    dataSetColDecimalEditor.label = column.label;
	                    dataSetColDecimalEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColDecimalEditor.helpText = column.helpText;
	                    dataSetColDecimalEditor.displayLength = column.displayLength;
	                    dataSetColDecimalEditor.showZero = column.showZero;
	                    dataSetColDecimalEditor.thousandSeperator = column.thousandSeperator;
	                    dataSetColDecimalEditor.numOfDecimals = column.numOfDecimals;
	                    dataSetColDecimalEditor.showDecimals = column.showDecimals;
	                    dataSetColDecimalEditor.currencyType = column.currencyType;
	                    dataSetColDecimalEditor.currencyPrefix = column.currencyPrefix;
	                    dataSetColDecimalEditor.percentage = column.percentage;
	                    dataTable.schema.columns.push(dataSetColDecimalEditor);
	                }
	                if (column.dataType == "Date") {
	                    var dataSetColDateEditor = new _DataSetColDateEditor2.default();
	                    dataSetColDateEditor.label = column.label;
	                    dataSetColDateEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColDateEditor.helpText = column.helpText;
	                    dataSetColDateEditor.displayLength = column.displayLength;
	                    dataSetColDateEditor.displayFormat = column.displayFormat;
	                    dataTable.schema.columns.push(dataSetColDateEditor);
	                }
	                if (column.dataType == "Time") {
	                    var dataSetColTimeEditor = new _DataSetColTimeEditor2.default();
	                    dataSetColTimeEditor.label = column.label;
	                    dataSetColTimeEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColTimeEditor.helpText = column.helpText;
	                    dataSetColTimeEditor.displayLength = column.displayLength;
	                    dataSetColTimeEditor.displayFormat = column.displayFormat;
	                    dataTable.schema.columns.push(dataSetColTimeEditor);
	                }
	                if (column.dataType == "DataTime") {
	                    var dataSetColDateTimeEditor = new _DataSetColDateTimeEditor2.default();
	                    dataSetColDateTimeEditor.label = column.label;
	                    dataSetColDateTimeEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColDateTimeEditor.helpText = column.helpText;
	                    dataSetColDateTimeEditor.displayLength = column.displayLength;
	                    dataSetColDateTimeEditor.displayFormat = column.displayFormat;
	                    dataTable.schema.columns.push(dataSetColDateTimeEditor);
	                }
	                if (column.dataType == "Enum") {
	                    var dataSetColEnumEditor = new _DataSetColEnumEditor2.default();
	                    dataSetColEnumEditor.label = column.label;
	                    dataSetColEnumEditor.name = dataTable.schema.name + "." + _StringUtil2.default.convertToFirstLowerCase(column.columnId);
	                    dataSetColEnumEditor.helpText = column.helpText;
	                    dataSetColEnumEditor.displayLength = column.displayLength;
	                    dataSetColEnumEditor.enumItems = column.DataProvider;
	                    dataTable.schema.columns.push(dataSetColEnumEditor);
	                }
	            }
	            if (dataArray) {
	                dataTable.data = dataArray;
	            }
	            dataSet.dataTables.push(dataTable);
	            return dataSet;
	        }
	    }]);
	
	    return DataSetUtil;
	}();
	
	exports.default = DataSetUtil;

/***/ },
/* 165 */,
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(290);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./normalize.css", function() {
				var newContent = require("!!../css-loader/index.js!./normalize.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(294);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./App.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./App.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _DialogFieldGroupForm = __webpack_require__(184);
	
	var _DialogFieldGroupForm2 = _interopRequireDefault(_DialogFieldGroupForm);
	
	var _DialogFieldDateEditor = __webpack_require__(113);
	
	var _DialogFieldDateEditor2 = _interopRequireDefault(_DialogFieldDateEditor);
	
	var _DialogFieldStringEditor = __webpack_require__(118);
	
	var _DialogFieldStringEditor2 = _interopRequireDefault(_DialogFieldStringEditor);
	
	var _DialogFieldEnumEditor = __webpack_require__(115);
	
	var _DialogFieldEnumEditor2 = _interopRequireDefault(_DialogFieldEnumEditor);
	
	var _DialogFieldBooleanEditor = __webpack_require__(112);
	
	var _DialogFieldBooleanEditor2 = _interopRequireDefault(_DialogFieldBooleanEditor);
	
	var _DialogFieldLongEditor = __webpack_require__(117);
	
	var _DialogFieldLongEditor2 = _interopRequireDefault(_DialogFieldLongEditor);
	
	var _DialogFieldDecimalEditor = __webpack_require__(114);
	
	var _DialogFieldDecimalEditor2 = _interopRequireDefault(_DialogFieldDecimalEditor);
	
	var _DialogFieldTimeEditor = __webpack_require__(119);
	
	var _DialogFieldTimeEditor2 = _interopRequireDefault(_DialogFieldTimeEditor);
	
	var _DialogFieldLabel = __webpack_require__(116);
	
	var _DialogFieldLabel2 = _interopRequireDefault(_DialogFieldLabel);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogForm = function (_React$Component) {
		_inherits(DialogForm, _React$Component);
	
		function DialogForm(props) {
			_classCallCheck(this, DialogForm);
	
			var _this = _possibleConstructorReturn(this, (DialogForm.__proto__ || Object.getPrototypeOf(DialogForm)).call(this, props));
	
			var dialogArg = _this.props.dialogArg;
			var layout = dialogArg.layout;
	
			_this.state = { controls: dialogArg.controls, layout: layout, title: dialogArg.title, okLabel: dialogArg.okLabel, cancelLabel: dialogArg.cancelLabel };
			return _this;
		}
	
		_createClass(DialogForm, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				$(this.outterDiv).draggable({
					handle: ".modal-header"
				});
			}
		}, {
			key: 'getDialogComponents',
			value: function getDialogComponents() {
				var result = [];
				if (this.state.controls) {
					for (var i = 0; i < this.state.controls.length; i++) {
						var control = this.state.controls[i];
						if (control.hasOwnProperty("fields")) {
							result.push(_react2.default.createElement(_DialogFieldGroupForm2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
						} //TODO Flex版会把多出的field按照顺序分组 比如  group field field group field
						//结果为 group group group group
						else {
								if (control.editorType == "TypeString") {
									result.push(_react2.default.createElement(_DialogFieldStringEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else if (control.editorType == "TypeEnum") {
									result.push(_react2.default.createElement(_DialogFieldEnumEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else if (control.editorType == "TypeBoolean") {
									result.push(_react2.default.createElement(_DialogFieldBooleanEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else if (control.editorType == "TypeLabel") {
									result.push(_react2.default.createElement(_DialogFieldLabel2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else if (control.editorType == "TypeLong") {
									result.push(_react2.default.createElement(_DialogFieldLongEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else if (control.editorType == "TypeDecimal") {
									result.push(_react2.default.createElement(_DialogFieldDecimalEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else if (control.editorType == "TypeTime") {
									result.push(_react2.default.createElement(_DialogFieldTimeEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								} else {
									result.push(_react2.default.createElement(_DialogFieldDateEditor2.default, { key: i, data: control, dialogId: this.props.dialogArg.id }));
								}
							}
					}
				}
				return result;
			}
		}, {
			key: 'closeDialogFormHandler',
			value: function closeDialogFormHandler() {
				this.do_server("Close");
			}
		}, {
			key: 'doCloseDialogFormHandler',
			value: function doCloseDialogFormHandler() {
				var $reactComponentContainer = $("#dialogModal .modal");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				$reactComponentContainer.remove();
			}
		}, {
			key: 'do_server',
			value: function do_server(cmd) {
				if (this.dialogIsClicking == true) {
					return;
				}
				this.dialogIsClicking = true;
				var that = this;
				setTimeout(function () {
					that.dialogIsClicking = false;
				}, 400);
				if (!window.formModuleInstance) return;
	
				var formId = window.formModuleInstance.formId;
	
				//暂定Dialog就是无数据源
				var group = null;var groupAlias = this.props.dialogArg.groupAlias;
				if (window.formModuleInstance.formDataSources) {
					if (groupAlias) {
						group = window.formModuleInstance.formDataSources.groups[groupAlias];
					} else {
						group = window.formModuleInstance.formDataSources.currentGroup;
						if (group == null) group = window.formModuleInstance.formDataSources.firstGroup;
					}
				}
	
				var defaultGroupAlias = !group ? null : group.groupAlias;
	
				var _do;
				if (cmd == "OK") {
					_do = "dialogOK_" + this.props.dialogArg.id;
				} else if (cmd == "Cancel") {
					_do = "dialogCancel_" + this.props.dialogArg.id;
				} else if (cmd == "Close") {
					_do = "dialogClose_" + this.props.dialogArg.id;
				} else {
					return;
				}
	
				var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(_do);
				if (!mi) {
					this.doCloseDialogFormHandler();
					return;
				}
	
				if (mi.prefetch == true) {
					this.doCloseDialogFormHandler();
					_CommandResolver2.default.resolve(mi.commandResult.tasks, window.formModuleInstance);
				} else {
					var arg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, defaultGroupAlias, mi);
					var mapEditors = { remoteClass: "java.util.HashMap" };
					_CommandActions2.default.diaLogMapEditors(this.props.dialogArg.id, mapEditors);
					arg.argObject = mapEditors;
					if (arg.argObject == null) return;
					var command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doDialog", "CommandResult").appendArg(this.props.dialogArg.id).appendArg(cmd).appendArg(arg, "CommandArg");
					var _rpc_result_do_server = this.rpc_result_do_server.bind(this);
					var remoteArg = { command: command, resultFunction: function resultFunction(data) {
							_rpc_result_do_server(data, group);
						}, sync: false };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			}
		}, {
			key: 'rpc_result_do_server',
			value: function rpc_result_do_server(data, group) {
				this.doCloseDialogFormHandler();
				var result = data.result;
				_CommandResolver2.default.resolve(result.tasks, window.formModuleInstance, group);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {}
			//alert("DialogForm卸载");
	
			//<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closeDialogFormHandler.bind(this)}></i>
			/** 
	   * <button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} id="userFormSetSaveModal_BtnCancel" data-dismiss="modal" onClick={this.hideQueryFormSetSaveTable.bind(this)}>取消</button>
	  	<button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}} onClick={this.saveQuerySetForm.bind(this)}>保存</button>
	  */
	
		}, {
			key: 'render',
			value: function render() {
				var _outerStyle2,
				    _this2 = this;
	
				var _style = { display: "flex", padding: "10px", backgroundColor: "#ffffff" };
				var _outerStyle = (_outerStyle2 = { alignSelf: "center", border: "2px solid #e5e5e5" }, _defineProperty(_outerStyle2, 'border', '1px solid #9B9B9B'), _defineProperty(_outerStyle2, 'boxShadow', '0 0 41px 5px rgba(0,0,0,0.25)'), _defineProperty(_outerStyle2, 'borderRadius', "2px"), _outerStyle2);
				if (this.props.dialogArg) {
					if (this.props.dialogArg.width) {
						_outerStyle.width = this.props.dialogArg.width + "px";
					}
					if (this.props.dialogArg.height) {
						_outerStyle.height = this.props.dialogArg.height + "px";
						_outerStyle.display = "flex";_outerStyle.flexDirection = "column";
						_style.flexGrow = 1;
					}
				}
				var _className = void 0;
				if (this.state.layout == "vertical") {
					_style.flexDirection = "column";_className = "verticalList";
				} else {
					_style.flexDirection = "row";_className = "horizontalList";
				};
				var list = this.getDialogComponents();
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this2.outterDiv = node;
						}, id: "dialog_" + this.props.dialogArg.id, style: _outerStyle },
					_react2.default.createElement(
						'div',
						{ className: 'modal-header', style: { position: "relative", height: "45px" } },
						_react2.default.createElement('div', { className: 'modal-close', onClick: this.closeDialogFormHandler.bind(this) }),
						_react2.default.createElement(
							'h5',
							{ className: 'modal-title' },
							this.state.title
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: function ref(node) {
								return _this2.dialogComponent = node;
							}, style: _style, className: _className },
						list
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal-footer', style: { padding: "5px", backgroundColor: "#ffffff", textAlign: "center" } },
						_react2.default.createElement(
							'button',
							{ style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px', color: '#fff' }, type: 'button', className: 'btn', onClick: this.do_server.bind(this, "OK") },
							this.state.okLabel ? this.state.okLabel : "确定"
						),
						_react2.default.createElement(
							'button',
							{ style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' }, type: 'button', className: 'btn', 'data-dismiss': 'modal', onClick: this.do_server.bind(this, "Cancel") },
							this.state.cancelLabel ? this.state.cancelLabel : "取消"
						)
					)
				);
			}
		}]);
	
		return DialogForm;
	}(_react2.default.Component);
	
	;
	
	DialogForm.defaultProps = {};
	
	exports.default = DialogForm;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(103);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Config = __webpack_require__(175);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _RecordsUtil = __webpack_require__(64);
	
	var _RecordsUtil2 = _interopRequireDefault(_RecordsUtil);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _ToolBarUtil = __webpack_require__(68);
	
	var _ToolBarUtil2 = _interopRequireDefault(_ToolBarUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _GOTPropertiesUtil = __webpack_require__(62);
	
	var _GOTPropertiesUtil2 = _interopRequireDefault(_GOTPropertiesUtil);
	
	var _FormDataSources = __webpack_require__(50);
	
	var _FormDataSources2 = _interopRequireDefault(_FormDataSources);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _GongqiDataType = __webpack_require__(107);
	
	var _GongqiDataType2 = _interopRequireDefault(_GongqiDataType);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _QueryOrderByType = __webpack_require__(141);
	
	var _QueryOrderByType2 = _interopRequireDefault(_QueryOrderByType);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _QueryActions = __webpack_require__(71);
	
	var _QueryActions2 = _interopRequireDefault(_QueryActions);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	var _ToolBarActions = __webpack_require__(87);
	
	var _ToolBarActions2 = _interopRequireDefault(_ToolBarActions);
	
	var _FocusController = __webpack_require__(106);
	
	var _FocusController2 = _interopRequireDefault(_FocusController);
	
	var _FormDataSourceGroupArg = __webpack_require__(140);
	
	var _FormDataSourceGroupArg2 = _interopRequireDefault(_FormDataSourceGroupArg);
	
	var _FormDataSourceGroupResult = __webpack_require__(251);
	
	var _FormDataSourceGroupResult2 = _interopRequireDefault(_FormDataSourceGroupResult);
	
	var _RecordCondition = __webpack_require__(256);
	
	var _RecordCondition2 = _interopRequireDefault(_RecordCondition);
	
	var _RecordConditionTask = __webpack_require__(257);
	
	var _RecordConditionTask2 = _interopRequireDefault(_RecordConditionTask);
	
	var _Attachment = __webpack_require__(111);
	
	var _Attachment2 = _interopRequireDefault(_Attachment);
	
	var _QueryTable = __webpack_require__(142);
	
	var _QueryTable2 = _interopRequireDefault(_QueryTable);
	
	var _QueryOrderByItem = __webpack_require__(171);
	
	var _QueryOrderByItem2 = _interopRequireDefault(_QueryOrderByItem);
	
	var _QueryWhereItem = __webpack_require__(108);
	
	var _QueryWhereItem2 = _interopRequireDefault(_QueryWhereItem);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _CommandStore = __webpack_require__(18);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	var _FormItemTimeDisplay = __webpack_require__(75);
	
	var _FormItemTimeDisplay2 = _interopRequireDefault(_FormItemTimeDisplay);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	var _FormDataSourceAuthorityType = __webpack_require__(161);
	
	var _FormDataSourceAuthorityType2 = _interopRequireDefault(_FormDataSourceAuthorityType);
	
	var _ExportTable = __webpack_require__(189);
	
	var _ExportTable2 = _interopRequireDefault(_ExportTable);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _LayerManager = __webpack_require__(51);
	
	var _LayerManager2 = _interopRequireDefault(_LayerManager);
	
	var _CurrentRecordInfo = __webpack_require__(186);
	
	var _CurrentRecordInfo2 = _interopRequireDefault(_CurrentRecordInfo);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _ReactPropTypes = __webpack_require__(333);
	
	var _DataSetUtil = __webpack_require__(164);
	
	var _DataSetUtil2 = _interopRequireDefault(_DataSetUtil);
	
	var _PivotExportDialog = __webpack_require__(185);
	
	var _PivotExportDialog2 = _interopRequireDefault(_PivotExportDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSourceGroup = function () {
	  function FormDataSourceGroup(groupAlias, mainSource, formDataSources) {
	    var forLookup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    _classCallCheck(this, FormDataSourceGroup);
	
	    this.tempDataMethodField = {};
	    this.tempDataMethodFieldType = {};
	    this._lastAttachmentNum = undefined;
	    this.tmpQueryTable = null;
	    this.lockedRecNew = false;
	    this.lockedFieldFalsed = false;
	
	    this.formDataSources = formDataSources;
	    this.groupAlias = groupAlias;
	    window.groupActiveRecordStateObj[this.groupAlias] = {};
	    window.lastEditedDataFields[this.groupAlias] = {};
	    this.mainSource = mainSource;
	    this.tableName = this.mainSource.tableName;
	    this.isTempTable = mainSource.isTempTable;
	    this.linkType = mainSource.joinType;
	    this.startPosition = mainSource.startPosition;
	    this.allowExternalJoin = mainSource.allowExternalJoin;
	    this.sources = [mainSource];
	    this.linkGroup = null;
	    this.forLookup = forLookup;
	    this.lockedRecNew = false;
	    this.externalJoinGroupAlias = null;
	    this.records = [];
	    this.currentRecord = null;
	    this.autoJoinParent = true;
	    this.queryChanged = false;
	    this.ds_AllowAdd = true;
	    this.ds_AllowDelete = true;
	    this.ds_AllowExport = true;
	    this.ds_AllowSave = true;
	    this.ds_AllowAttachment = true;
	    this.ds_AllowQuery = true;
	    this.ds_AllwEdit = true;
	
	    this.dataPageSize = _Config2.default.dataPageSize;
	
	    this.aggreateTableFields = [];
	    this.aggreateDimTableFiels = [];
	    this.mapRecId = {};
	    this.recordsBak = {};
	
	    this.afterRecordConditionTask = [];
	
	    var formStoreKey = _FormItemUtil2.default.getFormStoresKey(this.formDataSources.formModule.menuItemId, this.formDataSources.formModule.formId);
	    var formStore = window.parent.window[formStoreKey];
	    var mapQueryTable = formStore ? formStore.mapQueryTable : null;
	    var queryTableKey = this.formDataSources.formModule.formId + "_" + this.mainSource.xml.id;
	    var queryTemplate = {
	      qname: "Query", nextInnerId: 10000, Properties: {
	        Title: { V: "" }, Status: { V: "Open" }, Literals: { V: "forcePlaceholders" }, UseCache: { V: true }, FetchType: { V: "List" },
	        CreatedDate: { V: "" }, CreatedTime: { V: "" }, CreatedBy: { V: "" }, ModifiedDate: { V: "" }, ModifiedTime: { V: "" }, ModifiedBy: { V: "" }
	      }
	    };
	    var queryTable = void 0;
	    if (mapQueryTable && mapQueryTable[queryTableKey]) {
	      if (this.mainSource.isTempTable == true) {
	        this.hasTempDefaultQuery = true;
	      }
	
	      queryTable = _QueryUtil2.default.convertQueryTable2XML(mapQueryTable[queryTableKey], queryTemplate);
	      if (window.isDataSetView == true) {
	        this.dataSetQueryTable = mapQueryTable[queryTableKey];
	        this.initDataSetQueryTable = JSON.stringify(mapQueryTable[queryTableKey]);
	      }
	    } else {
	      queryTable = _QueryUtil2.default.buildBaseQueryTable(this.mainSource.xml, this.formDataSources.xml);
	    }
	
	    //queryTable = QueryUtil.buildBaseQueryTable(this.mainSource.xml,this.formDataSources.xml); 
	    queryTemplate.QueryTable = queryTable;
	    this.baseQuery = queryTemplate;
	    this.fieldCache = {};
	    this.initAliasList();
	    this.unsubscribeCmdExcuteQueryStore = _CmdTypeStore.CmdExecuteQueryStore.listen(this.onExecuteQuery.bind(this));
	    this.unsubscribeRecordsStore = _RecordsStore.DataGridUserChangeStore.listen(this.onDataGridUserChanged.bind(this));
	    if (!this.forLookup) this.unsubscribeRecordAutoSaveStore = _RecordsStore.RecordAutoSaveStore.listen(this.onRecordAutoSave.bind(this));
	    this.unsubscribeRecordNextStore = _RecordsStore.RecordNextStore.listen(this.onRecordNext.bind(this));
	    this.unsubscribeRecordNextPageStore = _RecordsStore.RecordNextPageStore.listen(this.recordNextPage.bind(this));
	    this.unsubscribeRecordPrevPageStore = _RecordsStore.RecordPrevPageStore.listen(this.recordPrevPage.bind(this));
	    this.unsubscribeRecordPrevStore = _RecordsStore.RecordPrevStore.listen(this.onRecordPrev.bind(this));
	    this.unsubscribeRecordFirstStore = _RecordsStore.RecordFirstStore.listen(this.recordFirst.bind(this));
	    this.unsbuscribeRecordLastStore = _RecordsStore.RecordLastStore.listen(this.recordLast.bind(this));
	    this.unsubscribeRecordNewStore = _RecordsStore.RecordNewStore.listen(this.onRecordNew.bind(this));
	    this.unsubscribeRecordFetchAllStore = _RecordsStore.RecordFetchAllStore.listen(this.recordFetchAll.bind(this));
	    this.unsubscribeRecordRefreshStore = _RecordsStore.RecordRefreshStore.listen(this.recordRefresh.bind(this));
	    this.unsubscribeSelectAllRecordsStore = _CommandStore.SelectAllRecordsStore.listen(this.onSelectAllRecords.bind(this));
	    //this.unsubscribeCurrentRecordChangeStore = 
	    //  CurrentRecordChangeStore.listen(this.onCurrentRecordChanged.bind(this));
	  }
	
	  _createClass(FormDataSourceGroup, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unsubscribeCmdExcuteQueryStore();
	      this.unsubscribeRecordsStore();
	      if (!this.forLookup) this.unsubscribeRecordAutoSaveStore();
	      this.unsubscribeRecordNextStore();
	      this.unsubscribeRecordNextPageStore();
	      this.unsubscribeRecordPrevPageStore();
	      this.unsubscribeRecordPrevStore();
	      this.unsubscribeRecordFirstStore();
	      this.unsbuscribeRecordLastStore();
	      this.unsubscribeRecordNewStore();
	      this.unsubscribeRecordFetchAllStore();
	      this.unsubscribeRecordRefreshStore();
	      this.unsubscribeSelectAllRecordsStore();
	    }
	  }, {
	    key: 'addTempDataMethodField',
	    value: function addTempDataMethodField(_key, _field, type) {
	      this.tempDataMethodField[_key] = _field;
	      this.tempDataMethodFieldType[_key] = type;
	    }
	  }, {
	    key: 'getTempDataMethodField',
	    value: function getTempDataMethodField() {
	      return this.tempDataMethodField;
	    }
	  }, {
	    key: 'isTempDataMethodField',
	    value: function isTempDataMethodField(_field1) {
	      var _field2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var fvalue = void 0;
	      if (_field2 != null) fvalue = _field1 + "." + _field2;else fvalue = _field1;
	      return this.tempDataMethodField.hasOwnProperty(fvalue);
	    }
	  }, {
	    key: 'deleteRecordTempDataMethodField',
	    value: function deleteRecordTempDataMethodField(record) {
	      var tempDataMethodField = this.getTempDataMethodField();
	      for (var _field in tempDataMethodField) {
	        if (record.hasOwnProperty(_field)) {
	          delete record[_field];
	        }
	      }
	    }
	  }, {
	    key: 'getCurRecVersion',
	    value: function getCurRecVersion(record) {
	      if (!record) record = this.currentRecord;
	      if (!record) return -2;
	      var recVersion = record[this.groupAlias + ".recVersion"];
	      return recVersion;
	    }
	  }, {
	    key: 'reverseSelectedRecords',
	    value: function reverseSelectedRecords(records) {
	      var _selectRecordsKeys = [];var formModule = this.formDataSources.formModule;
	      _CommandActions2.default.getSelectRecordsKey(_selectRecordsKeys, this.groupAlias, formModule.menuItemId, formModule.formId, formModule.instanceUUId);
	      if (_selectRecordsKeys.length == 0) return false;
	
	      if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	        if (this.tempRecordsFilter.length != records.length) {
	          var tempRecordsFilterRecIdMap = {};
	          for (var i = 0; i < this.tempRecordsFilter.length; i++) {
	            var __record = this.tempRecordsFilter[i];
	            var _recId = __record[this.groupAlias + ".recId"];
	            tempRecordsFilterRecIdMap[_recId] = true;
	          }
	          var records2 = [];
	          for (var _i = 0; _i < records.length; _i++) {
	            var record = records[_i];
	            var _recId2 = record[this.groupAlias + ".recId"];
	            if (!tempRecordsFilterRecIdMap.hasOwnProperty(_recId2)) continue;
	            records2.push(record);
	            for (var k = 0; k < _selectRecordsKeys.length; k++) {
	              var dataField = _selectRecordsKeys[k];
	              record[dataField] = !record[dataField];
	            }
	          }
	          _CommandActions2.default.reverseSelectedRecords(this.groupAlias);
	          return true;
	        }
	      }
	
	      for (var _i2 = 0; _i2 < records.length; _i2++) {
	        var _record2 = records[_i2];
	        for (var _k = 0; _k < _selectRecordsKeys.length; _k++) {
	          var _dataField2 = _selectRecordsKeys[_k];
	          _record2[_dataField2] = !_record2[_dataField2];
	        }
	      }
	      _CommandActions2.default.reverseSelectedRecords(this.groupAlias);
	      return true;
	    }
	  }, {
	    key: 'selectRecords',
	    value: function selectRecords(value, records) {
	      var _selectRecordsKeys = [];var formModule = this.formDataSources.formModule;
	      _CommandActions2.default.getSelectRecordsKey(_selectRecordsKeys, this.groupAlias, formModule.menuItemId, formModule.formId, formModule.instanceUUId);
	      if (_selectRecordsKeys.length == 0) return false;
	
	      if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	        if (this.tempRecordsFilter.length != records.length) {
	          var tempRecordsFilterRecIdMap = {};
	          for (var i = 0; i < this.tempRecordsFilter.length; i++) {
	            var __record = this.tempRecordsFilter[i];
	            var _recId = __record[this.groupAlias + ".recId"];
	            tempRecordsFilterRecIdMap[_recId] = true;
	          }
	          var records2 = [];
	          for (var _i3 = 0; _i3 < records.length; _i3++) {
	            var record = records[_i3];
	            var _recId3 = record[this.groupAlias + ".recId"];
	            if (!tempRecordsFilterRecIdMap.hasOwnProperty(_recId3)) continue;
	            records2.push(record);
	            for (var k = 0; k < _selectRecordsKeys.length; k++) {
	              var dataField = _selectRecordsKeys[k];
	              record[dataField] = value;
	            }
	          }
	          _CommandActions2.default.selectRecords2(value, this.groupAlias, null, records);
	          return true;
	        }
	      }
	
	      for (var _i4 = 0; _i4 < records.length; _i4++) {
	        var _record3 = records[_i4];
	        for (var _k2 = 0; _k2 < _selectRecordsKeys.length; _k2++) {
	          var _dataField3 = _selectRecordsKeys[_k2];
	          _record3[_dataField3] = value;
	        }
	      }
	      _CommandActions2.default.selectRecords2(value, this.groupAlias, null, records);
	      return true;
	    }
	  }, {
	    key: 'onSelectAllRecords',
	    value: function onSelectAllRecords(value, groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias) return;
	      var formModule = this.formDataSources.formModule;
	      if (moduleInstanceId != formModule.instanceUUId) return;
	      var _selectRecordsKeys = [];
	      _CommandActions2.default.getSelectRecordsKey(_selectRecordsKeys, this.groupAlias, formModule.menuItemId, formModule.formId, formModule.instanceUUId);
	      if (_selectRecordsKeys.length == 0) return;
	      var records = this.records;
	      if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	        if (this.tempRecordsFilter.length != records.length) {
	          var tempRecordsFilterRecIdMap = {};
	          for (var i = 0; i < this.tempRecordsFilter.length; i++) {
	            var __record = this.tempRecordsFilter[i];
	            var _recId = __record[this.groupAlias + ".recId"];
	            tempRecordsFilterRecIdMap[_recId] = true;
	          }
	
	          for (var _i5 = 0; _i5 < records.length; _i5++) {
	            var record = records[_i5];
	            var _recId4 = record[this.groupAlias + ".recId"];
	            if (!tempRecordsFilterRecIdMap.hasOwnProperty(_recId4)) continue;
	            for (var k = 0; k < _selectRecordsKeys.length; k++) {
	              var dataField = _selectRecordsKeys[k];
	              record[dataField] = value;
	            }
	          }
	          return;
	        }
	      }
	
	      for (var _i6 = 0; _i6 < records.length; _i6++) {
	        var _record4 = records[_i6];
	        for (var _k3 = 0; _k3 < _selectRecordsKeys.length; _k3++) {
	          var _dataField4 = _selectRecordsKeys[_k3];
	          _record4[_dataField4] = value;
	        }
	      }
	    }
	  }, {
	    key: 'doRecordNew',
	    value: function doRecordNew() {
	      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	      if (this.linkGroup) if (this.linkGroup.isCurrentRecordModified() && !isWorkFlow) {
	        _Warn2.default.show({ text: "请先保存关联记录" });
	        return;
	      }
	
	      var arg = new _FormDataSourceGroupArg2.default();
	      arg.groupAlias = this.groupAlias;arg.aliasList = null;arg.argType = 0;arg.arg = null;
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Add, this.currentRecord)) return;
	      var result = this.onRecordAutoSave(this.groupAlias);
	      if (result && (result.remoteFail || window.rowChangeAutoSaveFail)) {
	        window.rowChangeAutoSaveFail = false;
	        return;
	      }
	
	      if (!this.mainSource.isTempTable && this.linkGroup != null && this.linkGroup.currentRecord != null) {
	        var list = _GOTUtil2.default.getQueryRelationItemByPropertyQuery(this.formQuery, "dataField");
	
	        if (list.length >= 1) {
	          var array = []; //["OBJTYPE:java.lang.Object[]"];
	          for (var i = 0; i < list.length; i++) {
	            var obj = list[i];
	            var _parent = obj.parent;
	            var item = obj.item;
	            var key = item.Properties.Field.V;
	            var value = item.Properties.FieldValue.V;
	
	            for (var k = 0; k < _parent.Items.length; k++) {
	              var qri = _parent.Items[k];
	              var relatedFieldPro = qri.Properties.RelatedField || qri.Properties.ParentField;
	              if (qri.Properties.Field.V == key && relatedFieldPro.V != "") {
	                var keyValue = { remoteClass: "java.util.HashMap" };
	                keyValue[relatedFieldPro.V] = value;
	                array.push(keyValue);
	              }
	            }
	          }
	          arg.arg = array;
	        }
	      }
	
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".initRecord", window.menuItemId, window.formId);
	      if (mi == null) {
	        mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".beforeInitRecord", window.menuItemId, window.formId) || _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterInitRecord", window.menuItemId, window.formId);
	        if (mi == null) {
	          mi = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };
	        }
	      }
	      var commandArg = _CommandResolver2.default.getSendCmd(this.formDataSources.formModule, this.groupAlias, mi);
	      var command = _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doRecordNew").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg");
	      var _resultHandler = this.rpc_result_doRecordNew.bind(this);
	      _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: _resultHandler, sync: sync });
	    }
	  }, {
	    key: 'rpc_result_doRecordNew',
	    value: function rpc_result_doRecordNew(data) {
	      var result = data.result;
	      //var finalDatas = RecordsUtil.getOneLevelDatas(result,this.groupAlias);
	      this.formatFormDataSourceGroupResult(result);
	      var finalDatas = result.dataResult;
	      if (finalDatas.length > 0) {
	        var newRecord = finalDatas[0];
	
	        var _recId = newRecord[this.mainSource.alias + ".recId"];
	        if (this.mapRecId.hasOwnProperty(_recId)) throw new Error("already in when new record:" + _recId);
	        this.mapRecId[_recId] = newRecord;
	        this.recordsBak[_recId] = Object.assign({}, newRecord);;
	
	        var index = this.getNewRecordIndex();
	        this.records.splice(index, 0, newRecord);
	        var _records = this.records;
	        if (this.tempRecordsFilter) {
	          this.tempRecordsFilter.splice(index, 0, newRecord);
	          _records = this.tempRecordsFilter;
	        }
	
	        _RecordsActions2.default.recordsCmp(_records, this.groupAlias, this);
	        this.setCurrentRecord(newRecord, false, { focus: false });
	        this.formDataSources.formModule.focusController.setFocusAfterNewRecord(this);
	
	        _CommandResolver2.default.resolve(data.result.commandResult.tasks);
	      } else {
	        alert("新增失败，返回null");
	      }
	    }
	  }, {
	    key: 'rpc_result_doRecordNew2',
	    value: function rpc_result_doRecordNew2(data) {
	      var result = data.result;
	      //result.recordCounts = result.dataResult.length;
	      //var finalDatas = RecordsUtil.getOneLevelDatas(result,this.groupAlias);
	      this.formatFormDataSourceGroupResult(result);
	      var finalDatas = result.dataResult;
	      if (finalDatas.length > 0) {
	        try {
	          var _records2;
	
	          var newRecords = [];
	          for (var i = 0; i < finalDatas.length; i++) {
	            var newRecord = finalDatas[i];
	
	            var _recId = newRecord[this.mainSource.alias + ".recId"];
	
	            //如果原来该记录存在
	            if (this.mapRecId.hasOwnProperty(_recId)) {
	              this.replaceRecord3(newRecord);
	              this.mapRecId[_recId] = newRecord;
	              this.recordsBak[_recId] = Object.assign({}, newRecord);
	              continue;
	            }
	            this.mapRecId[_recId] = newRecord;
	            this.recordsBak[_recId] = Object.assign({}, newRecord);
	            //throw new Error("already in when new record:" + _recId);
	            newRecords.push(newRecord);
	          }
	          /*var newRecords = Object.keys(newRecordsObj).map(
	            function(key)
	            {
	              return newRecordsObj[key];
	            }
	          );*/
	          var index = this.getNewRecordIndex(data.location);
	          (_records2 = this.records).splice.apply(_records2, [index, 0].concat(newRecords));
	          this.currentRecord = newRecord;
	
	          _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this);
	          this.activeCurrentRecord(true, undefined, false);
	          this.formDataSources.formModule.focusController.setFocusAfterNewRecord(this);
	        } catch (e) {
	          _Warn2.default.show({ text: "clientRecordAdd命令传入的参数可能不正确" });
	        }
	      } else {
	        alert("新增失败，返回null");
	      }
	    }
	  }, {
	    key: 'onRecordNew',
	    value: function onRecordNew(groupAlias, moduleInstanceId) {
	      //TODO 留作DataGrid向下键新增交互
	      if (groupAlias == this.groupAlias && this.formDataSource.formModule.instanceUUId == moduleInstanceId) return this.doRecordNew();
	    }
	  }, {
	    key: 'getNewRecordIndex',
	    value: function getNewRecordIndex(insertType) {
	      if (this.records == null) return -1;
	
	      var index = 0; //add at first or last有区别
	      if (!insertType) insertType = this.mainSource.xml.Properties.InsertAt.Value;
	
	      if (insertType == "First") {
	        index = 0;
	      } else if (insertType == "Last") {
	        index = this.records.length;
	      } else {
	        var currentIndex;
	        if (this.currentRecord == null) {
	          currentIndex = 0;
	        } else {
	          currentIndex = this.records.indexOf(this.currentRecord);
	          if (currentIndex == -1) currentIndex = 0;
	        }
	
	        if (insertType == "Prev") index = currentIndex;else index = currentIndex + 1;
	      }
	
	      if (index < 0) index = 0;
	      if (index > this.records.length) index = this.records.length;
	
	      return index;
	    }
	  }, {
	    key: 'onRecordNext',
	    value: function onRecordNext(groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId) return;
	      this.doRecordNext();
	    }
	  }, {
	    key: 'doRecordNext',
	    value: function doRecordNext() {
	      if (window.lookupShowing) return;
	      if (this.records == null || this.records.length == 0) {
	        this.setCurrentRecord(null);
	        return;
	      }
	
	      var oldIndex = this.records.indexOf(this.currentRecord);
	      var index = 0;
	      //alert(oldIndex);
	      if (this.currentRecord == null) {
	        index = 0;
	      } else {
	        index = oldIndex + 1;
	      }
	
	      var findex = Math.min(index, this.records.length - 1);
	      this.setCurrentRecord(this.records[findex]);
	    }
	  }, {
	    key: 'onRecordPrev',
	    value: function onRecordPrev(groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId) return;
	      this.doRecordPrev();
	    }
	  }, {
	    key: 'doRecordPrev',
	    value: function doRecordPrev() {
	      if (window.lookupShowing) return;
	      if (this.records == null || this.records.length == 0) {
	        this.currentRecord = null;
	        return;
	      }
	
	      var oldIndex = this.records.indexOf(this.currentRecord);
	
	      var index = 0;
	      if (this.currentRecord == null) {
	        index = 0;
	      } else {
	        index = oldIndex - 1;
	      }
	
	      if (index < 0) {
	        index = 0;
	      }
	      this.setCurrentRecord(this.records[index]);
	    }
	  }, {
	    key: 'onDataGridUserChanged',
	    value: function onDataGridUserChanged(record, groupAlias, gridId, moduleInstanceId) {
	      var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	
	      if (this.groupAlias == groupAlias && moduleInstanceId == this.formDataSources.formModule.instanceUUId) {
	
	        //alert("setCurrentRecord");
	        this.currentRecord = record;
	        //alert("当前记录更改");
	        //this.currentRecordBak = Object.assign({},this.currentRecord);
	        //RecordsActions.currentRecordChanged(record,groupAlias,gridId);
	        /*if(delay == false)
	        {
	          window.groupActiveRecordStateObj[this.groupAlias].activingRecord=true;
	        }*/
	        this.activeCurrentRecord(true, gridId, delay, false, {}, true);
	        /*if(result == "FormLookup")
	        {
	          window.groupActiveRecordStateObj[this.groupAlias].activingRecord=false;
	          return;
	        }
	        if(delay == false)
	        {
	          var mi = FormResourceUtil.getCommandArgMethodInfo(this.mainSource.alias+".activeRecord",this.forLookup?"FormLookup":window.menuItemId,this.formDataSources.formModule.props.formId);
	          if(!mi || mi.prefetch == true)
	          {
	            window.groupActiveRecordStateObj[this.groupAlias].activingRecord=false;
	          }
	        }*/
	      }
	    }
	  }, {
	    key: 'isGlobalForehandGroup',
	    value: function isGlobalForehandGroup() {
	      var _parentWindow = window.parent.window;
	      return _parentWindow && _parentWindow.isCurrentWindow && _parentWindow.isCurrentWindow(window) && this == this.formDataSources.currentGroup;
	    }
	  }, {
	    key: 'isSelfForehandGroup',
	    value: function isSelfForehandGroup() {
	      return this == this.formDataSources.currentGroup;
	    }
	  }, {
	    key: 'activeRecordRemote',
	    value: function activeRecordRemote() {
	      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var onIcheckOnlyOne = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      // if(window.laterOperateFunction){
	      //   window.laterOperateFunction();
	      // }
	      // console.log("active",this.aliasList[0]);
	      _LayerManager2.default.executeLayerMethod(this.formDataSources.formModule, this, "activeRecord");
	      /*let _parentWindow = window.parent.window;
	      if(_parentWindow)
	      {
	        let layerLevels = _parentWindow.layerLevelConfig;
	        let formModule = this.formDataSources.formModule;
	        for(let i = layerLevels.length-1;i>-1;i--)
	        {
	          let layerName = layerLevels[i].name;
	          let layerConfig = _parentWindow.layerConfigs[layerName];
	          if(layerConfig)
	          {
	            let clsName = CommonUtil.getLayerDataSourceName(formModule.formName,this.mainSource.alias);
	            if(layerConfig.hasOwnProperty(clsName))
	            {
	              let classConfig = layerConfig[clsName];
	              let _cls = classConfig.classDef;
	              let cmdResult;
	              let mathodInfo = {fetchOption:true,groups:"all(cr,sr,ar,fq,cq)",editors:"all",joinGroup:"yes"};
	              if(typeof(_cls) == "function")
	              {
	                let instance = new _cls();
	                let commandArg = CommandResolver.getSendCmd(formModule, this.groupAlias, mathodInfo);
	                CommandArgFuncUtil.bindCommandArgFunc(commandArg);
	                cmdResult = instance.activeRecord(commandArg);
	              }
	              else if(typeof(_cls == "Object"))
	              {
	                let instance = _cls;
	                let commandArg = CommandResolver.getSendCmd(formModule, this.groupAlias, mathodInfo);
	                cmdResult = instance.activeRecord(commandArg);
	              }
	              if(cmdResult)
	              {
	                CommandResolver.resolve(cmdResult.tasks,formModule,this);
	              }
	              break;
	            }
	          }
	        }
	        }*/
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.mainSource.alias + ".activeRecord", this.forLookup ? "FormLookup" : window.menuItemId, this.formDataSources.formModule.props.formId);
	      if (mi) {
	        window.activeRemoting = true;
	        var formModule = this.formDataSources.formModule;
	        if (mi.prefetch == true) {
	          window.activeRemoting = false;
	          _CommandResolver2.default.resolve(mi.commandResult.tasks, formModule, this);
	        } else {
	          var arg = _CommandResolver2.default.getSendCmd(formModule, this.groupAlias, mi);
	          var command = _CommandHelper2.default.createFormInstance(formModule.formName, "doActiveRecord", "CommandResult");
	          command.appendArg(this.groupAlias, "String").appendArg(arg, "CommandArg");
	          window.groupActiveRecordStateObj[this.groupAlias].activingRecord = true;
	          if (sync) {
	            if (onIcheckOnlyOne) {
	              _ServiceHelper2.default.addTokenWithCommand({ command: command,
	                resultFunction: this.doActiveRecordRemoteResultHandlerActive.bind(this),
	                faultFunction: this.doActiveRecordRemoteFaultHandler.bind(this),
	                sync: true
	              });
	            } else {
	              _ServiceHelper2.default.addTokenWithCommand({ command: command,
	                resultFunction: this.doActiveRecordRemoteResultHandler.bind(this),
	                faultFunction: this.doActiveRecordRemoteFaultHandler.bind(this),
	                sync: true
	              });
	            }
	          } else {
	            _ServiceHelper2.default.addTokenWithCommand({ command: command,
	              resultFunction: this.doActiveRecordRemoteResultHandler.bind(this),
	              faultFunction: this.doActiveRecordRemoteFaultHandler.bind(this),
	              sync: false
	            });
	          }
	        }
	      } else {
	        window.activeRemoting = false;
	      }
	    }
	  }, {
	    key: 'doActiveRecordRemoteFaultHandler',
	    value: function doActiveRecordRemoteFaultHandler(data) {
	      window.activeRemoting = false;
	      if (data && data.successButNot0) {
	        _Warn2.default.show({ text: data.errText, title: "远程调用失败" });
	      } else {
	        _Warn2.default.show({ text: "请检查网络是否正常", title: "切换记录时远程调用失败" });
	      }
	      window.groupActiveRecordStateObj[this.groupAlias].activingRecord = false;
	      window.groupActiveRecordStateObj[this.groupAlias].cutClickEnter = false;
	    }
	  }, {
	    key: 'doActiveRecordRemoteResultHandlerActive',
	    value: function doActiveRecordRemoteResultHandlerActive(data) {
	      _CommandResolver2.default.resolve(data.result.tasks, this.formDataSources.formModule, this);
	      window.groupActiveRecordStateObj[this.groupAlias].activingRecord = false;
	
	      _FocusActions2.default.afterActiveRecord(this.groupAlias);
	      window.activeRemoting = false;
	      if (window.laterOperateFunction) {
	        window.laterOperateFunction();
	      }
	    }
	  }, {
	    key: 'doActiveRecordRemoteResultHandler',
	    value: function doActiveRecordRemoteResultHandler(data) {
	      _CommandResolver2.default.resolve(data.result.tasks, this.formDataSources.formModule, this);
	      window.groupActiveRecordStateObj[this.groupAlias].activingRecord = false;
	
	      _FocusActions2.default.afterActiveRecord(this.groupAlias);
	      window.activeRemoting = false;
	      if (window.laterOperateFunction) {
	        window.laterOperateFunction();
	      }
	    }
	  }, {
	    key: 'activeCurrentRecord',
	    value: function activeCurrentRecord(updateRelated, causeId) {
	      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var updateRelatedPart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var parms = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	      var doIcheckOnlyOneTime = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	
	      var lookupAlias = this.formDataSources.formModule.classAlias;
	      if (lookupAlias == "FormLookup") {
	        //万能视图 等 自动生成的下拉框 不需要根据activeRecord去更新toolbar
	        return "FormLookup";
	        /*var _parentWindow = window.parent.window;
	        if(!_parentWindow.setToolBar)
	          return "FormLookup";
	        let _toolBarObject = this.formDataSources.formModule.toolBarObject;
	        //let _toolBarObject = ToolBarUtil.createToolBarObj_Form_FormLookup();
	        ToolBarUtil.setObjectQueryRemove(_toolBarObject,this.queryChanged);
	        _parentWindow.setToolBar(_toolBarObject);
	        UtilActions.updateInnerToolBar(_toolBarObject);
	        return "FormLookup";*/
	      }
	      var _activeCurrentRecordSlow = this.activeCurrentRecordSlow.bind(this);
	      var _currentRecord = this.currentRecord;
	      if (delay) {
	        var timerId = setTimeout(function () {
	          _activeCurrentRecordSlow(_currentRecord, updateRelated, causeId, lookupAlias, true, updateRelatedPart, parms, doIcheckOnlyOneTime);clearTimeout(timerId);
	        }, 400);
	      } else {
	        _activeCurrentRecordSlow(_currentRecord, updateRelated, causeId, lookupAlias, false, updateRelatedPart, parms, doIcheckOnlyOneTime);
	      }
	    }
	  }, {
	    key: 'activeRecordLocal',
	    value: function activeRecordLocal() {
	      //TODO 对于prefetch是true 后台貌似会固定返回方法签名信息 且commandResult为null
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".clientActiveRecord", this.forLookup ? "FormLookup" : window.menuItemId, this.formDataSources.formModule.formId);
	      if (mi) {
	        if (mi.prefetch == true && mi.commandResult) {
	          _CommandResolver2.default.resolve(mi.commandResult.tasks, this.formDataSources.formModule, this);
	        }
	      }
	
	      this.countGroup();
	      return "doActiveRecordLocal";
	    }
	  }, {
	    key: 'countGroup',
	    value: function countGroup() {
	      var _parentWindow = window.parent.window;
	      if (!_parentWindow.userSettingEntry.showBottomSum) return;
	      var filterRecords = arguments[0];
	      $("#ActiveRecordCount", parent.document).text("");
	      if (this.formDataSources.formModule && this.formDataSources.formModule.classAlias == "FormModule") {
	        var numofdecimalses = [];
	        var _numofdecimals;
	        var _text = [];
	        var RecordCount = 0;
	        var DataField = [];
	        var textRestult = [];
	        for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	          var _item2 = _FormItemUtil2.default.formItemControlsForFor[key];
	          if (_item2.xml && _item2.xml.type == "DecimalEditor" && _item2.groupAlias == this.groupAlias && _item2.getProperty_AutoSum()) {
	            var dataField = _item2.getDataField();
	            DataField.push(dataField);
	            _numofdecimals = _item2.properties.NumOfDecimals;
	            if (_numofdecimals == -1) _numofdecimals = 0;
	            numofdecimalses.push(_numofdecimals);
	            var text = _item2.properties.Label + ":";
	            _text.push(text);
	
	            //if(DataField.length == 3)
	            //  break;
	            // resultKeyArr.push(dataField);
	          } else if (_item2.xml && _item2.xml.type == "LongEditor" && _item2.groupAlias == this.groupAlias && _item2.getProperty_AutoSum()) //item.xml.Properties.AutoSum.Value == "true") 
	            {
	              var _dataField5 = _item2.getDataField();
	              DataField.push(_dataField5);
	              //_numofdecimals = item.properties.NumOfDecimals;
	              //if (_numofdecimals == -1)
	              //   _numofdecimals = 0;
	              numofdecimalses.push(_numofdecimals);
	              var _text2 = _item2.properties.Label;
	              _text.push(_text2);
	
	              //if(DataField.length == 3)
	              //  break;
	              // resultKeyArr.push(dataField);
	            }
	        }
	        var StatusBar = {
	          tongjiObject: {
	            sum: true,
	            sel: true
	          }
	        };
	        var TotalNum = [];
	        var collection;
	        if (this.mainSource.isTempTable == true) {
	          collection = filterRecords ? filterRecords : this.tempRecordsFilter;
	          if (!collection) collection = this.records;
	        } else {
	          collection = this.records;
	        }
	        //var collection = filterRecords?filterRecords:this.records; //H5中的this.records
	        if (!collection || collection.length < 1) return;
	        var totalnum = 0;
	        RecordCount = collection.length;
	        for (var i = 0; i < DataField.length; i++) {
	          totalnum = 0;
	          collection.map(function (item) {
	            if (item[DataField[i]]) {
	              var value = item[DataField[i]];
	              var num = parseFloat(value);
	              totalnum += num;
	            } else totalnum += 0;
	          });
	          TotalNum.push(totalnum);
	        }
	        if (StatusBar.tongjiObject.sum) {
	          for (var i = 0; i < _text.length; i++) {
	            var _textresult = _text[i] + "[求和=" + TotalNum[i].toFixed(numofdecimalses[i]) + "]";
	            textRestult.push(_textresult);
	          }
	        }
	
	        if (StatusBar.tongjiObject.sel) {
	          var _selectedRecords = [];
	          _CommandActions2.default.getSelectRecords(_selectedRecords, this.groupAlias, this.formDataSources.formModule.instanceUUId);
	          if (_selectedRecords.length == 0 && this.currentRecord) _selectedRecords.push(this.currentRecord);
	
	          if (_selectedRecords.length > 1) {
	            RecordCount = _selectedRecords.length;
	            TotalNum = [];
	            textRestult = [];
	            totalnum = 0;
	            for (var j = 0; j < DataField.length; j++) {
	              totalnum = 0;
	              for (var i = 0; i < _selectedRecords.length; i++) {
	                var item = _selectedRecords[i];
	                var value = item[DataField[j]];
	                var num = parseFloat(value);
	                totalnum += num;
	              }
	              TotalNum.push(totalnum);
	            }
	            if (StatusBar.tongjiObject.sum) {
	              // _text += " 求和(选中)=" + totalnum.toFixed(_numofdecimals);
	              for (var i = 0; i < _text.length; i++) {
	                var _textresult2 = _text[i] + "[求和=" + TotalNum[i].toFixed(numofdecimalses[i]) + "]";
	                textRestult.push(_textresult2);
	              }
	            }
	          }
	        }
	
	        var footertext = "计数=" + RecordCount + " ";
	        for (var i = 0; i < textRestult.length; i++) {
	          footertext += textRestult[i] + " ";
	        }
	        $("#ActiveRecordCount", parent.document).text(footertext);
	        this.formDataSources.formModule.lastAutoSumInfo = footertext;
	      }
	    }
	  }, {
	    key: 'activeCurrentRecordSlow',
	    value: function activeCurrentRecordSlow(baseRecord, updateRelated, causeId, lookupAlias) {
	      var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	      var updateRelatedPart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	      var parms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
	      var onIcheckOnlyOne = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	
	      if (this.currentRecord == baseRecord) {
	        //TODO_yl  当同时 执行 selectRecords 命令时 不执行当前
	        if (this.doSelectRecords) {
	          this.doSelectRecords = undefined;
	          return;
	        }
	        _RecordsActions2.default.groupCurrentRecordChanged(this.records, this.currentRecord, this.groupAlias, this.formDataSources.formModule.instanceUUId, causeId, this, parms);
	
	        if (lookupAlias == "FormModule") this.activeToolBarByRecord(this.currentRecord);
	        var recordlocal = this.activeRecordLocal();
	        if (lookupAlias == "FormModule" && _ToolBarUtil2.default.getObjectAttachment(window.toolBarObject)) this.activeAttachment(this.currentRecord);
	        if (updateRelated) {
	          var _parentWindow = window.parent.window;
	          if (_parentWindow) {
	            //alert("更新关联");
	            _parentWindow.linkGroupActiveJoin(this, window.formModuleInstanceuuId, delay, updateRelatedPart);
	          }
	        }
	        if (recordlocal) {
	          this.activeRecordRemote(true, onIcheckOnlyOne);
	        } else {
	          this.activeRecordRemote(false, onIcheckOnlyOne);
	        }
	      } else {}
	    }
	  }, {
	    key: 'doLinkActive',
	    value: function doLinkActive() {
	      var formModule = this.formDataSources.formModule;
	      var formId = formModule.props.formId;
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.mainSource.alias + ".linkActive", this.forLookup ? "FormLookup" : window.menuItemId, this.formDataSources.formModule.props.formId);
	      if (mi != null) {
	        if (mi.prefetch == true) {
	          if (mi.commandResult) _CommandResolver2.default.resolve(mi.commandResult.tasks, formModule, this);
	        } else {
	          var arg = _CommandResolver2.default.getSendCmd(formModule, this.groupAlias, mi);
	          var command = _CommandHelper2.default.createFormInstance(formModule.formName, "doLinkActive", "CommandResult");
	          command.appendArg(this.groupAlias, "String").appendArg(arg, "CommandArg");
	
	          _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.doLinkActiveResultHandler.bind(this), sync: false });
	        }
	      }
	    }
	  }, {
	    key: 'doLinkActiveResultHandler',
	    value: function doLinkActiveResultHandler(data) {
	      _CommandResolver2.default.resolve(data.result.tasks, this.formDataSources.formModule, this);
	    }
	  }, {
	    key: 'activeAttachment',
	    value: function activeAttachment() {
	      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (this.mainSource.isTempTable == true) return;
	
	      if (record == null) record = this.currentRecord;
	
	      /*TODO activeCurrentRecord若要支持Attachment 则setState var attachmentaukey = "3_" + window.menuItemId + "." + this.mainSource.xml.id;
	      if(record == null)
	      {
	        Attachment.Instance.refresh(null, null, attachmentaukey,this);
	        return;
	      }*/
	
	      if (this.isGlobalForehandGroup()) {
	
	        if (record == null) {
	          var _parentWindow = window.parent.window;
	          if (_parentWindow) {
	            _parentWindow.updateAttachmentNum(0);
	          }
	          window.updateAttachmentNum(0);
	          this._lastAttachmentNum = 0;
	          return;
	        }
	
	        var tableId = _GOTUtil2.default.getProperty(this.mainSource.xml, "Table").refentityid;
	        var tableName = this.mainSource.xml.name;
	        var recId = record[tableName + ".recId"];
	        //Attachment.Instance.refresh(tableId,recId,attachmentaukey,this);
	        var command = _Command2.default.createService("gongqi.erp.gotmodel.services.AttachmentService", "sizeOfAttachments", "int");
	
	        command.appendArg(tableId + "/" + recId);
	        var _rpc_result_getAttachmentHandler = this.rpc_result_getAttachmentHandler.bind(this);
	        _ServiceHelper2.default.addTokenWithCommand({ command: command,
	          resultFunction: function resultFunction(data) {
	            _rpc_result_getAttachmentHandler(data, record);
	          },
	          faultFunction: null, sync: false, autoLock: false, autoUnlock: false });
	      }
	    }
	  }, {
	    key: 'rpc_result_getAttachmentHandler',
	    value: function rpc_result_getAttachmentHandler(data, baseRecord) {
	      if (baseRecord == this.currentRecord && this.isGlobalForehandGroup()) {
	        var _length = data.result;
	        var _parentWindow = window.parent.window;
	        if (_parentWindow) {
	          _parentWindow.updateAttachmentNum(_length);
	        }
	        if (window.updateAttachmentNum) window.updateAttachmentNum(_length);
	        this._lastAttachmentNum = _length;
	      }
	    }
	  }, {
	    key: 'activeToolBarByRecord',
	    value: function activeToolBarByRecord(record) {
	      if (window.isDataSetView == true) {
	        var _parentWindow = window.parent.window;
	        var toolBarObject = window.toolBarObject;
	
	        if (this.dataSetQueryTable.queryOrderBy.length > 0 || this.dataSetQueryTable.queryWhere.length > 0) {
	          toolBarObject.QueryRemove = true;
	        } else {
	          toolBarObject.QueryRemove = false;
	        }
	
	        _parentWindow.setToolBar(toolBarObject);
	        _UtilActions2.default.updateInnerToolBar(toolBarObject);
	
	        _ToolBarActions2.default.updateGridToolBar({ add: false,
	          del: false,
	          save: false,
	          query: true,
	          fatchAll: false,
	          groupAlias: this.groupAlias });
	
	        return;
	      }
	
	      if (!this.isSelfForehandGroup()) return;
	      if (record == undefined) record = this.currentRecord;
	      //if(record == undefined || record == null)
	      //  return;
	      var toolBarObject = window.toolBarObject;
	
	      _ToolBarUtil2.default.setObjectSave(toolBarObject, this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Save, record));
	      var queryEnable = this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Query, record);
	      _ToolBarUtil2.default.setObjectQuery(toolBarObject, queryEnable);
	      if (this.mainSource.isAggreateTable == true) _ToolBarUtil2.default.setObjectRestore(toolBarObject, false);
	      if (queryEnable) {
	        _ToolBarUtil2.default.setObjectQueryRemove(toolBarObject, this.queryChanged);
	      }
	      _ToolBarUtil2.default.setObjectExport(toolBarObject, this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Export, record));
	      if (!window.hasPrint()) _ToolBarUtil2.default.setObjectPrint(toolBarObject, false);
	
	      _ToolBarUtil2.default.setObjectDelete(toolBarObject, this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Delete, record));
	
	      _ToolBarUtil2.default.setObjectNew(toolBarObject, this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Add, record));
	      var attachment = this.ds_AllowAttachment;
	      if (attachment == true) {
	        var mainSource = this.mainSource.xml;
	        var allow = mainSource.Properties.AllowAttachment.Value;
	        attachment = allow == "true";
	      }
	      _ToolBarUtil2.default.setObjectAttachment(toolBarObject, attachment);
	      _ToolBarActions2.default.updateGridToolBar({ add: _ToolBarUtil2.default.getObjectNew(toolBarObject),
	        del: _ToolBarUtil2.default.getObjectDelete(toolBarObject),
	        save: _ToolBarUtil2.default.getObjectSave(toolBarObject),
	        query: _ToolBarUtil2.default.getObjectQuery(toolBarObject),
	        groupAlias: this.groupAlias });
	      if (this.isGlobalForehandGroup()) {
	        var _parentWindow = window.parent.window;
	        _parentWindow.setToolBar(toolBarObject);
	        _UtilActions2.default.updateInnerToolBar(toolBarObject);
	      }
	    }
	  }, {
	    key: 'getCurrentRecordAuthorityGOT',
	    value: function getCurrentRecordAuthorityGOT(formDataSourceName, authorityType, record) {
	      //见FormDataSourceAuthority枚举类
	      //int表示权限类型 visible export等
	      //
	      if (record == null) {
	        if (authorityType == _FormDataSourceAuthorityType2.default.Save || authorityType == _FormDataSourceAuthorityType2.default.Edit || authorityType == _FormDataSourceAuthorityType2.default.Delete) return false;
	      }
	      return this.getCurrentRecordAuthorityByXML(authorityType);
	    }
	  }, {
	    key: 'getCurrentRecordAuthorityByXML',
	    value: function getCurrentRecordAuthorityByXML(type) {
	      var value;
	      if (type == _FormDataSourceAuthorityType2.default.Add) {
	        value = this.mainSource.xml.Properties.AllowAdd.Value;
	      } else if (type == _FormDataSourceAuthorityType2.default.Delete) {
	        value = this.mainSource.xml.Properties.AllowDelete.Value;
	      } else if (type == _FormDataSourceAuthorityType2.default.Edit) {
	        value = this.mainSource.xml.Properties.AllowEdit.Value;
	      } else if (type == _FormDataSourceAuthorityType2.default.Export) {
	        value = this.mainSource.xml.Properties.AllowExport.Value;
	      } else if (type == _FormDataSourceAuthorityType2.default.Query) {
	        value = this.mainSource.xml.Properties.AllowQuery ? this.mainSource.xml.Properties.AllowQuery.Value : this.mainSource.xml.Properties.AllowChangeQuery.Value;
	      } else if (type == _FormDataSourceAuthorityType2.default.Save) {
	        value = this.mainSource.xml.Properties.AllowSave.Value;
	      }
	
	      if (value == "true" || value == true) return true;
	      return false;
	    }
	  }, {
	    key: 'consOnedimensionalGridColByAnlysis',
	    value: function consOnedimensionalGridColByAnlysis() {
	      var _group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (_group == null) _group = this;
	
	      if (_group.sources.length > 1) var isNeedTableName = true;else isNeedTableName = false;
	
	      var resultArr = [];
	      var tmp = [];
	      var focusableItemsQue1 = window.formModuleInstance.focusController.focusableItemsQue1;
	      for (var i = 0; i < focusableItemsQue1.length; i++) {
	        var focusableItem = focusableItemsQue1[i];
	        var formItem = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, focusableItem.id));
	
	        if (window.isDataSetView) {
	          this.dataSetQueryTable.allQueryFields = [];
	          this.getAllQueryFieldssForDataSetView(this.dataSetQueryTable);
	
	          for (var k in this.dataSetQueryTable.allQueryFields) {
	            if (this.dataSetQueryTable.allQueryFields[k].fieldAliasName && this.dataSetQueryTable.allQueryFields[k].fieldAliasName == formItem.dataSource_Field || _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[k].fieldName) == formItem.dataSource_Field) {
	              formItem.dataField = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName;
	              formItem.dataSource_Alias = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.substr(0, this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.lastIndexOf("."));
	              var tableXML = _GOT2.default.getTable(this.dataSetQueryTable.allQueryFields[k].refEntityId);
	              var tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	              formItem.comDataSetLabel = tableLabel;
	            }
	          }
	        }
	        if (formItem.group == _group && formItem.dataSource_Alias != "" && formItem.dataSource_Field != "") {
	          var fe = formItem;
	          if (fe.classAlias == "FormItemTimeEditorControl") continue;
	          if (fe.classAlias == "FormItemStringEditorControl" && fe.isDataAnlysFilter()) continue;
	
	          var oneddatafield;
	          if (fe.dataSource_Field.indexOf(".") == -1) {
	            oneddatafield = fe.dataSource_Alias + "-" + _StringUtil2.default.convertToFirstLowerCase(fe.dataSource_Field);
	          } else {
	            var _array = fe.dataSource_Field.split(".");
	            oneddatafield = fe.dataSource_Alias + "-" + _StringUtil2.default.convertToFirstLowerCase(_array[0]) + "-" + _StringUtil2.default.convertToFirstLowerCase(_array[1]);
	          }
	          if (!fe.isDataMethodField) {
	            var fieldObj = this.getFormDataSourceField(fe.dataSource_Field, fe.dataSource_Alias);
	            var dataSourceFieldXML = fieldObj.field;
	            if (dataSourceFieldXML == null) continue;
	            this.saveFieldCache(dataSourceFieldXML, oneddatafield);
	          }
	          if (tmp.indexOf(oneddatafield) != -1) continue;
	          tmp.push(oneddatafield);
	          if (!fe.getProperty_Visible_Final()) continue;
	          var _type = fe.xml.type;
	          var _fieldType = _type.substr(0, _type.length - "Editor".length);
	          var item = {};
	          item.fieldType = _fieldType;
	          item.dataField = oneddatafield;
	          if (fe.classAlias == "FormItemDecimalEditorControl") item.numOfDecimals = fe.getProperty_NumOfDecimals();
	          var _label = formItem.getProperty_Label(false);
	          var _totalLabel;
	          if (isNeedTableName) {
	            var sourceName = formItem.dataSource_Alias;
	            for (var _i7 = 0; _i7 < _group.sources.length; _i7++) {
	              var source = _group.sources[_i7];
	              if (source.alias == sourceName) break;
	            }
	            if (!window.isDataSetView) {
	              if (source.alias != sourceName) continue;
	              var tableName = _GOTUtil2.default.getPropertyValue(source.xml, "Table");
	              var tableXML = _GOT2.default.getTable(tableName);
	              var tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	              _totalLabel = tableLabel + "." + _label;
	            } else {
	              _totalLabel = formItem.comDataSetLabel + "." + _label;
	            }
	          } else {
	            _totalLabel = _label;
	          }
	          item.headerText = _totalLabel;
	          resultArr.push(item);
	        }
	      }
	
	      return resultArr;
	    }
	  }, {
	    key: 'dataAnlys',
	    value: function dataAnlys(filter) {
	      var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!this.getAuthorityByXML(_FormDataSourceAuthorityType2.default.exportStr)) return;
	      if (!this.records || this.records.length <= 0) {
	        _Warn2.default.show({ text: "当前无记录 无法进行数据分析", state: "info" });
	        return;
	      }
	      var focusableItemsQue1 = window.formModuleInstance.focusController.focusableItemsQue1;
	      for (var i = 0; i < focusableItemsQue1.length; i++) {
	        var focusableItem = focusableItemsQue1[i];
	        var formItem = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, focusableItem.id));
	        if (formItem.group == this && formItem.dataSource_Alias != "" && formItem.dataSource_Field != "") {
	          var fe = formItem;
	          var oneddatafield = void 0;
	          if (fe.dataSource_Field.indexOf(".") == -1) {
	            oneddatafield = fe.dataSource_Alias + "-" + _StringUtil2.default.convertToFirstLowerCase(fe.dataSource_Field);
	          } else {
	            var _array = fe.dataSource_Field.split(".");
	            oneddatafield = fe.dataSource_Alias + "-" + _StringUtil2.default.convertToFirstLowerCase(_array[0]) + "-" + _StringUtil2.default.convertToFirstLowerCase(_array[1]);
	          }
	          if (!this.fieldCache.hasOwnProperty(oneddatafield)) {
	            if (!fe.isDataMethodField) {
	              var fieldObj = this.getFormDataSourceField(fe.dataSource_Field, fe.dataSource_Alias);
	              var dataSourceFieldXML = fieldObj.field;
	
	              if (!dataSourceFieldXML) continue;
	              this.saveFieldCache(dataSourceFieldXML, oneddatafield);
	            }
	          }
	        }
	      }
	      var _records = this.records;
	      if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	        _records = this.tempRecordsFilter;
	      }
	      var ac = this.convertToOnedimensional1(_records, filter);
	      var headerInfo = this.consOnedimensionalGridColByAnlysis();
	      for (var _i8 = 0; _i8 < headerInfo.length; _i8++) {
	        var _column = headerInfo[_i8];
	        _column.visible = true;
	      }
	      var key = window.formId + "_" + this.mainSource.xml.id + "." + window.menuItemId;
	      if (window.isDataSetView == true) {
	        var strac = JSON.stringify(ac);
	        var jsonac = JSON.parse(strac);
	        if (window.isDataSetView) {
	          for (var kk = 0; kk < jsonac.length; kk++) {
	            var dsItem = jsonac[kk];
	            for (var k in dsItem) {
	              for (var _i9 in this.dataSetQueryTable.allQueryFields) {
	                if (this.dataSetQueryTable.allQueryFields[_i9].fieldAliasName && this.groupAlias + "-" + this.dataSetQueryTable.allQueryFields[_i9].fieldAliasName == k || this.groupAlias + "-" + _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[_i9].fieldName) == k) {
	                  dsItem[this.dataSetQueryTable.allQueryFields[_i9].dataSourceFliedName.replace(".", "-")] = dsItem[k];
	                  if (this.dataSetQueryTable.allQueryFields[_i9].dataSourceFliedName.indexOf(this.groupAlias) == -1) {
	                    delete dsItem[k];
	                  }
	                }
	              }
	            }
	          }
	        }
	        var columsCount = 0;
	        for (var _i10 in headerInfo) {
	          var item = headerInfo[_i10];
	          if (item.visible) {
	            columsCount++;
	          }
	        }
	        if (columsCount * jsonac.length >= 800000) {
	          _reactDom2.default.render(_react2.default.createElement(_PivotExportDialog2.default, { parent: this }), document.getElementById('pivotExportModal'));
	        } else {
	          this.exportToPivot_test(headerInfo, jsonac, key);
	        }
	      } else {
	        var extrals = this.getExtralExportFields1(headerInfo, filter);
	        for (var _i11 = 0; _i11 < extrals.length; _i11++) {
	          var _item3 = extrals[_i11];
	          _item3.visible = false;
	        }
	        headerInfo = headerInfo.concat(extrals);
	        var _columsCount = 0;
	        for (var _i12 in headerInfo) {
	          var _item4 = headerInfo[_i12];
	          if (_item4.visible) {
	            _columsCount++;
	          }
	        }
	        if (_columsCount * ac.length >= 800000) {
	          _reactDom2.default.render(_react2.default.createElement(_PivotExportDialog2.default, { parent: this }), document.getElementById('pivotExportModal'));
	        } else {
	          this.exportToPivot_test(headerInfo, ac, key, flag);
	        }
	        // this.exportToPivot_test(headerInfo,ac,key,flag);
	      }
	      /*var extrals = this.getExtralExportFields1(headerInfo,filter);
	      for(let i = 0;i<extrals.length;i++)
	      {
	        let item = extrals[i];
	        item.visible = false;
	      }
	      headerInfo = headerInfo.concat(extrals);
	      var key = window.formId + "_" + this.mainSource.xml.id + "." + window.menuItemId;
	      this.exportToPivot_test(headerInfo,ac,key);*/
	    }
	  }, {
	    key: 'exportToPivot_test',
	    value: function exportToPivot_test(header, ac, _configKey) {
	      var flag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var tmp = {};
	      tmp["rows"] = [];
	      tmp["cols"] = [];
	      var s2 = JSON.stringify(tmp);
	
	      var s3 = "{}";var json = {};
	      if (true) {
	        var args = {};json["args"] = args;var columns = [];
	        json["columns"] = columns;var numDecimals = {};json["numDecimals"] = numDecimals;
	        var _parentWindow = window.parent.window;
	        json["config"] = {
	          configKey: _configKey,
	          userId: _parentWindow.userInfos.userId, dataArea: _parentWindow.userInfos.subSysId,
	          serviceURL: _parentWindow.userInfos.pivotURL
	        };
	        if (flag == 'drop') {
	          window.parent.window.toolbarPivotDrop(json["config"]);
	          return;
	        }
	
	        //循环datagrid字段名
	        for (var i = 0; i < header.length; i++) {
	          var field = header[i];var column = {};
	          column["id"] = field.dataField;
	          column["label"] = field.headerText || field.totalLabel || field.label;
	          column["type"] = field.fieldType;
	          column["visible"] = field.visible;
	          if (column["type"] == "Decimal") {
	            column["concept"] = "Value";
	            numDecimals[field.dataField] = field.numOfDecimals;
	          } else if (column["type"] == "Date") {
	            column["concept"] = "Date";
	          } else {
	            column["concept"] = "Dim";
	          }
	          columns.push(column);
	
	          if (column.type == "Date") {
	            var extralColumn = {};
	            extralColumn.id = column.id + "-year";
	            extralColumn.label = column.label + "(年)";
	            extralColumn.type = "ExtralYear";
	            extralColumn.concept = "Dim";
	            extralColumn.visible = true;
	            columns.push(extralColumn);
	
	            extralColumn = {};
	            extralColumn.id = column.id + "-month";
	            extralColumn.label = column.label + "(月)";
	            extralColumn.type = "ExtralMonth";
	            extralColumn.concept = "Date";
	            extralColumn.visible = true;
	            columns.push(extralColumn);
	          }
	        }
	        columns.push({ id: "recordNum", label: "记录条数", type: "Decimal", concept: "Value", visible: true });
	        numDecimals[field.dataField] = 0;
	        var arr = [];var key;
	        for (var _i13 = 0; _i13 < ac.length; _i13++) {
	          var tmp1 = ac[_i13];var obj = {};
	          for (var k = 0; k < columns.length; k++) {
	            var _column2 = columns[k];
	            if (_column2.type == "ExtralYear") {
	              var dateValue = tmp1[key];
	              if (!dateValue || dateValue == "null") {
	                var dateValueNext = "";
	              } else {
	                var temparray = dateValue.split("-");
	                dateValueNext = temparray[0];
	              }
	
	              obj[key + "-year"] = dateValueNext;
	            } else if (_column2.type == "ExtralMonth") {
	              dateValue = tmp1[key];
	              if (!dateValue || dateValue == "null") {
	                dateValueNext = "";
	              } else {
	                temparray = dateValue.split("-");
	                dateValueNext = temparray[0] + "-" + temparray[1];
	              }
	              obj[key + "-month"] = dateValueNext;
	            } else {
	              key = _column2.id;
	              if (key == "recordNum") {
	                obj[key] = 1;
	              } else {
	                var tempkey = tmp1[key];
	                if (typeof tempKey === "string") tempkey = tempkey.replace(/\"/g, "");
	                obj[key] = tempkey;
	              }
	            }
	          }
	
	          for (var keyloop in tmp1) {
	            if (!obj.hasOwnProperty(keyloop)) {
	              var _value = tmp1[keyloop];
	              if (typeof _value === "string") obj[keyloop] = _value.replace(/\"/g, "");
	            }
	          }
	
	          arr.push(obj);
	        }
	        json["lines"] = arr;
	
	        //s3 = JSON.stringify(json);
	        //var pattern = new RegExp("\\\\","g");
	        //s3 = s3.replace(pattern,"\\\\\\\\");
	      }
	
	      sessionStorage.setItem("pivot_rowscols", tmp);
	      //sessionStorage.setItem("jsondata", s3);
	      sessionStorage.setItem("subSysId", window.parent.window.userInfos.subSysId);
	      window.parent.window.addDBPivotData({ id: 'tmp', data: { pivot_rowscols: tmp, jsondata: json } });
	
	      if (!window.parent.window.didomain) {
	        if (flag && flag != 'drop') {
	          window.open("pivot/pivot.html?initpivot=" + flag.fileName + "&user=" + flag.user);
	        } else {
	          window.open("pivot/pivot.html?");
	        }
	      } else {
	        var url = window.parent.window.parent.pivotUrl;
	        if (!url) {
	          alert("请先安装图表分析器APP");
	          return;
	        }
	        var record = {
	          url: url + '?dataFrom=zxbg',
	          icon: '../images/pivot.svg',
	          suffix: '.gongqi',
	          gongQiFileId: new Date().getTime() + '-',
	          win_title: '图表分析器',
	          name: '图表分析器',
	          office: false,
	          pageURL: url + '?dataFrom=zxbg',
	          dsOpenType: 'pivot'
	        };
	        window.parent.window.parent.openWindowByFileManage(record);
	      }
	
	      //var _result = ExternalInterface.call("openPivotTable", s2, s3);
	    }
	  }, {
	    key: 'getSpecExportData',
	    value: function getSpecExportData(ac) {
	      if (!this.getAuthorityByXML("export")) {
	        return;
	      }
	      var _key = window.formId + "_" + this.mainSource.xml.id + (window.menuItemId ? "." + window.menuItemId : "");
	      var columns;
	      var userDefaultExport = _FormDataSources2.default.getUserDefaultExportList(_key);
	      if (userDefaultExport) {
	        columns = this.consOnedimensionalGridColBySetting(userDefaultExport);
	      } else {
	        columns = this.consOnedimensionalGridColByView();
	      }
	      if (!columns || columns.length == 0) return;
	      var filter = [];
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var control = _FormItemUtil2.default.formItemControlsForFor[key];
	        if (control && control.classAlias == "FormItemStringEditorControl") {
	          if (control.getDisplayAsPassword()) filter.push(control.getDataField());
	        }
	      }
	
	      var _ac = this.convertToOnedimensional(ac, filter);
	      if (!_ac) _ac = [];
	      var headerInfo = [];
	
	      for (var _i14 = 0; _i14 < columns.length; _i14++) {
	        var col = columns[_i14];
	
	        var item = { dataField: col.dataField, headerText: col.headerText, fieldType: col.fieldType };
	        /*if(col.fieldType == "Decimal")
	        {
	          let control = FormItemUtil.formItemControls[window.menuItemId+"."+window.formId+"."+col.formItemId];
	          if(control && control.classAlias == "FormItemDecimalEditorControl")
	          {
	            item.numOfDecimals = control.getProperty_NumOfDecimals();
	          }
	        }*/
	        headerInfo.push(item);
	      }
	
	      var rowCount = _ac.length;
	      var data = "";
	      var fieldSeparator = "\t";
	      var lineSeparator = "\n";
	      var fields = [];
	      //循环表头数据
	
	      for (var i = 0; i < headerInfo.length; i++) {
	        var filed = headerInfo[i];
	        fields.push(filed.dataField);
	        data += filed.headerText + fieldSeparator;
	        if (i == headerInfo.length - 1) {
	          data += lineSeparator;
	        }
	      }
	
	      //循环行数据
	      for (var i = 0; i < rowCount; i++) {
	        var record = _ac[i];
	        for (var j = 0; j < fields.length; j++) {
	          var field_ = fields[j];
	          data += record[field_] + fieldSeparator;
	        }
	        data += lineSeparator;
	      }
	
	      return data;
	    }
	  }, {
	    key: 'getAuthorityByXML',
	    value: function getAuthorityByXML(type) {
	      var _parentWindow = window.parent.window;
	      if (_parentWindow.userInfos.isAdmin == true) return true;
	
	      var valueMainSource;
	      var valueSources;
	
	      valueMainSource = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId && window.menuItemId != "" ? window.menuItemId : window.formXML.name, this.mainSource.xml.id, type);
	      var finalValue = true;
	      var isForbidden = false;
	      var finalValueSetted = false;
	      if (valueMainSource["isDefault"] == false) {
	        finalValue = valueMainSource["result"];
	        finalValueSetted = true;
	        isForbidden = valueMainSource["isForbidden"];
	      }
	
	      if (isForbidden) return false;
	
	      valueSources = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId && window.menuItemId != "" ? window.menuItemId : window.formXML.name, this.formDataSources.xml.id, type);
	
	      if (valueSources["isDefault"] == false) {
	        if (!finalValueSetted) {
	          finalValue = valueSources["result"];
	          finalValueSetted = true;
	        }
	        isForbidden = valueSources["isForbidden"];
	      }
	
	      if (finalValueSetted) {
	        return finalValue && !isForbidden;
	      }
	
	      if (window.getIsQueryOnlyFromMenuItem() == true && (type == _FormDataSourceAuthorityType2.default.newStr || type == _FormDataSourceAuthorityType2.default.saveStr || type == _FormDataSourceAuthorityType2.default.delStr)) return false;
	
	      return true;
	    }
	
	    /**
	     * 查询权限始终跟当前记录无关 若是获得查询权限 record请传入null
	     * **/
	
	  }, {
	    key: 'getAuthorityFinal',
	    value: function getAuthorityFinal(formDataSourceName, autype, record) {
	      if (this.forLookup && autype != _FormDataSourceAuthorityType2.default.Query) return false;
	      if (autype == _FormDataSourceAuthorityType2.default.Save || autype == _FormDataSourceAuthorityType2.default.Delete || autype == _FormDataSourceAuthorityType2.default.Add) {
	        if (this.mainSource.isAggreateTable == true) {
	          return false;
	        }
	
	        if (window.getIsQueryOnlyFromMenuItem() == true) return false;
	      }
	
	      if (autype == _FormDataSourceAuthorityType2.default.Delete) {
	        if (record) {
	          if (record["recVersion"] == -1 || record[this.groupAlias + ".recVersion"] == -1) {
	            return true;
	          }
	        }
	      }
	
	      var cmdName = _FormDataSourceAuthorityType2.default.getDSName(autype);
	      var cmd = this[cmdName];
	
	      if (cmdName && this.hasOwnProperty(cmdName) && cmd == false) return false;
	      var xmltype = _FormDataSourceAuthorityType2.default.getXMLName(autype);
	      var result = this.getAuthorityByXML(xmltype) && this.getCurrentRecordAuthorityGOT(formDataSourceName, autype, record);
	      if (result == false) return false;
	
	      if (autype == _FormDataSourceAuthorityType2.default.Save || autype == _FormDataSourceAuthorityType2.default.Delete || autype == _FormDataSourceAuthorityType2.default.Add) {
	        var _isCurrentRecordLocked = this.isCurrentRecordLocked(record);
	        if (autype == _FormDataSourceAuthorityType2.default.Add && !this.lockedRecNew && _isCurrentRecordLocked == true) _isCurrentRecordLocked = false;
	        if (_isCurrentRecordLocked == true) {
	          // var ff:FreeForm = this.formDataSources.formModule.parent as FreeForm;
	          // if(ff)
	          //   var ftitle:String = ff.title;
	          // else
	          //   ftitle = this.formDataSources.formModule.label;
	          // if(autype == FormDataSourceAuthorityType.Save && ftitle.indexOf(FreeFormConst.MODIFIEDLABEL) != -1)
	          // {
	          //   _isCurrentRecordLocked = false;
	          // }
	        }
	      } else {
	        _isCurrentRecordLocked = false;
	      }
	
	      if (_isCurrentRecordLocked == true) return false;
	
	      var extral = true;
	      if (autype == _FormDataSourceAuthorityType2.default.Add) {
	        if (this.isLinkGroupRecordNull()) return false;
	        extral = !this.lockedRecNew && !(this.mainSource.tableGroup == "SingleParm" && record != null);
	      }
	
	      return extral;
	    }
	  }, {
	    key: 'isLinkGroupRecordNull',
	    value: function isLinkGroupRecordNull() {
	      if (this.linkGroup) {
	        var curVersion = this.linkGroup.getCurRecVersion();
	        if (curVersion < 0) return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isLinkGroup',
	    value: function isLinkGroup(sourceGroup, fromFormId) {
	      if (this.linkGroup == sourceGroup) {
	        //alert("1"+this.linkType);
	        //暂时屏蔽同画面的处理
	        if (this.linkType == "Passive" || this.linkType == "Delayed" || this.linkType == "Active") return false;
	      }
	
	      if (window.hasOwnProperty("argCaller")) {
	
	        var argCaller = window.argCaller;
	        //alert("2"+argCaller.callerType + "formId:"+formId+"callerId:"+argCaller.callerId);
	        if (argCaller.callerType == "FormModule" && fromFormId == argCaller.callerId) {
	          if (argCaller.joinGroupAlias == sourceGroup.groupAlias) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'setFormDataSourceGroupArg',
	    value: function setFormDataSourceGroupArg(arg) {
	      var opr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      arg.aliasList = [];
	
	      var tempDataMethodField = this.getTempDataMethodField();
	
	      var selectedRecords = [];
	      _CommandActions2.default.getSelectRecords(selectedRecords, this.groupAlias, this.formDataSources.formModule.instanceUUId, opr == "restore");
	
	      //getSelectedRecords为了后台能解析复制记录并加入了remoteClass 所以先去掉这个异常情况的检测
	      //TODO 某些二次开发会查询后直接保存 恢复等（不知道这样做是否合理) 此时FormITemDataGrid还没有更新(由于延迟换行)
	      // 但是currentRecord已经在local定位中更新 此时会出现临时性的不一致 但是Group的currentRecord是即时同步更新的
	      //所以当存在这种情况 以FormItemDataSourceGroup.currentRecord为准
	      if (selectedRecords.length == 1 && selectedRecords[0] != this.currentRecord) {
	        //alert("FormDataSourceGroup -> setFormDataSourceGroupArg 当前记录与Grid选中记录不一致 currentRecord:"+
	        //  JSON.stringify(this.currentRecord) + "       selectedRecords:"+JSON.stringify(selectedRecords[0]));
	        selectedRecords = [this.currentRecord];
	      }
	
	      if (selectedRecords.length == 0) {
	        selectedRecords.push(this.currentRecord);
	      }
	
	      var _count = 0;arg.arg = {};
	      for (var i = 0; i < selectedRecords.length; i++) {
	        var fRecord = {};
	        Object.assign(fRecord, selectedRecords[i]);
	        this.deleteRecordTempDataMethodField(fRecord);
	        var _record = _RecordsUtil2.default.getSecondaryRecord(fRecord, this.groupAlias);
	        if (opr == "restore") {
	          if (_record["recVersion"] != -1) {
	            arg.arg[_count] = _record;
	            _count++;
	          }
	        } else {
	          arg.arg[_count] = _record;
	          _count++;
	        }
	      }
	      arg.aliasList.push(this.groupAlias);
	      arg.recordCounts = _count;
	    }
	  }, {
	    key: 'onRecordAutoSave',
	    value: function onRecordAutoSave(groupAlias) {
	      if (groupAlias == this.groupAlias) return this.doRecordSave(true, true);
	    }
	  }, {
	    key: 'deleteSelectedTempRecords',
	    value: function deleteSelectedTempRecords(recIds) {
	      if (this.mainSource.isTempTable == true && recIds.length > 0) {
	        var mainAlias = this.mainSource.alias;
	        var locateNextRecId = "";
	        var flag = 0;var length = this.records.length;var _records = [];var next;var pre;
	        var dontLocate = false;
	
	        if (this.tempRecordsFilter) {
	          for (var i = 0; i < this.tempRecordsFilter.length; i++) {
	            var record = this.tempRecordsFilter[i];
	            var recId = record[mainAlias + ".recId"];
	            if (recIds.indexOf(recId) != -1) _records.push(record);
	          }
	        } else {
	          for (var i = 0; i < this.records.length; i++) {
	            var record = this.records[i];
	            var recId = record[mainAlias + ".recId"];
	            if (recIds.indexOf(recId) != -1) _records.push(record);
	          }
	        }
	
	        if (_records.indexOf(this.currentRecord) == -1) {
	          dontLocate = true;
	        }
	
	        var thisRecord = this.tempRecordsFilter ? this.tempRecordsFilter : this.records;
	
	        for (var k = 0; k < _records.length; k++) {
	          var record = _records[k];
	          var index = thisRecord.indexOf(record);
	          if (locateNextRecId == "" && dontLocate == false) {
	            if (index > 0) {
	              pre = thisRecord[index - 1];
	            } else {
	              pre = null;
	            }
	
	            if (pre != null) {
	              var preRecId = pre[mainAlias + ".recId"];
	              if (recIds.indexOf(preRecId) == -1) locateNextRecId = preRecId;
	            }
	
	            if (locateNextRecId == "") {
	              if (index < length - 1) {
	                next = thisRecord[index + 1];
	              } else {
	                next = null;
	              }
	
	              if (next != null) {
	                var nextRecId = next[mainAlias + ".recId"];
	                if (recIds.indexOf(nextRecId) == -1) locateNextRecId = nextRecId;
	              }
	            }
	          }
	
	          thisRecord.splice(index, 1);
	          if (thisRecord == this.tempRecordsFilter) {
	            var index2 = this.records.indexOf(record);
	            this.records.splice(index2, 1);
	          }
	          length--;
	          flag++;
	        }
	
	        _RecordsActions2.default.recordsCmp(thisRecord, this.groupAlias, this);
	
	        if (dontLocate == false) {
	          var located = false;
	          if (locateNextRecId == "") {
	            this.setCurrentRecord(null);
	            located = true;
	          } else {
	            for (var j = 0; j < thisRecord.length; j++) {
	              var r = thisRecord[j];
	              if (r[mainAlias + ".recId"] == locateNextRecId) {
	                this.setCurrentRecord(this.records[j]);
	                located = true;
	                break;
	              }
	            }
	          }
	
	          if (located == false) {
	            if (this.records.length > 0) this.setCurrentRecord(this.dataProvider[0]);else this.setCurrentRecord(null);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'doRecordDelete',
	    value: function doRecordDelete() {
	      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var prompt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      //TODO 如果要删除多条 每一条记录的删除权限都要判断？
	
	      var arg = new _FormDataSourceGroupArg2.default();
	      arg.argType = 0; //待定
	      arg.groupAlias = this.groupAlias;
	      this.setFormDataSourceGroupArg(arg);
	      if (arg.recordCounts == 0) return;
	      if (!this.currentRecord && this.records.length == 0) return;
	      for (var _key in arg.arg) {
	        var _r = arg.arg[_key];
	        if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Delete, _r)) return;
	      }
	      if (this.mainSource.isTempTable == true) {
	        var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".deleteRecord", window.menuItemId, window.formId);
	
	        if (mi == null) {
	          mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".beforeDeleteRecord", window.menuItemId, window.formId) || _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterDeleteRecord", window.menuItemId, window.formId);
	          if (mi == null) {
	            mi = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };
	          }
	        }
	
	        //mi =  FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".validateDelete",window.menuItemId,window.formId);
	        var commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
	
	        _ServiceHelper2.default.addTokenWithCommand({
	          command: _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doRecordDelete").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
	          resultFunction: this.rpc_result_tempRecordDelete.bind(this, arg), sync: sync
	        });
	        return;
	      }
	      var _parentWindow = window.parent.window;
	      if (_parentWindow.userSettingEntry.isDelPrompt && prompt) {
	        var options = {
	          text: "确认要删除吗,删除后将无法恢复",
	          interacdestroy: false,
	          confirm: { isShow: true, event: this.requireDeleteRecords.bind(this, arg, sync) },
	          cancel: { isShow: true, event: '' }
	        };
	        _Warn2.default.show(options);
	      } else {
	        this.requireDeleteRecords(arg, sync);
	      }
	    }
	  }, {
	    key: 'rpc_result_doTempRecordDelete',
	    value: function rpc_result_doTempRecordDelete(arg) {
	      var ids = [];
	      if (Array.isArray(arg.arg)) {
	        for (var i = 0; i < arg.arg.length; i++) {
	          var _record = arg.arg[i];
	          var id;
	          if (_record.hasOwnProperty("recId")) {
	            id = _record["recId"];
	          } else {
	            id = _record[this.groupAlias + ".recId"];
	          }
	          ids.push(id);
	        }
	      } else {
	        for (var _key in arg.arg) {
	          _record = arg.arg[_key];
	          if (_record.hasOwnProperty("recId")) {
	            id = _record["recId"];
	          } else {
	            id = _record[this.groupAlias + ".recId"];
	          }
	          //id = _record["recId"] || _record[this.groupAlias+".recId"];
	          ids.push(id);
	        }
	      }
	      this.deleteSelectedTempRecords(ids);
	    }
	  }, {
	    key: 'rpc_result_tempRecordDelete',
	    value: function rpc_result_tempRecordDelete(arg, data) {
	      var fdsgr = data.result;
	      var finalDatas = fdsgr.dataResult;
	      //TODO_yl 临时表 删除记录触发result
	      if (fdsgr && fdsgr.commandResult) {
	        _CommandResolver2.default.resolve(fdsgr.commandResult.tasks, this.formDataSources.formModule, this);
	      }
	      if (finalDatas && finalDatas.length > 0) {
	        this.rpc_result_doTempRecordDelete(arg);
	      } else {
	        alert("删除失败");
	      }
	    }
	  }, {
	    key: 'doDeleteVersionRecord',
	    value: function doDeleteVersionRecord(record) {
	      var mainAlias = this.mainSource.alias;
	      var locateNextRecId = "";
	      var origRecord = this.currentRecord;
	      var index = this.records.indexOf(origRecord);
	      var pre = null;
	      if (index >= 1) {
	        pre = this.records[index - 1];
	      } else {
	        pre = null;
	      }
	
	      if (pre) {
	        locateNextRecId = pre[mainAlias + ".recId"];
	      }
	      var next = null;
	      if (locateNextRecId == "") {
	        if (index < length - 1) {
	          next = this.records[index + 1];
	        } else {
	          next = null;
	        }
	
	        if (next != null) {
	          locateNextRecId = next[mainAlias + ".recId"];
	        }
	      }
	
	      if (index != -1) {
	        var recId = record["recId"];
	        this.records.splice(index, 1);
	        delete this.mapRecId[recId];
	        delete this.recordsBak[recId];
	        _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this);
	      }
	
	      var ret = { flag: true, locateNextRecId: locateNextRecId };
	
	      return ret;
	    }
	  }, {
	    key: 'requireDeleteRecords',
	    value: function requireDeleteRecords(arg, sync) {
	      /*if(arg && arg.arg)
	      {
	        let keys = Object.keys(arg.arg);
	        if(keys && keys.length==1)
	        {
	          let record = arg.arg[0];
	          if(record && record.recVersion == -1)
	          {
	            var obj = this.doDeleteVersionRecord(record); 
	            this.locationAfterDelete(obj);
	            return;
	          }
	        }
	        
	      }*/
	
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".deleteRecord", window.menuItemId, window.formId);
	
	      if (mi == null) {
	        mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".beforeDeleteRecord", window.menuItemId, window.formId) || _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterDeleteRecord", window.menuItemId, window.formId);
	        if (mi == null) {
	          mi = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };
	        }
	      }
	
	      var isDeleteAll = false;
	      if (arg && this.records && arg.recordCounts == this.records.length) isDeleteAll = true;
	
	      //mi =  FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".validateDelete",window.menuItemId,window.formId);
	      var commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
	
	      _ServiceHelper2.default.addTokenWithCommand({
	        command: _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doRecordDelete").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
	        resultFunction: this.rpc_result_doRecordDelete.bind(this, isDeleteAll), sync: sync
	      });
	    }
	  }, {
	    key: 'doRefreshOnClient',
	    value: function doRefreshOnClient(result) {
	      this.rpc_result_doRecordRestore({ result: result }, true, false);
	    }
	  }, {
	    key: 'deleteRecordOnClient',
	    value: function deleteRecordOnClient(recIds) {
	      var obj = this.local_deleteRecord(null, recIds, false);
	      this.locationAfterDelete(obj);
	    }
	  }, {
	    key: 'rpc_result_doRecordDelete',
	    value: function rpc_result_doRecordDelete(isDeleteAll, data) {
	      var fdsgr = data.result;
	      this.formatFormDataSourceGroupResult(fdsgr);
	
	      var finalDatas = fdsgr.dataResult; //RecordsUtil.getOneLevelDatas(fdsgr,this.groupAlias);
	
	      if (finalDatas && finalDatas.length > 0) {
	        var obj = this.local_deleteRecord(finalDatas);
	        //var flag = obj["flag"];
	        this.locationAfterDelete(obj);
	
	        if (fdsgr && fdsgr.commandResult) _CommandResolver2.default.resolve(fdsgr.commandResult.tasks, this.formDataSources.formModule, this);
	
	        if (isDeleteAll) {
	          this.recordRefresh(this.groupAlias, this.formDataSources.formModule.instanceUUId);
	        }
	      } else {
	        alert("删除失败");
	      }
	    }
	  }, {
	    key: 'locationAfterDelete',
	    value: function locationAfterDelete(obj) {
	      var locateNextRecId = obj["locateNextRecId"];
	      this.locateRecord(locateNextRecId);
	    }
	    //仅在删除后被调用
	
	  }, {
	    key: 'locateRecord',
	    value: function locateRecord(recId) {
	      if (!recId) {
	        this.setCurrentRecord(null, false);
	      } else {
	        var length = this.records.length;
	        for (var j = 0; j < length; j++) {
	          var r = this.records[j];
	          if (r[this.mainSource.alias + ".recId"] == recId) {
	            this.setCurrentRecord(this.records[j], false);
	            //this.formDataSources.formModule.focusController.setFocusAfterNewRecord(this);
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'local_deleteRecord',
	    value: function local_deleteRecord(ac) {
	      var recIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var fade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var mainAlias = this.mainSource.alias;
	      var locateNextRecId = "";
	      var flag = 0;
	      if (!recIds) var recordCounts = ac.length;else recordCounts = recIds.length;
	
	      var length = this.records.length;
	
	      var next;
	      var pre;
	      if (!recIds) {
	        recIds = [];
	        for (var i = 0; i < ac.length; i++) {
	          var record = ac[i];
	          recIds.push(record[mainAlias + ".recId"]);
	        }
	      }
	
	      if (fade) var indexes = [];
	
	      var delRecords = [];
	      for (var k = 0; k < recIds.length; k++) {
	        var recId = recIds[k];
	        var origRecord = this.mapRecId[recId];
	        if (origRecord) {
	          delRecords.push(origRecord);
	          var index = this.records.indexOf(origRecord);
	          if (index == -1) {
	            alert("mapRecId and dataProvider is not Match");
	            continue;
	          }
	
	          if (locateNextRecId == "") {
	            if (index >= 1) {
	              pre = this.records[index - 1];
	            } else {
	              pre = null;
	            }
	
	            if (pre != null) {
	              var preRecId = pre[mainAlias + ".recId"];
	              if (recIds.indexOf(preRecId) == -1) locateNextRecId = preRecId;
	            }
	
	            if (locateNextRecId == "") {
	              if (index < length - 1) {
	                next = this.records[index + 1];
	              } else {
	                next = null;
	              }
	
	              if (next != null) {
	                var nextRecId = next[mainAlias + ".recId"];
	                if (recIds.indexOf(nextRecId) == -1) locateNextRecId = nextRecId;
	              }
	            }
	          }
	          if (fade) {
	            indexes.push(index);
	          } else {
	            this.records.splice(index, 1);
	            delete this.mapRecId[recId];
	            delete this.recordsBak[recId];
	            _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this);
	          }
	
	          length--;
	          flag++;
	        } else {
	          alert("要删除的记录不存在");
	          continue;
	        }
	      }
	
	      var ret = { flag: flag, locateNextRecId: locateNextRecId };
	
	      if (fade) {
	        //TODO 客户端记录删除时要闪烁行
	        /*for each(var fgrid:FormItem_DataGrid in formDataSources.formModule.formDesign.grids)
	        {
	          if(fgrid.group == this)
	          {
	            var grid:GongqiDataGrid = fgrid.grid as GongqiDataGrid;
	            if(grid != null)
	            {
	              grid.changeRowsAlpha(indexes,deleteFadeEnd,this,[recIds,ret]);
	            }
	          }
	        }*/
	        return ret;
	      } else {
	        return ret;
	      }
	    }
	  }, {
	    key: 'doRecordRestore',
	    value: function doRecordRestore() {
	      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var updateRelated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var showInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (this.mainSource.isTempTable) {
	        if (window.remainTasks) {
	          var tasks = window.remainTasks;
	          window.remainTasks = null;
	          var task = tasks.shift();
	          if (task) _CommandResolver2.default.doResolveTask(task, this.formdataSources.formModule, tasks);
	        }
	        return;
	      }
	
	      if (!this.currentRecord) {
	        if (window.remainTasks) {
	          var _tasks = window.remainTasks;
	          window.remainTasks = null;
	          var _task = _tasks.shift();
	          if (_task) _CommandResolver2.default.doResolveTask(_task, this.formdataSources.formModule, _tasks);
	        }
	        return;
	      }
	
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Query, this.currentRecord)) {
	        if (window.remainTasks) {
	          var _tasks2 = window.remainTasks;
	          window.remainTasks = null;
	          var _task2 = _tasks2.shift();
	          if (_task2) _CommandResolver2.default.doResolveTask(_task2, this.formdataSources.formModule, _tasks2);
	        }
	        return;
	      }
	
	      var arg = new _FormDataSourceGroupArg2.default();
	      arg.argType = 0;
	      arg.groupAlias = this.groupAlias;
	      this.setFormDataSourceGroupArg(arg, "restore");
	
	      if (arg.recordCounts == 0) return;
	
	      if (this.formDataSources.formModule.classAlias == "FormLookup") {
	        //TODO 自定义与自动生成下拉框 均在权限判断时被捕获
	        return;
	      } else {
	        var _rpc_result_doRecordRestore = this.rpc_result_doRecordRestore.bind(this);
	        var formModule = this.formDataSources.formModule;
	        _ServiceHelper2.default.addTokenWithCommand({
	          command: _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doRecordRestore").appendArg(arg, "FormDataSourceGroupArg"),
	          resultFunction: function resultFunction(data) {
	            _rpc_result_doRecordRestore(data, updateRelated, showInfo);
	            if (window.remainTasks) {
	              var _tasks3 = window.remainTasks;
	              window.remainTasks = null;
	              var _task3 = _tasks3.shift();
	              if (_task3) _CommandResolver2.default.doResolveTask(_task3, formModule, _tasks3);
	            }
	          },
	          sync: sync
	        });
	      }
	    }
	  }, {
	    key: 'doRecordRefresh',
	    value: function doRecordRefresh() {
	      _RecordsActions2.default.RecordRefresh(this.groupAlias, this.formDataSources.formModule.instanceUUId);
	    }
	  }, {
	    key: 'doRecordFetchAll',
	    value: function doRecordFetchAll() {
	      _RecordsActions2.default.RecordFetchAll(this.groupAlias, this.formDataSources.formModule.instanceUUId);
	    }
	  }, {
	    key: 'local_restoreRecord',
	    value: function local_restoreRecord(ac) {
	      var mainAlias = this.mainSource.alias;
	      var recordCounts = ac.length;
	      for (var i = 0; i < recordCounts; i++) {
	        var record = ac[i];
	
	        var _recVersion = record[mainAlias + ".recVersion"];
	
	        if (_recVersion == "-1" || _recVersion == -1) {
	          //什么都不做，保持客户端现状不动
	        } else if (_recVersion == "-2" || _recVersion == -2) {
	          var recId = record[mainAlias + ".recId"];
	          var origIndex = this.records.indexOf(this.mapRecId[recId]);
	          this.records.splice(origIndex, 1);
	          this.mapRecId[recId] = null;
	          delete this.mapRecId[recId];
	          delete this.recordsBak[recId];
	          recordCounts--;
	          _Fade2.default.show("记录已被删除，无法恢复");
	        } else {
	          this.replaceRecord(record);
	          var _recId5 = record[mainAlias + ".recId"];
	          this.mapRecId[_recId5] = record;
	          this.recordsBak[_recId5] = Object.assign({}, record);
	        }
	      }
	
	      return recordCounts;
	    }
	  }, {
	    key: 'rpc_result_doRecordRestore',
	    value: function rpc_result_doRecordRestore(data, updateRelated, showInfo) {
	      var result = data.result;
	      this.formatFormDataSourceGroupResult(result, 'refresh');
	
	      if (result.dataResult) {
	        var currentIndex = this.records ? this.records.indexOf(this.currentRecord) : -1;
	        if (!this.dynamicColumnsPre || this.dynamicColumnsPre && (window.dynamicColumnsPreOldIndex == undefined || window.dynamicColumnsPreOldIndex == null)) {
	          var flag = this.local_restoreRecord(result.dataResult);
	        } else {
	          var lastRecord = this.records[window.dynamicColumnsPreOldIndex];
	          for (var key in result.dataResult[0]) {
	            var k = result.groupAlias + "." + key;
	            if (key.indexOf(".") != -1) {
	              k = key;
	            }
	            if (lastRecord[k]) {
	              lastRecord[k] = result.dataResult[0][key];
	            }
	          }
	          window.dynamicColumnsPreOldIndex = null;
	          // var flag = this.local_restoreRecord(result.dataResult);
	          var flag = 1;
	        }
	        //TODO 此处在晨光项目中会出现this.currentRecord不在this.records中的情况 但是无法找到原因 所以通过recId来找先屏蔽掉该问题
	        if (currentIndex == -1 && this.records && this.currentRecord) {
	          for (var i = 0; i < this.records.length; i++) {
	            var r = this.records[i];
	            if (r[this.groupAlias + ".recId"] == this.currentRecord[this.groupAlias + ".recId"]) {
	              currentIndex = i;break;
	            }
	          }
	        }
	        this.currentRecord = this.records[currentIndex];
	
	        //this.currentRecordBak = Object.assign({},this.currentRecord);
	        _RecordsActions2.default.RecordsRestoreCmp(this.groupAlias, this.records, this.formDataSources.formModule.instanceUUId);
	        _RecordsActions2.default.RenderUpdateModifiedTag(this.groupAlias, this.currentRecord);
	        //RecordsActions.currentRecordChanged(this.currentRecord,this.groupAlias);
	        this.activeCurrentRecord(updateRelated);
	        if (showInfo) _Fade2.default.show({ text: "已恢复" + flag + "条记录" });
	      } else {
	        _Fade2.default.show("恢复失败，返回null");
	      }
	    }
	  }, {
	    key: 'doAttachMent',
	    value: function doAttachMent() {
	      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (!this.currentRecord) {
	        _Warn2.default.show({ text: "请先选中记录再进行附件操作", state: "info" });
	        return;
	      }
	      if (this.getCurRecVersion() == -1) {
	        _Warn2.default.show({ text: "请先保存选中记录再进行附件操作", state: "info" });
	        return;
	      }
	      var record = this.currentRecord;
	      var _recId = record[this.mainSource.alias + ".recId"];
	      var _tableId = this.mainSource.tableId;
	      var _formId = window.formModuleInstance.formId;
	      var _aukey = "3_" + window.menuItemId + "." + this.mainSource.xml.id;
	      if (flag == 'drop') {
	        window.parent.window.toolbarAttachmentDrop(_tableId, _recId, _formId, _aukey);
	        return;
	      }
	      var $attachmentModal = $("#attachmentModal");
	      var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("align-items", "center").css("justify-content", "center").appendTo($attachmentModal);
	      _reactDom2.default.render(_react2.default.createElement(_Attachment2.default, { tableId: _tableId, recId: _recId, formId: _formId, aukey: _aukey }), modalDiv[0]);
	    }
	  }, {
	    key: 'doTempTableRecordSave',
	    value: function doTempTableRecordSave(arg, sync, autoSave) {
	      var fdsgr = new _FormDataSourceGroupResult2.default();
	      fdsgr.aliasList = arg.aliasList;
	      fdsgr.groupAlias = arg.groupAlias;
	      fdsgr.recordCounts = arg.recordCounts;
	      var ac = [];
	      var obj = arg.arg[0];
	      obj["recVersion"]++;
	      //TODO 是否还需要copy?
	      ac.push(obj);
	      fdsgr.dataResult = ac;
	
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".saveRecord", window.menuItemId, window.formId);
	      if (mi == null) {
	        mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".beforeSaveRecord", window.menuItemId, window.formId) || _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterSaveRecord", window.menuItemId, window.formId);
	        if (mi == null) {
	          mi = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };
	        }
	      }
	
	      var commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
	
	      var _thisRecordSaveFaultHandler = this.recordSaveFaultHandler.bind(this);
	      //sucessIngnoreStatus非异常返回固定调用success(除返回码为2的情况)
	      _ServiceHelper2.default.addTokenWithCommand({
	        command: _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doRecordSave").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
	        resultFunction: this.rpc_result_doRecordSave.bind(this, [autoSave]), sync: sync, successIngnoreStatus: true,
	        faultFunction: function faultFunction(data) {
	          window.rowChangeAutoSaveFail = true;result.remoteFail = true;
	          _thisRecordSaveFaultHandler(data);
	        }
	      });
	      return result;
	
	      this.do_rpc_result_doRecordSave(fdsgr);
	    }
	  }, {
	    key: 'doRecordSave',
	    value: function doRecordSave() {
	      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var autoSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	
	      //TODO 是否需要权限判断？
	      var result = { notModify: false, remoteFail: false };
	      //if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Save,this.currentRecord))
	      //  return result;
	      window.rowChangeAutoSaveFail = false;
	
	      if (this.currentRecord == null || this.currentRecord == undefined) return result;
	      var autoSaveBeforeResults = [];
	      _RecordsActions2.default.autoSaveBefore(this.groupAlias, autoSaveBeforeResults);
	
	      if (autoSaveBeforeResults && autoSaveBeforeResults.length > 0) {
	        for (var i = 0; i < autoSaveBeforeResults.length; i++) {
	          if (autoSaveBeforeResults[i] == false) return;
	        }
	      }
	
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Save, this.currentRecord)) return result;
	
	      if (!this.isCurrentRecordModified() && !this.isWorkFlow) {
	        result.notModify = true;
	        return result;
	      }
	
	      var arg = new _FormDataSourceGroupArg2.default();
	      arg.argType = 0; //待定
	      arg.groupAlias = this.groupAlias;
	      this.setFormDataSourceGroupArg(arg);
	
	      if (arg.recordCounts > 1) {
	        _Warn2.default.show({ text: "目前不支持多条记录的保存", interacdestroy: false, cancel: { isShow: false, event: '' } });
	        return;
	      }
	
	      //if(this.mainSource.isTempTable == true
	      //    || this.hasDynamicColumn == true)
	      if (this.hasDynamicColumn == true) {
	        var fdsgr = new _FormDataSourceGroupResult2.default();
	        fdsgr.aliasList = arg.aliasList;
	        fdsgr.groupAlias = arg.groupAlias;
	        fdsgr.recordCounts = arg.recordCounts;
	        var ac = [];
	        var obj = arg.arg[0];
	        obj["recVersion"]++;
	        delete obj["remoteClass"];
	        //TODO 是否还需要copy?
	        ac.push(obj);
	        fdsgr.dataResult = ac;
	        this.do_rpc_result_doRecordSave(fdsgr);
	        return;
	      }
	
	      var s = "";
	
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var item = _FormItemUtil2.default.formItemControlsForFor[key];
	        if (item.xml && item.xml.type && item.xml.type.indexOf("Editor") != -1 && item.group == this && item.getSelfNotNull()) {
	          var _result = item.validateNotNull();
	          if (_result) {
	            if (s == null) s = "值不能为空：" + _result;else s += "\n" + "值不能为空：" + _result;
	          }
	        }
	      }
	
	      if (s != "") {
	        window.rowChangeAutoSaveFail = true;
	        if (!window.rowrowChangeAutoSaveWarn) {
	          _Warn2.default.show({
	            text: "保存操作由于以下原因未成功:\n" + s,
	            interacdestroy: false,
	            cancel: { isShow: false, event: '' },
	            rowrowChangeAutoSaveWarn: true
	          });
	          window.rowrowChangeAutoSaveWarn = true;
	        }
	        return;
	      }
	
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".saveRecord", window.menuItemId, window.formId);
	      if (mi == null) {
	        mi = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".beforeSaveRecord", window.menuItemId, window.formId) || _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterSaveRecord", window.menuItemId, window.formId);
	        if (mi == null) {
	          mi = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };
	        }
	      }
	
	      var commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
	
	      var _thisRecordSaveFaultHandler = this.recordSaveFaultHandler.bind(this);
	      //sucessIngnoreStatus非异常返回固定调用success(除返回码为2的情况)
	      _ServiceHelper2.default.addTokenWithCommand({
	        command: _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doRecordSave").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
	        resultFunction: this.rpc_result_doRecordSave.bind(this, autoSave), sync: sync, successIngnoreStatus: true,
	        faultFunction: function faultFunction(data) {
	          window.rowChangeAutoSaveFail = true;result.remoteFail = true;
	          _thisRecordSaveFaultHandler(data);
	        }
	      });
	      return result;
	    }
	  }, {
	    key: 'rpc_result_doRecordSave',
	    value: function rpc_result_doRecordSave(autoSave, data) {
	      if (data.status != 0) {
	        window.rowChangeAutoSaveFail = true;
	        return;
	      }
	      var result = data.result;
	      this.do_rpc_result_doRecordSave(result, autoSave);
	
	      if (result && result.commandResult) _CommandResolver2.default.resolve(result.commandResult.tasks, this.formDataSources.formModule, this);
	    }
	  }, {
	    key: 'local_saveRecord',
	    value: function local_saveRecord(ac) {
	      var currentIndex;
	      var record;
	      var origIndex;
	      var recordCounts = ac.length;
	
	      var flag = false;
	      if (recordCounts == 1 && this.mainSource.idGenerator == "Identity") {
	        record = ac[0];
	        var recVersion = record[this.mainSource.alias + ".recVersion"];
	        if (recVersion == 0) {
	          for (var key in this.mapRecId) {
	            var o = this.mapRecId[key];
	            if (o[this.mainSource.alias + ".recVersion"] == -1) {
	              origIndex = this.records.indexOf(o);
	              currentIndex = origIndex;
	              this.records[origIndex] = record;
	
	              //更新临时表筛选记录 变更currentIndex以tempRecordsFilter为准
	              if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	                origIndex = this.tempRecordsFilter.indexOf(o);
	                currentIndex = origIndex;
	                this.tempRecordsFilter[origIndex] = record;
	              }
	
	              delete this.mapRecId[o[this.mainSource.alias + ".recId"]];
	              this.mapRecId[record[this.mainSource.alias + ".recId"]] = record;
	              this.recordsBak[record[this.mainSource.alias + ".recId"]] = Object.assign({}, record);
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	
	      if (flag == false) {
	        for (var i = 0; i < recordCounts; i++) {
	          record = ac[i];
	          var recId = record[this.mainSource.alias + ".recId"];
	
	          var origRecord = this.mapRecId[recId];
	
	          if (origRecord == null) throw new Error("miss origRecord when save record:" + recId);
	          origIndex = this.records.indexOf(origRecord);
	          if (origIndex == -1) {
	            for (var k = 0; k < this.records.length; k++) {
	              if (this.records[k] == origRecord) {
	                origIndex = k;
	                break;
	              }
	            }
	          }
	          if (i == 0) currentIndex = origIndex;
	          this.records[origIndex] = record;
	          this.mapRecId[recId] = record;
	          this.recordsBak[recId] = Object.assign({}, record);
	
	          //更新临时表筛选记录
	          if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	            origIndex = this.tempRecordsFilter.indexOf(origRecord);
	            if (origIndex == -1) {
	              for (var k = 0; k < this.tempRecordsFilter.length; k++) {
	                if (this.tempRecordsFilter[k] == origRecord) {
	                  origIndex = k;
	                  break;
	                }
	              }
	            }
	            if (i == 0) currentIndex = origIndex;
	            this.tempRecordsFilter[origIndex] = record;
	          }
	        }
	      }
	
	      return currentIndex;
	    }
	  }, {
	    key: 'do_rpc_result_doRecordSave',
	    value: function do_rpc_result_doRecordSave(fdsgr, autoSave) {
	      this.formatFormDataSourceGroupResult(fdsgr, "save");
	      var finalDatas = fdsgr.dataResult;
	      //RecordsUtil.getOneLevelDatas(fdsgr,this.groupAlias);
	      var ac = finalDatas;
	      if (!ac || ac.length == 0) {
	        alert("保存失败，返回null");
	      } else {
	        var currentIndex = this.local_saveRecord(ac);
	        if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	          this.currentRecord = this.tempRecordsFilter[currentIndex];
	        } else {
	          this.currentRecord = this.records[currentIndex];
	        }
	
	        //this.currentRecordBak = Object.assign({},this.currentRecord);
	        _RecordsActions2.default.RecordAutoSaveCmp(this.groupAlias, this.currentRecord);
	        _RecordsActions2.default.RenderUpdateModifiedTag(this.groupAlias, this.currentRecord);
	        //RecordsActions.currentRecordChanged(this.currentRecord,this.groupAlias);
	        // window.doIcheckOnlyOneTime = false;
	
	        this.activeCurrentRecord(true, undefined, false, autoSave ? true : false, {}, false);
	
	        //TODO 提示信息
	      }
	    }
	  }, {
	    key: 'recordSaveFaultHandler',
	    value: function recordSaveFaultHandler(message) {
	      if (message && message.successButNot0) {
	        message = message.errText;
	      } else if (typeof message != "string") {
	        _Warn2.default.show({ text: "请检查网络是否正常或联系管理员", title: "记录保存失败" });
	        return;
	      }
	
	      var faultString = message;
	      if (message.indexOf("Duplicate entry") == 0 && this.currentRecord) {
	        var key = message.substring(message.lastIndexOf(" ") + 2, message.length - 1);
	        var tableXML = _GOT2.default.getTable(this.mainSource.tableId);
	        if (tableXML) {
	          var index = _GOT2.default.getTableIndex(tableXML, key);
	          if (index) {
	            var tableIndexItems = index.IndexItems;
	            var fieldsLabel = "";
	            var labelNum = 0;
	            for (var i = 0; i < tableIndexItems.length; i++) {
	              var tableIndexItem = tableIndexItems[i];
	              var fieldPro = _GOTUtil2.default.getProperty(tableIndexItem, "Field");
	              if (fieldPro.hasOwnProperty("innerid")) {
	                var innerid = fieldPro.innerid;
	                var tableField = _GOT2.default.getTableField(tableXML, innerid);
	                if (tableField) {
	                  var label = _GOTUtil2.default.getFinalValue(tableField, tableXML, "Label");
	                  var dataFieldKey = this.mainSource.tableName + "." + _StringUtil2.default.convertToFirstLowerCase(tableField.name);
	                  if (!this.currentRecord.hasOwnProperty(dataFieldKey)) continue;
	                  fieldsLabel += label + ":" + this.currentRecord[dataFieldKey] + "\n";
	                  labelNum++;
	                }
	              }
	            }
	            faultString = "";
	            faultString += fieldsLabel;
	            if (labelNum > 1) faultString += "的组合";
	            faultString += " 不唯一";
	          }
	        }
	      } else if (message.indexOf("Row was updated or deleted by another transaction") == 0) {
	        faultString = "当前记录状态已不是最新或者已被删除，请执行恢复记录操作";
	      } else if (faultString && faultString.indexOf("#NotNull:") == 0) {
	        faultString = "请填写以下必填项：\n" + faultString.substr(9);
	      }
	      if (!window.rowrowChangeAutoSaveWarn) {
	        window.rowrowChangeAutoSaveWarn = true;
	        _Warn2.default.show({ text: faultString, rowrowChangeAutoSaveWarn: rowrowChangeAutoSaveWarn });
	      }
	    }
	  }, {
	    key: 'rpcAutoSaveRecord',
	    value: function rpcAutoSaveRecord(record) {}
	  }, {
	    key: 'isCurrentRecordModified',
	    value: function isCurrentRecordModified() {
	      if (this.getCurRecVersion() == -1) return true;
	
	      for (var key in this.currentRecord) {
	        if (this.isCurrentDataFieldModified(this.currentRecord, key, false)) return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isCurrentDataFieldModified',
	    value: function isCurrentDataFieldModified(record, dataField) {
	      var checkVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (checkVersion && record) {
	        if (this.getCurRecVersion(record) == -1) return true;
	      }
	      if (record != this.currentRecord) return false;
	      if (dataField && this.isTempDataMethodField(dataField)) return false;
	      var newValue = record[dataField];
	      var _recId = record[this.groupAlias + ".recId"];
	      var currentRecordBak = this.recordsBak[_recId];
	      var origValue = currentRecordBak[dataField];
	
	      /*let _alias;
	      if(dataField)
	      {
	        _alias = dataField.split(".")[0];
	      }
	      if(_alias)
	      {
	        var _fds
	        for(let i in this.sources)
	        {
	          var tf = this.sources[i];
	          if(tf.alias == _alias)
	          {
	            _fds = tf;
	            break;
	          }
	        }
	        if(_fds)
	        {
	          let _type = _fds.fieldType[dataField];
	          if(_type == "Decimal")
	          {
	            try
	            {
	              return parseFloat(newValue) != parseFloat(origValue);
	            }
	            catch(e)
	            {
	      
	            }
	          }
	        }
	      }*/
	
	      if (typeof origValue == "number") {
	        try {
	          return parseFloat(newValue) != parseFloat(origValue);
	        } catch (e) {}
	      }
	
	      return newValue + "" != origValue + "";
	    }
	  }, {
	    key: 'setCurrentRecord',
	    value: function setCurrentRecord(record) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var parms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      //TODO  如果为正式表 数据查询以后 为后台新返回 此处判断会判断到发生更改 从而执行activeCurrentRecord触发UI变更
	      //如果为临时表 由于是客户端过滤 过滤之前选中的记录与过滤后的记录为同一引用 所以不会变更
	      var bool = this.currentRecord != record;
	      if (this.mainSource.isTempTable == true) bool = true;
	      if (parms && parms.activeRecord == true) bool = true;
	      this.currentRecord = record;
	      //this.currentRecordBak = Object.assign({},this.currentRecord);
	      //RecordsActions.currentRecordChanged(record,this.groupAlias);
	      if (this.records && this.records.length > 0 && this.records.indexOf(this.currentRecord) == -1) {
	        var a = "string";
	      }
	      if (bool) this.activeCurrentRecord(true, undefined, delay, false, parms);
	    }
	  }, {
	    key: 'executeQuery',
	    value: function executeQuery(type) {
	      var xml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var onlyFecth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var sync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var tasks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      this.doExecuteQuery(type, xml, onlyFecth, sync, tasks);
	    }
	  }, {
	    key: 'reExecuteQuery',
	    value: function reExecuteQuery() {
	      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var tasks = arguments[1];
	
	      this.reSetCurrentQuery(this.currentQuery);
	      //this.executeQuery(null,null,false,sync,tasks);
	
	      if (this.forLookup) {
	        this.doExecuteQuery(null, null, false, sync, tasks);
	      } else {
	        var result = this.onRecordAutoSave(this.groupAlias);
	
	        if (result && !result.remoteFail) {
	          this.doExecuteQuery(null, null, false, sync, tasks);
	        }
	      }
	    }
	  }, {
	    key: 'onExecuteQuery',
	    value: function onExecuteQuery(queryType, groupAlias) {
	      var xml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var onlyFetch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      alert("已废弃");
	      //如果不是另外Form Link的情况 并且formId不同 说明是下拉画面与非下拉画面之间的传递
	      // if(type != ExecuteType.LINK && formId != this.formDataSources.formId)
	      //    return;
	
	      if (groupAlias != "all" && this.groupAlias != groupAlias) return;
	      var sourceNames = [];
	      for (var i in this.sources) {
	        var item = this.sources[i];
	        sourceNames.push(item.sourceName);
	      }
	      var postdata = { sources: JSON.stringify(sourceNames), filterVal: "" };
	      //验证同步调用在action中有效
	      /*AjaxRemoteUtil.ajax('get','http://127.0.0.1:50508/GongqiERP/test','json',true,function(){console.log("第11111111111111111111111111111111111")});
	      console.log("第2222222222222222222222222222222222");
	      AjaxRemoteUtil.ajax('get','http://127.0.0.1:50508/GongqiERP/test','json',false,function(){console.log("第三3333333333333333333333333333")});*/
	      //alert('2222222222222222222222222');
	      _AjaxRemoteUtil2.default.ajaxPost('/web/GetData/getData?_dataarea=dynamic', postdata, 'json', true, this.rpcExecuteQuery.bind(this));
	    }
	  }, {
	    key: 'appendWhereItemForFormModuleLookup',
	    value: function appendWhereItemForFormModuleLookup(xml, fm) {
	      var qwis = _GOTUtil2.default.getQueryWhereItemByPropertyValue(xml, "tag", "autoAppendForFormModuleLookup");
	      if (qwis.length > 0) return;
	
	      if (fm.lookupArg == null) return;
	
	      var bf = fm.lookupArg["baseFilter"];
	      if (bf == null || bf == "") return;
	
	      if (bf.indexOf("*") == -1 && bf.indexOf("?") == -1) return;
	
	      var qwi = { qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
	        Properties: { Field: { V: "", refentityid: "", refinnerid: "" },
	          Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
	          RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" },
	          Enabled: { V: true }
	        }
	      };
	      var pName = qwi.Properties.Field;
	      pName.refentityid = this.mainSource.tableId;
	      pName.refinnerid = this.formDataSources.xml.Properties.ReturnField.refinnerid;
	      if (pName.refinnerid == "" || pName.refinnerid == null) return;
	
	      pName.V = fm.lookupArg["fieldName"];
	      var pValue = qwi.Properties.Value;
	      pValue.V = bf;
	
	      var qw = xml.QueryWhere || xml.QueryTable.QueryWhere;
	      qw.Items.push(qwi);
	    }
	  }, {
	    key: 'getCurrentQueryTable',
	    value: function getCurrentQueryTable() {
	      var _queryTable;
	      ///try
	      //{
	
	      _queryTable = _QueryUtil2.default.convertXML2QueryTable(this.currentQuery);
	
	      //}
	      //catch(error)
	      //{
	      //  this.currentQuery = JSON.parse(JSON.stringify(this.formQuery));
	      //  this.currentQuery.needRefresh = true;
	      //  _queryTable = QueryUtil.convertXML2QueryTable(this.currentQuery);
	      //  alert("QueryTable构造失败，已重置，请与管理员联系");
	      //}
	
	      return _queryTable;
	    }
	  }, {
	    key: 'analysisSingleRecord',
	    value: function analysisSingleRecord(item) {
	      var _queryTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var isRightContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (_queryTable != null) {
	        if (!_queryTable.getSqlWhereStr) _queryTable.getSqlWhereStr = _QueryTable2.default.getSqlWhereStr;
	        var ws = _queryTable.getSqlWhereStr();
	        if (ws == "") return true;
	
	        /*var wsa2 = ws.split(" ");
	        var wsr = "";
	        
	        var wsa = [];
	        var flag = true;
	        var values = "";
	        var flagHelper = true;
	        var k = 0;
	        for(let i=0;i<wsa2.length;i++)
	        {
	          let s2 = wsa2[i];
	          if(flag && s2.indexOf("=\"") == -1)
	          {
	            if(k == (wsa2.length-1))
	            {
	              s2 = s2.replace("=\"","=");
	              values+=(s2.substr(0,s2.length-1));
	              break;
	            }
	            else
	            {
	              wsa.push(s2);
	            }
	            flag = false;
	          }
	          else
	          {
	            if(flagHelper)
	            {
	              s2 = s2.replace("=\"","=");
	              k==wsa2.length-1?values+=(s2.substr(0,s2.length-1)):values+=(s2+" ");
	              flagHelper = false;
	            }
	            else
	            {
	              if(k==wsa2.length-1)
	              {
	                values+=(s2.substr(0,s2.length-1));
	              }
	              else
	              {
	                values+=(s2+" ");
	              }
	            }
	          }
	          k++;
	            
	        }
	        
	        wsa.push(values);*/
	
	        var wsa = [];var wsr = "";
	        var fieldsTypes = {};
	        for (var k = 0; k < _queryTable.queryWhere.length; k++) {
	          var queryWhereItem = _queryTable.queryWhere[k];
	          if (k > 0) {
	            wsa.push("and");
	          }
	
	          if (typeof queryWhereItem.fieldValue != "number" && !queryWhereItem.fieldValue) {
	            queryWhereItem.fieldValue = "";
	          }
	          var fieldValues = [];
	          if (queryWhereItem.fieldValue.indexOf && queryWhereItem.fieldValue.indexOf(",") != -1) fieldValues = queryWhereItem.fieldValue.split(",");else fieldValues = [queryWhereItem.fieldValue];
	
	          if (fieldValues.length > 1) wsa.push("(");
	          for (var n = 0; n < fieldValues.length; n++) {
	            var _fv = fieldValues[n];
	            if (n > 0) {
	              wsa.push("or", queryWhereItem.fieldName + "=" + _fv);
	            } else {
	              wsa.push(queryWhereItem.fieldName + "=" + _fv);
	            }
	          }
	          if (fieldValues.length > 1) wsa.push(")");
	
	          fieldsTypes[queryWhereItem.fieldName] = queryWhereItem.fieldType;
	        }
	
	        for (var i = 0; i < wsa.length; i++)
	        //for each(var s:String in wsa)
	        {
	          var s = wsa[i];
	          if (s.indexOf("=") == -1) {
	            wsr += s;
	          } else {
	            var fn = _StringUtil2.default.convertToEachFirstLowerCase(s.substring(0, s.indexOf("=")));
	            var fv = s.substr(s.indexOf("=") + 1);
	            if (fn.indexOf(".") == -1) {
	              var value = item[this.groupAlias + "." + fn];
	            } else {
	              value = item[this.groupAlias + "." + fn];
	            }
	            if (fieldsTypes[s.substring(0, s.indexOf("="))] == "TypeDecimal") {
	              value = parseFloat(value);
	            }
	            //fv为表达式一定为string  而"true"==true解释器会判定为false 所以如果value是bool 则要转为字符串判断
	            if (typeof value == "boolean") value += "";
	            if (_RecordsUtil2.default.analysisValue(value, fv, false, isRightContext)) {
	              wsr += "1";
	            } else {
	              wsr += "0";
	            }
	          }
	        }
	
	        return _StringUtil2.default.evalLEString(_StringUtil2.default.trimThrough(wsr));
	      }
	      return true;
	    }
	  }, {
	    key: 'getFormDataSourceFieldTypeByField',
	    value: function getFormDataSourceFieldTypeByField(field) {
	      if (this.sources) {
	        for (var i = 0; i < this.sources.length; i++) {
	          var source = this.sources[i];
	          var fieldTypeObj = source.fieldType;
	          if (fieldTypeObj && fieldTypeObj.hasOwnProperty(field)) return fieldTypeObj[field];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'executeQueryOnClient',
	    value: function executeQueryOnClient(queryTable, tasks) {
	      var isRightContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      this.updateQueryRemove();
	
	      if (this.records && this.records.length > 0) {
	        var oldCurrentIndex = this.records.indexOf(this.currentRecord);
	
	        this.tmpQueryTable = queryTable;
	        //TODO 临时表过滤 是否可依赖REACTDATAGRID本身的功能
	        var _analysisSingleRecord = this.analysisSingleRecord.bind(this);
	        var recordsFilter = this.records.filter(function (item) {
	          return _analysisSingleRecord(item, queryTable, isRightContext);
	        });
	
	        //this.dataProvider.filterFunction = qwiEqualsFilterFunc;
	        var _groupAlias = this.groupAlias;
	        var _getFormDataSourceFieldTypeByField = this.getFormDataSourceFieldTypeByField.bind(this);
	        if (queryTable.queryOrderBy && queryTable.queryOrderBy.length > 0) {
	          recordsFilter.sort(function (a, b) {
	            for (var i = 0; i < queryTable.queryOrderBy.length; i++) {
	              var qoi = queryTable.queryOrderBy[i];
	              if (qoi.fieldName && qoi.fieldName != "") {
	                var desc = qoi.orderBy == _QueryOrderByType2.default.DESC ? true : false;
	                var trueFieldName = _StringUtil2.default.convertToEachFirstLowerCase(qoi.fieldName);
	                //var fieldtype = _mainSource.fieldType[trueFieldName];
	                var _field = _groupAlias + "." + trueFieldName;
	                var aValue = a[_field];
	                var bValue = b[_field];
	                var _type = _getFormDataSourceFieldTypeByField(trueFieldName);
	                if (_type == "Decimal" || _type == "Long") {
	                  if (typeof aValue == "string" || typeof bValue == "string") {
	                    try {
	                      var aValueNum = parseFloat(aValue);var bValueNum = parseFloat(bValue);
	                      if (desc) return bValueNum - aValueNum; //(aValueNum < bValueNum) ? 1 : -1;
	                      else return aValueNum - bValueNum; //(aValueNum > bValueNum) ? 1 : -1;
	                    } catch (e) {}
	                  }
	                }
	
	                if (aValue == bValue) continue;
	                if (desc) return aValue < bValue ? 1 : -1;else return aValue > bValue ? 1 : -1;
	              }
	            }
	            return 0;
	          });
	        }
	
	        //TODO 有风险this.records = recordsFilter;
	        this.mapRecId = {};
	        if (!this.records) return;
	
	        var mainAlias = this.groupAlias;
	        var record;
	        for (var i = 0; i < this.records.length; i++) {
	          record = this.records[i];
	          var _recId = record[mainAlias + ".recId"];
	          this.mapRecId[_recId] = record;
	          this.recordsBak[_recId] = Object.assign({}, record);
	        }
	
	        _RecordsActions2.default.recordsCmp(recordsFilter, this.groupAlias, this);
	
	        var sp = _GOTUtil2.default.getPropertyValue(this.mainSource.xml, "StartPosition");
	        var newCurrentRecord = null;
	        if (recordsFilter && recordsFilter.length > 0) {
	          if (sp == "First") newCurrentRecord = recordsFilter[0];else newCurrentRecord = recordsFilter[recordsFilter.length - 1];
	        }
	        this.tempRecordsFilter = recordsFilter;
	
	        //var newCurrentRecord = (recordsFilter&&recordsFilter.length>oldCurrentIndex)?recordsFilter[oldCurrentIndex]:null;
	        this.setCurrentRecord(newCurrentRecord);
	      } else {}
	      this.after_rpc_result_executeQuery(false, tasks);
	      // if(this.dataProvider==null || this.dataProvider.length==0)
	      // {
	      //   this.currentRecord = null;
	      // }
	      this.tempRecordsFilter = recordsFilter;
	      if (recordsFilter && recordsFilter.length > 0) this.countGroup(recordsFilter);
	    }
	  }, {
	    key: 'executeQueryAutoSaveStop',
	    value: function executeQueryAutoSaveStop(type) {
	      var xml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var onlyFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var isOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var isRightContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	      var arg = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	      if (this.forLookup) {
	        return this.doExecuteQuery(type, xml, onlyFetch);
	      } else {
	        var result = this.onRecordAutoSave(this.groupAlias);
	
	        if (!result.remoteFail) {
	          return this.doExecuteQuery(type, xml, onlyFetch, false, null, isOrder, isRightContext, arg);
	        }
	      }
	    }
	  }, {
	    key: 'queryFilter',
	    value: function queryFilter(_dataField, value) {
	      var isRightContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Query, this.currentRecord)) {
	        _Fade2.default.show({ text: "您所在的用户组没有该权限" });return;
	      }
	
	      if (window.isDataSetView) {
	        this.dataSetQueryTable.queryAllFields = [];
	        this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
	        this.queryFilterForSetData(_dataField, "", "", this.dataSetQueryTable, value);
	      }
	      if (!window.isDataSetView) {
	        _QueryUtil2.default.findOrCreateWhereItem(_dataField, this.currentQuery, value);
	        this.reSetCurrentQuery(this.currentQuery);
	      }
	      //xml = null,onlyFetch = false,isOrder = false
	      this.executeQueryAutoSaveStop(null, null, false, false, isRightContext);
	    }
	
	    // queryFilterForSetData(xml,filed,value){
	    //   var fiedArr = filed.split(".");
	    //   var filedNameUp = fiedArr[1].substring(0,1).toUpperCase()+fiedArr[1].substring(1);
	    //   for(let i=0;i<this.dataSetQueryTable.queryFields.length;i++){
	    //     let queryItem = this.dataSetQueryTable.queryFields[i];
	    //     if(queryItem.fieldName == filedNameUp){
	    //       var queryWhereItem = new QueryWhereItem();
	    //       queryWhereItem.tableId = this.dataSetQueryTable.tableId;
	    //       queryWhereItem.fieldId = queryItem.refInnerId;
	    //       queryWhereItem.fieldName = queryItem.fieldName;
	    //       //queryWhereItem.fieldValue = queryItem.Properties.Value.V;
	    //       queryWhereItem.value = value;
	    //       let tableFiled = GOT.getTableFieldById(this.dataSetQueryTable.tableId,queryItem.refInnerId);
	    //       if(tableFiled)queryWhereItem.fieldType = "Type"+tableFiled.type;
	    //       queryWhereItem.andOr = "And";
	    //       queryWhereItem.leftBracket = "None";
	    //       queryWhereItem.rightBracket = "None";
	    //       queryWhereItem.label = "";
	    //       queryWhereItem.status = "Open";
	    //       queryWhereItem.tag = "";
	    //       this.dataSetQueryTable["queryWhere"].push(queryWhereItem)
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'getQueryFiledAllItemsForDataSetView',
	    value: function getQueryFiledAllItemsForDataSetView(query) {
	      if (this.dataSetQueryTable.queryAllFields == undefined) this.dataSetQueryTable.queryAllFields = [];
	      for (var i = 0; i < query.queryFields.length; i++) {
	        this.dataSetQueryTable.queryAllFields.push(query.queryFields[i]);
	      }
	      if (query.queryJoins.length >= 1) {
	        for (var h in query.queryJoins) {
	          this.getQueryFiledAllItemsForDataSetView(query.queryJoins[h]);
	        }
	      }
	    }
	  }, {
	    key: 'getAllQueryFieldssForDataSetView',
	    value: function getAllQueryFieldssForDataSetView(query) {
	      if (this.dataSetQueryTable.allQueryFields == undefined) this.dataSetQueryTable.allQueryFields = [];
	      for (var i = 0; i < query.queryFields.length; i++) {
	        var dataSourceName = query.aliasName.substr(query.aliasName.lastIndexOf("_") + 1, query.aliasName.length);
	        query.queryFields[i].dataSourceFliedName = dataSourceName + "." + _StringUtil2.default.convertToFirstLowerCase(query.queryFields[i].fieldName);
	        this.dataSetQueryTable.allQueryFields.push(query.queryFields[i]);
	      }
	      if (query.queryJoins.length >= 1) {
	        for (var h in query.queryJoins) {
	          this.getAllQueryFieldssForDataSetView(query.queryJoins[h]);
	        }
	      }
	    }
	  }, {
	    key: 'getQueryOrderByAllItemsForDataSetView',
	    value: function getQueryOrderByAllItemsForDataSetView(query) {
	      if (this.dataSetQueryTable.queryOrderByFields == undefined) this.dataSetQueryTable.queryOrderByFields = [];
	      for (var i = 0; i < query.queryOrderBy.length; i++) {
	        this.dataSetQueryTable.queryOrderByFields.push(query.queryOrderBy[i]);
	      }
	      if (query.queryJoins.length >= 1) {
	        for (var h in query.queryJoins) {
	          this.getQueryOrderByAllItemsForDataSetView(query.queryJoins[h]);
	        }
	      }
	    }
	  }, {
	    key: 'queryFilterForSetData',
	    value: function queryFilterForSetData(tableField, field, alias, query) {
	      var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      var fiedArr = tableField.split(".");
	      var filedNameUp = fiedArr[1].substring(0, 1).toUpperCase() + fiedArr[1].substring(1);
	      if (!this.dataSetQueryTable.queryAllFields) {
	        this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
	      }
	      for (var i = 0; i < this.dataSetQueryTable.queryAllFields.length; i++) {
	        var queryItem = this.dataSetQueryTable.queryAllFields[i];
	        if (queryItem.fieldAliasName && queryItem.fieldAliasName == fiedArr[1] || _StringUtil2.default.convertToAllLowerCase(queryItem.fieldName) == _StringUtil2.default.convertToAllLowerCase(filedNameUp)) {
	          var queryWhereItem = new _QueryWhereItem2.default();
	          queryWhereItem.qname = _QueryWhereItem2.default;
	          queryWhereItem.tableId = queryItem.refEntityId; //String
	          queryWhereItem.fieldId = queryItem.refInnerId; //String
	          var tableFiled = _GOT2.default.getTableFieldById(queryItem.refEntityId, queryItem.refInnerId);
	          if (tableFiled) queryWhereItem.fieldType = "Type" + tableFiled.type;
	          queryWhereItem.fieldName = queryItem.fieldName; //String
	
	          // if(value.indexOf(">=") != -1 || value.indexOf("<=") != -1  || value.indexOf("<>") != -1 ) {
	          // 	value = value.slice(0,2)+"\'"+value.slice(2)+"\'"; 
	          // }
	          queryWhereItem.value = value; //String
	          queryWhereItem.andOr = "And"; //String
	          queryWhereItem.leftBracket = "None"; //String	//QueryWhereLeftBracket
	          queryWhereItem.rightBracket = "None"; //String	//QueryWhereRightBracket
	
	          queryWhereItem.label = ""; //String
	          queryWhereItem.status = "Open"; //String			//QueryWhereStatus	//String	//QueryWhereFieldType
	          queryWhereItem.tag = ""; //String
	          if (queryItem.type && queryItem.type == 'Expression') {
	            queryWhereItem.fieldType = 'Expression';
	          }
	          //queryWhereItem.fieldValue = value;
	
	
	          for (var _i15 in query.queryWhere) {
	            if (query.queryWhere[_i15].tableId === query.tableId && query.queryWhere[_i15].fieldId === queryItem.refInnerId && query.queryWhere[_i15].andOr === "And") {
	              if (query.queryWhere[_i15].fieldType == "TypeDate") {
	                if (value.indexOf(">=") != -1 && query.queryWhere[_i15].value.indexOf(">=") != -1 || value.indexOf("<=") != -1 && query.queryWhere[_i15].value.indexOf("<=") != -1 || value.indexOf("<>") != -1 && query.queryWhere[_i15].value.indexOf("<>") != -1) {
	                  query.queryWhere.splice(_i15, 1);
	                }
	              } else {
	                query.queryWhere.splice(_i15, 1);
	              }
	            }
	          }
	          if (query.tableId == queryItem.refEntityId) {
	            if (typeof value == 'string' && value.indexOf("<>") == -1) {
	              query.queryWhere.push(queryWhereItem);
	            } else {
	              query.queryWhere.push(queryWhereItem);
	            }
	          } else if (query.queryJoins.length > 0) {
	            for (var h in query.queryJoins) {
	              query.queryJoins[h]["QueryInteraction"] = query.QueryInteraction;
	              this.queryFilterForSetData(tableField, "", alias, query.queryJoins[h], value);
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'sort',
	    value: function sort(dataField) {
	      var sortType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var byUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var cover = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      //activeCurrentRecord已经触发 此时权限已经取得并反映到toolbarObject
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Query, this.currentRecord)) {
	        if (!window.isDataSetView) {
	          _Fade2.default.show({ text: "您所在的用户组没有该权限" });return;
	        }
	      }
	
	      if (window.isDataSetView) {
	        this.getQueryOrderByAllItemsForDataSetView(this.dataSetQueryTable);
	        var fiedArr = dataField.split(".");
	        var filedNameUp = fiedArr[1].substring(0, 1).toUpperCase() + fiedArr[1].substring(1);
	        for (var i = 0; i < this.dataSetQueryTable.queryOrderByFields.length; i++) {
	          var queryItem = this.dataSetQueryTable.queryOrderByFields[i];
	          for (var _i16 = 0; _i16 < this.dataSetQueryTable.queryAllFields.length; _i16++) {
	            var query = this.dataSetQueryTable.queryAllFields[_i16];
	            if (_StringUtil2.default.convertToAllLowerCase(query.fieldName) == _StringUtil2.default.convertToAllLowerCase(filedNameUp) || query.fieldAliasName == filedNameUp) {
	              if (_StringUtil2.default.convertToAllLowerCase(queryItem.fieldName) == _StringUtil2.default.convertToAllLowerCase(query.fieldName)) {
	                if (queryItem.orderBy == "ASC") {
	                  sortType = "DESC";
	                } else {
	                  sortType = "ASC";
	                }
	              }
	            }
	          }
	        }
	        this.reSetDataSetExecuteSort(null, this.dataSetQueryTable);
	        this.dataSetQueryTable.queryAllFields = [];
	        this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
	        this.sortForSetData(this.dataSetQueryTable, dataField, sortType, byUser, cover);
	      } else {
	        _QueryUtil2.default.setCurrentQueryOrderByByDataField(dataField, this.currentQuery, sortType, byUser, cover);
	        this.reSetCurrentQuery(this.currentQuery);
	      }
	      this.executeQueryAutoSaveStop(null, null, false, true);
	    }
	    //
	
	  }, {
	    key: 'sortForSetData',
	    value: function sortForSetData(query, filed, sortType, byUser, cover) {
	      var fiedArr = filed.split(".");
	      var filedNameUp = fiedArr[1].substring(0, 1).toUpperCase() + fiedArr[1].substring(1);
	      this.dataSetQueryTable["queryOrderBy"] = [];
	      var queryOrderByItem = new _QueryOrderByItem2.default();
	      for (var i = 0; i < this.dataSetQueryTable.queryAllFields.length; i++) {
	        var queryItem = this.dataSetQueryTable.queryAllFields[i];
	        if (_StringUtil2.default.convertToAllLowerCase(queryItem.fieldName) == _StringUtil2.default.convertToAllLowerCase(filedNameUp) || queryItem.fieldAliasName == filedNameUp) {
	          var queryOrderByItem = new _QueryOrderByItem2.default();
	          queryOrderByItem.tableId = this.dataSetQueryTable.tableId;
	          queryOrderByItem.fieldId = queryItem.refInnerId;
	          queryOrderByItem.fieldName = queryItem.fieldName;
	          queryOrderByItem.orderBy = sortType;
	          queryOrderByItem.fieldType = queryItem.type;
	          if (query.tableId == queryItem.refEntityId) {
	            query.queryOrderBy.push(queryOrderByItem);
	          } else if (query.queryJoins.length > 0) {
	            for (var h in query.queryJoins) {
	              query.queryJoins[h]["QueryInteraction"] = query.QueryInteraction;
	              this.sortForSetData(query.queryJoins[h], filed, sortType, byUser, cover);
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'sortForLookup',
	    value: function sortForLookup(dataField) {
	      var sortType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var byUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var cover = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      _QueryUtil2.default.setCurrentQueryOrderByByDataField(dataField, this.currentQuery, sortType, byUser, cover);
	      this.reSetCurrentQuery(this.currentQuery);
	      this.executeQueryAutoSaveStop(null, null, false, true);
	    }
	  }, {
	    key: 'doQueryRemove',
	    value: function doQueryRemove() {
	      this.reSetCurrentQuery(JSON.parse(JSON.stringify(this.formQuery)));
	      this.executeQueryAutoSaveStop(null);
	    }
	  }, {
	    key: 'doDataSetExecuteQuery',
	    value: function doDataSetExecuteQuery(arg) {
	      var xml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (xml != null) {
	        this.reSetCurrentQuery(xml);
	      }
	      var type = arg.type;var fromFirst;var startIndex = 0;
	      var size = 50;
	      if (type == "FetchAll") {
	        startIndex = 0;
	        size = 200000;
	      } else {
	        if (this.currentQuery.direction == "First") {
	          fromFirst = true;
	          if (this.records == null || this.currentQuery.needRefresh == true) {
	            startIndex = 0;
	          } else {
	            if (type == "NextPage" || type == "Next" || type == "PrevPage") startIndex = this.records.length;
	          }
	        } else {
	          fromFirst = false;
	          if (this.records == null || this.currentQuery.needRefresh == true) {
	            startIndex = 0;
	          } else {
	            if (type == "PrevPage" || type == "Prev") startIndex = this.records.length;
	          }
	        }
	        if (startIndex) {} else {
	          this.currentQuery.needRefresh = true;
	        }
	        // 暂时放开 20000
	      }
	
	      if (window.parent.dataSetPreviewFordataset) {
	        window.parent.dataSetPreviewFordataset.query.QueryTable = this.dataSetQueryTable;
	      }
	      // window.parent.window.didomain ="doMain_412";
	      // if(window.parent.window.didomain){
	      var queryTable = this.dataSetQueryTable;
	
	      if (window.parent.dataSetPreviewFordataset) {
	        window.parent.dataSetPreviewFordataset.query.queryTable = queryTable;
	      }
	
	      var domain = queryTable.doMain;
	      if (window.parent.window.dataSetPreviewForPrintApp) {
	        domain = window.parent.window.prientAppDomain;
	      }
	      if (!domain) {
	        domain = window.parent.window.didomain;
	      }
	      //TODO 综合域暂时写死 MIX
	      // var url = window.parent.window.osUrl+"/"+window.parent.window.didomain+"/web/apps/gongqi.tool.datasetDesign/dsDesign/executeQuery";
	      var url = window.parent.window.osUrl + "/" + "MIX" + "/web/apps/gongqi.tool.datasetDesign/dsDesign/executeQuery";
	      var _headers = { "Content-type": "application/json" };
	      if (!window.parent.window.loginToken) {
	        var _token = localStorage.getItem("userToken");
	        if (_token) {
	          _headers.token = _token;
	        } else {
	          _headers.token = window.parent.localStorage.getItem("userToken");
	        }
	      }
	      var _that = this;
	      var param = {
	        "queryTable": queryTable,
	        "stat": startIndex,
	        "size": size,
	        "init": false
	      };
	      _AjaxRemoteUtil2.default.setRemoteDisable({ lockText: '正在努力加载数据...', autoLock: true });
	      $.ajax({
	        type: 'post',
	        url: url,
	        dataType: "json",
	        headers: _headers,
	        data: JSON.stringify(param),
	        success: function success(data) {
	          if (data.errcode == 0) {
	            _AjaxRemoteUtil2.default.setRemoteEnable({ autoUnlock: true });
	            data.result = JSON.parse(data.content);
	            data.status = 0;
	            _that.rpc_dsExecuteQuery_result(arg, data);
	          } else {
	            _AjaxRemoteUtil2.default.setRemoteEnable({ autoUnlock: true });
	            var text = "查询失败：" + data.errmsg;
	            // var options = {state: 'error',text:text};
	            // Fade.show(options);
	            _Warn2.default.show({ text: text, mutiLine: true });
	          }
	        },
	        error: function error(data) {
	          var text = "查询失败";
	          var options = { state: 'error', text: text };
	          _Fade2.default.show(options);
	        }
	      });
	      // }else{
	      //     ServiceHelper.addTokenWithCommand({command:command,
	      //       resultFunction:this.rpc_dsExecuteQuery_result.bind(this,arg)});
	      // }
	    }
	  }, {
	    key: 'doExecuteQuery',
	    value: function doExecuteQuery(type) {
	      var xml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var onlyFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var sync = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var tasks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	      var isOrder = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	      var isRightContext = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	      var arg = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
	
	
	      if (window.isDataSetView && !this.forLookup) {
	        this.doDataSetExecuteQuery({ type: type });
	        return;
	      }
	
	      if (xml != null) {
	        this.reSetCurrentQuery(xml);
	      }
	
	      if (this.currentQuery == null) return;
	
	      var command;
	      var _queryTable;
	      var fromFirst;
	      var startIndex;
	
	      if (this.mainSource.fetchAll == true) type = "FetchAll";
	
	      var fmLookup;
	
	      //****************  非FormLookup的下拉框
	      if (this.forLookup) // && this.formDataSources.formModule.classAlias != "FormLookup")
	        {
	          if (arg && arg.appendFilter == true) {
	            if (this.records == null || this.currentQuery.needRefresh == true) {
	              this.appendWhereItemForFormModuleLookup(this.currentQuery, this.formDataSources.formModule);
	            }
	          }
	        }
	      //*********************
	
	
	      if (this.mainSource.isTempTable == true || isOrder && this.sortOnClient) {
	        _queryTable = this.getCurrentQueryTable();
	        _queryTable.queryRelations = null;
	        this.executeQueryOnClient(_queryTable, tasks, isRightContext);
	        return;
	      }
	
	      //TODO 初始化查询要异步 命令同步是通过栈实现的 此处判断不会影响到命令的执行 只会防止两个重复的异步查询
	      //if(inRemotingExecuteQuery)
	      //  return;
	
	      if (this.flag_enterMainForm == true) {
	        var mainTableWhereValues = window.argCaller.mainTableWhereValues;
	        for (var i = 0; i < mainTableWhereValues.length; i++) {
	          var kv = mainTableWhereValues[i];
	          var _value = kv.value;
	          if (_value == "") _value = null;
	
	          _QueryUtil2.default.createWhereItemByField(kv.key, kv.key, this.mainSource.alias, this.currentQuery, _value);
	        }
	        this.flag_enterMainForm = false;
	      }
	
	      _queryTable = this.getCurrentQueryTable();
	
	      /////
	      if (this.currentQuery.direction == "Last") {
	        _QueryUtil2.default.reverseOrderBy(_queryTable.queryOrderBy);
	      }
	      /////
	      _queryTable.queryRelations = null;
	      var commandArg;
	
	      if (type == "FetchAll") {
	        if (this.formDataSources.formModule.classAlias == "FormLookup") {
	          fmLookup = this.formDataSources.formModule;
	
	          if (fmLookup != null && fmLookup.lookupArg != null) {
	            var formId = fmLookup.lookupArg["baseFormId"];
	            if (formId) {
	              var fieldName;
	              if (fmLookup.lookupArg["groupAlias"] != null) {
	                fieldName = fmLookup.lookupArg["groupAlias"] + "." + "lookup_" + fmLookup.lookupArg["fieldName"];
	              } else {
	                fieldName = "lookup_" + fmLookup.lookupArg["filterFieldName"];
	              }
	              var cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(fieldName, window.menuItemId, window.formId);
	              if (cmdargInfo != null) {
	                //TODO FormDataSourceGroup只作用于FormLookup及FormModule QueryForm Dialog Report的查询不使用该类
	                // var fm:FormModule = fmLookup.lookupCaller as FormModule;
	                // if(fm!=null)
	                // {
	                var defaultGroupAlias = fmLookup.lookupArg["groupAlias"];
	                commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, defaultGroupAlias, cmdargInfo);
	                // }
	              }
	            }
	          }
	
	          // if(fmLookup.lookupCaller is FormLookup 
	          //   || fmLookup.lookupCaller is QueryForm
	          //   || fmLookup.lookupCaller is ReportModule
	          //   || fmLookup.lookupCaller is FormBaseModuleForDialog)  
	          // {
	          //   command = Command.createService( "gongqi.erp.gotmodel.services.GOTService", "doLookup", "FormDataSourceGroupResult")
	          //     .appendArg(fmLookup.lookupArg["fieldName"], "String")
	          //     .appendArg(fmLookup.lookupArg["filterFieldName"], "String")
	          //     .appendArg(fmLookup.lookupArg["baseFilter"], "String")
	          //     .appendArg(fmLookup.lookupArg["queryObject"], "Object")
	          //     .appendArg(false.toString(), "boolean")
	          //     .appendArg("0", "int")
	          //     .appendArg("0", "int")
	          //     .appendArg("false", "boolean");
	          // }
	          // else if(fmLookup.lookupCaller is FormModule)  //FormModule FormModuleLookup
	          // {
	          if (fmLookup.lookupArg.editorFormType == "Dialog") {
	            command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "doLookup", "FormDataSourceGroupResult").appendArg(fmLookup.lookupArg["fieldName"], "String").appendArg(fmLookup.lookupArg["filterFieldName"], "String").appendArg(fmLookup.lookupArg["baseFilter"], "String").appendArg(fmLookup.lookupArg["queryObject"], "Object").appendArg(false.toString(), "boolean").appendArg("0", "int").appendArg("0", "int").appendArg("false", "boolean");
	          } else {
	            command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doLookup").appendArg(commandArg, "CommandArg").appendArg(fmLookup.lookupArg["groupAlias"], "String").appendArg(fmLookup.lookupArg["fieldName"], "String").appendArg(fmLookup.lookupArg["filterFieldName"], "String").appendArg(fmLookup.lookupArg["baseFilter"], "String").appendArg(fmLookup.lookupArg["baseRecord"], "Object").appendArg(fmLookup.lookupArg["queryObject"], "Object").appendArg("false", "boolean").appendArg("0", "int").appendArg("0", "int").appendArg("false", "boolean");
	          }
	
	          // }
	          // else
	          // {
	          //   throw new Error("fmLookup.lookupCaller undefined");
	          // }
	        } else {
	          var fieldName = this.groupAlias + ".beforeExecuteQuery";
	          var fm = this.formDataSources.formModule;
	          var cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(fieldName, fm.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId, fm.props.formId);
	
	          if (cmdargInfo == null) {
	            cmdargInfo =
	            //FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeExecuteQuery",fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,fm.props.formId)
	            _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterExecuteQuery", fm.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId, fm.props.formId);
	            if (cmdargInfo == null) {
	              cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".executeQuery", fm.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId, fm.props.formId);
	              if (cmdargInfo == null) cmdargInfo = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };
	            }
	          }
	
	          if (cmdargInfo != null) {
	            commandArg = _CommandResolver2.default.getSendCmd(this.formDataSources.formModule, this.groupAlias, cmdargInfo);
	          }
	
	          command = _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "executeQuery").appendArg(commandArg, "CommandArg").appendArg(this.groupAlias, "String").appendArg(_queryTable, "Object").appendArg("false", "boolean").appendArg("0", "int").appendArg("0", "int").appendArg("false", "boolean");
	        }
	      } else {
	        if (this.currentQuery.direction == "First") {
	          fromFirst = true;
	          if (this.records == null || this.currentQuery.needRefresh == true) {
	            startIndex = 0;
	          } else {
	            if (type == "NextPage" || type == "Next") startIndex = this.records.length;
	          }
	          if (this.dynamicColumnsPre) {
	            startIndex = 0;
	          }
	        } else {
	          fromFirst = false;
	          if (this.records == null || this.currentQuery.needRefresh == true) {
	            startIndex = 0;
	          } else {
	            if (type == "PrevPage" || type == "Prev") startIndex = this.records.length;
	          }
	        }
	
	        if (this.formDataSources.formModule.classAlias == "FormLookup") {
	          fmLookup = this.formDataSources.formModule;
	          fmLookup.lookupArg["queryObject"] = _queryTable;
	
	          if (fmLookup != null && fmLookup.lookupArg != null) {
	            formId = fmLookup.lookupArg["baseFormId"];
	            if (formId != null) {
	
	              if (fmLookup.lookupArg["groupAlias"] != null) {
	                fieldName = fmLookup.lookupArg["groupAlias"] + "." + "lookup_" + fmLookup.lookupArg["fieldName"];
	              } else {
	                fieldName = "lookup_" + fmLookup.lookupArg["filterFieldName"];
	              }
	              cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(fieldName);
	              defaultGroupAlias = fmLookup.lookupArg["groupAlias"];
	              if (cmdargInfo != null) {
	                // fm = fmLookup.lookupCaller as FormModule;
	                // if(fm!=null)
	                // {
	                commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, defaultGroupAlias, cmdargInfo);
	                // }
	              } else {
	                commandArg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, defaultGroupAlias, { groups: "current(3)", editors: null, joinGroup: null });
	              }
	            }
	          }
	
	          if (fmLookup.lookupArg.editorFormType == "Dialog") {
	            command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "doLookup", "FormDataSourceGroupResult").appendArg(fmLookup.lookupArg["fieldName"], "String").appendArg(fmLookup.lookupArg["filterFieldName"], "String").appendArg(fmLookup.lookupArg["baseFilter"], "String").appendArg(fmLookup.lookupArg["queryObject"], "Object").appendArg("true", "boolean").appendArg(startIndex + "", "int").appendArg(this.dataPageSize + "", "int").appendArg(fromFirst + "", "boolean");
	          } else {
	            command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doLookup").appendArg(commandArg, "CommandArg").appendArg(fmLookup.lookupArg["groupAlias"], "String").appendArg(fmLookup.lookupArg["fieldName"], "String").appendArg(fmLookup.lookupArg["filterFieldName"], "String").appendArg(fmLookup.lookupArg["baseFilter"], "String").appendArg(fmLookup.lookupArg["baseRecord"], "Object").appendArg(fmLookup.lookupArg["queryObject"], "Object").appendArg("true", "boolean").appendArg(startIndex + "", "int").appendArg(this.dataPageSize + "", "int").appendArg(fromFirst + "", "boolean");
	          }
	        } else {
	
	          //TODO 暂时用来屏蔽由于最末条 滚动条通过编程方式到末尾时也会触发nextPage 而此时startIndex未定义
	          if (startIndex == undefined) return;
	
	          var fieldName = this.groupAlias + ".beforeExecuteQuery";
	          var fm = this.formDataSources.formModule;
	
	          var cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(fieldName, fm.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId, fm.classAlias == "FormModuleLookup" ? this.formDataSources.formModule.formId : window.formId);
	          if (cmdargInfo == null) {
	            cmdargInfo = //FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeExecuteQuery",
	            //                                             fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,
	            //                                             fm.classAlias=="FormModuleLookup"?this.formDataSources.formModule.formId:window.formId)
	            //|| 
	            _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".afterExecuteQuery", fm.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId, fm.classAlias == "FormModuleLookup" ? this.formDataSources.formModule.formId : window.formId);
	            if (cmdargInfo == null) {
	              cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + ".executeQuery", fm.classAlias == "FormModuleLookup" ? "FormLookup" : window.menuItemId, fm.classAlias == "FormModuleLookup" ? this.formDataSources.formModule.formId : window.formId);
	              if (cmdargInfo == null) cmdargInfo = { groups: "current(3)", editors: null, joinGroup: null, fetchOption: true };else if (!cmdargInfo.groups) cmdargInfo.groups = "current(3)";
	            }
	          }
	          if (cmdargInfo != null) {
	            commandArg = _CommandResolver2.default.getSendCmd(this.formDataSources.formModule, this.groupAlias, cmdargInfo);
	          }
	
	          command = _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "executeQuery").appendArg(commandArg, "CommandArg").appendArg(this.groupAlias, "String").appendArg(_queryTable, "Object").appendArg("true", "boolean").appendArg(startIndex + "", "int").appendArg(this.dataPageSize + "", "int").appendArg(fromFirst + "", "boolean");
	        }
	      }
	
	      var _rpc_result_executeQuery = this.rpc_result_executeQuery.bind(this);
	      var _this = this;
	      if (command.methodName == "doLookup" && (window.parent.window.TableCheckDoMain || window.parent.window.lookupEditorDoMain)) {
	        var domain = window.parent.window.lookupEditorDoMain ? window.parent.window.lookupEditorDoMain : window.parent.window.TableCheckDoMain;
	        var url = window.parent.window.osUrl + "/GongqiERP/" + domain + "/ServiceController";
	        return _ServiceHelper2.default.addTokenWithCommand2({ command: command, lockText: "正在努力获取数据 请稍后", url: url, domain: domain,
	          resultFunction: function resultFunction(data) {
	            _rpc_result_executeQuery(data, type, onlyFetch, tasks);
	            //alert(JSON.stringify(data));
	          }, sync: sync,
	          faultFunction: function faultFunction(data) {
	            //不管是何原因导致的错误 都认为可能是由于默认查询失效 使用正确的查询再试一次
	            if (_this.fromDefaultSavedQuery) {
	              _Warn2.default.show({ text: "之前保存的默认查询已失效，已自动更正" });
	              _this.fromDefaultSavedQuery = false;
	
	              var key = _this.formDataSources.formModule.props.formId + "_" + _this.mainSource.id + "." + (_this.forLookup ? "FormLookup" : window.menuItemId);
	              //delete QueryUtil.userQueryList[key];
	              _QueryUtil2.default.deleteUserQueryList(key);
	              _this.initFormQuery();
	              _this.initCurrentQuery();
	              _this.doExecuteQuery();
	
	              return;
	            }
	            //如果第二次试验都不行 则进入正常错误处理流程
	            if (data && data.successButNot0) {
	              if (window.parent.document.getElementsByClassName("gongqi-warn") && window.parent.document.getElementsByClassName("gongqi-warn").length < 1) {
	                _Warn2.default.show({ text: data.errText, title: "查询失败" });
	              }
	            } else {
	              _Warn2.default.show({ text: "请检查网络是否正常或联系管理员", title: "画面初始查询失败" });
	            }
	            window.groupActiveRecordStateObj[this.groupAlias].querying = false;
	            //Warning.show({text:JSON.stringify(data)});
	          }
	        });
	      } else {
	        return _ServiceHelper2.default.addTokenWithCommand({ command: command, lockText: "正在努力获取数据 请稍后",
	          resultFunction: function resultFunction(data) {
	            _rpc_result_executeQuery(data, type, onlyFetch, tasks);
	            //alert(JSON.stringify(data));
	          }, sync: sync,
	          faultFunction: function faultFunction(data) {
	            //不管是何原因导致的错误 都认为可能是由于默认查询失效 使用正确的查询再试一次
	            if (_this.fromDefaultSavedQuery) {
	              _Warn2.default.show({ text: "之前保存的默认查询已失效，已自动更正" });
	              _this.fromDefaultSavedQuery = false;
	
	              var key = _this.formDataSources.formModule.props.formId + "_" + _this.mainSource.id + "." + (_this.forLookup ? "FormLookup" : window.menuItemId);
	              //delete QueryUtil.userQueryList[key];
	              _QueryUtil2.default.deleteUserQueryList(key);
	              _this.initFormQuery();
	              _this.initCurrentQuery();
	              _this.doExecuteQuery();
	
	              return;
	            }
	            //如果第二次试验都不行 则进入正常错误处理流程
	            if (data && data.successButNot0) {
	              if (window.parent.document.getElementsByClassName("gongqi-warn") && window.parent.document.getElementsByClassName("gongqi-warn").length < 1) {
	                _Warn2.default.show({ text: data.errText, title: "查询失败" });
	              }
	            } else {
	              _Warn2.default.show({ text: "请检查网络是否正常或联系管理员", title: "画面初始查询失败" });
	            }
	            window.groupActiveRecordStateObj[this.groupAlias].querying = false;
	            //Warning.show({text:JSON.stringify(data)});
	          }
	        });
	      }
	    }
	  }, {
	    key: 'updateQueryRemove',
	    value: function updateQueryRemove() {
	      var formQueryChild = this.formQuery.QueryTable;
	      var currentQueryChild = this.currentQuery.QueryTable;
	
	      this.queryChanged = JSON.stringify(formQueryChild) != JSON.stringify(currentQueryChild);
	
	      if (this.isGlobalForehandGroup()) {
	        var toolBarObject = window.toolBarObject;
	        if (this.currentQuery.QueryTable.queryWhere && this.currentQuery.QueryTable.queryWhere.Items.length > 0) {
	          this.queryChanged = true;
	        }
	        _ToolBarUtil2.default.setObjectQueryRemove(toolBarObject, this.queryChanged);
	        var _parentWindow = window.parent.window;
	        _parentWindow.setToolBar(toolBarObject);
	        _UtilActions2.default.updateInnerToolBar(toolBarObject);
	      }
	    }
	    //record<=>newRecord
	
	  }, {
	    key: 'replaceRecord3',
	    value: function replaceRecord3(record) {
	      var replaceAttr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var ac = this.records;
	      if (!ac) throw new Error("ac==null");
	
	      var mainAlias = this.groupAlias;
	      var recId = record[mainAlias + ".recId"];
	      /*if(!this.mapRecId.hasOwnProperty(recId))
	      {
	       
	        this.mapRecId[recId] = item;
	        this.recordsBak[recId] = Object.assign({},record);
	      }
	        throw new Error("mapRecId中不存在" + recId);*/
	
	      var origRecord = this.mapRecId[recId];
	      if (replaceAttr) {
	        if (origRecord == null) {
	          alert("origRecord null");
	        } else if (record == null) {
	          alert("record null when replaceRecord");
	        } else {
	          this.replaceRecordValue(record, origRecord);
	        }
	      } else {
	        var index = ac.indexOf(origRecord);
	        //alert("替换了第"+index+"条记录");
	        if (index == -1) alert("index==-1  " + recId);
	        ac[index] = record;
	
	        if (this.tempRecordsFilter) {
	          index = this.tempRecordsFilter.indexOf(origRecord);
	          if (index != -1) this.tempRecordsFilter[index] = record;
	        }
	      }
	    }
	  }, {
	    key: 'replaceRecord',
	    value: function replaceRecord(record) {
	      var replaceAttr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var ac = this.records;
	      if (!ac) throw new Error("ac==null");
	
	      var mainAlias = this.groupAlias;
	      var recId = record[mainAlias + ".recId"];
	      //TODO_YL  不存在的跳过
	      if (!this.mapRecId.hasOwnProperty(recId)) return;
	      // throw new Error("mapRecId中不存在" + recId);
	      var origRecord = this.mapRecId[recId];
	      if (replaceAttr) {
	        if (origRecord == null) {
	          alert("origRecord null");
	        } else if (record == null) {
	          alert("record null when replaceRecord");
	        } else {
	          this.replaceRecordValue(record, origRecord);
	        }
	      } else {
	        var index = ac.indexOf(origRecord);
	        if (index == -1) alert("index==-1  " + recId);
	        ac[index] = record;
	      }
	    }
	  }, {
	    key: 'replaceRecordValue',
	    value: function replaceRecordValue(record, result) {
	      if (record == null || result == null) return;
	
	      for (var itemName in record) {
	        var item = record[itemName];
	        result[itemName] = item;
	      }
	    }
	  }, {
	    key: 'resetMapRecId',
	    value: function resetMapRecId() {
	      this.mapRecId = {};
	      if (!this.records) return;
	
	      var mainAlias = this.groupAlias;
	      var record;
	      for (var i = 0; i < this.records.length; i++) {
	        record = this.records[i];
	        var _recId = record[mainAlias + ".recId"];
	        this.mapRecId[_recId] = record;
	        this.recordsBak[_recId] = Object.assign({}, record);
	      }
	    }
	  }, {
	    key: 'local_recordFirst',
	    value: function local_recordFirst() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var parms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!this.records || this.records.length == 0) {
	        this.setCurrentRecord(null, true, parms);
	        return;
	      }
	
	      this.setCurrentRecord(this.records[0]);
	
	      if (focus) {}
	      //this.formDataSources.formModule.focusRecord();
	    }
	  }, {
	    key: 'local_recordNext',
	    value: function local_recordNext() {
	      var parms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this.records || this.records.length == 0) {
	        this.setCurrentRecord(null, true, parms);
	        return;
	      }
	
	      var oldIndex = this.records.indexOf(this.currentRecord);
	
	      var index = 0;
	      if (!this.currentRecord) {
	        index = 0;
	      } else {
	        index = oldIndex + 1;
	      }
	
	      var findex = Math.min(index, this.records.length - 1);
	
	      this.setCurrentRecord(this.records[findex]);
	    }
	  }, {
	    key: 'recordFirst',
	    value: function recordFirst(groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId) return;
	
	      if (!this.currentQuery) return;
	
	      if (this.currentQuery.direction == "First") {
	        this.local_recordFirst();
	      } else {
	        if (this.currentQuery.toEnd == true) {
	          this.local_recordFirst();
	        } else {
	          this.currentQuery.direction = "First";
	          this.currentQuery.toEnd = false;
	          this.currentQuery.needRefresh = true;
	
	          this.executeQueryAutoSaveStop("First");
	        }
	      }
	    }
	  }, {
	    key: 'recordLast',
	    value: function recordLast(groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId) return;
	      if (!this.currentQuery) return;
	
	      if (this.currentQuery.direction == "First") {
	        if (this.currentQuery.toEnd == true) {
	          this.local_recordLast();
	        } else {
	          this.currentQuery.direction = "Last";
	          this.currentQuery.toEnd = false;
	          this.currentQuery.needRefresh = true;
	
	          this.executeQueryAutoSaveStop("Last");
	        }
	      } else if (this.currentQuery.direction == "Last") {
	        this.local_recordLast();
	      }
	    }
	  }, {
	    key: 'local_recordLast',
	    value: function local_recordLast() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var parms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!this.records || this.records.length == 0) {
	        this.setCurrentRecord(null, true, parms);
	        return;
	      }
	
	      var _currentRecord = this.records[this.records.length - 1];
	      this.setCurrentRecord(_currentRecord);
	
	      if (focus) {}
	    }
	  }, {
	    key: 'local_recordPrev',
	    value: function local_recordPrev() {
	      var parms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this.records || this.records.length == 0) {
	        this.setCurrentRecord(null, true, parms);
	        return;
	      }
	
	      var oldIndex = this.records.indexOf(this.currentRecord);
	
	      var index = 0;
	      if (this.currentRecord == null) {
	        index = 0;
	      } else {
	        index = oldIndex - 1;
	      }
	
	      if (index < 0) {
	        index = 0;
	      }
	
	      var _currentRecord = this.records[index];
	      this.setCurrentRecord(_currentRecord);
	    }
	  }, {
	    key: 'recordNextPage',
	    value: function recordNextPage(onlyFetch, groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId) return;
	
	      if (!this.currentQuery) return;
	
	      if (this.currentQuery.direction == "First") {
	        if (this.currentQuery.toEnd == true) {
	          if (onlyFetch == false) this.local_recordNextPage();
	        } else {
	          if (!this.records || this.records.length == 0) {
	            this.executeQueryAutoSaveStop("NextPage");
	          } else {
	            var oldIndex = this.records.indexOf(this.currentRecord);
	            var index;
	            var result = {};
	            _UtilActions2.default.getGridInfos(this.groupAlias, result, this.formDataSources.formModule.instanceUUId);
	            if (result.linesOnScreen) {
	              index = result.verticalScrollPosition + Math.ceil(result.linesOnScreen);
	            } else {
	              index = oldIndex;
	            }
	
	            if (index + result.linesOnScreen * 2 >= this.records.length - 1 || oldIndex + result.linesOnScreen * 2 >= this.records.length - 1) {
	              this.executeQueryAutoSaveStop("NextPage", null, onlyFetch);
	            } else {
	              if (onlyFetch == false) this.local_recordNextPage();
	            }
	          }
	        }
	      } else {
	        if (onlyFetch == false) this.local_recordNextPage();
	      }
	    }
	  }, {
	    key: 'recordPrevPage',
	    value: function recordPrevPage() {
	      var onlyFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var groupAlias = arguments[1];
	      var moduleInstanceId = arguments[2];
	
	      if (groupAlias != this.groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId) return;
	      if (this.currentQuery == null) return;
	      //if(this.currentQuery.direction=="Last")
	      //{
	      if (this.currentQuery.toEnd == true) {
	        //if(onlyFetch==false)
	        // this.local_recordPrevPage();
	      } else {
	        if (!this.records || this.records.length == 0) {
	          this.executeQueryAutoSaveStop("PrevPage");
	        } else {
	          var index;
	          var result = {};
	          _UtilActions2.default.getGridInfos(this.groupAlias, result, this.formDataSources.formModule.instanceUUId);
	          if (result.linesOnScreen) {
	            index = result.verticalScrollPosition + Math.ceil(result.linesOnScreen);
	          } else {
	            index = oldIndex;
	          }
	          if (onlyFetch && result.linesOnScreen && result.verticalScrollPosition == 0 && this.currentQuery.toEnd == false) {
	            this.executeQueryAutoSaveStop("PrevPage", null, onlyFetch);
	          } else {
	            var oldIndex = this.records.indexOf(this.currentRecord);
	            var index;
	            if (result.linesOnScreen) {
	              index = result.verticalScrollPosition;
	            } else {
	              index = oldIndex;
	            }
	            var d = oldIndex - index;
	
	            if (d == 0) {
	              if (onlyFetch == false) this.local_recordPrevPage();
	              return;
	            }
	
	            if (result.linesOnScreen && d >= result.linesOnScreen) d = result.linesOnScreen - 1;
	
	            if (oldIndex - result.linesOnScreen * 2 - d <= 0) {
	              this.executeQueryAutoSaveStop("PrevPage", null, onlyFetch);
	            } else {
	              if (onlyFetch == false) this.local_recordPrevPage();
	            }
	          }
	        }
	      }
	      //}
	      //else
	      //{
	      //  if(this.currentQuery.direction == "First")
	      //    return;
	      //  if(onlyFetch==false)
	      //    this.local_recordPrevPage();
	
	      // }
	    }
	  }, {
	    key: 'recordRefresh',
	    value: function recordRefresh(groupAlias, moduleInstanceId) {
	      if (this.groupAlias == groupAlias && this.formDataSources.formModule.instanceUUId == moduleInstanceId) {
	        this.reSetCurrentQuery(this.currentQuery);
	        this.executeQueryAutoSaveStop();
	      }
	      //LogHelper.setUserOprLog("重新查询",this.formId,currentGroup.groupAlias);
	    }
	  }, {
	    key: 'recordFetchAll',
	    value: function recordFetchAll(groupAlias, moduleInstanceId) {
	      if (this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId) return;
	      if (!this.currentQuery) return;
	
	      this.currentQuery.needRefresh = true;
	      this.executeQueryAutoSaveStop("FetchAll");
	      //LogHelper.setUserOprLog("全部获取",this.formDataSources.formModule.formId,this.groupAlias);
	    }
	  }, {
	    key: 'recordFetchAllForCmd',
	    value: function recordFetchAllForCmd(tasks) {
	      if (!this.currentQuery) {
	        _CommandResolver2.default.resolve(tasks, this.formDataSources.formModule);
	        return;
	      }
	      this.currentQuery.needRefresh = true;
	
	      if (this.forLookup) {
	        this.doExecuteQuery("FetchAll", null, false, false, tasks);
	      } else {
	        var result = this.onRecordAutoSave(this.groupAlias);
	
	        if (!result.remoteFail) {
	          this.doExecuteQuery("FetchAll", null, false, false, tasks);
	        } else {
	          _CommandResolver2.default.resolve(tasks, this.formDataSources.formModule);
	        }
	      }
	    }
	  }, {
	    key: 'local_recordNextPage',
	    value: function local_recordNextPage() {
	      var parms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this.records || this.records.length == 0) {
	        this.setCurrentRecord(null, true, parms);
	        return;
	      }
	
	      var oldIndex = this.records.indexOf(this.currentRecord);
	
	      var index;
	      var result = {};
	      _UtilActions2.default.getGridInfos(this.groupAlias, result, this.formDataSources.formModule.instanceUUId);
	      if (result.linesOnScreen) {
	        index = result.verticalScrollPosition + Math.ceil(result.linesOnScreen);
	      } else {
	        index = oldIndex;
	      }
	      index = Math.min(index, this.records.length - 1);
	      this.setCurrentRecord(this.records[index]);
	    }
	  }, {
	    key: 'local_recordPrevPage',
	    value: function local_recordPrevPage() {
	      var parms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this.records || this.records.length == 0) {
	        this.setCurrentRecord(null, true, parms);
	        return;
	      }
	      var oldIndex = this.records.indexOf(this.currentRecord);
	      var index;
	      var result = {};
	
	      if (!this.currentRecord) {
	        index = 0;
	      } else {
	        _UtilActions2.default.getGridInfos(this.groupAlias, result, this.formDataSources.formModule.instanceUUId);
	        if (result.linesOnScreen) index = result.verticalScrollPosition;else index = oldIndex;
	
	        index -= result.linesOnScreen ? Math.ceil(result.linesOnScreen) : 10;
	      }
	
	      if (index < 0) index = 0;
	      this.setCurrentRecord(this.records[index]);
	    }
	  }, {
	    key: 'scrollEndNextPage',
	    value: function scrollEndNextPage() {
	      if (!this.currentQuery) {
	        alert("scrollEndNextPage but currentQuery is null");return;
	      }
	      if (this.currentQuery.toEnd == true) return;
	      this.executeQueryAutoSaveStop("NextPage", null, true);
	    }
	  }, {
	    key: 'rpc_dsExecuteQuery_result',
	    value: function rpc_dsExecuteQuery_result(arg, data) {
	      if (data.status != 0) {
	        _Warn2.default.show({ text: data.msg ? data.msg : data.message });
	        return;
	      }
	      var ac = data.result;
	      for (var kk = 0; kk < ac.length; kk++) {
	        var dsItem = ac[kk];
	        for (var key in dsItem) {
	          // for(let i in this.dataSetQueryTable.allQueryFields){
	          //   if((this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.dataSetQueryTable.allQueryFields[i].fieldAliasName == key)
	          //   ||StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName) == key){
	          //     dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[key];
	          //     delete dsItem[key];
	          //   }
	          // }
	          dsItem[this.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(key)] = dsItem[key];
	          delete dsItem[key];
	        }
	      }
	      if (this.currentQuery.direction == "Last") {
	        if (ac) {
	          ac = ac.reverse();
	        }
	      }
	      var type = arg.type;var onlyFetch = false;var tasks = null;
	      var record;
	      var mainAlias;var length;var i;var _recId;
	
	      if (type == "FetchAll") {
	        this.records = ac;
	        this.resetMapRecId();
	        this.currentQuery.toEnd = true;
	      } else {
	        if (this.currentQuery.needRefresh == true) {
	          this.records = ac;
	          this.resetMapRecId();
	          if (!ac || ac.length < this.dataPageSize) {
	            this.currentQuery.toEnd = true;
	          }
	        } else {
	          if (this.currentQuery.direction == "First") {
	            if (ac) {
	              /*mainAlias = this.groupAlias;
	              length = ac.length;
	              for (i=0; i<length; i++)
	              {
	                record = ac[i];
	                _recId = record[mainAlias+".recId"];
	                if(this.mapRecId.hasOwnProperty(_recId))
	                {
	                  this.replaceRecord(record);
	                }
	                else
	                {
	                  this.records.push(record);
	                }
	                this.mapRecId[_recId] = record;
	                this.recordsBak[_recId] = Object.assign({},record);
	              }*/
	              if (type == "NextPage") this.records.push.apply(this.records, ac);
	              //else
	              // alert("暂不支持该种查询");
	            }
	
	            if (!ac || ac.length < this.dataPageSize) {
	              this.currentQuery.toEnd = true;
	            }
	          } else if (this.currentQuery.direction == "Last") {
	            if (ac) {
	              mainAlias = this.groupAlias;
	              length = ac.length;
	              for (i = length - 1; i >= 0; i--) {
	                record = ac[i];
	                _recId = record[mainAlias + ".recId"];
	                if (this.mapRecId.hasOwnProperty(_recId)) {
	                  this.replaceRecord(record);
	                } else {
	                  this.records.unshift(record);
	                }
	                this.mapRecId[_recId] = record;
	                this.recordsBak[_recId] = Object.assign({}, record);
	              }
	            }
	
	            if (!ac || ac.length < this.dataPageSize) {
	              this.currentQuery.toEnd = true;
	            }
	          }
	        }
	      }
	      var hasSelectedRecords = false;
	
	      _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this, hasSelectedRecords);
	
	      if (!hasSelectedRecords) {
	        if (this.currentQuery.needRefresh == true) {
	          var _needFocus = false;
	          if (this.isGlobalForehandGroup()) _needFocus = true;
	
	          if (this.currentQuery.direction == "First") this.local_recordFirst(_needFocus);else this.local_recordLast(_needFocus);
	        } else {
	          if (onlyFetch == false) {
	            if (this.currentQuery.direction == "First") {
	              if (type == "First") {
	                this.local_recordFirst();
	              } else if (type == "Next") {
	                this.local_recordNext();
	              } else if (type == "NextPage") {
	                this.local_recordNextPage();
	              } else if (type == "Last" || type == "Prev" || type == "PrevPage") {
	                throw new Error("direction First not support type rpc Last/Prev/PrevPage");
	              }
	            } else {
	              if (type == "Last") {
	                this.local_recordLast();
	              } else if (type == "Prev") {
	                this.local_recordPrev();
	              } else if (type == "PrevPage") {
	                this.local_recordPrevPage();
	              } else if (type == "First" || type == "Next" || type == "NextPage") {
	                throw new Error("direction Last not support type rpc First/Next/NextPage");
	              }
	            }
	          } else {
	            if (type == "PrevPage") {
	              alert(type);
	            }
	          }
	        }
	      }
	
	      //alert("设置needRefresh");
	      if (this.currentQuery.needRefresh == true) this.currentQuery.needRefresh = false;
	      this.after_rpc_result_executeQuery(onlyFetch, tasks);
	    }
	  }, {
	    key: 'rpc_result_executeQuery',
	    value: function rpc_result_executeQuery(data, type, onlyFetch, tasks) {
	      this.aggreateTableFields = [];this.aggreateDimTableFiels = [];
	      var result = data.result;
	      var userInfos = window.parent.window.userInfos;
	      //万能视图
	      if (!userInfos) userInfos = { daoMaxListSize: 6000 };
	
	      if (result.recordCounts >= userInfos.daoMaxListSize) {
	        _Warn2.default.show({ text: "本次记录获取条数已达管理员设置的上限" + userInfos.daoMaxListSize + "条，请与管理员联系" });
	      }
	
	      if (result.maxCounts != -1) {
	        this.currentQuery.lastIndex = result.maxCounts;
	      }
	
	      //RecordsUtil.getOneLevelDatas(result,this.groupAlias);
	      this.formatFormDataSourceGroupResult(result);
	      var ac = result.dataResult;
	
	      //this.dataProvider = ac;
	      if (!this.currentQuery.hasOwnProperty("needRefresh")) throw new Error("miss @needRefresh");
	      this.updateQueryRemove();
	      var record;
	      var mainAlias;
	      var length;
	      var i;
	      var _recId;
	
	      if (this.currentQuery.direction == "Last") {
	        if (ac) {
	          ac = ac.reverse();
	        }
	      }
	
	      if (type == "FetchAll") {
	        this.records = ac;
	        this.resetMapRecId();
	        this.currentQuery.toEnd = true;
	      } else {
	        if (this.currentQuery.needRefresh == true) {
	          this.records = ac;
	          this.resetMapRecId();
	          if (!ac || ac.length < this.dataPageSize) {
	            this.currentQuery.toEnd = true;
	          }
	        } else {
	          if (this.currentQuery.direction == "First") {
	            if (ac) {
	              mainAlias = this.groupAlias;
	              length = ac.length;
	              for (i = 0; i < length; i++) {
	                record = ac[i];
	                _recId = record[mainAlias + ".recId"];
	                if (this.mapRecId.hasOwnProperty(_recId)) {
	                  this.replaceRecord(record);
	                } else {
	                  this.records.push(record);
	                }
	                this.mapRecId[_recId] = record;
	                this.recordsBak[_recId] = Object.assign({}, record);
	              }
	            }
	
	            if (!ac || ac.length < this.dataPageSize) {
	              this.currentQuery.toEnd = true;
	            }
	          } else if (this.currentQuery.direction == "Last") {
	            if (ac) {
	              mainAlias = this.groupAlias;
	              length = ac.length;
	              for (i = length - 1; i >= 0; i--) {
	                record = ac[i];
	                _recId = record[mainAlias + ".recId"];
	                if (this.mapRecId.hasOwnProperty(_recId)) {
	                  this.replaceRecord(record);
	                } else {
	                  this.records.unshift(record);
	                }
	                this.mapRecId[_recId] = record;
	                this.recordsBak[_recId] = Object.assign({}, record);
	              }
	            }
	
	            if (!ac || ac.length < this.dataPageSize) {
	              this.currentQuery.toEnd = true;
	            }
	          }
	        }
	      }
	      //let hasSelectedRecords = false;
	      /*if(tasks)
	      {
	        for(let i = 0;i<tasks.length;i++)
	        {
	          let _task = tasks[i];
	          if(_task.cmd == "selectRecords")
	          {
	            hasSelectedRecords = true;
	            break;
	          }
	        }
	      }*/
	
	      _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this, false);
	
	      if (this.currentQuery.needRefresh == true) {
	        var _needFocus = false;
	        if (this.isGlobalForehandGroup()) _needFocus = true;
	
	        if (this.currentQuery.direction == "First") this.local_recordFirst(_needFocus, { activeRecord: true });else this.local_recordLast(_needFocus, { activeRecord: true });
	      } else {
	        if (onlyFetch == false) {
	          if (this.currentQuery.direction == "First") {
	            if (type == "First") {
	              this.local_recordFirst(true, { activeRecord: true });
	            } else if (type == "Next") {
	              this.local_recordNext({ activeRecord: true });
	            } else if (type == "NextPage") {
	              this.local_recordNextPage({ activeRecord: true });
	            } else if (type == "Last" || type == "Prev" || type == "PrevPage") {
	              throw new Error("direction First not support type rpc Last/Prev/PrevPage");
	            } else {
	              this.local_recordFirst(true, { activeRecord: true });
	            }
	          } else {
	            if (type == "Last") {
	              this.local_recordLast(true, { activeRecord: true });
	            } else if (type == "Prev") {
	              this.local_recordPrev({ activeRecord: true });
	            } else if (type == "PrevPage") {
	              this.local_recordPrevPage({ activeRecord: true });
	            } else if (type == "First" || type == "Next" || type == "NextPage") {
	              throw new Error("direction Last not support type rpc First/Next/NextPage");
	            } else {
	              this.local_recordFirst(true, { activeRecord: true });
	            }
	          }
	        } else {
	          if (type == "PrevPage") {
	            alert(type);
	          }
	        }
	      }
	
	      //alert("设置needRefresh");
	      if (this.currentQuery.needRefresh == true) this.currentQuery.needRefresh = false;
	      this.after_rpc_result_executeQuery(onlyFetch, tasks, result);
	    }
	  }, {
	    key: 'after_rpc_result_executeQuery',
	    value: function after_rpc_result_executeQuery(onlyFetch, tasks, result) {
	      //升序向上 降序向下
	      // this.groupAlias this.currentQuery
	      //解析currentQuery数据结构 A字段要asc B字段要desc {A:asc,B:desc}
	      //通知到所有GongqiHeaderCell
	
	      var arg = {};
	      var itemArray = [];
	      //itemArray=
	      if (window.isDataSetView && !this.forLookup) {
	        for (var j = 0; j < this.dataSetQueryTable.queryOrderBy.length; j++) {
	          if (this.dataSetQueryTable.aliasName.indexOf("_") != -1) {
	            var key = this.dataSetQueryTable.aliasName.substring(this.dataSetQueryTable.aliasName.lastIndexOf("_") + 1).toLowerCase() + "." + this.dataSetQueryTable.queryOrderBy[j].fieldName.toLowerCase();
	            arg[key] = this.dataSetQueryTable.queryOrderBy[j].orderBy;
	          } else {
	            arg[this.dataSetQueryTable.aliasName.toLowerCase() + "." + this.dataSetQueryTable.queryOrderBy[j].fieldName.toLowerCase()] = this.dataSetQueryTable.queryOrderBy[j].orderBy;
	          }
	        }
	      } else {
	        _QueryUtil2.default.getAllOrderByItems(this.currentQuery.QueryTable, itemArray, false);
	        if (itemArray.length > 0) {
	          for (var i = 0; i < itemArray.length; i++) {
	            var item = itemArray[i];
	            if (item.hasOwnProperty('sorting')) {
	              var Field = (item.queryTableAlias + '.' + _GOTUtil2.default.getPropertyValue(item, 'Field')).toLowerCase();
	              var OrderBy = _GOTUtil2.default.getPropertyValue(item, 'OrderBy');
	              arg[Field] = OrderBy;
	            }
	          }
	          if (!arg[Field]) {
	            var Field = (itemArray[0].queryTableAlias + '.' + _GOTUtil2.default.getPropertyValue(itemArray[0], 'Field')).toLowerCase();
	            var OrderBy = _GOTUtil2.default.getPropertyValue(itemArray[0], 'OrderBy');
	            arg[Field] = OrderBy;
	          }
	        }
	      }
	      _QueryActions2.default.updateSortDirection(this.groupAlias, arg);
	      _UtilActions2.default.updateFetchAllIcon(this.groupAlias, this.currentQuery.toEnd, this.formDataSources.formModule.instanceUUId);
	      if (!tasks) tasks = [];
	      if (result && result.commandResult && result.commandResult.tasks) {
	        tasks = result.commandResult.tasks.concat(tasks);
	      }
	      if (tasks) {
	        var task = tasks.shift();
	        if (task) _CommandResolver2.default.doResolveTask(task, this.formDataSources.formModule, tasks);
	      }
	      // pivot 分析 获取数据集数据
	      if (this.records) {
	        window.parent.window.osDataSetViewRecords = this.records;
	      }
	
	      var strac = JSON.stringify(this.records);
	      var jsonac = JSON.parse(strac);
	      if (window.isDataSetView) {
	        for (var kk = 0; kk < jsonac.length; kk++) {
	          var dsItem = jsonac[kk];
	          for (var k in dsItem) {
	            for (var _i17 in this.dataSetQueryTable.allQueryFields) {
	              if (this.dataSetQueryTable.allQueryFields[_i17].fieldAliasName && this.groupAlias + "." + this.dataSetQueryTable.allQueryFields[_i17].fieldAliasName == k || this.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[_i17].fieldName) == k) {
	                dsItem[this.dataSetQueryTable.allQueryFields[_i17].dataSourceFliedName] = dsItem[k];
	                if (this.dataSetQueryTable.allQueryFields[_i17].dataSourceFliedName.indexOf(this.groupAlias) == -1) {
	                  delete dsItem[k];
	                }
	              }
	            }
	          }
	        }
	      }
	      if (window.parent.window.dataSetPreviewFordataset || window.parent.window.dataSet) {
	        if (window.parent.window.dataSetPreviewFordataset) {
	          window.parent.window.dataSetPreviewDataSet = _DataSetUtil2.default.strDataSet(window.parent.window.dataSetPreviewFordataset, jsonac);
	        }
	        if (window.parent.window.dataSet) {
	          window.parent.window.dataSetPreviewDataSet = _DataSetUtil2.default.strDataSet(window.parent.window.dataSet, jsonac);
	        }
	      }
	    }
	
	    //10000多条数据 多层转换成单层结构 耗时1.5秒 在现代浏览器中 +操作符最快
	
	  }, {
	    key: 'rpcExecuteQuery',
	    value: function rpcExecuteQuery(formDataSourceGroupResult) {
	
	      var finalDatas = _RecordsUtil2.default.getOneLevelDatas(formDataSourceGroupResult, this.groupAlias);
	      //alert("数据转换耗时"+(new Date().getTime()-now));
	      this.records = finalDatas;
	      _RecordsActions2.default.recordsCmp(finalDatas, this.groupAlias, this);
	      var initCurrentRecord = finalDatas.length > 0 ? finalDatas[0] : null;
	      this.setCurrentRecord(initCurrentRecord);
	    }
	  }, {
	    key: 'initCurrentQuery',
	    value: function initCurrentQuery() {
	      var formQueryCopy = JSON.parse(JSON.stringify(this.formQuery));
	      this.reSetCurrentQuery(formQueryCopy);
	    }
	  }, {
	    key: 'reSetCurrentQuery',
	    value: function reSetCurrentQuery() {
	      var xml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (window.isDataSetView && !this.forLookup) {
	        this.reSetDataSetExecuteQuery(xml, this.dataSetQueryTable);
	      }
	      if (xml != null) {
	        this.currentQuery = xml;
	      } else {
	        if (this.formQuery == null) this.formQuery = JSON.parse(JSON.stringify(this.baseQuery));
	
	        this.currentQuery = JSON.parse(JSON.stringify(this.formQuery));
	      }
	
	      this.currentQuery.direction = this.startPosition;
	      if (this.mainSource.isTempTable) this.currentQuery.toEnd = true;else this.currentQuery.toEnd = false;
	
	      this.currentQuery.needRefresh = true;
	
	      if (this.currentQuery.hasOwnProperty("lastIndex")) {
	        delete this.currentQuery.lastIndex;
	      }
	    }
	  }, {
	    key: 'reSetDataSetExecuteQuery',
	    value: function reSetDataSetExecuteQuery(xml, query) {
	      // if(!query)return;
	      // for(let i in query.queryWhere){
	      //   query.queryWhere.splice(0,query.queryWhere.length)
	      // }
	      // if(query.queryJoins.length>0){
	      //   for(let h in query.queryJoins){
	      //     this.reSetDataSetExecuteQuery(xml,query.queryJoins[h]);
	      //   }
	      // }
	      if (!query) return;
	      this.dataSetQueryTable = JSON.parse(this.initDataSetQueryTable);
	    }
	  }, {
	    key: 'reSetDataSetExecuteSort',
	    value: function reSetDataSetExecuteSort(xml, query) {
	      // if(!query)return;
	      // this.dataSetQueryTable = JSON.parse(this.initDataSetQueryTable);
	      if (!query) return;
	      for (var i in query.queryOrderBy) {
	        query.queryOrderBy.splice(0, query.queryOrderBy.length);
	      }
	      if (query.queryJoins.length > 0) {
	        for (var h in query.queryJoins) {
	          this.reSetDataSetExecuteSort(xml, query.queryJoins[h]);
	        }
	      }
	    }
	  }, {
	    key: 'reSetDataSetQuery',
	    value: function reSetDataSetQuery(xml, query) {
	      if (!query) return;
	      this.dataSetQueryTable = JSON.parse(this.initDataSetQueryTable);
	      // for(let i in query.queryWhere){
	      //   query.queryWhere.splice(0,query.queryWhere.length)
	      // }
	      // if(query.queryJoins.length>0){
	      //   for(let h in query.queryJoins){
	      //     this.reSetDataSetExecuteQuery(xml,query.queryJoins[h]);
	      //   }
	      // }
	      // for(let j in query.queryOrderBy){
	      //   query.queryOrderBy.splice(0,query.queryOrderBy.length)
	      // }
	    }
	  }, {
	    key: 'initFormQuery',
	    value: function initFormQuery() {
	      var key = this.formDataSources.formModule.props.formId + "_" + this.mainSource.id + "." + (this.forLookup ? "FormLookup" : window.menuItemId);
	      //alert(key + this.forLookup);
	      var obj = _QueryUtil2.default.getQueryList(key);
	      if (obj) {
	        this.formQuery = typeof obj == "string" ? JSON.parse(obj) : obj; //JSON.stringify(obj));
	        this.fromDefaultSavedQuery = true;
	      } else {
	        this.formQuery = JSON.parse(JSON.stringify(this.baseQuery));
	      }
	
	      var topQT = this.formQuery.QueryTable;
	      topQT.tempTable = this.mainSource.isTempTable;
	      var autoJoinParent = true;
	      if (!this.forLookup) {
	        if (this.linkGroup && window.argCaller) {
	          var autoJoinParentArg = window.argCaller.autoJoinParentArg;
	          if (autoJoinParentArg && this.linkGroup.groupAlias == autoJoinParentArg.autoJoinParentAlias) autoJoinParent = autoJoinParentArg.autoJoinParent;
	        }
	      }
	      if (this.linkGroup && autoJoinParent) {
	        var joinQueryTable = { name: "A_QueryTable", id: "1", Properties: { Table: { V: "" }, Alias: { V: "" }, UserUpdate: { V: true }, Output: { V: true }, Status: { V: "Open" } },
	          QueryRelation: { Properties: { Auto: { V: false }, JoinMode: { V: "None" }, Relation1N: { V: "ManyToOne" } }, Items: [] },
	          QueryFields: { Properties: { Auto: { V: true } }, Fields: [] }, QueryGroupBy: { name: "GroupBy" }, QueryOrderBy: { name: "OrderBy", Items: [] },
	          QueryWhere: { name: "Where", Items: [] }, QueryAggregations: { name: "Aggregations", Items: [] }, QueryJoins: { name: "Joins", Items: [] } };
	        topQT.QueryJoins.Items.push(joinQueryTable);
	        joinQueryTable.name = "Auto_JoinParent";
	        var nextInnerId = this.formQuery.nextInnerId;
	        joinQueryTable.id = nextInnerId;
	        joinQueryTable.tempTable = this.linkGroup.mainSource.isTempTable;
	        nextInnerId++;
	        this.formQuery.nextInnerId = nextInnerId;
	        var pTable = joinQueryTable.Properties.Table;
	        pTable.refentityid = this.linkGroup.mainSource.tableId;
	        pTable.V = this.linkGroup.mainSource.tableName;
	        joinQueryTable.Properties.Alias.V = "Auto_JoinParent";
	        joinQueryTable.Properties.Output.V = "false";
	        var parentWindow = window.parent.window;
	        if (parentWindow.serverDebug) joinQueryTable.Properties.Status.V = "Lock";else joinQueryTable.Properties.Status.V = "Hide";
	
	        var queryRelation = joinQueryTable.QueryRelation;
	        queryRelation.Properties.JoinMode.V = "ExistJoin";
	        queryRelation.Properties.Relation1N.V = "ManyToOne";
	
	        var relationItems = this.mainSource.xml.FormDataSourceRelation;
	        if (relationItems.length > 0) {
	          for (var i = 0; i < relationItems.length; i++) {
	            var relationItem = relationItems[i];
	
	            var rtemp = {
	              name: "A_QueryRelationItem", id: "2",
	              Properties: {
	                Field: { V: "" }, ParentField: { V: "" }, FieldValue: { V: "" }, RelatedValue: { V: "" }
	              }
	            };
	
	            rtemp.id = relationItem.id;
	            _QueryUtil2.default.setQueryRelationByFormRelation(rtemp, relationItem, this.mainSource.xml);
	            queryRelation.Items.push(rtemp);
	
	            if (rtemp.Properties.Field.V != "" && rtemp.Properties.ParentField.V != "") {
	              var rtemp2 = JSON.parse(JSON.stringify(rtemp));
	
	              var sDataField;
	              var pFieldForDataField = rtemp2.Properties.Field;
	              sDataField = pFieldForDataField.V;
	              sDataField = sDataField.substr(0, 1).toLowerCase() + sDataField.substring(1);
	              rtemp2.dataField = sDataField;
	
	              var pField = rtemp2.Properties.ParentField;
	              pField.V = "";
	              delete pField.refentityid;
	              delete pField.refinnerid;
	
	              queryRelation.Items.push(rtemp2);
	            }
	          }
	        } else //auto relation 
	          {
	            //by  current table   join table
	            //
	            // A Delayed join B A即this上的relationItems必定存在
	            this.formQuery = _QueryUtil2.default.consQueryByQuery(this.formQuery);
	            //throw new Error("FormDataSource无FormDataSourceRelationItem");
	          }
	
	        this.updateFormQueryByLinkGroup(this.linkGroup.currentRecord, this.linkGroup.mainSource.alias);
	      }
	    }
	  }, {
	    key: 'updateFormQueryByLinkGroup',
	    value: function updateFormQueryByLinkGroup(_linkRecord, _linkAlias) {
	
	      var joinQueryTable = _GOTUtil2.default.getQueryTableByName(this.formQuery, "Auto_JoinParent");
	      if (joinQueryTable != null) {
	
	        var list = _GOTUtil2.default.getQueryRelationItemByProperty(joinQueryTable.QueryRelation, "dataField");
	        for (var i = 0; i < list.length; i++) {
	          var item = list[i];
	          if (_linkRecord == null) {
	            item.Properties.FieldValue.V = "#null#";
	          } else {
	            var s = _linkRecord[_linkAlias + "." + item.dataField];
	            //TODO 如果是数字的 则认为肯定不是空
	            if (typeof s == "number" || s != "") item.Properties.FieldValue.V = s;else item.Properties.FieldValue.V = "#null#";
	          }
	        }
	      }
	    }
	    //如果传入record 如果是当前group 则以传入record为准 否则以指定的group为准
	
	  }, {
	    key: 'anyRecordValue',
	    value: function anyRecordValue(field) {
	      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var record = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var index = 0;
	      var group = this;
	      while (field.charAt(index) == ".") {
	        if (index == 0) {
	          index++;
	          continue;
	        }
	        group = group.linkGroup;
	        if (!group) return value;
	        record = group.currentRecord;
	        index++;
	      }
	      if (!record) record = group.currentRecord;
	      if (!record) return null;
	      field = field.substr(index);
	      if (field.indexOf(".") != -1) {
	        field = _StringUtil2.default.convertToEachFirstLowerCase(field.substr(index));
	        field = _StringUtil2.default.convertToFirstUpperCase(field);
	      } else {
	        field = group.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(field);
	      }
	
	      return record[field];
	    }
	  }, {
	    key: 'setAliasList',
	    value: function setAliasList(list, queryTable) {
	      if (_GOTUtil2.default.getPropertyValue(queryTable, "Output") == true) {
	        list.push(queryTable.name);
	        for (var i = 0; i < queryTable.QueryJoins.length; i++) {
	          var qt = queryTable.QueryJoins[i];
	          this.setAliasList(list, qt);
	        }
	      }
	    }
	  }, {
	    key: 'getEmptyValueByFieldType',
	    value: function getEmptyValueByFieldType(fieldType) {
	      if (fieldType == "String") {
	        return "";
	      } else if (fieldType == "Long") {
	        return 0;
	      } else if (fieldType == "Decimal") {
	        return 0.00;
	      } else if (fieldType == "Date" || fieldType == "DateTime") {
	        return "";
	      } else if (fieldType == "Time") {
	        return "00:00:00";
	      } else if (fieldType == "Boolean") {
	        return false;
	      } else if (fieldType == "Enum") {
	        return 0;
	      } else {
	        throw new Error("fieldType undefined");
	      }
	    }
	  }, {
	    key: 'initAliasList',
	    value: function initAliasList() {
	      this.aliasList = [];
	      this.setAliasList(this.aliasList, this.baseQuery.QueryTable);
	
	      this.aliasListEmptyObject = {};
	
	      for (var i = 0; i < this.aliasList.length; i++) {
	        var aliasName = this.aliasList[i];
	        for (var k = 0; k < this.sources.length; k++) {
	          var fds = this.sources[k];
	          if (fds.alias == aliasName) {
	            var obj = {};
	            this.aliasListEmptyObject[aliasName] = obj;
	            var fields = fds.xml.FormDataSourceFields;
	            var tmpComponentName;var tmpComponent;
	            for (var j = 0; j < fields.length; j++) {
	              var field = fields[j];
	              var fieldType = field.type;
	              var fieldName = _StringUtil2.default.convertToFirstLowerCase(field.name);
	              if (fieldName.indexOf(".") != -1) {
	                var _arr = fieldName.split(".");
	                var cName = _arr[0];
	                var fName = _StringUtil2.default.convertToFirstLowerCase(_arr[1]);
	                if (tmpComponentName != cName) {
	                  tmpComponentName = cName;
	                  tmpComponent = {};
	                  obj[tmpComponentName] = tmpComponent;
	                }
	
	                tmpComponent[fName] = this.getEmptyValueByFieldType(fieldType);
	              } else {
	                if (fieldType == "Component") {
	                  //什么都不做
	                } else {
	                  obj[fieldName] = this.getEmptyValueByFieldType(fieldType);
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'isCurrentRecordLocked',
	    value: function isCurrentRecordLocked() {
	      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return false;
	      this.lockedRecNew = false;
	      if (this.lockedFieldFalsed) return false;
	
	      if (record == null) record = this.currentRecord;
	
	      var lockFieldValue = this.mainSource.xml.Properties.LockField ? this.mainSource.xml.Properties.LockField.Value : "";
	      if (lockFieldValue == "") return false;
	      var lockField = _StringUtil2.default.trimThrough(lockFieldValue);
	      var conA;var field;var value;var recordValue;var lockNew = false;var result = false;
	
	      try {
	        if (lockField.charAt(0) == "(") {
	          var num = lockField.charAt(1);
	          if (num == "2") {
	            lockNew = true;
	          }
	
	          lockField = lockField.substr(3);
	        }
	
	        var _arr = lockField.split("|");
	        for (var i = 0; i < _arr.length; i++) {
	          var con = _arr[i];
	          if (con.indexOf("&gt;=") != -1) {
	            conA = con.split("&gt;=");
	            field = conA[0];
	            if (field.charAt(0) != "." && record == null) continue;
	            var isParent = field.charAt(0) == ".";
	            value = conA[1];
	            recordValue = this.anyRecordValue(field, value, record);
	            if (recordValue != undefined && recordValue != null && recordValue >= value) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            } else if ((recordValue == undefined || recordValue == null) && isParent) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            }
	          } else if (con.indexOf("&lt;=") != -1) {
	            conA = con.split("&lt;=");
	            field = conA[0];
	            if (field.charAt(0) != "." && !record) continue;
	            isParent = field.charAt(0) == ".";
	            value = conA[1];
	            recordValue = this.anyRecordValue(field, value, record);
	            if (recordValue != null && recordValue != undefined && recordValue <= value) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            } else if ((recordValue == undefined || recordValue == null) && isParent) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            }
	          } else if (con.indexOf("=") != -1) {
	            conA = con.split("=");
	            field = conA[0];
	            if (field.charAt(0) != "." && !record) continue;
	            isParent = field.charAt(0) == ".";
	            value = conA[1];
	            recordValue = this.anyRecordValue(field, value, record);
	            if (recordValue != undefined && record != null && (recordValue == value || (recordValue == true || recordValue == "1") && (value == "true" || value == "1") || (recordValue == false || recordValue == "0") && (value == "false" || value == "0"))) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            } else if ((recordValue == null || recordValue == undefined) && isParent) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            }
	          } else if (con.indexOf("&lt;&gt;") != -1) {
	            conA = con.split("&lt;&gt;");
	            field = conA[0];
	            if (field.charAt(0) != "." && record == null) continue;
	            isParent = field.charAt(0) == ".";
	            value = conA[1];
	            recordValue = this.anyRecordValue(field, value, record);
	            if (recordValue != null && recordValue != undefined && recordValue != value) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            } else if ((recordValue == null || recordValue == undefined) && isParent) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            }
	          } else if (con.indexOf("&gt;") != -1) {
	            conA = con.split("&gt;");
	            field = conA[0];
	            if (field.charAt(0) != "." && record == null) continue;
	            isParent = field.charAt(0) == ".";
	            value = conA[1];
	            recordValue = this.anyRecordValue(field, value, record);
	            if (recordValue != undefined && recordValue != null && recordValue > value) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            } else if (recordValue == undefined && recordValue == null && isParent) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            }
	          } else if (con.indexOf("&lt;") != -1) {
	            conA = con.split("&lt;");
	            field = conA[0];
	            if (field.charAt(0) != "." && record == null) continue;
	            isParent = field.charAt(0) == ".";
	            value = conA[1];
	            recordValue = this.anyRecordValue(field, value, record);
	            if (recordValue != undefined && recordValue != null && recordValue < value) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            } else if (recordValue != undefined && recordValue != null && isParent) {
	              result = true;
	              if (lockNew) this.lockedRecNew = true;
	              break;
	            }
	          }
	        }
	      } catch (e) {
	        _Warn2.default.show({ text: this.mainSource.alias + ":填写正确的LockedField" });
	        lockedFieldFalsed = true;
	      }
	
	      return result;
	    }
	  }, {
	    key: 'formatFormDataSourceGroupResult',
	    value: function formatFormDataSourceGroupResult(result, from) {
	      //行列转置 - 此处判断有无动态列 有动态列则通知DataGrid 并把参数传过去 更改column 
	      var dynamicColumnFieldName = void 0;
	      if (from == "save" || from == "modified" || from == "refresh") {
	        if (this.dynamicColumnsPre) {
	          result.dynamicColumns = this.dynamicColumnsPre;
	          if ((from == "modified" || from == "refresh") && result.dataResult && this.currentRecord) {
	            for (var dynamicSource in result.dynamicColumns) {
	              var dynamicSourceObj = result.dynamicColumns[dynamicSource];
	              for (var i = 0; i < result.dataResult.length; i++) {
	                var record = result.dataResult[i];
	                var record2 = record[dynamicSource];
	                if (typeof record2 == "undefined" || record2 == undefined) {
	                  record2 = record;
	                }
	                if (record2) {
	                  //let dynamicArr = dynamicSourceObj["Sources"];
	                  for (var secondKey in dynamicSourceObj) {
	                    var dynamicArr = dynamicSourceObj[secondKey];
	                    for (var k = 0; k < dynamicArr.length; k++) {
	                      var dynamicObj = dynamicArr[k];
	                      var recordKey = dynamicSource + "." + dynamicObj.dataKey;
	                      if (this.currentRecord[this.groupAlias + ".recId"] == record2["recId"]) {
	                        record2[dynamicObj.dataKey] = this.currentRecord[recordKey];
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	      if (result.dynamicColumns) {
	        var isEmpty = true;
	        for (var key in result.dynamicColumns) {
	          isEmpty = false;
	          var singleColumn = result.dynamicColumns[key];
	          for (var key2 in singleColumn) {
	            dynamicColumnFieldName = key2;
	            _UtilActions2.default.dynamicColumns({ key: key, origColumn: key2, dynamicColumns: singleColumn[key2] });
	          }
	        }
	        if (isEmpty == false) this.dynamicColumnsPre = result.dynamicColumns;
	      }
	      //标准格式 result.result -->ArrayCollection [index][aliasName.fieldName]
	
	      //flag_validateFieldNameFirstChar = false;
	
	      if (!result || !result.dataResult || Array.isArray(result.dataResult) && result.dataResult.length == 0) return;
	
	      if (result.dataResult && Array.isArray(result.dataResult)) {
	        if (!result.groupAlias) {
	          var _tmp = result.dataResult;
	          if (_tmp.length != 0) {
	            result.groupAlias = this.groupAlias;
	            result.aliasList = [];
	            result.aliasList.push(this.mainSource.alias);
	          } else {
	            return;
	          }
	        }
	      }
	
	      if (!result.aliasList) {
	        result.dataResult = null;
	        return;
	      }
	
	      var aliasListLength = result.aliasList.length;
	      if (result.recordCounts <= 0 || aliasListLength <= 0) {
	        result.dataResult = null;
	        return;
	      }
	
	      var type; //0 Array   1 Object      
	      if (Array.isArray(result.dataResult)) {
	        type = 0;
	        var resultAC = result.dataResult;
	      } else {
	        type = 1;
	        var resultObject = result.dataResult;
	      }
	
	      var ac;var fieldName;var groupObject;var aliasObject;var index;var strAlias;
	
	      //if(aliasListLength==0 && result.recordCounts>0) //这种是新增的，对应于后台不指定groupAlias，直接传List<Map<String,Object>>的情况。 事实上只用于lookup_方法的返回，以后要考虑是否从FormDataSourceGroup中拆出来
	      //{
	      //  
	      //}
	      //上面这种为新增的
	      //由于至少存在RecId RecVersion，所以不可能只有(一条记录、一个alias、一个字段)，所以只要下面三种情况即可
	      //else
	      if (aliasListLength == 1 && result.recordCounts == 1) {
	        //[fieldName]
	        //[0][fieldName]
	        ac = [];
	
	        if (type == 0) {
	          groupObject = this.formatSingleRecord(result.groupAlias, resultAC[0], dynamicColumnFieldName);
	        } else {
	          if (!resultObject.hasOwnProperty("recId")) resultObject = resultObject[this.groupAlias];
	
	          groupObject = this.formatSingleRecord(result.groupAlias, resultObject, dynamicColumnFieldName);
	        }
	
	        this.fillEmptyObject(groupObject);
	
	        ac.push(groupObject);
	        result.dataResult = ac;
	      } else if (aliasListLength == 1 && result.recordCounts > 1) {
	        //[index][fieldName]
	        ac = [];
	
	        for (index = 0; index < result.recordCounts; index++) {
	          groupObject = {};
	          if (type == 0) {
	            groupObject = this.formatSingleRecord(result.groupAlias, resultAC[index], dynamicColumnFieldName);
	          } else {
	            groupObject = this.formatSingleRecord(result.groupAlias, resultObject[index], dynamicColumnFieldName);
	          }
	
	          this.fillEmptyObject(groupObject);
	
	          ac.push(groupObject);
	        }
	        result.dataResult = ac;
	      } else if (aliasListLength > 1 && result.recordCounts == 1) {
	        ac = [];
	        groupObject = {};
	        if (type == 0) {
	          for (index = 0; index < aliasListLength; index++) {
	            strAlias = result.aliasList[index];
	
	            var tmp = resultAC[0][index];
	            if (!tmp) tmp = resultAC[0][strAlias];
	
	            var _newRecord = this.formatSingleRecord(strAlias, tmp, dynamicColumnFieldName);
	            this.copyRecord(_newRecord, groupObject);
	          }
	        } else {
	          for (index = 0; index < aliasListLength; index++) {
	            strAlias = result.aliasList[index];
	            if (resultObject.hasOwnProperty(0)) {
	              tmp = resultObject[0][index];
	              if (tmp == null) tmp = resultObject[0][strAlias];
	            } else {
	              tmp = resultObject[index];
	              if (tmp == null) tmp = resultObject[strAlias];
	            }
	
	            var _newRecord2 = this.formatSingleRecord(strAlias, tmp, dynamicColumnFieldName);
	            this.copyRecord(_newRecord2, groupObject);
	          }
	        }
	
	        this.fillEmptyObject(groupObject);
	
	        ac.push(groupObject);
	
	        result.dataResult = ac;
	      } else if (aliasListLength > 1 && result.recordCounts > 1) {
	        ac = [];
	
	        for (var indexOut = 0; indexOut < result.recordCounts; indexOut++) {
	          groupObject = {};
	          if (type == 0) {
	            for (index = 0; index < aliasListLength; index++) {
	              strAlias = result.aliasList[index];
	
	              tmp = resultAC[indexOut][index];
	              if (tmp == null) tmp = resultAC[indexOut][strAlias];
	              var _newRecord3 = this.formatSingleRecord(strAlias, tmp, dynamicColumnFieldName);
	              this.copyRecord(_newRecord3, groupObject);
	            }
	          } else {
	            for (index = 0; index < aliasListLength; index++) {
	              strAlias = result.aliasList[index];
	
	              tmp = resultObject[indexOut][index];
	              if (tmp == null) tmp = resultObject[indexOut][strAlias];
	              var _newRecord4 = this.formatSingleRecord(strAlias, tmp, dynamicColumnFieldName);
	              this.copyRecord(_newRecord4, groupObject);
	            }
	          }
	
	          this.fillEmptyObject(groupObject);
	          ac.push(groupObject);
	        }
	        result.dataResult = ac;
	      }
	    }
	  }, {
	    key: 'getFieldNameNew',
	    value: function getFieldNameNew(fieldName) {
	      var _fieldNameNew;
	      var firstChar = fieldName.charCodeAt(0);
	      if (firstChar >= 65 && firstChar <= 90) // A..Z
	        {
	          _fieldNameNew = String.fromCharCode(firstChar + 32) + fieldName.substring(1);
	        } else {
	        _fieldNameNew = fieldName;
	      }
	      return _fieldNameNew;
	    }
	  }, {
	    key: 'fixFieldNameFirstChar',
	    value: function fixFieldNameFirstChar(record) {
	      for (var key in record) {
	        var firstChar = key.charCodeAt(0);
	        if (firstChar >= 65 && firstChar <= 90) // A..Z
	          {
	            record[this.getFieldNameNew(key)] = record[key];
	            delete record[key];
	          }
	      }
	    }
	  }, {
	    key: 'addRecordTempDataMethodField',
	    value: function addRecordTempDataMethodField(record, alias) {
	      var tempDataMethodField = this.getTempDataMethodField();
	      var value = "";
	      var _recId = record["recId"];
	      for (var key in this.tempDataMethodField) {
	        var _field = tempDataMethodField[key];
	        var index = _field.indexOf(".");
	        var datasource = _field.substring(0, index);
	        if (datasource == alias) {
	          var subfield = _field.substr(index + 1);
	          if (record.hasOwnProperty(subfield) && record[subfield] != null) continue;
	          if (this.mapRecId.hasOwnProperty(_recId)) {
	            var orgObj = this.mapRecId[_recId];
	            value = orgObj[datasource + "." + subfield];
	          } else {
	            var type = this.tempDataMethodFieldType[key];
	            if (type == "LongEditor") value = 0;else if (type == "DecimalEditor") {
	              var controlKey = "ctrl_" + _StringUtil2.default.convertToFirstUpperCase(subfield);
	              var controls = _FormItemUtil2.default.formItemControls;
	              var control = controls[controlKey];
	              var numDecimals = control.getProperty_NumOfDecimals();
	              value = numDecimals > 0 ? "0." : "0";
	              for (var i = 0; i < numDecimals; i++) {
	                value += "0";
	              }
	
	              //value =  "0.00";
	            } else if (type == "TimeEditor") value = "00:00:00";else if (type == "BooleanEditor") value = false;else if (type == "EnumEditor") value = 0;else value = "";
	          }
	
	          record[subfield] = value;
	        }
	      }
	    }
	  }, {
	    key: 'formatSingleRecord',
	    value: function formatSingleRecord(_alias, record, dynamicColumnFieldName) {
	      if (!record) return null;
	
	      if (!record.hasOwnProperty("recId") || !record.hasOwnProperty("recVersion")) {
	        if (record.hasOwnProperty(this.groupAlias)) {
	          record = record[this.groupAlias];
	        } else {
	          //非标准格式的record，按原样返回 ， TODO 什么时候发生？
	          //alert("存在非标准格式的记录:" + record.toString());
	          return record;
	        }
	      }
	
	      this.fixFieldNameFirstChar(record);
	
	      this.addRecordTempDataMethodField(record, _alias);
	
	      var fieldName;var fieldValue;var fieldType;var _recordNew = {};var _fieldNameNew;
	
	      var _fds;
	      for (var i in this.sources) {
	        var tf = this.sources[i];
	        if (tf.alias == _alias) {
	          _fds = tf;
	          break;
	        }
	      }
	      if (_fds == null) {
	        throw new Error("没有找到对应的FormDataSource");
	      }
	      if (dynamicColumnFieldName && _fds.xml.Properties.PivotSource) {
	        var pivotSourceEntityid = _fds.xml.Properties.PivotAggregateColumn.refentityid;
	        var pivotSourceName = _fds.xml.Properties.PivotSource.Value;
	        for (var _i18 in this.sources) {
	          var tf = this.sources[_i18];
	          if (tf.alias == pivotSourceName || tf.tableId == pivotSourceEntityid) {
	            _fds = tf;
	            break;
	          }
	        }
	      }
	
	      if (_fds.isTempTable == true) {
	        //new
	        if (record["recId"] == -1) {
	          record["recId"] = tmpRecId++;
	          record["recVersion"] = 0;
	        }
	      }
	
	      for (fieldName in record) {
	        _fieldNameNew = this.getFieldNameNew(fieldName);
	
	        fieldType = _fds.fieldType[_fieldNameNew];
	        if (!fieldType) {
	          if (dynamicColumnFieldName && _fieldNameNew.indexOf('alias_') != -1) {
	            fieldType = _fds.fieldType[_StringUtil2.default.convertToFirstLowerCase(dynamicColumnFieldName)];
	          }
	          if (!fieldType) //插件内部节点带点 
	            {
	              fieldType = _fds.fieldType[_StringUtil2.default.convertToEachFirstLowerCase(_fieldNameNew)];
	            }
	        }
	        if (dynamicColumnFieldName && !fieldType) {
	          for (var _i19 in this.sources) {
	            var tf = this.sources[_i19];
	            if (tf.alias == _alias) {
	              _fds = tf;
	              break;
	            }
	          }
	          fieldType = _fds.fieldType[_fieldNameNew];
	          if (!fieldType) {
	            if (_fieldNameNew) {
	              fieldType = _fds.fieldType[_StringUtil2.default.convertToFirstLowerCase(_fieldNameNew)];
	            }
	            if (!fieldType) //插件内部节点带点 
	              {
	                fieldType = _fds.fieldType[_StringUtil2.default.convertToEachFirstLowerCase(_fieldNameNew)];
	              }
	          }
	        }
	
	        if (!fieldType) continue;
	
	        fieldValue = record[fieldName];
	
	        if (fieldType == "Long" || fieldType == "Decimal") {
	          if (dynamicColumnFieldName && (fieldValue == null || fieldValue == "")) fieldValue = "";
	          //TODO处理数字长度
	          if (fieldType == "Decimal") {
	            var _decimalValue = fieldValue + "";
	            if (!_decimalValue) _decimalValue = "0";
	            var numDecimals = _fds.fieldNumOfDecimals[_fieldNameNew];
	            if (!numDecimals) numDecimals = 2;
	            var indexdot = _decimalValue.indexOf(".");
	            if (indexdot == -1) {
	              _decimalValue += ".";
	              for (var _i20 = 0; _i20 < numDecimals; _i20++) {
	                _decimalValue += "0";
	              }
	            } else {
	              var nowDecimalNum = _decimalValue.length - (indexdot + 1);
	              if (nowDecimalNum < numDecimals) {
	                for (var _i21 = 0; _i21 < numDecimals - nowDecimalNum; _i21++) {
	                  _decimalValue += "0";
	                }
	              }
	            }
	
	            if (numDecimals == "0") _decimalValue = _decimalValue.substr(0, _decimalValue.length - 1);
	
	            _recordNew[_alias + "." + _fieldNameNew] = _decimalValue;
	          } else {
	            _recordNew[_alias + "." + _fieldNameNew] = fieldValue;
	          }
	        } else if (fieldType == "Component") {
	          var _oNameNew;var fieldValueNew = {};
	          for (var oName in fieldValue) {
	            if (oName == "class") continue;
	            _oNameNew = this.getFieldNameNew(oName);
	
	            var oValue = fieldValue[oName];
	
	            if (!oValue) {
	              oValue = "";
	            }
	
	            _recordNew[_alias + "." + _fieldNameNew + "." + _oNameNew] = oValue;
	          }
	        }
	        /*else if(fieldType=='Date'&&fieldValue=='1970-01-01'){
	          fieldValue='';
	          _recordNew[_alias+"."+_fieldNameNew] = fieldValue;
	        }*/
	
	        else {
	            _recordNew[_alias + "." + _fieldNameNew] = fieldValue;
	          }
	      }
	
	      if (this.mainSource.isAggreateTable == true) {
	        if (this.aggreateTableFields.length == 0) {
	          for (var key in _recordNew) {
	            if (key.indexOf(".") == -1) {
	              this.aggreateTableFields.push(key);
	            } else {
	              var tfarray = key.split(".");
	              this.aggreateTableFields.push(tfarray[1]);
	              if (tfarray.length == 3) {
	                this.aggreateDimTableFiels.push(tfarray[2]);
	              }
	            }
	          }
	        }
	        this.completeRecordField(_recordNew, _fds, _alias);
	      }
	
	      return _recordNew;
	    }
	  }, {
	    key: 'completeRecordField',
	    value: function completeRecordField(record, source, _alias) {
	      var sourcexml = source.xml;
	      var formdatasourcefields = sourcexml.FormDataSourceFields;
	
	      for (var i in formdatasourcefields) {
	        var sourcefield = formdatasourcefields[i];
	        var key2 = _StringUtil2.default.convertToEachFirstLowerCase(sourcefield.name);
	        var type = sourcefield.type;
	        key2 = _alias + "." + key2;
	        if (!record.hasOwnProperty(key2)) {
	          if (type == _GongqiDataType2.default.TypeComponentLabel) {
	            record[key2] = {};
	          } else {
	            var finalvalue = null;
	            if (type == _GongqiDataType2.default.TypeStringLabel) {
	              finalvalue = "";
	            } else if (type == _GongqiDataType2.default.TypeEnumLabel) {
	              finalvalue = 0;
	            } else if (type == _GongqiDataType2.default.TypeBooleanLabel) {
	              finalvalue = false;
	            } else if (type == _GongqiDataType2.default.TypeLongLabel || type == _GongqiDataType2.default.TypeDecimalLabel) {
	              finalvalue = 0;
	            } else if (type == _GongqiDataType2.default.TypeDateLabel) {
	              finalvalue = "";
	            } else if (type == _GongqiDataType2.default.TypeTimeLabel) {
	              finalvalue = "";
	            }
	            record[key2] = finalvalue;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'fillEmptyObject',
	    value: function fillEmptyObject(groupObject) {
	      var length = this.aliasList.length;
	      if (length <= 1) return;
	
	      for (var i = 0; i < length; i++) {
	        var alias = this.aliasList[i];
	
	        var has = false;
	        for (var key in groupObject) {
	          if (key.indexOf(alias) > -1) {
	            has = true;
	            break;
	          }
	        }
	
	        if (!has) {
	          this.copyRecord(this.aliasListEmptyObject[alias], groupObject);
	        }
	      }
	    }
	  }, {
	    key: 'copyRecord',
	    value: function copyRecord(baseRecord, toRecord) {
	      if (toRecord == null) return null;
	      for (var key in baseRecord) {
	        if (!toRecord.hasOwnProperty(key)) toRecord[key] = baseRecord[key];
	      }
	    }
	  }, {
	    key: 'getExportSettingTitle',
	    value: function getExportSettingTitle(settingdoc, _key) {
	      var settingNode0 = settingdoc.childNodes[0];
	      var _fileName = settingNode0.attributes.fileName.nodeValue;
	      var _title = "导出预览 来自设置" + _fileName;
	      var defaultSetting = _FormDataSources2.default.getUserDefaultExportList(_key);
	      if (defaultSetting) {
	        var defaultSettingDoc = new DOMParser().parseFromString(defaultSetting, "application/xml");
	        var defaultSettingNode0 = defaultSettingDoc.childNodes[0];
	        var defaultFileName = defaultSettingNode0.attributes.fileName.nodeValue;
	        if (defaultFileName == _fileName) {
	          _title += "(默认)";
	        }
	      }
	      return _title;
	    }
	  }, {
	    key: 'doExport',
	    value: function doExport(filter) {
	      var isPivot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Export, this.currentRecord)) return;
	      /*if(!this.getAuthorityByXML(FormDataSourceAuthorityType.exportStr))
	        return;*/
	      var _showTableName = true;
	      var columns = null;
	      var key;
	      if (window.formId.indexOf(".") == -1 && window.menuItemId.indexOf(".") == -1) {
	        key = window.formId + "_" + this.mainSource.xml.id + (window.menuItemId ? "." + window.menuItemId : "");
	      } else {
	        key = window.formId + "_" + this.mainSource.xml.id + (window.menuItemId ? "&" + window.menuItemId : "");
	      }
	      if (flag == 'drop') {
	        window.parent.window.toolbarExportDrop(key);
	        return;
	      }
	
	      var _title = null;
	      if (!isPivot) {
	        //var setting = FormDataSources.userExportList;//((window.parent && window.parent.window)?window.parent.window.userExportList:{});
	
	        var settingXML = _FormDataSources2.default.getUserDefaultExportList(key);
	        if (settingXML) {
	          var settingdoc = new DOMParser().parseFromString(settingXML, "application/xml");
	          var settingdocNode0 = settingdoc.childNodes[0];
	          _showTableName = settingdocNode0.attributes.showTableName.nodeValue == "true" ? true : false;
	          _title = this.getExportSettingTitle(settingdoc, key);
	          //columns = this.consOnedimensionalGridColBySetting(FormDataSources.userExportList[key]);
	          columns = this.consOnedimensionalGridColBySetting(settingdocNode0);
	        } else {
	          columns = this.consOnedimensionalGridColByView(null, filter, isPivot);
	        }
	      } else {
	        columns = this.consOnedimensionalGridColByView(null, filter, isPivot);
	        _title = "数据分析设置";
	      }
	
	      var _records = this.records;
	      if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	        _records = this.tempRecordsFilter;
	      }
	
	      var ac = this.convertToOnedimensional(_records, filter);
	
	      var extrals = this.getExtralExportFields(columns, filter);
	
	      var strac = JSON.stringify(ac);
	      var jsonac = JSON.parse(strac);
	      if (window.isDataSetView) {
	        for (var kk = 0; kk < jsonac.length; kk++) {
	          var dsItem = jsonac[kk];
	          for (var k in dsItem) {
	            //导出时 如果是Enum 类型 取值存在 问题  如果是Date 日期类型 先转为String
	            for (var j in columns) {
	              var sht = k.substring(k.lastIndexOf(".") + 1, k.length);
	              var shtc = columns[j].dataField.substring(columns[j].dataField.lastIndexOf(".") + 1, columns[j].dataField.length);
	              if (columns[j].fieldType == "Enum" && sht == shtc) {
	                for (var ii in this.dataSetQueryTable.allQueryFields) {
	                  if (this.dataSetQueryTable.allQueryFields[ii].fieldAliasName && this.groupAlias + "." + this.dataSetQueryTable.allQueryFields[ii].fieldAliasName == k || this.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[ii].fieldName) == k) {
	                    var newFieldValue = "";
	                    var table = _GOT2.default.getTable(this.dataSetQueryTable.allQueryFields[ii].refEntityId);
	                    if (table) {
	                      var tableField = _GOT2.default.getTableField(table, this.dataSetQueryTable.allQueryFields[ii].refInnerId);
	                      if (tableField) {
	                        var enumId = tableField.Properties.Extends.refentityid;
	                        var enumItem = _GOT2.default.getEnum(enumId);
	                        if (enumItem) {
	                          for (var ein in enumItem.EnumItems) {
	                            var its = enumItem.EnumItems[ein];
	                            if (dsItem[k] == its.Properties.Value.V || dsItem[k] == its.Properties.Value.V + "") {
	                              newFieldValue = its.Properties.Label.V ? its.Properties.Label.V : its.Properties.Label.Value;
	                              break;
	                            }
	                          }
	                        }
	                      }
	                    }
	                    dsItem[k] = newFieldValue;
	                  }
	                }
	              }
	              if (columns[j].fieldType == "Decimal" && dsItem[k] != null && dsItem[k] != 'null') {
	                if (this.groupAlias + "." + columns[j].normalHeaderText == k) {
	                  dsItem[k] = _FormItemDecimalDisplay2.default.getDisplayText(dsItem[k], columns[j].showZero, columns[j].numOfDecimals ? columns[j].numOfDecimals : 2, columns[j].thousandSeperator, {});
	                }
	              }
	              if (columns[j].fieldType == "Decimal" && dsItem[k] != null && dsItem[k] != 'null') {
	                if (dsItem[k].indexOf(',') != -1) {
	                  dsItem[k] = dsItem[k].replace(/,/g, "");
	                }
	              }
	            }
	            for (var i in this.dataSetQueryTable.allQueryFields) {
	              if (this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.groupAlias + "." + this.dataSetQueryTable.allQueryFields[i].fieldAliasName == k || this.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName) == k) {
	                if (dsItem[k] == null || dsItem[k] == 'null') {
	                  dsItem[k] = '';
	                }
	                if (window.parent.window.dataSet) {
	                  var dcolumns = window.parent.window.dataSet.dataColumn.columns;
	                  for (var col in dcolumns) {
	                    if (col == this.dataSetQueryTable.allQueryFields[i].fieldAliasName || col == this.dataSetQueryTable.allQueryFields[i].fieldName) {
	                      if (dcolumns[col].dataType == "Date" && dcolumns[col].displayFormat) {
	                        dsItem[k] = _FormItemDateDisplay2.default.getDisplayText2(dsItem[k], dcolumns[col].displayFormat.toUpperCase());
	                      }
	                      if (dcolumns[col].dataType == "Time" && dcolumns[col].displayFormat) {
	                        dsItem[k] = _FormItemTimeDisplay2.default.getDisplayText2(dsItem[k], dcolumns[col].displayFormat.toUpperCase());
	                      }
	                      if (dcolumns[col].dataType == "Decimal" && dcolumns[col].displayFormat) {
	                        dsItem[k] = _FormItemDecimalDisplay2.default.getDisplayText2(dsItem[k], dcolumns[col].displayFormat.toUpperCase());
	                      }
	                    }
	                  }
	                }
	                dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[k];
	                var dataSource = this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.substring(0, this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf("."));
	                dsItem[dataSource + "." + this.dataSetQueryTable.allQueryFields[i].fieldAliasName] = dsItem[k];
	                if (this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf(this.groupAlias) == -1) {
	                  // delete dsItem[k];
	                }
	              }
	            }
	          }
	        }
	        ac = jsonac;
	        extrals = [];
	      }
	      if (window.isDataSetView) {
	        for (var _j in columns) {
	          var _col = columns[_j];
	          _col.dataField = this.mainSource.alias + '.' + _col.dataField.substring(_col.dataField.lastIndexOf('.') + 1);
	        }
	      }
	
	      /*if(this.linkGroup && this.linkGroup.currentRecord)
	      {
	        var headerColumns = this.linkGroup.consOnedimensionalGridColByView();
	        var headerAc = this.linkGroup.convertToOnedimensional([this.linkGroup.currentRecord],filter);
	      }*/
	
	      //TODO 打开export//columns extrals ac key this _showTableName isPivot
	
	      // ReactDOM.render(<ExportTable columns={columns} extrals={extrals} ac={ac} key={key} showTableName={_showTableName} isPivot={isPivot} group={this}/>,
	      //     window.parent.window.document.getElementById('exportModal'));
	
	      var htmlarg = { columns: columns, extrals: extrals, ac: ac, key: key, showTableName: _showTableName, isPivot: isPivot, group: this };
	      _reactDom2.default.render(_react2.default.createElement(_ExportTable2.default, { htmlarg: htmlarg, initExport: flag }), document.getElementById('exportModal'));
	      // window.parent.window.htmlarg = {columns:columns,extrals:extrals,ac:ac,key:key,showTableName:_showTableName,isPivot:isPivot,group:this};
	      // window.parent.$("#exportModal").load("export/export.html");
	    }
	  }, {
	    key: 'convertValue',
	    value: function convertValue(value, key) {
	      var cacheValue = this.fieldCache[key];
	      if (cacheValue == null) {
	        cacheValue = this.fieldCache[key.replace(".", "-")];
	      }
	      if (!cacheValue) return null;
	      if (typeof cacheValue === "string") {
	        return new String(value).replace(/[\n\r]+/g, " ");
	      } else if (Array.isArray(cacheValue)) {
	        for (var i = 0; i < cacheValue.length; i++) {
	          var obj = cacheValue[i];
	          if (obj.value == value) return obj.label;
	        }
	      } else {
	        return cacheValue[value];
	      }
	
	      return null;
	    }
	
	    //传入到后台导出的数据均为字符串 后台导出EXCEL时根据数据类型做强制转换
	
	  }, {
	    key: 'convertToOnedimensional1',
	    value: function convertToOnedimensional1(ac) {
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var newAc = [];
	      var tempObj = {};
	      for (var i = 0; i < ac.length; i++) {
	        var item = ac[i];
	        for (var key in item) {
	          var fieldValue = item[key];
	          var keyarr = key.split(".");
	          var table = keyarr[0];
	
	          var value = fieldValue;
	          var df = key;var oddf = key;
	          if (filter != null && filter.indexOf(df) != -1) {
	            cacheValue = "";
	          } else {
	            var cacheValue = this.convertValue(value, oddf);
	          }
	
	          oddf = oddf.replace(/[\.]/g, '-');
	
	          if (cacheValue != null) tempObj[oddf] = cacheValue + "";else tempObj[oddf] = value + "";
	        }
	        newAc.push(tempObj);
	        tempObj = {};
	      }
	      return newAc;
	    }
	  }, {
	    key: 'convertToOnedimensional',
	    value: function convertToOnedimensional(ac) {
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var newAc = [];
	      var tempObj = {};
	      for (var i = 0; i < ac.length; i++) {
	        var item = ac[i];
	        for (var key in item) {
	          var fieldValue = item[key];
	          var keyarr = key.split(".");
	          var table = keyarr[0];
	
	          var value = fieldValue;
	          var df = key;var oddf = key;
	          if (filter != null && filter.indexOf(df) != -1) {
	            cacheValue = "";
	          } else {
	            var cacheValue = this.convertValue(value, oddf);
	          }
	          if (cacheValue != null) tempObj[oddf] = cacheValue + "";else tempObj[oddf] = value + "";
	        }
	        newAc.push(tempObj);
	        tempObj = {};
	      }
	      return newAc;
	    }
	  }, {
	    key: 'consOnedimensionalGridColBySetting',
	    value: function consOnedimensionalGridColBySetting(settingdoc) {
	
	      if (this.sources.length > 1) var isNeedTableName = true;else isNeedTableName = false;
	
	      var columns = [];var childNodes = settingdoc.children;var map = {};
	      for (var i = 0; i < childNodes.length; i++) {
	        var xml = childNodes[i];
	        var formItemId = xml.attributes.formItemId ? xml.attributes.formItemId.nodeValue : "";
	        var fdsfId = xml.attributes.fdsfId ? xml.attributes.fdsfId.nodeValue : "";
	        var isDataMethod = xml.attributes.isDataMethod.nodeValue == "true" ? true : false;
	        var selected = xml.attributes.selected.nodeValue == "true" ? true : false;
	        var result = this.getExportColumnInfo(fdsfId, formItemId, isDataMethod, isNeedTableName);
	        if (result) {
	          if (result.oneddatafield && map[result.oneddatafield] == true) {
	            continue;
	          }
	          map[result.oneddatafield] = true;
	          this.addDataGridColumn(columns, result.formItemId, result.isDataMethod, result.oneddatafield, result.fdsfId, result.label, result.totalLabel, result.sourceName, selected, result.fieldType);
	        }
	      }
	      return columns;
	    }
	  }, {
	    key: 'consOnedimensionalGridColByView',
	    value: function consOnedimensionalGridColByView(_group) {
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var isPivot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (!_group) _group = this;
	
	      if (_group.sources.length > 1) var isNeedTableName = true;else isNeedTableName = false;
	
	      var columns = [];
	      var focusSequenceList = window.formModuleInstance.focusController.focusableItemsQue1;
	      var map = {};
	      for (var i = 0; i < focusSequenceList.length; i++) {
	        var xml = focusSequenceList[i];
	        var formItem = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, xml.id));
	
	        //TODO 如果是 数据集 区分不同数据源 item
	        if (window.isDataSetView) {
	          this.dataSetQueryTable.allQueryFields = [];
	          this.getAllQueryFieldssForDataSetView(this.dataSetQueryTable);
	
	          for (var k in this.dataSetQueryTable.allQueryFields) {
	            if (this.dataSetQueryTable.allQueryFields[k].fieldAliasName && this.dataSetQueryTable.allQueryFields[k].fieldAliasName == formItem.dataSource_Field || _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[k].fieldName) == formItem.dataSource_Field) {
	              formItem.dataField = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName;
	              formItem.dataSource_Alias = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.substr(0, this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.lastIndexOf("."));
	              if (this.dataSetQueryTable.allQueryFields[k].type == "Expression") {
	                var fileName = _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[k].fieldName);
	                var expAlisa = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.replace(fileName, '');
	                formItem.dataSource_Alias = expAlisa.replace('.', '');
	                formItem._expression = true;
	              }
	              var tableXML = _GOT2.default.getTable(this.dataSetQueryTable.allQueryFields[k].refEntityId);
	              var tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	              formItem.comDataSetLabel = tableLabel;
	            }
	          }
	        }
	
	        if (formItem.group == _group && xml.type && xml.type.indexOf("Editor") != -1 && formItem.dataSource_Alias != "" && formItem.dataSource_Field != "") {
	          //TODO_YL 行列转置聚合的字段列 不作为输出列 
	          var flaga = false;
	          if (this.dynamicColumnsPre && window.formModuleInstance.focusController.focusableItemsQue) {
	            for (var j in window.formModuleInstance.focusController.focusableItemsQue) {
	              if (window.formModuleInstance.focusController.focusableItemsQue[j].id == formItem.xml.parentId) {
	                var dynamicol = _GOTUtil2.default.getProperty(window.formModuleInstance.focusController.focusableItemsQue[j], "DynamicColumn");
	                if (formItem && dynamicol && formItem.innerId == dynamicol.innerid) {
	                  flaga = true;
	                  break;
	                }
	              };
	            }
	          }
	          if (flaga) {
	            continue;
	          }
	          if (isPivot) {
	            if (formItem.classAlias == "FormItemTimeEditorControl") continue;
	            if (formItem.classAlias == "FormItemStringEditorControl" && formItem.isDataAnlysFilter()) continue;
	          }
	          var fe = formItem;
	          if (filter && filter.indexOf(fe.getDataField()) != -1) continue;
	          var oneddatafield;
	          if (fe.dataSource_Field.indexOf(".") == -1) {
	            oneddatafield = fe.dataSource_Alias + "." + _StringUtil2.default.convertToFirstLowerCase(fe.dataSource_Field);
	          } else {
	            var _array = fe.dataSource_Field.split(".");
	            if (_array.length > 3) {
	              oneddatafield = fe.dataSource_Alias + "." + _StringUtil2.default.convertToFirstLowerCase(fe.dataSource_Field);
	            } else {
	              oneddatafield = fe.dataSource_Alias + "." + _StringUtil2.default.convertToFirstLowerCase(_array[0]) + "." + _StringUtil2.default.convertToFirstLowerCase(_array[1]);
	            }
	          }
	          if (fe._expression) {
	            oneddatafield = fe.dataSource_Alias + '.' + fe.dataSource_Field;
	          }
	          if (map[oneddatafield] == true) continue;
	          map[oneddatafield] = true;
	          var dataSourceFieldXML = void 0;
	          if (!fe.isDataMethodField) {
	            var fieldObj = this.getFormDataSourceField(fe.dataSource_Field, fe.dataSource_Alias);
	            dataSourceFieldXML = fieldObj.field;
	            if (dataSourceFieldXML == null) continue;
	            this.saveFieldCache(dataSourceFieldXML, oneddatafield);
	          } else {
	            dataSourceFieldXML = null;
	          }
	          if (!fe.getProperty_Visible_Final()) continue;
	          var _type = fe.xml.type;
	          var _fieldType = _type.substr(0, _type.length - "Editor".length);
	          var gc = {};
	          gc.formItemId = fe.xml.id;
	          gc.isDataMethod = fe.isDataMethodField;
	          gc.fdsfId = dataSourceFieldXML == null ? "" : dataSourceFieldXML.id;
	          gc.dataField = oneddatafield;
	          gc.fieldType = _fieldType;
	          if (_fieldType == "Decimal") {
	            gc.numOfDecimals = fe.getProperty_NumOfDecimals();
	          }
	          var _label = formItem.getProperty_Label(false);var _totalLabel;
	          if (isNeedTableName) {
	            var sourceName = formItem.dataSource_Alias;
	
	            for (var _i22 = 0; _i22 < _group.sources.length; _i22++) {
	              var source = _group.sources[_i22];
	              if (source.alias == sourceName) break;
	            }
	            if (!window.isDataSetView) {
	              if (source.alias != sourceName) continue;
	              var tableName = _GOTUtil2.default.getPropertyValue(source.xml, "Table");
	              var tableXML = _GOT2.default.getTable(tableName);
	              var tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	              _totalLabel = tableLabel + "." + _label;
	            } else {
	              _totalLabel = formItem.comDataSetLabel + "." + _label;
	            }
	          } else {
	            _totalLabel = _label;
	          }
	          gc.headerText = _label;
	          gc.totalHeaderText = _totalLabel;
	          gc.normalHeaderText = _label;
	          gc.selected = true;
	          columns.push(gc);
	        }
	      }
	
	      if (this.dynamicColumnsPre) {
	        for (var key in this.dynamicColumnsPre) {
	          var cls = this.dynamicColumnsPre[key];
	          for (var _i23 in cls) {
	            var cols = cls[_i23];
	            for (var _j2 in cols) {
	              var col = cols[_j2];
	              var _gc = {};
	              _gc.formItemId = "";
	              _gc.isDataMethod = true;
	              _gc.fdsfId = "";
	              _gc.dataField = key + "." + _StringUtil2.default.convertToFirstLowerCase(col.dataKey);
	              _gc.fieldType = "String";
	              _gc.normalHeaderText = col.columnLabel;
	              _gc.selected = true;
	              _gc.totalHeaderText = col.columnLabel;
	              _gc.dataKey = col.dataKey;
	
	              _gc.isDynmicColumn = true;
	              columns.push(_gc);
	            }
	          }
	        }
	      }
	
	      return columns;
	    }
	  }, {
	    key: 'getFormDataSourceField2',
	    value: function getFormDataSourceField2(_name, table, _group) {
	      if (!_group) _group = this;
	      var _name1 = _StringUtil2.default.convertToEachFirstLowerCase(_name);
	      var _name2 = _StringUtil2.default.convertToEachFirstUpperCase(_name);
	      var result = null;
	      for (var i = 0; i < _group.sources.length; i++) {
	        var formDataSource = _group.sources[i];
	        if (formDataSource.xml.name == table || _GOTUtil2.default.getPropertyValue(formDataSource.xml, "Table") == table) {
	          result = _GOT2.default.getFormDataSourceField(formDataSource.xml, _name1, _name2);
	          if (result) return result;
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'getFormDataSourceField',
	    value: function getFormDataSourceField(_name, table, _group) {
	      var parms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	      if (!_group) _group = this;
	      var _name1 = _StringUtil2.default.convertToEachFirstLowerCase(_name);
	      var _name2 = _StringUtil2.default.convertToEachFirstUpperCase(_name);
	      if (_name.split('.').length > 3) {
	        _name1 = _name;
	        _name2 = _name;
	      }
	      var result = null;
	      for (var i = 0; i < _group.sources.length; i++) {
	        var formDataSource = _group.sources[i];
	        if (formDataSource.xml.name == table || _GOTUtil2.default.getPropertyValue(formDataSource.xml, "Table") == table) {
	          var result = _GOT2.default.getFormDataSourceField(formDataSource.xml, _name1, _name2, parms.ingoreCase);
	          if (result) {
	            var au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId, result.id, "visible");
	            if (!au["result"] || _GOTUtil2.default.getFinalValue(result, window.formXML, "Visible") == "false") {
	              result = null;
	            }
	          }
	
	          return { field: result, dataSource: formDataSource.xml };
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'saveFieldCache',
	    value: function saveFieldCache(field, key) {
	      if (this.fieldCache.hasOwnProperty(key)) return;
	      var type = field.type;
	      if (type == "Enum") {
	        var extendsPro = field.Properties.Field;
	        if (extendsPro.hasOwnProperty("refentityid")) {
	          var table = _GOT2.default.getTable(extendsPro.refentityid);
	          var tableField = _GOT2.default.getTableField(table, extendsPro.refinnerid);
	          this.fieldCache[key] = _GOTUtil2.default.getDataSourceByTableField(tableField);
	        }
	      } else if (type == "Boolean") {
	        var textTrueLabel = _GOTUtil2.default.getFinalValue(field, window.formXML, "TextTrue");
	        textTrueLabel = textTrueLabel == "" ? "是" : textTrueLabel;
	        var textFalseLabel = _GOTUtil2.default.getFinalValue(field, window.formXML, "TextFalse");
	        textFalseLabel = textFalseLabel == "" ? "否" : textFalseLabel;
	        this.fieldCache[key] = { "true": textTrueLabel, "false": textFalseLabel };
	      } else {
	        this.fieldCache[key] = type;
	      }
	    }
	  }, {
	    key: 'getFormDataSourceFieldById',
	    value: function getFormDataSourceFieldById(_id) {
	      for (var i = 0; i < this.sources.length; i++) {
	        var formDataSource = this.sources[i];
	        var formDataSourceFields = formDataSource.xml.FormDataSourceFields;
	        for (var k = 0; k < formDataSourceFields.length; k++) {
	          var formDataSourceField = formDataSourceFields[k];
	          if (formDataSourceField.id == _id) return { field: formDataSourceField, dataSource: formDataSource.xml };
	        }
	      }
	
	      return null;
	    }
	
	    //仅在通过setting获取columnInfo的时候才被调用
	
	  }, {
	    key: 'getExportColumnInfo',
	    value: function getExportColumnInfo(fdsfId, formItemId, isDataMethod, isNeedTableName) {
	      if (fdsfId == "" && formItemId != "" && isDataMethod) {
	        var fe = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, formItemId));
	        if (fe == null) return null;
	        var oneddatafield = fe.getDataField();
	        /*if(fe.dataSource_Field.indexOf(".")==-1)
	        {
	          oneddatafield = fe.dataSource_Alias + "-" + StringHelper.convertToFirstLowerCase(fe.dataSource_Field);
	        }
	        else
	        {
	          var _array:Array = fe.dataSource_Field.split(".");
	          oneddatafield = fe.dataSource_Alias + "-" + StringHelper.convertToFirstLowerCase(_array[0]) + "-" + StringHelper.convertToFirstLowerCase(_array[1]);
	        }*/
	        if (!fe.isDataMethodField) {
	          var fieldObj = this.getFormDataSourceField(fe.dataSource_Field, fe.dataSource_Alias);
	          var dataSourceFieldXML = fieldObj.field;
	          this.saveFieldCache(dataSourceFieldXML, oneddatafield);
	        }
	        if (!fe.getProperty_Visible_FinalWithOutUserSet()) return null;
	        var _type = fe.xml.type;
	        var _fieldType = _type.substr(0, _type.length - "Editor".length);
	        var _label = fe.getProperty_Label(false);
	        if (isNeedTableName) {
	          var sourceName = fe.dataSource_Alias;
	          for (var i = 0; i < this.sources.length; i++) {
	            var source = this.sources[i];
	            if (source.alias == sourceName) break;
	          }
	          if (window.isDataSetView) {
	            var sali = source.alias;
	            if (source.alias.indexOf('.') != -1 && sourceName.indexOf('.') == -1) {
	              sali = source.alias.substring(source.alias.lastIndexOf('.') + 1);
	            }
	            if (sali != sourceName && fe.ExpressionGroupAlisa != sali) {}
	            // return null;
	          } else {
	            if (source.alias != sourceName) return null;
	          }
	          var tableName = _GOTUtil2.default.getPropertyValue(source.xml, "Table");
	          var tableXML = _GOT2.default.getTable(tableName);
	          var tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	          var totalLabel = tableLabel + "." + _label;
	        } else {
	          totalLabel = _label;
	        }
	        return { formItemId: formItemId, isDataMethod: true, oneddatafield: oneddatafield, fdsfId: "", label: _label, totalLabel: totalLabel, sourceName: fe.dataSource_Alias, fieldType: _fieldType };
	      } else if (fdsfId != "" && formItemId == "") {
	        var obj = this.getFormDataSourceFieldById(fdsfId);
	        if (!obj) return null;
	        var fdsf = obj.field;var fds = obj.dataSource;var fdsn = fdsf.name;var fdsna = fdsn.split(".");
	        oneddatafield = fds.name;
	        for (var _i24 = 0; _i24 < fdsna.length; _i24++) {
	          var s = fdsna[_i24];
	          oneddatafield += "." + _StringUtil2.default.convertToFirstLowerCase(s);
	        }
	        this.saveFieldCache(fdsf, oneddatafield);
	        var au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId, fdsfId, "visible");
	        if (!au["result"] || _GOTUtil2.default.getFinalValue(fdsf, this.formDataSources.formModule.formXML, "Visible") == "false") {
	          return null;
	        }
	        _label = _GOTUtil2.default.getFinalValue(fdsf, this.formDataSources.formModule.formXML, "Label");
	        if (isNeedTableName) {
	          tableName = _GOTUtil2.default.getPropertyValue(fds, "Table");
	          tableXML = _GOT2.default.getTable(tableName);
	          tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	          totalLabel = tableLabel + "." + _label;
	        } else {
	          totalLabel = _label;
	        }
	        return { formItemId: "", isDataMethod: false, oneddatafield: oneddatafield, fdsfId: fdsfId, label: _label, totalLabel: totalLabel, sourceName: fds.name, fieldType: fdsf.type };
	      } else if (fdsfId != "" && formItemId != "") {
	        fe = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, formItemId));
	
	        if (!fe || !fe.getProperty_Visible_FinalWithOutUserSet()) return null;
	
	        var obj = this.getFormDataSourceFieldById(fdsfId);
	        if (!obj) return null;
	        fdsf = obj.field;
	        var au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId, fdsfId, "visible");
	        if (!au["result"] || _GOTUtil2.default.getFinalValue(fdsf, "Visible") == "false") {
	          return null;
	        }
	        _label = fe.getProperty_Label(false);
	        if (isNeedTableName) {
	          sourceName = fe.dataSource_Alias;
	          for (var _i25 = 0; _i25 < this.sources.length; _i25++) {
	            var source = this.sources[_i25];
	            if (source.alias == sourceName) break;
	          }
	          if (source.alias != sourceName) return null;
	          tableName = _GOTUtil2.default.getPropertyValue(source.xml, "Table");
	          tableXML = _GOT2.default.getTable(tableName);
	          tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	          totalLabel = tableLabel + "." + _label;
	        } else {
	          totalLabel = _label;
	        }
	        oneddatafield = fe.dataSource_Alias + "." + _StringUtil2.default.convertToEachFirstLowerCase(fe.dataSource_Field); //.replace(".","-");
	        this.saveFieldCache(fdsf, oneddatafield);
	        return { formItemId: formItemId, isDataMethod: false, oneddatafield: oneddatafield, fdsfId: fdsfId, label: _label, totalLabel: totalLabel, sourceName: fe.dataSource_Alias, fieldType: fdsf.type };
	      }
	      return null;
	    }
	  }, {
	    key: 'addDataGridColumn',
	    value: function addDataGridColumn(columns, formItemId, isDataMethod, oneddatafield, fdsfId, _label, _totalLabel, sourceName, _selected, _fieldType) {
	      var gc = {};
	      gc.formItemId = formItemId;
	      gc.isDataMethod = isDataMethod;
	      gc.fdsfId = fdsfId;
	      gc.fieldType = _fieldType;
	
	      if (_fieldType == "Decimal") {
	        var tmpNumOfDecimals = 2;
	        if (formItemId) {
	          var formItem = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, formItemId));
	          if (formItem) {
	            gc.numOfDecimals = formItem.getProperty_NumOfDecimals();
	          }
	        } else if (fdsfId) {
	          var form = _GOT2.default.getForm(window.formId);
	          if (form) {
	            var formDataSourceField = void 0;
	            for (var i in form.FormDataSources.DataSources) {
	              var formDataSource = form.FormDataSources.DataSources[i];
	
	              for (var k = 0; k < formDataSource.FormDataSourceFields.length; k++) {
	                var item = formDataSource.FormDataSourceFields[k];
	                if (item && item.id == fdsfId) {
	                  formDataSourceField = item;
	                  break;
	                }
	              }
	              if (formDataSourceField) break;
	            }
	            if (formDataSourceField && form) tmpNumOfDecimals = _GOTUtil2.default.getFinalValue(formDataSourceField, form, "NumOfDecimals");
	            if (!tmpNumOfDecimals) tmpNumOfDecimals = 2;
	          }
	        }
	        gc.numOfDecimals = tmpNumOfDecimals;
	      }
	      gc.dataField = oneddatafield;
	      gc.totalHeaderText = _totalLabel;
	      gc.normalHeaderText = _label;
	      gc.selected = _selected;
	      gc.visible = _selected;
	      gc.headerText = _label;
	
	      columns.push(gc);
	    }
	  }, {
	    key: 'getExtralExportFields',
	    value: function getExtralExportFields(columns) {
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!this.records || this.records.length == 0) return null;
	      var isNeedTableName = this.sources.length > 1;
	      var result = [];
	
	      var mapLabel;var mapVisible;var mapSort;
	      for (var i = 0; i < this.sources.length; i++) {
	        var formDataSource = this.sources[i];
	        var tableLabel = "";var fieldLabel = "";
	        var table = formDataSource.alias;
	        var formDataSourceFields = formDataSource.xml.FormDataSourceFields;
	        mapLabel = mapVisible = mapSort = null;
	        var dimAdjustFormDataSourceField = this.formDataSources.formModule.dimAdjustFormDataSourceField;
	        if (dimAdjustFormDataSourceField) {
	          if (dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapLabel && dimAdjustFormDataSourceField.mapLabel.hasOwnProperty(table)) {
	            mapLabel = dimAdjustFormDataSourceField.mapLabel[table];
	          }
	
	          if (dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapVisible && dimAdjustFormDataSourceField.mapVisible.hasOwnProperty(table)) {
	            mapVisible = dimAdjustFormDataSourceField.mapVisible[table];
	          }
	
	          if (dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapSort && dimAdjustFormDataSourceField.mapSort.hasOwnProperty(table)) {
	            mapSort = dimAdjustFormDataSourceField.mapSort[table];
	          }
	        }
	        var mapSortDemi = {};var mapSortCpy = {};
	        for (var cmp in mapSort) {
	          var arrayItemsCpy = [];
	
	          var cmpaitems = mapSort[cmp];
	
	          for (var kk = 0; kk < cmpaitems.length; kk++) {
	            arrayItemsCpy[kk] = cmp + "." + cmpaitems[kk];
	            mapSortDemi[arrayItemsCpy[kk]] = true;
	          }
	          mapSortCpy[cmp] = arrayItemsCpy;
	        }
	        var array = [];
	        for (var j = 0; j < formDataSourceFields.length; j++) {
	          var formDataSourceField = formDataSourceFields[j];
	          var _name = formDataSourceField.name;
	          if (window.isDataSetView == true && _name == "CreatedDate") break;
	          if (formDataSourceField.type == "Component" && _name.indexOf(".") == -1) {
	            if (mapSortCpy && mapSortCpy.hasOwnProperty(_name)) {
	              var dataTypeArrayItems = mapSortCpy[_name];
	              for (var k = 0; k < dataTypeArrayItems.length; k++) {
	                var dataTypeArrayItem = dataTypeArrayItems[k];
	
	                var arrayItemDataSourceField = null;
	                for (var n = 0; n < formDataSourceFields.length; n++) {
	                  if (formDataSourceFields[n].name == dataTypeArrayItem) {
	                    arrayItemDataSourceField = formDataSourceFields[n];break;
	                  }
	                }
	                if (arrayItemDataSourceField) {
	                  array.push(arrayItemDataSourceField);
	                } else {
	                  _Warn2.default.show("跟拒二次开发中的mapSort中的名称未能找到对应的FormDataSourceField:" + dataTypeArrayItem + " 请确认二次开发是否有误");
	                }
	              }
	            }
	            continue;
	          }
	          if (_name.indexOf(".") != -1 && mapSortDemi.hasOwnProperty(_name)) continue;
	          array.push(formDataSourceField);
	        }
	
	        for (var _j3 = 0; _j3 < array.length; _j3++) {
	          var _formDataSourceField = array[_j3];
	          var _name3 = _formDataSourceField.name;
	          if (mapVisible && mapVisible.hasOwnProperty(_name3) && mapVisible[_name3] == false) continue;
	
	          var origdataSourceField = _StringUtil2.default.convertToEachFirstLowerCase(_name3);
	          var dataSourceField = origdataSourceField; //.replace(".","-");
	          var _dataField = table + "-" + dataSourceField;
	          var _recDataField = table + "." + dataSourceField;
	          if (filter && filter.indexOf(_recDataField) != -1) continue;
	          var flag = false;
	          for (var _k4 = 0; _k4 < columns.length; _k4++) {
	            var column = columns[_k4];
	            if (column.dataField == _dataField || column.dataField == _recDataField) {
	              flag = true;
	              break;
	            }
	          }
	          if (!flag) {
	            var fe = this.findItemByDataField(_recDataField);
	            var _label;var _totalLabel;
	            if (!fe) {
	              if (_formDataSourceField) {
	                _label = mapLabel && mapLabel.hasOwnProperty(_name3) ? mapLabel[_name3] : _GOTUtil2.default.getFinalValue(_formDataSourceField, window.formXML, "Label");
	                if (isNeedTableName) {
	                  var fds = formDataSource.xml;
	                  var tableName = _GOTUtil2.default.getPropertyValue(fds, "Table");
	                  var tableXML = _GOT2.default.getTable(tableName);
	                  tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	                  _totalLabel = tableLabel + "." + _label;
	                } else {
	                  _totalLabel = _label;
	                }
	                var obj = { label: _label, selected: true, dataField: table + "." + dataSourceField, totalLabel: _totalLabel, fdsfId: _formDataSourceField.id, formItemId: "", isDataMethod: false, fieldType: _formDataSourceField.type };
	                if (obj.fieldType == "Decimal") obj.numOfDecimals = _GOTUtil2.default.getFinalValue(_formDataSourceField, this.formDataSources.formModule.props.xml, "NumOfDecimals");
	                result.push(obj);
	              }
	            } else {
	              if (fe.getProperty_Visible_FinalWithOutUserSet()) {
	                _label = mapLabel && mapLabel.hasOwnProperty(_name3) ? mapLabel[_name3] : fe.getProperty_Label(false);
	
	                if (isNeedTableName) {
	                  var sourceName = fe.dataSource_Alias;
	                  for (var _i26 = 0; _i26 < this.sources.length; _i26++) {
	                    var source = this.sources[_i26];
	                    if (source.alias == sourceName) break;
	                  }
	                  if (source.alias != sourceName) continue;
	                  tableName = _GOTUtil2.default.getPropertyValue(source.xml, "Table");
	                  tableXML = _GOT2.default.getTable(tableName);
	                  tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	                  _totalLabel = tableLabel + "." + _label;
	                } else {
	                  _totalLabel = _label;
	                }
	                var _obj = {
	                  label: _label, selected: true, dataField: table + "." + dataSourceField, totalLabel: _totalLabel,
	                  fdsfId: _formDataSourceField ? _formDataSourceField.id : "", formItemId: fe.innerId, isDataMethod: fe.isDataMethodField, fieldType: _fieldType
	                };
	                var _type = fe.xml.type;
	                var _fieldType = _type.substr(0, _type.length - "Editor".length);
	                if (fe.classAlias == "FormItemDecimalEditorControl") _obj.numOfDecimals = fe.getProperty_NumOfDecimals();
	                result.push(_obj);
	              }
	            }
	          }
	        }
	      }
	
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var _fe = _FormItemUtil2.default.formItemControlsForFor[key];
	
	        if (_fe && _fe.isDataMethodField) {
	          var _dataField6 = _fe.dataSource_Alias + "-" + _fe.dataSource_Field;
	          var _dataField1 = _fe.dataSource_Alias + "." + _fe.dataSource_Field;
	          var _flag = false;
	          for (var _i27 = 0; _i27 < columns.length; _i27++) {
	            var _column3 = columns[_i27];
	            if (_column3.dataField == _dataField6 || _column3.dataField == _dataField1) {
	              _flag = true;
	              break;
	            }
	          }
	
	          if (!_flag) {
	            var _type2 = _fe.xml.type;
	            var _fieldType2 = _type2.substr(0, _type2.length - "Editor".length);
	            var _label2 = _fe.getProperty_Label(false);
	            var _source = void 0;
	            if (isNeedTableName) {
	              var _sourceName = _fe.dataSource_Alias;
	              for (var _i28 = 0; _i28 < this.sources.length; _i28++) {
	                _source = this.sources[_i28];
	                if (_source.alias == _sourceName) break;
	              }
	              if (_source.alias != _sourceName) continue;
	              tableName = _GOTUtil2.default.getPropertyValue(_source.xml, "Table");
	              tableXML = _GOT2.default.getTable(tableName);
	              tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	              _totalLabel = tableLabel + "." + _label2;
	            } else {
	              _totalLabel = _label2;
	            }
	            var obj2 = { label: _label2, selected: true, dataField: _dataField1, totalLabel: _totalLabel, fdsfId: "", formItemId: _fe.innerId, isDataMethod: true, fieldType: _fieldType2 };
	            if (_fe.classAlias == "FormItemDecimalEditorControl") obj2.numOfDecimals = _fe.getProperty_NumOfDecimals();
	            result.push(obj2);
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'getExtralExportFields1',
	    value: function getExtralExportFields1(columns) {
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!this.records || this.records.length == 0) return null;
	      var isNeedTableName = this.sources.length > 1;
	      var result = [];
	
	      var mapLabel;var mapVisible;var mapSort;
	      for (var i = 0; i < this.sources.length; i++) {
	        var formDataSource = this.sources[i];
	        if (this.mainSource.isAggreateTable && formDataSource != this.mainSource) continue;
	        var tableLabel = "";var fieldLabel = "";
	        var table = formDataSource.alias;
	        var formDataSourceFields = formDataSource.xml.FormDataSourceFields;
	        mapLabel = mapVisible = mapSort = null;
	        var dimAdjustFormDataSourceField = this.formDataSources.formModule.dimAdjustFormDataSourceField;
	        if (dimAdjustFormDataSourceField) {
	          if (dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapLabel && dimAdjustFormDataSourceField.mapLabel.hasOwnProperty(table)) {
	            mapLabel = dimAdjustFormDataSourceField.mapLabel[table];
	          }
	
	          if (dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapVisible && dimAdjustFormDataSourceField.mapVisible.hasOwnProperty(table)) {
	            mapVisible = dimAdjustFormDataSourceField.mapVisible[table];
	          }
	
	          if (dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapSort && dimAdjustFormDataSourceField.mapSort.hasOwnProperty(table)) {
	            mapSort = dimAdjustFormDataSourceField.mapSort[table];
	          }
	        }
	        var mapSortDemi = {};var mapSortCpy = {};
	        for (var cmp in mapSort) {
	          var arrayItemsCpy = [];
	
	          var cmpaitems = mapSort[cmp];
	
	          for (var kk = 0; kk < cmpaitems.length; kk++) {
	            arrayItemsCpy[kk] = cmp + "." + cmpaitems[kk];
	            mapSortDemi[arrayItemsCpy[kk]] = true;
	          }
	          mapSortCpy[cmp] = arrayItemsCpy;
	        }
	        var array = [];
	        for (var j = 0; j < formDataSourceFields.length; j++) {
	          var formDataSourceField = formDataSourceFields[j];
	          var _name = formDataSourceField.name;
	          if (formDataSourceField.type == "Component" && _name.indexOf(".") == -1) {
	            if (mapSortCpy && mapSortCpy.hasOwnProperty(_name)) {
	              var dataTypeArrayItems = mapSortCpy[_name];
	              for (var k = 0; k < dataTypeArrayItems.length; k++) {
	                var dataTypeArrayItem = dataTypeArrayItems[k];
	
	                var arrayItemDataSourceField = null;
	                for (var n = 0; n < formDataSourceFields.length; n++) {
	                  if (formDataSourceFields[n].name == dataTypeArrayItem) {
	                    arrayItemDataSourceField = formDataSourceFields[n];break;
	                  }
	                }
	                if (arrayItemDataSourceField) {
	                  array.push(arrayItemDataSourceField);
	                } else {
	                  _Warn2.default.show("跟拒二次开发中的mapSort中的名称未能找到对应的FormDataSourceField:" + dataTypeArrayItem + " 请确认二次开发是否有误");
	                }
	              }
	            }
	            continue;
	          }
	          if (_name.indexOf(".") != -1 && mapSortDemi.hasOwnProperty(_name)) continue;
	          array.push(formDataSourceField);
	        }
	
	        for (var _j4 = 0; _j4 < array.length; _j4++) {
	          var _formDataSourceField2 = array[_j4];
	          var _name4 = _formDataSourceField2.name;
	          if (mapVisible && mapVisible.hasOwnProperty(_name4) && mapVisible[_name4] == false) continue;
	
	          var origdataSourceField = _StringUtil2.default.convertToEachFirstLowerCase(_name4);
	          var dataSourceField = origdataSourceField.replace(".", "-");
	          var _dataField = table + "-" + dataSourceField;
	          var _recDataField = table + "." + dataSourceField;
	          if (filter && filter.indexOf(_recDataField) != -1) continue;
	          var flag = false;
	          for (var _k5 = 0; _k5 < columns.length; _k5++) {
	            var column = columns[_k5];
	            if (column.dataField == _dataField || column.dataField == _recDataField) {
	              flag = true;
	              break;
	            }
	          }
	          if (!flag) {
	            var fe = this.findItemByDataField(_recDataField);
	            var _label;var _totalLabel;
	            if (!fe) {
	              if (_formDataSourceField2) {
	                _label = mapLabel && mapLabel.hasOwnProperty(_name4) ? mapLabel[_name4] : _GOTUtil2.default.getFinalValue(_formDataSourceField2, window.formXML, "Label");
	                if (isNeedTableName) {
	                  var fds = formDataSource.xml;
	                  var tableName = _GOTUtil2.default.getPropertyValue(fds, "Table");
	                  var tableXML = _GOT2.default.getTable(tableName);
	                  tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	                  _totalLabel = tableLabel + "." + _label;
	                } else {
	                  _totalLabel = _label;
	                }
	                var obj = { label: _label, selected: true, dataField: table + "-" + dataSourceField, totalLabel: _totalLabel, fdsfId: _formDataSourceField2.id, formItemId: "", isDataMethod: false, fieldType: _formDataSourceField2.type };
	                if (obj.fieldType == "Decimal") obj.numOfDecimals = _GOTUtil2.default.getFinalValue(_formDataSourceField2, this.formDataSources.formModule.props.xml, "NumOfDecimals");
	                result.push(obj);
	              }
	            } else {
	              if (fe.getProperty_Visible_FinalWithOutUserSet()) {
	                _label = mapLabel && mapLabel.hasOwnProperty(_name4) ? mapLabel[_name4] : fe.getProperty_Label(false);
	
	                if (isNeedTableName) {
	                  var sourceName = fe.dataSource_Alias;
	                  for (var _i29 = 0; _i29 < this.sources.length; _i29++) {
	                    var source = this.sources[_i29];
	                    if (source.alias == sourceName) break;
	                  }
	                  if (source.alias != sourceName) continue;
	                  tableName = _GOTUtil2.default.getPropertyValue(source.xml, "Table");
	                  tableXML = _GOT2.default.getTable(tableName);
	                  tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	                  _totalLabel = tableLabel + "." + _label;
	                } else {
	                  _totalLabel = _label;
	                }
	                var _obj2 = {
	                  label: _label, selected: true, dataField: table + "-" + dataSourceField, totalLabel: _totalLabel,
	                  fdsfId: _formDataSourceField2 ? _formDataSourceField2.id : "", formItemId: fe.innerId, isDataMethod: fe.isDataMethodField, fieldType: _fieldType
	                };
	                var _type = fe.xml.type;
	                var _fieldType = _type.substr(0, _type.length - "Editor".length);
	                if (fe.classAlias == "FormItemDecimalEditorControl") _obj2.numOfDecimals = fe.getProperty_NumOfDecimals();
	                result.push(_obj2);
	              }
	            }
	          }
	        }
	      }
	
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var _fe2 = _FormItemUtil2.default.formItemControlsForFor[key];
	
	        if (_fe2 && _fe2.isDataMethodField) {
	          var _dataField7 = _fe2.dataSource_Alias + "-" + _fe2.dataSource_Field;
	          var _dataField1 = _fe2.dataSource_Alias + "." + _fe2.dataSource_Field;
	          var _flag2 = false;
	          for (var _i30 = 0; _i30 < columns.length; _i30++) {
	            var _column4 = columns[_i30];
	            if (_column4.dataField == _dataField7 || _column4.dataField == _dataField1) {
	              _flag2 = true;
	              break;
	            }
	          }
	
	          if (!_flag2) {
	            var _type3 = _fe2.xml.type;
	            var _fieldType3 = _type3.substr(0, _type3.length - "Editor".length);
	            var _label3 = _fe2.getProperty_Label(false);
	            var _source2 = void 0;
	            if (isNeedTableName) {
	              var _sourceName2 = _fe2.dataSource_Alias;
	              for (var _i31 = 0; _i31 < this.sources.length; _i31++) {
	                _source2 = this.sources[_i31];
	                if (_source2.alias == _sourceName2) break;
	              }
	              if (_source2.alias != _sourceName2) continue;
	              tableName = _GOTUtil2.default.getPropertyValue(_source2.xml, "Table");
	              tableXML = _GOT2.default.getTable(tableName);
	              tableLabel = _GOTUtil2.default.getFinalValue(tableXML, tableXML, "Label");
	              _totalLabel = tableLabel + "." + _label3;
	            } else {
	              _totalLabel = _label3;
	            }
	            var obj2 = { label: _label3, selected: true, dataField: _dataField7, totalLabel: _totalLabel, fdsfId: "", formItemId: _fe2.innerId, isDataMethod: true, fieldType: _fieldType3 };
	            if (_fe2.classAlias == "FormItemDecimalEditorControl") obj2.numOfDecimals = _fe2.getProperty_NumOfDecimals();
	            result.push(obj2);
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'findItemByDataField',
	    value: function findItemByDataField(df) {
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var formItemControl = _FormItemUtil2.default.formItemControlsForFor[key];
	        if (formItemControl.classAlias.indexOf("Editor") != -1 && formItemControl.group == this && formItemControl.getDataField() == df) {
	          return formItemControl;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'clearTempRecord',
	    value: function clearTempRecord() {
	      if (this.mainSource.isTempTable == false) return;
	      this.records = [];
	      if (this.tempRecordsFilter) this.tempRecordsFilter = null;
	      _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this);
	    }
	  }, {
	    key: 'deleteTempRecords',
	    value: function deleteTempRecords(_queryTable) {
	      if (this.mainSource.isTempTable == true && _queryTable) {
	        var mainAlias = this.mainSource.alias;var locateNextRecId = "";var flag = 0;
	
	        var thisRecords = this.tempRecordsFilter ? this.tempRecordsFilter : this.records;
	
	        var length = thisRecords.length;var _records = [];var recIds = [];var next;var pre;var dontLocate = false;
	
	        for (var i = 0; i < thisRecords.length; i++) {
	          var record = thisRecords[i];
	          if (this.analysisSingleRecord(record, _queryTable) == true) {
	            var __recId = record[mainAlias + ".recId"];
	            recIds.push(__recId);
	            _records.push(record);
	          }
	        }
	        //_records是被删除的记录
	        if (thisRecords.indexOf(this.currentRecord) == -1) {
	          dontLocate = true;
	        }
	
	        for (var _i32 = 0; _i32 < _records.length; _i32++) {
	          var _record5 = _records[_i32];
	          var index = thisRecords.indexOf(_record5);
	          if (!locateNextRecId && !dontLocate) {
	            if (index > 0) {
	              pre = thisRecords[index - 1]; //getItemAt(index-1)[mainAlias];
	            } else {
	              pre = null;
	            }
	
	            if (pre != null) {
	              var preRecId = pre[mainAlias + ".recId"];
	              if (recIds.indexOf(preRecId) == -1) locateNextRecId = preRecId;
	            }
	
	            if (!locateNextRecId) {
	              if (index < length - 1) {
	                next = thisRecords[index + 1];
	              } else {
	                next = null;
	              }
	
	              if (next) {
	                var nextRecId = next[mainAlias + ".recId"];
	                if (recIds.indexOf(nextRecId) == -1) locateNextRecId = nextRecId;
	              }
	            }
	          }
	
	          thisRecords.splice(index, 1);
	          //this.dataProvider.removeItemAt(index);
	          length--;
	          flag++;
	        }
	
	        if (this.tempRecordsFilter) {
	          for (var _i33 = 0; _i33 < recIds.length; _i33++) {
	            var deletedrecId = recIds[_i33];
	            var deletedRecord = this.mapRecId[deletedrecId];
	            if (deletedRecord) {
	              var deletedIndex = this.records.indexOf(deletedRecord);
	              if (deletedIndex > -1) this.records.splice(deletedIndex, 1);
	            }
	          }
	        }
	
	        //dataProvider.refresh();
	        _RecordsActions2.default.recordsCmp(thisRecords, this.groupAlias, this);
	        if (dontLocate == false) {
	          var located = false;
	          if (!locateNextRecId) {
	            this.setCurrentRecord(null);
	            located = true;
	          } else {
	            for (var _i34 = 0; _i34 < thisRecords.length; _i34++) {
	              var r = thisRecords[_i34];
	              var _locateNextRecId = r[this.mainSource.alias + ".recId"];
	              if (_locateNextRecId == locateNextRecId) {
	                this.setCurrentRecord(r);
	                located = true;
	                break;
	              }
	            }
	          }
	
	          if (located == false) {
	            if (thisRecords.length > 0) this.setCurrentRecord(thisRecords[0]);else this.setCurrentRecord(null);
	          }
	        }
	
	        /*var revent:FormRecordEvent = new FormRecordEvent(FormRecordEvent.RECORD_OPR,true);
	        revent.info = "删除成功:" + flag.toFixed() + "条记录";
	        revent.oprType = RecordOprType.del;
	        this.formDataSources.formModule.dispatchEvent(revent);*/
	      }
	    }
	  }, {
	    key: 'addTempRecords',
	    value: function addTempRecords(ac) {
	      if (ac == null || this.mainSource.isTempTable == false) return;
	
	      var fdsgr = new _FormDataSourceGroupResult2.default();
	      fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
	
	      this.formatFormDataSourceGroupResult(fdsgr);
	      var isFirst = false;
	      if (!this.records) {
	        this.records = [];
	      }
	
	      if (this.records.length == 0) {
	        isFirst = true;
	      }
	
	      var newRecords = fdsgr.dataResult;
	
	      for (var i = 0; i < newRecords.length; i++) {
	        var item = newRecords[i];
	        var _recId = item[this.groupAlias + ".recId"];
	        this.mapRecId[_recId] = item;
	        this.recordsBak[_recId] = Object.assign({}, item);
	      }
	
	      this.records = this.records.concat(newRecords);
	      //如果已有被用户筛选过的记录(在临时表上进行过查询器查询) 此为最高优先级
	      //如果没有筛选过 又有默认查询条件 则默认查询条件第一次起作用 二者均使用同一变量this.tempRecordsFilter
	      if (this.tempRecordsFilter && this.tempRecordsFilter.length > 0) {
	        var _analysisSingleRecord = this.analysisSingleRecord.bind(this);
	        var _queryTable = this.getCurrentQueryTable();
	        _queryTable.queryRelations = null;
	        var _recordsFilter = newRecords.filter(function (item) {
	          return _analysisSingleRecord(item, _queryTable, false);
	        });
	        this.tempRecordsFilter = this.tempRecordsFilter.concat(_recordsFilter);
	      } else if (this.hasTempDefaultQuery) {
	        var _analysisSingleRecord = this.analysisSingleRecord.bind(this);
	        var _queryTable2 = this.getCurrentQueryTable();
	        _queryTable2.queryRelations = null;
	        var _recordsFilter2 = newRecords.filter(function (item) {
	          return _analysisSingleRecord(item, _queryTable2, false);
	        });
	        if (!this.tempRecordsFilter) this.tempRecordsFilter = [];
	        this.tempRecordsFilter = this.tempRecordsFilter.concat(_recordsFilter2);
	      }
	      var _records = this.tempRecordsFilter ? this.tempRecordsFilter : this.records;
	      _RecordsActions2.default.recordsCmp(_records, this.groupAlias, this);
	      if (isFirst) {
	        this.setCurrentRecord(this.records.length > 0 ? this.records[0] : null);
	      }
	    }
	  }, {
	    key: 'refreshTempRecordPartly',
	    value: function refreshTempRecordPartly(ac) {
	      if (ac == null || this.mainSource.isTempTable == false) return;
	      //alert(ac.length); 
	      var fdsgr = new _FormDataSourceGroupResult2.default();
	      fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
	
	      this.formatFormDataSourceGroupResult(fdsgr);
	      var isFirst = false;
	      if (!this.records) {
	        this.records = [];
	      }
	      var origIndex = -1;
	      if (this.records.length == 0) {
	        isFirst = true;
	      } else {
	        origIndex = this.tempRecordsFilter ? this.tempRecordsFilter.indexOf(this.currentRecord) : this.records.indexOf(this.currentRecord);
	      }
	
	      var newRecords = fdsgr.dataResult;
	
	      for (var i = 0; i < newRecords.length; i++) {
	
	        var item = newRecords[i];
	        this.replaceRecord3(item);
	        var _recId = item[this.groupAlias + ".recId"];
	        this.mapRecId[_recId] = item;
	        this.recordsBak[_recId] = Object.assign({}, item);
	      }
	
	      //this.records = newRecords.concat();
	      var _records = this.tempRecordsFilter ? this.tempRecordsFilter : this.records;
	      _RecordsActions2.default.recordsCmp(_records, this.groupAlias, this, true);
	      if (isFirst) {
	        this.setCurrentRecord(_records.length > 0 ? _records[0] : null);
	      } else {
	        if (origIndex == -1) origIndex = 0;
	        this.setCurrentRecord(_records.length > origIndex ? _records[origIndex] : null);
	      }
	    }
	  }, {
	    key: 'refreshTempRecord',
	    value: function refreshTempRecord(ac) {
	      if (ac == null || this.mainSource.isTempTable == false) return;
	
	      var fdsgr = new _FormDataSourceGroupResult2.default();
	      fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
	
	      this.formatFormDataSourceGroupResult(fdsgr);
	      var isFirst = false;
	      if (!this.records) {
	        this.records = [];
	      }
	
	      if (this.records.length == 0) {
	        isFirst = true;
	      }
	
	      var newRecords = fdsgr.dataResult;
	
	      for (var i = 0; i < newRecords.length; i++) {
	        var item = newRecords[i];
	        var _recId = item[this.groupAlias + ".recId"];
	        this.mapRecId[_recId] = item;
	        this.recordsBak[_recId] = Object.assign({}, item);
	      }
	
	      this.records = newRecords;
	      _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this);
	      if (isFirst) {
	        this.setCurrentRecord(this.records.length > 0 ? this.records[0] : null);
	      }
	
	      return;
	      if (ac == null || this.mainSource.isTempTable == false) return;
	      //alert(ac.length); 
	      var fdsgr = new _FormDataSourceGroupResult2.default();
	      fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
	
	      this.formatFormDataSourceGroupResult(fdsgr);
	      var isFirst = false;
	      if (!this.records) {
	        this.records = [];
	      }
	
	      if (this.records.length == 0) {
	        isFirst = true;
	      }
	
	      var newRecords = fdsgr.dataResult;
	
	      for (var _i35 = 0; _i35 < newRecords.length; _i35++) {
	
	        var _item5 = newRecords[_i35];
	
	        /*var ac = this.records;
	        if(!ac)
	          throw new Error("ac==null");
	        
	        var mainAlias = this.groupAlias;
	        var recId = record[mainAlias+".recId"];
	        if(!this.mapRecId.hasOwnProperty(recId))
	          throw new Error("mapRecId中不存在" + recId);
	        
	        var origRecord = this.mapRecId[recId];
	        if(replaceAttr)
	        { 
	          if(origRecord==null)
	          {
	            alert("origRecord null");
	          }
	          else if(record==null)
	          {
	            alert("record null when replaceRecord");
	          }
	          else
	          {
	            this.replaceRecordValue(record,origRecord);
	          }
	        }
	        else
	        {
	          var index = ac.indexOf(origRecord);
	          if(index==-1)
	            alert("index==-1  " + recId);
	          ac[index] = record;
	        }*/
	
	        this.replaceRecord3(_item5);
	        var _recId = _item5[this.groupAlias + ".recId"];
	        this.mapRecId[_recId] = _item5;
	        this.recordsBak[_recId] = Object.assign({}, _item5);
	      }
	
	      //this.records = newRecords.concat();
	      _RecordsActions2.default.recordsCmp(this.records, this.groupAlias, this, true);
	      if (isFirst) {
	        this.setCurrentRecord(this.records.length > 0 ? this.records[0] : null);
	      }
	    }
	
	    /*refreshTempRecord(ac)
	    {
	      let that = this;
	      setTimeout(
	          function()
	        {
	          that.refreshTempRecord2(ac);
	        },
	        2000
	      );
	    }*/
	
	  }, {
	    key: 'anyRecordValue2',
	    value: function anyRecordValue2(field) {
	      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var record = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var index = 0;
	      var group = this;
	      while (field.charAt(index) == ".") {
	        if (index == 0) {
	          index++;
	          continue;
	        }
	        group = group.linkGroup;
	        if (!group) return value;
	        index++;
	      }
	      if (!record) record = group.currentRecord;
	      if (!record) return null;
	      field = field.substr(index);
	      if (field.indexOf(".") != -1) {
	        if (field.indexOf(".") > 2) {
	          field = group.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(field);
	        } else {
	          field = _StringUtil2.default.convertToEachFirstLowerCase(field.substr(index));
	          field = _StringUtil2.default.convertToFirstUpperCase(field);
	        }
	      } else {
	        field = group.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(field);
	      }
	
	      return record[field];
	    }
	  }, {
	    key: 'analysisConditionSingleRecord',
	    value: function analysisConditionSingleRecord(item, jca) {
	
	      if (!jca) return true;
	      if (!item) item = this.currentRecord;
	      if (!item && jca.isNull == true) return true;
	      if (!item) return false;
	      if (!jca.getSqlWhereStr) jca.getSqlWhereStr = _RecordConditionTask2.default.getSqlWhereStr;
	      var ws = jca.getSqlWhereStr();
	      if (ws == "") return true;
	      var wsa = ws.split(" ");
	      var wsr = "";
	      for (var i = 0; i < wsa.length; i++) {
	        var s = wsa[i];
	        if (s.indexOf("=") == -1) {
	          wsr += s;
	        } else {
	          var fn = _StringUtil2.default.convertToFirstLowerCase(s.substring(0, s.indexOf("=")));
	          var fv = s.substr(s.indexOf("=") + 1);
	
	          if (fn.indexOf(".") != 0) continue;
	          var value = this.anyRecordValue2(fn, null, item);
	
	          if (fv.indexOf(".") == 0) fv = this.anyRecordValue2(fv, null, item);
	
	          if (_RecordsUtil2.default.analysisValue(value, fv))
	            //(String(item[groupAlias][fn]) == fv)
	            {
	              wsr += "1";
	            } else {
	            wsr += "0";
	          }
	        }
	      }
	
	      return _StringUtil2.default.evalLEString(_StringUtil2.default.trimThrough(wsr));
	    }
	  }, {
	    key: 'analysisConditionSingleRecord1',
	    value: function analysisConditionSingleRecord1(item, recordCondition) {
	      var isFloat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (recordCondition == null) return true;
	      if (item == null) item = this.currentRecord;
	
	      if (item == null) return false;
	      if (!recordCondition.getSqlWhereStr) recordCondition.getSqlWhereStr = _RecordCondition2.default.getSqlWhereStr;
	      var ws = recordCondition.getSqlWhereStr();
	      if (ws == "") return true;
	      var wsa = ws.split(" ");
	      var wsr = "";
	      for (var i = 0; i < wsa.length; i++) {
	        var s = wsa[i];
	        if (s.indexOf("=") == -1) {
	          wsr += s;
	        } else {
	          var fn = _StringUtil2.default.convertToFirstLowerCase(s.substring(0, s.indexOf("=")));
	          var fv = s.substr(s.indexOf("=") + 1);
	
	          if (fn.indexOf(".") != 0) continue;
	          var value = this.anyRecordValue2(fn, null, item);
	
	          if (fv.indexOf(".") == 0) fv = this.anyRecordValue2(fv, null, item);
	
	          if (isFloat) {
	            if (value.indexOf(".") != -1) {
	              value = _StringUtil2.default.trimRight(String(value), "0");
	              if (value.charAt(value.length - 1) == ".") value = value.substr(0, value.length - 1);
	            }
	            if (fv.indexOf(".") != -1) {
	              fv = _StringUtil2.default.trimRight(fv, "0");
	              if (fv.charAt(fv.length - 1) == ".") fv = fv.substr(0, fv.length - 1);
	            }
	          }
	
	          if (_RecordsUtil2.default.analysisValue(value, fv)) {
	            wsr += "1";
	          } else {
	            wsr += "0";
	          }
	        }
	      }
	
	      return _StringUtil2.default.evalLEString(_StringUtil2.default.trimThrough(wsr));
	    }
	  }, {
	    key: 'findValue',
	    value: function findValue(dataField, filterValue) {
	      if (window.isDataSetView) {
	        this.dataSetQueryTable.queryAllFields = [];
	        this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
	        this.queryFilterForSetData(dataField, "", "", this.dataSetQueryTable, filterValue);
	      } else {
	        _QueryUtil2.default.findOrCreateWhereItem(dataField, this.currentQuery, filterValue);
	        this.reSetCurrentQuery(this.currentQuery);
	      }
	      this.executeQueryAutoSaveStop(null);
	    }
	  }, {
	    key: 'setFieldModifiedNewValue',
	    value: function setFieldModifiedNewValue(records, record, aliasName, fieldName, componentItemName, newValue) {
	      for (var i = 0; i < records.length; i++) {
	        var item = records[i];
	        var itemRecId = item[aliasName]['recId'];
	        var baseRecId = record[aliasName + '.recId'];
	        if (itemRecId == baseRecId) {
	          //let newValueField = componentItemName?(aliasName+"."+fieldName+"."+componentItemName):(aliasName+"."+fieldName);
	          if (componentItemName) {
	            item[aliasName][fieldName][componentItemName] = newValue;
	          } else {
	            item[aliasName][fieldName] = newValue;
	          }
	
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'doFieldModifiedRemote',
	    value: function doFieldModifiedRemote(aliasName, fieldName, componentItemName, oldValue, newValue, dataField, record, component) {
	      var extralParms = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
	
	      console.log("doFieldModifiedRemote");
	      var fullFieldName = void 0;
	      var fullFieldName2 = void 0;
	      var result = true;
	      var methodName = "";
	      var dataSourceFieldHasDot = false;
	      //插件内部节点带点
	      if (extralParms.formDataSourceField) {
	        var ns = "";var fieldName2 = "";
	        var dataSourceFieldId = extralParms.formDataSourceField.id;
	        if (dataSourceFieldId.indexOf(".") != -1) {
	          var arr = dataSourceFieldId.split(".");
	          arr.pop();
	          ns = arr.join(".");var ns2 = arr.join("_");
	          var dataSourceFieldName = extralParms.formDataSourceField.name;
	          if (dataSourceFieldName) {
	            var trueFieldName = dataSourceFieldName.substr(ns.length + 1);
	            fullFieldName2 = ns + "." + trueFieldName;
	            fullFieldName = ns2 + "$" + _StringUtil2.default.replaceAll(trueFieldName, ".", "_");
	            dataSourceFieldHasDot = true;
	          }
	        }
	      }
	      if (!dataSourceFieldHasDot) //FormDataSourceField不带点号 按原逻辑处理
	        {
	          if (componentItemName == null) fullFieldName = _StringUtil2.default.convertToFirstUpperCase(fieldName);else fullFieldName = _StringUtil2.default.convertToFirstUpperCase(fieldName) + "." + _StringUtil2.default.convertToFirstUpperCase(componentItemName);
	          methodName = aliasName + ".modifiedField_" + _StringUtil2.default.replaceAll(fullFieldName, ".", "_");
	        } else //FormDataSourceField带点号 又是另外一种逻辑
	        {
	          methodName = aliasName + ".modifiedField_" + fullFieldName;
	          fullFieldName = fullFieldName2;
	        }
	
	      if (fullFieldName == null) {
	        alert("fullFieldName null");
	      }
	      if (!record) record = this.currentRecord;
	      var args = [oldValue, newValue, record, null, null];
	      _LayerManager2.default.executeLayerMethod(this.formDataSources.formModule, this.formDataSources.currentGroup, "modifiedField_" + _StringUtil2.default.replaceAll(fullFieldName, ".", "_"), args);
	      var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, this.formDataSources.formModule.menuItemId, this.formDataSources.formModule.formId);
	      if (mi) {
	        var arg = new _FormDataSourceGroupArg2.default();
	        arg.argType = 0;
	        arg.groupAlias = this.groupAlias;
	        arg.aliasList = [];
	        arg.arg = {};
	        if (!record) record = this.currentRecord;
	        arg.arg[0] = _RecordsUtil2.default.getSecondaryRecord1(record, this.mainSource.alias, _StringUtil2.default.convertToFirstLowerCase(fieldName), _StringUtil2.default.convertToFirstLowerCase(componentItemName), newValue);
	        arg.aliasList.push(this.mainSource.alias);
	        arg.recordCounts = 1;
	        var extparms = {};
	        if (extralParms.dynamicColumn == true) extparms.ignoreFetchOption = true;
	        var commandArg = _CommandResolver2.default.getSendCmd(this.formDataSources.formModule, this.groupAlias, mi, extparms);
	        if (extralParms.dynamicColumn == true && commandArg) commandArg.argObject = extralParms.dynamicKey;
	
	        if (commandArg && commandArg.mapGroups) {
	          try {
	            for (var key in commandArg.mapGroups) {
	              if (key == this.groupAlias) {
	                var gi = commandArg.mapGroups[key];
	                if (gi) {
	                  if (gi.selectedRecords) {
	                    this.setFieldModifiedNewValue(gi.selectedRecords, record, aliasName, fieldName, componentItemName, newValue);
	                  }
	                  if (gi.allRecords) {
	                    this.setFieldModifiedNewValue(gi.allRecords, record, aliasName, fieldName, componentItemName, newValue);
	                  }
	                }
	              }
	            }
	          } catch (e) {}
	        }
	        var _editorName = extralParms.editorName;
	
	        var _rpc_fault_doFieldModifield = this.rpc_fault_doFieldModified.bind(this);
	        var _rpc_result_doFieldModified = this.rpc_result_doFieldModified.bind(this);
	        this.fullFieldName = fullFieldName;
	        var _that = this;
	        _ServiceHelper2.default.addTokenWithCommand({
	          command: _CommandHelper2.default.createFormInstance(this.formDataSources.formModule.formName, "doFieldModified").appendArg(_editorName ? _editorName : "", "String").appendArg(fullFieldName, "String").appendArg(oldValue + "", "Object").appendArg(newValue + "", "Object").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
	          resultFunction: function resultFunction(data) {
	            //TODO存在modifiedField之后刷新DataGrid的情况并且与自动保存存在冲突 所以延迟500ms解决同步问题
	            //setTimeout(function(){_rpc_result_doFieldModified(data,record);},200);
	            _rpc_result_doFieldModified(data, record, _that.fullFieldName);
	            //TODO此处不知道为何会返回false 导致调用者不返回新值 但是根据 1.回送值 2.自动保存 3.执行modified二次开发的顺序 此处不对  所以改为true
	            result = true;
	          },
	          //resultFunction:this.rpc_result_doFieldModified.bind(this),
	          faultFunction: function faultFunction(faultEvent) {
	            _rpc_fault_doFieldModifield(faultEvent, oldValue, newValue, component);
	            result = false;
	          } //,sync:extralParms.async?false:true
	        });
	      }
	      return result;
	    }
	  }, {
	    key: 'rpc_fault_doFieldModified',
	    value: function rpc_fault_doFieldModified(faultEvent, oldValue, newValue, component) {
	      var faultString;
	      if (faultEvent && faultEvent.successButNot0) {
	        faultString = faultEvent.errText;
	        //Warning.show({text:data.errText,title:"画面初始查询失败"});
	      } else {
	        faultString = "可能是网络错误 请检查网络是否正常";
	        //Warning.show({text:"请检查网络是否正常或联系管理员",title:"变更值失败"});
	      }
	
	      //var faultString = faultEvent;
	      if (component && typeof component.restoreValue == "function") {
	        component.restoreValue(oldValue);
	      }
	      //record[dataField] = oldValue;
	      _Warn2.default.show({ text: "变更值失败：" + oldValue + " -> " + newValue + "<br/>" + "现已恢复到：" + oldValue + "<br/>" + "错误原因为：" + faultString, title: "此次操作未能成功" });
	    }
	  }, {
	    key: 'rpc_result_doFieldModified',
	    value: function rpc_result_doFieldModified(data, record) {
	      var itemName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (!this.records) return;
	      var result = data.result;
	      if (!result.dataResult) return;
	
	      var obj = result.dataResult.length > 0 ? result.dataResult[0] : null;
	      if (!obj) return;
	
	      this.formatFormDataSourceGroupResult(result, "modified");
	
	      if (result.dataResult) {
	        if (!record) record = this.currentRecord;
	        var currentIndex = this.records.indexOf(record);
	        var flag = this.local_fieldModified(result.dataResult, itemName);
	        /*TODO 为何？if(currentIndex!=-1)
	        {
	          this.currentRecord = this.dataProvider.getItemAt(currentIndex);
	        }
	        if(result.autoSaveRecord)
	        {
	          doDelayRecordSave();
	        }
	        else
	        {
	          inFieldModified = false;
	          if(saveDelay)
	          {
	            saveDelay = false;
	            callBackFunCache = null;
	            callBacFunCacheArgs = null;
	          }
	        }*/
	        _CommandResolver2.default.resolve(result.commandResult.tasks, this.formDataSources.formModule, this);
	      } else {
	        alert("字段修改失败，返回null");
	      }
	    }
	  }, {
	    key: 'local_fieldModified',
	    value: function local_fieldModified(ac) {
	      var fullitemName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var mainAlias = this.mainSource.alias;
	      var flag = 0;
	      var recordCounts = 1;
	
	      var record = ac[0];
	
	      /*if(record["NumberSequenceTable.maxNum"] == 0 || record["NumberSequenceTable.minNum"] == 0)
	      {
	        alert("后台返回没改");
	      }*/
	      var mainAlias = this.groupAlias;
	      var recId = record[mainAlias + ".recId"];
	      if (!this.mapRecId.hasOwnProperty(recId)) throw new Error("mapRecId中不存在" + recId);
	
	      var origRecord = this.mapRecId[recId];
	
	      if (origRecord == null) {
	        alert("origRecord null");
	      } else if (record == null) {
	        alert("record null when replaceRecord");
	      } else {
	        //console.log("发生modifiedField------"+recId);
	        for (var itemName in record) {
	          var item = record[itemName];
	          var oldValue = origRecord[itemName];
	          var changed = oldValue != item;
	          origRecord[itemName] = item;
	          if (changed) {
	            _RecordsActions2.default.RecordFieldChanged(origRecord, itemName, oldValue, item, null);
	          } else if (itemName.substring(itemName.lastIndexOf(".") + 1) == _StringUtil2.default.convertToFirstLowerCase(fullitemName)) {
	            _RecordsActions2.default.RecordFieldChanged(origRecord, itemName, oldValue, item, null);
	          }
	        }
	
	        //TODO innerJoin LeftJoin的关联更改 如果后台没有关联就返回的 现有记录的关联字段置为空
	        if (record) {
	          for (var origItemName in origRecord) {
	            if (!record.hasOwnProperty(origItemName)) {
	              var _oldValue = origRecord[origItemName];
	              origRecord[origItemName] = "";
	              if (_oldValue) _RecordsActions2.default.RecordFieldChanged(origRecord, origItemName, _oldValue, "", null);
	            }
	          }
	        }
	      }
	      return flag;
	    }
	  }, {
	    key: 'checkDataSourceField2FormItem',
	    value: function checkDataSourceField2FormItem(dataSourceField, formDataSource) {
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var formItem = _FormItemUtil2.default.formItemControlsForFor[key];
	        if (formItem.type && formItem.type.indexOf("Editor") != -1) {
	          var ext = _GOTUtil2.default.getPropertyValue(formItem.xml, "Extends");
	          var ds = _GOTUtil2.default.getPropertyValue(formItem.xml, "DataSource");
	
	          if (ext && ds && ext == dataSourceField.name && ds == formDataSource.xml.name) {
	            if (formItem.getProperty_Visible_Final()) return true;else return false;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getFormDataSourcesExpInnerJoin',
	    value: function getFormDataSourcesExpInnerJoin() {
	      var _group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (_group == null) _group = this;
	      var dataSourceFields = [];
	      var _parentWindow = window.parent.window;
	      for (var i = 0; i < _group.sources.length; i++) {
	        var formDataSource = _group.sources[i];
	        var notComponentFields = _GOTUtil2.default.getNotComponentFormDataSourceFields(formDataSource.xml);
	        for (var k = 0; k < notComponentFields.length; k++) {
	          var xml = notComponentFields[k];
	          var au = _AuthorityUtil2.default.getXmlType2SCacheItem(window.menuItemId, xml.id, "visible");
	          if (!au["result"] || _GOTUtil2.default.getFinalValue(xml, this.formDataSources.formModule.props.xml, "Visible") == false) {
	            continue;
	          }
	
	          if (!_parentWindow.userInfos.isAdmin && formDataSource != this.mainSource) {
	            if (!this.checkDataSourceField2FormItem(xml, formDataSource)) continue;
	          }
	
	          dataSourceFields.push(xml);
	        }
	      }
	
	      return dataSourceFields;
	    }
	  }, {
	    key: 'getDataMethodFormItem',
	    value: function getDataMethodFormItem(_dataField) {
	      for (var key in _FormItemUtil2.default.formItemControlsForFor) {
	        var item = _FormItemUtil2.default.formItemControlsForFor[key];
	        if (item.classAlias.indexOf("Editor") != -1) {
	          if (item.dataField == _dataField) return item;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getAggregateFormDataSourcesExpInnerJoin',
	    value: function getAggregateFormDataSourcesExpInnerJoin() {
	      var _group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!_group) _group = this;
	      var dataSourceFields = [];
	      for (var i = 0; i < _group.sources.length; i++) {
	        var formDataSource = _group.sources[i];
	        for (var k = 0; k < formDataSource.xml.FormDataSourceFields.length; k++) {
	          var xml = formDataSource.xml.FormDataSourceFields[k];
	          var field = _StringUtil2.default.convertToFirstLowerCase(xml.name);
	          if (this.aggreateTableFields.indexOf(field) == -1) {
	            continue;
	          }
	          var au = _AuthorityUtil2.default.getXmlType2SCacheItem(this.formDataSources.formModule.menuItemId, xml.id, "visible");
	
	          if (!au["result"] || _GOTUtil2.default.getFinalValue(xml, window.formXML, "Visible") == "false") {
	            continue;
	          }
	
	          if (formDataSource != this.mainSource) {
	            if (!this.checkDataSourceField2FormItem(xml, formDataSource)) continue;
	          }
	
	          dataSourceFields.push(xml);
	        }
	      }
	      return dataSourceFields;
	    }
	  }, {
	    key: 'showCurRecTotalAggreateTable',
	    value: function showCurRecTotalAggreateTable() {
	      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!this.currentRecord) return;
	      var data = this.currentRecord;
	      var dataSourceFields = this.getAggregateFormDataSourcesExpInnerJoin();
	      var dataSourceFieldsCollection = dataSourceFields;
	      var dataProvider = [];
	      var dataMethodFields = [];
	      var cacheValue = "";
	      for (var key in data) {
	        var value = data[key];
	        var keyarr = key.split(".");
	        var table = keyarr[0];
	        var fieldLabel = "";var fieldName = "";
	        if (keyarr.length == 2) {
	          var _labelsuffix = "";
	          var dataSourceField = _StringUtil2.default.convertToFirstUpperCase(keyarr[1]);
	          if (dataSourceField.indexOf("Aggregate_Sum_") == 0) {
	            dataSourceField = dataSourceField.substr(14);_labelsuffix = "(合计)";
	          } else if (dataSourceField.indexOf("Aggregate_Avg_") == 0) {
	            dataSourceField = dataSourceField.substr(14);_labelsuffix = "(平均值)";
	          } else if (dataSourceField.indexOf("Aggregate_Max_") == 0) {
	            dataSourceField = dataSourceField.substr(14);_labelsuffix = "(最大值)";
	          } else if (dataSourceField.indexOf("Aggregate_Min_") == 0) {
	            dataSourceField = dataSourceField.substr(14);_labelsuffix = "(最小值)";
	          } else if (dataSourceField.indexOf("Aggregate_Count_") == 0) {
	            dataSourceField = dataSourceField.substr(16);_labelsuffix = "(计数)";
	          } else if (dataSourceField.indexOf("Aggregate_Distinct_") == 0) {
	            dataSourceField = dataSourceField.substr(19);_labelsuffix = "(不同值)";
	          } else if (dataSourceField.indexOf("Aggregate_CountDistinct_") == 0) {
	            dataSourceField = dataSourceField.substr(24);_labelsuffix = "(不同值计数)";
	          } else if (dataSourceField.indexOf("Aggregate_Const_") == 0) {
	            dataSourceField = dataSourceField.substr(16);_labelsuffix = "(约束)";
	          }
	
	          var resultObject = this.getFormDataSourceField(dataSourceField, table);
	          var dataSourceFieldXML = resultObject ? resultObject.field : null;
	          if (dataSourceFieldXML == null) {
	            var _dataField = key;
	            var formItemEditor = this.getDataMethodFormItem(_dataField);
	            if (formItemEditor != null) dataMethodFields.push({ chLabel: formItemEditor.getProperty_Label(), enLabel: keyarr[1], fvalue: value });
	            continue;
	          }
	          if (dataSourceFieldXML.type == "Component") continue;
	          var childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
	          if (childIndex == -1) continue;
	
	          fieldLabel = _GOTUtil2.default.getFinalValue(dataSourceFieldXML, window.formXML, "Label") + _labelsuffix;
	          fieldName = dataSourceFieldXML.name;
	
	          var fieldpXML = _GOTUtil2.default.getProperty(dataSourceFieldXML, "Field");
	          var filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
	          if (filter != null && filter.indexOf(filterKey) != -1) {
	            cacheValue = "";
	          } else {
	            this.saveFieldCache(dataSourceFieldXML, table + "-" + key);
	            cacheValue = this.convertValue(value, table + "-" + key);
	          }
	
	          dataProvider[childIndex] = { chLabel: fieldLabel, enLabel: fieldName, fvalue: cacheValue };
	        } else if (keyarr.length == 3) {
	          var compDataSourceFieldName = _StringUtil2.default.convertToFirstUpperCase(keyarr[1]);
	          var compDataSourceFieldXML = this.getFormDataSourceField(compDataSourceFieldName, table);
	
	          if (compDataSourceFieldXML == null) continue;
	
	          //var compDataSourceFieldLabel = GOTHelper.getFinalValue(compDataSourceFieldXML,window.formXML,"Label");
	          var okey = keyarr[2];
	
	          if (this.aggreateDimTableFiels.indexOf(okey) == -1) continue;
	          var ovalue = value;
	          dataSourceField = _StringUtil2.default.convertToFirstUpperCase(keyarr[1]) + "." + _StringUtil2.default.convertToFirstUpperCase(keyarr[2]);
	          compDataSourceFieldName = key.substr(0, 1).toUpperCase() + key.substr(1);
	
	          var labelsuffix = "";
	          if (dataSourceField.indexOf("Aggregate_Sum_") == 0) {
	            dataSourceField = dataSourceField.substr(14);labelsuffix = "(合计)";
	          } else if (dataSourceField.indexOf("Aggregate_Avg_") == 0) {
	            dataSourceField = dataSourceField.substr(14);labelsuffix = "(平均值)";
	          } else if (dataSourceField.indexOf("Aggregate_Max_") == 0) {
	            dataSourceField = dataSourceField.substr(14);labelsuffix = "(最大值)";
	          } else if (dataSourceField.indexOf("Aggregate_Min_") == 0) {
	            dataSourceField = dataSourceField.substr(14);labelsuffix = "(最小值)";
	          } else if (dataSourceField.indexOf("Aggregate_Count_") == 0) {
	            dataSourceField = dataSourceField.substr(16);labelsuffix = "(计数)";
	          } else if (dataSourceField.indexOf("Aggregate_Distinct_") == 0) {
	            dataSourceField = dataSourceField.substr(19);labelsuffix = "(不同值)";
	          } else if (dataSourceField.indexOf("Aggregate_CountDistinct_") == 0) {
	            dataSourceField = dataSourceField.substr(24);labelsuffix = "(不同值计数)";
	          } else if (dataSourceField.indexOf("Aggregate_Const_") == 0) {
	            dataSourceField = dataSourceField.substr(16);labelsuffix = "(约束)";
	          }
	          dataSourceFieldXML = this.getFormDataSourceField(dataSourceField, table);
	
	          if (dataSourceFieldXML == null) {
	            continue;
	          }
	          childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
	          if (childIndex == -1) continue;
	          fieldLabel = _GOTUtil2.default.getFinalValue(dataSourceFieldXML, window.formXML, "Label") + labelsuffix;
	          fieldName = dataSourceFieldXML.name;
	          fieldpXML = _GOTUtil2.default.getProperty(dataSourceFieldXML, "Field");
	          filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
	          if (filter != null && filter.indexOf(filterKey) != -1) {
	            cacheValue = "";
	          } else {
	            this.saveFieldCache(dataSourceFieldXML, table + "-" + key + "-" + okey);
	            cacheValue = this.convertValue(ovalue, table + "-" + key + "-" + okey);
	          }
	
	          dataProvider[childIndex] = { chLabel: fieldLabel, enLabel: fieldName, fvalue: cacheValue };
	        }
	      }
	      return { dataMethodFields: dataMethodFields, dataProvider: dataProvider };
	    }
	  }, {
	    key: 'showCurRecTotal',
	    value: function showCurRecTotal() {
	      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var parms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result;
	      if (this.mainSource.isAggreateTable) result = this.showCurRecTotalAggreateTable(filter);else result = this.getRecTotalDataProvider(filter);
	      if (!result) return;
	      var dataMethodFields = result.dataMethodFields;
	      var dataProvider = result.dataProvider;
	
	      var _title = "详细信息 ";
	      var _table = _GOT2.default.getTable(this.mainSource.tableId);
	      var _tableNameLabel = _GOTUtil2.default.getFinalValue(_table, _table, "Label");
	      _title += _tableNameLabel;
	      var _parentWindow = window.parent.window;
	      if (_parentWindow.userInfos.isAdmin) {
	        _title += " " + this.mainSource.tableName;
	      }
	      //TODO 使用concat？
	      if (dataMethodFields.length > 0) {
	        var fdataProvider = [];
	        for (var i in dataProvider) {
	          var _item = dataProvider[i];
	          fdataProvider.push(_item);
	        }
	        for (var _i36 in dataMethodFields) {
	          var _item6 = dataMethodFields[_i36];
	          fdataProvider.push(_item6);
	        }
	        var fdataProvider = fdataProvider;
	        var tableName = this.mainSource.tableName;
	        var self = this;
	        var title = _title;
	        // ReactDOM.render(<CurrentRecordInfo fdataProvider={fdataProvider} tableName={tableName} self={self} title={title}/>,document.getElementById('currentRecordInfoModal'));
	        //  $("#currentRecordInfoModal").css("display","flex");
	        _CurrentRecordInfo2.default.show(fdataProvider, tableName, self, title, parms);
	      } else {
	        fdataProvider = [];
	        for (var _i37 in dataProvider) {
	          var _item7 = dataProvider[_i37];
	          fdataProvider.push(_item7);
	        }
	        var fdataProvider = fdataProvider;
	        var tableName = this.mainSource.tableName;
	        var self = this;
	        var title = _title;
	        // ReactDOM.render(<CurrentRecordInfo fdataProvider={fdataProvider} tableName={tableName} self={self} title={title}/>,document.getElementById('currentRecordInfoModal'));
	        // $("#currentRecordInfoModal").css("display", "flex");
	        _CurrentRecordInfo2.default.show(fdataProvider, tableName, self, title, parms);
	      }
	
	      console.log(fdataProvider);
	    }
	  }, {
	    key: 'getRecTotalDataProvider',
	    value: function getRecTotalDataProvider() {
	      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!this.currentRecord) return null;
	
	      var data = this.currentRecord;
	      var dataSourceFields = this.getFormDataSourcesExpInnerJoin();
	
	      var dataSourceFieldsCollection = dataSourceFields;
	      var dataProvider = [];
	      var formXML = this.formDataSources.formModule.props.xml;
	      var dataMethodFields = [];
	
	      var mapLabel = null;var mapVisible = null;var mapSort = null;
	      if (this.formDataSources.formModule.dimAdjustFormDataSourceField) {
	        var dimAdjustFormDataSourceField = this.formDataSources.formModule.dimAdjustFormDataSourceField;
	        mapLabel = dimAdjustFormDataSourceField.mapLabel;
	        mapVisible = dimAdjustFormDataSourceField.mapVisible;
	        mapSort = dimAdjustFormDataSourceField.mapSort;
	      }
	      for (var key in data) {
	        var table = "";
	        var fieldLabel = "";
	        var fieldName = "";
	        var tempResult;
	
	        var keyarr = key.split(".");
	
	        var value = data[key];
	        table = keyarr[0];
	        //插件内部节点带点 如果包含.号 如果大于3个点 则认为是带点号字段 并且找FormDataSourceField的时候要忽略大小写
	        //跟普通字段处理方式一样
	        if (keyarr.length == 2 || keyarr.length > 3) {
	          var dataSourceField;
	          if (keyarr.length == 2) {
	            dataSourceField = _StringUtil2.default.convertToFirstUpperCase(keyarr[1]);
	            tempResult = this.getFormDataSourceField(dataSourceField, table);
	          } else {
	            var firstdotIndex = key.indexOf(".");
	            var keyarr1 = key.substr(firstdotIndex + 1);
	            dataSourceField = _StringUtil2.default.convertToFirstUpperCase(keyarr1);
	            tempResult = this.getFormDataSourceField(dataSourceField, table, null, { ingoreCase: true });
	          }
	
	          var dataSourceFieldXML = tempResult ? tempResult.field : null;
	
	          //如果没有找到dataSourceField 则考虑其为一个DataMethod
	          if (!tempResult) {
	            var _dataField = key; //this.groupAlias+"."+key;
	            var formItemEditor = this.getDataMethodFormItem(_dataField);
	            if (formItemEditor) {
	              var _editorType = formItemEditor.xml.type;
	              var _fieldType = _editorType.substring(0, _editorType.length - 6);
	              //shift刚好大致按照Form上的FormItem排布顺序
	              dataMethodFields.unshift({ chLabel: formItemEditor.getProperty_Label(), enLabel: keyarr[1], fvalue: value + '', dataField: _dataField, fieldType: _fieldType });
	            }
	            continue;
	          }
	
	          //如果找到dataSourceField但是由于某些原因其不可见
	          if (!dataSourceFieldXML) {
	            continue;
	          }
	
	          var childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
	          if (childIndex == -1) continue;
	          fieldName = dataSourceFieldXML.name;
	          if (mapVisible && mapVisible.hasOwnProperty(table) && mapVisible[table].hasOwnProperty(fieldName)) {
	            if (mapVisible[table][fieldName] == false) continue;
	          }
	          if (mapLabel && mapLabel.hasOwnProperty(table) && mapLabel[table].hasOwnProperty(fieldName)) {
	            fieldLabel = mapLabel[table][fieldName];
	          } else {
	            fieldLabel = _GOTUtil2.default.getFinalValue(dataSourceFieldXML, formXML, "Label");
	          }
	
	          var fieldpXML = _GOTUtil2.default.getProperty(dataSourceFieldXML, "Field");
	          var filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
	          if (filter && filter.indexOf(filterKey) != -1) {
	            cacheValue = "";
	          } else {
	            this.saveFieldCache(dataSourceFieldXML, table + "-" + keyarr[1]);
	            var cacheValue = this.convertValue(value + "", table + "-" + keyarr[1]);
	          }
	
	          dataProvider[childIndex] = { dataSourceEnLabel: table,
	            chLabel: fieldLabel, enLabel: fieldName, fvalue: cacheValue, dataField: key,
	            fieldType: dataSourceFieldXML.type };
	        } else if (keyarr.length == 3) {
	          var compDataSourceFieldName = _StringUtil2.default.convertToFirstUpperCase(keyarr[1]);
	          tempResult = this.getFormDataSourceField(compDataSourceFieldName, table);
	          var compDataSourceFieldXML = tempResult ? tempResult.field : null;
	
	          if (!compDataSourceFieldXML) continue;
	
	          //var compDataSourceFieldLabel = GOTUtil.getFinalValue(compDataSourceFieldXML,formXML,"Label");
	
	          var compDataSourceFieldName = compDataSourceFieldXML.name;
	
	          var compDataSourceFieldNames = [];
	          for (var i = 0; i < dataSourceFieldsCollection.length; i++) {
	            var field = dataSourceFieldsCollection[i];
	            var compFieldName = field.name;
	            if (compFieldName.indexOf(".") != -1 && compFieldName.indexOf(compDataSourceFieldName) == 0) {
	              compDataSourceFieldNames.push(compFieldName);
	            }
	          }
	
	          var ovalue = value;
	          dataSourceField = _StringUtil2.default.convertToFirstUpperCase(keyarr[1]) + "." + _StringUtil2.default.convertToFirstUpperCase(keyarr[2]);
	          tempResult = this.getFormDataSourceField(dataSourceField, table);
	          dataSourceFieldXML = tempResult ? tempResult.field : null;
	
	          if (!dataSourceFieldXML) {
	            continue;
	          }
	          childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
	          if (childIndex == -1) continue;
	          fieldName = dataSourceFieldXML.name;
	          var helpArray = fieldName.split(".");
	          var fieldCutName = helpArray.length > 0 ? helpArray[1] : fieldName;
	          if (mapVisible && mapVisible.hasOwnProperty(table) && mapVisible[table].hasOwnProperty(fieldName)) {
	            if (mapVisible[table][fieldName] == false) continue;
	          }
	          if (mapLabel && mapLabel.hasOwnProperty(table) && mapLabel[table].hasOwnProperty(fieldName)) {
	            fieldLabel = mapLabel[table][fieldName];
	          } else {
	            fieldLabel = _GOTUtil2.default.getFinalValue(dataSourceFieldXML, formXML, "Label");
	          }
	
	          fieldpXML = _GOTUtil2.default.getProperty(dataSourceFieldXML, "Field");
	          filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
	          if (filter && filter.indexOf(filterKey) != -1) {
	            cacheValue = "";
	          } else {
	            this.saveFieldCache(dataSourceFieldXML, table + "-" + keyarr[1] + "-" + keyarr[2]);
	            cacheValue = this.convertValue(value, table + "-" + keyarr[1] + "-" + keyarr[2]);
	          }
	
	          if (mapSort && mapSort.hasOwnProperty(table) && mapSort[table].hasOwnProperty(compDataSourceFieldName)) {
	            var newCompDataSourceFieldNames = mapSort[table][compDataSourceFieldName];
	            if (newCompDataSourceFieldNames && newCompDataSourceFieldNames.length > 0) {
	              childIndex += newCompDataSourceFieldNames.indexOf(fieldCutName) - compDataSourceFieldNames.indexOf(fieldName);
	            }
	          }
	          dataProvider[childIndex] = { chLabel: fieldLabel, enLabel: fieldName, fvalue: cacheValue,
	            dataField: key, fieldType: dataSourceFieldXML.type, dataSourceEnLabel: table };
	        }
	      }
	      return { dataMethodFields: dataMethodFields, dataProvider: dataProvider };
	    }
	  }, {
	    key: 'doWriteField',
	    value: function doWriteField(values) {
	      var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!this.currentRecord) return;
	      for (var field in values) {
	        if (field) {
	          var value = values[field];
	          field = _StringUtil2.default.convertToEachFirstLowerCase(field);
	          var fullField = this.groupAlias + "." + field;
	          var oldValue = this.currentRecord[fullField];
	          if (this.currentRecord.hasOwnProperty(fullField)) this.currentRecord[fullField] = value;
	          var arr = fullField.split(".");
	          _RecordsActions2.default.RecordFieldChanged(this.currentRecord, fullField, oldValue, value, null);
	          if (triggerModified) {
	            this.doFieldModifiedRemote(this.groupAlias, arr[1], arr.length > 2 ? arr[2] : null, oldValue, value, fullField, this.currentRecord);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updateDataMethodFieldValue',
	    value: function updateDataMethodFieldValue(arg) {
	      for (var key in arg) {
	        if (this.mapRecId.hasOwnProperty(key)) {
	          var valueo = arg[key];
	          var record = this.mapRecId[key];
	          for (var valuekey in valueo) {
	            var value = valueo[valuekey];
	            var _valuekey = this.groupAlias + "." + _StringUtil2.default.convertToEachFirstLowerCase(valuekey);
	            if (this.tempDataMethodField.hasOwnProperty(_valuekey)) {
	              var field = this.tempDataMethodField[_valuekey];
	              // let _field = this.groupAlias + "." + StringUtil.convertToEachFirstLowerCase(field);
	              if (record.hasOwnProperty(field)) {
	                if (!value) value = "";
	                record[field] = value;
	
	                _RecordsActions2.default.RecordDataMethodFieldChanged(record, field);
	              }
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'findValueStepByStepPre',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(args) {
	        var value, dataField, records, fromIndex, stepColumn, i, record, dataValue, _record6, _dataValue, preDataField, fromIndex2, keys, startIndex, k, key;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                value = args.value;
	                dataField = args.dataField;
	                records = this.records;
	                fromIndex = args.fromIndex;
	                stepColumn = args.stepColumn;
	
	                if (!fromIndex) fromIndex = stepColumn ? { row: 0 } : 0;
	                if (this.tempRecordsFilter) records = this.tempRecordsFilter;
	                if (stepColumn == true) fromIndex = fromIndex.row;
	
	                if (stepColumn) {
	                  _context.next = 22;
	                  break;
	                }
	
	                i = fromIndex - 2;
	
	              case 10:
	                if (!(i > -1)) {
	                  _context.next = 20;
	                  break;
	                }
	
	                record = records[i];
	                dataValue = record[dataField] + "";
	
	
	                dataValue = this.getEnumLabelByDataField(dataField, dataValue);
	
	                if (!(dataValue.indexOf(value) != -1)) {
	                  _context.next = 17;
	                  break;
	                }
	
	                _FocusActions2.default.scrollToAndFocus({ groupAlias: this.groupAlias, toIndex: i, fromIndex: fromIndex, dataField: dataField });
	                return _context.abrupt('return', Math.max(i + 1, 0));
	
	              case 17:
	                i--;
	                _context.next = 10;
	                break;
	
	              case 20:
	                _context.next = 47;
	                break;
	
	              case 22:
	                i = fromIndex;
	
	              case 23:
	                if (!(i > -1)) {
	                  _context.next = 47;
	                  break;
	                }
	
	                _record6 = records[i];
	                _dataValue = _record6[dataField] + "";
	                preDataField = args.fromIndex ? args.fromIndex.dataField : null;
	                fromIndex2 = args.fromIndex ? args.fromIndex.row : fromIndex;
	                keys = args.dataFields;
	                startIndex = !preDataField || i != fromIndex2 || keys.indexOf(preDataField) == -1 ? keys.length - 1 : keys.indexOf(preDataField);
	
	                if (i != fromIndex2) {
	                  preDataField = null;
	                }
	                k = startIndex - 1;
	
	              case 32:
	                if (!(k > -1)) {
	                  _context.next = 44;
	                  break;
	                }
	
	                key = keys[k];
	
	                if (!(key == preDataField)) {
	                  _context.next = 36;
	                  break;
	                }
	
	                return _context.abrupt('continue', 41);
	
	              case 36:
	
	                _dataValue = _record6[key] + "";
	                _dataValue = this.getEnumLabelByDataField(key, _dataValue);
	
	                if (!(_dataValue.indexOf(value) != -1)) {
	                  _context.next = 41;
	                  break;
	                }
	
	                _FocusActions2.default.scrollToAndFocus({ groupAlias: this.groupAlias, toIndex: i, fromIndex: fromIndex2, dataField: key });
	                return _context.abrupt('return', { row: i, dataField: key });
	
	              case 41:
	                k--;
	                _context.next = 32;
	                break;
	
	              case 44:
	                i--;
	                _context.next = 23;
	                break;
	
	              case 47:
	                return _context.abrupt('return', 0);
	
	              case 48:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function findValueStepByStepPre(_x101) {
	        return _ref.apply(this, arguments);
	      }
	
	      return findValueStepByStepPre;
	    }()
	  }, {
	    key: 'findValueStepByStep',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(args) {
	        var value, dataField, records, fromIndex, stepColumn, i, record, dataValue, preDataField, fromIndex2, keys, startIndex, k, key;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                value = args.value;
	                dataField = args.dataField;
	                records = this.records;
	                fromIndex = args.fromIndex;
	                stepColumn = args.stepColumn;
	
	                if (!fromIndex) fromIndex = stepColumn ? { row: 0 } : 0;
	                if (this.tempRecordsFilter) records = this.tempRecordsFilter;
	                if (stepColumn == true) fromIndex = fromIndex.row;
	                i = fromIndex;
	
	              case 9:
	                if (!(i < records.length)) {
	                  _context2.next = 41;
	                  break;
	                }
	
	                record = records[i];
	                dataValue = record[dataField] + "";
	
	                dataValue = this.getEnumLabelByDataField(dataField, dataValue);
	
	                if (stepColumn) {
	                  _context2.next = 19;
	                  break;
	                }
	
	                if (!(dataValue.indexOf(value) != -1)) {
	                  _context2.next = 17;
	                  break;
	                }
	
	                _FocusActions2.default.scrollToAndFocus({ groupAlias: this.groupAlias, toIndex: i, fromIndex: fromIndex, dataField: dataField });
	                return _context2.abrupt('return', i + 1);
	
	              case 17:
	                _context2.next = 38;
	                break;
	
	              case 19:
	                if (!(stepColumn == true)) {
	                  _context2.next = 38;
	                  break;
	                }
	
	                preDataField = args.fromIndex ? args.fromIndex.dataField : null;
	                fromIndex2 = args.fromIndex ? args.fromIndex.row : fromIndex;
	                keys = args.dataFields;
	                startIndex = !preDataField || i != fromIndex2 || keys.indexOf(preDataField) == -1 ? 0 : keys.indexOf(preDataField);
	
	                if (i != fromIndex2) {
	                  preDataField = null;
	                }
	                k = startIndex;
	
	              case 26:
	                if (!(k < keys.length)) {
	                  _context2.next = 38;
	                  break;
	                }
	
	                key = keys[k];
	
	                if (!(key == preDataField)) {
	                  _context2.next = 30;
	                  break;
	                }
	
	                return _context2.abrupt('continue', 35);
	
	              case 30:
	                dataValue = record[key] + "";
	                dataValue = this.getEnumLabelByDataField(key, dataValue);
	
	                if (!(dataValue.indexOf(value) != -1)) {
	                  _context2.next = 35;
	                  break;
	                }
	
	                _FocusActions2.default.scrollToAndFocus({ groupAlias: this.groupAlias, toIndex: i, fromIndex: fromIndex2, dataField: key });
	                return _context2.abrupt('return', { row: i, dataField: key });
	
	              case 35:
	                k++;
	                _context2.next = 26;
	                break;
	
	              case 38:
	                i++;
	                _context2.next = 9;
	                break;
	
	              case 41:
	                _context2.next = 43;
	                return this.executeQueryAutoSaveStop("NextPage");
	
	              case 43:
	                if (stepColumn == true) {
	                  args.formIndex = { row: i + 1 };
	                } else {
	                  args.fromIndex = i + 1;
	                }
	
	                args.stackDeep++;
	                return _context2.abrupt('return', this.findValueStepByStep2(args));
	
	              case 46:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function findValueStepByStep(_x102) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return findValueStepByStep;
	    }()
	  }, {
	    key: 'findValueStepByStep2',
	    value: function findValueStepByStep2(args) {
	      var value = args.value;
	      var dataField = args.dataField;
	      var records = this.records;
	      var fromIndex = args.fromIndex;
	      var stepColumn = args.stepColumn;
	      if (!fromIndex) fromIndex = stepColumn ? { row: 0 } : 0;;
	      if (this.tempRecordsFilter) records = this.tempRecordsFilter;
	      if (stepColumn == true) fromIndex = fromIndex.row;
	      for (var i = fromIndex; i < records.length; i++) {
	        var record = records[i];
	        var dataValue = record[dataField] + "";
	        dataValue = this.getEnumLabelByDataField(dataField, dataValue);
	        if (!stepColumn) {
	          if (dataValue.indexOf(value) != -1) {
	            _FocusActions2.default.scrollToAndFocus({ groupAlias: this.groupAlias, toIndex: i, fromIndex: fromIndex, dataField: dataField });
	            return i + 1;
	          }
	        } else {
	          var preDataField = args.fromIndex ? args.fromIndex.dataField : null;var fromIndex2 = args.fromIndex ? args.fromIndex.row : fromIndex;
	          var keys = args.dataFields;
	          var startIndex = !preDataField || i != fromIndex2 || keys.indexOf(preDataField) == -1 ? 0 : keys.indexOf(preDataField);
	          if (i != fromIndex2) {
	            preDataField = null;
	          }
	          for (var k = startIndex; k < keys.length; k++)
	          //for(let key in record)
	          {
	            var key = keys[k];
	            if (key == preDataField) continue;
	            dataValue = record[key] + "";
	            dataValue = this.getEnumLabelByDataField(key, dataValue);
	            if (dataValue.indexOf(value) != -1) {
	              _FocusActions2.default.scrollToAndFocus({ groupAlias: this.groupAlias, toIndex: i, fromIndex: fromIndex2, dataField: key });
	              return { row: i, dataField: key };
	            }
	          }
	        }
	      }
	      return -1;
	    }
	  }, {
	    key: 'getEnumLabelByDataField',
	    value: function getEnumLabelByDataField(dataField, dataValue) {
	      var formItemControl = _FormItemUtil2.default.getFormItemControlByDataField(dataField);
	      if (formItemControl && formItemControl.classAlias == "FormItemEnumEditorControl") {
	        var _properties = _GOTPropertiesUtil2.default.getItemPropertyFinalValue(window.menuItemId, formItemControl.formId, formItemControl.innerId);
	        var _dataProvider = _properties.DataProvider;
	        if (_dataProvider) {
	          for (var i = 0; i < _dataProvider.length; i++) {
	            var enumItem = _dataProvider[i];
	            if (enumItem.value + "" == dataValue + "") {
	              dataValue = enumItem.label;
	            }
	          }
	        }
	      }
	      return dataValue;
	    }
	  }, {
	    key: 'getDataInfoForPrint',
	    value: function getDataInfoForPrint() {
	      var result = this.getRecTotalDataProvider();
	      if (!result) return null;
	      var dataMethodFields = result.dataMethodFields;
	      var dataProvider = result.dataProvider;
	      var printInfo = { billhead: { metadata: [], headdata: {} }, billbody: { metadata: [], bodydata: [] }, dataForLuckySheet: [] };
	      if (dataMethodFields.length > 0) {
	        var fdataProvider = new ArrayList();
	        for (var _item in dataProvider) {
	          fdataProvider.addItem(dataProvider[_item]);
	        }
	        for (_item in dataMethodFields) {
	          fdataProvider.addItem(dataMethodFields[_item]);
	        }
	      } else {
	        fdataProvider = dataProvider;
	      }
	
	      for (var item in fdataProvider) {
	        printInfo.billhead.metadata.push({ name: fdataProvider[item].enLabel, type: fdataProvider[item].fieldType });
	        printInfo.billhead.headdata[fdataProvider[item].enLabel] = fdataProvider[item].fvalue;
	      }
	      var b = {};
	      for (var item in fdataProvider) {
	        var a = fdataProvider[item].dataSourceEnLabel;
	        b[a] = "";
	      }
	      for (var key in b) {
	        var h = [];
	        var c = {};
	        for (var item in fdataProvider) {
	          var a = fdataProvider[item].dataSourceEnLabel;
	          if (a == key) {
	            c[fdataProvider[item].enLabel] = fdataProvider[item].fvalue;
	          }
	        }
	        h.push(c);
	        var g = {};
	        g[this.tableName] = { "records": h };
	        printInfo.dataForLuckySheet.push(g);
	      }
	
	      var formDataSources = this.formDataSources;
	      for (var key in formDataSources.groups) {
	        var group = formDataSources.groups[key];
	        if (group.linkType == 'Delayed' && group.linkGroup == this) {
	          var bodyGroup = group;
	          break;
	        }
	      }
	
	      if (bodyGroup) {
	        bodyGroup.getBillBodyInfoForPrint(printInfo.billbody, printInfo.dataForLuckySheet);
	      }
	      return printInfo;
	    }
	  }, {
	    key: 'getBillBodyInfoForPrint',
	    value: function getBillBodyInfoForPrint(billbody, dataForLuckySheet) {
	      var result = this.getRecTotalDataProvider();
	      if (!result) return;
	      var dataMethodFields = result.dataMethodFields;
	      var dataProvider = result.dataProvider;
	
	      if (dataMethodFields.length > 0) {
	        var fdataProvider = new ArrayList();
	        for (var _item in dataProvider) {
	          fdataProvider.addItem(dataProvider[_item]);
	        }
	        for (_item in dataMethodFields) {
	          fdataProvider.addItem(dataMethodFields[_item]);
	        }
	      } else {
	        fdataProvider = dataProvider;
	      }
	
	      for (var item in fdataProvider) {
	        billbody.metadata.push({ name: fdataProvider[item].enLabel, type: fdataProvider[item].fieldType });
	      }
	
	      for (var record in this.records) {
	        var bodydataItem = {};
	        for (item in fdataProvider) {
	          var dataField = fdataProvider[item].dataField;
	          // bodydataItem[fdataProvider[item].enLabel] = this.getComplexRecordFinalValue(this.records[record], dataField).bind(this);
	          bodydataItem[fdataProvider[item].enLabel] = this.records[record][dataField];
	        }
	
	        billbody.bodydata.push(bodydataItem);
	      }
	
	      var c = {};
	      for (var record in this.records) {
	        var bodydataItem = {};
	        for (item in fdataProvider) {
	          c[fdataProvider[item].dataSourceEnLabel] = "";
	        }
	      }
	
	      for (var key in c) {
	        var d = [];
	        this.records.forEach(function (item) {
	          var e = {};
	          for (var key in item) {
	            if (key.indexOf(".") != -1) var ke = key.substring(key.indexOf(".") + 1);
	            var ekey = ke.slice(0, 1).toUpperCase() + ke.slice(1);
	            e[ekey] = item[key];
	          }
	          d.push(e);
	        });
	        // for (var record in this.records) {
	        //   var bodydataItem = {};
	
	        //   for (item in fdataProvider) {
	        //     if(fdataProvider[item].dataSourceEnLabel == key){
	        //       e[fdataProvider[item].enLabel] = fdataProvider[item].fvalue;
	        //     }
	        //   }
	        //   d.push(e);
	        // }
	        var h = {};
	        h[this.tableName] = { "records": d };
	        dataForLuckySheet.push(h);
	      }
	    }
	  }, {
	    key: 'dataSetExportBtn',
	    value: function dataSetExportBtn() {
	      if (window.parent.window.dataSet) {
	        // window.parent.window.dataSet.dataRow = this.records;
	        // var table = GOT.getTable(window.parent.window.dataSet.queryTable.tableId);
	        // var name =table.Properties.Label.V;
	        // var location = "root/desk";
	
	        var dataSet = _DataSetUtil2.default.strDataSet(window.parent.window.dataSet, this.records);
	        var suffix = ".ds";
	        var content = {
	          'title': "",
	          'content': dataSet
	        };
	        window.parent.window.parent.window.saveFile(suffix, content);
	      }
	    }
	  }, {
	    key: 'dataSetRecrods',
	    value: function dataSetRecrods() {
	      if (window.parent.dataSetPreview) {
	        window.parent.dataSetPreview.dataRows = this.records;
	      }
	    }
	  }, {
	    key: 'doPivotExport',
	    value: function doPivotExport(filter) {
	      var isPivot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (!this.getAuthorityFinal("test", _FormDataSourceAuthorityType2.default.Export, this.currentRecord)) return;
	      /*if(!this.getAuthorityByXML(FormDataSourceAuthorityType.exportStr))
	        return;*/
	      var _showTableName = true;
	      var columns = null;
	      var key;
	      if (window.formId.indexOf(".") == -1 && window.menuItemId.indexOf(".") == -1) {
	        key = window.formId + "_" + this.mainSource.xml.id + (window.menuItemId ? "." + window.menuItemId : "");
	      } else {
	        key = window.formId + "_" + this.mainSource.xml.id + (window.menuItemId ? "&" + window.menuItemId : "");
	      }
	      if (flag == 'drop') {
	        window.parent.window.toolbarExportDrop(key);
	        return;
	      }
	
	      var _title = null;
	      if (!isPivot) {
	        //var setting = FormDataSources.userExportList;//((window.parent && window.parent.window)?window.parent.window.userExportList:{});
	
	        var settingXML = _FormDataSources2.default.getUserDefaultExportList(key);
	        if (settingXML) {
	          var settingdoc = new DOMParser().parseFromString(settingXML, "application/xml");
	          var settingdocNode0 = settingdoc.childNodes[0];
	          _showTableName = settingdocNode0.attributes.showTableName.nodeValue == "true" ? true : false;
	          _title = this.getExportSettingTitle(settingdoc, key);
	          //columns = this.consOnedimensionalGridColBySetting(FormDataSources.userExportList[key]);
	          columns = this.consOnedimensionalGridColBySetting(settingdocNode0);
	        } else {
	          columns = this.consOnedimensionalGridColByView(null, filter, isPivot);
	        }
	      } else {
	        columns = this.consOnedimensionalGridColByView(null, filter, isPivot);
	        _title = "数据分析设置";
	      }
	
	      var _records = this.records;
	      if (this.mainSource.isTempTable == true && this.tempRecordsFilter) {
	        _records = this.tempRecordsFilter;
	      }
	
	      var ac = this.convertToOnedimensional(_records, filter);
	
	      var extrals = this.getExtralExportFields(columns, filter);
	
	      var strac = JSON.stringify(ac);
	      var jsonac = JSON.parse(strac);
	      if (window.isDataSetView) {
	        for (var kk = 0; kk < jsonac.length; kk++) {
	          var dsItem = jsonac[kk];
	          for (var k in dsItem) {
	            //导出时 如果是Enum 类型 取值存在 问题  如果是Date 日期类型 先转为String
	            for (var j in columns) {
	              var sht = k.substring(k.lastIndexOf(".") + 1, k.length);
	              var shtc = columns[j].dataField.substring(columns[j].dataField.lastIndexOf(".") + 1, columns[j].dataField.length);
	              if (columns[j].fieldType == "Enum" && sht == shtc) {
	                for (var ii in this.dataSetQueryTable.allQueryFields) {
	                  if (this.dataSetQueryTable.allQueryFields[ii].fieldAliasName && this.groupAlias + "." + this.dataSetQueryTable.allQueryFields[ii].fieldAliasName == k || this.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[ii].fieldName) == k) {
	                    var newFieldValue = "";
	                    var table = _GOT2.default.getTable(this.dataSetQueryTable.allQueryFields[ii].refEntityId);
	                    if (table) {
	                      var tableField = _GOT2.default.getTableField(table, this.dataSetQueryTable.allQueryFields[ii].refInnerId);
	                      if (tableField) {
	                        var enumId = tableField.Properties.Extends.refentityid;
	                        var enumItem = _GOT2.default.getEnum(enumId);
	                        if (enumItem) {
	                          for (var ein in enumItem.EnumItems) {
	                            var its = enumItem.EnumItems[ein];
	                            if (dsItem[k] == its.Properties.Value.V || dsItem[k] == its.Properties.Value.V + "") {
	                              newFieldValue = its.Properties.Label.V ? its.Properties.Label.V : its.Properties.Label.Value;
	                              break;
	                            }
	                          }
	                        }
	                      }
	                    }
	                    dsItem[k] = newFieldValue;
	                  }
	                }
	              }
	              if (columns[j].fieldType == "Decimal" && dsItem[k] != null && dsItem[k] != 'null') {
	                if (this.groupAlias + "." + columns[j].normalHeaderText == k) {
	                  dsItem[k] = _FormItemDecimalDisplay2.default.getDisplayText(dsItem[k], columns[j].showZero, columns[j].numOfDecimals ? columns[j].numOfDecimals : 2, columns[j].thousandSeperator, {});
	                }
	              }
	              if (columns[j].fieldType == "Decimal" && dsItem[k] != null && dsItem[k] != 'null') {
	                if (dsItem[k].indexOf(',') != -1) {
	                  dsItem[k] = dsItem[k].replace(/,/g, "");
	                }
	              }
	            }
	            for (var i in this.dataSetQueryTable.allQueryFields) {
	              if (this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.groupAlias + "." + this.dataSetQueryTable.allQueryFields[i].fieldAliasName == k || this.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName) == k) {
	                if (dsItem[k] == null || dsItem[k] == 'null') {
	                  dsItem[k] = '';
	                }
	                if (window.parent.window.dataSet) {
	                  var dcolumns = window.parent.window.dataSet.dataColumn.columns;
	                  for (var col in dcolumns) {
	                    if (col == this.dataSetQueryTable.allQueryFields[i].fieldAliasName || col == this.dataSetQueryTable.allQueryFields[i].fieldName) {
	                      if (dcolumns[col].dataType == "Date" && dcolumns[col].displayFormat) {
	                        dsItem[k] = _FormItemDateDisplay2.default.getDisplayText2(dsItem[k], dcolumns[col].displayFormat.toUpperCase());
	                      }
	                      if (dcolumns[col].dataType == "Time" && dcolumns[col].displayFormat) {
	                        dsItem[k] = _FormItemTimeDisplay2.default.getDisplayText2(dsItem[k], dcolumns[col].displayFormat.toUpperCase());
	                      }
	                      if (dcolumns[col].dataType == "Decimal" && dcolumns[col].displayFormat) {
	                        dsItem[k] = _FormItemDecimalDisplay2.default.getDisplayText2(dsItem[k], dcolumns[col].displayFormat.toUpperCase());
	                      }
	                    }
	                  }
	                }
	                dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[k];
	                var dataSource = this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.substring(0, this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf("."));
	                dsItem[dataSource + "." + this.dataSetQueryTable.allQueryFields[i].fieldAliasName] = dsItem[k];
	                if (this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf(this.groupAlias) == -1) {
	                  delete dsItem[k];
	                }
	              }
	            }
	          }
	        }
	        ac = jsonac;
	        extrals = [];
	      }
	      if (window.isDataSetView) {
	        for (var _j5 in columns) {
	          var _col2 = columns[_j5];
	          _col2.dataField = this.mainSource.alias + '.' + _col2.dataField.substring(_col2.dataField.lastIndexOf('.') + 1);
	        }
	      }
	
	      var htmlarg = { columns: columns, extrals: extrals, ac: ac, key: key, showTableName: _showTableName, isPivot: isPivot, group: this };
	      // ReactDOM.render( <ExportTable htmlarg={htmlarg} initExport={flag} />,document.getElementById('exportModal'));
	      return htmlarg;
	    }
	  }]);
	
	  return FormDataSourceGroup;
	}();
	
	exports.default = FormDataSourceGroup;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _UtilStores = __webpack_require__(80);
	
	var _DomActions = __webpack_require__(86);
	
	var _DomActions2 = _interopRequireDefault(_DomActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(316);
	
	var FormItemDesign = function (_FormItemContainer) {
		_inherits(FormItemDesign, _FormItemContainer);
	
		_createClass(FormItemDesign, [{
			key: 'getProperty_Layout',
			value: function getProperty_Layout() {
				var properties = this.props.xml.firstChild;
				var elements = properties.getElementsByTagName("Property");
				var result = void 0;
				for (var i = 0; i < elements.length; i++) {
					var name = elements[i].getElementsByTagName("Name")[0].firstChild.nodeValue;
					if (name == "Layout") {
						var value = elements[i].getElementsByTagName("Value")[0].firstChild.nodeValue;
						result = value;
						break;
					}
				}
				return result;
			}
		}]);
	
		function FormItemDesign(props) {
			_classCallCheck(this, FormItemDesign);
	
			var _this = _possibleConstructorReturn(this, (FormItemDesign.__proto__ || Object.getPrototypeOf(FormItemDesign)).call(this, props));
	
			var _parentWindow = window.parent.window;
			if (_parentWindow && _parentWindow.userSettingEntry && _parentWindow.userSettingEntry.innerToolBar) _this.unsubcribeUpdateInnerToolBarStore = _UtilStores.UpdateInnerToolBarStore.listen(_this.updateInnerToolBarStore.bind(_this));
			return _this;
		}
	
		_createClass(FormItemDesign, [{
			key: 'updateInnerToolBarStore',
			value: function updateInnerToolBarStore(obj) {
	
				obj.Export == true ? $(this.toolbarExport).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarExport).removeAttr("onclick").removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.Da == true ? $(this.toolbarDa).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarDa).removeAttr("onclick").removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				if (obj.Attachment == true) {
					$(this.toolbarAttchment).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" });$(this.attachmentNum).show();
				} else {
					$(this.toolbarAttchment).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });$(this.attachmentNum).hide();
				}
	
				obj.WorkFlowDetail == true ? $(this.toolbarWorkflow).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarWorkflow).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.QueryOpen == true ? $(this.toolbarQueryopen).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarQueryopen).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.QueryRemove == true ? $(this.toolbarQueryRemove).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarQueryRemove).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.FindOpen == true ? $(this.toolbarFind).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarFind).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.CursorPrev == true ? $(this.toolbarRecordPrev).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarRecordPrev).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.CursorNext == true ? $(this.toolbarRecordNext).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarRecordNext).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.RecordNew == true ? $(this.toolbarRecordNew).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarRecordNew).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.RecordSave == true ? $(this.toolbarSave).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarSave).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.EditModeChange == true ? $(this.toolbarSwitchEditMode).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarSwitchEditMode).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.RecordRestore == true ? $(this.toolbarRecordRestore).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarRecordRestore).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
	
				obj.RecordDelete == true ? $(this.toolbarRecordDelete).attr("en", "true").find("i").css({ color: "#505050", pointerEvents: "auto" }) : $(this.toolbarRecordDelete).removeAttr("en").find("i").css({ color: "#c2c2c2", pointerEvents: "none" });
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var layout = this.props.xml.Properties.Layout.Value;
	
				var flexDirection = layout == "horizontal" ? "row" : "column";
				var style = {
					//flex-direction:flexDirection,
					//align-items:"flex-start",
					display: "flex",
					width: "100%",
					height: "100%"
				};
				style["flexDirection"] = flexDirection;
				style["alignItems"] = "flex-start";
				//style["overflow"] = 'auto';
				/*if(this.props.isLookup)
	   {
	   	style["position"] = 'absolute';style["top"] = "34px";style["left"] = "200px";
	   }*/
				return style;
			}
		}, {
			key: 'closePopUpFormHandler',
			value: function closePopUpFormHandler() {
				window.parent.window.dataSetPreview = null;
				if (this.props.isPop) {
					_LookupActions2.default.popDropDownClose(this.props.stringEditorEntityId, this.props.stringEditorInnerId);
				} else {
					var _parentWindow = window.parent.window;
					if (_parentWindow) {
						_parentWindow.closePopUpForm(window.menuItemId, window.formId, true);
					}
				}
			}
		}, {
			key: 'getDisplayLength',
			value: function getDisplayLength() {}
		}, {
			key: 'innerToolBarExport',
			value: function innerToolBarExport() {
				window.groupExport();
			}
		}, {
			key: 'innerToolBarDataAn',
			value: function innerToolBarDataAn() {
				window.da();
			}
		}, {
			key: 'innerToolBarAttachment',
			value: function innerToolBarAttachment() {
				window.attachment();
			}
		}, {
			key: 'innerToolBarWorkFlow',
			value: function innerToolBarWorkFlow() {
				window.workFlow();
			}
		}, {
			key: 'innerToolBarQueryOpen',
			value: function innerToolBarQueryOpen() {
				window.queryOpen();
			}
		}, {
			key: 'innerToolBarQueryRemove',
			value: function innerToolBarQueryRemove() {
				window.queryRemove();
			}
		}, {
			key: 'innerToolBarFind',
			value: function innerToolBarFind() {
				window.find();
			}
		}, {
			key: 'innerToolBarRecordPre',
			value: function innerToolBarRecordPre() {
				window.recordPrev();
			}
		}, {
			key: 'innerToolBarRecordNext',
			value: function innerToolBarRecordNext() {
				window.recordNext();
			}
		}, {
			key: 'innerToolBarRecordNew',
			value: function innerToolBarRecordNew() {
				window.recordNew();
			}
		}, {
			key: 'innerToolBarRecordSave',
			value: function innerToolBarRecordSave() {
				window.recordSave();
			}
		}, {
			key: 'innerToolBarEditMode',
			value: function innerToolBarEditMode() {
				window.switchEditMode();
			}
		}, {
			key: 'innerToolBarRecordRestore',
			value: function innerToolBarRecordRestore() {
				window.recordRestore();
			}
		}, {
			key: 'innerToolBarDelete',
			value: function innerToolBarDelete() {
				window.recordDelete();
			}
		}, {
			key: 'innerToolBarGlobaluserSet',
			value: function innerToolBarGlobaluserSet() {
				var _parentWindow = window.parent.window;
				if (_parentWindow) _parentWindow.globalUserSetOpen();
			}
		}, {
			key: 'innerToolBarReInitForm',
			value: function innerToolBarReInitForm() {
				var _parentWindow = window.parent.window;
				if (_parentWindow) _parentWindow.reInitForm();
			}
		}, {
			key: 'innerToolBarReInitGlobal',
			value: function innerToolBarReInitGlobal() {
				var _parentWindow = window.parent.window;
				if (_parentWindow) _parentWindow.reInitGlobal();
			}
		}, {
			key: 'innerToolBarImportManager',
			value: function innerToolBarImportManager() {
				var _parentWindow = window.parent.window;
				if (_parentWindow) _parentWindow.importManager();
			}
		}, {
			key: 'innerToolBarJobsOpen',
			value: function innerToolBarJobsOpen() {
				var _parentWindow = window.parent.window;
				if (_parentWindow) _parentWindow.jobsOpen();
			}
		}, {
			key: 'showOnLineUser',
			value: function showOnLineUser() {
				var _parentWindow = window.parent.window;
				if (_parentWindow) _parentWindow.showOnLineUser();
			}
			//style={{display:'none',position:'absolute',right:0,left:'auto',width:'200px',padding:'0 0 0 0',margin:0,top:'100%',borderTopLeftRadius:0,borderTopRightRadius:0,boxShadow:'none',borderColor:'#eee'}}
	
		}, {
			key: 'getToolBarInner',
			value: function getToolBarInner() {
				var _this2 = this;
	
				var _parentWindow = window.parent.window;
				if (_parentWindow.userSettingEntry && !_parentWindow.userSettingEntry.innerToolBar) return null;
				var isAdmin = void 0;
				if (_parentWindow.userInfos.isAdmin == true) isAdmin = true;else isAdmin = false;
				var expandNodeDisplay = isAdmin ? 'block' : 'none';
				return _react2.default.createElement(
					'ul',
					{ style: { display: 'flex', flexDirection: 'row', alignItems: 'flex-end', margin: '0px', padding: '0px' }, className: 'innerToolBar' },
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u5BFC\u51FA(Ctrl+O)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarExport.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer" }, ref: function ref(node) {
									return _this2.toolbarExport = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "45px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderRadius: "2px", paddingTop: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-share-square-o', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u6570\u636E\u5206\u6790(Ctrl+I)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarDataAn.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer" }, ref: function ref(node) {
									return _this2.toolbarDa = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "45px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-bar-chart', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u9644\u4EF6' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarAttachment.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer" }, ref: function ref(node) {
									return _this2.toolbarAttchment = node;
								} },
							_react2.default.createElement(
								'span',
								{ id: 'attachmentNum', ref: function ref(node) {
										return _this2.attachmentNum = node;
									}, className: 'label label-danger', style: { display: "none", position: 'absolute', top: '-2px', right: '7px', textAlign: 'center', fontSize: '9px', padding: '2px 3px', lineHeight: '.9' } },
								'0'
							),
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-paperclip', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ 'class': 'dropdown messages-menu', title: '\u5DE5\u4F5C\u6D41', style: { display: "none" } },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarWorkFlow.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer" }, ref: function ref(node) {
									return _this2.toolbarWorkflow = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "45px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-random', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u6253\u5F00\u7B5B\u9009(Ctrl+Q)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarQueryOpen.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingRight: "0px !important" }, ref: function ref(node) {
									return _this2.toolbarQueryopen = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderTopLeftRadius: "2px", borderBottomLeftRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-filter', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u79FB\u9664\u7B5B\u9009(Ctrl+E)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarQueryRemove.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingLeft: "0px !important" }, ref: function ref(node) {
									return _this2.toolbarQueryRemove = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderTopRightRadius: "2px", borderBottomRightRadius: "2px", borderLeft: "0.5px solid rgb(201, 200, 201)" } },
								_react2.default.createElement('i', { className: 'fa fa-filter fa-flip-horizontal', style: { color: "#474747" } }),
								_react2.default.createElement('i', { className: 'fa fa-minus', 'aria-hidden': 'true', style: { color: "#474747", position: "absolute", top: "12px", right: "10px", textAlign: "center", fontSize: "9px", padding: "2px 3px", lineHeight: ".9" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u67E5\u627E(Ctrl+F)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarFind.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer" }, ref: function ref(node) {
									return _this2.toolbarFind = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "45px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-search', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u4E0A\u4E00\u6761' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarRecordPre.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingRight: "0px !important" }, ref: function ref(node) {
									return _this2.toolbarRecordPrev = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderTopLeftRadius: "2px", borderBottomLeftRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-play fa-flip-horizontal', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u4E0B\u4E00\u6761' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarRecordNext.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingLeft: "0px !important" }, ref: function ref(node) {
									return _this2.toolbarRecordNext = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderTopRightRadius: "2px", borderBottomRightRadius: "2px", borderLeft: "0.5px solid rgb(201, 200, 201)" } },
								_react2.default.createElement('i', { className: 'fa fa-play', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u65B0\u589E(Ctrl+~)' },
						_react2.default.createElement(
							'a',
							{ className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', onClick: this.innerToolBarRecordNew.bind(this), style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingRight: "0px !important" }, ref: function ref(node) {
									return _this2.toolbarRecordNew = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderTopLeftRadius: "2px", borderBottomLeftRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-plus-square', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u4FDD\u5B58(Ctrl+S)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarRecordSave.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingLeft: "0px !important" }, ref: function ref(node) {
									return _this2.toolbarSave = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderLeft: "0.5px solid rgb(201, 200, 201)" } },
								_react2.default.createElement('i', { className: 'fa fa-save', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u5207\u6362\u7F16\u8F91\u6A21\u5F0F' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarEditMode.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', ref: function ref(node) {
									return _this2.toolbarSwitchEditMode = node;
								}, style: { userSelect: "none", cursor: "pointer" } },
							_react2.default.createElement(
								'button',
								{ style: { width: "45px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-pencil-square-o', style: { color: "#474747" } }),
								_react2.default.createElement('i', { className: 'fa fa-ban text-danger', style: { position: "absolute", top: "11px", right: "14px", textAlign: "center", fontSize: "9px", padding: "2px 3px", lineHeight: ".9" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u6062\u590D(Ctrl+R)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarRecordRestore.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingLeft: "0px" }, ref: function ref(node) {
									return _this2.toolbarRecordRestore = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)", borderTopRightRadius: "2px", borderBottomRightRadius: "2px" } },
								_react2.default.createElement('i', { className: 'fa fa-reply-all', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'li',
						{ className: 'dropdown messages-menu', title: '\u5220\u9664(Ctrl+Delete)' },
						_react2.default.createElement(
							'a',
							{ onClick: this.innerToolBarDelete.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { color: "#c2c2c2", userSelect: "none", cursor: "pointer", paddingLeft: "0px", paddingRight: "0px" }, ref: function ref(node) {
									return _this2.toolbarRecordDelete = node;
								} },
							_react2.default.createElement(
								'button',
								{ style: { width: "30px", height: "24px", backgroundImage: "linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)", border: "0.5px solid #C9C8C9", boxShadow: "0 1px 5px 0 rgba(0,0,0,0.08)" } },
								_react2.default.createElement('i', { className: 'fa fa-trash', style: { color: "#474747" } })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'navbar-custom-menu', style: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', flexGrow: 1 } },
						_react2.default.createElement(
							'ul',
							{ className: 'nav navbar-nav' },
							_react2.default.createElement(
								'li',
								{ className: 'dropdown messages-menu', title: '\u8BBE\u7F6E' },
								_react2.default.createElement(
									'a',
									{ href: '#', onClick: this.innerToolBarGlobaluserSet.bind(this), className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { padding: '4px', paddingRight: '10px', color: '#f6f6f6' } },
									_react2.default.createElement('i', { className: 'fa fa-cog', style: { color: "#505050", fontSize: "17px" } })
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'dropdown notifications-menu', style: { display: expandNodeDisplay }, ref: function ref(node) {
										return _this2.expandNode = node;
									} },
								_react2.default.createElement(
									'a',
									{ href: '#', className: 'dropdown-toggle toolbarA', 'data-toggle': 'dropdown', style: { padding: '15px', color: '#f6f6f6', backgrondColor: 'unset !important' } },
									_react2.default.createElement('i', { className: 'fa fa-cubes' })
								),
								_react2.default.createElement(
									'ul',
									{ className: 'dropdown-menu' },
									_react2.default.createElement(
										'li',
										{ className: 'header' },
										'\u53EF\u7528\u6269\u5C55\u9879'
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'ul',
											{ className: 'menu' },
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'a',
													{ href: '#', onClick: this.innerToolBarReInitForm.bind(this) },
													_react2.default.createElement('i', { className: 'fa fa-users text-aqua' }),
													'\u521D\u59CB\u5316\u753B\u9762'
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'a',
													{ href: '#', onClick: this.innerToolBarReInitGlobal.bind(this) },
													_react2.default.createElement('i', { className: 'fa fa-warning text-yellow' }),
													'\u521D\u59CB\u5316\u5168\u5C40'
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'a',
													{ href: '#', onClick: this.innerToolBarImportManager.bind(this) },
													_react2.default.createElement('i', { className: 'fa fa-shopping-cart text-green' }),
													'\u5BFC\u5165\u63A7\u5236\u53F0'
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'a',
													{ href: '#', onClick: this.innerToolBarJobsOpen.bind(this) },
													_react2.default.createElement('i', { className: 'fa fa-paper-plane text-red' }),
													'\u8FDC\u7A0B\u8C03\u7528'
												)
											),
											_react2.default.createElement(
												'li',
												null,
												'//TODO \u53BB\u6389 \u6539\u6210\u5728menu\u91CC\u9762'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'lookupOnKeyDown',
			value: function lookupOnKeyDown(e) {
				if (e.keyCode == 27 || e.ctrlKey && e.keyCode == 38) {
					_LookupActions2.default.popDropDownClose(this.entityId, this.innerId);
				}
			}
	
			/*componentWillUnmount()
	  {
	  	if(this.props.forLookup)
	  	{
	  		$(this.containerComponent).off("onkeydown");
	  	}
	  }*/
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				/*if(this.props.forLookup)
	   {
	   	$(this.containerComponent).on("onkeydown",this.lookupOnKeyDown.bind(this));
	   }*/
	
				if (window.isPopUp && !this.props.forLookup || this.props.isPop && this.props.forLookup) {
	
					var width = this.props.control.getProperty_Width();
					if (width) {
						if ((width + "").indexOf("%") != -1) {
							$(this.outterDiv).css("width", width);
						} else {
							$(this.outterDiv).css("width", width + 'px');
						}
					} else {
						var _parentDocument = window.parent.document;
						var maxWidth = $(".content-wrapper", _parentDocument).outerWidth(true);
						maxWidth -= 100;
						var nowWidth = $(this.outterDiv).outerWidth();
						if (nowWidth > maxWidth) {
							$(this.outterDiv).css("overflow", "hidden").width(maxWidth);
							$(this.containerComponent).css("overflow", "auto");
							$(".datagridcontainer").css("max-width", "100%");
						} else {
							$(this.outterDiv).css("width", nowWidth + 2 + 'px');
						}
					}
	
					var height = this.props.control.getProperty_Height();
					if (height) {
						if ((height + "").indexOf("%") != -1) {
							$(this.outterDiv).css("height", height);
						} else {
							$(this.outterDiv).css("height", height + 'px');
						}
					} else {
						var _parentDocument2 = window.parent.document;
						var maxHeight = $(".content-wrapper", _parentDocument2).outerHeight(true);
	
						maxHeight -= 10;
						var nowHeight = $(this.outterDiv).outerHeight();
						if (nowHeight > maxHeight) {
	
							$(this.outterDiv).css("overflow", "hidden").height(maxHeight);
							var headerHeight = $(this.modalHeader).outerHeight(true);
							$(this.containerComponent).css("overflow", "auto").height(maxHeight - headerHeight - 5);
							$(".datagridcontainer").css("max-height", "100%");
						} else {
							$(this.outterDiv).css("height", nowHeight + 4 + 'px');
						}
					}
	
					$(this.outterDiv).draggable({
						handle: ".modal-header" // 只能点击头部拖动
					});
	
					_DomActions2.default.popUpDomReady();
				}
			}
		}, {
			key: 'getQueryString',
			value: function getQueryString(name, url) {
				var arr = url.split("?");
				if (arr != null && arr.length > 1) {
					var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
					var r = arr[1].match(reg);
					if (r != null) {
						return unescape(r[2]);
					}
				}
				return null;
			}
		}, {
			key: 'getIsUniversalViewRep',
			value: function getIsUniversalViewRep() {
				if (this.getQueryString("isPreview", window.location.search)) {
					return true;
				}
				return false;
			}
		}, {
			key: 'universalViewReportBtn',
			value: function universalViewReportBtn() {
				window.parent.window.toobarFunc(null, "groupExport", "");
			}
		}, {
			key: 'universalViewPivotBtn',
			value: function universalViewPivotBtn() {
				window.parent.window.toobarFunc(null, "da", "");
			}
		}, {
			key: 'universalViewDSExpBtn',
			value: function universalViewDSExpBtn() {
				window.dataSetViewDSExp();
			}
		}, {
			key: 'universalViewRSelectBtn',
			value: function universalViewRSelectBtn() {
				window.dataSetViewRSelect();
			}
		}, {
			key: 'universalViewPrintAppBtnOk',
			value: function universalViewPrintAppBtnOk() {
				window.universalViewPrintAppBtnOk();
				this.closePopUpFormHandler();
			}
	
			//<i className="fa fa-close" style={{position:"absolute",top:"8px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closePopUpFormHandler.bind(this)}></i>
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				//this.props.formItem.getDisplayLength();
				var parent = this.props.xml;
				var children = parent.FormItem;
				var layout = parent.Properties.Layout.Value;
				var that = this;
				var splitterStyle = { alignSelf: 'stretch', backgroundColor: '#ccc !important', opacity: 0, border: 'none !important', flexShrink: '0' };
				if (layout == "vertical") splitterStyle.height = "4px";else splitterStyle.width = "4px";
				var list = [];
				for (var i = 0; i < children.length; i++) {
					var item = children[i];
					list.push(_FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup));
					//if(i<children.length-1)
					//	list.push(<div className={"GongqiFormFirstSplitter"} style={splitterStyle}></div>);
				}
				/*let list = children.map(function(item){
	   	return 
	   		 });*/
				/*<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closePopUpFormHandler.bind(this)}>
	           <span aria-hidden="true" style={{fontSize:"20px"}}>×</span>
	   </button>*/
				var innerToolBar = this.getToolBarInner();
				var _style = Object.assign({}, this.props.customStyle);
				/*_style.border = "solid 4px #fff";
	   _style.backgroundColor = "white";
	   _style.borderRadius = "2px";#EDF1F4*/
	
				var _className = layout == "vertical" ? "gongqiFormVertical" : "gongqiFormHorizontal";
				_className += " GongqiFormDesign";
				if (!this.props.forLookup) {
					_style.backgroundColor = '#EEEFF1';_style.borderRadius = '2px'; //_style.padding = "5px";
				}
	
				var propFormName = this.props.formName;
				var formNameChanged = propFormName ? propFormName.replace(/\./g, "_") : "";
				if (window.isPopUp && !this.props.forLookup || this.props.isPop && this.props.forLookup) {
					var outterStyle = { alignSelf: "center", border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: "2px", backgroundColor: 'white' };
					var height = this.props.control.getProperty_Height();
					if (height) {
						if ((height + "").indexOf("%") != -1) {
							outterStyle.height = height;
						} else {
							outterStyle.height = height + "px";
						}
					}
					var _dataSetViewBtnsStyle = { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' };
					if (window.parent.window.formOSdsScrip) {
						_dataSetViewBtnsStyle.display = 'none';
					}
					//TODO 暂时去掉 存在内容超出弹出框问题
					// _style.height=_style.height?_style.height:'100%';
					if (this.getIsUniversalViewRep()) {
						var reprot_vis = this.getIsUniversalViewRep() ? 'block' : 'none';
						outterStyle.left = '3%';
						if (window.parent.window.formOSopenDataSetView) {
	
							return _react2.default.createElement(
								'div',
								{ ref: function ref(node) {
										return _this3.outterDiv = node;
									}, id: formNameChanged, style: outterStyle },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header', ref: function ref(node) {
											return _this3.modalHeader = node;
										}, style: { position: "relative" } },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.closePopUpFormHandler.bind(this) }),
									_react2.default.createElement(
										'h5',
										{ className: 'modal-title' },
										this.props.formLabel
									)
								),
								innerToolBar,
								_react2.default.createElement(
									'div',
									{ className: _className, ref: function ref(node) {
											return _this3.containerComponent = node;
										}, style: _style },
									list
								),
								_react2.default.createElement(
									'div',
									{ style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }, id: 'osDataViewBtns' },
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-cancel', style: { height: '28px', margin: '3px 10px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', color: 'rgb(49, 49, 49)' }, id: 'universalViewRemoveSelect', onClick: this.universalViewRSelectBtn.bind(this), ref: function ref(node) {
												return _this3.universalView_RSelect = node;
											} },
										'\u79FB\u9664\u7B5B\u9009'
									)
								)
							);
						} else if (window.parent.window.dataSetPreviewForPrintApp) {
							outterStyle.top = '6%';
							return _react2.default.createElement(
								'div',
								{ ref: function ref(node) {
										return _this3.outterDiv = node;
									}, id: formNameChanged, style: outterStyle },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header', ref: function ref(node) {
											return _this3.modalHeader = node;
										}, style: { position: "relative" } },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.closePopUpFormHandler.bind(this) }),
									_react2.default.createElement(
										'h5',
										{ className: 'modal-title' },
										this.props.formLabel
									)
								),
								innerToolBar,
								_react2.default.createElement(
									'div',
									{ className: _className, ref: function ref(node) {
											return _this3.containerComponent = node;
										}, style: _style },
									list
								),
								_react2.default.createElement(
									'div',
									{ style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }, id: 'osDataViewBtns' },
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-cancel', style: { height: '28px', margin: '3px 10px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', color: 'rgb(49, 49, 49)' }, id: 'universalViewRemoveSelect', onClick: this.universalViewRSelectBtn.bind(this), ref: function ref(node) {
												return _this3.universalView_RSelect = node;
											} },
										'\u79FB\u9664\u7B5B\u9009'
									),
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-require', style: { height: '28px', margin: '3px 10px', width: '120px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', color: 'white' }, id: 'universalViewPrintAppBtn', onClick: this.universalViewPrintAppBtnOk.bind(this), ref: function ref(node) {
												return _this3.universalView_PrintApp = node;
											} },
										'\u786E\u5B9A'
									)
								)
							);
						} else {
	
							return _react2.default.createElement(
								'div',
								{ ref: function ref(node) {
										return _this3.outterDiv = node;
									}, id: formNameChanged, style: outterStyle },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header', ref: function ref(node) {
											return _this3.modalHeader = node;
										}, style: { position: "relative" } },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.closePopUpFormHandler.bind(this) }),
									_react2.default.createElement(
										'h5',
										{ className: 'modal-title' },
										this.props.formLabel
									)
								),
								innerToolBar,
								_react2.default.createElement(
									'div',
									{ className: _className, ref: function ref(node) {
											return _this3.containerComponent = node;
										}, style: _style },
									list
								),
								_react2.default.createElement(
									'div',
									{ style: _dataSetViewBtnsStyle },
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-cancel', style: { height: '28px', margin: '3px 10px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', color: 'rgb(49, 49, 49)' }, id: 'universalViewRemoveSelect', onClick: this.universalViewRSelectBtn.bind(this), ref: function ref(node) {
												return _this3.universalView_RSelect = node;
											} },
										'\u79FB\u9664\u7B5B\u9009'
									),
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-cancel', style: { height: '28px', margin: '3px 10px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', color: 'rgb(49, 49, 49)' }, id: 'universalViewPivot', onClick: this.universalViewPivotBtn.bind(this), ref: function ref(node) {
												return _this3.universalView_Pivot = node;
											} },
										'\u6570\u636E\u5206\u6790'
									),
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-cancel', style: { height: '28px', margin: '3px 10px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', color: 'rgb(49, 49, 49)' }, id: 'universalViewReport', onClick: this.universalViewReportBtn.bind(this), ref: function ref(node) {
												return _this3.universalView_Report = node;
											} },
										'\u5BFC\u51FA'
									),
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-info ufs-require', style: { height: '28px', margin: '3px 10px', width: '120px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', color: 'white' }, id: 'universalViewDSExp', onClick: this.universalViewDSExpBtn.bind(this), ref: function ref(node) {
												return _this3.universalView_DSExp = node;
											} },
										'\u751F\u6210DS\u6587\u4EF6'
									)
								)
							);
						}
					} else return _react2.default.createElement(
						'div',
						{ ref: function ref(node) {
								return _this3.outterDiv = node;
							}, id: formNameChanged, style: outterStyle },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header', ref: function ref(node) {
									return _this3.modalHeader = node;
								}, style: { position: "relative" } },
							_react2.default.createElement('div', { className: 'modal-close', onClick: this.closePopUpFormHandler.bind(this) }),
							_react2.default.createElement(
								'h5',
								{ className: 'modal-title' },
								this.props.formLabel
							)
						),
						innerToolBar,
						_react2.default.createElement(
							'div',
							{ className: _className, ref: function ref(node) {
									return _this3.containerComponent = node;
								}, style: _style },
							list
						)
					);
				} else {
					if (innerToolBar) {
						return _react2.default.createElement(
							'div',
							{ id: formNameChanged, style: { display: 'flex', flexDirection: 'column', width: '100%', height: '100%' } },
							innerToolBar,
							_react2.default.createElement(
								'div',
								{ className: _className, ref: function ref(node) {
										return _this3.containerComponent = node;
									}, style: _style },
								list
							)
						);
					} else {
						return _react2.default.createElement(
							'div',
							{ className: _className, id: formNameChanged, ref: function ref(node) {
									return _this3.containerComponent = node;
								}, style: _style },
							list
						);
					}
				}
			}
		}]);
	
		return FormItemDesign;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemDesign.defaultProps = {};
	
	exports.default = FormItemDesign;

/***/ },
/* 171 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryOrderByItem = //String
	//String
	//String
	//String
	
	//String			//QueryOrderByType
	function QueryOrderByItem() {
		_classCallCheck(this, QueryOrderByItem);
	
		this.remoteClass = "gongqi.erp.gotmodel.sqlquery.QueryOrderByItem";
	};
	
	exports.default = QueryOrderByItem;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _GOTXML2Json = __webpack_require__(104);
	
	var _GOTXML2Json2 = _interopRequireDefault(_GOTXML2Json);
	
	var _UserFormUtil = __webpack_require__(158);
	
	var _UserFormUtil2 = _interopRequireDefault(_UserFormUtil);
	
	var _UserSetFormTree = __webpack_require__(281);
	
	var _UserSetFormTree2 = _interopRequireDefault(_UserSetFormTree);
	
	var _UserSetListDataGrid = __webpack_require__(282);
	
	var _UserSetListDataGrid2 = _interopRequireDefault(_UserSetListDataGrid);
	
	var _UserSetFormPropertyPanel = __webpack_require__(280);
	
	var _UserSetFormPropertyPanel2 = _interopRequireDefault(_UserSetFormPropertyPanel);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(85);
	
	var UserFormSetForm = function (_React$Component) {
		_inherits(UserFormSetForm, _React$Component);
	
		function UserFormSetForm(props, context) {
			_classCallCheck(this, UserFormSetForm);
	
			var _this = _possibleConstructorReturn(this, (UserFormSetForm.__proto__ || Object.getPrototypeOf(UserFormSetForm)).call(this, props, context));
	
			_initialiseProps.call(_this);
	
			_this.noSetLabel = "当前无默认值";
			var _parentWindow = window.parent.window;
			if (!_parentWindow.userProperties) {
				_parentWindow.userProperties = {};
			}
	
			if (!_parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
				_parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
			}
			_this.state = { columnWidthProperties: null };
			return _this;
		}
	
		_createClass(UserFormSetForm, [{
			key: 'reqUserSetForm',
			value: function reqUserSetForm() {
				var _parentWindow = window.parent.window;
				var allUserProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
				Object.assign(allUserProperties, this.propertyPanel.allUserProperties);
				if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
				_parentWindow.userSetForms[window.menuItemId + "." + window.formId] = this.formTree.userSetForm;
	
				_parentWindow.reOpenCurrentForm();
				//this.closeUserSetForm();
			}
		}, {
			key: 'resetForm',
			value: function resetForm() {
				var _parentWindow = window.parent.window;
				_parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
				if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
				_parentWindow.userSetForms[window.menuItemId + "." + window.formId] = window.formXML;
	
				_parentWindow.reOpenCurrentForm();
			}
		}, {
			key: 'resetColProperties',
			value: function resetColProperties() {
				var columnWidthProperties = {};
				_CommandActions2.default.getColumnLengthProperties(columnWidthProperties);
				this.setState({ columnWidthProperties: columnWidthProperties });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('body').mLoading("hide");
				$(this.outterDiv).draggable({
					handle: ".modal-header" // 只能点击头部拖动
				});
				$(this.userFormSetSaveDiv).draggable({
					handle: ".modal-header" // 只能点击头部拖动
				});
			}
		}, {
			key: 'hideUserFormSetSaveTable',
			value: function hideUserFormSetSaveTable() {
				$('#userFormSetSaveModal').hide();
			}
		}, {
			key: 'parseForm2UserForm',
			value: function parseForm2UserForm(root) {
				var parent = this.parseForm2UserFormItem(root);
				for (var i = 0; i < root.FormItem.length; i++) {
					var item = root.FormItem[i];
					parent.appendChild(this.parseForm2UserForm(item));
				}
				return parent;
			}
		}, {
			key: 'parseForm2UserFormItem',
			value: function parseForm2UserFormItem(item) {
				var innerId = item.id;
	
				var _parentWindow = window.parent.window;
				var properties;
	
				if (_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					properties = _userProperties[innerId];
				}
				if (!properties) properties = {};
				var allUserProperties = this.propertyPanel.allUserProperties;
				if (allUserProperties.hasOwnProperty(innerId)) {
					Object.assign(properties, allUserProperties[innerId]);
				}
	
				var node = document.createElement("node");
				node.setAttribute("id", innerId);
				for (var key in properties) {
					node.setAttribute(key, properties[key]);
				}
				return node;
			}
		}, {
			key: 'save',
			value: function save(arg) {
				//this.saveScope = arg;
				$("#userFormSetSaveModal").show();
			}
		}, {
			key: 'saveUserSetForm',
			value: function saveUserSetForm() {
				var formDesignXML = this.formTree.userSetForm.FormDesign;
				var userForm = this.parseForm2UserForm(formDesignXML);
	
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "saveUserFormDesign", "boolean");
	
				var slipper = ".";
				if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
	
				command.appendArg(window.formId + slipper + window.menuItemId);
	
				var setDefault_all = $(this.userSetDefaultBoxAll).prop("checked");
	
				if (setDefault_all) {
					/*var command = Command.createService( "gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
	    
	    command.appendArg(userId); //ClientSession.getClientSessionInstance().userId
	    command.appendArg(ugse,"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");*/
					command.appendArg('_default');
				} else {
					var _parentWindow = window.parent.window;
					command.appendArg(_parentWindow.userInfos.userId);
				}
	
				var fileName = $('#userSetFormSaveFileName').val();
				if (fileName != null && fileName != "") command.appendArg(fileName);else command.appendArg("test");
	
				command.appendArg(new XMLSerializer().serializeToString(userForm));
				var setDefault = $("#userSetDefaultBox").prop("checked");
				command.appendArg(setDefault, "boolean");
				_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_saveUserSetHandler.bind(this, setDefault) });
			}
		}, {
			key: 'rpc_saveUserSetHandler',
			value: function rpc_saveUserSetHandler(_default, data) {
				if (data.result == true) {
					this.hideUserFormSetSaveTable();
					var options = {
						state: 'success'
					};
					_Fade2.default.show(options);
					// Warn.show({text:"保存成功"});
				} else {
					this.hideUserFormSetSaveTable();
					var options = {
						state: 'error'
					};
					_Fade2.default.show(options);
				}
				if (_default) {
					var _parentWindow = window.parent.window;
					var allUserProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					Object.assign(allUserProperties, this.propertyPanel.allUserProperties);
					if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
					_parentWindow.userSetForms[window.menuItemId + "." + window.formId] = this.formTree.userSetForm;
				}
			}
		}, {
			key: 'btnLoadDefault_clickHandler',
			value: function btnLoadDefault_clickHandler(event) {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserDefaultFormDesign", "String");
				var slipper = ".";
				if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
				command.appendArg(window.formId + slipper + window.menuItemId);
				var _parentWindow = window.parent.window;
				command.appendArg(_parentWindow.userInfos.userId);
	
				_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_loadDefaultSetHandler.bind(this) });
			}
		}, {
			key: 'rpc_loadDefaultSetHandler',
			value: function rpc_loadDefaultSetHandler(data) {
				var xmls = data.result;
				if (xmls) {
	
					var getxml = new DOMParser();
					var xmlDoc = getxml.parseFromString(xmls, "text/xml");
					var origFormXMLDoc = window.origFormXMLDoc.cloneNode(true);
					var mergedXML = _UserFormUtil2.default.mergeXML(xmlDoc.documentElement, origFormXMLDoc, null);
					var _parentWindow = window.parent.window;
					if (!_parentWindow.userProperties) _parentWindow.userProperties = {};
					_parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
					var _userFormXML = _GOTUtil2.default.parseUserForm2Form(origFormXMLDoc, mergedXML);
					var formDesign = origFormXMLDoc.children[2];
					origFormXMLDoc.removeChild(formDesign);
					origFormXMLDoc.appendChild(_userFormXML);
					var _userSetForm = _GOTXML2Json2.default.parseForm(origFormXMLDoc);
	
					if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
					_parentWindow.userSetForms[window.menuItemId + "." + window.formId] = _userSetForm;
					_parentWindow.reOpenCurrentForm();
				} else {
					_Warn2.default.show({ text: "加载失败" });
				}
			}
		}, {
			key: 'showUserSetForm',
			value: function showUserSetForm() {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "getUserFormDesignsWithDefault", "List");
				var slipper = ".";
				if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
				command.appendArg(window.formId + slipper + window.menuItemId);
				var _parentWindow = window.parent.window;
				command.appendArg(_parentWindow.userInfos.userId);
				var remoteArg = { command: command, resultFunction: this.rpc_getListHandler.bind(this), sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		}, {
			key: 'rpc_getListHandler',
			value: function rpc_getListHandler(data) {
				var result = data.result;
				var listRows = [];
	
				for (var i = 1; i < result.length; i++) {
					var listRow = {};
					var item = result[i];
					var itemArr = item.split(" ");
					listRow['userName'] = itemArr[0];
					listRow['fileName'] = itemArr[1];
					listRows.push(listRow);
				}
				this.userSetList.setState({ rows: listRows });
				var defaultItem;
				if (result[0]) {
					defaultItem = result[0].split(" ")[1];
				}
	
				this.userSetTableTitle(defaultItem);
				$("#userSetTable").show();
			}
		}, {
			key: 'hideUserSetTable',
			value: function hideUserSetTable() {
				$("#userSetTable").hide();
			}
	
			//删除
	
		}, {
			key: 'rpc_deleteUserSetListHandler',
			value: function rpc_deleteUserSetListHandler(arg, data) {
				var row = arg.row;
				var delDefault = row.fileName == $("#userSetListDefaultItem").attr("name");
				if (delDefault) {
					$("#userSetListDefaultItem").text(this.noSetLabel);
					$("#cancelUserSetListDefaultItem").hide();
				}
			}
		}, {
			key: 'rpc_loadHandler',
			value: function rpc_loadHandler(data) {
				var xmls = data.result;
				if (xmls) {
	
					var getxml = new DOMParser();
					var xmlDoc = getxml.parseFromString(xmls, "text/xml");
					var origFormXMLDoc = window.origFormXMLDoc.cloneNode(true);
					var mergedXML = _UserFormUtil2.default.mergeXML(xmlDoc.documentElement, origFormXMLDoc, null);
					var _parentWindow = window.parent.window;
					if (!_parentWindow.userProperties) _parentWindow.userProperties = {};
					_parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
					var _userFormXML = _GOTUtil2.default.parseUserForm2Form(origFormXMLDoc, mergedXML);
					var formDesign = origFormXMLDoc.children[2];
					origFormXMLDoc.removeChild(formDesign);
					origFormXMLDoc.appendChild(_userFormXML);
					var _userSetForm = _GOTXML2Json2.default.parseForm(origFormXMLDoc);
	
					if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
					_parentWindow.userSetForms[window.menuItemId + "." + window.formId] = _userSetForm;
					_parentWindow.reOpenCurrentForm();
				} else {
					_Warn2.default.show({ text: "加载失败" });
				}
			}
		}, {
			key: 'fault_deleteUserSetListHandler',
			value: function fault_deleteUserSetListHandler(arg, data) {
				var row = arg.row;
				var rows = this.userSetList.state.rows.slice();
				rows.splice(arg.index, 0, row);
				this.userSetList.setState({ rows: rows });
	
				var faultString;
				if (data && data.successButNot0) {
					faultString = data.errText;
				} else {
					faultString = "可能是网络错误 请检查网络是否正常";
				}
				_Warn2.default.show({ text: faultString, title: "删除失败" });
			}
		}, {
			key: 'filterCurrentUser',
			value: function filterCurrentUser(e) {
				var _parentWindow = window.parent.window;
				var defaultUser = _parentWindow.userInfos.userId;
				this.userSetList.filterCurrentUser(defaultUser);
				$(this.btnFilterCurrentUser).hide();
				$(this.btnCancelFilterCurrentUser).show();
			}
		}, {
			key: 'cancelFilterCurrentUser',
			value: function cancelFilterCurrentUser(e) {
				this.userSetList.cancelFilterCurrentUser();
				$(this.btnFilterCurrentUser).show();
				$(this.btnCancelFilterCurrentUser).hide();
			}
		}, {
			key: 'setDefault',
			value: function setDefault(e) {
				var item = this.userSetList.getSelectedRow();
				if (item) {
					var userId = item.userName;
					var fileName = item.fileName;
	
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "setUserDefaultFormDesign", "String");
	
					var _parentWindow = window.parent.window;
					var slipper = ".";
					if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
	
					command.appendArg(window.formId + slipper + window.menuItemId);
					command.appendArg(_parentWindow.userInfos.userId);
	
					command.appendArg(userId);
					command.appendArg(fileName);
	
					_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_setDefaultSetHandler.bind(this, fileName) });
				}
			}
		}, {
			key: 'rpc_setDefaultSetHandler',
			value: function rpc_setDefaultSetHandler(defaultItem, data) {
				$("#userSetListDefaultItem").text("当前默认值" + defaultItem).attr("name", defaultItem);
				$("#cancelUserSetListDefaultItem").show();
				//alert("设置成功");
			}
		}, {
			key: 'btnUnSetDefault_clickHandler',
			value: function btnUnSetDefault_clickHandler(event) {
				if ($("#userSetListDefaultItem").text() == this.noSetLabel) return;
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "unsetUserDefaultFormDesign", "void");
				var slipper = ".";
				if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
				command.appendArg(window.formId + slipper + window.menuItemId);
				command.appendArg(window.parent.window.userInfos.userId);
	
				_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_unSetDefaultHandler.bind(this) });
			}
		}, {
			key: 'rpc_unSetDefaultHandler',
			value: function rpc_unSetDefaultHandler(event) {
				$("#userSetListDefaultItem").text(this.noSetLabel);
				//delete window.parent.window.userSetForms[window.menuItemId + "." + window.formId];
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _title = window.formModuleInstance.formLabel + " id=" + window.formModuleInstance.formId + " name=" + window.formModuleInstance.formName;
				var userInfos = window.userInfos ? window.userInfos : window.parent.window && window.parent.window.userInfos ? window.parent.window.userInfos : null;
				var isAdmin = userInfos ? userInfos.isAdmin : false;
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this2.outterDiv = node;
						}, style: { alignSelf: "center", borderRadius: "2px", backgroundColor: 'white', width: '900px', height: '520px', display: 'flex', flexDirection: 'column', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' } },
					_react2.default.createElement(
						'div',
						{ className: 'modal-header', style: { background: "#ffffff", padding: "10px", position: "relative", paddingTop: '13px', paddingBottom: '13px', backgroundColor: '#F8F8F8' } },
						_react2.default.createElement('div', { className: 'modal-close', onClick: this.closeUserSetForm.bind(this) }),
						_react2.default.createElement(
							'h5',
							{ className: 'modal-title', style: { fontFamily: 'STSongti-SC-Bold', fontSize: '16px', color: '#000000', fontWeight: '500 !IMPORTANT' } },
							'\u754C\u9762\u8C03\u6574\xA0\xA0\xA0',
							_title
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { display: 'flex', flexDirection: 'column', flexGrow: 100 } },
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', flexDirection: 'row', flexGrow: 100, boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)', borderRadius: '3px' } },
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'column', width: '300px', overflow: 'auto', maxHeight: '420px', background: '#FAFAFA', boxShadow: '1px 0 0 0 rgba(203,203,203,0.50)', paddingTop: '12px', paddingRight: '2px' } },
								_react2.default.createElement(_UserSetFormTree2.default, { ref: function ref(node) {
										return _this2.formTree = node;
									} })
							),
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'column', flexGrow: 2, marginLeft: '5px', marginRight: '5px', paddingLeft: '20px', overflow: 'auto' } },
								_react2.default.createElement(_UserSetFormPropertyPanel2.default, { ref: function ref(node) {
										return _this2.propertyPanel = node;
									}, allUserProperties: this.props.columnProperties, allColWidth: this.state.columnWidthProperties })
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', flexDirection: 'horizontal', flexGrow: 0, flex: '0 0 auto', height: '50px', alignItems: 'center', paddingRight: '22px', paddingLeft: '22px' } },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { paddingLeft: '21px !important', fontFamily: 'STSongti-SC-Bold', fontSize: '14px', textAlign: 'center', marginRight: '9px', width: '88px', height: '32px', marginTop: '-2px' }, onClick: this.save.bind(this, 'singleUser') },
								_react2.default.createElement('i', { style: { color: '##0178D4', marginTop: '4px', float: 'left', marginLeft: '7px' }, className: 'fa fa-download', 'aria-hidden': 'true' }),
								'\u4FDD\u5B58'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { paddingLeft: '21px !important', fontFamily: 'STSongti-SC-Bold', fontSize: '14px', marginRight: '9px', width: '118px', height: '32px', marginTop: '-2px' }, onClick: this.btnLoadDefault_clickHandler.bind(this) },
								_react2.default.createElement('i', { style: { color: '##0178D4', marginTop: '3px', float: 'left', marginLeft: '7px' }, className: 'fa fa-spinner', 'aria-hidden': 'true' }),
								'\u52A0\u8F7D\u9ED8\u8BA4'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { paddingLeft: '21px !important', fontFamily: 'STSongti-SC-Bold', fontSize: '14px', marginRight: '9px', width: '88px', height: '32px', marginTop: '-2px' }, onClick: this.showUserSetForm.bind(this) },
								_react2.default.createElement('i', { style: { color: '##0178D4', marginTop: '3px', float: 'left', marginLeft: '7px' }, className: 'fa fa-cog', 'aria-hidden': 'true' }),
								'\u8BBE\u7F6E'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { paddingLeft: '21px !important', fontFamily: 'STSongti-SC-Bold', fontSize: '14px', marginRight: '5px', width: '88px', height: '32px', marginTop: '-2px' }, onClick: this.resetForm.bind(this) },
								_react2.default.createElement('i', { style: { color: '##0178D4', marginTop: '3px', float: 'left', marginLeft: '7px' }, className: 'fa fa-repeat', 'aria-hidden': 'true' }),
								'\u590D\u4F4D'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { paddingLeft: '21px !important', fontFamily: 'STSongti-SC-Bold', fontSize: '14px', marginRight: '5px', width: '118px', height: '32px', marginTop: '-2px' }, onClick: this.resetColProperties.bind(this) },
								_react2.default.createElement('i', { style: { color: '##0178D4', marginTop: '3px', float: 'left', marginLeft: '7px' }, className: 'fa fa-edit', 'aria-hidden': 'true' }),
								'\u63D0\u53D6\u5217\u5BBD'
							),
							_react2.default.createElement('div', { style: { flexGrow: 100 } }),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info ufs-cancel', style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px' }, onClick: this.closeUserSetForm.bind(this) },
								'\u53D6\u6D88'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info ufs-require', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623' }, onClick: this.reqUserSetForm.bind(this) },
								'\u786E\u8BA4'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'userFormSetSaveModal', key: 'saveModal', style: { zIndex: '2000' }, ref: function ref(node) {
								return _this2.userFormSetSaveDiv = node;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog', style: { marginTop: '100px', width: '640px' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content', style: {
										background: '#FFFFFF',
										border: '1px solid #9B9B9B',
										boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
										borderRadius: '2px'
									} },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideUserFormSetSaveTable.bind(this) }),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title', style: { marginTop: '0', marginBottom: '0' } },
										'\u4FDD\u5B58'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body', style: { display: 'flex', flexDirection: 'column', padding: '40px 10px' } },
									_react2.default.createElement(
										'div',
										{ style: { flexGrow: 0, textAlign: 'center' } },
										_react2.default.createElement(
											'div',
											{ style: { display: 'flex', flexDirection: 'row', paddingLeft: '35px' } },
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'right' } },
												_react2.default.createElement(
													'label',
													{ style: { paddingTop: '8px', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', fontWeight: 'normal' } },
													'\u6587\u4EF6\u540D\uFF1A'
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'left', flexGrow: 1, marginRight: '10px' } },
												_react2.default.createElement('input', { type: 'text', spellcheck: 'false', className: 'form-control', id: 'userSetFormSaveFileName' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ style: { flexGrow: 1, textAlign: 'center', paddingLeft: '83px' } },
										_react2.default.createElement(
											'div',
											{ style: { display: 'flex', flexDirection: 'row' } },
											_react2.default.createElement(
												'div',
												{ style: { display: 'flex', alignItems: 'center', textAlign: 'left', position: 'relative' } },
												_react2.default.createElement('input', { type: 'checkbox', id: 'userSetDefaultBox', style: { width: '16px', height: '16px' } }),
												_react2.default.createElement('label', { htmlFor: 'userSetDefaultBox' })
											),
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'right', paddingLeft: '3px' } },
												_react2.default.createElement(
													'label',
													{ style: { paddingTop: '3px', fontSize: '14px', fontFamily: 'STSongti-SC-Regular', color: '#4A90E2', marginRight: '10px' } },
													'\u8BBE\u4E3A\u9ED8\u8BA4'
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { display: isAdmin ? 'flex' : 'none', alignItems: 'center', textAlign: 'left', position: 'relative' } },
												_react2.default.createElement('input', { type: 'checkbox', id: 'userSetDefaultBoxAll', ref: function ref(node) {
														return _this2.userSetDefaultBoxAll = node;
													}, style: { width: '16px', height: '16px' } }),
												_react2.default.createElement('label', { htmlFor: 'userSetDefaultBoxAll' })
											),
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'right', paddingLeft: '3px', display: isAdmin ? 'flex' : 'none' } },
												_react2.default.createElement(
													'label',
													{ style: { paddingTop: '3px', fontSize: '14px', fontFamily: 'STSongti-SC-Regular', color: '#4A90E2' } },
													'\u4E3A\u6240\u6709\u7528\u6237\u4FDD\u5B58'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-footer', style: { padding: '10px 15px' } },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' }, id: 'userFormSetSaveModal_BtnCancel', 'data-dismiss': 'modal', onClick: this.hideUserFormSetSaveTable.bind(this) },
										'\u53D6\u6D88'
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px', color: '#fff' }, onClick: this.saveUserSetForm.bind(this) },
										'\u4FDD\u5B58'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'userSetTable', style: { zIndex: '2000', display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog', style: { width: '600px', backgroundColor: '#fff' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content', style: { marginTop: '80px', background: '#FFFFFF', border: '0 solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideUserSetTable.bind(this) }),
									_react2.default.createElement(
										'h5',
										{ className: 'modal-title', style: { fontWeight: 'bolder' } },
										'\u5DF2\u4FDD\u5B58\u5217\u8868'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'box', style: { borderTop: '1px solid #d2d6de', textAlign: 'center' } },
										_react2.default.createElement(
											'div',
											{ className: 'box-header with-border', style: { textAlign: 'left', background: '#FAFAFA', marginLeft: '10px', marginRight: '10px', height: '40px', borderLeft: 'solid 3px #0178D4', paddingTop: '10px', display: 'flex', alignItems: 'center', borderBottom: 'none' } },
											_react2.default.createElement('span', { className: 'box-title', id: 'userSetListDefaultItem', style: { marginLeft: '10px', fontSize: '14px', fontWeight: 'inherit' } }),
											_react2.default.createElement(
												'button',
												{ type: 'button', id: 'cancelUserSetListDefaultItem', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.btnUnSetDefault_clickHandler.bind(this) },
												'\u53D6\u6D88'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'box-body', style: { height: '290px' } },
											_react2.default.createElement(
												'div',
												{ style: { width: '100%', height: '100%' } },
												_react2.default.createElement(_UserSetListDataGrid2.default, { ref: function ref(node) {
														return _this2.userSetList = node;
													} })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'box-footer', id: 'userSetTable-footer', style: { marginTop: '5px', textAlign: 'right', borderTop: '1px solid rgba(0,0,0,0.10)' } },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.resetUserSetTable.bind(this), style: { marginLeft: '5px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-spinner' }),
												'\u52A0\u8F7D'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.deleteUserSetList.bind(this), style: { marginLeft: '8px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-trash-o', 'aria-hidden': 'true' }),
												'\u5220\u9664'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.filterCurrentUser.bind(this), ref: function ref(node) {
														return _this2.btnFilterCurrentUser = node;
													}, style: { marginLeft: '8px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-filter', 'aria-hidden': 'true' }),
												'\u7B5B\u9009\u5F53\u524D\u7528\u6237'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', style: { display: 'none', marginLeft: '8px', marginRight: '0' }, onClick: this.cancelFilterCurrentUser.bind(this), ref: function ref(node) {
														return _this2.btnCancelFilterCurrentUser = node;
													} },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-filter', 'aria-hidden': 'true' }),
												'\u53D6\u6D88\u7B5B\u9009'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.setDefault.bind(this), ref: function ref(node) {
														return _this2.btnSetDefault = node;
													}, style: { marginLeft: '8px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-cog', 'aria-hidden': 'true' }),
												'\u8BBE\u4E3A\u9ED8\u8BA4'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return UserFormSetForm;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
		var _this3 = this;
	
		this.closeUserSetForm = function () {
			var $reactComponentContainer = $("#userFormSetDiv");
			_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
			//$reactComponentContainer.remove();
			$("#userFormSetDiv").css("display", "none");
		};
	
		this.userSetTableTitle = function (defaultItem) {
	
			if (defaultItem) {
				$("#userSetListDefaultItem").text("当前默认值 " + defaultItem).attr("name", defaultItem);
				$("#cancelUserSetListDefaultItem").show();
			} else {
				$("#userSetListDefaultItem").text(_this3.noSetLabel);
				$("#cancelUserSetListDefaultItem").hide();
			}
		};
	
		this.deleteUserSetList = function () {
			var obj = _this3.userSetList.deleteRow();
			if (obj.row) {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "deleteUserFormDesign", "void");
	
				var _parentWindow = window.parent.window;
				var slipper = ".";
				if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
				command.appendArg(window.formId + slipper + window.menuItemId);
				command.appendArg(_parentWindow.userInfos.userId);
				command.appendArg(obj.row.fileName);
				var remoteArg = { command: command, resultFunction: _this3.rpc_deleteUserSetListHandler.bind(_this3, obj),
					sync: false, faultFunction: _this3.fault_deleteUserSetListHandler.bind(_this3, obj) };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		};
	
		this.resetUserSetTable = function () {
			var selectedItem = _this3.userSetList.getSelectedRow();
	
			var userId = selectedItem.userName;
			var fileName = selectedItem.fileName;
			var methodName;
			var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserFormDesign", "String");
			var slipper = ".";
			if (window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1) slipper = "&";
			command.appendArg(window.formId + slipper + window.menuItemId);
			command.appendArg(userId);
			command.appendArg(fileName);
	
			_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: _this3.rpc_loadHandler.bind(_this3) });
		};
	};
	
	exports.default = UserFormSetForm;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LogUtil = function () {
	    function LogUtil() {
	        _classCallCheck(this, LogUtil);
	    }
	
	    _createClass(LogUtil, null, [{
	        key: 'setUserOprLog',
	        value: function setUserOprLog(options) {
	            return;
	            var userInfos = window.userInfos ? window.userInfos : window.parent.window.userInfos;
	            var defaultOption = {
	                remoteClass: "java.util.Map",
	                dateTime: new Date().getTime(),
	                dataArea: userInfos.subSysId,
	                userId: userInfos.userId,
	                userName: userInfos.userName,
	                clientSessionId: userInfos.userSessionId,
	                formId: "", formDataSourceName: "", formItemName: "", remark: ""
	            };
	            /*IndexedDBUtil.addData(IndexedDBUtil.DB.db,IndexedDBUtil.DB.name3,
	                Object.assign(defaultOption,options)
	            );*/
	            LogUtil.clientLogs.operate.push(Object.assign(defaultOption, options));
	        }
	    }, {
	        key: 'setRpcLog',
	        value: function setRpcLog(options) {
	            LogUtil.clientLogs.rpcCall.push(options);
	        }
	    }, {
	        key: 'setOperate',
	        value: function setOperate(options) {
	            LogUtil.clientLogs.operate.push(options);
	        }
	    }, {
	        key: 'setGlobalError',
	        value: function setGlobalError(options) {
	            var userInfos = window.userInfos ? window.userInfos : window.parent.window.userInfos;
	            var defaultOption = {
	                remoteClass: "java.util.Map",
	                dateTime: new Date().getTime() + "",
	                dataArea: userInfos.subSysId,
	                userId: userInfos.userId,
	                userName: userInfos.userName,
	                clientSessionId: userInfos.userSessionId,
	                remark: "", stackInfo: ""
	            };
	            LogUtil.clientLogs.errorInfo.push(Object.assign(defaultOption, options));
	        }
	    }, {
	        key: 'upLog',
	        value: function upLog(datas) {
	            var command = _Command2.default.createService("gongqi.erp.framework.services.ClientLoggingService", "saveLog", "void");
	            command.appendArg(LogUtil.clientLogs, "Object");
	            var remoteArg = {
	                command: command,
	                resultFunction: LogUtil.rpcUpLoadLog,
	                faultFunction: LogUtil.rpcFaultUpLoadLog,
	                autoLock: false,
	                autoUnlock: false
	            };
	            _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	        }
	    }, {
	        key: 'upNetWorkErrorLog',
	        value: function upNetWorkErrorLog(datas) {
	            if (datas && datas.length) {
	                var data = { remoteClass: "java.util.Map", rpcCallError: datas };
	                var command = _Command2.default.createService("gongqi.erp.framework.services.ClientLoggingService", "saveLog", "void");
	                command.appendArg(data, "Object");
	                var remoteArg = {
	                    command: command,
	                    resultFunction: LogUtil.rpcUpLoadErrorLog,
	                    autoLock: false,
	                    autoUnlock: false
	                };
	                _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	            }
	        }
	    }, {
	        key: 'rpcUpLoadErrorLog',
	        value: function rpcUpLoadErrorLog(data) {}
	    }, {
	        key: 'rpcUpLoadLog',
	        value: function rpcUpLoadLog(data) {
	            LogUtil.clientLogs = { remoteClass: "java.util.Map", errorInfo: [], operate: [], overTimeFrame: [], rpcCall: [] };
	        }
	    }, {
	        key: 'rpcFaultUpLoadLog',
	        value: function rpcFaultUpLoadLog(data) {
	            //日志上传错误 不弹出任何提示 避免当服务器关掉时 每隔一分钟就弹出断网提示
	        }
	    }]);
	
	    return LogUtil;
	}();
	
	LogUtil.CLIENTLOG = "clientLog";
	LogUtil.ERRORINFO = "errorInfo";
	LogUtil.OPR = "operate";
	LogUtil.OVERTIME_FRAME = "overTimeFrame";
	LogUtil.RPCCALL = "rpcCall";
	LogUtil.clientLogs = { remoteClass: "java.util.Map", errorInfo: [], operate: [], overTimeFrame: [], rpcCall: [] };
	exports.default = LogUtil;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _copyToClipboard = __webpack_require__(165);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var RemotePasteDialog = function (_React$Component) {
	    _inherits(RemotePasteDialog, _React$Component);
	
	    function RemotePasteDialog(props) {
	        _classCallCheck(this, RemotePasteDialog);
	
	        var _this = _possibleConstructorReturn(this, (RemotePasteDialog.__proto__ || Object.getPrototypeOf(RemotePasteDialog)).call(this, props));
	
	        _this.getGridRowAt = function (index) {
	            if (index < 0 || index > _this.getGridSize()) {
	                return undefined;
	            }
	
	            return _this.state.gridDataProvider[index];
	        };
	
	        _this.getGridSize = function () {
	            return _this.state.gridDataProvider.length;
	        };
	
	        _this.handleGridRowsUpdated2 = function (_ref) {
	            var fromRow = _ref.fromRow,
	                toRow = _ref.toRow,
	                updated = _ref.updated;
	
	            var rows = _this.state.keyValueGridRows.slice();
	
	            for (var i = fromRow; i <= toRow; i++) {
	                var rowToUpdate = rows[i];
	                var updatedRow = $.extend(rowToUpdate, updated);
	                rows[i] = updatedRow;
	            }
	            _this.setState({ keyValueGridRows: rows });
	        };
	
	        _this.handleGridRowsUpdated = function (_ref2) {
	            var fromRow = _ref2.fromRow,
	                toRow = _ref2.toRow,
	                updated = _ref2.updated;
	
	            var rows = _this.state.gridDataProvider.slice();
	
	            for (var i = fromRow; i <= toRow; i++) {
	                var rowToUpdate = rows[i];
	                var updatedRow = $.extend(rowToUpdate, updated);
	                rows[i] = updatedRow;
	            }
	            _this.setState({ gridDataProvider: rows });
	        };
	
	        _this.rowClick = function (index, record, proxy) {
	            _this.setState({ selectedIndexes: [index] });
	        };
	
	        _this.state = {
	            mode: _this.props.remotearg.mode,
	            type: _this.props.remotearg.type,
	            keyValueGridRows: [],
	            gridColumns: [],
	            gridDataProvider: [],
	            selectedIndexes: [0],
	            keyValueColumns: [{ key: 'key', name: "属性名称", width: 130, resizable: true }, { key: 'value', name: "属性值", width: 130, resizable: true }],
	            title: _this.props.remotearg.title
	        };
	
	        if (_this.state.mode == RemotePasteDialog.MODE_IN && _this.props.type == RemotePasteDialog.TYPE_KEYVALUE) {
	            if (_this.props.remotearg && _this.props.remotearg.fields && _this.props.remotearg.fields.length > 0) {
	                var fixedData = [];
	                for (var i = 0; i < _this.props.remotearg.fields.length; i++) {
	                    var field = _this.props.remotearg.fields[i];
	                    fixedData.push({ key: field.label == "" ? RemotePasteDialog.typetocn[String(field.fieldType)] : field.label, value: "", serverfield: field.dataField });
	                }
	                _this.state.keyValueGridRows = fixedData;
	            }
	        } else if (_this.state.mode == RemotePasteDialog.MODE_IN && _this.state.type == RemotePasteDialog.TYPE_DATAGRID) {
	
	            if (_this.props.remotearg && _this.props.remotearg.fields && _this.props.remotearg.fields.length > 0) {
	                var headers = [];
	                for (var _i = 0; _i < _this.props.remotearg.fields.length; _i++) {
	                    var _field = _this.props.remotearg.fields[_i];
	                    var gc = {};gc.type = _field.fieldType;gc.numOfDecimals = _field.numOfDecimals;gc.name = _field.label;gc.key = _field.dataField;
	                    gc.resizable = true;
	                    headers.push(gc);
	                }
	                _this.state.gridColumns = headers;
	            } else {
	                //this.state.gridColumns = [{key:'key',name: "右键选择粘贴",width: 130,resizable: true}];
	            }
	        } else if (_this.props.remotearg.mode == RemotePasteDialog.MODE_OUT) {
	            if (_this.props.remotearg.type == RemotePasteDialog.TYPE_TEXT) {
	                _this.state.mode0Text = remotearg.data;
	            } else if (_this.props.remotearg.type == RemotePasteDialog.TYPE_KEYVALUE) {
	
	                var datas = [];
	                if (_this.props.remotearg.fields && _this.props.remotearg.fields.length > 1) {
	                    for (key in remotearg.data) {
	                        data = {};var keyLabel = "";
	                        for (var _i2 = 0; _i2 < _this.props.remotearg.fields.length; _i2++) {
	                            var _field2 = _this.props.remotearg.fields[_i2];
	                            if (_field2.dataField == key) keyLabel = _field2.label == "" || _field2.label == null ? key : _field2.label;
	                        }
	                        data["key"] = keyLabel;
	                        data["value"] = _this.props.remotearg.data[key];
	                        datas.push(data);
	                    }
	                    _this.state.keyValueGridRows = datas;
	                } else {
	                    for (var key in _this.props.remotearg.data) {
	                        var data = {};data["key"] = key;data["value"] = _this.props.remotearg.data[key];datas.push(data);
	                    }
	                    _this.state.keyValueGridRows = datas;
	                }
	            } else if (_this.props.remotearg.type == RemotePasteDialog.TYPE_DATAGRID) {
	                if (_this.props.remotearg.fields && _this.props.remotearg.fields.length > 0) {
	                    var headers = [];
	                    for (var _i3 = 0; _i3 < _this.props.remotearg.fields.length; _i3++) {
	                        var _field3 = _this.props.remotearg.fields[_i3];
	                        gc = {};gc.name = _field3.label;gc.key = _field3.dataField;gc.type = _field3.fieldType;gc.numOfDecimals = _field3.numOfDecimals;
	                        gc.resizable = true;headers.push(gc);
	                    }
	                    _this.state.gridColumns = headers;
	                    _this.state.gridDataProvider = _this.props.remotearg.data;
	                } else {
	                    if (typeof _this.props.remotearg.data == "Array" && _this.props.remotearg.data.length > 0) {
	                        var first = _this.props.remotearg.data[0];
	                        for (key in first) {
	                            gc = {};gc.name = key;gc.key = key;
	                            gc.resizable = true;headers.push(gc);
	                        }
	                        _this.state.gridColumns = headers;
	                        _this.state.gridDataProvider = _this.props.remotearg.data;
	                    } else {
	                        _Warn2.default.show({ text: "服务端未能传回数据" });
	                    }
	                }
	            }
	        }
	        return _this;
	    }
	
	    _createClass(RemotePasteDialog, [{
	        key: 'getKeyValueGridRowAt',
	        value: function getKeyValueGridRowAt(index) {
	            if (index < 0 || index > this.getKeyValueGridSize()) {
	                return undefined;
	            }
	
	            return this.state.keyValueGridRows[index];
	        }
	    }, {
	        key: 'getKeyValueGridSize',
	        value: function getKeyValueGridSize() {
	            return this.state.keyValueGridRows.length;
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            _reactDom2.default.unmountComponentAtNode(document.getElementById('remotePasteDialogModal'));
	            $(this.remotePasteDialogContainer).remove();
	            $('#remotePasteDialogModal').hide();
	        }
	    }, {
	        key: 'closePaste',
	        value: function closePaste() {
	            $(this.pasteHelperContainer).remove();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            $(this.remotePasteDialogContainer).draggable({
	                handle: ".modal-header" // 只能点击头部拖动
	            }); //为模态对话框添加拖拽
	
	            $(this.pasteHelperContainer).draggable({ handle: ".modal-header" });
	
	            /*let contextMenuItems;
	              var remotearg = this.props.remotearg;
	            if(remotearg)
	            {
	                
	                if(remotearg.mode == RemotePasteDialog.MODE_IN)
	                {
	                    contextMenuItems = [
	                        {label:'粘贴',icon:'',action:this.contextMenuPasteHandler.bind(this)}
	                    ];
	                }
	                else
	                {
	                    contextMenuItems = [
	                        {label:'复制',icon:'',action:this.contextMenuPasteHandler.bind(this)}
	                    ];
	                }
	                
	            }
	              if(this.grid)
	                $(this.grid).find(".react-grid-Canvas")
	                    .contextPopup({items:contextMenuItems}).css({'overflow-y':'auto','overflow-x':'scroll'});
	            else if(this.keyValueGrid)
	                $(this.keyValueGrid).find(".react-grid-Canvas")
	                    .contextPopup({items:contextMenuItems}).css({'overflow-y':'auto','overflow-x':'scroll'});*/
	
	            /*if(this.grid)
	                $(this.grid).contextPopup({items:contextMenuItems});
	            else if(this.keyValueGrid)
	                $(this.keyValueGrid).contextPopup({items:contextMenuItems});*/
	        }
	    }, {
	        key: 'copyPasteClick',
	        value: function copyPasteClick() {
	            if (this.state.mode == RemotePasteDialog.MODE_IN) {
	                $(this.pasteHelperContainer).show();
	            } else if (this.state.mode == RemotePasteDialog.MODE_OUT) {
	                if (this.state.type == RemotePasteDialog.TYPE_KEYVALUE) {
	                    this.grid1_copyHandler();
	                } else {
	                    this.grid_copyHandler();
	                }
	            }
	        }
	    }, {
	        key: 'contextMenuPasteHandler',
	        value: function contextMenuPasteHandler() {
	            $(this.pasteHelperContainer).show();
	        }
	    }, {
	        key: 'btnPasteRequire',
	        value: function btnPasteRequire() {
	            if (this.state.type == RemotePasteDialog.TYPE_KEYVALUE) {
	                this.paste1Handler($(this.pasteTextContainer).val());
	            } else if (this.state.type == RemotePasteDialog.TYPE_DATAGRID) {
	                this.pasteHandler($(this.pasteTextContainer).val());
	            }
	            $(this.pasteHelperContainer).hide();
	        }
	    }, {
	        key: 'doPaste',
	        value: function doPaste(text) {
	            var colNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	            var remotearg = this.props.remotearg;
	            if (!remotearg) return null;
	
	            if (!text) {
	                _Warn2.default.show({ text: "未在剪贴板中找到文本数据" });
	                return null;
	            }
	            //try
	            //{
	            var rows = text.split("\n");var colnum = -1;var ac = [];var obj;var i = 0;var k = 0;var headers = [];var gc;
	            for (var _i4 = 0; _i4 < rows.length; _i4++) {
	                var row = rows[_i4];
	                if (!row) continue;
	                var columns = row.split(/[\t]/g);
	                if (colnum == -1) colnum = columns.length;
	                obj = {};
	                for (var _k = 0; _k < columns.length; _k++) {
	                    var coldata = columns[_k];
	                    if (_i4 == 0) {
	                        gc = {};
	                        if (remotearg.isDataWithHeader == true) {
	                            gc.name = coldata;gc.key = coldata;gc.resizable = true;
	                        } else {
	                            obj[_k + ''] = coldata;gc.key = _k + '';gc.resizable = true;
	                        }
	                        headers.push(gc);
	                    } else {
	                        //第一行与第二行所标识的列数不一样 以第一行为准 后面的将忽略
	                        if (_k > headers.length - 1) {
	                            gc = {};gc.resizable = true;gc.name = "";gc.key = _k + '';headers.push(gc);
	                            //break;
	                        }
	                        var header = headers[_k];
	                        var key = header.key;
	                        obj[key] = coldata;
	                        if (!header.width) {
	                            header.width = (coldata + "").visualLength() + 25 + "px";
	                        } else {
	                            var coldataLength = (coldata + "").visualLength();
	                            if (coldataLength > header.width) header.width = coldataLength + 25 + "px";
	                        }
	                    }
	                    if (colNum != 0 && _k == colNum) break;
	                }
	
	                if (remotearg.isDataWithHeader == true) {
	                    if (_i4 != 0) ac.push(obj);
	                } else {
	                    ac.push(obj);
	                }
	            }
	
	            var result = { columns: headers, datas: ac };
	            return result;
	
	            //}catch(e)
	            //{
	            //    Warn.show({text:"无法解析复制的文本"});
	            //}
	            return null;
	        }
	    }, {
	        key: 'pasteHandler',
	        value: function pasteHandler(text) {
	            var remotearg = this.props.remotearg;
	            if (remotearg) {
	                if (remotearg.fields && remotearg.fields.length > 0) {
	                    if (!text) {
	                        _Warn2.default.show({ text: "未在剪贴板中找到文本数据" });
	                        return;
	                    }
	                    try {
	                        var rows = text.split("\n");var datas = [];
	                        for (var i = 0; i < row.length; i++) {
	                            var row = rows[i];
	                            var columns = row.split(/[\t]+/g);var data = {};
	                            for (var k = 0; k < columns.length; k++) {
	                                if (k > this.state.gridColumns.length - 1) break;
	                                var dataField = gridColumns[k].key;
	                                data[dataField] = columns[k];
	                            }
	
	                            if (columns.length < this.state.gridColumns.length) {
	                                for (var l = columns.length; l < this.state.gridColumns.length; l++) {
	                                    data[gridColumns[l].key] = "";
	                                }
	                            }
	                            datas.push(data);
	                        }
	                        this.setState({ gridDataProvider: datas });
	                    } catch (e) {}
	                } else {
	                    var dataprovider = this.doPaste(text);
	                    if (dataprovider) {
	                        this.setState({ gridColumns: dataprovider.columns, gridDataProvider: dataprovider.datas });
	                    }
	                }
	            }
	        }
	
	        //有fields
	
	    }, {
	        key: 'paste1Handler',
	        value: function paste1Handler(text) {
	            if (!text) {
	                _Warn2.default.show({ text: "未在剪贴板中找到文本数据" });
	                return;
	            }
	            var remotearg = this.props.remotearg;
	            if (!remotearg) return;
	            if (remotearg.fields && remotearg.fields.length > 0) {
	                try {
	                    var rows = text.split("\n");
	                    for (var i = 0; i < this.state.keyValueGridRows.length; i++) {
	                        var item = keyValueGridRows[i];
	                        if (i >= rows.length) break;
	                        var row = rows[i];
	                        if (!row) continue;
	                        var columns = row.split(/[\t]+/g);
	                        var value = columns[columns.length - 1];
	                        item.value = value;
	                    }
	                    this.setState({ keyValueGridRows: this.state.keyValueGridRows.slice() });
	                    //this.forceUpdate();
	                } catch (e) {
	                    _Warn2.default.show({ text: "粘贴的数据有不可识别的格式" });
	                }
	            } else {
	                try {
	                    var newGrid1Data = [];
	                    var rows = text.split("\n");
	                    for (var _i5 = 0; _i5 < rows.length; _i5++) {
	                        var row = rows[_i5];
	                        if (!row) continue;
	                        var columns = row.split(/[\t]+/g);
	                        if (columns.length == 0) break;
	                        if (columns.length == 1) columns.unshift(_i5);
	                        var item = {};
	                        for (var k = 0; k < 2; k++) {
	                            var key = k == 0 ? "key" : "value";
	                            item[key] = columns[k];
	                        }
	                        newGrid1Data.push(item);
	                    }
	                    this.setState({ keyValueGridRows: newGrid1Data });
	                } catch (e) {
	                    _Warn2.default.show({ text: "粘贴的数据有不可识别的格式" });
	                }
	            }
	        }
	    }, {
	        key: 'btnclear0_clickHandler',
	        value: function btnclear0_clickHandler(event) {
	            $(this.textModeInput).val("");
	        }
	    }, {
	        key: 'btnclear1_clickHandler',
	        value: function btnclear1_clickHandler(event) {
	            this.setState({ keyValueGridRows: [] });
	        }
	    }, {
	        key: 'btnclear2_clickHandler',
	        value: function btnclear2_clickHandler(event) {
	            this.setState({ gridDataProvider: [], gridColumns: [] });
	        }
	    }, {
	        key: 'getTaskGroup',
	        value: function getTaskGroup(task, fm) {
	            if (!task || !fm || !fm.formDataSources) return null;
	            var group;
	            if (task.group) group = fm.formDataSources.groups[task.group];
	
	            if (!group) group = fm.formDataSources.getFirstGroup();
	
	            return group;
	        }
	    }, {
	        key: 'getInData',
	        value: function getInData(remotearg) {
	            if (this.state.type == RemotePasteDialog.TYPE_KEYVALUE) {
	                var _arg = {};
	                if (this.props.remotearg && this.props.remotearg.fields && this.props.remotearg.fields.length > 0) {
	                    for (var i = 0; i < this.state.keyValueGridRows.length; i++) {
	                        var item = this.state.keyValueGridRows[i];
	                        _arg[item.serverfield] = item.value;
	                    }
	                } else {
	                    var ac = this.state.keyValueGridRows;
	                    var column0 = this.state.keyValueColumns[0];
	                    var column1 = this.state.keyValueColumns[1];
	                    var key1 = column0.key;
	                    var key2 = column1.key;
	                    for (var _i6 = 0; _i6 < ac.length; _i6++) {
	                        var _item = ac[_i6];
	                        _arg[_item[key1]] = _item[key2];
	                    }
	                }
	                return _arg;
	            } else if (this.state.type == RemotePasteDialog.TYPE_DATAGRID) {
	                _arg = this.state.gridDataProvider.slice();
	                if (this.props.remotearg && !this.props.remotearg.fields && this.props.remotearg.isDataWithHeader) {
	                    if (!_arg) _arg = [];
	                    var headerdata = {};
	                    for (var _i7 = 0; _i7 < this.state.gridColumns.length; _i7++) {
	                        var gc = this.state.gridColumns[_i7];
	                        headerdata[gc.key] = gc.name;
	                    }
	                    _arg.unshift(headerdata);
	                }
	                return _arg;
	            }
	
	            return $(textModeInput).val();
	        }
	    }, {
	        key: 'btnRequire0_clickHandler',
	        value: function btnRequire0_clickHandler(event) {
	            var _arg = $(this.textModeInput).val();
	            this.dobtnRequire_clickHandler(event, _arg);
	        }
	    }, {
	        key: 'btnRequire1_clickHandler',
	        value: function btnRequire1_clickHandler(event) {
	            var remotearg = this.props.remotearg;
	            var _arg = {};
	            if (remotearg.fields && remotearg.fields.length > 0) {
	                for (var i = 0; i < this.state.keyValueGridRows.length; i++) {
	                    var item = this.tate.keyValueGridRows[i];
	                    _arg[item.serverfield] = item.value;
	                }
	            } else {
	                var ac = this.state.keyValueGridRows;
	                var column0 = this.state.keyValueColumns[0];
	                var column1 = this.state.keyValueColumns[1];
	                var key1 = column0.key;
	                var key2 = column1.key;
	                for (var _i8 = 0; _i8 < ac.length; _i8++) {
	                    var _item2 = ac[_i8];
	                    _arg[_item2[key1]] = _item2[key2];
	                }
	            }
	
	            this.dobtnRequire_clickHandler(event, _arg);
	        }
	    }, {
	        key: 'btnRequire_clickHandler',
	        value: function btnRequire_clickHandler(event) {
	            var _arg = this.state.gridDataProvider.slice();
	            var remotearg = this.props.remotearg;
	            if (remotearg && !remotearg.fields && remotearg.isDataWithHeader) {
	                if (!_arg) _arg = [];
	                var headerdata = {};
	                for (var i = 0; i < this.state.gridColumns.length; i++) {
	                    var gc = this.state.gridColumns[i];
	                    headerdata[gc.key] = gc.name;
	                }
	                _arg.unshift(headerdata, 0);
	                //_arg.addItemAt(headerdata,0);
	            }
	            this.dobtnRequire_clickHandler(event, _arg);
	        }
	    }, {
	        key: 'dobtnRequire_clickHandler',
	        value: function dobtnRequire_clickHandler(event, _arg) {
	            var remotearg = this.props.remotearg;
	            var group = this.getTaskGroup(this.props.task, window.formModuleInstance);
	            var _methodName = "clipboardOK_" + remotearg.id;
	            var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(_methodName, window.menuItemId, window.formId);
	            if (!mi) return;
	
	            if (mi.prefetch == true) {
	                if (mi.commandResult) _CommandResolver2.default.resolve(mi.commandResult.tasks, this);
	                this.close();
	            } else {
	                var arg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, group != null ? group.groupAlias : "", mi);
	                arg.argObject = _arg;
	                var command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, _methodName, "CommandResult").appendArg(arg, "CommandArg");
	                var that = this;
	                _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: function resultFunction(event) {
	                        that.rpc_result_do_server(event, group);
	                    } });
	            }
	        }
	    }, {
	        key: 'rpc_result_do_server',
	        value: function rpc_result_do_server(event, group) {
	            this.close();
	            _CommandResolver2.default.resolve(event.result.tasks, window.formModuleInstance, group);
	        }
	
	        //复制到剪贴板
	
	    }, {
	        key: 'exportClipBoard',
	        value: function exportClipBoard(exportHeads, exportBodys) {
	            if (!exportHeads || exportHeads.length == 0) {
	                _Fade2.default.show({ text: "没有可导出的列" });
	                return;
	            }
	
	            var rowCount = exportBodys.length;
	            var data = "";
	            var fieldSeparator = "\t";
	            var lineSeparator = "\n";
	            var fields = [];
	            //循环表头数据
	            for (var i = 0; i < exportHeads.length; i++) {
	                var filed = exportHeads[i];
	                fields.push(filed.headerText);
	                data += filed.headerText + fieldSeparator;
	                if (i == exportHeads.length - 1) {
	                    data += lineSeparator;
	                }
	            }
	
	            //循环行数据
	            for (var i = 0; i < rowCount; i++) {
	                var record = exportBodys[i];
	                for (var j = 0; j < record.length; j++) {
	                    var item = record[j];
	                    data += item + fieldSeparator;
	                    if (j == record.length - 1) data += lineSeparator;
	                }
	            }
	            var copyHandler = function copyHandler(e) {
	                e.clipboardData.setData('text/plain', data);
	                e.preventDefault();
	            };
	            document.addEventListener('copy', copyHandler);
	            (0, _copyToClipboard2.default)(data);
	            document.removeEventListener('copy', copyHandler);
	            var options = {
	                state: 'success',
	                text: '成功复制到剪切板'
	            };
	            _Fade2.default.show(options);
	        }
	    }, {
	        key: 'grid1_copyHandler',
	        value: function grid1_copyHandler(event) {
	            this.exportClipBoard(this.state.keyValueColumns, this.state.keyValueGridRows);
	        }
	    }, {
	        key: 'grid_copyHandler',
	        value: function grid_copyHandler(event) {
	            this.exportClipBoard(this.state.gridColumns, this.state.gridDataProvider);
	        }
	    }, {
	        key: 'onHeaderDragHandleDoubleClick',
	        value: function onHeaderDragHandleDoubleClick(column) {
	            var max = column.name.visualLength();
	            //let fontSizeRequired = false;
	            var rows = this.state.gridDataProvider ? this.state.gridDataProvider : this.state.keyValueGridRows;
	            for (var i = 0; i < rows.length; i++) {
	                var item = rows[i];
	                var value = item[column.key];
	                if (value) {
	                    var width = value.visualLength();
	                    if (width > max) max = width;
	                }
	            }
	            return max > 0 ? max + 20 : 0;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var content = void 0;var buttonDsiplay = this.state.mode == RemotePasteDialog.MODE_IN ? 'flex' : 'none';
	            var _label = void 0;
	            var cancellabel = this.props.remotearg.cancelLabel ? this.props.remotearg.cancelLabel : "清空数据";
	            var oklabel = this.props.remotearg.okLabel ? this.props.remotearg.okLabel : "提交数据";
	            if (this.state.type == RemotePasteDialog.TYPE_TEXT) {
	                _label = this.state.mode == RemotePasteDialog.MODE_IN ? RemotePasteDialog.MODE_IN_0_PROMPT : RemotePasteDialog.MODE_OUT_0_PROMPT;
	                if (this.props.remotearg.promptInfo) {
	                    _label = this.props.remotearg.promptInfo;
	                }
	                content = _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column', flexGrow: 100, alignSelf: 'strecth' } },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _label
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'row', flexGrow: 100, alignSelf: 'strecth' } },
	                        _react2.default.createElement('textarea', { style: { flexGrow: 100 }, ref: function ref(node) {
	                                return _this2.textModeInput = node;
	                            }, rows: '5', defaultValue: this.state.mode0Text }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: buttonDsiplay, flexDirection: 'column', alignSelf: 'strecth', marginLeft: '5px' } },
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px' }, onClick: this.btnclear0_clickHandler.bind(this) },
	                                cancellabel
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.btnRequire0_clickHandler.bind(this) },
	                                oklabel
	                            )
	                        )
	                    )
	                );
	            } else if (this.state.type == RemotePasteDialog.TYPE_KEYVALUE) {
	                _label = this.state.mode == RemotePasteDialog.MODE_IN ? RemotePasteDialog.MODE_IN_1_PROMPT : RemotePasteDialog.MODE_OUT_1_PROMPT;
	                if (this.props.remotearg.promptInfo) {
	                    _label = this.props.remotearg.promptInfo;
	                }
	                content = _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column', flexGrow: 100, alignSelf: 'strecth' } },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _label
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'row', flexGrow: 100, alignSelf: 'strecth' } },
	                        _react2.default.createElement(ReactDataGrid, { ref: function ref(node) {
	                                return _this2.keyValueGrid = node;
	                            }, enableCellSelect: true, columns: this.state.keyValueColumns, rowGetter: this.getKeyValueGridRowAt.bind(this), rowsCount: this.getSize.bind(this), onGridRowsUpdated: this.handleGridRowsUpdated2,
	                            enableRowSelect: false, rowSelection: { showCheckbox: false, selectBy: { indexes: this.state.selectedIndexes } }, onRowClick: this.rowClick, rowHeight: 30, minHeight: 240, rowScrollTimeout: 500, cellNavigationMode: 'loopOverRow',
	                            onDoubleClickToFit: this.onHeaderDragHandleDoubleClick.bind(this) }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: buttonDsiplay, flexDirection: 'column', flexGrow: 100, alignSelf: 'strecth', marginLeft: '5px' } },
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px' }, onClick: this.btnclear1_clickHandler.bind(this) },
	                                cancellabel
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.btnRequire1_clickHandler.bind(this) },
	                                oklabel
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.copyPasteClick.bind(this) },
	                                this.state.mode == RemotePasteDialog.MODE_IN ? "粘贴数据" : "复制数据"
	                            )
	                        )
	                    )
	                );
	            } else if (this.state.type == RemotePasteDialog.TYPE_DATAGRID) {
	                _label = this.state.mode == RemotePasteDialog.MODE_IN ? RemotePasteDialog.MODE_IN_2_PROMPT : RemotePasteDialog.MODE_OUT_2s_PROMPT;
	                if (this.props.remotearg.promptInfo) {
	                    _label = this.props.remotearg.promptInfo;
	                }
	                content = _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column', flexGrow: 100, alignSelf: 'strecth' } },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _label
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'row', flexGrow: 100, alignSelf: 'strecth' } },
	                        _react2.default.createElement(ReactDataGrid, { ref: function ref(node) {
	                                return _this2.grid = node;
	                            }, enableCellSelect: true, columns: this.state.gridColumns, rowGetter: this.getGridRowAt, rowsCount: this.getGridSize(), onGridRowsUpdated: this.handleGridRowsUpdated,
	                            enableRowSelect: false, rowSelection: { showCheckbox: false, selectBy: { indexes: this.state.selectedIndexes } }, onRowClick: this.rowClick, rowHeight: 30, minHeight: 240, rowScrollTimeout: 500, cellNavigationMode: 'loopOverRow',
	                            onDoubleClickToFit: this.onHeaderDragHandleDoubleClick.bind(this) }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: buttonDsiplay, flexDirection: 'column', flexGrow: 100, alignSelf: 'strecth', marginLeft: '5px' } },
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px' }, onClick: this.btnclear2_clickHandler.bind(this) },
	                                cancellabel
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.btnRequire_clickHandler.bind(this) },
	                                oklabel
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.copyPasteClick.bind(this) },
	                                this.state.mode == RemotePasteDialog.MODE_IN ? "粘贴数据" : "复制数据"
	                            )
	                        )
	                    )
	                );
	            }
	            var _title = this.props.remotearg.title ? this.props.remotearg.title : "剪贴面板";
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(node) {
	                        return _this2.remotePasteDialogContainer = node;
	                    }, style: { position: 'absolute', alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px", backgroundColor: 'white', width: '450px', height: '330px', display: 'flex', flexDirection: 'column' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header', style: { background: "#ffffff", padding: "10px", position: "relative" } },
	                    _react2.default.createElement('i', { className: 'fa fa-close', style: { position: 'absolute', top: '13px', right: '10px', fontSize: '15px', cursor: 'pointer' }, onClick: this.close.bind(this) }),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: 'modal-title', style: { fontWeight: 'bolder' } },
	                        _title
	                    )
	                ),
	                content,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal', ref: function ref(node) {
	                            return _this2.pasteHelperContainer = node;
	                        }, style: { zIndex: '2000', display: 'none' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal-dialog', style: { marginTop: '100px', width: '400px' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal-content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal-header', style: { padding: '5px 15px' } },
	                                _react2.default.createElement('i', { className: 'fa fa-close', style: { position: "absolute", top: "13px", right: "10px", fontSize: "15px", cursor: "pointer" }, onClick: this.closePaste.bind(this) }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'modal-title', style: { marginTop: '0', marginBottom: '0', fontSize: '16px' } },
	                                    '\u6570\u636E\u7C98\u8D34'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal-body', style: { display: 'flex', flexDirection: 'row', padding: '10px 5px' } },
	                                _react2.default.createElement('textarea', { style: { width: '378px', height: '274px' }, ref: function ref(node) {
	                                        return _this2.pasteTextContainer = node;
	                                    }, placeholder: '\u8BF7\u5C06\u5185\u5BB9\u7C98\u8D34\u5230\u6B64\u5904\u7136\u540E\u70B9\u51FB\u786E\u5B9A' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal-footer', style: { padding: '5px 15px' } },
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', className: 'btn btn-primary', onClick: this.btnPasteRequire.bind(this) },
	                                    '\u786E\u5B9A'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RemotePasteDialog;
	}(_react2.default.Component);
	
	RemotePasteDialog.typetocn = { 0: "字符串", 1: "长整数", 2: "小数", 3: "日期", 4: "时间", 5: "是否" };
	RemotePasteDialog.MODE_IN = "In";
	RemotePasteDialog.MODE_OUT = "Out";
	RemotePasteDialog.TYPE_KEYVALUE = "KeyValue";
	RemotePasteDialog.TYPE_TEXT = "Text";
	RemotePasteDialog.TYPE_DATAGRID = "DataGrid";
	RemotePasteDialog.MODE_IN_0_PROMPT = "右键粘贴剪贴板数据到下面文本框";
	RemotePasteDialog.MODE_IN_1_PROMPT = "点击粘贴数据按钮,将剪贴板数据粘贴到文本框,最后点击确定";
	RemotePasteDialog.MODE_IN_2_PROMPT = "点击粘贴数据按钮,将剪贴板数据粘贴到文本框,最后点击确定";
	RemotePasteDialog.MODE_OUT_0_PROMPT = "在下面文本框右键复制数据";
	RemotePasteDialog.MODE_OUT_1_PROMPT = "在下边表格中右键复制数据";
	RemotePasteDialog.MODE_OUT_2_PROMPT = "在下边表格中右键复制数据";
	exports.default = RemotePasteDialog;

/***/ },
/* 175 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Config = function Config() {
		_classCallCheck(this, Config);
	};
	
	Config.showGongqi = true;
	Config.dataPageSize = 50;
	exports.default = Config;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _RecordsUtil = __webpack_require__(64);
	
	var _RecordsUtil2 = _interopRequireDefault(_RecordsUtil);
	
	var _FormLookupRenderFactory = __webpack_require__(149);
	
	var _FormLookupRenderFactory2 = _interopRequireDefault(_FormLookupRenderFactory);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _LookupRefreshStore = __webpack_require__(77);
	
	var _LookupRefreshStore2 = _interopRequireDefault(_LookupRefreshStore);
	
	var _LookupStores = __webpack_require__(34);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _FormDataSources = __webpack_require__(50);
	
	var _FormDataSources2 = _interopRequireDefault(_FormDataSources);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _QueryStores = __webpack_require__(78);
	
	var _FormLookupFactory = __webpack_require__(65);
	
	var _FormLookupFactory2 = _interopRequireDefault(_FormLookupFactory);
	
	var _GOTPropertiesUtil = __webpack_require__(62);
	
	var _GOTPropertiesUtil2 = _interopRequireDefault(_GOTPropertiesUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _AutoLookupStringEditor = __webpack_require__(183);
	
	var _AutoLookupStringEditor2 = _interopRequireDefault(_AutoLookupStringEditor);
	
	var _AutoLookupLongEditor = __webpack_require__(182);
	
	var _AutoLookupLongEditor2 = _interopRequireDefault(_AutoLookupLongEditor);
	
	var _AutoLookupDateEditor = __webpack_require__(180);
	
	var _AutoLookupDateEditor2 = _interopRequireDefault(_AutoLookupDateEditor);
	
	var _LookupHeaderCell = __webpack_require__(179);
	
	var _LookupHeaderCell2 = _interopRequireDefault(_LookupHeaderCell);
	
	var _AutoLookupDecimalEditor = __webpack_require__(181);
	
	var _AutoLookupDecimalEditor2 = _interopRequireDefault(_AutoLookupDecimalEditor);
	
	var _FormItemFieldGroup = __webpack_require__(94);
	
	var _FormItemFieldGroup2 = _interopRequireDefault(_FormItemFieldGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var FormLookup = function (_React$Component) {
		_inherits(FormLookup, _React$Component);
	
		function FormLookup(props) {
			_classCallCheck(this, FormLookup);
	
			var _this = _possibleConstructorReturn(this, (FormLookup.__proto__ || Object.getPrototypeOf(FormLookup)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.entityId = _this.props.entityId;
			_this.innerId = _this.props.innerId;
			_this.lookupKey = _this.entityId + "." + _this.innerId;
			_this.classAlias = "FormLookup";
	
			_this._extralsWhereItemsRefresh = null;
			_this._joinQueryWhereItems = [];
			_this.queryBoxClear = _this.queryBoxClear.bind(_this);
			_this.unsubscribeLookupCmpStore = _LookupRefreshStore2.default.listen(_this.onDataProviderRefresh.bind(_this));
			_this.unsubscribeLookupasteriskRefreshStore = _LookupStores.LookupasteriskRefreshStore.listen(_this.onAsteriskRefresh.bind(_this));
			/*this.unsubscribeLookupHostKeydownStore = 
	  	LookupHostKeydownStore.listen(this.onLookupHostKeydown.bind(this));*/
	
			_this.unsubscribeRecordsCmpStore = _RecordsStore.RecordsCmpStore.listen(_this.onExecuteCmp.bind(_this));
			_this.unsbuscribeAutoFormLookupHeaderClickSortStore = _QueryStores.AutoFormLookupHeaderClickSortStore.listen(_this.onGridHeaderClick.bind(_this));
			_this.dataType = _this.props.dataType;
			var dataTypeRelation = _this.dataType.DataTypeRelation;
			var mainTablePro = dataTypeRelation.Properties.Table;
			var mainTable = null;
			if (mainTablePro.hasOwnProperty("refentityid")) {
				mainTable = _GOT2.default.getTable(mainTablePro.refentityid);
			}
	
			var dataTypeRelationNormalItem = _GOT2.default.getDataTypeRelationNormalItem(dataTypeRelation);
	
			var dataTypeRelationFixed = _GOT2.default.getDataTypeRelationFixedItem(dataTypeRelation);
	
			_this.dataTypeRelationNormalItem = dataTypeRelationNormalItem;
			_this.dataTypeRelationFixed = dataTypeRelationFixed;
			_this.dataTypeRelation = dataTypeRelation;
			_this.mainTable = mainTable;
	
			_this.returnField = _this.getReturnField(dataTypeRelationNormalItem, mainTable);
			_this.autoReturn = true;
			_this.autoQueryFields = [];
			var tableFields = _this.getAutoLookupFields(mainTable);
			var totalWidth = 0;var columns = [];
			for (var i in tableFields) {
				var tableField = tableFields[i];
				var type = tableField.type;
				var name = tableField.name;
				//var column = {};
				if (type == "Component") {
					var items = _GOT2.default.getComponentItems(tableField);
					var tempComponent2ArrayItem = tableField.tempComponent2ArrayItem;
					for (var i in items) {
						var item = items[i];
						if (tempComponent2ArrayItem && item.name != tempComponent2ArrayItem) continue;
						var refPro = item.Properties.RefDataType;
						if (refPro.hasOwnProperty("refentityid")) {
							var subName = _StringUtil2.default.convertToFirstLowerCase(name) + "." + _StringUtil2.default.convertToFirstLowerCase(item.name);
	
							var dataType = _GOT2.default.getDataType(refPro.refentityid);
							_dataField = mainTable.name + "." + subName;
							_label = _GOTUtil2.default.getFinalValue(dataType, dataType, "Label");
							var column = {};
							column.name = _label;column.editable = false;column.resizable = true;column.key = _dataField;
							var render = _FormLookupRenderFactory2.default.getLookupRender(dataType.type, _dataField, dataType.id, null);
							column.formatter = render;
							_width = _GOTUtil2.default.getFinalValue(dataType, dataType, "DisplayLength") * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;
							column.width = _width;totalWidth += _width;
							column.headerRenderer = _react2.default.createElement(_LookupHeaderCell2.default, { lookupKey: _this.entityId + "." + _this.innerId });
							columns.push(column);
						}
					}
				} else {
					var _column = {};
					var _dataField = mainTable.name + "." + _StringUtil2.default.convertToFirstLowerCase(name);
					var _label = tableField.hasOwnProperty("shortcut") ? "快捷码" : _GOTUtil2.default.getFinalValue(tableField, mainTable, "Label");
					var render = _FormLookupRenderFactory2.default.getLookupRender(type, _dataField, mainTable.id, tableField.id);
					var displayLength = _GOTUtil2.default.getFinalValue(tableField, mainTable, "DisplayLength");
					var _width = Number(displayLength) * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;totalWidth += _width;_column.width = _width;
					_column.formatter = render;_column.name = _label;_column.key = _dataField;_column.editable = false;_column.resizable = true;
					_column.headerRenderer = _react2.default.createElement(_LookupHeaderCell2.default, { lookupKey: _this.entityId + "." + _this.innerId });
					columns.push(_column);
				}
			}
	
			_this._columns = columns;
			_this.formXML = JSON.parse(JSON.stringify(_FormLookupFactory2.default.formLookupXMLTemplate));
			_this.setFormDataSources();
			_this.state = { rows: [], selectedIndexes: [], scrollmax: 0, gridContainerWidth: totalWidth + 35, updateMinHeight: -1, containerWidth100: true };
			return _this;
		}
	
		_createClass(FormLookup, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeLookupCmpStore();
				this.unsubscribeLookupasteriskRefreshStore();
				//this.unsubscribeLookupHostKeydownStore();
				this.unsubscribeRecordsCmpStore();
				this.unsbuscribeAutoFormLookupHeaderClickSortStore();
				this.formDataSources.componentWillUnmount();
			}
		}, {
			key: 'onExecuteCmp',
			value: function onExecuteCmp(data, groupAlias, group) {
				if (this.formDataSources.firstGroup == group) {
					this.waitingInitFocus = true;
					var baseFilter = this.lookupArg["baseFilter"];
					var mainField = this.lookupArg["fieldName"];
					var selectIndex = 0;
					if (data && baseFilter && mainField) {
						for (var i = 0; i < data.length; i++) {
							var record = data[i];
							var mainDataField = this.mainTable.name + "." + _StringUtil2.default.convertToEachFirstLowerCase(mainField);
							var mainDataFieldValue = record[mainDataField];
							if (mainDataFieldValue == baseFilter) {
								selectIndex = i;break;
							}
						}
					}
					this.setState({ rows: data, selectedIndexes: [selectIndex] });
					if (selectIndex > 0) this.scrollToIndex(selectIndex, true);
	
					//this.forceUpdate();
					// if(data && data.length>0)
					// {
					// 	this.grid.doOnSelect({rowIndex:0,idx:0,active:false});
					// 	$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Cell.row-selected")[0].focus();
					// }
				}
			}
		}, {
			key: 'setFormDataSources',
			value: function setFormDataSources() {
				var formDataSource = this.formXML.FormDataSources.DataSources[0];
	
				var tablePro = formDataSource.Properties["Table"];
				tablePro.refentityid = this.mainTable.id;
				tablePro.Value = this.mainTable.name;
				//自动构建的下拉换面的别名就是表名 不存在关联表 肯定不会重复 其被用作后台查询的数据的键值
				//与dataGrid中列的dataField也是一致
				formDataSource.name = this.mainTable.name;
				this.formDataSources = new _FormDataSources2.default(this.formXML.FormDataSources, this, true);
			}
		}, {
			key: 'getReturnField',
			value: function getReturnField(dataTypeRelationNormalItem, mainTable) {
				var fieldValue = dataTypeRelationNormalItem.Properties.Field.V;
				if (fieldValue == "") {
					throw new Error("miss FieldValue");
				}
				return mainTable.name + "." + fieldValue.substr(0, 1).toLowerCase() + fieldValue.substr(1);
			}
		}, {
			key: 'getAutoLookupFields',
			value: function getAutoLookupFields(mainTable) {
				var tableFields = [];
				var tableField;
				var fieldPro;
				var allTableFields = mainTable.TableFields.TableField;
				var autoTableFieldGroup = _GOT2.default.getAutoTableFieldGroup(mainTable);
				var thisTableFieldId = this.dataTypeRelationNormalItem ? this.dataTypeRelationNormalItem.Properties.Field.refinnerid : "";
				for (var i in autoTableFieldGroup.FieldGroupItems) {
					var tableFieldGroupItem = autoTableFieldGroup.FieldGroupItems[i];
					fieldPro = tableFieldGroupItem.Properties.Field;
					var innerid = fieldPro.innerid;
					tableField = _GOT2.default.getTableField(mainTable, innerid);
	
					if (!tableField) throw new Error("GOT设置错误 在AutoLookup的GroupItem上找不到TableField");
	
					if (tableFieldGroupItem.Properties.Visible && (tableFieldGroupItem.Properties.Visible.V == false || tableFieldGroupItem.Properties.Visible.V == 'false')) {
						continue;
					}
					var autoQueryField = tableFieldGroupItem.Properties.AutoQueryField.V;
					if (autoQueryField == "true") {
						this.autoQueryFields.push(tableField);
						var focusIn = tableFieldGroupItem.Properties.FocusIn.V;
						if (focusIn == "true") tableField.focusIn = focusIn;
					}
					if (tableField.type == "Component") {
						var arrayItem = _GOTUtil2.default.getPropertyValue(tableFieldGroupItem, "ArrayItem");
						if (arrayItem) {
							tableField.tempComponent2ArrayItem = arrayItem;
						}
					}
	
					var joinQuery = _GOTUtil2.default.getPropertyValue(tableFieldGroupItem, "JoinQuery");
					if (typeof joinQuery == "boolean" && joinQuery == true || joinQuery == "true") {
						//let tableFieldGroupItemFieldId = tableFieldGroupItem.Properties.Field.innerid;
						//if(tableFieldGroupItemFieldId != thisTableFieldId)
						//{
						this._joinQueryWhereItems.push(tableField);
						//}
					}
					tableFields.push(tableField);
				}
	
				if (tableFields.length == 0) {
					fieldPro = mainTable.Properties.TitleField1;
	
					if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
						var _innerid = fieldPro.innerid;
						tableField = _GOT2.default.getTableField(mainTable, _innerid);
						if (!tableField) throw new Error("GOT设置错误 在TitleField1上找不到TableField");
						tableFields.push(tableField);
					}
					fieldPro = mainTable.Properties.TitleField2;
					if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
						var _innerid2 = fieldPro.innerid;
						tableField = _GOT2.default.getTableField(mainTable, _innerid2);
						if (!tableField) throw new Error("GOT设置错误 在TitleField2上找不到TableField(存在innerid)");
						tableFields.push(tableField);
					}
				}
	
				var index;
				var indexItem;
				var indexes;
				if (tableFields.length == 0) {
					fieldPro = mainTable.Properties.ClusterIndex;
					if (fieldPro.hasOwnProperty("innerid")) {
						var _innerid3 = fieldPro.innerid;
						index = _GOT2.default.getTableIndex(mainTable, _innerid3);
	
						for (var _i in index.TableIndexItem) {
							indexItem = index.TableIndexItem[_i];
							fieldPro = indexItem.Properties.Field;
							if (fieldPro.hasOwnProperty("innerid")) {
								tableField = _GOT2.default.getTableField(mainTable, fieldPro.innerid);
								tableFields.push(tableField);
							}
						}
					}
				}
	
				if (tableFields.length == 0) {
					if (this.dataTypeRelationNormalItem) {
						fieldPro = this.dataTypeRelationNormalItem.Properties.Field;
						if (fieldPro.hasOwnProperty("refinnerid")) {
							tableField = _GOT2.default.getTableField(mainTable, fieldPro.refinnerid);
							tableFields.push(tableField);
						}
					}
				}
	
				fieldPro = mainTable.Properties.ShortCutField;
				if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
					tableField = _GOT2.default.getTableField(mainTable, fieldPro.innerid);
					if (tableFields.indexOf(tableField) == -1) {
						tableField.shortcut = true;
						tableFields.push(tableField);
					}
				}
	
				return tableFields;
			}
		}, {
			key: 'rowGetter',
			value: function rowGetter(i) {
				return this.state.rows[i];
			}
		}, {
			key: 'rowClick',
			value: function rowClick(index, record, proxy) {
				if (index == -1) return;
				//alert("点击");
				var datas = this.state.rows;
				var returnItem = datas[index];
				var returnValue = returnItem[this.returnField];
				_LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
			}
		}, {
			key: 'gridKeyDown',
			value: function gridKeyDown(proxy) {
				if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
					var ne = proxy["nativeEvent"];
					if (ne.keyCode == 40 || ne.keyCode == 38) {
						if (ne.ctrlKey) return false;
						this.moveSelectVertical(ne.keyCode);
						return true;
						/*var newSelectIndexes = this.state.selectedIndexes;
	     if(newSelectIndexes.length == 0)
	     {
	       if(this.state.rows.length>0)
	       {
	         newSelectIndexes.push(0);
	       }
	     }
	     else
	     {
	       let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
	       let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
	       let total = this.state.rows.length;
	       if(newIndex>=0&&newIndex<total)
	       {
	         newSelectIndexes = [newIndex];
	       }
	     }
	       this.setState({selectedIndexes:newSelectIndexes});
	     return true;*/
					} else if (ne.keyCode == 13) {
						var datas = this.state.rows;
						if (!datas || datas.length == 0) return;
						var index = 0;
						if (this.state.selectedIndexes && this.state.selectedIndexes.length > 0) index = this.state.selectedIndexes[this.state.selectedIndexes.length - 1];
						var returnItem = datas[index];
						var returnValue = returnItem[this.returnField];
						_LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
					}
				}
			}
		}, {
			key: 'scrolling',
			value: function scrolling(arg) {
				try {
					if (this.scrollState && arg.scrollLeft != this.scrollState.scrollLeft) {
						//是横向滚动条 不需要动态加载数据
						this.scrollState.scrollLeft = arg.scrollLeft;
						return;
					}
					console.log(arg);
					var _divdom = arg.dom;
					if (_divdom) {
						var scrollTop,
						    maxScroll,
						    minScroll = 0;
						scrollTop = _divdom.scrollTop;
						maxScroll = _divdom.scrollHeight - _divdom.clientHeight;
						console.log(scrollTop + "------------" + maxScroll);
						if (scrollTop >= maxScroll - 2) {
							// var addrows = this.createRows(50,50);
							// var rows = this.state.rows.slice();
							// var newrows = rows.concat(addrows);
							// this.setState({rows:newrows,scrollmax:0}); 
							if (this.formDataSources.firstGroup) {
								this.formDataSources.firstGroup.scrollEndNextPage();
							}
						} else if (scrollTop <= 0) {}
					}
				} catch (e) {}
			}
		}, {
			key: 'scrollToIndex',
			value: function scrollToIndex(index) {
				var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				//alert(this.grid.props.rowHeight);
				if (index == undefined) index = 30;
				var targetTop = this.grid.props.rowHeight * (index + 1);
				var _dom = this.grid.base.viewport.canvas.rowsContainerDiv;
				//var scroll_offset = $(_dom).offset(); //得到pos 这个div层的offset，包含两个值，top和left
	
				var screenFirstRow = _dom.scrollTop / this.grid.props.rowHeight;
				var screenLastRow = screenFirstRow + _dom.clientHeight / this.grid.props.rowHeight;
				if (index > screenLastRow) targetTop -= _dom.clientHeight;else if (index > screenFirstRow) return;else targetTop -= this.grid.props.rowHeight;
				var maxScroll = _dom.scrollHeight - _dom.clientHeight;
				if (targetTop > maxScroll) targetTop = maxScroll;
				if (first) {
					targetTop += _dom.clientHeight - this.grid.props.rowHeight;
				}
				setTimeout(function () {
					$(_dom).animate({
						scrollTop: targetTop //让body的scrollTop等于pos的top，就实现了滚动 
					}, 10);
				}, 100);
			}
		}, {
			key: 'addFilterField',
			value: function addFilterField(group, arg) {
				if (!this.dataTypeRelation) return;
				var queryWhereItemTemplate = {
					qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
					Properties: {
						Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
						RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
					}
				};
				var _baseFilter = this.lookupArg["baseFilter"];
				var mainQueryWhereItem = null;
				//TODO 输入星号导致的查询 包括了输入*号导致下拉 以及 下拉已经存在的情况下输入*号
				if (arg && arg.isInputAsteriskRefresh) {
					var queryWhere = group.currentQuery.QueryTable.QueryWhere;
					var queryWhereItem = JSON.parse(JSON.stringify(queryWhereItemTemplate)); // Object.assign({},queryWhereItemTemplate);
					var fieldPro = queryWhereItem.Properties.Field;
					var valuePro = queryWhereItem.Properties.Value;
					var mainFieldName = this.lookupArg["fieldName"];
					var mainField = _GOT2.default.getTableField(this.mainTable, mainFieldName);
					if (mainField) {
						fieldPro.refentityid = this.mainTable.id;
						fieldPro.refinnerid = mainField.id;
						fieldPro.V = mainField.name;
						valuePro.V = this.lookupArg["baseFilter"];
						//TODO 用户输入*号后 如果通配符不是星号 过滤条件中应该把*号变成通配符
						// if(FormItemConst.WILDCARD != "*" && valuePro.V)
						// {
						// 	valuePro.V = valuePro.V.replace(/\*/g,FormItemConst.WILDCARD);
						// }
						if (!queryWhere.Items) queryWhere.Items = [];
						queryWhere.Items.push(queryWhereItem);
						mainQueryWhereItem = queryWhereItem;
					}
				}
	
				//QueryOnTyping时也加入JoinQuery条件
				if (this._joinQueryWhereItems && this._joinQueryWhereItems.length > 0 && group.currentQuery && _baseFilter && _baseFilter.indexOf("*") != -1) {
					var _length = this._joinQueryWhereItems.length;
					var queryWhere = group.currentQuery.QueryTable.QueryWhere;
					var skipEnum = 0;
					for (var i = 0; i < _length; i++) {
						var tableField = this._joinQueryWhereItems[i];
						var queryWhereItem = JSON.parse(JSON.stringify(queryWhereItemTemplate)); //Object.assign({},queryWhereItemTemplate);
	
						var fieldPro = queryWhereItem.Properties.Field;
						var valuePro = queryWhereItem.Properties.Value;
	
						fieldPro.refentityid = this.mainTable.id;
						fieldPro.refinnerid = tableField.id;
						if (tableField.type != "Component") fieldPro.V = tableField.name;else fieldPro.V = _GOTUtil2.default.getPropertyValue(tableField, "ArrayItem");
						//2022-03 如果像输入
						if (tableField.type == "Enum") {
							var enumItems = _GOTUtil2.default.getDataSourceByTableField(tableField);
							var _baseFilter3 = this.lookupArg["baseFilter"];var resultArr = [];
							//_baseFilter   *xxx  *xxxx* xxx*
							if (_baseFilter3) //把*号去掉
								{
									var reg = new RegExp("[\\" + _FormItemConst2.default.WILDCARD + "]{1,}", "g");
									var _baseFilter2 = _baseFilter3.replace(reg, "");
									var x_left = new RegExp(_baseFilter2 + ".*");
									var x_right = new RegExp(".*" + _baseFilter2);
									var x_mid = new RegExp(".*" + _baseFilter2 + ".*");
									var _statrWidth = _baseFilter3.indexOf(_FormItemConst2.default.WILDCARD) == 0;
									var _endWidth = _baseFilter3.indexOf(_FormItemConst2.default.WILDCARD) == _baseFilter3.length - 1;
									if (_statrWidth || _endWidth) {
										// 若输入为 *xxx* 或 *xxx 或 xxx*
										if (_statrWidth && _endWidth) {
											// 若输入为 *xxx*
											for (var _i2 = 0; _i2 < enumItems.length; _i2++) {
												var enumItem = enumItems[_i2];
												var result = enumItem.label.match(x_mid);
												if (result && result.length > 0) {
													resultArr.push(enumItem.value);
												}
											}
										} else if (_endWidth) {
											// 若输入为 xxx*
											for (var _i3 = 0; _i3 < enumItems.length; _i3++) {
												var _enumItem = enumItems[_i3];
												var result = _enumItem.label.match(x_left);
												if (result && result.length > 0) {
													resultArr.push(_enumItem.value);
												}
											}
										} else if (_statrWidth) {
											// 若输入为 *xxx
											for (var _i4 = 0; _i4 < enumItems.length; _i4++) {
												var _enumItem2 = enumItems[_i4];
												var result = _enumItem2.label.match(x_right);
												if (result && result.length > 0) {
													resultArr.push(_enumItem2.value);
												}
											}
										}
									}
									//alert(resultArr.join(","));
								}
							valuePro.V = resultArr.join(",");
							if (valuePro.V == "") {
								skipEnum++;continue;
							}
						} else {
							valuePro.V = this.lookupArg["baseFilter"];
						}
						if (!queryWhere.Items) queryWhere.Items = [];
						queryWhere.Items.push(queryWhereItem);
						queryWhereItem.Properties.AndOr.V = "Or";
						/*if(i==0)//第一个
	     {
	     	if(mainQueryWhereItem)
	     	{
	     		mainQueryWhereItem.Properties.LeftBracket.V = "(";
	     	}
	     }
	     if(i == _length - 1)//最后一个
	     {
	     	queryWhereItem.Properties.RightBracket.V = ")";
	     }*/
					}
	
					if (_length - skipEnum > 0) {
						if (mainQueryWhereItem) {
							mainQueryWhereItem.Properties.LeftBracket.V = "(";
						}
						queryWhere.Items[queryWhere.Items.length - 1].Properties.RightBracket.V = ")";
					}
				}
				var filterfieldPro = this.dataType.DataTypeRelation.Properties.FilterField;
				if (!filterfieldPro.hasOwnProperty("refentityid")) return;
	
				if (this._extralsWhereItemsRefresh && this._extralsWhereItemsRefresh.length > 0 && group.currentQuery) {
					var queryWhere = group.currentQuery.QueryTable.QueryWhere;
					for (var _i5 = 0; _i5 < this._extralsWhereItemsRefresh.length; _i5++) {
						var queryWhereItemValue = this._extralsWhereItemsRefresh[_i5];
						var queryWhereItem = JSON.parse(JSON.stringify(queryWhereItemTemplate)); //Object.assign({},queryWhereItemTemplate);
	
						var fieldPro = queryWhereItem.Properties.Field;
						var valuePro = queryWhereItem.Properties.Value;
	
						fieldPro.refentityid = filterfieldPro.refentityid;
						fieldPro.refinnerid = filterfieldPro.refinnerid;
						fieldPro.V = filterfieldPro.V;
	
						valuePro.V = queryWhereItemValue;
						if (!queryWhere.Items) queryWhere.Items = [];
						queryWhere.Items.push(queryWhereItem);
					}
				}
	
				if (this._extralsAggregationItemsRefresh && this._extralsAggregationItemsRefresh.length > 0 && group.currentQuery) {
					var queryAggregations = group.currentQuery.QueryTable.QueryAggregations;
					for (var _i6 = 0; _i6 < this._extralsAggregationItemsRefresh.length; _i6++) {
						var queryAggregationItemValue = this._extralsAggregationItemsRefresh[_i6];
	
						/*<QueryAggregation name="ItemId#Distinct" id="2" createdLayer="sys" modifiedLayer="sys">
	     	<Properties>
	     		<Property refentityid="30000030" refinnerid="30">
	     		<Name>Field</Name>
	     		<Value>ItemId</Value>
	     		</Property>
	     		<Property>
	     		<Name>Aggregation</Name>
	     		<Value>Distinct</Value>
	     		</Property>
	     	</Properties>
	     </QueryAggregation>*/
	
						var queryAggregationItem = {
							qname: "QueryAggregation", name: "", id: "", tag: "autoAppendForFormModuleLookup",
							Properties: {
								Field: { V: filterfieldPro.V, refentityid: filterfieldPro.refentityid, refinnerid: filterfieldPro.refinnerid },
								Aggregation: { V: queryAggregationItemValue }
							}
						};
	
						if (!queryAggregations.Items) queryAggregations.Items = [];
						queryAggregations.Items.push(queryAggregationItem);
					}
				}
			}
		}, {
			key: 'onGridHeaderClick',
			value: function onGridHeaderClick(columnKey, _sortDirection, lookupKey) {
	
				if (lookupKey == this.entityId + "." + this.innerId) {
					var group = this.formDataSources.firstGroup;
					if (!group) {
						var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
						group = this.formDataSources.groups[firstDataSourceName];
					}
					if (group) {
						group.sortForLookup(columnKey, _sortDirection, true, true);
					}
				}
			}
		}, {
			key: 'doDataProviderRefresh',
			value: function doDataProviderRefresh(arg) {
				var group = this.formDataSources.firstGroup;
				if (!group) {
					var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
					group = this.formDataSources.groups[firstDataSourceName];
				}
				if (group) {
					group.reSetCurrentQuery();
					if (this.lookupArg["asteriskLookupQuery"]) {
						this.lookupArg["asteriskLookupQuery"] = false;
						if (!arg) arg = {};
						arg.isInputAsteriskRefresh = true;
					}
					this.addFilterField(group, arg);
					group.executeQueryAutoSaveStop(null, null, false, false, false, arg);
					//this.executeQuery(group);
				} else {
					throw new Error("FormModuleLookup refresh not find group");
				}
			}
		}, {
			key: 'beforeClose',
			value: function beforeClose() {
				var canvas = $(this.refs["datagridcontainer" + this.entityId + this.innerId]).find(".react-grid-Canvas")[0];
				if (canvas) canvas.scrollTop = 0;
			}
		}, {
			key: 'onDataProviderRefresh',
			value: function onDataProviderRefresh(entityId, innerId) {
				if (this.entityId != entityId || this.innerId != innerId) return;
	
				//let canvas = $(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Canvas")[0];
				//if(canvas)canvas.scrollTop=0;
	
				this.doDataProviderRefresh();
			}
		}, {
			key: 'rpcDataProviderRefresh',
			value: function rpcDataProviderRefresh(formDataSourceGroupResult) {
				var finalDatas = _RecordsUtil2.default.getOneLevelDatas(formDataSourceGroupResult, this.mainTable.name);
				this.setState({ rows: finalDatas, selectedIndexes: [0], scrollmax: 0 });
			}
	
			//输入*号导致了查询
	
		}, {
			key: 'onAsteriskRefresh',
			value: function onAsteriskRefresh(entityId, innerId, filter) {
				if (this.entityId != entityId || this.innerId != innerId) return;
				this.lookupArg["baseFilter"] = filter;
				this.doDataProviderRefresh({ appendFilter: true, isInputAsteriskRefresh: true });
			}
		}, {
			key: 'queryBoxClear',
			value: function queryBoxClear() {}
		}, {
			key: 'setExtralAggregationItemValueForRefresh',
			value: function setExtralAggregationItemValueForRefresh() {
				var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (append == true) {
					if (this._extralsAggregationItemsRefresh == null) this._extralsAggregationItemsRefresh = [];
				} else {
					this._extralsAggregationItemsRefresh = [];
				}
	
				for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					params[_key - 1] = arguments[_key];
				}
	
				for (var i in params) {
					var item = params[i];
					this._extralsAggregationItemsRefresh.push(item);
				}
			}
		}, {
			key: 'setExtralWhereItemValueForRefresh',
			value: function setExtralWhereItemValueForRefresh() {
				var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (append == true) {
					if (this._extralsWhereItemsRefresh == null) this._extralsWhereItemsRefresh = [];
				} else {
					this._extralsWhereItemsRefresh = [];
				}
	
				for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
					params[_key2 - 1] = arguments[_key2];
				}
	
				for (var i in params) {
					var item = params[i];
					this._extralsWhereItemsRefresh.push(item);
				}
			}
		}, {
			key: 'onLookupHostKeydown',
			value: function onLookupHostKeydown(lookupKey, e) {
				if (this.props.lookupKey == lookupKey) {
					this.moveSelectVertical(e.keyCode);
					var methodName = 'onPress' + e.key;
					if (typeof this.grid[methodName] === 'function') {
						this.grid[methodName](e);
					}
				}
			}
		}, {
			key: 'moveSelectVertical',
			value: function moveSelectVertical(keyCode) {
				if (keyCode == 40 || keyCode == 38) {
					var record = null;
					var newSelectIndexes = this.state.selectedIndexes;
					if (newSelectIndexes.length == 0) {
						if (this.state.rows.length > 0) {
							record = keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
							newSelectIndexes.push(0);
						}
					} else {
						var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
						var newIndex = keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
						var total = this.state.rows.length;
						if (newIndex >= 0 && newIndex < total) {
							record = this.state.rows[newIndex];
							newSelectIndexes = [newIndex];
						}
					}
					var selected = this.grid.state.selected;
					var colIndex = 0;
					if (selected) colIndex = selected.idx;
					var rowIndex = newSelectIndexes && newSelectIndexes.length > 0 ? newSelectIndexes[0] : 0;
					this.setState({ selectedIndexes: newSelectIndexes });
	
					//this.grid.doOnSelect({rowIndex:rowIndex,idx:colIndex,active:false});	
					//$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Row.row-selected>.react-grid-Cell.row-selected")[colIndex].focus();
					//console.log("rowIndex:"+rowIndex+"   newSelectIndexes"+JSON.stringify(newSelectIndexes));
					//this.grid.doOnSelect({idx:idx,rowIdx:rowIdx,active:false});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				//alert(this.entityId+" "+this.innerId);
				for (var key in this.formDataSources.groups) {
					var group = this.formDataSources.groups[key];
					group.initFormQuery();
				}
				//根据dataTypeRelationItem中的Fixed，补充QueryWhereItem
				this.addFixedWhereItem();
				this.addSysActiveWhereItem();
				this.addshortcutWhereItem();
	
				this.bindResize(this.outterDiv ? this.outterDiv : this.refs["datagridcontainer" + this.entityId + this.innerId]);
				//document.getElementById("selectedLookup"));
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.waitingInitFocus == true) {
					this.waitingInitFocus = false;
					var selectedCells = $(this.refs["datagridcontainer" + this.entityId + this.innerId]).find(".react-grid-Cell.row-selected");
					if (selectedCells.length == 0) {
						return;
					}
	
					this.grid.doOnSelect({ idx: 1, rowIdx: 0, active: false });
					selectedCells[0].focus();
				}
			}
		}, {
			key: 'addshortcutWhereItem',
			value: function addshortcutWhereItem() {
				var shortcutfield = _GOTUtil2.default.getShortCut(this.mainTable);
				if (shortcutfield != null) {
					var group = this.formDataSources.firstGroup;
					var queryWhere = group.formQuery.QueryTable.QueryWhere;
					if (!queryWhere.Items) queryWhere.Items = [];
					var queryWhereItem = {
						qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
						Properties: {
							Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
							RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
						}
					};
					queryWhereItem.tag = "shortcut";
					var fieldPro = queryWhereItem.Properties.Field;
					var valuePro = queryWhereItem.Properties.Value;
	
					fieldPro.refentityid = this.mainTable.id;
					fieldPro.refinnerid = shortcutfield.id;
					fieldPro.V = shortcutfield.name;
	
					valuePro.Value = "";
	
					queryWhere.Items.push(queryWhereItem);
				}
			}
		}, {
			key: 'addSysActiveWhereItem',
			value: function addSysActiveWhereItem() {
				if (!this.formDataSources) throw new Error("formDataSources");
				var group = this.formDataSources.firstGroup;
				if (group.formQuery) {
					var dataType = this.dataType;
					var sysactivePro = dataType.Properties.SysActive || dataType.Properties.FilterSysActive;
					if (!sysactivePro) return;
					var queryWhere = null;var queryWhereItem;var fieldPro;var valuePro;
					if (sysactivePro.V == "true" || sysactivePro.V == true) {
						var tableFields = this.mainTable.TableFields;
	
						for (var i = 0; i < tableFields.length; i++) {
							var tableField = tableFields[i];
							//暂时这样判断是继承系统SysActive
							if ((tableField.name == "SysActive" || tableField.name == "Active") && _GOTUtil2.default.getPropertyValue(tableField, "Extends") == "SysActive") {
								if (queryWhere == null) queryWhere = group.formQuery.QueryTable.QueryWhere;
								queryWhereItem = {
									qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
									Properties: {
										Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
										RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
									}
								};
	
								queryWhereItem.tag = "sysactive";
								fieldPro = queryWhereItem.Properties.Field;
								valuePro = queryWhereItem.Properties.Value;
	
								fieldPro.refentityid = this.mainTable.id;
								fieldPro.refinnerid = tableField.id;
								fieldPro.V = tableField.name;
								valuePro.V = true;
								if (!queryWhere.Items) queryWhere.Items = [];
								queryWhere.Items.push(queryWhereItem);
								break;
							}
						}
					}
				}
			}
		}, {
			key: 'addFixedWhereItem',
			value: function addFixedWhereItem() {
				if (!this.formDataSources) throw new Error("formDataSources");
				var group = this.formDataSources.firstGroup;
				if (group.formQuery) {
					if (this.dataTypeRelationFixedItems && dataTypeRelationFixedItems.length() > 0) {
						var queryWhere = group.formQuery.QueryWhere;
						var queryWhereItem;var fieldPro;var valuePro;var relationItemFieldPro;var relationItemValuePro;
						for (var i = 0; i < this.dataTypeRelationFixedItems.length; i++) {
							var dataTypeRelationFixedItem = this.dataTypeRelationFixedItems[i];
							queryWhereItem = {
								qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
								Properties: {
									Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
									RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
								}
							};
							queryWhereItem.tag = "fixed";
							fieldPro = queryWhereItem.Properties.Field;
							valuePro = queryWhereItem.Properties.Value;
							relationItemFieldPro = dataTypeRelationFixedItem.Properties.Field;
							relationItemValuePro = dataTypeRelationFixedItem.Properties.FixedValue;
							fieldPro.refentityid = relationItemFieldPro.refentityid;
							fieldPro.refinnerid = relationItemFieldPro.refinnerid;
							fieldPro.V = relationItemFieldPro.V;
							valuePro.V = relationItemValuePro.V;
							if (!queryWhere.Items) queryWhere.Items = [];
							queryWhere.Items.push(queryWhereItem);
						}
						var formQueryCopy = JSON.parse(JSON.stringify(group.formQuery));
						group.reSetCurrentQuery(formQueryCopy);
					}
				}
			}
		}, {
			key: 'closeHandler',
			value: function closeHandler() {
				_LookupActions2.default.popDropDownClose(this.entityId, this.innerId);
			}
		}, {
			key: 'lookupOnKeyDown',
			value: function lookupOnKeyDown(e) {
				if (e.keyCode == 27 || e.ctrlKey && e.keyCode == 38) {
					this.closeHandler();
				}
			}
		}, {
			key: 'returnSelectionData',
			value: function returnSelectionData() {
				var indexes = this.state.selectedIndexes;
				if (!indexes || indexes.length < 1) return;
				var returnValue = "";
				var datas = this.state.rows;
				for (var i = 0; i < indexes.length; i++) {
					var index = indexes[i];
					var returnItem = datas[index];
					var returnValueSingle = returnItem[this.returnField];
					if (i == 0) {
						returnValue += returnValueSingle;
					} else {
						returnValue += "," + returnValueSingle;
					}
				}
	
				//returnValue = returnItem[this.returnField];
				_LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
			}
		}, {
			key: 'getGridDom',
			value: function getGridDom(hasQueryList) {
				var _this2 = this;
	
				var selectionObj = {
					showCheckbox: false,
					enableShiftSelect: true,
					selectBy: {
						indexes: this.state.selectedIndexes
					}
				};
	
				var tmpMinW = this.state.gridContainerWidth + 20;
				var _style = { minWidth: (tmpMinW < 200 ? 200 : tmpMinW) + 'px', height: '250px', alignSelf: 'stretch' };
				if (!hasQueryList && !this.props.isPop) {
					//_style.paddingLeft = "5px";
					_style.paddingRight = "5px";
				}
				var buttonDom = null;var minHeight = 250;
				if (this.props.formType == "Query") {
					selectionObj.showCheckbox = true;
					selectionObj.onRowsSelected = this.onRowsSelected;
					selectionObj.onRowsDeselected = this.onRowsDeselected;
					_style.minWidth = (tmpMinW < 220 ? 220 : tmpMinW + 20) + 'px';_style.height = '280px';
					//minHeight = 330;
					buttonDom = _react2.default.createElement(
						'div',
						{ style: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', height: '30px' } },
						_react2.default.createElement(
							'button',
							{ style: { backgroundColor: 'rgb(245, 166, 35)', fontSize: '14px', border: '1px solid rgb(245, 166, 35)', color: '#fff', borderRadius: '2px' }, onClick: this.returnSelectionData.bind(this) },
							'\u8FD4\u56DE\u9009\u4E2D\u884C\u6240\u6709'
						)
					);
				}
				var _rowHeight = _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
				var _headerRowHeight = _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
				if (window.formCustomConfigs && window.formModuleInstance) {
					var formName = window.formModuleInstance.formName;
					if (window.formCustomConfigs.hasOwnProperty(formName)) {
						var _config = window.formCustomConfigs[formName];
						if (_config) {
							if (_config.autoLookupRowHeight) _rowHeight = _config.autoLookupRowHeight;
							if (_config.autoLookupHeaderRowHeight) _headerRowHeight = _config.autoLookupHeaderRowHeight;
						}
					}
				}
				return _react2.default.createElement(
					'div',
					{ className: 'datagridcontainer FormLookup_Grid_Container', style: _style,
						ref: "datagridcontainer" + this.entityId + this.innerId, onKeyDown: this.lookupOnKeyDown.bind(this) },
					_react2.default.createElement(ReactDataGrid, {
						ref: function ref(node) {
							return _this2.grid = node;
						},
						onRowClick: this.rowClick.bind(this),
						onGridKeyDown: this.gridKeyDown.bind(this),
						numColumn: true,
						columns: this._columns.slice(),
						enableCellSelect: true,
						rowGetter: this.rowGetter.bind(this),
						rowsCount: this.state.rows.length,
						rowHeight: _rowHeight,
						headerRowHeight: _headerRowHeight,
						onScroll: this.scrolling.bind(this),
						minHeight: minHeight,
						containerWidth100: this.state.containerWidth100,
						fixedContainerWidth: this.fixedContainerWidth,
						rowSelection: selectionObj
					}),
					buttonDom
				);
			}
		}, {
			key: 'getQueryListDom',
			value: function getQueryListDom() {
				if (this.autoQueryFields && this.autoQueryFields.length > 0) {
					var _getEditor = this.getEditor.bind(this);
					return this.autoQueryFields.map(function (item) {
						return _getEditor(item);
					});
				} else {
					return null;
				}
			}
		}, {
			key: 'getEditor',
			value: function getEditor(item) {
				var editorType = item.type;
				var itemProperties = _GOTPropertiesUtil2.default.getItemPropertyFinalValue(null, this.mainTable.id, item.id, this.mainTable);
				var _displayLength = itemProperties.DisplayLength;
				var _id = _CommonUtil2.default.guid();
				if (editorType == "String") {
					return _react2.default.createElement(_AutoLookupStringEditor2.default, { displayLength: _displayLength, id: _id, key: item.id, label: itemProperties.Label,
						lookupKey: this.lookupKey, tableField: item, trim: itemProperties.Trim, changeCase: itemProperties.ChangeCase,
						stringSize: itemProperties.StringSize, regular: itemProperties.Regular, initFocus: item.focusIn });
				} else if (editorType == "Long") {
					return _react2.default.createElement(_AutoLookupLongEditor2.default, { displayLength: _displayLength, id: _id, key: item.id, label: itemProperties.Label,
						allowNegative: itemProperties.AllowNegative, showZero: itemProperties.ShowZero, thousandSeperator: itemProperties.ThousandSeperator,
						lookupKey: this.lookupKey, tableField: item, initFocus: item.focusIn });
				} else if (editorType == "Date") {
					return _react2.default.createElement(_AutoLookupDateEditor2.default, { displayLength: _displayLength, id: _id, key: item.id, label: itemProperties.Label,
						show1970: itemProperties.Show1970, seperator: itemProperties.Seperator, numOfDay: itemProperties.NumOfDay,
						numOfMonth: itemProperties.NumOfMonth, numOfYear: itemProperties.NumOfYear, lookupKey: this.lookupKey, tableField: item, initFocus: item.focusIn });
				} else if (editorType == "Decimal")
					//AllowNegative: false DisplayHeight: 1 DisplayLength: 11 Label: "Bair" NumOfDecimals: 2 Regular: "" RoundOff: "HalfUp" ShowDecimals: 0 ShowZero: true ThousandSeperator: false
					{
						return _react2.default.createElement(_AutoLookupDecimalEditor2.default, { displayStyle: itemProperties.displayStyle, displayLength: _displayLength, id: _id, key: item.id, label: itemProperties.Label,
							numOfDecimals: itemProperties.NumOfDecimals, allowNegative: itemProperties.AllowNegative, roundOff: itemProperties.RoundOff, thousandSeperator: itemProperties.ThousandSeperator, showZero: itemProperties.ShowZero,
							lookupKey: this.lookupKey, tableField: item, initFocus: item.focusIn });
					}
			}
		}, {
			key: 'queryHandler',
			value: function queryHandler() {
				var args = {};
				_LookupActions2.default.lookupAutoQuery(this.lookupKey, args);
				var group = this.formDataSources.firstGroup;
				if (!group) {
					var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
					group = this.formDataSources.groups[firstDataSourceName];
				}
				if (!group) return;
				group.reSetCurrentQuery();
				for (var key in args) {
					var _value = args[key];
					_QueryUtil2.default.createWhereItemByField(key, key, this.mainTable.name, group.currentQuery, _value);
				}
				group.executeQueryAutoSaveStop();
			}
		}, {
			key: 'queryClear',
			value: function queryClear() {
				var group = this.formDataSources.firstGroup;
				if (!group) {
					var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
					group = this.formDataSources.groups[firstDataSourceName];
				}
				if (!group) return;
				group.reSetCurrentQuery();
				group.executeQueryAutoSaveStop();
			}
		}, {
			key: 'resizeMouseDown',
			value: function resizeMouseDown(el, e) {
				var offset = el.offsetParent;
				var x = 0;
				var y = 0;
				var right_x = e.pageX - offset.offsetLeft - el.offsetWidth; //获得鼠标指针离DIV元素左边界的距离
				var bottom_y = e.pageY - offset.offsetTop - el.offsetHeight; //获得鼠标指针离DIV元素上边界的距离
				if (right_x < -5 || right_x > 5) {
					return;
				}
				//按下元素后，计算当前鼠标与对象计算后的坐标  
				x = e.clientX - el.offsetWidth, y = e.clientY - el.offsetHeight;
				var columns = this._columns;
				var lastColumn = columns && columns.length > 0 ? columns[columns.length - 1] : null;
				var _resizeMouseMove = this.resizeMouseMove.bind(this, x, e.clientX, lastColumn ? lastColumn.width : -1);
				var _resizeMouseUp = this.resizeMouseUp.bind(this, el);
				//在支持 setCapture 做些东东  
				el.setCapture ? (
				//捕捉焦点   
				el.setCapture(),
				//设置事件   
				el.onmousemove = _resizeMouseMove, el.onmouseup = _resizeMouseUp) :
				//绑定事件   
				$(document).bind("mousemove", _resizeMouseMove).bind("mouseup", _resizeMouseUp);
				//防止默认事件发生   
				e.preventDefault();
			}
		}, {
			key: 'resizeMouseMove',
			value: function resizeMouseMove(x, origX, startWidth, e) {
				e = e || event;
				var columns = this._columns;
				if (columns) columns = columns.slice();
				var lastColumn = columns && columns.length > 0 ? columns[columns.length - 1] : null;
				//let nowWidth = e.clientX-x;
				if (lastColumn) {
					lastColumn = Object.assign({}, lastColumn);
					lastColumn.width = startWidth + e.clientX - origX;
					columns.splice(columns.length - 1, 1, lastColumn);
					this._columns = columns;
				}
	
				var _gridContainerWidth = e.clientX - x;
				this.fixedContainerWidth = _gridContainerWidth;
				this.setState({
					gridContainerWidth: _gridContainerWidth
				});
			}
	
			//停止事件   
	
		}, {
			key: 'resizeMouseUp',
			value: function resizeMouseUp(el, e) {
				//在支持 releaseCapture 做些东东   
				el.releaseCapture ? (
				//释放焦点   
				el.releaseCapture(),
				//移除事件   
				el.onmousemove = el.onmouseup = null) :
				//卸载事件   
				$(document).unbind("mousemove").unbind("mouseup");
			}
		}, {
			key: 'bindResize',
			value: function bindResize(el) {
				//初始化参数   
				var els = el.style;
				//鼠标的 X 和 Y 轴坐标   
	
				//el.style.cursor = "e-resize";
				el.childNodes[0].style.cursor = "text";
				$(el).mousedown(this.resizeMouseDown.bind(this, el));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var queryListDom = this.getQueryListDom();
				var hasQueryList = queryListDom ? true : false;
				var gridDom = this.getGridDom(hasQueryList);
				var resizeDom = _react2.default.createElement('div', { style: { position: 'absolute', right: 0,
						bottom: 0, height: '100%', width: '5px', cursor: 'e-resize' } });
				if (this.props.isPop) {
					if (!queryListDom) {
						return _react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this3.outterDiv = node;
								}, style: { alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px", paddingRight: "5px", paddingLeft: "5px" } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header', style: { background: "#ffffff", padding: "5px", position: "relative", height: "30px" } },
								_react2.default.createElement('i', { className: 'fa fa-close', style: { position: "absolute", top: "7px", right: "10px", fontSize: "15px", cursor: "pointer" }, onClick: this.closeHandler.bind(this) })
							),
							resizeDom,
							gridDom
						);
					} else {
						return _react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this3.outterDiv = node;
								}, style: { alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px", paddingRight: "5px", paddingLeft: "5px" } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header', style: { background: "#ffffff", padding: "5px", position: "relative", height: "30px" } },
								_react2.default.createElement('i', { className: 'fa fa-close', style: { position: "absolute", top: "7px", right: "10px", fontSize: "15px", cursor: "pointer" }, onClick: this.closeHandler.bind(this) })
							),
							resizeDom,
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'column' } },
								_react2.default.createElement(
									'div',
									{ style: { display: 'flex', flexDirection: 'row', marginTop: '5px', marginBottom: '5px' } },
									queryListDom,
									_react2.default.createElement(
										'div',
										{ style: { marginLeft: '10px', display: 'flex', flexDirection: 'row' } },
										_react2.default.createElement(
											'button',
											{ ref: function ref(node) {
													return _this3.btnQuery = node;
												}, className: 'btn btn-info', onClick: this.queryHandler.bind(this), style: { height: _FormItemConst2.default.EDITOR_HEIGHT + 'px' } },
											'\u67E5\u8BE2'
										),
										_react2.default.createElement(
											'button',
											{ ref: function ref(node) {
													return _this3.btnQuery = node;
												}, className: 'btn btn-info', onClick: this.queryClear.bind(this), style: { height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', marginLeft: '5px' } },
											'\u91CD\u7F6E'
										)
									)
								),
								gridDom
							)
						);
					}
				} else {
					if (queryListDom) {
						return _react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this3.outterDiv = node;
								}, style: { display: 'flex', flexDirection: 'column', paddingRight: '5px', paddingLeft: '5px' } },
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'row', marginTop: '5px', marginBottom: '5px' } },
								queryListDom,
								_react2.default.createElement(
									'div',
									{ style: { marginLeft: '10px', display: 'flex', flexDirection: 'row' } },
									_react2.default.createElement(
										'button',
										{ ref: function ref(node) {
												return _this3.btnQuery = node;
											}, className: 'btn btn-info', onClick: this.queryHandler.bind(this), style: { height: _FormItemConst2.default.EDITOR_HEIGHT + 'px' } },
										'\u67E5\u8BE2'
									),
									_react2.default.createElement(
										'button',
										{ ref: function ref(node) {
												return _this3.btnQuery = node;
											}, className: 'btn btn-info', onClick: this.queryClear.bind(this), style: { height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', marginLeft: '5px' } },
										'\u91CD\u7F6E'
									)
								),
								resizeDom
							),
							gridDom
						);
					} else {
						return gridDom;
					}
				}
			}
		}]);
	
		return FormLookup;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
		var _this4 = this;
	
		this.onRowsSelected = function (rows) {
			_this4.setState({
				selectedIndexes: _this4.state.selectedIndexes.concat(rows.map(function (r) {
					return r.rowIdx;
				}))
			});
		};
	
		this.onRowsDeselected = function (rows) {
			var rowIndexes = rows.map(function (r) {
				return r.rowIdx;
			});
			_this4.setState({
				selectedIndexes: _this4.state.selectedIndexes.filter(function (i) {
					return rowIndexes.indexOf(i) === -1;
				})
			});
		};
	};
	
	;
	FormLookup.defaultProps = {};
	
	module.exports = FormLookup;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _LookupRefreshStore = __webpack_require__(77);
	
	var _LookupRefreshStore2 = _interopRequireDefault(_LookupRefreshStore);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _FormItemStringRenderForAutoLookup = __webpack_require__(138);
	
	var _FormItemStringRenderForAutoLookup2 = _interopRequireDefault(_FormItemStringRenderForAutoLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var FormLookupServerAllSpec = function (_React$Component) {
		_inherits(FormLookupServerAllSpec, _React$Component);
	
		function FormLookupServerAllSpec(props) {
			_classCallCheck(this, FormLookupServerAllSpec);
	
			var _this = _possibleConstructorReturn(this, (FormLookupServerAllSpec.__proto__ || Object.getPrototypeOf(FormLookupServerAllSpec)).call(this, props));
	
			_this.classAlias = "FormLookupServerAllSpec";
			_this.entityId = _this.props.entityId;
			_this.innerId = _this.props.innerId;
			_this.groupAlias = _this.props.groupAlias;
			_this.fieldName = _this.props.fieldName;
			_this.unsubscribeLookupCmpStore = _LookupRefreshStore2.default.listen(_this.onDataProviderRefresh.bind(_this));
			var gridColumns = _this.props.remoteArg.columns;var columns = [];var totalWidth = 100;
			if (gridColumns) {
				totalWidth = 0;
				for (var i = 0; i < gridColumns.length; i++) {
					var column = {};column.editable = false;column.resizable = true;
					var gridColumn = gridColumns[i];
					column.key = gridColumn.dataField;
					column.key = _StringUtil2.default.convertToFirstLowerCase(column.key);
					var _width = void 0;
					if (column.width) _width = gridColumn.width;else _width = gridColumn.displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;
					column.formatter = _react2.default.createElement(_FormItemStringRenderForAutoLookup2.default, { dataField: gridColumn.dataField });
					column.width = _width;
					totalWidth += _width;
					column.name = gridColumn.label;
					columns.push(column);
				}
			}
			if (totalWidth < _this.props.minWidth) totalWidth = _this.props.minWidth;
			_this._columns = columns;
			_this.state = { rows: [], selectedIndexes: [0], scrollmax: 0, gridContainerWidth: totalWidth };
			return _this;
		}
	
		_createClass(FormLookupServerAllSpec, [{
			key: 'onDataProviderRefresh',
			value: function onDataProviderRefresh(entityId, innerId) {
				if (this.entityId != entityId || this.innerId != innerId) return;
				var fm = window.formModuleInstance;
				if (fm == null) return;
				var formId = fm.formId;var cmdargInfo = void 0;
	
				if (!this.groupAlias) {
					cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo("lookup_" + this.fieldName, window.menuItemId, window.formId);
				} else {
					cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo(this.groupAlias + "." + "lookup_" + this.fieldName, window.menuItemId, window.formId);
				}
	
				if (cmdargInfo) {
					var baseRecord = this.lookupArg["baseRecord"];
					if (baseRecord && baseRecord.visualLength && typeof baseRecord.visualLength == "function") delete baseRecord["visualLength"];
					//cmdargInfo.fetchOption = true;
					var arg = _CommandResolver2.default.getSendCmd(window.formModuleInstance, this.groupAlias, cmdargInfo);
					var command = _CommandHelper2.default.createFormInstance(window.formModuleInstance.formName, "doLookup").appendArg(arg, "CommandArg").appendArg(this.lookupArg["groupAlias"], "String").appendArg(this.fieldName, "String").appendArg(this.lookupArg["filterFieldName"], "String").appendArg(this.lookupArg["baseFilter"], "String").appendArg(this.lookupArg["baseRecord"], "Object").appendArg(this.lookupArg["queryObject"], "Object").appendArg("true", "boolean").appendArg("0", "int").appendArg("50", "int").appendArg("true", "boolean");
					var remoteArg = { command: command, resultFunction: this.rpc_result_refreshData.bind(this) };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			}
		}, {
			key: 'rpc_result_refreshData',
			value: function rpc_result_refreshData(data) {
				//TODO 按照Flex代码逻辑 有可能出现多层数据结构的情况 需要数据转换成单层
				var result = data.result;
				if (result) {
					this.setState({ rows: result.dataResult ? result.dataResult : [], selectedIndexes: [0] });
				}
			}
		}, {
			key: 'rowGetter',
			value: function rowGetter(i) {
				return this.state.rows[i];
			}
		}, {
			key: 'rowClick',
			value: function rowClick(index, record, proxy) {
				if (this.props.remoteArg.returnFields && this.props.remoteArg.returnFields.length > 0) {
					var datas = this.state.rows;
					var returnItem = datas[index];
					var castedReturnItem = this.castLookupReturnFields(this.props.remoteArg.returnFields, returnItem);
					_LookupActions2.default.lookupReturn(castedReturnItem, this.props.entityId, this.props.innerId);
				}
			}
		}, {
			key: 'castLookupReturnFields',
			value: function castLookupReturnFields(arr, fromRecord) {
				for (var i = 0; i < arr.length; i++) {
					var flrf = arr[i];
					var _from = _StringUtil2.default.convertToEachFirstLowerCase(flrf.fromDataField);
					//let _from = flrf.fromDataField;
					var _fromObj = void 0;var fromValue = void 0;
					//TODO 按照Flex代码逻辑 有可能出现多层数据结构的情况 需要数据转换成单层
					if (fromRecord.hasOwnProperty(_from) || fromRecord.hasOwnProperty(flrf.fromDataField)) {
						_fromObj = fromRecord[_from] ? fromRecord[_from] : fromRecord[flrf.fromDataField];
					}
	
					fromValue = _fromObj;
					flrf.fromValue = fromValue;
				}
				return arr;
			}
		}, {
			key: 'gridKeyDown',
			value: function gridKeyDown(proxy) {
				if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
					var ne = proxy["nativeEvent"];
					if (ne.keyCode == 40 || ne.keyCode == 38) {
						this.moveSelectVertical(ne.keyCode);
					} else if (ne.keyCode == 13) {
						var datas = this.state.rows;
						if (!datas || datas.length == 0) return;
						var index = 0;
						if (this.state.selectedIndexes && this.state.selectedIndexes.length > 0) index = this.state.selectedIndexes[this.state.selectedIndexes.length - 1];
						var returnItem = datas[index];
						var returnValue = returnItem[this.returnField];
						_LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
					}
				}
			}
		}, {
			key: 'moveSelectVertical',
			value: function moveSelectVertical(keyCode) {
				if (keyCode == 40 || keyCode == 38) {
					var record = null;
					var newSelectIndexes = this.state.selectedIndexes;
					if (newSelectIndexes.length == 0) {
						if (this.state.rows.length > 0) {
							record = keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
							newSelectIndexes.push(0);
						}
					} else {
						var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
						var newIndex = keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
						var total = this.state.rows.length;
						if (newIndex >= 0 && newIndex < total) {
							record = this.state.rows[newIndex];
							newSelectIndexes = [newIndex];
						}
					}
					var selected = this.grid.state.selected;
					var colIndex = 0;
					if (selected) colIndex = selected.idx;
					var rowIndex = newSelectIndexes && newSelectIndexes.length > 0 ? newSelectIndexes[0] : 0;
					this.setState({ selectedIndexes: newSelectIndexes });
	
					this.grid.doOnSelect({ rowIndex: rowIndex, idx: colIndex, active: false });
					$(this.refs["datagridcontainer" + this.entityId + this.innerId]).find(".react-grid-Row.row-selected>.react-grid-Cell.row-selected")[colIndex].focus();
					console.log("rowIndex:" + rowIndex + "   newSelectIndexes" + JSON.stringify(newSelectIndexes));
					//this.grid.doOnSelect({idx:idx,rowIdx:rowIdx,active:false});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'datagridcontainer', style: { width: this.state.gridContainerWidth + 40 + 'px', height: '210px', display: 'flex' },
						ref: "datagridcontainer" + this.entityId + this.innerId, id: "datagridcontainerLookup" + this.entityId + this.innerId },
					_react2.default.createElement(ReactDataGrid, {
						ref: function ref(node) {
							return _this2.grid = node;
						},
						onRowClick: this.rowClick.bind(this),
						onGridKeyDown: this.gridKeyDown.bind(this),
						numColumn: true,
						columns: this._columns,
						enableCellSelect: true,
						rowGetter: this.rowGetter.bind(this),
						rowsCount: this.state.rows.length,
						rowHeight: _FormItemConst2.default.DATAGRID_ROW_HEIGHT,
						headerRowHeight: _FormItemConst2.default.DATAGRID_HEADER_HEIGHT,
						minHeight: 200,
						rowSelection: {
							showCheckbox: false,
							enableShiftSelect: true,
							selectBy: {
								indexes: this.state.selectedIndexes
							}
						}
					})
				);
			}
		}]);
	
		return FormLookupServerAllSpec;
	}(_react2.default.Component);
	
	exports.default = FormLookupServerAllSpec;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _RecordsUtil = __webpack_require__(64);
	
	var _RecordsUtil2 = _interopRequireDefault(_RecordsUtil);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _FormLookupRenderFactory = __webpack_require__(149);
	
	var _FormLookupRenderFactory2 = _interopRequireDefault(_FormLookupRenderFactory);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _LookupRefreshStore = __webpack_require__(77);
	
	var _LookupRefreshStore2 = _interopRequireDefault(_LookupRefreshStore);
	
	var _LookupStores = __webpack_require__(34);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _FormDataSources = __webpack_require__(50);
	
	var _FormDataSources2 = _interopRequireDefault(_FormDataSources);
	
	var _LookupActions = __webpack_require__(25);
	
	var _LookupActions2 = _interopRequireDefault(_LookupActions);
	
	var _FormLookupFactory = __webpack_require__(65);
	
	var _FormLookupFactory2 = _interopRequireDefault(_FormLookupFactory);
	
	var _GOTPropertiesUtil = __webpack_require__(62);
	
	var _GOTPropertiesUtil2 = _interopRequireDefault(_GOTPropertiesUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var FormLookupServerSpec = function (_React$Component) {
		_inherits(FormLookupServerSpec, _React$Component);
	
		function FormLookupServerSpec(props) {
			_classCallCheck(this, FormLookupServerSpec);
	
			var _this = _possibleConstructorReturn(this, (FormLookupServerSpec.__proto__ || Object.getPrototypeOf(FormLookupServerSpec)).call(this, props));
	
			_this.entityId = _this.props.entityId;
			_this.innerId = _this.props.innerId;
			_this.lookupKey = _this.entityId + "." + _this.innerId;
			_this.classAlias = "FormLookup";
	
			_this._extralsWhereItemsRefresh = null;
			_this.queryBoxClear = _this.queryBoxClear.bind(_this);
			_this.unsubscribeLookupCmpStore = _LookupRefreshStore2.default.listen(_this.onDataProviderRefresh.bind(_this));
			_this.unsubscribeLookupasteriskRefreshStore = _LookupStores.LookupasteriskRefreshStore.listen(_this.onAsteriskRefresh.bind(_this));
			_this.unsubscribeLookupHostKeydownStore = _LookupStores.LookupHostKeydownStore.listen(_this.onLookupHostKeydown.bind(_this));
	
			_this.unsubscribeRecordsCmpStore = _RecordsStore.RecordsCmpStore.listen(_this.onExecuteCmp.bind(_this));
	
			_this.dataType = _this.props.dataType;
			var dataTypeRelation = _this.dataType.DataTypeRelation;
			var mainTablePro = dataTypeRelation.Properties.Table;
			var mainTable = null;
			if (mainTablePro.hasOwnProperty("refentityid")) {
				mainTable = _GOT2.default.getTable(mainTablePro.refentityid);
			}
	
			var dataTypeRelationNormalItem = _GOT2.default.getDataTypeRelationNormalItem(dataTypeRelation);
	
			var dataTypeRelationFixed = _GOT2.default.getDataTypeRelationFixedItem(dataTypeRelation);
	
			_this.dataTypeRelationNormalItem = dataTypeRelationNormalItem;
			_this.dataTypeRelationFixed = dataTypeRelationFixed;
			_this.dataTypeRelation = dataTypeRelation;
			_this.mainTable = mainTable;
			_this.returnField = _this.getReturnField(dataTypeRelationNormalItem, mainTable);
			_this.returnFields = _this.props.formLookupRemote.returnFields;
			_this.autoReturn = true;
	
			var totalWidth = 0;var columns = [];
			for (var i = 0; i < _this.props.formLookupRemote.columns.length; i++) {
				var column = _this.props.formLookupRemote.columns[i];
				var tableField = _GOT2.default.getTableField(_this.mainTable, column.dataField);
				var type = tableField.type;
				var name = tableField.name;
				var column = {};
	
				var _dataField = mainTable.name + "." + _StringUtil2.default.convertToFirstLowerCase(name);
				var _label = column.label ? column.label : tableField.hasOwnProperty("shortcut") ? "快捷码" : _GOTUtil2.default.getFinalValue(tableField, mainTable, "Label");
				var render = _FormLookupRenderFactory2.default.getLookupRender(type, _dataField, mainTable.id, tableField.id);
				var displayLength = column.displayLength ? column.displayLength : _GOTUtil2.default.getFinalValue(tableField, mainTable, "DisplayLength");
				var _width = column.width ? column.width : Number(displayLength) * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;totalWidth += _width;column.width = _width;
				column.formatter = render;column.name = _label;column.key = _dataField;column.editable = false;column.resizable = true;
				columns.push(column);
			}
	
			_this._columns = columns;
			_this.formXML = JSON.parse(JSON.stringify(_FormLookupFactory2.default.formLookupXMLTemplate));
			_this.setFormDataSources();
			_this.state = { rows: [], selectedIndexes: [], scrollmax: 0, gridContainerWidth: totalWidth, updateMinHeight: -1, containerWidth100: false };
			return _this;
		}
	
		_createClass(FormLookupServerSpec, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeLookupCmpStore();
				this.unsubscribeLookupasteriskRefreshStore();
				this.unsubscribeLookupHostKeydownStore();
				this.unsubscribeRecordsCmpStore();
				this.formDataSources.componentWillUnmount();
			}
		}, {
			key: 'onExecuteCmp',
			value: function onExecuteCmp(data, groupAlias, group) {
				if (this.formDataSources.firstGroup == group) {
					this.setState({ rows: data, selectedIndexes: [0] });
					// if(data && data.length>0)
					// {
					// 	this.grid.doOnSelect({rowIndex:0,idx:0,active:false});
					// 	$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Cell.row-selected")[0].focus();
					// }
				}
			}
		}, {
			key: 'setFormDataSources',
			value: function setFormDataSources() {
				var formDataSource = this.formXML.FormDataSources.DataSources[0];
	
				var tablePro = formDataSource.Properties["Table"];
				tablePro.refentityid = this.mainTable.id;
				tablePro.Value = this.mainTable.name;
				//自动构建的下拉换面的别名就是表名 不存在关联表 肯定不会重复 其被用作后台查询的数据的键值
				//与dataGrid中列的dataField也是一致
				formDataSource.name = this.mainTable.name;
				this.formDataSources = new _FormDataSources2.default(this.formXML.FormDataSources, this, true);
			}
		}, {
			key: 'getReturnField',
			value: function getReturnField(dataTypeRelationNormalItem, mainTable) {
				var fieldValue = dataTypeRelationNormalItem.Properties.Field.V;
				if (fieldValue == "") {
					throw new Error("miss FieldValue");
				}
				return mainTable.name + "." + fieldValue.substr(0, 1).toLowerCase() + fieldValue.substr(1);
			}
		}, {
			key: 'rowGetter',
			value: function rowGetter(i) {
				return this.state.rows[i];
			}
		}, {
			key: 'rowClick',
			value: function rowClick(index, record, proxy) {
				//alert("点击");
				var datas = this.state.rows;
				var returnItem = datas[index];
				var returnValue = returnItem[this.returnField];
				_LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
			}
		}, {
			key: 'gridKeyDown',
			value: function gridKeyDown(proxy) {
				if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
					var ne = proxy["nativeEvent"];
					if (ne.keyCode == 40 || ne.keyCode == 38) {
						this.moveSelectVertical(ne.keyCode);
						return;
						var newSelectIndexes = this.state.selectedIndexes;
						if (newSelectIndexes.length == 0) {
							if (this.state.rows.length > 0) {
								newSelectIndexes.push(0);
							}
						} else {
							var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
							var newIndex = ne.keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
							var total = this.state.rows.length;
							if (newIndex >= 0 && newIndex < total) {
								newSelectIndexes = [newIndex];
							}
						}
	
						this.setState({ selectedIndexes: newSelectIndexes });
						return true;
					} else if (ne.keyCode == 13) {
						var datas = this.state.rows;
						if (!datas || datas.length == 0) return;
						var index = 0;
						if (this.state.selectedIndexes && this.state.selectedIndexes.length > 0) index = this.state.selectedIndexes[this.state.selectedIndexes.length - 1];
						var returnItem = datas[index];
						var returnValue = returnItem[this.returnField];
						_LookupActions2.default.lookupReturn(returnValue, this.props.entityId, this.props.innerId);
					}
				}
			}
		}, {
			key: 'scrolling',
			value: function scrolling(arg) {
				try {
					if (this.scrollState && arg.scrollLeft != this.scrollState.scrollLeft) {
						//是横向滚动条 不需要动态加载数据
						this.scrollState.scrollLeft = arg.scrollLeft;
						return;
					}
					console.log(arg);
					var _divdom = arg.dom;
					if (_divdom) {
						var scrollTop,
						    maxScroll,
						    minScroll = 0;
						scrollTop = _divdom.scrollTop;
						maxScroll = _divdom.scrollHeight - _divdom.clientHeight;
						console.log(scrollTop + "------------" + maxScroll);
						if (scrollTop >= maxScroll - 2) {
							// var addrows = this.createRows(50,50);
							// var rows = this.state.rows.slice();
							// var newrows = rows.concat(addrows);
							// this.setState({rows:newrows,scrollmax:0}); 
							if (this.formDataSources.firstGroup) {
								this.formDataSources.firstGroup.scrollEndNextPage();
							}
						} else if (scrollTop <= 0) {}
					}
				} catch (e) {}
			}
		}, {
			key: 'addFilterField',
			value: function addFilterField(group) {
				if (this._extralsWhereItemsRefresh && this._extralsWhereItemsRefresh.length > 0 && group.currentQuery) {
					if (this.dataTypeRelation) {
						var filterfieldPro = this.dataType.DataTypeRelation.Properties.FilterField;
						if (filterfieldPro.hasOwnProperty("refentityid")) {
							var queryWhere = group.currentQuery.QueryTable.QueryWhere;
							for (var i = 0; i < this._extralsWhereItemsRefresh.length; i++) {
								var queryWhereItemValue = this._extralsWhereItemsRefresh[i];
								var queryWhereItem = {
									qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
									Properties: {
										Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
										RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
									}
								};
	
								var fieldPro = queryWhereItem.Properties.Field;
								var valuePro = queryWhereItem.Properties.Value;
	
								fieldPro.refentityid = filterfieldPro.refentityid;
								fieldPro.refinnerid = filterfieldPro.refinnerid;
								fieldPro.V = filterfieldPro.V;
	
								valuePro.V = queryWhereItemValue;
								if (!queryWhere.Items) queryWhere.Items = [];
								queryWhere.Items.push(queryWhereItem);
							}
						}
					}
				}
			}
		}, {
			key: 'doDataProviderRefresh',
			value: function doDataProviderRefresh(arg) {
				var group = this.formDataSources.firstGroup;
				if (!group) {
					var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
					group = this.formDataSources.groups[firstDataSourceName];
				}
				if (group) {
					group.reSetCurrentQuery();
					this.addFilterField(group);
					group.executeQueryAutoSaveStop(null, null, false, false, false, arg);
					//this.executeQuery(group);
				} else {
					throw new Error("FormModuleLookup refresh not find group");
				}
			}
		}, {
			key: 'onDataProviderRefresh',
			value: function onDataProviderRefresh(entityId, innerId) {
				if (this.entityId != entityId || this.innerId != innerId) return;
				this.doDataProviderRefresh();
			}
		}, {
			key: 'rpcDataProviderRefresh',
			value: function rpcDataProviderRefresh(formDataSourceGroupResult) {
				var finalDatas = _RecordsUtil2.default.getOneLevelDatas(formDataSourceGroupResult, this.mainTable.name);
				this.setState({ rows: finalDatas, selectedIndexes: [0], scrollmax: 0 });
			}
		}, {
			key: 'onAsteriskRefresh',
			value: function onAsteriskRefresh(entityId, innerId, filter) {
				if (this.entityId != entityId || this.innerId != innerId) return;
				this.lookupArg["baseFilter"] = filter;
				this.doDataProviderRefresh({ appendFilter: true });
			}
		}, {
			key: 'queryBoxClear',
			value: function queryBoxClear() {}
		}, {
			key: 'setExtralWhereItemValueForRefresh',
			value: function setExtralWhereItemValueForRefresh() {
				var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (append == true) {
					if (this._extralsWhereItemsRefresh == null) this._extralsWhereItemsRefresh = [];
				} else {
					this._extralsWhereItemsRefresh = [];
				}
	
				for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					params[_key - 1] = arguments[_key];
				}
	
				for (var i in params) {
					var item = params[i];
					this._extralsWhereItemsRefresh.push(item);
				}
			}
		}, {
			key: 'onLookupHostKeydown',
			value: function onLookupHostKeydown(lookupKey, e) {
				if (this.props.lookupKey == lookupKey) {
					this.moveSelectVertical(e.keyCode);
					var methodName = 'onPress' + e.key;
					if (typeof this.grid[methodName] === 'function') {
						this.grid[methodName](e);
					}
				}
			}
		}, {
			key: 'moveSelectVertical',
			value: function moveSelectVertical(keyCode) {
				if (keyCode == 40 || keyCode == 38) {
					var record = null;
					var newSelectIndexes = this.state.selectedIndexes;
					if (newSelectIndexes.length == 0) {
						if (this.state.rows.length > 0) {
							record = keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
							newSelectIndexes.push(0);
						}
					} else {
						var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
						var newIndex = keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
						var total = this.state.rows.length;
						if (newIndex >= 0 && newIndex < total) {
							record = this.state.rows[newIndex];
							newSelectIndexes = [newIndex];
						}
					}
					var selected = this.grid.state.selected;
					var colIndex = 0;
					if (selected) colIndex = selected.idx;
					var rowIndex = newSelectIndexes && newSelectIndexes.length > 0 ? newSelectIndexes[0] : 0;
					this.setState({ selectedIndexes: newSelectIndexes });
	
					this.grid.doOnSelect({ rowIndex: rowIndex, idx: colIndex, active: false });
					$(this.refs["datagridcontainer" + this.entityId + this.innerId]).find(".react-grid-Row.row-selected>.react-grid-Cell.row-selected")[colIndex].focus();
					console.log("rowIndex:" + rowIndex + "   newSelectIndexes" + JSON.stringify(newSelectIndexes));
					//this.grid.doOnSelect({idx:idx,rowIdx:rowIdx,active:false});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				//alert(this.entityId+" "+this.innerId);
				for (var key in this.formDataSources.groups) {
					var group = this.formDataSources.groups[key];
					group.initFormQuery();
				}
				//根据dataTypeRelationItem中的Fixed，补充QueryWhereItem
				this.addFixedWhereItem();
				this.addSysActiveWhereItem();
				this.addshortcutWhereItem();
			}
		}, {
			key: 'addshortcutWhereItem',
			value: function addshortcutWhereItem() {
				var shortcutfield = _GOTUtil2.default.getShortCut(this.mainTable);
				if (shortcutfield != null) {
					var group = this.formDataSources.firstGroup;
					var queryWhere = group.formQuery.QueryWhere;
					if (!queryWhere.Items) queryWhere.Items = [];
					var queryWhereItem = {
						qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
						Properties: {
							Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
							RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
						}
					};
					queryWhereItem.tag = "shortcut";
					var fieldPro = queryWhereItem.Properties.Field;
					var valuePro = queryWhereItem.Properties.Value;
	
					fieldPro.refentityid = mainTable.id;
					fieldPro.refinnerid = shortcutfield.id;
					fieldPro.V = shortcutfield.name;
	
					valuePro.Value = "";
	
					queryWhere.Items.push(queryWhereItem);
				}
			}
		}, {
			key: 'addSysActiveWhereItem',
			value: function addSysActiveWhereItem() {
				if (!this.formDataSources) throw new Error("formDataSources");
				var group = this.formDataSources.firstGroup;
				if (group.formQuery) {
					var dataType = this.dataType;
					var sysactivePro = dataType.Properties.SysActive || dataType.Properties.FilterSysActive;
					if (!sysactivePro) return;
					var queryWhere = null;var queryWhereItem;var fieldPro;var valuePro;
					if (sysactivePro.V == "true" || sysactivePro.V == true) {
						var tableFields = this.mainTable.TableFields;
	
						for (var i = 0; i < tableFields.length; i++) {
							var tableField = tableFields[i];
							//暂时这样判断是继承系统SysActive
							if ((tableField.name == "SysActive" || tableField.name == "Active") && _GOTUtil2.default.getPropertyValue(tableField, "Extends") == "SysActive") {
								if (queryWhere == null) queryWhere = group.formQuery.QueryTable.QueryWhere;
								queryWhereItem = {
									qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
									Properties: {
										Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
										RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
									}
								};
	
								queryWhereItem.tag = "sysactive";
								fieldPro = queryWhereItem.Properties.Field;
								valuePro = queryWhereItem.Properties.Value;
	
								fieldPro.refentityid = this.mainTable.id;
								fieldPro.refinnerid = tableField.id;
								fieldPro.V = tableField.name;
								valuePro.V = true;
								if (!queryWhere.Items) queryWhere.Items = [];
								queryWhere.Items.push(queryWhereItem);
								break;
							}
						}
					}
				}
			}
		}, {
			key: 'addFixedWhereItem',
			value: function addFixedWhereItem() {
				if (!this.formDataSources) throw new Error("formDataSources");
				var group = this.formDataSources.firstGroup;
				if (group.formQuery) {
					if (this.dataTypeRelationFixedItems && dataTypeRelationFixedItems.length() > 0) {
						var queryWhere = group.formQuery.QueryWhere;
						var queryWhereItem;var fieldPro;var valuePro;var relationItemFieldPro;var relationItemValuePro;
						for (var i = 0; i < this.dataTypeRelationFixedItems.length; i++) {
							var dataTypeRelationFixedItem = this.dataTypeRelationFixedItems[i];
							queryWhereItem = {
								qname: "QueryWhereItem", name: "t", id: "", tag: "autoAppendForFormModuleLookup",
								Properties: {
									Field: { V: "", refentityid: "", refinnerid: "" }, Value: { V: "" }, AndOr: { V: "And" }, LeftBracket: { V: "None" },
									RightBracket: { V: "None" }, Label: { V: "" }, Status: { V: "Hide" }, Enabled: { V: true }
								}
							};
							queryWhereItem.tag = "fixed";
							fieldPro = queryWhereItem.Properties.Field;
							valuePro = queryWhereItem.Properties.Value;
							relationItemFieldPro = dataTypeRelationFixedItem.Properties.Field;
							relationItemValuePro = dataTypeRelationFixedItem.Properties.FixedValue;
							fieldPro.refentityid = relationItemFieldPro.refentityid;
							fieldPro.refinnerid = relationItemFieldPro.refinnerid;
							fieldPro.V = relationItemFieldPro.V;
							valuePro.V = relationItemValuePro.V;
							if (!queryWhere.Items) queryWhere.Items = [];
							queryWhere.Items.push(queryWhereItem);
						}
						var formQueryCopy = JSON.parse(JSON.stringify(group.formQuery));
						group.reSetCurrentQuery(formQueryCopy);
					}
				}
			}
		}, {
			key: 'closeHandler',
			value: function closeHandler() {
				_LookupActions2.default.popDropDownClose(this.entityId, this.innerId);
			}
		}, {
			key: 'getGridDom',
			value: function getGridDom() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'datagridcontainer', style: { width: this.state.gridContainerWidth + 40 + 'px', height: '300px' },
						ref: "datagridcontainer" + this.entityId + this.innerId },
					_react2.default.createElement(ReactDataGrid, {
						ref: function ref(node) {
							return _this2.grid = node;
						},
						onRowClick: this.rowClick.bind(this),
						onGridKeyDown: this.gridKeyDown.bind(this),
						numColumn: false,
						columns: this._columns,
						enableCellSelect: true,
						rowGetter: this.rowGetter.bind(this),
						rowsCount: this.state.rows.length,
						rowHeight: _FormItemConst2.default.DATAGRID_ROW_HEIGHT,
						headerRowHeight: _FormItemConst2.default.DATAGRID_HEADER_HEIGHT,
						onScroll: this.scrolling.bind(this),
						minHeight: -1,
						containerWidth100: this.state.containerWidth100,
						rowSelection: {
							showCheckbox: false,
							enableShiftSelect: true,
							selectBy: {
								indexes: this.state.selectedIndexes
							}
						}
					})
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var gridDom = this.getGridDom();
				if (this.props.isPop) {
					return _react2.default.createElement(
						'div',
						{ style: { alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px" } },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header', style: { background: "#ffffff", padding: "5px", position: "relative", height: "30px" } },
							_react2.default.createElement('i', { className: 'fa fa-close', style: { position: "absolute", top: "7px", right: "10px", fontSize: "15px", cursor: "pointer" }, onClick: this.closeHandler.bind(this) })
						),
						_react2.default.createElement('div', { style: { width: '100px', height: '30px', backgroundColor: '#ff0000' } }),
						gridDom
					);
				} else {
					return gridDom;
				}
			}
		}]);
	
		return FormLookupServerSpec;
	}(_react2.default.Component);
	
	;
	FormLookupServerSpec.defaultProps = {};
	
	module.exports = FormLookupServerSpec;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _QueryActions = __webpack_require__(71);
	
	var _QueryActions2 = _interopRequireDefault(_QueryActions);
	
	var _ControlPropertyConst = __webpack_require__(91);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(78),
	    SortDirectionStore = _require.SortDirectionStore;
	
	var LookupSortableHeaderCell = React.createClass({
	    displayName: 'LookupSortableHeaderCell',
	
	    propTypes: {
	        column: React.PropTypes.shape({ name: React.PropTypes.node })
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            sortDirection: '',
	            notNull: this.props.column.notNull,
	            label: this.props.column.name
	        };
	    },
	
	
	    componentDidMount: function componentDidMount() {
	
	        this.unsubscribeUpdateSortDirection = SortDirectionStore.listen(this.onUpdateSortDirection);
	    },
	
	    onUpdateSortDirection: function onUpdateSortDirection(groupAlias, arg) {
	        var _sortDirection;
	        var _columnKey = this.props.column.key.toLowerCase();
	        if (arg.hasOwnProperty(_columnKey)) {
	            _sortDirection = arg[_columnKey];
	        }
	        this.setState({ sortDirection: _sortDirection });
	    },
	
	    onCmdUpdateControlLabel: function onCmdUpdateControlLabel(name, _label) {
	        if (this.props.column.xmlName == name) {
	            this.setState({ label: _label });
	        }
	    },
	
	    onCmdUpdateControlProperty: function onCmdUpdateControlProperty(name, property, value) {
	        if (this.props.column.xmlName == name) {
	            if (property == _ControlPropertyConst2.default.NOTNULL) {
	                this.setState({ notNull: value });
	            }
	        }
	    },
	
	    getSortByText: function getSortByText() {
	
	        var unicodeKeys = {
	            ASC: 9650,
	            DESC: 9660
	        };
	        var _sortDirection = this.state.sortDirection;
	        var ret;
	        if (_sortDirection == undefined || _sortDirection == '') {
	            ret = '';
	        } else {
	            ret = String.fromCharCode(unicodeKeys[_sortDirection]);
	        }
	        // var ret= _sortDirection==undefined?'':(String.fromCharCode(unicodeKeys[_sortDirection]));
	        // console.log('ret:'+ret);
	        return ret;
	    },
	
	    onClick: function onClick(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var columnKey = this.props.column.key;
	        var sortDirection = this.state.sortDirection;
	        var _sortDirection;
	        if (sortDirection == 'ASC') {
	            _sortDirection = 'DESC';
	        } else if (sortDirection == 'DESC') {
	            _sortDirection = 'ASC';
	        } else {
	            _sortDirection = 'ASC';
	        }
	        _QueryActions2.default.autoFormLookupGridHeaderClickSort(columnKey, _sortDirection, this.props.lookupKey);
	        //this.setState({sortDirection:_sortDirection})
	    },
	
	    getIconStyle: function getIconStyle() {
	
	        var iconStyle = {};
	        iconStyle['fontSize'] = '8px';
	        iconStyle['color'] = 'red';
	        var notNull = this.state.notNull;
	        if (!notNull) {
	            iconStyle['display'] = 'none';
	        }
	        return iconStyle;
	    },
	
	    render: function render() {
	        var xmlName = "";
	        if (this.props.column) xmlName = this.props.column.key;
	        return React.createElement(
	            'div',
	            { 'data-xmlName': xmlName, alt: '', style: { cursor: 'pointer', textAlign: this.props.textAlign }, onClick: this.onClick },
	            React.createElement('i', { className: 'fa fa-snowflake-o', style: this.getIconStyle() }),
	            this.state.label,
	            React.createElement(
	                'span',
	                { className: 'pull-right' },
	                this.getSortByText()
	            )
	        );
	    }
	});
	
	module.exports = LookupSortableHeaderCell;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _LookupStores = __webpack_require__(34);
	
	var _FormItemDateResolver = __webpack_require__(55);
	
	var _FormItemDateResolver2 = _interopRequireDefault(_FormItemDateResolver);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoLookupDateEditor = function (_React$Component) {
		_inherits(AutoLookupDateEditor, _React$Component);
	
		function AutoLookupDateEditor(props) {
			_classCallCheck(this, AutoLookupDateEditor);
	
			var _this = _possibleConstructorReturn(this, (AutoLookupDateEditor.__proto__ || Object.getPrototypeOf(AutoLookupDateEditor)).call(this, props));
	
			_this.lookupStates = {
				isShowed: false
			};
	
			_this.record = "";
			_this.state = { inQueryGroup: false };
			_this.classAlias = "AutoLookupDateEditor";
			_this.unsubscribeLookupAutoQueryStore = _LookupStores.LookupAutoQueryStore.listen(_this.onLookupAutoQuery.bind(_this));
			return _this;
		}
	
		_createClass(AutoLookupDateEditor, [{
			key: 'onLookupAutoQuery',
			value: function onLookupAutoQuery(key, args) {
				if (this.props.lookupKey == key && this.state.inQueryGroup) {
					args[this.props.tableField.name] = this.record;
				}
			}
		}, {
			key: 'showDateDropDown',
			value: function showDateDropDown() {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				var $pickerdropdown = $("div.datepicker");
				if ($pickerdropdown.is(':visible')) {
					this.lookupStates.isShowed = false;
					$(this.inputField).datepicker('hide');
				} else {
					this.lookupStates.isShowed = true;
					$(this.inputField).datepicker('show');
				}
			}
		}, {
			key: 'onDatePanelClose',
			value: function onDatePanelClose() {
				this.lookupStates.isShowed = false;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.inputField).datepicker({
					language: 'zh-CN',
					autoclose: true, //选中之后自动隐藏日期选择框
					clearBtn: true, //清除按钮
					todayBtn: true, //今日按钮
					todayHighlight: true,
					format: "yyyy-mm-dd",
					buttonImageOnly: true,
					hide: this.onDatePanelClose.bind(this)
				});
	
				//此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
				//不能获得焦点的比如下拉框div仍然可以使得input失去焦点
				$(this.inputField).blur(function (event) {
					/*if(event.relatedTarget!=null && event.relatedTarget == this.refs.inputpicker)
	    {
	    	return;
	    }*/
					//$(this).val("06-06");
				});
			}
	
			//新框架避免增加复杂条件判断 所以该类只表示Form上FormItem
	
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				if (this.lookupStates.isShowed) return;
				this.setFinalValue();
				this.setDisplay();
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				if (!value) value = $(this.inputField).val();
				if (value == "t" || value == "T") {
					var today = new Date();
					value = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
				}
				value = _FormItemDateResolver2.default.getResult(value, false);
				if (value.indexOf("false:") == 0) {
					_Warn2.default.show({ text: value.substr(6) });
					return false;
				}
				this.record = value;
				return true;
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					value = this.record;
				}
	
				value = _FormItemDateDisplay2.default.getDisplayText(value, this.props.show1970, this.props.seperator, this.props.numOfDay, this.props.numOfMonth, this.props.numOfYear);
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {
					//TODO 如何做自定义导航
					//e.preventDefault();
				} else if (e.keyCode > 64 && e.keyCode < 91 && e.keyCode != 84) {
					e.preventDefault();
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(_width) {
				var _this2 = this;
	
				var _style = { padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT + 'px', width: _width, fontSize: "12px" };
	
				if (this.state.inQueryGroup) return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
						return _this2.inputField = node;
					},
					type: 'text', className: 'form-control pull-right', id: "AutoLookupDateEditor" + this.props.id, style: _style,
					onBlur: this.inputFieldBlur.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });else return _react2.default.createElement('input', { spellCheck: 'false', ref: function ref(node) {
						return _this2.inputField = node;
					}, readOnly: 'readonly',
					type: 'text', className: 'form-control pull-right', id: "AutoLookupDateEditor" + this.props.id, style: _style,
					onBlur: this.inputFieldBlur.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) });
			}
		}, {
			key: 'getDownArrowButtonDom',
			value: function getDownArrowButtonDom() {
				var _this3 = this;
	
				if (this.state.inQueryGroup) return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, className: 'input-group-addon', style: { cursor: 'pointer', paddingTop: '2px', width: '33px', paddingLeft: '6px', paddingRight: '6px', height: '22px', paddingBottom: '2px' }, onMouseDown: this.showDateDropDown.bind(this) },
					_react2.default.createElement('i', { className: 'fa fa-calendar' })
				);else return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.downArrowButton = node;
						}, className: 'input-group-addon', style: { cursor: 'pointer', paddingTop: '2px', width: '33px', paddingLeft: '6px', paddingRight: '6px', height: '22px', paddingBottom: '2px', backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR }, onMouseDown: this.showDateDropDown.bind(this) },
					_react2.default.createElement('i', { className: 'fa fa-calendar' })
				);
			}
		}, {
			key: 'labelClickHandler',
			value: function labelClickHandler() {
				this.setState({ inQueryGroup: !this.state.inQueryGroup });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var displayLength = this.props.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
	
				var inputdom = this.getInputDom(_width);
				var downArrowButtonDom = this.getDownArrowButtonDom();
				var labelStyle = { paddingLeft: '5px', cursor: 'pointer', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				if (!this.state.inQueryGroup) {
					labelStyle.color = "#CFCFCF";
				}
				return _react2.default.createElement(
					'div',
					{ id: this.props.id, className: 'editorGroup', ref: function ref(node) {
							return _this4.contextMenuHandler = node;
						}, style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: "AutoLookupDateEditor" + this.props.id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this4.componentLabel = node;
							}, style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.props.label
					),
					_react2.default.createElement(
						'div',
						{ className: 'input-group date' },
						inputdom,
						downArrowButtonDom
					)
				);
			}
		}]);
	
		return AutoLookupDateEditor;
	}(_react2.default.Component);
	
	exports.default = AutoLookupDateEditor;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LookupStores = __webpack_require__(34);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _FormItemDecimalResolver = __webpack_require__(63);
	
	var _FormItemDecimalResolver2 = _interopRequireDefault(_FormItemDecimalResolver);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoLookupDecimalEditor = function (_React$Component) {
		_inherits(AutoLookupDecimalEditor, _React$Component);
	
		function AutoLookupDecimalEditor(props) {
			_classCallCheck(this, AutoLookupDecimalEditor);
	
			var _this = _possibleConstructorReturn(this, (AutoLookupDecimalEditor.__proto__ || Object.getPrototypeOf(AutoLookupDecimalEditor)).call(this, props));
	
			_this.state = { inQueryGroup: false };
			_this.classAlias = "AutoLookupDecimalEditor";
			_this.unsubscribeLookupAutoQueryStore = _LookupStores.LookupAutoQueryStore.listen(_this.onLookupAutoQuery.bind(_this));
			return _this;
		}
	
		_createClass(AutoLookupDecimalEditor, [{
			key: 'onLookupAutoQuery',
			value: function onLookupAutoQuery(key, args) {
				if (this.props.lookupKey == key && this.state.inQueryGroup) {
					args[this.props.tableField.name] = this.record;
				}
			}
		}, {
			key: 'labelClickHandler',
			value: function labelClickHandler() {
				this.setState({ inQueryGroup: !this.state.inQueryGroup });
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				if (!value) value = $(this.inputField).val();
	
				value = _FormItemDecimalResolver2.default.getResult(value, false, this.props.allowNegative, this.props.numOfDecimals, this.props.roundOff);
				if (value.indexOf("false:") == 0) {
					Warning.show({ text: value.substr(6) });
					return;
				}
				this.record = value;
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				this.setFinalValue();
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				this.setDisplay();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					value = this.record;
				}
				var parms = {};
				if (this.props.displayStyle == "%") parms.percent = true;
				value = _FormItemDecimalDisplay2.default.getDisplayText(value, this.props.showZero, this.props.showDecimals, this.props.thousandSeperator, parms);
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {} else if (e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom() {
				var _this2 = this;
	
				var _id = this.props.id;
				var displayLength = this.props.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				if (this.state.inQueryGroup) {
					return _react2.default.createElement('input', { ref: function ref(node) {
							return _this2.inputField = node;
						}, onBlur: this.inputFieldBlur.bind(this), id: _id, style: { width: _width, marginLeft: '5px', padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT }, spellCheck: 'false', className: 'form-control', onKeyDown: this.onKeyDownHandler.bind(this) });
				} else {
					return _react2.default.createElement('input', { ref: function ref(node) {
							return _this2.inputField = node;
						}, onBlur: this.inputFieldBlur.bind(this), readOnly: 'readonly', spellCheck: 'false', className: 'form-control', id: _id, style: { width: _width, marginLeft: '5px', height: _FormItemConst2.default.EDITOR_HEIGHT, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, padding: '2px' }, onKeyDown: this.onKeyDownHandler.bind(this) });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var displayLength = this.props.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				var _id = this.props.id;
				var labelStyle = { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', cursor: "pointer" };
				if (!this.state.inQueryGroup) {
					labelStyle.color = '#CFCFCF';
				}
				var inputDom = this.getInputDom();
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.element = node;
						}, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							},
							style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.props.label
					),
					inputDom
				);
			}
		}]);
	
		return AutoLookupDecimalEditor;
	}(_react2.default.Component);
	
	exports.default = AutoLookupDecimalEditor;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _LookupStores = __webpack_require__(34);
	
	var _FormItemLongDisplay = __webpack_require__(74);
	
	var _FormItemLongDisplay2 = _interopRequireDefault(_FormItemLongDisplay);
	
	var _FormItemLongResolver = __webpack_require__(98);
	
	var _FormItemLongResolver2 = _interopRequireDefault(_FormItemLongResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoLookupLongEditor = function (_React$Component) {
		_inherits(AutoLookupLongEditor, _React$Component);
	
		function AutoLookupLongEditor(props) {
			_classCallCheck(this, AutoLookupLongEditor);
	
			var _this = _possibleConstructorReturn(this, (AutoLookupLongEditor.__proto__ || Object.getPrototypeOf(AutoLookupLongEditor)).call(this, props));
	
			_this.state = { inQueryGroup: false };
			_this.classAlias = "AutoLookupLongEditor";
			_this.unsubscribeLookupAutoQueryStore = _LookupStores.LookupAutoQueryStore.listen(_this.onLookupAutoQuery.bind(_this));
			return _this;
		}
	
		_createClass(AutoLookupLongEditor, [{
			key: 'onLookupAutoQuery',
			value: function onLookupAutoQuery(key, args) {
				if (this.props.lookupKey == key && this.state.inQueryGroup) {
					args[this.props.tableField.name] = this.record;
				}
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				if (!value) value = $(this.inputField).val();
				value = _FormItemLongResolver2.default.getResult(value, false, this.props.allowNegative);
				if (value.indexOf("false:") == 0) {
					_Warn2.default.show({ text: value.substr(6) });
					return;
				}
				this.record = value;
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				this.setFinalValue();
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				this.setDisplay();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					value = this.record;
				}
	
				value = _FormItemLongDisplay2.default.getDisplayText(value, this.props.showZero, this.props.thousandSeperator);
	
				$(this.inputField).val(value);
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {} else if (e.keyCode > 64 && e.keyCode < 91) {
					e.preventDefault();
				}
			}
		}, {
			key: 'labelClickHandler',
			value: function labelClickHandler() {
				this.setState({ inQueryGroup: !this.state.inQueryGroup });
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom() {
				var _this2 = this;
	
				var _id = this.props.id;
				var displayLength = this.props.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				if (this.state.inQueryGroup) {
					return _react2.default.createElement('input', { ref: function ref(node) {
							return _this2.inputField = node;
						}, onBlur: this.inputFieldBlur.bind(this), id: _id, style: { width: _width, marginLeft: '5px', padding: '2px', height: _FormItemConst2.default.EDITOR_HEIGHT }, spellCheck: 'false', className: 'form-control', onKeyDown: this.onKeyDownHandler.bind(this) });
				} else {
					return _react2.default.createElement('input', { ref: function ref(node) {
							return _this2.inputField = node;
						}, onBlur: this.inputFieldBlur.bind(this), readOnly: 'readonly', spellCheck: 'false', className: 'form-control', id: _id, style: { width: _width, marginLeft: '5px', height: _FormItemConst2.default.EDITOR_HEIGHT, backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, padding: '2px' }, onKeyDown: this.onKeyDownHandler.bind(this) });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				var _id = this.props.id;
				var labelStyle = { paddingLeft: '5px', cursor: 'pointer', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				if (!this.state.inQueryGroup) {
					labelStyle.color = "#CFCFCF";
				}
				var inputDom = this.getInputDom();
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.element = node;
						}, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							},
							style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.props.label
					),
					inputDom
				);
			}
		}]);
	
		return AutoLookupLongEditor;
	}(_react2.default.Component);
	
	exports.default = AutoLookupLongEditor;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _LookupStores = __webpack_require__(34);
	
	var _FormItemStringResolver = __webpack_require__(99);
	
	var _FormItemStringResolver2 = _interopRequireDefault(_FormItemStringResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoLookupStringEditor = function (_React$Component) {
		_inherits(AutoLookupStringEditor, _React$Component);
	
		function AutoLookupStringEditor(props) {
			_classCallCheck(this, AutoLookupStringEditor);
	
			var _this = _possibleConstructorReturn(this, (AutoLookupStringEditor.__proto__ || Object.getPrototypeOf(AutoLookupStringEditor)).call(this, props));
	
			_this.state = { inQueryGroup: _this.props.initFocus ? true : false };
			_this.classAlias = "AutoLookupStringEditor";
			_this.unsubscribeLookupAutoQueryStore = _LookupStores.LookupAutoQueryStore.listen(_this.onLookupAutoQuery.bind(_this));
			return _this;
		}
	
		_createClass(AutoLookupStringEditor, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.initFocus) {
					var _inputField = this.inputField;
					setTimeout(function () {
						$(_inputField).focus();
					}, 500);
				}
			}
		}, {
			key: 'onLookupAutoQuery',
			value: function onLookupAutoQuery(key, args) {
				if (this.props.lookupKey == key && this.state.inQueryGroup) {
					args[this.props.tableField.name] = _FormItemConst2.default.WILDCARD + this.record + _FormItemConst2.default.WILDCARD;
				}
			}
		}, {
			key: 'labelClickHandler',
			value: function labelClickHandler() {
				this.setState({ inQueryGroup: !this.state.inQueryGroup });
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom() {
				var _this2 = this;
	
				var _id = this.props.id;
				var displayLength = this.props.displayLength;
				var _width = displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon + 'px';
				if (this.state.inQueryGroup) {
					return _react2.default.createElement('input', { ref: function ref(node) {
							return _this2.inputField = node;
						}, id: _id, style: { width: _width, marginLeft: '5px', height: _FormItemConst2.default.EDITOR_HEIGHT, padding: '2px' }, spellCheck: 'false', className: 'form-control', onBlur: this.inputFieldBlur.bind(this) });
				} else {
					return _react2.default.createElement('input', { ref: function ref(node) {
							return _this2.inputField = node;
						}, onBlur: this.inputFieldBlur.bind(this), readOnly: 'readonly', className: 'form-control', spellCheck: 'false', id: _id, style: { width: _width, height: _FormItemConst2.default.EDITOR_HEIGHT, marginLeft: '5px', backgroundColor: _FormItemConst2.default.EDITOR_NOTEDIT_COLOR, padding: '2px' } });
				}
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				if (!value) value = $(this.inputField).val();
	
				value = _FormItemStringResolver2.default.getResult(value, this.props.trim, this.props.changeCase, this.props.stringSize, this.props.regular);
				if (value.indexOf(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG) == 0) {
					alert(value.substr(_FormItemStringResolver2.default.RESOLVER_FALSE_TAG.length));
					return;
				}
	
				this.record = value;
			}
		}, {
			key: 'inputFieldBlur',
			value: function inputFieldBlur() {
				this.setFinalValue();
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				this.setDisplay();
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					value = this.record;
				}
				$(this.inputField).val(value);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var editorStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
				var _id = this.props.id;
				var labelStyle = { paddingLeft: '5px', width: 'auto', cursor: 'pointer', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' };
				if (!this.state.inQueryGroup) {
					labelStyle.color = "#CFCFCF";
				}
				var inputDom = this.getInputDom();
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.element = node;
						}, className: 'editorGroup', style: editorStyle },
					_react2.default.createElement(
						'label',
						{ htmlFor: _id, className: 'fieldGroupLabel', ref: function ref(node) {
								return _this3.componentLabel = node;
							},
							style: labelStyle, onClick: this.labelClickHandler.bind(this) },
						this.props.label
					),
					inputDom
				);
			}
		}]);
	
		return AutoLookupStringEditor;
	}(_react2.default.Component);
	
	exports.default = AutoLookupStringEditor;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _DialogFieldDateEditor = __webpack_require__(113);
	
	var _DialogFieldDateEditor2 = _interopRequireDefault(_DialogFieldDateEditor);
	
	var _DialogFieldStringEditor = __webpack_require__(118);
	
	var _DialogFieldStringEditor2 = _interopRequireDefault(_DialogFieldStringEditor);
	
	var _DialogFieldEnumEditor = __webpack_require__(115);
	
	var _DialogFieldEnumEditor2 = _interopRequireDefault(_DialogFieldEnumEditor);
	
	var _DialogFieldBooleanEditor = __webpack_require__(112);
	
	var _DialogFieldBooleanEditor2 = _interopRequireDefault(_DialogFieldBooleanEditor);
	
	var _DialogFieldLongEditor = __webpack_require__(117);
	
	var _DialogFieldLongEditor2 = _interopRequireDefault(_DialogFieldLongEditor);
	
	var _DialogFieldDecimalEditor = __webpack_require__(114);
	
	var _DialogFieldDecimalEditor2 = _interopRequireDefault(_DialogFieldDecimalEditor);
	
	var _DialogFieldTimeEditor = __webpack_require__(119);
	
	var _DialogFieldTimeEditor2 = _interopRequireDefault(_DialogFieldTimeEditor);
	
	var _DialogFieldLabel = __webpack_require__(116);
	
	var _DialogFieldLabel2 = _interopRequireDefault(_DialogFieldLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogFieldGroupForm = function (_React$Component) {
		_inherits(DialogFieldGroupForm, _React$Component);
	
		function DialogFieldGroupForm(props) {
			_classCallCheck(this, DialogFieldGroupForm);
	
			var _this = _possibleConstructorReturn(this, (DialogFieldGroupForm.__proto__ || Object.getPrototypeOf(DialogFieldGroupForm)).call(this, props));
	
			_this.state = { fields: _this.props.data.fields, layout: _this.props.data.layout };
			return _this;
		}
	
		_createClass(DialogFieldGroupForm, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var maxWidth = 0;
				$(this.fieldGroupComponent).find(".fieldGroupLabel").each(function () {
					//alert($(this).width());
					if ($(this).width() > maxWidth) maxWidth = $(this).width();
				});
	
				$(this.fieldGroupComponent).find(".fieldGroupLabel").each(function () {
					$(this).width(maxWidth);
				});
			}
		}, {
			key: 'getDialogFieldGroupComponents',
			value: function getDialogFieldGroupComponents() {
				var result = [];
				if (this.state.fields) {
					for (var i = 0; i < this.state.fields.length; i++) {
						var field = this.state.fields[i];
						if (field.editorType == "TypeString") {
							result.push(_react2.default.createElement(_DialogFieldStringEditor2.default, { data: field, dialogId: this.props.dialogId }));
						} else if (field.editorType == "TypeEnum") {
							result.push(_react2.default.createElement(_DialogFieldEnumEditor2.default, { data: field, dialogId: this.props.dialogId }));
						} else if (field.editorType == "TypeBoolean") {
							result.push(_react2.default.createElement(_DialogFieldBooleanEditor2.default, { data: field, dialogId: this.props.dialogId }));
						} else if (field.editorType == "TypeLabel") {
							result.push(_react2.default.createElement(_DialogFieldLabel2.default, { data: field, dialogId: this.props.dialogId }));
						} else if (field.editorType == "TypeLong") {
							result.push(_react2.default.createElement(_DialogFieldLongEditor2.default, { data: field, dialogId: this.props.dialogId }));
						} else if (field.editorType == "TypeDecimal") {
							result.push(_react2.default.createElement(_DialogFieldDecimalEditor2.default, { data: field, dialogId: this.props.dialogId }));
						} else if (field.editorType == "TypeTime") {
							result.push(_react2.default.createElement(_DialogFieldTimeEditor2.default, { data: field, dialogId: this.props.dialogId }));
						} else {
							result.push(_react2.default.createElement(_DialogFieldDateEditor2.default, { data: field, dialogId: this.props.dialogId }));
						}
					}
				}
				return result;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var components = this.getDialogFieldGroupComponents();
				var _style = {};
				if (this.state.layout == 'horizontal') {
					_style = { display: 'flex', flexDirection: 'row' };
				}
				if (this.state.label) {
					return _react2.default.createElement(
						'div',
						{ className: 'box box-info', style: _style, ref: function ref(node) {
								return _this2.fieldGroupComponent = node;
							} },
						_react2.default.createElement(
							'div',
							{ className: 'box-header with-border', style: { padding: '5px', textAlign: 'center' } },
							_react2.default.createElement(
								'h4',
								{ className: 'box-title' },
								this.state.label
							)
						),
						components
					);
				} else {
					_style.borderTop = '0px';
					return _react2.default.createElement(
						'div',
						{ className: 'box box-info', style: _style, ref: function ref(node) {
								return _this2.fieldGroupComponent = node;
							} },
						components
					);
				}
			}
		}]);
	
		return DialogFieldGroupForm;
	}(_react2.default.Component);
	
	exports.default = DialogFieldGroupForm;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PivotExportDialog = function (_React$Component) {
	  _inherits(PivotExportDialog, _React$Component);
	
	  function PivotExportDialog(props) {
	    _classCallCheck(this, PivotExportDialog);
	
	    var _this = _possibleConstructorReturn(this, (PivotExportDialog.__proto__ || Object.getPrototypeOf(PivotExportDialog)).call(this, props));
	
	    _this.getExportHeadData = function () {
	      var headerInfo = [];
	      for (var i = 0; i < _this.state.columns.length; i++) {
	        var col = _this.state.columns[i];
	        if (col.selected) {
	          var _headerText = _this.state.showTableName ? col.totalHeaderText : col.headerText || col.normalHeaderText;
	          var item = { dataField: col.dataField, headerText: _headerText, fieldType: col.fieldType };
	          if (col.fieldType == "Decimal") {
	            if (!col.numOfDecimals) {
	              for (var key in FormItemUtil.formItemControlsForFor) {
	                var fe = FormItemUtil.formItemControlsForFor[key];
	                if (col.formItemId == fe.xml.id) {
	                  item.numOfDecimals = fe.getProperty_NumOfDecimals();
	                  break;
	                }
	              }
	            } else {
	              item.numOfDecimals = col.numOfDecimals;
	            }
	
	            if (typeof item.numOfDecimals == "string") {
	              try {
	                item.numOfDecimals = parseInt(item.numOfDecimals);
	              } catch (e) {
	                item.numOfDecimals = 2;
	              }
	            }
	          }
	          headerInfo.push(item);
	        }
	      }
	      return headerInfo;
	    };
	
	    _this.rpc_exportExcelHandler = function (data) {
	      if (data) {
	        var commandTask = new _CommandTask2.default();
	        commandTask.cmd = _Cmd2.default.FileDownload;
	        commandTask.arg = data.result;
	        _CommandResolver2.default.downLoad(commandTask, window.formModuleInstance);
	      }
	    };
	
	    _this.parent = props.parent;
	    return _this;
	  }
	
	  _createClass(PivotExportDialog, [{
	    key: 'export',
	    value: function _export(e) {
	      var _group = this.parent;
	      var htmlarg = _group.doPivotExport();
	      this.state = htmlarg;
	      var label = "";
	      var mainSource = _group.mainSource;
	      var tablePro = _GOTUtil2.default.getProperty(mainSource.xml, "Table");
	      if (tablePro != null && tablePro.hasOwnProperty("refentityid")) {
	        var table = _GOT2.default.getTable(tablePro.refentityid);
	        if (table) {
	          label = _GOTUtil2.default.getPropertyValue(table, "Label");
	          if (!label) {
	            label = mainSource.xml.name;
	          }
	        }
	      }
	      var array = this.getExportHeadData();
	      var command = _Command2.default.createService("gongqi.erp.layers.sys.services.ExportService", "exportExcel", "String");
	      command.appendArg(label);
	
	      command.appendArg(array, "List");
	
	      var _exportDataProvider = [];
	
	      for (var i = 0; i < this.state.ac.length; i++) {
	        var item = this.state.ac[i];
	        var _exportItem = {};
	        for (var j = 0; j < array.length; j++) {
	          var field = array[j];
	          _exportItem[field.dataField] = item[field.dataField] + "";
	          if (_exportItem[field.dataField] == '' || _exportItem[field.dataField] == "undefined" || _exportItem[field.dataField] == null || _exportItem[field.dataField] == "null") {
	            if (field.fieldType == "Decimal" || field.fieldType == "Long") {
	              _exportItem[field.dataField] = 0;
	            } else {
	              _exportItem[field.dataField] = "";
	            }
	          }
	        }
	        _exportDataProvider.push(_exportItem);
	      }
	      command.appendArg(_exportDataProvider, "List");
	      //command.appendArg(this.state.ac,"List");
	
	      _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.rpc_exportExcelHandler, sync: false });
	      return;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $("#pivotExportModal .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal ', style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	        _react2.default.createElement(
	          'div',
	          { className: ' ui-draggable', style: (_ref = { alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff" }, _defineProperty(_ref, 'background', '#FFFFFF'), _defineProperty(_ref, 'border', '1px solid #9B9B9B'), _defineProperty(_ref, 'boxShadow', '0 0 41px 5px rgba(0,0,0,0.25)'), _defineProperty(_ref, 'borderRadius', '2px'), _defineProperty(_ref, 'width', '400px'), _ref) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header', style: { position: "relative" } },
	            _react2.default.createElement('div', { className: 'modal-close', onClick: this.closeAttachmentHandler.bind(this) }),
	            _react2.default.createElement(
	              'h5',
	              { className: 'modal-title' },
	              '\u63D0\u793A'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: '', style: { borderTop: '1px solid #d2d6de', textAlign: 'center' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-body', style: { paddingTop: '0px' } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    '\u5F53\u524D\u6570\u636E\u91CF\u8FC7\u5927,\u6682\u65F6\u65E0\u6CD5\u4F7F\u7528\u8BE5\u5DE5\u5177\u8FDB\u884C\u5206\u6790',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '\u8BF7\u4E0B\u8F7DEXCEL\u4E4B\u540E\u5229\u7528\u5176\u4ED6\u5DE5\u5177\u5904\u7406'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn', style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' }, id: 'dataSourceDoMain_BtnCancel', 'data-dismiss': 'modal', onClick: this.closeAttachmentHandler.bind(this) },
	              '\u53D6\u6D88'
	            ),
	            _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn', style: { height: '28px', marginRight: '0px', width: '100px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px', color: '#fff' }, onClick: this.export.bind(this) },
	              '\u4E0B\u8F7DEXCEL'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'closeAttachmentHandler',
	    value: function closeAttachmentHandler() {
	      //关掉要卸载
	      var $reactComponentContainer = $("#pivotExportModal .modal");
	      _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	      $reactComponentContainer.remove();
	    }
	  }]);
	
	  return PivotExportDialog;
	}(_react2.default.Component);
	
	PivotExportDialog.defaultProps = {};
	
	exports.default = PivotExportDialog;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ArrayUtil = __webpack_require__(70);
	
	var _ArrayUtil2 = _interopRequireDefault(_ArrayUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var CurrentRecordInfo = function (_React$Component) {
	  _inherits(CurrentRecordInfo, _React$Component);
	
	  function CurrentRecordInfo(props) {
	    _classCallCheck(this, CurrentRecordInfo);
	
	    var _this = _possibleConstructorReturn(this, (CurrentRecordInfo.__proto__ || Object.getPrototypeOf(CurrentRecordInfo)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.isAdmin = window.parent.window.userInfos.isAdmin;
	    // var rows=this.props.rows;
	    if (_this.isAdmin) {
	      var columns = [{
	        key: 'dataSourceEnLabel',
	        name: "数据源",
	        width: 137,
	        resizable: true
	      }, {
	        key: 'chLabel',
	        name: "中文名",
	        width: 137,
	        resizable: true
	      }, {
	        key: 'enLabel',
	        name: "英文名",
	        width: 150,
	        resizable: true
	      }, {
	        key: 'fvalue',
	        name: "值",
	        width: 136,
	        resizable: true
	      }];
	    } else {
	      var columns = [{
	        key: 'chLabel',
	        name: "中文名",
	        width: 205,
	        resizable: true
	      }, {
	        key: 'fvalue',
	        name: "值",
	        width: 205,
	        resizable: true
	      }];
	    }
	    var initSelectIndex = 0;
	    var currentEnLabel = _this.props.parms ? _this.props.parms.field : "";
	    if (currentEnLabel) {
	      var rowsLength = _this.props.fdataProvider ? _this.props.fdataProvider.length : 0;
	      for (var i = 0; i < rowsLength; i++) {
	        var row = _this.props.fdataProvider[i];
	        if (row.enLabel == currentEnLabel) {
	          initSelectIndex = i;
	          break;
	        }
	      }
	    }
	    _this.columns = columns;
	    _this.state = {
	      rows: _this.props.fdataProvider,
	      selectedIndexes: [initSelectIndex],
	      fdataProvider: {},
	      title: _this.props.title,
	      _tabName: _this.props.tableName,
	      _group: _this.props.self
	    };
	
	    _this.GlobalValueRepalceSelectItem = null;
	    _this.GlobalValueRepalceSelectTitle = null;
	
	    _this.RefResultList = null;
	
	    return _this;
	  }
	
	  _createClass(CurrentRecordInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $(this.CurrentRecordInfoModalContainer).draggable({
	        handle: ".modal-header", // 只能点击头部拖动
	        cancel: "div.modal-header-only-title"
	      }); //为模态对话框添加拖拽
	
	      $(this.RecordRefViewModal_Container).draggable({
	        handle: ".modal-header" // 只能点击头部拖动
	      }); //为模态对话框添加拖拽
	
	      $(this.GlobalValueRepalceModal_Container).draggable({
	        handle: ".modal-header" // 只能点击头部拖动
	      }); //为模态对话框添加拖拽
	      $("#currentRecordInfoModal").css("display", "flex");
	
	      /*let selectedIndex = this.state.selectedIndexes?this.state.selectedIndexes[0]:null;
	      if(!selectedIndex)selectedIndex = 0;
	      this.grid.doOnSelect({rowIdx:selectedIndex,idx:0,active:false});
	        var selectedCells = $(this.gridContainer).find(".react-grid-Cell.row-selected");
	      if(selectedCells.length==0)
	       return;
	      selectedCells[0].focus();
	        this.GlobalValueRepalceSelectItem = this.state.rows[selectedIndex];*/
	    }
	  }, {
	    key: 'btnRequire_clickHandler',
	    value: function btnRequire_clickHandler() {
	      $(this.RecordRefViewModalContainer).css("display", "none");
	    }
	  }, {
	    key: 'refUpdateResultHandler',
	    value: function refUpdateResultHandler(value, event) {
	      var _this2 = this;
	
	      if (event.result == null || event.result.length == 0) {
	        // alert("无结果返回!您可能替换的不是业务主键");
	        $(this.GlobalValueRepalceModalContainer).css("display", "none");
	        _Warn2.default.show({
	          text: "无结果返回!您可能替换的不是业务主键",
	          title: "提示",
	          confirm: {
	            isShow: true,
	            event: this.btnGlobalValueRepalce_clickHandler.bind(this)
	          }
	        });
	      } else {
	        $(this.GlobalValueRepalceModalContainer).css("display", "none");
	        var items = event.result;
	        $(this.RefListBody).empty();
	        items.map(function (item) {
	          $(_this2.RefListBody).append("<li style='line-height:30px;line-style:none;width:100%;border-bottom:1px solid #f3f3f3;'>" + item + "</li>");
	        });
	        $(this.RecordRefViewModalContainer).css("display", "block");
	        // RecordRefView.Instance.show(IList(event.result));
	        var rows = this.state.rows;
	        var _clickIndex = void 0;
	        if (this.state.selectedIndexes && this.state.selectedIndexes.length > 0) _clickIndex = this.state.selectedIndexes[this.state.selectedIndexes.length - 1];
	        var selectedIndexes = _clickIndex ? _clickIndex : 0;
	        rows[selectedIndexes].fvalue = value;
	        this.setState({
	          rows: rows
	        });
	        this.state._group.doRecordRestore(false, true, false);
	      }
	    }
	
	    /**datagrid */
	
	  }, {
	    key: 'gridKeyDown',
	    value: function gridKeyDown(proxy) {
	      //console.log(arguments);
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	
	        if (ne.keyCode == 40 || ne.keyCode == 38) {
	          var record = null;
	          var newSelectIndexes = this.state.selectedIndexes.slice();
	          if (newSelectIndexes.length == 0) {
	            if (this.state.rows.length > 0) {
	              record = ne.keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
	              newSelectIndexes.push(0);
	              this.setState({ selectedIndexes: newSelectIndexes });
	            }
	          } else {
	            var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	            var newIndex = ne.keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
	            var total = this.state.rows.length;
	            if (newIndex >= 0 && newIndex < total) {
	              record = this.state.rows[newIndex];
	              newSelectIndexes = [newIndex];
	              this.setState({ selectedIndexes: newSelectIndexes });
	            }
	          }
	
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'rowClick',
	    value: function rowClick(index, record, proxy) {
	      if (index == -1) return;
	      var newSelectIndexes;
	
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	
	        if (ne.shiftKey) {
	          //let origSelectIndexes = this.state.selectedIndexes;
	          if (this.state.selectedIndexes.length > 0) {
	            newSelectIndexes = this.state.selectedIndexes.slice();
	            var minIndex = newSelectIndexes[0];var maxIndex = newSelectIndexes[0];
	            for (var i in newSelectIndexes) {
	              if (newSelectIndexes[i] > maxIndex) maxIndex = newSelectIndexes[i];
	              if (newSelectIndexes[i] < minIndex) minIndex = newSelectIndexes[i];
	            }
	
	            if (index > maxIndex) {
	              for (i = maxIndex + 1; i <= index; i++) {
	                newSelectIndexes.push(i);
	              }
	            } else if (index < minIndex) {
	              for (i = minIndex - 1; i >= index; i--) {
	                newSelectIndexes.push(i);
	              }
	            } else {
	              if (newSelectIndexes.indexOf(index) == -1) {
	                var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	                newSelectIndexes.push(index);
	                for (i = 0; i < Math.abs(index - lastIndex); i++) {
	                  if (index < lastIndex) {
	                    newSelectIndexes.push(index + i);
	                  } else if (lastIndex > index) {
	                    newSelectIndexes.push(lastIndex + i);
	                  }
	                }
	              }
	            }
	          } else {
	            newSelectIndexes.push(index);
	          }
	        } else if (ne.ctrlKey) {
	          newSelectIndexes = this.state.selectedIndexes.slice();
	          if (newSelectIndexes.indexOf(index) == -1) {
	            newSelectIndexes.push(index);
	          } else {
	            _ArrayUtil2.default.removeByValue(newSelectIndexes, index);
	          }
	          //禁止完全取消选中 因为很多功能流程都依赖于选中项 如果去掉可能造成很多不可预知的bug 如保存记录时recId重复
	          //新增记录 然后取消选中 换行 此时会导致保存成功 但是DataGrid控件并没有把保存成功的记录更新到状态因为已没有选中项
	          if (newSelectIndexes.length == 0) newSelectIndexes = [index];
	        } else {
	          newSelectIndexes = [index];
	        }
	      } else {
	        newSelectIndexes = [index];
	      }
	
	      this.setState({ selectedIndexes: newSelectIndexes });
	
	      this.GlobalValueRepalceSelectTitle = record.chLabel;
	      this.GlobalValueRepalceSelectItem = record;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var globalReplaceDisplay = "none";
	
	      if (window.parent && window.parent.window) {
	        if (window.parent.window.userInfos && window.parent.window.userInfos.isAdmin) {
	          globalReplaceDisplay = "block";
	        }
	      }
	      var _parentWindow = typeof window.openMenuItem == 'function' ? window : window.parent.window;
	      return React.createElement(
	        'div',
	        { ref: function ref(node) {
	            return _this3.CurrentRecordInfoModalContainer = node;
	          }, tabIndex: '-1', style: { position: 'absolute', alignSelf: "center", borderRadius: "2px", backgroundColor: 'white', width: '800px', height: '500px', display: 'flex', flexDirection: 'column', background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' } },
	        React.createElement(
	          'div',
	          { className: 'modal-header', style: { position: "relative" } },
	          React.createElement('div', { className: 'modal-close', onClick: this.hideCurrentRecordInfo.bind(this) }),
	          React.createElement(
	            'h5',
	            { className: 'modal-title' },
	            React.createElement(
	              'div',
	              { className: 'modal-header-only-title', style: { float: "left", userSelect: "text" } },
	              this.state.title
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { style: { display: 'flex', flexDirection: 'column', flexGrow: 100 } },
	          React.createElement(
	            'div',
	            { style: { display: 'flex', flexDirection: 'row', flexGrow: 100, borderRadius: '3px', padding: '14px' } },
	            React.createElement(
	              'div',
	              { style: { display: 'flex', flexDirection: 'column', flexGrow: 100 }, ref: function ref(node) {
	                  return _this3.gridContainer = node;
	                } },
	              React.createElement(ReactDataGrid, {
	                ref: function ref(node) {
	                  return _this3.grid = node;
	                }
	                // onGridSort={this.handleGridSort}
	                , enableCellSelect: true,
	                columns: this.columns //columns={this.state.columns}
	                // columns={this.props.columns}
	                // columns={this.getColumns()}
	                , rowGetter: this.getRowAt,
	                rowsCount: this.getSize(),
	                onGridRowsUpdated: this.handleGridRowsUpdated
	                // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	                , enableRowSelect: false,
	                onGridKeyDown: this.gridKeyDown.bind(this),
	
	                rowSelection: {
	                  showCheckbox: false,
	                  selectBy: {
	                    indexes: this.state.selectedIndexes
	
	                  }
	                },
	                onRowClick: this.rowClick.bind(this) //this.rowClick this.rowClick.bind(this)
	                , rowHeight: 30,
	                minHeight: 240,
	                rowScrollTimeout: 500,
	                cellNavigationMode: 'loopOverRow'
	
	              })
	            )
	          ),
	          React.createElement(
	            'div',
	            { style: { display: 'flex', flexDirection: 'horizontal', flexGrow: 0, padding: '9px 9px', overflow: 'auto', borderTop: '1px solid rgba(0,0,0,0.10)', paddingLeft: '13px' } },
	            React.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.btnCopy_clickHandler.bind(this), style: { marginLeft: '0px', marginRight: '0', padding: '5px 12px !important' } },
	              '\u590D\u5236\u5230\u526A\u8D34\u677F'
	            ),
	            React.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.btnCopyItem_clickHandler.bind(this), style: { marginLeft: '5px', marginRight: '0', padding: '5px 12px !important' } },
	              '\u590D\u5236\u9009\u4E2D\u884C\u5230\u526A\u8D34\u677F'
	            ),
	            React.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.btnRef_clickHandler.bind(this), style: { marginLeft: '5px', marginRight: '0' } },
	              '\u67E5\u770B\u5F15\u7528\u5217\u8868'
	            ),
	            React.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.btnGlobalValueRepalce_clickHandler.bind(this), style: { marginLeft: '5px', marginRight: '0', display: globalReplaceDisplay } },
	              '\u5168\u5C40\u66FF\u6362'
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'modal', ref: function ref(node) {
	              return _this3.RecordRefViewModalContainer = node;
	            }, style: { zIndex: '2000', display: 'none' } },
	          React.createElement(
	            'div',
	            { className: 'modal-dialog', style: { marginTop: '100px', width: '400px' } },
	            React.createElement(
	              'div',
	              { className: 'modal-content', ref: function ref(node) {
	                  return _this3.RecordRefViewModal_Container = node;
	                }, style: { background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
	              React.createElement(
	                'div',
	                { id: 'RecordRefViewModal_Container_Header', className: 'modal-header' },
	                React.createElement('div', { className: 'modal-close', onClick: this.btnRequire_clickHandler.bind(this) }),
	                React.createElement(
	                  'span',
	                  { className: 'modal-title', style: { marginTop: '0', marginBottom: '0', fontSize: '16px' } },
	                  '\u8BB0\u5F55\u5F15\u7528\u5173\u7CFB'
	                )
	              ),
	              React.createElement(
	                'div',
	                { ref: function ref(node) {
	                    return _this3.RefSuccessList = node;
	                  }, className: 'modal-body', style: { display: 'flex', flexDirection: 'row', padding: '10px 5px' } },
	                React.createElement('ul', { ref: function ref(node) {
	                    return _this3.RefListBody = node;
	                  }, style: { width: '100%', padding: '0 10px', height: '200px', overflow: 'auto', margin: '0' } })
	              ),
	              React.createElement(
	                'div',
	                { className: 'modal-footer', style: { padding: '5px 15px' } },
	                React.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-primary', style: { width: '80px', height: '28px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', color: '#FFFFFF', letterSpacing: 0, textAlign: 'center', lineHeight: '10px', border: '1px solid #f5a623', backgroundColor: '#f5a623' }, onClick: this.btnRequire_clickHandler.bind(this) },
	                  '\u786E\u5B9A'
	                )
	              )
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'modal', ref: function ref(node) {
	              return _this3.GlobalValueRepalceModalContainer = node;
	            }, style: { zIndex: '2000', display: 'none' } },
	          React.createElement(
	            'div',
	            { className: 'modal-dialog', style: { marginTop: '100px', width: '550px' } },
	            React.createElement(
	              'div',
	              { className: 'modal-content', ref: function ref(node) {
	                  return _this3.GlobalValueRepalceModal_Container = node;
	                }, style: { background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
	              React.createElement(
	                'div',
	                { className: 'modal-header' },
	                React.createElement('div', { className: 'modal-close', onClick: this.hideGlobalValueRepalce.bind(this) }),
	                React.createElement('span', { className: 'modal-title', ref: function ref(node) {
	                    return _this3.GlobalValueRepalceModal_title = node;
	                  }, style: { marginTop: '0', marginBottom: '0', fontSize: '16px' } })
	              ),
	              React.createElement(
	                'div',
	                { className: 'modal-body', style: { display: 'flex', flexDirection: 'row', padding: '20px 23px' } },
	                React.createElement(
	                  'div',
	                  { style: { flexGrow: 1, textAlign: 'center' } },
	                  React.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'row' } },
	                    React.createElement(
	                      'div',
	                      { style: { flexGrow: 0, textAlign: 'right' } },
	                      React.createElement(
	                        'label',
	                        { style: { paddingTop: '4px', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', textAlign: 'right', fontWeight: 500 } },
	                        '\u8BF7\u8F93\u5165\u65B0\u503C\uFF1A'
	                      )
	                    ),
	                    React.createElement(
	                      'div',
	                      { style: { flexGrow: 1, textAlign: 'left' } },
	                      React.createElement('input', { ref: function ref(node) {
	                          return _this3.doRepalceValue = node;
	                        }, type: 'text', spellCheck: 'false', className: 'form-control', style: { width: '250px', height: '28px', borderRadius: '4px' } })
	                    )
	                  )
	                )
	              ),
	              React.createElement(
	                'div',
	                { className: 'modal-footer', style: { padding: '10px 15px' } },
	                React.createElement(
	                  'button',
	                  { type: 'button', className: 'btn', 'data-dismiss': 'modal', onClick: this.hideGlobalValueRepalce.bind(this), style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' } },
	                  '\u53D6\u6D88'
	                ),
	                React.createElement(
	                  'button',
	                  { type: 'button', className: 'btn', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px' }, onClick: this.saveGlobalValueRepalce.bind(this) },
	                  '\u786E\u8BA4'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'show',
	    value: function show(fdataProvider, tableName, self, title) {
	      var parms = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	      if (CurrentRecordInfo.instance == null) {
	
	        CurrentRecordInfo.instance = _reactDom2.default.render(React.createElement(CurrentRecordInfo, { fdataProvider: fdataProvider, tableName: tableName, self: self, title: title, parms: parms }), document.getElementById('currentRecordInfoModal'));
	      } else {
	
	        /*let origRows = CurrentRecordInfo.instance.state.rows;
	        //let selectedIndex = CurrentRecordInfo.instance.state.selectedIndexes?CurrentRecordInfo.instance.state.selectedIndexes[0]:null;
	        //if(!selectedIndex)selectedIndex = 0;
	        let origRecId;
	        for(let i = 0;i<origRows.length;i++)
	        {
	          let origRow = origRows[i];
	          if(origRow.enLabel == "RecId")
	          {
	            origRecId = origRow.fvalue;
	            break;
	          }
	        }
	          let nowRecId;
	        for(let i = 0;i<fdataProvider.length;i++)
	        {
	          let row = fdataProvider[i];
	          if(row.enLabel == "RecId")
	          {
	            nowRecId = row.fvalue;
	            break;
	          }
	        }
	          if(origRecId && nowRecId == origRecId)
	        {
	          CurrentRecordInfo.instance.setState({
	            rows:fdataProvider,
	            title:title,
	            _tabName : tableName,
	            _group:self
	          });
	        }
	        else
	        {
	          CurrentRecordInfo.instance.setState({
	            rows:fdataProvider,
	            title:title,
	            _tabName : tableName,
	            _group:self,
	            selectedIndexes:[0]
	          });
	        }*/
	
	        var initSelectIndex = 0;
	        var currentEnLabel = parms ? parms.field : "";
	        if (currentEnLabel) {
	          var rowsLength = fdataProvider ? fdataProvider.length : 0;
	          for (var i = 0; i < rowsLength; i++) {
	            var row = fdataProvider[i];
	            if (row.enLabel == currentEnLabel) {
	              initSelectIndex = i;
	              break;
	            }
	          }
	        }
	
	        CurrentRecordInfo.instance.setState({
	          rows: fdataProvider,
	          title: title,
	          _tabName: tableName,
	          _group: self,
	          selectedIndexes: [initSelectIndex]
	        });
	        $("#currentRecordInfoModal").css("display", "flex");
	
	        /*let selectedIndex = CurrentRecordInfo.instance.state.selectedIndexes?CurrentRecordInfo.instance.state.selectedIndexes[0]:null;
	        if(!selectedIndex)selectedIndex = 0;
	        CurrentRecordInfo.instance.grid.doOnSelect({rowIdx:selectedIndex,idx:0,active:false});
	            var selectedCells = $(CurrentRecordInfo.instance.gridContainer).find(".react-grid-Cell.row-selected");
	        if(selectedCells.length==0)
	         return;
	        selectedCells[0].focus();*/
	      }
	    }
	  }]);
	
	  return CurrentRecordInfo;
	}(React.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.hideCurrentRecordInfo = function () {
	    $("#currentRecordInfoModal").css("display", "none");
	  };
	
	  this.btnCopy_clickHandler = function () {
	    var items = _this4.state.rows;
	    var columns = _this4.columns;
	    var CopyData = "";
	    if (_this4.isAdmin) {
	      CopyData = CopyData + columns[0].name + "\t" + columns[1].name + "\t" + columns[2].name + "\t" + columns[3].name + "\n";
	    } else {
	      CopyData = CopyData + columns[1].name + "\t" + columns[3].name + "\n";
	    }
	
	    if (_this4.isAdmin) {
	      items.map(function (item) {
	        CopyData = CopyData + item.dataSourceEnLabel + "\t" + item.chLabel + "\t" + item.enLabel + "\t" + item.fvalue + "\n";
	      });
	    } else {
	      items.map(function (item, i) {
	        CopyData = CopyData + item.chLabel + "\t" + item.fvalue + "\n";
	      });
	    }
	    _this4.doCopy(CopyData);
	  };
	
	  this.btnCopyItem_clickHandler = function () {
	    var columns = _this4.columns;
	    var CopyData = "";
	    if (_this4.isAdmin) {
	      CopyData = CopyData + columns[0].name + "\t" + columns[1].name + "\t" + columns[2].name + "\t" + columns[3].name + "\n";
	    } else {
	      CopyData = CopyData + columns[1].name + "\t" + columns[3].name + "\n";
	    }
	
	    for (var i = 0; i < _this4.state.selectedIndexes.length; i++) {
	      var _selectedIndex = _this4.state.selectedIndexes[i];
	      var item = _this4.state.rows[_selectedIndex];
	      if (_this4.isAdmin) {
	        CopyData = CopyData + item.dataSourceEnLabel + "\t" + item.chLabel + "\t" + item.enLabel + "\t" + item.fvalue + "\n";
	      } else {
	        CopyData = CopyData + item.chLabel + "\t" + item.fvalue + "\n";
	      }
	    }
	
	    _this4.doCopy(CopyData);
	  };
	
	  this.doCopy = function (txt) {
	    var tag = document.createElement('textarea');
	    tag.setAttribute('id', 'cp_hgz_input');
	    tag.value = txt;
	    document.getElementsByTagName('body')[0].appendChild(tag);
	    document.getElementById('cp_hgz_input').select();
	    document.execCommand('copy');
	    document.getElementById('cp_hgz_input').remove();
	
	    if (tag) {
	      $(_this4.CopyModalContainer).css("display", "none");
	      _Fade2.default.show({
	        text: "复制成功"
	      });
	    }
	  };
	
	  this.hideCopyModal = function () {
	    $(_this4.CopyModalContainer).css("display", "none");
	  };
	
	  this.btnRef_clickHandler = function () {
	    _this4.GlobalValueRepalceSelectItem = _this4.getCurrentRecord();
	    if (_this4.GlobalValueRepalceSelectItem == null) return;
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.services.MixedService", "listRecordRef", "List");
	    var recId;
	    var dgData = _this4.state.rows;
	    dgData.map(function (item) {
	      if (item.enLabel == "RecId") {
	        recId = item.fvalue;
	      }
	    });
	    var _tableName = _this4.state._tabName;
	    command.appendArg(_tableName);
	    command.appendArg(recId);
	    command.appendArg(_this4.GlobalValueRepalceSelectItem.enLabel);
	    _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: _this4.refResultHandler.bind(_this4) });
	  };
	
	  this.refResultHandler = function (event) {
	    if (event.result == null || event.result.length == 0) {
	      // alert("无引用关系","提示");
	      _Warn2.default.show({
	        text: "无引用关系",
	        title: "提示"
	      });
	    } else {
	      // this.RefResultList = event.result;
	      var items = event.result;
	      $(_this4.RefListBody).empty();
	      items.map(function (item) {
	        $(_this4.RefListBody).append("<li style='line-height:30px;line-style:none;width:100%;border-bottom:1px solid #f3f3f3;'>" + item + "</li>");
	      });
	      $(_this4.RecordRefViewModalContainer).css("display", "block");
	    }
	  };
	
	  this.btnGlobalValueRepalce_clickHandler = function () {
	    _this4.GlobalValueRepalceSelectItem = _this4.getCurrentRecord();
	    if (_this4.GlobalValueRepalceSelectItem == null) return;
	
	    $(_this4.GlobalValueRepalceModalContainer).css("display", "block");
	    var rows = _this4.state.rows;
	    var selectedIndex = void 0;
	
	    if (_this4.state.selectedIndexes && _this4.state.selectedIndexes.length > 0) selectedIndex = _this4.state.selectedIndexes[_this4.state.selectedIndexes.length - 1];
	
	    if (selectedIndex == -1 || !rows) return;
	    if (rows[selectedIndex]) {
	      $(_this4.GlobalValueRepalceModal_title).html(rows[selectedIndex].chLabel);
	      $(_this4.doRepalceValue).val(rows[selectedIndex].fvalue).focus().select();
	    }
	  };
	
	  this.hideGlobalValueRepalce = function () {
	
	    $(_this4.GlobalValueRepalceModalContainer).css("display", "none");
	  };
	
	  this.getCurrentRecord = function () {
	    var selectedIndex = _this4.state.selectedIndexes ? _this4.state.selectedIndexes[0] : -1;
	    if (selectedIndex > -1) {
	      return _this4.state.rows[selectedIndex];
	    }
	    return null;
	  };
	
	  this.saveGlobalValueRepalce = function () {
	
	    _this4.GlobalValueRepalceSelectItem = _this4.getCurrentRecord();
	
	    if (_this4.GlobalValueRepalceSelectItem == null) return;
	    var value = $(_this4.doRepalceValue).val();
	    var command = _Command2.default.createService("gongqi.erp.gotmodel.services.MixedService", "updateRecordRef", "List");
	    var recId = null;
	    var dataSourceMain = _this4.GlobalValueRepalceSelectItem.dataSourceEnLabel;
	    var dgData = _this4.state.rows;
	    dgData.map(function (item) {
	      if (item.enLabel == "RecId" && item.dataSourceEnLabel == dataSourceMain) {
	        recId = item.fvalue;
	      }
	    });
	    var _tableName = _this4.state._tabName;
	    command.appendArg(_tableName);
	    command.appendArg(recId);
	    command.appendArg(_this4.GlobalValueRepalceSelectItem.enLabel);
	    command.appendArg(value);
	    var self = _this4;
	    var remoteArg = {
	      command: command,
	      resultFunction: self.refUpdateResultHandler.bind(_this4, value),
	      faultFunction: self.refUpdateFaultHandler.bind(_this4)
	    };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    // ServiceHelper.addTokenWithCommand({
	    //   command: command,
	    //   resultFunction: self.refUpdateResultHandler.bind(this,result,value), 
	    //   faultFunction: self.refUpdateFaultHandler.bind(this)
	    // });
	  };
	
	  this.refUpdateFaultHandler = function (event) {
	    if (event && event.successButNot0) {
	      _Warn2.default.show({ text: event.errText, title: "替换失败" });
	      return;
	    }
	
	    var faultString = "";
	    var rootCause = event.fault.rootCause;
	    if (rootCause != null && rootCause.hasOwnProperty("message")) {
	      var errorCode = rootCause["errorCode"];
	      if (errorCode == "hibernate.ConstraintViolationException") {
	        var message = rootCause["message"];
	        if (message.indexOf("Duplicate entry") == 0) {
	          faultString = "存在重复的键值，不允许修改";
	        }
	      } else if (errorCode == "hibernate.StaleObjectStateException") {
	        faultString = "当前记录状态已不是最新或者已被删除，请执行恢复记录操作";
	      }
	
	      if (faultString == "") faultString = rootCause["message"];
	    } else {
	      faultString = event.fault.faultString;
	    }
	
	    if (faultString.indexOf("#NotNull:") == 0) {
	      faultString = "值不能为空，不允许修改";
	    }
	
	    //GongqiAlert.show(faultString,"保存操作由于以下原因未成功");
	    // alert(faultString,"全局替换操作由于以下原因未成功");
	    _Warn2.default.show({
	      text: faultString + "无结果返回!您可能替换的不是业务主键"
	    });
	  };
	
	  this.handleGridRowsUpdated = function (_ref) {
	    var fromRow = _ref.fromRow,
	        toRow = _ref.toRow,
	        updated = _ref.updated;
	
	    var rows = _this4.state.rows.slice();
	
	    for (var i = fromRow; i <= toRow; i++) {
	      var rowToUpdate = rows[i];
	      var updatedRow = $.extend(rowToUpdate, updated);
	      rows[i] = updatedRow;
	    }
	    _this4.setState({ rows: rows });
	  };
	
	  this.getRowAt = function (index) {
	    if (index < 0 || index > _this4.getSize()) {
	      return undefined;
	    }
	
	    return _this4.state.rows[index];
	  };
	
	  this.getSize = function () {
	    return _this4.state.rows.length;
	  };
	};
	
	exports.default = CurrentRecordInfo;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSource = function () {
	    function FormDataSource(xml, menuItemId, formId, forLookup) {
	        _classCallCheck(this, FormDataSource);
	
	        this.xml = xml;
	        this.id = xml.id;
	        var tablePro = this.xml.Properties.Table;
	        if (!tablePro.hasOwnProperty("refentityid")) throw new Error("GOT错误，id为" + this.xml.id + "的FormDataSource没有关联Table");
	        this.tableId = tablePro.refentityid;
	        this.tableName = tablePro.Value;
	        this.isAggreateTable = false;
	        this.isPivotTable = false;
	        this.alias = this.xml.name;
	        this.sourceName = this.xml.name;
	        this.joinType = _GOTUtil2.default.getPropertyValue(xml, "JoinType");
	
	        var _table = _GOT2.default.getTable(this.tableId);
	
	        this.isTempTable = _GOTUtil2.default.getPropertyValue(_table, "Temporary") == "true";
	
	        this.idGenerator = "Identity";
	
	        this.tableGroup = _GOTUtil2.default.getPropertyValue(_table, "TableType");
	
	        var _fetchAll = _GOTUtil2.default.getPropertyValue(xml, "FetchAll") == "true";
	        if (_fetchAll || this.isTempTable) this.fetchAll = true;else this.fetchAll = false;
	        if (this.isTempTable == false) {
	            var _key = _FormItemUtil2.default.getFormStoresKey(menuItemId, formId);
	            var formStore = window.parent.window[_key];
	            //formStore只针对于正常FormModule有用 针对于FormLookup及查询器、万能视图上的FormLookup等无用
	            if (formStore) {
	                var tmpAlias = formStore.listTmpTable;
	                if (tmpAlias && tmpAlias.indexOf(this.alias) > -1) {
	                    this.isTempTable = true;
	                } else {
	                    var listAggreate = formStore.listAggregateTable;
	                    if (listAggreate && listAggreate.indexOf(this.alias) > -1) {
	                        this.isAggreateTable = true;
	                        this.xml.Properties.AllowAttachment.Value = false;
	                    }
	
	                    var listPivotTable = formStore.listPivotTable;
	                    if (listPivotTable && listPivotTable.indexOf(this.alias) > -1) {
	                        this.isPivotTable = true;
	                    }
	                }
	            }
	        }
	
	        if (this.isTempTable == true) {
	            this.xml.Properties.AllowAttachment.Value = false;
	        }
	
	        this.joinType = _GOTUtil2.default.getPropertyValue(this.xml, "JoinType");
	        this.startPosition = _GOTUtil2.default.getPropertyValue(this.xml, "StartPosition");
	        this.allowExternalJoin = _GOTUtil2.default.getPropertyValue(this.xml, "ExternalJoin");
	        this.fieldNumOfDecimals = {}; //用于在获取记录以后 根据numOfDecimals去处理所有的记录的所有Decimals字段的值补零
	        this.fieldType = this.initFieldType(_table);
	    }
	
	    _createClass(FormDataSource, [{
	        key: 'addExtralFieldType',
	        value: function addExtralFieldType(field, type) {
	            if (!this.fieldType) this.fieldType = {};
	            this.fieldType[field] = type;
	        }
	    }, {
	        key: 'initFieldType',
	        value: function initFieldType(_table) {
	            var fieldType = {};
	
	            var list = this.xml.FormDataSourceFields;
	            if (!list || list.length == 0) {
	                list = _table.TableFields;
	            }
	
	            for (var i in list) {
	                var field = list[i];
	                var fieldName = _StringUtil2.default.convertToEachFirstLowerCase(field.name);
	                fieldType[fieldName] = field.type;
	                if (field.type == "Decimal") {
	                    this.fieldNumOfDecimals[fieldName] = _GOTUtil2.default.getPropertyValueStepByStep(field, null, "NumOfDecimals", "", false, false);
	                }
	            }
	            return fieldType;
	        }
	    }]);
	
	    return FormDataSource;
	}();
	
	exports.default = FormDataSource;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var ExportDataGrid = function (_React$Component) {
	  _inherits(ExportDataGrid, _React$Component);
	
	  function ExportDataGrid(props, context) {
	    _classCallCheck(this, ExportDataGrid);
	
	    var _this = _possibleConstructorReturn(this, (ExportDataGrid.__proto__ || Object.getPrototypeOf(ExportDataGrid)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    window.ExportDataGrid = _this;
	    var rows = _this.props.rows;
	    var columns = _this.props.columns;
	    _this.state = { rows: rows, selectedIndexes: [], columns: columns };
	    return _this;
	  }
	
	  _createClass(ExportDataGrid, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var minH = 375;
	      if (window.didomain || window.parent.window.didomain) {
	        if ($(document.body).width() < 900 || $(document.body).height() < 500) {
	          minH = 264;
	        }
	      }
	      return React.createElement(ReactDataGrid, {
	        ref: function ref(node) {
	          return _this2.grid = node;
	        },
	        onGridSort: this.handleGridSort,
	        enableCellSelect: true,
	        columns: this.props.columns
	        // columns={this.getColumns()}
	        , rowGetter: this.getRowAt,
	        rowsCount: this.getSize(),
	        onGridRowsUpdated: this.handleGridRowsUpdated
	        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	        , enableRowSelect: false,
	        rowSelection: {
	          showCheckbox: false,
	          selectBy: {
	            indexes: this.state.selectedIndexes
	
	          }
	        },
	        onRowClick: this.rowClick //this.rowClick this.rowClick.bind(this)
	        , rowHeight: 30,
	        minHeight: minH,
	        rowScrollTimeout: 500,
	        cellNavigationMode: 'loopOverRow'
	
	      });
	    }
	  }]);
	
	  return ExportDataGrid;
	}(React.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.createRows = function (numberOfRows) {
	    var rows = [];
	    for (var i = 0; i < numberOfRows; i++) {
	      rows[i] = _this3.createFakeRowObjectData(i);
	    }
	    return rows;
	  };
	
	  this.createFakeRowObjectData = function (index, data) {
	    console.log(data);
	    for (var i = 0; i < data.length; i++) {
	      var rows = _this3.state.rows.slice();
	      var _index = _this3.state.rows.length;
	      return {
	        id: 'id_' + _index,
	        title: tableName[i],
	        firstName: itemName[i],
	        lastName: lastName[i]
	      };
	    }
	  };
	
	  this.getColumns = function () {
	    var columns = _this3.state.columns.slice();
	    return columns;
	  };
	
	  this.test = function () {
	    console.log('1');
	  };
	
	  this.handleGridRowsUpdated = function (_ref) {
	    var fromRow = _ref.fromRow,
	        toRow = _ref.toRow,
	        updated = _ref.updated;
	
	    var rows = _this3.state.rows.slice();
	
	    for (var i = fromRow; i <= toRow; i++) {
	      var rowToUpdate = rows[i];
	      var updatedRow = $.extend(rowToUpdate, updated);
	      rows[i] = updatedRow;
	    }
	    _this3.setState({ rows: rows });
	  };
	
	  this.handleAddRow = function () {
	    var rows = _this3.state.rows.slice();
	    for (var i = fromRow; i <= toRow; i++) {
	      var rowToUpdate = rows[i];
	      var updatedRow = $.extend(rowToUpdate, updated);
	      rows[i] = updatedRow;
	    }
	    _this3.setState({ rows: rows });
	  };
	
	  this.deleteRow = function () {
	    var rows = _this3.state.rows.slice();
	    var selectedIndex = _this3.state.selectedIndexes[0];
	    rows.splice(selectedIndex, 1);
	    _this3.setState({ rows: rows, selectedIndexes: [rows.length - 1] });
	  };
	
	  this.getRowAt = function (index) {
	    if (index < 0 || index > _this3.getSize()) {
	      return undefined;
	    }
	
	    return _this3.state.rows[index];
	  };
	
	  this.getSize = function () {
	    return _this3.state.rows.length;
	  };
	
	  this.rowClick = function (index, record, proxy) {
	    _this3.setState({ selectedIndexes: [index] });
	  };
	
	  this.updateColumns = function (columns) {
	    alert(223);
	    _this3.props.columns = columns;
	    _this3.setState();
	  };
	
	  this.handleGridSort = function (sortColumn, sortDirection) {
	    var comparer = function comparer(a, b) {
	      if (sortDirection === 'ASC') {
	        return a[sortColumn] > b[sortColumn] ? 1 : -1;
	      } else if (sortDirection === 'DESC') {
	        return a[sortColumn] < b[sortColumn] ? 1 : -1;
	      }
	    };
	
	    var rows = sortDirection === 'NONE' ? _this3.state.rows.slice(0) : _this3.state.rows.sort(comparer);
	
	    _this3.setState({ rows: rows });
	  };
	
	  this.componentDidUpdate = function () {
	    var columns = _this3.state.columns.slice();
	  };
	};
	
	exports.default = ExportDataGrid;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExportDataGrid = __webpack_require__(188);
	
	var _ExportDataGrid2 = _interopRequireDefault(_ExportDataGrid);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ListDataGrid = __webpack_require__(191);
	
	var _ListDataGrid2 = _interopRequireDefault(_ListDataGrid);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormDataSources = __webpack_require__(50);
	
	var _FormDataSources2 = _interopRequireDefault(_FormDataSources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(314);
	
	var ExportTable = function (_React$Component) {
		_inherits(ExportTable, _React$Component);
	
		function ExportTable(props, context) {
			_classCallCheck(this, ExportTable);
	
			var _this = _possibleConstructorReturn(this, (ExportTable.__proto__ || Object.getPrototypeOf(ExportTable)).call(this, props, context));
	
			_this.componentDidMount = function () {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "getUserFormExports", "List");
	
				var key = _this.state.key;
				command.appendArg(key);
				command.appendArg(_this.userId);
				var that = _this;
				var _resultHandler = function _resultHandler(data) {
					that.initSaveList(data);
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
	
				$(_this.exportSizeDiv).draggable({
					handle: ".modal-header" // 只能点击头部拖动
				}); //为模态对话框添加拖拽
				var button = $("#gongqi_exportToClipboardModal button")[0];
				if (button && !button.onclick) {
					button.onclick = _this.onclipboardContentChange.bind(_this);
				}
				var close = $("#gongqi_exportToClipboardModal .modal-close")[0];
				if (close && !close.onclick) {
					close.onclick = _this.onclipboardClose.bind(_this);
				}
				if (_this.state.initExport) {
					_this.initOptionsList(_this.state.initExport);
				}
			};
	
			_this.initSaveList = function (data) {
				console.log(data);
				var result = data.result;
				var defaultItem;
				if (result.length > 0) {
					var saveList = [];
					if (result[0] == null) defaultItem = "";else defaultItem = result[0].split(" ")[0];
	
					for (var i = 0; i < result.length; i++) {
						var item = result[i];
						var itemArr = item.split(" ");
	
						var list = {};
						list['label'] = itemArr[1];
						list['fileName'] = itemArr[1];
						list['setDefault'] = itemArr[1] == defaultItem ? true : false;
						saveList.push(list);
					}
	
					_this.setState({ saveList: saveList });
				}
			};
	
			_this.saveSetting = function () {
				$("#exportSaveTable").show();
			};
	
			_this.listToXml = function (fileName) {
				var xmlStr = "<?xml version='1.0' encoding='utf-8'?>";
				var showTableName = _this.state.showTableName;
				xmlStr += "<nodes showTableName='" + showTableName + "' fileName='" + fileName + "'>";
				var columns = _this.state.columns.slice();
				for (var i = 0; i < columns.length; i++) {
					var column = columns[i];
					xmlStr += "<node dataField='" + column.dataField + "' fdsfId='" + column.fdsfId + "' fieldType='" + column.fieldType + "' ";
					xmlStr += "headerText='" + column.headerText + "' isDataMethod='" + column.isDataMethod + "' ";
					xmlStr += "normalHeaderText='" + column.normalHeaderText + "' ";
					xmlStr += "selected='" + column.selected + "' ";
					xmlStr += "formItemId='" + column.formItemId + "' ";
					xmlStr += "totalHeaderText='" + column.totalHeaderText + "'></node>";
				}
				xmlStr += "</nodes>";
				return xmlStr;
			};
	
			_this.save = function () {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "saveUserFormExport", "boolean");
				var key = _this.state.key;
	
				command.appendArg(key);
				command.appendArg(_this.userId);
				var fileName = $("#exportFileName").val();
				if (fileName != null && fileName != "") command.appendArg(fileName);else command.appendArg("test");
				var exportSetting = _this.listToXml(fileName);
				var setDefault = $("#exportDefaultBox").prop("checked");
				var saveList = _this.state.saveList.slice();
				var fileNameArr = [];
				for (var i = 0; i < saveList.length; i++) {
					var item = saveList[i];
					fileNameArr.push(item.fileName);
				}
				if ($.inArray(fileName, fileNameArr) == -1) {
					var list = {};
					list['label'] = fileName;
					list['fileName'] = fileName;
					list['setDefault'] = setDefault;
	
					saveList.push(list);
				}
	
				_this.setState({ saveList: saveList });
				var that = _this;
				command.appendArg(exportSetting);
				command.appendArg(setDefault, "boolean");
				var remoteArg = { command: command, resultFunction: function resultFunction(data) {
						that.saveSuccess(data, fileName, exportSetting, setDefault, key);
					},
					sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.saveSuccess = function (data, fileName, exportSetting, setDefault, key) {
				if (data.result) {
					//if(!window.userExportList)window.userExportList = {};
	
					if (setDefault) {
						//window.userExportList[this.key] = exportSetting
						_FormDataSources2.default.setUserDefaultExportList(exportSetting, key);
					} else {
						_FormDataSources2.default.updateUserDefaultExportListDupName(fileName, key, exportSetting);
						/*if(window.userExportList.hasOwnProperty(this.key))
	     {
	     var defaultSetting = window.userExportList[this.key];
	     var doc = (new DOMParser()).parseFromString(defaultSetting,"application/xml");
	     var	mainMsg=doc.getElementsByTagName("nodes")[0];
	     if(defaultSetting && mainMsg.attributes.fileName.nodeValue==fileName)
	     {
	     window.userExportList[this.key] = exportSetting;
	     }
	     
	     }*/
					}
				}
				_this.hideExportSaveTable();
				var options = {
					state: 'success'
				};
				_Fade2.default.show(options);
			};
	
			_this.setDefaultData = function () {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserDefaultFormExport", "String");
	
				var key = _this.state.key;
	
				command.appendArg(key);
				command.appendArg(_this.userId);
				var that = _this;
				var _resultHandler = function _resultHandler(data) {
					that.setDefaultSuccess(data);
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.setDefaultSuccess = function (data) {
				var result = data.result;
				var doc = new DOMParser().parseFromString(result, "application/xml");
				var mainMsg = doc.childNodes[0];
				var _showTableName = mainMsg.attributes.showTableName.nodeValue;
				var showTableName = _showTableName == true || _showTableName == 'true' ? true : false;
				var fileName = mainMsg.attributes.fileName.nodeValue;
				var columnsMsg = mainMsg.childNodes;
				var dataFieldArr = [];
				var dataFieldNode = {};
				for (var i = 0; i < columnsMsg.length; i++) {
					if (columnsMsg[i].attributes) {
						var res = _this.state.group.getExportColumnInfo(columnsMsg[i].attributes.fdsfId.nodeValue, columnsMsg[i].attributes.formItemId.nodeValue, columnsMsg[i].attributes.isDataMethod.nodeValue, _this.state.group.sources.length > 1 ? true : false);
						// dataFieldArr.push(columnsMsg[i].attributes.dataField.nodeValue);
						if (res) {
							dataFieldArr.push(res.oneddatafield);
							dataFieldNode[res.oneddatafield] = columnsMsg[i];
						} else {
							dataFieldArr.push(columnsMsg[i].attributes.dataField.nodeValue);
							dataFieldNode[columnsMsg[i].attributes.dataField.nodeValue] = columnsMsg[i];
						}
					}
				}
				var all = _this.all;
				var columns = [];
				for (var i = 0; i < dataFieldArr.length; i++) {
					var columnDataFiled = dataFieldArr[i];
					for (var j = 0; j < all.length; j++) {
						var item = all[j];
						if (item.dataField == columnDataFiled) {
							if (item.totalLabel) {
								var column = {};
								column['dataField'] = item.dataField;
								column['fdsfId'] = item.fdsfId;
								column['fieldType'] = item.fieldType;
								column['formItemId'] = item.formItemId;
								column['isDataMethod'] = item.isDataMethod;
								column['normalHeaderText'] = item.label;
								column['selected'] = item.selected;
								column['totalHeaderText'] = item.totalLabel;
								columns.push(column);
							} else {
								item['selected'] = dataFieldNode[columnDataFiled].attributes.selected.nodeValue;
								columns.push(item);
							}
							all.splice($.inArray(item, all), 1);
						}
					}
				}
	
				for (var i = 0; i < all.length; i++) {
					var item = all[i];
					if (!item.totalLabel) {
						var extral = {};
						extral['dataField'] = item.dataField;
						extral['fdsfId'] = item.fdsfId;
						extral['fieldType'] = item.fieldType;
						extral['formItemId'] = item.formItemId;
						extral['isDataMethod'] = item.isDataMethod;
						extral['label'] = item.normalHeaderText;
						extral['selected'] = item.selected;
						extral['totalLabel'] = item.totalHeaderText;
						all.push(extral);
						all.splice($.inArray(item, all), 1);
					}
				}
				var title = "导出预览" + fileName;
				_this.setState({ columns: columns, extrals: all, showTableName: showTableName, title: title });
				setTimeout(_this.forceUpdate.bind(_this), 100);
				_this.all = _this.state.columns.slice().concat(_this.state.extrals.slice());
				var options = {
					state: 'success'
				};
				_Fade2.default.show(options);
			};
	
			_this.setOptionsList = function () {
				var options = [];
				var saveList = _this.state.saveList.slice();
				if (saveList.length == 0) {
					options.push(_react2.default.createElement(
						'option',
						{ key: 'none' },
						'\u6CA1\u6709\u53EF\u7528\u5217\u8868'
					));
				} else {
					for (var i = 0; i < saveList.length; i++) {
						var list = saveList[i];
						options.push(_react2.default.createElement(
							'option',
							{ value: list.fileName, key: 'list' + i },
							list.label
						));
					}
				}
				return options;
			};
	
			_this.changeOptionsList = function () {
				var value = $("#exportLists").val();
				var saveList = _this.state.saveList.slice();
				if (value) {
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserFormExport", "String");
	
					var key = _this.state.key;
					var that = _this;
	
					command.appendArg(key);
					command.appendArg(_this.userId);
					command.appendArg(value);
					var _resultHandler = function _resultHandler(data) {
						that.setOptionSuccess(data);
					};
					var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			};
	
			_this.initOptionsList = function (value) {
				var saveList = _this.state.saveList.slice();
				if (value) {
					var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserFormExport", "String");
	
					var key = _this.state.key;
					var that = _this;
	
					command.appendArg(key);
					command.appendArg(_this.userId);
					command.appendArg(value);
					var _resultHandler = function _resultHandler(data) {
						that.setOptionSuccess(data, value);
					};
					var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
					_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				}
			};
	
			_this.setOptionSuccess = function (data) {
				var fileName2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				var result = data.result;
				var doc = new DOMParser().parseFromString(result, "application/xml");
				var mainMsg = doc.childNodes[0];
				//console.log(mainMsg);
				var _showTableName = mainMsg.attributes.showTableName ? mainMsg.attributes.showTableName.nodeValue : false;
				var showTableName = _showTableName == true || _showTableName == 'true' ? true : false;
				var fileName = mainMsg.attributes.fileName.nodeValue;
				if (!fileName) fileName = fileName2;
				var columnsMsg = mainMsg.getElementsByTagName("node");
				var columns = [];
				var difference = false;var map = {};
				//console.log(columnsMsg);
				for (var i = 0; i < columnsMsg.length; i++) {
	
					var _columnItem = columnsMsg[i];
	
					var fdsfId = _columnItem.attributes.fdsfId.nodeValue;
					var formItemId = _columnItem.attributes.formItemId.nodeValue;
					var isDataMethod = _columnItem.attributes.isDataMethod.nodeValue;
					var _selected = _columnItem.attributes.selected.nodeValue;
					var result = _this.state.group.getExportColumnInfo(fdsfId, formItemId, isDataMethod, _this.state.group.sources.length > 1 ? true : false);
					if (!result) {
						difference = true;
						continue;
					}
					if (result.oneddatafield && map[result.oneddatafield] == true) {
						continue;
					}
					map[result.oneddatafield] = true;
					var column = {
						headerText: result.label, normalHeaderText: result.label, dataField: result.oneddatafield, formItemId: formItemId, totalLabel: result.totalLabel, totalHeaderText: result.totalLabel,
						selected: _selected == true || _selected == 'true' ? true : false, isDataMethod: isDataMethod, fdsfId: fdsfId
					};
					//if(!_columnItem.attributes.fieldType)alert("保存的设置中没有字段数据类型信息");
					column['fieldType'] = _columnItem.attributes.fieldType ? _columnItem.attributes.fieldType.nodeValue : result.fieldType;
					columns.push(column);
				}
				var all = _this.all;
	
				for (var i = 0; i < columns.length; i++) {
					var thisDataField = columns[i].dataField;
					for (var j = 0; j < all.length; j++) {
						var item = all[j];
						if (item.dataField == thisDataField) {
							all.splice($.inArray(item, all), 1);
						}
					}
				}
				for (var i = 0; i < all.length; i++) {
					var item = all[i];
					if (!item.totalLabel) {
						var extral = {};
						extral['dataField'] = item.dataField;
						extral['fdsfId'] = item.fdsfId;
						extral['fieldType'] = item.fieldType;
						extral['formItemId'] = item.formItemId;
						extral['isDataMethod'] = item.isDataMethod;
						extral['label'] = item.normalHeaderText;
						extral['selected'] = item.selected;
						extral['totalLabel'] = item.totalHeaderText;
						all.push(extral);
						all.splice($.inArray(item, all), 1);
					}
				}
				var title = "导出预览  来自设置(" + fileName + ")";
				var warnTitle = "";
				if (difference == true) warnTitle = "由于业务模型更改，您现在看到的设置是拟合后的结果，如有疑问请联系管理员";
				_this.setState({ columns: columns, extrals: all, showTableName: showTableName, title: title, warnTitle: warnTitle });
				setTimeout(_this.forceUpdate.bind(_this), 100);
				_this.all = _this.state.columns.slice().concat(_this.state.extrals.slice());
				_this.hideExportSetTable();
				var options = {
					state: 'success'
				};
				if (fileName2) {
					_this.state.initExport = undefined;
					return;
				}
				_Fade2.default.show(options);
			};
	
			_this.getExportHeadData = function () {
				var headerInfo = [];
				for (var i = 0; i < _this.state.columns.length; i++) {
					var col = _this.state.columns[i];
					if (col.selected) {
						var _headerText = _this.state.showTableName ? col.totalHeaderText : col.headerText || col.normalHeaderText;
						var item = { dataField: col.dataField, headerText: _headerText, fieldType: col.fieldType };
						if (col.fieldType == "Decimal") {
							if (!col.numOfDecimals) {
								for (var key in _FormItemUtil2.default.formItemControlsForFor) {
									var fe = _FormItemUtil2.default.formItemControlsForFor[key];
									if (col.formItemId == fe.xml.id) {
										item.numOfDecimals = fe.getProperty_NumOfDecimals();
										break;
									}
								}
							} else {
								item.numOfDecimals = col.numOfDecimals;
							}
	
							if (typeof item.numOfDecimals == "string") {
								try {
									item.numOfDecimals = parseInt(item.numOfDecimals);
								} catch (e) {
									item.numOfDecimals = 2;
								}
							}
						}
						headerInfo.push(item);
					}
				}
				return headerInfo;
			};
	
			_this.getExportBodyData = function (exportHeads) {
				var ac = _this.state.ac.slice();
				var exportBodys = [];
				for (var i = 0; i < ac.length; i++) {
					var item = ac[i];
					var exportBody = [];
					for (var j = 0; j < exportHeads.length; j++) {
						var key = exportHeads[j].dataField;
						exportBody.push(item[key]);
					}
					exportBodys.push(exportBody);
				}
				return exportBodys;
			};
	
			_this.exportExcel = function () {
	
				var array = _this.getExportHeadData();
				if (!array || array.length == 0) {
					_Fade2.default.show({ text: "没有可导出的列" });
					return;
				}
				var label = "";var _group = _this.state.group;
				var mainSource = _group.mainSource;
				var tablePro = _GOTUtil2.default.getProperty(mainSource.xml, "Table");
				if (tablePro != null && tablePro.hasOwnProperty("refentityid")) {
					var table = _GOT2.default.getTable(tablePro.refentityid);
					if (table) {
						label = _GOTUtil2.default.getPropertyValue(table, "Label");
						if (!label) {
							label = mainSource.xml.name;
						}
					}
				}
	
				var command = _Command2.default.createService("gongqi.erp.layers.sys.services.ExportService", "exportExcel", "String");
				command.appendArg(label);
				// TODO_YL 数值类型变成String  方便处理
				// for(let ja = 0;ja<array.length;ja++)
				// {
				// 	var fieldd = array[ja];
				// 	if(fieldd.fieldType == "Decimal" || fieldd.fieldType=="Long"){
				// 		fieldd.fieldType ="String";
				// 	}				
				// }
	
				command.appendArg(array, "List");
	
				var _exportDataProvider = [];
	
				for (var i = 0; i < _this.state.ac.length; i++) {
					var item = _this.state.ac[i];
					var _exportItem = {};
					for (var j = 0; j < array.length; j++) {
						var field = array[j];
						_exportItem[field.dataField] = item[field.dataField] + "";
						if (_exportItem[field.dataField] == '' || _exportItem[field.dataField] == "undefined" || _exportItem[field.dataField] == null || _exportItem[field.dataField] == "null") {
							if (field.fieldType == "Decimal" || field.fieldType == "Long") {
								_exportItem[field.dataField] = 0;
							} else {
								_exportItem[field.dataField] = "";
							}
						}
					}
					_exportDataProvider.push(_exportItem);
				}
				command.appendArg(_exportDataProvider, "List");
				//command.appendArg(this.state.ac,"List");
	
				_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: _this.rpc_exportExcelHandler, sync: false });
				return;
	
				var options = {
					type: 'excel'
				};
				var exportHeads = _this.getExportHeadData();
				var exportBodys = _this.getExportBodyData(exportHeads);
	
				$("#exportDataGrid .react-grid-Grid").tableExport(exportHeads, exportBodys, options); //tbodySelector,theadSelector,type,options
			};
	
			_this.rpc_exportExcelHandler = function (data) {
				if (data) {
					var commandTask = new _CommandTask2.default();
					commandTask.cmd = _Cmd2.default.FileDownload;
					commandTask.arg = data.result;
					_CommandResolver2.default.downLoad(commandTask, window.formModuleInstance);
				}
			};
	
			_this.exportCSV = function () {
				var userId = "";
				var _parentWindow = window.parent.window;
				if (_parentWindow) userId = _parentWindow.userInfos.userId;
				var options = {
					type: 'csv',
					fileName: window.formModuleInstance.formLabel + "_" + new Date().format("yyyyMMddhhmmssS") + "_" + userId
				};
				var exportHeads = _this.getExportHeadData();
				if (!exportHeads || exportHeads.length == 0) {
					_Fade2.default.show({ text: "没有可导出的列" });
					return;
				}
				var exportBodys = _this.getExportBodyData(exportHeads);
				$("#exportDataGrid .react-grid-Grid").tableExport(exportHeads, exportBodys, options);
			};
	
			_this.exportClipBoard = function (e) {
				var exportHeads = _this.getExportHeadData();
				if (!exportHeads || exportHeads.length == 0) {
					_Fade2.default.show({ text: "没有可导出的列" });
					return;
				}
				var exportBodys = _this.getExportBodyData(exportHeads);
				var rowCount = exportBodys.length;
				var data = "";
				var fieldSeparator = "\t";
				var lineSeparator = "\n";
				var fields = [];
				//循环表头数据
				for (var i = 0; i < exportHeads.length; i++) {
					var filed = exportHeads[i];
					fields.push(filed.headerText);
					data += filed.headerText + fieldSeparator;
					if (i == exportHeads.length - 1) {
						data += lineSeparator;
					}
				}
	
				//循环行数据
				for (var i = 0; i < rowCount; i++) {
					var record = exportBodys[i];
					for (var j = 0; j < record.length; j++) {
						var item = record[j];
						data += item + fieldSeparator;
						if (j == record.length - 1) data += lineSeparator;
					}
				}
	
				var textarea = document.getElementById("exportToClipBoardContent"); //创建input对象  
	
				textarea.value = data;
				$("#gongqi_exportToClipboardModal p").html("本次共导出" + rowCount + "条数据");
				$("#gongqi_exportToClipboardModal").css("display", "flex");
				//return $(textarea).text();
				//$("#gongqi_exportToClipboardModal").css("display","flex");
				//this.clipboardjs.onClick({delegateTarget:textarea});
				//$("#gongqi_exportToClipboardModal #exportToClipBoard").trigger("click");
	
	
				/*const copyHandler = (e) => {
	   e.clipboardData.setData('text/plain', data);
	   e.preventDefault();
	   };
	   document.addEventListener('copy', copyHandler);
	   Copy(data);
	   document.removeEventListener('copy', copyHandler);
	   var options = {
	   state: 'success',
	   text: '成功复制到剪切板'
	   }
	   Fade.show(options);*/
			};
	
			_this.exportCheckboxState = function (ev) {
				var _columns = _this.state.columns.slice();
				for (var i = 0; i < _columns.length; i++) {
					if (_columns[i].dataField == ev.target.name) {
						var _selected = $(ev.target).prop("checked") == "true" || $(ev.target).prop("checked") == true ? true : false;
						_columns[i].selected = _selected;
					}
				}
				var tableColumns = _this.setTableColumns(_columns);
				_this.setState({ columns: _columns, tableColumns: tableColumns });
				setTimeout(_this.forceUpdate.bind(_this), 100);
			};
	
			_this.oppoChoose = function (ev) {
				var _columns = _this.state.columns.slice();
				for (var i = 0; i < _columns.length; i++) {
					_columns[i].selected = !_columns[i].selected;
				}
				var tableColumns = _this.setTableColumns(_columns);
				_this.setState({ columns: _columns, tableColumns: tableColumns });
				setTimeout(_this.forceUpdate.bind(_this), 100);
			};
	
			_this.allChoose = function (ev) {
				if (!ev.target) return;
				var _selected = ev.target.checked;
				var _columns = _this.state.columns.slice();
				for (var i = 0; i < _columns.length; i++) {
					_columns[i].selected = _selected;
				}
				var tableColumns = _this.setTableColumns(_columns);
				_this.setState({ columns: _columns, tableColumns: tableColumns });
				setTimeout(_this.forceUpdate.bind(_this), 100);
			};
	
			_this.changeTableNameState = function (ev) {
				var _showTable = $(ev.target).prop("checked") == true || $(ev.target).prop("checked") == "true" ? true : false;
	
				_this.setState({ showTableName: _showTable });
				setTimeout(_this.forceUpdate.bind(_this), 100);
			};
	
			_this.allowDrop = function (ev) {
				ev.preventDefault();
			};
	
			_this.drag = function (ev) {
				/*var btn=document.createElement("BUTTON");
	   var t=document.createTextNode("CLICKxxx");
	   btn.appendChild(t);*/
				var helper = $("#exportDragHelper");
				helper.empty();
				var parent = $(ev.target).parent();
				var uiSelected = parent.find(">div.ui-selected");
				helper.append(uiSelected.clone());
				var ids = [];
				uiSelected.each(function (index, item) {
	
					ids.push(this.id);
				});
				ev.dataTransfer.setData("Text", ids);
				//let cloned1 = $("#EquipCodePointTable\\.codePointld").clone();
				//let cloned2 = $("#EquipCodePointTable\\.codePointName").clone();
				//let div = $("<div style='display:flex;flex-direction:column'></div>").append(cloned1).append(cloned2);
				ev.dataTransfer.setDragImage(helper[0], 0, 0);
			};
	
			_this.drop = function (ev) {
				ev.preventDefault();
				var data = ev.dataTransfer.getData("Text");
				if (!data) return;
				var datas = data.split(",");
				var _columns = _this.state.columns.slice();
				var _extrals = _this.state.extrals.slice();
				if (ev.target.id == 'chooseableColumns') {
	
					for (var i = _columns.length - 1; i >= 0; i--) {
						var column = _columns[i];
						if (datas.indexOf(column.dataField) != -1) {
							//if(column.dataField==data){
							var extral = {};
							extral['dataField'] = column.dataField;
							extral['fdsfId'] = column.fdsfId;
							extral['fieldType'] = column.fieldType;
							extral['formItemId'] = column.formItemId;
							extral['isDataMethod'] = column.isDataMethod;
							extral['label'] = column.normalHeaderText;
							extral['selected'] = column.selected;
							extral['totalLabel'] = column.totalHeaderText;
							if (column.numOfDecimals) extral['numOfDecimals'] = column.numOfDecimals;
							_extrals.push(extral);
							_columns.splice($.inArray(column, _columns), 1);
						}
					}
				} else if (ev.target.parentNode.id == 'chooseableColumns') {
					var thisIndex;
					//先找到拖拽代理放置的那个节点的索引
					for (var i = 0; i < _extrals.length; i++) {
						var extrals = _extrals[i];
						if (extrals.dataField == ev.target.id) {
							thisIndex = $.inArray(extrals, _extrals);
						}
					}
					var j = 0;
					for (var i = _columns.length - 1; i > 0; i--) {
						var column = _columns[i];
						//if(column.dataField==data)
						if (datas.indexOf(column.dataField) != -1) {
							var extral = {};
							extral['dataField'] = column.dataField;
							extral['fdsfId'] = column.fdsfId;
							extral['fieldType'] = column.fieldType;
							extral['formItemId'] = column.formItemId;
							extral['isDataMethod'] = column.isDataMethod;
							extral['label'] = column.normalHeaderText;
							extral['selected'] = column.selected;
							extral['totalLabel'] = column.totalHeaderText;
							if (column.numOfDecimals) extral['numOfDecimals'] = column.numOfDecimals;
							_extrals.splice(thisIndex, 0, extral);
							_columns.splice($.inArray(column, _columns), 1);
						} else {
							j++;
						}
					}
					if (j == _columns.length) {
						for (var i = _extrals.length - 1; i >= 0; i--) {
							var extral = _extrals[i];
							if (datas.indexOf(extral.dataField) != -1) {
								//if(extral.dataField==data){
								_extrals.splice($.inArray(extral, _extrals), 1);
								_extrals.splice(thisIndex, 0, extral);
							}
						}
					}
				} else if (ev.target.id == "exportColumns") {
					for (var i = _extrals.length - 1; i >= 0; i--) {
						var extral = _extrals[i];
						if (datas.indexOf(extral.dataField) != -1) {
							//if(extral.dataField==data){
							var column = {};
							column['dataField'] = extral.dataField;
							column['fdsfId'] = extral.fdsfId;
							column['fieldType'] = extral.fieldType;
							column['formItemId'] = extral.formItemId;
							column['isDataMethod'] = extral.isDataMethod;
							column['headerText'] = column['normalHeaderText'] = extral.label;
							column['selected'] = extral.selected;
							column['totalHeaderText'] = extral.totalLabel;
							if (extral.numOfDecimals) column['numOfDecimals'] = extral.numOfDecimals;
							_columns.push(column);
							_extrals.splice($.inArray(extral, _extrals), 1);
						}
					}
				} else if (ev.target.parentNode.id == 'exportColumns') {
					var thisIndex;
					for (var i = 0; i < _columns.length; i++) {
						var column = _columns[i];
						if (column.dataField == ev.target.id) {
							thisIndex = $.inArray(column, _columns);
						}
					}
					var j = 0;thisIndex--;if (!thisIndex || thisIndex < 0) thisIndex = 0;
					for (var i = _extrals.length - 1; i >= 0; i--) {
						var extral = _extrals[i];
						//if(extral.dataField==data){
						if (datas.indexOf(extral.dataField) != -1) {
							var column = {};
							column['dataField'] = extral.dataField;
							column['fdsfId'] = extral.fdsfId;
							column['fieldType'] = extral.fieldType;
							column['formItemId'] = extral.formItemId;
							column['isDataMethod'] = extral.isDataMethod;
							column['normalHeaderText'] = extral.label;
							column['selected'] = extral.selected;
							column['totalHeaderText'] = extral.totalLabel;
							if (extral.numOfDecimals) column['numOfDecimals'] = extral.numOfDecimals;
							_columns.splice(thisIndex, 0, column);
							thisIndex++;
							_extrals.splice($.inArray(extral, _extrals), 1);
						} else {
							j++;
						}
					}
					if (j == _extrals.length) {
						var nextIndex;
						for (var i = _columns.length - 1; i >= 0; i--) {
							var column = _columns[i];
							//if(column.dataField==data){
							if (datas.indexOf(column.dataField) != -1) {
								_columns.splice($.inArray(column, _columns), 1);
								_columns.splice(thisIndex, 0, column);
							}
						}
					}
				}
				var tableColumns = _this.setTableColumns(_columns);
				_this.setState({ columns: _columns, extrals: _extrals, tableColumns: tableColumns });
				setTimeout(_this.forceUpdate.bind(_this), 100);
				$("#exportDragHelper").empty();
				$(_this.chooseableColumnsNode).find(">div.ui-selected").removeClass("ui-selected");
				$(_this.exportColumnsContentNode).find(">div.ui-selected").removeClass("ui-selected");
			};
	
			_this.onDragEnterHandler = function (ev) {
				$(ev.target).addClass("ui-selected");
			};
	
			_this.onDragLeaveHandler = function (ev) {
				$(ev.target).removeClass("ui-selected");
			};
	
			_this.setTableColumns = function (_columns) {
				var tableColumns = [];
				var dataFieldArr = [];
				for (var i = 0; i < _columns.length; i++) {
	
					//判断重复dataField
					if (dataFieldArr.indexOf(_columns[i].dataField) == -1) {
						var column = {};
						column['key'] = _columns[i].dataField;
						dataFieldArr.push(_columns[i].dataField);
						if (_this.state.showTableName) {
							column['name'] = _columns[i].totalHeaderText;
						} else {
							column['name'] = _columns[i].normalHeaderText;
						}
						column['width'] = 120;
						column['resizable'] = 'true';
						column['sortable'] = 'true';
						if (_columns[i].selected) tableColumns.push(column);
					}
				}
				return tableColumns;
			};
	
			_this.setExportColumns = function () {
				var list = [];
				var exportColumns = _this.state.columns.slice();
				for (var i = 0; i < exportColumns.length; i++) {
					var _selected = exportColumns[i].selected;
	
					if (_this.state.showTableName) {
						list.push(_react2.default.createElement(
							'div',
							{ onDragEnter: _this.onDragEnterHandler, onDragLeave: _this.onDragLeaveHandler, onMouseDown: _this.exportColumnMouseDown, onMouseUp: _this.exportolumnMouseUp, draggable: 'true', onDragStart: _this.drag, id: exportColumns[i].dataField, key: 'drop' + i, style: { position: 'relative', paddingLeft: '5px' } },
							_react2.default.createElement('input', { type: 'checkbox', checked: _selected, onClick: _this.exportCheckboxState, id: "export_input_" + exportColumns[i].dataField, name: exportColumns[i].dataField }),
							_react2.default.createElement('label', { htmlFor: "export_input_" + exportColumns[i].dataField }),
							exportColumns[i].totalHeaderText
						));
					} else {
						list.push(_react2.default.createElement(
							'div',
							{ onDragEnter: _this.onDragEnterHandler, onDragLeave: _this.onDragLeaveHandler, onMouseDown: _this.exportColumnMouseDown, onMouseUp: _this.exportolumnMouseUp, draggable: 'true', onDragStart: _this.drag, id: exportColumns[i].dataField, key: 'drop' + i, style: { position: 'relative', paddingLeft: '5px' } },
							_react2.default.createElement('input', { type: 'checkbox', checked: _selected, onClick: _this.exportCheckboxState, id: "export_input_" + exportColumns[i].dataField, name: exportColumns[i].dataField }),
							_react2.default.createElement('label', { htmlFor: "export_input_" + exportColumns[i].dataField }),
							exportColumns[i].normalHeaderText
						));
					}
				}
				return list;
			};
	
			_this.chooseableColumnMouseDown = function (e) {
				var _selectable = $(_this.chooseableColumnsNode);
				if (!e.ctrlKey && !e.shiftKey) {
					//没有按下Ctrl或Shift键
					if (!$(e.target).hasClass("ui-selected")) {
						_selectable.find(">div").removeClass("ui-selected");
					}
					$(e.target).addClass("ui-selected");
					_this.chooseable_selected_begin_index = _selectable.find(">div").index(e.target);
				} else if (e.ctrlKey && !e.shiftKey) {
					//只按下Ctrl键
					$(e.target).addClass("ui-selected");
					_this.chooseable_selected_begin_index = _selectable.find(">div").index(e.target);
				} else if (!e.ctrlKey && e.shiftKey || e.ctrlKey && e.shiftKey) {
					//只按下Shift键或Ctrl和Shift键都按下
					_selectable.find(">div").removeClass("ui-selected");
					$(e.target).addClass("ui-selected");
	
					if (_this.chooseable_selected_begin_index != undefined) {
						_this.chooseable_selected_end_index = _selectable.find(">div").index(e.target);
					} else {
						_this.chooseable_selected_begin_index = _selectable.find(">div").index(e.target);
					}
	
					if (_this.chooseable_selected_end_index >= _this.chooseable_selected_begin_index) {
						for (var i = _this.chooseable_selected_begin_index; i <= _this.chooseable_selected_end_index; i++) {
							_selectable.find(">div").eq(i).addClass("ui-selected");
						}
					} else {
						for (var i = _this.chooseable_selected_end_index; i <= _this.chooseable_selected_begin_index; i++) {
							_selectable.find(">li").eq(i).addClass("ui-selected");
						}
					}
				}
			};
	
			_this.exportColumnMouseDown = function (e) {
				var _selectable = $(_this.exportColumnsContentNode);
				if (!e.ctrlKey && !e.shiftKey) {
					//没有按下Ctrl或Shift键
					if (!$(e.target).hasClass("ui-selected")) {
						_selectable.find(">div").removeClass("ui-selected");
					}
					$(e.target).addClass("ui-selected");
					_this.chooseable_selected_begin_index = _selectable.find(">div").index(e.target);
				} else if (e.ctrlKey && !e.shiftKey) {
					//只按下Ctrl键
					$(e.target).addClass("ui-selected");
					_this.chooseable_selected_begin_index = _selectable.find(">div").index(e.target);
				} else if (!e.ctrlKey && e.shiftKey || e.ctrlKey && e.shiftKey) {
					//只按下Shift键或Ctrl和Shift键都按下
					_selectable.find(">div").removeClass("ui-selected");
					$(e.target).addClass("ui-selected");
	
					if (_this.chooseable_selected_begin_index != undefined) {
						_this.chooseable_selected_end_index = _selectable.find(">div").index(e.target);
					} else {
						_this.chooseable_selected_begin_index = _selectable.find(">div").index(e.target);
					}
	
					if (_this.chooseable_selected_end_index >= _this.chooseable_selected_begin_index) {
						for (var i = _this.chooseable_selected_begin_index; i <= _this.chooseable_selected_end_index; i++) {
							_selectable.find(">div").eq(i).addClass("ui-selected");
						}
					} else {
						for (var i = _this.chooseable_selected_end_index; i <= _this.chooseable_selected_begin_index; i++) {
							_selectable.find(">li").eq(i).addClass("ui-selected");
						}
					}
				}
			};
	
			_this.chooseableColumnMouseUp = function (e) {
				var _selectable = $(_this.chooseableColumnsNode);
				if (!e.ctrlKey && !e.shiftKey) {
					//没有按下Ctrl或Shift键
					_selectable.find(">div").removeClass("ui-selected");
					$(e.target).addClass("ui-selected");
				}
			};
	
			_this.exportColumnMouseUp = function (e) {
				var _selectable = $(_this.exportColumnsContentNode);
				if (!e.ctrlKey && !e.shiftKey) {
					//没有按下Ctrl或Shift键
					_selectable.find(">div").removeClass("ui-selected");
					$(e.target).addClass("ui-selected");
				}
			};
	
			_this.setChooseableColumns = function () {
				var list = [];
				var chooseableColumns = _this.state.extrals.slice();
				for (var i = 0; i < chooseableColumns.length; i++) {
					var label = void 0;
					if (_this.state.showTableName) {
						label = chooseableColumns[i].totalLabel;
					} else {
						label = chooseableColumns[i].label;
					}
	
					list.push(_react2.default.createElement(
						'div',
						{ onDragEnter: _this.onDragEnterHandler, onDragLeave: _this.onDragLeaveHandler, onMouseUp: _this.chooseableColumnMouseUp, onMouseDown: _this.chooseableColumnMouseDown, draggable: 'true', onDragStart: _this.drag, id: chooseableColumns[i].dataField, key: 'drag' + i },
						label
					));
				}
				return list;
			};
	
			_this.hideExportTable = function () {
				$("#exportModal").empty();
			};
	
			_this.hideExportSaveTable = function () {
				$("#exportSaveTable").hide();
			};
	
			_this.showExportSetTable = function () {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "getUserFormExportsWithDefault", "List");
				var key = _this.state.key;
	
				command.appendArg(key);
				command.appendArg(_this.userId);
				var that = _this;
				var remoteArg = { command: command, resultFunction: function resultFunction(data) {
						that.getListDataGridRows(data);
					}, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.getListDataGridRows = function (data) {
				var result = data.result;
				var listRows = [];
	
				for (var i = 1; i < result.length; i++) {
					var listRow = {};
					var item = result[i];
					var itemArr = item.split(" ");
					listRow['userName'] = itemArr[0];
					listRow['fileName'] = itemArr[1];
					listRows.push(listRow);
				}
				window.ListDataGrid.setState({ rows: listRows });
				var defaultItem;
				if (result[0]) {
					defaultItem = result[0].split(" ")[1];
				}
	
				_this.exportSetTableTitle(defaultItem);
				$("#exportSetTable").show();
			};
	
			_this.setTableSelectedFileName = function () {
				var selectedIndex = window.ListDataGrid.state.selectedIndexes[0];
				var rows = window.ListDataGrid.state.rows.slice();
				if (!rows || rows.length == 0) return;
				if (selectedIndex >= rows.length || selectedIndex < 0) return;
				var fileName = rows[selectedIndex].fileName;
	
				return fileName;
			};
	
			_this.setTableSelectedUserName = function () {
				var selectedIndex = window.ListDataGrid.state.selectedIndexes[0];
				var rows = window.ListDataGrid.state.rows.slice();
				var userName = rows[selectedIndex].userName;
				return userName;
			};
	
			_this.resetExportTable = function () {
				var fileName = _this.setTableSelectedFileName();
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserFormExport", "String");
	
				var key = _this.state.key;
				var that = _this;
				var selectedIndex = window.ListDataGrid.state.selectedIndexes[0];
				var rows = window.ListDataGrid.state.rows.slice();
				var userName = rows[selectedIndex].userName;
				command.appendArg(key);
				command.appendArg(userName);
				command.appendArg(fileName);
				var remoteArg = { command: command, resultFunction: function resultFunction(data) {
						that.setOptionSuccess(data);
					}, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.deleteExportList = function () {
				var fileName = _this.setTableSelectedFileName();
				var delDefault;
				var saveList = _this.state.saveList.slice();
				for (var i = 0; i < saveList.length; i++) {
					if (saveList[i].setDefault) {
						delDefault = true;
					}
				}
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "deleteUserFormExport", "void");
	
				var key = _this.state.key;
				var that = _this;
	
				command.appendArg(key);
				command.appendArg(_this.userId);
				command.appendArg(fileName);
				var _resultHandler = function _resultHandler(data) {
					if (delDefault) {
						_FormDataSources2.default.setUserDefaultExportList(null, that.key);
						//window.userExportList[that.key] = null;
						//delete window.userExportList[that.key];
					}
					var saveList = that.state.saveList.slice();
					for (var i = 0; i < saveList.length; i++) {
						if (saveList[i].fileName == fileName) {
							saveList.splice(saveList[1], 1);
						}
					}
					that.setState({ saveList: saveList });
					window.ListDataGrid.deleteRow();
					var options = {
						state: 'success'
					};
					_Fade2.default.show(options);
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.setDefaultList = function () {
				var fileName = _this.setTableSelectedFileName();
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "setUserDefaultFormExport", "String");
	
				var key = _this.state.key;
	
				command.appendArg(key);
				command.appendArg(_this.userId);
				var userId = _this.setTableSelectedUserName();
				command.appendArg(userId);
				command.appendArg(fileName);
				var that = _this;
				var _resultHandler = function _resultHandler(data) {
					that.setDefaultListSuccess(data, fileName);
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.setDefaultListSuccess = function (data, fileName) {
				//if(!window.userExportList)window.userExportList={};
				if (data.result)
					//window.userExportList[this.key] = data.result;
					_FormDataSources2.default.setUserDefaultExportList(data.result, _this.state.key);
	
				_this.exportSetTableTitle(fileName);
				var options = {
					state: 'success'
				};
				_Fade2.default.show(options);
			};
	
			_this.exportSetTableTitle = function (defaultItem) {
	
				if (defaultItem) {
					$("#exportListDefaultItem").text("当前默认值" + defaultItem).attr("name", defaultItem);
					$("#cancelExportListDefaultItem").show();
				} else {
					$("#exportListDefaultItem").text("当前默认值 没有默认值");
					$("#cancelExportListDefaultItem").hide();
				}
			};
	
			_this.deleteDefaultFileName = function () {
				var title = $("#exportListDefaultItem").attr("name");
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "unsetUserDefaultFormExport", "void");
	
				var key = _this.state.key;
	
				command.appendArg(key);
				command.appendArg(_this.userId);
				var that = _this;
				var _resultHandler = function _resultHandler(data) {
	
					/*if(window.userExportList&&window.userExportList[that.key]){
	    	window.userExportList[that.key] = null;
	    	delete window.userExportList[that.key];	
	    }*/
					_FormDataSources2.default.setUserDefaultExportList(null, that.key);
	
					$("#exportListDefaultItem").text("当前默认值 没有默认值");
					var options = {
						state: 'success'
					};
					_Fade2.default.show(options);
					$("#cancelExportListDefaultItem").hide();
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
	
				//title 文件名
			};
	
			_this.selectDefaultUser = function () {
				var defaultUser = _this.userId;
				var rowsList = window.ListDataGrid.state.rows.slice();
				_this.rowsListBak = rowsList.slice();
				console.log(_this.rowsListBak);
				for (var i = 0; i < rowsList.length; i++) {
					if (rowsList[i].userName != defaultUser) {
						rowsList.splice($.inArray(rowsList[i], rowsList), 1);
					}
				}
				window.ListDataGrid.setState({ rows: rowsList });
				$("#selectUser").hide();
				$("#cancelSelect").show();
			};
	
			_this.cancelSelectDefaultUser = function () {
				console.log(_this.rowsListBak);
				window.ListDataGrid.setState({ rows: _this.rowsListBak });
				$("#selectUser").show();
				$("#cancelSelect").hide();
			};
	
			_this.hideExportSetTable = function () {
				$("#exportSetTable").hide();
			};
	
			_this.state = _this.props.htmlarg;
			_this.state.tableColumns = _this.setTableColumns(_this.state.columns);
			_this.state.saveList = [];
			_this.state.title = '导出预览';
			_this.state.warnTitle = "";
			_this.extrals = _this.state.extrals;
			_this.all = _this.state.columns.slice().concat(_this.state.extrals.slice());
			_this.userId = window.parent.window.userInfos.userId;
	
			_this.state.translateX = 0, _this.state.translateY = 0, _this.moving = false;
			_this.lastX = null;
			_this.lastY = null;
			window.onmouseup = function (e) {
				return _this.onMouseUp(e);
			};
			window.onmousemove = function (e) {
				return _this.onMouseMove(e);
			};
	
			_this.state.initExport = _this.props.initExport;
			return _this;
		}
	
		_createClass(ExportTable, [{
			key: 'onclipboardClose',
			value: function onclipboardClose(exent) {
				$("#gongqi_exportToClipboardModal").css("display", "none");
			}
		}, {
			key: 'onclipboardContentChange',
			value: function onclipboardContentChange(event) {
				var textarea = document.getElementById("exportToClipBoardContent");
				var element = textarea;
				var isReadOnly = element.hasAttribute('readonly');
	
				if (!isReadOnly) {
					element.setAttribute('readonly', '');
				}
				element.focus();
				element.select();
				element.setSelectionRange(0, element.value.length);
	
				if (!isReadOnly) {
					element.removeAttribute('readonly');
				}
				var succeeded = void 0;
				try {
					succeeded = document.execCommand("copy");
				} catch (err) {
					succeeded = false;
				}
				$("#gongqi_exportToClipboardModal").css("display", "none");
				if (succeeded == true) {
					_Fade2.default.show({ text: "已复制" });
				} else {
					_Warn2.default.show({ text: "复制失败,数据量可能超过系统剪切板设置" });
				}
			}
	
			/** 拖拉 */
	
		}, {
			key: 'onMouseDown',
			value: function onMouseDown(e) {
				e.stopPropagation();
				this.moving = true;
			}
		}, {
			key: 'onMouseUp',
			value: function onMouseUp() {
				this.moving = false;
				this.lastX = null;
				this.lastY = null;
			}
		}, {
			key: 'onMouseMove',
			value: function onMouseMove(e) {
				this.moving && this.onMove(e);
			}
		}, {
			key: 'onMove',
			value: function onMove(e) {
				//   var height = $("#exportSizeModalContainer").height();
				//   var width = $("#exportSizeModalContainer").width();
				//   console.log(height+","+width);
				//   if (e.clientX < 0) {
				//     return false;
				//   }
				//   if (e.clientY < 0 ) {
				//     return false;
				//   }
				if (this.lastX && this.lastY) {
					var dx = e.clientX - this.lastX;
					var dy = e.clientY - this.lastY;
					console.log("dx:" + dx + ";dy:" + dy);
					this.setState({
						translateX: this.state.translateX + dx,
						translateY: this.state.translateY + dy
					});
				}
				this.lastX = e.clientX;
				this.lastY = e.clientY;
	
				console.log(this.state.translateX, this.state.translateY);
			}
			//导出预览保存
	
	
			//保存可用列表
	
	
			//加载默认
	
	
			//可用列表
	
	
			//选择可用列表
	
			//手动加载
	
	
			//以Excel导出
	
	
			//以CSV格式导出
	
	
			//复制到剪贴板
	
	
			//导出列checkbox是否选中
	
	
			//反选控制
	
	
			//全选控制
	
	
			//多表关联是否显示表名
	
	
			//设置导出列
	
	
			//设置可选列
	
	
			//删除
	
	
			//设为默认
	
	
			//取消默认
	
	
			//筛选当前用户
	
	
			//取消筛选
	
		}, {
			key: 'render',
	
			//选择可用列表
			// initDefExport=(value)=>{
			// 	if(value){
			// 		var command = Command.createService( 
			// 			"gongqi.erp.gotmodel.services.UserSettingService", 
			// 			"loadUserFormExport", 
			// 			"String"
			// 		);
			// 		var key=this.state.key;
			// 		var that=this;
			// 		command.appendArg(key);
			// 		command.appendArg(this.userId);
			// 		command.appendArg(value);		
			// 		var _resultHandler = function(data){that.setOptionSuccess(data)};
			// 		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
			// 		ServiceHelper.addTokenWithCommand(remoteArg);
			// 	}
			// }
	
	
			value: function render() {
				var _this2 = this,
				    _ref,
				    _ref2;
	
				var _rows = this.state.ac.slice();
				var chooseableColumnsContent = this.setChooseableColumns();
				var exportColumnsContent = this.setExportColumns();
				var optionsList = this.setOptionsList();
				var _columns = this.setTableColumns(this.state.columns.slice());
				var showTableName = this.state.showTableName;
				var title = this.state.title;
				var exportSetTableTitle = this.exportSetTableTitle();
				var modalCloseStyle = {};
				var outerStyle = { height: '415px' };
				var modalBodyStyle = { padding: '0px 15px', display: 'flex', flexDirection: 'row', alignItems: 'stretch' };
				var modalHeaderStyle = {};
				if (window.didomain || window.parent.window.didomain) {
					if ($(document.body).width() < 900 || $(document.body).height() < 500) {
						modalCloseStyle.top = '8px';modalHeaderStyle.paddingTop = '4px';modalHeaderStyle.paddingBottom = '4px';
						outerStyle.height = '256px';
						modalBodyStyle.maxHeight = '280px';
					}
				}
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'exportSizeModalContainer', style: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }, key: 'mainModal' },
						_react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this2.exportSizeDiv = node;
								}, className: 'modal-content', style: { display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', overflow: 'auto', background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header', style: modalHeaderStyle },
								_react2.default.createElement('div', { className: 'modal-close', style: modalCloseStyle, onClick: this.hideExportTable }),
								_react2.default.createElement(
									'h5',
									{ className: 'modal-title' },
									title
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal-body', style: modalBodyStyle },
								_react2.default.createElement(
									'div',
									{ style: { marginBottom: '0', WebkitTouchCallout: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', user: 'none' } },
									_react2.default.createElement(
										'div',
										{ className: 'box-header with-border' },
										_react2.default.createElement(
											'div',
											{ style: { fontFamily: 'STSongti-SC-Regular', fontSize: '14px', color: '#000000', fontWeight: 'normal', marginTop: '2px', marginBottom: '5px' } },
											'\u53EF\u9009\u5217'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'box-body', style: { height: '93%', marginTop: '5px', padding: '0', marginRight: '14px' } },
										_react2.default.createElement(
											'div',
											{ ref: function ref(node) {
													return _this2.chooseableColumnsNode = node;
												}, id: 'chooseableColumns', style: outerStyle, onDrop: this.drop, onDragOver: this.allowDrop },
											chooseableColumnsContent
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { marginBottom: '0', WebkitTouchCallout: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', user: 'none' } },
									_react2.default.createElement(
										'div',
										{ className: 'box-header with-border' },
										_react2.default.createElement(
											'div',
											{ style: { fontFamily: 'STSongti-SC-Regular', fontSize: '14px', color: '#000000', fontWeight: 'normal', marginTop: '2px', marginBottom: '5px' } },
											'\u5BFC\u51FA\u5217'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'box-body', style: { height: '93%', marginTop: '5px', padding: '0', marginRight: '11px' } },
										_react2.default.createElement(
											'div',
											{ ref: function ref(node) {
													return _this2.exportColumnsContentNode = node;
												}, id: 'exportColumns', style: outerStyle, onDrop: this.drop, onDragOver: this.allowDrop },
											exportColumnsContent
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { flexGrow: 100, display: 'flex', flexDirection: 'column', marginTop: this.state.warnTitle ? '4px' : '27px', marginBottom: '1px', marginLeft: '2px' } },
									_react2.default.createElement(
										'div',
										{ style: { color: 'orangered' } },
										this.state.warnTitle
									),
									_react2.default.createElement(_ExportDataGrid2.default, { columns: _columns, rows: _rows })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal-footer', style: { padding: '10px 15px 8px', borderTopColor: 'rgba(0,0,0,0.10)', marginTop: '10px', borderTop: '1px solid rgba(0,0,0,0.10)' } },
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'div',
										{ style: { display: 'inline-block', marginRight: '47px', position: 'relative' } },
										_react2.default.createElement('input', { id: 'export_column_allChoose', type: 'checkbox', onClick: this.allChoose, style: { marginRight: '11px' } }),
										_react2.default.createElement('label', { htmlFor: 'export_column_allChoose', style: (_ref = { marginRight: '10px' }, _defineProperty(_ref, 'marginRight', '10px'), _defineProperty(_ref, 'padding', '0px'), _defineProperty(_ref, 'width', '18px'), _defineProperty(_ref, 'height', '18px'), _defineProperty(_ref, 'marginBottom', '0px'), _defineProperty(_ref, 'top', '1px'), _defineProperty(_ref, 'left', '0px'), _ref) }),
										'\u5168\u9009\u63A7\u5236',
										_react2.default.createElement('input', { id: 'export_column_oppoChoose', type: 'checkbox', onClick: this.oppoChoose, style: { marginLeft: '15px' } }),
										_react2.default.createElement('label', { htmlFor: 'export_column_oppoChoose', style: (_ref2 = { marginRight: '10px' }, _defineProperty(_ref2, 'marginRight', '10px'), _defineProperty(_ref2, 'padding', '0px'), _defineProperty(_ref2, 'width', '18px'), _defineProperty(_ref2, 'height', '18px'), _defineProperty(_ref2, 'marginBottom', '0px'), _defineProperty(_ref2, 'top', '1px'), _defineProperty(_ref2, 'left', '76px'), _ref2) }),
										'\u53CD\u9009\u63A7\u5236',
										_react2.default.createElement('input', { id: 'export_column_mutiTableShowName', type: 'checkbox', checked: showTableName, onClick: this.changeTableNameState, style: { marginRight: '15px' } }),
										'\u591A\u8868\u5173\u8054\u65F6\u663E\u793A\u8868\u540D',
										_react2.default.createElement('label', { htmlFor: 'export_column_mutiTableShowName', style: { top: '1px', left: '151px' } })
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn btn-info', onClick: this.saveSetting, style: { height: '28px', width: '88px' } },
										_react2.default.createElement('i', { style: { marginRight: '3px' }, className: 'fa fa-download', 'aria-hidden': 'true' }),
										'\u4FDD\u5B58'
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn btn-info', onClick: this.setDefaultData, style: { height: '28px', width: '118px' } },
										_react2.default.createElement('i', { style: { marginRight: '3px' }, className: 'fa fa-spinner', 'aria-hidden': 'true' }),
										'\u52A0\u8F7D\u9ED8\u8BA4'
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn btn-info', onClick: this.showExportSetTable, style: { height: '28px', width: '88px' } },
										_react2.default.createElement('i', { style: { marginRight: '3px' }, className: 'fa fa-cog', 'aria-hidden': 'true' }),
										'\u8BBE\u7F6E'
									),
									_react2.default.createElement(
										'select',
										{ className: 'btn btn-info', style: { padding: '4.2px 12px !important', width: '100px', height: '28px' }, onChange: this.changeOptionsList, id: 'exportLists' },
										_react2.default.createElement(
											'option',
											{ style: { display: 'none' }, key: 'title' },
											'\u53EF\u7528\u5217\u8868'
										),
										optionsList
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn btn-info', onClick: this.exportExcel, style: { height: '28px', width: '110px' } },
										'\u5BFC\u51FA\u5230Excel'
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn btn-info', onClick: this.exportCSV, style: { height: '28px', width: '110px' } },
										'\u5BFC\u51FA\u5230CSV'
									),
									_react2.default.createElement(
										'button',
										{ onClick: this.exportClipBoard, ref: function ref(node) {
												return _this2.exportToClipBoard = node;
											}, type: 'button', className: 'btn btn-info', style: { height: '28px', width: '110px' } },
										'\u5BFC\u51FA\u5230\u526A\u8D34\u677F'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'exportSaveTable', key: 'saveModal', style: { zIndex: '2000' } },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog', style: { marginTop: '100px', width: '640px' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content', style: {
										background: '#FFFFFF',
										border: '1px solid #9B9B9B',
										boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
										borderRadius: '2px'
									} },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideExportSaveTable }),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title', style: { marginTop: '0', marginBottom: '0' } },
										'\u4FDD\u5B58'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body', style: { display: 'flex', flexDirection: 'column', padding: '40px 10px' } },
									_react2.default.createElement(
										'div',
										{ style: { flexGrow: 0, textAlign: 'center' } },
										_react2.default.createElement(
											'div',
											{ style: { display: 'flex', flexDirection: 'row', paddingLeft: '35px' } },
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'right' } },
												_react2.default.createElement(
													'label',
													{ style: { paddingTop: '8px', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', fontWeight: 'normal' } },
													'\u6587\u4EF6\u540D\uFF1A'
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'left', flexGrow: 1, marginRight: '10px' } },
												_react2.default.createElement('input', { type: 'text', spellcheck: 'false', className: 'form-control', id: 'exportFileName' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ style: { flexGrow: 1, textAlign: 'center', paddingLeft: '83px' } },
										_react2.default.createElement(
											'div',
											{ style: { display: 'flex', flexDirection: 'row' } },
											_react2.default.createElement(
												'div',
												{ style: { display: 'flex', alignItems: 'center', textAlign: 'left', position: 'relative' } },
												_react2.default.createElement('input', { type: 'checkbox', id: 'exportDefaultBox', style: { width: '16px', height: '16px' } }),
												_react2.default.createElement('label', { htmlFor: 'exportDefaultBox', style: { top: '7px', marginLeft: '2px' } })
											),
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'right', paddingLeft: '3px' } },
												_react2.default.createElement(
													'label',
													{ style: { paddingTop: '6px', fontSize: '14px', fontFamily: 'STSongti-SC-Regular', color: '#4A90E2' } },
													'\u8BBE\u4E3A\u9ED8\u8BA4'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-footer', style: { padding: '10px 15px' } },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' }, id: 'userFormSetSaveModal_BtnCancel', 'data-dismiss': 'modal', onClick: this.hideExportSaveTable },
										'\u53D6\u6D88'
									),
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px', color: '#fff' }, onClick: this.save },
										'\u4FDD\u5B58'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'exportSetTable', style: { zIndex: '2000', display: 'none' } },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog', style: { width: '600px', backgroundColor: '#fff' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content', style: { marginTop: '100px', background: '#FFFFFF', border: '0 solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideExportSetTable }),
									_react2.default.createElement(
										'h5',
										{ className: 'modal-title', style: { fontWeight: 'bolder' } },
										'\u5DF2\u4FDD\u5B58\u5217\u8868'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'box', style: { borderTop: '1px solid #d2d6de', textAlign: 'center' } },
										_react2.default.createElement(
											'div',
											{ className: 'box-header with-border', style: { textAlign: 'left', background: '#FAFAFA', marginLeft: '10px', marginRight: '10px', height: '40px', borderLeft: 'solid 3px #0178D4', paddingTop: '10px', display: 'flex', alignItems: 'center', borderBottom: 'none' } },
											_react2.default.createElement('span', { className: 'box-title', id: 'exportListDefaultItem', style: { marginLeft: '10px', fontSize: '14px', fontWeight: 'inherit' } }),
											_react2.default.createElement(
												'button',
												{ type: 'button', id: 'cancelExportListDefaultItem', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.deleteDefaultFileName },
												'\u53D6\u6D88'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'box-body', style: { height: '290px' } },
											_react2.default.createElement(
												'div',
												{ style: { width: '100%', height: '100%' } },
												_react2.default.createElement(_ListDataGrid2.default, null)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'box-footer', id: 'userSetTable-footer', style: { marginTop: '5px', textAlign: 'right', borderTop: '1px solid rgba(0,0,0,0.10)' } },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.resetExportTable, style: { marginLeft: '5px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-spinner' }),
												'\u52A0\u8F7D'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.deleteExportList, style: { marginLeft: '8px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-trash-o', 'aria-hidden': 'true' }),
												'\u5220\u9664'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.selectDefaultUser, id: 'selectUser', style: { marginLeft: '8px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-filter', 'aria-hidden': 'true' }),
												'\u7B5B\u9009\u5F53\u524D\u7528\u6237'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', style: { display: 'none', marginLeft: '8px', marginRight: '0' }, onClick: this.cancelSelectDefaultUser, id: 'cancelSelect' },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-filter', 'aria-hidden': 'true' }),
												'\u53D6\u6D88\u7B5B\u9009'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-info', 'data-dismiss': 'modal', onClick: this.setDefaultList, style: { marginLeft: '8px', marginRight: '0' } },
												_react2.default.createElement('i', { style: { marginTop: '1px', marginRight: '2px', float: 'left' }, className: 'fa fa-cog', 'aria-hidden': 'true' }),
												'\u8BBE\u4E3A\u9ED8\u8BA4'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return ExportTable;
	}(_react2.default.Component);
	
	exports.default = ExportTable;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _QueryActions = __webpack_require__(71);
	
	var _QueryActions2 = _interopRequireDefault(_QueryActions);
	
	var _ControlPropertyConst = __webpack_require__(91);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(78),
	    SortDirectionStore = _require.SortDirectionStore;
	
	var _require2 = __webpack_require__(7),
	    CmdUpdateControlLabelStore = _require2.CmdUpdateControlLabelStore,
	    CmdUpdateControlPropertyStore = _require2.CmdUpdateControlPropertyStore;
	
	var SortableHeaderCell = React.createClass({
	  displayName: 'SortableHeaderCell',
	
	  propTypes: {
	    column: React.PropTypes.shape({ name: React.PropTypes.node })
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      sortDirection: '',
	      notNull: this.props.column.notNull,
	      label: this.props.column.name
	    };
	  },
	
	
	  componentDidMount: function componentDidMount() {
	    this.unsubscribeUpdateSortDirection = SortDirectionStore.listen(this.onUpdateSortDirection);
	    this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel);
	    this.unsubscribeCmdUpdateControlPropertyStore = CmdUpdateControlPropertyStore.listen(this.onCmdUpdateControlProperty);
	  },
	
	  onCmdUpdateControlLabel: function onCmdUpdateControlLabel(name, _label) {
	    if (this.props.column.xmlName == name) {
	      this.setState({ label: _label });
	    }
	  },
	
	  onCmdUpdateControlProperty: function onCmdUpdateControlProperty(name, property, value) {
	    if (this.props.column.xmlName == name) {
	      if (property == _ControlPropertyConst2.default.NOTNULL) {
	        this.setState({ notNull: value });
	      }
	    }
	  },
	
	  getSortByText: function getSortByText() {
	
	    var unicodeKeys = {
	      ASC: 9650,
	      DESC: 9660
	    };
	    var _sortDirection = this.state.sortDirection;
	    var ret;
	    if (_sortDirection == undefined || _sortDirection == '') {
	      ret = '';
	    } else {
	      ret = String.fromCharCode(unicodeKeys[_sortDirection]);
	    }
	    // var ret= _sortDirection==undefined?'':(String.fromCharCode(unicodeKeys[_sortDirection]));
	    // console.log('ret:'+ret);
	    return ret = String.fromCharCode(9650);
	  },
	  setSortStyle: function setSortStyle(upSty, downSty) {
	    var _sortDirection = this.state.sortDirection;
	    if (_sortDirection == "ASC") {
	      upSty.borderBottomColor = '#5473e8';
	    } else if (_sortDirection == "DESC") {
	      downSty.borderTopColor = '#5473e8';
	    }
	  },
	
	  onUpdateSortDirection: function onUpdateSortDirection(groupAlias, arg) {
	    var _sortDirection;
	    if (this.props.groupAlias == groupAlias) {
	      var _columnKey = this.props.column.key.toLowerCase();
	      if (arg.hasOwnProperty(_columnKey)) {
	        _sortDirection = arg[_columnKey];
	      }
	      if (_sortDirection == undefined) {}
	      this.setState({ sortDirection: _sortDirection });
	    }
	  },
	
	  onClick: function onClick(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var columnKey = this.props.column.key;
	    var sortDirection = this.state.sortDirection;
	    var _sortDirection;
	    if (sortDirection == 'ASC') {
	      _sortDirection = 'DESC';
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#c0c4cc');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#5473e8');
	    } else if (sortDirection == 'DESC') {
	      _sortDirection = undefined;
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#c0c4cc');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#c0c4cc');
	    } else {
	      _sortDirection = 'ASC';
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#5473e8');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#c0c4cc');
	    }
	    _QueryActions2.default.gridHeaderClickSort(columnKey, _sortDirection, this.props.moduleInstanceId);
	  },
	
	  sortDownClick: function sortDownClick(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var columnKey = this.props.column.key;
	    var sortDirection = this.state.sortDirection;
	    var _sortDirection;
	    if (sortDirection == 'DESC') {
	      _sortDirection = undefined;
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#c0c4cc');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#c0c4cc');
	    } else {
	      _sortDirection = 'DESC';
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#c0c4cc');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#5473e8');
	    }
	    _QueryActions2.default.gridHeaderClickSort(columnKey, _sortDirection, this.props.moduleInstanceId);
	  },
	  sortUpClick: function sortUpClick(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var columnKey = this.props.column.key;
	    var sortDirection = this.state.sortDirection;
	    var _sortDirection;
	    if (sortDirection == 'ASC') {
	      _sortDirection = undefined;
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#c0c4cc');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#c0c4cc');
	    } else {
	      _sortDirection = 'ASC';
	      $(this.dataGridSortUpNode).css('borderBottomColor', '#5473e8');
	      $(this.dataGridSortDownNode).css('borderTopColor', '#c0c4cc');
	    }
	    _QueryActions2.default.gridHeaderClickSort(columnKey, _sortDirection, this.props.moduleInstanceId);
	  },
	
	
	  getIconStyle: function getIconStyle() {
	
	    var iconStyle = {};
	    iconStyle['fontSize'] = '8px';
	    iconStyle['color'] = 'red';
	    var notNull = this.state.notNull;
	    if (!notNull) {
	      iconStyle['display'] = 'none';
	    }
	    return iconStyle;
	  },
	  HeadMouseMove: function HeadMouseMove() {
	    if ($(this.sortModel).hasClass('absoluteSort')) {
	      $(this.sortModel).css('display', 'block');
	    }
	  },
	  HeadSortMouseLeave: function HeadSortMouseLeave() {
	    if ($(this.sortModel).hasClass('absoluteSort')) {
	      $(this.sortModel).css('display', 'none');
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var xmlName = "";
	    if (this.props.column) xmlName = this.props.column.key;
	    var _justifyContent = "end";
	    if (this.props.textAlign == 'left') {
	      _justifyContent = 'start';
	    }
	    if (this.props.textAlign == 'center') {
	      _justifyContent = 'center';
	    }
	    var dataGridSortUpStyle = { width: 0, height: 0, border: 'solid 5px transparent', position: 'relative', right: '-5px', borderBottomColor: '#c0c4cc', bottom: '13px' };
	    var dataGridSortDownStle = { width: 0, height: 0, border: 'solid 5px transparent', position: 'relative', right: '5px', borderTopColor: '#c0c4cc', top: '13px' };
	    this.setSortStyle(dataGridSortUpStyle, dataGridSortDownStle);
	    var _sortSpanStyle = { width: '20px', height: '17px' };
	    var _sortClass = '';
	    if (this.state.label.visualLength() + 20 > this.props.column.width) {
	      _sortSpanStyle = { display: 'none', width: '20px', height: '17px', position: 'absolute', top: '3px', backgroundColor: 'rgb(255,255,255,0.6)', right: '3px', borderRadius: '18px' };
	      _sortClass = "absoluteSort";
	    }
	    return React.createElement(
	      'div',
	      { 'data-xmlName': xmlName, alt: '', style: { display: 'flex', mmcursor: 'pointer', textAlign: this.props.textAlign, justifyContent: _justifyContent }, onClick: this.onClick, onMouseEnter: this.HeadMouseMove, onMouseLeave: this.HeadSortMouseLeave },
	      React.createElement('i', { className: 'fa fa-snowflake-o', style: this.getIconStyle() }),
	      this.state.label,
	      React.createElement(
	        'span',
	        { style: _sortSpanStyle, className: _sortClass, ref: function ref(node) {
	            return _this.sortModel = node;
	          } },
	        React.createElement('i', { ref: function ref(node) {
	            return _this.dataGridSortUpNode = node;
	          }, className: 'dataGridSortUp', style: dataGridSortUpStyle, onClick: this.sortUpClick }),
	        React.createElement('i', { ref: function ref(node) {
	            return _this.dataGridSortDownNode = node;
	          }, className: 'dataGridSortDown', style: dataGridSortDownStle, onClick: this.sortDownClick })
	      )
	    );
	  }
	});
	
	module.exports = SortableHeaderCell;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var faker = __webpack_require__(69);
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var listcolumns = [{
	  key: 'userName',
	  name: "用户名",
	  width: 285,
	  resizable: true
	}, {
	  key: 'fileName',
	  name: "表名",
	  width: 285,
	  resizable: true
	}];
	
	var ExportDataGrid = function (_React$Component) {
	  _inherits(ExportDataGrid, _React$Component);
	
	  function ExportDataGrid(props, context) {
	    _classCallCheck(this, ExportDataGrid);
	
	    var _this = _possibleConstructorReturn(this, (ExportDataGrid.__proto__ || Object.getPrototypeOf(ExportDataGrid)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    window.ListDataGrid = _this;
	    var rows = [];
	    _this.state = { rows: rows, selectedIndexes: [] };
	    return _this;
	  }
	
	  _createClass(ExportDataGrid, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(ReactDataGrid, {
	        ref: function ref(node) {
	          return _this2.grid = node;
	        },
	        enableCellSelect: true,
	        columns: listcolumns,
	        rowGetter: this.getRowAt,
	        rowsCount: this.getSize(),
	        onGridRowsUpdated: this.handleGridRowsUpdated
	        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	        , enableRowSelect: false,
	        rowSelection: {
	          showCheckbox: false,
	          selectBy: {
	            indexes: this.state.selectedIndexes
	
	          }
	        },
	        onRowClick: this.rowClick //this.rowClick this.rowClick.bind(this)
	        , rowHeight: 30,
	        minHeight: 200,
	        rowScrollTimeout: 500 });
	    }
	  }]);
	
	  return ExportDataGrid;
	}(React.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.deleteRow = function () {
	    var rows = _this3.state.rows.slice();
	    var selectedIndex = _this3.state.selectedIndexes[0];
	    rows.splice(selectedIndex, 1);
	    _this3.setState({ rows: rows, selectedIndexes: [rows.length - 1] });
	  };
	
	  this.getRowAt = function (index) {
	    if (index < 0 || index > _this3.getSize()) {
	      return undefined;
	    }
	    return _this3.state.rows[index];;
	  };
	
	  this.getSize = function () {
	    return _this3.state.rows.length;
	  };
	
	  this.rowClick = function (index, record, proxy) {
	    _this3.setState({ selectedIndexes: [index] });
	  };
	};
	
	exports.default = ExportDataGrid;

/***/ },
/* 192 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArgCaller = function ArgCaller() {
		_classCallCheck(this, ArgCaller);
	
		this.type = "";
		this.caller = null;
		this.callerKey = "";
		this.joinGroup = null;
		this.joinAlias = "";
		this.enterMainForm = false;
		this.mainTableWhereValues = [];
		this.parameters = "";
		this.paramObject = null;
		this.authorityObject = null;
	}
	
	/**
	 * 用来标识新打开画面的源 包括记录，控件
	 * 1.若是通过menuItemButton打开 则此值为button的控件名称 当源画面切换记录的时候 若新画面有关联 则触发默认的关联查询 当源画面某个
	 * 无数据源控件的值发生变化的时候 因为button的控件名称与无数据源控件肯定不同 故不会触发新画面的linkVar方法
	 * 2.若是通过OpenForm命令打开 则此值由二次开发方法指定 callereditor可以控制linVar方法与画面再次打开的策略 callereditor从记录级控制画面打开策略
	 * */
	;
	
	exports.default = ArgCaller;

/***/ },
/* 193 */
/***/ function(module, exports) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArgCallerType = function ArgCallerType() {
		_classCallCheck(this, ArgCallerType);
	};
	
	ArgCallerType.FormModule = "FormModule";
	ArgCallerType.StringEditor = "StringEditor";
	ArgCallerType.MainMenu = "MainMenu";

/***/ },
/* 194 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditorFormType = function EditorFormType() {
		_classCallCheck(this, EditorFormType);
	};
	
	EditorFormType.Non = -1;
	EditorFormType.FormModule = 0;
	EditorFormType.QueryForm = 1;
	EditorFormType.Report = 2;
	EditorFormType.Dialog = 3;
	exports.default = EditorFormType;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _FocusStore = __webpack_require__(28);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _CommandStore = __webpack_require__(18);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(82);
	/*{this.props.xml.name}*/
	
	var FormItemButtonMenu = function (_GongqiFormItem) {
		_inherits(FormItemButtonMenu, _GongqiFormItem);
	
		function FormItemButtonMenu(props) {
			_classCallCheck(this, FormItemButtonMenu);
	
			var _this = _possibleConstructorReturn(this, (FormItemButtonMenu.__proto__ || Object.getPrototypeOf(FormItemButtonMenu)).call(this, props));
	
			_this.dropdownShowed = false;
			if (!_this.props.forLookup) {
				_this.unsubscribeCmdUpdateControlAllowEditStore = _CmdTypeStore.CmdUpdateControlAllowEditStore.listen(_this.onCmdUpdateControlAllowEditStore.bind(_this));
				_this.unsubcribeCmdUpdateControlVisibleStore = _CmdTypeStore.CmdUpdateControlVisibleStore.listen(_this.onCmdUpdateControlVisible.bind(_this));
				_this.unsubscribeCmdDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(_this.onDsAllowEdit.bind(_this));
				_this.unsubscribeButtonShortCutStore = _CommandStore.ButtonShortCutStore.listen(_this.onShortCut.bind(_this));
			}
			_this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this.onFocusSet.bind(_this));
			_this.unsubscribeSetButtonStyleStore = _CmdTypeStore.SetButtonStyleStore.listen(_this.onSetButtonStyle.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
	
			_this.state.devStyles = {};
			_this.state.label = _this.props.label;
			return _this;
		}
	
		_createClass(FormItemButtonMenu, [{
			key: 'onShortCut',
			value: function onShortCut(keyCodeStr) {
				return;
				if (!this.props.dropdown) return;
				var lilist = this.props.dropdown.find(">li");
				for (var i = 0; i < lilist.length; i++) {
					var $li = $(lilist[i]);
					var controlId = $li.attr("controlId");
					var formItemButtonControl = _FormItemUtil2.default.getFormItemControl(controlId, this.props.forLookup);
					var shortCut = formItemButtonControl.getProperty_ShortCut();
					if (shortCut == keyCodeStr) {
						formItemButtonControl.beforeOK({ target: lilist[i] }, true);
					}
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (!this.props.forLookup) {
					this.unsubscribeCmdUpdateControlAllowEditStore();
					this.unsubscribeCmdDsAllowEditStore();
				}
				this.unsubscribeFocusSetStore();
				this.unsubscribeSetButtonStyleStore();
				this.unsubscribeCmdUpdateControlLabelStore();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
				if (finalAllowEdit) {
					$(this.btnMain).removeClass("disabled");$(this.dropdownbutton).removeClass("disabled");
				} else {
					$(this.btnMain).addClass("disabled");$(this.dropdownbutton).addClass("disabled");
				}
			}
		}, {
			key: 'onCmdUpdateControlVisible',
			value: function onCmdUpdateControlVisible(menuItemId, formId, names, isLookup) {
				if (this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId && this.props.formId == formId) {
					if (names.indexOf(this.props.xml.name) != -1) {
						var nowVisible = this.state.visible;
						var finalVisible = this.props.control.getProperty_Visible_Final();
	
						this.setState({ visible: finalVisible });
	
						if (finalVisible != nowVisible) {
							if (nowVisible == false && finalVisible == true) {
								this.visibleFlaseToTrue();
							}
						}
					} else {
						var lilist = this.props.dropdown.find(">li");
						for (var i = 0; i < lilist.length; i++) {
							var $li = $(lilist[i]);
							if (names.indexOf($li.attr("componentName")) != -1) {
								var controlId = $li.attr("controlId");
								var formItemButtonControl = _FormItemUtil2.default.getFormItemControl(controlId, this.props.forLookup);
	
								var _finalVisible = formItemButtonControl.getProperty_Visible_Final();
	
								if (_finalVisible) {
									$li.show();
								} else {
									$li.hide();
								}
								break;
							}
						}
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlAllowEditStore',
			value: function onCmdUpdateControlAllowEditStore(name, _allowEdit) {
				if (name == this.props.xml.name) {
					var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
					if (finalAllowEdit) {
						$(this.btnMain).removeClass("disabled");$(this.dropdownbutton).removeClass("disabled");
					} else {
						$(this.btnMain).addClass("disabled");$(this.dropdownbutton).addClass("disabled");
					}
				} else {
					var lilist = this.props.dropdown.find(">li");
					for (var i = 0; i < lilist.length; i++) {
						var $li = $(lilist[i]);
						if ($li.attr("componentName") == name) {
							var controlId = $li.attr("controlId");
							var formItemButtonControl = _FormItemUtil2.default.getFormItemControl(controlId, this.props.forLookup);
	
							var _finalAllowEdit = formItemButtonControl.getProperty_AllowEdit_Final();
	
							if (_finalAllowEdit) {
								$li.removeClass("disabled").css({ opacity: 1 });
							} else {
								$li.addClass("disabled").css({ opacity: 0.5 });
							}
							break;
						}
					}
				}
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				} else {
					var lilist = this.props.dropdown.find(">li");
					for (var i = 0; i < lilist.length; i++) {
						var $li = $(lilist[i]);
						if ($li.attr("componentName") == name) {
							var controlId = $li.attr("controlId");
							var formItemButtonControl = _FormItemUtil2.default.getFormItemControl(controlId, this.props.forLookup);
							if (formItemButtonControl.xml.name == name) {
								$li.context.children[0].innerText = formItemButtonControl._cmdLabel;
							}
							break;
						}
					}
				}
			}
		}, {
			key: 'onDsAllowEdit',
			value: function onDsAllowEdit(groupAlias) {
				if (groupAlias == this.props.groupAlias) {
					var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
					if (finalAllowEdit) {
						$(this.btnMain).removeClass("disabled");$(this.dropdownbutton).removeClass("disabled");
					} else {
						$(this.btnMain).addClass("disabled");$(this.dropdownbutton).addClass("disabled");
					}
				} else {
					var lilist = this.props.dropdown.find(">li");
					for (var i = 0; i < lilist.length; i++) {
						var $li = $(lilist[i]);
						var controlId = $li.attr("controlId");
						var formItemButtonControl = _FormItemUtil2.default.getFormItemControl(controlId, this.props.forLookup);
						var _finalAllowEdit2 = formItemButtonControl.getProperty_AllowEdit_Final();
						if (_finalAllowEdit2) $li.removeClass("disabled");else $li.addClass("disabled");
					}
				}
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				//alert(itemId + "  " + this.props.xml.id);
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.btnMain).focus();
					//$(this.inputField).select();
				}
			}
		}, {
			key: 'onSetButtonStyle',
			value: function onSetButtonStyle(formId, name, buttonStyle) {
				if (this.props.xml.name == name && this.props.formId == formId) {
					this.setState({ devStyles: buttonStyle });
				}
			}
	
			//当时此button在下拉框上 属于第三极IFrame
	
		}, {
			key: 'testIframeToParentAction',
			value: function testIframeToParentAction() {
				document.addEventListener("paste", function (e) {
					alert("paste");
				});
				document.execCommand("paste");
				return;
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					if (typeof _parentWindow.lookupReturnTest == 'function') _parentWindow.lookupReturnTest();
				}
				//window.parent.window.filterNodesBySubPage("SJLJ")
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {
					//alert(e.shiftKey)
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
				}
			}
		}, {
			key: 'showDropDown',
			value: function showDropDown() {
				if ($(this.btnMain).hasClass("disabled")) {
					return;
				}
				//dropdown要求是一个jquery对象
				if (this.dropdownShowed && this.props.dropdown) {
					this.props.dropdown.css("display", "none");
					this.dropdownShowed = false;
					this.deAttachDropDownEvents();
					return false;
				}
				if (this.props.dropdown.parent().length == 0) this.props.dropdown.appendTo($('body'));
				this.attachDropDownEvents();
				this.dropdownShowed = true;
				this.setDropDownPosition();
				this.props.dropdown.css("display", "block");
			}
		}, {
			key: 'attachDropDownEvents',
			value: function attachDropDownEvents() {
				$(document).one('mousedown', this.mouseDownOutSideHandler.bind(this));
				this.props.dropdown.find("a").one('click', this.itemClickHandler.bind(this));
			}
		}, {
			key: 'deAttachDropDownEvents',
			value: function deAttachDropDownEvents() {}
		}, {
			key: 'itemClickHandler',
			value: function itemClickHandler(e) {
				this.props.dropdown.css("display", "none");
				this.dropdownShowed = false;
			}
		}, {
			key: 'mouseDownOutSideHandler',
			value: function mouseDownOutSideHandler(e) {
				if (!($(this.dropdownbutton).is(e.target) || $(this.dropdownbutton).find(e.target).length || $(this.btnMain).is(e.target) || $(this.btnMain).find(e.target).length || $(this.props.dropdown).is(e.target) || $(this.props.dropdown).find(e.target).length)) {
					this.props.dropdown.css("display", "none");
					this.dropdownShowed = false;
				}
			}
		}, {
			key: 'setDropDownPosition',
			value: function setDropDownPosition() {
				var lookupdiv = this.props.dropdown;
	
				var _inputwidth = $(this.btnMain).width() + $(this.dropdownbutton).width();
				var _inputHeight = $(this.btnMain).outerHeight(true);
				var _iframewidth = lookupdiv.width();
	
				var _iframeheight = lookupdiv.outerHeight(true);
	
				var _gwidth = $("#app").width();
				var _gheight = $("#app").height();
				if (_iframewidth > _gwidth) {
					_iframewidth = _gwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				} else if (_iframewidth < _inputwidth) {
					_iframewidth = _inputwidth;
					lookupdiv.css({ width: _iframewidth + 'px', overflow: "auto" });
				}
				var _offset = $(this.btnMain).offset();
				var _y = _offset.top;
				var _x = _offset.left;
				var _top = _y + _inputHeight; //$(this.btnMain).height();
				//alert('x:'+_x+'y:'+_y);
				//下方屏幕放不下
				if (_top + _iframeheight > _gheight) {
					//上下都放不下 考虑缩减高度
					if (_iframeheight > _top) {
						//上方空间大
						if (_top > _gheight / 2) {
							var _newdivheight = _top - 1 + 'px';
							//lookupdiv.css("height":_newdivheight);
							lookupdiv.height(_top - 14 - $(this.btnMain).height());
							//alert(_newdivheight);
							_top = '0px';
							//'-'+_newdivheight+'px';
						} else //下方空间大
							{
								//let _newdivheight = (_gheight-_y)+'px';
								lookupdiv.height(_gheight - _top);
							}
					} else //下拉框置于上方
						{
							_top = _top - _iframeheight - _inputHeight + 'px';
							//'-'+_iframeheight+'px';
						}
				} else {
					_top -= 2;
				}
				var _left = _x - (_iframewidth - _inputwidth) / 2;
				//(_iframewidth-_inputwidth)/2;
				if (_left + _iframewidth > _gwidth) _left = _gwidth - _iframewidth - 8;
				if (_left < 0) _left = 0;
				lookupdiv.css({ left: _left + 'px', top: _top });
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				window.lastFocusUI = this.btn;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				if (!_style) _style = {};
	
				_style["display"] = "flex";
				_style["flexDirection"] = "row";
				_style["alignItems"] = "flex-start";
				_style["margin"] = '2px';
	
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				Object.assign(_style, this.state.devStyles);
				var btnInfo = this.props.iconClass ? _react2.default.createElement(
					'button',
					{ type: 'button', className: 'btn btn-info GongqiFormItemButtonMenu', ref: function ref(node) {
							return _this2.btnMain = node;
						},
						style: { padding: "1px 4px", flexGrow: '100', borderTopRightRadius: '0', borderBottomRightRadius: '0' },
						onClick: this.showDropDown.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) },
					_react2.default.createElement('i', { className: this.props.iconClass }),
					'\xA0',
					this.state.label
				) : _react2.default.createElement(
					'button',
					{ type: 'button', className: 'btn btn-info GongqiFormItemButtonMenu', ref: function ref(node) {
							return _this2.btnMain = node;
						},
						style: { padding: "1px 4px", flexGrow: '100', borderTopRightRadius: '0', borderBottomRightRadius: '0' },
						onClick: this.showDropDown.bind(this), onFocus: this.inputFieldFocus.bind(this), onKeyDown: this.onKeyDownHandler.bind(this) },
					this.state.label
				);
				return _react2.default.createElement(
					'div',
					{ style: _style, ref: function ref(node) {
							return _this2.btn = node;
						} },
					btnInfo,
					_react2.default.createElement(
						'button',
						{ type: 'button', className: 'buttonMenuDropDown btn GongqiFormItemButtonMenu', ref: function ref(node) {
								return _this2.dropdownbutton = node;
							},
							style: { borderTopLeftRadius: '0', borderBottomLeftRadius: '0' },
							onClick: this.showDropDown.bind(this), onFocus: this.inputFieldFocus.bind(this) },
						_react2.default.createElement('i', { className: "fa fa-angle-down", 'aria-hidden': 'true' }),
						_react2.default.createElement(
							'span',
							{ className: 'sr-only' },
							'Toggle Dropdown'
						)
					)
				);
			}
		}]);
	
		return FormItemButtonMenu;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemButtonMenu.defaultProps = {};
	
	exports.default = FormItemButtonMenu;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EditorForDataGridMix2 = __webpack_require__(46);
	
	var _EditorForDataGridMix3 = _interopRequireDefault(_EditorForDataGridMix2);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemDateTimeEditor = __webpack_require__(124);
	
	var _FormItemDateTimeEditor2 = _interopRequireDefault(_FormItemDateTimeEditor);
	
	var _FormItemDateTimeResolver = __webpack_require__(139);
	
	var _FormItemDateTimeResolver2 = _interopRequireDefault(_FormItemDateTimeResolver);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDateTimeEditorForDataGrid = function (_EditorForDataGridMix) {
		_inherits(FormItemDateTimeEditorForDataGrid, _EditorForDataGridMix);
	
		function FormItemDateTimeEditorForDataGrid() {
			_classCallCheck(this, FormItemDateTimeEditorForDataGrid);
	
			return _possibleConstructorReturn(this, (FormItemDateTimeEditorForDataGrid.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditorForDataGrid)).apply(this, arguments));
		}
	
		_createClass(FormItemDateTimeEditorForDataGrid, [{
			key: 'initStores',
			value: function initStores() {
				this.unsubscribeRecordFieldChangeStore = _RecordsStore.RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
				this.unsubscribeDsAllowEditStore = _CmdTypeStore.DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRecordFieldChangeStore();
				this.unsubscribeDsAllowEditStore();
			}
		}, {
			key: 'onDsAllowEditStore',
			value: function onDsAllowEditStore(groupAlias) {
				if (this.props.groupAlias == groupAlias) {
					var finalValue = this.props.control.getProperty_AllowEdit_Final();
	
					this.doSetEnable(finalValue);
				}
			}
		}, {
			key: 'getValue',
			value: function getValue() {
	
				var updated = {};
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (!nowAllowEdit) return;
				this.justCommit = true;
				var text = this.getInputNode().value;
				var _val = _FormItemDateTimeResolver2.default.getResult(text, false);
	
				if (_val.indexOf("false:") == 0) {
					_Warn2.default.show({ text: _val.substr(6) });
					_val = this.props.value;
				}
	
				updated[this.props.column.key] = _val;
	
				if (this.props.value != updated[this.props.column.key]) {
					_RecordsActions2.default.RecordFieldChanged(this.props.rowData, this.props.column.key, this.props.value, updated[this.props.column.key], this);
					if (this.props.control) {
						var result = void 0;
						if (this.props.column.isdynamic == true) {
							result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName, _val, this.props.value, null, null, { dynamicColumn: true, dynamicKey: this.props.column.dynamicFieldLabel });
						} else {
							result = this.props.control.doFieldModifiedRemote(this.props.column.key, _val, this.props.value);
						}
	
						if (!result && !this.props.control.isDataMethodField) {
							return {};
						}
						if (result && !this.props.control.isDataMethodField) {
							if (this.props.rowData[this.props.column.key] != this.props.value && this.props.rowData[this.props.column.key] != _val) {
								_val = this.props.rowData[this.props.column.key];
								updated[this.props.column.key] = _val;
							}
						}
					}
				}
				return updated;
			}
	
			//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
			//下拉框是否销毁由项目编辑器决定
	
		}, {
			key: 'handleBlurCommit',
			value: function handleBlurCommit() {
				if (this.justCommit == true) {
					this.justCommit = false;return false;
				}
				if (this.lookupStates.isShowed) return false;
				return true;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.Flatpickr.l10n.weekdays = {
					shorthand: ["三", "一", "二", "三", "四", "五", "六"],
					longhand: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"]
				};
	
				window.Flatpickr.l10n.months = {
					shorthand: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
					longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
				}, $(this.flatpickrDom).flatpickr({ enableTime: true, allowInput: true, onChange: this.onDatePanelChange.bind(this),
					onClose: this.onDatePanelClose.bind(this), time_24hr: true,
					minuteIncrement: 1, clickOpens: false, wrap: true, enableSeconds: true });
	
				if (this.props.control) {
					var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
					this.doSetEnable(_allowEdit);
				}
				var copy = Object.assign({}, this.props.contextMenuData);
				if (copy.items) {
					for (var i = 0; i < copy.items.length; i++) {
						var item = copy.items[i];
						if (item && item.label == "过滤[Ctrl+T]") {
							item.action = this.queryFilter.bind(this);
							break;
						}
					}
					$(this.inputField).contextPopup(copy);
				} else {
					$(this.inputField).contextPopup(this.props.contextMenuData);
				}
			}
		}, {
			key: 'onDatePanelClose',
			value: function onDatePanelClose() {
				$(this.inputField).focus().select();
				this.lookupStates.isShowed = false;
			}
		}, {
			key: 'onDatePanelChange',
			value: function onDatePanelChange() {}
		}, {
			key: 'queryFilter',
			value: function queryFilter() {
				if (!this.props.control || !this.props.control.group) return;
				var _dataField = this.props.dataField;
				if (_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField)) {
	
					var value = this.props.rowData[_dataField];
					this.props.control.group.queryFilter(_dataField, value);
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				var nowAllowEdit = $(this.inputField).attr("readonly") == undefined;
				if (nowAllowEdit == true && enable == false) {
					$(this.inputField).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
					$(this.inputField).attr("readonly", "readonly");
					$(this.downArrowButton).css("backgroundColor", _FormItemConst2.default.EDITOR_NOTEDIT_COLOR);
				} else if (nowAllowEdit == false && enable == true) {
					$(this.inputField).css("backgroundColor", "#FFFFFF");
					$(this.inputField).removeAttr("readonly");
					$(this.downArrowButton).css("backgroundColor", "#FFFFFF");
				}
			}
		}, {
			key: 'onKeyDownHandler2',
			value: function onKeyDownHandler2(e) {
				if (e.ctrlKey && e.keyCode == 65) {
					e.stopPropagation();
					return true;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: '2px', backgroundColor: '#ffffff', fontSize: "12px", cursor: 'text', paddingRight: '13px' };
				var _textAlign = this.props.control.getProperty_Alignment();
				_style.textAlign = _textAlign.toLowerCase();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + rowStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + colStyle.color.toString(16); //原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				var _v = this.props.value;
				return _react2.default.createElement(
					'div',
					{ className: 'input-group date', style: { width: '100%' }, ref: function ref(node) {
							return _this2.flatpickrDom = node;
						} },
					_react2.default.createElement('input', { 'data-input': true, spellCheck: 'false', type: 'text', className: 'form-control pull-right', defaultValue: _v, ref: function ref(node) {
							return _this2.inputField = node;
						}, style: _style, onKeyDown: this.onKeyDownHandler2.bind(this) }),
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.downArrowButton = node;
						}, className: 'fa fa-calendar', onClick: this.showDateDropDown.bind(this), style: { position: 'absolute', top: 'calc(100% / 2 - 5.5px)', left: 'calc(100% - 13px)', fontSize: '11px', cursor: 'pointer', zIndex: 3 } })
				);
			}
		}]);
	
		return FormItemDateTimeEditorForDataGrid;
	}((0, _EditorForDataGridMix3.default)(_FormItemDateTimeEditor2.default));
	
	exports.default = FormItemDateTimeEditorForDataGrid;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _FormItemEnumEditor2 = __webpack_require__(72);
	
	var _FormItemEnumEditor3 = _interopRequireDefault(_FormItemEnumEditor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemEnumRadioEditor = function (_FormItemEnumEditor) {
		_inherits(FormItemEnumRadioEditor, _FormItemEnumEditor);
	
		function FormItemEnumRadioEditor(props) {
			_classCallCheck(this, FormItemEnumRadioEditor);
	
			var _this = _possibleConstructorReturn(this, (FormItemEnumRadioEditor.__proto__ || Object.getPrototypeOf(FormItemEnumRadioEditor)).call(this, props));
	
			_this.selectedValue = "";
			return _this;
		}
	
		_createClass(FormItemEnumRadioEditor, [{
			key: 'doSetModifiedTagNone',
			value: function doSetModifiedTagNone() {}
		}, {
			key: 'doSetModifiedTagHas',
			value: function doSetModifiedTagHas() {}
		}, {
			key: 'updateModifiedTag',
			value: function updateModifiedTag() {}
		}, {
			key: 'selectValue',
			value: function selectValue(_value) {
				var that = this;
				$(this.radioContainer).find("input[type='radio']").each(function () {
					if ($(this).attr("data-serverId") == _value) {
						//遍历radio组，使用iCheck设置选中项
						that.selectedValue = _value;
						$(this).iCheck('check');
					}
				});
			}
		}, {
			key: 'onCurrentRecordChanged',
			value: function onCurrentRecordChanged(records, currentRecord, groupAlias, moduleInstanceId) {
				_get(FormItemEnumRadioEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemEnumRadioEditor.prototype), 'onCurrentRecordChanged', this).call(this, records, currentRecord, groupAlias, moduleInstanceId);
				if (this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId) {
					this.currentDataFieldChanged = false;
					this.doSetModifiedTagNone();
					if (this.props.dataField) {
						var _value = this.record ? this.record[this.props.dataField] : '';
					} else {
						_value = this.record;
					}
	
					this.selectValue(_value);
					//$(this.inputField).selectpicker('val',_value);
	
					if (this.props.control) {
	
						var _allowEdit = true;
						if (!this.record && groupAlias) {
							_allowEdit = false;
						} else {
							_allowEdit = this.props.control.getProperty_AllowEdit_Final();
						}
						this.doSetEnable(_allowEdit);
					}
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus(e) {
				window.lastFocusUI = this.radioContainer;
				if (this.props.groupAlias) window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
				//alert("EnumEditor inputFieldFocus");
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'onDataFieldChanged',
			value: function onDataFieldChanged(record, dataField, oldValue, newValue, observer) {
				if (observer != this && this.props.dataField == dataField && record == this.record) {
					this.selectValue(newValue);
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'enumRadioOnKeyDownHandler',
			value: function enumRadioOnKeyDownHandler(e) {
				if (9 === e.keyCode) {
					e.preventDefault();
					var index = $(e.target).attr("data-index");
					this.onTabHandler(index, e.shiftKey);
				}
			}
		}, {
			key: 'enumRadioOnBlurHandler',
			value: function enumRadioOnBlurHandler(e) {}
		}, {
			key: 'enumRadioOnFocusHandler',
			value: function enumRadioOnFocusHandler(e) {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_get(FormItemEnumRadioEditor.prototype.__proto__ || Object.getPrototypeOf(FormItemEnumRadioEditor.prototype), 'componentDidMount', this).call(this);
				$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
				$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
					radioClass: 'iradio_minimal-blue' }).on('ifChecked', this.selectedChanged.bind(this, true)).on('ifUnchecked', this.selectedChanged.bind(this, false));
	
				if (this.initedSelectedValue) {
					this.selectValue(this.initedSelectedValue);
				}
				if (this.props.underQueryGroup) {
					if (this.props.control.getProperty_AllowEdit_Final()) {
						this.doSetEnable(true);
					} else {
						this.doSetEnable(false);
					}
				} else {
					var _initRecord = void 0;
					if (this.props.dataField) {
						_initRecord = this.props.initRecord;
					} else {
						if (this.props.control.hasInitEditorValue) {
							_initRecord = this.props.initEditorValue;
						} else {
							_initRecord = this.props.initRecord;
						}
					}
					this.onCurrentRecordChanged(null, _initRecord, this.props.groupAlias, this.props.moduleInstanceId);
				}
	
				//this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
				if (!this.props.groupAlias) {
					this.doUpdateAllowEditByJquery(this.state.allowEdit);
				}
			}
		}, {
			key: 'doSetEnable',
			value: function doSetEnable(enable) {
				this.setState({ allowEdit: enable });
			}
		}, {
			key: 'doUpdateAllowEditByJquery',
			value: function doUpdateAllowEditByJquery(allowEdit) {
				if (allowEdit == false) {
					$(this.radioContainer).find('input[type="radio"].minimal').iCheck('disable');
				} else {
					$(this.radioContainer).find('input[type="radio"].minimal').iCheck('enable');
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.doUpdateAllowEditByJquery(this.state.allowEdit);
			}
		}, {
			key: 'selectedChanged',
			value: function selectedChanged(value, e) {
				if (value == true && e.target) {
					this.selectedValue = $(e.target).attr("data-serverId");
					this.setFinalValue();
				}
			}
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				if (value == null || value == undefined) {
					if (this.props.dataField && this.record) value = this.record[this.props.dataField];else value = this.record;
				}
				this.selectValue(value);
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					var radioInputs = $(this.radioContainer).find("input[type='radio']");
					$(radioInputs[0]).focus();
					this.onTabHandler(-1, pre);
				}
			}
		}, {
			key: 'onTabHandler',
			value: function onTabHandler(currentIndex, pre) {
				if (this.props.options && this.props.options.length) {
					var length = this.props.options.length;
					pre ? currentIndex-- : currentIndex++;
					if (currentIndex < 0 || currentIndex >= length) {
						//todo焦点跳出
						$(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
						_FocusActions2.default.focusChange(this.props.xml, pre);
					} else {
						//由于使用了基于jquery的插件 会自动更改dom 所以不能用状态管理来实现this.setState({currentTabFocusIndex:currentIndex});
						var inputList = $(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
						$(inputList[currentIndex]).addClass("gongqiFocus").find("input[type='radio']").focus();
					}
				}
			}
		}, {
			key: 'setFinalValue',
			value: function setFinalValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (!value) value = this.selectedValue;
				if (!this.props.dataField) {
					if (this.props.groupAlias == "" || !this.props.groupAlias) {
						var oldValue = this.record;var newValue = value;this.record = value;
	
						if (this.props.control && oldValue != newValue && triggerModified) {
							this.props.control.doModifiedEditor(oldValue, newValue);
						}
					}
					this.record = value;
				} else {
					var changed = false;
					var _oldValue = this.record && this.props.dataField ? this.record[this.props.dataField] : this.record ? this.record : "";
					var _newValue = value;
					if (_oldValue != _newValue) changed = true;
					this.record[this.props.dataField] = _newValue;
					//alert("派发");	
					if (changed) {
						_RecordsActions2.default.RecordFieldChanged(this.record, this.props.dataField, _oldValue, _newValue, this);
						if (this.props.control) this.props.control.doFieldModifiedRemote(this.props.dataField, _newValue + "", _oldValue + "");
					}
					this.updateModifiedTag();
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var triggerModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (value == 0 || value) {
					if (Array.isArray(value)) {
						this.selectValue(value[0]);
					} else {
						if (typeof value == 'string' && value.indexOf(',') != -1) {
							this.selectValue(value.split(',')[0]);
							return;
						}
						var list = this.props.control.getProperty_DataProvider();
						for (var i = 0; i < list.length; i++) {
							var item = list[i];
							if (item.value == value || item.value == value + "") {
								this.selectValue(value);
								this.setFinalValue(item.value, triggerModified);
								return;
							}
						}
					}
				} else {
					throw new Error("EnumEditor.setValue not String");
				}
			}
		}, {
			key: 'setDisplayFieldText',
			value: function setDisplayFieldText(value) {
				var triggerModify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				this.setValue(value, triggerModify);
			}
		}, {
			key: 'getFormAutoQueryValue',
			value: function getFormAutoQueryValue() {
				return this.selectedValue;
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if ((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId) {
					if (selector != "all" && this.props.xml.name != selector) return;
					if (this.props.underQueryGroup && !this.getInQueryGroupNow()) return;
					if (!this.record || this.record == "") {
						mapEditorValues[this.props.xml.name] = this.props.defaultValueForCMD;
					} else {
						var _record = this.record;
						if (Array.isArray(this.record)) {
							_record = this.record.join(",");
						}
						mapEditorValues[this.props.xml.name] = _record;
					}
				}
			}
		}, {
			key: 'getRadioItems',
			value: function getRadioItems(_layout) {
				var _options = this.props.options;
				var onFocusHandler = this.enumRadioOnFocusHandler.bind(this);
				var onBlurHandler = this.enumRadioOnBlurHandler.bind(this);
				var onTabHandler = this.enumRadioOnKeyDownHandler.bind(this);
				var inputClass = "minimal";
				var list = [];
				for (var i = 0; i < _options.length; i++) {
					var item = _options[i];
					var _value = item.value;
					list.push(_react2.default.createElement(
						'label',
						{ style: { paddingRight: _layout == "vertical" ? '0px' : '20px', fontWeight: '200', margin: '0px', marginBottom: _layout == "vertical" ? "5px" : "" }, key: i },
						_react2.default.createElement('input', { onKeyDown: onTabHandler, onFocus: onFocusHandler, onBlur: onBlurHandler, type: 'radio',
							name: this.props.xml.name, className: inputClass, 'data-serverId': _value, 'data-index': i }),
						item.label
					));
				}
	
				return list;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var list = this.getRadioItems("horizontal");
				var _style = { display: 'flex', flexShrink: '0', alignSelf: 'stretch', padding: '5px', flexWrap: 'wrap' };
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this2.radioContainer = node;
						}, style: _style, className: 'formItemPluginRadio', 'data-xmlid': this.props.xml.id, id: this.props.xml.name },
					list
				);
			}
		}]);
	
		return FormItemEnumRadioEditor;
	}(_FormItemEnumEditor3.default);
	
	exports.default = FormItemEnumRadioEditor;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(315);
	
	var FormItemImageDialog = function (_React$Component) {
	  _inherits(FormItemImageDialog, _React$Component);
	
	  function FormItemImageDialog(props) {
	    _classCallCheck(this, FormItemImageDialog);
	
	    var _this = _possibleConstructorReturn(this, (FormItemImageDialog.__proto__ || Object.getPrototypeOf(FormItemImageDialog)).call(this, props));
	
	    _this.resourceURL = window.parent.window.userInfos.resourceURL;
	    _this.serviceURL = window.parent.window.userInfos.serviceURL;
	    _this.imgPath = props.imgPath;
	    _this.imgName = props.imgName;
	    _this.imgNum = props.imgNum;
	    _this.imgs = props.imgs;
	    return _this;
	  }
	
	  _createClass(FormItemImageDialog, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _ref;
	
	      var imgList = this.getContent();
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal ', ref: function ref(node) {
	            return _this2.FormItemImage_DialogModel = node;
	          }, style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	        _react2.default.createElement(
	          'div',
	          { className: ' ui-draggable', style: (_ref = { alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff" }, _defineProperty(_ref, 'background', '#FFFFFF'), _defineProperty(_ref, 'border', '1px solid #9B9B9B'), _defineProperty(_ref, 'boxShadow', '0 0 41px 5px rgba(0,0,0,0.25)'), _defineProperty(_ref, 'borderRadius', '2px'), _defineProperty(_ref, 'width', '540px'), _defineProperty(_ref, 'height', '399px'), _ref) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header', style: { position: "relative" } },
	            _react2.default.createElement('div', { className: 'modal-close', onClick: this.closeAttachmentHandler.bind(this) }),
	            _react2.default.createElement(
	              'h5',
	              { className: 'modal-title' },
	              '\u56FE\u7247'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { overflow: 'auto' } },
	            _react2.default.createElement(
	              'ul',
	              { className: 'wrap-selectImg' },
	              imgList
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'FormItemImage_DialogDelete' },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '18px', borderRight: '1px double', paddingRight: '6px', paddingLeft: '20px' } },
	              '\u5168\u9009'
	            ),
	            _react2.default.createElement('input', { type: 'checkbox', id: 'FormItemImage_DialogDeleteQX', onClick: this.checkAllImages.bind(this) }),
	            _react2.default.createElement(
	              'button',
	              { className: 'FormItemImage_DialogDeleteBtn', onClick: this.deleteImgs.bind(this) },
	              _react2.default.createElement('i', { className: 'fa fa-trash-o', 'aria-hidden': 'true' }),
	              '\xA0\u5220\u9664'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'closeAttachmentHandler',
	    value: function closeAttachmentHandler() {
	      //关掉要卸载
	      var $reactComponentContainer = $(this.FormItemImage_DialogModel);
	      _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	      $reactComponentContainer.remove();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $(this.FormItemImage_DialogModel).children(':first').draggable({ cursor: "move", containment: "parent" });
	      //this.doRefresh();
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var content = [];
	      for (var i = 0; i < this.imgNum; i++) {
	        var value = this.imgs[i];
	        var path = this.imgPath + "/" + this.imgs[i];
	        content.push(_react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement('input', { type: 'checkbox', name: 'imgs', id: '', value: value, onClick: this.selectImage.bind(this) }),
	          _react2.default.createElement('img', { src: path, alt: '', style: { width: '140px', height: '120px' } }),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            value
	          )
	        ));
	      }
	      return content;
	    }
	  }, {
	    key: 'deleteImgs',
	    value: function deleteImgs() {
	      var obj = document.getElementsByName("imgs");
	      var check_arr = [];
	      for (var i = 0; i < obj.length; i++) {
	        if (obj[i].checked) check_arr.push(obj[i].value);
	      }
	      this.props.deleteImgs(check_arr);
	
	      var $reactComponentContainer = $(this.FormItemImage_DialogModel);
	      _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	      $reactComponentContainer.remove();
	    }
	  }, {
	    key: 'checkAllImages',
	    value: function checkAllImages() {
	      var obj = document.getElementById('FormItemImage_DialogDeleteQX');
	      var imgs = document.getElementsByName("imgs");
	      if (obj.checked) {
	        for (var i = 0; i < imgs.length; i++) {
	          if (!imgs[i].checked) imgs[i].checked = true;
	        }
	      } else {
	        for (var i = 0; i < imgs.length; i++) {
	          if (imgs[i].checked) imgs[i].checked = false;
	        }
	      }
	    }
	  }, {
	    key: 'selectImage',
	    value: function selectImage() {
	      var imgs = document.getElementsByName("imgs");
	      var isAll = 1;
	      for (var i = 0; i < imgs.length; i++) {
	        if (!imgs[i].checked) isAll = 0;
	      }
	      var obj = document.getElementById('FormItemImage_DialogDeleteQX');
	      if (isAll == 0) {
	        obj.checked = false;
	      }
	      if (isAll == 1) {
	        obj.checked = true;
	      }
	    }
	  }]);
	
	  return FormItemImageDialog;
	}(_react2.default.Component);
	
	FormItemImageDialog.defaultProps = {};
	exports.default = FormItemImageDialog;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _TreeRefreshArg = __webpack_require__(76);
	
	var _TreeRefreshArg2 = _interopRequireDefault(_TreeRefreshArg);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from 'react-dom';
	
	
	__webpack_require__(83);
	
	var FormItemPluginAttachment = function (_GongqiFormItem) {
		_inherits(FormItemPluginAttachment, _GongqiFormItem);
	
		function FormItemPluginAttachment(props) {
			_classCallCheck(this, FormItemPluginAttachment);
	
			var _this = _possibleConstructorReturn(this, (FormItemPluginAttachment.__proto__ || Object.getPrototypeOf(FormItemPluginAttachment)).call(this, props));
	
			_this.serviceURL = window.parent.window.userInfos.serviceURL;
			_this.resourceURL = window.parent.window.userInfos.resourceURL;
			_this.width = _this.props.control.width;
			_this.state = {
				task: false,
				fileList: [],
				returnFileList: [],
				AttachmentFileList: [],
				// selectedIndex:'0',
				renameIsShow: false,
				coverIsShow: false
			};
			_this.unsubscribeCommandMapEditorsStore = _CommandStore.CommandMapEditorsStore.listen(_this.onMapEditorsHandler.bind(_this));
			_this.unsubscribeRefreshPluginStore = _CmdTypeStore.RefreshPluginStore.listen(_this.onRefresh.bind(_this));
			return _this;
		}
	
		_createClass(FormItemPluginAttachment, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCommandMapEditorsStore();
				this.unsubscribeRefreshPluginStore();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
				if (window.hasOwnProperty(key)) {
					var pluginLaterArg = window[key];
					var tasks = pluginLaterArg.tasks;
					for (var i = 0; i < tasks.length; i++) {
						this.refresh(tasks[i]);
					}
					window[key] = null;
					delete window[key];
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'onRefresh',
			value: function onRefresh(task, pluginName, formId, result) {
				if (this.props.xml.name == pluginName && this.props.formId == formId) {
					result.push(this.props.xml.name);
					this.refresh(task);
				}
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if (this.props.moduleInstanceId != moduleInstanceId) return;
				if (selector != "all" && this.props.xml.name != selector) return;
	
				var returnFileList = this.state.returnFileList;
				// if(returnFileList){
				// 	var id = this.state.returnFileList[0];
				// }else{
				// 	var id = "";
				// }
				// var arr = [];
				// arr.push(id);
	
				mapEditorValues[this.props.xml.name] = returnFileList;
				return;
			}
		}, {
			key: 'refresh',
			value: function refresh(task) {
				console.log(task);
				// var attachments = task.arg.attachments
				var data = task;
				(function (data) {
					this.setState({
						task: data,
						AttachmentFileList: data.arg.attachments
					});
					// console.log(this.state.data);
				}).call(this, data);
				// this.setState({
				// 	task:task,
				// 	AttachmentFileList: attachments
				// });
				var AttachmentFileList = data.arg.attachments;
				var list = [];
				var idlist = [];
				if (AttachmentFileList.length > 0) {
					for (var i = 0; i < AttachmentFileList.length; i++) {
						list.push(AttachmentFileList[i].attachmentName);
						idlist.push(AttachmentFileList[i].attachmentId);
					}
					this.setState({
						fileList: list,
						returnFileList: idlist
					});
				}
				if (!task.arg.allowEditor) {
					$(this.uploaderButton).css("display", "none");
				}
			}
		}, {
			key: 'btnUpLoad_clickHandler',
			value: function btnUpLoad_clickHandler() {
				// alert("2");
				$(this.uploaderInput).click();
			}
		}, {
			key: 'upLoaderChangeHandler',
			value: function upLoaderChangeHandler(e) {
				var uploadFiles = e.target.files || e.dataTransfer.files;
				var uploadFile = uploadFiles[0];
				if (uploadFile) {
					this.fileSelectedHandler(uploadFile);
				}
			}
		}, {
			key: 'doFileSelected',
			value: function doFileSelected(uploadFile) {
				var fileList = this.state.fileList;
				var fileName = uploadFile.name;
				this.uploadFile = uploadFile;
				if (fileList.length > 0 && fileList.indexOf(fileName) > -1) {
					this.setState({ coverIsShow: true });
				} else {
					this.upLoadFileHandler();
				}
			}
		}, {
			key: 'fileSelectedHandler',
			value: function fileSelectedHandler(uploadFile) {
	
				if (uploadFile.size > 100 * 1024 * 1024) {
					var options = {
						text: '要上传的文件不允许超过100M'
					};
					_Fade2.default.show(options);
				} else {
					this.doFileSelected(uploadFile);
				}
			}
		}, {
			key: 'upLoadFileHandler',
			value: function upLoadFileHandler() {
				var dataItemId = this.state.task.arg.dataItemId;
				var uploadFile = this.uploadFile;
				this.setState({ coverIsShow: false });
				var fileName = uploadFile.name;
				// var tableId=this.state.tableId;
				// var recId=this.state.recId;
				//web/apps/gongqi.oa.bpm/attachment/upload/
				var path = "web/apps/gongqi.oa.bpm/attachment/upload/" + dataItemId;
				// var serviceURL=this.serviceURL;
				var url = encodeURI(path);
				// var url = "http://192.168.1.140:10201/web/bpm/attachment/upload/"+dataItemId;
	
	
				var oMyForm = new FormData();
				oMyForm.append("attachmentFile", uploadFile);
				this.client = new XMLHttpRequest();
				var progressBar = $('<progress></progress>').css({ 'width': '15em', 'height': '2.1em' }).html('您的浏览器不支持progress元素');
				var that = this;
				var progressA = $('<a></a>').css({ 'background-color': '#fff', 'color': '#ff0000', 'font-size': '1.5em' }).click(function () {
					that.client.abort();
				}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
				var progressBtn = $('<div></div>').append(progressA);
				var progressDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '40.5%', 'left': '40%', 'display': 'flex' }).append(progressBar).append(progressBtn);
				var percentageDiv = $('<span></span>');
				var time = $("<span></span>");
				var percentDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '41%', 'left': '40.5%', 'font-size': '0.8em' }).append(percentageDiv).append(time);
				var progressBorder = $("<div></div>").append(progressDiv).append(percentDiv).attr('id', 'progressBorder').addClass('modal');
				$('body').append(progressBorder);
	
				this.client.upload.onprogress = function (pe) {
	
					if (pe.lengthComputable) {
						progressBorder.css('display', 'block');
						progressBar.attr('max', pe.total);
						progressBar.attr('value', pe.loaded);
						percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
					}
					var nt = new Date().getTime(); //获取当前时间
					var pertime = (nt - this.ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
					this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
					var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
					this.oloaded = pe.loaded; //重新赋值已上传文件大小，用以下次计算
	
					//上传速度计算
					var speed = perload / pertime; //单位b/s
					var bspeed = speed;
					var units = 'b/s'; //单位名称
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'k/s';
					}
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'M/s';
					}
					speed = speed.toFixed(1);
					//剩余时间
					var resttime = ((pe.total - pe.loaded) / bspeed).toFixed(1);
	
					var timeContent = ' ' + speed + units + '，剩余时间：' + resttime + 's';
					time.html(timeContent);
				};
	
				this.client.upload.onloadstart = function () {
					//上传开始执行方法
					this.ot = new Date().getTime(); //设置上传开始时间
					this.oloaded = 0; //设置上传开始时，以上传的文件大小为0
				};
				this.client.onreadystatechange = this.uploadStateChangeHandler.bind(this, fileName, uploadFile);
	
				this.client.open("POST", url, true); //+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
				this.client.withCredentials = true;
	
				this.client.onloadend = function (pe) {
					// document.getElementById('progressDiv').style.display='none';
					$('#progressBorder').remove();
				};
				this.client.send(oMyForm);
			}
		}, {
			key: 'uploadStateChangeHandler',
			value: function uploadStateChangeHandler(fileName, uploadFile) {
				var that = this;
				if (this.client.readyState == 4) {
					// 4 = "loaded"
					if (this.client.status == 200) {
						var options = {
							state: 'success',
							text: '上传成功！'
						};
						_Fade2.default.show(options);
						//更新列表
	
						console.log(this.client.responseText);
						var responseText = JSON.parse(this.client.responseText);
						var data = responseText.content;
						var returnfileidarr = this.state.returnFileList;
	
						//this.doRefresh();
						var fileList = this.state.fileList;
						var attachmentfilelist = this.state.AttachmentFileList;
						if (fileList.indexOf(fileName) == -1) {
							fileList.push(fileName);
							attachmentfilelist.push(uploadFile);
							returnfileidarr.push(data.attachmentId);
							this.setState({
								fileList: fileList,
								AttachmentFileList: attachmentfilelist,
								returnFileList: returnfileidarr
							});
						}
	
						var _parentWindow = window.parent.window;
						if (_parentWindow) {
							_parentWindow.updateAttachmentNum(fileList.length);
						}
						window.updateAttachmentNum(fileList.length);
					} else {
						var options = {
							state: 'error',
							text: '上传失败！'
						};
						_Fade2.default.show(options);
					}
				}
				$(this.uploaderInput).val('');
			}
		}, {
			key: 'getTableContent',
			value: function getTableContent() {
				var fileList = this.state.fileList;
				var tableContent = [];
				var that = this;
				var task = this.state.task;
				var allowEditor = false;
				var returnFileList = this.state.returnFileList;
				var AttachmentFileList = this.state.AttachmentFileList;
				if (task) {
					allowEditor = task.arg.allowEditor;
				}
				if (fileList.length == 0) {} else {
					var _loop = function _loop() {
						fileName = fileList[i];
						attachmentId = returnFileList[i];
						filesize = AttachmentFileList[i].attachmentSize;
						href = "web/apps/gongqi.oa.bpm/attachment/download/" + attachmentId + "/" + fileName;
	
						if (allowEditor) {
							displaystyle = "block";
						} else {
							displaystyle = "none";
						}
						var f = fileName;
						tableContent.push(_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								_react2.default.createElement(
									'a',
									{ href: href, target: '_blank' },
									fileName
								)
							),
							_react2.default.createElement(
								'td',
								{ style: { float: 'right', textAlign: 'center' } },
								_react2.default.createElement(
									'a',
									null,
									filesize
								),
								_react2.default.createElement(
									'span',
									null,
									'\u2003'
								),
								_react2.default.createElement(
									'a',
									{ href: href, target: '_blank', disable: !allowEditor },
									_react2.default.createElement('i', { className: 'fa fa-download' }),
									'\u4E0B\u8F7D'
								),
								_react2.default.createElement(
									'span',
									null,
									'\u2003'
								),
								_react2.default.createElement(
									'a',
									{ title: fileName, onClick: function onClick() {
											return that.btnDelete_clickHandler(f);
										}, style: { display: displaystyle } },
									_react2.default.createElement('i', { title: fileName, className: 'fa fa-minus' }),
									'\u5220\u9664'
								)
							)
						));
					};
	
					for (var i = 0; i < fileList.length; i++) {
						var fileName;
						var attachmentId;
						var filesize;
						var displaystyle;
						var href;
	
						_loop();
					}
				}
				return tableContent;
			}
		}, {
			key: 'btnDelete_clickHandler',
			value: function btnDelete_clickHandler(fileName) {
				//删除
				// let fileName = $(e.target).attr("title");
				var fileList = this.state.fileList;
				var attachmentfilelist = this.state.AttachmentFileList;
				var returnFileList = this.state.returnFileList;
				if (fileList.length == 0) {} else {
					for (var i = 0; i < fileList.length; i++) {
						var name = fileList[i];
						if (name == fileName) {
							fileList.splice($.inArray(name, fileList), 1);
							attachmentfilelist.splice($.inArray(attachmentfilelist[i], attachmentfilelist), 1);
							returnFileList.splice($.inArray(returnFileList[i], returnFileList), 1);
						}
					}
					this.setState({
						fileList: fileList,
						AttachmentFileList: attachmentfilelist,
						returnFileList: returnFileList
					});
				}
			}
		}, {
			key: 'btnDownLoad_clickHandler',
			value: function btnDownLoad_clickHandler(fileName) {
				//下载
				// alert("download");
				// var selectedIndex=this.state.selectedIndex;
				// var fileList=this.state.fileList;
				// var selectedItem;
				// var returnFileList = this.state.returnFileList;
				// if(fileList.length==0){
	
				// }else{
				// 	for(var i=0;i<fileList.length;i++){
				// 		var name=fileList[i];
				// 		if(name == fileName){
				// 			selectedItem = returnFileList[i];
				// 		}
				// 	}
				// }
				// // var selectedItem=fileList[selectedIndex];
				// if(selectedItem == null || selectedItem == "")
				// 	return;
				// var base=this.resourceURL;
				// // var tableId=this.state.tableId;
				// // var recId=this.state.recId;
				// var dataItemId = this.state.task.arg.dataItemId;
				// // var url=base+"web/bpm/attachment/dowmnload/" + selectedItem;
				// var url = "web/bpm/attachment/dowmnload/" + selectedItem;
				// // /GongqiERP/resource/attachments/30102106/1993897950/loading.gif
				// // var url='http://www.gongqi.info:10208/bin/'+selectedItem;
				// if(typeof url == 'object' && url instanceof Blob)
				// {
				// 	url = URL.createObjectURL(url); // 创建blob地址
				// }
				// var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
				// a.href = url;
				// a.download = selectedItem;
	
				// var e = document.createEvent('MouseEvents');
				// e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				// a.dispatchEvent(e);
				// URL.revokeObjectURL(url);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var tableContent = this.getTableContent();
				return _react2.default.createElement(
					'div',
					{ id: this.props.xml.name, className: 'gongqiPluginAttachment', style: { width: '100%' } },
					_react2.default.createElement(
						'div',
						{ style: { padding: ' 0 100px' } },
						_react2.default.createElement(
							'table',
							{ className: 'table', style: { marginBottom: '0px' } },
							_react2.default.createElement(
								'tbody',
								null,
								tableContent
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { padding: '0 100px' } },
						_react2.default.createElement('input', { type: 'file', accept: '*', multiple: 'false', style: { display: 'none' }, ref: function ref(node) {
								return _this2.uploaderInput = node;
							}, onChange: this.upLoaderChangeHandler.bind(this) }),
						_react2.default.createElement(
							'button',
							{ type: 'button', ref: function ref(node) {
									return _this2.uploaderButton = node;
								}, className: 'btn btn-default', style: { width: '100%', background: '#fff', border: '1px dashed #ccc' }, onClick: this.btnUpLoad_clickHandler.bind(this) },
							'\u70B9\u51FB\u4E0A\u4F20'
						)
					)
				);
			}
		}]);
	
		return FormItemPluginAttachment;
	}(_GongqiFormItem3.default);
	
	exports.default = FormItemPluginAttachment;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _TreeRefreshArg = __webpack_require__(76);
	
	var _TreeRefreshArg2 = _interopRequireDefault(_TreeRefreshArg);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from 'react-dom';
	
	
	__webpack_require__(83);
	
	var FormItemPluginComment = function (_GongqiFormItem) {
		_inherits(FormItemPluginComment, _GongqiFormItem);
	
		function FormItemPluginComment(props) {
			_classCallCheck(this, FormItemPluginComment);
	
			var _this = _possibleConstructorReturn(this, (FormItemPluginComment.__proto__ || Object.getPrototypeOf(FormItemPluginComment)).call(this, props));
	
			_this.state = {
				task: false
			};
			_this.unsubscribeCommandMapEditorsStore = _CommandStore.CommandMapEditorsStore.listen(_this.onMapEditorsHandler.bind(_this));
			_this.unsubscribeRefreshPluginStore = _CmdTypeStore.RefreshPluginStore.listen(_this.onRefresh.bind(_this));
			return _this;
		}
	
		_createClass(FormItemPluginComment, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCommandMapEditorsStore();
				this.unsubscribeRefreshPluginStore();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
				if (window.hasOwnProperty(key)) {
					var pluginLaterArg = window[key];
					var tasks = pluginLaterArg.tasks;
					for (var i = 0; i < tasks.length; i++) {
						this.refresh(tasks[i]);
					}
					window[key] = null;
					delete window[key];
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'onRefresh',
			value: function onRefresh(task, pluginName, formId, result) {
				if (this.props.xml.name == pluginName && this.props.formId == formId) {
					result.push(this.props.xml.name);
					this.refresh(task);
				}
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if (this.props.moduleInstanceId != moduleInstanceId) return;
				if (selector != "all" && this.props.xml.name != selector) return;
	
				var textareavalue = $(this.TextareaValue).val();
				var task = this.state.task;
				if (task) {
					var id = task.arg.editorId;
				} else {
					var id = "";
				}
	
				mapEditorValues[this.props.xml.name] = {
					remoteClass: "java.util.Map",
					id: id,
					commentText: textareavalue
				};
				return;
			}
		}, {
			key: 'refresh',
			value: function refresh(task) {
				console.log(task);
				this.setState({
					task: task
				});
			}
		}, {
			key: 'getInputDom',
			value: function getInputDom(task) {
				var _this2 = this;
	
				if (task) {
					var comments = task.arg.comments;
					var domLabelItems = [];
					var editorId = task.arg.editorId;
					comments.map(function (item) {
						if (item.id == editorId && task.arg.allowEditor) {
							var labelitem = _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'textarea',
									{ className: 'form-control', rows: '12', ref: function ref(node) {
											return _this2.TextareaValue = node;
										}, style: { height: '60px' } },
									item.commentText
								)
							);
							domLabelItems.push(labelitem);
						} else {
							var labelitem = _react2.default.createElement(
								'div',
								{ style: { padding: '10px 5px', display: 'flex' } },
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('img', { src: item.portraitImage, height: '36px;' })
								),
								_react2.default.createElement(
									'div',
									{ style: { padding: '0 5px', width: '100%' } },
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'span',
											null,
											item.approvalBy
										),
										_react2.default.createElement(
											'a',
											null,
											'[',
											item.approvalNode,
											']'
										),
										_react2.default.createElement(
											'span',
											null,
											item.approvalTime
										)
									),
									_react2.default.createElement(
										'div',
										null,
										item.commentText
									),
									_react2.default.createElement(
										'div',
										{ style: { float: 'right' } },
										_react2.default.createElement(
											'span',
											null,
											'\u64CD\u4F5C\uFF1A',
											item.approval
										)
									)
								)
							);
							domLabelItems.push(labelitem);
						}
					});
					//console.log(domLabelItems);
					var commentLabel = this.props.control.getProperty_Label();
					if (!commentLabel) {
						commentLabel = _GOTUtil2.default.getPropertyValue(this.props.xml, "Label");
					}
					var inputdom = _react2.default.createElement(
						'div',
						{ id: this.props.xml.name, className: 'row gongqiPluginComment', style: { width: '100%' } },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-3', style: { textAlign: 'center' } },
							commentLabel
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-9' },
							_react2.default.createElement(
								'div',
								{ style: { border: '1px solid #d2cfcf' } },
								domLabelItems.map(function (item) {
									return item;
								})
							)
						)
					);
	
					return inputdom;
				} else {
					return _react2.default.createElement('div', { id: this.props.xml.name });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var task = this.state.task;
	
				var inputdom = this.getInputDom(task);
				return _react2.default.createElement(
					'div',
					{ style: { width: '100%' } },
					inputdom
				);
			}
		}]);
	
		return FormItemPluginComment;
	}(_GongqiFormItem3.default);
	
	exports.default = FormItemPluginComment;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemPluginHtml = function (_GongqiFormItem) {
		_inherits(FormItemPluginHtml, _GongqiFormItem);
	
		function FormItemPluginHtml(props) {
			_classCallCheck(this, FormItemPluginHtml);
	
			var _this = _possibleConstructorReturn(this, (FormItemPluginHtml.__proto__ || Object.getPrototypeOf(FormItemPluginHtml)).call(this, props));
	
			_this.CHANGE_URL = "changeURL";
			_this.CALL_IFRAMEM_METHOD = "callIFrameMethod";
	
			_this.unsubscribeRefreshPluginStore = _CmdTypeStore.RefreshPluginStore.listen(_this.onRefresh.bind(_this));
			return _this;
		}
	
		_createClass(FormItemPluginHtml, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeRefreshPluginStore();
			}
		}, {
			key: 'onRefresh',
			value: function onRefresh(task, pluginName, formId, result) {
				if (this.props.xml.name == pluginName && this.props.formId == formId) {
					result.push(this.props.xml.name);
					this.refresh(task);
				}
			}
	
			/*componentDidMount()
	  {
	  	if($(this.parentNode).height()!=$(this.iframeNode).height())
	  	{
	  		$(this.iframeNode).height($(this.parentNode).height());
	  	}
	  }*/
	
		}, {
			key: 'refresh',
			value: function refresh(task) {
				if (this.iframeNode) {
					var htmlrefresharg = task.arg;
					if (htmlrefresharg.opr == this.CHANGE_URL) {
	
						//TODO  plugin  在os内部跳转时  需要固定的 ip前缀
						if (window.parent.window.didomain && window.parent.window.appId) {
							//$(this.iframeNode).attr("src","appCustomClient/"+htmlrefresharg.arg);
							if (htmlrefresharg.arg.startsWith("/")) {
								htmlrefresharg.arg = "." + htmlrefresharg.arg;
							}
							$(this.iframeNode).attr("src", htmlrefresharg.arg);
						} else {
							$(this.iframeNode).attr("src", htmlrefresharg.arg);
						}
						//$(this.iframeNode).load(htmlrefresharg.arg);
					} else if (htmlrefresharg.opr == this.CALL_IFRAMEM_METHOD) {
						//TODO 取消CommandArg的情况 allowEdit固定为true
						var funcName = htmlrefresharg.arg;
	
						if (htmlrefresharg.addClientInfo) {
							var _parentWindow = window.parent.window;
							if (htmlrefresharg.iframeFuncArg == null) htmlrefresharg.iframeFuncArg = [];
							var commandArg = {};
							try {
								_CommandResolver2.default.regCmdArgGroup(this.module, commandArg, this.props.control.group, false, true, true, false, true, true);
							} catch (err) {}
	
							htmlrefresharg.iframeFuncArg.push({
								allowEdit: true,
								userId: _parentWindow.userInfos.userId,
								userGroups: _parentWindow.userInfos.userGroups,
								commandArg: commandArg
							});
						}
						var win = this.iframeNode.window || this.iframeNode.contentWindow;
						var fn = win[funcName];
						var funcArg = htmlrefresharg.iframeFuncArg;
						if (typeof fn === 'function') {
							fn.apply(null, funcArg);
						}
					}
				}
			}
		}, {
			key: 'changeFrameHeight',
			value: function changeFrameHeight() {
				return;
				var doc = this.iframeNode.contentWindow.document;
				$(this.iframeNode).height(doc.documentElement.clientHeight);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
				if (window.hasOwnProperty(key)) {
					var pluginLaterArg = window[key];
					var tasks = pluginLaterArg.tasks;
					for (var i = 0; i < tasks.length; i++) {
						this.refresh(tasks[i]);
					}
					window[key] = null;
					delete window[key];
				}
			}
	
			/*window.onresize=function()
	  {  
	       this.changeFrameHeight();  
	  
	  }*/
			/*<div style={{_style}} ref={node => this.iframeNode = node}></div>*/
	
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				//_style.display = 'flex';
				if (!this.props.control.getProperty_Visible() && !this.props.control.getProperty_PlaceHolder()) {
					_style.display = 'none';
				}
				_style = Object.assign(_style, { border: 'none', boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)', borderRadius: '3px' });
				return _react2.default.createElement('iframe', { onLoad: this.changeFrameHeight.bind(this), style: _style, id: "htmlPlugin" + this.props.xml.id, ref: function ref(node) {
						return _this2.iframeNode = node;
					} });
			}
		}]);
	
		return FormItemPluginHtml;
	}(_GongqiFormItem3.default);
	
	exports.default = FormItemPluginHtml;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _TreeRefreshArg = __webpack_require__(76);
	
	var _TreeRefreshArg2 = _interopRequireDefault(_TreeRefreshArg);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FocusStore = __webpack_require__(28);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from 'react-dom';
	
	
	__webpack_require__(83);
	
	var FormItemPluginRadio = function (_GongqiFormItem) {
		_inherits(FormItemPluginRadio, _GongqiFormItem);
	
		function FormItemPluginRadio(props) {
			_classCallCheck(this, FormItemPluginRadio);
	
			var _this = _possibleConstructorReturn(this, (FormItemPluginRadio.__proto__ || Object.getPrototypeOf(FormItemPluginRadio)).call(this, props));
	
			Object.assign(_this.state ? _this.state : {}, {
				tag: false,
				radioArg: "",
				RadioFormGroup: null
			});
	
			_this.currentIndex = -1;
			_this.selectedValue = "";
			_this.serverSelectChange = false;
			_this.unsubscribeCommandMapEditorsStore = _CommandStore.CommandMapEditorsStore.listen(_this.onMapEditorsHandler.bind(_this));
			_this.unsubscribeRefreshPluginStore = _CmdTypeStore.RefreshPluginStore.listen(_this.onRefresh.bind(_this));
			_this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this.onFocusSet.bind(_this));
			return _this;
		}
	
		_createClass(FormItemPluginRadio, [{
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					var radioInputs = $(this.radioContainer).find("input[type='radio']");
					$(radioInputs[0]).focus();
					this.onTabHandler(-1, pre);
				}
				//$(this.radioContainer).focus();
				//$($(this.radioContainer).find("input.minimal")[0]).focus();
			}
		}, {
			key: 'onTabHandler',
			value: function onTabHandler(currentIndex, pre) {
				var radioArg = this.state.radioArg;
				if (!radioArg) {
					radioArg = this.initedRadioArg;
				}
				if (radioArg && radioArg.arg && radioArg.arg.items) {
					var length = radioArg.arg.items.length;
					pre ? currentIndex-- : currentIndex++;
					if (currentIndex < 0 || currentIndex >= length) {
						//todo焦点跳出
						$(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
						_FocusActions2.default.focusChange(this.props.xml, pre);
					} else {
						//由于使用了基于jquery的插件 会自动更改dom 所以不能用状态管理来实现this.setState({currentTabFocusIndex:currentIndex});
						var inputList = $(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
						$(inputList[currentIndex]).addClass("gongqiFocus").find("input[type='radio']").focus();
					}
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCommandMapEditorsStore();
				this.unsubscribeRefreshPluginStore();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				// $("form-group .iradio_flat-blue .minimal").iCheck({
				// 	checkboxClass: 'icheckbox_minimal-blue14',
				// 	radioClass:'iradio_minimal-blue'
				// });
	
				$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
					radioClass: 'iradio_minimal-blue' }).on('ifChecked', this.selectedChanged.bind(this, true)).on('ifUnchecked', this.selectedChanged.bind(this, false));
	
				if (this.initedSelectedValue) {
					var selectedItemId = this.initedSelectedValue;
					var that = this;
					$(this.radioContainer).find("input[type='radio']").each(function () {
						if ($(this).attr("data-serverId") == selectedItemId) {
							//遍历radio组，使用iCheck设置选中项
							that.selectedValue = selectedItemId;
							that.serverSelectChange = true;
							$(this).iCheck('check');
						}
					});
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
					radioClass: 'iradio_minimal-blue' }).on('ifChecked', this.selectedChanged.bind(this, true)).on('ifUnchecked', this.selectedChanged.bind(this, false));
			}
		}, {
			key: 'selectedChanged',
			value: function selectedChanged(value, e) {
	
				if (value == true && e.target) {
					var mi = void 0;var methodName = "pluginRadioItemSelect_" + this.props.xml.name;
					var formModule = this.props.control.module;
					var isLookup = formModule.classAlias == "FormModuleLookup";
					mi = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, isLookup ? "FormLookup" : formModule.menuItemId, formModule.formId);
					if (!mi) mi = { groups: "current(4)", editors: "all", joinGroup: null, fetchOption: true };
	
					this.selectedValue = $(e.target).attr("data-serverId");
					var commandArg = _CommandResolver2.default.getSendCmd(formModule, this.props.control.groupAlias, mi);
					commandArg.argObject = this.selectedValue;
	
					_ServiceHelper2.default.addTokenWithCommand({
						command: _CommandHelper2.default.createFormInstance(formModule.formName, "doPluginRadioItemSelect", "CommandResult").appendArg(this.props.xml.name, "String").appendArg(commandArg, "CommandArg"),
						resultFunction: function resultFunction(data) {
							var newCr = data.result;
							if (newCr && newCr.tasks && newCr.tasks.length > 0) {
								var tasks = newCr.tasks;
								var task = tasks.shift();
								if (task) _CommandResolver2.default.doResolveTask(task, formModule, tasks);
							}
						}
					});
	
					/*var arg = {};
	    arg.methodName = "pluginRadioItemSelect_" + this.props.xml.name;
	    arg.methodArg = $(e.target).attr("data-serverId");
	    this.selectedValue = arg.methodArg;
	    var commandTask = new CommandTask();
	    commandTask.cmd = Cmd.FormCmd;
	    commandTask.arg = arg;
	    CommandResolver.formCmd(commandTask,this.props.control.module);*/
				}
			}
		}, {
			key: 'onRefresh',
			value: function onRefresh(task, pluginName, formId, result) {
				if (this.props.xml.name == pluginName && this.props.formId == formId) {
					result.push(this.props.xml.name);
					this.refresh(task);
				}
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if (this.props.moduleInstanceId != moduleInstanceId) return;
				if (selector != "all" && this.props.xml.name != selector) return;
	
				mapEditorValues[this.props.xml.name] = this.selectedValue;
			}
		}, {
			key: 'refresh',
			value: function refresh(task) {
				var _this2 = this;
	
				console.log(task);
				var _arg = task.arg;
				if (!_arg) return;
				if (_arg.opr == "SET_DATA") {
					if (_arg.arg && _arg.arg.items && _arg.arg.items.length > 0) {
						this.selectedValue = _arg.arg.items[0].id;
					}
					this.setState({
						tag: true,
						radioArg: _arg
					});
				} else if (_arg.opr == "SELECT_ITEM") {
					var selectedItemId = _arg.arg;
					var that = this;
					if ($(this.radioContainer).find("input[type='radio']").length != 0) {
						$(this.radioContainer).find("input[type='radio']").each(function () {
							if ($(this).attr("data-serverId") == selectedItemId) {
								//遍历radio组，使用iCheck设置选中项
								that.selectedValue = selectedItemId;
								that.serverSelectChange = true;
								$(this).iCheck('check');
							}
						});
					} else {
						setTimeout(function () {
							var that = _this2;
							$(_this2.radioContainer).find("input[type='radio']").each(function () {
								if ($(this).attr("data-serverId") == selectedItemId) {
									//遍历radio组，使用iCheck设置选中项
									that.selectedValue = selectedItemId;
									that.serverSelectChange = true;
									$(this).iCheck('check');
								}
							});
						}, 350);
					}
				}
			}
		}, {
			key: 'getRadioItems',
			value: function getRadioItems(_layout, radioArg) {
				if (!radioArg) return null;
				var list = [];
				if (radioArg && radioArg.arg && radioArg.arg.items) {
					if (radioArg.arg.label) {
						list.push(_react2.default.createElement(
							'label',
							{ style: { paddingRight: _layout == "vertical" ? '0px' : '20px', margin: '0px' } },
							radioArg.arg.label
						));
					}
					for (var i = 0; i < radioArg.arg.items.length; i++) {
						var item = radioArg.arg.items[i];
						var uiChild = this.switchRadioArgItems2Dom(item);
						list.push(uiChild);
					}
				}
	
				return list;
			}
		}, {
			key: 'switchRadioArgItems2Dom',
			value: function switchRadioArgItems2Dom(item, _layout, i) {
				//this.selectedValue = item.id;
				var onFocusHandler = this.pluginOnFocusHandler.bind(this);
				var onBlurHandler = this.pluginOnBlurHandler.bind(this);
				var onTabHandler = this.pluginOnKeyDownHandler.bind(this);
				var inputClass = "minimal";
				return _react2.default.createElement(
					'label',
					{ style: { paddingRight: _layout == "vertical" ? '0px' : '20px', fontWeight: '200', margin: '0px', marginBottom: _layout == "vertical" ? "5px" : "" }, key: i },
					_react2.default.createElement('input', { onKeyDown: onTabHandler, onFocus: onFocusHandler, onBlur: onBlurHandler, type: 'radio', name: this.props.xml.name, className: inputClass, 'data-serverId': item.id, 'data-index': i }),
					item.label
				);
			}
		}, {
			key: 'getMutiRowColChildren',
			value: function getMutiRowColChildren(_style, radioArg, count) {
				var _layout = radioArg.arg.layout;
				var children = radioArg.arg.items;
				var length = children.length;
				if (_layout == "horizontal") {
	
					//var _form:GongqiFormBox = new GongqiFormBox();
					var flatChildren = [];
					var columnChildren = [];
					var _num = 0;
					for (var _i = 0; _i < length; _i++) {
						var child = children[_i];
						if (_num < count) {
							var uiChild = this.switchRadioArgItems2Dom(child, _layout, _i);
							columnChildren.push(uiChild);
							_num++;
							if (_i == length - 1) {
								flatChildren.push(columnChildren);
								//(control as Container).addElement(_form);
							}
						} else {
							_num = 0;
							_i--;
							//(control as Container).addElement(_form);
							flatChildren.push(columnChildren);
							columnChildren = [];
						}
					}
					var resultArr = [];
					for (var i = 0; i < flatChildren.length; i++) {
						var itemArray = flatChildren[i];
						resultArr.push(_react2.default.createElement(
							'div',
							{ key: i, style: { display: "flex", flexDirection: "column", alignItems: "stretch" }, className: 'form-vertical' },
							itemArray
						));
					}
					return resultArr;
				} else {
					var rowNum = length / count;
					var remainder = length % count;
					if (remainder > 0) rowNum++;
	
					_num = 0;
					var arr = [];
					for (var _i2 = 0; _i2 < count; _i2++) {
						var subarr = [];
						arr.push(subarr);
					}
					for (var _i3 = 0; _i3 < length; _i3++) {
						child = children[_i3];
						if (_num < count) {
							arr[_num].push(this.switchRadioArgItems2Dom(child, _layout, _i3));
							_num++;
						} else {
							_num = 0;
							_i3--;
						}
					}
					var _resultArr = [];
					for (var _i4 = 0; _i4 < arr.length; _i4++) {
						var _subarr = arr[_i4];
						_resultArr.push(_react2.default.createElement(
							'div',
							{ key: _i4, style: { display: "flex", flexDirection: "column", alignItems: "stretch" }, className: 'form-vertical' },
							_subarr
						));
					}
					return _resultArr;
				}
			}
		}, {
			key: 'pluginOnFocusHandler',
			value: function pluginOnFocusHandler(e) {
				//this.currentIndex = -1;
			}
		}, {
			key: 'pluginOnBlurHandler',
			value: function pluginOnBlurHandler(e) {
				//this.currentIndex = -1;
				//$(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
			}
		}, {
			key: 'pluginOnKeyDownHandler',
			value: function pluginOnKeyDownHandler(e) {
				if (9 === e.keyCode) {
					e.preventDefault();
					var index = $(e.target).attr("data-index");
					this.onTabHandler(index, e.shiftKey);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _style = { display: 'flex', flexShrink: '0', alignSelf: 'stretch', padding: '5px', flexWrap: 'wrap' };
				if (this.state.visible == false) {
					if (this.state.hideInVisible == false) _style.visibility = "hidden";else _style.display = "none";
				}
				// var randomNum = Math.floor(Math.random() * 1000) ;
				// $(window.parent.document).find("#gongqi_testthree_406000150").css('height',randomNum+'px')
	
				// $("#DataGrid").height(randomNum)
				//if(this.props.control.getProperty_Height() > 0)
				//	_style["height"] = this.props.control.getProperty_Height() + "px";
				// if(window.parent.toolbarBig == undefined || window.parent.toolbarBig==false){
				// 	$(window.parent.document).find("#contentWrapper").css('paddingBottom',randomNum+'px')
				// }else{
				// 	$(window.parent.document).find("#contentWrapper").css('paddingBottom',randomNum+'px')
				// }
	
				var list = [];
	
				var radioArg = this.state.radioArg;
				if (!radioArg) {
					radioArg = this.initedRadioArg;
				}
				if (!radioArg) {
					var key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
					if (window.hasOwnProperty(key)) {
						var pluginLaterArg = window[key];
						if (pluginLaterArg) {
							var tasks = pluginLaterArg.tasks;
							for (var i = 0; i < tasks.length; i++) {
								pluginLaterArg = tasks[i];
								if (pluginLaterArg) {
									if (pluginLaterArg.cmd == "refreshPlugin") {
										pluginLaterArg = pluginLaterArg.arg;
										if (pluginLaterArg.opr == "SET_DATA") {
											radioArg = pluginLaterArg;
											this.initedRadioArg = radioArg;
										} else if (pluginLaterArg.opr == "SELECT_ITEM") {
											this.initedSelectedValue = pluginLaterArg.arg;
										}
									}
								}
							}
						}
	
						window[key] = null;
						delete window[key];
					}
				}
	
				if (!radioArg || !radioArg.arg) {
					var _height = this.props.control.getProperty_Height();
					if (_height) {
						if (_height < 25) _height = 25;
						_style.height = _height + "px";
					} else {
						// _height = 25;
					}
					_style.height = _height;
					// console.log('RadioRend',_height);
					return _react2.default.createElement('div', { ref: function ref(node) {
							return _this3.radioContainer = node;
						}, style: _style, className: 'formItemPluginRadio', 'data-xmlid': this.props.xml.id, id: this.props.xml.name });
				}
	
				var rowsOrColumns = radioArg.rowsOrColumns;
				//rowsOrColumns=2;
				if (rowsOrColumns) {
					var arr = this.getMutiRowColChildren(_style, radioArg, rowsOrColumns);
					return _react2.default.createElement(
						'div',
						{
							ref: function ref(node) {
								return _this3.radioContainer = node;
							}, style: _style, className: 'formItemPluginRadio', 'data-xmlid': this.props.xml.id, id: this.props.xml.name },
						arr
					);
				}
	
				if (radioArg.arg.layout == "vertical") {
					_style.flexDirection = "column";delete _style["flexWrap"];_style.overflowY = "auto";
					var _width = this.props.control.getProperty_Width();
					if (_width > 0) _style.width = _width + "px";
	
					var _height2 = this.props.control.getProperty_Height();
					if (_height2) _style.height = _height2 + "px";
					list = this.getRadioItems("vertical", radioArg);
				} else {
					var _height3 = this.props.control.getProperty_Height();
					if (_height3) {
						if (_height3 < 25) _height3 = 25;
						_style.height = _height3 + "px";
					} else {
						// _height=25;
						// _style.height = _height+"px";
					}
	
					var _width2 = this.props.control.getProperty_Width();
					if (_width2) _style.width = _width2 + "px";
					list = this.getRadioItems("horizontal", radioArg);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this3.radioContainer = node;
						}, style: _style, className: 'formItemPluginRadio', 'data-xmlid': this.props.xml.id, id: this.props.xml.name },
					list
				);
			}
		}]);
	
		return FormItemPluginRadio;
	}(_GongqiFormItem3.default);
	
	exports.default = FormItemPluginRadio;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _TreeRefreshArg = __webpack_require__(76);
	
	var _TreeRefreshArg2 = _interopRequireDefault(_TreeRefreshArg);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _CommandStore = __webpack_require__(18);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FocusStore = __webpack_require__(28);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactDOM from 'react-dom';
	
	
	__webpack_require__(83);
	
	var FormItemPluginTree = function (_GongqiFormItem) {
		_inherits(FormItemPluginTree, _GongqiFormItem);
	
		function FormItemPluginTree(props) {
			_classCallCheck(this, FormItemPluginTree);
	
			var _this = _possibleConstructorReturn(this, (FormItemPluginTree.__proto__ || Object.getPrototypeOf(FormItemPluginTree)).call(this, props));
	
			_this.unsubscribeCommandMapEditorsStore = _CommandStore.CommandMapEditorsStore.listen(_this.onMapEditorsHandler.bind(_this));
			_this.unsubscribeRefreshPluginStore = _CmdTypeStore.RefreshPluginStore.listen(_this.onRefresh.bind(_this));
			_this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this.onFocusSet.bind(_this));
			return _this;
		}
	
		_createClass(FormItemPluginTree, [{
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.pluginTreeContainer).focus();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeCommandMapEditorsStore();
				this.unsubscribeRefreshPluginStore();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.treeDiv).height($(this.treeDiv).parent().height() - 12);
	
				var key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
				if (window.hasOwnProperty(key)) {
					var pluginLaterArg = window[key];
					var tasks = pluginLaterArg.tasks;
					for (var i = 0; i < tasks.length; i++) {
						this.refresh(tasks[i]);
					}
					window[key] = null;
					delete window[key];
				}
	
				//$(this.treeDiv).css("width",$(this.treeDiv).width()+"px");
				//$(this.treeDiv).css("height",$(this.treeDiv).height()+"px");
				//alert("height:"+$(this.treeDiv).css("height"));
				//alert("width:"+$(this.treeDiv).css("width"));
				// var setting = {
				// 	data: 
				// 	{
				// 		key: {
				// 			title:"t"
				// 		},
				// 		simpleData: {
				// 			enable: true
				// 		}
				// 	},
				// 	callback:
				// 	{
				// 		// beforeClick: this.beforeItemClick.bind(this),
				// 		// onClick: this.onItemClick.bind(this),
				// 		onDblClick: this.onItemDblClick.bind(this),
				// 		onRightClick: this.onItemRightClick.bind(this)
				// 	}
				// };
	
				// var xmlStr='<node>'+
				// 		'<node label="标签1" add="true" delete="true" open="打开" show="label1" id="1" >'+
				// 			'<node label="标签1-1" add="true" delete="true" open="打开" show="label11" id="11">'+
				// 					'<node label="标签1-1-1" add="true" delete="true" open="打开" show="label111" id="111">'+
				// 						'<node label="标签1-1-1-1" add="true" delete="true" open="打开" id="1111"></node>'+
				// 						'<node label="标签1-1-1-2" add="true" delete="true" open="打开" id="1112"></node>'+
				// 					'</node>'+
				// 			'</node>'+
				// 			'<node label="标签1-2" add="true" delete="true" open="打开" id="12"></node>'+
				// 			'<node label="标签1-3" add="true" delete="true" open="打开" id="13"></node>'+
				// 		'</node>'+
				// 		'<node label="标签2" add="true" id="2">'+
				// 			'<node label="标签2-1" add="true" id="21" show="label21"></node>'+
				// 		'</node>'+
				// 		'<node label="标签3" add="true" id="3">'+
				// 			'<node label="标签3-1" add="true" id="31"></node>'+
				// 		'</node>'+
				// 	'</node>'
				// var doc = (new DOMParser()).parseFromString(xmlStr,"application/xml");
				// var parentNodes=doc.childNodes[0].childNodes;
				// var pId=0;
				// var zNodes=this.getZNodes(parentNodes,pId);
				// $.fn.zTree.init($(this.treeDiv), setting, zNodes);
				// var zNodes =[
				// 	{ id:1, pId:0, name:"普通的父节点", t:"我很普通，随便点我吧", server:{} open:true},
				// 	{ id:11, pId:1, name:"叶子节点 - 1", t:"我很普通，随便点我吧"},
				// 	{ id:12, pId:1, name:"叶子节点 - 2", t:"我很普通，随便点我吧"},
				// 	{ id:13, pId:1, name:"叶子节点 - 3", t:"我很普通，随便点我吧"},
				// 	{ id:2, pId:0, name:"NB的父节点", t:"点我可以，但是不能点我的子节点，有本事点一个你试试看？", open:true},
				// 	{ id:21, pId:2, name:"叶子节点2 - 1", t:"你哪个单位的？敢随便点我？小心点儿..", click:false},
				// 	{ id:22, pId:2, name:"叶子节点2 - 2", t:"我有老爸罩着呢，点击我的小心点儿..", click:false},
				// 	{ id:23, pId:2, name:"叶子节点2 - 3", t:"好歹我也是个领导，别普通群众就来点击我..", click:false},
				// 	{ id:3, pId:0, name:"郁闷的父节点", t:"别点我，我好害怕...我的子节点随便点吧...", open:true, click:false },
				// 	{ id:31, pId:3, name:"叶子节点3 - 1", t:"唉，随便点我吧"},
				// 	{ id:32, pId:3, name:"叶子节点3 - 2", t:"唉，随便点我吧"},
				// 	{ id:33, pId:3, name:"叶子节点3 - 3", t:"唉，随便点我吧"}
				// ];
	
			}
		}, {
			key: 'onRefresh',
			value: function onRefresh(task, pluginName, formId, result) {
				if (this.props.xml.name == pluginName && this.props.formId == formId) {
					result.push(this.props.xml.name);
					this.refresh(task);
				}
			}
		}, {
			key: 'refresh',
			value: function refresh(task) {
				console.log(task);
				if (!task.arg) return;
				if (task.arg.opr == _TreeRefreshArg2.default.SET_DATA) {
					var xmlString;var expandDeep = 0;var expandNodeId = "";
					if (typeof task.arg.arg == "string") {
						xmlString = task.arg.arg;
					} else {
						xmlString = task.arg.arg.data;
						expandDeep = task.arg.arg.expanddeep;
						expandNodeId = task.arg.arg.expandNodeId ? task.arg.arg.expandNodeId : "";
					}
	
					if (expandDeep <= 0) expandDeep = 1;
					var doc = new DOMParser().parseFromString(xmlString, "application/xml");
					var parentNodes = doc.childNodes;
					//var expandDeep=task.arg.arg.expanddeep;
					//TODO_YL 增加 需求 默认哪个节点展开、展开多少级，其他节点不展开
					var pId = '0';
					var expandNodePId = this.getexpandNodeForOpen(parentNodes, pId, expandDeep, expandNodeId, 0);
					var zNodes = this.getZNodes(parentNodes, pId, expandDeep, expandNodeId, expandNodePId, 0);
					if (zNodes) {
						for (var i = 0; i < zNodes.length; i++) {
							if (zNodes[i].pId == 0) {
								this.selectedItem = zNodes[i];
								break;
							}
						}
					}
					var setting = {
						data: {
							key: {
								title: "t"
							},
							simpleData: {
								enable: true
							}
						},
						callback: {
							// beforeClick: this.beforeItemClick.bind(this),
							onClick: this.onItemClick.bind(this),
							onDblClick: this.onItemDblClick.bind(this),
							onRightClick: this.onItemRightClick.bind(this),
							onKeyChange: this.onKeyChange.bind(this)
						},
						view: {
							addDiyDom: this.addDiyDom.bind(this)
						}
					};
					var zTree = $.fn.zTree.init($(this.treeDiv), setting, zNodes);
					$.fn.zTreeKeyboardNavigation(zTree, this.pluginTreeContainer);
				} else if (task.arg.opr == _TreeRefreshArg2.default.SELECT_NODE) {
					var selId = task.arg.arg;
					var treeObj = $.fn.zTree.getZTreeObj("treePlugin" + this.props.xml.id);
					var nodes = treeObj.getNodes();
					nodes = treeObj.transformToArray(nodes);
					if (nodes.length > 0) {
						var treeNode = treeObj.getNodeByParam("serverId", selId);
						if (treeNode) {
							treeObj.selectNode(treeNode);
	
							var commandTask = new _CommandTask2.default();
							commandTask.cmd = _Cmd2.default.FormCmd;
							var tasks = [commandTask];
							var arg = {};
							this.selectedItem = treeNode;
							arg["methodName"] = "pluginTreeNodeChange_" + this.props.xml.name;
							arg["methodArg"] = treeNode.serverId; //treeNode.id;
							if (arg["methodArg"] == null) arg["methodArg"] = treeNode.name;
							commandTask.arg = arg;
							_CommandResolver2.default.resolve(tasks, this.props.control.module);
						}
					}
				} else if (task.arg.opr == _TreeRefreshArg2.default.UPDATE_NODE) {
					var _treeObj = $.fn.zTree.getZTreeObj("treePlugin" + this.props.xml.id);
					var treeUpdateArg = task.arg.arg;
					var updateNode = _treeObj.getNodeByParam("serverId", treeUpdateArg.id, null);
					var doc = new DOMParser().parseFromString(treeUpdateArg.data, "application/xml");
					var xmlNode = doc.childNodes[0];
	
					for (var j = 0; j < xmlNode.attributes.length; j++) {
						var nodeName = xmlNode.attributes[j].nodeName;
						if (nodeName == 'label') {
							updateNode['name'] = xmlNode.attributes[j].nodeValue;
							updateNode['t'] = xmlNode.attributes[j].nodeValue;
						} else if (nodeName == 'id') {
							updateNode['serverId'] = xmlNode.attributes[j].nodeValue;
						} else {
							updateNode['server_' + nodeName] = xmlNode.attributes[j].nodeValue;
						}
					}
	
					_treeObj.updateNode(updateNode, false);
				} else if (task.arg.opr == _TreeRefreshArg2.default.DELETE_NODE) {
					var _treeObj2 = $.fn.zTree.getZTreeObj("treePlugin" + this.props.xml.id);
					var deleteId = task.arg.arg;
					var deleteNode = _treeObj2.getNodeByParam("serverId", deleteId, null);
					_treeObj2.removeNode(deleteNode, false);
				} else if (task.arg.opr == _TreeRefreshArg2.default.ADD_NODE) {
					var _treeObj3 = $.fn.zTree.getZTreeObj("treePlugin" + this.props.xml.id);
					var treeAddArg = task.arg.arg;
					var parentNode = _treeObj3.getNodeByParam("serverId", treeAddArg.id, null);
	
					var doc = new DOMParser().parseFromString(treeAddArg.data, "application/xml");
					var _xmlNode = doc.childNodes[0];
					var zNode = { pId: parentNode.id };
	
					for (var _j = 0; _j < _xmlNode.attributes.length; _j++) {
						var nodeName = _xmlNode.attributes[_j].nodeName;
						if (nodeName == 'label') {
							zNode['name'] = _xmlNode.attributes[_j].nodeValue;
							zNode['t'] = _xmlNode.attributes[_j].nodeValue;
						} else if (nodeName == 'id') {
							zNode['serverId'] = _xmlNode.attributes[_j].nodeValue;
						} else {
							zNode['server_' + nodeName] = _xmlNode.attributes[_j].nodeValue;
						}
					}
					_treeObj3.addNodes(parentNode, [zNode]);
				}
			}
		}, {
			key: 'addDiyDom',
			value: function addDiyDom(treeId, treeNode) {
				var spaceWidth = 5;
				var switchObj = $("#" + treeNode.tId + "_switch"),
				    icoObj = $("#" + treeNode.tId + "_ico");
				switchObj.remove();
				icoObj.parent().before(switchObj);
				/*var spantxt = $("#" + treeNode.tId + "_span").html();
	   if ((spantxt.length*7) > $(this.treeDiv).width()) {
	       spantxt = spantxt.substring(0, 17) + "...";
	       $("#" + treeNode.tId + "_span").html(spantxt);
	   }*/
			}
		}, {
			key: 'getZNodes',
			value: function getZNodes(parentNodes, pId, expandDeep, expandNodeId, expandNodePId, nowDeep) {
				var zNodes = [];
				for (var i = 0; i < parentNodes.length; i++) {
					var parentNode = parentNodes[i];
					var zNode = {};
					/*if(pId==0)
	    	var id=i+''+1;
	    else
	    	var id=parseInt(pId+''+i);*/
					var id = pId + '_' + i;
	
					zNode['id'] = id;
					zNode['pId'] = pId;
					for (var j = 0; j < parentNode.attributes.length; j++) {
						var nodeName = parentNode.attributes[j].nodeName;
						if (nodeName == 'label') {
							zNode['name'] = parentNode.attributes[j].nodeValue;
							zNode['t'] = parentNode.attributes[j].nodeValue;
						} else if (nodeName == 'id') {
							zNode['serverId'] = parentNode.attributes[j].nodeValue;
						} else {
							zNode['server_' + nodeName] = parentNode.attributes[j].nodeValue;
						}
						if (expandNodeId && expandNodePId.startsWith(id)) {
							zNode['open'] = "true";
						} else if (expandNodeId && id.startsWith(expandNodePId) && nowDeep < nowDeep + expandDeep - 1) {
							zNode['open'] = "true";
						} else {
							if (expandNodeId) {
								zNode['open'] = "false";
							} else if (nowDeep < expandDeep) {
								zNode['open'] = "true";
							} else {
								zNode['open'] = "false";
							}
						}
					}
					zNodes.push(zNode);
					if (parentNode.childNodes.length > 0) {
						var zNode = this.getZNodes(parentNode.childNodes, id, expandDeep, expandNodeId, expandNodePId, nowDeep + 1);
						zNodes.push.apply(zNodes, zNode);
					}
				}
				pId++;
	
				return zNodes;
			}
		}, {
			key: 'getexpandNodeForOpen',
			value: function getexpandNodeForOpen(parentNodes, pId, expandDeep, expandNodeId, nowDeep) {
				var ids = "";
				for (var i = 0; i < parentNodes.length; i++) {
					var parentNode = parentNodes[i];
					var id = pId + '_' + i;
					if (expandNodeId == parentNode.id) {
						ids = ids + id;
					}
					if (parentNode.childNodes.length > 0) {
						var idz = this.getexpandNodeForOpen(parentNode.childNodes, id, expandDeep, expandNodeId, nowDeep + 1);
						ids = ids + idz;
					}
				}
				pId++;
				return ids;
			}
		}, {
			key: 'beforeItemClick',
			value: function beforeItemClick(treeId, treeNode, clickFlag) {}
		}, {
			key: 'onKeyChange',
			value: function onKeyChange(treeNode) {
				if (!treeNode) return;
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				var tasks = [commandTask];
				var arg = {};
				this.selectedItem = treeNode;
				arg["methodName"] = "pluginTreeNodeChange_" + this.props.xml.name;
				arg["methodArg"] = treeNode.serverId; //treeNode.id;
				if (arg["methodArg"] == null) arg["methodArg"] = treeNode.name;
				commandTask.arg = arg;
				_CommandResolver2.default.resolve(tasks, this.props.control.module);
			}
		}, {
			key: 'onItemClick',
			value: function onItemClick(event, treeId, treeNode, clickFlag) {
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				var tasks = [commandTask];
				var arg = {};
				if (this.selectedItem == treeNode) {
					return;
				}
				this.selectedItem = treeNode;
				arg["methodName"] = "pluginTreeNodeChange_" + this.props.xml.name;
				arg["methodArg"] = treeNode.serverId; //treeNode.id;
				if (arg["methodArg"] == null) arg["methodArg"] = treeNode.name;
				commandTask.arg = arg;
				_CommandResolver2.default.resolve(tasks, this.props.control.module);
			}
		}, {
			key: 'onItemDblClick',
			value: function onItemDblClick(event, treeId, treeNode) {
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				var tasks = [commandTask];
				var arg = {};
				arg["methodName"] = "pluginTreeNodeDoubleClick_" + this.props.xml.name;
				arg["methodArg"] = treeNode.serverId; //treeNode.id;
				if (!arg["methodArg"]) arg["methodArg"] = treeNode.name;
				commandTask.arg = arg;
				_CommandResolver2.default.resolve(tasks, this.props.control.module);
			}
		}, {
			key: 'onItemRightClick',
			value: function onItemRightClick(event, treeId, treeNode) {
				// <ul class="contextMenuPlugin" style="display: block; z-index: 1000001; left: 118px; top: 50px;">
				// 	<div class="gutterLine"></div>
				// 	<li><a href="#"><span>增加</span></a></li>
				// 	<li><a href="#"><span>删除</span></a></li>
				// 	<li><a href="#"><span>label111</span></a></li>
				// 	<li class="divider"></li>
				// 	<li style="display: none;"><a href="#"><span>复制</span></a></li>
				// 	<li><a href="#"><span>粘贴</span></a></li>
				// </ul>
	
				var treeObj = $.fn.zTree.getZTreeObj("treePlugin" + this.props.xml.id);
				var treeNode = treeObj.getSelectedNodes()[0];
				var rMenuUl = $('<ul></ul>').addClass('contextMenuPlugin').attr('id', 'rMenu');
				var rMenuLine = $('<div></div>').addClass('gutterLine');
				var that = this;
				rMenuUl.append(rMenuLine);
				if (treeNode) {
					if (treeNode.server_add) {
						var rMenuSpan = $('<span></span>').html('增加');
						var rMenuA = $('<a></a>').click(function () {
							that.treeNodeAdd(that, event, treeId, treeNode);
							rMenuUl.remove();
						}).append(rMenuSpan);
						var rMenuli = $('<li></li>').append(rMenuA);
						rMenuUl.append(rMenuli);
					}
					if (treeNode.server_delete) {
						var rMenuSpan = $('<span></span>').html('删除');
						var rMenuA = $('<a></a>').click(function () {
							that.treeNodeDelete(that, event, treeId, treeNode);
							rMenuUl.remove();
						}).append(rMenuSpan);
						var rMenuli = $('<li></li>').append(rMenuA);
						rMenuUl.append(rMenuli);
					}
	
					for (var i in treeNode) {
						if (i.indexOf('server_menu_') > -1 && i != 'server_add' && i != 'server_delete') {
							var functionName = i.substring(12);
							var rMenuSpan = $('<span></span>').html(treeNode[i]);
							var rMenuA = $('<a></a>').click(function () {
								that.treeNodeOthor(event, treeId, treeNode, functionName);
								rMenuUl.remove();
							}).append(rMenuSpan);
							var rMenuli = $('<li></li>').append(rMenuA);
							rMenuUl.append(rMenuli);
						}
					}
					var x = event.clientX + document.body.scrollLeft;
					var y = event.clientY + document.body.scrollTop;
					rMenuUl.css({ 'position': 'absolute', 'top': y + 'px', 'left': x + 'px', 'display': 'block' });
					if (rMenuUl.children().length > 1) {
						$('body').append(rMenuUl);
						$(document).on("mousedown", function (e) {
							if (rMenuUl.length > 0) {
								if (!rMenuUl.is(e.target) && !rMenuUl.is(e.target.parentNode) && !rMenuUl.is(e.target.parentNode.parentNode) && !rMenuUl.is(e.target.parentNode.parentNode.parentNode)) {
									$(document).off("mousedown");
									rMenuUl.remove();
								}
							}
						});
					}
				}
			}
		}, {
			key: 'treeNodeAdd',
			value: function treeNodeAdd(event, treeId, treeNode) {
				console.log('Add');
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				var tasks = [commandTask];
				var arg = {};
				arg["methodName"] = "pluginTreeNodeAdd_" + this.props.xml.name;
				arg["methodArg"] = treeNode.serverId; //treeNode.id;
				if (!arg["methodArg"]) arg["methodArg"] = treeNode.name;
				commandTask.arg = arg;
				_CommandResolver2.default.resolve(tasks, this.props.control.module);
			}
		}, {
			key: 'treeNodeDelete',
			value: function treeNodeDelete(event, treeId, treeNode) {
				console.log('Delete');
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				var tasks = [commandTask];
				var arg = {};
				arg["methodName"] = "pluginTreeNodeDelete_" + this.props.xml.name;
				arg["methodArg"] = treeNode.serverId; //treeNode.id;
				if (!arg["methodArg"]) arg["methodArg"] = treeNode.name;
				commandTask.arg = arg;
				_CommandResolver2.default.resolve(tasks, this.props.control.module);
			}
		}, {
			key: 'treeNodeOthor',
			value: function treeNodeOthor(event, treeId, treeNode, functionName) {
				console.log('Change');
				var commandTask = new _CommandTask2.default();
				commandTask.cmd = _Cmd2.default.FormCmd;
				var tasks = [commandTask];
				var arg = {};
				arg["methodName"] = "pluginTreeNodeMenu_" + functionName + "_" + this.props.xml.name;
				arg["methodArg"] = treeNode.serverId; //treeNode.id;
				if (!arg["methodArg"]) arg["methodArg"] = treeNode.name;
				commandTask.arg = arg;
				_CommandResolver2.default.resolve(tasks, this.props.control.module);
			}
		}, {
			key: 'onMapEditorsHandler',
			value: function onMapEditorsHandler(selector, mapEditorValues, moduleInstanceId) {
				if (this.props.moduleInstanceId != moduleInstanceId) return;
				if (selector != "all" && this.props.xml.name != selector) return;
				if (this.selectedItem && this.selectedItem.serverId) mapEditorValues[this.props.xml.name] = this.selectedItem.serverId + ""; //this.getSelectedMap();
				return;
			}
		}, {
			key: 'getSelectedMap',
			value: function getSelectedMap() {
				var result = { 0: "java.util.Map" };
				for (var key in this.selectedItem) {
					if (key == "name") result["label"] = this.selectedItem[key];else if (key == "serverId") result["id"] = this.selectedItem[key];else if (key && key.indexOf("server_") == 0) {
						var key2 = key.substr(7);
						result[key2] = this.selectedItem[key];
					}
				}
				return result;
			}
		}, {
			key: 'pluginTreeOnFocusHandler',
			value: function pluginTreeOnFocusHandler(e) {
				//$(this.pluginTreeContainer).css("border","solid 1px red");
			}
		}, {
			key: 'pluginTreeOnBlurHandler',
			value: function pluginTreeOnBlurHandler(e) {
				//$(this.pluginTreeContainer).css("border","none");
			}
		}, {
			key: 'onContainerKeyDown',
			value: function onContainerKeyDown(e) {
				if (9 === e.keyCode) {
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
					return;
				}
				if (40 === e.keyCode || 39 === e.keyCode) //向下或向右箭头
					{
						/*var treeObj = $.fn.zTree.getZTreeObj(("treePlugin"+this.props.xml.id));
	     var selectedNodes = treeObj.getSelectedNodes();
	     if ( selectedNodes && selectedNodes.length )
	     {
	     	treeObj.selectNode( selectedNodes[0] );
	     	$("#" + selectedNodes[0].tId ).focus();
	     }
	     else
	     {
	     	//触发Home
	     	$(this.pluginTreeContainer).trigger({ type : 'keydown', which : 36, keyCode: 36 });
	     }*/
						return;
						var treeObj = $.fn.zTree.getZTreeObj("treePlugin" + this.props.xml.id);
						var nodes = treeObj.getSelectedNodes();
						if (nodes.length == 0) {
							var allNodes = treeObj.getNodes();
							var node = allNodes[0];
							treeObj.selectNode(node);
						} else {}
						/*else
	     {
	     	var allNodes = treeObj.getNodes();
	     	var platArray = treeObj.transformToArray(allNodes);
	     	var index = platArray.indexOf(nodes[nodes.length-1]);
	     	var newIndex = index+1;
	     	if(newIndex < 0)
	     		newIndex = nodes.length-1;
	     	if(newIndex == nodes.length)
	     		newIndex = 0;
	     	var newNode = platArray[newIndex];
	     	treeObj.selectNode(newNode);
	     }*/
					}
				if (38 === e.keyCode) //向上箭头
					{}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle); //_style.overflow = "auto";
				if (!_style) _style = {};
				if (_style.width && _style.width.indexOf && _style.width.indexOf("px") != -1) _style.flexShrink = 0;
				_style.overflow = "auto";
				_style.minWidth = '100px';
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				return _react2.default.createElement(
					'div',
					{ onKeyDown: this.onContainerKeyDown.bind(this), tabIndex: '0', ref: function ref(node) {
							return _this2.pluginTreeContainer = node;
						}, onFocus: this.pluginTreeOnFocusHandler.bind(this), onBlur: this.pluginTreeOnBlurHandler.bind(this), className: 'formItemPluginTree', style: _style },
					_react2.default.createElement('ul', { style: { width: '100%', height: '100%', overflow: 'auto' }, id: "treePlugin" + this.props.xml.id, ref: function ref(node) {
							return _this2.treeDiv = node;
						}, className: 'ztree' })
				);
			}
		}]);
	
		return FormItemPluginTree;
	}(_GongqiFormItem3.default);
	
	exports.default = FormItemPluginTree;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _ToolBarPrintStore = __webpack_require__(100);
	
	var _ToolBarPrintStore2 = _interopRequireDefault(_ToolBarPrintStore);
	
	var _FocusStore = __webpack_require__(28);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(82);
	
	var FormItemSubFormButton = function (_GongqiFormItem) {
		_inherits(FormItemSubFormButton, _GongqiFormItem);
	
		function FormItemSubFormButton(props) {
			_classCallCheck(this, FormItemSubFormButton);
	
			var _this = _possibleConstructorReturn(this, (FormItemSubFormButton.__proto__ || Object.getPrototypeOf(FormItemSubFormButton)).call(this, props));
	
			_this.unsubscribeTestStore = _ToolBarPrintStore2.default.listen(_this.onPrint.bind(_this));
			_this.unsubscribeFocusSetStore = _FocusStore.FocusSetStore.listen(_this.onFocusSet.bind(_this));
			_this.unsubscribeSetButtonStyleStore = _CmdTypeStore.SetButtonStyleStore.listen(_this.onSetButtonStyle.bind(_this));
			_this.unsubscribeCmdUpdateControlAllowEditStore = _CmdTypeStore.CmdUpdateControlAllowEditStore.listen(_this.onCmdUpdateControlAllowEditStore.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			_this.state.devStyles = {};
			_this.state.label = _this.props.label;
			return _this;
		}
	
		_createClass(FormItemSubFormButton, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeTestStore();
				this.unsubscribeFocusSetStore();
				this.unsubscribeSetButtonStyleStore();
				this.unsubscribeCmdUpdateControlAllowEditStore();
				this.unsubscribeCmdUpdateControlLabelStore();
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				}
			}
		}, {
			key: 'onFocusSet',
			value: function onFocusSet(formId, itemId, pre, init) {
				//alert(itemId + "  " + this.props.xml.id);
				if (this.props.formId == formId && this.props.xml.id == itemId) {
					$(this.btn).focus();
					//$(this.inputField).select();
				}
			}
		}, {
			key: 'onSetButtonStyle',
			value: function onSetButtonStyle(formId, name, buttonStyle) {
				if (this.props.xml.name == name && this.props.formId == formId) {
					this.setState({ devStyles: buttonStyle });
				}
			}
		}, {
			key: 'onCmdUpdateControlAllowEditStore',
			value: function onCmdUpdateControlAllowEditStore(name, _allowEdit, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
					if (!finalAllowEdit) $(this.btn).attr("disabled", true);else $(this.btn).removeAttr("disabled");
				}
			}
		}, {
			key: 'onPrint',
			value: function onPrint(_value) {
				alert(_value);
			}
	
			//当时此button在下拉框上 属于第三极IFrame
	
		}, {
			key: 'testIframeToParentAction',
			value: function testIframeToParentAction() {
				if (this.isclicking == true) {
					return;
				}
	
				this.isclicking = true;
				var _that = this;
				var _id = setTimeout(function (e) {
	
					clearTimeout(_id);
					_that.isclicking = false;
				}, 1000);
	
				if (typeof this.props.clickHandler == "function") this.props.clickHandler();
				return;
				alert(window.menuItemId + window.formId);
				return;
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					if (typeof _parentWindow.lookupReturnTest == 'function') _parentWindow.lookupReturnTest();
				}
				//window.parent.window.filterNodesBySubPage("SJLJ")
			}
		}, {
			key: 'onKeyDownHandler',
			value: function onKeyDownHandler(e) {
				if (9 === e.keyCode) {
					//alert(e.shiftKey)
					e.preventDefault();
					_FocusActions2.default.focusChange(this.props.xml, e.shiftKey);
				}
			}
		}, {
			key: 'inputFieldFocus',
			value: function inputFieldFocus() {
				window.lastFocusUI = this.btn;
				_FocusActions2.default.currentGroupSet(this.props.groupAlias, this.props.formId);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
				if (!_allowEdit) $(this.btn).attr("disabled", "disabled");else $(this.btn).removeAttr("disabled");
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				if (_style != undefined) {
					_style['margin'] = '3px';_style.position = 'relative';
				}
				if (this.state.visible == false) if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				Object.assign(_style, this.state.devStyles);
				if (this.props.iconClass) {
					return _react2.default.createElement(
						'button',
						{ id: this.props.xml.name, ref: function ref(node) {
								return _this2.btn = node;
							}, className: 'btn btn-info GongqiFormItemSubFormButton', onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
							onClick: this.testIframeToParentAction.bind(this), style: _style },
						_react2.default.createElement('i', { className: this.props.iconClass }),
						'\xA0',
						this.state.label,
						_react2.default.createElement('i', { className: "fa fa-angle-right", 'aria-hidden': 'true', style: { position: 'absolute', right: '8px' } })
					);
				} else {
					return _react2.default.createElement(
						'button',
						{ id: this.props.xml.name, ref: function ref(node) {
								return _this2.btn = node;
							}, className: 'btn btn-info GongqiFormItemSubFormButton', onKeyDown: this.onKeyDownHandler.bind(this), onFocus: this.inputFieldFocus.bind(this),
							onClick: this.testIframeToParentAction.bind(this), style: _style },
						this.state.label,
						_react2.default.createElement('i', { className: "fa fa-angle-right", 'aria-hidden': 'true', style: { position: 'absolute', right: '8px' } })
					);
				}
			}
		}]);
	
		return FormItemSubFormButton;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemSubFormButton.defaultProps = {};
	
	exports.default = FormItemSubFormButton;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTabPage = function (_FormItemContainer) {
		_inherits(FormItemTabPage, _FormItemContainer);
	
		function FormItemTabPage(props) {
			_classCallCheck(this, FormItemTabPage);
	
			return _possibleConstructorReturn(this, (FormItemTabPage.__proto__ || Object.getPrototypeOf(FormItemTabPage)).call(this, props));
		}
	
		_createClass(FormItemTabPage, [{
			key: 'getStyle',
			value: function getStyle() {
				var layout = this.props.xml.Properties.Layout.Value;
				var parentLayout = this.props.parentLayout;
				var _flexDirection = layout == "horizontal" ? "row" : "column";
				var style = {
					flexDirection: _flexDirection,
					alignItems: "flex-start",
					flex: 'none'
				};
				style["display"] = this.props.visible ? "flex" : "none";
				//chrome浏览器在某一父节点没有采用百分比的情况下 子节点设置百分比无效无效 
				//所以采用flex布局
				//style["height"] = "100%";
				style["flexGrow"] = 100;
				style["overflow"] = 'auto';
	
				/*if(this.props.heightFromTab!=undefined)
	   	style["height"] = this.props.heightFromTab+"px";
	   else
	   alert(35345435);*/
				return style;
			}
		}, {
			key: 'getPageDiv',
			value: function getPageDiv() {
				return this.pageDiv;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.pageDiv).contextPopup(this.props.contextMenuData);
			}
	
			//更新显示隐藏由Tab统一处理
	
		}, {
			key: 'onCmdUpdateControlVisible',
			value: function onCmdUpdateControlVisible(menuItemId, formId, names, isLookup) {}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var parent = this.props.xml;
				var children = parent.FormItem;
				var layout = parent.Properties.Layout.Value;
				var _className = "tab-pane"; //this.props.visible?"tab-pane":"tab-pane active";
				var that = this;
				var list = children.map(function (item) {
					return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
				});
	
				var _style = this.getStyle();
				//_style.display = this.props.visible?"flex":"none";
				return _react2.default.createElement(
					'div',
					{ 'data-index': this.props.xmlChildIndex, ref: function ref(node) {
							return _this2.pageDiv = node;
						}, className: "FormItemTabPage " + _className, id: this.props.xml.name, style: _style },
					list
				);
			}
		}]);
	
		return FormItemTabPage;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemTabPage.defaultProps = {};
	
	exports.default = FormItemTabPage;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTable = function (_FormItemContainer) {
	  _inherits(FormItemTable, _FormItemContainer);
	
	  function FormItemTable(props) {
	    _classCallCheck(this, FormItemTable);
	
	    return _possibleConstructorReturn(this, (FormItemTable.__proto__ || Object.getPrototypeOf(FormItemTable)).call(this, props));
	  }
	
	  _createClass(FormItemTable, [{
	    key: 'render',
	    value: function render() {
	      var parent = this.props.xml;
	      var children = parent.FormItem;
	      var that = this;
	      var _style = Object.assign({}, this.props.customStyle);
	      var list = children.map(function (item) {
	        return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
	      });
	      return _react2.default.createElement(
	        'table',
	        { style: _style },
	        list
	      );
	    }
	  }]);
	
	  return FormItemTable;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemTable.defaultProps = {};
	
	exports.default = FormItemTable;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTableCell = function (_FormItemContainer) {
	  _inherits(FormItemTableCell, _FormItemContainer);
	
	  function FormItemTableCell(props) {
	    _classCallCheck(this, FormItemTableCell);
	
	    var _this = _possibleConstructorReturn(this, (FormItemTableCell.__proto__ || Object.getPrototypeOf(FormItemTableCell)).call(this, props));
	
	    _this.state.borderLeft = _this.props.borderLeft;_this.state.borderRight = _this.props.borderRight;
	    _this.state.borderTop = _this.props.borderTop;_this.state.borderBottom = _this.props.borderBottom;
	    _this.state.colspan = _this.props.colspan;
	    _this.state.rowspan = _this.props.rowspan;
	    _this.state.horizontalAlignment = _this.props.horizontalAlignment;
	    return _this;
	  }
	
	  _createClass(FormItemTableCell, [{
	    key: 'render',
	    value: function render() {
	      var parent = this.props.xml;
	      var children = parent.FormItem;
	      var that = this;
	      var _style = Object.assign({}, this.props.customStyle);
	      var list = children.map(function (item) {
	        return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
	      });
	      _style.borderLeft = this.state.borderLeft;_style.borderRight = this.state.borderRight;
	      _style.borderTop = this.state.borderTop;_style.borderBottom = this.state.borderBottom;
	      return _react2.default.createElement(
	        'td',
	        { style: _style, rowSpan: this.state.rowspan, colSpan: this.state.colspan },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', height: '100%', justifyContent: 'center', alignItems: this.state.horizontalAlignment } },
	          list
	        )
	      );
	    }
	  }]);
	
	  return FormItemTableCell;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemTableCell.defaultProps = {};
	
	exports.default = FormItemTableCell;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainer2 = __webpack_require__(36);
	
	var _FormItemContainer3 = _interopRequireDefault(_FormItemContainer2);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTableCell = function (_FormItemContainer) {
	  _inherits(FormItemTableCell, _FormItemContainer);
	
	  function FormItemTableCell(props) {
	    _classCallCheck(this, FormItemTableCell);
	
	    return _possibleConstructorReturn(this, (FormItemTableCell.__proto__ || Object.getPrototypeOf(FormItemTableCell)).call(this, props));
	  }
	
	  _createClass(FormItemTableCell, [{
	    key: 'render',
	    value: function render() {
	      var parent = this.props.xml;
	      var children = parent.FormItem;
	      var that = this;
	      var _style = Object.assign({}, this.props.customStyle);
	      var list = children.map(function (item) {
	        return _FormItemUtil2.default.getFormItemInstance(that.props.menuItemId, that.props.formId, item, parent, that.props.forLookup);
	      });
	      return _react2.default.createElement(
	        'tr',
	        { style: _style },
	        list
	      );
	    }
	  }]);
	
	  return FormItemTableCell;
	}(_FormItemContainer3.default);
	
	;
	
	FormItemTableCell.defaultProps = {};
	
	exports.default = FormItemTableCell;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _GongqiFormItem2 = __webpack_require__(24);
	
	var _GongqiFormItem3 = _interopRequireDefault(_GongqiFormItem2);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _ToolBarPrintStore = __webpack_require__(100);
	
	var _ToolBarPrintStore2 = _interopRequireDefault(_ToolBarPrintStore);
	
	var _FocusStore = __webpack_require__(28);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemText = function (_GongqiFormItem) {
		_inherits(FormItemText, _GongqiFormItem);
	
		function FormItemText(props) {
			_classCallCheck(this, FormItemText);
	
			var _this = _possibleConstructorReturn(this, (FormItemText.__proto__ || Object.getPrototypeOf(FormItemText)).call(this, props));
	
			_this.unsubscribeSetTextStyleStore = _CmdTypeStore.SetTextStyleStore.listen(_this.onSetTextStyle.bind(_this));
			_this.unsubscribeCmdUpdateControlLabelStore = _CmdTypeStore.CmdUpdateControlLabelStore.listen(_this.onCmdUpdateControlLabel.bind(_this));
			_this.unsubscribeCmdWriteControlStore = _CmdTypeStore.CmdWriteControlStore.listen(_this.onCmdWriteControlStore.bind(_this));
			var _label = _this.props.initEditorValue ? _this.props.initEditorValue : _this.props.label;
			_this.state = Object.assign(_this.state, {
				displayLength: _this.props.displayLength,
				displayHeight: _this.props.displayHeight,
				alignMent: _this.props.alignMent,
				alignBase: _this.props.alignBase,
				label: _label
			});
	
			var textStyles = _this.getTextStyles();
			if (textStyles) _this.state.devStyles = Object.assign({}, textStyles);else _this.state.devStyles = {};
	
			var displayStyle = _this.getProperty_DisplayStyle();
			if (displayStyle) _this.state.displayStyle = Object.assign({}, displayStyle);
			/*let textStyles = this.getTextStyles();
	  if(textStyles)
	  {
	  	let devStyles = {};
	  	for(let key in textStyles)
	  	{
	  		if(key != "map")
	  			devStyles[key] = textStyles[key];
	  	}
	  	this.state = Object.assign(this.state,devStyles);
	  	devStyles = {};
	  			for(let key in textStyles.map)
	  	{
	  		devStyles[key] = textStyles.map[key];
	  	}
	  	this.state.devStyles = devStyles;
	  }*/
			return _this;
		}
	
		_createClass(FormItemText, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unsubscribeSetTextStyleStore();
				this.unsubscribeCmdUpdateControlLabelStore();
			}
		}, {
			key: 'onCmdUpdateControlLabel',
			value: function onCmdUpdateControlLabel(name, _label, moduleInstanceId) {
				if (name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId) {
					this.setState({ label: _label });
				}
			}
		}, {
			key: 'getTextStyles',
			value: function getTextStyles() {
				var menuItemId = this.props.menuItemId;
				var formId = this.props.formId;
				var innerId = this.props.xml.id;
				return _FormItemUtil2.default.getControlStyles(menuItemId, formId, innerId);
			}
		}, {
			key: 'getProperty_DisplayStyle',
			value: function getProperty_DisplayStyle() {
				if (this.props.xml.Properties.DisplayStyle && this.props.xml.Properties.DisplayStyle.Value) {
					return this.props.xml.Properties.DisplayStyle.Value;
				}
				return '';
			}
		}, {
			key: 'getProperty_Alignment',
			value: function getProperty_Alignment() {
				var dis = this.getProperty_DisplayStyle();
				if (dis) {
					var displayStyle = JSON.parse(dis);
	
					if (displayStyle && displayStyle.HorizontalAlignment) return displayStyle.HorizontalAlignment;
				}
				return "";
			}
		}, {
			key: 'getProperty_VAlignment',
			value: function getProperty_VAlignment() {
				var dis = this.getProperty_DisplayStyle();
				if (dis) {
					var displayStyle = JSON.parse(dis);
					if (displayStyle && displayStyle.VerticalAlignment) return displayStyle.VerticalAlignment;
				}
				return "";
			}
		}, {
			key: 'getProperty_CSSStyle_Display',
			value: function getProperty_CSSStyle_Display() {
				var dis = this.getProperty_DisplayStyle();
				if (dis) {
					var displayStyle = JSON.parse(dis);
					if (displayStyle && displayStyle.cssStyle) return displayStyle.cssStyle;
				}
				return "";
			}
		}, {
			key: 'onSetTextStyle',
			value: function onSetTextStyle(formId, name) {
				if (this.props.xml.name == name && this.props.formId == formId) {
					var textStyles = this.getTextStyles();
					if (textStyles) this.setState({ devStyles: textStyles });
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				//$(this.textField).html(this.state.label);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//$(this.textField).html(this.state.label);	
			}
		}, {
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId) {
				if (arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId) {
					var value = arg[this.props.xml.name];
					this.setState({ label: value });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _style = Object.assign({}, this.props.customStyle);
				var displayLength = this.state.displayLength;
				var cssStyle = this.getProperty_CSSStyle_Display();
				var VerticalAlignment = this.getProperty_VAlignment();
				var HorizontalAlignment = this.getProperty_Alignment();
				if (!_style) _style = {};
	
				if (!_style.width) {
					var _width = displayLength * _FormItemConst2.default.displayLength_CH + 'px';
					_style.width = _width;
				}
	
				if (this.state.visible == false) {
					if (this.state.hideInVisible == true) _style.display = "none";else _style.visibility = "hidden";
				}
	
				if (this.state.color && this.state.color != -1) _style.color = this.state.color;
				if (this.state.backgroundColor && this.state.backgroundColor != -1) _style.backgroundColor = this.state.backgroundColor;
				if (this.state.fontSize && this.state.fontSize != -1) _style.fontSize = this.state.fontSize;
				if (this.state.fontFamily) _style.fontFamily = this.state.fontFamily;
				if (this.state.fontWeight) _style.fontWeight = this.state.fontWeight;
				//displayStyle 属性设置
				if (cssStyle.fontFamily) _style.fontFamily = cssStyle.fontFamily;
				if (cssStyle.color) _style.color = cssStyle.color;
				if (cssStyle.fontSize) _style.fontSize = cssStyle.fontSize + "px";
				if (cssStyle.fontStyle) _style.fontStyle = cssStyle.fontStyle;
				if (cssStyle.fontWeight) _style.fontWeight = cssStyle.fontWeight;
				if (VerticalAlignment) {
					_style.display = "flex";_style.alignItems = VerticalAlignment;
				}
				if (HorizontalAlignment) {
					_style.display = "flex";_style.justifyContent = HorizontalAlignment;
				}
	
				if (this.state.devStyles) Object.assign(_style, this.state.devStyles);
				return _react2.default.createElement('div', { className: "GongqiFormItemText", id: this.props.xml.name, ref: function ref(node) {
						return _this2.textField = node;
					}, style: _style, dangerouslySetInnerHTML: { __html: this.state.label } });
			}
		}]);
	
		return FormItemText;
	}(_GongqiFormItem3.default);
	
	;
	
	FormItemText.defaultProps = {};
	
	exports.default = FormItemText;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemBooleanEditor = __webpack_require__(120);
	
	var _FormItemBooleanEditor2 = _interopRequireDefault(_FormItemBooleanEditor);
	
	var _FormItemBooleanRender = __webpack_require__(137);
	
	var _FormItemBooleanRender2 = _interopRequireDefault(_FormItemBooleanRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	var _CommandStore = __webpack_require__(18);
	
	var _LayerManager = __webpack_require__(51);
	
	var _LayerManager2 = _interopRequireDefault(_LayerManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemBooleanEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemBooleanEditorControl, _FormItemEditorContro);
	
		function FormItemBooleanEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemBooleanEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemBooleanEditorControl.__proto__ || Object.getPrototypeOf(FormItemBooleanEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemBooleanEditorControl";
			_this.unsubscribeGetSelectRecordsKeyStore = _CommandStore.GetSelectRecordsKeyStore.listen(_this.onGetSelectRecordsKey.bind(_this));
			return _this;
		}
	
		_createClass(FormItemBooleanEditorControl, [{
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 6;
			}
		}, {
			key: 'getDefaultValue',
			value: function getDefaultValue() {
				var dvalue = _get(FormItemBooleanEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemBooleanEditorControl.prototype), 'getDefaultValue', this).call(this);
				if (dvalue == "") dvalue = "false";
				return dvalue;
			}
		}, {
			key: 'onGetSelectRecordsKey',
			value: function onGetSelectRecordsKey(keys, groupAlias, menuItemId, formId, moduleInstanceId) {
				if (this.isDataMethodSelectRecords && this.group && this.group.groupAlias == groupAlias && this.menuItemId == menuItemId && this.formId == formId && this.module.instanceUUId == moduleInstanceId) {
					keys.push(this.getDataField());
				}
			}
		}, {
			key: 'getAfterRecordConditionTask_AllowEditor',
			value: function getAfterRecordConditionTask_AllowEditor(_record, afterRecordConditionTask) {
				if (!this.group) return;
				if (this.group.analysisConditionSingleRecord(_record, afterRecordConditionTask)) {
					var trueResult = afterRecordConditionTask.trueCommandResult.tasks.concat();
					for (var i in trueResult) {
						var task = trueResult[i];
						if (task.cmd == "updateControlAllowEdit" && ("ctrl_" + task.control == this.controlId || this.dataSource_Field == task.control)) {
							return task.arg;
						}
					}
				} else {
					var falseResult = afterRecordConditionTask.falseCommandResult.tasks.concat();
					for (var _i in falseResult) {
						var _task = falseResult[_i];
						if (_task.cmd == "updateControlAllowEdit" && ("ctrl_" + _task.control == this.controlId || this.dataSource_Field == _task.control)) {
							return _task.arg;
						}
					}
				}
			}
		}, {
			key: 'getProperty_AllowEdit_Final',
			value: function getProperty_AllowEdit_Final(_record) {
				var afterRecordConditionTask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				/*Q21096256if(this.group && _record && _record!=this.group.currentRecord)
	   	return false;*/
				var dataMethod = this.getProperty_DataMethod();
				if (dataMethod && dataMethod.charAt(0) == "#") return false;
				if (this.forLookup && this.group) return false;
	
				if (this.forLookup) return true;
				if (this.group && this.group.mainSource.isAggreateTable == true) return false;
	
				if (this.group && afterRecordConditionTask && (afterRecordConditionTask.trueCommandResult || afterRecordConditionTask.falseCommandResult)) {
					var taskAllEditor = this.getAfterRecordConditionTask_AllowEditor(_record, afterRecordConditionTask);
					if (taskAllEditor == true) {
						return true;
					}
					if (taskAllEditor == false) {
						return false;
					}
				}
	
				if (this._cmdEditFalse == true) return false;
				if (this._cmdConditionTaskEditFalse == true) return false;
	
				if (this.dataSource_Field) {
					var externalArgs = [_record];
					if (this.group && this.group.linkGroup) externalArgs.push(this.group.linkGroup.currentRecord);
					var allowEdit = _LayerManager2.default.executeLayerMethod(this.module, this.group, "recordAllowEdit_" + this.dataSource_Field, externalArgs);
					if (typeof allowEdit != "undefined" && allowEdit == false) return false;
				}
	
				if (this.getProperty_AllowEdit_CurrentRecordLocked(_record) == true) return false;
	
				var result = this.getProperty_AllowEdit_UserSetFinal();
				if (!result) return false;
				result = this.getProperty_AuFinal("edit");
				if (result) {
					result = this.getProperty_AllowEdit_GOTFinal(_record);
				}
				if (result == false) {
					var a = "aaa";
				}
				return result;
			}
		}, {
			key: 'getProperty_AllowEdit_CurrentRecordLocked',
			value: function getProperty_AllowEdit_CurrentRecordLocked(_record) {
				if (this.isDataMethodField) return false;
				if (this.group && this.group.ds_AllowEdit == false) return true;
				if (this.group && this.group.isCurrentRecordLocked(_record)) return true;
				return false;
			}
		}, {
			key: 'getProperty_AllowEdit_GOTFinal',
			value: function getProperty_AllowEdit_GOTFinal(_record) {
				var result = this.getProperty_AllowEdit_GOT();
	
				if (result == false) {
					if (this.group) {
						var recVersion = this.group.getCurRecVersion(_record);
						if (isNaN(recVersion) == false && recVersion == -1) {
							result = this.getProperty_AllowEditOnCreate();
						}
					}
				}
				if (!result) return false;
				result = this.getProperty_AllowEdit_FieldAu();
				if (!result) return false;
				result = this.getProperty_AllowEdit_Loop();
				return result;
			}
		}, {
			key: 'setControlProperty',
			value: function setControlProperty(property, value) {
				if (property == _ControlPropertyConst2.default.DISPLAYLENGTH) {
					this.propertyDisplayLength = value;
				}
			}
		}, {
			key: 'getProperty_NotNull',
			value: function getProperty_NotNull() {
				return false;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var notNull = this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue == "true" ? true : false;
					}
				}
				this.component = _react2.default.createElement(_FormItemBooleanEditor2.default, _extends({ notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					displayLengthWidth: displayLengthWidth, key: this.xml.id,
					xml: this.xml, parentLayout: layout, forLookup: forLookup, customStyle: this.getStyle(),
					underFieldGroup: parent.type == "FieldGroup", groupAlias: this.groupAlias,
					dataField: this.getDataField(), initRecord: _initRecord, label: label,
					formId: this.formId, menuItemId: this.menuItemId, contextMenuData: this.contextMenuData,
					formType: _EditorFormType2.default.FormModule, control: this, underQueryGroup: this.isUnderQueryGroup()
				}, commonProps));
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemBooleanRender2.default, { test: 1, dataField: this.getDataField(), formType: _EditorFormType2.default.FormModule,
					control: this, groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId });
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var big = false;
				var displayHeight = this.getProperty_DisplayHeight();
				if (displayHeight > 1) {
					big = true;
				} else {
					var height = this.getProperty_Height();
					if (height > 40) big = true;
				}
				return _react2.default.createElement(_FormItemBooleanRender2.default, { big: big, group: this.group, groupAlias: this.groupAlias, contextMenuData: this.contextMenuData, dataField: this.getDataField(), forLookup: forLookup, menuItemId: this.menuItemId, formId: this.formId, colXml: this.xml,
					control: this, gridXml: this.parentXML, isSelectedRecords: this.isDataMethodSelectRecords, moduleInstanceId: this.module.instanceUUId });
			}
		}]);
	
		return FormItemBooleanEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemBooleanEditorControl;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemButtonBaseControl = __webpack_require__(73);
	
	var _FormItemButtonBaseControl2 = _interopRequireDefault(_FormItemButtonBaseControl);
	
	var _FormItemButton = __webpack_require__(92);
	
	var _FormItemButton2 = _interopRequireDefault(_FormItemButton);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _LayerManager = __webpack_require__(51);
	
	var _LayerManager2 = _interopRequireDefault(_LayerManager);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _CommandStore = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemButtonControl = function (_FormItemButtonBaseCo) {
		_inherits(FormItemButtonControl, _FormItemButtonBaseCo);
	
		function FormItemButtonControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemButtonControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemButtonControl.__proto__ || Object.getPrototypeOf(FormItemButtonControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemButtonControl";
			_this.module = module;
			if (!_this.forLookup) {
				_this.unsubscribeCmdButtonOk = _CmdTypeStore.CmdButtonOk.listen(_this.onButtonOk.bind(_this));
	
				if (_this.isUnderButtonMenu()) {
					_this.unsubscribeButtonShortCutStore = _CommandStore.ButtonShortCutStore.listen(_this.onShortCut.bind(_this));
				}
			}
			return _this;
		}
	
		_createClass(FormItemButtonControl, [{
			key: 'isUnderButtonMenu',
			value: function isUnderButtonMenu() {
				if (this.parentXML) {
					if (this.parentXML.type == "ButtonMenu") return true;
				}
				return false;
			}
		}, {
			key: 'onShortCut',
			value: function onShortCut(keyCodeStr) {
				var shortCut = this.getProperty_ShortCut();
				if (shortCut == keyCodeStr) {
					this.beforeOK({ target: this.jqueryComponent }, true);
				}
			}
		}, {
			key: 'onButtonOk',
			value: function onButtonOk(arg) {
				if (arg && arg.hasOwnProperty(this.xml.name)) {
					this.initButtonOkCmd = arg;
				}
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var _style = {};
				var layout = this.parentXML.Properties.Layout.Value;
				var parentType = this.parentXML.type;
				if (parentType == "ButtonGroup" && layout == "vertical") {
					_style["alignSelf"] = 'stretch';
				}
				//宽度高度的设置 其余都是在component中
				_style["padding"] = "1px 6px";
	
				var _width = this.xml.Properties.Width.Value;
				var _height = this.xml.Properties.Height.Value;
	
				if (_width) _style["width"] = _width + "px";
				if (_height) _style["height"] = _height + "px";
	
				return _style;
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
				_CmdTypeActions2.default.updateControlAllowEdit(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'getJqueryItemUnderButtonMenu',
			value: function getJqueryItemUnderButtonMenu() {
				var $li = $("<li>");
				var $a = $("<a>").html(this.getProperty_Label()).click(this.beforeOK.bind(this));
				var allowEdit = this.getProperty_AllowEdit_Final();
				var visible = this.getProperty_Visible_Final();
				if (!allowEdit) $li.addClass("disabled").css({ opacity: 0.5 });
				if (!visible) $li.css("display", "none");
				$li.attr("componentName", this.xml.name);
				$li.attr("controlId", this.controlId);
				this.jqueryComponent = $a;
				return $li.append($a);
			}
		}, {
			key: 'clickHandler',
			value: function clickHandler(e) {
				//alert(this.getProperty_Label());
				document.execCommand("SaveAs");
			}
		}, {
			key: 'getProperty_QueryType',
			value: function getProperty_QueryType() {
				if (this.properties.hasOwnProperty("QueryType")) return this.properties.QueryType;
				return this.properties.ButtonType;
			}
		}, {
			key: 'getProperty_MultiSelect',
			value: function getProperty_MultiSelect() {
				return this.properties.MultiSelect;
			}
		}, {
			key: 'getProperty_SaveRecord',
			value: function getProperty_SaveRecord() {
				if (this.properties.hasOwnProperty("SaveRecord")) return this.properties.SaveRecord;
				return this.properties.AutoSaveRecord;
			}
		}, {
			key: 'getProperty_DisplayStyle',
			value: function getProperty_DisplayStyle() {
				var _displayStyle = this.properties.DisplayStyle;
				try {
					_displayStyle = JSON.parse(_displayStyle);
				} catch (e) {
					_displayStyle = {};
				}
				return _displayStyle;
			}
		}, {
			key: 'checkQuery',
			value: function checkQuery() {
				if (!this.group) return null;
				var queryType = this.getProperty_QueryType();
				if (queryType == _FormItemConst2.default.BUTTON_PROPERTY_QUERYTYPE_SUBMIT_VALUE || queryType == _FormItemConst2.default.BUTTON_PROPERTY_QUERYTYPE_RESET_VALUE) {
					var parent = this.parentControl;
					while (parent && parent.classAlias && parent.classAlias != "FormItemDesignControl") {
						if (parent.classAlias == "FormItemGroupControl" && parent.getProperty_GroupType() == "Query") {
							return parent;
						}
						parent = parent.parentControl;
					}
				}
				// if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_DATASETRESET_VALUE){
				// 	this.group.reSetDataSetQuery(null,this.group.dataSetQueryTable);
				// 	QueryUtil.reverseOrderBy(this.group.dataSetQueryTable.queryOrderBy);
				// 	this.group.executeQueryAutoSaveStop(null,null,false,true);
				// }
				// if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_DATASETEXPORT_VALUE){
	
				// }
				return null;
			}
		}, {
			key: 'findNoGroupEditor',
			value: function findNoGroupEditor(node, source, sources, vector) {
				if (node.childrenControl) {
					for (var i = 0; i < node.childrenControl.length; i++) {
						var child = node.childrenControl[i];
						if (child.classAlias && child.classAlias.indexOf("Editor") != -1 && !child.group && child.getProperty_QuerySource() && child.getProperty_QuerySource() != "") {
							var cdsn = child.getProperty_QuerySource();
							var editords = sources[cdsn];
							var qf = child.getProperty_QueryField();
							if (editords && editords.group == source.group && qf != "" && qf) {
								vector.push(child);
							}
						} else {
							this.findNoGroupEditor(child, source, sources, vector);
						}
					}
				}
			}
	
			//TODO 毫无意义
	
		}, {
			key: 'checkMutiSelect',
			value: function checkMutiSelect() {
				return true;
				/*if(this.getProperty_MultiSelect() == false)
	   {
	   	for each(var grid:FormItem_DataGrid in this.formDesign.grids)
	   	{
	   		if(grid.group == this.group)
	   		{
	   			var gridc:OrigDataGrid = grid.grid;
	   			if(gridc != null && gridc.selectedItems.length>1)
	   			{
	   				FadeAlert.show("当前按钮不支持记录多选后的操作");
	   				return false;
	   			}
	   		}
	   	}
	   	
	   }
	   
	   return true;*/
			}
		}, {
			key: 'saveRecord',
			value: function saveRecord() {
				if (this.forLookup) return;
				var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
				if (currentGroup) {
					if (this.getProperty_SaveRecord()) {
						_RecordsActions2.default.RecordAutoSave(this.group);
						if (window.rowChangeAutoSaveFail == true) {
							//借用自动换行自动保存失败的标识
							window.rowChangeAutoSaveFail = false;
							return false;
						}
					}
				}
				return true;
			}
		}, {
			key: 'beforeOK',
			value: function beforeOK(event) {
				var isShortCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				//console.log("执行到了beforeOK-》"+this.xml.name);
				if (event.target) {
					if ($(event.target).hasClass("disabled") || $(event.target).parent().hasClass("disabled")) {
						if (window.tasks) {
							var tasks = window.remainTasks;
							window.remainTasks = null;
							var task = tasks.shift();
							if (task) _CommandResolver2.default.doResolveTask(task, this.module, tasks);
						}
						//console.log("执行到了209-》"+this.xml.name);
						return;
					}
				}
				if (this.forLookup) {
					return this.doOK();
				}
				if ((typeof isShortCut === 'undefined' ? 'undefined' : _typeof(isShortCut)) == "object") isShortCut = false;
				var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
	
				if (currentGroup == this.group) {
					//console.log("执行到了223-》"+this.xml.name);
					if (this.getProperty_SaveRecord() && currentGroup) {
						//console.log("执行到了226-》"+this.xml.name);
						if (this.getProperty_SaveRecord()) {
							//console.log("执行到了229-》"+this.xml.name);
							_RecordsActions2.default.RecordAutoSave(this.group.groupAlias);
							if (window.rowChangeAutoSaveFail == true) {
								//借用自动换行自动保存失败的标识
								window.rowChangeAutoSaveFail = false;
								if (window.remainTasks) {
									var _tasks = window.remainTasks;
									window.remainTasks = null;
									var _task = _tasks.shift();
									if (_task) _CommandResolver2.default.doResolveTask(_task, this.module, _tasks);
								}
								return false;
							}
							return this.doOK();
						}
					} else if (!currentGroup) {
						return this.doOK();
					} else {
						return this.doOK();
					}
				} else {
					if (currentGroup) {
						_RecordsActions2.default.RecordAutoSave(currentGroup.groupAlias);
						//if(isShortCut)
						return this.doOK();
						//else
						//{
						//	if(window.remainTasks)
						//	{
						//		let tasks = window.remainTasks;
						//		window.remainTasks = null;
						//		let task = tasks.shift();
						//		if(task)
						//			CommandResolver.doResolveTask(task,this.module,tasks);					
						//	}
						//}
					} else {
						//console.log("执行到了281-》"+this.xml.name);
						//鼠标点击切换 快捷键不切换
						if (isShortCut) return this.doOK();
	
						//if(this.groupAlias)
	
						if (this.parentControl && this.parentControl.classAlias == "FormItemButtonMenuControl") {
							return this.doOK();
						}
					}
				}
			}
		}, {
			key: 'doOK',
			value: function doOK() {
				var isShortCut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				//FocusActions.scrollToAndFocus({groupAlias:"ItemTable",toIndex:30});return;
				/*var userGroupId = "test";
	   var url="sysauthorityforIndustrialInternet/SysAuthoritySetup/SysAuthoritySetupForII.html?appId=000017&userGroupId="+userGroupId+"&userGroupName=车辆管理分组";
	   url = encodeURI(url);
	   //var iframe = $("<iframe>").css("width","100%").css("height","100%").css("border","none");
	   
	   		window.open(url);
	   //alert("dianji");
	   return;*/
				var buttonds = null;var dataSource_Alias = _GOTUtil2.default.getPropertyValue(this.xml, "DataSource");
				if (this.module.formDataSources) buttonds = this.module.formDataSources.sources[dataSource_Alias];
	
				var flag_queryButton = false;
				if (this.getProperty_QueryType() && this.getProperty_QueryType() == _FormItemConst2.default.BUTTON_PROPERTY_QUERYTYPE_DATASETEXPORT_VALUE) {
					this.group.dataSetExportBtn();
					return;
				}
				if (buttonds) {
					var fg = this.checkQuery();
					if (fg) {
						var editors = [];
	
						this.findNoGroupEditor(fg, buttonds, this.module.formDataSources.sources, editors);
	
						var queryType = this.getProperty_QueryType();
						if (queryType == _FormItemConst2.default.BUTTON_PROPERTY_QUERYTYPE_SUBMIT_VALUE) {
							var cqbak = this.group.currentQuery;
							this.group.reSetCurrentQuery();
							for (var i = 0; i < editors.length; i++) {
								var editor = editors[i];
	
								var result = {};
								_CommandActions2.default.callComponentFunc(this.formId, editor.xml.id, "getInQueryGroupNow", null, result);
								if (result.ret == false) continue;
								_CommandActions2.default.callComponentFunc(this.formId, editor.xml.id, "getFormAutoQueryValue", null, result);
								var finalev = result.ret;
								var querysource = editor.getProperty_QuerySource();
								var formdatasource = this.module.formDataSources.sources[querysource];
								if (finalev == false) {
									var array = [finalev];
								} else if (finalev == 'null') {
									var array = [null];
								} else if (finalev == "''" || finalev == "") {
									var array = [null];
								} else if (typeof finalev == 'string' && finalev.indexOf('只查空值') != -1) {
									var array = [''];
								} else {
									if (finalev == true || finalev == false || !finalev) {
										var array = [finalev];
									} else {
										var array = finalev.split("&");
									}
								}
								var _queryField = editor.getProperty_QueryField();
								for (var _i = 0; _i < array.length; _i++) {
	
									if (window.isDataSetView) {
										var itemValue = array[_i];
										_QueryUtil2.default.dataSetViewcreateWhereItemByField(_queryField.split(".")[0], _queryField, formdatasource.alias, this.group.dataSetQueryTable, itemValue);
									} else {
										var itemValue = array[_i];
										if (_queryField.indexOf(".") > 2) {
											_QueryUtil2.default.createWhereItemByField(_queryField, _queryField, formdatasource.alias, this.group.currentQuery, itemValue);
										} else {
											_QueryUtil2.default.createWhereItemByField(_queryField.split(".")[0], _queryField, formdatasource.alias, this.group.currentQuery, itemValue);
										}
									}
								}
							}
						} else if (queryType == _FormItemConst2.default.BUTTON_PROPERTY_QUERYTYPE_RESET_VALUE) {
							for (var _i2 = 0; _i2 < editors.length; _i2++) {
								var _editor = editors[_i2];
								_editor.record = "";
								var _result = {};
								// TODO_YL  重置Enum  使得Enum 显示未选中
								if (_editor.classAlias == "FormItemEnumEditorControl") {
									_CommandActions2.default.callComponentFunc(this.formId, _editor.xml.id, "setdeselectAll");
								} else if (_editor.classAlias == "FormItemBooleanEditorControl") {
									_CommandActions2.default.callComponentFunc(this.formId, _editor.xml.id, "setDisplayFieldBooleanText");
								} else {
									// CommandActions.callComponentFunc(this.formId,editor.xml.id,"setDisplayFieldText",['-点此填值-']);
									_CommandActions2.default.callComponentFunc(this.formId, _editor.xml.id, "setDisplayFieldDefText", ['-点此填值-']);
									// CommandActions.callComponentFunc(this.formId,editor.xml.id,"setDisplayFieldText",[editor.getDefaultValue()]);
								}
								_CommandActions2.default.callComponentFunc(this.formId, _editor.xml.id, "setQueryGroupEnable");
							}
							this.group.reSetCurrentQuery();
						}
	
						//formDesign.formModule.executeQuery(group,group.currentQuery);
						//return;
						flag_queryButton = true;
					}
				}
	
				if (flag_queryButton == false) {
					if (this.checkMutiSelect() == false) return;
				}
	
				var formId = this.module.formId;
				var btnName = this.xml.name;
	
				_FocusActions2.default.currentGroupSet(this.groupAlias, this.module.formId);
	
				_LayerManager2.default.executeLayerMethod(this.module, this.group, "buttonOK_" + btnName);
	
				var cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo("buttonOK_" + btnName, this.forLookup ? "FormLookup" : window.menuItemId, formId);
				if (cmdargInfo != null) {
					var _group = this.group;
					if (!_group) {
						var _fds = this.module.formDataSources;
						if (_fds != null) {
							_group = _fds.currentGroup; //_fds.firstGroup;
							if (!_group) _group = _fds.firstGroup;
						}
					}
	
					if (cmdargInfo.prefetch == true) {
						var tasks = cmdargInfo.commandResult.tasks;
						if (window.remainTasks) {
							tasks = window.remainTasks;
							window.remainTasks = null;
							if (cmdargInfo.commandResult.tasks) {
								var newTasks = cmdargInfo.commandResult.tasks.reverse();
								for (var _i3 = 0; _i3 < newTasks.length; _i3++) {
									tasks.unshift(newTasks[_i3]);
								}
							}
						}
						_CommandResolver2.default.resolve(tasks, this.module, _group);
					} else {
	
						var arg = _CommandResolver2.default.getSendCmd(this.module, !_group ? null : _group.groupAlias, cmdargInfo);
	
						if (window.lastFocusDataGrid) {
							if (window.lastFocusDataGrid.lastSelected) {
								var idx = window.lastFocusDataGrid.lastSelected.idx - 1;
								if (idx < 0) idx = 0;
								var column = window.lastFocusDataGrid._columns[idx];
								if (column) {
									var _argObject = { remoteClass: "java.util.Map" };
									_argObject["dataField"] = column.key;
									_argObject["formItemName"] = column.xmlName;
									_argObject["lastDataSource"] = window.lastFocusDataGrid.props.groupAlias;
									arg.argObject = _argObject;
								}
							} else {
								var _argObject2 = { remoteClass: "java.util.Map" };
								_argObject2["lastDataSource"] = window.lastFocusDataGrid.props.groupAlias;
								arg.argObject = _argObject2;
							}
						}
	
						var command = _CommandHelper2.default.createFormInstance(this.module.formName, "doButtonOK", "CommandResult").appendArg(btnName, "String").appendArg(arg, "CommandArg");
						var remoteArg = { command: command, resultFunction: this.rpc_result_doOK.bind(this, isShortCut), sync: false };
						return _ServiceHelper2.default.addTokenWithCommand(remoteArg);
					}
				} else {
					if (flag_queryButton == true) {
						if (!this.group) {
							_Warn2.default.show({ text: "type为Submit的Button 请指定DataSource属性用来表示查询的数据源", confirm: { isShow: false, event: '' } });
							return;
						}
						this.group.executeQuery(null, this.group.currentQuery);
					}
				}
			}
		}, {
			key: 'rpc_result_doOK',
			value: function rpc_result_doOK(isShortCut, data) {
				var result = data.result;
				var tasks;
				if (result) {
					tasks = result.tasks;
					if (window.remainTasks) {
						tasks = window.remainTasks;
						window.remainTasks = null;
						if (result.tasks) {
							var newTasks = result.tasks.reverse();
							for (var i = 0; i < newTasks.length; i++) {
								tasks.unshift(newTasks[i]);
							}
						}
					}
					_CommandResolver2.default.resolve(tasks, this.module, this.group);
				} else {
					if (window.remainTasks) {
						tasks = window.remainTasks;
						window.remainTasks = null;
						var task = tasks.shift();
						if (task) _CommandResolver2.default.doResolveTask(task, this.props.control.module, tasks);
					}
				}
	
				if (!isShortCut) {
					_FocusActions2.default.focusSet(this.formId, this.xml.id);
				}
			}
		}, {
			key: 'getProperty_CSSStyle_Display',
			value: function getProperty_CSSStyle_Display() {
				var displayStyle = this.getProperty_DisplayStyle();
	
				//displayStyle = {cssStyle:{fontFamily:"微软雅黑",fontStyle:"italic",fontWeight:"bold",fontSize:20}};
	
				if (displayStyle && displayStyle.cssStyle) return displayStyle.cssStyle;
				return "";
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				var helpText = this.getProperty_HelpText();
				this.component = _react2.default.createElement(_FormItemButton2.default, _extends({ displayStyle: this.getProperty_DisplayStyle(), key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, initButtonOkCmd: this.initButtonOkCmd,
					label: label, customStyle: this.getStyle(), menuItemId: this.menuItemId, formId: this.formId, cssStyle: this.getProperty_CSSStyle_Display(),
					control: this, iconClass: this.getProperty_Icon(), helpText: helpText }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemButtonControl;
	}(_FormItemButtonBaseControl2.default);
	
	exports.default = FormItemButtonControl;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemButtonGroup = __webpack_require__(121);
	
	var _FormItemButtonGroup2 = _interopRequireDefault(_FormItemButtonGroup);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemButtonGroupControl = function (_FormItemContainerCon) {
		_inherits(FormItemButtonGroupControl, _FormItemContainerCon);
	
		function FormItemButtonGroupControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemButtonGroupControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemButtonGroupControl.__proto__ || Object.getPrototypeOf(FormItemButtonGroupControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemButtonGroupControl";
			return _this;
		}
	
		_createClass(FormItemButtonGroupControl, [{
			key: 'getProperty_MainContentAlignment',
			value: function getProperty_MainContentAlignment() {
				return this.properties.MainContentAlignment;
			}
		}, {
			key: 'updateControlAllowEdit',
			value: function updateControlAllowEdit(arg) {
				if (arg && arg.hasOwnProperty(this.xml.name)) {
					var _arg = {};var _allowEdit = arg[this.xml.name];
					for (var i = 0; i < this.xml.FormItem.length; i++) {
						var item = this.xml.FormItem[i];
						_arg[item.name] = _allowEdit;
					}
					_CmdTypeActions2.default.updateControlAllowEdit(_arg);
				}
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var superStyle = _get(FormItemButtonGroupControl.prototype.__proto__ || Object.getPrototypeOf(FormItemButtonGroupControl.prototype), 'getStyle', this).call(this);
				if (superStyle) {
					var justifyContent = this.getProperty_MainContentAlignment();
					if (!justifyContent) justifyContent = "flex-start";
					superStyle.justifyContent = justifyContent;
				}
				return superStyle;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemButtonGroup2.default, _extends({ key: this.xml.id, xml: this.xml,
					parentLayout: layout, forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					groupAlias: this.groupAlias, customStyle: this.getStyle(),
					formId: this.formId, menuItemId: this.menuItemId, contextMenuData: this.contextMenuData,
					control: this }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemButtonGroupControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemButtonGroupControl;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemButtonBaseControl = __webpack_require__(73);
	
	var _FormItemButtonBaseControl2 = _interopRequireDefault(_FormItemButtonBaseControl);
	
	var _FormItemButtonMenu = __webpack_require__(195);
	
	var _FormItemButtonMenu2 = _interopRequireDefault(_FormItemButtonMenu);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemButtonMenuControl = function (_FormItemButtonBaseCo) {
		_inherits(FormItemButtonMenuControl, _FormItemButtonBaseCo);
	
		function FormItemButtonMenuControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemButtonMenuControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemButtonMenuControl.__proto__ || Object.getPrototypeOf(FormItemButtonMenuControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemButtonMenuControl";
			return _this;
		}
	
		_createClass(FormItemButtonMenuControl, [{
			key: 'getStyle',
			value: function getStyle() {
				var _style = {};
				var layout = this.parentXML.Properties.Layout.Value;
				var parentType = this.parentXML.type;
				if (parentType == "ButtonGroup" && layout == "vertical") {
					_style["alignSelf"] = 'stretch';
				}
	
				/*_style["padding-left"] = '3px';
	    		_style["padding-right"] = '1px';
	    		_style["margin-top"] = '3px';
	   }
	   else
	   {
	   _style["margin"] = '3px';
	   }*/
				return _style;
			}
		}, {
			key: 'getButtonMenuDropDown',
			value: function getButtonMenuDropDown() {
				var parent = this.xml;
				var children = parent.FormItem;
				var menuItemId = this.menuItemId;var formId = this.formId;var forLookup = this.forLookup;var controlId = this.controlId;
				var ul = $("<ul>").addClass("dropdown-menu").css({ display: "block", overflow: "auto" }).attr("role", "menu");
				var list = children.map(function (item) {
					var key = _FormItemUtil2.default.getFormItemControlKey(menuItemId, formId, item.id);
					var control = _FormItemUtil2.default.getFormItemControl(key, forLookup);
					var $buttonItem = control.getJqueryItemUnderButtonMenu(parent, forLookup);
					ul.append($buttonItem);
				});
	
				return ul;
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
				_CmdTypeActions2.default.updateControlAllowEdit(this.xml.name, value);
				/*if(this.childrenControl && this.childrenControl.length>0)
	   {
	   	var finalValue = this.getProperty_AllowEdit_Final();
	   	for(let i = 0;i<this.childrenControl.length;i++)
	   	{
	   		var item = this.childrenControl[i];
	   		item.doSetEnableCmd(finalValue);
	   	}
	   }*/
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemButtonMenu2.default, _extends({ key: this.xml.id, xml: this.xml, control: this,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId,
					label: label, customStyle: this.getStyle(), menuItemId: this.menuItemId, iconClass: this.getProperty_Icon(),
					formId: this.formId, dropdown: this.getButtonMenuDropDown() }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemButtonMenuControl;
	}(_FormItemButtonBaseControl2.default);
	
	exports.default = FormItemButtonMenuControl;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _FormItemDataGrid = __webpack_require__(122);
	
	var _FormItemDataGrid2 = _interopRequireDefault(_FormItemDataGrid);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	var _GongqiHeaderCell = __webpack_require__(190);
	
	var _GongqiHeaderCell2 = _interopRequireDefault(_GongqiHeaderCell);
	
	var _RecordsStore = __webpack_require__(14);
	
	var _GongqiSelectRecordsHeaderCell = __webpack_require__(250);
	
	var _GongqiSelectRecordsHeaderCell2 = _interopRequireDefault(_GongqiSelectRecordsHeaderCell);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDataGridControl = function (_GongqiFormItemContro) {
	  _inherits(FormItemDataGridControl, _GongqiFormItemContro);
	
	  function FormItemDataGridControl(menuItemId, formId, parent, xml, group, module, forLookup) {
	    _classCallCheck(this, FormItemDataGridControl);
	
	    var _this = _possibleConstructorReturn(this, (FormItemDataGridControl.__proto__ || Object.getPrototypeOf(FormItemDataGridControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
	    _this.classAlias = "FormItemDataGridControl";
	    _this.module = module;
	    _this.rowHeight = undefined;
	    if (_this.groupAlias == "") {
	      var columnsFormItem = _this.xml.FormItem;
	      if (columnsFormItem.length == 0) return _possibleConstructorReturn(_this);
	      var i = 0;
	      var columnFormItem = columnsFormItem[i];
	      while (i < columnsFormItem.length && columnFormItem.Properties.DataSource.Value == "") {
	        columnFormItem = columnsFormItem[++i];
	      }
	      _this.groupAlias = columnFormItem.Properties.DataSource.Value;
	    }
	
	    _this.unsubscribeRecordsCmpStore = _RecordsStore.RecordsCmpStore.listen(_this.onExecuteCmp.bind(_this));
	    return _this;
	  }
	
	  _createClass(FormItemDataGridControl, [{
	    key: 'getProperty_LockedNum',
	    value: function getProperty_LockedNum() {
	      var _parentWindow = window.parent.window;
	      if (!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
	        var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
	        var _properties = _userProperties[this.xml.id];
	        if (_properties && _properties.hasOwnProperty("lockedNum")) return _properties["lockedNum"];else if (_properties && _properties.hasOwnProperty("lockednum")) return _properties["lockednum"];
	      }
	      if (!this.properties.hasOwnProperty("FreezeColumns")) this.properties.FreezeColumns = 0;
	      return this.properties.FreezeColumns;
	    }
	  }, {
	    key: 'getProperty_HeaderHeight',
	    value: function getProperty_HeaderHeight() {
	      return this.properties.HeaderHeight;
	    }
	  }, {
	    key: 'getProperty_DisableAutoSave',
	    value: function getProperty_DisableAutoSave() {
	      if (this.properties.hasOwnProperty("ShowToolbar")) return this.properties.DisableAutoSave;
	      return false;
	    }
	  }, {
	    key: 'getProperty_ShowToolbar',
	    value: function getProperty_ShowToolbar() {
	      if (this.properties.hasOwnProperty("ShowToolbar")) return this.properties.ShowToolbar;
	      return true;
	    }
	  }, {
	    key: 'onExecuteCmp',
	    value: function onExecuteCmp(data, groupAlias, groupInstance) {
	      if (this.group && this.group == groupInstance && this.group.groupAlias == groupAlias) {
	        this.records = data;
	      }
	    }
	  }, {
	    key: 'enterMainForm',
	    value: function enterMainForm(columnIndex, _value) {
	      var columnsFormItem = this.columnsDataFlat;
	      if (columnsFormItem.length == 0) return;
	      if (columnIndex - 1 < 0) return;
	      var columnFormItem = columnsFormItem[columnIndex - 1];
	      var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, columnFormItem.id);
	      var columnFormItemControl = _FormItemUtil2.default.getFormItemControl(key, false);
	      if (columnFormItemControl.enterMainForm) columnFormItemControl.enterMainForm({ currentValue: _value });
	    }
	  }, {
	    key: 'ascOrder',
	    value: function ascOrder(columnIndex) {
	      var columnsFormItem = this.columnsDataFlat;
	      if (columnsFormItem.length == 0) return;
	      if (columnIndex - 1 < 0) return;
	      var columnFormItem = columnsFormItem[columnIndex - 1];
	      var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, columnFormItem.id);
	      var columnFormItemControl = _FormItemUtil2.default.getFormItemControl(key, false);
	      columnFormItemControl.ascOrder();
	    }
	  }, {
	    key: 'descOrder',
	    value: function descOrder(columnIndex) {
	      var columnsFormItem = this.columnsDataFlat;
	      if (columnsFormItem.length == 0) return;
	      if (columnIndex - 1 < 0) return;
	      var columnFormItem = columnsFormItem[columnIndex - 1];
	      var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, columnFormItem.id);
	      var columnFormItemControl = _FormItemUtil2.default.getFormItemControl(key, false);
	      columnFormItemControl.descOrder();
	    }
	  }, {
	    key: 'findValue',
	    value: function findValue(columnIndex) {
	      var columnsFormItem = this.columnsDataFlat;
	      if (columnsFormItem.length == 0) return;
	      if (columnIndex - 1 < 0) return;
	      var columnFormItem = columnsFormItem[columnIndex - 1];
	      var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, columnFormItem.id);
	      var columnFormItemControl = _FormItemUtil2.default.getFormItemControl(key, false);
	      columnFormItemControl.findValue();
	    }
	  }, {
	    key: 'findValue2',
	    value: function findValue2(columnIndex) {
	      var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var columnsFormItem = this.columnsDataFlat;
	      if (columnsFormItem.length == 0) return;
	      if (columnIndex - 1 < 0) return;
	      var columnFormItem = columnsFormItem[columnIndex - 1];
	      var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, columnFormItem.id);
	      var columnFormItemControl = _FormItemUtil2.default.getFormItemControl(key, false);
	      columnFormItemControl.findValueStepByStep(flag);
	    }
	  }, {
	    key: 'enterFind',
	    value: function enterFind(columnIndex) {
	      var columnsFormItem = this.columnsDataFlat;
	      if (columnsFormItem.length == 0) return;
	      if (columnIndex - 1 < 0) return;
	      var columnFormItem = columnsFormItem[columnIndex - 1];
	      var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, columnFormItem.id);
	      var columnFormItemControl = _FormItemUtil2.default.getFormItemControl(key, false);
	      columnFormItemControl.enterFind();
	    }
	  }, {
	    key: 'getDynamicColumnName',
	    value: function getDynamicColumnName() {
	      var dynamicPropertyValue = _GOTUtil2.default.getPropertyValue(this.xml, "DynamicColumn");
	      if (!dynamicPropertyValue && this.group && this.group.mainSource && this.group.mainSource.xml && this.group.mainSource.xml.Properties.PivotSource && this.group.mainSource.xml.Properties.PivotSource.Value) {
	        var columnsData = this.xml.FormItem;
	        var pivotSourceEntityid = this.group.mainSource.xml.Properties.PivotAggregateColumn.refentityid;
	        var pivotSourceValue = this.group.mainSource.xml.Properties.PivotAggregateColumn.Value;
	        if (pivotSourceEntityid && pivotSourceValue) {
	          for (var i in columnsData) {
	            var columnItem = columnsData[i];
	            if (columnItem && columnItem.Properties && columnItem.Properties.Extends && pivotSourceValue == columnItem.Properties.Extends.Value && pivotSourceEntityid == columnItem.Properties.Extends.refentityid) {
	              dynamicPropertyValue = columnItem.name;
	              break;
	            }
	          }
	        }
	      }
	      return dynamicPropertyValue;
	    }
	  }, {
	    key: 'getDataGridColumns',
	    value: function getDataGridColumns() {
	      //alert("getDataGridColumns" + this.groupAlias);
	      var columnsData = this.xml.FormItem;
	      var columnsDataFlat = [];
	      var dynamicPropertyValue = _GOTUtil2.default.getPropertyValue(this.xml, "DynamicColumn");
	      if (dynamicPropertyValue) this.group.hasDynamicColumn = true;
	
	      if (!dynamicPropertyValue && this.group && this.group.mainSource && this.group.mainSource.xml && this.group.mainSource.xml.Properties.PivotSource && this.group.mainSource.xml.Properties.PivotSource.Value) {
	        var pivotSourceEntityid = this.group.mainSource.xml.Properties.PivotAggregateColumn.refentityid;
	        var pivotSourceValue = this.group.mainSource.xml.Properties.PivotAggregateColumn.Value;
	        var pivotSourceName = this.group.mainSource.xml.Properties.PivotSource.Value;
	        if (pivotSourceEntityid && pivotSourceValue) {
	          for (var i in columnsData) {
	            var columnItem = columnsData[i];
	            if (columnItem && columnItem.Properties && columnItem.Properties.Extends && pivotSourceValue == columnItem.Properties.Extends.Value && pivotSourceEntityid == columnItem.Properties.Extends.refentityid) {
	              this.group.hasDynamicColumn = true;
	              dynamicPropertyValue = columnItem.name;
	              break;
	            }
	          }
	        }
	      }
	      for (var _i in columnsData) {
	        var _columnItem = columnsData[_i];
	        if (_columnItem.type == "FieldGroup") {
	          var fieldGroupFormItemArray = _columnItem.FormItem;
	          for (var j in fieldGroupFormItemArray) {
	            columnsDataFlat.push(fieldGroupFormItemArray[j]);
	          }
	        } else {
	          columnsDataFlat.push(_columnItem);
	        }
	      }
	      var columns = [];
	      var columnLockedNum = this.getProperty_LockedNum();
	      columnLockedNum = parseInt(columnLockedNum);
	      var num = 0;
	      this.columnsDataFlat = columnsDataFlat;
	      for (var _i2 in columnsDataFlat) {
	        var _columnItem2 = columnsDataFlat[_i2];
	        if (_columnItem2.name == dynamicPropertyValue) continue;
	        /*key: 'county',
	        name: 'County',
	        editor: <AutoCompleteEditor options={counties}/>,
	        width: 200,
	        resizable: true*/
	        var column = {};
	        if (num < columnLockedNum) column.locked = true;
	        var controlKey = _FormItemUtil2.default.getFormItemControlKey(this.menuItemId, this.formId, _columnItem2.id);
	        var columnControl = _FormItemUtil2.default.getFormItemControl(controlKey, this.forLookup);
	        var columnDisplayHeight = columnControl.getProperty_DisplayHeight();
	        var columnFixHeight = columnControl.getProperty_Height();
	        if (!this.columnDisplayHeight && columnFixHeight && columnFixHeight > 0) this.columnDisplayHeight = columnFixHeight;else if (columnDisplayHeight && columnDisplayHeight > 1 && !this.columnDisplayHeight) {
	          this.columnDisplayHeight = columnDisplayHeight * _FormItemConst2.default.DATAGRID_ROW_HEIGHT;
	        }
	        column.key = columnControl.getDataField();
	        if (column.key == undefined) column.key = "1";
	        column.name = columnControl.getInitialLabel();
	        column.skipTab = columnControl.getProperty_SkipTab();
	        column.isDataMethodField = columnControl.isDataMethodField;
	        //FormItemUtil.getFormItemInstanceForDataGrid(columnItem,false);
	
	        // column.width = columnControl.getDisplayLengthWidth();
	        var _width = columnControl.getProperty_Width();
	        if (_width != "" && typeof _width == "string") _width = parseInt(_width);
	        if (!_width) {
	          var _displayLength = columnControl.propertyDisplayLength ? columnControl.propertyDisplayLength : columnControl.getProperty_DisplayLength();
	          if (_displayLength == _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH) _displayLength = _FormItemConst2.default.DATEEDITOR_DEFAULT_DISPLAYLENGTH + 1;
	          column.width = _displayLength * _FormItemConst2.default.displayLength_EN + _FormItemConst2.default.displayLength_ENAddon;
	        } else {
	          column.width = _width;
	        }
	        if (_columnItem2.type == "DateEditor") //TODO 由于项目编辑器焦点框特殊实现 DataGrid外的宽度逻辑会造成有焦点时少显示4分之一字 所以加了2个像素宽度
	          column.width += _FormItemConst2.default.DATAEDITOR_DATAGRID_ADDON_FOCUS;
	
	        //if(columnItem.type == "BooleanEditor")
	        //  column.width += 20;
	        column.widthBak = column.width;
	        column.notNull = columnControl.getInitialNotNull();
	        column.uid = _columnItem2.id;
	        column.xmlName = _columnItem2.name;
	        column.resizable = true;
	        column.editorType = _columnItem2.type;
	        var groupAlias = this.groupAlias;
	        var _textAlign = columnControl.getProperty_Alignment();
	        if (!_textAlign) _textAlign = "Left";
	        if (columnControl.isDataMethodSelectRecords) {
	          column.headerRenderer = _react2.default.createElement(_GongqiSelectRecordsHeaderCell2.default, { moduleInstanceId: this.module.instanceUUId, groupAlias: groupAlias });
	          column.resizable = false;column.editable = false;
	        } else {
	          column.headerRenderer = _react2.default.createElement(_GongqiHeaderCell2.default, { moduleInstanceId: this.module.instanceUUId, groupAlias: groupAlias, textAlign: _textAlign.toLowerCase() });
	        }
	        //TODO非常重要 借用宽度来实现不可见
	        if (columnControl.getProperty_Visible_Final() == false) {
	          column.width = 0.1;
	          column.visible = false;
	        }
	        if (_columnItem2.type == "BooleanEditor") {
	          column.editable = false;
	        } else {
	          var _editor = columnControl.getComponentInstanceForDataGrid(this.xml, this.forLookup);
	          column.editor = _editor;
	        }
	
	        if (_columnItem2.type == "DecimalEditor") {
	          column.numofdecimals = columnControl.getProperty_NumOfDecimals();
	        }
	        if (this.module.rendersObject && this.module.rendersObject.hasOwnProperty(column.xmlName)) {
	          var _arg = this.module.rendersObject[column.xmlName];
	          if (_arg) {
	            var CustomRender = _arg.render;
	            column.formatter = _react2.default.createElement(CustomRender, { executeCommandResult: this.executeCommandResult.bind(this) });
	            if (_arg.editable == false) {
	              column.editable = false;
	              column.editor = null;
	            }
	          }
	        } else {
	          column.formatter = columnControl.getRenderForDataGrid(this.forLookup);
	        }
	
	        if (this.module.dragStartObjects && this.module.dragStartObjects.hasOwnProperty(column.xmlName)) {
	          var _arg2 = this.module.dragStartObjects[column.xmlName];
	          if (_arg2) {
	            var _handler = _arg2.handler;
	            column.dragStartHandler = _handler;
	          }
	        } else {
	          // if(window.parent.window.appId && window.parent.window.didomain){
	          column.dragStartHandler = this.columndragStartHandler.bind(this);
	          // }
	        }
	
	        /*if(column.width!=0.1 && i == columnsDataFlat.length-1)
	        {
	          column.width +=25;
	        }*/
	        /*if(i == columnsDataFlat.length-1)
	          {column.width = 0.1;column.visible = false;}*/
	
	        /*if(window.isDataSetView==true)
	        {
	          let extendsPro = GOTUtil.getProperty(columnItem,"Extends");
	          if(extendsPro && extendsPro.refentityid && extendsPro.refinnerid)
	          {
	            let extendsTable = GOT.getTable(extendsPro.refentityid);
	            if(extendsTable)
	            {
	              let tableField = GOT.getTableField(extendsTable,extendsPro.refinnerid);
	              if(tableField && tableField.type == "Component")
	              {
	                column.key = column.key.replace(/\./g,"_");
	              }
	            }
	          }
	        }*/
	
	        columns.push(column);
	        // if(column.width > 0.1)
	        num++;
	      }
	      console.log(columns);
	      this._columns = columns;
	      return columns;
	    }
	  }, {
	    key: 'columndragStartHandler',
	    value: function columndragStartHandler(event, billData) {
	      if (billData) billData.name = this.module.formLabel + ".xlg";
	      event.dataTransfer.setData("billData", JSON.stringify(billData));
	    }
	  }, {
	    key: 'executeCommandResult',
	    value: function executeCommandResult(commandResult) {
	      _CommandResolver2.default.resolve(commandResult.tasks, window.formModuleInstance);
	    }
	
	    /*onTabNavHandler(proxy,rowIndex,columnIndex)
	    {
	      if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
	      {
	        let ne = proxy["nativeEvent"];
	        if(ne.shiftKey)
	        {
	          }
	      }
	    }*/
	
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var parentLayout = this.parentXML.Properties.Layout.Value;
	
	      var style = {
	        //align-items:flex-start,
	        //flex-grow:flexGrow
	      };
	
	      if (this.forLookup || window.isLookup || window.isPopUp) {
	        //let columnWidth = this._columns.length*200-120;
	        //style["width"] = columnWidth +"px";
	        var totalWidth = 46;
	        for (var i in this._columns) {
	          var column = this._columns[i];
	          totalWidth += column.width;
	        }
	
	        // if(totalWidth>($(document).width()-300))
	        //   totalWidth = $(document).width() - 300;
	        if (totalWidth < 387) totalWidth = 387;
	        style["minWidth"] = totalWidth + "px";
	      }
	
	      /*if(window.isPopUp)
	      {
	        let totalWidth = 48;
	        for(let i in this._columns)
	        {
	          let column = this._columns[i];
	          totalWidth+=column.width;
	          if(i>5)
	            break;
	        }
	        if(totalWidth<350)totalWidth = 350;
	        style["minWidth"] = (totalWidth) +"px";
	        
	      }*/
	
	      if (parentLayout == "horizontal") {
	
	        var _width = this.getProperty_Width(); //this.xml.Properties.Width.Value;
	        if (_width == undefined || _width == 0) _width = "";
	        if (typeof _width == "number") _width = _width + "";
	        var flexGrow = 100;
	        var iex = _width.indexOf("%");
	        if (iex != -1) {
	          flexGrow = _width.substring(0, iex);
	        }
	
	        if (iex == -1 && _width != "") {
	          style["width"] = _width + "px";
	        } else {
	          style["flexGrow"] = flexGrow;
	        }
	
	        var _height = this.getProperty_Height(); //this.xml.Properties.Height.Value;
	        if (_height == undefined) _height = "";
	        if (this.forLookup || window.isPopUp || window.isLookup || this.xml.Properties.Rows.Value) // && this.module.hasUpDownDataGrid))
	          {
	            //alert(this.xml.Properties.Rows.Value);
	            if (!this.xml.Properties.Rows.Value) this.xml.Properties.Rows.Value = 16;
	
	            var _rowsNum = this.xml.Properties.Rows.Value;
	            var _extralHeight = 39;
	
	            if (_rowsNum == 4) {
	              _extralHeight = 49;
	            }
	
	            style["height"] = parseInt(_rowsNum) * (this.columnDisplayHeight ? this.columnDisplayHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT) + _FormItemConst2.default.DATAGRID_HEADER_HEIGHT + _extralHeight + "px";
	          } else if (_height == "100%" || _height == "") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
	      } else //vertical 暂不考虑absolute
	        {
	          var _height2 = this.getProperty_Height(); //this.xml.Properties.Height.Value;
	          if (_height2 == undefined || _height2 == 0) _height2 = "";
	          if (typeof _height2 == "number") _height2 = _height2 + "";
	          var _flexGrow = 100; //this.props.xml.Properties.Rows.Value;
	          var _iex = _height2.indexOf("%");
	          if (_iex != -1) {
	            _flexGrow = _height2.substring(0, _iex);
	          } else if (_iex == -1 && _height2 != "") {
	            _flexGrow = _height2 + "px";
	          } else if (_height2 == "") {
	            if (this.forLookup || window.isPopUp || window.isLookup || this.xml.Properties.Rows.Value) // && this.module.hasUpDownDataGrid))
	              {
	                if (!this.xml.Properties.Rows.Value) this.xml.Properties.Rows.Value = 16;
	                var _rowsNum2 = this.xml.Properties.Rows.Value;
	                var _extralHeight2 = 39;
	
	                if (_rowsNum2 == 4) {
	                  _extralHeight2 = 49;
	                }
	                style["height"] = parseInt(_rowsNum2) * (this.columnDisplayHeight ? this.columnDisplayHeight : _FormItemConst2.default.DATAGRID_ROW_HEIGHT) + _FormItemConst2.default.DATAGRID_HEADER_HEIGHT + _extralHeight2 + "px";
	                style["flexShrink"] = 0;
	              }
	          }
	          if (!style.hasOwnProperty("height")) style["flexGrow"] = _flexGrow;
	
	          var _width2 = this.getProperty_Width(); //this.xml.Properties.Width.Value;
	          if (_width2 == undefined) _width2 = "";
	          if (_width2 == "100%" || _width2 == "") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
	        }
	
	      return style;
	    }
	  }, {
	    key: 'remoteReturnHandler',
	    value: function remoteReturnHandler() {
	      var gridName = this.xml.name;
	      var cmdargInfo = _FormResourceUtil2.default.getCommandArgMethodInfo("lookupSelect_" + gridName, "FormLookup", this.formId);
	      if (cmdargInfo) {
	        var defaultGroupAlias = this.groupAlias;
	        var arg = _CommandResolver2.default.getSendCmd(this.module, defaultGroupAlias, cmdargInfo);
	        var command = _CommandHelper2.default.createFormInstance(this.module.formName, "doLookupSelect", "CommandResult").appendArg(gridName, "String").appendArg(arg, "CommandArg");
	        var remoteArg = { command: command, resultFunction: this.rpc_remoteClickresult.bind(this), sync: false };
	        _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'rpc_remoteClickresult',
	    value: function rpc_remoteClickresult(data) {
	      var commandResult = data.result;
	      _CommandResolver2.default.resolve(commandResult.tasks, this.module, this.group);
	    }
	  }, {
	    key: 'autoReturnHandler',
	    value: function autoReturnHandler(record) {
	      this.module.autoReturnHandler(record);
	    }
	  }, {
	    key: 'isSkipTab',
	    value: function isSkipTab() {
	      //TODO Group折叠考虑
	      //if(getGroupParentFolded())
	      //  return true;
	
	
	      if (!this.getProperty_Visible_FinalusersetLoopForSkip()) return true;
	      if (this.getProperty_ActualSkipTab()) return true;
	
	      return false;
	    }
	  }, {
	    key: 'getComponentInstance',
	    value: function getComponentInstance(parent, forLookup) {
	      var layout = parent.Properties.Layout.Value;
	      var columns = this.getDataGridColumns();
	      //let store = window.parent.window[storeKey];
	      var allowMutiSelect = true; //store.mapItemProperty[this.formId+"_"+this.xml.id].MultiSelect;
	      var _updateHeightPercent100 = false;
	      /*if(ptype != "FormDesign")
	      {
	        //TODO不知道为何 但是要先改掉
	        if(layout == "horizontal" && parent.FormItem.length>0)
	          _updateHeightPercent100 = true;
	      }*/
	
	      var remoteReturnHandler = null;
	      var autoReturnHandler = null;
	      if (forLookup) {
	        remoteReturnHandler = this.remoteReturnHandler.bind(this);
	        var autoReturn = this.module.classAlias == "FormModuleLookup" ? this.module.autoReturn : false;
	        if (autoReturn) autoReturnHandler = this.autoReturnHandler.bind(this);
	      }
	      var commonProps = this.getCommonProps();
	      this.component = _react2.default.createElement(_FormItemDataGrid2.default, _extends({ columns: columns, key: this.xml.id, xml: this.xml, control: this, hasDividedBox: this.module.hasDividedBox,
	        parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId,
	        allowMutiSelect: allowMutiSelect, customStyle: this.getStyle(), group: this.group,
	        formId: this.formId, menuItemId: this.menuItemId, updateHeightPercent100: _updateHeightPercent100,
	        contextMenuData: this.contextMenuData, remoteReturnHandler: remoteReturnHandler, autoReturnHandler: autoReturnHandler,
	        showToolbar: this.getProperty_ShowToolbar(),
	        initRecords: this.records, headerRowHeightPro: this.getProperty_HeaderHeight(), rowHeight: this.columnDisplayHeight }, commonProps));
	      return this.component;
	    }
	  }]);
	
	  return FormItemDataGridControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemDataGridControl;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemDateEditor = __webpack_require__(93);
	
	var _FormItemDateEditor2 = _interopRequireDefault(_FormItemDateEditor);
	
	var _FormItemDateEditorForDataGrid = __webpack_require__(123);
	
	var _FormItemDateEditorForDataGrid2 = _interopRequireDefault(_FormItemDateEditorForDataGrid);
	
	var _FormItemDateRender = __webpack_require__(237);
	
	var _FormItemDateRender2 = _interopRequireDefault(_FormItemDateRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDateEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemDateEditorControl, _FormItemEditorContro);
	
		function FormItemDateEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemDateEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemDateEditorControl.__proto__ || Object.getPrototypeOf(FormItemDateEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemDateEditorControl";
			return _this;
		}
	
		_createClass(FormItemDateEditorControl, [{
			key: 'validateNotNull',
			value: function validateNotNull() {
				var _dataField = this.getDataField();
				if (_dataField && this.group && this.group.currentRecord) {
					var value = this.group.currentRecord[_dataField];
					if (!value || value == "" || value == 0) {
						var _label = this.getProperty_Label();
						return _label + " 不能为空";
					}
				}
				return null;
			}
		}, {
			key: 'getSelfNotNull',
			value: function getSelfNotNull() {
				var key = this.formId + this.xml.id + _ControlPropertyConst2.default.NOTNULL;
				var notnull = window.controlProperties[key];
				if (notnull) return notnull;
				var notnull = this.xml.Properties.NotNull.Value;
				if (typeof notnull == "string") {
					return notnull == "true" ? true : false;
				} else {
					return notnull;
				}
				//return this.xml.Properties.NotNull.Value;
			}
	
			/*getProperty_DisplayFormat()
	  {
	  	return this.properties.DisplayStyle;
	  }*/
	
		}, {
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 12;
			}
		}, {
			key: 'getProperty_Seperator',
			value: function getProperty_Seperator() {
				return "-";
				return this.properties.Seperator;
			}
		}, {
			key: 'getProperty_NumOfYear',
			value: function getProperty_NumOfYear() {
				if (this.properties.hasOwnProperty("NumOfYear")) return this.properties.NumOfYear;
				return _FormItemDateDisplay2.default.defaultNumOfYear;
			}
		}, {
			key: 'getProperty_NumOfDay',
			value: function getProperty_NumOfDay() {
				if (this.properties.hasOwnProperty("NumOfDay")) return this.properties.NumOfDay;
				return _FormItemDateDisplay2.default.defaultNumOfDay;
			}
		}, {
			key: 'getProperty_NumOfMonth',
			value: function getProperty_NumOfMonth() {
				if (this.properties.hasOwnProperty("NumOfMonth")) return this.properties.NumOfMonth;
				return _FormItemDateDisplay2.default.defaultNumOfMonth;
			}
		}, {
			key: 'getProperty_Show1970',
			value: function getProperty_Show1970() {
				return true;
				return this.properties.Show1970;
			}
		}, {
			key: 'getProperty_DisplayFormat',
			value: function getProperty_DisplayFormat() {
				var _displayStyle = this.getProperty_DisplayStyle();
				//let _displayStyle = {"fontFamily":"微软雅黑","buttonStyle":"普通","VerticalAlignment":"Center","fontSize":"72","fontStyle":"","HorizontalAlignment":"Center","fontWeight":"bold"};
				if (_displayStyle && _displayStyle.DisplayFormat) return _displayStyle.DisplayFormat.toUpperCase();
				return "";
			}
		}, {
			key: 'getQueryFilteredVaue',
			value: function getQueryFilteredVaue(value) {
				var filter = this.getProperty_QueryFilter();
				if (!value) return "";
				if (filter == ">+dateNull") {
					return ">" + value + ",''";
				} else if (filter == ">=+dateNull") {
					return ">=" + value + ",''";
				} else if (filter == "<+dateNull") {
					return "<" + value;
				} else if (filter == "<=+dateNull") {
					return "<=" + value;
				} else if (filter == "<") {
					return "<" + value + "&<>''";
				} else if (filter == "<=") {
					return "<=" + value + "&<>''";
				} else {
					return _get(FormItemDateEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemDateEditorControl.prototype), 'getQueryFilteredVaue', this).call(this, value);
				}
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var _extends2;
	
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var displayHeight = this.getProperty_DisplayHeight();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				var displayStyle = this.getProperty_DisplayStyle();
	
				this.component = _react2.default.createElement(_FormItemDateEditor2.default, _extends((_extends2 = { displayLengthWidth: displayLengthWidth,
					displayLength: displayLength, displayHeight: displayHeight, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					key: this.xml.id, xml: this.xml, formType: _EditorFormType2.default.FormModule,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias,
					dataField: this.getDataField(), initRecord: _initRecord, initEditorValue: this.initEditorValue,
					label: label, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId, contextMenuData: this.contextMenuData
				}, _defineProperty(_extends2, 'contextMenuData', this.contextMenuData), _defineProperty(_extends2, 'seperator', this.getProperty_Seperator()), _defineProperty(_extends2, 'numOfYear', this.getProperty_NumOfYear()), _defineProperty(_extends2, 'numOfDay', this.getProperty_NumOfDay()), _defineProperty(_extends2, 'numOfMonth', this.getProperty_NumOfMonth()), _defineProperty(_extends2, 'show1970', this.getProperty_Show1970()), _defineProperty(_extends2, 'control', this), _defineProperty(_extends2, 'underQueryGroup', this.isUnderQueryGroup()), _defineProperty(_extends2, 'verticalAlign', this.getProperty_VAlignment()), _defineProperty(_extends2, 'cssStyle', this.getProperty_CSSStyle_Display()), _defineProperty(_extends2, 'displayStyle', displayStyle), _extends2), commonProps));
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemDateEditorForDataGrid2.default, { key: this.xml.id, xml: this.xml, forLookup: forLookup, group: this.group, formType: _EditorFormType2.default.FormModule, control: this,
					groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId, formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML,
					verticalAlign: this.getProperty_VAlignment() });
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				return _react2.default.createElement(_FormItemDateRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: this.getDataField(), numOfDay: this.getProperty_NumOfDay(), numOfMonth: this.getProperty_NumOfMonth(), show1970: this.getProperty_Show1970(),
					numOfYear: this.getProperty_NumOfYear(), seperator: this.getProperty_Seperator(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), displayFormat: displayFormat, cssStyle: this.getProperty_CSSStyle_Display(),
					displayStyle: displayStyle });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				return _react2.default.createElement(_FormItemDateRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: dataField, numOfDay: this.getProperty_NumOfDay(), numOfMonth: this.getProperty_NumOfMonth(), show1970: this.getProperty_Show1970(),
					numOfYear: this.getProperty_NumOfYear(), seperator: this.getProperty_Seperator(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), displayFormat: displayFormat, cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle });
			}
		}]);
	
		return FormItemDateEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemDateEditorControl;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemDateTimeEditorForDataGrid = __webpack_require__(196);
	
	var _FormItemDateTimeEditorForDataGrid2 = _interopRequireDefault(_FormItemDateTimeEditorForDataGrid);
	
	var _FormItemDateTimeEditor = __webpack_require__(124);
	
	var _FormItemDateTimeEditor2 = _interopRequireDefault(_FormItemDateTimeEditor);
	
	var _FormItemDateTimeRender = __webpack_require__(239);
	
	var _FormItemDateTimeRender2 = _interopRequireDefault(_FormItemDateTimeRender);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	var _ResizeStore = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDateTimeEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemDateTimeEditorControl, _FormItemEditorContro);
	
		function FormItemDateTimeEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemDateTimeEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemDateTimeEditorControl.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemDateTimeEditorControl";
			return _this;
		}
	
		_createClass(FormItemDateTimeEditorControl, [{
			key: 'validateNotNull',
			value: function validateNotNull() {
				var _dataField = this.getDataField();
				if (_dataField && this.group && this.group.currentRecord) {
					var value = this.group.currentRecord[_dataField];
					if (!value || value == "" || value == 0) {
						var _label = this.getProperty_Label();
						return _label + " 不能为空";
					}
				}
				return null;
			}
		}, {
			key: 'getSelfNotNull',
			value: function getSelfNotNull() {
				var key = this.formId + this.xml.id + _ControlPropertyConst2.default.NOTNULL;
				var notnull = window.controlProperties[key];
				if (notnull) return notnull;
				var notnull = this.xml.Properties.NotNull.Value;
				if (typeof notnull == "string") {
					return notnull == "true" ? true : false;
				} else {
					return notnull;
				}
				//return this.xml.Properties.NotNull.Value;
			}
	
			/*getProperty_DisplayFormat()
	  {
	  	return this.properties.DisplayStyle;
	  }*/
	
		}, {
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 12;
			}
		}, {
			key: 'getProperty_Seperator',
			value: function getProperty_Seperator() {
				return "-";
				return this.properties.Seperator;
			}
		}, {
			key: 'getProperty_NumOfYear',
			value: function getProperty_NumOfYear() {
				if (this.properties.hasOwnProperty("NumOfYear")) return this.properties.NumOfYear;
				return _FormItemDateDisplay2.default.defaultNumOfYear;
			}
		}, {
			key: 'getProperty_NumOfDay',
			value: function getProperty_NumOfDay() {
				if (this.properties.hasOwnProperty("NumOfDay")) return this.properties.NumOfDay;
				return _FormItemDateDisplay2.default.defaultNumOfDay;
			}
		}, {
			key: 'getProperty_NumOfMonth',
			value: function getProperty_NumOfMonth() {
				if (this.properties.hasOwnProperty("NumOfMonth")) return this.properties.NumOfMonth;
				return _FormItemDateDisplay2.default.defaultNumOfMonth;
			}
		}, {
			key: 'getProperty_Show1970',
			value: function getProperty_Show1970() {
				return true;
				return this.properties.Show1970;
			}
		}, {
			key: 'getProperty_DisplayFormat',
			value: function getProperty_DisplayFormat() {
				var _displayStyle = this.getProperty_DisplayStyle();
				if (_displayStyle && _displayStyle.DisplayFormat) {
					var _displayFormat = _displayStyle.DisplayFormat;
					if (_displayFormat == "yyyy-MM-dd HH:MM:SS") {
						return "YYYY-MM-DD HH:NN:SS";
					} else {
						return "YYYY-MM-DD HH:NN";
					}
				}
	
				return "";
			}
		}, {
			key: 'getQueryFilteredVaue',
			value: function getQueryFilteredVaue(value) {
				var filter = this.getProperty_QueryFilter();
				if (!value) return "";
				if (filter == ">+dateNull") {
					return ">" + value + ",''";
				} else if (filter == ">=+dateNull") {
					return ">=" + value + ",''";
				} else if (filter == "<+dateNull") {
					return "<" + value;
				} else if (filter == "<=+dateNull") {
					return "<=" + value;
				} else if (filter == "<") {
					return "<" + value + "&<>''";
				} else if (filter == "<=") {
					return "<=" + value + "&<>''";
				} else {
					return _get(FormItemDateTimeEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemDateTimeEditorControl.prototype), 'getQueryFilteredVaue', this).call(this, value);
				}
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var _extends2;
	
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var displayHeight = this.getProperty_DisplayHeight();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				this.component = _react2.default.createElement(_FormItemDateTimeEditor2.default, _extends((_extends2 = { displayLengthWidth: displayLengthWidth,
					displayLength: displayLength, displayHeight: displayHeight, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					key: this.xml.id, xml: this.xml, formType: _EditorFormType2.default.FormModule,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias,
					dataField: this.getDataField(), initRecord: _initRecord, initEditorValue: this.initEditorValue,
					label: label, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId, contextMenuData: this.contextMenuData
				}, _defineProperty(_extends2, 'contextMenuData', this.contextMenuData), _defineProperty(_extends2, 'seperator', this.getProperty_Seperator()), _defineProperty(_extends2, 'numOfYear', this.getProperty_NumOfYear()), _defineProperty(_extends2, 'numOfDay', this.getProperty_NumOfDay()), _defineProperty(_extends2, 'numOfMonth', this.getProperty_NumOfMonth()), _defineProperty(_extends2, 'show1970', this.getProperty_Show1970()), _defineProperty(_extends2, 'control', this), _defineProperty(_extends2, 'underQueryGroup', this.isUnderQueryGroup()), _defineProperty(_extends2, 'verticalAlign', this.getProperty_VAlignment()), _extends2), commonProps, {
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle, displayFormat: displayFormat }));
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemDateTimeEditorForDataGrid2.default, { key: this.xml.id, xml: this.xml, forLookup: forLookup, group: this.group, formType: _EditorFormType2.default.FormModule, control: this,
					groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId, formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML,
					verticalAlign: this.getProperty_VAlignment() });
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				return _react2.default.createElement(_FormItemDateTimeRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: this.getDataField(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), displayFormat: displayFormat, displayStyle: displayStyle, cssStyle: this.getProperty_CSSStyle_Display() });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				return _react2.default.createElement(_FormItemDateTimeRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: dataField, formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), displayFormat: displayFormat, displayStyle: displayStyle, cssStyle: this.getProperty_CSSStyle_Display() });
			}
		}]);
	
		return FormItemDateTimeEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemDateTimeEditorControl;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemDecimalEditor = __webpack_require__(125);
	
	var _FormItemDecimalEditor2 = _interopRequireDefault(_FormItemDecimalEditor);
	
	var _FormItemDecimalEditorForDataGrid = __webpack_require__(126);
	
	var _FormItemDecimalEditorForDataGrid2 = _interopRequireDefault(_FormItemDecimalEditorForDataGrid);
	
	var _FormItemDecimalRender = __webpack_require__(241);
	
	var _FormItemDecimalRender2 = _interopRequireDefault(_FormItemDecimalRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDecimalEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemDecimalEditorControl, _FormItemEditorContro);
	
		function FormItemDecimalEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemDecimalEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemDecimalEditorControl.__proto__ || Object.getPrototypeOf(FormItemDecimalEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemDecimalEditorControl";
			_this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(_this.onUpdateDropDownContnent.bind(_this));
	
			return _this;
		}
	
		_createClass(FormItemDecimalEditorControl, [{
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.module.instanceUUId == formModuleInstanceuuId && control == this.xml.name) {
					this.dropDownContent = type;
				}
			}
		}, {
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 12;
			}
		}, {
			key: 'getProperty_AutoSum',
			value: function getProperty_AutoSum() {
				//return true;
				return this.properties.AutoSum;
			}
		}, {
			key: 'getProperty_NumOfDecimals',
			value: function getProperty_NumOfDecimals() {
				return this.properties.NumOfDecimals;
			}
		}, {
			key: 'getProperty_AllowNegative',
			value: function getProperty_AllowNegative() {
				if (this.properties.hasOwnProperty("AllowNegative")) return this.properties.AllowNegative;
				return true;
			}
		}, {
			key: 'getProperty_RoundOff',
			value: function getProperty_RoundOff() {
				return this.properties.RoundOff;
			}
		}, {
			key: 'getProperty_ShowZero',
			value: function getProperty_ShowZero() {
				return this.properties.ShowZero;
			}
		}, {
			key: 'getProperty_ShowDecimals',
			value: function getProperty_ShowDecimals() {
				if (this.properties.hasOwnProperty("ShowDecimals")) return this.properties.ShowDecimals;
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.DisplayDecimals) return displayStyle.DisplayDecimals;
				return this.properties.DisplayDecimals;
			}
		}, {
			key: 'getProperty_ThousandSeperator',
			value: function getProperty_ThousandSeperator() {
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.ThousandSeperator) return displayStyle.ThousandSeperator;
				return this.properties.ThousandSeperator;
			}
		}, {
			key: 'getProperty_DropDownContent',
			value: function getProperty_DropDownContent() {
				return this.properties.DropDownContent;
			}
		}, {
			key: 'getProperty_DisplayStyle',
			value: function getProperty_DisplayStyle() {
				if (this._castedDisplayStyle) return this._castedDisplayStyle;
				var _displayStyle = this.properties.DisplayStyle;
				try {
					_displayStyle = JSON.parse(_displayStyle);
				} catch (e) {}
				this._castedDisplayStyle = _displayStyle;
				return this._castedDisplayStyle;
			}
		}, {
			key: 'getDefaultValue',
			value: function getDefaultValue() {
				var dvalue = _get(FormItemDecimalEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemDecimalEditorControl.prototype), 'getDefaultValue', this).call(this);
				if (dvalue == "") {
					var numdecimals = this.getProperty_NumOfDecimals();
					if (numdecimals > 0) dvalue = "0.";else dvalue = "0";
					while (numdecimals > 0) {
						dvalue += "0";
						numdecimals--;
					}
				}
				return dvalue;
			}
		}, {
			key: 'getProperty_Alignment',
			value: function getProperty_Alignment() {
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.HorizontalAlignment) return displayStyle.HorizontalAlignment;
				if (this.properties.hasOwnProperty("Alignment")) return this.properties.Alignment;
				return "Right";
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var displayHeight = this.getProperty_DisplayHeight();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				this.component = _react2.default.createElement(_FormItemDecimalEditor2.default, _extends({ displayLengthWidth: displayLengthWidth, key: this.xml.id,
					displayLength: displayLength, displayHeight: displayHeight, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					xml: this.xml, parentLayout: layout, forLookup: forLookup, formType: _EditorFormType2.default.FormModule,
					underFieldGroup: parent.type == "FieldGroup", groupAlias: this.groupAlias,
					dataField: this.getDataField(), initRecord: _initRecord, displayStyle: this.getProperty_DisplayStyle(),
					label: label, customStyle: this.getStyle(), formId: this.formId,
					menuItemId: this.menuItemId, contextMenuData: this.contextMenuData,
					numOfDecimals: this.getProperty_NumOfDecimals(), allowNegative: this.getProperty_AllowNegative(), roundOff: this.getProperty_RoundOff(),
					showZero: this.getProperty_ShowZero(), showDecimals: this.getProperty_ShowDecimals(), thousandSeperator: this.getProperty_ThousandSeperator(),
					control: this, underQueryGroup: this.isUnderQueryGroup(), verticalAlign: this.getProperty_VAlignment(),
					cssStyle: this.getProperty_CSSStyle_Display() }, commonProps));
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemDecimalEditorForDataGrid2.default, { key: this.xml.id, xml: this.xml, forLookup: forLookup, formType: _EditorFormType2.default.FormModule, group: this.group,
					numOfDecimals: this.getProperty_NumOfDecimals(), allowNegative: this.getProperty_AllowNegative(), roundOff: this.getProperty_RoundOff(),
					control: this, groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId, formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML,
					verticalAlign: this.getProperty_VAlignment() });
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemDecimalRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: this.getDataField(), showZero: this.getProperty_ShowZero(), showDecimals: this.getProperty_ShowDecimals(), thousandSeperator: this.getProperty_ThousandSeperator(),
					formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup, moduleInstanceId: this.module.instanceUUId, displayStyle: displayStyle,
					verticalAlign: this.getProperty_VAlignment(), cssStyle: this.getProperty_CSSStyle_Display() });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemDecimalRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: dataField, showZero: this.getProperty_ShowZero(), showDecimals: this.getProperty_ShowDecimals(), thousandSeperator: this.getProperty_ThousandSeperator(),
					formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: false, moduleInstanceId: this.module.instanceUUId, displayStyle: displayStyle,
					verticalAlign: this.getProperty_VAlignment(), cssStyle: this.getProperty_CSSStyle_Display() });
			}
		}]);
	
		return FormItemDecimalEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemDecimalEditorControl;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _FormItemDesign = __webpack_require__(170);
	
	var _FormItemDesign2 = _interopRequireDefault(_FormItemDesign);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDesignControl = function (_GongqiFormItemContro) {
		_inherits(FormItemDesignControl, _GongqiFormItemContro);
	
		function FormItemDesignControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemDesignControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemDesignControl.__proto__ || Object.getPrototypeOf(FormItemDesignControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemDesignControl";
			return _this;
		}
	
		_createClass(FormItemDesignControl, [{
			key: 'getProperty_AllowEdit_GOTFinal',
			value: function getProperty_AllowEdit_GOTFinal() {
				if (this.finalAllowEditGOT) return this.finalAllowEditGOT;
	
				var result = this.getProperty_AllowEdit_GOT();
				if (!result) return false;
				return result;
			}
		}, {
			key: 'getProperty_AllowEdit_UserSetFinal',
			value: function getProperty_AllowEdit_UserSetFinal() {
				var result = this.getProperty_AllowEdit_UserSet();
				if (!result) {
					return false;
				}
	
				return result;
			}
		}, {
			key: 'getProperty_Visible_Final',
			value: function getProperty_Visible_Final() {
				return true;
			}
		}, {
			key: 'getProperty_Visible_GOT',
			value: function getProperty_Visible_GOT() {
				return true;
			}
		}, {
			key: 'getProperty_Visible_GOTFinal',
			value: function getProperty_Visible_GOTFinal() {
				return true;
			}
		}, {
			key: 'getProperty_Visible_Loop',
			value: function getProperty_Visible_Loop() {
				return true;
			}
		}, {
			key: 'getProperty_Visible_UserSetFinal',
			value: function getProperty_Visible_UserSetFinal() {
				return true;
			}
		}, {
			key: 'getProperty_Visible_UserSet',
			value: function getProperty_Visible_UserSet() {
				return true;
			}
		}, {
			key: 'getProperty_Visible_UserSetLoop',
			value: function getProperty_Visible_UserSetLoop() {
				return true;
			}
		}, {
			key: 'getProperty_Layout',
			value: function getProperty_Layout() {
				return this.xml.Properties.Layout.Value;
			}
		}, {
			key: 'getIsWorkFlow',
			value: function getIsWorkFlow() {
				if (this.parentXML.Properties.hasOwnProperty("Workflow")) return this.parentXML.Properties.Workflow.Value;
				if (!this.parentXML.Properties.hasOwnProperty("FormType")) return false;
				var formType = this.parentXML.Properties.FormType.Value;
				return formType == _FormItemConst2.default.PROPERTY_FORMTYPE_WORKFLOW;
			}
		}, {
			key: 'getStyle',
			value: function getStyle(isPop) {
				var layout = this.xml.Properties.Layout.Value;
	
				var flexDirection = layout == "horizontal" ? "row" : "column";
				var style = {
					//flex-direction:flexDirection,
					//align-items:"flex-start",
					display: "flex"
					//paddingTop:'2px'
				};
				var isWorkFlow = this.getIsWorkFlow();
				if (isWorkFlow) {
					style.flexGrow = 1;
				} else {
					style.width = "100%";style.height = "100%";
					if (window.isPopUp || isPop) style.height = "";
				}
				style["flexDirection"] = flexDirection;
				style["alignItems"] = "flex-start";
	
				var propertyWidth = this.getProperty_Width();
				if (propertyWidth) {
					style["width"] = propertyWidth + "px";
				}
				//if(window.isPopUp)style["justifyContent"] = "center";
				//TODO最开始的时候为了解决滚动条问题加的-1
				//style["margin"] = "-1px";
				//style["overflow"] = 'auto';
				/*if(this.props.isLookup)
	   {
	   	style["position"] = 'absolute';style["top"] = "34px";style["left"] = "200px";
	   }*/
				return style;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup, formLabel, formName, isPop, stringEditorEntityId, stringEditorInnerId) {
				//alert("FormDesign111");		
				return _react2.default.createElement(_FormItemDesign2.default, { xml: this.xml, formName: formName, parentItem: parent, formLabel: formLabel ? formLabel : "",
					forLookup: forLookup, customStyle: this.getStyle(isPop), isPop: isPop, control: this,
					formId: this.formId, menuItemId: this.menuItemId, stringEditorEntityId: stringEditorEntityId,
					contextMenuData: this.contextMenuData, stringEditorInnerId: stringEditorInnerId });
			}
		}]);
	
		return FormItemDesignControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemDesignControl;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemDividedBox = __webpack_require__(127);
	
	var _FormItemDividedBox2 = _interopRequireDefault(_FormItemDividedBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemDividedBoxControl = function (_FormItemContainerCon) {
		_inherits(FormItemDividedBoxControl, _FormItemContainerCon);
	
		function FormItemDividedBoxControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemDividedBoxControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemDividedBoxControl.__proto__ || Object.getPrototypeOf(FormItemDividedBoxControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemDividedBoxControl";
			return _this;
		}
	
		_createClass(FormItemDividedBoxControl, [{
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemDividedBox2.default, _extends({ key: this.xml.id, xml: this.xml,
					parentLayout: layout, forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					groupAlias: this.groupAlias, customStyle: this.getStyle(),
					formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemDividedBoxControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemDividedBoxControl;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemEnumEditor = __webpack_require__(72);
	
	var _FormItemEnumEditor2 = _interopRequireDefault(_FormItemEnumEditor);
	
	var _FormItemEnumEditorForDataGrid = __webpack_require__(128);
	
	var _FormItemEnumEditorForDataGrid2 = _interopRequireDefault(_FormItemEnumEditorForDataGrid);
	
	var _FormItemEnumRender = __webpack_require__(243);
	
	var _FormItemEnumRender2 = _interopRequireDefault(_FormItemEnumRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _FormItemEnumRadioEditor = __webpack_require__(197);
	
	var _FormItemEnumRadioEditor2 = _interopRequireDefault(_FormItemEnumRadioEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemEnumEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemEnumEditorControl, _FormItemEditorContro);
	
		function FormItemEnumEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemEnumEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemEnumEditorControl.__proto__ || Object.getPrototypeOf(FormItemEnumEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemEnumEditorControl";
			_this.module = module;
			return _this;
		}
	
		_createClass(FormItemEnumEditorControl, [{
			key: 'getProperty_NotNull',
			value: function getProperty_NotNull() {
				return false;
			}
		}, {
			key: 'validateNotNull',
			value: function validateNotNull() {
				var _dataField = this.getDataField();
				if (_dataField && this.group && this.group.currentRecord) {
					var value = this.group.currentRecord[_dataField];
					if (!value || value == "" || value == "0" || value == 0) {
						var _label = this.getProperty_Label();
						var _dataProvider = this.getProperty_DataProvider();
						if (_dataProvider.length > 0) {
							for (var i = 0; i < _dataProvider.length; i++) {
								var item = _dataProvider[i];
								if (item.value == 0 || item.value == "0") {
									var _firstValue = item.label;
									break;
								}
							}
						}
						return _label + " 不能为" + (!_firstValue || _firstValue == "" ? "空" : _firstValue);
					}
				}
				return null;
			}
		}, {
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 10;
			}
		}, {
			key: 'getProperty_DataProvider',
			value: function getProperty_DataProvider() {
				return this.properties.DataProvider;
			}
		}, {
			key: 'getProperty_Regular',
			value: function getProperty_Regular() {
				return this.properties.Regular;
			}
		}, {
			key: 'getDefaultValue',
			value: function getDefaultValue() {
				var dvalue = _get(FormItemEnumEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemEnumEditorControl.prototype), 'getDefaultValue', this).call(this);
				if (dvalue == "") {
					dvalue = "0";
				}
				return dvalue;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				var _multiple = false;
				if (this.isUnderQueryGroup()) _multiple = true;
				var isWorkFlow = false;
				var enumType = this.getProperty_EnumType();
				if (this.module && this.module.classAlias == "FormModule") {
					if (this.module.getIsWorkFlow() == true) isWorkFlow = true;
				}
				if (isWorkFlow == true && enumType == 'Radio') {
					this.component = _react2.default.createElement(_FormItemEnumRadioEditor2.default, _extends({ displayLengthWidth: displayLengthWidth, key: this.xml.id,
						xml: this.xml, parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias,
						displayLength: displayLength, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
						dataField: this.getDataField(), initRecord: _initRecord, options: this.getProperty_DataProvider(),
						label: label, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
						contextMenuData: this.contextMenuData, formType: _EditorFormType2.default.FormModule, multiple: _multiple,
						control: this, underQueryGroup: this.isUnderQueryGroup() }, commonProps));
				} else {
					var displayStyle = this.getProperty_DisplayStyle();
					this.component = _react2.default.createElement(_FormItemEnumEditor2.default, _extends({ displayLengthWidth: displayLengthWidth, key: this.xml.id,
						xml: this.xml, parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias,
						displayLength: displayLength, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
						dataField: this.getDataField(), initRecord: _initRecord, options: this.getProperty_DataProvider(),
						label: label, regular: this.getProperty_Regular(), customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
						contextMenuData: this.contextMenuData, formType: _EditorFormType2.default.FormModule, multiple: _multiple,
						control: this, underQueryGroup: this.isUnderQueryGroup() }, commonProps, {
						cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle }));
				}
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemEnumEditorForDataGrid2.default, { key: this.xml.id, xml: this.xml, forLookup: forLookup, group: this.group,
					options: this.getProperty_DataProvider(), formType: _EditorFormType2.default.FormModule, control: this, regular: this.getProperty_Regular(),
					verticalAlign: this.getProperty_VAlignment(), groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId, formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML });
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemEnumRender2.default, { contextMenuData: this.contextMenuData, group: this.group, options: this.getProperty_DataProvider(), dataField: this.getDataField(),
					formId: this.formId, regular: this.getProperty_Regular(), menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup,
					moduleInstanceId: this.module.instanceUUId, verticalAlign: this.getProperty_VAlignment(), cssStyle: this.getProperty_CSSStyle_Display(),
					displayStyle: displayStyle });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemEnumRender2.default, { contextMenuData: this.contextMenuData, group: this.group, options: this.getProperty_DataProvider(), dataField: dataField,
					formId: this.formId, regular: this.getProperty_Regular(), menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: false,
					moduleInstanceId: this.module.instanceUUId, verticalAlign: this.getProperty_VAlignment(), cssStyle: this.getProperty_CSSStyle_Display(),
					displayStyle: displayStyle });
			}
		}]);
	
		return FormItemEnumEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemEnumEditorControl;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemFieldGroup = __webpack_require__(94);
	
	var _FormItemFieldGroup2 = _interopRequireDefault(_FormItemFieldGroup);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemFieldGroupControl = function (_FormItemContainerCon) {
		_inherits(FormItemFieldGroupControl, _FormItemContainerCon);
	
		function FormItemFieldGroupControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemFieldGroupControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemFieldGroupControl.__proto__ || Object.getPrototypeOf(FormItemFieldGroupControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemFieldGroupControl";
			return _this;
		}
	
		_createClass(FormItemFieldGroupControl, [{
			key: 'getProperty_FilterEditor',
			value: function getProperty_FilterEditor() {
				var xml = this.xml;
				var componentPro = _GOTUtil2.default.getProperty(xml, "Component");
				if (componentPro && componentPro.refentityid) return _GOTUtil2.default.getProperty(xml, "FilterEditor");
				return {};
				//return this.properties.FilterEditor;
			}
		}, {
			key: 'getProperty_Columns',
			value: function getProperty_Columns() {
				if (this.properties.hasOwnProperty("Columns")) return this.properties.Columns;
				if (this.properties.RowsOrColumns == 0) {
					this.properties.RowsOrColumns = 1;
				}
				return this.properties.RowsOrColumns;
			}
		}, {
			key: 'getProperty_ShowLabel',
			value: function getProperty_ShowLabel() {
				return true;
				return this.properties.ShowLabel;
			}
		}, {
			key: 'getProperty_HeaderAlign',
			value: function getProperty_HeaderAlign() {
				return this.properties.HeaderAlign;
			}
		}, {
			key: 'getProperty_DisplayLength',
			value: function getProperty_DisplayLength() {
				return this.properties.DisplayLength;
			}
		}, {
			key: 'setControlLabelCmd',
			value: function setControlLabelCmd(value) {
				this._cmdLabel = value;
				_CmdTypeActions2.default.updateControlLabel(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'getProperty_AllowEdit_GOTFinal',
			value: function getProperty_AllowEdit_GOTFinal() {
				if (this.finalAllowEditGOT) return this.finalAllowEditGOT;
	
				var result = this.getProperty_AllowEdit_GOT();
				if (!result) {
					if (this.group) {
						var recVersion = this.group.getCurRecVersion();
						if (isNaN(recVersion) == false && recVersion == -1) {
							var componentPro = _GOTUtil2.default.getProperty(this.xml, "Component");
							if (componentPro.hasOwnProperty("refentityid")) {
								var allowEdits = _GOTUtil2.default.getPropertyValue(this.xml, "AllowEdit");
								if (allowEdits == "false" || !allowEdits) {
									var fdsfs = componentPro.V || componentPro.Value;
									var fdss = _GOTUtil2.default.getPropertyValue(this.xml, "DataSource");
									var formDataSourceField = this.group.getFormDataSourceField2(fdsfs, fdss);
									if (formDataSourceField) {
										allowEdits = _GOTUtil2.default.getPropertyValue(formDataSourceField, "AllowEdit");
										if (allowEdits != "" && (allowEdits == "false" || allowEdits == false)) {
											return false;
										}
									}
									var tableId = componentPro.refentityid;
									var tableEntity = _GOT2.default.getTable(tableId);
									if (tableEntity) {
										var tableFieldId = componentPro.refinnerid;
										var tableField = _GOT2.default.getTableField(tableEntity, tableFieldId);
										//allowEdits = GOTUtil.getPropertyValue(tableField,"AllowEdit");
										var allowEditOnCreate = _GOTUtil2.default.getPropertyValue(tableField, "AllowEditOnCreate");
										if (allowEditOnCreate == "true" || allowEditOnCreate) result = true;
									}
								}
							}
						}
					}
				}
	
				if (!result) return false;
	
				result = this.getProperty_AllowEdit_Loop();
				this.finalAllowEditGOT = result;
				return result;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var parentLayout = this.parentXML.Properties.Layout.Value;
				var style = {
					//width:'auto'
	
				};
	
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					var flexGrow = 0;
					var fixedWidth = false;
					var iex = _width.indexOf("%");
					if (iex != -1) {
						flexGrow = _width.substring(0, iex);
					}
	
					if (iex == -1 && _width != "") {
						style['width'] = _width + "px";
						fixedWidth = true;
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;
	
					var _height = this.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 0;
						var fixedHeight = false;
						var _iex = _height2.indexOf("%");
						if (_iex != -1) {
							_flexGrow = _height2.substring(0, _iex);
						}
						if (_iex == -1 && _height2 != "") {
							//flexGrow = _height+"px";
							style['height'] = _height2 + "px";
							fixedHeight = true;
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;
	
						var _width2 = this.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
				style.boxShadow = "none";
				if (this.hasBorderSetted && this.propertyHasBorder) {
					style.border = "solid 1px #ccc";style.margin = "1px";
				} else {
					style.border = "none";
				}
	
				return style;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var columns = this.getProperty_Columns();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var showLabel = this.getProperty_ShowLabel();
				var titleAlign = this.getProperty_HeaderAlign();
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemFieldGroup2.default, _extends({ key: this.xml.id, xml: this.xml, parentXMLId: this.parentControl.xml.id, columns: columns, moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, layout: this.getProperty_Layout(), forLookup: forLookup, groupAlias: this.groupAlias,
					label: label, showLabel: showLabel, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData, titleAlign: titleAlign, control: this }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemFieldGroupControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemFieldGroupControl;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemGroup = __webpack_require__(129);
	
	var _FormItemGroup2 = _interopRequireDefault(_FormItemGroup);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemGroupControl = function (_FormItemContainerCon) {
		_inherits(FormItemGroupControl, _FormItemContainerCon);
	
		function FormItemGroupControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemGroupControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemGroupControl.__proto__ || Object.getPrototypeOf(FormItemGroupControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemGroupControl";
			_this.initExpand = true;
			if (_this.getProperty_Collapsible()) {
				_this.unsubscribeUpdateGroupCollapseStateStore = _CmdTypeStore.UpdateGroupCollapseStateStore.listen(_this.onUpdateGroupCollapseStateStore.bind(_this));
			}
			return _this;
		}
	
		_createClass(FormItemGroupControl, [{
			key: 'onUpdateGroupCollapseStateStore',
			value: function onUpdateGroupCollapseStateStore(arg) {
				if (arg && arg.hasOwnProperty(this.xml.name)) {
					this.initExpand = arg[this.xml.name];
				}
			}
		}, {
			key: 'getProperty_GroupType',
			value: function getProperty_GroupType() {
				return this.properties.GroupType;
			}
		}, {
			key: 'getProperty_ShowBorder',
			value: function getProperty_ShowBorder() {
				return false;
				return this.properties.ShowBorder;
			}
		}, {
			key: 'getProperty_ShowLabel',
			value: function getProperty_ShowLabel() {
				return this.properties.ShowLabel;
			}
		}, {
			key: 'getProperty_Collapsible',
			value: function getProperty_Collapsible() {
				return this.properties.Collapsible;
			}
		}, {
			key: 'getProperty_MainContentAlignment',
			value: function getProperty_MainContentAlignment() {
				return this.properties.MainContentAlignment;
			}
		}, {
			key: 'setControlLabelCmd',
			value: function setControlLabelCmd(value) {
				this._cmdLabel = value;
				_CmdTypeActions2.default.updateControlLabel(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var superStyle = _get(FormItemGroupControl.prototype.__proto__ || Object.getPrototypeOf(FormItemGroupControl.prototype), 'getStyle', this).call(this);
				if (superStyle) {
					var justifyContent = this.getProperty_MainContentAlignment();
					if (!justifyContent) justifyContent = "flex-start";
					superStyle.justifyContent = justifyContent;
					//TODO 与Flex一致,Group加了默认padding
					superStyle.padding = '1px 2px';
	
					if (typeof superStyle.width == "string" && superStyle.width.indexOf("px") != -1) {
						superStyle.overflowX = "auto";
						if (!superStyle.overflowY) superStyle.overflowY = "hidden";
					}
					if (typeof superStyle.height == "string" && superStyle.height.indexOf("px") != -1) {
						superStyle.overflowY = "auto";
						if (!superStyle.overflowX) superStyle.overflowX = "hidden";
					}
				}
	
				return superStyle;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var label = this.getProperty_Label();
				var showLabel = this.getProperty_ShowLabel();
				var commonProps = this.getCommonProps();
				var hasBorder = showLabel;
				var isGroupQuery = this.getProperty_GroupType() == "Query";
				if (this.hasBorderSetted) {
					if (this.propertyHasBorder) {
						/*superStyle.border="solid 1px #ccc";superStyle.margin = "1px";
	     if(this.getProperty_GroupType() == "Query")superStyle.margin="2px";*/
						hasBorder = true;
					}
					/*else
	    {
	    	superStyle.border = "none";
	    }*/
				} else {
					if (isGroupQuery)
						/*{superStyle.border="solid 1px #ccc";superStyle.margin="2px";}*/
						hasBorder = true;else if (this.getProperty_ShowBorder())
						/*{superStyle.border = "solid 1px #ccc";superStyle.margin= "1px";}*/
						hasBorder = true;
					/*else
	    	{superStyle.border = "none";}*/
				}
				this.component = _react2.default.createElement(_FormItemGroup2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId, control: this,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, isGroupQuery: isGroupQuery,
					label: label, hasBorder: hasBorder, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData, showLabel: showLabel, foldable: this.getProperty_Collapsible(), expand: this.initExpand }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemGroupControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemGroupControl;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _FormItemImage = __webpack_require__(130);
	
	var _FormItemImage2 = _interopRequireDefault(_FormItemImage);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormImageControl = function (_GongqiFormItemContro) {
		_inherits(FormImageControl, _GongqiFormItemContro);
	
		function FormImageControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormImageControl);
	
			var _this = _possibleConstructorReturn(this, (FormImageControl.__proto__ || Object.getPrototypeOf(FormImageControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormImageControl";
			//this.contextMenuData.beforeMenuShow = this.beforeContextMenuShow.bind(this);
			return _this;
		}
	
		_createClass(FormImageControl, [{
			key: 'getProperty_MultipleImage',
			value: function getProperty_MultipleImage() {
				return this.properties.MultipleImage;
			}
		}, {
			key: 'getProperty_URL',
			value: function getProperty_URL() {
				return this.properties.URL;
			}
		}, {
			key: 'getProperty_FailureImage',
			value: function getProperty_FailureImage() {
				return this.properties.FailureImage;
			}
		}, {
			key: 'getProperty_Suffix',
			value: function getProperty_Suffix() {
				return this.properties.Suffix;
			}
		}, {
			key: 'getProperty_LayoutMode',
			value: function getProperty_LayoutMode() {
				if (this.properties.hasOwnProperty("LayoutMode")) return this.properties.LayoutMode;
				return this.properties.ImageLayoutMode;
			}
		}, {
			key: 'upLoaderClickHandler',
			value: function upLoaderClickHandler(event) {
				alert("上传点击");
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var width = this.getProperty_Width();
				var height = this.getProperty_Height();
				var parentLayout = this.parentXML.Properties.Layout.Value;
				var style = { flex: "0 0 auto" };
				if (parentLayout == "horizontal") {
					var _width = this.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					if (_width == "") _width = "200";
					if (width) _width = width;
					var flexGrow = 100;
					var fixedWidth = false;
	
					var iex = _width.indexOf("%");
					if (iex != -1) {
						flexGrow = _width.substring(0, iex);
					}
	
					if (iex == -1 && _width != "") {
						flexGrow = _width + "px";
						fixedWidth = true;
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;else style["width"] = flexGrow;
	
					var _height = this.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
					if (_height == "") _height = "200";
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 100;
						var fixedHeight = false;
						if (_height2 == "") _height2 = "200";
						if (height) _height2 = height;
						var _iex = _height2.indexOf("%");
						if (_iex != -1) {
							_flexGrow = _height2.substring(0, _iex);
						}
						if (_iex == -1 && _height2 != "") {
							_flexGrow = _height2 + "px";
							fixedHeight = true;
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;else style["height"] = _flexGrow;
	
						var _width2 = this.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "") _width2 = "200";
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
	
				return style;
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
			}
		}, {
			key: 'getProperty_AllowEdit_Final',
			value: function getProperty_AllowEdit_Final() {
				if (this.group && (this.group.getCurRecVersion() < 0 || this.group.isCurrentRecordModified())) return false;
				return _get(FormImageControl.prototype.__proto__ || Object.getPrototypeOf(FormImageControl.prototype), 'getProperty_AllowEdit_Final', this).call(this);
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this.getProperty_Label();
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemImage2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, multiple: this.getProperty_MultipleImage(),
					label: label, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId, control: this,
					group: this.group, initRecord: this.group ? this.group.currentRecord : null, url: this.getProperty_URL(), failureImage: this.getProperty_FailureImage(),
					contextMenuData: this.contextMenuData, suffix: this.getProperty_Suffix() }, commonProps));
				return this.component;
			}
		}]);
	
		return FormImageControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormImageControl;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemLongEditor = __webpack_require__(131);
	
	var _FormItemLongEditor2 = _interopRequireDefault(_FormItemLongEditor);
	
	var _FormItemLongEditorForDataGrid = __webpack_require__(132);
	
	var _FormItemLongEditorForDataGrid2 = _interopRequireDefault(_FormItemLongEditorForDataGrid);
	
	var _FormItemLongRender = __webpack_require__(245);
	
	var _FormItemLongRender2 = _interopRequireDefault(_FormItemLongRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemLongEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemLongEditorControl, _FormItemEditorContro);
	
		function FormItemLongEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemLongEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemLongEditorControl.__proto__ || Object.getPrototypeOf(FormItemLongEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemLongEditorControl";
			return _this;
		}
	
		_createClass(FormItemLongEditorControl, [{
			key: 'validateNotNull',
			value: function validateNotNull() {
				if (this.group && this.group.currentRecord) {
					var value = this.group.currentRecord[this.getDataField()];
					if (!value || value == "" || value == "0" || value == 0) {
						var _label = this.getProperty_Label();
						return _label + " 不能为空";
					}
				}
				return null;
			}
		}, {
			key: 'getProperty_Alignment',
			value: function getProperty_Alignment() {
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.HorizontalAlignment) return displayStyle.HorizontalAlignment;
				if (this.properties.hasOwnProperty("Alignment")) return this.properties.Alignment;
				return "Right";
			}
		}, {
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 10;
			}
		}, {
			key: 'getProperty_AutoSum',
			value: function getProperty_AutoSum() {
				return this.properties.AutoSum;
			}
		}, {
			key: 'getProperty_AllowNegative',
			value: function getProperty_AllowNegative() {
				if (this.properties.hasOwnProperty("AllowNegative")) return this.properties.AllowNegative;
				return true;
			}
		}, {
			key: 'getProperty_ShowZero',
			value: function getProperty_ShowZero() {
				return this.properties.ShowZero;
			}
		}, {
			key: 'getProperty_ThousandSeperator',
			value: function getProperty_ThousandSeperator() {
				return this.properties.ThousandSeperator;
			}
		}, {
			key: 'getDefaultValue',
			value: function getDefaultValue() {
				var dvalue = _get(FormItemLongEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemLongEditorControl.prototype), 'getDefaultValue', this).call(this);
				if (dvalue == "") {
					dvalue = "0";
				}
				return dvalue;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var displayHeight = this.getProperty_DisplayHeight();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				var displayStyle = this.getProperty_DisplayStyle();
				this.component = _react2.default.createElement(_FormItemLongEditor2.default, _extends({ displayLengthWidth: displayLengthWidth, key: this.xml.id,
					displayLength: displayLength, displayHeight: displayHeight, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					xml: this.xml, parentLayout: layout, forLookup: forLookup, formType: _EditorFormType2.default.FormModule,
					underFieldGroup: parent.type == "FieldGroup", groupAlias: this.groupAlias,
					dataField: this.getDataField(), initRecord: _initRecord,
					label: label, customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData, allowNegative: this.getProperty_AllowNegative(),
					showZero: this.getProperty_ShowZero(), thousandSeperator: this.getProperty_ThousandSeperator(),
					control: this, underQueryGroup: this.isUnderQueryGroup(), verticalAlign: this.getProperty_VAlignment(),
					cssStyle: this.getProperty_CSSStyle_Display() }, commonProps, { displayStyle: displayStyle }));
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemLongEditorForDataGrid2.default, { key: this.xml.id, xml: this.xml, forLookup: forLookup, allowNegative: this.getProperty_AllowNegative(), formType: _EditorFormType2.default.FormModule, control: this, groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, group: this.group });
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemLongRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: this.getDataField(), showZero: this.getProperty_ShowZero(), thousandSeperator: this.getProperty_ThousandSeperator(),
					verticalAlign: this.getProperty_VAlignment(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: forLookup, moduleInstanceId: this.module.instanceUUId,
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemLongRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: dataField, showZero: this.getProperty_ShowZero(), thousandSeperator: this.getProperty_ThousandSeperator(),
					verticalAlign: this.getProperty_VAlignment(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, textAlign: this.getProperty_Alignment(), forLookup: false, moduleInstanceId: this.module.instanceUUId,
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle });
			}
		}]);
	
		return FormItemLongEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemLongEditorControl;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemButtonBaseControl = __webpack_require__(73);
	
	var _FormItemButtonBaseControl2 = _interopRequireDefault(_FormItemButtonBaseControl);
	
	var _FormItemMenuItemButton = __webpack_require__(133);
	
	var _FormItemMenuItemButton2 = _interopRequireDefault(_FormItemMenuItemButton);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _ArgCallerType = __webpack_require__(58);
	
	var _ArgCallerType2 = _interopRequireDefault(_ArgCallerType);
	
	var _GongqiFormItem = __webpack_require__(24);
	
	var _GongqiFormItem2 = _interopRequireDefault(_GongqiFormItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemMenuItemButtonControl = function (_FormItemButtonBaseCo) {
		_inherits(FormItemMenuItemButtonControl, _FormItemButtonBaseCo);
	
		function FormItemMenuItemButtonControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemMenuItemButtonControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemMenuItemButtonControl.__proto__ || Object.getPrototypeOf(FormItemMenuItemButtonControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemMenuItemButtonControl";
			return _this;
		}
	
		_createClass(FormItemMenuItemButtonControl, [{
			key: 'getStyle',
			value: function getStyle() {
				var _style = {};
				var layout = this.parentXML.Properties.Layout.Value;
				var parentType = this.parentXML.type;
				if (parentType == "ButtonGroup" && layout == "vertical") {
					_style["alignSelf"] = 'stretch';
				}
				//宽度高度的设置 其余都是在component中
				_style["padding"] = "1px 6px";
	
				var _width = this.xml.Properties.Width.Value;
				var _height = this.xml.Properties.Height.Value;
	
				if (_width) _style["width"] = _width + "px";
				if (_height) _style["height"] = _height + "px";
	
				return _style;
			}
		}, {
			key: 'getProperty_MenuItem',
			value: function getProperty_MenuItem() {
				return this.properties.MenuItem;
			}
		}, {
			key: 'getProperty_Label',
			value: function getProperty_Label() {
				var showLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				if (this.properties.Label) return this.properties.Label;
				var result = _GOTUtil2.default.getPropertyValue(this.xml, "Label");
				if (result == "") {
					var property = _GOTUtil2.default.getProperty(this.xml, "MenuItem");
					if (property.hasOwnProperty("refentityid")) {
						var menuItem = _GOT2.default.getMenuItem(property.refentityid);
						result = _GOTUtil2.default.getPropertyValue(menuItem, "Label");
					}
				}
				if (result == "") result = this.xml.name;
	
				return result;
			}
		}, {
			key: 'doOpenRelateForm',
			value: function doOpenRelateForm(e) {
				var menuItemProStr = this.getProperty_MenuItem();
				var domParser = new DOMParser();
				var xmlDoc = domParser.parseFromString(menuItemProStr, "text/xml");
				var _xml = xmlDoc.childNodes[0];
				var refEntityId = null; //TODO 属性兼容
				if (_xml && _xml.attributes) {
					for (var i = 0; i < _xml.attributes.length; i++) {
						var att = _xml.attributes[i];
						if (att.nodeName == "refentityid") {
							refEntityId = att.nodeValue;
							break;
						}
					}
				}
	
				if (!refEntityId) refEntityId = menuItemProStr;
				if (!refEntityId) return;
				var menuItem = _GOT2.default.getMenuItem(refEntityId);
				if (!menuItem) return;
				//TODO 完善传给Manual画面的参数
				var commandArg = null;
				// if(menuItem.Properties.LoadType && menuItem.Properties.LoadType == "Manual")
				if (menuItem.name == "SysAuthoritySetup") {
					commandArg = { currentRecord: this.group ? this.group.currentRecord : null };
				}
	
				_FormLoadHelper2.default.openMenuItemByAuthority({ menuItemId: menuItem.id, fm: window.formModuleInstance,
					group: this.group, callerKey: this.controlId, commandArg: commandArg });
				return;
				// if(!menuItemPro.hasOwnProperty("@refentityid"))
				// 	return ;
				// var menuItemId:String = String(menuItemPro.@refentityid);
				// FormLoadHelper.openMenuItemByAuthority(menuItemId, null, this.formDesign.formModule, this.group, null,controlId);
	
				var argCaller = {};
				argCaller.type = _ArgCallerType2.default.FormModule;
				argCaller.callerType = "FormModule";
				argCaller.callerFormId = window.formId;
				argCaller.callerFormInstanceUUId = window.formModuleInstanceuuId;
				argCaller.callerMenuItemId = window.menuItemId;
				argCaller.callerKey = _FormItemUtil2.default.getFormModuleCallerKey(this.menuItemId, this.xml.id);
				argCaller.parm = "parm";
				argCaller.joinGroupAlias = this.groupAlias;
				argCaller.joinTableName = this.group != null ? this.group.mainSource.tableName : null;
				argCaller.joinRecord = this.group != null ? this.group.currentRecord : null;
				//alert(JSON.stringify(argCaller.joinRecord));
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					if (typeof _parentWindow.openMenuItem == 'function') {
						console.log(this.getProperty_MenuItem());
						//TODO 根据menuItem属性对应的menuItemId 找到MenuItem 进而找到formId
						_parentWindow.openMenuItem("40000003", argCaller);
					}
				}
			}
		}, {
			key: 'openRelateForm',
			value: function openRelateForm(e) {
				var isShortCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				if (event.target) {
					if ($(event.target).hasClass("disabled") || $(event.target).parent().hasClass("disabled")) return;
				}
				if (this.forLookup) {
					this.doOpenRelateForm(e);
					return;
				}
				if ((typeof isShortCut === 'undefined' ? 'undefined' : _typeof(isShortCut)) == "object") isShortCut = false;
				var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
	
				if (currentGroup == this.group) {
					if (this.getProperty_SaveRecord() && currentGroup) {
						if (this.getProperty_SaveRecord()) {
							_RecordsActions2.default.RecordAutoSave(this.group.groupAlias);
							if (window.rowChangeAutoSaveFail == true) {
								//借用自动换行自动保存失败的标识
								window.rowChangeAutoSaveFail = false;
								return false;
							}
							this.doOpenRelateForm(e);
						}
					} else if (!currentGroup) {
						this.doOpenRelateForm(e);
					} else {
						this.doOpenRelateForm(e);
					}
				} else {
					if (currentGroup) {
						//alert("自动保存了");
						_RecordsActions2.default.RecordAutoSave(currentGroup.groupAlias);
						this.doOpenRelateForm(e);
					} else {
						//鼠标点击切换 快捷键不切换
						if (isShortCut) this.doOpenRelateForm(e);
						if (this.parentControl && this.parentControl.classAlias == "FormItemButtonMenuControl") {
							this.doOpenRelateForm(e);
						}
					}
				}
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
				_CmdTypeActions2.default.updateControlAllowEdit(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'getJqueryItemUnderButtonMenu',
			value: function getJqueryItemUnderButtonMenu() {
				var $li = $("<li>");
				var $a = $("<a>").html(this.getProperty_Label()).click(this.openRelateForm.bind(this));
				var allowEdit = this.getProperty_AllowEdit_Final();
				var visible = this.getProperty_Visible_Final();
				if (!allowEdit) $li.addClass("disabled").css({ opacity: 0.5 });
				if (!visible) $li.css("display", "none");
				$li.attr("componentName", this.xml.name);
				$li.attr("controlId", this.controlId);
				return $li.append($a);
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemMenuItemButton2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, iconClass: this.getProperty_Icon(),
					label: label, customStyle: this.getStyle(), menuItemId: this.menuItemId,
					formId: this.formId, clickHandler: this.openRelateForm.bind(this), control: this
				}, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemMenuItemButtonControl;
	}(_FormItemButtonBaseControl2.default);
	
	exports.default = FormItemMenuItemButtonControl;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _FormItemPluginTree = __webpack_require__(203);
	
	var _FormItemPluginTree2 = _interopRequireDefault(_FormItemPluginTree);
	
	var _FormItemPluginHtml = __webpack_require__(201);
	
	var _FormItemPluginHtml2 = _interopRequireDefault(_FormItemPluginHtml);
	
	var _FormItemPluginRadio = __webpack_require__(202);
	
	var _FormItemPluginRadio2 = _interopRequireDefault(_FormItemPluginRadio);
	
	var _FormItemPluginComment = __webpack_require__(200);
	
	var _FormItemPluginComment2 = _interopRequireDefault(_FormItemPluginComment);
	
	var _FormItemPluginAttachment = __webpack_require__(199);
	
	var _FormItemPluginAttachment2 = _interopRequireDefault(_FormItemPluginAttachment);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _FormItemConst = __webpack_require__(3);
	
	var _FormItemConst2 = _interopRequireDefault(_FormItemConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemPluginControl = function (_GongqiFormItemContro) {
		_inherits(FormItemPluginControl, _GongqiFormItemContro);
	
		function FormItemPluginControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemPluginControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemPluginControl.__proto__ || Object.getPrototypeOf(FormItemPluginControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemPluginControl";
			_this.module = module;
			return _this;
		}
	
		_createClass(FormItemPluginControl, [{
			key: 'getProperty_ControlType',
			value: function getProperty_ControlType() {
				if (this.properties.hasOwnProperty("ControlType")) return this.properties.ControlType;
				return this.properties.PluginType;
			}
		}, {
			key: 'getProperty_ClassName',
			value: function getProperty_ClassName() {
				if (this.properties.hasOwnProperty("ClassName")) return this.properties.ClassName;
				return this.properties.Parameters;
			}
		}, {
			key: 'getProperty_Visible',
			value: function getProperty_Visible() {
				if (this.properties.hasOwnProperty("Visible")) return this.properties.Visible;
				return this.properties.Visible;
			}
		}, {
			key: 'getProperty_PlaceHolder',
			value: function getProperty_PlaceHolder() {
				if (this.properties.hasOwnProperty("PlaceHolder")) return this.properties.PlaceHolder;
				return this.properties.PlaceHolder;
			}
		}, {
			key: 'getCommandArg',
			value: function getCommandArg() {
				var mi = {};
				var commandArg = CommandResolver.getSendCmd(this.module, this.group ? this.group.groupAlias : null, mi);
				return commandArg;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var parentLayout = this.parentXML.Properties.Layout.Value;
				var style = {};
	
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.getProperty_Width(); //this.xml.Properties.Width.Value;
					if (_width == undefined || _width == 0) _width = "";
					if (typeof _width == "number") _width = _width + "";
					var flexGrow = 0;
					var fixedWidth = false;
					if (_width == "") {
						flexGrow = 100;
					} else {
						var iex = _width.indexOf("%");
						if (iex != -1) {
							flexGrow = _width.substring(0, iex);
							style.width = _width;
						}
	
						if (iex == -1 && _width != "") {
							flexGrow = _width + "px";
							fixedWidth = true;
						}
					}
	
					//style["width"] = "160px";
					if (!fixedWidth) style["flexGrow"] = flexGrow;else style["width"] = flexGrow;
	
					var _height = this.getProperty_Height(); //this.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
					if (_height == "") _height = "100%";
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.getProperty_Height(); //this.xml.Properties.Height.Value;
						if (_height2 == undefined || _height2 == 0) _height2 = "";
						if (typeof _height2 == "number") _height2 = _height2 + "";
						var _flexGrow = 0;
						var fixedHeight = false;
						if (_height2 == "") {
							_flexGrow = 100;
						} else {
							var _iex = _height2.indexOf("%");
							if (_iex != -1) {
								_flexGrow = _height2.substring(0, _iex);
								style.height = _height2;
							}
							if (_iex == -1 && _height2 != "") {
								_flexGrow = _height2 + "px";
								fixedHeight = true;
							}
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;else style["height"] = _flexGrow;
	
						var _width2 = this.getProperty_Width(); //this.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "") _width2 = "100%";
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";
					}
	
				return style;
			}
		}, {
			key: 'isSkipTab',
			value: function isSkipTab() {
				var controlType = this.getProperty_ControlType();
				if (controlType == _FormItemConst2.default.PLUGIN_TYPE_RADIO) {
					return false;
				}
				if (controlType == _FormItemConst2.default.PLUGIN_TYPE_TREE) {
					return false;
				}
				return _get(FormItemPluginControl.prototype.__proto__ || Object.getPrototypeOf(FormItemPluginControl.prototype), 'isSkipTab', this).call(this);
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this.getProperty_Label();
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				var controlType = this.getProperty_ControlType();
				var controlClassName = this.getProperty_ClassName();
				if (controlType == _FormItemConst2.default.PLUGIN_TYPE_TREE) {
					this.component = _react2.default.createElement(_FormItemPluginTree2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
						parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, menuItemId: this.menuItemId,
						label: label, formId: this.formId, group: this.group, customStyle: this.getStyle(),
						control: this }, commonProps));
				} else if (controlType == _FormItemConst2.default.PLUGIN_TYPE_RADIO) {
					this.component = _react2.default.createElement(_FormItemPluginRadio2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
						parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, menuItemId: this.menuItemId,
						label: label, formId: this.formId, group: this.group, customStyle: this.getStyle(),
						control: this }, commonProps));
				} else if (controlType == _FormItemConst2.default.PLUGIN_TYPE_COMMENT || controlClassName == _FormItemConst2.default.PLUGIN_TYPE_COMMENT) {
					this.component = _react2.default.createElement(_FormItemPluginComment2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
						parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, menuItemId: this.menuItemId,
						label: label, formId: this.formId, group: this.group, customStyle: this.getStyle(),
						control: this }, commonProps));
				} else if (controlType == _FormItemConst2.default.PLUGIN_TYPE_ATTACHMENT || controlClassName == _FormItemConst2.default.PLUGIN_TYPE_ATTACHMENT) {
					this.component = _react2.default.createElement(_FormItemPluginAttachment2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
						parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, menuItemId: this.menuItemId,
						label: label, formId: this.formId, group: this.group, customStyle: this.getStyle(),
						control: this }, commonProps));
				} else {
					this.component = _react2.default.createElement(_FormItemPluginHtml2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
						parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias,
						label: label, formId: this.formId, group: this.group, customStyle: this.getStyle(),
						control: this }, commonProps));
				}
				return this.component;
			}
		}]);
	
		return FormItemPluginControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemPluginControl;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemStringEditor = __webpack_require__(95);
	
	var _FormItemStringEditor2 = _interopRequireDefault(_FormItemStringEditor);
	
	var _FormItemStringEditorForDataGrid = __webpack_require__(134);
	
	var _FormItemStringEditorForDataGrid2 = _interopRequireDefault(_FormItemStringEditorForDataGrid);
	
	var _FormItemStringRender = __webpack_require__(247);
	
	var _FormItemStringRender2 = _interopRequireDefault(_FormItemStringRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _MainFormFactory = __webpack_require__(286);
	
	var _MainFormFactory2 = _interopRequireDefault(_MainFormFactory);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	var _ControlPropertyConst = __webpack_require__(47);
	
	var _ControlPropertyConst2 = _interopRequireDefault(_ControlPropertyConst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemStringEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemStringEditorControl, _FormItemEditorContro);
	
		function FormItemStringEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemStringEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemStringEditorControl.__proto__ || Object.getPrototypeOf(FormItemStringEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this._inputCacheKey = null;
			_this._inputCacheKeyInited = false;
	
			_this.classAlias = "FormItemStringEditorControl";
			_this.serverHasLookup = null;
			_this.module = module;
			if (!forLookup) _this.initMainFormContextMenuData();
			_this.unsubscribeUpdateDropDownContenStore = _CmdTypeStore.UpdateDropDownContentStore.listen(_this.onUpdateDropDownContnent.bind(_this));
			var extendsPro = _this.xml.Properties.Extends;
			if (extendsPro) {
				if (extendsPro.refentityid && extendsPro.refinnerid) {
					var table = _GOT2.default.getTable(extendsPro.refentityid);
					if (table) {
						var tableField = _GOT2.default.getTableField(table, extendsPro.refinnerid);
						if (tableField && tableField.type == "Component") {
							var extendsValue = extendsPro.Value;
							if (extendsValue) {
								var arr = extendsValue.split(".");
								_this.componentField = arr.pop();
								_this.componentDim = arr.join(".");
							}
						}
					}
				}
			}
			return _this;
		}
		//插件内部节点带点号
	
	
		_createClass(FormItemStringEditorControl, [{
			key: 'doFieldModifiedRemote',
			value: function doFieldModifiedRemote(dataField, newValue, oldValue, record, comoponent) {
				var extralParms = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
				if (this.group) {
	
					var arr = dataField.split(".");
					var aliasName = arr.shift();
					var fieldName = void 0;
					if (this.componentField) {
						fieldName = this.componentDim;
					} else {
						fieldName = arr.join(".");
					}
					var componentName = null;
					if (this.componentField) componentName = this.componentField;
					extralParms.editorName = this.xml.name;
					extralParms.formDataSourceField = this.formDataSourceField;
					return this.group.doFieldModifiedRemote(aliasName, fieldName, componentName, oldValue, newValue, dataField, record, comoponent, extralParms);
				}
				return true;
			}
		}, {
			key: 'onUpdateDropDownContnent',
			value: function onUpdateDropDownContnent(type, control, formModuleInstanceuuId) {
				if (this.module.instanceUUId == formModuleInstanceuuId && control == this.xml.name) {
					if (type == "numKeyBoard") {
						this.dropDownNumKeyBoard = true;
					} else if (type == "normal") {
						this.dropDownNumKeyBoard = false;
					}
				}
			}
		}, {
			key: 'initMainFormContextMenuData',
			value: function initMainFormContextMenuData() {
				/*TODO用户设置if(ClientSession.getClientSessionInstance().canEnterMainform==false)
	   	return;*/
				// if(this.isDataMethodField == true)
				// 	return;
				var contextMenuItems = this.contextMenuData.items;
				var contextMenuItem = { label: "进入主表[Ctrl+M]", icon: '', isEnterMainForm: true, visible: false, action: this.enterMainForm.bind(this) };
				contextMenuItems.push(contextMenuItem);
	
				/*if(this.serverUpateMainForm != null)
	   {
	   	contextMenuItem.visible = Boolean(FormItem_StringEditor(gongqiFormItem).serverUpateMainForm);
	   	hasMainForm = contextMenuItem.visible;
	   	return;
	   }*/
				var methodName;
	
				if (this.group && this.getDataField()) {
					//MainForm二次开发应为FormDataSourceField的名字 若包含.号 则改为下划线（针对于Component）
					var i = this.getDataField().indexOf(".");
					methodName = _StringUtil2.default.convertToEachFirstUpperCase(this.getDataField().substring(i + 1));
					methodName = this.groupAlias + ".mainForm_" + methodName;
				} else {
					methodName = "mainForm_" + this.xml.name;
				}
	
				var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, window.menuItemId, window.formId);
				if (mi) {
					contextMenuItem.visible = true;
					this.hasMainForm = true;
				} else {
					var hasGotMainForm = _MainFormFactory2.default.hasMainForm(this.formId, this.xml.id, _GOTUtil2.default.getComponentItemName(this.getDataField()));
					if (hasGotMainForm) {
						contextMenuItem.visible = true;
						this.hasMainForm = true;
					}
				}
			}
		}, {
			key: 'enterMainForm',
			value: function enterMainForm() {
				if (!this.hasMainForm) return;
				var e = arguments[0];
				var value = "";
				if (e.hasOwnProperty("currentValue")) {
					value = e.currentValue;
				} else if (!e.currentTarget) return;
	
				if (!e.hasOwnProperty("currentValue")) {
					if ($(e.currentTarget).hasClass("editorGroup")) {
						value = $(e.currentTarget).find(".input-group>input").val();
					} else if ($(e.currentTarget).hasClass("gongqi_render_select")) {
						value = $(e.currentTarget).text();
					} else {
						value = $(e.currentTarget).val();
					}
				}
	
				//let value = $("#input"+this.xml.id).val() || $("#stringRender"+this.xml.id).text();
				//let menuItem = GOT.getMenuItem(this.menuItemId);
				var options = {
					entityId: this.formId, innerId: this.xml.id, componentItemName: _GOTUtil2.default.getComponentItemName(this.getDataField()),
					value: value, record: this.group ? this.group.currentRecord : null, fm: this.module, dataField: this.getDataField(), editorName: this.xml.name,
					groupAlias: this.groupAlias ? this.groupAlias : null, paramString: null
				};
				var extendsPro = _GOTUtil2.default.getProperty(this.xml, "Extends");
				if (extendsPro && extendsPro.refentityid) {
					var table = _GOT2.default.getTable(extendsPro.refentityid);
					if (table) {
						var tableField = _GOT2.default.getTableField(table, extendsPro.refinnerid);
						var filterFieldPro = _GOTUtil2.default.getProperty(tableField, "FilterField");
						var filterField = filterFieldPro.V;
						if (options.record && options.groupAlias) {
							var filterDataField = options.groupAlias + "." + _StringUtil2.default.convertToFirstLowerCase(filterField);
							var filterValue = options.record[filterDataField];
							options.filterValue = filterValue;
						}
					}
				}
	
				_MainFormFactory2.default.callMainForm(options);
	
				//LogHelper.setUserOprLog("进入主表",this.entityId,this.gongqiFormItem?this.gongqiFormItem.dataSource_Alias:"",this.gongqiFormItem?String(this.gongqiFormItem.xml.@name):"");
	
				//dispatchEvent(formModuleEvent);
			}
		}, {
			key: 'getQueryFilteredVaue',
			value: function getQueryFilteredVaue(value) {
				if (value == "" || value == null) return "''";
				if (value == "*") return value;
				var filter = this.getProperty_QueryFilter();
				if (filter == "") filter = "Contains";
	
				if (filter == "Contains") {
					return "*" + value + "*";
				} else if (filter == "NotContains") {
					return "!(*" + value + "*)";
				} else if (filter == "StartWith") {
					return value + "*";
				} else if (filter == "NotStartWith") {
					return "!(" + value + "*)";
				} else if (filter == "EndWith") {
					return "*" + value;
				} else if (filter == "NotEndWith") {
					return "!(*" + value + ")";
				}
	
				return filter == "=" ? value : filter + value;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var displayLengthWidth = this.getDisplayLengthWidth();
				var displayHeight = this.getProperty_DisplayHeight();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var layout = parent.Properties.Layout.Value;
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _customStyle = this.getStyle();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				var displayStyle = this.getProperty_DisplayStyle();
				this.component = _react2.default.createElement(_FormItemStringEditor2.default, _extends({ key: this.xml.id, xml: this.xml, queryOnTextChanging: this.getProperty_SearchMode() == "OnTyping",
					parentLayout: layout, forLookup: forLookup, formType: _EditorFormType2.default.FormModule, allowKeyIn: this.getProperty_AllowKeyIn(),
					displayHeight: displayHeight, displayLength: displayLength, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					displayLengthWidth: displayLengthWidth, groupAlias: this.groupAlias, group: this.group, initEditorValue: this.initEditorValue,
					dataField: this.getDataField(), initRecord: _initRecord, filterField: this.getProperty_FilterField(), filterEditor: this.getProperty_FilterEditor(),
					label: label, customStyle: _customStyle, formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData, trim: this.getProperty_Trim(), changeCase: this.getProperty_ChangeCase(), stringSize: this.getProperty_StringSize(),
					regular: this.getProperty_Regular(), assignedFormLookup: this.getProperty_FormLookup(), dropDownMode: this.getProperty_DropDownMode(),
					control: this, serverSpecify: this.getServerSpecify(), underQueryGroup: this.isUnderQueryGroup(),
					verticalAlign: this.getProperty_VAlignment(), returnLookup: this.getProperty_ReturnLookup() }, commonProps, {
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle }));
				return this.component;
			}
		}, {
			key: 'getProperty_ReturnLookup',
			value: function getProperty_ReturnLookup() {
				return this.properties.ReturnLookup;
			}
		}, {
			key: 'getProperty_DropDownMode',
			value: function getProperty_DropDownMode() {
				var proName = this.properties.hasOwnProperty("LookupMode") ? "LookupMode" : "DropDownMode";
				if (this.properties[proName] == "PullDown") return "drop";else return "pop";
			}
		}, {
			key: 'getProperty_DropDownContent',
			value: function getProperty_DropDownContent() {
				return this.properties.DropDownContent;
			}
		}, {
			key: 'getProperty_FormLookup',
			value: function getProperty_FormLookup() {
				return this.properties.FormLookup;
			}
		}, {
			key: 'getProperty_Trim',
			value: function getProperty_Trim() {
				return this.properties.Trim;
			}
		}, {
			key: 'getProperty_ChangeCase',
			value: function getProperty_ChangeCase() {
				return this.properties.ChangeCase;
			}
		}, {
			key: 'getProperty_StringSize',
			value: function getProperty_StringSize() {
				return this.properties.StringSize;
			}
		}, {
			key: 'getProperty_Regular',
			value: function getProperty_Regular() {
				return this.properties.Regular;
			}
		}, {
			key: 'getProperty_SearchMode',
			value: function getProperty_SearchMode() {
				return this.properties.SearchMode;
			}
		}, {
			key: 'getProperty_AllowKeyIn',
			value: function getProperty_AllowKeyIn() {
				if (!this.properties.hasOwnProperty("AllowKeyIn")) return true;
				return this.properties.AllowKeyIn;
			}
		}, {
			key: 'getProperty_FilterField',
			value: function getProperty_FilterField() {
				var filterField = this.properties.FilterField;
				if (!filterField) {
					var extendsPro = _GOTUtil2.default.getProperty(this.xml, "Extends");
					if (extendsPro && extendsPro.refentityid) {
						var table = _GOT2.default.getTable(extendsPro.refentityid);
						if (table) {
							var tableField = _GOT2.default.getTableField(table, extendsPro.refinnerid);
							var filterFieldPro = _GOTUtil2.default.getProperty(tableField, "FilterField");
							filterField = filterFieldPro.V;
							if (!filterField) {
								if (tableField.type == "Component") {
									var compoentItems = _GOT2.default.getTableFieldComponentItems(tableField);
									for (var i in compoentItems) {
										var item = compoentItems[i];
										if (item.name == this.componentField) {
											var RefDataType = _GOTUtil2.default.getProperty(item, "RefDataType");
											var compDataType = _GOT2.default.getDataType(RefDataType.refentityid);
											if (compDataType.DataTypeRelation) {
												filterField = compDataType.DataTypeRelation.Properties.FilterField.V;
												break;
											}
										}
									}
								} else {
									var _extendsPro = _GOTUtil2.default.getProperty(tableField, "Extends");
									var compDataType = _GOT2.default.getDataType(_extendsPro.refentityid);
									if (compDataType.DataTypeRelation) {
										filterField = compDataType.DataTypeRelation.Properties.FilterField.V;
									}
								}
							}
						}
					}
				}
	
				return filterField;
			}
		}, {
			key: 'getProperty_FilterEditor',
			value: function getProperty_FilterEditor() {
				var xml = this.xml;
				var filterEditorPro = _GOTUtil2.default.getProperty(xml, "FilterEditor");
				if (filterEditorPro && !filterEditorPro.V && !filterEditorPro.Value) {
					if (this.parentControl.classAlias == "FormItemFieldGroupControl") {
						return this.parentControl.getProperty_FilterEditor();
					}
				}
				return filterEditorPro;
				//return this.properties.FilterEditor;
			}
		}, {
			key: 'getProperty_Alignment',
			value: function getProperty_Alignment() {
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.HorizontalAlignment) return displayStyle.HorizontalAlignment;
				if (this.properties.hasOwnProperty("Alignment")) return this.properties.Alignment;
				return "Left";
			}
		}, {
			key: 'getDisplayAsPassword',
			value: function getDisplayAsPassword() {
				//TODO 获取二次开发属性 var key = window.formId+this.xml.id//+ControlPropertyConst.DISPLAYASPASSWORD;
				//var _displayAsPassword:* = formDesign.formModule.getControlProperties(key);
				//if(_displayAsPassword == null)
				//{
				var dataMethod = this.getProperty_DataMethod();
				if (!this.group && dataMethod == "Password") return true;
				if (this.xml.name && typeof this.xml.name == "string" && (this.xml.name.indexOf("Password") != -1 || this.xml.name.indexOf("password") != -1)) return true;
				return false;
				//}
				//return _displayAsPassword;
			}
		}, {
			key: 'isDataAnlysFilter',
			value: function isDataAnlysFilter() {
				if (window.isDataSetView == true) return false;
				return !_MainFormFactory2.default.hasMainForm(this.formId, this.xml.id, _GOTUtil2.default.getComponentItemName(this.getDataField()));
			}
		}, {
			key: 'getServerSpecify',
			value: function getServerSpecify() {
				var methodName;var _dataField = this.getDataField();
				if (this.group && _dataField && _dataField != "") {
					//TODO 以前就有错误? Component中的点号并未改成_ 二次开发应为FormDataSourceField的名字 若包含.号 则改为下划线（针对于Component）
					var i = _dataField.indexOf(".");
					methodName = _StringUtil2.default.convertToEachFirstUpperCase(_dataField.substring(i + 1));
					methodName = this.group.groupAlias + ".openLookup_" + methodName;
				} else {
					methodName = "openLookup_" + this.xml.name;
				}
	
				var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, window.menuItemId, window.formId);
				return mi;
			}
		}, {
			key: 'isMainGroup',
			value: function isMainGroup() {
				//该函数只在主画面被调用 下拉框上不调用 所以直接采用window.formXML
				var firstDataSource = window.formXML.FormDataSources.DataSources[0];
				if (!firstDataSource) return false;
				var mainDataSource = this.module.formDataSources.sources[firstDataSource.name];
				return mainDataSource ? mainDataSource.group == this.group : false;
			}
		}, {
			key: 'getRefEntityId',
			value: function getRefEntityId() {
				var extendsPro = _GOTUtil2.default.getProperty(this.xml, "Extends");
				return extendsPro.refentityid;
			}
		}, {
			key: 'getInputCacheKey',
			value: function getInputCacheKey() {
				if (this._inputCacheKeyInited) return this._inputCacheKey;
				var extendsXML = this.xml.Properties.Extends;
				if (extendsXML.hasOwnProperty("refinnerid")) {
					var extendsValue = extendsXML.Value;
					var dotIndex = extendsValue.indexOf(".");
					if (dotIndex != -1) {
						var componentName = extendsValue.substr(dotIndex + 1);
					}
	
					var tableId = extendsXML.refentityid;
					var tableFieldId = extendsXML.refinnerid;
					var table = _GOT2.default.getTable(tableId);
					var tableField = _GOT2.default.getTableField(table, tableFieldId);
					var extendsPro = _GOTUtil2.default.getProperty(tableField, "Extends");
					if (extendsPro.hasOwnProperty("refentityid")) {
						if (!componentName) {
							this._inputCacheKey = extendsPro.refentityid;
						} else {
							var dataType = _GOT2.default.getDataType(extendsPro.refentityid);
							if (!dataType) throw new Error("InputCacheKey 从FormItem起始未能找到一个DataType");
							var arrayItemList = dataType.DataTypeArrayItems;
							if (Array.isArray(arrayItemList)) {
								for (var i = 0; i < arrayItemList.length; i++) {
									var arrayItem = arrayItemList[i];
									var refProValue = _GOTUtil2.default.getPropertyValue(arrayItem, "RefDataType");
									if (refProValue == componentName) {
										var refPro = _GOTUtil2.default.getProperty(arrayItem, "RefDataType");
										_inputCacheKey = refPro.refentityid;
									}
								}
							}
						}
					}
				} else if (extendsXML.hasOwnProperty("refentityid")) {
					this._inputCacheKey = extendsXML.refentityid;
				}
	
				this._inputCacheKeyInited = true;
				return this._inputCacheKey;
			}
		}, {
			key: 'setControlProperty',
			value: function setControlProperty(property, value) {
				var result = _get(FormItemStringEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemStringEditorControl.prototype), 'setControlProperty', this).call(this, property, value);
				if (!result) {
					if (property == _ControlPropertyConst2.default.IMEENABLE) {
						this.propertyImeEnabel = value;
						this.propertyImeEnabelSetted = true;
						_CmdTypeActions2.default.updateControlProperty(this.xml.name, property, value, this.module.intanceUUId);
						return true;
					}
				}
				return false;
			}
		}, {
			key: 'getRefInnerId',
			value: function getRefInnerId() {
				var extendsPro = _GOTUtil2.default.getProperty(this.xml, "Extends");
				return extendsPro.refinnerid;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				var _parentXML = this.parentXML;
				var _displayHeight = this.getProperty_DisplayHeight();
				var _gridXML = this.parentXML.type == "DataGrid" ? this.parentXML : this.parentControl.parentControl.xml;
				return _react2.default.createElement(_FormItemStringEditorForDataGrid2.default, _defineProperty({ xml: this.xml, forLookup: forLookup, trim: this.getProperty_Trim(), changeCase: this.getProperty_ChangeCase(), stringSize: this.getProperty_StringSize(),
					displayHeight: _displayHeight, regular: this.getProperty_Regular(), formId: this.formId, menuItemId: this.menuItemId, dataField: this.getDataField(), dropDownMode: this.getProperty_DropDownMode(),
					assignedFormLookup: this.getProperty_FormLookup(), group: this.group, formType: _EditorFormType2.default.FormModule, moduleInstanceId: this.module.instanceUUId,
					queryOnTextChanging: this.getProperty_SearchMode() == "OnTyping", filterField: this.getProperty_FilterField(),
					control: this, groupAlias: this.groupAlias, serverSpecify: this.getServerSpecify(), allowKeyIn: this.getProperty_AllowKeyIn(),
					colXml: this.xml, gridXml: _gridXML, contextMenuData: this.contextMenuData,
					returnLookup: this.getProperty_ReturnLookup(), verticalAlign: this.getProperty_VAlignment() }, 'trim', this.getProperty_Trim()));
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var _parentXML = this.parentXML;
				var _gridXML = this.parentXML.type == "DataGrid" ? this.parentXML : this.parentControl.parentControl.xml;
				var isMutiRow = false;
				var _displayHeight = this.getProperty_DisplayHeight();
				if (_displayHeight > 1) {
					isMutiRow = true;
				}
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemStringRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: this.getDataField(), forLookup: forLookup,
					formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: _gridXML, textAlign: this.getProperty_Alignment(),
					isMutiRow: isMutiRow, moduleInstanceId: this.module.instanceUUId, verticalAlign: this.getProperty_VAlignment(),
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle, trim: this.getProperty_Trim() });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var _parentXML = this.parentXML;
				var _gridXML = this.parentXML.type == "DataGrid" ? this.parentXML : this.parentControl.parentControl.xml;
				var isMutiRow = false;
				var _displayHeight = this.getProperty_DisplayHeight();
				if (_displayHeight > 1) {
					isMutiRow = true;
				}
				var displayStyle = this.getProperty_DisplayStyle();
				return _react2.default.createElement(_FormItemStringRender2.default, { contextMenuData: this.contextMenuData, group: this.group, dataField: dataField, forLookup: false,
					formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: _gridXML, textAlign: this.getProperty_Alignment(),
					isMutiRow: isMutiRow, moduleInstanceId: this.module.instanceUUId, verticalAlign: this.getProperty_VAlignment(),
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle });
			}
		}]);
	
		return FormItemStringEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemStringEditorControl;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemButtonBaseControl = __webpack_require__(73);
	
	var _FormItemButtonBaseControl2 = _interopRequireDefault(_FormItemButtonBaseControl);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _RecordsActions = __webpack_require__(15);
	
	var _RecordsActions2 = _interopRequireDefault(_RecordsActions);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _ArgCallerType = __webpack_require__(58);
	
	var _ArgCallerType2 = _interopRequireDefault(_ArgCallerType);
	
	var _FormItemSubFormButton = __webpack_require__(204);
	
	var _FormItemSubFormButton2 = _interopRequireDefault(_FormItemSubFormButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemSubFormButtonControl = function (_FormItemButtonBaseCo) {
		_inherits(FormItemSubFormButtonControl, _FormItemButtonBaseCo);
	
		function FormItemSubFormButtonControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemSubFormButtonControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemSubFormButtonControl.__proto__ || Object.getPrototypeOf(FormItemSubFormButtonControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemSubFormButtonControl";
			return _this;
		}
	
		_createClass(FormItemSubFormButtonControl, [{
			key: 'getStyle',
			value: function getStyle() {
				var _style = {};
				var layout = this.parentXML.Properties.Layout.Value;
				var parentType = this.parentXML.type;
				if (parentType == "ButtonGroup" && layout == "vertical") {
					_style["alignSelf"] = 'stretch';
				}
				//宽度高度的设置 其余都是在component中
				_style["padding"] = "1px 6px";
	
				var _width = this.xml.Properties.Width.Value;
				var _height = this.xml.Properties.Height.Value;
	
				if (_width) _style["width"] = _width + "px";
				if (_height) _style["height"] = _height + "px";
	
				return _style;
			}
		}, {
			key: 'getProperty_SubForm',
			value: function getProperty_SubForm() {
				return this.properties.SubForm;
			}
		}, {
			key: 'getProperty_Label',
			value: function getProperty_Label() {
				var showLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				var result = _GOTUtil2.default.getPropertyValue(this.xml, "Label");
				if (result == "") {
					var property = _GOTUtil2.default.getProperty(this.xml, "SubForm");
					if (property.hasOwnProperty("refentityid")) {
						var form = _GOT2.default.getForm(property.refentityid);
						result = _GOTUtil2.default.getLabelByForm(form, null, false);
					}
				}
				if (result == "") result = this.xml.name;
	
				return result;
			}
		}, {
			key: 'doOpenRelateForm',
			value: function doOpenRelateForm(e) {
				var menuItemProStr = this.getProperty_SubForm();
				var domParser = new DOMParser();
				var xmlDoc = domParser.parseFromString(menuItemProStr, "text/xml");
				var _xml = xmlDoc.childNodes[0];
				var refEntityId = null;
				for (var i = 0; i < _xml.attributes.length; i++) {
					var att = _xml.attributes[i];
					if (att.nodeName == "refentityid") {
						refEntityId = att.nodeValue;
						break;
					}
				}
				if (!refEntityId) return;
				_FormLoadHelper2.default.openFormDirectly({ formId: refEntityId, menuItemId: "-1", fm: window.formModuleInstance,
					group: this.group, callerKey: this.controlId });
				return;
	
				var argCaller = {};
				argCaller.type = _ArgCallerType2.default.FormModule;
				argCaller.callerType = "FormModule";
				argCaller.callerFormId = window.formId;
				argCaller.callerFormInstanceUUId = window.formModuleInstanceuuId;
				argCaller.callerMenuItemId = window.menuItemId;
				argCaller.callerKey = _FormItemUtil2.default.getFormModuleCallerKey(this.menuItemId, this.xml.id);
				argCaller.parm = "parm";
				argCaller.joinGroupAlias = this.groupAlias;
				argCaller.joinTableName = this.group != null ? this.group.mainSource.tableName : null;
				argCaller.joinRecord = this.group != null ? this.group.currentRecord : null;
				//alert(JSON.stringify(argCaller.joinRecord));
				var _parentWindow = window.parent.window;
				if (_parentWindow) {
					if (typeof _parentWindow.openMenuItem == 'function') {
						console.log(this.getProperty_MenuItem());
						//TODO 根据menuItem属性对应的menuItemId 找到MenuItem 进而找到formId
						_parentWindow.openMenuItem("40000003", argCaller);
					}
				}
			}
		}, {
			key: 'openRelateForm',
			value: function openRelateForm(e) {
				var isShortCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				if (event.target) {
					if ($(event.target).hasClass("disabled") || $(event.target).parent().hasClass("disabled")) return;
				}
				if (this.forLookup) {
					this.doOpenRelateForm(e);
					return;
				}
				if ((typeof isShortCut === 'undefined' ? 'undefined' : _typeof(isShortCut)) == "object") isShortCut = false;
				var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
	
				if (currentGroup == this.group) {
					if (this.getProperty_SaveRecord() && currentGroup) {
						if (this.getProperty_SaveRecord()) {
							_RecordsActions2.default.RecordAutoSave(this.group.groupAlias);
							if (window.rowChangeAutoSaveFail == true) {
								//借用自动换行自动保存失败的标识
								window.rowChangeAutoSaveFail = false;
								return false;
							}
							this.doOpenRelateForm(e);
						}
					} else if (!currentGroup) {
						this.doOpenRelateForm(e);
					} else {
						this.doOpenRelateForm(e);
					}
				} else {
					if (currentGroup) {
						//alert("自动保存了");
						_RecordsActions2.default.RecordAutoSave(currentGroup.groupAlias);
						this.doOpenRelateForm(e);
					} else {
						//鼠标点击切换 快捷键不切换
						if (isShortCut) this.doOpenRelateForm(e);
						if (this.parentControl && this.parentControl.classAlias == "FormItemButtonMenuControl") {
							this.doOpenRelateForm(e);
						}
					}
				}
			}
		}, {
			key: 'doSetEnableCmd',
			value: function doSetEnableCmd(value) {
				this._cmdEditFalse = !value;
				_CmdTypeActions2.default.updateControlAllowEdit(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'getJqueryItemUnderButtonMenu',
			value: function getJqueryItemUnderButtonMenu() {
				var $li = $("<li>");
				var $a = $("<a>").html(this.getProperty_Label()).click(this.openRelateForm.bind(this));
				var allowEdit = this.getProperty_AllowEdit_Final();
				var visible = this.getProperty_Visible_Final();
				if (!allowEdit) $li.addClass("disabled").css({ opacity: 0.5 });
				if (!visible) $li.css("display", "none");
				$li.attr("componentName", this.xml.name);
				$li.attr("controlId", this.controlId);
				return $li.append($a);
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemSubFormButton2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, iconClass: this.getProperty_Icon(),
					label: label, customStyle: this.getStyle(), menuItemId: this.menuItemId,
					formId: this.formId, clickHandler: this.openRelateForm.bind(this), control: this
				}, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemSubFormButtonControl;
	}(_FormItemButtonBaseControl2.default);
	
	exports.default = FormItemSubFormButtonControl;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemTab = __webpack_require__(135);
	
	var _FormItemTab2 = _interopRequireDefault(_FormItemTab);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _UtilActions = __webpack_require__(35);
	
	var _UtilActions2 = _interopRequireDefault(_UtilActions);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTabControl = function (_FormItemContainerCon) {
		_inherits(FormItemTabControl, _FormItemContainerCon);
	
		function FormItemTabControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTabControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTabControl.__proto__ || Object.getPrototypeOf(FormItemTabControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTabControl";
			return _this;
		}
	
		_createClass(FormItemTabControl, [{
			key: 'tabPageChanged',
			value: function tabPageChanged(tabPageXML) {
				var tabPageName = tabPageXML.name;
				var tabPageControl = _FormItemUtil2.default.getFormItemControl(_FormItemUtil2.default.getFormItemControlKey(this.menuItemId, this.formId, tabPageXML.id));
	
				if (tabPageControl) {
					var gridControls = [];
					_FormItemUtil2.default.getDataGridUnderFormItem(tabPageControl, gridControls);
					for (var i = 0; i < gridControls.length; i++) {
						var gridControl = gridControls[i];
						_UtilActions2.default.tabpageUserChanged({
							moduleInstanceId: this.module.instanceUUId,
							gridId: gridControl.xml.id
						});
					}
				}
	
				if (this.module && this.module.classAlias == "FormModule") this.module.focusController.initFocus(false, tabPageControl);
				var mi = _FormResourceUtil2.default.getCommandArgMethodInfo("tabPageChanged_" + tabPageName, this.menuItemId, this.formId);
				if (mi) {
					var formModule = this.module;
					if (mi.prefetch == true) {
						_CommandResolver2.default.resolve(mi.commandResult.tasks, formModule, this.group);
					} else {
						var arg = _CommandResolver2.default.getSendCmd(formModule, this.groupAlias, mi);
						var command = _CommandHelper2.default.createFormInstance(formModule.formName, "doTabPageChanged", "CommandResult");
						command.appendArg(tabPageName, "String").appendArg(arg, "CommandArg");
	
						_ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.doTabPageChangedRemoteResultHandler.bind(this), sync: false });
					}
				}
			}
		}, {
			key: 'doTabPageChangedRemoteResultHandler',
			value: function doTabPageChangedRemoteResultHandler(data) {
				_CommandResolver2.default.resolve(data.result.tasks, this.module, this.group);
			}
		}, {
			key: 'setInitSelectIndex',
			value: function setInitSelectIndex(index) {
				this.initSelectIndex = index;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				//对于Tab本身没有任何布局 所以只关心父级布局情况
				var parentLayout = this.parentXML.Properties.Layout.Value;
				//本身固定布局为flex 纵向 因为要布局下面的标签选项卡与内容区域 内容区域填充剩余空间
				var style = {
					display: 'flex',
					flex: 'none',
					flexDirection: 'column',
					paddingTop: '2px'
				};
	
				//如果设置了Width或者Height属性 则按照属性设置 否则为百分百 与Flex版框架保持一致	   
				//但是存在其余控件包含tab而设置成百分百的情况 此情况在Flex版框架中也没有考虑 但是在实际
				//使用过程中并未提出此问题 所以暂不考虑
	
				if (parentLayout == "horizontal") {
					//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
					//alert(json);
					var _width = this.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					var flexGrow = 0;
					var fixedWidth = false;
					if (_width == "") // && !window.isPopUp && !window.isLookup)
						{
							flexGrow = 100;
							//let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
							//if(_containsMaxControl)flexGrow = 100;
						} else {
						var iex = _width.indexOf("%");
						if (iex != -1) {
							flexGrow = _width.substring(0, iex);
							//20210413 支持直接填写百分比 不使用flexGrow代替
							style.width = _width;
						}
	
						if (iex == -1 && _width != "") {
							flexGrow = _width + "px";
							fixedWidth = true;
						}
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;
	
					var _height = this.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
	
					if (_height == "" && !window.isPopUp && !window.isLookup) {
						if (this.module.hasUpDownDataGrid) {
							var _containsMaxControl = this.containsMaxControlForHeight(this.xml);
							if (_containsMaxControl) _height = "100%";
						} else {
							_height = "100%";
						}
					}
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 0;
						var fixedHeight = false;
	
						_flexGrow = 0;
						if (_height2 == "" && !window.isPopUp && !window.isLookup) {
							if (this.module.hasUpDownDataGrid) {
								var _containsMaxControl2 = this.containsMaxControlForHeight(this.xml);
								if (_containsMaxControl2) _flexGrow = 100;
							} else {
								_flexGrow = 100;
							}
						} else {
							var _iex = _height2.indexOf("%");
							if (_iex != -1) {
								_flexGrow = _height2.substring(0, _iex);
								style.height = _height2;
							}
							if (_iex == -1 && _height2 != "") {
								_flexGrow = _height2 + "px";
								fixedHeight = true;
							}
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;else style["height"] = _flexGrow;
	
						var _width2 = this.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "" && !window.isPopUp && !window.isLookup) {
							_width2 = "100%";
							//let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
							//if(_containsMaxControl)_width = "100%";
						}
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";else if (window.isPopUp) style["alignSelf"] = "stretch";
					}
				return style;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var currentIndex = this.initSelectIndex ? this.initSelectIndex : 0;
				var currentIndexBak = currentIndex;
				var unVisibleIndexes = [];
				var currentVisible = void 0;
				for (var i = 0; i < this.childrenControl.length; i++) {
					var currentPageControl = this.childrenControl[i];
					var visible = currentPageControl.getProperty_Visible_Final();
					if (!visible) unVisibleIndexes.push(i);
					if (i == currentIndex) currentVisible = visible;
				}
				while (!currentVisible) {
					if (currentIndex + 1 < this.childrenControl.length) currentIndex++;else currentIndex = 0;
					if (currentIndex == currentIndexBak) {
						currentIndex = -1;break;
					}
					var _currentPageControl = this.childrenControl[currentIndex];
					currentVisible = _currentPageControl.getProperty_Visible_Final();
				}
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemTab2.default, _extends({ key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, customStyle: this.getStyle(),
					formId: this.formId, menuItemId: this.menuItemId, initSelectIndex: currentIndex, unVisiblePages: unVisibleIndexes,
					contextMenuData: this.contextMenuData, control: this }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemTabControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemTabControl;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTabPageControl = function (_FormItemContainerCon) {
		_inherits(FormItemTabPageControl, _FormItemContainerCon);
	
		function FormItemTabPageControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTabPageControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTabPageControl.__proto__ || Object.getPrototypeOf(FormItemTabPageControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTabPageControl";
	
			return _this;
		}
	
		_createClass(FormItemTabPageControl, [{
			key: 'getStyle',
			value: function getStyle() {
				var layout = this.xml.Properties.Layout.Value;
				var parentLayout = this.parentXML.Properties.Layout.Value;
				var _flexDirection = layout == "horizontal" ? "row" : "column";
				var style = {
					flexDirection: _flexDirection,
					alignItems: "flex-start",
					flex: 'none'
				};
				style["display"] = this.props.visible ? "flex" : "none";
				//chrome浏览器在某一父节点没有采用百分比的情况下 子节点设置百分比无效无效 
				//所以采用flex布局
				//style["height"] = "100%";
				style["flexGrow"] = 100;
	
				style["overflow"] = 'auto';
				return style;
			}
		}, {
			key: 'setControlLabelCmd',
			value: function setControlLabelCmd(value) {
				this._cmdLabel = value;
				_CmdTypeActions2.default.updateControlLabel(this.xml.name, value, this.module.instanceUUId);
			}
		}]);
	
		return FormItemTabPageControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemTabPageControl;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemTableCell = __webpack_require__(207);
	
	var _FormItemTableCell2 = _interopRequireDefault(_FormItemTableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTableCellControl = function (_FormItemContainerCon) {
		_inherits(FormItemTableCellControl, _FormItemContainerCon);
	
		function FormItemTableCellControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTableCellControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTableCellControl.__proto__ || Object.getPrototypeOf(FormItemTableCellControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTableCellControl";
			return _this;
		}
	
		_createClass(FormItemTableCellControl, [{
			key: 'getProperty_Width',
			value: function getProperty_Width() {
				return this.properties.Width;
			}
		}, {
			key: 'getProperty_ColSpan',
			value: function getProperty_ColSpan() {
				var colspan = this.properties.ColSpan;
				if (!colspan) return 1;
				return colspan;
			}
		}, {
			key: 'getProperty_RowSpan',
			value: function getProperty_RowSpan() {
				var rowspan = this.properties.RowSpan;
				if (!rowspan) return 1;
				return rowspan;
			}
		}, {
			key: 'getProperty_BorderLeft',
			value: function getProperty_BorderLeft() {
				return "solid 1px #000";
			}
		}, {
			key: 'getProperty_BorderRight',
			value: function getProperty_BorderRight() {
				return "solid 1px #000";
			}
		}, {
			key: 'getProperty_BorderTop',
			value: function getProperty_BorderTop() {
				return "solid 1px #000";
			}
		}, {
			key: 'getProperty_BorderBottom',
			value: function getProperty_BorderBottom() {
				return "solid 1px #000";
			}
		}, {
			key: 'getProperty_HorizontalAlignment',
			value: function getProperty_HorizontalAlignment() {
				return "center";
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var style = {};
				//let length = this.parentControl.childrenControl.length;
				//style.width = 
	
				var _width = this.getProperty_Width();
				if (_width) {
					style.width = _width + "px";
				}
	
				var _height = this.getProperty_Height();
				if (_height) {
					style.height = _height + "px";
				}
	
				return style;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				this.component = _react2.default.createElement(_FormItemTableCell2.default, { key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					control: this, colspan: this.getProperty_ColSpan(), rowspan: this.getProperty_RowSpan(),
					forLookup: forLookup, groupAlias: this.groupAlias, horizontalAlignment: this.getProperty_HorizontalAlignment(),
					customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData, borderLeft: this.getProperty_BorderLeft(), borderRight: this.getProperty_BorderRight(),
					borderTop: this.getProperty_BorderTop(), borderBottom: this.getProperty_BorderBottom() });
				return this.component;
			}
		}]);
	
		return FormItemTableCellControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemTableCellControl;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemTable = __webpack_require__(206);
	
	var _FormItemTable2 = _interopRequireDefault(_FormItemTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTableControl = function (_FormItemContainerCon) {
		_inherits(FormItemTableControl, _FormItemContainerCon);
	
		function FormItemTableControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTableControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTableControl.__proto__ || Object.getPrototypeOf(FormItemTableControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTableRowControl";
			return _this;
		}
	
		_createClass(FormItemTableControl, [{
			key: 'getProperty_Height',
			value: function getProperty_Height() {
				return this.properties.Height;
			}
		}, {
			key: 'getProperty_HorizontalAlignment',
			value: function getProperty_HorizontalAlignment() {
				return "center"; //this.properties.HorizontalAlignment;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				//对于Tab本身没有任何布局 所以只关心父级布局情况
				var parentLayout = this.parentXML.Properties.Layout.Value;
				//本身固定布局为flex 纵向 因为要布局下面的标签选项卡与内容区域 内容区域填充剩余空间
				var style = {
					borderCollapse: 'collapse'
				};
	
				//如果设置了Width或者Height属性 则按照属性设置 否则为百分百 与Flex版框架保持一致	   
				//但是存在其余控件包含tab而设置成百分百的情况 此情况在Flex版框架中也没有考虑 但是在实际
				//使用过程中并未提出此问题 所以暂不考虑
	
				if (parentLayout == "horizontal") {
					var _width = this.xml.Properties.Width.Value;
					if (_width == undefined) _width = "";
					var flexGrow = 0;
					var fixedWidth = false;
					if (_width == "") // && !window.isPopUp && !window.isLookup)
						{
							flexGrow = 100;
						} else {
						var iex = _width.indexOf("%");
						if (iex != -1) {
							flexGrow = _width.substring(0, iex);
							//20210413 支持直接填写百分比 不使用flexGrow代替
							style.width = _width;
						}
	
						if (iex == -1 && _width != "") {
							flexGrow = _width + "px";
							fixedWidth = true;
						}
					}
	
					if (!fixedWidth) style["flexGrow"] = flexGrow;
	
					var _height = this.xml.Properties.Height.Value;
					if (_height == undefined) _height = "";
	
					if (_height == "" && !window.isPopUp && !window.isLookup) {
						if (this.module.hasUpDownDataGrid) {
							var _containsMaxControl = this.containsMaxControlForHeight(this.xml);
							if (_containsMaxControl) _height = "100%";
						} else {
							_height = "100%";
						}
					}
					if (_height == "100%") style["alignSelf"] = "stretch";else if (_height.indexOf("%") != -1) style["height"] = _height;else if (_height != "") style["height"] = _height + "px";
				} else //vertical 暂不考虑absolute
					{
						var _height2 = this.xml.Properties.Height.Value;
						if (_height2 == undefined) _height2 = "";
						var _flexGrow = 0;
						var fixedHeight = false;
	
						_flexGrow = 0;
						if (_height2 == "" && !window.isPopUp && !window.isLookup) {
							if (this.module.hasUpDownDataGrid) {
								var _containsMaxControl2 = this.containsMaxControlForHeight(this.xml);
								if (_containsMaxControl2) _flexGrow = 100;
							} else {
								_flexGrow = 100;
							}
						} else {
							var _iex = _height2.indexOf("%");
							if (_iex != -1) {
								_flexGrow = _height2.substring(0, _iex);
								style.height = _height2;
							}
							if (_iex == -1 && _height2 != "") {
								_flexGrow = _height2 + "px";
								fixedHeight = true;
							}
						}
	
						if (!fixedHeight) style["flexGrow"] = _flexGrow;else style["height"] = _flexGrow;
	
						var _width2 = this.xml.Properties.Width.Value;
						if (_width2 == undefined) _width2 = "";
						if (_width2 == "" && !window.isPopUp && !window.isLookup) {
							_width2 = "100%";
							//let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
							//if(_containsMaxControl)_width = "100%";
						}
						if (_width2 == "100%") style["alignSelf"] = "stretch";else if (_width2.indexOf("%") != -1) style["width"] = _width2;else if (_width2 != "") style["width"] = _width2 + "px";else if (window.isPopUp) style["alignSelf"] = "stretch";
					}
	
				return style;
			}
		}, {
			key: 'containsMaxControlForHeight',
			value: function containsMaxControlForHeight(item) {
				return false;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				this.component = _react2.default.createElement(_FormItemTable2.default, { key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					control: this, forLookup: forLookup, groupAlias: this.groupAlias,
					customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData });
				return this.component;
			}
		}]);
	
		return FormItemTableControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemTableControl;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemContainerControl = __webpack_require__(37);
	
	var _FormItemContainerControl2 = _interopRequireDefault(_FormItemContainerControl);
	
	var _FormItemTableRow = __webpack_require__(208);
	
	var _FormItemTableRow2 = _interopRequireDefault(_FormItemTableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTableRowControl = function (_FormItemContainerCon) {
		_inherits(FormItemTableRowControl, _FormItemContainerCon);
	
		function FormItemTableRowControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTableRowControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTableRowControl.__proto__ || Object.getPrototypeOf(FormItemTableRowControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTableRowControl";
			return _this;
		}
	
		_createClass(FormItemTableRowControl, [{
			key: 'getProperty_Height',
			value: function getProperty_Height() {
				return this.properties.Height;
			}
		}, {
			key: 'getProperty_HorizontalAlignment',
			value: function getProperty_HorizontalAlignment() {
				return "center"; //this.properties.HorizontalAlignment;
			}
		}, {
			key: 'getStyle',
			value: function getStyle() {
				var style = {};
				var _height = this.getProperty_Height();
				if (_height) {
					style.height = _height + "px";
				}
				return style;
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				this.component = _react2.default.createElement(_FormItemTableRow2.default, { key: this.xml.id, xml: this.xml, moduleInstanceId: this.module.instanceUUId,
					control: this, forLookup: forLookup, groupAlias: this.groupAlias,
					customStyle: this.getStyle(), formId: this.formId, menuItemId: this.menuItemId,
					contextMenuData: this.contextMenuData });
				return this.component;
			}
		}]);
	
		return FormItemTableRowControl;
	}(_FormItemContainerControl2.default);
	
	exports.default = FormItemTableRowControl;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GongqiFormItemControl = __webpack_require__(42);
	
	var _GongqiFormItemControl2 = _interopRequireDefault(_GongqiFormItemControl);
	
	var _FormItemText = __webpack_require__(209);
	
	var _FormItemText2 = _interopRequireDefault(_FormItemText);
	
	var _CmdTypeActions = __webpack_require__(21);
	
	var _CmdTypeActions2 = _interopRequireDefault(_CmdTypeActions);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTextControl = function (_GongqiFormItemContro) {
		_inherits(FormItemTextControl, _GongqiFormItemContro);
	
		function FormItemTextControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTextControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTextControl.__proto__ || Object.getPrototypeOf(FormItemTextControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTextControl";
			_this.unsubscribeCmdWriteControlStore = _CmdTypeStore.CmdWriteControlStore.listen(_this.onCmdWriteControlStore.bind(_this));
			return _this;
		}
	
		_createClass(FormItemTextControl, [{
			key: 'getStyle',
			value: function getStyle() {
				var _style = _get(FormItemTextControl.prototype.__proto__ || Object.getPrototypeOf(FormItemTextControl.prototype), 'getStyle', this).call(this);
				var propertyWidth = this.getProperty_Width();
				if (propertyWidth) _style["width"] = propertyWidth + "px";
				return _style;
			}
		}, {
			key: 'getProperty_DisplayStyle',
			value: function getProperty_DisplayStyle() {
				if (this._castedDisplayStyle) return this._castedDisplayStyle;
				var _displayStyle = this.properties.DisplayStyle;
				try {
					_displayStyle = JSON.parse(_displayStyle);
				} catch (e) {}
				this._castedDisplayStyle = _displayStyle;
				return this._castedDisplayStyle;
			}
		}, {
			key: 'getProperty_Alignment',
			value: function getProperty_Alignment() {
				var displayStyle = this.getProperty_DisplayStyle();
				if (displayStyle && displayStyle.HorizontalAlignment) return displayStyle.HorizontalAlignment;
				return this.properties.Alignment;
			}
		}, {
			key: 'getProperty_AlignBase',
			value: function getProperty_AlignBase() {
				return this.properties.AlignBase;
			}
		}, {
			key: 'getProperty_DisplayLength',
			value: function getProperty_DisplayLength() {
				return this.properties.DisplayLength;
			}
		}, {
			key: 'getProperty_DisplayHeight',
			value: function getProperty_DisplayHeight() {
				return this.properties.DisplayHeight;
			}
		}, {
			key: 'setControlLabelCmd',
			value: function setControlLabelCmd(value) {
				this._cmdLabel = value;
				_CmdTypeActions2.default.updateControlLabel(this.xml.name, value, this.module.instanceUUId);
			}
		}, {
			key: 'onCmdWriteControlStore',
			value: function onCmdWriteControlStore(arg, moduleInstanceId) {
				if (arg && arg.hasOwnProperty(this.xml.name) && this.module.instanceUUId == moduleInstanceId) {
					var value = arg[this.xml.name];
					this.initEditorValue = value;
				}
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
	
				label = label.replace(/\\n/g, "<br/>");
				var layout = parent.Properties.Layout.Value;
				var commonProps = this.getCommonProps();
				this.component = _react2.default.createElement(_FormItemText2.default, _extends({ key: this.xml.id, xml: this.xml, alignMent: this.getProperty_Alignment(), moduleInstanceId: this.module.instanceUUId,
					parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, alignBase: this.getProperty_AlignBase(),
					label: label, customStyle: this.getStyle(), menuItemId: this.menuItemId, formId: this.formId, displayLength: this.getProperty_DisplayLength(),
					control: this, displayHeight: this.getProperty_DisplayHeight(), initEditorValue: this.initEditorValue }, commonProps));
				return this.component;
			}
		}]);
	
		return FormItemTextControl;
	}(_GongqiFormItemControl2.default);
	
	exports.default = FormItemTextControl;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorControl = __webpack_require__(41);
	
	var _FormItemEditorControl2 = _interopRequireDefault(_FormItemEditorControl);
	
	var _FormItemTimeEditor = __webpack_require__(96);
	
	var _FormItemTimeEditor2 = _interopRequireDefault(_FormItemTimeEditor);
	
	var _FormItemTimeEditorForDataGrid = __webpack_require__(136);
	
	var _FormItemTimeEditorForDataGrid2 = _interopRequireDefault(_FormItemTimeEditorForDataGrid);
	
	var _FormItemTimeRender = __webpack_require__(248);
	
	var _FormItemTimeRender2 = _interopRequireDefault(_FormItemTimeRender);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _EditorFormType = __webpack_require__(38);
	
	var _EditorFormType2 = _interopRequireDefault(_EditorFormType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemTimeEditorControl = function (_FormItemEditorContro) {
		_inherits(FormItemTimeEditorControl, _FormItemEditorContro);
	
		function FormItemTimeEditorControl(menuItemId, formId, parent, xml, group, module, forLookup) {
			_classCallCheck(this, FormItemTimeEditorControl);
	
			var _this = _possibleConstructorReturn(this, (FormItemTimeEditorControl.__proto__ || Object.getPrototypeOf(FormItemTimeEditorControl)).call(this, menuItemId, formId, parent, xml, group, module, forLookup));
	
			_this.classAlias = "FormItemTimeEditorControl";
			return _this;
		}
	
		_createClass(FormItemTimeEditorControl, [{
			key: 'getDefaultDisplayLength',
			value: function getDefaultDisplayLength() {
				return 12;
			}
		}, {
			key: 'getProperty_ShowHour',
			value: function getProperty_ShowHour() {
				return true;
				return this.properties.ShowHour;
			}
		}, {
			key: 'getProperty_ShowMinute',
			value: function getProperty_ShowMinute() {
				return true;
				return this.properties.ShowMinute;
			}
		}, {
			key: 'getProperty_ShowSecond',
			value: function getProperty_ShowSecond() {
				return true;
				return this.properties.ShowSecond;
			}
		}, {
			key: 'getDefaultValue',
			value: function getDefaultValue() {
				var dvalue = _get(FormItemTimeEditorControl.prototype.__proto__ || Object.getPrototypeOf(FormItemTimeEditorControl.prototype), 'getDefaultValue', this).call(this);
				if (dvalue == "") {
					dvalue = "00:00:00";
				}
				return dvalue;
			}
		}, {
			key: 'getProperty_DisplayFormat',
			value: function getProperty_DisplayFormat() {
				var _displayStyle = this.getProperty_DisplayStyle();
				if (_displayStyle && _displayStyle.DisplayFormat) try {
					return _displayStyle.DisplayFormat.toUpperCase().replace(new RegExp("M", "g"), "N");
				} catch (e) {}
				return "";
			}
		}, {
			key: 'getComponentInstance',
			value: function getComponentInstance(parent, forLookup) {
				var layout = parent.Properties.Layout.Value;
				var displayLengthWidth = this.getDisplayLengthWidth();
				var label = this._cmdLabel ? this._cmdLabel : this.getProperty_Label();
				var commonProps = this.getCommonProps();
				var displayLength = this.propertyDisplayLength ? this.propertyDisplayLength : this.getProperty_DisplayLength();
				var displayHeight = this.getProperty_DisplayHeight();
				var notNull = this.propertyNotNull ? this.propertyNotNull : this.getProperty_NotNull();
				var _initRecord = this.record;
				if (!_initRecord) {
					if (!this.group) {
						var defaultValue = this.getDefaultValue();
						_initRecord = defaultValue;
					}
				}
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				this.component = _react2.default.createElement(_FormItemTimeEditor2.default, _extends({ displayLengthWidth: displayLengthWidth, key: this.xml.id,
					displayLength: displayLength, displayHeight: displayHeight, notNull: notNull, moduleInstanceId: this.module.instanceUUId,
					xml: this.xml, parentLayout: layout, forLookup: forLookup, groupAlias: this.groupAlias, formType: _EditorFormType2.default.FormModule,
					dataField: this.getDataField(), initRecord: _initRecord, label: label, customStyle: this.getStyle(),
					formId: this.formId, menuItemId: this.menuItemId, contextMenuData: this.contextMenuData,
					showHour: this.getProperty_ShowHour(), showMinute: this.getProperty_ShowMinute(), showSecond: this.getProperty_ShowSecond(),
					control: this, underQueryGroup: this.isUnderQueryGroup(), verticalAlign: this.getProperty_VAlignment(),
					cssStyle: this.getProperty_CSSStyle_Display(), displayStyle: displayStyle, displayFormat: displayFormat }, commonProps));
				return this.component;
			}
		}, {
			key: 'getComponentInstanceForDataGrid',
			value: function getComponentInstanceForDataGrid(parent, forLookup) {
				return _react2.default.createElement(_FormItemTimeEditorForDataGrid2.default, { key: this.xml.id, xml: this.xml, forLookup: forLookup, formType: _EditorFormType2.default.FormModule, control: this, groupAlias: this.groupAlias, moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML, group: this.group
				});
			}
		}, {
			key: 'getRenderForDataGrid',
			value: function getRenderForDataGrid(forLookup) {
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				return _react2.default.createElement(_FormItemTimeRender2.default, { contextMenuData: this.contextMenuData, group: this.group, forLookup: forLookup,
					dataField: this.getDataField(), showHour: this.getProperty_ShowHour(), showMinute: this.getProperty_ShowMinute(),
					showSecond: this.getProperty_ShowSecond(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML,
					textAlign: this.getProperty_Alignment(), moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), cssStyle: this.getProperty_CSSStyle_Display(),
					displayStyle: displayStyle, displayFormat: displayFormat });
			}
		}, {
			key: 'getRenderForDynamicColumn',
			value: function getRenderForDynamicColumn(dataField) {
				var displayStyle = this.getProperty_DisplayStyle();
				var displayFormat = this.getProperty_DisplayFormat();
				return _react2.default.createElement(_FormItemTimeRender2.default, { contextMenuData: this.contextMenuData, group: this.group, forLookup: false,
					dataField: dataField, showHour: this.getProperty_ShowHour(), showMinute: this.getProperty_ShowMinute(),
					showSecond: this.getProperty_ShowSecond(), formId: this.formId, menuItemId: this.menuItemId, colXml: this.xml, gridXml: this.parentXML,
					textAlign: this.getProperty_Alignment(), moduleInstanceId: this.module.instanceUUId,
					verticalAlign: this.getProperty_VAlignment(), cssStyle: this.getProperty_CSSStyle_Display(),
					displayStyle: displayStyle, displayFormat: displayFormat });
			}
		}]);
	
		return FormItemTimeEditorControl;
	}(_FormItemEditorControl2.default);
	
	exports.default = FormItemTimeEditorControl;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItemBooleanRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemBooleanRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemBooleanRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemBooleanRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemBooleanRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemBooleanRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemBooleanRenderForAutoLookup, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				//disabled={true} 
				var _value = this.props.value;
				var boolvalue = _value == "true" || _value || _value == "1";
				var _style = { textAlign: 'center', marginTop: '0px' };
				return _react2.default.createElement(
					'div',
					{ className: 'checkbox', style: _style, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					_react2.default.createElement(
						'label',
						{ style: { paddingLeft: '26px' } },
						_react2.default.createElement('input', { type: 'checkbox', ref: 'checkdom', checked: boolvalue, defaultChecked: boolvalue })
					)
				);
			}
		}]);
	
		return FormItemBooleanRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemBooleanRenderForAutoLookup;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemDateRender = function (_FormItemEditorRender) {
		_inherits(FormItemDateRender, _FormItemEditorRender);
	
		function FormItemDateRender(props) {
			_classCallCheck(this, FormItemDateRender);
	
			return _possibleConstructorReturn(this, (FormItemDateRender.__proto__ || Object.getPrototypeOf(FormItemDateRender)).call(this, props));
		}
	
		_createClass(FormItemDateRender, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
	
				var displayFormat = this.props.displayFormat;
				if (displayFormat) {
					_value = _FormItemDateDisplay2.default.getDisplayText2(_value, displayFormat);
				} else {
					_value = _FormItemDateDisplay2.default.getDisplayText(_value, this.props.show1970, this.props.seperator, this.props.numOfDay, this.props.numOfMonth, this.props.numOfYear);
				}
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var newValue = this.props.rowData[this.props.dataField];
				var displayValue = this.getDisplay(newValue);
	
				var _display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: "3px" };
				_style.textAlign = this.props.textAlign.toLowerCase();
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color); //rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor); //rowStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color); //colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor); //colStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				var _clsName = "gongqi_render_select";
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (_display == "block") _clsName += " gongqi_render_version0";
				return _react2.default.createElement(
					'div',
					{ className: _clsName, ref: function ref(node) {
							return _this2.componentLabel = node;
						}, style: _style },
					displayValue,
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.modifiedTag = node;
						}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
				);
			}
		}]);
	
		return FormItemDateRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemDateRender;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	var _FormItemDateDisplay = __webpack_require__(48);
	
	var _FormItemDateDisplay2 = _interopRequireDefault(_FormItemDateDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemDateRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemDateRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemDateRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemDateRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemDateRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemDateRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemDateRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
	
				//Gongqi 如果继承了DataType 则此处肯定不是空 是空说明没有继承DataType 没有格式化显示设置 所以直接返回后台数据
				if (!this.props.seperator) return _value;
	
				_value = _FormItemDateDisplay2.default.getDisplayText(_value, this.props.show1970, this.props.seperator, this.props.numOfDay, this.props.numOfMonth, this.props.numOfYear);
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var newValue = this.props.rowData[this.props.dataField];
				var displayValue = this.getDisplay(newValue);
	
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					displayValue
				);
			}
		}]);
	
		return FormItemDateRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemDateRenderForAutoLookup;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _FormItemDateTimeDisplay = __webpack_require__(97);
	
	var _FormItemDateTimeDisplay2 = _interopRequireDefault(_FormItemDateTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemDateTimeRender = function (_FormItemEditorRender) {
		_inherits(FormItemDateTimeRender, _FormItemEditorRender);
	
		function FormItemDateTimeRender(props) {
			_classCallCheck(this, FormItemDateTimeRender);
	
			return _possibleConstructorReturn(this, (FormItemDateTimeRender.__proto__ || Object.getPrototypeOf(FormItemDateTimeRender)).call(this, props));
		}
	
		_createClass(FormItemDateTimeRender, [{
			key: 'testDragStart',
			value: function testDragStart(e) {
				//var data = e.dataTransfer;
				var billData = {};
				var billTable = {};
				for (var key in this.props.rowData) {
					if (key.indexOf(".") != -1) {
						var keyArr = key.split(".");
						var subKey = keyArr[keyArr.length - 1];
						var dataSourceFields = this.props.group.mainSource.xml.FormDataSourceFields;
						var caseUp = _StringUtil2.default.convertToEachFirstUpperCase(subKey);
						for (var index in dataSourceFields) {
							if (dataSourceFields[index].qname == "FormDataSourceField" && dataSourceFields[index].name == caseUp) {
								var fieldLabel = GOTUtil.getFinalValue(dataSourceFields[index], this.props.group.formDataSources.formModule.props.xml, "Label");
								billTable[fieldLabel] = this.props.rowData[key];
							};
						}
					}
				}
				billData["billTable"] = billTable;
	
				var groups = this.props.group.formDataSources.groups;
				var purchLineGroup = null;
				for (var _key in groups) {
					var _group = groups[_key];
					if (_group.linkGroup == this.props.group) {
						purchLineGroup = _group;break;
					}
				}
	
				if (purchLineGroup) {
					var billLines = [];
					var length = purchLineGroup.records ? purchLineGroup.records.length : 0;
					for (var i = 0; i < length; i++) {
						var _record = purchLineGroup.records[i];
						var _lineItem = {};
						for (var _key2 in _record) {
							if (_key2.indexOf(".") != -1) {
								var _keyArr = _key2.split(".");
								var _subKey = _keyArr[_keyArr.length - 1];
								var _dataSourceFields = purchLineGroup.mainSource.xml.FormDataSourceFields;
								var _caseUp = _StringUtil2.default.convertToEachFirstUpperCase(_subKey);
								for (var _index in _dataSourceFields) {
									if (_dataSourceFields[_index].qname == "FormDataSourceField" && _dataSourceFields[_index].name == _caseUp) {
										var _fieldLabel = GOTUtil.getFinalValue(_dataSourceFields[_index], this.props.group.formDataSources.formModule.props.xml, "Label");
										_lineItem[_fieldLabel] = _record[_key2];
									};
								}
							}
						}
						billLines.push(_lineItem);
					}
					billData["billLines"] = billLines;
				}
				var dragHandlerFunc = this.props.column.dragStartHandler;
				dragHandlerFunc(e, billData);
			}
		}, {
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				var _dislayFormat = this.props.displayFormat;
				if (_dislayFormat) {
					_value = _FormItemDateTimeDisplay2.default.getDisplayText2(_value, _dislayFormat);
				} else {
					_value = _FormItemDateTimeDisplay2.default.getDisplayText(_value);
				}
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _display = "none";
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				_display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
	
				var _style = { padding: "3px" };
				_style.textAlign = this.props.textAlign.toLowerCase();
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				var rowStyles = this.getRowStyles();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color); //rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor); //rowStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color); //colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor); //colStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
	
				if (this.props.isMutiRow) {
					_style.whiteSpace = "pre-wrap";
					_style.wordWrap = "break-word";
					_style.wordBreak = "break-all";
				}
				var dragHandlerFunc = null;
				if (this.props.column && this.props.column.dragStartHandler) {
					if (typeof this.props.column.dragStartHandler == "function") {
						dragHandlerFunc = this.props.column.dragStartHandler;
					}
				}
				var _clsName = "gongqi_render_select";if (_display == "block") _clsName += " gongqi_render_version0";
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (dragHandlerFunc) {
					return _react2.default.createElement(
						'div',
						{ draggable: 'true', onDragStart: this.testDragStart.bind(this), className: _clsName, ref: function ref(node) {
								return _this2.componentLabel = node;
							}, style: _style },
						_value,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this2.modifiedTag = node;
							}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: _clsName, ref: function ref(node) {
								return _this2.componentLabel = node;
							}, style: _style },
						_value,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this2.modifiedTag = node;
							}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
					);
				}
			}
		}]);
	
		return FormItemDateTimeRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemDateTimeRender;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	var _FormItemDateTimeDisplay = __webpack_require__(97);
	
	var _FormItemDateTimeDisplay2 = _interopRequireDefault(_FormItemDateTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemDateTimeRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemDateTimeRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemDateTimeRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemDateTimeRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemDateTimeRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemDateTimeRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemDateTimeRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				_value = _FormItemDateTimeDisplay2.default.getDisplayText(_value);
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var newValue = this.props.rowData[this.props.dataField];
				var displayValue = this.getDisplay(newValue);
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					displayValue
				);
			}
		}]);
	
		return FormItemDateTimeRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemDateTimeRenderForAutoLookup;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _CmdTypeStore = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemDecimalRender = function (_FormItemEditorRender) {
		_inherits(FormItemDecimalRender, _FormItemEditorRender);
	
		function FormItemDecimalRender(props) {
			_classCallCheck(this, FormItemDecimalRender);
	
			var _this = _possibleConstructorReturn(this, (FormItemDecimalRender.__proto__ || Object.getPrototypeOf(FormItemDecimalRender)).call(this, props));
	
			_this.unsubcribeCmdUpdateControlVisibleStore = _CmdTypeStore.CmdUpdateShowDecimalStore.listen(_this.onCmdUpdateShowDecimal.bind(_this));
			return _this;
		}
	
		_createClass(FormItemDecimalRender, [{
			key: 'onCmdUpdateShowDecimal',
			value: function onCmdUpdateShowDecimal(name, _value, moduleInstanceId) {
				if (name == _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField).replace(".", "_")) {
					this.state['_cmdDisplayDecimal'] = _value;
					if (!window.doUpformItemShowDecimalValueMap) {
						window.doUpformItemShowDecimalValueMap = {};
						window.doUpformItemShowDecimalValueMap[name] = _value;
					} else {
						window.doUpformItemShowDecimalValueMap[name] = _value;
					}
					this.setState({});
				}
			}
		}, {
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
	
				var parms = {};
	
				if (this.props.displayStyle) {
					var _displayStyle = this.props.displayStyle;
					if (_displayStyle.IsPercent == true) {
						parms.type = "percent";
					} else if (_displayStyle.CurrencyPrefix) {
						parms.type = "prefix";
						parms.prefix = _displayStyle.CurrencyPrefix;
					} else {
						parms.type = "normal";
					}
				}
				var sname = _StringUtil2.default.convertToEachFirstUpperCase(this.props.dataField).replace(".", "_");
				if (window.doUpformItemShowDecimalValueMap && window.doUpformItemShowDecimalValueMap[sname]) {
					_value = _FormItemDecimalDisplay2.default.getDisplayText(_value, this.props.showZero, window.doUpformItemShowDecimalValueMap[sname], this.props.thousandSeperator, parms);
				} else {
					_value = _FormItemDecimalDisplay2.default.getDisplayText(_value, this.props.showZero, this.props.showDecimals, this.props.thousandSeperator, parms);
				}
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				var _display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: "3px" };
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
				_style.textAlign = this.props.textAlign.toLowerCase();
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color);
							//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor);
							//rowStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color);
							//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor);
							//colStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				var _clsName = "gongqi_render_select";
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (_display == "block") _clsName += " gongqi_render_version0";
				return _react2.default.createElement(
					'div',
					{ className: _clsName, ref: function ref(node) {
							return _this2.componentLabel = node;
						}, style: _style },
					_value,
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.modifiedTag = node;
						}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
				);
			}
		}]);
	
		return FormItemDecimalRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemDecimalRender;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	var _FormItemDecimalDisplay = __webpack_require__(49);
	
	var _FormItemDecimalDisplay2 = _interopRequireDefault(_FormItemDecimalDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemDecimalRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemDecimalRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemDecimalRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemDecimalRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemDecimalRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemDecimalRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemDecimalRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				var parms = {};
				if (this.props.displayStyle == "%") parms.percent = true;
				_value = _FormItemDecimalDisplay2.default.getDisplayText(_value, this.props.showZero, this.props.showDecimals, this.props.thousandSeperator, parms);
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
	
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					_value
				);
			}
		}]);
	
		return FormItemDecimalRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemDecimalRenderForAutoLookup;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemEnumRender = function (_FormItemEditorRender) {
		_inherits(FormItemEnumRender, _FormItemEditorRender);
	
		function FormItemEnumRender(props) {
			_classCallCheck(this, FormItemEnumRender);
	
			return _possibleConstructorReturn(this, (FormItemEnumRender.__proto__ || Object.getPrototypeOf(FormItemEnumRender)).call(this, props));
		}
	
		_createClass(FormItemEnumRender, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				var _options = this.props.options;
				var _valueRender = _value;
				for (var i in _options) {
					var item = _options[i];
					if (item.value == _value) {
						_valueRender = item.label;
						break;
					}
				}
				return _valueRender;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				var _display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
	
				var rowStyles = this.getRowStyles();
				var _style = { padding: "3px" };
				_style.textAlign = this.props.textAlign.toLowerCase();
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color);
							//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor);
							//rowStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color);
							//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor);
							//colStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				var _clsName = "gongqi_render_select";
	
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (_display == "block") _clsName += " gongqi_render_version0";
	
				// let valueStyle=['#33CC99','#2db7f5','#ff9000','#F5222D','#EB2F96','#722ED1','#F5222D','#4682B4','#FAFAD2','#FFDAB9']
				// let valueBackStyle=['#cff3e7','#dcf1fa','#fdedd7','#FFF1F0','#FFF0F6','#F9F0FF','#FFA39E','#87CEFA','#F5F5DC','#F4A460']
				// let valueBorderStyle=['#81f1cc','#91d5ff','#facb8d','#FFA39E','#FFADD2','#D3ADF7','#FFF1F0','#87CEEB','#FFFFF0','#D2691E']
				// _style.display='flex';
				// _style.justifyContent='center';
				// let val = Number(this.props.rowData[this.props.dataField])
				// if(val>=valueStyle.length)val=Number(this.props.rowData[this.props.dataField])-10;
				// return(
				// 	<div className={_clsName} ref={ node => this.componentLabel = node } style={_style}>
				// 		<div style={{width: '80%',border: '1px solid',whiteSpace: 'nowrap',borderRadius: '4px',color:valueStyle[val] ,background: valueBackStyle[val],borderColor:  valueBorderStyle[val]}}>
				// 			{_value}
				// 		</div>
				// 		<i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
				// 	</div>
	
				// );
	
				return _react2.default.createElement(
					'div',
					{ className: _clsName, ref: function ref(node) {
							return _this2.componentLabel = node;
						}, style: _style },
					_value,
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.modifiedTag = node;
						}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
				);
			}
		}]);
	
		return FormItemEnumRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemEnumRender;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemEnumRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemEnumRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemEnumRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemEnumRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemEnumRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemEnumRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemEnumRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				var _options = this.props.options;
				var _valueRender = _value;
				for (var i in _options) {
					var item = _options[i];
					if (item.value == _value) {
						_valueRender = item.label;
						break;
					}
				}
				return _valueRender;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
	
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					_value
				);
			}
		}]);
	
		return FormItemEnumRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemEnumRenderForAutoLookup;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _FormItemLongDisplay = __webpack_require__(74);
	
	var _FormItemLongDisplay2 = _interopRequireDefault(_FormItemLongDisplay);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemLongRender = function (_FormItemEditorRender) {
		_inherits(FormItemLongRender, _FormItemEditorRender);
	
		function FormItemLongRender(props) {
			_classCallCheck(this, FormItemLongRender);
	
			return _possibleConstructorReturn(this, (FormItemLongRender.__proto__ || Object.getPrototypeOf(FormItemLongRender)).call(this, props));
		}
	
		_createClass(FormItemLongRender, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
	
				_value = _FormItemLongDisplay2.default.getDisplayText(_value, this.props.showZero, this.props.thousandSeperator);
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				var _display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
				var rowStyles = this.getRowStyles();
				var _style = { padding: "3px" };
				_style.textAlign = this.props.textAlign.toLowerCase();
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color);
							//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor);
							//colStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color);
							//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor);
							//rowStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				var _clsName = "gongqi_render_select";
	
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (_display == "block") _clsName += " gongqi_render_version0";
				return _react2.default.createElement(
					'div',
					{ className: _clsName, ref: function ref(node) {
							return _this2.componentLabel = node;
						}, style: _style },
					_value,
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.modifiedTag = node;
						}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
				);
			}
		}]);
	
		return FormItemLongRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemLongRender;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	var _FormItemLongDisplay = __webpack_require__(74);
	
	var _FormItemLongDisplay2 = _interopRequireDefault(_FormItemLongDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemLongRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemLongRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemLongRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemLongRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemLongRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemLongRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemLongRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
	
				_value = _FormItemLongDisplay2.default.getDisplayText(_value, this.props.showZero, this.props.thousandSeperator);
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
	
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					_value
				);
			}
		}]);
	
		return FormItemLongRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemLongRenderForAutoLookup;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommandArgFuncUtil = __webpack_require__(148);
	
	var _CommandArgFuncUtil2 = _interopRequireDefault(_CommandArgFuncUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemStringRender = function (_FormItemEditorRender) {
		_inherits(FormItemStringRender, _FormItemEditorRender);
	
		function FormItemStringRender(props) {
			_classCallCheck(this, FormItemStringRender);
	
			return _possibleConstructorReturn(this, (FormItemStringRender.__proto__ || Object.getPrototypeOf(FormItemStringRender)).call(this, props));
		}
	
		_createClass(FormItemStringRender, [{
			key: 'testDragStart',
			value: function testDragStart(e) {
				//var data = e.dataTransfer;
				var billData = {};
				var billTable = {};
				for (var key in this.props.rowData) {
					if (key.indexOf(".") != -1) {
						var keyArr = key.split(".");
						var subKey = keyArr[keyArr.length - 1];
						// billTable[this.props.column.name] = this.props.rowData[key];
						var dataSourceFields = this.props.group.mainSource.xml.FormDataSourceFields;
						var caseUp = _StringUtil2.default.convertToEachFirstUpperCase(subKey);
						for (var index in dataSourceFields) {
							if (dataSourceFields[index].qname == "FormDataSourceField" && dataSourceFields[index].name == caseUp) {
								var fieldLabel = _GOTUtil2.default.getFinalValue(dataSourceFields[index], this.props.group.formDataSources.formModule.props.xml, "Label");
								billTable[fieldLabel] = this.props.rowData[key];
							};
						}
					}
				}
				billData["billTable"] = billTable;
	
				var groups = this.props.group.formDataSources.groups;
				var LineGroup = null;
				for (var _key in groups) {
					var _group = groups[_key];
					if (_group.linkGroup == this.props.group) {
						LineGroup = _group;break;
					}
				}
	
				if (LineGroup) {
					var billLines = [];
					var length = LineGroup.records ? LineGroup.records.length : 0;
					for (var i = 0; i < length; i++) {
						var _record = LineGroup.records[i];
						var _lineItem = {};
						for (var _key2 in _record) {
							if (_key2.indexOf(".") != -1) {
								var _keyArr = _key2.split(".");
								var _subKey = _keyArr[_keyArr.length - 1];
								var _dataSourceFields = LineGroup.mainSource.xml.FormDataSourceFields;
								var _caseUp = _StringUtil2.default.convertToEachFirstUpperCase(_subKey);
								for (var _index in _dataSourceFields) {
									if (_dataSourceFields[_index].qname == "FormDataSourceField" && _dataSourceFields[_index].name == _caseUp) {
										var _fieldLabel = _GOTUtil2.default.getFinalValue(_dataSourceFields[_index], this.props.group.formDataSources.formModule.props.xml, "Label");
										_lineItem[_fieldLabel] = _record[_key2];
									};
								}
							}
						}
						billLines.push(_lineItem);
					}
					billData["billLines"] = billLines;
				}
	
				/*data.setData("purch",JSON.stringify(
	   	{content:purchData,name:this.props.rowData[this.props.group.groupAlias+".purchId"]}
	   ));*/
	
				var dragHandlerFunc = this.props.column.dragStartHandler;
				dragHandlerFunc(e, billData);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _display = "none";
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				_display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
	
				var _style = { padding: "3px" };
				_style.textAlign = this.props.textAlign.toLowerCase();
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				var rowStyles = this.getRowStyles();
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color); //rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor); //rowStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color); //colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor); //colStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
	
				if (this.props.isMutiRow) {
					_style.whiteSpace = "pre-wrap";
					_style.wordWrap = "break-word";
					_style.wordBreak = "break-all";
				}
				var dragHandlerFunc = null;
				if (this.props.column && this.props.column.dragStartHandler) {
					if (typeof this.props.column.dragStartHandler == "function") {
						dragHandlerFunc = this.props.column.dragStartHandler;
					}
				}
				if (this.props.trim) {
					if (this.props.trim == 'None') {
						_style.whiteSpace = "pre-wrap";
					}
				}
	
				/*if(this.props.rowData && this.props.rowData["EquipmentTable.sysActive"] == false)
	   {
	   	_style.backgroundColor = "rgb(255, 255, 153)";
	   }*/
				var _clsName = "gongqi_render_select";if (_display == "block") _clsName += " gongqi_render_version0";
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (dragHandlerFunc) {
					return _react2.default.createElement(
						'div',
						{ draggable: 'true', onDragStart: this.testDragStart.bind(this), className: _clsName, ref: function ref(node) {
								return _this2.componentLabel = node;
							}, style: _style },
						_value,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this2.modifiedTag = node;
							}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: _clsName, ref: function ref(node) {
								return _this2.componentLabel = node;
							}, style: _style },
						_value,
						_react2.default.createElement('i', { ref: function ref(node) {
								return _this2.modifiedTag = node;
							}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
					);
				}
			}
		}]);
	
		return FormItemStringRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemStringRender;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRender2 = __webpack_require__(43);
	
	var _FormItemEditorRender3 = _interopRequireDefault(_FormItemEditorRender2);
	
	var _FormItemTimeDisplay = __webpack_require__(75);
	
	var _FormItemTimeDisplay2 = _interopRequireDefault(_FormItemTimeDisplay);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemTimeRender = function (_FormItemEditorRender) {
		_inherits(FormItemTimeRender, _FormItemEditorRender);
	
		function FormItemTimeRender(props) {
			_classCallCheck(this, FormItemTimeRender);
	
			return _possibleConstructorReturn(this, (FormItemTimeRender.__proto__ || Object.getPrototypeOf(FormItemTimeRender)).call(this, props));
		}
	
		_createClass(FormItemTimeRender, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
				var _dislayFormat = this.props.displayFormat;
				if (_dislayFormat) {
					_value = _FormItemTimeDisplay2.default.getDisplayText2(_value, _dislayFormat);
				} else {
					_value = _FormItemTimeDisplay2.default.getDisplayText(_value, this.props.showHour, this.props.showMinute, this.props.showSecond);
				}
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
				var _display = this.forLookup ? "none" : this.props.group == undefined ? "none" : this.props.group.isCurrentDataFieldModified(this.props.rowData, this.props.dataField) ? "block" : "none";
				var rowStyles = this.getRowStyles();
				var _style = { padding: "3px" };
				_style.textAlign = this.props.textAlign.toLowerCase();
				var _displayStyle = this.props.displayStyle;
				if (_displayStyle && _displayStyle.Color) _style.color = _displayStyle.Color;
				if (this.props.cssStyle) {
					Object.assign(_style, this.props.cssStyle);
				}
				if (_display == "block") _style.backgroundColor = "#f8e8b7";
	
				var clientStyle = _CommonUtil2.default.getClientLayerRowStyles(window.formModuleInstance, null, "getDataGridStyle_" + this.props.gridXml.name, [this.props.rowData, this.props.dataField]);
	
				if (clientStyle) {
					_style = Object.assign(_style, clientStyle);
				}
	
				if (rowStyles) {
					for (var i = 0; i < rowStyles.length; i++) {
						var rowStyle = rowStyles[i];
						var bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, rowStyle.recordCondition);
						if (bool) {
							if (rowStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(rowStyle.color);
							//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (rowStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(rowStyle.backgroundColor);
							//rowStyle.backgroundColor.toString(16);
							if (rowStyle.fontSize != -1) _style.fontSize = rowStyle.fontSize;
							if (rowStyle.fontFamily != null) _style.fontFamily = rowStyle.fontFamily;
							if (rowStyle.fontWeight != null) _style.fontWeight = rowStyle.fontWeight;
						}
					}
				}
	
				var colStyles = this.getEditorStyles();
				if (colStyles) {
					for (var _i = 0; _i < colStyles.length; _i++) {
						var colStyle = colStyles[_i];
						var _bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData, colStyle.recordCondition);
						if (_bool) {
							if (colStyle.color != -1) _style.color = "#" + _StringUtil2.default.toColorStyleString(colStyle.color);
							//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
							if (colStyle.backgroundColor != -1) _style.backgroundColor = "#" + _StringUtil2.default.toColorStyleString(colStyle.backgroundColor);
							//colStyle.backgroundColor.toString(16);
							if (colStyle.fontSize != -1) _style.fontSize = colStyle.fontSize;
							if (colStyle.fontFamily != null) _style.fontFamily = colStyle.fontFamily;
							if (colStyle.fontWeight != null) _style.fontWeight = colStyle.fontWeight;
						}
					}
				}
				var _clsName = "gongqi_render_select";
				if (_style.backgroundColor) _clsName += " gongqi_render_back";
				if (_display == "block") _clsName += " gongqi_render_version0";
				return _react2.default.createElement(
					'div',
					{ className: _clsName, ref: function ref(node) {
							return _this2.componentLabel = node;
						}, style: _style },
					_value,
					_react2.default.createElement('i', { ref: function ref(node) {
							return _this2.modifiedTag = node;
						}, className: 'fa fa-sort-desc', 'aria-hidden': 'true', style: { color: "red", position: "absolute", top: "-3px", right: "0px", transform: 'rotate(224deg) scale(1.5)', zIndex: "100", display: _display } })
				);
			}
		}]);
	
		return FormItemTimeRender;
	}(_FormItemEditorRender3.default);
	
	exports.default = FormItemTimeRender;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemEditorRenderForAutoLookup = __webpack_require__(44);
	
	var _FormItemEditorRenderForAutoLookup2 = _interopRequireDefault(_FormItemEditorRenderForAutoLookup);
	
	var _FormItemTimeDisplay = __webpack_require__(75);
	
	var _FormItemTimeDisplay2 = _interopRequireDefault(_FormItemTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(27);
	
	var FormItemTimeRenderForAutoLookup = function (_FormItemEditorRender) {
		_inherits(FormItemTimeRenderForAutoLookup, _FormItemEditorRender);
	
		function FormItemTimeRenderForAutoLookup(props) {
			_classCallCheck(this, FormItemTimeRenderForAutoLookup);
	
			return _possibleConstructorReturn(this, (FormItemTimeRenderForAutoLookup.__proto__ || Object.getPrototypeOf(FormItemTimeRenderForAutoLookup)).call(this, props));
		}
	
		_createClass(FormItemTimeRenderForAutoLookup, [{
			key: 'getDisplay',
			value: function getDisplay(_value) {
				if (_value == null || _value == undefined) _value = this.props.value;
	
				_value = _FormItemTimeDisplay2.default.getDisplayText(_value, this.props.showHour, this.props.showMinute, this.props.showSecond);
	
				return _value;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _value = this.props.rowData[this.props.dataField];
				_value = this.getDisplay(_value);
	
				return _react2.default.createElement(
					'div',
					{ className: 'gongqi_render_select', style: { padding: '3px' }, ref: function ref(node) {
							return _this2.componentLabel = node;
						} },
					_value
				);
			}
		}]);
	
		return FormItemTimeRenderForAutoLookup;
	}(_FormItemEditorRenderForAutoLookup2.default);
	
	exports.default = FormItemTimeRenderForAutoLookup;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CommandActions = __webpack_require__(31);
	
	var _CommandActions2 = _interopRequireDefault(_CommandActions);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GongqiSelectRecordsHeaderCell = function (_React$Component) {
		_inherits(GongqiSelectRecordsHeaderCell, _React$Component);
	
		function GongqiSelectRecordsHeaderCell(props) {
			_classCallCheck(this, GongqiSelectRecordsHeaderCell);
	
			return _possibleConstructorReturn(this, (GongqiSelectRecordsHeaderCell.__proto__ || Object.getPrototypeOf(GongqiSelectRecordsHeaderCell)).call(this, props));
		}
	
		_createClass(GongqiSelectRecordsHeaderCell, [{
			key: 'checkChangeHandler',
			value: function checkChangeHandler(e) {
				_CommandActions2.default.selectAllRecords(e.currentTarget.checked, this.props.groupAlias, this.props.moduleInstanceId);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'render',
			value: function render() {
				var columnName = this.props.column.xmlName;
				var _nameid = "gridckbox" + columnName + _CommonUtil2.default.guid();
				return _react2.default.createElement(
					'div',
					{ className: 'react-grid-checkbox-container checkbox-align' },
					_react2.default.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: _nameid, id: _nameid, onChange: this.checkChangeHandler.bind(this) }),
					_react2.default.createElement('label', { htmlFor: _nameid, className: 'react-grid-checkbox-label' })
				);
			}
		}]);
	
		return GongqiSelectRecordsHeaderCell;
	}(_react2.default.Component);
	
	exports.default = GongqiSelectRecordsHeaderCell;

/***/ },
/* 251 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormDataSourceGroupResult = function FormDataSourceGroupResult() {
	    _classCallCheck(this, FormDataSourceGroupResult);
	
	    this.remoteClass = "gongqi.erp.gotmodel.form.datasource.FormDataSourceGroupResult";
	    this.maxCounts = -1;
	    this.autoSaveRecord = true;
	} //-1表示未知
	;
	
	exports.default = FormDataSourceGroupResult;

/***/ },
/* 252 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandArgGroupInfo = function CommandArgGroupInfo() {
		_classCallCheck(this, CommandArgGroupInfo);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.remote.CommandArgGroupInfo";
	};
	
	exports.default = CommandArgGroupInfo;

/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContextMapArg = function ContextMapArg() {
		_classCallCheck(this, ContextMapArg);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.remote.ContextMapArg";
	};
	
	ContextMapArg.PUT = "put";
	ContextMapArg.REMOVE = "remove";
	ContextMapArg.CLEAR = "clear";
	exports.default = ContextMapArg;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryWhereLeftBracket = __webpack_require__(56);
	
	var _QueryWhereLeftBracket2 = _interopRequireDefault(_QueryWhereLeftBracket);
	
	var _QueryWhereRightBracket = __webpack_require__(57);
	
	var _QueryWhereRightBracket2 = _interopRequireDefault(_QueryWhereRightBracket);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormParamCondition = function () {
		function FormParamCondition() {
			_classCallCheck(this, FormParamCondition);
	
			this.remoteClass = "gongqi.erp.gotmodel.form.remote.FormParamCondition";
		}
	
		_createClass(FormParamCondition, null, [{
			key: 'getSqlWhereStr',
			value: function getSqlWhereStr() {
				if (this._sqlWhereStr) return this._sqlWhereStr;
				var i = 0;
				var result = "";
				var leftBracket = _QueryWhereLeftBracket2.default.None;
				var rightBracket = _QueryWhereRightBracket2.default.None;
				for (var _i = 0; _i < this.items.length; _i++) {
					var item = this.items[_i];
					if (_i > 0) {
						result += " " + item.andOr;
					}
	
					if (item.leftBracket != _QueryWhereLeftBracket2.default.None) {
						result += " " + _QueryWhereLeftBracket2.default.labelOf(item.leftBracket);
						leftBracket += item.leftBracket;
					}
	
					if (item.value == null) item.value = "";
	
					if (item.value.indexOf(",") != -1) var fieldValues = item.value.split(",");else fieldValues = [item.value];
	
					if (fieldValues.length > 1) result += " (";
	
					for (var j = 0; j < fieldValues.length; j++) {
						var _fv = fieldValues[j];
						if (j > 0) {
							result += " or " + (item.type == "MenuItemId" ? ".menuItemId" : item.type == "CallerMenuItemId" ? ".callerMenuItemId" : item.type == "CallerLookupField" ? ".callerLookupField" : ".fieldName") + "=" + _StringUtil2.default.trimThrough(_fv);
							//result += (" or " + (item.type=="MenuItemId"?".menuItemId":".fieldName")+"="+StringUtil.trimThrough(_fv));	
						} else {
							result += " " + (item.type == "MenuItemId" ? ".menuItemId" : item.type == "CallerMenuItemId" ? ".callerMenuItemId" : item.type == "CallerLookupField" ? ".callerLookupField" : ".fieldName") + "=" + _StringUtil2.default.trimThrough(_fv);
							//result += (" "+(item.type=="MenuItemId"?".menuItemId":".fieldName")+"="+StringUtil.trimThrough(_fv));
						}
					}
	
					if (fieldValues.length > 1) result += " )";
	
					//if(item.rightBracket != 0)
					//	item.rightBracket = 0;
	
					if (item.rightBracket != _QueryWhereRightBracket2.default.None) {
						result += " " + _QueryWhereRightBracket2.default.labelOf(item.rightBracket);
						rightBracket += item.rightBracket;
					}
				}
	
				if (leftBracket != rightBracket) {
					//GongqiAlert.show("括号不匹配");
					return "";
				}
	
				this._sqlWhereStr = result;
				return result;
			}
		}]);
	
		return FormParamCondition;
	}();
	
	exports.default = FormParamCondition;

/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OpenFormArg = function OpenFormArg() {
		_classCallCheck(this, OpenFormArg);
	
		this.remoteClass = "gongqi.erp.gotmodel.form.remote.OpenFormArg";
		this.menuItemId = null;
		this.callerKey = null;
		this.paramString = null;
		this.paramObject = null;
		this.enterMainForm = false;
		this.mainFormWhereValues = null;
		this.addFixedGroupRelation = false;
		this.linkGroupAlias = null;
		this.addAutoGroupRelation = false;
		this.isPopUp = false;
	}
	
	//优先级高
	
	//优先级低
	;
	
	exports.default = OpenFormArg;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryWhereLeftBracket = __webpack_require__(56);
	
	var _QueryWhereLeftBracket2 = _interopRequireDefault(_QueryWhereLeftBracket);
	
	var _QueryWhereRightBracket = __webpack_require__(57);
	
	var _QueryWhereRightBracket2 = _interopRequireDefault(_QueryWhereRightBracket);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecordCondition = function () {
		function RecordCondition() {
			_classCallCheck(this, RecordCondition);
	
			this.remoteClass = "gongqi.erp.gotmodel.form.remote.RecordCondition";
		}
	
		_createClass(RecordCondition, null, [{
			key: 'getSqlWhereStr',
			value: function getSqlWhereStr() {
				//默认为undifined 经过计算也有可能未""所以要单独判断
				if (this._sqlWhereStr == "" || this._sqlWhereStr) return this._sqlWhereStr;
				var i = 0;
				var result = "";
				var leftBracket = _QueryWhereLeftBracket2.default.None;
				var rightBracket = _QueryWhereRightBracket2.default.None;
				for (i = 0; i < this.items.length; i++) {
					var item = this.items[i];
					if (item.fieldName.indexOf(".") != 0) item.fieldName = "." + item.fieldName;
					if (i > 0) {
						//result += (" " + QueryWhereAndOr.labelOf(item.andOr));
						result += " " + item.andOr;
					}
	
					if (item.leftBracket != _QueryWhereLeftBracket2.default.None) {
						result += " " + _QueryWhereLeftBracket2.default.labelOf(item.leftBracket);
						leftBracket += item.leftBracket;
					}
	
					if (item.fieldValue == null) item.fieldValue = "";
	
					if (item.fieldValue.indexOf(",") != -1) var fieldValues = item.fieldValue.split(",");else fieldValues = [item.fieldValue];
	
					if (fieldValues.length > 1) result += " (";
	
					var j = 0;
					for (j = 0; j < fieldValues.length; j++) {
						var _fv = fieldValues[j];
						if (j > 0) {
							result += " or " + item.fieldName + "=" + _StringUtil2.default.trimThrough(_fv);
						} else {
							result += " " + item.fieldName + "=" + _StringUtil2.default.trimThrough(_fv);
						}
					}
	
					if (fieldValues.length > 1) result += " )";
	
					if (item.rightBracket != _QueryWhereRightBracket2.default.None) {
						result += " " + _QueryWhereRightBracket2.default.labelOf(item.rightBracket);
						rightBracket += item.rightBracket;
					}
				}
	
				if (leftBracket != rightBracket) {
					//GongqiAlert.show("括号不匹配");
					return "";
				}
	
				this._sqlWhereStr = result;
				return result;
			}
		}]);
	
		return RecordCondition;
	}();
	
	exports.default = RecordCondition;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryWhereLeftBracket = __webpack_require__(56);
	
	var _QueryWhereLeftBracket2 = _interopRequireDefault(_QueryWhereLeftBracket);
	
	var _QueryWhereRightBracket = __webpack_require__(57);
	
	var _QueryWhereRightBracket2 = _interopRequireDefault(_QueryWhereRightBracket);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//CMD Job
	var RecordConditionTask = function () {
		function RecordConditionTask() {
			_classCallCheck(this, RecordConditionTask);
	
			this.remoteClass = "gongqi.erp.gotmodel.form.remote.RecordConditionTask";
			this._sqlWhereStr = null;
		}
	
		_createClass(RecordConditionTask, null, [{
			key: 'getSqlWhereStr',
			value: function getSqlWhereStr() {
				//默认为undifined 经过计算也有可能未""所以要单独判断
				if (this._sqlWhereStr == "" || this._sqlWhereStr) return this._sqlWhereStr;
				var i = 0;
				var result = "";
				var leftBracket = _QueryWhereLeftBracket2.default.None;
				var rightBracket = _QueryWhereRightBracket2.default.None;
				for (i = 0; i < this.recordCondition.items.length; i++) {
					var item = this.recordCondition.items[i];
					if (item.fieldName.indexOf(".") != 0 && item.fieldName.indexOf("@") != 0) item.fieldName = "." + item.fieldName;
					if (i > 0) {
						//result += (" " + QueryWhereAndOr.labelOf(item.andOr));
						result += " " + item.andOr;
					}
	
					if (item.leftBracket != _QueryWhereLeftBracket2.default.None) {
						result += " " + _QueryWhereLeftBracket2.default.labelOf(item.leftBracket);
						leftBracket += item.leftBracket;
					}
	
					if (item.fieldValue == null) item.fieldValue = "";
	
					if (item.fieldValue.indexOf(",") != -1) var fieldValues = item.fieldValue.split(",");else fieldValues = [item.fieldValue];
	
					if (fieldValues.length > 1) result += " (";
	
					var j = 0;
					for (j = 0; j < fieldValues.length; j++) {
						var _fv = fieldValues[j];
						if (j > 0) {
							result += " or " + item.fieldName + "=" + _StringUtil2.default.trimThrough(_fv);
						} else {
							result += " " + item.fieldName + "=" + _StringUtil2.default.trimThrough(_fv);
						}
					}
	
					if (fieldValues.length > 1) result += " )";
	
					if (item.rightBracket != _QueryWhereRightBracket2.default.None) {
						result += " " + _QueryWhereRightBracket2.default.labelOf(item.rightBracket);
						rightBracket += item.rightBracket;
					}
				}
	
				if (leftBracket != rightBracket) {
					//GongqiAlert.show("括号不匹配");
					return "";
				}
	
				this._sqlWhereStr = result;
				return result;
			}
		}]);
	
		return RecordConditionTask;
	}();
	
	exports.default = RecordConditionTask;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryWhereLeftBracket = __webpack_require__(56);
	
	var _QueryWhereLeftBracket2 = _interopRequireDefault(_QueryWhereLeftBracket);
	
	var _QueryWhereRightBracket = __webpack_require__(57);
	
	var _QueryWhereRightBracket2 = _interopRequireDefault(_QueryWhereRightBracket);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValueCondition = function () {
		function ValueCondition() {
			_classCallCheck(this, ValueCondition);
	
			this.remoteClass = "gongqi.erp.gotmodel.form.remote.ValueCondition";
		}
	
		_createClass(ValueCondition, null, [{
			key: 'getSqlWhereStr',
			value: function getSqlWhereStr() {
				//TODO  这个类应删除掉，改为RecordConditionTask
				if (this.sqlWhereStr) return _sqlWhereStr;
				var result = "";
				var leftBracket = _QueryWhereLeftBracket2.default.None;
				var rightBracket = _QueryWhereRightBracket2.default.None;
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
	
					if (i > 0) {
						result += " " + item.andOr;
					}
	
					if (item.leftBracket != _QueryWhereLeftBracket2.default.None) {
						result += " " + _QueryWhereLeftBracket2.default.labelOf(item.leftBracket);
						leftBracket += item.leftBracket;
					}
	
					if (item.value == null) item.value = "";
	
					if (item.value.indexOf(",") != -1) var fieldValues = item.value.split(",");else fieldValues = [item.value];
	
					if (fieldValues.length > 1) result += " (";
	
					for (var j = 0; j < fieldValues.length; j++) {
						var _fv = fieldValues[j];
	
						if (j > 0) {
							result += " or " + ".fieldName" + "=" + _StringUtil2.default.trimThrough(_fv);
						} else {
							result += " " + ".fieldName" + "=" + _StringUtil2.default.trimThrough(_fv);
						}
					}
	
					if (fieldValues.length > 1) result += " )";
	
					//if(item.rightBracket != 0)
					//	item.rightBracket = 0;
	
					if (item.rightBracket != _QueryWhereRightBracket2.default.None) {
						result += " " + _QueryWhereRightBracket2.default.labelOf(item.rightBracket);
						rightBracket += item.rightBracket;
					}
				}
	
				if (leftBracket != rightBracket) {
					//GongqiAlert.show("括号不匹配");
					return "";
				}
	
				this._sqlWhereStr = result;
				return result;
			}
		}]);
	
		return ValueCondition;
	}();
	
	exports.default = ValueCondition;

/***/ },
/* 259 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryAggregationItem = //String
	//String
	//String
	//String
	
	//String
	//String
	
	
	function QueryAggregationItem() {
		_classCallCheck(this, QueryAggregationItem);
	
		this.remoteClass = "gongqi.erp.gotmodel.query.QueryAggregationItem";
	};
	
	exports.default = QueryAggregationItem;

/***/ },
/* 260 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryOrderByItem = //String
	//String
	//String
	//String
	
	function QueryOrderByItem() {
		_classCallCheck(this, QueryOrderByItem);
	
		this.remoteClass = "gongqi.erp.gotmodel.query.QueryOrderByItem";
	} //String			//QueryOrderByType
	
	;
	
	exports.default = QueryOrderByItem;

/***/ },
/* 261 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryParentProperty = function QueryParentProperty() {
		_classCallCheck(this, QueryParentProperty);
	
		this.remoteClass = "gongqi.erp.gotmodel.query.QueryParentProperty";
	};
	
	exports.default = QueryParentProperty;

/***/ },
/* 262 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryRelation1N = function () {
		function QueryRelation1N() {
			_classCallCheck(this, QueryRelation1N);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryRelation1N";
		}
	
		_createClass(QueryRelation1N, null, [{
			key: "valueOf",
			value: function valueOf(value) {
				if (value == QueryRelation1N.OneToManyLabel || value == QueryRelation1N.OneToManyNotLabel) return QueryRelation1N.OneToMany;else if (value == QueryRelation1N.ManyToOneLabel) return QueryRelation1N.ManyToOne;
	
				throw new Error("类型非法");
			}
		}, {
			key: "labelOf",
			value: function labelOf(value) {
				if (value == QueryRelation1N.OneToMany) return QueryRelation1N.OneToManyLabel;else if (value == QueryRelation1N.ManyToOne) return QueryRelation1N.ManyToOneLabel;
	
				throw new Error("类型非法");
			}
		}]);
	
		return QueryRelation1N;
	}();
	
	QueryRelation1N.OneToMany = "OneToMany";
	QueryRelation1N.ManyToOne = "ManyToOne";
	QueryRelation1N.OneToManyLabel = "OneToMany";
	QueryRelation1N.OneToManyNotLabel = "OneToMany(NOT)";
	QueryRelation1N.ManyToOneLabel = "ManyToOne";
	exports.default = QueryRelation1N;

/***/ },
/* 263 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryRelationItem = //String
	//String
	//String
	//String
	
	//String
	//String
	//String
	//String
	//String
	//String
	
	//String	//QueryWhereFieldType
	function QueryRelationItem() {
		_classCallCheck(this, QueryRelationItem);
	
		this.remoteClass = "gongqi.erp.gotmodel.query.QueryRelationItem";
	} //String
	;
	
	exports.default = QueryRelationItem;

/***/ },
/* 264 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryRelationJoinMode = function () {
		function QueryRelationJoinMode() {
			_classCallCheck(this, QueryRelationJoinMode);
	
			this.remoteClass = "gongqi.erp.gotmodel.query.QueryRelationJoinMode";
		}
	
		_createClass(QueryRelationJoinMode, null, [{
			key: "labelOf",
			value: function labelOf(value) {
				switch (value) {
					case QueryRelationJoinMode.None:
						return "None";
					case QueryRelationJoinMode.InnerJoin:
						return "InnerJoin";
					case QueryRelationJoinMode.LeftJoin:
						return "LeftJoin";
					case QueryRelationJoinMode.ExistJoin:
						return "ExistJoin";
					case QueryRelationJoinMode.NotExistJoin:
						return "NotExistJoin";
					default:
						throw new Error("类型非法");
				}
			}
		}, {
			key: "valueOf",
			value: function valueOf(value) {
				switch (value) {
					case "None":
					case "":
						return QueryRelationJoinMode.None;
					case "InnerJoin":
						return QueryRelationJoinMode.InnerJoin;
					case "LeftJoin":
						return QueryRelationJoinMode.LeftJoin;
					case "ExistJoin":
						return QueryRelationJoinMode.ExistJoin;
					case "NotExistJoin":
						return QueryRelationJoinMode.NotExistJoin;
					default:
						throw new Error("类型非法");
				}
			}
		}]);
	
		return QueryRelationJoinMode;
	}();
	
	QueryRelationJoinMode.None = "None";
	QueryRelationJoinMode.InnerJoin = "InnerJoin";
	QueryRelationJoinMode.LeftJoin = "LeftJoin";
	QueryRelationJoinMode.ExistJoin = "ExistJoin";
	QueryRelationJoinMode.NotExistJoin = "NotExistJoin";
	exports.default = QueryRelationJoinMode;

/***/ },
/* 265 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryWhereItem = //String
	//String
	//String
	//String
	
	//String
	//String	//QueryWhereLeftBracket
	//String	//QueryWhereRightBracket
	
	//String
	//String			//QueryWhereStatus
	//String	//QueryWhereFieldType
	
	function QueryWhereItem() {
		_classCallCheck(this, QueryWhereItem);
	
		this.remoteClass = "gongqi.erp.gotmodel.query.QueryWhereItem";
	} //String
	;
	
	exports.default = QueryWhereItem;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ResizeActions = __webpack_require__(53);
	
	var _ResizeActions2 = _interopRequireDefault(_ResizeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainMenuToggleStore = _reflux2.default.createStore({
	    init: function init() {
	        this.listenTo(_ResizeActions2.default.mainMenuToggle, 'onMainMenuToggle');
	    },
	    onMainMenuToggle: function onMainMenuToggle() {
	        this.trigger();
	    }
	});
	
	exports.default = MainMenuToggleStore;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _reflux = __webpack_require__(5);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ToolBarActions = __webpack_require__(87);
	
	var _ToolBarActions2 = _interopRequireDefault(_ToolBarActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToolBarUpdateGridToolBarStore = _reflux2.default.createStore({
	   init: function init() {
	      this.listenTo(_ToolBarActions2.default.updateGridToolBar, 'onUpdateGridToolBar');
	   },
	   onUpdateGridToolBar: function onUpdateGridToolBar(_value) {
	      this.trigger(_value);
	   }
	});
	
	exports.default = ToolBarUpdateGridToolBarStore;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOT = __webpack_require__(147);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GOTUtil = function () {
		function GOTUtil() {
			_classCallCheck(this, GOTUtil);
		}
	
		_createClass(GOTUtil, null, [{
			key: "getNormalRelationItem",
			value: function getNormalRelationItem(dataType) {
				var items = dataType.DataTypeRelation.DataTypeRelationItems;
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.type == "Normal") return item;
				}
				return null;
			}
		}, {
			key: "getFixedRelationItem",
			value: function getFixedRelationItem(dataType) {
				var result = [];
				var items = dataType.DataTypeRelation.DataTypeRelationItems;
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.type == "Fixed") result.push(item);
				}
				return result;
			}
		}, {
			key: "getShortCut",
			value: function getShortCut(table) {
				if (table == null) return null;
				var results = null;
				var shortcutPro = table.Properties.ShortCutField;
				if (shortcutPro && shortcutPro.hasOwnProperty("innerid")) {
					var innerid = shortcutPro.innerid;
					for (var i in table.TableFields) {
						var tableField = table.TableFields[i];
						if (tableField.id == innerid) return tableField;
					}
				}
	
				return null;
			}
		}, {
			key: "isTableFieldShortCut",
			value: function isTableFieldShortCut(tableField) {
				var extendsPro = tableField.Properties.Field;
				if (extendsPro.hasOwnProperty("refentityid")) {
					var entityid = extendsPro.refentityid;
					var innerid = extendsPro.refinnerid;
					var table = _GOT2.default.getTable(entityid);
					var shortcutPro = table.Properties.ShortCutField;
					if (shortcutPro && shortcutPro.innerid == innerid) {
						return true;
					}
				}
	
				return false;
			}
		}, {
			key: "isFormItemShortCut",
			value: function isFormItemShortCut(formItem) {
				var extendsPro = formItem.Properties.Extends;
				if (extendsPro.hasOwnProperty("refentityid")) {
					var entityid = extendsPro.refentityid;
					var innerid = extendsPro.refinnerid;
					var table = _GOT2.default.getTable(entityid);
					var shortcutPro = table.Properties.ShortCutField;
					if (shortcutPro.innerid == innerid) {
						return true;
					}
				}
	
				return false;
			}
		}, {
			key: "getDataTypePropertyValueFromFormItem",
			value: function getDataTypePropertyValueFromFormItem(formItem, propertyName) {
				//本方法针对FormItem_Editor 但不支持Enum类型
				var pFormItem = formItem.Properties.Extends;
				if (pFormItem == null) return null;
	
				if (!pFormItem.hasOwnProperty("refentityid")) return null;
	
				if (pFormItem.hasOwnProperty("refinnerid")) {
					var table = _GOT2.default.getTable(pFormItem.refentityid);
					if (table != null) {
						var tableField = _GOT2.default.getTableField(table, pFormItem.refinnerid);
						var pTableField = tableField.Properties.Extends;
						if (!pTableField.hasOwnProperty("refentityid")) return null;
	
						var dataType = _GOT2.default.getDataType(pTableField.refentityid);
					} else {
						return null;
					}
				} else {
					dataType = _GOT2.default.getDataType(pFormItem.refentityid);
				}
	
				if (dataType.type == "Component") {
					var itemName = pFormItem.V.split(".")[1];
					var arrayItem = _GOT2.default.getDataTypeArrayItem(itemName);
					var refentityId = arrayItem.Properties.RefDataType.refentityid;
					dataType = _GOT2.default.getDataType(refentityId);
				}
				var value = dataType.Properties[propertyName].Value;
				while (value == "") {
					var _refentityId2 = dataType.Properties["Extends"].refentityid;
					dataType = _GOT2.default.getDataType(_refentityId2);
					value = dataType.Properties[propertyName].Value;
				}
	
				if (value == "") return null;else return value;
			}
	
			// static getItemEntity(item)
			// {
			// 	if(item.hasOwnProperty("version"))
			// 		return item;
			// 	else
			// 		return getItemEntity(item.parent());
			// }
	
		}, {
			key: "isFindQueryField",
			value: function isFindQueryField(propertyName) {
				if (propertyName == "Label" || propertyName == "NumOfDecimal" || propertyName == "StringSize") return true;
				return false;
			}
		}, {
			key: "getPropertyValueStepByStep",
			value: function getPropertyValueStepByStep(item, entity, propertyName, validateString, validateEquals, findFormDataSourceField) {
				var value;
	
				if (item.qname == "FormItem") {
					value = item.Properties[propertyName].Value;
					//item.Properties.Property.(Name==propertyName).Value;
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
	
					var pFormItem_Extends;
					if (item.type == "FieldGroup") {
						pFormItem_Extends = item.Properties["Component"];
						if (!pFormItem_Extends.hasOwnProperty("refentityid")) {
							//pFormItem_Extends = getProperty(item,"FieldGroup");
							return value;
						}
					} else {
						pFormItem_Extends = item.Properties["Extends"];
					}
	
					if (pFormItem_Extends == null) throw new Error("FromItem上找不到Extends");
	
					var isQueryField = false;
					if (!pFormItem_Extends.hasOwnProperty("refentityid") && isFindQueryField(propertyName)) {
						pFormItem_Extends = item.Proeprties["QueryField"];
						if (pFormItem_Extends == null || !pFormItem_Extends.hasOwnProperty("refentityid")) return value;
						isQueryField = true;
					}
					if (pFormItem_Extends.hasOwnProperty("refinnerid")) {
						if (pFormItem_Extends.Value == "") return "";
						if (findFormDataSourceField) {
							if (isQueryField == false) {
								var pFormItem_DataSource = item.Properties["DataSource"];
							} else {
								pFormItem_DataSource = item.Properties["QuerySource"];
							}
	
							if (pFormItem_DataSource == null || !pFormItem_DataSource.hasOwnProperty("innerid")) return value;
							var innerid = pFormItem_DataSource.innerid;
							//TODO form
							var formDataSource = _GOT2.default.getFormDataSource(window.formXML, innerid);
							var formDataSourceFieldName = pFormItem_Extends.Value;
							item = _GOT2.default.getFormDataSourceField(formDataSource, formDataSourceFieldName);
							/*item = XML(getItemEntity(item).FormDataSources.FormDataSource.(@id==pFormItem_DataSource.@innerid)[0])
	      	.FormDataSourceFields.FormDataSourceField.(@name==pFormItem_Extends.Value)[0];*/
						} else {
							var refentityId = pFormItem_Extends.refentityid;
							var refinnerId = pFormItem_Extends.refinnerid;
							var table = _GOT2.default.getTable(refentityId);
							item = _GOT2.default.getTableField(table, refinnerId);
							//item = GOT.getTable(pFormItem_Extends.@refentityid).TableFields.TableField.(@id==pFormItem_Extends.@refinnerid)[0];
						}
					} else if (pFormItem_Extends.hasOwnProperty("refentityid")) {
						item = _GOT2.default.getDataType(pFormItem_Extends.refentityid);
						if (item == null) item = _GOT2.default.getEnum(pFormItem_Extends.refentityid);
					}
				}
	
				if (item.qname == "FormDataSourceField") {
					value = item.Properties.hasOwnProperty(propertyName) ? item.Properties[propertyName].Value : "";
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
	
					var pFormDataSourceField_Field = item.Properties["Field"];
					var _refentityId = pFormDataSourceField_Field.refentityid;
					var _refinnerId = pFormDataSourceField_Field.refinnerid;
					var _table = _GOT2.default.getTable(_refentityId);
					item = _GOT2.default.getTableField(_table, _refinnerId);
					//item = GOT.getTable(pFormDataSourceField_Field.@refentityid).TableFields.TableField.(@id==pFormDataSourceField_Field.@refinnerid)[0];
				}
	
				if (item.qname == "TableField") {
					value = item.Properties.hasOwnProperty(propertyName) ? item.Properties[propertyName].V : "";
					if (propertyName == "Visible") //即使碰到Component，也不展开，直接返回
						return value;
	
					if (propertyName == "AllowEdit" || propertyName == "NotNull") {
						return value;
					}
	
					if (item.type == "Component") {
						if (pFormItem_Extends && pFormItem_Extends.Value.indexOf(".") != -1) {
							pTableField_Extends = item.Properties["Extends"];
							var _refentityId3 = pTableField_Extends.refentityid;
							var componentDataType = _GOT2.default.getDataType(_refentityId3);
							var arrayItemName = pFormItem_Extends.Value.split(".")[1];
							var dataTypeArrayItem = _GOT2.default.getDataTypeArrayItem(componentDataType, arrayItemName);
							_refentityId3 = dataTypeArrayItem.Properties["RefDataType"].refentityid;
							item = _GOT2.default.getDataType(_refentityId3);
							/*item = GOT.getDataType(
	      GOT.getDataType().DataTypeArray.DataTypeArrayItem
	      	.(@name==String(pFormItem_Extends.Value).split(".")[1])
	      	.Properties.Property.(Name=="RefDataType").@refentityid);	*/
						} else if (pFormDataSourceField_Field && pFormDataSourceField_Field.Value.indexOf(".") != -1) {
							pTableField_Extends = item.Properties["Extends"];
							var t = _GOT2.default.getDataType(pTableField_Extends.refentityid);
							var _arrayItemName = pFormDataSourceField_Field.Value.split(".")[1];
							var arrayItem = _GOT2.default.getDataTypeArrayItem(t, _arrayItemName);
							var _refentityId4 = arrayItem.Properties["RefDataType"].refentityid;
							item = _GOT2.default.getDataType(_refentityId4);
							/*item = GOT.getDataType(
	      	t.DataTypeArray.DataTypeArrayItem.(@name==String(pFormDataSourceField_Field.Value).split(".")[1])
	      	.Properties.Property.(Name=="RefDataType").@refentityid);*/
						} else {
							if (validateEquals) {
								if (value == validateString) return value;
							} else {
								if (value != validateString) return value;
							}
							pTableField_Extends = item.Properties["Extends"];
							if (!pTableField_Extends.hasOwnProperty("refentityid")) return value;
							item = _GOT2.default.getDataType(pTableField_Extends.refentityid);
						}
					} else {
						if (validateEquals) {
							if (value == validateString) return value;
						} else {
							if (value != validateString) return value;
						}
						var pTableField_Extends = item.Properties["Extends"];
						if (!pTableField_Extends.hasOwnProperty("refentityid")) return value;
						item = _GOT2.default.getDataType(pTableField_Extends.refentityid);
						if (item == null) item = _GOT2.default.getEnum(pTableField_Extends.refentityid);
					}
				}
	
				while (item.qname == "DataType") {
					var tmp = item.Properties[propertyName];
					if (tmp == null) return value;
					value = tmp.V;
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
	
					var pDataType_Extends = item.Properties["Extends"];
					if (pDataType_Extends == null) return value;
					if (!pDataType_Extends.hasOwnProperty("refentityid")) return value;
					item = _GOT2.default.getDataType(pDataType_Extends.refentityid);
					if (item == null) item = _GOT2.default.getEnum(pDataType_Extends.refentityid);
				}
	
				if (item.qname == "Enum") {
					tmp = item.Properties[propertyName];
					if (tmp == null) return value;
					value = tmp.V;
					if (validateEquals) {
						if (value == validateString) return value;
					} else {
						if (value != validateString) return value;
					}
				}
	
				return value;
			}
		}, {
			key: "hasProperty",
			value: function hasProperty(reportField, property) {
				if (reportField.Properties.hasOwnProperty(property)) return true;else return false;
			}
		}, {
			key: "getReprotFinalValue",
			value: function getReprotFinalValue(item, property) {
				var nodeName = item.qname;
				if (nodeName == "ReportField") {
					if (property == "Extends" || property == "Source") return item.Properties[property].V;
	
					var hasProperty = GOTUtil.hasProperty(item, property);
					if (hasProperty) {
						var value = item.Properties[property].V;
						if (value != "") return value;
					}
	
					var extendsPro = item.Properties["Extends"];
					if (extendsPro.hasOwnProperty("refentityid")) {
						var refId = extendsPro.refentityid;
						if (refId.substr(0, 2) == "20") var entity = _GOT2.default.getDataType(refId);else entity = _GOT2.default.getEnum(refId);
						return GOTUtil.getFinalValue(entity, entity, property);
					}
	
					if (property == "Label") return item.name;
	
					//如果是ReportField 并且该属性在这个ReportField上没有并且它又不继承任何DataType
					//或者这个属性在这个ReportField上有但是值是空
	
					if ("Regular" == property) {
						return "";
					} else if ("NotNull" == property) {
						return "false";
					} else if ("AllowEdit" == property) {
						return "true";
					} else if ("AllowEditOnCreate" == property) {
						return "true";
					} else if ("Default" == property) {
						return "";
					} else if ("SkipTab" == property) {
						return "false";
					} else if ("DisplayHeight" == property) {
						return "1";
					} else if ("Seperator" == property) {
						return "-";
					} else if ("NumOfYear" == property) {
						return "4";
					} else if ("NumOfMonth" == property) {
						return "2";
					} else if ("NumOfDay" == property) {
						return "2";
					} else if ("Show1970" == property) {
						return "true";
					} else if ("ShowZero" == property) {
						return "true";
					} else if ("ThousandSeperator" == property) {
						return ",";
					} else if ("AllowNegative" == property) {
						return "true";
					} else if ("ShowDecimals" == property) {
						return "true";
					} else if ("RoundOff" == property) {
						return "HalfUp";
					} else if ("Trim" == property) {
						return "LeftRight";
					} else if ("ChangeCase" == property) {
						return "None";
					} else if ("ShowHour" == property) {
						return "true";
					} else if ("ShowMinute" == property) {
						return "true";
					} else if ("ShowSecond" == property) {
						return "true";
					}
	
					return "";
				}
	
				if (nodeName == "ReportQuery") {
					return item.Properties[property].V;
				}
	
				if (nodeName == "Report") {
					var label = item.Properties[property].V;
					if (label == "") return item.name;
					return label;
				}
	
				if (nodeName == "Query" && property == "Title") {
					value = item.Properties[property].V;
					if (value == "") {
						var queryTable = item.QueryTable;
						if (queryTable == undefined || queryTable == null) return item.name;
						extendsPro = item.Properties["Table"];
						if (extendsPro.hasOwnProperty("refentityid")) var table = _GOT2.default.getTable(extendsPro.refentityid);
						if (table != null) {
							value = GOTUtil.getFinalValue(table, table, "Label");
							if (value == "") value = item.name;
						}
					}
					return value;
				}
	
				return null;
			}
		}, {
			key: "getFilterFieldFromFormItem",
			value: function getFilterFieldFromFormItem(item) {
				var result = null;
				if (item.type == "StringEditor") {
					var dataSource = item.Properties["DataSource"].V;
					if (dataSource != "") {
						var extendsPro = item.Properties["Extends"];
						if (extendsPro.hasOwnProperty("refentityid") && extendsPro.hasOwnProperty("refinnerid")) {
							var entityid = extendsPro.refentityid;
							var innerid = extendsPro.refinnerid;
							var tableField = _GOT2.default.getTableField(entityid, innerid);
							if (tableField != null) {
								var filterField = tableField.Properties["FilterField"].V;
								if (filterField != "") return filterField;
							}
						}
					}
				}
	
				return result;
			}
		}, {
			key: "getFinalValue",
			value: function getFinalValue(item, entity, property) {
				var value;
				var p;
				var nodeName = item.qname;
	
				if (nodeName == "FormItem") {
	
					if (property == "X" || property == "Y" || property == "Width" || property == "Height" || property == "HideInvisible" || property == "Layout" || property == "Icon" || property == "DisabledIcon" || property == "ShortCut" || property == "DisplayMode" || property == "SaveRecord" || property == "MultiSelect" || property == "DisplayHeight" || property == "ShowLabel" || property == "LabelPosition" || property == "LabelAlignment" || property == "SearchMode" || property == "ReturnLookup" || property == "Source" || property == "DataSource" || property == "DataMethod" || property == "Extends" || property == "FieldGroup" || property == "Component" || property == "MenuItem" || property == "ShowHeader" || property == "SkipTab" || property == "LabelLength" || property == "HeaderAlign" || property == "Rows" || property == "URL" || property == "Suffix" || property == "Popup" || property == "LayoutMode" || property == "ControlType" || property == "ClassName" || property == "FailureImage" || property == "QueryType" || property == "ButtonType" || property == "GroupType" || property == "QuerySource" || property == "QueryField" || property == "QueryFilter"
					//Button
					|| property == "DisabledIcon" || property == "SearchMode" || property == "AuthorityLevel" || property == "AlignBase") {
						return item.Properties[property].Value;
					}
	
					if (property == "FilterField") {
						value = GOTUtil.getFilterFieldFromFormItem(item);
						if (value != null) return value;else return "";
					}
	
					if (property == "Trim") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "LeftRight";
					} else if (property == "ChangeCase") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "None";
					} else if (property == "ShowZero") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "true";
					} else if (property == "AllowNegative") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "true";
					} else if (property == "ThousandSeperator") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "false";
					} else if (property == "ShowDecimals") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "2";
					} else if (property == "RoundOff") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "HalfUp";
					} else if (property == "Seperator") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "-";
					} else if (property == "NumOfYear") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "4";
					} else if (property == "NumOfMonth") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "2";
					} else if (property == "NumOfDay") {
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "2";
					} else if (property == "Show1970") {
						return true;
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "false";
					} else if (property == "ShowHour" || property == "ShowMinute" || property == "ShowSecond") {
						return true;
						value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
						if (value != null) return value;else return "true";
					}
					//下面两个TextTrue TextFalse 目前用不上，在画面上只是CheckBox，没有显示文字的时候
					else if (property == "TextTrue") {
							value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
							if (value != null) return value;else return "是";
						} else if (property == "TextFalse") {
							value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
							if (value != null) return value;else return "否";
						}
	
					var formItemType = item.type;
	
					if (formItemType == "Text") return item.Properties[property].Value;
	
					if (property == "Label" && formItemType == "FieldGroup") {
						//self
						value = item.Properties[property].Value;
						if (value != "") return value;
	
						//FormItem --> TableFieldGroup
						p = item.Properties["FieldGroup"];
						if (p.hasOwnProperty("refentityid")) {
							var refentityId = p.refentityid;
							var table = _GOT2.default.getTable(refentityId);
							var tableFieldGroup = _GOT2.default.getTableFieldGroup(table, p.refinnerid);
							value = tableFieldGroup.Properties[property].V;
							/*value = GOT.getTable(p.@refentityid).TableFieldGroups.TableFieldGroup
	      	.(@id==p.@refinnerid).Properties.Property
	      	.(Name==property).Value;*/
							if (value != "") return value;else return "";
						}
	
						//FormItem -->FormDataSourceField_Component
						p = item.Properties["Component"];
						if (p.hasOwnProperty("refinnerid")) {
							var _table2 = _GOT2.default.getTable(p.refinnerid);
							var refinnerId = p.refinnerid;
							var tmp = _GOT2.default.getTableField(_table2, refinnerId);
							value = tmp.Properties[property].V;
							if (value != "") {
								return value;
							} else {
								var _refentityId5 = tmp.Properties["Extends"].refentityid;
								var dataType = _GOT2.default.getDataType(_refentityId5);
								value = dataType.Properties[property].Value;
								if (value != "") return value;else return "";
							}
						}
	
						//FormItem --> Component
						p = item.Properties["Component"];
						if (p.hasOwnProperty("refentityid")) {
							var _refentityId6 = p.refentityid;
							var _dataType = _GOT2.default.getDataType(_refentityId6);
							value = _dataType.Properties[property].V;
							if (value != "") return value;else return "";
						}
	
						return value;
						/*
	     if(value=="")
	     	return item.@name;
	     else
	     	return value;*/
					}
	
					if (formItemType.indexOf("Editor") == -1) {
						if (property == "AllowEdit" || property == "Visible") {
							if (formItemType == "FieldGroup") {
								return GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
							} else {
								return item.Properties[property].Value;
							}
						} else if (property == "Label") {
							value = item.Properties[property].Value;
							if (value != "") return value;else return item.name;
						} else return null; //前面都已经判断完了，这种情况应该不存在
					}
	
					if (property == "AllowEditOnCreate") {
						var allowEdit = item.Properties["AllowEdit"].Value;
						if (allowEdit == "false") return "false";
						p = item.Properties["Extends"];
						if (!p.hasOwnProperty("refentityid") || !p.hasOwnProperty("refinnerid")) return "true";
						var pFormItem_DataSource = item.Properties["DataSource"];
						var innerId = pFormItem_DataSource.innerid;
						var formDataSource = _GOT2.default.getFormDataSource(entity, innerId);
						var formDataSourceFieldName = p.Value;
						item = _GOT2.default.getFormDataSourceField(formDataSource, formDataSourceFieldName);
						/*item = XML(getItemEntity(item).FormDataSources.FormDataSource.(@id==pFormItem_DataSource.@innerid)[0])
	     	.FormDataSourceFields.FormDataSourceField.(@name==p.Value)[0];*/
						allowEdit = item.Properties["AllowEdit"].Value;
						if (allowEdit == "false") return "false";
						var _table = _GOT2.default.getTable(p.refentityid);
						var _istmp = _table.Properties["Temporary"].V;
						if (_istmp == "true") return "false";
						var tableField = _GOT2.default.getTableField(_table, p.refinnerid);
						return tableField.Properties[property].V;
					}
	
					if (property == "Label") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
						if (value != "" && value != null) return value;else {
							return item.name;
						}
					} else if (property == "HelpText" || property == "DisplayLength" || property == "Regular" || property == "Default") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					} else if (property == "Alignment" || property == "StringSize" || property == "FormLookup"
					//|| property=="ValidateLookup"
					|| property == "NumOfDecimals") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, false);
					} else if (property == "AllowEdit") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "Visible") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "NotNull") {
						return GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					}
					return null; //FormItem应该在上面 全覆盖了 到此为null异常	
				}
	
				if (nodeName == "FormDataSource" && property == "Label") {
					var _tablePro = item.Properties["Table"];
					if (_tablePro.hasOwnProperty("refentityid")) {
						var _refentityid = _tablePro.refentityid;
						_tablePro = _GOT2.default.getTable(_refentityid);
						var _label = _tablePro.Properties["Label"].V;
						if (_label != "") return _label;
						return item.name;
					}
				}
	
				if (nodeName == "FormDataSourceField" || nodeName == "TableField" || nodeName == "DataType" || nodeName == "Enum") {
	
					if (property == "AllowEdit") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "Visible") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "false", true, true);
					} else if (property == "NotNull") {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					} else {
						value = GOTUtil.getPropertyValueStepByStep(item, entity, property, "", false, true);
					}
	
					if (value == "") {
						if (property == "Label") return item.name;
					} else {
						return value == null ? "" : value;
					}
				}
	
				if (nodeName == "FormDataSourceFieldGroup" && property == "Label") {
					var pFormDataSourceFieldGroup_FieldGroup = item.Properties["FieldGroup"];
					var _refentityId7 = pFormDataSourceFieldGroup_FieldGroup.refentityid;
					var _table3 = _GOT2.default.getTable(_refentityId7);
					var _refinnerId2 = pFormDataSourceFieldGroup_FieldGroup.refinnerid;
					var _tableFieldGroup = _GOT2.default.getTableFieldGroup(_table3, _refinnerId2);
					value = _tableFieldGroup.Properties[property].V;
					/*value = GOT.getTable(pFormDataSourceFieldGroup_FieldGroup.@refentityid)
	    	.TableFieldGroups.TableFieldGroup.(@id==pFormDataSourceFieldGroup_FieldGroup.@refinnerid)
	    	.Properties.Property.(Name==property).Value;*/
					if (value == "") return item.name;else return value;
				}
	
				value = item.Properties.hasOwnProperty(property) ? item.Properties[property].Value || item.Properties[property].V : "";
	
				if (value == "") {
					if (property == "Label" && nodeName != "EnumItem") return item.name;else if (property == "DefaultOrderBy") return "RecIdx";
				}
	
				return value;
	
				//TODO HashMap做缓存 propertyValueHash[valueKey] = value;
			}
		}, {
			key: "getTitleFormDataSource",
			value: function getTitleFormDataSource(form) {
				var formDesign = form.FormDesign;
				var titleDataSourcePro = formDesign.Properties["TitleDataSource"];
				var formDesignDataSourcePro = formDesign.Properties["DataSource"];
	
				var dataSource = null;
				if (titleDataSourcePro && titleDataSourcePro.hasOwnProperty("innerid")) {
					var innerId = titleDataSourcePro.innerid;
					dataSource = _GOT2.default.getFormDataSource(form, innerId);
					//dataSource = form.FormDataSources.FormDataSource.(@id == String(titleDataSourcePro.@innerid));
				} else if (formDesignDataSourcePro && formDesignDataSourcePro.hasOwnProperty("innerid")) {
					var _innerId2 = formDesignDataSourcePro.innerid;
					dataSource = _GOT2.default.getFormDataSource(form, _innerId2);
					//dataSource = form.FormDataSources.FormDataSource.(@id == String(formDesignDataSourcePro.@innerid));
				} else if (form.FormDataSources.DataSources.length > 0) {
					dataSource = form.FormDataSources.DataSources[0];
				}
	
				return dataSource;
			}
		}, {
			key: "getFormDataSourceTable",
			value: function getFormDataSourceTable(dataSource) {
				var tablePro = dataSource.Properties["Table"];
				if (tablePro.hasOwnProperty("refentityid")) {
					var table = _GOT2.default.getTable(tablePro.refentityid);
					if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
					return table;
				} else {
					throw new Error("GOT错误 在DataSource上的Table属性没有继承自表");
				}
			}
		}, {
			key: "getLabelByForm",
			value: function getLabelByForm(form, firstGroup) {
				var label = "";
	
				var menuItemid = form.menuItemId;
				if (menuItemid != "") {
					var menuItem = _GOT2.default.getMenuItem(menuItemid);
					if (menuItem != null) {
						label = menuItem.Properties["Label"].V;
						if (label != "") return label;
					}
				}
				var titlePro = form.Properties["Title"];
				label = titlePro.Value;
				if (label != "") return label;
	
				var labelPro;
				var dataSource = GOTUtil.getTitleFormDataSource(form);
				if (dataSource) {
					var tablePro = dataSource.Properties["Table"];
					if (tablePro.hasOwnProperty("refentityid")) {
						var table = _GOT2.default.getTable(tablePro.refentityid);
						if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
						labelPro = table.Properties["Label"];
						label = labelPro.V;
						if (label != "") return label;
					}
				}
				if (firstGroup != null) {
					var mainSource = firstGroup.mainSource;
					tablePro = mainSource.xml.Properties["Table"];
					if (tablePro != null && tablePro.hasOwnProperty("refentityid")) {
						table = _GOT2.default.getTable(tablePro.refentityid);
						if (table != null) {
							label = table.Properties["Label"].V;
							if (label != "") return label;
						}
					}
				}
	
				if (menuItem != null) return menuItem.name;
	
				return form.name;
			}
		}, {
			key: "getLabelByFormOrig",
			value: function getLabelByFormOrig(form) {
				var label = "";
	
				var titlePro = form.Properties["Title"];
				label = titlePro.Value;
				if (label != "") return label;
				var formDesign = form.FormDesign;
	
				var labelPro = formDesign.Properties["Label"];
				label = labelPro.Value;
				if (label != "") return label;
	
				var dataSource = GOTUtil.getTitleFormDataSource(form);
				if (dataSource) {
					var tablePro = dataSource.Properties["Table"];
					if (tablePro.hasOwnProperty("refentityid")) {
						var table = _GOT2.default.getTable(tablePro.refentityid);
						if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
						labelPro = table.Properties["Label"];
						label = labelPro.V;
						if (label != "") return label;
					}
				}
	
				return form.name;
			}
		}, {
			key: "getMenuItemLabel",
			value: function getMenuItemLabel(menuItem) {
				var labelPro = menuItem.Properties["Label"];
				if (labelPro.V == "") {
					var sourceTypePro = menuItem.Properties["SourceType"] || menuItem.Properties["Source"];
					var sourceType = sourceTypePro.V;
					var refObjectPro = menuItem.Properties["RefObject"] || menuItem.Properties["Source"];
	
					var id = "";
					var refObject;
	
					if (sourceType == "Form") {
	
						if (refObjectPro.hasOwnProperty("refentityid")) {
							id = refObjectPro.refentityid;
							refObject = _GOT2.default.getForm(id);
							if (refObject == null) throw new Error("GOT閿欒 鍦╮efObject涓婃壘涓嶅埌Form");
							return GOTUtil.getLabelByFormOrig(refObject);
						}
					} else if (sourceType == "Report") {
						if (refObjectPro.hasOwnProperty("refentityid")) {
							id = refObjectPro.refentityid;
							refObject = _GOT2.default.getReport(id);
							if (refObject == null) throw new Error("从MenuItem上找不到对应的Report");
							return GOTUtil.getFinalValue(refObject, refObject, "Label");
						}
					}
				}
				return labelPro.V;
			}
		}, {
			key: "getMainTable",
			value: function getMainTable(dname) {
				var dataType = _GOT2.default.getDataType(dname);
				if (dataType == null) {
					//alert("没有找到DataType" + dname);
					return null;
				}
				var dataTypeRelation = dataType.DataTypeRelation;
				if (dataTypeRelation == null) return null;
				var tablepro = dataTypeRelation.Properties["Table"];
				//var pro:XMLList = dataTypeRelation.Properties.Property.(Name == "Table");
				var obj = new Object();
				obj.mainTable = tablepro.V;
				obj.dataType = dataType;
				return obj;
			}
		}, {
			key: "getAutoLookupFields",
			value: function getAutoLookupFields(mainTable, dataTypeRelation) {
				var tableFields = [];
				var tableField;
				var fieldPro;
				var allTableFields = mainTable.TableFields;
				var autoLookUp = _GOT2.default.getTableFieldGroup("AutoLookup");
				for (var i in autoLookUp.FieldGroupItems) {
					var tableFieldGroupItem = autoLookUp.FieldGroupItems[i];
					fieldPro = tableFieldGroupItem.Properties["Field"];
					var innerId = fieldPro.innerid;
					tableField = _GOT2.default.getTableField(innerId);
					if (!tableField) throw new Error("GOT设置错误 在AutoLookup的GroupItem上找不到TableField");
					tableFields.push(tableField);
				}
	
				if (tableFields.length == 0) {
					fieldPro = mainTable.Properties["TitleField1"];
	
					if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
						var _innerId3 = fieldPro.innerid;
						tableField = _GOT2.default.getTableField(_innerId3);
						if (!tableField) throw new Error("GOT设置错误 在TitleField1上找不到TableField");
						tableFields.push(tableField);
					}
					fieldPro = mainTable.Properties["TitleField2"];
					if (fieldPro && fieldPro.hasOwnProperty("innerid")) {
						var _innerId4 = fieldPro.innerid;
						tableField = _GOT2.default.getTableField(_innerId4);
						if (!tableField) throw new Error("GOT设置错误 在TitleField2上找不到TableField(存在innerid)");
						tableFields.push(tableField);
					}
				}
	
				var index;
				var indexItem;
				var indexes;
				if (tableFields.length == 0) {
					fieldPro = mainTable.Properties["ClusterIndex"];
					if (fieldPro.hasOwnProperty("innerid")) {
						var _innerId5 = fieldPro.innerid;
						index = _GOT2.default.getTableIndex(mainTable, _innerId5);
						for (var i in index.IndexItems) {
							var indexItem = index.IndexItems[i];
							fieldPro = indexItem.Properties["Field"];
							if (fieldPro.hasOwnProperty("innerid")) {
								var _innerId6 = fieldPro.innerid;
								tableField = _GOT2.default.getTableField(_innerId6);
								if (!tableField) throw new Error("GOT设置错误 在TableIndexItem上找不到TableField(存在innerid)");
								tableFields.push(tableField);
							}
						}
					}
				}
	
				if (tableFields.length == 0) {
					if (dataTypeRelation != null) {
						var normalItem = _GOT2.default.getDataTypeRelationNormalItem(dataTypeRelation);
						if (normalItem != null) {
							fieldPro = normalItem.Properties["Field"];
							if (fieldPro.hasOwnProperty("refinnerid")) {
								var refinnerId = fieldPro.refinnerid;
								tableField = _GOT2.default.getTableField(mainTable, refinnerId);
								if (!tableField) throw new Error("GOT设置错误 在RelationItem上找不到TableField(存在refinnerid)");
								tableFields.push(tableField);
							}
						}
					}
				}
	
				return tableFields;
			}
		}, {
			key: "getComponentItemName",
			value: function getComponentItemName(dataField) {
				if (dataField == null) return null;
	
				var array = dataField.split(".");
				if (array.length == 3) {
					var s = array[2];
					return s.substr(0, 1).toUpperCase() + s.substring(1);
				}
	
				return null;
			}
		}, {
			key: "getDataType2",
			value: function getDataType2(_entityId, _innerId) {
				if (!_entityId) {
					throw new Error("unknown type of StringEditor");
				}
	
				var _entityIdArr = _entityId.split(".");
				var _entityIdtmp = _entityIdArr[_entityIdArr.length - 1];
	
				if (_entityIdtmp && _entityIdtmp.indexOf(".") != -1) {
					var entityIdtmpArr = _entityIdtmp.split(".");
					var lastId = entityIdtmpArr[entityIdtmpArr.length - 1];
					entityIdtmp = lastId;
				}
	
				var first = _entityIdtmp.substr(0, 2);
				if (first == "40" && _innerId != null) {
					return GOTUtil.getDataTypeByFormItem(_entityId, _innerId);
				} else if (first == "73" && _innerId != null) {
					return GOTUtil.getDataTypeByReportField(_entityId, _innerId);
				} else if (first == "30" && _innerId != null) {
					return GOTUtil.getDataTypeByTableField(_entityId, _innerId);
				} else if (first == "20" && _innerId == null) {
					return GOTUtil.getDataTypeByDataType(_entityId);
				} else {
					throw new Error("unknown type of StringEditor");
				}
			}
		}, {
			key: "getDataTypeByReportField",
			value: function getDataTypeByReportField(entityId, innerId) {
				var dataType;
				var reportField = GOTUtil.getItemXML(entityId, innerId);
	
				var extendsPro = reportField.Properties["Extends"];
				if (extendsPro.hasOwnProperty("refentityid")) {
					dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
				}
				return dataType;
			}
		}, {
			key: "getDataTypeByFormItem",
			value: function getDataTypeByFormItem(entityId, innerId) {
				var dataType;
				var form = _GOT2.default.getForm(entityId);
				var formItem = _GOT2.default.getFormItem(form, innerId);
				//var formItem = GOT.getForm(entityId).descendants("FormItem").(@id == innerId);
				if (formItem == null) throw new Error("multi formitem to StringEditor");
				var extendsPro = formItem.Properties["Extends"];
				if (extendsPro.hasOwnProperty("refentityid")) {
					if (extendsPro.hasOwnProperty("refinnerid")) {
						var tableId = extendsPro.refentityid;
						var tableFieldId = extendsPro.refinnerid;
						dataType = GOTUtil.getDataTypeByTableField(tableId, tableFieldId);
					} else {
						dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
					}
				}
				return dataType;
			}
		}, {
			key: "getDataTypeByTableField",
			value: function getDataTypeByTableField(tableId, tableFieldId) {
				var table = _GOT2.default.getTable(tableId);
				var dataType;
				if (table) {
					var tableField = _GOT2.default.getTableField(table, tableFieldId);
					var extendsPro = tableField.Properties["Extends"];
					if (extendsPro.hasOwnProperty("refentityid")) dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
				}
				return dataType;
			}
		}, {
			key: "getDataTypeByDataType",
			value: function getDataTypeByDataType(entityId) {
				var dataType = _GOT2.default.getDataType(entityId);
				return dataType;
			}
	
			//TODO Inner节点目前只支持TableField 发现错误应该再加 比如Report Flex版由于e4x都支持
	
		}, {
			key: "getItemXML",
			value: function getItemXML(entityId, innerId) {
				var entity = GOTUtil.getEntityXML(entityId);
				if (innerId) {
					return GOTUtil.getInnerXML(entity, innerId);
				}
	
				return entity;
			}
		}, {
			key: "getEntityType",
			value: function getEntityType(entityId) {
				var type;
				if (!entityId) {
					return null;
				}
	
				var _entityIdArr = entityId.split(".");
				entityId = _entityIdArr[_entityIdArr.length - 1];
	
				var first = parseInt(entityId.substr(0, 2));
				if (first == 10) type = "Enum";else if (first == 20) type = "DataType";else if (first == 30) type = "Table";else if (first == 40) type = "Form";else if (first == 50) type = "MenuItem";else if (first == 60) type = "Menu";else if (first == 71) type = "Map";else if (first == 72) type = "Query";else if (first == 73) type = "Report";else type = null;
	
				return type;
			}
		}, {
			key: "getEntityXML",
			value: function getEntityXML(_id) {
				if (_id == null) return null;
	
				var type = GOTUtil.getEntityType(_id);
	
				switch (type) {
					case "Enum":
						return _GOT2.default.getEnum(_id);
					case "DataType":
						return _GOT2.default.getDataType(_id);
					case "Table":
						return _GOT2.default.getTable(_id);
					case "MenuItem":
						return _GOT2.default.getMenuItem(_id);
					case "Menu":
						return _GOT2.default.getMenu(_id);
					case "Form":
						return _GOT2.default.getForm(_id);
					case "Query":
						return _GOT2.default.getQuery(_id);
					case "Report":
						return _GOT2.default.getReport(_id);
					default:
						throw new Error("非法的Entity Type");
				}
			}
	
			/*private static var innerCache:Object = {};
	  public static function clearInnerCache(entityid:String = null):void
	  {
	  	if(entityid == null)
	  	{
	  		innerCache = {};
	  	}
	  	else
	  	{
	  		var temp:Vector.<String> = new Vector.<String>();
	  		for (var key:String in innerCache)
	  		{
	  			if(key.split(".")[0] == entityid)
	  			{
	  				temp.push(key);
	  			}
	  		}
	  		
	  		for each(key in temp)
	  		{
	  			innerCache[key] = null;
	  			delete innerCache[key];
	  		}
	  	}
	  }*/
	
		}, {
			key: "getInnerXML",
			value: function getInnerXML(entity, innerId) {
				if (entity.id.indexOf("3") == 0) {
					return _GOT2.default.getTableField(entity, innerId);
				}
			}
	
			/*public static function getInnerXML(entity, _innerId)
	  {
	  	
	  	let qname = (entity.hasOwnProperty("FormDesign")?"Form":"");
	  	if(qname == "Form")
	  	{
	  		return GOT.getFormItem(entity,_innerId);
	  	}
	  	else
	  	{
	  		list = entity.descendants().(hasOwnProperty("@id")&&@id==_innerId);
	  	}
	  	
	  }*/
	
		}, {
			key: "getFormItemInnerXML",
			value: function getFormItemInnerXML(entity, _innerId) {
				return _GOT2.default.getFormItem(entity, _innerId);
			}
	
			/*static parseUserForm2Form(formXML,root)
	  {
	  	var parent = GOTUtil.parseUserForm2FormItem(formXML,root);
	  	var childs = root.children;
	  	for(let i = 0;i<childs.length;i++)
	  	{
	  		let item = childs[i];
	  		parent.appendChild(GOTUtil.parseUserForm2Form(formXML,item));
	  	}
	  	return parent;
	  }*/
	
			//for Form JSON
	
		}, {
			key: "getFormItemInnerXMLByCache2",
			value: function getFormItemInnerXMLByCache2(entity, _innerId) {
				if (!GOTUtil.formItemCache2[entity.id + "_" + _innerId]) {
					var list = GOTUtil.elementsFormHasId(entity);
					for (var i = 0; i < list.length; i++) {
						var node = list[i];
						GOTUtil.formItemCache2[entity.id + "_" + node.id] = node;
						GOTUtil.getFormItemInnerXMLByCache2(node, _innerId);
					}
				}
	
				return GOTUtil.formItemCache2[entity.id + "_" + _innerId];
			}
	
			//for Form XML
	
		}, {
			key: "getFormItemInnerXMLByCache",
			value: function getFormItemInnerXMLByCache(entity, _innerId) {
				if (!GOTUtil.formItemCache[entity.id + "_" + _innerId]) {
					var list = entity.getElementsByTagName("FormItem");
					for (var i = 0; i < list.length; i++) {
						var node = list[i];
						GOTUtil.formItemCache[entity.id + "_" + node.id] = node;
					}
				}
	
				return GOTUtil.formItemCache[entity.id + "_" + _innerId];
			}
	
			/*static parseUserForm2FormItem(formXML,item)
	  {
	  	var innerId = item.id;
	  	let formItem;
	  	if(!innerId || innerId == "FormDesign")
	  	{
	  		formItem = formXML.children[2].cloneNode(true);
	  	}
	  	else
	  	{
	  		formItem = GOTUtil.getFormItemInnerXMLByCache(formXML,innerId).cloneNode(true);	
	  	}
	  
	  	let userProperties = {};
	  	var atts = item.attributes;
	  	for(var k=0; k<atts.length; k++)
	  	{
	  		var att = atts[k];
	  		if(att.nodeName != "id")
	  			userProperties[att.nodeName] = att.nodeValue;
	  	}
	  	
	  	var _parentWindow = window.parent.window;
	  	if(!_parentWindow.userProperties)
	  		_parentWindow.userProperties = {};
	  	if(!_parentWindow.userProperties[window.menuItemId+"."+window.formId])
	  		_parentWindow.userProperties[window.menuItemId+"."+window.formId] = {};
	  	var allUserProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
	  	if(!allUserProperties.hasOwnProperty(innerId))
	  		allUserProperties[innerId] = {};
	  	Object.assign(allUserProperties[innerId],userProperties);
	  
	  	var childs = formItem.childNodes; 
	  	for(var i = childs.length - 1; i >= 0; i--)
	  	{
	  	  let child = childs[i];
	  	  if(child.nodeName != "Properties")
	  	  	formItem.removeChild(childs[i]);
	  	}
	  	return formItem;
	  }*/
	
		}, {
			key: "descendantsFormHasIdItem",
			value: function descendantsFormHasIdItem(item, result) {
				var qname = item.qname;
				if (qname == "FormDataSources") {
					GOTUitl.descendantsFormDataSourcesHasId(item, result);
				} else if (qname == "FormDataSource") {
					GOTUtil.descendantsFormDataSourceHasId(item, result);
				} else if (qname == "FormDataSourceFieldGroup" || qname == "FormDataSourceField") {
					result.push(item);
				} else if (qname == "FormItem" || qname == "FormDesign") {
					GOTUtil.descendantsFormDesignHasId(item, result);
				}
			}
		}, {
			key: "descendantsFormHasId",
			value: function descendantsFormHasId(form, result) {
				var formDataSources = form.FormDataSources;
				result.push(formDataSources);
				GOTUtil.descendantsFormDataSourcesHasId(formDataSources, result);
				var formDesign = form.FormDesign;
				result.push(formDesign);
				GOTUtil.descendantsFormDesignHasId(formDesign, result);
			}
		}, {
			key: "elementsFormHasId",
			value: function elementsFormHasId(item) {
				var qname = item.qname;
				if (qname == "Form") {
					return [item.FormDataSources, item.FormDesign];
				}
				if (qname == "FormDataSources") {
					return item.DataSources;
				} else if (qname == "FormDataSource") {
					return item.FormDataSourceFieldGroups.concat(item.FormDataSourceFields);
				} else if (qname == "FormDataSourceFieldGroup" || qname == "FormDataSourceField") {
					return [];
				} else if (qname == "FormItem" || qname == "FormDesign") {
					return item.FormItem;
				}
				return [];
			}
		}, {
			key: "descendantsFormDesignHasId",
			value: function descendantsFormDesignHasId(item, result) {
				var formItems = item.FormItem;
				for (var i = 0; i < formItems.length; i++) {
					var formItem = formItems[i];
					result.push(formItem);
					GOTUtil.descendantsFormDesignHasId(formItem, result);
				}
			}
		}, {
			key: "descendantsFormDataSourcesHasId",
			value: function descendantsFormDataSourcesHasId(item, result) {
				var dataSources = item.DataSources;
				for (var i = 0; i < dataSources.length; i++) {
					var dataSource = dataSources[i];
					result.push(dataSource);
					GOTUtil.descendantsFormDataSourceHasId(dataSource, result);
				}
			}
		}, {
			key: "descendantsFormDataSourceHasId",
			value: function descendantsFormDataSourceHasId(item, result) {
				var formDataSourceFieldGroups = item.formDataSourceFieldGroups;
				for (var i = 0; i < formDataSourceFieldGroups.length; i++) {
					var formDataSourceFieldGroup = formDataSourceFieldGroups[i];
					GOTUtil.descendantsFormDataSourceFieldGroupHasId(formDataSourceFieldGroup);
				}
				var formDataSourceFields = item.FormDataSourceFields;
				for (var _i = 0; _i < formDataSourceFields.length; _i++) {
					var formDataSourceField = formDataSourceFields[_i];
					GOTUtil.descendantsFormDataSourceFieldHasId(formDataSourceField, result);
				}
			}
		}, {
			key: "descendantsFormDataSourceFieldHasId",
			value: function descendantsFormDataSourceFieldHasId(item, result) {
				result.push(item);
			}
		}, {
			key: "descendantsFormDataSourceFieldGroupHasId",
			value: function descendantsFormDataSourceFieldGroupHasId(item, result) {
				result.push(item);
			}
	
			/////////////////////////////////////////////////////////////////////////////////
	
		}, {
			key: "getArrayItemByName",
			value: function getArrayItemByName(dataType, itemName) {
				return _GOT2.default.getDataTypeArrayItem(dataType, itemName);
			}
		}, {
			key: "getDataSourceByDataSource",
			value: function getDataSourceByDataSource(extendsPro) {
				if (!extendsPro.hasOwnProperty("refentityid")) return [];
				var tableId = extendsPro.refentityid;
				var tableFieldId = extendsPro.refinnerid;
				var _table = _GOT2.default.getTable(tableId);
				var tableField = _GOT2.default.getTableField(_table, tableFieldId);
	
				if (tableField.type == "Component") {
					var textendsPro = tableField.Properties["Extends"];
					if (!textendsPro.hasOwnProperty("refentityid")) throw new Error("GOT错误:Component类型的TableField没有正确关联到一个对应的DataType");
					var cdataTypeId = textendsPro.refentityid;
					var cdataType = _GOT2.default.getDataType(cdataTypeId);
					var value = extendsPro.V;
					var arrayItemName = value.split(".")[1];
					var arrayItem = _GOT2.default.getDataTypeArrayItem(cdataType, arrayItemName);
					var refDataTypePro = arrayItem.Properties["RefDataType"];
					if (!refDataTypePro.hasOwnProperty("refentityid")) throw new Error("GOT错误:" + cdataType.name + "." + arrayItemName + "没有关联到DataType");
	
					return GOTUtil.getDataSourceByDataType(refDataTypePro);
				} else {
					return GOTUtil.getDataSourceByTableField(tableField);
				}
			}
		}, {
			key: "getDataSourceByTableField",
			value: function getDataSourceByTableField(tableField) {
				var sourcePro = tableField.Properties["Source"];
	
				var extendsPro = tableField.Properties["Extends"];
	
				if (!extendsPro.hasOwnProperty("refentityid")) return GOTUtil.getDataSourceByRegular(tableField);
	
				if (sourcePro.V == "Enum") {
					return GOTUtil.getDataSourceByEnum(extendsPro);
				} else {
					return GOTUtil.getDataSourceByDataType(extendsPro);
				}
			}
		}, {
			key: "getDataSourceByReportField",
			value: function getDataSourceByReportField(reportField) {
				var sourcePro = reportField.Properties["Source"];
				var extendsPro = reportField.Properties["Extends"];
				//tableField.Properties.Property.(Name == "Extends");
	
				if (!extendsPro.hasOwnProperty("refentityid")) return GOTUtil.getDataSourceByRegular(reportField);
	
				if (sourcePro.V == "Enum") {
					return GOTUtil.getDataSourceByEnum(extendsPro);
				} else {
					return GOTUtil.getDataSourceByDataType(extendsPro);
				}
			}
		}, {
			key: "getDataSourceByEnum",
			value: function getDataSourceByEnum(extendsPro) {
				if (!extendsPro.hasOwnProperty("refentityid")) return [];
				var enumId = extendsPro.refentityid;
	
				var entityEnum = _GOT2.default.getEnum(enumId);
	
				var collection = [];
	
				var label;
	
				var value;
	
				for (var i in entityEnum.EnumItems) {
					var item = entityEnum.EnumItems[i];
					label = item.Properties["Label"].V;
					value = item.Properties["Value"].V;
	
					collection.push({ label: label, value: value });
				}
	
				return collection;
			}
		}, {
			key: "getDataSourceByDataType",
			value: function getDataSourceByDataType(extendsPro) {
				if (!extendsPro.hasOwnProperty("refentityid")) return [];
	
				var dataType = _GOT2.default.getDataType(extendsPro.refentityid);
				var extendsPro = dataType.Properties["Extends"];
	
				var sourcePro;
				while (extendsPro.hasOwnProperty("refentityid")) {
					sourcePro = dataType.Properties["Source"];
					if (sourcePro == undefined) throw new Error("从EnumEditor到DataType的继承链上存在非Enum类型的DataType");
	
					if (sourcePro.V == "Enum") {
						return GOTUtil.getDataSourceByEnum(extendsPro);
					}
					dataType = _GOT2.default.getDataType(extendsPro.refentityid);
					extendsPro = dataType.Properties["Extends"];
				}
	
				return GOTUtil.getDataSourceByRegular(dataType);
			}
		}, {
			key: "getDataSourceByRegular",
			value: function getDataSourceByRegular(node) {
				var regularPro = node.Properties["Regular"];
	
				if (regularPro == null) return null;
	
				var regular = regularPro.hasOwnProperty("Value") ? regularPro.Value : regularPro.V;
	
				var collection = [];
	
				var value;
	
				var label;
	
				if (regular != "") {
					var array = regular.split("|");
					for (var i in array) {
						var item = array[i];
						if (item.indexOf(":") > -1) {
							value = item.split(":")[0];
							label = item.split(":")[1];
						} else {
							value = item;
							label = item;
						}
	
						collection.push({ label: label, value: value });
					}
				}
	
				return collection;
			}
		}, {
			key: "getQueryTableByName",
			value: function getQueryTableByName(query, name) {
				var queryTables = query.QueryTable.QueryJoins.Items;
				for (var i = 0; i < queryTables.length; i++) {
					var queryTable = queryTables[i];
					if (queryTable.name == name) return queryTable;
				}
				return null;
			}
		}, {
			key: "getQueryRelationItemByProperty",
			value: function getQueryRelationItemByProperty(queryRelation, propertyName) {
				var items = queryRelation.Items;
				var result = [];
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.hasOwnProperty(propertyName)) result.push(item);
				}
				return result;
			}
		}, {
			key: "getQueryRelationItemByPropertyQuery",
			value: function getQueryRelationItemByPropertyQuery(query, propertyName) {
				var result = [];
				var queryTableItems = query.QueryTable.QueryJoins.Items;
				for (var i = 0; i < queryTableItems.length; i++) {
					var queryTable = queryTableItems[i];
					var queryRelation = queryTable.QueryRelation;
					var items = queryRelation.Items;
	
					for (var k = 0; k < items.length; k++) {
						var item = items[k];
						if (item.hasOwnProperty(propertyName)) result.push({ parent: queryRelation, item: item });
					}
				}
				return result;
			}
		}, {
			key: "getQueryWhereItemByPropertyValue",
			value: function getQueryWhereItemByPropertyValue(query, propertyName, propertyValue) {
				var result = [];
				var queryWhereItems = query.hasOwnProperty("QueryWhere") ? query.QueryWhere.Items : query.QueryTable.QueryWhere.Items;
				for (var i = 0; i < queryWhereItems.length; i++) {
					var queryWhereItem = queryWhereItems[i];
					var _value = GOTUtil.getPropertyValue(queryWhereItem, propertyName);
					if (_value == propertyValue) {
						result.push(queryWhereItem);
					}
				}
				return result;
			}
		}, {
			key: "getQueryTableByAlias",
			value: function getQueryTableByAlias(alias, query) {
				var queryTable = GOTUtil.getQueryTableByAlias2(alias, query.QueryTable);
				if (queryTable == null) throw new Error("queryTable can't find");
	
				return queryTable;
			}
		}, {
			key: "getQueryTableByAlias2",
			value: function getQueryTableByAlias2(alias, queryTable) {
				if (alias == null || queryTable == null) return null;
	
				var _alias = queryTable.Properties.Alias.V;
				if (_alias == alias) return queryTable;
	
				if (queryTable.QueryJoins == null) return null;
	
				var list = queryTable.QueryJoins.Items;
				if (list == null || list.length == 0) return null;
	
				for (var i = 0; i < list.length; i++) {
					var qt = list[i];
					var result = GOTUtil.getQueryTableByAlias2(alias, qt);
					if (result != null) return result;
				}
	
				return null;
			}
		}, {
			key: "getTitleFormDataSource",
			value: function getTitleFormDataSource(form) {
				var formDesign = form.FormDesign;
				var titleDataSourcePro = formDesign.Properties.TitleDataSource;
				var formDesignDataSourcePro = formDesign.Properties.DataSource;
	
				var dataSource = null;
				if (titleDataSourcePro && titleDataSourcePro.hasOwnProperty("innerid")) {
					dataSource = _GOT2.default.getFormDataSource(form, titleDataSourcePro.innerid);
				} else if (formDesignDataSourcePro && formDesignDataSourcePro.hasOwnProperty("innerid")) {
					dataSource = _GOT2.default.getFormDataSource(form, formDesignDataSourcePro.innerid);
				} else {
					dataSource = form.FormDataSources.DataSources.length > 0 ? form.FormDataSources.DataSources[0] : null;
				}
	
				if (dataSource) {
					return dataSource;
				}
	
				return null;
			}
		}, {
			key: "getLabelByForm",
			value: function getLabelByForm(form, firstGroup, menuItemid) {
				var label = "";
				if (!menuItemid) menuItemid = window.menuItemId;
				if (menuItemid) {
					var menuItem = _GOT2.default.getMenuItem(menuItemid);
					if (menuItem) {
						label = menuItem.Properties.Label.V;
						if (label != "") return label;
					}
				}
				var titlePro = form.Properties.Title;
				label = titlePro.Value;
				if (label != "") return label;
	
				var labelPro;
				var dataSource = GOTUtil.getTitleFormDataSource(form);
				if (dataSource) {
					var tablePro = dataSource.Properties.Table;
					if (tablePro.hasOwnProperty("refentityid")) {
						var table = _GOT2.default.getTable(tablePro.refentityid);
						if (table == null) throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
						labelPro = table.Properties.Label;
						label = labelPro.V;
						if (label != "") return label;
					}
				}
				if (firstGroup) {
					var mainSource = firstGroup.mainSource;
					tablePro = mainSource.xml.Properties.Table;
					if (tablePro && tablePro.hasOwnProperty("refentityid")) {
						table = _GOT2.default.getTable(tablePro.refentityid);
						if (table != null) {
							label = table.Proeprties.Label.V;
							if (label != "") return label;
						}
					}
				}
	
				if (menuItem) return menuItem.name;
	
				return form.name;
			}
		}, {
			key: "getPropertyValue",
			value: function getPropertyValue(xml, property) {
				if (xml.hasOwnProperty("Properties")) {
					var properties = xml.Properties;
					if (properties.hasOwnProperty(property)) {
						var propertyEntity = properties[property];
						var result = propertyEntity.V || propertyEntity.Value;
						if (!result) result = "";
						return result;
					}
				}
				return null;
			}
		}, {
			key: "getProperty",
			value: function getProperty(xml, property) {
				if (xml.hasOwnProperty("Properties")) {
					var properties = xml.Properties;
					if (properties.hasOwnProperty(property)) {
						return properties[property];
					}
				}
				return null;
			}
		}, {
			key: "getShortCut",
			value: function getShortCut(table) {
				if (table == null) return null;
				var result = null;
				var shortcutPro = table.Properties.ShortCutField;
				if (shortcutPro && shortcutPro.hasOwnProperty("innerid")) {
					var innerid = shortcutPro.innerid;
					result = _GOT2.default.getTableField(table, innerid);
					return result;
				}
	
				return null;
			}
		}, {
			key: "getNotComponentFormDataSourceFields",
			value: function getNotComponentFormDataSourceFields(dataSource) {
				var result = [];
				for (var i = 0; i < dataSource.FormDataSourceFields.length; i++) {
					var dataSourceField = dataSource.FormDataSourceFields[i];
					if (dataSourceField.type != "Component") result.push(dataSourceField);
				}
				return result;
			}
		}]);
	
		return GOTUtil;
	}();
	
	GOTUtil.formItemCache2 = {};
	GOTUtil.formItemCache = {};
	exports.default = GOTUtil;

/***/ },
/* 269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSet = function DataSet() {
		_classCallCheck(this, DataSet);
	};
	
	exports.default = DataSet;

/***/ },
/* 270 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColBooleanEditor = function DataSetColBooleanEditor() {
	   _classCallCheck(this, DataSetColBooleanEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 6;
	   this.alignment = "Left";
	   this.textTrue = null;
	   this.textFalse = null;
	   this.type = "Boolean";
	};
	
	exports.default = DataSetColBooleanEditor;

/***/ },
/* 271 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColDateEditor = function DataSetColDateEditor() {
	   _classCallCheck(this, DataSetColDateEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 12;
	   this.alignment = "Center";
	   this.displayFormat = "yyyy-MM-dd";
	   this.type = "Date";
	};
	
	exports.default = DataSetColDateEditor;

/***/ },
/* 272 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColDateTimeEditor = function DataSetColDateTimeEditor() {
	   _classCallCheck(this, DataSetColDateTimeEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 24;
	   this.alignment = "Center";
	   this.displayFormat = "yyyy-MM-dd HH:mm:ss";
	   this.type = "DataTime";
	};
	
	exports.default = DataSetColDateTimeEditor;

/***/ },
/* 273 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColDecimalEditor = function DataSetColDecimalEditor() {
	   _classCallCheck(this, DataSetColDecimalEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 20;
	   this.alignment = "Center";
	   this.showZero = false;
	   this.thousandSeperator = false;
	   this.numOfDecimals = 2;
	   this.displayDecimals = 0;
	   this.currencyType = 'None';
	   this.currencySymbol = 'None';
	   this.percentage = false;
	   this.type = "Decimal";
	};
	
	exports.default = DataSetColDecimalEditor;

/***/ },
/* 274 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColEnumEditor = function DataSetColEnumEditor() {
	   _classCallCheck(this, DataSetColEnumEditor);
	
	   this.name = "";
	   this.label = "";
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 20;
	   this.alignment = "Center";
	   this.enumItems = [];
	   this.type = "Enum";
	};
	
	exports.default = DataSetColEnumEditor;

/***/ },
/* 275 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColLongEditor = function DataSetColLongEditor() {
	   _classCallCheck(this, DataSetColLongEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 20;
	   this.alignment = "Center";
	   this.showZero = false;
	   this.thousandSeperator = false;
	   this.type = "Long";
	};
	
	exports.default = DataSetColLongEditor;

/***/ },
/* 276 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColStringEditor = function DataSetColStringEditor() {
	   _classCallCheck(this, DataSetColStringEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 20;
	   this.alignment = "Center";
	   this.stringSize = 20;
	   this.type = "String";
	};
	
	exports.default = DataSetColStringEditor;

/***/ },
/* 277 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataSetColTimeEditor = function DataSetColTimeEditor() {
	   _classCallCheck(this, DataSetColTimeEditor);
	
	   this.visible = true;
	   this.helpText = null;
	   this.displayLength = 24;
	   this.alignment = "Center";
	   this.displayFormat = "HH:mm:ss";
	   this.type = "Time";
	};
	
	exports.default = DataSetColTimeEditor;

/***/ },
/* 278 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataTable = function DataTable() {
		_classCallCheck(this, DataTable);
	};
	
	exports.default = DataTable;

/***/ },
/* 279 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataTableSchema = function DataTableSchema() {
	   _classCallCheck(this, DataTableSchema);
	};
	
	exports.default = DataTableSchema;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _UserSetStores = __webpack_require__(146);
	
	var _UserSetActions = __webpack_require__(90);
	
	var _UserSetActions2 = _interopRequireDefault(_UserSetActions);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSetFormPropertyPanel = function (_React$Component) {
					_inherits(UserSetFormPropertyPanel, _React$Component);
	
					function UserSetFormPropertyPanel(props, context) {
									_classCallCheck(this, UserSetFormPropertyPanel);
	
									var _this = _possibleConstructorReturn(this, (UserSetFormPropertyPanel.__proto__ || Object.getPrototypeOf(UserSetFormPropertyPanel)).call(this, props, context));
	
									_this.state = {};
									_this.allUserProperties = _this.props.allUserProperties ? _this.props.allUserProperties : {};
	
									//this.allUserProperties["50023"] = {displayLength:50};
	
									_this.unscribeUserSetFormTreeChangedStore = _UserSetStores.UserSetFormTreeChangedStore.listen(_this.onUserSetFormTreeChanged.bind(_this));
									return _this;
					}
	
					_createClass(UserSetFormPropertyPanel, [{
									key: 'onUserSetFormTreeChanged',
									value: function onUserSetFormTreeChanged(properties) {
													if (!this.allUserProperties.hasOwnProperty(properties.innerId)) {
																	this.allUserProperties[properties.innerId] = {};
													}
													this.userProperties = this.allUserProperties[properties.innerId];
													this.setState(properties);
									}
					}, {
									key: 'componentWillUnmount',
									value: function componentWillUnmount() {
													this.unscribeUserSetFormTreeChangedStore();
									}
					}, {
									key: 'componentDidMount',
									value: function componentDidMount() {
													$(this.propertyPanel).find(".minimal").iCheck({
																	checkboxClass: 'icheckbox_minimal-blue14', width: '18px', height: '18px'
													});
													$(this.layoutNode).selectpicker({ width: '100px', height: '24px', noneSelectedText: '未选中', container: 'body',
																	noneResultsText: '没有找到匹配项' });
	
													$(this.visibleNode).on('ifClicked', this.visibleNodeClick.bind(this));
													$(this.hideInVisibleNode).on('ifClicked', this.hideInVisibleNodeClick.bind(this));
													$(this.allowEditNode).on('ifClicked', this.allowEditNodeClick.bind(this));
													$(this.skipTabNode).on('ifClicked', this.skipTabNodeClick.bind(this));
									}
					}, {
									key: 'componentDidUpdate',
									value: function componentDidUpdate() {
													var allColWidth = this.props.allColWidth ? this.props.allColWidth : {};
													var stateObj = Object.assign(this.state, this.userProperties);
													if (stateObj.visible == true) $(this.visibleNode).iCheck('check');else $(this.visibleNode).iCheck('uncheck');
													if (stateObj.allowEdit == true) $(this.allowEditNode).iCheck('check');else $(this.allowEditNode).iCheck('uncheck');
													if (stateObj.hideInVisible == true) $(this.hideInVisibleNode).iCheck('check');else $(this.hideInVisibleNode).iCheck('uncheck');
													if (stateObj.skipTab == true) $(this.skipTabNode).iCheck('check');else $(this.skipTabNode).iCheck('uncheck');
													$(this.layoutNode).selectpicker('val', stateObj.layout);
	
													//TODO 更新enable
													$(this.labelNode).val(stateObj.label);
													if (stateObj.labelEnabled == false) $(this.labelNode).attr("disabled", true);else $(this.labelNode).removeAttr("disabled");
	
													if (stateObj.visibleEnabled == false) {
																	$(this.visibleNode).attr("disabled", true);
																	$(this.visibleContainer).find(".icheckbox_minimal-blue14").addClass("disabled");
																	$(this.visibleDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.visibleNode).removeAttr("disabled");
																	$(this.visibleContainer).find(".icheckbox_minimal-blue14").removeClass("disabled");
																	$(this.visibleDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
	
													if (stateObj.hideInVisibleEnabled == false) {
																	$(this.hideInVisibleNode).attr("disabled", true);
																	$(this.hideInVisibleContainer).find(".icheckbox_minimal-blue14").addClass("disabled");
																	$(this.hideInVisibleDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.hideInVisibleNode).removeAttr("disabled");
																	$(this.hideInVisibleContainer).find(".icheckbox_minimal-blue14").removeClass("disabled");
																	$(this.hideInVisibleDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
	
													if (stateObj.allowEditEnabled == false) {
																	$(this.allowEditNode).attr("disabled", true);
																	$(this.allowEditContainer).find(".icheckbox_minimal-blue14").addClass("disabled");
																	$(this.allowEditDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.allowEditNode).removeAttr("disabled");
																	$(this.allowEditContainer).find(".icheckbox_minimal-blue14").removeClass("disabled");
																	$(this.allowEditDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
	
													if (stateObj.skipTabEnabled == false) {
																	$(this.skipTabNode).attr("disabled", true);
																	$(this.skipTabDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.skipTabNode).removeAttr("disabled");
																	$(this.skipTabDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
	
													if (stateObj.layoutEnabled == false) {
																	$(this.layoutNode).attr("disabled", true);
																	$(this.layoutDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.layoutNode).removeAttr("disabled");
																	$(this.layoutDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
	
													$(this.displayLengthNode).val(stateObj.displayLength);
													if (stateObj.displayLengthEnabled == false) {
																	$(this.displayLengthNode).attr("disabled", true);
																	$(this.displayLengthDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.displayLengthNode).removeAttr("disabled");
																	$(this.displayLengthDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
													$(this.shortCutNode).val(stateObj.shortCut);
													if (stateObj.shortCutEnabled == false) {
																	$(this.shortCutNode).attr("disabled", true);
																	$(this.shortCutDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.shortCutNode).removeAttr("disabled");
																	$(this.shortCutDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
													$(this.lockColumnNode).val(stateObj.lockedNum);
													if (stateObj.lockedNumEnabled == false) {
																	$(this.lockColumnNode).attr("disabled", true);
																	$(this.lockedNumDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.lockColumnNode).removeAttr("disabled");
																	$(this.lockedNumDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
													if (allColWidth[this.state.innerId]) {
																	stateObj.width = allColWidth[this.state.innerId].width;
													}
													$(this.widthNode).val(stateObj.width);
													if (stateObj.widthEnabled == false) {
																	$(this.widthNode).attr("disabled", true);
																	$(this.widthDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.widthNode).removeAttr("disabled");
																	$(this.widthDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
													$(this.heightNode).val(stateObj.height);
													if (stateObj.heightEnabled == false) {
																	$(this.heightNode).attr("disabled", true);
																	$(this.heightDefaultNode).css("pointer-events", "none").css("color", "#d4d4e6");
													} else {
																	$(this.heightNode).removeAttr("disabled");
																	$(this.heightDefaultNode).css("pointer-events", "auto").css("color", "#0178D4");
													}
									}
					}, {
									key: 'visibleNodeClick',
									value: function visibleNodeClick() {
													if ($(this.visibleNode).is(":checked")) {
																	this.userProperties.visible = false;
													} else {
																	this.userProperties.visible = true;
													}
									}
					}, {
									key: 'allowEditNodeClick',
									value: function allowEditNodeClick() {
													if ($(this.allowEditNode).is(":checked")) {
																	this.userProperties.allowEdit = false;
													} else {
																	this.userProperties.allowEdit = true;
													}
									}
					}, {
									key: 'skipTabNodeClick',
									value: function skipTabNodeClick() {
													if ($(this.skipTabNode).is(":checked")) {
																	this.userProperties.skipTab = false;
													} else {
																	this.userProperties.skipTab = true;
													}
									}
					}, {
									key: 'hideInVisibleNodeClick',
									value: function hideInVisibleNodeClick() {
													if ($(this.hideInVisibleNode).is(":checked")) {
																	this.userProperties.hideInVisible = false;
													} else {
																	this.userProperties.hideInVisible = true;
													}
									}
					}, {
									key: 'labelInputBlur',
									value: function labelInputBlur() {
													this.userProperties.label = $(this.labelNode).val();
													_UserSetActions2.default.treeLabelChanged(this.userProperties.label);
									}
					}, {
									key: 'displayLengthInputBlur',
									value: function displayLengthInputBlur() {
													this.userProperties.displayLength = $(this.displayLengthNode).val();
									}
					}, {
									key: 'shortCutInputBlur',
									value: function shortCutInputBlur() {
													this.userProperties.shortCut = $(this.shortCutNode).val();
									}
					}, {
									key: 'layoutChanged',
									value: function layoutChanged() {
													this.userProperties.layout = $(this.layoutNode).val();
									}
					}, {
									key: 'lockedInputBlur',
									value: function lockedInputBlur() {
													this.userProperties.lockedNum = $(this.lockColumnNode).val();
									}
					}, {
									key: 'widthInputBlur',
									value: function widthInputBlur() {
													this.userProperties.width = $(this.widthNode).val();
									}
					}, {
									key: 'heightInputBlur',
									value: function heightInputBlur() {
													this.userProperties.height = $(this.heightNode).val();
									}
					}, {
									key: 'deleteUserProperty',
									value: function deleteUserProperty(propertyName) {
													var _parentWindow = window.parent.window;
													if (_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
																	var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
																	var _properties = _userProperties[this.state.innerId];
																	if (_properties && _properties.hasOwnProperty(propertyName)) delete _properties[propertyName];
													}
									}
					}, {
									key: 'setVisibleDefault',
									value: function setVisibleDefault() {
													this.deleteUserProperty("visible");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_Visible_Final();
													if (propertyValue) $(this.visibleNode).iCheck('check');else $(this.visibleNode).iCheck('uncheck');
									}
					}, {
									key: 'setHideInVisibleDefault',
									value: function setHideInVisibleDefault() {
													this.deleteUserProperty("hideInVisible");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_HideInVisible();
													if (propertyValue) $(this.hideInVisibleNode).iCheck('check');else $(this.hideInVisibleNode).iCheck('uncheck');
									}
					}, {
									key: 'setAllowEditDefault',
									value: function setAllowEditDefault() {
													this.deleteUserProperty("allowEdit");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_AllowEdit_Final();
													if (propertyValue) $(this.allowEditNode).iCheck('check');else $(this.allowEditNode).iCheck('uncheck');
									}
					}, {
									key: 'setSkipTabDefault',
									value: function setSkipTabDefault() {
													this.deleteUserProperty("skipTab");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_SkipTab();
													if (propertyValue) $(this.skipTabNode).iCheck('check');else $(this.skipTabNode).iCheck('uncheck');
									}
					}, {
									key: 'setLayoutDefault',
									value: function setLayoutDefault() {
													this.deleteUserProperty("layout");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_Layout();
													$(this.layoutNode).selectpicker('val', propertyValue);
									}
					}, {
									key: 'setDisplayLengthDefault',
									value: function setDisplayLengthDefault() {
													this.deleteUserProperty("displayLength");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_DisplayLength();
													$(this.displayLengthNode).val(propertyValue);
									}
					}, {
									key: 'setShortCutDefault',
									value: function setShortCutDefault() {
													this.deleteUserProperty("shortCut");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_ShortCut();
													$(this.shortCutNode).val(propertyValue);
									}
					}, {
									key: 'setLockedNumDefault',
									value: function setLockedNumDefault() {
													this.deleteUserProperty("lockedNum");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_LockedNum();
													$(this.lockColumnNode).val(propertyValue);
									}
					}, {
									key: 'setWidthDefault',
									value: function setWidthDefault() {
													this.deleteUserProperty("width");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_Width();
													$(this.widthNode).val(propertyValue);
									}
					}, {
									key: 'setHeightDefault',
									value: function setHeightDefault() {
													this.deleteUserProperty("height");
													var key = _FormItemUtil2.default.getFormItemControlKey(window.menuItemId, window.formId, this.state.innerId);
													var itemControl = _FormItemUtil2.default.getFormItemControl(key, false);
													var propertyValue = itemControl.getProperty_Height();
													$(this.heightNode).val(propertyValue);
									}
					}, {
									key: 'render',
									value: function render() {
													var _ref,
													    _this2 = this;
	
													return _react2.default.createElement(
																	'div',
																	{ className: 'box box-info', style: { flexGrow: 0, boxShadow: 'none', border: 'none', width: 'auto', marginBottom: '2px' } },
																	_react2.default.createElement(
																					'div',
																					{ className: 'box-header with-border', style: { marginBottom: '5px', marginTop: '17px', paddingRight: '30px', paddingLeft: '30px', marginLeft: '113px', fontFamily: 'STSongti-SC-Regular', fontSize: '16px', color: '#000000' } },
																					_react2.default.createElement(
																									'h4',
																									{ className: 'box-title', style: (_ref = { fontSize: '15px', paddingRight: '30px', fontFamily: 'STSongti-SC-Regular' }, _defineProperty(_ref, 'fontSize', '16px'), _defineProperty(_ref, 'color', '#000000'), _defineProperty(_ref, 'fontWeight', 'normal'), _ref) },
																									'\u5C5E\u6027\u8BBE\u7F6E'
																					)
																	),
																	_react2.default.createElement(
																					'form',
																					{ style: { padding: '5px' }, ref: function ref(node) {
																													return _this2.propertyPanel = node;
																									} },
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u6807\u7B7E'
																									),
																									_react2.default.createElement('input', { ref: function ref(node) {
																																	return _this2.labelNode = node;
																													}, onChange: this.labelInputBlur.bind(this), type: 'text', spellcheck: 'false', className: 'form-control', style: { padding: '2px', height: '24px', fontSize: '12px', width: '139px' }, defaultValue: this.state.label })
																					),
																					_react2.default.createElement(
																									'div',
																									{ ref: function ref(node) {
																																	return _this2.visibleContainer = node;
																													}, style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u53EF\u89C1'
																									),
																									_react2.default.createElement('input', { ref: function ref(node) {
																																	return _this2.visibleNode = node;
																													}, type: 'checkbox', className: 'minimal' }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setVisibleDefault.bind(this), ref: function ref(node) {
																																					return _this2.visibleDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ ref: function ref(node) {
																																	return _this2.hideInVisibleContainer = node;
																													}, style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u4E0D\u53EF\u89C1\u65F6\u9690\u85CF'
																									),
																									_react2.default.createElement('input', { ref: function ref(node) {
																																	return _this2.hideInVisibleNode = node;
																													}, type: 'checkbox', className: 'minimal' }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setHideInVisibleDefault.bind(this), ref: function ref(node) {
																																					return _this2.hideInVisibleDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ ref: function ref(node) {
																																	return _this2.allowEditContainer = node;
																													}, style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u7F16\u8F91'
																									),
																									_react2.default.createElement('input', { ref: function ref(node) {
																																	return _this2.allowEditNode = node;
																													}, type: 'checkbox', className: 'minimal' }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setAllowEditDefault.bind(this), ref: function ref(node) {
																																					return _this2.allowEditDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ ref: function ref(node) {
																																	return _this2.skipTabContainer = node;
																													}, style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u8DF3\u8FC7Tab'
																									),
																									_react2.default.createElement('input', { ref: function ref(node) {
																																	return _this2.skipTabNode = node;
																													}, type: 'checkbox', className: 'minimal' }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setSkipTabDefault.bind(this), ref: function ref(node) {
																																					return _this2.skipTabDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u5E03\u5C40\u65B9\u5F0F'
																									),
																									_react2.default.createElement(
																													'select',
																													{ className: 'selectpicker form-control', 'data-live-search': 'true', ref: function ref(node) {
																																					return _this2.layoutNode = node;
																																	}, style: { padding: '2px !important', height: '24px' }, onChange: this.layoutChanged.bind(this) },
																													_react2.default.createElement(
																																	'option',
																																	{ value: 'horizontal' },
																																	'\u6A2A\u5411'
																													),
																													_react2.default.createElement(
																																	'option',
																																	{ value: 'vertical' },
																																	'\u7EB5\u5411'
																													)
																									),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setLayoutDefault.bind(this), ref: function ref(node) {
																																					return _this2.layoutDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u5B57\u7B26\u957F\u5EA6'
																									),
																									_react2.default.createElement('input', { defaultValue: this.state.displayLength, ref: function ref(node) {
																																	return _this2.displayLengthNode = node;
																													}, type: 'text',
																													spellcheck: 'false', className: 'form-control', style: { padding: '2px', height: '24px', fontSize: '12px', width: '139px' },
																													onChange: this.displayLengthInputBlur.bind(this) }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setDisplayLengthDefault.bind(this), ref: function ref(node) {
																																					return _this2.displayLengthDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u5FEB\u6377\u952E'
																									),
																									_react2.default.createElement('input', { defaultValue: this.state.shortCut, ref: function ref(node) {
																																	return _this2.shortCutNode = node;
																													}, type: 'text', spellcheck: 'false',
																													className: 'form-control', style: { padding: '2px', height: '24px', fontSize: '12px', width: '139px' },
																													onChange: this.shortCutInputBlur.bind(this) }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setShortCutDefault.bind(this), ref: function ref(node) {
																																					return _this2.shortCutDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u9501\u5B9A\u5217\u6570'
																									),
																									_react2.default.createElement('input', { defaultValue: this.state.lockedNum, ref: function ref(node) {
																																	return _this2.lockColumnNode = node;
																													}, type: 'text', spellcheck: 'false',
																													className: 'form-control', style: { padding: '2px', height: '24px', fontSize: '12px', width: '139px' },
																													onChange: this.lockedInputBlur.bind(this) }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setLockedNumDefault.bind(this), ref: function ref(node) {
																																					return _this2.lockedNumDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u5BBD\u5EA6'
																									),
																									_react2.default.createElement('input', { defaultValue: this.state.width, ref: function ref(node) {
																																	return _this2.widthNode = node;
																													}, type: 'text', spellcheck: 'false', className: 'form-control', style: { padding: '2px', height: '24px', fontSize: '12px', width: '139px' },
																													onChange: this.widthInputBlur.bind(this) }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setWidthDefault.bind(this), ref: function ref(node) {
																																					return _this2.widthDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					),
																					_react2.default.createElement(
																									'div',
																									{ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', marginBottom: '11px' } },
																									_react2.default.createElement(
																													'label',
																													{ style: { fontWeight: 'normal', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingLeft: '5px', width: '100px', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px', marginRight: '10px' } },
																													'\u9AD8\u5EA6'
																									),
																									_react2.default.createElement('input', { defaultValue: this.state.height, ref: function ref(node) {
																																	return _this2.heightNode = node;
																													}, type: 'text', spellcheck: 'false', className: 'form-control', style: { padding: '2px', height: '24px', fontSize: '12px', width: '139px' },
																													onChange: this.heightInputBlur.bind(this) }),
																									_react2.default.createElement(
																													'div',
																													{ style: { textDecoration: 'underline', marginLeft: '10px', cursor: 'pointer', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#4A90E2' }, onClick: this.setHeightDefault.bind(this), ref: function ref(node) {
																																					return _this2.heightDefaultNode = node;
																																	} },
																													'\u91C7\u7528\u9ED8\u8BA4'
																									)
																					)
																	)
													);
									}
					}]);
	
					return UserSetFormPropertyPanel;
	}(_react2.default.Component);
	
	exports.default = UserSetFormPropertyPanel;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _UserSetStores = __webpack_require__(146);
	
	var _UserSetActions = __webpack_require__(90);
	
	var _UserSetActions2 = _interopRequireDefault(_UserSetActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSetFormTree = function (_React$Component) {
		_inherits(UserSetFormTree, _React$Component);
	
		function UserSetFormTree(props) {
			_classCallCheck(this, UserSetFormTree);
	
			var _this = _possibleConstructorReturn(this, (UserSetFormTree.__proto__ || Object.getPrototypeOf(UserSetFormTree)).call(this, props));
	
			_this.currentTreeNodeId = "";
			_this.unscribeUserSetTreeLabelChangedStore = _UserSetStores.UserSetTreeLabelChangedStore.listen(_this.onUserSetTreeLabelChanged.bind(_this));
			return _this;
		}
	
		_createClass(UserSetFormTree, [{
			key: 'onUserSetTreeLabelChanged',
			value: function onUserSetTreeLabelChanged(label) {
				var treeObj = $.fn.zTree.getZTreeObj("UserSetFormTree");
				var nodes = treeObj.getSelectedNodes();
				if (nodes.length > 0) {
					nodes[0].label = label;
					treeObj.updateNode(nodes[0]);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var formXML = window.formModuleInstance.props.xml;
				var formLabel = window.formModuleInstance.formLabel;
				var setting = {
					data: {
						key: {
							title: "title",
							children: "FormItem",
							name: "label"
						}
					},
					edit: {
						drag: {
							autoExpandTrigger: false,
							isCopy: false,
							isMove: true,
							prev: true,
							next: true,
							inner: true,
							borderMax: 1000,
							borderMin: 1000,
							minMoveSize: 5,
							maxShowNodeNum: 5,
							autoOpenTime: 500
						},
						editNameSelectAll: false,
						enable: true,
						showRemoveBtn: false,
						showRenameBtn: false
	
					},
					callback: {
						onClick: this.onItemClick.bind(this),
						onDblClick: this.onItemDblClick.bind(this),
						beforeDrop: this.zTreeBeforeDrop.bind(this)
					}
				};
				var _formXML = JSON.parse(JSON.stringify(formXML));
				var formDesign = _formXML.FormDesign;
				this.userSetForm = _formXML;
				formDesign.label = formLabel;
				formDesign.open = true;formDesign.pId = 0;formDesign.type = "FormDesign";
				//var zNodes=[{ id:formDesign.id, pId:0,formItemName:formDesign.name,name:formLabel,open:true,sourceNode:formDesign}];
				this.currentTreeNodeId = formDesign.id;
				this.getZNodes(formDesign);
				$.fn.zTree.init($(this.treeDiv), setting, formDesign);
				var treeObj = $.fn.zTree.getZTreeObj("UserSetFormTree");
				var treeNode = treeObj.getNodeByParam("id", formDesign.id);
				treeObj.selectNode(treeNode);
	
				var stateObj = {};
				stateObj.label = treeNode.name;stateObj.labelEnabled = false;
				stateObj.visible = true;stateObj.visibleEnabled = false;
				stateObj.allowEdit = true;stateObj.allowEditEnabled = false;
				stateObj.hideInVisible = true;stateObj.hideInVisibleEnabled = false;
				stateObj.skipTab = false;stateObj.skipTabEnabled = false;
				stateObj.width = "";stateObj.widthEnabled = false;
				stateObj.height = "";stateObj.heightEnabled = false;
				stateObj.shortCut = "";stateObj.shortCutEnabled = false;
				stateObj.displayLength = "";stateObj.displayLengthEnabled = false;
				stateObj.lockedNum = "";stateObj.lockedNumEnabled = false;
				stateObj.layout = "";stateObj.layoutEnabled = false;
				_UserSetActions2.default.userSetFormTreeChanged(stateObj);
			}
		}, {
			key: 'getParentNode',
			value: function getParentNode(node) {
				var treeObj = $.fn.zTree.getZTreeObj("UserSetFormTree");
				var nodes = treeObj.getNodes();
				nodes = treeObj.transformToArray(nodes);
				if (nodes.length > 0) return treeObj.getNodeByParam("id", node.pId);
				return null;
			}
		}, {
			key: 'validateLevel',
			value: function validateLevel(items) {
				if (!items || items.length == 0) return true;
				var base = items[0];
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item.pId != base.pId) return false;
				}
				return true;
			}
		}, {
			key: 'validateFieldGroupDrag',
			value: function validateFieldGroupDrag(base) {
				if (base.type != "FieldGroup") return true;
	
				var fieldGroupValue = _GOTUtil2.default.getPropertyValue(base, "FieldGroup");
				var componentValue = _GOTUtil2.default.getPropertyValue(base, "Component");
				var dataSourceValue = _GOTUtil2.default.getPropertyValue(base, "DataSource");
	
				if (dataSourceValue && componentValue || dataSourceValue && fieldGroupValue || componentValue) {
	
					return false;
				} else {
					return true;
				}
			}
		}, {
			key: 'getPosition',
			value: function getPosition(parent, from, to) {
				if (parent.indexOf("Editor") != -1 || parent == "Button" || parent == "MenuItemButton" || parent == "Plugin") return "false";
	
				if (parent == "Tab" && from != "TabPage") return "false";
				//对于parent为Tab的情况 并没有列出 并且只能是TabPage 而这里只能填哪些不行 所以单独判断
				var str = from + "->" + parent;
				switch (str) {
					case 'TabPage->Design':
					case 'FieldGroup->FieldGroup':
					case 'Button->FieldGroup':
					case 'MenuItemButton->FieldGroup':
					case 'ButtonGroup->FieldGroup':
					case 'ButtonMenu->FieldGroup':
					case 'DataGrid->FieldGroup':
					case 'Group->FieldGroup':
					case 'DividedBox->FieldGroup':
					case 'Tab->FieldGroup':
					case 'TabPage->FieldGroup':
					case 'StringEditor->ButtonGroup':
					case 'LongEditor->ButtonGroup':
					case 'DecimalEditor->ButtonGroup':
					case 'DateEditor->ButtonGroup':
					case 'TimeEditor->ButtonGroup':
					case 'BooleanEditor->ButtonGroup':
					case 'EnumEditor->ButtonGroup':
					case 'FieldGroup->ButtonGroup':
					case 'ButtonGroup->ButtonGroup':
					case 'DataGrid->ButtonGroup':
					case 'Group->ButtonGroup':
					case 'DividedBox->ButtonGroup':
					case 'Tab->ButtonGroup':
					case 'TabPage->ButtonGroup':
					case 'StringEditor->ButtonMenu':
					case 'LongEditor->ButtonMenu':
					case 'DecimalEditor->ButtonMenu':
					case 'DateEditor->ButtonMenu':
					case 'TimeEditor->ButtonMenu':
					case 'BooleanEditor->ButtonMenu':
					case 'EnumEditor->ButtonMenu':
					case 'FieldGroup->ButtonMenu':
					case 'ButtonGroup->ButtonMenu':
					case 'ButtonMenu->ButtonMenu':
					case 'DataGrid->ButtonMenu':
					case 'Group->ButtonMenu':
					case 'DividedBox->ButtonMenu':
					case 'Tab->ButtonMenu':
					case 'TabPage->ButtonMenu':
					case 'Button->DataGrid':
					case 'MenuItemButton->DataGrid':
					case 'ButtonGroup->DataGrid':
					case 'ButtonMenu->DataGrid':
					case 'DataGrid->DataGrid':
					case 'Group->DataGrid':
					case 'DividedBox->DataGrid':
					case 'Tab->DataGrid':
					case 'TabPage->DataGrid':
					case 'TabPage->Group':
					case 'TabPage->DividedBox':
					case 'TabPage->TabPage':
					case 'TabPage->Plugin':
						return "false";
				}
	
				str = from + "->" + to;
	
				switch (str) {
					case 'StringEditor->StringEditor':
						return 'true';
					case 'StringEditor->LongEditor':
						return 'true';
					case 'StringEditor->DecimalEditor':
						return 'true';
					case 'StringEditor->DateEditor':
						return 'true';
					case 'StringEditor->TimeEditor':
						return 'true';
					case 'StringEditor->BooleanEditor':
						return 'true';
					case 'StringEditor->EnumEditor':
						return 'true';
					case 'StringEditor->FieldGroup':
						return 'down';
					case 'StringEditor->Button':
						return 'true';
					case 'StringEditor->MenuItemButton':
						return 'true';
					case 'StringEditor->ButtonGroup':
						return 'true';
					case 'StringEditor->ButtonMenu':
						return 'true';
					case 'StringEditor->DataGrid':
						return 'down';
					case 'StringEditor->Group':
						return 'down';
					case 'StringEditor->DividedBox':
						return 'down';
					case 'StringEditor->Tab':
						return 'true';
					case 'StringEditor->TabPage':
						return 'down';
					case 'StringEditor->FormDesign':
						return 'down';
					case 'LongEditor->StringEditor':
						return 'true';
					case 'LongEditor->LongEditor':
						return 'true';
					case 'LongEditor->DecimalEditor':
						return 'true';
					case 'LongEditor->DateEditor':
						return 'true';
					case 'LongEditor->TimeEditor':
						return 'true';
					case 'LongEditor->BooleanEditor':
						return 'true';
					case 'LongEditor->EnumEditor':
						return 'true';
					case 'LongEditor->FieldGroup':
						return 'down';
					case 'LongEditor->Button':
						return 'true';
					case 'LongEditor->MenuItemButton':
						return 'true';
					case 'LongEditor->ButtonGroup':
						return 'true';
					case 'LongEditor->ButtonMenu':
						return 'true';
					case 'LongEditor->DataGrid':
						return 'down';
					case 'LongEditor->Group':
						return 'down';
					case 'LongEditor->DividedBox':
						return 'down';
					case 'LongEditor->Tab':
						return 'true';
					case 'LongEditor->TabPage':
						return 'down';
					case 'LongEditor->FormDesign':
						return 'down';
					case 'DecimalEditor->StringEditor':
						return 'true';
					case 'DecimalEditor->LongEditor':
						return 'true';
					case 'DecimalEditor->DecimalEditor':
						return 'true';
					case 'DecimalEditor->DateEditor':
						return 'true';
					case 'DecimalEditor->TimeEditor':
						return 'true';
					case 'DecimalEditor->BooleanEditor':
						return 'true';
					case 'DecimalEditor->EnumEditor':
						return 'true';
					case 'DecimalEditor->FieldGroup':
						return 'down';
					case 'DecimalEditor->Button':
						return 'true';
					case 'DecimalEditor->MenuItemButton':
						return 'true';
					case 'DecimalEditor->ButtonGroup':
						return 'true';
					case 'DecimalEditor->ButtonMenu':
						return 'true';
					case 'DecimalEditor->DataGrid':
						return 'down';
					case 'DecimalEditor->Group':
						return 'down';
					case 'DecimalEditor->DividedBox':
						return 'down';
					case 'DecimalEditor->Tab':
						return 'true';
					case 'DecimalEditor->TabPage':
						return 'down';
					case 'DecimalEditor->FormDesign':
						return 'down';
					case 'DateEditor->StringEditor':
						return 'true';
					case 'DateEditor->LongEditor':
						return 'true';
					case 'DateEditor->DecimalEditor':
						return 'true';
					case 'DateEditor->DateEditor':
						return 'true';
					case 'DateEditor->TimeEditor':
						return 'true';
					case 'DateEditor->BooleanEditor':
						return 'true';
					case 'DateEditor->EnumEditor':
						return 'true';
					case 'DateEditor->FieldGroup':
						return 'down';
					case 'DateEditor->Button':
						return 'true';
					case 'DateEditor->MenuItemButton':
						return 'true';
					case 'DateEditor->ButtonGroup':
						return 'true';
					case 'DateEditor->ButtonMenu':
						return 'true';
					case 'DateEditor->DataGrid':
						return 'down';
					case 'DateEditor->Group':
						return 'down';
					case 'DateEditor->DividedBox':
						return 'down';
					case 'DateEditor->Tab':
						return 'true';
					case 'DateEditor->TabPage':
						return 'down';
					case 'DateEditor->FormDesign':
						return 'down';
					case 'TimeEditor->StringEditor':
						return 'true';
					case 'TimeEditor->LongEditor':
						return 'true';
					case 'TimeEditor->DecimalEditor':
						return 'true';
					case 'TimeEditor->DateEditor':
						return 'true';
					case 'TimeEditor->TimeEditor':
						return 'true';
					case 'TimeEditor->BooleanEditor':
						return 'true';
					case 'TimeEditor->EnumEditor':
						return 'true';
					case 'TimeEditor->FieldGroup':
						return 'down';
					case 'TimeEditor->Button':
						return 'true';
					case 'TimeEditor->MenuItemButton':
						return 'true';
					case 'TimeEditor->ButtonGroup':
						return 'true';
					case 'TimeEditor->ButtonMenu':
						return 'true';
					case 'TimeEditor->DataGrid':
						return 'down';
					case 'TimeEditor->Group':
						return 'down';
					case 'TimeEditor->DividedBox':
						return 'down';
					case 'TimeEditor->Tab':
						return 'true';
					case 'TimeEditor->TabPage':
						return 'down';
					case 'TimeEditor->FormDesign':
						return 'down';
					case 'BooleanEditor->StringEditor':
						return 'true';
					case 'BooleanEditor->LongEditor':
						return 'true';
					case 'BooleanEditor->DecimalEditor':
						return 'true';
					case 'BooleanEditor->DateEditor':
						return 'true';
					case 'BooleanEditor->TimeEditor':
						return 'true';
					case 'BooleanEditor->BooleanEditor':
						return 'true';
					case 'BooleanEditor->EnumEditor':
						return 'true';
					case 'BooleanEditor->FieldGroup':
						return 'down';
					case 'BooleanEditor->Button':
						return 'true';
					case 'BooleanEditor->MenuItemButton':
						return 'true';
					case 'BooleanEditor->ButtonGroup':
						return 'true';
					case 'BooleanEditor->ButtonMenu':
						return 'true';
					case 'BooleanEditor->DataGrid':
						return 'down';
					case 'BooleanEditor->Group':
						return 'down';
					case 'BooleanEditor->DividedBox':
						return 'down';
					case 'BooleanEditor->Tab':
						return 'true';
					case 'BooleanEditor->TabPage':
						return 'down';
					case 'BooleanEditor->FormDesign':
						return 'down';
					case 'EnumEditor->StringEditor':
						return 'true';
					case 'EnumEditor->LongEditor':
						return 'true';
					case 'EnumEditor->DecimalEditor':
						return 'true';
					case 'EnumEditor->DateEditor':
						return 'true';
					case 'EnumEditor->TimeEditor':
						return 'true';
					case 'EnumEditor->BooleanEditor':
						return 'true';
					case 'EnumEditor->EnumEditor':
						return 'true';
					case 'EnumEditor->FieldGroup':
						return 'down';
					case 'EnumEditor->Button':
						return 'true';
					case 'EnumEditor->MenuItemButton':
						return 'true';
					case 'EnumEditor->ButtonGroup':
						return 'true';
					case 'EnumEditor->ButtonMenu':
						return 'true';
					case 'EnumEditor->DataGrid':
						return 'down';
					case 'EnumEditor->Group':
						return 'down';
					case 'EnumEditor->DividedBox':
						return 'down';
					case 'EnumEditor->Tab':
						return 'true';
					case 'EnumEditor->TabPage':
						return 'down';
					case 'EnumEditor->FormDesign':
						return 'down';
					case 'FieldGroup->StringEditor':
						return 'true';
					case 'FieldGroup->LongEditor':
						return 'true';
					case 'FieldGroup->DecimalEditor':
						return 'true';
					case 'FieldGroup->DateEditor':
						return 'true';
					case 'FieldGroup->TimeEditor':
						return 'true';
					case 'FieldGroup->BooleanEditor':
						return 'true';
					case 'FieldGroup->EnumEditor':
						return 'true';
					case 'FieldGroup->FieldGroup':
						return 'true';
					case 'FieldGroup->Button':
						return 'true';
					case 'FieldGroup->MenuItemButton':
						return 'true';
					case 'FieldGroup->ButtonGroup':
						return 'true';
					case 'FieldGroup->ButtonMenu':
						return 'true';
					case 'FieldGroup->DataGrid':
						return 'down';
					case 'FieldGroup->Group':
						return 'down';
					case 'FieldGroup->DividedBox':
						return 'down';
					case 'FieldGroup->Tab':
						return 'true';
					case 'FieldGroup->TabPage':
						return 'down';
					case 'FieldGroup->FormDesign':
						return 'down';
					case 'Button->StringEditor':
						return 'true';
					case 'Button->LongEditor':
						return 'true';
					case 'Button->DecimalEditor':
						return 'true';
					case 'Button->DateEditor':
						return 'true';
					case 'Button->TimeEditor':
						return 'true';
					case 'Button->BooleanEditor':
						return 'true';
					case 'Button->EnumEditor':
						return 'true';
					case 'Button->FieldGroup':
						return 'true';
					case 'Button->Button':
						return 'true';
					case 'Button->MenuItemButton':
						return 'true';
					case 'Button->ButtonGroup':
						return 'down';
					case 'Button->ButtonMenu':
						return 'down';
					case 'Button->DataGrid':
						return 'true';
					case 'Button->Group':
						return 'down';
					case 'Button->DividedBox':
						return 'down';
					case 'Button->Tab':
						return 'true';
					case 'Button->TabPage':
						return 'down';
					case 'Button->FormDesign':
						return 'down';
					case 'MenuItemButton->StringEditor':
						return 'true';
					case 'MenuItemButton->LongEditor':
						return 'true';
					case 'MenuItemButton->DecimalEditor':
						return 'true';
					case 'MenuItemButton->DateEditor':
						return 'true';
					case 'MenuItemButton->TimeEditor':
						return 'true';
					case 'MenuItemButton->BooleanEditor':
						return 'true';
					case 'MenuItemButton->EnumEditor':
						return 'true';
					case 'MenuItemButton->FieldGroup':
						return 'true';
					case 'MenuItemButton->Button':
						return 'true';
					case 'MenuItemButton->MenuItemButton':
						return 'true';
					case 'MenuItemButton->ButtonGroup':
						return 'down';
					case 'MenuItemButton->ButtonMenu':
						return 'down';
					case 'MenuItemButton->DataGrid':
						return 'true';
					case 'MenuItemButton->Group':
						return 'down';
					case 'MenuItemButton->DividedBox':
						return 'down';
					case 'MenuItemButton->Tab':
						return 'true';
					case 'MenuItemButton->TabPage':
						return 'down';
					case 'MenuItemButton->FormDesign':
						return 'down';
					case 'ButtonGroup->StringEditor':
						return 'true';
					case 'ButtonGroup->LongEditor':
						return 'true';
					case 'ButtonGroup->DecimalEditor':
						return 'true';
					case 'ButtonGroup->DateEditor':
						return 'true';
					case 'ButtonGroup->TimeEditor':
						return 'true';
					case 'ButtonGroup->BooleanEditor':
						return 'true';
					case 'ButtonGroup->EnumEditor':
						return 'true';
					case 'ButtonGroup->FieldGroup':
						return 'true';
					case 'ButtonGroup->Button':
						return 'true';
					case 'ButtonGroup->MenuItemButton':
						return 'true';
					case 'ButtonGroup->ButtonGroup':
						return 'true';
					case 'ButtonGroup->ButtonMenu':
						return 'true';
					case 'ButtonGroup->DataGrid':
						return 'true';
					case 'ButtonGroup->Group':
						return 'down';
					case 'ButtonGroup->DividedBox':
						return 'down';
					case 'ButtonGroup->Tab':
						return 'true';
					case 'ButtonGroup->TabPage':
						return 'down';
					case 'ButtonGroup->FormDesign':
						return 'down';
					case 'ButtonMenu->StringEditor':
						return 'true';
					case 'ButtonMenu->LongEditor':
						return 'true';
					case 'ButtonMenu->DecimalEditor':
						return 'true';
					case 'ButtonMenu->DateEditor':
						return 'true';
					case 'ButtonMenu->TimeEditor':
						return 'true';
					case 'ButtonMenu->BooleanEditor':
						return 'true';
					case 'ButtonMenu->EnumEditor':
						return 'true';
					case 'ButtonMenu->FieldGroup':
						return 'true';
					case 'ButtonMenu->Button':
						return 'true';
					case 'ButtonMenu->MenuItemButton':
						return 'true';
					case 'ButtonMenu->ButtonGroup':
						return 'down';
					case 'ButtonMenu->ButtonMenu':
						return 'true';
					case 'ButtonMenu->DataGrid':
						return 'true';
					case 'ButtonMenu->Group':
						return 'down';
					case 'ButtonMenu->DividedBox':
						return 'down';
					case 'ButtonMenu->Tab':
						return 'true';
					case 'ButtonMenu->TabPage':
						return 'down';
					case 'ButtonMenu->FormDesign':
						return 'down';
					case 'DataGrid->StringEditor':
						return 'true';
					case 'DataGrid->LongEditor':
						return 'true';
					case 'DataGrid->DecimalEditor':
						return 'true';
					case 'DataGrid->DateEditor':
						return 'true';
					case 'DataGrid->TimeEditor':
						return 'true';
					case 'DataGrid->BooleanEditor':
						return 'true';
					case 'DataGrid->EnumEditor':
						return 'true';
					case 'DataGrid->FieldGroup':
						return 'true';
					case 'DataGrid->Button':
						return 'true';
					case 'DataGrid->MenuItemButton':
						return 'true';
					case 'DataGrid->ButtonGroup':
						return 'true';
					case 'DataGrid->ButtonMenu':
						return 'true';
					case 'DataGrid->DataGrid':
						return 'true';
					case 'DataGrid->Group':
						return 'down';
					case 'DataGrid->DividedBox':
						return 'down';
					case 'DataGrid->Tab':
						return 'true';
					case 'DataGrid->TabPage':
						return 'down';
					case 'DataGrid->FormDesign':
						return 'down';
					case 'Group->StringEditor':
						return 'true';
					case 'Group->LongEditor':
						return 'true';
					case 'Group->DecimalEditor':
						return 'true';
					case 'Group->DateEditor':
						return 'true';
					case 'Group->TimeEditor':
						return 'true';
					case 'Group->BooleanEditor':
						return 'true';
					case 'Group->EnumEditor':
						return 'true';
					case 'Group->FieldGroup':
						return 'true';
					case 'Group->Button':
						return 'true';
					case 'Group->MenuItemButton':
						return 'true';
					case 'Group->ButtonGroup':
						return 'true';
					case 'Group->ButtonMenu':
						return 'true';
					case 'Group->DataGrid':
						return 'true';
					case 'Group->Group':
						return 'true';
					case 'Group->DividedBox':
						return 'down';
					case 'Group->Tab':
						return 'true';
					case 'Group->TabPage':
						return 'down';
					case 'Group->FormDesign':
						return 'down';
					case 'DividedBox->StringEditor':
						return 'true';
					case 'DividedBox->LongEditor':
						return 'true';
					case 'DividedBox->DecimalEditor':
						return 'true';
					case 'DividedBox->DateEditor':
						return 'true';
					case 'DividedBox->TimeEditor':
						return 'true';
					case 'DividedBox->BooleanEditor':
						return 'true';
					case 'DividedBox->EnumEditor':
						return 'true';
					case 'DividedBox->FieldGroup':
						return 'true';
					case 'DividedBox->Button':
						return 'true';
					case 'DividedBox->MenuItemButton':
						return 'true';
					case 'DividedBox->ButtonGroup':
						return 'true';
					case 'DividedBox->ButtonMenu':
						return 'true';
					case 'DividedBox->DataGrid':
						return 'true';
					case 'DividedBox->Group':
						return 'down';
					case 'DividedBox->DividedBox':
						return 'true';
					case 'DividedBox->Tab':
						return 'true';
					case 'DividedBox->TabPage':
						return 'down';
					case 'DividedBox->FormDesign':
						return 'down';
					case 'Tab->StringEditor':
						return 'true';
					case 'Tab->LongEditor':
						return 'true';
					case 'Tab->DecimalEditor':
						return 'true';
					case 'Tab->DateEditor':
						return 'true';
					case 'Tab->TimeEditor':
						return 'true';
					case 'Tab->BooleanEditor':
						return 'true';
					case 'Tab->EnumEditor':
						return 'true';
					case 'Tab->FieldGroup':
						return 'true';
					case 'Tab->Button':
						return 'true';
					case 'Tab->MenuItemButton':
						return 'true';
					case 'Tab->ButtonGroup':
						return 'true';
					case 'Tab->ButtonMenu':
						return 'true';
					case 'Tab->DataGrid':
						return 'true';
					case 'Tab->Group':
						return 'down';
					case 'Tab->DividedBox':
						return 'down';
					case 'Tab->Tab':
						return 'true';
					case 'Tab->TabPage':
						return 'down';
					case 'Tab->FormDesign':
						return 'down';
					case 'TabPage->StringEditor':
						return 'false';
					case 'TabPage->LongEditor':
						return 'false';
					case 'TabPage->DecimalEditor':
						return 'false';
					case 'TabPage->DateEditor':
						return 'false';
					case 'TabPage->TimeEditor':
						return 'false';
					case 'TabPage->BooleanEditor':
						return 'false';
					case 'TabPage->EnumEditor':
						return 'false';
					case 'TabPage->FieldGroup':
						return 'false';
					case 'TabPage->Button':
						return 'false';
					case 'TabPage->MenuItemButton':
						return 'false';
					case 'TabPage->ButtonGroup':
						return 'false';
					case 'TabPage->ButtonMenu':
						return 'false';
					case 'TabPage->DataGrid':
						return 'false';
					case 'TabPage->Group':
						return 'false';
					case 'TabPage->DividedBox':
						return 'false';
					case 'TabPage->Tab':
						return 'down';
					case 'TabPage->TabPage':
						return 'true';
					case 'TabPage->FormDesign':
						return 'false';
					case 'TabPage->Plugin':
						return 'false';
	
					default:
						return "true";
				}
	
				return "true";
			}
		}, {
			key: 'validateType',
			value: function validateType(items, toType, toParentType) {
				if (items.length == 0) return "draginvalid";
				var base = items[0];
				var basePosition = this.getPosition(toParentType, base.type, toType);
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (item != base) {
						if (this.getPosition(toParentType, base.type, toType) != basePosition) return "draginvalid";
					}
				}
	
				return basePosition;
			}
		}, {
			key: 'getOrigItemById',
			value: function getOrigItemById(id) {
				var formDesign = this.userSetForm.FormDesign;
				return this.getOrigItemByIdLoop(formDesign, id);
			}
		}, {
			key: 'getOrigItemByIdLoop',
			value: function getOrigItemByIdLoop(formItem, id) {
				if (formItem.id == id) return formItem;
				for (var i = 0; i < formItem.FormItem.length; i++) {
					var childFormItem = formItem.FormItem[i];
					if (childFormItem.id == id) return childFormItem;
					var result = this.getOrigItemByIdLoop(childFormItem, id);
					if (result) return result;
				}
				return null;
			}
		}, {
			key: 'deleteSrcItem',
			value: function deleteSrcItem(src, parent) {
				var _index = parent.FormItem.indexOf(src);
				parent.FormItem.splice(_index, 1);
			}
		}, {
			key: 'adjustSrcForm',
			value: function adjustSrcForm(srcItems, targetNode, type) {
				for (var i = 0; i < srcItems.length; i++) {
					var srcItem = srcItems[i];
					var srcId = srcItem.id;
					var origSrcItem = this.getOrigItemById(srcId);
					var srcPid = origSrcItem.pId;
					var origSrcParent = this.getOrigItemById(srcPid);
					this.deleteSrcItem(origSrcItem, origSrcParent);
	
					var targetId = targetNode.id;
					var targetOrigItem = this.getOrigItemById(targetId);
					if (type == "inner") {
						if (!targetOrigItem.FormItem) targetOrigItem.FormItem = [];
						targetOrigItem.FormItem.push(origSrcItem);
						origSrcItem.pId = targetOrigItem.id;
					} else if (type == "next") {
						var targetPid = targetOrigItem.pId;
						var targetOrigParent = this.getOrigItemById(targetPid);
						var _index = targetOrigParent.FormItem.indexOf(targetOrigItem);
						_index++;
						targetOrigParent.FormItem.splice(_index, 0, origSrcItem);
						origSrcItem.pId = targetOrigParent.id;
					} else if (type == "prev") {
						var _targetPid = targetOrigItem.pId;
						var _targetOrigParent = this.getOrigItemById(_targetPid);
						var _index2 = _targetOrigParent.FormItem.indexOf(targetOrigItem);
						_targetOrigParent.FormItem.splice(_index2, 0, origSrcItem);
						origSrcItem.pId = _targetOrigParent.id;
					}
				}
			}
		}, {
			key: 'zTreeBeforeDrop',
			value: function zTreeBeforeDrop(treeId, treeNodes, targetNode, moveType) {
				var isRoot = targetNode == null || moveType != "inner" && !targetNode.parentTId;
				if (isRoot) return false;
	
				var srcItems = treeNodes;
				if (!srcItems || srcItems.length == 0) {
					return false;
				}
	
				if (!this.validateLevel(srcItems)) return false;
				var base = srcItems[0];
				var baseParentNode = this.getParentNode(base);
				if (!this.validateFieldGroupDrag(baseParentNode)) return false;
	
				var dropTarget = targetNode;
				var dropTargetParent = this.getParentNode(targetNode);
	
				if (!this.validateFieldGroupDrag(dropTargetParent)) return false;
	
				var toType = targetNode.type;
				var toParentType = moveType == "inner" ? toType : dropTargetParent.type;
				var position = this.validateType(srcItems, toType, toParentType);
	
				if (position == "down" && moveType != "inner") position = "true";
				if (position == "true" && moveType == "inner") position = "down";
	
				if (position == "down" && !this.validateFieldGroupDrag(dropTarget)) {
					this.adjustSrcForm(treeNodes, targetNode, moveType);
					return true;
				}
	
				if (position == "draginvalid") {
					return false;
				}
	
				if (!this.validateDataSourceGroup(position, srcItems, dropTarget)) {
					return false;
				}
	
				if (position == "true") {
					this.adjustSrcForm(treeNodes, targetNode, moveType);
					return true;
				}
	
				if (position == "down") {
					this.adjustSrcForm(treeNodes, targetNode, moveType);
					return true;
				}
	
				if (position == "false") {
					return false;
				}
				this.adjustSrcForm(treeNodes, targetNode, moveType);
				return true;
			}
		}, {
			key: 'validateDataSourceGroup',
			value: function validateDataSourceGroup(position, srcItems, dropTarget) {
				if (position == "false") return true;
				if (srcItems.length <= 0) return true;
	
				if (position == "down" && dropTarget.type == "DataGrid") {
					for (var i = 0; i < srcItems.length; i++) {
						var src = srcItems[i];
						var dataSource = _GOTUtil2.default.getProperty(src, "DataSource");
						if (!dataSource.hasOwnProperty("innerid")) return false;
					}
	
					var baseDataSourceName = _GOTUtil2.default.getPropertyValue(src, "DataSource");
					var baseDataSource = window.formModuleInstance.formDataSources.sources[baseDataSourceName];
					var targetItems = dropTarget.FormItem;
					if (targetItems.length > 0) var targetItem = targetItems[0];
					if (targetItem) {
						var targetDataSourceName = _GOTUtil2.default.getPropertyValue(targetItem, "DataSource");
						var targetDataSource = window.formModuleInstance.formDataSources.sources[targetDataSourceName];
					}
					for (var _i = 0; _i < srcItems.length; _i++) {
						var _src = srcItems[_i];
						var tempName = _GOTUtil2.default.getPropertyValue(_src, "DataSource");
						var tempDataSource = widnow.formModuleInstance.formDataSources.sources[tempName];
						if (baseDataSource.group != tempDataSource.group || targetDataSource && tempDataSource.group != targetDataSource.group) return false;
					}
				}
	
				var targetP = this.getParentNode(dropTarget);
				var targetPP = this.getParentNode(targetP);
				if (position == "true" && (targetP != null && targetP.type == "DataGrid" || targetPP != null && targetPP.type == "DataGrid")) {
					for (var _i2 = 0; _i2 < srcItems.length; _i2++) {
						var _src2 = srcItems[_i2];
						dataSource = _GOTUtil2.default.getProperty(_src2, "DataSource");
						if (!dataSource.hasOwnProperty("innerid")) return false;
					}
	
					targetDataSourceName = _GOTUtil2.default.getPropertyValue(dropTarget, "DataSource");
					targetDataSource = window.formModuleInstance.formDataSources.sources[targetDataSourceName];
					for (var _i3 = 0; _i3 < srcItems.length; _i3++) {
						var _src3 = srcItems[_i3];
						tempName = _GOTUtil2.default.getPropertyValue(_src3, "DataSource");
						tempDataSource = window.formModuleInstance.formDataSources.sources[tempName];
						if (targetDataSource != null && tempDataSource.group != targetDataSource.group) return false;
					}
				}
	
				return true;
			}
		}, {
			key: 'getZNodes',
			value: function getZNodes(item) {
				for (var i = 0; i < item.FormItem.length; i++) {
					var childFormItem = item.FormItem[i];
					var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + childFormItem.name, false);
					var _label = void 0;
					if (itemControl) _label = itemControl.getProperty_Label();
					if (!_label && childFormItem.type && childFormItem.type.indexOf("Editor") == -1) _label = childFormItem.name;
					/*var zNode={id:childFormItem.id,pId:item.id,name:_label,formItemName:childFormItem.name,
	    			nodeType:childFormItem.type,sourceNode:childFormItem};
	    zNodes.push(zNode);*/
					childFormItem.label = _label;childFormItem.pId = item.id;
					var isDataGrid = childFormItem.type == "DataGrid";
					if (isDataGrid) childFormItem.open = true;
					var toolTip = "";
					if (childFormItem.hasOwnProperty("name")) {
						toolTip += "name=" + childFormItem.name + " ";
					} else if (childFormItem.hasOwnProperty("qname")) {
						toolTip += "name=" + childFormItem.qname + " ";
					}
	
					if (childFormItem.hasOwnProperty("id")) {
						toolTip += "id=" + childFormItem.id + " ";
					}
	
					var extendsPro = _GOTUtil2.default.getProperty(childFormItem, "Extends");
					if (extendsPro) {
						if (extendsPro.hasOwnProperty("refentityid")) {
							toolTip += "tableId=" + extendsPro.refentityid + " ";
							toolTip += "tableFieldId=" + extendsPro.refinnerid;
						}
					}
	
					childFormItem.title = toolTip;
	
					var result = this.getZNodes(childFormItem);
	
					if (result) item.open = true;
				}
	
				return item.open;
			}
		}, {
			key: 'checkHasUserSetVisible',
			value: function checkHasUserSetVisible(innerId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[innerId];
					if (_properties && _properties.hasOwnProperty("visible") && (_properties.visible == false || _properties.visible == 'false')) return true;
				}
				return false;
			}
		}, {
			key: 'checkHasUserSetAllowEdit',
			value: function checkHasUserSetAllowEdit(innerId) {
				var _parentWindow = window.parent.window;
				if (_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId + "." + window.formId)) {
					var _userProperties = _parentWindow.userProperties[window.menuItemId + "." + window.formId];
					var _properties = _userProperties[innerId];
					if (_properties && _properties.hasOwnProperty("allowEdit") && (_properties.allowEdit == false || _properties.allowEdit == 'false')) return true;
				}
				return false;
			}
		}, {
			key: 'onItemClick',
			value: function onItemClick(event, treeId, treeNode, clickFlag) {
				if (treeNode.id != this.currentTreeNodeId) {
					this.currentTreeNodeId = treeNode.id;
					var itemControl = _FormItemUtil2.default.getFormItemControl("ctrl_" + treeNode.name, false);
					var stateObj = { innerId: treeNode.id };
					if (itemControl.classAlias == "FormItemDesignControl") {
						stateObj.label = treeNode.name;stateObj.labelEnabled = false;
						stateObj.visible = true;stateObj.visibleEnabled = false;
						stateObj.allowEdit = true;stateObj.allowEditEnabled = false;
						stateObj.hideInVisible = true;stateObj.hideInVisibleEnabled = false;
						stateObj.skipTab = false;stateObj.skipTabEnabled = false;
						stateObj.width = "";stateObj.widthEnabled = false;
						stateObj.height = "";stateObj.heightEnabled = false;
						stateObj.shortCut = "";stateObj.shortCutEnabled = false;
						stateObj.displayLength = "";stateObj.displayLengthEnabled = false;
						stateObj.lockedNum = "";stateObj.lockedNumEnabled = false;
						stateObj.layout = "";stateObj.layoutEnabled = false;
						stateObj.itemControl = itemControl;
						_UserSetActions2.default.userSetFormTreeChanged(stateObj);
						return;
					}
					stateObj.label = itemControl.getProperty_Label();stateObj.labelEnabled = true;
					if (itemControl._cmdLabel) stateObj.labelEnabled = false;
					stateObj.visible = itemControl.getProperty_Visible_Final();
					stateObj.visibleEnabled = true;
					if (!stateObj.visible && !this.checkHasUserSetVisible(itemControl.xml.id)) {
						stateObj.visibleEnabled = false;
					}
	
					//stateObj.visible = (UserSetFormTree.flag%2==0?true:false);
					//UserSetFormTree.flag++;
					stateObj.allowEdit = itemControl.getProperty_AllowEdit_Final();
					stateObj.allowEditEnabled = true;
					if (!stateObj.allowEdit && !this.checkHasUserSetAllowEdit(itemControl.xml.id)) {
						stateObj.allowEditEnabled = false;
					}
					stateObj.hideInVisible = itemControl.getProperty_HideInVisible();
					stateObj.hideInVisibleEnabled = true;
					stateObj.skipTab = itemControl.getProperty_SkipTab();
					stateObj.skipTabEnabled = true;
					stateObj.width = itemControl.getProperty_Width();
					stateObj.widthEnabled = true;
					stateObj.height = itemControl.getProperty_Height();
					stateObj.heightEnabled = true;
					stateObj.itemControl = itemControl;
					if (typeof itemControl.getProperty_ShortCut == "function") {
						stateObj.shortCut = itemControl.getProperty_ShortCut();
						stateObj.shortCutEnabled = true;
					} else {
						stateObj.shortCut = "";stateObj.shortCutEnabled = false;
					}
					if (typeof itemControl.getProperty_DisplayLength == "function") {
						stateObj.displayLength = itemControl.getProperty_DisplayLength();
						stateObj.displayLengthEnabled = true;
					} else {
						stateObj.displayLength = "";stateObj.displayLengthEnabled = false;
					}
					if (typeof itemControl.getProperty_LockedNum == "function") {
						stateObj.lockedNum = itemControl.getProperty_LockedNum();
						stateObj.lockedNumEnabled = true;
					} else {
						stateObj.lockedNum = "";stateObj.lockedNumEnabled = false;
					}
					if (typeof itemControl.getProperty_Layout == "function") {
						stateObj.layout = itemControl.getProperty_Layout();
						stateObj.layoutEnabled = true;
					} else {
						stateObj.layoutEnabled = false;stateObj.layout = "";
					}
	
					_UserSetActions2.default.userSetFormTreeChanged(stateObj);
				}
			}
		}, {
			key: 'onItemDblClick',
			value: function onItemDblClick(event, treeId, treeNode) {}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement('ul', { style: { flexGrow: 100, overflow: 'auto' }, id: 'UserSetFormTree', ref: function ref(node) {
						return _this2.treeDiv = node;
					}, className: 'ztree' });
			}
		}]);
	
		return UserSetFormTree;
	}(_react2.default.Component);
	
	exports.default = UserSetFormTree;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var faker = __webpack_require__(69);
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var listcolumns = [{
	  key: 'userName',
	  name: "用户名",
	  width: 290,
	  resizable: true
	}, {
	  key: 'fileName',
	  name: "设置名称",
	  width: 290,
	  resizable: true
	}];
	
	var UserSetListDataGrid = function (_React$Component) {
	  _inherits(UserSetListDataGrid, _React$Component);
	
	  function UserSetListDataGrid(props, context) {
	    _classCallCheck(this, UserSetListDataGrid);
	
	    //window.ListDataGrid=this;
	    var _this = _possibleConstructorReturn(this, (UserSetListDataGrid.__proto__ || Object.getPrototypeOf(UserSetListDataGrid)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var rows = [];
	    _this.state = { rows: rows, selectedIndexes: [] };
	    return _this;
	  }
	
	  _createClass(UserSetListDataGrid, [{
	    key: 'filterCurrentUser',
	    value: function filterCurrentUser(userId) {
	
	      var rowsList = [];
	      this.backRows = this.state.rows.slice();
	      for (var i = 0; i < this.state.rows.length; i++) {
	        var item = this.state.rows[i];
	        if (item.userName == userId) {
	          rowsList.push(item);
	        }
	      }
	      this.setState({ rows: rowsList });
	    }
	  }, {
	    key: 'cancelFilterCurrentUser',
	    value: function cancelFilterCurrentUser() {
	      this.setState({ rows: this.backRows });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(ReactDataGrid, {
	        ref: function ref(node) {
	          return _this2.grid = node;
	        },
	        enableCellSelect: true,
	        columns: listcolumns,
	        rowGetter: this.getRowAt,
	        rowsCount: this.getSize(),
	        onGridRowsUpdated: this.handleGridRowsUpdated
	        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	        , enableRowSelect: false,
	        rowSelection: {
	          showCheckbox: false,
	          selectBy: {
	            indexes: this.state.selectedIndexes
	
	          }
	        },
	        onRowClick: this.rowClick //this.rowClick this.rowClick.bind(this)
	        , rowHeight: 30,
	        minHeight: 250,
	        rowScrollTimeout: 500 });
	    }
	  }]);
	
	  return UserSetListDataGrid;
	}(React.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.deleteRow = function () {
	    var rows = _this3.state.rows.slice();
	    var selectedIndex = _this3.state.selectedIndexes[0];
	    var row = rows.splice(selectedIndex, 1);
	    var newSelectedIndex = selectedIndex - 1;
	    if (newSelectedIndex < 0) newSelectedIndex = 0;
	    if (newSelectedIndex >= rows.length) newSelectedIndex = rows.length - 1;
	
	    _this3.setState({ rows: rows, selectedIndexes: newSelectedIndex });
	    if (row && row.length > 0) row = row[0];else row = null;
	    return { row: row, index: selectedIndex };
	  };
	
	  this.getRowAt = function (index) {
	    if (index < 0 || index > _this3.getSize()) {
	      return undefined;
	    }
	    return _this3.state.rows[index];;
	  };
	
	  this.getSelectedRow = function () {
	    var selectedIndexes = _this3.state.selectedIndexes;
	    if (!selectedIndexes || selectedIndexes.length < 0) return null;
	    var selectedIndex = selectedIndexes[0];
	    var rows = _this3.state.rows;
	    if (selectedIndex >= rows.length || selectedIndex < 0) return;
	    return rows[selectedIndex];
	  };
	
	  this.getSize = function () {
	    return _this3.state.rows.length;
	  };
	
	  this.rowClick = function (index, record, proxy) {
	    _this3.setState({ selectedIndexes: [index] });
	  };
	};
	
	exports.default = UserSetListDataGrid;

/***/ },
/* 283 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommandArgGroupInfoFuncUtil = function () {
	    function CommandArgGroupInfoFuncUtil() {
	        _classCallCheck(this, CommandArgGroupInfoFuncUtil);
	    }
	
	    _createClass(CommandArgGroupInfoFuncUtil, null, [{
	        key: "getCurrentRecord",
	        value: function getCurrentRecord() {
	            if (!this.currentRecord) return null;
	            if (!this.groupAlias) return null;
	            var obj = this.currentRecord[this.groupAlias];
	            return obj;
	        }
	    }, {
	        key: "getCurrentMap",
	        value: function getCurrentMap() {
	            if (!this.currentRecord) return null;
	            var obj = this.currentRecord[this.groupAlias];
	            if (!obj) return null;
	            return obj;
	        }
	    }, {
	        key: "getSelectedRecordsByCurrentRecord",
	        value: function getSelectedRecordsByCurrentRecord() {
	            if (this.hasColumnAsSysSelectRecords) {
	                return [];
	            }
	
	            var record = this.getCurrentRecord();
	            if (!record) return [];
	
	            return [record];
	        }
	    }, {
	        key: "getSelectedMapsByCurrentRecord",
	        value: function getSelectedMapsByCurrentRecord() {
	            return this.getSelectedRecordsByCurrentRecord();
	        }
	    }, {
	        key: "getSelectedRecords",
	        value: function getSelectedRecords() {
	            if (!this.selectedRecords || this.selectedRecords.length == 0) return this.getSelectedRecordsByCurrentRecord();
	            return this.selectedRecords;
	        }
	    }, {
	        key: "getSelectedMaps",
	        value: function getSelectedMaps() {
	            return this.getSelectedRecords();
	        }
	    }, {
	        key: "getAllRecords",
	        value: function getAllRecords() {
	            if (!this.allRecords || this.allRecords.length == 0) return [];
	            return this.allRecords;
	        }
	    }, {
	        key: "getAllMaps",
	        value: function getAllMaps() {
	            return this.getAllRecords();
	        }
	    }, {
	        key: "getCurrentQuery",
	        value: function getCurrentQuery() {
	            return this.currentQuery;
	        }
	    }, {
	        key: "getFormQuery",
	        value: function getFormQuery() {
	            return this.formQuery;
	        }
	    }]);
	
	    return CommandArgGroupInfoFuncUtil;
	}();
	
	exports.default = CommandArgGroupInfoFuncUtil;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(85);
	
	var FindForm = function (_React$Component) {
		_inherits(FindForm, _React$Component);
	
		function FindForm() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FindForm);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FindForm.__proto__ || Object.getPrototypeOf(FindForm)).call.apply(_ref, [this].concat(args))), _this), _this.keyDownHandler = function (e) {
				//alert("FindForm document keydown");
				if (e.keyCode == 13) {
					_this.query();
					e.preventDefault();
					e.stopImmediatePropagation();
				} else if (e.keyCode == 27) {
					_this.closeHandler(true);
					e.preventDefault();
					e.stopImmediatePropagation();
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FindForm, [{
			key: 'closeHandler',
			value: function closeHandler() {
				var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
				var $reactComponentContainer = $("#findModal");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				$(this.modalDiv).remove();
	
				if (typeof window.switchToCurrent == "function") window.switchToCurrent();
			}
		}, {
			key: 'query',
			value: function query() {
				var filterTxt = $(this.inputFilter).val();
				if (this.props.parms && this.props.parms.type == "DateEditor") {
					if (filterTxt && filterTxt.indexOf("#") != 0) {
						filterTxt = _QueryUtil2.default.formatDateValue(filterTxt); //FormItemDateResolver.getResult(filterTxt);
						if (filterTxt.indexOf("false:") == 0) {
							_Warn2.default.show({ text: filterTxt.substr(6) });
							return false;
						}
					}
				}
				this.props.queryHandler(filterTxt);
				FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
				this.closeHandler();
	
				var _parentWindow = typeof window.setOperate == 'function' ? window : window.parent.window;
				if (_parentWindow.setOperate) {
					var remark = { 'title': '搜索', "搜索内容": filterTxt, '搜索字段': this.props.cacheKey };
					var data = {
						'dataArea': 'dynamic',
						'userId': _parentWindow.userInfos.userId,
						'userName': _parentWindow.userInfos.userName,
						'clientSessionId': _parentWindow.userInfos.userSessionId,
						'dateTime': new Date().getTime() + '',
						'operationId': '008',
						'formId': formId,
						'formDataSourceName': '',
						'formItemName': this.props.cacheKey,
						'remark': JSON.stringify(remark)
					};
					_parentWindow.setOperate(data);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (FindForm.queryHistoryCache.hasOwnProperty(this.props.cacheKey)) {
					$(this.inputFilter).val(FindForm.queryHistoryCache[this.props.cacheKey]);
				}
				$(this.inputFilter).focus();
				$(this.inputFilter).select();
				$(document).on("keydown", this.keyDownHandler);
	
				$(this.modalDiv).draggable({
					handle: ".modal-header" // 只能点击头部拖动
				}); //为模态对话框添加拖拽
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				//TODO如果没有unmountComponentAtNode手动调用，通过remove并没有调用卸载询问函数 对于该类场景 应如何设计？
				$(document).off("keydown", null, this.keyDownHandler);
			}
		}, {
			key: 'findKeyDownHandler',
			value: function findKeyDownHandler(e) {}
		}, {
			key: 'onPasteHandler',
			value: function onPasteHandler(event) {
				var clipboardData = event.clipboardData || window.clipboardData;
				if (!clipboardData) return false;
				var paste = clipboardData.getData('text');
				if (!paste) return false;
				paste = paste.replace(/\r\n/g, ",");
				paste = paste.replace(/\n/g, ",");
	
				var val = $(this.inputFilter).val();
				if (!val) {
					$(this.inputFilter).val(paste);
				} else {
					var selectionStart = this.inputFilter.selectionStart;
					var selectionEnd = this.inputFilter.selectionEnd;
	
					$(this.inputFilter).val(val.substr(0, selectionStart) + paste + val.substr(selectionEnd));
				}
	
				event.preventDefault();
			}
		}, {
			key: 'getInputFilterDom',
			value: function getInputFilterDom() {
				var _ref2,
				    _this2 = this,
				    _ref3;
	
				if (this.props.parms && this.props.parms.type == "StringEditor") return _react2.default.createElement('input', { onPaste: this.onPasteHandler.bind(this), autoComplete: 'on', spellCheck: 'false', type: 'text', style: (_ref2 = { width: "200px", marginRight: "10px" }, _defineProperty(_ref2, 'width', '308px'), _defineProperty(_ref2, 'height', '28px'), _defineProperty(_ref2, 'background', '#FFFFFF'), _defineProperty(_ref2, 'border', '1px solid #C4C6CF'), _defineProperty(_ref2, 'borderRadius', '1px'), _ref2), ref: function ref(node) {
						return _this2.inputFilter = node;
					} });
	
				return _react2.default.createElement('input', { autoComplete: 'on', spellCheck: 'false', type: 'text', style: (_ref3 = { width: "200px", marginRight: "10px" }, _defineProperty(_ref3, 'width', '308px'), _defineProperty(_ref3, 'height', '28px'), _defineProperty(_ref3, 'background', '#FFFFFF'), _defineProperty(_ref3, 'border', '1px solid #C4C6CF'), _defineProperty(_ref3, 'borderRadius', '1px'), _ref3), ref: function ref(node) {
						return _this2.inputFilter = node;
					} });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var inputFilterDom = this.getInputFilterDom();
				return _react2.default.createElement(
					'div',
					{ className: 'modal', style: { display: "flex", justifyContent: "center" }, ref: function ref(node) {
							return _this3.modalDiv = node;
						}, onKeyDown: this.findKeyDownHandler.bind(this) },
					_react2.default.createElement(
						'div',
						{ style: _defineProperty({ alignSelf: "center", borderRadius: "2px", width: '508px', height: '137px', display: 'flex', flexDirection: 'column', background: '#FFFFFF', border: '0 solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' }, 'borderRadius', '2px') },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header', style: _defineProperty({ display: "flex", flexDirection: "row", position: "relative", width: "auto", alignItems: "center", paddingLeft: "2px" }, 'position', "relative") },
							_react2.default.createElement(
								'h5',
								{ className: 'modal-title', style: { paddingLeft: '23px', fontFamily: 'STSongti-SC-Bold', fontSize: '16px', color: '#000000' } },
								'\u67E5\u627E'
							),
							_react2.default.createElement('div', { className: 'modal-close', onClick: this.closeHandler.bind(this) })
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: '1' } },
							_react2.default.createElement(
								'h5',
								{ style: { fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', paddingRight: '10px' } },
								this.props.label
							),
							inputFilterDom,
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info ufs-require', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', color: '#fff' }, onClick: this.query.bind(this) },
								'\u67E5\u627E'
							)
						)
					)
				);
			}
		}], [{
			key: 'show',
			value: function show(queryHandler, label, historyCacheKey) {
				var parms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
				_reactDom2.default.render(_react2.default.createElement(FindForm, { parms: parms, queryHandler: queryHandler, cacheKey: historyCacheKey, label: label }), document.getElementById("findModal"));
			}
		}]);
	
		return FindForm;
	}(_react2.default.Component);
	
	FindForm.queryHistoryCache = {};
	exports.default = FindForm;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(103);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _FocusActions = __webpack_require__(12);
	
	var _FocusActions2 = _interopRequireDefault(_FocusActions);
	
	var _AjaxRemoteUtil = __webpack_require__(45);
	
	var _AjaxRemoteUtil2 = _interopRequireDefault(_AjaxRemoteUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(85);
	
	var FindForm = function (_React$Component) {
		_inherits(FindForm, _React$Component);
	
		function FindForm() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FindForm);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FindForm.__proto__ || Object.getPrototypeOf(FindForm)).call.apply(_ref, [this].concat(args))), _this), _this.keyDownHandler = function (e) {
				//alert("FindForm document keydown");
				if (e.keyCode == 13) {
					_this.query();
					e.preventDefault();
					e.stopImmediatePropagation();
				} else if (e.keyCode == 27) {
					_this.closeHandler(true);
					e.preventDefault();
					e.stopImmediatePropagation();
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FindForm, [{
			key: 'closeHandler',
			value: function closeHandler() {
				var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
				var $reactComponentContainer = $("#findModal");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				$(this.modalDiv).remove();
				_FocusActions2.default.clearSigned();
				if (typeof window.switchToCurrent == "function") window.switchToCurrent();
			}
		}, {
			key: 'queryPre',
			value: function () {
				var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
					var filterTxt, nowQueryIndex, nowQueryIndexObj;
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									filterTxt = $(this.inputFilter).val();
	
									if (this.stepColumn) {
										_context.next = 9;
										break;
									}
	
									_context.next = 4;
									return this.props.queryHandler(filterTxt, this.nowQueryIndex, this.stepColumn, true);
	
								case 4:
									nowQueryIndex = _context.sent;
	
									FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
									if (nowQueryIndex == 0) {
										_Warn2.default.show({ text: "已查找到第一个" });
										//if(this.nowQueryIndex>0)this.nowQueryIndex+=50;
										//else this.nowQueryIndex = 51;
									} else {
										this.nowQueryIndex = nowQueryIndex;
									}
									_context.next = 14;
									break;
	
								case 9:
									_context.next = 11;
									return this.props.queryHandler(filterTxt, this.nowQueryIndexObj, this.stepColumn, true);
	
								case 11:
									nowQueryIndexObj = _context.sent;
	
									FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
									if (nowQueryIndexObj == 0) {
										_Warn2.default.show({ text: "已查找到第一个" });
										//if(this.nowQueryIndexObj.row>0)this.nowQueryIndexObj.row+=50;
										//else this.nowQueryIndexObj.row = 51;
									} else {
										this.nowQueryIndexObj = nowQueryIndexObj;
									}
	
								case 14:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this);
				}));
	
				function queryPre() {
					return _ref2.apply(this, arguments);
				}
	
				return queryPre;
			}()
		}, {
			key: 'query',
			value: function () {
				var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
					var filterTxt, nowQueryIndex, nowQueryIndexObj;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!(_AjaxRemoteUtil2.default.tokenNum > 0)) {
										_context2.next = 2;
										break;
									}
	
									return _context2.abrupt('return');
	
								case 2:
									filterTxt = $(this.inputFilter).val();
	
									/*if(this.props.parms && this.props.parms.type == "EnumEditor")
	        {
	        	var _properties = GOTPropertiesUtil.getItemPropertyFinalValue(window.menuItemId,this.props.parms.entityId,this.props.parms.innerId);
	        	var _dataProvider = _properties.DataProvider;
	        	if(_dataProvider)
	        	{
	        		
	        		for(let i = 0;i<_dataProvider.length;i++)
	        		{
	        			let item = _dataProvider[i];
	        			if(item.label && item.label.indexOf(filterTxt) != -1)
	        			{
	        				filterTxt
	        			}
	        		}
	        	}
	        		
	        }*/
	
									if (this.stepColumn) {
										_context2.next = 11;
										break;
									}
	
									_context2.next = 6;
									return this.props.queryHandler(filterTxt, this.nowQueryIndex, this.stepColumn);
	
								case 6:
									nowQueryIndex = _context2.sent;
	
									FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
									if (nowQueryIndex == -1) {
										_Warn2.default.show({ text: "本页找不到正在搜索的数据,已自动加载下一页数据" });
										if (this.nowQueryIndex > 0) {
											this.nowQueryIndex += 50 - this.nowQueryIndex % 50;
										} else {
											this.nowQueryIndex = 51;
										}
									} else {
										this.nowQueryIndex = nowQueryIndex;
									}
									_context2.next = 16;
									break;
	
								case 11:
									_context2.next = 13;
									return this.props.queryHandler(filterTxt, this.nowQueryIndexObj, this.stepColumn);
	
								case 13:
									nowQueryIndexObj = _context2.sent;
	
									FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
									if (nowQueryIndexObj == -1) {
										_Warn2.default.show({ text: "本页找不到正在搜索的数据,已自动加载下一页数据" });
										if (this.nowQueryIndexObj.row > 0) this.nowQueryIndexObj.row += 50 - this.nowQueryIndex.row % 50;else this.nowQueryIndexObj.row = 51;
									} else {
										this.nowQueryIndexObj = nowQueryIndexObj;
									}
	
								case 16:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, this);
				}));
	
				function query() {
					return _ref3.apply(this, arguments);
				}
	
				return query;
			}()
		}, {
			key: 'selectedChanged',
			value: function selectedChanged(select) {
				this.stepColumn = select;
				if (select == true) {
					$(this.labelNode).hide();
				} else {
					$(this.labelNode).show();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(this.checkBox).on('ifChecked', this.selectedChanged.bind(this, true));
				$(this.checkBox).on('ifUnchecked', this.selectedChanged.bind(this, false));
				var _checkboxClass = 'icheckbox_minimal-blue14';
				//if(!this.state.allowEdit)
				//_checkboxClass += ' disabled';
				$(this.checkBox).iCheck({
					checkboxClass: _checkboxClass
				});
				if (FindForm.queryHistoryCache.hasOwnProperty(this.props.cacheKey)) {
					$(this.inputFilter).val(FindForm.queryHistoryCache[this.props.cacheKey]);
				}
				$(this.inputFilter).focus();
				$(this.inputFilter).select();
				$(document).on("keydown", this.keyDownHandler);
				$(this.modalDiv).draggable({
					handle: ".modal-header" // 只能点击头部拖动
				}); //为模态对话框添加拖拽
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				//TODO如果没有unmountComponentAtNode手动调用，通过remove并没有调用卸载询问函数 对于该类场景 应如何设计？
				$(document).off("keydown", null, this.keyDownHandler);
			}
		}, {
			key: 'findKeyDownHandler',
			value: function findKeyDownHandler(e) {}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this,
				    _ref6;
	
				var klSty = { display: 'none', justifyContent: 'flex-end', paddingRight: '15px', paddingTop: '10px' };
				var kValue = false;
				var label = '逐个查找';
				if (this.props.flag) {
					kValue = true;
					label = '跨列查找';
					this.stepColumn = true;
				}
				return _react2.default.createElement(
					'div',
					{ className: 'modal', style: { display: "flex", justifyContent: "center" }, ref: function ref(node) {
							return _this2.modalDiv = node;
						}, onKeyDown: this.findKeyDownHandler.bind(this) },
					_react2.default.createElement(
						'div',
						{ style: _defineProperty({ alignSelf: "center", borderRadius: "2px", width: '508px', height: '153px', display: 'flex', flexDirection: 'column', background: '#FFFFFF', border: '0 solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' }, 'borderRadius', '2px') },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header', style: _defineProperty({ display: "flex", flexDirection: "row", position: "relative", width: "auto", alignItems: "center", paddingLeft: "2px" }, 'position', "relative") },
							_react2.default.createElement(
								'h5',
								{ className: 'modal-title', style: { paddingLeft: '23px', fontFamily: 'STSongti-SC-Bold', fontSize: '16px', color: '#000000' } },
								label
							),
							_react2.default.createElement('div', { className: 'modal-close', onClick: this.closeHandler.bind(this) })
						),
						_react2.default.createElement(
							'div',
							{ style: klSty },
							_react2.default.createElement(
								'label',
								{ style: { marginBottom: '0px', marginTop: '1px' } },
								'\u8DE8\u5217\u641C\u7D22'
							),
							_react2.default.createElement(
								'div',
								{ style: { marginLeft: '5px' } },
								_react2.default.createElement('input', { ref: function ref(node) {
										return _this2.checkBox = node;
									}, type: 'checkbox', className: 'minimal', value: kValue })
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { marginTop: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', paddingLeft: '15px', paddingTop: '5px', paddingBottom: '5px', paddingRight: '5px' } },
							_react2.default.createElement('input', { autoComplete: 'on', spellCheck: 'false', type: 'text', style: (_ref6 = { width: "200px", marginRight: "10px" }, _defineProperty(_ref6, 'width', '308px'), _defineProperty(_ref6, 'height', '28px'), _defineProperty(_ref6, 'background', '#FFFFFF'), _defineProperty(_ref6, 'border', '1px solid #C4C6CF'), _defineProperty(_ref6, 'borderRadius', '1px'), _defineProperty(_ref6, 'flexGrow', 1), _ref6), ref: function ref(node) {
									return _this2.inputFilter = node;
								} })
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', justifyContent: "flex-end" } },
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info ufs-require', style: { height: '28px', marginRight: '0px', width: '97px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', color: '#fff' }, onClick: this.queryPre.bind(this) },
								'\u67E5\u627E\u4E0A\u4E00\u4E2A'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info ufs-require', style: _defineProperty({ height: '28px', marginRight: '0px', width: '97px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', color: '#fff', marginLeft: '10px' }, 'marginRight', '15px'), onClick: this.query.bind(this) },
								'\u67E5\u627E\u4E0B\u4E00\u4E2A'
							)
						)
					)
				);
	
				/*return 	(
	   				<div className="modal" style={{display:"flex",justifyContent:"center"}} ref={node => this.modalDiv = node} onKeyDown={this.findKeyDownHandler.bind(this)}>
	   			<div style={{alignSelf:"center",borderRadius:"2px",width:'508px',height:'137px',display:'flex',flexDirection:'column',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
	   			<div className="modal-header" style={{display:"flex",flexDirection:"row",position:"relative",width:"auto",alignItems:"center",paddingLeft:"2px",position:"relative"}}>
	   				<h5 className="modal-title" style={{paddingLeft:'23px',fontFamily:'STSongti-SC-Bold',fontSize:'16px',color:'#000000'}}>搜索</h5>
	   				<div className="modal-close" onClick={this.closeHandler.bind(this)}></div>
	   			</div>
	   			<div style={{position:"relative"}}>
	   					
	   					<label style={{position:'absolute',top:'4px',right:'45px'}}>跨列搜索</label>
	   					<div style={{position:'absolute',top:'5px',right:'27px'}}>
	   						<input ref={node=>this.checkBox = node} type="checkbox" className="minimal"/>
	   					</div>
	   			</div>
	   			<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexGrow:'1',position:'relative',padding:'15px'}}>
	   				<h5 ref={node=>this.labelNode=node} style={{fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingRight:'10px'}}>{this.props.label}</h5>
	   				<input autoComplete="on" spellCheck="false" type="text" style={{width:"200px",marginRight:"10px",width:'308px',height:'28px',background:'#FFFFFF',border:'1px solid #C4C6CF',borderRadius:'1px',flexGrow:1}} ref={node => this.inputFilter = node}/>
	   				
	   				<button type="button" className="btn btn-info ufs-require" style={{height:'28px',marginRight:'0px',width:'97px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color:'#fff'}} onClick={this.query.bind(this)}>查找下一个</button>
	   			</div>
	   			</div>
	   		</div>
	   	);*/
			}
		}], [{
			key: 'show',
			value: function show(queryHandler, label, historyCacheKey) {
				var parms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
				var flag = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	
				_reactDom2.default.render(_react2.default.createElement(FindForm, { parms: parms, queryHandler: queryHandler, cacheKey: historyCacheKey, label: label, flag: flag }), document.getElementById("findModal"));
			}
		}]);
	
		return FindForm;
	}(_react2.default.Component);
	
	FindForm.queryHistoryCache = {};
	exports.default = FindForm;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _AuthorityUtil = __webpack_require__(52);
	
	var _AuthorityUtil2 = _interopRequireDefault(_AuthorityUtil);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _FormResourceUtil = __webpack_require__(22);
	
	var _FormResourceUtil2 = _interopRequireDefault(_FormResourceUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _CommandHelper = __webpack_require__(23);
	
	var _CommandHelper2 = _interopRequireDefault(_CommandHelper);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainFormFactory = function () {
		function MainFormFactory() {
			_classCallCheck(this, MainFormFactory);
		}
	
		_createClass(MainFormFactory, null, [{
			key: 'hasMainForm',
			value: function hasMainForm(entityId, innerId, componentItemName) {
				if (window.parent.window.formOSopenAllUniversal || window.isDataSetView || window.parent.window.isDataSetView) {
					return false;
				}
				var key = MainFormFactory.getKey(entityId, innerId, componentItemName);
				if (!key) return false;
				var result;
				if (MainFormFactory.mapMainForm.hasOwnProperty(key)) {
					result = MainFormFactory.mapMainForm[key];
				} else {
					result = MainFormFactory.getMainForm(entityId, innerId, componentItemName);
					if (result != null) MainFormFactory.mapMainForm[key] = result;
				}
	
				if (result == null) {
					return false;
				} else {
					return true;
				}
			}
		}, {
			key: 'getFinalMainTableAndMainFormProFromDataType',
			value: function getFinalMainTableAndMainFormProFromDataType(dataType, result) {
				var dataTypeRelation = dataType.DataTypeRelation;
				if (dataTypeRelation) {
					var mainTablePro = _GOTUtil2.default.getProperty(dataTypeRelation, "Table");
					var mainFormPro = _GOTUtil2.default.getProperty(dataTypeRelation, "RefMenuItem") || _GOTUtil2.default.getProperty(dataTypeRelation, "MainForm");
					result.dataTypeRelation = dataTypeRelation;
					if (mainTablePro.hasOwnProperty("refentityid") && !result.hasOwnProperty("MainTablePro")) {
						result.MainTablePro = mainTablePro;
					}
	
					if (mainFormPro.hasOwnProperty("refentityid") && !result.hasOwnProperty("MainFormPro")) {
						result.MainFormPro = mainFormPro;
					}
				}
	
				if (!result.hasOwnProperty("MainTablePro") || !result.hasOwnProperty("MainFormPro")) {
					var extendsPro = _GOTUtil2.default.getProperty(dataType, "Extends");
					if (extendsPro.hasOwnProperty("refentityid")) {
						dataType = _GOT2.default.getDataType(extendsPro.refentityid);
						result = MainFormFactory.getFinalMainTableAndMainFormProFromDataType(dataType, result);
					}
				}
	
				return result;
			}
		}, {
			key: 'getMainForm',
			value: function getMainForm(entityId, innerId, componentItemName) {
				var dataType = _GOTUtil2.default.getDataType2(entityId, innerId);
				if (dataType == null) {
					return null;
				}
	
				if (dataType.type == "Component") {
					if (componentItemName) {
						var componentItemList = dataType.DataTypeArrayItems;
						for (var i = 0; i < componentItemList.length; i++) {
							var componentItem = componentItemList[i];
							if (componentItem.name == componentItemName) {
								dataType = _GOT2.default.getDataType(_GOTUtil2.default.getProperty(componentItem, "RefDataType").refentityid);
								break;
							}
						}
					}
				}
	
				if (dataType.type != "String") {
					return null;
				}
	
				var mainFormPro = null;var mainTablePro = null;var resultObject = {};
				resultObject = MainFormFactory.getFinalMainTableAndMainFormProFromDataType(dataType, resultObject);
	
				if (!resultObject.MainTablePro || !resultObject.MainFormPro) {
					return null;
				}
				var dataTypeRelation = resultObject.dataTypeRelation;
				mainTablePro = resultObject.MainTablePro;
				var mainTable = _GOT2.default.getTable(mainTablePro.refentityid);
				mainFormPro = resultObject.MainFormPro;
	
				var menuItem = _GOT2.default.getMenuItem(mainFormPro.refentityid);
				var proRefObject = _GOTUtil2.default.getProperty(menuItem, "RefObject") || _GOTUtil2.default.getProperty(menuItem, "Source");
				if (!proRefObject.hasOwnProperty("refentityid")) {
					return null;
				}
	
				var mainFormName = proRefObject.Value || proRefObject.V;
	
				var obj = {};
				obj["menuItemId"] = mainFormPro.refentityid;
				obj["mainFormName"] = mainFormName;
				obj["dataTypeRelation"] = dataTypeRelation;
				obj["mainTable"] = mainTable;
				obj["mainFormId"] = proRefObject.refentityid;
				return obj;
			}
		}, {
			key: 'getKey',
			value: function getKey(entityId, innerId, componentItemName) {
				return entityId + "." + innerId + "." + componentItemName;
			}
		}, {
			key: 'callMainForm',
			value: function callMainForm(options) {
				//entityId, innerId,componentItemName,value,fm,groupAlias,caller
				var key = MainFormFactory.getKey(options.entityId, options.innerId, options.componentItemName);
	
				if (MainFormFactory.mapMainForm.hasOwnProperty(key) && MainFormFactory.mapMainForm[key] != null) {
					var result = MainFormFactory.mapMainForm[key];
					var menuItemId = result["menuItemId"];
					var authorityObject = _AuthorityUtil2.default.getAuthorityMenuItem(menuItemId);
					//TODO BEGIN mainform
	
					var mainFormWhereValues = MainFormFactory.getMainTableWhereValues2({
						entityId: options.entityId, innerId: options.innerId,
						componentItemName: options.componentItemName,
						value: options.value, result: result, record: options.record,
						filterValue: options.filterValue
					});
	
					var options2 = {
						menuItemId: menuItemId, fm: options.fm, mainTableWhereValues: mainFormWhereValues, authorityArg: authorityObject,
						addJoin: false, entityId: options.entityId, checkHas: false,
						dataField: options.dataField, groupAlias: options.groupAlias, editorName: options.editorName, paramString: options.paramString
					};
					//TODO END
					if (!options.fm) {
						_FormLoadHelper2.default.openMenuItemByAuthority(options2);
					} else {
						MainFormFactory.callRemoteMainForm(options2);
					}
	
					return true;
				} else {
					var _options = {
						menuItemId: null, fm: options.fm, mainTableWhereValues: null, authorityArg: null,
						addJoin: false, entityId: options.entityId, checkHas: false,
						dataField: options.dataField, editorName: options.editorName, groupAlias: options.groupAlias, paramString: options.paramString
					};
					MainFormFactory.callRemoteMainForm(_options);
				}
			}
		}, {
			key: 'callRemoteMainForm',
			value: function callRemoteMainForm(options) {
				//在Dialog或者Report上进入主表 openFormArg,authorityObject,caller,groupAlias,fm
				if (!options.fm) {
					if (options.authorityArg["query"] == false) {
						if (window.parent.userInfos && window.parent.userInfos.userGroups && window.parent.userInfos.userGroups.length > 0) {
							_Warn2.default.show({ text: "您没有权限进去该画面" });
						} else {
							_Warn2.default.show({ text: "您所在的用户组没有权限" });
						}
					} else {
						_FormLoadHelper2.default.openMenuItem(options);
					}
					return;
				}
				var methodName;
				//if(caller.dataField!=null)
				if (options.groupAlias && options.dataField) {
					var i = options.dataField.indexOf(".");
					methodName = _StringUtil2.default.convertToEachFirstUpperCase(options.dataField.substring(i + 1));
					methodName = "mainForm_" + _StringUtil2.default.replaceAll(methodName, ".", "_");
					methodName = options.groupAlias + "." + methodName;
				} else {
					methodName = "mainForm_" + options.editorName;
				}
	
				var mi = _FormResourceUtil2.default.getCommandArgMethodInfo(methodName, window.menuItemId, window.formId);
				if (!mi) {
					if (options.authorityArg["query"] == false) {
						if (window.parent.userInfos && window.parent.userInfos.userGroups && window.parent.userInfos.userGroups.length > 0) {
							_Warn2.default.show({ text: "您没有权限进去该画面" });
						} else {
							_Warn2.default.show({ text: "您所在的用户组没有权限" });
						}
					} else {
						_FormLoadHelper2.default.openMenuItem(options);
					}
					return;
				}
				var commandArg = _CommandResolver2.default.getSendCmd(options.fm, options.groupAlias, mi);
	
				if (options.groupAlias && options.dataField) {
					i = options.dataField.indexOf(".");
					var _fieldName = _StringUtil2.default.convertToEachFirstUpperCase(options.dataField.substring(i + 1));
				} else {
					_fieldName = options.editorName;
				}
	
				var openMainFormArg = {
					remoteClass: "gongqi.erp.gotmodel.form.remote.OpenMainFormArg",
					menuItemId: options.menuItemId,
					paramString: options.paramString,
					mainFormWhereValues: options.mainTableWhereValues
				};
	
				var command = _CommandHelper2.default.createFormInstance(options.fm.formName, "doMainForm", "OpenMainFormArg").appendArg(options.groupAlias).appendArg(_fieldName).appendArg(commandArg, "CommandArg").appendArg(openMainFormArg, "OpenMainFormArg");
				var remoteArg = { command: command, resultFunction: this.rpc_result_mainFormArg.bind(this, options) };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		}, {
			key: 'rpc_result_mainFormArg',
			value: function rpc_result_mainFormArg(options, data) {
				var omfa = data.result;
	
				if (!omfa || !omfa.menuItemId) {
					_Warn2.default.show({ text: "检测到二次开发未能传回有效的MenuItemId", title: "进入主表失败了哦" });
					return;
				}
	
				options.menuItemId = omfa.menuItemId;
				options.paramString = omfa.paramString;
				options.mainTableWhereValues = omfa.mainFormWhereValues;
				options.enterMainForm = true;
	
				var authorityObject = _AuthorityUtil2.default.getAuthorityMenuItem(options.menuItemId);
				if (authorityObject["query"] == false) {
					_Warn2.default.show({ text: "您所在的用户组没有权限" });
				} else {
					_FormLoadHelper2.default.openMenuItem(options);
				}
			}
		}, {
			key: 'getMainTableWhereValues2',
			value: function getMainTableWhereValues2(args) {
				var entityId = args.entityId;var innerId = args.innerId;
				var componentItemName = args.componentItemName;
				var value = args.value;var result = args.result;var record = args.record;
				var mtr = null;var mainTableValues = [];
				//var formItemDataSource;
				//var form = GOT.getForm(entityId);
				/*if(form)
	   {
	   	var formItem = GOT.getFormItem(form,innerId);
	   	formItemDataSource = GOTUtil.getProperty(formItem, "DataSource");
	   	if(formItemDataSource.hasOwnProperty("innerid"))
	   	{
	   		var ds = GOT.getFormDataSource(form,formItemDataSource.innerid);
	   		var dsTablePro = GOTUtil.getProperty(ds,"Table");
	   		var table = GOT.getTable(dsTablePro.refentityid);
	   		var mainTable = result["mainTable"];
	   		var mainTableId = mainTable.id;
	   		var trs = [];
	   		var tableRelations = table.TableRelations.Relations;
	   		for(let i = 0;i<tableRelations.length;i++)
	   		{
	   			let tr = trs[i];
	   			let hasFixed = false;
	   			let tableRelationItems = tr.Items;
	   			for(let k = 0;k<tableRelationItems.length;k++)
	   			{
	   				let tableRelationItem = tableRelationItems[k];
	   				if(tableRelatinItem.type == "Fixed")
	   				{
	   					hasFixed = true;
	   					break;
	   				}
	   			}
	   			if(hasFixed)
	   				continue;
	   			mtr = tr;
	   			break;
	   		}
	   	}
	   	else
	   	{
	   		mtr = null;
	   	}
	   }
	   else
	   {
	   	mtr = null;
	   }*/
	
				if (mtr) {
					var kv;
					var rfList = mtr.TableRelationItems; //.(@type=="RelatedFixed");
					for (var i = 0; i < rfList.length; i++) {
						var rf = rfList[i];
						kv = { remoteClass: "gongqi.erp.gotmodel.form.remote.StringKeyValue" };
						if (rf.type == "Normal") {
							kv.key = _GOTUtil2.default.getPropertyValue(rf, "RelatedField") || _GOTUtil2.default.getPropertyValue(rf, "ParentField");
							if (!record) kv.value = "";else kv.value = record[formDataSource.Value + "." + _StringUtil2.default.convertToFirstLowerCase(_GOTUtil2.default.getPropertyValue(rf, "Field"))];
						} else if (rf.type == "RelatedFixed") {
							kv.key = _GOTUtil2.default.getPropertyValue(rf, "RelatedField") || _GOTUtil2.default.getPropertyValue(rf, "ParentField");
							kv.value = _GOTUtil2.default.getPropertyValue(rf, "Value");
						}
						mainTableValues.push(kv);
					}
					return mainTableValues;
				} else {
	
					var dataTypeRelation = result["dataTypeRelation"];
					if (!dataTypeRelation) return [];
	
					var _fieldPro = dataTypeRelation.Properties.Field;
					if (!_fieldPro) return [];
					if (!_fieldPro.V) return [];
	
					var kv = { remoteClass: "gongqi.erp.gotmodel.form.remote.StringKeyValue" };
					kv.key = _fieldPro.V;
					kv.value = value;
					mainTableValues.push(kv);
	
					if (args.filterValue) {
						var filterFieldV = _GOTUtil2.default.getPropertyValue(dataTypeRelation, "FilterField");
	
						var kv2 = { remoteClass: "gongqi.erp.gotmodel.form.remote.StringKeyValue" };
						kv2.key = filterFieldV;
						kv2.value = args.filterValue;
						mainTableValues.push(kv2);
					}
	
					return mainTableValues;
					var relationItems = dataTypeRelation.DataTypeRelationItems;
					var _fieldPro;var fixedPro;
					for (var _i = 0; _i < relationItems.length; _i++) {
						var relationItem = relationItems[_i];
						_fieldPro = _GOTUtil2.default.getProperty(relationItem, "Field"); //relationItem.Properties.Property.(Name == "Field");
						if (relationItem.type == "Normal") {
							kv = { remoteClass: "gongqi.erp.gotmodel.form.remote.StringKeyValue" };
							kv.key = _fieldPro.V;
							kv.value = value;
							mainTableValues.push(kv);
						} else {
							fixedPro = _GOTUtil2.default.getProperty(relationItem, "FixedValue");
							kv = { remoteClass: "gongqi.erp.gotmodel.form.remote.StringKeyValue" };
							kv.key = _fieldPro.V;
							kv.value = fixedPro.V;
							mainTableValues.push(kv);
						}
					}
					return mainTableValues;
				}
			}
		}]);
	
		return MainFormFactory;
	}();
	
	MainFormFactory.mapMainForm = {};
	exports.default = MainFormFactory;

/***/ },
/* 287 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PropertyValueType = function PropertyValueType() {
		_classCallCheck(this, PropertyValueType);
	};
	
	PropertyValueType.STRING = 0;
	PropertyValueType.INT = 1;
	PropertyValueType.BOOLEAN = 2;
	PropertyValueType.PROPERTY_XML = 3;
	exports.default = PropertyValueType;

/***/ },
/* 288 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TimerTasksUtil = function () {
		function TimerTasksUtil() {
			_classCallCheck(this, TimerTasksUtil);
		}
	
		_createClass(TimerTasksUtil, null, [{
			key: "addTimer",
			value: function addTimer(_id, _delay, handler) {
				var _repeatCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
				if (_repeatCount == 0) {
					var timer = setInterval(handler, _delay);
					TimerTasksUtil.timers[_id] = timer;
				} else {
					var _id = setTimeout(function () {
						clearTimeout(_id);handler();
					}, _delay);
				}
			}
		}, {
			key: "cancelTimer",
			value: function cancelTimer(_id) {
				if (TimerTasksUtil.timers.hasOwnProperty(_id)) {
					clearInterval(TimerTasksUtil.timers[_id]);
					delete TimerTasksUtil.timers[_id];
				}
			}
		}]);
	
		return TimerTasksUtil;
	}();
	
	TimerTasksUtil.timers = {};
	exports.default = TimerTasksUtil;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\r\n * Bootstrap-select v1.12.4 (http://silviomoreto.github.io/bootstrap-select)\r\n *\r\n * Copyright 2013-2017 bootstrap-select\r\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\r\n */select.bs-select-hidden,select.selectpicker{display:none!important}.bootstrap-select{width:220px \\0}.bootstrap-select>.dropdown-toggle{width:100%;padding-right:25px;z-index:1}.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:active,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover{color:#999}.bootstrap-select>select{position:absolute!important;bottom:0;left:50%;display:block!important;width:.5px!important;height:100%!important;padding:0!important;opacity:0!important;border:none}.bootstrap-select>select.mobile-device{top:0;left:0;display:block!important;width:100%!important;z-index:2}.error .bootstrap-select .dropdown-toggle,.has-error .bootstrap-select .dropdown-toggle{border-color:#b94a48}.bootstrap-select.fit-width{width:auto!important}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:220px}.bootstrap-select .dropdown-toggle:focus{outline:thin dotted #333!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.bootstrap-select.form-control{margin-bottom:0;padding:0;border:none}.bootstrap-select.form-control:not([class*=col-]){width:100%}.bootstrap-select.form-control.input-group-btn{z-index:auto}.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn{border-radius:0}.bootstrap-select.btn-group:not(.input-group-btn),.bootstrap-select.btn-group[class*=col-]{float:none;display:inline-block;margin-left:0}.bootstrap-select.btn-group.dropdown-menu-right,.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right{float:right}.form-group .bootstrap-select.btn-group,.form-horizontal .bootstrap-select.btn-group,.form-inline .bootstrap-select.btn-group{margin-bottom:0}.form-group-lg .bootstrap-select.btn-group.form-control,.form-group-sm .bootstrap-select.btn-group.form-control{padding:0}.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle{height:100%;font-size:inherit;line-height:inherit;border-radius:inherit}.form-inline .bootstrap-select.btn-group .form-control{width:100%}.bootstrap-select.btn-group.disabled,.bootstrap-select.btn-group>.disabled{cursor:not-allowed}.bootstrap-select.btn-group.disabled:focus,.bootstrap-select.btn-group>.disabled:focus{outline:none!important}.bootstrap-select.btn-group.bs-container{position:absolute;height:0!important;padding:0!important}.bootstrap-select.btn-group.bs-container .dropdown-menu{z-index:1060}.bootstrap-select.btn-group .dropdown-toggle .filter-option{display:inline-block;overflow:hidden;width:100%;text-align:left}.bootstrap-select.btn-group .dropdown-toggle .caret{position:absolute;top:50%;right:12px;margin-top:-2px;vertical-align:middle}.bootstrap-select.btn-group[class*=col-] .dropdown-toggle{width:100%}.bootstrap-select.btn-group .dropdown-menu{min-width:100%;box-sizing:border-box}.bootstrap-select.btn-group .dropdown-menu.inner{position:static;float:none;border:0;padding:0;margin:0;border-radius:0;box-shadow:none}.bootstrap-select.btn-group .dropdown-menu li{position:relative}.bootstrap-select.btn-group .dropdown-menu li.active small{color:#fff}.bootstrap-select.btn-group .dropdown-menu li.disabled a{cursor:not-allowed}.bootstrap-select.btn-group .dropdown-menu li a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bootstrap-select.btn-group .dropdown-menu li a.opt{position:relative;padding-left:2.25em}.bootstrap-select.btn-group .dropdown-menu li a span.check-mark{display:none}.bootstrap-select.btn-group .dropdown-menu li a span.text{display:inline-block}.bootstrap-select.btn-group .dropdown-menu li small{padding-left:.5em}.bootstrap-select.btn-group .dropdown-menu .notify{position:absolute;bottom:5px;width:96%;margin:0 2%;min-height:26px;padding:3px 5px;background:#f5f5f5;border:1px solid #e3e3e3;box-shadow:inset 0 1px 1px rgba(0,0,0,.05);pointer-events:none;opacity:.9;box-sizing:border-box}.bootstrap-select.btn-group .no-results{padding:3px;background:#f5f5f5;margin:0 5px;white-space:nowrap}.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option{position:static}.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret{position:static;top:auto;margin-top:-1px}.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark{position:absolute;display:inline-block;right:15px;margin-top:5px}.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text{margin-right:34px}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle{z-index:1061}.bootstrap-select.show-menu-arrow .dropdown-toggle:before{content:\"\";border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid hsla(0,0%,80%,.2);position:absolute;bottom:-4px;left:9px;display:none}.bootstrap-select.show-menu-arrow .dropdown-toggle:after{content:\"\";border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;position:absolute;bottom:-4px;left:10px;display:none}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before{bottom:auto;top:-3px;border-top:7px solid hsla(0,0%,80%,.2);border-bottom:0}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after{bottom:auto;top:-3px;border-top:6px solid #fff;border-bottom:0}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before{right:12px;left:auto}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after{right:13px;left:auto}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:after,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:before{display:block}.bs-actionsbox,.bs-donebutton,.bs-searchbox{padding:4px 8px}.bs-actionsbox{width:100%;box-sizing:border-box}.bs-actionsbox .btn-group button{width:50%}.bs-donebutton{float:left;width:100%;box-sizing:border-box}.bs-donebutton .btn-group button{width:100%}.bs-searchbox+.bs-actionsbox{padding:0 8px 4px}.bs-searchbox .form-control{margin-bottom:0;width:100%;float:none}", ""]);
	
	// exports


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block}audio:not([controls]){display:none;height:0}progress{vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;margin:0}optgroup{font-weight:700}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-input-placeholder{color:inherit;opacity:.54}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}", ""]);
	
	// exports


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".selectedFile,.table tr:hover{background-color:#f1f7fd}", ""]);
	
	// exports


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "#chooseableColumns,#exportColumns{padding:10px;border:1px solid #ddd;overflow:auto;max-height:600px}#exportSizeModalContainer #exportLists{padding-top:2px!important;padding-bottom:6px!important;padding-right:0!important;width:89px}#exportModal #exportLists option{background-color:#fff!important;color:#000!important}#exportModal input[type=checkbox]{visibility:hidden}#exportModal input[type=checkbox]+label{display:block;width:18px;height:18px;cursor:pointer;position:absolute;top:4px;left:-2px;background:#fff;border:1px solid #0078d4}#exportModal input[type=checkbox]:checked+label:before{display:block;content:\"\\2713\";text-align:center;font-size:14px;color:#0078d4;width:17px;height:18px;top:-2px;position:absolute}#exportModal .modal-footer .btn-info{border:1px solid #0078d4;border-radius:2px;font-family:STSongti-SC-Bold;font-size:14px;color:#0178d4}#exportModal .react-grid-Main{outline:none}#exportModal .modal-title{font-family:unset;font-size:16px;color:#000}#exportDragHelper .ui-selected,#exportModal #chooseableColumns>div.ui-selected,#exportModal #exportColumns>div.ui-selected{background-color:#1e90ff}@media screen and (max-height:700px){#chooseableColumns,#exportColumns{max-height:500px!important}}@media screen and (max-height:600px){#chooseableColumns,#exportColumns{max-height:400px!important}}@media screen and (max-height:500px){#chooseableColumns,#exportColumns{max-height:300px!important}}@media screen and (max-height:400px){#chooseableColumns,#exportColumns{max-height:200px!important}}#chooseableColumns div,#exportColumns div{padding:5px 0}#exportGridModal .box-header{padding:5px}#exportGridModal .box-body{padding:0}#exportGridModal .modal-footer input[type=checkbox]{margin:2px 0 0 -20px}#exportGridModal .react-grid-Canvas::-webkit-scrollbar-track{margin-left:0}#exportDataGrid .react-grid-HeaderCell{padding:4px}#exportDataGrid .react-grid-Cell__value{height:70%}#exportModal input[type=checkbox]:checked{display:inline-block}#exportModal .box-header .box-title{font-size:12px}#exportModal .box{border-top:none;box-shadow:0 1px 1px rgba(1,1,1,0)}#exportSizeDiv{width:1200px;height:500px}#exportColumns input[type=checkbox]{height:14px;width:14px;vertical-align:middle;margin-bottom:3px}@media screen and (max-width:1200px){#exportSizeDiv{width:1000px;height:500px}}@media screen and (max-width:950px){#exportSizeDiv{width:800px;height:500px}}#btn-cancel{padding:6px 12px!important}", ""]);
	
	// exports


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".wrap-selectImg{margin-top:20px}.wrap-selectImg li{float:left;position:relative;margin-right:15px;margin-bottom:20px}.wrap-selectImg li input[type=checkbox]{opacity:0;position:absolute;left:0;bottom:0;top:0;right:0;height:120px;width:140px}.wrap-selectImg li img{border:2px solid transparent}.wrap-selectImg li input[type=checkbox]:checked~img{border:2px solid #1e9fff}.wrap-selectImg li p{display:flex;align-items:center;justify-content:center;width:140px;overflow:hidden}.FormItemImage_DialogDelete{background-color:#fff;width:100%;height:30px;margin-bottom:2px;position:absolute;bottom:0;display:flex;align-items:center}.FormItemImage_DialogDeleteBtn{width:100px;position:absolute;bottom:0;margin-left:75%;height:30px;background-color:#008cba;border:none;color:#fff;text-align:center;text-decoration:none;display:inline-block;font-size:14px;border-radius:10px;margin-bottom:2px}#FormItemImage_DialogDeleteQX{width:19px;height:19px;display:inline-block;margin-bottom:4px;margin-left:6px}", ""]);
	
	// exports


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".index img{margin:40px auto;border-radius:4px;background:#fff;display:block}.index .notice{margin:20px auto;padding:15px 0;text-align:center;border:1px solid #000;border-width:1px 0;background:#666}#app{width:100%;height:100%}", ""]);
	
	// exports


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background:rgba(0,0,0,.1)!important;border-color:#337ab7}", ""]);
	
	// exports


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".icheckbox_minimal-blue14,.iradio_minimal-blue14{display:inline-block;*display:inline;vertical-align:middle;margin:0;padding:0;width:13px;height:13px;background:url(" + __webpack_require__(325) + ") no-repeat;border:none;cursor:pointer}.icheckbox_minimal-blue14{background-position:0 0}.icheckbox_minimal-blue14.hover{background-position:-14px 0}.icheckbox_minimal-blue14.checked{background-position:-28px 0}.gongqi_render_boolean.disabled .icheckbox_minimal-blue14,.icheckbox_minimal-blue14.disabled{background-position:-42px 0;cursor:default}.gongqi_render_boolean.disabled .icheckbox_minimal-blue14.checked,.icheckbox_minimal-blue14.checked.disabled{background-position:-56px 0}@media only screen and (-moz-min-device-pixel-ratio:1.5),only screen and (-o-min-device-pixel-ratio:3/2),only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min-device-pixel-ratio:1.5){.icheckbox_minimal-blue14,.iradio_minimal-blue14{background-image:url(" + __webpack_require__(326) + ");background-size:140px 14px}}.icheckbox_minimal-blue28,.iradio_minimal-blue28{display:inline-block;*display:inline;vertical-align:middle;margin:0;margin-left:2px;padding:0;width:40px;height:40px;background:url(" + __webpack_require__(327) + ") no-repeat;border:none;cursor:pointer}.icheckbox_minimal-blue28{background-position:-1px 0}.icheckbox_minimal-blue28.hover{background-position:-40px 0}.icheckbox_minimal-blue28.checked{background-position:-80px 0}.gongqi_render_boolean.disabled .icheckbox_minimal-blue28,.icheckbox_minimal-blue28.disabled{background-position:-120px 0;cursor:default}.gongqi_render_boolean.disabled .icheckbox_minimal-blue28.checked,.icheckbox_minimal-blue28.checked.disabled{background-position:-160px 0}.outDataGrid_checkbox{margin-top:1px}", ""]);
	
	// exports


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "button:focus{border:1px solid #338fff}.buttonIconOccupied{margin-left:5px}", ""]);
	
	// exports


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".datagridcontainer .react-grid-cell-signed{outline:2px solid #66afe9;outline-offset:-2px}.datagridcontainer .react-grid-Grid{border:1px solid #ddd}.datagridcontainer .react-grid-Main{outline:none}.datagridcontainer .react-grid-HeaderCell{padding-left:2px;padding-top:3px;padding-right:1px;overflow:hidden;font-family:Source Sans Pro,Helvetica Neue,Helvetica,Arial,sans-serif}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0;padding-right:1px}.datagridcontainer .react-grid-Header{background:#fff}.datagridcontainer .react-grid-Main{height:100%}.datagridcontainer .react-grid-Cell{padding-left:0;padding-right:0;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.datagridcontainer .react-grid-Cell__value{height:100%;width:100%}.GongqiDataGridNumColHeaderCell{cursor:pointer}.react-grid-Row.row-selected div.react-grid-Cell{background-color:#e6f0fa;border-top:1px solid #0a6ed1;border-bottom:1px solid #0a6ed1}.react-grid-Cell.react-grid-Cell--locked:not(.data-grid-num-col){background-color:#f2f2f2}.react-grid-Cell.row-selected.react-grid-Cell--locked:not(.data-grid-num-col){z-index:100!important}.react-grid-Cell:focus,.react-grid-Row.row-selected div.react-grid-Cell:focus{border:2px solid #0a6ed1}.react-grid-Cell:focus{outline:none;user-select:text}.react-grid-Row.row-selected .data-grid-num-col{border-left:1px solid #0a6ed1}.react-grid-Row.row-selected .react-grid-Cell.lastNoLock{border-right:1px solid #0a6ed1}", ""]);
	
	// exports


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".dividedbox_splitter_proxy{float:left;width:4px;display:none;cursor:e-resize;position:absolute;background-color:#f0f0f0;border:1px solid #99bbe8;filter:alpha(opacity=60);-moz-opacity:.6;-khtml-opacity:.6;opacity:.6;z-index:1000000}", ""]);
	
	// exports


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".select2-container .select2-selection--single{height:22px}.select2-container--default .select2-selection--single,.select2-selection .select2-selection--single{padding:0;padding-top:1px}.select2-container--default .select2-selection--single .select2-selection__arrow{height:22px}.FormItemEnumEditor .dropdown-menu,.FormItemEnumEditorForDataGrid .dropdown-menu{margin-top:0}.bootstrap-select.form-control,.bootstrap-select.form-control:not([class*=col-]){width:auto}div.bootstrap-select{height:22px}div.bootstrap-select>button.btn{padding:0;padding-top:2px;background-color:#fff}div.bootstrap-select>button.btn>span.pull-left{text-align:center;width:calc(100% - 15px)!important}.FormItemEnumEditor button.btn.dropdown-toggle{padding-left:2px}", ""]);
	
	// exports


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".box-header .box-title{font-size:15px;font-weight:700}.form-vertical .editorGroup:not(:last-child){padding-bottom:5px}.fieldGroupMutiRow label{padding-left:5px!important}", ""]);
	
	// exports


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".verticalList>.editorGroup{padding-top:5px;flex-shrink:0}.verticalList>.editorGroup:last-child{padding-bottom:5px}.horizontalList>.editorGroup:not(:last-child){padding-right:5px}.horizontalList>.editorGroup{padding-top:3px;padding-bottom:3px}", ""]);
	
	// exports


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".FormItemImage:focus{background:#eff7fe;border:1px dashed #87b9fa;outline:none}.FormItemImage{background:#fafafa;border:1px dashed #d9d9d9;border-radius:3px}.FormItemImageContainer .viewer-toolbar>li.viewer-next,.FormItemImageContainer .viewer-toolbar>li.viewer-prev{display:none}.FormItemImageContainer.FormItemImageMutiple .viewer-toolbar>li.viewer-next,.FormItemImageContainer.FormItemImageMutiple .viewer-toolbar>li.viewer-prev{display:block}.FormItemImageContainer.FormItemImageMutiple{position:relative}", ""]);
	
	// exports


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".formItemPluginRadio .iradio_minimal-blue{margin-right:3px}.iradio_minimal-blue.gongqiFocus{background-position:-120px 0}.iradio_minimal-blue.checked.gongqiFocus{background-position:0 0;background:url(" + __webpack_require__(329) + ");background-size:contain}@media only screen and (-moz-min-device-pixel-ratio:1.5),only screen and (-o-min-device-pixel-ratio:1.5),only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min-device-pixel-ratio:1.5){.iradio_minimal-blue.checked.gongqiFocus{background-position:0 0;background:url(" + __webpack_require__(328) + ");background-size:contain}}", ""]);
	
	// exports


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".gongqi_render_select{-webkit-touch-callout:initial;-webkit-user-select:initial;-moz-user-select:initial;-ms-user-select:initial;user-select:none;width:100%;height:100%;padding-top:1px}.react-grid-Cell:focus .gongqi_render_select{user-select:text}.checkbox,.radio{margin-top:0;margin-bottom:0}", ""]);
	
	// exports


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".nav>li>a.gongqi_tabpage{padding:2px 15px}", ""]);
	
	// exports


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".dateTimeWrap{display:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;background:#494a4a;padding:7px;position:fixed;left:0;top:0;z-index:999;font-size:14px;color:#e2e2e2;width:240px}.dateTimeWrap ol,.dateTimeWrap ul{list-style:none}#dateTime{*float:left}.dateTimeHead{*overflow:hidden;padding:8px 0 4px}.dateTimeFoot span,.timeFooter span{cursor:pointer;display:inline-block;background:#fff;color:#333;height:20px;line-height:20px;width:50px;text-align:center;margin-left:6px;float:right}.timePart{text-align:center;color:#333;line-height:22px}.timePart p,.timePart ul{background:#fff}.timePart>ul>li{float:left;width:119px;background:#fff;color:#333;border-right:none}.timePart ul{overflow:hidden}.timePart>ul>li p{line-height:30px;margin-bottom:0}.timePart ol{height:170px;overflow-y:hidden;overflow-x:hidden;padding-left:0;border:1px solid #e6e6e6}.timePart ol:hover{overflow-y:auto}.timePart ol:hover li{padding-left:17px}.timePart ol li{line-height:28px}.timePart ol li.cur{background:#1ea0fa;color:#fff}.dateTimeFoot,.timeFooter{overflow:hidden;height:24px}.timeFooter #curTime{width:80px;background:#fff;border:1px solid #1fa0fa;border-radius:2px;color:#1fa0fa}.timeFooter #curTime,.timeFooter #ensure{height:24px;font-family:PingFangSC-Regular;font-size:12px}.timeFooter #ensure{width:56px;background:#1fa0fa;border-radius:2px;color:#fff}.dateTimeFoot .selTime,.timeFooter .selTime{float:left;margin-left:0;display:none}.selTime{width:80px!important}.darkgrey{color:#d0d0d0!important}.mycontainer input{border:1px solid #ccc;padding:6px 10px}", ""]);
	
	// exports


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".vertical-list{flex-flow:column;display:flex}.vertical-list li{list-style-type:none}.vertical-list>*{display:block;margin-top:2px;margin-bottom:2px}.horizontal-list>*{margin-left:2px;margin-right:2px;display:inline-block;vertical-align:top}.horizontal-list{display:flex;align-items:flex-start;overflow:auto;white-space:nowrap}", ""]);
	
	// exports


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "#Form_SysDataSetView .GongqiFormDesign{height:auto!important}#userFormSetDiv .btn-info{color:#0178d4!important}#userFormSetDiv .btn-info.ufs-cancel{color:#000!important}#userFormSetDiv .btn-info.ufs-require{color:#fff!important}#userFormSetDiv .modal-title{font-weight:500!important}#currentRecordInfoModal .btn-info{font-family:STSongti-SC-Bold;font-size:14px;color:#0178d4!important;border:1px solid #0078d4!important;border-radius:2px}#userFormSetDiv #userSetTable-footer .btn-info{border:1px solid #0078d4;border-radius:2px;height:28px}#userFormSetDiv .react-grid-Grid{border:none}#userFormSetDiv #userSetDefaultBox{visibility:hidden}#userFormSetDiv input[type=checkbox]+label{display:block;width:18px;height:18px;cursor:pointer;position:absolute;top:4px;left:0;background:#fff;border:1px solid #0078d4}#userFormSetDiv input[type=checkbox]:checked+label:before{display:block;content:\"\\2713\";text-align:center;font-size:14px;color:#0078d4;width:17px;height:18px;top:-2px;left:-1px;position:absolute}#queryFormDiv .react-grid-Main{outline:none}#queryFormDiv .tab-content .react-grid-Grid{border:none}#queryFormDiv input[type=checkbox]{visibility:hidden}#queryFormDiv input[type=checkbox]+label{display:block;width:18px;height:18px;cursor:pointer;position:absolute;top:4px;left:0;background:#fff;border:1px solid #0078d4}#queryFormDiv input[type=checkbox]:checked+label:before{display:block;content:\"\\2713\";text-align:center;font-size:14px;color:#0078d4;width:17px;height:18px;top:-2px;left:-1px;position:absolute}#queryFormDiv .btn-info.ufs-cancel{color:#000!important}#queryFormDiv .btn-info.ufs-require{color:#fff!important}#currentRecordInfoModal .modal-title,#queryFormDiv .modal-title,#userFormSetDiv .modal-title{font-family:unset;font-size:16px;color:#000}#findModal .btn-info.ufs-require{color:#fff!important}select.btn-info>option{background-color:#fff!important;color:#000!important}.universalViewFormDownButton:focus,.universalViewFormTopButton:focus{border:2px solid transparent}.previewDataGridContainer .react-grid-Grid,.relationDataGridContainer .react-grid-Grid{min-height:0!important}", ""]);
	
	// exports


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap-select v1.12.4 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */select.bs-select-hidden,select.selectpicker{display:none!important}.bootstrap-select{width:220px \\0}.bootstrap-select>.dropdown-toggle{width:100%;padding-right:25px;z-index:1}.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:active,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover{color:#999}.bootstrap-select>select{position:absolute!important;bottom:0;left:50%;display:block!important;width:.5px!important;height:100%!important;padding:0!important;opacity:0!important;border:none}.bootstrap-select>select.mobile-device{top:0;left:0;display:block!important;width:100%!important;z-index:2}.error .bootstrap-select .dropdown-toggle,.has-error .bootstrap-select .dropdown-toggle{border-color:#b94a48}.bootstrap-select.fit-width{width:auto!important}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:220px}.bootstrap-select .dropdown-toggle:focus{outline:thin dotted #333!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.bootstrap-select.form-control{margin-bottom:0;padding:0;border:none}.bootstrap-select.form-control:not([class*=col-]){width:100%}.bootstrap-select.form-control.input-group-btn{z-index:auto}.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn{border-radius:0}.bootstrap-select.btn-group:not(.input-group-btn),.bootstrap-select.btn-group[class*=col-]{float:none;display:inline-block;margin-left:0}.bootstrap-select.btn-group.dropdown-menu-right,.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right{float:right}.form-group .bootstrap-select.btn-group,.form-horizontal .bootstrap-select.btn-group,.form-inline .bootstrap-select.btn-group{margin-bottom:0}.form-group-lg .bootstrap-select.btn-group.form-control,.form-group-sm .bootstrap-select.btn-group.form-control{padding:0}.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle{height:100%;font-size:inherit;line-height:inherit;border-radius:inherit}.form-inline .bootstrap-select.btn-group .form-control{width:100%}.bootstrap-select.btn-group.disabled,.bootstrap-select.btn-group>.disabled{cursor:not-allowed}.bootstrap-select.btn-group.disabled:focus,.bootstrap-select.btn-group>.disabled:focus{outline:none!important}.bootstrap-select.btn-group.bs-container{position:absolute;height:0!important;padding:0!important}.bootstrap-select.btn-group.bs-container .dropdown-menu{z-index:1060}.bootstrap-select.btn-group .dropdown-toggle .filter-option{display:inline-block;overflow:hidden;width:100%;text-align:left}.bootstrap-select.btn-group .dropdown-toggle .caret{position:absolute;top:50%;right:3px;margin-top:-2px;vertical-align:middle}.bootstrap-select.btn-group[class*=col-] .dropdown-toggle{width:100%}.bootstrap-select.btn-group .dropdown-menu{min-width:100%;box-sizing:border-box}.bootstrap-select.btn-group .dropdown-menu.inner{position:static;float:none;border:0;padding:0;margin:0;border-radius:0;box-shadow:none}.bootstrap-select.btn-group .dropdown-menu li{position:relative}.bootstrap-select.btn-group .dropdown-menu li.active small{color:#fff}.bootstrap-select.btn-group .dropdown-menu li.disabled a{cursor:not-allowed}.bootstrap-select.btn-group .dropdown-menu li a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bootstrap-select.btn-group .dropdown-menu li a.opt{position:relative;padding-left:2.25em}.bootstrap-select.btn-group .dropdown-menu li a span.check-mark{display:none}.bootstrap-select.btn-group .dropdown-menu li a span.text{display:inline-block}.bootstrap-select.btn-group .dropdown-menu li small{padding-left:.5em}.bootstrap-select.btn-group .dropdown-menu .notify{position:absolute;bottom:5px;width:96%;margin:0 2%;min-height:26px;padding:3px 5px;background:#f5f5f5;border:1px solid #e3e3e3;box-shadow:inset 0 1px 1px rgba(0,0,0,.05);pointer-events:none;opacity:.9;box-sizing:border-box}.bootstrap-select.btn-group .no-results{padding:3px;background:#f5f5f5;margin:0 5px;white-space:nowrap}.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option{position:static}.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret{position:static;top:auto;margin-top:-1px}.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark{position:absolute;display:inline-block;right:15px;margin-top:5px}.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text{margin-right:34px}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle{z-index:1061}.bootstrap-select.show-menu-arrow .dropdown-toggle:before{content:\"\";border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid hsla(0,0%,80%,.2);position:absolute;bottom:-4px;left:9px;display:none}.bootstrap-select.show-menu-arrow .dropdown-toggle:after{content:\"\";border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;position:absolute;bottom:-4px;left:10px;display:none}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before{bottom:auto;top:-3px;border-top:7px solid hsla(0,0%,80%,.2);border-bottom:0}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after{bottom:auto;top:-3px;border-top:6px solid #fff;border-bottom:0}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before{right:12px;left:auto}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after{right:13px;left:auto}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:after,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:before{display:block}.bs-actionsbox,.bs-donebutton,.bs-searchbox{padding:4px 8px}.bs-actionsbox{width:100%;box-sizing:border-box}.bs-actionsbox .btn-group button{width:50%}.bs-donebutton{float:left;width:100%;box-sizing:border-box}.bs-donebutton .btn-group button{width:100%}.bs-searchbox+.bs-actionsbox{padding:0 8px 4px}.bs-searchbox .form-control{margin-bottom:0;width:100%;float:none}", ""]);
	
	// exports


/***/ },
/* 311 */,
/* 312 */,
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./Attachment.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./Attachment.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./exportStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./exportStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(293);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemImageDialog.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemImageDialog.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(295);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormDesign.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormDesign.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(298);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemDataGridStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemDataGridStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(299);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemDividedBoxStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemDividedBoxStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(301);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemFieldGroupStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemFieldGroupStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemGroupStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemGroupStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(303);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemImageStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemImageStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(306);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemTabStyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemTabStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(307);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./FormItemTime.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./FormItemTime.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8652a953374d00000588cbb8f3858ecc.png";

/***/ },
/* 325 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 326 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 327 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 328 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 329 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjMzMDRCMjBBOTEzRTExRUI4QkE5OTQ3QjZGOTU2M0QwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjMzMDRCMjBCOTEzRTExRUI4QkE5OTQ3QjZGOTU2M0QwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzMwNEIyMDg5MTNFMTFFQjhCQTk5NDdCNkY5NTYzRDAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzMwNEIyMDk5MTNFMTFFQjhCQTk5NDdCNkY5NTYzRDAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4HtoD8AAAB5ElEQVR42qzUT0jTYRzH8W1taxAjlKB22EkHlocuKiFkHcKOYYO6KEEgYVANRMGL0N2Lhw5JWEF58SYV9A/cYnRIGB2KcqEgXVzDw8gI3ZjvBz7P+PnwmzboC6/D77dn3+fP9/t7gvV6PfA/I5yezzX7rQ2XMYBORFHGCl6j4Pen4JHMM7/3GYxhC2/wBX9xCufRg++YQHHfCo9Fw97nGMwMXbirlbgxh5MYxzJu4UUjoWdgCM9xHOfw+4Cj2sQkPuEJhvDBTXgbp7WdP/9Yg0W04xF6UQl5CnAPd1pIZuMhfmpBAZtwEL/w3ucPZsVP8VbnFvMZM4trZsd2yxdVTTd6NUlcz5fQjVHUPOM+anEpu8IOfG3SPnHn3Q0l9YbZXRUJmzCqPnMj4fMupE5ww3xyEZuwrN5y46XPuw01tTeimqhR5YI+MTce4DF29byu8ys541IqVtEmfIV+nHAGmmO4qeJcQF+T4l3Hqtmpd4WmKFNNeu0zcjoaN5KadMbbhwF96MO42kJTH8UClpB3E37TTHO6aQ6LpJq9ovYKuAltVdMa8A5XnOqbap7FfWR1FOZi2GncNts7VXfmrA7frHJak9bUZyFdKKYAI3ab+y7Y/FrpsK2d0cUa0fZ+6MvwjT0BBgBTImY+iRwyCgAAAABJRU5ErkJggg=="

/***/ },
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IndexedDBUtil = function () {
	    function IndexedDBUtil() {
	        _classCallCheck(this, IndexedDBUtil);
	    }
	
	    _createClass(IndexedDBUtil, null, [{
	        key: "openDB",
	        value: function openDB(name, callBack, version) {
	            var _name = name || IndexedDBUtil.DB.name;
	            var _version = version || 4;
	            var _indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
	            var request = _indexedDB.open(_name, _version);
	
	            request.onerror = IndexedDBUtil.dbOnError;
	            request.onsuccess = function (e) {
	                IndexedDBUtil.dbOnSuccess(e, callBack);
	            };
	            request.onupgradeneeded = IndexedDBUtil.dbOnupgradeneeded;
	        }
	    }, {
	        key: "dbOnError",
	        value: function dbOnError(e) {
	            alert(e.currentTarget.error.message);
	        }
	    }, {
	        key: "dbOnSuccess",
	        value: function dbOnSuccess(e, callBack) {
	            IndexedDBUtil.DB.db = e.target.result;
	            if (callBack) {
	                callBack();
	            }
	        }
	    }, {
	        key: "dbOnupgradeneeded",
	        value: function dbOnupgradeneeded(e) {
	            var db = e.target.result;
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name)) {
	                db.createObjectStore(IndexedDBUtil.DB.name, { keyPath: "id" });
	            }
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name2)) {
	                db.createObjectStore(IndexedDBUtil.DB.name2, { keyPath: "id" });
	                //alert("dbOnupgradeneeded      " + IndexedDBUtil.DB.name2);
	            }
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name3)) {
	                db.createObjectStore(IndexedDBUtil.DB.name3, { keyPath: "id" });
	                //alert("dbOnupgradeneeded      " + IndexedDBUtil.DB.name2);
	            }
	
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name4)) {
	                db.createObjectStore(IndexedDBUtil.DB.name4, { keyPath: "id" });
	            }
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name5)) {
	                db.createObjectStore(IndexedDBUtil.DB.name5, { keyPath: "id" });
	            }
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name6)) {
	                db.createObjectStore(IndexedDBUtil.DB.name6, { keyPath: "id" });
	            }
	            if (!db.objectStoreNames.contains(IndexedDBUtil.DB.name7)) {
	                db.createObjectStore(IndexedDBUtil.DB.name7, { keyPath: "id" });
	            }
	        }
	    }, {
	        key: "addData",
	        value: function addData(db, storeName, data) {
	            if (db) {
	                var transaction = db.transaction(storeName, 'readwrite');
	                var store = transaction.objectStore(storeName);
	                var request = store.get(data.id);
	                request.onsuccess = function (e) {
	                    store.put(data);
	                };
	            }
	            //store.add(data);
	        }
	    }, {
	        key: "getDataById",
	        value: function getDataById(id, storeName, callBack) {
	            if (IndexedDBUtil.DB.db) {
	                var transaction = IndexedDBUtil.DB.db.transaction(storeName);
	                var store = transaction.objectStore(storeName);
	
	                if (!id) {
	                    alert("在访问数据库时未指定id");
	                    return;
	                }
	                var request = store.get(id);
	                request.onsuccess = callBack;
	                request.onerror = function (e) {
	                    alert(e.target.error);
	                };
	            }
	        }
	    }, {
	        key: "getAllDataAndDelete",
	        value: function getAllDataAndDelete(storeName, callback) {
	            var transaction = IndexedDBUtil.DB.db.transaction(storeName, 'readwrite');
	            var store = transaction.objectStore(storeName);
	
	            var request = store.openCursor();
	            var data = [];
	            request.onerror = function () {
	                alert("上传网络错误日志时在获取浏览器数据库数据错误");
	            };
	            request.onsuccess = function (e) {
	                var result = e.target.result;
	                if (result && result !== null) {
	                    if (result.value && result.value.id && result.value.data) data.push(result.value.data);
	                    result.delete();
	                    result.continue();
	                } else {
	                    if (callback) {
	                        //console.log('全部查找数据成功')
	                        callback(data);
	                    }
	                }
	            };
	        }
	    }, {
	        key: "getAllData",
	        value: function getAllData(storeName, callback) {
	            var transaction = IndexedDBUtil.DB.db.transaction(storeName, 'readwrite');
	            var store = transaction.objectStore(storeName);
	
	            var request = store.openCursor();
	            var data = [];
	            request.onerror = function () {
	                alert("查看网络错误日志时在获取浏览器数据库数据错误");
	            };
	            request.onsuccess = function (e) {
	                var result = e.target.result;
	                if (result && result !== null) {
	                    if (result.value && result.value.id && result.value.data) data.push(result.value.data);
	                    //result.delete();
	                    result.continue();
	                } else {
	                    if (callback) {
	                        //console.log('全部查找数据成功')
	                        callback(data);
	                    }
	                }
	            };
	        }
	    }]);
	
	    return IndexedDBUtil;
	}();
	
	IndexedDBUtil.DB = { name: "formRes", name2: "pivotTmp", name3: "logTmp", name4: "clientopr", name5: "performanceTiming", name6: "requestHttp", name7: "performanceMemory" };
	exports.default = IndexedDBUtil;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _IndexedDBUtil = __webpack_require__(347);
	
	var _IndexedDBUtil2 = _interopRequireDefault(_IndexedDBUtil);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = __webpack_require__(360);
	
	var formatMs = utils.formatMs;
	var isObject = utils.isObject;
	var checkResourceType = utils.checkResourceType;
	
	
	function Performance() {};
	
	Performance.prototype = {
	  // 获取数据信息
	  getPerformanceTiming: function getPerformanceTiming(e) {
	    var _this = this;
	
	    // 初始化数据
	    this.init();
	    this.formLabel = e.formLabel;
	    if (!isObject(this.timing)) {
	      console.log('值需要是一个对象类型');
	      return;
	    }
	    // 过早获取 loadEventEnd值会是0
	    var loadTime = this.timing.loadEventEnd - this.timing.navigationStart;
	    if (loadTime < 0) {
	      setTimeout(function () {
	        _this.getPerformanceTiming(e);
	      }, 200);
	      return;
	    }
	    // 获取解析后的数据
	    this.afterDatas.enteriesResouceDataFormat = this._setEnteries();
	    this.afterDatas.timingFormat = this._setTiming(loadTime);
	    this.afterDatas.memory = this._setMemory();
	    this.afterDatas.timingFormatJson = this._setTimingJson(loadTime);
	
	    this._showTiming();
	    var data = { "timing": this.afterDatas.timingFormat, "memory": this.afterDatas.memory };
	    return data;
	  },
	
	  init: function init() {
	    this.timing = window.performance.timing;
	    this.memory = window.performance.memory;
	    // 获取资源类型为 resource的所有数据
	    this.enteriesResouceData = window.performance.getEntriesByType('resource');
	  },
	  // 保存原始数据
	  timing: {},
	  formLabel: '',
	  // 原始enteries数据
	  enteriesResouceData: [],
	  // 保存解析后的数据
	  afterDatas: {
	    memory: {},
	    timingFormat: {},
	    timingFormatJson: {},
	    enteriesResouceDataFormat: {},
	    enteriesResouceDataTiming: {
	      "js": 0,
	      "css": 0,
	      "image": 0,
	      "video": 0,
	      "others": 0
	    },
	    timingMax: {},
	    memoryMax: {},
	    requestMax: {}
	  },
	  _setTiming: function _setTiming(loadTime) {
	    var timing = this.timing;
	    // 对数据进行计算
	    var otherdata = [];
	    for (var key in this.afterDatas.enteriesResouceDataFormat) {
	      var b = {};
	      b[key + "--- 共加载时间" + formatMs(this.afterDatas.enteriesResouceDataTiming[key])] = this.afterDatas.enteriesResouceDataFormat[key];
	      otherdata.push(b);
	    }
	    var data = {
	      "formId": window.formId,
	      "formLable": this.formLabel,
	      "startDateTime": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	      "clientSessionId": window.parent.userInfos.userSessionId,
	      "userId": window.parent.userInfos.userId,
	      "connectStart": timing.connectStart + "",
	      "connectEnd": timing.connectEnd + "",
	      "domComplete": timing.domComplete + "",
	      "domInteractive": timing.domInteractive + "",
	      "domContentLoadedEventEnd": timing.domContentLoadedEventEnd + "",
	      "domContentLoadedEventStart": timing.domContentLoadedEventStart + "",
	      "domainLookupEnd": timing.domainLookupEnd + "",
	      "domainLookupStart": timing.domainLookupStart + "",
	      "navigationStart": timing.navigationStart + "",
	      "requestStart": timing.requestStart + "",
	      "responseEnd": timing.responseEnd + "",
	      "responseStart": timing.responseStart + "",
	      "secureConnectionStart": timing.secureConnectionStart + "",
	      "staticResources": otherdata + ""
	    };
	    return data;
	  },
	  _setTimingJson: function _setTimingJson(loadTime) {
	    var timing = this.timing;
	    // 对数据进行计算
	    var otherdata = [];
	    for (var key in this.afterDatas.enteriesResouceDataFormat) {
	      var b = {};
	      b[key + "--- 共加载时间" + formatMs(this.afterDatas.enteriesResouceDataTiming[key])] = this.afterDatas.enteriesResouceDataFormat[key];
	      otherdata.push(b);
	    }
	    var data = {
	      "formId": window.formId,
	      "formLable": this.formLabel,
	      "startDateTime": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	      "clientSessionId": window.parent.userInfos.userSessionId,
	      "userId": window.parent.userInfos.userId,
	      "connectStart": timing.connectStart + "",
	      "connectEnd": timing.connectEnd + "",
	      "domComplete": timing.domComplete + "",
	      "domInteractive": timing.domInteractive + "",
	      "domContentLoadedEventEnd": timing.domContentLoadedEventEnd + "",
	      "domContentLoadedEventStart": timing.domContentLoadedEventStart + "",
	      "domainLookupEnd": timing.domainLookupEnd + "",
	      "domainLookupStart": timing.domainLookupStart + "",
	      "navigationStart": timing.navigationStart + "",
	      "requestStart": timing.requestStart + "",
	      "responseEnd": timing.responseEnd + "",
	      "responseStart": timing.responseStart + "",
	      "secureConnectionStart": timing.secureConnectionStart + "",
	      "staticResources": otherdata
	    };
	    var timingMax = {
	      "画面ID": window.formId,
	      "画面名称": this.formLabel,
	      "触发时间": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	      "SessionID": window.parent.userInfos.userSessionId,
	      "用户ID": window.parent.userInfos.userId,
	      "重定向耗时": formatMs(timing.redirectEnd - timing.redirectStart),
	      "Appcache耗时": formatMs(timing.domainLookupStart - timing.fetchStart),
	      "DNS查询耗时": formatMs(timing.domainLookupEnd - timing.domainLookupStart),
	      "TCP链接耗时": formatMs(timing.connectEnd - timing.connectStart),
	      "HTTP请求耗时": formatMs(timing.responseEnd - timing.responseStart),
	      "请求完毕到DOM加载耗时": formatMs(timing.domInteractive - timing.responseEnd),
	      "解析DOM树耗时": formatMs(timing.domComplete - timing.domInteractive),
	      "白屏时间耗时": formatMs(timing.responseStart - timing.navigationStart),
	      "load事件耗时": formatMs(timing.loadEventEnd - timing.loadEventStart),
	      "页面加载完成的时间": formatMs(loadTime),
	      "静态资源加载": otherdata
	    };
	    this.afterDatas.timingMax = timingMax;
	    return data;
	  },
	  _setMemory: function _setMemory() {
	    var memory = this.memory;
	    // 对数据进行计算
	    var otherdata = [];
	    for (var key in this.afterDatas.enteriesResouceDataFormat) {
	      var b = {};
	      b[key + "--- 共加载时间" + formatMs(this.afterDatas.enteriesResouceDataTiming[key])] = this.afterDatas.enteriesResouceDataFormat[key];
	      otherdata.push(b);
	    }
	    var data = {
	      "formId": window.formId,
	      "formLable": this.formLabel,
	      "startDateTime": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	      "clientSessionId": window.parent.userInfos.userSessionId,
	      "userId": window.parent.userInfos.userId,
	      "jsHeapSizeLimit": memory.jsHeapSizeLimit + "",
	      "totalJSHeapSize": memory.totalJSHeapSize + "",
	      "usedJSHeapSize": memory.usedJSHeapSize + ""
	    };
	    this.afterDatas.memoryMax = {
	      "画面ID": window.formId,
	      "画面名称": this.formLabel,
	      "触发时间": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	      "SessionID": window.parent.userInfos.userSessionId,
	      "用户ID": window.parent.userInfos.userId,
	      "内存大小限制": memory.jsHeapSizeLimit + "",
	      "总内存": memory.totalJSHeapSize + "",
	      "已使用的内存": memory.usedJSHeapSize + ""
	    };
	    return data;
	  },
	  _setEnteries: function _setEnteries() {
	    var _this2 = this;
	
	    var enteriesResouceData = this.enteriesResouceData;
	    var imageArrs = [],
	        jsArrs = [],
	        cssArrs = [],
	        videoArrs = [],
	        otherArrs = [];
	    enteriesResouceData.map(function (item) {
	      var d = {
	        '资源名称': item.name,
	        'HTTP协议类型': item.nextHopProtocol,
	        "TCP链接耗时": formatMs(item.connectEnd - item.connectStart),
	        "加载时间": formatMs(item.duration)
	      };
	      switch (checkResourceType(item.name)) {
	        case 'image':
	          _this2.afterDatas.enteriesResouceDataTiming.image += item.duration;
	          imageArrs.push(d);
	          break;
	        case 'javascript':
	          _this2.afterDatas.enteriesResouceDataTiming.js += item.duration;
	          jsArrs.push(d);
	          break;
	        case 'css':
	          _this2.afterDatas.enteriesResouceDataTiming.css += item.duration;
	          cssArrs.push(d);
	          break;
	        case 'video':
	          _this2.afterDatas.enteriesResouceDataTiming.video += item.duration;
	          videoArrs.push(d);
	          break;
	        case 'others':
	          _this2.afterDatas.enteriesResouceDataTiming.others += item.duration;
	          otherArrs.push(d);
	          break;
	      }
	    });
	    return {
	      'js': jsArrs,
	      'css': cssArrs,
	      'image': imageArrs,
	      'video': videoArrs,
	      'others': otherArrs
	    };
	  },
	  _showTiming: function _showTiming() {
	    var allData = {};
	    allData['id'] = new Date().getTime();
	    allData['data'] = this.afterDatas.memoryMax;
	    _IndexedDBUtil2.default.openDB(window.parent.userInfos.subSysId, null);
	    setTimeout(function () {
	      _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name7, allData);
	    }, 2000);
	
	    var allData2 = {};
	    allData2['id'] = new Date().getTime();
	    allData2['data'] = this.afterDatas.timingMax;
	    _IndexedDBUtil2.default.openDB(window.parent.userInfos.subSysId, null);
	    setTimeout(function () {
	      _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name5, allData2);
	    }, 2000);
	  },
	  gerPerformanceResource: function gerPerformanceResource(formReq) {
	    var arr = window.performance.getEntriesByType('resource');
	    var arrData = [];
	    if (formReq.length == 0) {
	      formReq = arr;
	      for (var j = 0; j < arr.length; j++) {
	        var allData = {
	          "formId": window.formId,
	          "startDateTime": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	          "clientSessionId": window.parent.userInfos.userSessionId,
	          "userId": window.parent.userInfos.userId,
	          "connectEnd": arr[j].connectEnd + "",
	          "connectStart": arr[j].connectStart + "",
	          "domainLookupEnd": arr[j].domainLookupEnd + "",
	          "domainLookupStart": arr[j].domainLookupStart + "",
	          "requestStart": arr[j].requestStart + "",
	          "responseEnd": arr[j].responseEnd + "",
	          "responseStart": arr[j].responseStart + "",
	          "decodedBodySize": arr[j].decodedBodySize + "",
	          "secureConnectionStart": arr[j].secureConnectionStart + "",
	          "url": arr[j].name,
	          "requestName": "",
	          "duration": arr[j].duration,
	          "initiatorType": arr[j].initiatorType
	        };
	        var allDataJs = {
	          "画面ID": window.formId,
	          "触发时间": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	          "SessionId": window.parent.userInfos.userSessionId,
	          "用户ID": window.parent.userInfos.userId,
	          "连接类型": arr[j].initiatorType,
	          "connectTime": formatMs(arr[j].connectEnd - arr[j].connectStart),
	          "stalled": formatMs(arr[j].requestStart - arr[j].connectEnd),
	          "DNS连接时间": formatMs(arr[j].domainLookupEnd - arr[j].domainLookupStart),
	          "TTFB": formatMs(arr[j].responseStart - arr[j].requestStart),
	          "响应时间": formatMs(arr[j].responseEnd - arr[j].responseStart),
	          "url路径": arr[j].name,
	          "请求名称": "",
	          "加载总时耗": arr[j].duration
	        };
	        if (arr[j].responseStart === 0) {
	          allDataJs['响应时间'] = '0ms';
	        }
	        var indexDBData = {};
	        //id 光时间搓 可能存在重复 所以id 后三位为序列号
	        indexDBData['id'] = new Date().getTime() + this.coder(j + "", 3);
	        indexDBData['data'] = allDataJs;
	        _IndexedDBUtil2.default.openDB(window.parent.userInfos.subSysId, null);
	        _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name6, indexDBData);
	
	        arrData.push(allData);
	      }
	    } else {
	      var newarr = arr.filter(function (v) {
	        return !formReq.includes(v);
	      });
	      for (var g = 0; g < newarr.length; g++) {
	        var _allData = {
	          "formId": window.formId,
	          "startDateTime": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	          "clientSessionId": window.parent.userInfos.userSessionId,
	          "userId": window.parent.userInfos.userId,
	          "connectEnd": newarr[g].connectEnd + "",
	          "connectStart": newarr[g].connectStart + "",
	          "domainLookupEnd": newarr[g].domainLookupEnd + "",
	          "domainLookupStart": newarr[g].domainLookupStart + "",
	          "requestStart": newarr[g].requestStart + "",
	          "responseEnd": newarr[g].responseEnd + "",
	          "responseStart": newarr[g].responseStart + "",
	          "decodedBodySize": newarr[g].decodedBodySize + "",
	          "secureConnectionStart": newarr[g].secureConnectionStart + "",
	          "url": newarr[g].name,
	          "requestName": "",
	          "duration": newarr[g].duration,
	          "initiatorType": newarr[g].initiatorType
	        };
	        var _allDataJs = {
	          "画面ID": window.formId,
	          "触发时间": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
	          "SessionId": window.parent.userInfos.userSessionId,
	          "用户ID": window.parent.userInfos.userId,
	          "连接类型": newarr[g].initiatorType,
	          "connectTime": formatMs(newarr[g].connectEnd - newarr[g].connectStart),
	          "stalled": formatMs(newarr[g].requestStart - newarr[g].connectEnd),
	          "DNS连接时间": formatMs(newarr[g].domainLookupEnd - newarr[g].domainLookupStart),
	          "TTFB": formatMs(newarr[g].responseStart - newarr[g].requestStart),
	          "响应时间": formatMs(newarr[g].responseEnd - newarr[g].responseStart),
	          "url路径": newarr[g].name,
	          "请求名称": "",
	          "加载总时耗": newarr[g].duration
	        };
	        if (newarr[g].responseStart === 0) {
	          _allDataJs['响应时间'] = '0ms';
	        }
	        var _indexDBData = {};
	        //id 光时间搓 可能存在重复 所以id 后三位为序列号
	        _indexDBData['id'] = new Date().getTime() + this.coder(g + "", 3);
	        _indexDBData['data'] = _allDataJs;
	        _IndexedDBUtil2.default.openDB(window.parent.userInfos.subSysId, null);
	        _IndexedDBUtil2.default.addData(_IndexedDBUtil2.default.DB.db, _IndexedDBUtil2.default.DB.name6, _indexDBData);
	        arrData.push(_allData);
	      }
	      formReq = arr;
	    }
	
	    var timingFormat = { remoteClass: "java.util.Map", PerformanceXmlHttpRequest: arrData };
	    var command = _Command2.default.createService("gongqi.erp.framework.services.ClientLoggingService", "saveLog", "void");
	    command.appendArg(timingFormat, "Object");
	    var remoteArg = {
	      command: command,
	      resultFunction: this.success,
	      faultFunction: this.error,
	      autoLock: false,
	      autoUnlock: false
	    };
	    _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    return formReq;
	  },
	  deletePerformeTiming: function deletePerformeTiming() {
	    //IndexedDBUtil.openDB(window.userInfos.subSysId,null);
	    setTimeout(function () {
	      if (_IndexedDBUtil2.default.DB.db) {
	        var transaction = _IndexedDBUtil2.default.DB.db.transaction(_IndexedDBUtil2.default.DB.name5, 'readwrite');
	        var store = transaction.objectStore(_IndexedDBUtil2.default.DB.name5);
	        //删除两天前的数据
	        var time = new Date().getTime() - 172800000;
	        var request = store.openCursor(IDBKeyRange.upperBound(time, true));
	        var data = [];
	        request.onerror = function () {
	          alert("上传网络错误日志时在获取浏览器数据库数据错误");
	        };
	        request.onsuccess = function (e) {
	          var result = e.target.result;
	          if (result && result !== null) {
	            if (result.value && result.value.id && result.value.data) data.push(result.value.data);
	            result.delete();
	            result.continue();
	          }
	        };
	      }
	    }, 1000);
	    setTimeout(function () {
	      //IndexedDBUtil.openDB(window.userInfos.subSysId,null);
	      if (_IndexedDBUtil2.default.DB.db) {
	        var transaction = _IndexedDBUtil2.default.DB.db.transaction(_IndexedDBUtil2.default.DB.name7, 'readwrite');
	        var store = transaction.objectStore(_IndexedDBUtil2.default.DB.name7);
	        //删除两天前的数据
	        var time = new Date().getTime() - 172800000;
	        var request = store.openCursor(IDBKeyRange.upperBound(time, true));
	        var data = [];
	        request.onerror = function () {
	          alert("上传网络错误日志时在获取浏览器数据库数据错误");
	        };
	        request.onsuccess = function (e) {
	          var result = e.target.result;
	          if (result && result !== null) {
	            if (result.value && result.value.id && result.value.data) data.push(result.value.data);
	            result.delete();
	            result.continue();
	          }
	        };
	      }
	    }, 1000);
	    setTimeout(function () {
	      //IndexedDBUtil.openDB(window.userInfos.subSysId,null);
	      if (_IndexedDBUtil2.default.DB.db) {
	        var transaction = _IndexedDBUtil2.default.DB.db.transaction(_IndexedDBUtil2.default.DB.name6, 'readwrite');
	        var store = transaction.objectStore(_IndexedDBUtil2.default.DB.name6);
	        //删除两天前的数据
	        var time = new Date().getTime() - 172800000;
	        time = time + "000";
	        var request = store.openCursor(IDBKeyRange.upperBound(time, true));
	        var data = [];
	        request.onerror = function () {
	          alert("上传网络错误日志时在获取浏览器数据库数据错误");
	        };
	        request.onsuccess = function (e) {
	          var result = e.target.result;
	          if (result && result !== null) {
	            if (result.value && result.value.id && result.value.data) data.push(result.value.data);
	            result.delete();
	            result.continue();
	          }
	        };
	      }
	    }, 1000);
	  },
	
	  getDataAndDelete: function getDataAndDelete(db, storeName, fag) {
	    var transaction = _IndexedDBUtil2.default.DB.db.transaction(db, storeName, 'readwrite');
	    var store = transaction.objectStore(storeName);
	    //删除两天前的数据
	    var time = new Date().getTime() - 172800000;
	    if (fag) {
	      time = time + "000";
	    }
	    var request = store.openCursor(IDBKeyRange.upperBound(time, true));
	    var data = [];
	    request.onerror = function () {
	      alert("上传网络错误日志时在获取浏览器数据库数据错误");
	    };
	    request.onsuccess = function (e) {
	      var result = e.target.result;
	      if (result && result !== null) {
	        if (result.value && result.value.id && result.value.data) data.push(result.value.data);
	        result.delete();
	        result.continue();
	      }
	    };
	  },
	
	  sendTimingAndMemoryToServer: function sendTimingAndMemoryToServer(timing, memory) {
	    if (timing.length > 0 || memory.length > 0) {
	      var timingFormat = { remoteClass: "java.util.Map", PerformanceTiming: timing, PerformanceMemory: memory };
	      var command = _Command2.default.createService("gongqi.erp.framework.services.ClientLoggingService", "saveLog", "void");
	      command.appendArg(timingFormat, "Object");
	      var remoteArg = {
	        command: command,
	        resultFunction: this.success,
	        faultFunction: this.error,
	        autoLock: false,
	        autoUnlock: false
	      };
	      _ServiceHelper2.default.addTokenWithCommand(remoteArg);
	    }
	  },
	  getCurrentData: function getCurrentData(fmt) {
	    var date = new Date();
	    var o = {
	      "M+": date.getMonth() + 1, // 月份
	      "d+": date.getDate(), // 日
	      "h+": date.getHours(), // 小时
	      "m+": date.getMinutes(), // 分
	      "s+": date.getSeconds(), // 秒
	      "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
	      "S": date.getMilliseconds() // 毫秒
	    };
	    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	    for (var k in o) {
	      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	    }return fmt;
	  },
	  guid2: function guid2() {
	    function S4() {
	      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	    }
	    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
	  },
	
	  // content: 主题内容 如：'10',digit:数据长度：如:3 返回 '010'
	  coder: function coder(content, digit) {
	    var result = "";
	    for (var i = 0; i < digit - content.length; i++) {
	      result = result + "0";
	    }
	    return result + content;
	  },
	  success: function success(data) {
	    window.parent.performanceData = { 'tim': [], 'mem': [] };
	  },
	  error: function error(data) {
	    window.parent.performanceData = { 'tim': [], 'mem': [] };
	  }
	};
	
	var Per = new Performance();
	module.exports = Per;

/***/ },
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ function(module, exports) {

	module.exports = window.$;

/***/ },
/* 357 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 358 */
357,
/* 359 */,
/* 360 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isObject = isObject;
	exports.formatMs = formatMs;
	exports.isImg = isImg;
	exports.isJS = isJS;
	exports.isCss = isCss;
	exports.isVideo = isVideo;
	exports.checkResourceType = checkResourceType;
	function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	}
	
	// 格式化成毫秒
	function formatMs(time) {
	  if (typeof time !== 'number') {
	    console.log('时间必须为数字');
	    return;
	  }
	  // 毫秒转换成秒 返回
	  if (time > 1000) {
	    return (time / 1000).toFixed(2) + 's';
	  }
	  // 默认返回毫秒
	  return Math.round(time) + 'ms';
	}
	
	function isImg(param) {
	  if (/\.(gif|jpg|jpeg|png|webp|svg)/i.test(param)) {
	    return true;
	  }
	  return false;
	}
	
	function isJS(param) {
	  if (/\.(js)/i.test(param)) {
	    return true;
	  }
	  return false;
	}
	
	function isCss(param) {
	  if (/\.(css)/i.test(param)) {
	    return true;
	  }
	  return false;
	}
	
	function isVideo(param) {
	  if (/\.(mp4|rm|rmvb|mkv|avi|flv|ogv|webm)/i.test(name)) {
	    return true;
	  }
	  return false;
	}
	
	function checkResourceType(param) {
	  if (isImg(param)) {
	    return 'image';
	  }
	  if (isJS(param)) {
	    return 'javascript';
	  }
	  if (isCss(param)) {
	    return 'css';
	  }
	  if (isVideo(param)) {
	    return 'video';
	  }
	  return 'other';
	}

/***/ },
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryTableUtil = function () {
	    function QueryTableUtil() {
	        _classCallCheck(this, QueryTableUtil);
	
	        this.doMainTables = [];
	    }
	
	    _createClass(QueryTableUtil, [{
	        key: "getQueryTableParams",
	        value: function getQueryTableParams(queryTable) {
	            var ob = {
	                "doMain": queryTable.doMain,
	                "tableName": this.getDBTableFiledName(queryTable.tableName),
	                "isDirect": queryTable.isDirect
	            };
	            this.doMainTables.push(ob);
	            var queryJoins = queryTable.queryJoins;
	            for (var i in queryJoins) {
	                this.getQueryTableParams(queryJoins[i]);
	            }
	        }
	    }, {
	        key: "getDBTableFiledName",
	        value: function getDBTableFiledName(entityName) {
	            if (entityName.lastIndexOf(".") != -1) {
	                var solutionName = entityName.substr(0, entityName.lastIndexOf("."));
	                var simpleEntityName = entityName.substr(entityName.lastIndexOf(".") + 1);
	                solutionName = solutionName.replace(/[\.]/g, "_");
	                return solutionName + "$" + simpleEntityName;
	            } else {
	                return entityName;
	            }
	        }
	    }, {
	        key: "getDoMainByTableId",
	        value: function getDoMainByTableId(entity, queryTable) {
	            if (entity == queryTable.tableId) {
	                return queryTable.doMain;
	            } else {
	                var queryJoins = queryTable.queryJoins;
	                for (var i in queryJoins) {
	                    this.getDoMainByTableId(entity, queryJoins[i]);
	                }
	            }
	        }
	    }, {
	        key: "getDoMainByTableId2",
	        value: function getDoMainByTableId2(entity, queryTable) {
	            if (entity == queryTable.Properties.Table.refentityid) {
	                return queryTable.Properties.DoMain.V;
	            } else {
	                var queryJoins = queryTable.queryJoins;
	                for (var i in queryJoins) {
	                    this.getDoMainByTableId(entity, queryJoins[i]);
	                }
	            }
	        }
	    }]);
	
	    return QueryTableUtil;
	}();
	
	exports.default = QueryTableUtil;

/***/ },
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HookUtil = function () {
	  function HookUtil() {
	    _classCallCheck(this, HookUtil);
	  }
	
	  _createClass(HookUtil, null, [{
	    key: "hookAJAX",
	    value: function hookAJAX() {
	      XMLHttpRequest.prototype.nativeOpen = XMLHttpRequest.prototype.open;
	      var customizeOpen = function customizeOpen(method, url, async, user, password) {
	        // do something
	        if (url) {
	          if (url.indexOf("?") != -1) {
	            url += "&token=" + localStorage.getItem("userToken");
	          } else {
	            url += "?token=" + localStorage.getItem("userToken");
	          }
	        }
	        this.nativeOpen(method, url, async, user, password);
	        //this.setRequestHeader("token",localStorage.getItem("userToken"));
	      };
	
	      XMLHttpRequest.prototype.open = customizeOpen;
	    }
	
	    /**
	     *全局拦截Image的图片请求添加token
	     *
	     */
	
	  }, {
	    key: "hookImg",
	    value: function hookImg() {
	      var property = Object.getOwnPropertyDescriptor(Image.prototype, 'src');
	      var nativeSet = property.set;
	
	      function customiseSrcSet(url) {
	        if (url) {
	          if (url.indexOf("?") != -1) {
	            url += "&token=" + localStorage.getItem("userToken");
	          } else {
	            url += "?token=" + localStorage.getItem("userToken");
	          }
	        }
	
	        nativeSet.call(this, url);
	      }
	      Object.defineProperty(Image.prototype, 'src', {
	        set: customiseSrcSet
	      });
	    }
	
	    /**
	     * 拦截全局open的url添加token
	     *
	     */
	
	  }, {
	    key: "hookOpen",
	    value: function hookOpen() {
	      var nativeOpen = window.open;
	      window.open = function (url) {
	        var _name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        // do something
	        if (url) {
	          if (url.indexOf("?") != -1) {
	            url += "&token=" + localStorage.getItem("userToken");
	          } else {
	            url += "?token=" + localStorage.getItem("userToken");
	          }
	        }
	        nativeOpen.call(this, url, _name);
	      };
	    }
	  }, {
	    key: "hookFetch",
	    value: function hookFetch() {
	      var fet = Object.getOwnPropertyDescriptor(window, 'fetch');
	      Object.defineProperty(window, 'fetch', {
	        value: function value(a, b, c) {
	          // do something
	          return fet.value.apply(this, args);
	        }
	      });
	    }
	  }]);
	
	  return HookUtil;
	}();
	
	exports.default = HookUtil;

/***/ },
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(629);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./TreeViewMainMenuStyle.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./TreeViewMainMenuStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 510 */,
/* 511 */,
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReInitAPPComponent = function (_React$Component) {
		_inherits(ReInitAPPComponent, _React$Component);
	
		function ReInitAPPComponent(props, context) {
			_classCallCheck(this, ReInitAPPComponent);
	
			//判断是否是管理员
			var _this = _possibleConstructorReturn(this, (ReInitAPPComponent.__proto__ || Object.getPrototypeOf(ReInitAPPComponent)).call(this, props, context));
	
			_this.hideReInitAPP = function () {
				var $reactComponentContainer = $("#globalUserSetFormDiv");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				$("#globalUserSetFormDiv").empty().css("display", "none");
			};
	
			_this.changeautoEnterList = function () {
				var tag = $("#autoEnterListCheckBox").prop("checked");
				window.userSettingEntry.autoEnterList = tag;
				_this.userSettingEntry.autoEnterList = tag;
			};
	
			_this.btnsave_clickHandler = function () {
	
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.GOTService", "reInitSolution", "void");
				var selectedApp = $(_this.radioContainer).find("input[type='radio']:checked").attr("data-serverId");
				command.appendArg(selectedApp);
	
				var remoteArg = {
					command: command,
					resultFunction: _this.saveResultHandler,
					sync: false
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.saveResultHandler = function () {
	
				_this.hideReInitAPP();
				window.location.reload();
			};
	
			_this.userInfos = window.userInfos;
	
			if (_this.userInfos.userGroups.indexOf("admin") != -1 || _this.userInfos.userGroups.indexOf("Admin") != -1) {
				_this.isAdmin = true;
			} else {
				_this.isAdmin = false;
			}
			_this.state = {
				appList: _this.props.appList
			};
			return _this;
		}
	
		_createClass(ReInitAPPComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				return;
				$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
					radioClass: 'iradio_minimal-blue' });
			}
	
			//关闭
	
		}, {
			key: 'getAppList',
			value: function getAppList() {
				var list = [];
				for (var i = 0; i < this.state.appList.length; i++) {
					var label = this.state.appList[i];
	
					list.push(_react2.default.createElement(
						'label',
						{ style: { fontWeight: '200', margin: '0px', marginBottom: "5px", display: "flex", minHeight: '20px' }, key: i },
						_react2.default.createElement('input', { style: { marginRight: '5px' }, type: 'radio', name: 'appSolutionsRadio', className: 'minimal', 'data-serverId': label }),
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '14px' } },
							label
						)
					));
					/*<div draggable="true" style={{paddingLeft:'15px'}}>
	        <label><input style={{marginRight:'10px'}} type="radio" id="isShowBusyRemoteCheckBox" name="" value="on" />{label}&emsp;</label>
	    </div>*/
				}
				if (list.length == 0) {
	
					list.push(_react2.default.createElement(
						'label',
						{ style: { fontWeight: '200', margin: '0px', marginBottom: "5px", display: "flex", minHeight: '20px', justifyContent: 'center' } },
						_react2.default.createElement(
							'div',
							{ style: { fontSize: '16px' } },
							'\u5F53\u524D\u73AF\u5883\u6682\u65E0\u5E94\u7528'
						)
					));
				}
				return list;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var btnSty = { display: 'flex', flexDirection: 'horizontal', flexGrow: 0, paddingTop: '10px', paddingBottom: '10px' };
				if (this.state.appList && this.state.appList.length == 0) {
					btnSty.display = 'none';
				}
				return _react2.default.createElement(
					'div',
					{ style: { alignSelf: "center", borderRadius: "2px", backgroundColor: 'white', minWidth: '200px', display: 'flex', flexDirection: 'column', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' } },
					_react2.default.createElement(
						'div',
						{ className: 'modal-header', style: _defineProperty({ background: "#ffffff", padding: "10px", position: "relative", paddingTop: "15px", paddingBottom: "15px" }, 'background', "#F8F8F8") },
						_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideReInitAPP.bind(this) }),
						_react2.default.createElement(
							'h5',
							{ className: 'modal-title' },
							'\u9009\u62E9\u5E94\u7528'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: function ref(node) {
								return _this2.radioContainer = node;
							}, style: { display: 'flex', flexDirection: 'column', flexGrow: 100, padding: '5px', maxHeight: '700px', overflowY: 'auto' } },
						this.getAppList(),
						_react2.default.createElement(
							'div',
							{ style: btnSty },
							_react2.default.createElement('div', { style: { flexGrow: 100 } }),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.btnsave_clickHandler },
								'\u521D\u59CB\u5316\u9009\u4E2D\u5E94\u7528'
							)
						)
					)
				);
			}
		}]);
	
		return ReInitAPPComponent;
	}(_react2.default.Component);
	
	exports.default = ReInitAPPComponent;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(771);
	
	var PrintReportDialog = function (_React$Component) {
	  _inherits(PrintReportDialog, _React$Component);
	
	  function PrintReportDialog(props) {
	    _classCallCheck(this, PrintReportDialog);
	
	    var _this = _possibleConstructorReturn(this, (PrintReportDialog.__proto__ || Object.getPrototypeOf(PrintReportDialog)).call(this, props));
	
	    _this.parent = props.parent;
	    _this.state = { sources: [props.reportList], printTaskId: props.printTaskId };
	    return _this;
	  }
	
	  _createClass(PrintReportDialog, [{
	    key: 'getFieldsList',
	    value: function getFieldsList(sources) {
	      var optionList = [];
	      for (var key in sources) {
	        var source = sources[key];
	        for (var k in source) {
	          optionList.push(_react2.default.createElement(
	            'div',
	            { className: 'panel panel-default dataSourceFieldListItem', title: source[k]['name'], 'data-sourceid': source[k]['id'], onClick: this.itemClick.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel-heading', role: 'tab', title: source[k]['name'], 'data-sourceid': source[k]['id'] },
	              _react2.default.createElement(
	                'h4',
	                { className: 'panel-title', title: source[k]['name'], 'data-sourceid': source[k]['id'] },
	                _react2.default.createElement(
	                  'a',
	                  { role: 'button', 'data-toggle': 'collapse', 'data-parent': '#accordion',
	                    href: '#', 'aria-expanded': 'true', 'aria-controls': 'collapseOne', title: source[k]['name'], 'data-sourceid': source[k]['id'] },
	                  source[k]['name']
	                )
	              )
	            )
	          ));
	        }
	      }
	      return optionList;
	    }
	  }, {
	    key: 'itemClick',
	    value: function itemClick(e) {
	      var id = $(e.target).attr("data-sourceid");
	      window.printReportTaskId = this.state.printTaskId;
	      window.printReportId = id;
	      var task = { taskId: this.state.printTaskId, reportId: id };
	      this.closeAttachmentHandler();
	      window.doPrintReport(task, null);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $("#printReportDialogModel .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref,
	          _this2 = this;
	
	      var optionList = this.getFieldsList(this.state.sources);
	      var _outerStyle = { width: '100%', flexShrink: '0', display: 'flex', flexDirection: 'column', alignSelf: 'stretch', overflow: 'hidden', backgroundColor: 'white' };
	      var _style = { flexGrow: 100, flexShrink: '0', display: 'flex', flexDirection: 'column',
	        alignSelf: 'stretch', overflowY: 'auto', overflowX: 'hidden', textOverflow: 'ellipsis' };
	      if (this.state.height) _style.height = $(this.sourcesContainer).height() + "px";
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal ', style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	        _react2.default.createElement(
	          'div',
	          { className: ' ui-draggable', style: (_ref = { alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff" }, _defineProperty(_ref, 'background', '#FFFFFF'), _defineProperty(_ref, 'border', '1px solid #9B9B9B'), _defineProperty(_ref, 'boxShadow', '0 0 41px 5px rgba(0,0,0,0.25)'), _defineProperty(_ref, 'borderRadius', '2px'), _defineProperty(_ref, 'width', '300px'), _defineProperty(_ref, 'height', '305px'), _ref) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header', style: { position: "relative" } },
	            _react2.default.createElement('div', { className: 'modal-close', onClick: this.closeAttachmentHandler.bind(this) }),
	            _react2.default.createElement(
	              'h5',
	              { className: 'modal-title' },
	              '\u6837\u5F0F\u5217\u8868'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { height: '100%' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', flexDirection: 'row', flexGrow: 100, height: '270px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'container', style: { overflow: 'auto' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row', style: { marginRight: '-10px', marginLeft: '-10px' } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'panel-group', id: 'accordion', style: { paddingTop: '3px' }, role: 'tablist', 'aria-multiselectable': 'true', ref: function ref(node) {
	                          return _this2.sourcesContainer = node;
	                        } },
	                      optionList
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'closeAttachmentHandler',
	    value: function closeAttachmentHandler() {
	      //关掉要卸载
	      var $reactComponentContainer = $("#printReportDialogModel .modal");
	      _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	      $reactComponentContainer.remove();
	    }
	  }]);
	
	  return PrintReportDialog;
	}(_react2.default.Component);
	
	PrintReportDialog.defaultProps = {};
	
	exports.default = PrintReportDialog;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DoMainAppInfo = function (_React$Component) {
	  _inherits(DoMainAppInfo, _React$Component);
	
	  function DoMainAppInfo(props) {
	    _classCallCheck(this, DoMainAppInfo);
	
	    var _this = _possibleConstructorReturn(this, (DoMainAppInfo.__proto__ || Object.getPrototypeOf(DoMainAppInfo)).call(this, props));
	
	    _this.parent = props.parent;
	    _this.param = props.param;
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DoMainAppInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $("#doMainAppInfoModel .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var version = this.param.version;
	      var clientVersion = this.param.clientVersion;
	      var frameworkVersion = this.param.frameworkVersion;
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal ', style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
	        _react2.default.createElement(
	          'div',
	          { className: ' ui-draggable', style: { alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff", border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px', width: '380px', height: '260px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header', style: { position: "relative", background: 'white', border: 'none' } },
	            _react2.default.createElement('div', { className: 'modal-close', onClick: this.closeAttachmentHandler.bind(this) }),
	            _react2.default.createElement(
	              'h5',
	              { className: 'modal-title', style: { display: 'none' } },
	              ' \u4FE1\u606F'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { height: '100%' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', flexDirection: 'row', flexGrow: 100, height: '100%', width: '100%' } },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'auto', width: '100%' } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { height: '80px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "10px" } },
	                  _react2.default.createElement('img', { style: { height: '80px' }, src: './html/Example/images/info2.png' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { height: '20px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "10px", color: 'rgba(51, 51, 51, 1)', fontWeight: '800' } },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u7248\u672C\u4FE1\u606F'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { height: '30px', width: '90%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid rgba(198, 198, 198, 1)', marginLeft: '5%', marginBottom: '5px', fontWeight: '400', color: 'rgba(51, 51, 51, 1)' } },
	                  '\u7248\u672C\uFF1A',
	                  version
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { height: '30px', width: '90%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid rgba(198, 198, 198, 1)', marginLeft: '5%', marginBottom: '5px', fontWeight: '400', color: 'white', background: 'rgba(58, 118, 225, 0.8)' } },
	                  '\u6570\u5B57\u57DF\u5BA2\u6237\u7AEF\u7248\u672C\uFF1A',
	                  clientVersion
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { height: '30px', width: '90%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid rgba(198, 198, 198, 1)', marginLeft: '5%', marginBottom: '5px', fontWeight: '400', color: 'rgba(51, 51, 51, 1)' } },
	                  '\u6570\u5B57\u57DF\u670D\u52A1\u7AEF\u7248\u672C\uFF1A',
	                  frameworkVersion
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'closeAttachmentHandler',
	    value: function closeAttachmentHandler() {
	      //关掉要卸载
	      var $reactComponentContainer = $("#doMainAppInfoModel .modal");
	      _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	      $reactComponentContainer.remove();
	    }
	  }]);
	
	  return DoMainAppInfo;
	}(_react2.default.Component);
	
	DoMainAppInfo.defaultProps = {};
	
	exports.default = DoMainAppInfo;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(772);
	
	var ListMainMenu = function (_React$Component) {
		_inherits(ListMainMenu, _React$Component);
	
		function ListMainMenu(props) {
			_classCallCheck(this, ListMainMenu);
	
			var _this = _possibleConstructorReturn(this, (ListMainMenu.__proto__ || Object.getPrototypeOf(ListMainMenu)).call(this, props));
	
			_this.renderMainMenu = _this.renderMainMenu.bind(_this);
			_this.renderSubMenu = _this.renderSubMenu.bind(_this);
			_this.menuItemClick = _this.menuItemClick.bind(_this);
			_this.platMainMenu = {};
			return _this;
		}
	
		_createClass(ListMainMenu, [{
			key: 'menuItemClick',
			value: function menuItemClick(event) {
				var target = event.target;
				var _label = $(target).attr("data-formLabel");
				var _formId = $(target).attr("data-formId");
				var _menuItemId = $(target).attr("data-menuItemId");
				var _onlyQuery = $(target).attr("data-onlyQuery");
				_FormLoadHelper2.default.openMenuItem({ menuItemId: _menuItemId, onlyQuery: _onlyQuery, label: _label, checkHas: false, fromMainMenu: true });
				//window.testOpenForm(_label,_formId,_menuItemId,_onlyQuery);
			}
		}, {
			key: 'getLabelName',
			value: function getLabelName(item) {
				var label = _GOTUtil2.default.getPropertyValue(item, "Label");
				if (label == "" | !label) {
					label = item.name;
				}
				return label;
			}
		}, {
			key: 'renderMainMenu',
			value: function renderMainMenu(menuData, moudleId) {
				var content = [];
				if (menuData) {
					for (var i = 0; i < menuData.length; i++) {
						var item = menuData[i];
	
						var isShow = false;
						var visible = item.Properties.Visible.V;
						if (visible != 'false') {
							if (window.userInfos.isAdmin) {
								isShow = true;
							} else {
								moudleId = item.id;
								var authorityArr = window.xmlType0SCache[moudleId];
								if (authorityArr != undefined) {
									if (authorityArr.del) {
										isShow = true;
									}
								}
							}
						}
	
						if (isShow) {
							var label = this.getLabelName(item);
							var _subMenu = this.renderSubMenu(item.items, moudleId);
							content.push(_react2.default.createElement(
								'li',
								{ className: 'dropdown', key: 'dropdown-li' + i },
								_react2.default.createElement(
									'a',
									{ className: 'dropdown-joily-title', key: 'dropdown-a' + i },
									label
								),
								_react2.default.createElement(
									'ul',
									{ className: 'dropdown-content', key: 'dropdown-ul' + i },
									_subMenu
								)
							));
						}
					}
					return content;
				}
			}
		}, {
			key: 'renderSubMenu',
			value: function renderSubMenu(subMenu, moudleId) {
				var content = [];
				if (subMenu) {
					for (var i = 0; i < subMenu.length; i++) {
						var item = subMenu[i];
						if (item.qname == "MenuSub") {
							var isShow = false;
							var visible = item.Properties.Visible.V;
							if (visible != 'false') {
								if (window.userInfos.isAdmin) {
									isShow = true;
								} else {
									var thisAu = moudleId + '.' + item.id;
									var authorityArr = window.xmlType1SCache[thisAu];
									if (authorityArr != undefined) {
										if (!authorityArr.del && !authorityArr.query && !authorityArr.visible) {
											isShow = false;
										} else {
											isShow = true;
										}
									}
								}
							}
	
							if (isShow) {
								var label = this.getLabelName(item);
								var _subMenu = this.renderSubMenu(item.items, moudleId);
								var _caretRightDisplay = "block";
								if (!_subMenu || _subMenu.length == 0) _caretRightDisplay = "none";
								content.push(_react2.default.createElement(
									'li',
									{ className: 'dropdown-joily', key: 'joily' + i },
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-joily-title', href: '#' },
										label
									),
									_react2.default.createElement('i', { className: 'fa fa-caret-right' }),
									_react2.default.createElement(
										'ul',
										{ className: 'dropdown-content-joily', key: 'joily-ul' + i },
										_subMenu
									)
								));
							}
						} else if (item.qname == 'MenuItem') {
	
							var isShow = false;
							var onlyQuery = false;
							var visible = item.Properties.Visible.V;
							if (visible != 'false') {
								if (window.userInfos.isAdmin) {
									isShow = true;
									//onlyQuery=true;
								} else {
									var thisAu = moudleId + '.' + item.idInMenu;
									var authorityArr = window.xmlType1SCache[thisAu];
									if (authorityArr) {
										/*if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	         	isShow=false;
	         	onlyQuery=false;//看不见打不开
	         }else if(!authorityArr.del&&!authorityArr.query&&authorityArr.visible){
	         	isShow=true;
	         	onlyQuery=false;//看见打不开
	         }else if((!authorityArr.del&&authorityArr.query&&authorityArr.visible)||(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible)){
	         	isShow=true;
	         	onlyQuery=true;//看见打开 
	         }else{
	         	isShow=true;
	         	onlyQuery=false;//看见打开
	         }*/
										if (!authorityArr.del && !authorityArr.visible && !authorityArr.query) {
											onlyQuery = true;
										} else if (!authorityArr.del && authorityArr.query) {
											isShow = true;onlyQuery = true;
										} else if (authorityArr.del || authorityArr.query) {
											isShow = true;
										}
									}
								}
							}
	
							var label = this.getLabelName(item);
							if (isShow) {
								var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
								content.push(_react2.default.createElement(
									'a',
									{ href: '#', key: i, onClick: this.menuItemClick, 'data-formId': dataFormId,
										'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': onlyQuery },
									label
								));
	
								var menuItemKey = item.id + "." + item.idInMenu;
								item.onlyQuery = onlyQuery;
								this.platMainMenu[menuItemKey] = item;
							}
						}
					}
				}
				return content;
			}
		}, {
			key: 'mouseenterHandler',
			value: function mouseenterHandler(event) {
				var jq = $(event.currentTarget);
	
				/*if (this.lostTimer) clearTimeout(this.lostTimer);
	   		$(".listtree-menu li").removeClass("listtree-menu-hover");
	   		jq.parent().addClass("listtree-menu-hover");*/
	
				//top
	
				var ul = jq.parent().find(">ul");
				if (!ul || ul.length == 0) return;
	
				//ul.css("top", "-40px");
	
				var viewHeight = $(window).height() - 1;
				var offset = ul.offset(),
				    height = ul.outerHeight();
	
				var top = offset.top;
	
				if (top + height > viewHeight) {
					if (height > viewHeight) {
						ul.css("top", 0 - top + 'px');
						ul.css("height", viewHeight - 10 + 'px');
						ul.mCustomScrollbar({ autoHideScrollbar: true });
					} else {
						top = viewHeight - (height + top);
						ul.css("top", top + 'px');
					}
				}
			}
	
			/*mouseleaveHandler(event)
	  {
	  	var jq = $(event.currentTarget);
	  
	  	this.lostTimer = setTimeout(function () {
	  		jq.parent().removeClass("listtree-menu-hover");
	  	}, 200);
	  }*/
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(document.body).on("mouseenter", ".dropdown-joily-title", this.mouseenterHandler.bind(this));
				//$(document.body).on("mouseleave", ".dropdown-joily-title", this.mouseleaveHandler.bind(this));
			}
		}, {
			key: 'renderCustomMenu',
			value: function renderCustomMenu(mainContent) {
				if (!window.userSettingEntryOrig.menuCustomObject) return;
				var i = mainContent.length;
				if (i == 0) return;
				var _menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
				var num = 0;
				for (var key in _menuCustomObject.customItems) {
					num++;
				}
				if (num == 0) return;
				mainContent.push(_react2.default.createElement(
					'li',
					{ className: 'dropdown', key: 'dropdown-li' + i },
					_react2.default.createElement(
						'a',
						{ className: 'dropdown-joily-title', key: 'dropdown-a' + i },
						'\u5E38\u7528\u83DC\u5355'
					),
					_react2.default.createElement(
						'ul',
						{ className: 'dropdown-content', key: 'dropdown-ul' + i },
						this.renderCustomMenuSub()
					)
				));
			}
		}, {
			key: 'renderCustomMenuSubSub',
			value: function renderCustomMenuSubSub(groupKey, groupItem) {
				var content = [];var i = 0;
				if (!groupKey) return content;
				for (var key in window.userSettingEntryOrig.menuCustomObject.customItems) {
					var customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
					if (customItem.groupId != groupKey) continue;
					if (this.platMainMenu.hasOwnProperty(key)) {
						var item = this.platMainMenu[key];
						var label = this.getLabelName(item);
						var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
						content.push(_react2.default.createElement(
							'a',
							{ href: '#', key: i, onClick: this.menuItemClick, 'data-formId': dataFormId,
								'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': item.onlyQuery },
							label
						));
						i++;
					}
				}
				return content;
			}
		}, {
			key: 'renderCustomMenuSub',
			value: function renderCustomMenuSub() {
				var content = [];var i = 0;
				for (var groupKey in window.userSettingEntryOrig.menuCustomObject.groups) {
					var groupItem = window.userSettingEntryOrig.menuCustomObject.groups[groupKey];
					var label = groupItem.name;
					var _subMenu = this.renderCustomMenuSubSub(groupKey, groupItem);
					var stylClass = "drpdown-blockStyle";
					if (!_subMenu || _subMenu.length == 0) stylClass = "drpdown-noneStyle";
					content.push(_react2.default.createElement(
						'li',
						{ className: 'dropdown-joily', key: 'joily' + i },
						_react2.default.createElement(
							'a',
							{ className: 'dropdown-joily-title', href: '#' },
							label
						),
						_react2.default.createElement('i', { className: "fa fa-caret-right " + stylClass }),
						_react2.default.createElement(
							'ul',
							{ className: 'dropdown-content-joily', key: 'joily-ul' + i },
							_subMenu
						)
					));
					i++;
				}
	
				for (var key in window.userSettingEntryOrig.menuCustomObject.customItems) {
					var customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
					if (customItem.groupId) continue;
					if (this.platMainMenu.hasOwnProperty(key)) {
						var item = this.platMainMenu[key];
						var label = this.getLabelName(item);
						var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
						content.push(_react2.default.createElement(
							'a',
							{ href: '#', key: i, onClick: this.menuItemClick, 'data-formId': dataFormId,
								'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': item.onlyQuery },
							label
						));
						i++;
					}
				}
				return content;
			}
		}, {
			key: 'rederUserDataSettings',
			value: function rederUserDataSettings(mainContent) {
				if (window.rightSidebarClicked) return;
				var i = mainContent.length;
				if (i == 0) return;
	
				mainContent.push(_react2.default.createElement(
					'li',
					{ className: 'dropdown', key: 'dropdown-li' + i },
					_react2.default.createElement(
						'a',
						{ className: 'dropdown-joily-title', key: 'dropdown-a' + i },
						'\u53EF\u7528\u5BFC\u51FA'
					),
					_react2.default.createElement(
						'ul',
						{ className: 'dropdown-content', key: 'dropdown-ul' + i },
						this.renderUserDataSettingsSub()
					)
				));
			}
		}, {
			key: 'renderUserDataSettingsSub',
			value: function renderUserDataSettingsSub() {
				var content = [];var i = 0;
	
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserDataSetSetting", "String");
				var _resultHandler = function _resultHandler(data) {
	
					var dataSettings = data.result;
					if (!dataSettings) {
						return;
					}
					dataSettings = JSON.parse(dataSettings);
	
					/**
	     * <li>
	    	  <a href="javascript:void(0)" style="padding-top: 0px;">
	    		<h6 class="control-sidebar-heading" style="font-size:14px;cursor:pointer;margin-top: 0px;">9点前打卡次数</h6>
	    	  </a>
	       </li>
	    */
					window.userDataSettings = dataSettings;
					for (var _i = 0; _i < dataSettings.length; _i++) {
						var ds = dataSettings[_i];
	
						content.push(_react2.default.createElement(
							'a',
							{ href: '#', key: _i, onClick: window.dataSettingClick, dataSetId: ds.dataSetId,
								menuLabel: ds.menuLabel, dataSetUniqueId: ds.recId },
							ds.menuLabel
						));
					}
					window.rightSidebarClicked = true;
				};
				var remoteArg = {
					command: command, resultFunction: _resultHandler,
					faultFunction: function faultFunction() {},
					sync: false
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
				return content;
			}
		}, {
			key: 'render',
			value: function render() {
				var menuData = this.props.data.items;
				var moudleId;
				var MainMenu = this.renderMainMenu(menuData, moudleId);
				this.renderCustomMenu(MainMenu);
				//this.rederUserDataSettings(MainMenu);
				return _react2.default.createElement(
					'ul',
					null,
					MainMenu
				);
			}
		}]);
	
		return ListMainMenu;
	}(_react2.default.Component);
	
	exports.default = ListMainMenu;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(509);
	
	var TreeViewMainMenu = function (_React$Component) {
		_inherits(TreeViewMainMenu, _React$Component);
	
		function TreeViewMainMenu(props) {
			_classCallCheck(this, TreeViewMainMenu);
	
			var _this = _possibleConstructorReturn(this, (TreeViewMainMenu.__proto__ || Object.getPrototypeOf(TreeViewMainMenu)).call(this, props));
	
			_this.renderSub = _this.renderSub.bind(_this);
			_this.menuItemClick = _this.menuItemClick.bind(_this);
			_this.getLabelName = _this.getLabelName.bind(_this);
			_this.platMainMenu = {};
			return _this;
		}
	
		_createClass(TreeViewMainMenu, [{
			key: 'menuItemClick',
			value: function menuItemClick(event) {
				this.doOpenMenuItem(event);
				//window.testOpenForm(_label,_formId,_menuItemId,_onlyQuery);
			}
		}, {
			key: 'doOpenMenuItem',
			value: function doOpenMenuItem(event) {
				var target = event.target;
	
				if (!$(target).hasClass("listtree-menu-title")) {
					target = $(target).parent();
				}
	
				if (!$(target).hasClass("listtree-menu-title")) {
					target = $(target).parent();
				}
	
				if (!$(target).hasClass("listtree-menu-title")) {
					return;
				}
	
				var _label = $(target).attr("data-formLabel");
				var _formId = $(target).attr("data-formId");
				var _menuItemId = $(target).attr("data-menuItemId");
				var _onlyQuery = $(target).attr("data-onlyQuery") == "true" ? true : false;
				_FormLoadHelper2.default.openMenuItem({ menuItemId: _menuItemId, onlyQuery: _onlyQuery, label: _label, checkHas: false, fromMainMenu: true });
			}
		}, {
			key: 'menuItemClickSelect',
			value: function menuItemClickSelect(event) {
				var target = event.target;
				$("#mainMenu a.selected").removeClass("selected");
				$(target).addClass("selected");
			}
		}, {
			key: 'getLabelName',
			value: function getLabelName(item) {
				var label = _GOTUtil2.default.getPropertyValue(item, "Label");
				if (label == "" | !label) {
					label = item.name;
				}
				return label;
			}
		}, {
			key: 'autoScrollbar',
			value: function autoScrollbar() {
				var jq = $(".mCSB_container");
				if (jq.parent().height() >= jq.children().outerHeight()) {
					jq.css("height", "100%");
				} else {
					jq.css("height", "auto");
				}
			}
		}, {
			key: 'mouseenterHandler',
			value: function mouseenterHandler(event) {
				var jq = $(event.currentTarget);
	
				if (this.lostTimer) clearTimeout(this.lostTimer);
	
				$(".listtree-menu li").removeClass("listtree-menu-hover");
	
				jq.parent().addClass("listtree-menu-hover");
	
				//alert(1);
	
				//////////////////////////////////////////////////////////
	
				//top
				var ul = jq.next('ul');
				if (!ul[0]) return;
	
				ul.css("top", "");
	
				var viewHeight = $(window).height() - 1;
				var offset = ul.offset(),
				    height = ul.outerHeight();
	
				var top = offset.top;
	
				if (top + height > viewHeight) {
					top = viewHeight - height;
					ul.offset({ left: 0, top: top });
					ul.css("left", "");
				}
			}
		}, {
			key: 'mouseleaveHandler',
			value: function mouseleaveHandler(event) {
				var jq = $(event.currentTarget);
	
				this.lostTimer = setTimeout(function () {
					jq.parent().removeClass("listtree-menu-hover");
				}, 200);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(".listtree-sidebar").mCustomScrollbar({ autoHideScrollbar: false });
	
				$(window).on("resize", this.autoScrollbar.bind(this));
				this.autoScrollbar();
	
				var el = $("#listtree-mainMenu");
	
				var lostTimer;
				$(document.body).on("mouseenter", ".listtree-menu-title", this.mouseenterHandler.bind(this));
	
				$(document.body).on("mouseleave", ".listtree-menu-title", this.mouseleaveHandler.bind(this));
			}
		}, {
			key: 'renderSub',
			value: function renderSub(items, moudleId) {
				var content = [];
	
				if (items) {
					for (var i = 0; i < items.length; i++) {
						var item = items[i];
	
						if (item.qname) {
							if (item.qname == "MenuItem") {
								if (!window.flatMainMenuToMenuItem.hasOwnProperty(item.id)) {
									window.flatMainMenuToMenuItem[item.id] = {};
								}
								var _menuKey = moudleId + '.' + item.idInMenu;
								window.flatMainMenuToMenuItem[item.id][_menuKey] = true;
								var isShow = false;
								var onlyQuery = false;
								var visible = item.Properties.Visible.V;
								if (visible != 'false') {
									if (window.userInfos.isAdmin) {
										isShow = true;
									} else {
										var thisAu = moudleId + '.' + item.idInMenu;
										var authorityArr = window.xmlType1SCache[thisAu];
										if (authorityArr) {
	
											if (!authorityArr.del && !authorityArr.visible && !authorityArr.query) {
												onlyQuery = true;
											} else if (!authorityArr.del && authorityArr.query) {
												isShow = true;onlyQuery = true;
											} else if (authorityArr.del || authorityArr.query) {
												isShow = true;
											}
										}
									}
								}
	
								if (isShow) {
									var label = this.getLabelName(item);
									var _iclsName = "iconfont icon-liebiao";
									var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
									if (iconPro) {
										_iclsName = iconPro;
									}
									var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
									content.push(_react2.default.createElement(
										'li',
										{ key: 'menuItem-li' + i, 'data-formLabel': item.Properties.Label.V },
										_react2.default.createElement(
											'a',
											{ className: 'listtree-menu-title', onClick: this.menuItemClick, title: label, 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': onlyQuery },
											_react2.default.createElement(
												'div',
												{ className: 'listtree-menu-title-div' },
												_react2.default.createElement('div', { className: "listtree-menu-icon " + _iclsName }),
												_react2.default.createElement(
													'span',
													{ 'class': 'listtree-menu-text' },
													label
												)
											)
										)
									));
									var menuItemKey = item.id + "." + item.idInMenu;
									item.onlyQuery = onlyQuery;
									this.platMainMenu[menuItemKey] = item;
								}
							} else if (item.qname == "MenuSub") {
	
								var isShow = false;
								var visible = item.Properties.Visible.V;
								if (visible == 'true') {
									if (window.userInfos.isAdmin) {
										isShow = true;
									} else {
										var thisAu = moudleId + '.' + item.id;
										var authorityArr = window.xmlType1SCache[thisAu];
										if (authorityArr) {
											if (!authorityArr.del && !authorityArr.query && !authorityArr.visible) {
												isShow = false;
											} else {
												isShow = true;
											}
										}
									}
								}
	
								if (isShow) {
									var label = this.getLabelName(item);
									var _clsName = "iconfont icon-liebiao";
									var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
									//|| GOTUtil.getPropertyValue(item,"HasIcon")
									if (iconPro) {
										_clsName = iconPro;
										content.push(_react2.default.createElement(
											'li',
											{ className: 'listtree-has-children', key: 'listtree' + i },
											_react2.default.createElement(
												'a',
												{ className: 'listtree-menu-title' },
												_react2.default.createElement(
													'div',
													{ className: 'listtree-menu-title-div' },
													_react2.default.createElement('div', { className: "listtree-menu-icon " + _clsName }),
													_react2.default.createElement(
														'span',
														{ className: 'listtree-menu-text' },
														label
													),
													_react2.default.createElement('span', { className: 'listtree-menu-arrow fa' })
												)
											),
											_react2.default.createElement(
												'ul',
												{ className: 'listtree-menu-submenu' },
												this.renderSub(item.items, moudleId)
											)
										));
									} else {
										content.push(_react2.default.createElement(
											'li',
											{ className: 'listtree-has-children', key: 'listtree' + i },
											_react2.default.createElement(
												'a',
												{ className: 'listtree-menu-title' },
												_react2.default.createElement('i', { className: "listtree-menu-icon " + _clsName }),
												_react2.default.createElement(
													'span',
													{ className: 'listtree-menu-text' },
													label
												),
												_react2.default.createElement('span', { className: 'listtree-menu-arrow fa' })
											),
											_react2.default.createElement(
												'ul',
												{ className: 'listtree-menu-submenu' },
												this.renderSub(item.items, moudleId)
											)
										));
									}
								}
							}
						} else {
							var isShow = false;
							var visible = item.Properties.Visible.V;
							if (visible == 'true') {
								if (window.userInfos.isAdmin) {
									isShow = true;
								} else {
									moudleId = item.id;
									var authorityArr = window.xmlType0SCache[moudleId];
									if (authorityArr) {
										if (authorityArr.del) {
											isShow = true;
										} else {
											isShow = false;
										}
									}
								}
							}
	
							if (isShow) {
								var label = this.getLabelName(item);
								var _clsName = "iconfont icon-liebiao";
								var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon");
								if (iconPro) _clsName = iconPro;
								content.push(_react2.default.createElement(
									'li',
									{ className: 'listtree-has-children', key: 'listtree' + i },
									_react2.default.createElement(
										'a',
										{ className: 'listtree-menu-title' },
										_react2.default.createElement('i', { className: "listtree-menu-icon " + _clsName }),
										_react2.default.createElement(
											'span',
											{ className: 'listtree-menu-text' },
											label
										),
										_react2.default.createElement('span', { className: 'listtree-menu-arrow fa' })
									),
									_react2.default.createElement(
										'ul',
										{ className: 'listtree-menu-submenu' },
										this.renderSub(item.items, moudleId)
									)
								));
							}
						}
					}
				}
				return content;
			}
		}, {
			key: 'renderCustomMenu',
			value: function renderCustomMenu(mainContent) {
				if (!window.userSettingEntryOrig.menuCustomObject) return;
				var i = mainContent.length;
				if (i == 0) return;
				var _menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
				var num = 0;
				for (var key in _menuCustomObject.customItems) {
					num++;
				}
				if (num == 0) return;
				var _clsName = "iconfont icon-yingyong";
				mainContent.unshift(_react2.default.createElement(
					'li',
					{ className: 'listtree-has-children', key: 'listtree' + i },
					_react2.default.createElement(
						'a',
						{ className: 'listtree-menu-title' },
						_react2.default.createElement('i', { className: "listtree-menu-icon " + _clsName }),
						_react2.default.createElement(
							'span',
							{ className: 'listtree-menu-text' },
							'\u5E38\u7528\u83DC\u5355'
						),
						_react2.default.createElement('span', { className: 'listtree-menu-arrow fa' })
					),
					_react2.default.createElement(
						'ul',
						{ className: 'listtree-menu-submenu' },
						this.renderCustomMenuSub()
					)
				));
			}
		}, {
			key: 'renderCustomMenuSubSub',
			value: function renderCustomMenuSubSub(groupKey, groupItem) {
				var content = [];var i = 0;
				if (!groupKey) return content;
				for (var key in window.userSettingEntryOrig.menuCustomObject.customItems) {
					var customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
					if (customItem.groupId != groupKey) continue;
					if (this.platMainMenu.hasOwnProperty(key)) {
						var item = this.platMainMenu[key];
						var label = this.getLabelName(item);
						/*var _clsName = "iconfont icon-default text-blue";
	     var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
	     if(iconPro)_clsName = iconPro;
	     content.push(
	     	<li className="treeview menuItem" key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
	     		<a title={label} style={{cursor:"pointer",display:'flex',alignItems:'center',paddingTop:'1px',paddingBottom:'1px'}} onClick={this.menuItemClickSelect} onDoubleClick={this.menuItemClick} data-formId={item.Properties.RefObject.refentityid} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>
	     			<i className={_clsName} style={{flexShrink:0,marginRight:'4px',marginTop:'2px',fontSize:'14px'}}></i> 
	     			<div>{label}</div>
	     		</a>
	     	</li>
	     );*/
						var _iclsName = "iconfont icon-liebiao";
						var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
						if (iconPro) {
							_iclsName = iconPro;
						}
						var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
						content.push(_react2.default.createElement(
							'li',
							{ key: 'menuItem-li' + i, 'data-formLabel': item.Properties.Label.V },
							_react2.default.createElement(
								'a',
								{ className: 'listtree-menu-title', onClick: this.menuItemClick, title: label, 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': item.onlyQuery },
								_react2.default.createElement(
									'div',
									{ className: 'listtree-menu-title-div' },
									_react2.default.createElement('div', { className: "listtree-menu-icon " + _iclsName }),
									_react2.default.createElement(
										'span',
										{ className: 'listtree-menu-text' },
										label
									)
								)
							)
						));
						i++;
					}
				}
				return content;
			}
		}, {
			key: 'renderCustomMenuSub',
			value: function renderCustomMenuSub() {
				var content = [];var i = 0;var k = 0;
	
				for (var groupKey in window.userSettingEntryOrig.menuCustomObject.groups) {
					var groupItem = window.userSettingEntryOrig.menuCustomObject.groups[groupKey];
					var label = groupItem.name;
					var _clsName = "fa fa-bars";
					content.push(_react2.default.createElement(
						'li',
						{ className: 'listtree-has-children', key: 'listtree' + k },
						_react2.default.createElement(
							'a',
							{ className: 'listtree-menu-title' },
							_react2.default.createElement('i', { className: "listtree-menu-icon " + _clsName }),
							_react2.default.createElement(
								'span',
								{ className: 'listtree-menu-text' },
								label
							),
							_react2.default.createElement('span', { className: 'listtree-menu-arrow fa' })
						),
						_react2.default.createElement(
							'ul',
							{ className: 'listtree-menu-submenu' },
							this.renderCustomMenuSubSub(groupKey, groupItem)
						)
					));
					k++;
					/*var _clsName = "fa fa-bars text-blue";
	    
	    content.push(
	    	<li className="treeview menuSub">
	    		<a style={{cursor:"pointer"}}>
	    			<i className={_clsName}></i> 
	    			<span>{label}</span>
	    			<span className="pull-right-container">
	    				<i className="fa fa-angle-left pull-right"></i>
	    			</span>
	    		</a>
	    		<ul className="treeview-menu">
	    			{this.renderCustomMenuSubSub(groupKey,groupItem)}
	    		</ul>
	    	</li>
	    );*/
				}
	
				for (var key in window.userSettingEntryOrig.menuCustomObject.customItems) {
					var customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
					if (customItem.groupId) continue;
					if (this.platMainMenu.hasOwnProperty(key)) {
						var item = this.platMainMenu[key];
						var label = this.getLabelName(item);
						var _iclsName = "iconfont icon-liebiao";
						var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
						if (iconPro) {
							_iclsName = iconPro;
						}
						var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
						content.push(_react2.default.createElement(
							'li',
							{ key: 'menuItem-li' + i, 'data-formLabel': item.Properties.Label.V },
							_react2.default.createElement(
								'a',
								{ className: 'listtree-menu-title', onClick: this.menuItemClick, title: label, 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': item.onlyQuery },
								_react2.default.createElement(
									'div',
									{ className: 'listtree-menu-title-div' },
									_react2.default.createElement('div', { className: "listtree-menu-icon " + _iclsName }),
									_react2.default.createElement(
										'span',
										{ className: 'listtree-menu-text' },
										label
									)
								)
							)
						));
						i++;
					}
				}
				return content;
			}
		}, {
			key: 'rederUserDataSettings',
			value: function rederUserDataSettings(mainContent, dataSettings, index) {
				if (window.rightSidebarClicked) return;
				var i = mainContent.length;
				if (i == 0) return;
				var _clsName = "iconfont icon-kaoheweidufenxi";
	
				mainContent.unshift(_react2.default.createElement(
					'li',
					{ className: 'listtree-has-children', key: 'listtree' + (index + 1) },
					_react2.default.createElement(
						'a',
						{ className: 'listtree-menu-title' },
						_react2.default.createElement('i', { className: "listtree-menu-icon " + _clsName }),
						_react2.default.createElement(
							'span',
							{ className: 'listtree-menu-text' },
							'\u6570\u636E\u96C6'
						),
						_react2.default.createElement('span', { className: 'listtree-menu-arrow fa' })
					),
					_react2.default.createElement(
						'ul',
						{ className: 'listtree-menu-submenu' },
						dataSettings
					)
				));
			}
		}, {
			key: 'render',
			value: function render() {
				var mainMenu = this.props.data;
				var dataSettings = this.props.dataSettings;
				var moudleId;
				var mainContent = this.renderSub(mainMenu.items, moudleId);
				this.renderCustomMenu(mainContent);
				if (dataSettings) {
					this.rederUserDataSettings(mainContent, dataSettings, mainMenu.items.length);
				}
				//TODO MainMenu的Label不显示 <li className="header">{mainMenu.Properties.Label.V}</li>
				return _react2.default.createElement(
					'ul',
					{ className: 'listtree-menu' },
					mainContent
				);
			}
		}]);
	
		return TreeViewMainMenu;
	}(_react2.default.Component);
	
	exports.default = TreeViewMainMenu;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _FormLoadHelper = __webpack_require__(59);
	
	var _FormLoadHelper2 = _interopRequireDefault(_FormLoadHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(509);
	
	var TreeViewMainMenu = function (_React$Component) {
		_inherits(TreeViewMainMenu, _React$Component);
	
		function TreeViewMainMenu(props) {
			_classCallCheck(this, TreeViewMainMenu);
	
			var _this = _possibleConstructorReturn(this, (TreeViewMainMenu.__proto__ || Object.getPrototypeOf(TreeViewMainMenu)).call(this, props));
	
			_this.renderSub = _this.renderSub.bind(_this);
			_this.menuItemClick = _this.menuItemClick.bind(_this);
			_this.getLabelName = _this.getLabelName.bind(_this);
			_this.platMainMenu = {};
			return _this;
		}
	
		//dbclick
	
	
		_createClass(TreeViewMainMenu, [{
			key: 'menuItemClick',
			value: function menuItemClick(event) {
				this.doOpenMenuItem(event);
				//window.testOpenForm(_label,_formId,_menuItemId,_onlyQuery);
			}
		}, {
			key: 'doOpenMenuItem',
			value: function doOpenMenuItem(event) {
				var target = event.target;
				if (!$(target).parent().hasClass("treeview menuItem")) {
					target = $(target).parent();
				}
	
				if (!$(target).parent().hasClass("treeview menuItem")) {
					target = $(target).parent();
				}
	
				if (!$(target).parent().hasClass("treeview menuItem")) {
					return;
				}
	
				var _label = $(target).attr("data-formLabel");
				var _formId = $(target).attr("data-formId");
				var _menuItemId = $(target).attr("data-menuItemId");
				var _onlyQuery = $(target).attr("data-onlyQuery") == "true" ? true : false;
				_FormLoadHelper2.default.openMenuItem({ menuItemId: _menuItemId, onlyQuery: _onlyQuery, label: _label, checkHas: false, fromMainMenu: true });
			}
	
			//click
	
		}, {
			key: 'menuItemClickSelect',
			value: function menuItemClickSelect(event) {
				var target = event.target;
				$("#mainMenu a.selected").removeClass("selected");
				$(target).addClass("selected");
			}
		}, {
			key: 'getLabelName',
			value: function getLabelName(item) {
				var label = _GOTUtil2.default.getPropertyValue(item, "Label");
				if (label == "" | !label) {
					label = item.name;
				}
				return label;
			}
		}, {
			key: 'renderSub',
			value: function renderSub(items, moudleId, parent, isActive) {
				var content = [];
	
				if (items) {
					for (var i = 0; i < items.length; i++) {
						var item = items[i];
						//item.pId = parent.id;
						if (item.qname) {
							if (item.qname == "MenuItem") {
	
								var isShow = false;
								var onlyQuery = false;
								var visible = item.Properties.Visible.V;
								if (!window.flatMainMenuToMenuItem.hasOwnProperty(item.id)) {
									window.flatMainMenuToMenuItem[item.id] = {};
								}
								var _menuKey = moudleId + '.' + item.idInMenu;
								window.flatMainMenuToMenuItem[item.id][_menuKey] = true;
								if (visible != 'false') {
									if (window.userInfos.isAdmin) {
										isShow = true;
									} else {
										var thisAu = moudleId + '.' + item.idInMenu;
										var authorityArr = window.xmlType1SCache[thisAu];
										if (authorityArr) {
											if (!authorityArr.del && !authorityArr.visible && !authorityArr.query) {
												onlyQuery = true;
											} else if (!authorityArr.del && authorityArr.query) {
												isShow = true;onlyQuery = true;
											} else if (authorityArr.del || authorityArr.query) {
												isShow = true;
											}
										}
									}
								}
								var label = this.getLabelName(item);
	
								if (isShow) {
	
									var _clsName = "iconfont icon-yingyong-dianjihou";
									var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
									if (iconPro) {
										_clsName = iconPro;
									} else {
										var icon_res_clsName = " menuItemIconCls_" + item.name;
										_clsName += icon_res_clsName;
									}
	
									var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
									content.push(_react2.default.createElement(
										'li',
										{ className: 'treeview menuItem', key: 'menuItem-li' + i, 'data-formLabel': item.Properties.Label.V },
										_react2.default.createElement(
											'a',
											{ className: 'treeviewmenuItemA', title: label, onClick: this.menuItemClickSelect.bind(this), onDoubleClick: this.menuItemClick.bind(this), 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': onlyQuery },
											_react2.default.createElement('i', { className: _clsName }),
											_react2.default.createElement(
												'div',
												null,
												label
											)
										)
									));
									var menuItemKey = item.id + "." + item.idInMenu;
									item.onlyQuery = onlyQuery;
									this.platMainMenu[menuItemKey] = item;
								}
							} else if (item.qname == "MenuSub") {
	
								var isShow = false;
								var visible = item.Properties.Visible.V;
								if (visible == 'true') {
									if (window.userInfos.isAdmin) {
										isShow = true;
									} else {
										var thisAu = moudleId + '.' + item.id;
										var authorityArr = window.xmlType1SCache[thisAu];
										if (authorityArr) {
											if (!authorityArr.del && !authorityArr.query && !authorityArr.visible) {
												isShow = false;
											} else {
												isShow = true;
											}
										}
									}
								}
	
								if (isShow) {
									var label = this.getLabelName(item);
									var _clsName = "fa fa-bars  treeviewMenuSubI";
									var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon");
									if (iconPro) _clsName = iconPro + " treeviewMenuSubI";
									var liClassNameSub = "treeview menuSub";
									if (isActive) {
										liClassNameSub = "treeview menuSub active";
									}
									content.push(_react2.default.createElement(
										'li',
										{ className: liClassNameSub, key: 'menuSub-li' + i },
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement('i', { className: _clsName }),
											_react2.default.createElement(
												'span',
												null,
												label
											),
											_react2.default.createElement(
												'span',
												{ className: 'pull-right-container' },
												_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
											)
										),
										_react2.default.createElement(
											'ul',
											{ className: 'treeview-menu' },
											this.renderSub(item.items, moudleId, item, isActive)
										)
									));
								}
							}
						} else {
							var isShow = false;
							var visible = item.Properties.Visible.V;
							if (visible == 'true') {
								if (window.userInfos.isAdmin) {
									isShow = true;
								} else {
									moudleId = item.id;
									var authorityArr = window.xmlType0SCache[moudleId];
									if (authorityArr) {
										if (authorityArr.del) {
											isShow = true;
										} else {
											isShow = false;
										}
									}
								}
							}
	
							var label = this.getLabelName(item);
							if (isShow) {
								var _clsName = "fa fa-th-list";
								var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon");
								if (iconPro) _clsName = iconPro;
								var itemClassId = item.id.replace(/\./g, "_");;
								var liClassName = "treeview " + itemClassId;
								if (isActive) {
									liClassName = "treeview  active  " + itemClassId;
								}
								content.push(_react2.default.createElement(
									'li',
									{ className: liClassName, key: 'treeview' + i },
									_react2.default.createElement(
										'a',
										null,
										_react2.default.createElement('i', { className: _clsName }),
										_react2.default.createElement(
											'span',
											null,
											label
										),
										_react2.default.createElement(
											'span',
											{ className: 'pull-right-container' },
											_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
										)
									),
									_react2.default.createElement(
										'ul',
										{ className: 'treeview-menu' },
										this.renderSub(item.items, moudleId, item, isActive)
									)
								));
							}
						}
					}
				}
				return content;
			}
		}, {
			key: 'renderCustomMenu',
			value: function renderCustomMenu(mainContent) {
				if (!window.userSettingEntryOrig.menuCustomObject) return;
				var i = mainContent.length;
				if (i == 0) return;
				var _menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
				var num = 0;
				for (var key in _menuCustomObject.customItems) {
					num++;
				}
				if (num == 0) return;
				mainContent.unshift(_react2.default.createElement(
					'li',
					{ className: 'treeview', key: 'treeview' + i },
					_react2.default.createElement(
						'a',
						null,
						_react2.default.createElement('i', { className: 'fa fa-user-plus' }),
						_react2.default.createElement(
							'span',
							null,
							'\u5E38\u7528\u83DC\u5355'
						),
						_react2.default.createElement(
							'span',
							{ className: 'pull-right-container' },
							_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
						)
					),
					_react2.default.createElement(
						'ul',
						{ className: 'treeview-menu' },
						this.renderCustomMenuSub()
					)
				));
			}
		}, {
			key: 'renderCustomMenuSubSub',
			value: function renderCustomMenuSubSub(groupKey, groupItem) {
				var content = [];var i = 0;
				if (!groupKey) return content;
				for (var key in window.userSettingEntryOrig.menuCustomObject.customItems) {
					var customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
					if (customItem.groupId != groupKey) continue;
					if (this.platMainMenu.hasOwnProperty(key)) {
						var item = this.platMainMenu[key];
						var label = this.getLabelName(item);
						var _clsName = "iconfont icon-yingyong-dianjihou";
						var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
						if (iconPro) {
							_clsName = iconPro;
						} else {
							var icon_res_clsName = " menuItemIconCls_" + item.name;
							_clsName += icon_res_clsName;
						}
						var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
						content.push(_react2.default.createElement(
							'li',
							{ className: 'treeview menuItem', key: 'menuItem-li' + i, 'data-formLabel': item.Properties.Label.V },
							_react2.default.createElement(
								'a',
								{ className: 'treeviewmenuItemA', title: label, onClick: this.menuItemClickSelect, onDoubleClick: this.menuItemClick, 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': item.onlyQuery },
								_react2.default.createElement('i', { className: _clsName }),
								_react2.default.createElement(
									'div',
									null,
									label
								)
							)
						));
						i++;
					}
				}
				return content;
			}
		}, {
			key: 'renderCustomMenuSub',
			value: function renderCustomMenuSub() {
				var content = [];var i = 0;
				for (var groupKey in window.userSettingEntryOrig.menuCustomObject.groups) {
					var groupItem = window.userSettingEntryOrig.menuCustomObject.groups[groupKey];
					var label = groupItem.name;
					var _clsName = "fa fa-bars";
					//var iconPro = GOTUtil.getPropertyValue(item,"Icon");
					//if(iconPro)_clsName = iconPro;
					content.push(_react2.default.createElement(
						'li',
						{ className: 'treeview menuSub' },
						_react2.default.createElement(
							'a',
							null,
							_react2.default.createElement('i', { className: _clsName }),
							_react2.default.createElement(
								'span',
								null,
								label
							),
							_react2.default.createElement(
								'span',
								{ className: 'pull-right-container' },
								_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
							)
						),
						_react2.default.createElement(
							'ul',
							{ className: 'treeview-menu' },
							this.renderCustomMenuSubSub(groupKey, groupItem)
						)
					));
				}
	
				for (var key in window.userSettingEntryOrig.menuCustomObject.customItems) {
					var customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
					if (customItem.groupId) continue;
					if (this.platMainMenu.hasOwnProperty(key)) {
						var item = this.platMainMenu[key];
						var label = this.getLabelName(item);
						var _clsName = "iconfont icon-yingyong-dianjihou";
						var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon") || _GOTUtil2.default.getPropertyValue(item, "HelpText");
						if (iconPro) {
							_clsName = iconPro;
						} else {
							var icon_res_clsName = " menuItemIconCls_" + item.name;
							_clsName += icon_res_clsName;
						}
						var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
						content.push(_react2.default.createElement(
							'li',
							{ className: 'treeview menuItem', key: 'menuItem-li' + i, 'data-formLabel': item.Properties.Label.V },
							_react2.default.createElement(
								'a',
								{ className: 'treeviewmenuItemA', title: label, onClick: this.menuItemClickSelect, onDoubleClick: this.menuItemClick, 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-onlyQuery': item.onlyQuery },
								_react2.default.createElement('i', null),
								_react2.default.createElement(
									'div',
									null,
									label
								)
							)
						));
						i++;
					}
				}
				return content;
			}
		}, {
			key: 'rederUserDataSettings',
			value: function rederUserDataSettings(mainContent, dataSettings, index) {
	
				var i = mainContent.length;
				if (i == 0) return;
				mainContent.unshift(_react2.default.createElement(
					'li',
					{ className: 'treeview', key: 'treeview' + (index + 1) },
					_react2.default.createElement(
						'a',
						null,
						_react2.default.createElement('i', { className: 'iconfont icon-kaoheweidufenxi useDataSeti' }),
						_react2.default.createElement(
							'span',
							null,
							'\u6570\u636E\u96C6'
						),
						_react2.default.createElement(
							'span',
							{ className: 'pull-right-container' },
							_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
						)
					),
					_react2.default.createElement(
						'ul',
						{ className: 'treeview-menu' },
						dataSettings
					)
				));
			}
		}, {
			key: 'render',
			value: function render() {
				var mainMenu = this.props.data; //[<li></li><li></li>] content.push(<li></li>);this.props.tree
				var dataSettings = this.props.dataSettings;
				var moudleId = void 0;
				var isActive = void 0;
				if (mainMenu.items.length <= 2) {
					isActive = true;
				} else {
					isActive = false;
				}
				var mainContent = this.renderSub(mainMenu.items, moudleId, mainMenu, isActive);
				this.renderCustomMenu(mainContent);
				if (dataSettings) {
					this.rederUserDataSettings(mainContent, dataSettings, mainMenu.items.length);
				}
				//TODO MainMenu的Label不显示 <li className="header">{mainMenu.Properties.Label.V}</li>
				//[<div></div><div></div>]
				return _react2.default.createElement(
					'ul',
					{ className: 'sidebar-menu' },
					mainContent
				);
			}
		}]);
	
		return TreeViewMainMenu;
	}(_react2.default.Component);
	
	exports.default = TreeViewMainMenu;

/***/ },
/* 518 */,
/* 519 */,
/* 520 */
/***/ function(module, exports) {

	'use strict';
	
	/*The MIT License (MIT)
	
	 Original work Copyright (c) 2014 https://github.com/kayalshri/
	 Modified work Copyright (c) 2015 https://github.com/hhurz/
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in
	 all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 THE SOFTWARE.*/
	
	(function ($) {
	    $.fn.extend({
	        tableExport: function tableExport(exportHeads, exportBodys, options) {
	            var defaults = {
	                consoleLog: false,
	                csvEnclosure: '"',
	                csvSeparator: ',',
	                csvUseBOM: true,
	                displayTableName: false,
	                escape: false,
	                excelstyles: ['border-bottom', 'border-top', 'border-left', 'border-right'],
	                fileName: 'tableExport',
	                htmlContent: false,
	                ignoreColumn: [],
	                ignoreRow: [],
	                jspdf: {
	                    orientation: 'p',
	                    unit: 'pt',
	                    format: 'a4',
	                    margins: { left: 20, right: 10, top: 10, bottom: 10 },
	                    autotable: {
	                        padding: 2,
	                        lineHeight: 12,
	                        fontSize: 8,
	                        tableExport: {
	                            onAfterAutotable: null,
	                            onBeforeAutotable: null,
	                            onTable: null
	                        }
	                    }
	                },
	                numbers: {
	                    html: {
	                        decimalMark: '.',
	                        thousandsSeparator: ','
	                    },
	                    output: {
	                        decimalMark: '.',
	                        thousandsSeparator: ','
	                    }
	                },
	                onCellData: null,
	                outputMode: 'file', // file|string|base64
	                tbodySelector: 'tr',
	                theadSelector: 'tr',
	                tableName: 'myTableName',
	                type: 'csv',
	                worksheetName: 'sheet1'
	            };
	
	            var el = this;
	            var DownloadEvt = null;
	            var rowIndex = 0;
	            var rowspans = [];
	            var trData = '';
	
	            $.extend(true, defaults, options);
	
	            if (defaults.type == 'csv' || defaults.type == 'txt') {
	
	                // Header
	                var csvData = "";
	                rowIndex = 0;
	                var trData = "";
	                for (var i = 0; i < exportHeads.length; i++) {
	                    var exportHead = exportHeads[i];
	                    trData += exportHead.name + defaults.csvSeparator;
	                    trData = $.trim(trData); //.substring(0, trData.length - 1);
	                }
	                if (trData.length > 0) {
	                    if (csvData.length > 0) csvData += "\n";
	                    trData = $.trim(trData).substring(0, trData.length - 1);
	                    csvData += trData;
	                }
	
	                for (var i = 0; i < exportBodys.length; i++) {
	                    var exportBody = exportBodys[i];
	                    trData = "";
	                    for (var j = 0; j < exportBody.length; j++) {
	                        var item = exportBody[j];
	                        trData += item + defaults.csvSeparator;
	                    }
	                    trData = $.trim(trData).substring(0, trData.length - 1);
	                    if (trData.length > 0) {
	                        if (csvData.length > 0) csvData += "\n";
	                        csvData += trData;
	                    }
	                }
	                // $(el).find('thead').first().find(defaults.theadSelector).each(function () {
	                // $(el).find('.react-grid-Header').first().find(defaults.theadSelector).each(function () {
	                //      trData = "";
	                //      // ForEachVisibleCell(this, 'th,td', rowIndex,
	                //      ForEachVisibleCell(this,'.react-grid-HeaderCell',rowIndex,
	                //              function (cell, row, col) {
	                //                  trData += csvString(cell, row, col) + defaults.csvSeparator;
	                //              });
	                //      trData = $.trim(trData).substring(0, trData.length - 1);
	                //      if (trData.length > 0) {
	
	                //          if (csvData.length > 0)
	                //              csvData += "\n";
	
	                //          csvData += trData;
	                //      }
	                //      rowIndex++;
	                //  });
	
	                // Row vs Column
	                // $(el).find('tbody').first().find(defaults.tbodySelector).each(function () {
	                // $(el).find('.react-grid-Viewport').first().find(defaults.tbodySelector).each(function () {
	                //     trData = "";
	                //     ForEachVisibleCell(this, '.react-grid-Cell', rowIndex,
	                //             function (cell, row, col) {
	                //                 trData += csvString(cell, row, col) + defaults.csvSeparator;
	                //             });
	                //     trData = $.trim(trData).substring(0, trData.length - 1);
	                //     if (trData.length > 0) {
	                //         if (csvData.length > 0)
	                //             csvData += "\n";
	                //         csvData += trData;
	                //     }
	                //     rowIndex++;
	                // });
	
	                csvData += "\n";
	
	                //output
	                if (defaults.consoleLog === true) console.log(csvData);
	
	                if (defaults.outputMode === 'string') return csvData;
	
	                if (defaults.outputMode === 'base64') return base64encode(csvData);
	
	                try {
	                    var blob = new Blob([(defaults.type == 'csv' && defaults.csvUseBOM ? '\uFEFF' : '') + csvData], { type: "text/" + (defaults.type == 'csv' ? 'csv' : 'plain') + ";charset=utf-8" });
	                    saveAs(blob, defaults.fileName + '.' + defaults.type);
	                } catch (e) {
	                    // 导出csv
	                    downloadFile(defaults.fileName + '.' + defaults.type, 'data:text/' + (defaults.type == 'csv' ? 'csv' : 'plain') + ';charset=utf-8,' + (defaults.type == 'csv' && defaults.csvUseBOM ? '\uFEFF' : '') + encodeURIComponent(csvData));
	                }
	            } else if (defaults.type == 'sql') {
	
	                // Header
	                rowIndex = 0;
	                var tdData = "INSERT INTO `" + defaults.tableName + "` (";
	                $(el).find('thead').first().find(defaults.theadSelector).each(function () {
	
	                    ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                        tdData += "'" + parseString(cell, row, col) + "',";
	                    });
	                    rowIndex++;
	                    tdData = $.trim(tdData);
	                    tdData = $.trim(tdData).substring(0, tdData.length - 1);
	                });
	                tdData += ") VALUES ";
	                // Row vs Column
	                $(el).find('tbody').first().find(defaults.tbodySelector).each(function () {
	                    trData = "";
	                    ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                        trData += "'" + parseString(cell, row, col) + "',";
	                    });
	                    if (trData.length > 3) {
	                        tdData += "(" + trData;
	                        tdData = $.trim(tdData).substring(0, tdData.length - 1);
	                        tdData += "),";
	                    }
	                    rowIndex++;
	                });
	
	                tdData = $.trim(tdData).substring(0, tdData.length - 1);
	                tdData += ";";
	
	                //output
	                if (defaults.consoleLog === true) console.log(tdData);
	
	                if (defaults.outputMode == 'string') return tdData;
	
	                if (defaults.outputMode == 'base64') return base64encode(tdData);
	
	                try {
	                    var blob = new Blob([tdData], { type: "text/plain;charset=utf-8" });
	                    saveAs(blob, defaults.fileName + '.sql');
	                } catch (e) {
	                    downloadFile(defaults.fileName + '.sql', 'data:application/sql;charset=utf-8,' + encodeURIComponent(tdData));
	                }
	            } else if (defaults.type == 'json') {
	
	                var jsonHeaderArray = [];
	                $(el).find('thead').first().find(defaults.theadSelector).each(function () {
	                    var jsonArrayTd = [];
	
	                    ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                        jsonArrayTd.push(parseString(cell, row, col));
	                    });
	                    jsonHeaderArray.push(jsonArrayTd);
	                });
	
	                var jsonArray = [];
	                $(el).find('tbody').first().find(defaults.tbodySelector).each(function () {
	                    var jsonArrayTd = [];
	
	                    ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                        jsonArrayTd.push(parseString(cell, row, col));
	                    });
	
	                    if (jsonArrayTd.length > 0 && (jsonArrayTd.length != 1 || jsonArrayTd[0] != "")) jsonArray.push(jsonArrayTd);
	
	                    rowIndex++;
	                });
	
	                var jsonExportArray = [];
	                jsonExportArray.push({ header: jsonHeaderArray, data: jsonArray });
	
	                var sdata = JSON.stringify(jsonExportArray);
	
	                if (defaults.consoleLog === true) console.log(sdata);
	
	                if (defaults.outputMode == 'string') return sdata;
	
	                var base64data = base64encode(sdata);
	
	                if (defaults.outputMode == 'base64') return base64data;
	
	                try {
	                    var blob = new Blob([sdata], { type: "application/json;charset=utf-8" });
	                    saveAs(blob, defaults.fileName + '.json');
	                } catch (e) {
	                    downloadFile(defaults.fileName + '.json', 'data:application/json;charset=utf-8;base64,' + base64data);
	                }
	            } else if (defaults.type === 'xml') {
	
	                rowIndex = 0;
	                var xml = '<?xml version="1.0" encoding="utf-8"?>';
	                xml += '<tabledata><fields>';
	
	                // Header
	                $(el).find('thead').first().find(defaults.theadSelector).each(function () {
	
	                    ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                        xml += "<field>" + parseString(cell, row, col) + "</field>";
	                    });
	                    rowIndex++;
	                });
	                xml += '</fields><data>';
	
	                // Row Vs Column
	                var rowCount = 1;
	                $(el).find('tbody').first().find(defaults.tbodySelector).each(function () {
	                    var colCount = 1;
	                    trData = "";
	                    ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                        trData += "<column-" + colCount + ">" + parseString(cell, row, col) + "</column-" + colCount + ">";
	                        colCount++;
	                    });
	                    if (trData.length > 0 && trData != "<column-1></column-1>") {
	                        xml += '<row id="' + rowCount + '">' + trData + '</row>';
	                        rowCount++;
	                    }
	
	                    rowIndex++;
	                });
	                xml += '</data></tabledata>';
	
	                //output
	                if (defaults.consoleLog === true) console.log(xml);
	
	                if (defaults.outputMode == 'string') return xml;
	
	                var base64data = base64encode(xml);
	
	                if (defaults.outputMode == 'base64') return base64data;
	
	                try {
	                    var blob = new Blob([xml], { type: "application/xml;charset=utf-8" });
	                    saveAs(blob, defaults.fileName + '.xml');
	                } catch (e) {
	                    downloadFile(defaults.fileName + '.xml', 'data:application/xml;charset=utf-8;base64,' + base64data);
	                }
	            } else if (defaults.type == 'excel' || defaults.type == 'doc') {
	
	                rowIndex = 0;
	                var excelData = "<table>";
	
	                var trData = "";
	                for (var i = 0; i < exportHeads.length; i++) {
	                    var exportHead = exportHeads[i];
	                    if (exportHead.columnType == "String") {
	                        trData += "<td x:str>" + exportHead.name + "</td>";
	                    } else {
	                        trData += "<td>" + exportHead.name + "</td>";
	                    }
	                }
	                excelData += "<tr>" + trData + '</tr>';
	
	                for (var i = 0; i < exportBodys.length; i++) {
	                    var exportBody = exportBodys[i];
	                    var trData = "";
	                    for (var j = 0; j < exportBody.length; j++) {
	                        var item = exportBody[j];
	                        var stringflag = false;
	                        if (j < exportHeads.length) {
	                            exportHead = exportHeads[j];
	                            if (exportHead.columnType == "String") {
	                                stringflag = true;trData += "<td x:str>" + item + "</td>";
	                            }
	                        }
	                        if (stringflag == false) trData += "<td>" + item + "</td>";
	                    }
	
	                    excelData += "<tr>" + trData + '</tr>';
	                }
	                // $(el).find(defaults.theadSelector).each(function(){
	                //     trData="";
	                //     ForEachVisibleCell(this,'.react-grid-HeaderCell',rowIndex,
	                //         function(cell, row, col){
	                //             if (cell != null) {
	                //                 trData += "<td style='";
	                //                 for (var styles in defaults.excelstyles) {
	                //                     if (defaults.excelstyles.hasOwnProperty(styles)) {
	                //                         trData += defaults.excelstyles[styles] + ": " + $(cell).css(defaults.excelstyles[styles]) + ";";
	                //                     }
	                //                 }
	                //                 if ($(cell).is("[colspan]"))
	                //                     trData += "' colspan='" + $(cell).attr('colspan');
	                //                 if ($(cell).is("[rowspan]"))
	                //                     trData += "' rowspan='" + $(cell).attr('rowspan');
	                //                 trData += "'>" + parseString(cell, row, col) + "</td>";
	                //             }
	                //         })
	                //     if (trData.length > 0)
	                //         excelData += "<tr>" + trData + '</tr>';
	                //     rowIndex++;
	                // })
	                // $(el).find(defaults.tbodySelector).each(function () {
	                //     trData = "";
	                //     ForEachVisibleCell(this,'.react-grid-Cell',rowIndex,
	                //            function (cell, row, col) {
	                //                 if (cell != null) {
	                //                     trData += "<td style='";
	                //                     for (var styles in defaults.excelstyles) {
	                //                         if (defaults.excelstyles.hasOwnProperty(styles)) {
	                //                             trData += defaults.excelstyles[styles] + ": " + $(cell).css(defaults.excelstyles[styles]) + ";";
	                //                         }
	                //                     }
	                //                     if ($(cell).is("[colspan]"))
	                //                         trData += "' colspan='" + $(cell).attr('colspan');
	                //                     if ($(cell).is("[rowspan]"))
	                //                         trData += "' rowspan='" + $(cell).attr('rowspan');
	                //                     trData += "'>" + parseString(cell, row, col) + "</td>";
	                //                 }
	                //             });
	                //     if (trData.length > 0)
	                //         excelData += "<tr>" + trData + '</tr>';
	                //     rowIndex++;
	                //     console.log(rowIndex);
	                // });
	
	                if (defaults.displayTableName) excelData += "<tr><td></td></tr><tr><td></td></tr><tr><td>" + parseString($('<p>' + defaults.tableName + '</p>')) + "</td></tr>";
	
	                excelData += '</table>';
	
	                if (defaults.consoleLog === true) console.log(excelData);
	
	                var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:" + defaults.type + "' xmlns='http://www.w3.org/TR/REC-html40'>";
	                excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-' + defaults.type + '; charset=UTF-8">';
	                excelFile += '<meta http-equiv="content-type" content="application/';
	                excelFile += defaults.type === 'excel' ? 'vnd.ms-excel' : 'msword';
	                excelFile += '; charset=UTF-8">';
	                excelFile += "<head>";
	                if (defaults.type === 'excel') {
	                    excelFile += "<!--[if gte mso 9]>";
	                    excelFile += "<xml>";
	                    excelFile += "<x:ExcelWorkbook>";
	                    excelFile += "<x:ExcelWorksheets>";
	                    excelFile += "<x:ExcelWorksheet>";
	                    excelFile += "<x:Name>";
	                    excelFile += defaults.worksheetName;
	                    excelFile += "</x:Name>";
	                    excelFile += "<x:WorksheetOptions>";
	                    excelFile += "<x:DisplayGridlines/>";
	                    excelFile += "</x:WorksheetOptions>";
	                    excelFile += "</x:ExcelWorksheet>";
	                    excelFile += "</x:ExcelWorksheets>";
	                    excelFile += "</x:ExcelWorkbook>";
	                    excelFile += "</xml>";
	                    excelFile += "<![endif]-->";
	                }
	                excelFile += "</head>";
	                excelFile += "<body>";
	                excelFile += excelData;
	                excelFile += "</body>";
	                excelFile += "</html>";
	
	                if (defaults.outputMode == 'string') return excelFile;
	
	                var base64data = base64encode(excelFile);
	
	                if (defaults.outputMode === 'base64') return base64data;
	
	                var extension = defaults.type === 'excel' ? 'xls' : 'doc';
	                try {
	                    var blob = new Blob([excelFile], { type: 'application/vnd.ms-' + defaults.type });
	                    saveAs(blob, defaults.fileName + '.' + extension);
	                } catch (e) {
	                    //导出excel
	                    downloadFile(defaults.fileName + '.' + extension, 'data:application/vnd.ms-' + defaults.type + ';base64,' + base64data);
	                }
	            } else if (defaults.type == 'png') {
	                html2canvas($(el), {
	                    onrendered: function onrendered(canvas) {
	
	                        var image = canvas.toDataURL();
	                        image = image.substring(22); // remove data stuff
	
	                        var byteString = atob(image);
	                        var buffer = new ArrayBuffer(byteString.length);
	                        var intArray = new Uint8Array(buffer);
	
	                        for (var i = 0; i < byteString.length; i++) {
	                            intArray[i] = byteString.charCodeAt(i);
	                        }try {
	                            var blob = new Blob([buffer], { type: "image/png" });
	                            saveAs(blob, defaults.fileName + '.png');
	                        } catch (e) {
	                            downloadFile(defaults.fileName + '.png', 'data:image/png;base64,' + image);
	                        }
	                    }
	                });
	            } else if (defaults.type == 'pdf') {
	                if (defaults.jspdf.autotable === false) {
	                    var addHtmlOptions = {
	                        dim: {
	                            w: getPropertyUnitValue($(el).first().get(0), 'width', 'mm'),
	                            h: getPropertyUnitValue($(el).first().get(0), 'height', 'mm')
	                        },
	                        pagesplit: false
	                    };
	
	                    var doc = new jsPDF(defaults.jspdf.orientation, defaults.jspdf.unit, defaults.jspdf.format);
	                    doc.addHTML($(el).first(), defaults.jspdf.margins.left, defaults.jspdf.margins.top, addHtmlOptions, function () {
	                        jsPdfOutput(doc);
	                    });
	                    //delete doc;
	                } else {
	                    // pdf output using jsPDF AutoTable plugin
	                    // https://github.com/someatoms/jsPDF-AutoTable
	
	                    var teOptions = defaults.jspdf.autotable.tableExport;
	
	                    // When setting jspdf.format to 'bestfit' tableExport tries to choose
	                    // the minimum required paper format and orientation in which the table
	                    // (or tables in multitable mode) completely fit without column adjustment
	                    if (typeof defaults.jspdf.format === 'string' && defaults.jspdf.format.toLowerCase() === 'bestfit') {
	                        var pageFormats = {
	                            'a0': [2383.94, 3370.39], 'a1': [1683.78, 2383.94],
	                            'a2': [1190.55, 1683.78], 'a3': [841.89, 1190.55],
	                            'a4': [595.28, 841.89]
	                        };
	                        var rk = '',
	                            ro = '';
	                        var mw = 0;
	
	                        $(el).filter(':visible').each(function () {
	                            if ($(this).css('display') != 'none') {
	                                var w = getPropertyUnitValue($(this).get(0), 'width', 'pt');
	
	                                if (w > mw) {
	                                    if (w > pageFormats['a0'][0]) {
	                                        rk = 'a0';
	                                        ro = 'l';
	                                    }
	                                    for (var key in pageFormats) {
	                                        if (pageFormats.hasOwnProperty(key)) {
	                                            if (pageFormats[key][1] > w) {
	                                                rk = key;
	                                                ro = 'l';
	                                                if (pageFormats[key][0] > w) ro = 'p';
	                                            }
	                                        }
	                                    }
	                                    mw = w;
	                                }
	                            }
	                        });
	                        defaults.jspdf.format = rk == '' ? 'a4' : rk;
	                        defaults.jspdf.orientation = ro == '' ? 'w' : ro;
	                    }
	
	                    // The jsPDF doc object is stored in defaults.jspdf.autotable.tableExport,
	                    // thus it can be accessed from any callback function from below
	                    teOptions.doc = new jsPDF(defaults.jspdf.orientation, defaults.jspdf.unit, defaults.jspdf.format);
	
	                    $(el).filter(':visible').each(function () {
	                        if ($(this).css('display') != 'none') {
	                            var colKey;
	                            var rowIndex = 0;
	                            var atOptions = {};
	
	                            teOptions.columns = [];
	                            teOptions.rows = [];
	                            teOptions.rowoptions = {};
	
	                            // onTable: optional callback function for every matching table that can be used
	                            // to modify the tableExport options or to skip the output of a particular table
	                            // when the  table selector targets multiple tables
	                            if (typeof teOptions.onTable === 'function') if (teOptions.onTable($(this), defaults) === false) return true; // continue to next iteration step (table)
	
	                            // each table works with an own copy of AutoTable options
	                            Object.keys(defaults.jspdf.autotable).forEach(function (key) {
	                                atOptions[key] = defaults.jspdf.autotable[key];
	                            });
	                            atOptions.margins = {};
	                            $.extend(true, atOptions.margins, defaults.jspdf.margins);
	
	                            if (typeof atOptions.renderCell !== 'function') {
	
	                                // draw cell text with original <td> alignment
	                                atOptions.renderCell = function (x, y, width, height, key, value, row, settings) {
	                                    var doc = settings.tableExport.doc;
	                                    var xoffset = 0;
	
	                                    doc.setFillColor(row % 2 === 0 ? 245 : 255);
	                                    doc.setTextColor(50);
	                                    doc.rect(x, y, width, height, 'F');
	                                    y += settings.lineHeight / 2 + doc.autoTableTextHeight() / 2 - 2.5;
	
	                                    if (typeof settings.tableExport.columns[key] != 'undefined') {
	                                        var col = settings.tableExport.columns[key];
	                                        if (typeof col.style != 'undefined') {
	                                            var alignment = col.style.align;
	                                            var rowopt = settings.tableExport.rowoptions[row + 1 + ":" + key];
	
	                                            if (typeof rowopt != 'undefined') alignment = rowopt.style.align;
	
	                                            if (alignment == 'right') xoffset = width - doc.getStringUnitWidth('' + value) * doc.internal.getFontSize() - settings.padding;else if (alignment == 'center') xoffset = (width - doc.getStringUnitWidth('' + value) * doc.internal.getFontSize()) / 2;
	                                        }
	                                    }
	
	                                    if (xoffset < settings.padding) xoffset = settings.padding;
	
	                                    doc.text(value, x + xoffset, y);
	                                };
	                            }
	
	                            // collect header and data rows
	                            $(this).find('thead').find(defaults.theadSelector).each(function () {
	                                colKey = 0;
	
	                                ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                                    var obj = {
	                                        title: parseString(cell, row, col),
	                                        key: colKey++,
	                                        style: {
	                                            align: getStyle(cell, 'text-align'),
	                                            bcolor: getStyle(cell, 'background-color')
	                                        }
	                                    };
	                                    teOptions.columns.push(obj);
	                                });
	                                rowIndex++;
	                            });
	
	                            $(this).find('tbody').find(defaults.tbodySelector).each(function () {
	                                var rowData = [];
	                                var rowCount = 0;
	                                colKey = 0;
	
	                                ForEachVisibleCell(this, 'th,td', rowIndex, function (cell, row, col) {
	                                    var obj = {
	                                        style: {
	                                            align: getStyle(cell, 'text-align'),
	                                            bcolor: getStyle(cell, 'background-color')
	                                        }
	                                    };
	                                    teOptions.rowoptions[rowCount + ":" + colKey++] = obj;
	
	                                    rowData.push(parseString(cell, row, col));
	                                });
	                                if (rowData.length) {
	                                    teOptions.rows.push(rowData);
	                                    rowCount++;
	                                }
	                                rowIndex++;
	                            });
	
	                            // onBeforeAutotable: optional callback function before calling
	                            // jsPDF AutoTable that can be used to modify the AutoTable options
	                            if (typeof teOptions.onBeforeAutotable === 'function') teOptions.onBeforeAutotable($(this), teOptions.columns, teOptions.rows, atOptions);
	
	                            teOptions.doc.autoTable(teOptions.columns, teOptions.rows, atOptions);
	
	                            // onAfterAutotable: optional callback function after returning
	                            // from jsPDF AutoTable that can be used to modify the AutoTable options
	                            if (typeof teOptions.onAfterAutotable === 'function') teOptions.onAfterAutotable($(this), atOptions);
	
	                            // set the start position for the next table (in case there is one)
	                            defaults.jspdf.autotable.startY = teOptions.doc.autoTableEndPosY() + atOptions.margins.top;
	                        }
	                    });
	
	                    jsPdfOutput(teOptions.doc);
	
	                    teOptions.columns.length = 0;
	                    teOptions.rows.length = 0;
	                    delete teOptions.doc;
	                    teOptions.doc = null;
	                }
	            }
	
	            function ForEachVisibleCell(tableRow, selector, rowIndex, cellcallback) {
	                if (defaults.ignoreRow.indexOf(rowIndex) == -1) {
	                    $(tableRow).filter(':visible').find(selector).each(function (colIndex) {
	                        if ($(this).data("tableexport-display") == 'always' || $(this).css('display') != 'none' && $(this).css('visibility') != 'hidden' && $(this).data("tableexport-display") != 'none') {
	                            if (defaults.ignoreColumn.indexOf(colIndex) == -1) {
	                                if (typeof cellcallback === "function") {
	                                    var cs = 0; // colspan value
	
	                                    // handle previously detected rowspans
	                                    if (typeof rowspans[rowIndex] != 'undefined' && rowspans[rowIndex].length > 0) {
	                                        for (c = 0; c <= colIndex; c++) {
	                                            if (typeof rowspans[rowIndex][c] != 'undefined') {
	                                                cellcallback(null, rowIndex, c);
	                                                delete rowspans[rowIndex][c];
	                                                colIndex++;
	                                            }
	                                        }
	                                    }
	
	                                    // output content of current cell
	                                    cellcallback(this, rowIndex, colIndex);
	
	                                    // handle colspan of current cell
	                                    if ($(this).is("[colspan]")) {
	                                        cs = $(this).attr('colspan');
	                                        for (c = 0; c < cs - 1; c++) {
	                                            cellcallback(null, rowIndex, colIndex + c);
	                                        }
	                                    }
	
	                                    // store rowspan for following rows
	                                    if ($(this).is("[rowspan]")) {
	                                        var rs = parseInt($(this).attr('rowspan'));
	
	                                        for (r = 1; r < rs; r++) {
	                                            if (typeof rowspans[rowIndex + r] == 'undefined') rowspans[rowIndex + r] = [];
	                                            rowspans[rowIndex + r][colIndex] = "";
	
	                                            for (c = 1; c < cs; c++) {
	                                                rowspans[rowIndex + r][colIndex + c] = "";
	                                            }
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    });
	                }
	            }
	
	            function jsPdfOutput(doc) {
	                if (defaults.consoleLog === true) console.log(doc.output());
	
	                if (defaults.outputMode == 'string') return doc.output();
	
	                if (defaults.outputMode == 'base64') return base64encode(doc.output());
	
	                try {
	                    var blob = doc.output('blob');
	                    saveAs(blob, defaults.fileName + '.pdf');
	                } catch (e) {
	                    downloadFile(defaults.fileName + '.pdf', 'data:application/pdf;base64,' + base64encode(doc.output()));
	                }
	            }
	
	            function escapeRegExp(string) {
	                return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	            }
	
	            function replaceAll(string, find, replace) {
	                return string.replace(new RegExp(escapeRegExp(find), 'g'), replace);
	            }
	
	            function csvString(cell, rowIndex, colIndex) {
	                var result = '';
	
	                if (cell != null) {
	                    var dataString = parseString(cell, rowIndex, colIndex);
	
	                    var csvValue = dataString === null || dataString == '' ? '' : dataString.toString();
	
	                    if (dataString instanceof Date) result = defaults.csvEnclosure + dataString.toLocaleString() + defaults.csvEnclosure;else {
	                        result = replaceAll(csvValue, defaults.csvEnclosure, defaults.csvEnclosure + defaults.csvEnclosure);
	
	                        if (result.indexOf(defaults.csvSeparator) >= 0 || /[\r\n ]/g.test(result)) result = defaults.csvEnclosure + result + defaults.csvEnclosure;
	                    }
	                }
	
	                return result;
	            }
	
	            function parseNumber(value) {
	                value = value || "0";
	                value = replaceAll(value, defaults.numbers.html.decimalMark, '.');
	                value = replaceAll(value, defaults.numbers.html.thousandsSeparator, '');
	
	                return typeof value === "number" || jQuery.isNumeric(value) !== false ? value : false;
	            }
	
	            function parseString(cell, rowIndex, colIndex) {
	                var result = '';
	
	                if (cell != null) {
	                    var $cell = $(cell);
	
	                    if (defaults.htmlContent === true) {
	                        result = $cell.html().trim();
	                    } else {
	                        result = $cell.text().trim().replace(/\u00AD/g, ""); // remove soft hyphens
	
	                        if (defaults.numbers.html.decimalMark != defaults.numbers.output.decimalMark || defaults.numbers.html.thousandsSeparator != defaults.numbers.output.thousandsSeparator) {
	                            var number = parseNumber(result);
	
	                            if (number !== false) {
	                                var frac = ("" + number).split('.');
	                                if (frac.length == 1) frac[1] = "";
	                                var mod = frac[0].length > 3 ? frac[0].length % 3 : 0;
	
	                                result = (number < 0 ? "-" : "") + (defaults.numbers.output.thousandsSeparator ? (mod ? frac[0].substr(0, mod) + defaults.numbers.output.thousandsSeparator : "") + frac[0].substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + defaults.numbers.output.thousandsSeparator) : frac[0]) + (frac[1].length ? defaults.numbers.output.decimalMark + frac[1] : "");
	                            }
	                        }
	                    }
	
	                    if (defaults.escape === true) {
	                        result = escape(result);
	                    }
	
	                    if (typeof defaults.onCellData === 'function') {
	                        result = defaults.onCellData($cell, rowIndex, colIndex, result);
	                    }
	                }
	
	                return result;
	            }
	
	            function hyphenate(a, b, c) {
	                return b + "-" + c.toLowerCase();
	            }
	
	            // get computed style property
	            function getStyle(target, prop) {
	                try {
	                    if (window.getComputedStyle) {
	                        // gecko and webkit
	                        prop = prop.replace(/([a-z])([A-Z])/, hyphenate); // requires hyphenated, not camel
	                        return window.getComputedStyle(target, null).getPropertyValue(prop);
	                    }
	                    if (target.currentStyle) {
	                        // ie
	                        return target.currentStyle[prop];
	                    }
	                    return target.style[prop];
	                } catch (e) {}
	                return "";
	            }
	
	            function getPropertyUnitValue(target, prop, unit) {
	                var baseline = 100; // any number serves
	
	                var value = getStyle(target, prop); // get the computed style value
	
	                var numeric = value.match(/\d+/); // get the numeric component
	                if (numeric !== null) {
	                    numeric = numeric[0]; // get the string
	
	                    var temp = document.createElement("div"); // create temporary element
	                    temp.style.overflow = "hidden"; // in case baseline is set too low
	                    temp.style.visibility = "hidden"; // no need to show it
	
	                    target.parentElement.appendChild(temp); // insert it into the parent for em, ex and %
	
	                    temp.style.width = baseline + unit;
	                    var factor = baseline / temp.offsetWidth;
	
	                    target.parentElement.removeChild(temp); // clean up
	
	                    return numeric * factor;
	                }
	                return 0;
	            }
	
	            function downloadFile(filename, data) {
	                var DownloadLink = document.createElement('a');
	
	                if (DownloadLink) {
	                    document.body.appendChild(DownloadLink);
	                    DownloadLink.style = 'display: none';
	                    DownloadLink.download = filename;
	                    DownloadLink.href = data;
	
	                    if (document.createEvent) {
	                        if (DownloadEvt == null) DownloadEvt = document.createEvent('MouseEvents');
	
	                        DownloadEvt.initEvent('click', true, false);
	                        DownloadLink.dispatchEvent(DownloadEvt);
	                    } else if (document.createEventObject) DownloadLink.fireEvent('onclick');else if (typeof DownloadLink.onclick == 'function') DownloadLink.onclick();
	
	                    document.body.removeChild(DownloadLink);
	                }
	            }
	
	            function utf8Encode(string) {
	                string = string.replace(/\x0d\x0a/g, "\x0a");
	                var utftext = "";
	                for (var n = 0; n < string.length; n++) {
	                    var c = string.charCodeAt(n);
	                    if (c < 128) {
	                        utftext += String.fromCharCode(c);
	                    } else if (c > 127 && c < 2048) {
	                        utftext += String.fromCharCode(c >> 6 | 192);
	                        utftext += String.fromCharCode(c & 63 | 128);
	                    } else {
	                        utftext += String.fromCharCode(c >> 12 | 224);
	                        utftext += String.fromCharCode(c >> 6 & 63 | 128);
	                        utftext += String.fromCharCode(c & 63 | 128);
	                    }
	                }
	                return utftext;
	            }
	
	            function base64encode(input) {
	                var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	                var output = "";
	                var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	                var i = 0;
	                input = utf8Encode(input);
	                while (i < input.length) {
	                    chr1 = input.charCodeAt(i++);
	                    chr2 = input.charCodeAt(i++);
	                    chr3 = input.charCodeAt(i++);
	                    enc1 = chr1 >> 2;
	                    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	                    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	                    enc4 = chr3 & 63;
	                    if (isNaN(chr2)) {
	                        enc3 = enc4 = 64;
	                    } else if (isNaN(chr3)) {
	                        enc4 = 64;
	                    }
	                    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
	                }
	                return output;
	            }
	
	            return this;
	        }
	    });
	})(jQuery);

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _StringUtil = __webpack_require__(6);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _QueryUtil = __webpack_require__(30);
	
	var _QueryUtil2 = _interopRequireDefault(_QueryUtil);
	
	var _styles = __webpack_require__(774);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var GlobalUserSetForm = function (_React$Component) {
		_inherits(GlobalUserSetForm, _React$Component);
	
		function GlobalUserSetForm(props, context) {
			_classCallCheck(this, GlobalUserSetForm);
	
			// window.userSettingEntry = {
			//   autoEnterList: false, // 自动进入列表
			//   //clickEnterList:false,  //
			//   //flickerTime:800,   //
			//   isAutoSavePrompt: false, // 自动保存提示
			//   isDelPrompt: true,  //删除提示
			//   isEditMode: true,  
			//   isEditModeHelp: true,
			//   isRecSavePrompt: false,  //recordsave 提醒
			//   isReportBrowser: true,
			//   isShowBusyRemote: true,
			//   showOprInfo: false,
			//   downNewRec: false,    
			//   showLeftMenu: false,  //左边侧边栏
			//   showToolMenu: true   //工具栏
			// }
			var _this = _possibleConstructorReturn(this, (GlobalUserSetForm.__proto__ || Object.getPrototypeOf(GlobalUserSetForm)).call(this, props, context));
	
			_this.hideGlobalUserSetForm = function () {
				var $reactComponentContainer = $("#globalUserSetFormDiv");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				//$reactComponentContainer.remove();
				$("#globalUserSetFormDiv").empty().css("display", "none");
			};
	
			_this.changeisShowBusyRemote = function () {
				var tag = $("#isShowBusyRemoteCheckBox").prop("checked");
				// alert("isShowBusyRemote"+tag);
				window.userSettingEntry.isShowBusyRemote = tag;
				_this.userSettingEntry.isShowBusyRemote = tag;
			};
	
			_this.changeisRecSavePrompt = function () {
				var tag = $("#isRecSavePromptCheckBox").prop("checked");
				window.userSettingEntry.isRecSavePrompt = tag;
				_this.userSettingEntry.isRecSavePrompt = tag;
			};
	
			_this.changeisAutoSavePrompt = function () {
				var tag = $("#isAutoSavePromptCheckBox").prop("checked");
				window.userSettingEntry.isAutoSavePrompt = tag;
				_this.userSettingEntry.isAutoSavePrompt = tag;
			};
	
			_this.changeisDelPrompt = function () {
				var tag = $("#isDelPromptCheckBox").prop("checked");
				window.userSettingEntry.isDelPrompt = tag;
				_this.userSettingEntry.isDelPrompt = tag;
			};
	
			_this.changeBottomSumShow = function () {
				var tag = $("#isShowBottomSumCheckBox").prop("checked");
				window.userSettingEntry.showBottomSum = tag;
				_this.userSettingEntry.showBottomSum = tag;
			};
	
			_this.changedownNewRec = function () {
				var tag = $("#downNewRecCheckBox").prop("checked");
				window.userSettingEntry.downNewRec = tag;
				_this.userSettingEntry.downNewRec = tag;
			};
	
			_this.changeautoEnterList = function () {
				var tag = $("#autoEnterListCheckBox").prop("checked");
				window.userSettingEntry.autoEnterList = tag;
				_this.userSettingEntry.autoEnterList = tag;
			};
	
			_this.changeclickEnterList = function () {
				var tag = $("#clickEnterListCheckBox").prop("checked");
				window.userSettingEntry.clickEnterList = tag;
				_this.userSettingEntry.clickEnterList = tag;
			};
	
			_this.changePressEditList = function () {
				var tag = $("#clickPressEditCheckBox").prop("checked");
				window.userSettingEntry.pressEditList = tag;
				_this.userSettingEntry.pressEditList = tag;
			};
	
			_this.changeshowToolMenu = function () {
				var tag = $("#showToolMenuCheckBox").prop("checked");
				window.userSettingEntry.showToolMenu = tag;
				_this.userSettingEntry.showToolMenu = tag;
				/*if(tag)//如果启用工具栏菜单 则把左侧主菜单隐藏
	   {
	   	this.userSettingEntry.showLeftMenu = false;
	   	window.userSettingEntry.showLeftMenu = false;
	   }
	   else//否则确保左侧主菜单要显示
	   {
	   	this.userSettingEntry.showLeftMenu = true;
	   	window.userSettingEntry.showLeftMenu = true;
	   }*/
			};
	
			_this.changeshowLeftMenu = function () {
				var tag = $("#showLeftMenuCheckBox").prop("checked");
				window.userSettingEntry.showLeftMenu = tag;
				_this.userSettingEntry.showLeftMenu = tag;
				if (tag == true) {
					var tag = $("#showLeftListMenuCheckBox").prop("checked", false);
					window.userSettingEntry.showLeftListMenu = false;
					_this.userSettingEntry.showLeftListMenu = false;
				}
			};
	
			_this.changeshowLeftListMenu = function () {
				var tag = $("#showLeftListMenuCheckBox").prop("checked");
				window.userSettingEntry.showLeftListMenu = tag;
				_this.userSettingEntry.showLeftListMenu = tag;
	
				if (tag == true) {
					var tag = $("#showLeftMenuCheckBox").prop("checked", false);
					window.userSettingEntry.showLeftMenu = false;
					_this.userSettingEntry.showLeftMenu = false;
				}
			};
	
			_this.changeHideToolBar = function () {
				var tag = $("#hideToolBarCheckBox").prop("checked");
				window.userSettingEntry.hideToolBar = tag;
				_this.userSettingEntry.hideToolBar = tag;
			};
	
			_this.changeInnerToolBar = function () {
				var tag = $("#innerToolBarCheckBox").prop("checked");
				window.userSettingEntry.innerToolBar = tag;
				_this.userSettingEntry.innerToolBar = tag;
				if (tag) //如果把工具栏放到画面内 则要隐藏画面外的工具栏
					{
						window.userSettingEntry.hideToolBar = true;
						_this.userSettingEntry.hideToolBar = true;
					} else //否则要保证画面外的工具栏是显示的
					{
						window.userSettingEntry.hideToolBar = false;
						_this.userSettingEntry.hideToolBar = false;
					}
			};
	
			_this.changeisReportBrowser = function () {
				var tag = $("#isReportBrowserCheckBox").prop("checked");
				window.userSettingEntry.isReportBrowser = tag;
				_this.userSettingEntry.isReportBrowser = tag;
			};
	
			_this.changeisDebug = function () {
				var tag = $("#isReportBrowserCheckBox").prop("checked");
				window.userSettingEntry.isDebug = tag;
				_this.userSettingEntry.isDebug = tag;
			};
	
			_this.changeisEditMode = function () {
				var tag = $("#isEditModeCheckBox").prop("checked");
				window.userSettingEntry.isEditMode = tag;
				_this.userSettingEntry.isEditMode = tag;
			};
	
			_this.btnRestore_clickHandler = function () {
	
				// 自动进入列表autoEnterList false
				window.userSettingEntry.autoEnterList = false;
				_this.userSettingEntry.autoEnterList = false;
				// $("#autoEnterListCheckBox").prop("checked", false);
	
				// clickEnterList true
				window.userSettingEntry.clickEnterList = true;
				_this.userSettingEntry.clickEnterList = true;
	
				window.userSettingEntry.pressEditList = false;
				_this.userSettingEntry.pressEditList = false;
	
				// flickerTime 800
				window.userSettingEntry.flickerTime = 800;
				_this.userSettingEntry.flickerTime = 800;
	
				// isAutoSavePrompt false
				window.userSettingEntry.isAutoSavePrompt = false;
				_this.userSettingEntry.isAutoSavePrompt = false;
				// $("#isAutoSavePromptCheckBox").prop("checked",false);
	
				// isDebug false
				window.userSettingEntry.isDebug = false;
				_this.userSettingEntry.isDebug = false;
				// $("#isDebugCheckBox").prop("checked", false);
	
				//showBottomSum false
				window.userSettingEntry.showBottomSum = false;
				_this.userSettingEntry.showBottomSum = false;
	
				// isDelPrompt true
				window.userSettingEntry.isDelPrompt = true;
				_this.userSettingEntry.isDelPrompt = true;
				// $("#isDelPromptCheckBox").prop("checked",true);
	
				// isEditMode true
				window.userSettingEntry.isEditMode = true;
				_this.userSettingEntry.isEditMode = true;
				// $("#isEditModeCheckBox").prop("checked",true);
	
				// isRecSavePrompt false
				window.userSettingEntry.isRecSavePrompt = false;
				_this.userSettingEntry.isRecSavePrompt = false;
				// $("#isRecSavePromptCheckBox").prop("checked",false);
	
				// isReportBrowser true
				window.userSettingEntry.isReportBrowser = true;
				_this.userSettingEntry.isReportBrowser = true;
				// $("#isReportBrowserCheckBox").prop("checked",true);
	
				// isShowBusyRemote true
				window.userSettingEntry.isShowBusyRemote = true;
				_this.userSettingEntry.isShowBusyRemote = true;
				// $("#isShowBusyRemoteCheckBox").prop("checked",true);
	
				// isStayWindowMem true
				window.userSettingEntry.isStayWindowMem = true;
				_this.userSettingEntry.isStayWindowMem = true;
	
				// useFixedMainMenu true
				window.userSettingEntry.useFixedMainMenu = true;
				_this.userSettingEntry.useFixedMainMenu = true;
	
				// useFixedForm false
				window.userSettingEntry.useFixedForm = false;
				_this.userSettingEntry.useFixedForm = false;
	
				// ugse.downNewRec = false;
				window.userSettingEntry.downNewRec = false;
				_this.userSettingEntry.downNewRec = false;
				// $("#downNewRecCheckBox").prop("checked",false);
	
				// ugse.showOprInfo = false;
				window.userSettingEntry.showOprInfo = false;
				_this.userSettingEntry.showOprInfo = false;
	
				// //showOprInfo.selected = false;
				window.userSettingEntry.showOprInfo = false;
				_this.userSettingEntry.showOprInfo = false;
	
				// ugse.showLeftMenu = true;
				window.userSettingEntry.showLeftMenu = true;
				_this.userSettingEntry.showLeftMenu = true;
				// $("#showLeftMenuCheckBox").prop("checked",true);
	
	
				// ugse.showToolMenu = false;
				window.userSettingEntry.showToolMenu = false;
				_this.userSettingEntry.showToolMenu = false;
				// $("#showToolMenuCheckBox").prop("checked",false);
	
				window.userSettingEntry.hideToolBar = false;
				_this.userSettingEntry.hideToolBar = false;
	
				window.userSettingEntry.innerToolBar = false;
				_this.userSettingEntry.innerToolBar = false;
	
				_this.componentDidMount();
			};
	
			_this.btnsave_clickHandler = function () {
				var ugse = _this.userSettingEntry;
				var userId = _this.userInfos.userId;
	
				for (var k in ugse) {
					ugse[k] = ugse[k].toString();
				}
				if (typeof window.userSettingEntryOrig.menuCustomObject != "string") {
					ugse.menuCustomObject = JSON.stringify(window.userSettingEntryOrig.menuCustomObject);
				} else {
					ugse.menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
				}
	
				console.log(ugse);
				// var saveFaultHandler = function(data)
				// {
				// 	alert("保存失败","提示");	
				// }
				var saveResultHandler = function saveResultHandler(data) {
					window.userSettingEntryOrig = ugse;
					console.log(data);
					if (Boolean(data.result)) {
						if (Boolean(data.result)) {
							var options = {
								state: 'success',
								text: "已成功保存您的偏好设置"
							};
							_Fade2.default.show(options);
						} else {
							var options = {
								state: 'error',
								text: "保存失败"
							};
							_Fade2.default.show(options);
							// alert("保存失败","提示");	
						}
					}
				};
	
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
	
				command.appendArg(userId); //ClientSession.getClientSessionInstance().userId
				command.appendArg(ugse, "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");
	
				var remoteArg = {
					command: command,
					resultFunction: saveResultHandler,
					sync: false
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.loadGlobalHandler = function () {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "loadUserProperties", "UserGlobalSetEntity");
				command.appendArg("_default");
				var self = _this;
				var Fun = function Fun(data) {
					var ugse = data.result;
					console.log(data);
					// 自动进入列表autoEnterList false
					window.userSettingEntry.autoEnterList = ugse.autoEnterList;
					self.userSettingEntry.autoEnterList = ugse.autoEnterList;
					// $("#autoEnterListCheckBox").prop("checked", false);
	
					// clickEnterList true
					window.userSettingEntry.clickEnterList = ugse.clickEnterList;
					self.userSettingEntry.clickEnterList = ugse.clickEnterList;
	
					// flickerTime 800
					window.userSettingEntry.flickerTime = ugse.flickerTime;
					self.userSettingEntry.flickerTime = ugse.flickerTime;
	
					window.userSettingEntry.pressEditList = ugse.pressEditList;
					self.userSettingEntry.pressEditList = ugse.pressEditList;
	
					// isAutoSavePrompt false
					window.userSettingEntry.isAutoSavePrompt = ugse.isAutoSavePrompt;
					self.userSettingEntry.isAutoSavePrompt = ugse.isAutoSavePrompt;
					// $("#isAutoSavePromptCheckBox").prop("checked",false);
	
					// isDebug false
					window.userSettingEntry.isDebug = ugse.isDebug;
					self.userSettingEntry.isDebug = ugse.isDebug;
					// $("#isDebugCheckBox").prop("checked", false);
	
					// isDelPrompt true
					window.userSettingEntry.isDelPrompt = ugse.isDelPrompt;
					self.userSettingEntry.isDelPrompt = ugse.isDelPrompt;
					// $("#isDelPromptCheckBox").prop("checked",true);
	
					window.userSettingEntry.showBottomSum = ugse.showBottomSum;
					self.userSettingEntry.showBottomSum = ugse.showBottomSum;
	
					// isEditMode true
					window.userSettingEntry.isEditMode = ugse.isEditMode;
					self.userSettingEntry.isEditMode = ugse.isEditMode;
					// $("#isEditModeCheckBox").prop("checked",true);
	
					// isRecSavePrompt false
					window.userSettingEntry.isRecSavePrompt = ugse.isRecSavePrompt;
					self.userSettingEntry.isRecSavePrompt = ugse.isRecSavePrompt;
					// $("#isRecSavePromptCheckBox").prop("checked",false);
	
					// isReportBrowser true
					window.userSettingEntry.isReportBrowser = ugse.isReportBrowser;
					self.userSettingEntry.isReportBrowser = ugse.isReportBrowser;
					// $("#isReportBrowserCheckBox").prop("checked",true);
	
					// isShowBusyRemote true
					window.userSettingEntry.isShowBusyRemote = ugse.isShowBusyRemote;
					self.userSettingEntry.isShowBusyRemote = ugse.isShowBusyRemote;
					// $("#isShowBusyRemoteCheckBox").prop("checked",true);
	
					// isStayWindowMem true
					window.userSettingEntry.isStayWindowMem = ugse.isStayWindowMem;
					self.userSettingEntry.isStayWindowMem = ugse.isStayWindowMem;
	
					// useFixedMainMenu true
					window.userSettingEntry.useFixedMainMenu = ugse.useFixedMainMenu;
					self.userSettingEntry.useFixedMainMenu = ugse.useFixedMainMenu;
	
					// useFixedForm false
					window.userSettingEntry.useFixedForm = ugse.useFixedForm;
					self.userSettingEntry.useFixedForm = ugse.useFixedForm;
	
					// ugse.downNewRec = false;
					window.userSettingEntry.downNewRec = ugse.downNewRec;
					self.userSettingEntry.downNewRec = ugse.downNewRec;
					// $("#downNewRecCheckBox").prop("checked",false);
	
					// ugse.showOprInfo = false;
					window.userSettingEntry.showOprInfo = ugse.showOprInfo;
					self.userSettingEntry.showOprInfo = ugse.showOprInfo;
	
					// ugse.showLeftMenu = true;
					window.userSettingEntry.showLeftMenu = ugse.showLeftMenu;
					self.userSettingEntry.showLeftMenu = ugse.showLeftMenu;
					// $("#showLeftMenuCheckBox").prop("checked",true);
	
	
					// ugse.showToolMenu = false;
					window.userSettingEntry.showToolMenu = ugse.showToolMenu;
					self.userSettingEntry.showToolMenu = ugse.showToolMenu;
					// $("#showToolMenuCheckBox").prop("checked",false);
	
					window.userSettingEntry.hideToolBar = ugse.hideToolBar;
					self.userSettingEntry.hideToolBar = ugse.hideToolBar;
	
					window.userSettingEntry.innerToolBar = ugse.innerToolBar;
					self.userSettingEntry.innerToolBar = ugse.innerToolBar;
	
					self.componentDidMount();
				};
				// var loadFaultHandler = function(data){
	
				// }
				// var Fun = function (data){
				// 	console.log(data);
				// }
				var remoteArg = {
					command: command,
					// loadResultHandler, loadFaultHandler,
					resultFunction: Fun,
					sync: false
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.saveGlobalHandler = function () {
				var ugse = _this.userSettingEntry;
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
	
				command.appendArg("_default");
				command.appendArg(ugse, "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");
				var saveGlobalResultHandler = function saveGlobalResultHandler(data) {
					if (Boolean(data.result)) {
						var options = {
							state: 'success',
							text: "已成功保存您的偏好设置"
						};
						_Fade2.default.show(options);
					} else {
						//   alert("保存失败", "提示");
						var options = {
							state: 'error',
							text: "保存失败"
						};
						_Fade2.default.show(options);
					}
				};
				var remoteArg = {
					command: command,
					// saveGlobalResultHandler, saveGlobalFaultHandler,
					resultFunction: saveGlobalResultHandler,
					sync: false
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.userSettingEntry = Object.assign({ remoteClass: "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity" }, window.userSettingEntry);
			// this.userSettingEntry.remoteClass = "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity";
			// this.userSettingEntry = {
			// 	autoEnterList:false,
			// 	clickEnterList:true,
			// 	downNewRec:false,
			// 	flickerTime:1000,
			// 	isAutoSavePrompt:false,
			// 	isDebug:false,
			// 	isDelPrompt:true,
			// 	isEditMode:true,
			// 	isRecSavePrompt:false,
			// 	isReportBrowser:true,
			// 	isShowBusyRemote:true,
			// 	isStayWindowMem:true,
			// 	showLeftMenu:true,
			// 	showOprInfo:false,
			// 	showToolMenu:false,
			// 	useFixedForm:false,
			// 	useFixedMainMenu:true
			// }
			console.log(_this.userSettingEntry);
	
			//判断是否是管理员
			_this.userInfos = window.userInfos;
			console.log(_this.userInfos);
			if (_this.userInfos.userGroups.indexOf("admin") != -1 || _this.userInfos.userGroups.indexOf("Admin") != -1) {
				_this.isAdmin = true;
			} else {
				_this.isAdmin = false;
			}
			console.log(_this.isAdmin);
	
			_this.state = {};
			return _this;
		}
	
		_createClass(GlobalUserSetForm, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.isAdmin == false) {
					$("#tabli_5").css("display", "none");
				} else {
					$("#tabli_5").css("display", "block");
				}
	
				$(".tab_container > div > label > input[type='checkbox']").prop("checked", false);
	
				var init = this.userSettingEntry;
				if (init.autoEnterList == true) {
					$("#autoEnterListCheckBox").prop("checked", true);
				}
				if (init.clickEnterList == true) {
					$("#clickEnterListCheckBox").prop("checked", true);
				}
				if (init.pressEditList == true) {
					$("#clickPressEditCheckBox").prop("checked", true);
				}
				if (init.downNewRec == true) {
					$("#downNewRecCheckBox").prop("checked", true);
				}
				if (init.isAutoSavePrompt == true) {
					$("#isAutoSavePromptCheckBox").prop("checked", true);
				}
				if (init.isDebug == true) {
					$("#isDebugCheckBox").prop("checked", true);
				}
				if (init.isDelPrompt == true) {
					$("#isDelPromptCheckBox").prop("checked", true);
				}
	
				if (init.showBottomSum == true) {
					$("#isShowBottomSumCheckBox").prop("checked", true);
				}
	
				if (init.isEditMode == true) {
					$("#isEditModeCheckBox").prop("checked", true);
				}
	
				if (init.isRecSavePrompt == true) {
					$("#isRecSavePromptCheckBox").prop("checked", true);
				}
				if (init.isReportBrowser == true) {
					$("#isReportBrowserCheckBox").prop("checked", true);
				}
				if (init.isShowBusyRemote == true) {
					$("#isShowBusyRemoteCheckBox").prop("checked", true);
				}
				if (init.isStayWindowMem == true) {
					//   $("#isStayWindowMemCheckBox").prop("checked", true);
				}
				if (init.showLeftMenu == true) {
					$("#showLeftMenuCheckBox").prop("checked", true);
				}
	
				if (init.showLeftListMenu == true) {
					$("#showLeftListMenuCheckBox").prop("checked", true);
				}
	
				if (init.hideToolBar == true) {
					$("#hideToolBarCheckBox").prop("checked", true);
				}
	
				if (init.innerToolBar == true) {
					$("#innerToolBarCheckBox").prop("checked", true);
				}
	
				if (init.showOprInfo == true) {
					//   $("#showOprInfoCheckBox").prop("checked", true);
				}
				if (init.showToolMenu == true) {
					$("#showToolMenuCheckBox").prop("checked", true);
				}
				if (init.useFixedForm == true) {
					//   $("#useFixedFormCheckBox").prop("checked", true);
				}
				if (init.useFixedMainMenu == true) {
					//   $("#useFixedMainMenuCheckBox").prop("checked", true);
				}
			}
	
			//关闭
	
		}, {
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					{ style: { alignSelf: "center", borderRadius: "2px", backgroundColor: 'white', width: '600px', height: '410px', display: 'flex', flexDirection: 'column', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' } },
					_react2.default.createElement(
						'div',
						{ className: 'modal-header', style: _defineProperty({ background: "#ffffff", padding: "10px", position: "relative", paddingTop: "15px", paddingBottom: "15px" }, 'background', "#F8F8F8") },
						_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideGlobalUserSetForm.bind(this) }),
						_react2.default.createElement(
							'h5',
							{ className: 'modal-title' },
							'\u53C2\u6570\u8BBE\u7F6E'
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { display: 'flex', flexDirection: 'column', flexGrow: 100, padding: '5px' } },
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', flexDirection: 'row', flexGrow: 100, boxShadow: 'none', borderRadius: '3px' } },
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'column', width: '900px' } },
								_react2.default.createElement(
									'div',
									{ className: 'nav-tabs-custom', style: { 'marginBottom': '0', display: 'flex', flexDirection: 'column', height: '100%', boxShadow: 'none' } },
									_react2.default.createElement(
										'ul',
										{ className: 'nav nav-tabs', style: { paddingTop: '8px' } },
										_react2.default.createElement(
											'li',
											{ id: 'tabli_1', className: 'active' },
											_react2.default.createElement(
												'a',
												{ style: { paddingBottom: '10px' }, className: 'gongqi_tabpage', href: '#globalUserSetForm_tab_1', 'data-toggle': 'tab', 'aria-expanded': 'false' },
												'\u4EA4\u4E92'
											)
										),
										_react2.default.createElement(
											'li',
											{ id: 'tabli_2' },
											_react2.default.createElement(
												'a',
												{ style: { paddingBottom: '10px' }, className: 'gongqi_tabpage', id: 'globalUserSetForm_tab_btn_2', href: '#globalUserSetForm_tab_2', 'data-toggle': 'tab', 'aria-expanded': 'false' },
												'\u753B\u9762'
											)
										),
										_react2.default.createElement(
											'li',
											{ id: 'tabli_3' },
											_react2.default.createElement(
												'a',
												{ style: { paddingBottom: '10px' }, className: 'gongqi_tabpage', id: 'globalUserSetForm_tab_btn_3', href: '#globalUserSetForm_tab_3', 'data-toggle': 'tab', 'aria-expanded': 'false' },
												'\u62A5\u8868'
											)
										),
										_react2.default.createElement(
											'li',
											{ id: 'tabli_4' },
											_react2.default.createElement(
												'a',
												{ style: { paddingBottom: '10px' }, className: 'gongqi_tabpage', id: 'globalUserSetForm_tab_btn_4', href: '#globalUserSetForm_tab_4', 'data-toggle': 'tab', 'aria-expanded': 'false' },
												'\u8C03\u8BD5'
											)
										),
										_react2.default.createElement(
											'li',
											{ id: 'tabli_5' },
											_react2.default.createElement(
												'a',
												{ style: { paddingBottom: '10px' }, className: 'gongqi_tabpage', id: 'globalUserSetForm_tab_btn_5', href: '#globalUserSetForm_tab_5', 'data-toggle': 'tab', 'aria-expanded': 'false' },
												'\u5168\u5C40'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'tab-content', style: { 'padding': '0px', flexGrow: 100, width: '100%', height: '100%' } },
										_react2.default.createElement(
											'div',
											{ className: 'active tab-pane', id: 'globalUserSetForm_tab_1', style: { width: '100%', height: '100%', padding: '1px', flexDirection: 'row', paddingTop: '10px' } },
											_react2.default.createElement(
												'div',
												{ className: 'tab_container', style: { height: '100%' } },
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'isShowBusyRemoteCheckBox', name: '', value: 'on', onClick: this.changeisShowBusyRemote }),
														'\u8FDC\u7A0B\u4EA4\u4E92\u65F6\u9F20\u6807\u5FD9\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'isDelPromptCheckBox', name: '', value: 'on', onClick: this.changeisDelPrompt }),
														'\u8BB0\u5F55\u5220\u9664\u65F6\u662F\u5426\u63D0\u9192\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { display: 'none', paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'isShowBottomSumCheckBox', name: '', value: 'off', onClick: this.changeBottomSumShow }),
														'\u662F\u5426\u663E\u793A\u5E95\u90E8\u5408\u8BA1\u680F\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { display: 'none', paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'downNewRecCheckBox', name: '', value: 'on', onClick: this.changedownNewRec }),
														'\u5217\u8868\u4E2D\u4E0B\u79FB\u8BB0\u5F55\u65F6\u65B0\u589E\u8BB0\u5F55\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'isEditModeCheckBox', name: '', value: 'on', onClick: this.changeisEditMode }),
														'\u767B\u9646\u9ED8\u8BA4\u7F16\u8F91\u6A21\u5F0F\u2003'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane', id: 'globalUserSetForm_tab_2', style: { width: '100%', height: '100%', paddingTop: '10px' } },
											_react2.default.createElement(
												'div',
												{ className: 'tab_container', style: { height: '100%' } },
												_react2.default.createElement(
													'div',
													{ draggable: 'true', id: '', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'autoEnterListCheckBox', name: '', value: 'on', onClick: this.changeautoEnterList }),
														'\u5217\u8868\u81EA\u52A8\u8FDB\u5165\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { display: 'none', paddingLeft: '15px' }, id: '' },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'clickEnterListCheckBox', name: '', value: 'on', onClick: this.changeclickEnterList }),
														'\u5217\u8868\u5355\u51FB\u53EF\u7F16\u8F91\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'clickPressEditCheckBox', name: '', value: 'on', onClick: this.changePressEditList }),
														'\u5217\u8868\u8F93\u5165\u65F6\u81EA\u52A8\u7F16\u8F91\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'showLeftMenuCheckBox', name: '', value: 'on', onClick: this.changeshowLeftMenu }),
														'\u4F7F\u7528\u5DE6\u4FA7\u6811\u5F62\u83DC\u5355\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'showLeftListMenuCheckBox', name: '', value: 'off', onClick: this.changeshowLeftListMenu }),
														'\u4F7F\u7528\u5DE6\u4FA7\u5217\u8868\u83DC\u5355\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', id: '', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'showToolMenuCheckBox', name: '', value: 'off', onClick: this.changeshowToolMenu }),
														'\u4F7F\u7528\u5DE5\u5177\u680F\u83DC\u5355\u2003'
													)
												),
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', id: 'innerToolBarCheckBox', name: '', value: 'off', onClick: this.changeInnerToolBar }),
														'\u628A\u5DE5\u5177\u680F\u653E\u5728\u753B\u9762\u5185\u2003'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane', id: 'globalUserSetForm_tab_3', style: { width: '100%', height: '100%', paddingTop: '10px' } },
											_react2.default.createElement(
												'div',
												{ className: 'tab_container', style: { height: '100%' } },
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', name: '', id: 'isReportBrowserCheckBox', value: 'on', onClick: this.changeisReportBrowser }),
														'\u4F7F\u7528\u6D4F\u89C8\u5668\u9884\u89C8\u62A5\u8868\u2003'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane', id: 'globalUserSetForm_tab_4', style: { width: '100%', height: '100%', paddingTop: '10px' } },
											_react2.default.createElement(
												'div',
												{ className: 'tab_container', style: { height: '100%' } },
												_react2.default.createElement(
													'div',
													{ draggable: 'true', style: { paddingLeft: '15px' } },
													_react2.default.createElement(
														'label',
														null,
														_react2.default.createElement('input', { style: { marginRight: '10px' }, type: 'checkbox', name: '', id: 'isDebugCheckBox', value: 'on', onClick: this.changeisDebug }),
														'\u8C03\u8BD5\u6A21\u5F0F\u2003'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane', id: 'globalUserSetForm_tab_5', style: { width: '100%', height: '100%', paddingTop: '10px' } },
											_react2.default.createElement(
												'div',
												{ className: 'tab_container', style: { height: '100%' } },
												_react2.default.createElement(
													'div',
													{ style: { width: '100%', textAlign: 'center', paddingTop: '50px' } },
													_react2.default.createElement(
														'button',
														{ type: 'button', className: 'btn btn-info', onClick: this.loadGlobalHandler },
														'\u52A0\u8F7D\u5168\u5C40\u9ED8\u8BA4\u8BBE\u7F6E'
													)
												),
												_react2.default.createElement(
													'div',
													{ style: { width: '100%', textAlign: 'center' } },
													_react2.default.createElement(
														'button',
														{ type: 'button', className: 'btn btn-info', onClick: this.saveGlobalHandler },
														'\u4FDD\u5B58\u4E3A\u5168\u5C40\u9ED8\u8BA4\u8BBE\u7F6E'
													)
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', flexDirection: 'horizontal', flexGrow: 0, paddingTop: '10px', paddingBottom: '10px' } },
							_react2.default.createElement('div', { style: { flexGrow: 100 } }),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { height: '25px', marginRight: '5px', marginTop: '5px' }, onClick: this.btnRestore_clickHandler },
								'\u6062\u590D\u9ED8\u8BA4'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { height: '25px', marginTop: '5px' }, onClick: this.btnsave_clickHandler },
								'\u4FDD\u5B58'
							)
						)
					)
				);
			}
		}]);
	
		return GlobalUserSetForm;
	}(_react2.default.Component);
	
	exports.default = GlobalUserSetForm;

/***/ },
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var faker = __webpack_require__(69);
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var JobsDataGrid = function (_React$Component) {
	  _inherits(JobsDataGrid, _React$Component);
	
	  function JobsDataGrid(props, context) {
	    _classCallCheck(this, JobsDataGrid);
	
	    // var rows=this.props.rows;
	    // var columns=this.props.columns;
	
	    var _this = _possibleConstructorReturn(this, (JobsDataGrid.__proto__ || Object.getPrototypeOf(JobsDataGrid)).call(this, props, context));
	
	    _this.createRows = function (numberOfRows) {
	      var rows = [];
	      for (var i = 0; i < numberOfRows; i++) {
	        rows[i] = _this.createFakeRowObjectData(i);
	      }
	      return rows;
	
	      /*let rows= this.state.rows.slice();
	      rows=xxxx;
	      this.setState({rows:rows})
	        let columns=this.state.columns.slice();
	      columns=xxx;
	      this.setState({columns:columns});*/
	    };
	
	    _this.createFakeRowObjectData = function (index, data) {
	      console.log(data);
	      for (var i = 0; i < data.length; i++) {
	        var rows = _this.state.rows.slice();
	        var _index = _this.state.rows.length;
	        return {
	          id: 'id_' + _index,
	          title: tableName[i],
	          firstName: itemName[i],
	          lastName: lastName[i]
	        };
	      }
	    };
	
	    _this.getColumns = function () {
	      var columns = _this.state.columns.slice();
	      return columns;
	    };
	
	    _this.test = function () {
	      console.log('1');
	    };
	
	    _this.handleGridRowsUpdated = function (_ref) {
	      var fromRow = _ref.fromRow,
	          toRow = _ref.toRow,
	          updated = _ref.updated;
	
	      var rows = _this.state.rows.slice();
	
	      for (var i = fromRow; i <= toRow; i++) {
	        var rowToUpdate = rows[i];
	        var updatedRow = $.extend(rowToUpdate, updated);
	        rows[i] = updatedRow;
	      }
	      _this.setState({ rows: rows });
	    };
	
	    _this.handleAddRow = function () {
	      var rows = _this.state.rows.slice();
	      for (var i = fromRow; i <= toRow; i++) {
	        var rowToUpdate = rows[i];
	        var updatedRow = $.extend(rowToUpdate, updated);
	        rows[i] = updatedRow;
	      }
	      _this.setState({ rows: rows });
	    };
	
	    _this.deleteRow = function () {
	      var rows = _this.state.rows.slice();
	      var selectedIndex = _this.state.selectedIndexes[0];
	      rows.splice(selectedIndex, 1);
	      _this.setState({ rows: rows, selectedIndexes: [rows.length - 1] });
	    };
	
	    _this.getRowAt = function (index) {
	      if (index < 0 || index > _this.getSize()) {
	        return undefined;
	      }
	
	      return _this.state.rows[index];
	    };
	
	    _this.getSize = function () {
	      return _this.state.rows.length;
	    };
	
	    _this.rowClick = function (index, record, proxy) {
	      _this.setState({ selectedIndexes: [index] });
	    };
	
	    _this.updateColumns = function (columns) {
	      _this.props.columns = columns;
	      _this.setState();
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      var comparer = function comparer(a, b) {
	        if (sortDirection === 'ASC') {
	          return a[sortColumn] > b[sortColumn] ? 1 : -1;
	        } else if (sortDirection === 'DESC') {
	          return a[sortColumn] < b[sortColumn] ? 1 : -1;
	        }
	      };
	
	      var rows = sortDirection === 'NONE' ? _this.state.rows.slice(0) : _this.state.rows.sort(comparer);
	
	      _this.setState({ rows: rows });
	    };
	
	    _this.componentDidUpdate = function () {
	      var columns = _this.state.columns.slice();
	    };
	
	    _this.state = { rows: [], selectedIndexes: [], columns: [] };
	    return _this;
	  }
	
	  _createClass(JobsDataGrid, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(ReactDataGrid, {
	
	        ref: function ref(node) {
	          return _this2.grid = node;
	        }
	        // onGridSort={this.handleGridSort}
	        , enableCellSelect: true,
	        columns: this.state.columns.slice() //columns={this.state.columns}
	        // columns={this.props.columns}
	        // columns={this.getColumns()}
	        , rowGetter: this.getRowAt,
	        rowsCount: this.getSize(),
	        onGridRowsUpdated: this.handleGridRowsUpdated
	        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	        , enableRowSelect: false,
	        rowSelection: {
	          showCheckbox: false,
	          selectBy: {
	            indexes: this.state.selectedIndexes
	
	          }
	        },
	        onRowClick: this.rowClick //this.rowClick this.rowClick.bind(this)
	        // rowHeight={30}
	        // minHeight={375}
	        , rowScrollTimeout: 500,
	        cellNavigationMode: 'loopOverRow'
	
	      });
	    }
	  }]);
	
	  return JobsDataGrid;
	}(React.Component);
	
	exports.default = JobsDataGrid;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _JobsDataGrid = __webpack_require__(527);
	
	var _JobsDataGrid2 = _interopRequireDefault(_JobsDataGrid);
	
	var _TabFromItem = __webpack_require__(529);
	
	var _TabFromItem2 = _interopRequireDefault(_TabFromItem);
	
	var _styles = __webpack_require__(775);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobsForm = function (_React$Component) {
		_inherits(JobsForm, _React$Component);
	
		function JobsForm(props, context) {
			_classCallCheck(this, JobsForm);
	
			var _this = _possibleConstructorReturn(this, (JobsForm.__proto__ || Object.getPrototypeOf(JobsForm)).call(this, props, context));
	
			_this.hideJobsForm = function () {
				var $reactComponentContainer = $("#JobsFormDiv");
				_reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
				//$reactComponentContainer.remove();
				$("#JobsFormDiv").empty().css("display", "none");
			};
	
			_this.onPaste = function (e) {
				// alert("触发了粘贴");
				var cpTxt = "复制的数据";
				var clipboardData = window.clipboardData; //for IE
				if (!clipboardData) {
					// for chrome
					clipboardData = e.clipboardData;
				}
				var result = clipboardData.getData("text") + ":" + cpTxt;
			};
	
			_this.PasteFun = function (e) {
	
				var cbd = e.clipboardData;
				var ua = window.navigator.userAgent;
	
				e.stopPropagation();
				e.preventDefault();
	
				// 如果是 Safari 直接 return
				if (!cbd || !cbd.items || !cbd.types) return;
	
				// Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉
				if (cbd.items.length === 2 && cbd.items[0].kind === 'string' && cbd.items[1].kind === 'file' && cbd.types.length === 2 && cbd.types[0] === 'text/plain' && cbd.types[1] === 'Files' && ua.match(/Macintosh/i) && ~~ua.match(/Chrome\/(\d{2})/i)[1] < 49) return;
	
				// for (let i = 0, len = cbd.items.length; i < len; i++) {
				//   let item = cbd.items[i];
				//   // 文件类型上传
				//   if (item.kind === 'file') {
				//     let blob = item.getAsFile();
				//     if (blob.size === 0) return;
				//     let fileName = cbd.getData('text/plain');
				//     // 上传文件
				//     return uploader(blob, { name: fileName });
				//   }
				// }
				var text = cbd.getData('text/plain');
				_this.pastedata = text;
	
				var pastetype = _this.state.pastetype;
	
				_this.setState({
					IsPaste: 1
				});
				switch (pastetype) {
					case 1:
						_this.DataGirdViewCellPaste();
						break;
					case 2:
						_this.PasteString();
						break;
					default:
						_this.paste1Handler();
						break;
				}
			};
	
			_this.PasteString = function () {
				var text = _this.pastedata;
				$("#txtModeInput").val(text);
			};
	
			_this.DataGirdViewCellPaste = function (e) {
				$("#inputDataGridText").css("display", "none");
				$("#inputDataGrid").css("display", "block");
	
				// var data = $("#inputDataGridText textarea").val();
				var data = _this.pastedata;
				// alert(data);
	
				var text = data;
				var colNum = 0;
	
				var _this$state = _this.state,
				    PasteJobName = _this$state.PasteJobName,
				    PasteJobDes = _this$state.PasteJobDes;
	
	
				var remotearg = _this.state;
	
				if (remotearg == null) return null;
	
				if (text == null || text == "") {
					FadeAlert.show("未在剪贴板中找到文本数据");
					return null;
				}
				try {
					var rows = text.split("\n");
					var colnum = -1;
					var ac = [];
					var obj;
					var i = 0;
					var k = 0;
					var headers = [];
					var gc;
					for (var n = 0; n < rows.length; n++) {
						//for each(var row: String in rows) {
						var row = rows[n];
						if (row == "") continue;
						var columns = row.split(/[\t]/g);
						if (colnum == -1) colnum = columns.length;
						k = 0;
						obj = {};
						for (var m = 0; m < columns.length; m++) {
							//for each(var coldata: String in columns) {
							var coldata = columns[m];
							if (i == 0) {
								gc = {};
								if (remotearg.isDataWithHeader == true) {
									gc.name = coldata;
									gc.key = coldata;
									gc.resizable = true;
								} else {
									obj[k] = coldata;
									gc.key = k;
									gc.resizable = true;
								}
								//gc.dataField = String(k);
								headers.push(gc);
							} else {
								//第一行与第二行所标识的列数不一样 以第一行为准 后面的将忽略
								if (k > headers.length - 1) {
									gc = {};
									gc.name = " ";
									gc.key = k;
									gc.resizable = true;
									headers.push(gc);
									//break;
								}
								var key = headers[k].key;
								obj[key] = coldata;
								//obj[String(k)] = coldata;
							}
							k++;
							if (colNum != 0 && k == colNum) break;
						}
	
						if (remotearg.isDataWithHeader == true) {
							if (i != 0) ac.push(obj);
						} else {
							ac.push(obj);
						}
						i++;
					}
					//g.columns = headers;
					//g.dataProvider = ac;
					//if(gdata)gdata = ac;else g.dataProvider = ac;
	
				} catch (e) {
					alert("无法解析复制的文本");
				}
	
				// this.jobsDataGrid.setState({rows:ac});
				// const{PasteHeader,PasteData,PasteType} = this.state;
				console.log(headers);
	
				_this.jobsDataGrid.setState({
					columns: headers,
					rows: ac
				});
				setTimeout(_this.jobsDataGrid.forceUpdate.bind(_this.jobsDataGrid), 100);
	
				_this.setState({
					GridDataList: ac
				});
				// return;
	
				// 	var result = {columns:headers,datas:ac};
				// 	return result;
				// 	var rowdata = result.datas;
				// }
			};
	
			_this.paste1Handler = function () {
				var _this$state2 = _this.state,
				    Remotearg = _this$state2.Remotearg,
				    PasteHeader = _this$state2.PasteHeader;
				//   var text = $("#inputDataGridText textarea").val(); //剪切板内容
	
				var text = _this.pastedata;
				if (text == null || text == "") {
					alert("未在剪贴板中找到文本数据");
					return;
				}
				var remotearg = Remotearg;
				var grid1Data = PasteHeader;
				// var task.arg = remotearg;
				if (!remotearg) return;
				if (remotearg.fields && remotearg.fields.length > 0) {
					var rows = text.split("\n");
					for (var i = 0; i < grid1Data.length; i++) {
						var item = grid1Data[i];
						if (i >= rows.length) break;
						var row = rows[i];
						if (row == "") continue;
						var columns = row.split(/[\t]+/g);
						var value = columns[columns.length - 1];
						item.value = value;
					}
					//   grid1Data.refresh();
				} else {
	
					var newGrid1Data = [];
					var rows = text.split("\n");
					for (var i = 0; i < rows.length; i++) {
						var row = rows[i];
						if (row == "") continue;
						var columns = row.split(/[\t]+/g);
						if (columns.length == 0) break;
						if (columns.length == 1) columns.unshift(i);
						var item = {};
						for (var k = 0; k < 2; k++) {
							var key = k == 0 ? "key" : "value";
							item[key] = columns[k];
						}
						newGrid1Data.push(item);
					}
					grid1Data = newGrid1Data;
				}
	
				var PasteType = _this.state.PasteType;
	
				var headerss = [{
					// id: 'grid1Column0',
					key: 'key',
					name: '属性名称'
				}, {
					// id: 'grid1Column1',
					key: 'value',
					name: '属性值'
				}];
	
				_this.jobsDataGrid.setState({
					columns: headerss,
					rows: grid1Data
				});
				setTimeout(_this.jobsDataGrid.forceUpdate.bind(_this.jobsDataGrid), 100);
	
				_this.setState({
					Grid1Data: grid1Data
				});
	
				$("#inputDataGridText").css("display", "none");
				$("#DataGridpaste").css("display", "block");
				$("#inputDataGrid").css("display", "block");
			};
	
			_this.testRemoteClass = function () {
				var _this$state3 = _this.state,
				    ChoseJobName = _this$state3.ChoseJobName,
				    ResultObj = _this$state3.ResultObj;
	
				var jobName = ChoseJobName;
				var _resultobj = ResultObj;
				var self = _this;
				// var selectedItem:Object = listJobs.selectedItem as Object;
				// if(selectedItem == null)
				// 	return;
	
				if (jobName == null) return;
	
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.JobService", "execute", "Object");
	
				command.appendArg(jobName);
	
				var argType;
				var argValue;
	
				var _arg;
	
				if (_resultobj.paramType == "String") {
					if (_resultobj.paramClipboard) {
						// const{IsPaste}= this.state;
						// if(IsPaste == 0){
						// 	alert("请先点击粘贴，然后远程调用");
						// 	return false;
						// }
						_arg = _this.getInData(_resultobj.paramClipboard);
					} else {
						_arg = $("#jobsinput10001").val();
					}
	
					argType = "String";
					argValue = _arg;
				} else if (_resultobj.paramType != null) {
					if (_resultobj.paramClipboard) {
						var IsPaste = _this.state.IsPaste;
	
						if (IsPaste == 0) {
							alert("请先点击粘贴，然后远程调用");
							return false;
						}
						_arg = _this.getInData(_resultobj.paramClipboard);
					} else _arg = $("#jobsinput10001").text;
	
					argType = _resultobj.paramType;
					argValue = _arg;
				} else {
					argType = null;
					argValue = null;
				}
	
				command.appendArg(argType, "String");
				command.appendArg(argValue, "Object");
	
				var self2 = _this;
	
				var rpc_result_btnSubmit = function rpc_result_btnSubmit(data) {
					console.log(data);
					var Remotearg = self2.state.Remotearg;
	
					var remotearg = Remotearg;
					var event = data;
					//var obj:gongqi.erp.forms.sys.remote.Clipboard = event.result as gongqi.erp.forms.sys.remote.Clipboard;
					if (event.result == null) {
						alert("远程调用成功");
	
						//   Warning.show({text:"1"});
						// outbox.enabled = false;tabnav.selectedChild = normalbox;//远程调用返回不显示 
					} else if (remotearg || event.result.mode == "Out") {
						//远程调用数据返回
						self.setState({
							tabhandle3: 'tab',
							tabhref3: '#jobsForm_tab_3'
						});
						$("#jobsForm_tab_btn_3").removeClass("noclickBtn");
	
						$("#jobsForm_tab_1").removeClass("active");
						$("#tabli_1").removeClass("active");
						$("#jobsForm_tab_2").removeClass("active");
						$("#tabli_2").removeClass("active");
	
						$("#jobsForm_tab_3").addClass("active");
						$("#tabli_3").addClass("active");
						// outbox.enabled = true;tabnav.selectedChild = outbox;
	
						var remotearg = event.result;
	
						if (remotearg.type == "Text") {
							// self.setState({
							// 	tabactive:3
							// })
							// remotepasteoutdialog.mode0Text = remotearg.data as String;
							$("#txtModeOutput").val(remotearg.data);
						} else if (remotearg.type == "KeyValue") {
							$("#outputTextarea").css("display", "none");
							$("#outputDataGrid").css("display", "block");
							if (remotearg.fields && remotearg.fields.length > 1) {
								var datas = new Array();
								for (var key in remotearg.data)
								// for (var m= 0; m < remotearg.data.count; m++)
								{
									// var key = remotearg.data[m];
									var data1 = {};
									var keyLabel = "";
									// for each(var field:ClipboardField in remotearg.fields)
									for (var i = 0; i < remotearg.fields.length; i++) {
										var field = remotearg.fields[i];
										if (field.dataField == key) keyLabel = field.label == "" || field.label == null ? key : field.label;
									}
									data1["key"] = keyLabel;
									data1["value"] = remotearg.data[key];
									datas.push(data1);
								}
								if (datas == null) {
									datas = [];
								}
								console.log(datas);
								var headerss = [{
									// id: 'grid1Column0',
									key: 'key',
									name: '属性名称'
								}, {
									// id: 'grid1Column1',
									key: 'value',
									name: '属性值'
								}];
								self2.jobsDataGridOut.setState({
									columns: headerss,
									rows: datas
									// rows: ac
								});
								setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
							} else {
								var datas = {};
								for (var key in remotearg.data)
								// for(var j = 0 ; j < remotearg.data ;j++)
								{
									// var key = remotearg.data[j];
									var data1 = {};
									data1["key"] = key;
									data1["value"] = remotearg.data[key];
									datas.push(data1);
								}
								if (datas == null) {
									datas = [];
								}
								console.log(datas);
								var headerss = [{
									// id: 'grid1Column0',
									key: 'key',
									name: '属性名称'
								}, {
									// id: 'grid1Column1',
									key: 'value',
									name: '属性值'
								}];
								self2.jobsDataGridOut.setState({
									columns: headerss,
									rows: datas
								});
								setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
								// remotepasteoutdialog.grid1Data = datas;
							}
						} else if (remotearg.type == "DataGrid") {
							$("#outputTextarea").css("display", "none");
							$("#outputDataGrid").css("display", "block");
							if (remotearg.fields) {
								var headers = [];
								var remotobj = remotearg.fields;
								remotobj.map(function (val) {
									var gc = {};
									// gc.headerText = val.label;
									// gc.dataField = val.dataField;
									gc.name = val.label;
									gc.key = val.dataField;
									gc.type = val.fieldType;
									gc.numOfDecimals = val.numOfDecimals;
									gc.width = 100;
									headers.push(gc);
								});
								// forEach(field in remotearg.fields)
								// for(var k = 0 ; k < remotearg.fields.length ; k++)
								// {
								// 	var field = remotearg.fields[k];
								// 	var gc = [];
								// 	gc.headerText = field.label;
								// 	gc.dataField = field.dataField;
								// 	gc.type = field.fieldType;
								// 	gc.numOfDecimals = field.numOfDecimals;
								// 	headers.push(gc);
								// }
								var GridDataList = self2.state.GridDataList;
								// console.log(GridDataList);
	
								console.log(headers);
								self2.jobsDataGridOut.setState({
									columns: headers,
									rows: remotearg.data
								});
								setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
								// remotepasteoutdialog.gridColumns = headers;
								// remotepasteoutdialog.gridDataProvider = remotearg.data as ArrayCollection;
							} else {
								if (remotearg.data && remotearg.data.length > 0) {
									headers = new Array();
									var first = remotearg.data[0];
									for (var key in first)
									// for(var i = 0 ; i < first.length ; i ++)
									{
										// var key = first[i];
										var gc = [];
										gc.headerText = key;
										gc.dataField = key;
										headers.push(gc);
									}
									var _GridDataList = self2.state.GridDataList;
	
									self2.jobsDataGridOut.setState({
										columns: headers,
										rows: remotearg.data
									});
									setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
									// remotepasteoutdialog.gridColumns = headers;
									// remotepasteoutdialog.gridDataProvider = remotearg.data as ArrayCollection;
								} else {
									// AlertInfo.Instance.show("提示","服务端未能传回数据",0x4,Assert.ICON_INFO);
									alert("提示：服务端未能传回数据");
								}
							}
						} else // if(event.result is String)
							{
								var IsDate = false;
								var txtReturn;
								if (IsDate) {
									// txtReturn= StringHelper.dateToStringDateTime(event.result as Date);
								} else {
									txtReturn = event.result.toString();
									$("#jobsinput10000").val(txtReturn);
								}
								$("#jobsForm_tab_3").removeClass("active");
								$("#tabli_3").removeClass("active");
								$("#jobsForm_tab_2").removeClass("active");
								$("#tabli_2").removeClass("active");
	
								$("#jobsForm_tab_1").addClass("active");
								$("#tabli_1").addClass("active");
								// AlertInfo.Instance.show("远程调用结果",txtReturn.text,Alert.OK,Assert.ICON_INFO);
								//   Warning.show({text:txtReturn});
								//   alert("远程调用结果：" + txtReturn);
								var defaults = {
									state: "success",
									backgroundColor: undefined,
									color: "#fff",
									text: "远程调用结果: " + txtReturn,
									cornerRadius: "10",
									interacdestroy: true,
									cancel: {
										isShow: false,
										event: ''
									}
								};
								// alert("远程调用结果：" + txtReturn);
								_Warn2.default.show(defaults);
								// outbox.enabled = false;tabnav.selectedChild = normalbox;
							}
	
						// 	if(pasteoutdialogadded==false)
						// 	{
						// 		outbox.addChild(remotepasteoutdialog);pasteoutdialogadded = true;
						// 	}
					} else // if(event.result is String)
						{
							var IsDate = false;
							var txtReturn;
							if (IsDate) {
								// txtReturn= StringHelper.dateToStringDateTime(event.result as Date);
							} else {
								txtReturn = event.result.toString();
								$("#jobsinput10000").val(txtReturn);
							}
	
							//远程调用数据返回
							self.setState({
								tabhandle3: '',
								tabhref3: '#'
							});
							$("#jobsForm_tab_btn_3").addClass("noclickBtn");
	
							$("#jobsForm_tab_3").removeClass("active");
							$("#tabli_3").removeClass("active");
							$("#jobsForm_tab_2").removeClass("active");
							$("#tabli_2").removeClass("active");
	
							$("#jobsForm_tab_1").addClass("active");
							$("#tabli_1").addClass("active");
	
							// AlertInfo.Instance.show("远程调用结果",txtReturn.text,Alert.OK,Assert.ICON_INFO);
							//   Warning.show({text:txtReturn});
							// $("#jobsinput10000").val(txtReturn);
							var defaults = {
								state: "success",
								backgroundColor: undefined,
								color: "#fff",
								text: "远程调用结果: " + txtReturn,
								cornerRadius: "10",
								interacdestroy: true,
								cancel: {
									isShow: false,
									event: ''
								}
							};
							// alert("远程调用结果：" + txtReturn);
							_Warn2.default.show(defaults);
							// outbox.enabled = false;tabnav.selectedChild = normalbox;
						}
				};
	
				var remoteArg = { command: command, resultFunction: rpc_result_btnSubmit, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			};
	
			_this.clear = function () {
				$("#txtModeOutput").val("");
				$("#txtModeInput").val("");
				$("#inputDataGridText").css("display", "block");
				$("#inputDataGrid").css("display", "none");
				$("#outputTextarea").css("display", "block");
				$("#inputDataGrid").css("display", "none");
	
				_this.jobsDataGridOut.setState({
					colnums: [],
					rows: []
				});
				setTimeout(_this.jobsDataGridOut.forceUpdate.bind(_this.jobsDataGridOut), 100);
	
				_this.jobsDataGrid.setState({
					colnums: [],
					rows: []
				});
				setTimeout(_this.jobsDataGrid.forceUpdate.bind(_this.jobsDataGrid), 100);
			};
	
			_this.btnRefreshCurClickHandler = function (e) {
				var SelectJob = _this.state.SelectJob;
	
				_this.doRefreshSelectedJob(SelectJob);
			};
	
			_this.state = {
	
				SelectJob: '',
	
				pastetype: 0,
	
				// tabactive:1, //tab页的active状态  默认为1
				active: 0, // 0 是默认第一个，不要的话就空''
				tabhandle2: '',
				tabhref2: '#',
				tabhandle3: '',
				tabhref3: '#',
				tabtype: 'Null',
				jsondata: '',
	
				PasteType: '',
				PasteHeader: '',
				PasteData: '',
				PasteJobName: '',
				Remotearg: '',
				PasteJobDes: '',
				IsPaste: 0,
	
				ChoseJobName: '',
				ResultObj: '',
				Grid1Data: '', //用于存放
				GridDataList: ''
			};
	
			return _this;
		}
	
		_createClass(JobsForm, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.JobService", "jobs", "List");
				var _resultHandler = function _resultHandler(data) {
					window.jobsresult = data.result;
					_reactDom2.default.render(_react2.default.createElement(JobsForm, null), document.getElementById('JobsFormDiv'));
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
	
				$(this.JobsForm_Container).draggable({
					handle: ".modal-header" // 只能点击头部拖动
				}); //为模态对话框添加拖拽
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				if (window.jobsresult.length > 0 && this.state.active == 0) {
					if (this.state.SelectJob == "") {
						this.handleClick(0, window.jobsresult[0].jobName);
					}
				}
			}
		}, {
			key: 'test',
			value: function test() {
				alert("123");
			}
	
			//关闭
	
	
			//datagrid粘贴
	
	
			//KeyValuezhantie
	
		}, {
			key: 'doRefreshSelectedJob',
			value: function doRefreshSelectedJob(jobName) {
				this.clear();
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.JobService", "jobDeclaration", "Map");
				command.appendArg(jobName);
				var self = this;
				var _resultHandler = function _resultHandler(data) {
					var resultobj = data.result;
					var remotearg = resultobj.paramClipboard;
					self.setState({
						Remotearg: remotearg,
						ResultObj: resultobj
					});
	
					if (resultobj.paramType == null) {
						//右侧描述
						var type = "Null";
						self.setState({
							tabtype: type,
							jsondata: resultobj
						});
						// $("#DataGridpaste").css("display", 'none');
	
						//远程调用数据不可点击
						self.setState({
							tabhandle2: '',
							tabhref2: '#',
							tabhandle3: '',
							tabhref3: '#'
						});
						$("#jobsForm_tab_btn_2").addClass("noclickBtn");
						$("#jobsForm_tab_btn_3").addClass("noclickBtn");
	
						//调用返回不可点击
	
	
						// txtArg.editable = false;txtArg.prompt=resultobj.paramDescription==null?"该Job无需调用参数":resultobj.paramDescription;
						// inbox.enabled = false;
					} else if (resultobj.paramType == "String" && !remotearg) {
	
						//右侧描述
						var type = "String";
						self.setState({
							tabtype: type,
							jsondata: resultobj
						});
						// $("#DataGridpaste").css("display", 'none');
	
						//远程调用数据不可点击
						self.setState({
							tabhandle2: '',
							tabhref2: '#',
							tabhandle3: '',
							tabhref3: '#'
						});
						$("#jobsForm_tab_btn_2").addClass("noclickBtn");
						$("#jobsForm_tab_btn_3").addClass("noclickBtn");
	
						//调用返回不可点击
					}
					if (remotearg) {
	
						if (resultobj.paramType == "Map") {
							//右侧描述
							var type = "MAP";
							self.setState({
								tabtype: type,
								jsondata: resultobj,
								PasteJobName: jobName,
								PasteJobDes: resultobj.jobDescription,
								PasteType: 'KeyValue',
								pastetype: 0
							});
	
							$("#DataGridpaste").css("display", 'block');
							// $("#DataGridpaste").attr("onClick", "this.paste1Handler");
	
							//远程调用数据可点击
							self.setState({
								tabhandle2: 'tab',
								tabhref2: '#jobsForm_tab_2',
								tabhandle3: '',
								tabhref3: '#'
							});
							$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
							$("#jobsForm_tab_btn_3").addClass("noclickBtn");
	
							//调用返回不可点击
	
	
							if (remotearg.fields && remotearg.fields.length > 0) {
								var fixedData = [];
								// for each(var field:ClipboardField in remotearg.fields)
								for (var p = 0; p < remotearg.fields.length; p++) {
									var field = remotearg.fields.paramClipboard[p];
									fixedData.push({ key: field.label == "" ? RemotePasteDialog.typetocn[field.fieldType] : field.label, value: "", serverfield: field.dataField });
								}
								// remotepasteindialog.grid1Data = fixedData;
								self.setState({
									PasteHeader: fixedData
								});
							}
						} else if (resultobj.paramType == "List") //List
							{
								//右侧描述
								var type = "LIST";
								self.setState({
									tabtype: type,
									jsondata: resultobj,
									PasteJobName: jobName,
									PasteJobDes: resultobj.jobDescription,
									PasteType: 'List',
									pastetype: 1
								});
	
								$("#DataGridpaste").css("display", 'block');
	
								// $("#DataGridpaste").attr("onClick", "this.DataGirdViewCellPaste");
	
								//远程调用数据可点击
								self.setState({
									tabhandle2: 'tab',
									tabhref2: '#jobsForm_tab_2',
									tabhandle3: '',
									tabhref3: '#'
								});
								$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
								$("#jobsForm_tab_btn_3").addClass("noclickBtn");
	
								//调用返回不可点击
	
	
								// if(remotepasteindialog.gridColumns)
								// 	remotepasteindialog.gridColumns.removeAll();
								// remotepasteindialog.gridDataProvider = null;
								if (remotearg.fields) {
									var headers = [];
									// for each(field in remotearg.fields)
									for (var q = 0; q < remotearg.fields.length; q++) {
										var field = fields[q];
										var gc;
										gc.headerText = field.label;
										gc.dataField = field.dataField;
										gc.type = field.fieldType;
										gc.numOfDecimals = field.numOfDecimals;
										headers.push(gc);
									}
									// remotepasteindialog.gridColumns = headers;
								}
							} else if (resultobj.returnType == "Clipboard") {
							//右侧描述
							var type = "ReClipboard";
							self.setState({
								tabtype: type,
								jsondata: resultobj,
								PasteType: '',
								pastetype: 2
							});
							$("#DataGridpaste").css("display", 'none');
	
							//远程调用数据可点击
							self.setState({
								tabhandle2: 'tab',
								tabhref2: '#jobsForm_tab_2',
								tabhandle3: '',
								tabhref3: '#'
							});
							$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
							$("#jobsForm_tab_btn_3").addClass("noclickBtn");
	
							//调用返回不可点击
						} else {
							//右侧描述
							var type = "String";
							self.setState({
								tabtype: type,
								jsondata: resultobj,
								PasteType: ''
							});
							$("#DataGridpaste").css("display", 'none');
	
							//远程调用数据可点击
							self.setState({
								tabhandle2: 'tab',
								tabhref2: '#jobsForm_tab_2',
								tabhandle3: '',
								tabhref3: '#'
							});
							$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
							$("#jobsForm_tab_btn_3").addClass("noclickBtn");
						}
					}
				};
				var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
	
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		}, {
			key: 'handleClick',
			value: function handleClick(i, jobName) {
				var active = this.state.active;
	
				if (active === i && this.state.jsondata != '') {
					return;
				} else {
					//点击不同job
					console.log('i', i);
					this.setState({
						SelectJob: jobName,
						active: i,
						ChoseJobName: jobName
					});
					var jobsName = jobName;
					this.doRefreshSelectedJob(jobsName);
				}
			}
		}, {
			key: 'getInData',
			value: function getInData(remotearg) {
				var _state = this.state,
				    PasteType = _state.PasteType,
				    Remotearg = _state.Remotearg,
				    Grid1Data = _state.Grid1Data;
				// var remotearg = Remotearg;
	
				var grid1Data = Grid1Data;
				if (PasteType == "KeyValue") {
					var _arg = {};
					if (remotearg.fields && remotearg.fields.length > 0) {
						//grid1Data 是ReactDataGrid的rows
						// for each(var item:Object in grid1Data)
						for (var i = 0; i < grid1Data.length; i++) {
							var item = grid1Data[i];
							_arg[item.serverfield] = item.value;
						}
					} else {
						var grid1 = this.jobsDataGrid.state;
						//grid1就是keyvalue的reactDataGrid grid1.dataProvider就是它的rows
						// var ac = grid1.dataProvider ;
						var ac = grid1.rows;
						// columns【0】
						var column = new Array();
						column[0] = grid1.columns[0];
						column[1] = grid1.columns[1];
						//column的key
						var key1 = column[0].key;
						var key2 = column[1].key;
						// for each(item in ac)
						for (var j = 0; j < ac.length; j++) {
							var item = ac[j];
							_arg[item[key1]] = item[key2];
						}
					}
					return _arg;
				}
				//DataGrid
				else if (PasteType == "List") {
						//datagrid的rows
						var _jobsDataGrid$state = this.jobsDataGrid.state,
						    rows = _jobsDataGrid$state.rows,
						    columns = _jobsDataGrid$state.columns;
	
						var gridDataProvider = rows;
						_arg = gridDataProvider;
						if (!remotearg.fields && remotearg.isDataWithHeader) {
							if (_arg == null) _arg = {};
							var headerdata = {};
							//columns
							var grid = this.jobsDataGrid.state;
							for (var i = 0; i < grid.columns.length; i++) {
								var gc = grid.columns[i];
								//headerText就是column里面的name
								headerdata[gc.dataField] = gc.headerText;
							}
							_arg.push(headerdata, 0);
						}
						return _arg;
					}
	
				return $("#txtModeInput").val();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this,
				    _ref;
	
				var result1 = window.jobsresult;
				var _state2 = this.state,
				    tabactive = _state2.tabactive,
				    active = _state2.active,
				    tabhandle2 = _state2.tabhandle2,
				    tabhref2 = _state2.tabhref2,
				    tabhandle3 = _state2.tabhandle3,
				    tabhref3 = _state2.tabhref3,
				    tabtype = _state2.tabtype,
				    jsondata = _state2.jsondata;
	
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(node) {
							return _this2.JobsForm_Container = node;
						}, style: { alignSelf: "center", border: "2px solid #e5e5e5", borderRadius: "2px", backgroundColor: 'white', width: '900px', height: '532px', display: 'flex', flexDirection: 'column' } },
					_react2.default.createElement(
						'div',
						{ className: 'modal-header', style: { position: "relative" } },
						_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideJobsForm.bind(this) }),
						_react2.default.createElement(
							'h5',
							{ className: 'modal-title' },
							'\u8FDC\u7A0B\u8C03\u7528'
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { display: 'flex', flexDirection: 'column', flexGrow: 100, padding: '5px' } },
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', flexDirection: 'row', flexGrow: 100, boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)', borderRadius: '3px' } },
							_react2.default.createElement(
								'div',
								{ style: { display: 'flex', flexDirection: 'column', width: '900px' } },
								_react2.default.createElement(
									'div',
									{ className: 'nav-tabs-custom', style: { 'marginBottom': '0', display: 'flex', flexDirection: 'column', height: '100%' } },
									_react2.default.createElement(
										'ul',
										{ id: 'jobsNav', className: 'nav nav-tabs' },
										_react2.default.createElement(
											'li',
											{ id: 'tabli_1', className: 'active' },
											_react2.default.createElement(
												'a',
												{ className: 'gongqi_tabpage', href: '#jobsForm_tab_1', 'data-toggle': 'tab', 'aria-expanded': 'false' },
												'\u8FDC\u7A0B\u8C03\u7528'
											)
										),
										_react2.default.createElement(
											'li',
											{ id: 'tabli_2' },
											_react2.default.createElement(
												'a',
												{ className: 'gongqi_tabpage noclickBtn', id: 'jobsForm_tab_btn_2', href: tabhref2, 'data-toggle': tabhandle2, 'aria-expanded': 'false' },
												'\u8FDC\u7A0B\u8C03\u7528\u6570\u636E'
											)
										),
										_react2.default.createElement(
											'li',
											{ id: 'tabli_3' },
											_react2.default.createElement(
												'a',
												{ className: 'gongqi_tabpage noclickBtn', id: 'jobsForm_tab_btn_3', href: tabhref3, 'data-toggle': tabhandle3, 'aria-expanded': 'false' },
												'\u8FDC\u7A0B\u8C03\u7528\u8FD4\u56DE'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'tab-content', style: { 'padding': '0px', flexGrow: 100, width: '100%', height: '100%' } },
										_react2.default.createElement(
											'div',
											{ className: 'active tab-pane', id: 'jobsForm_tab_1', style: { width: '100%', height: '100%', padding: '1px' } },
											_react2.default.createElement(
												'div',
												{ style: { display: 'flex', flexDirection: 'row', width: '100%', height: '100%' } },
												_react2.default.createElement(
													'div',
													{ style: (_ref = { display: 'flex', flexDirection: 'column', width: '70%', height: '100%', padding: '1%', border: '1px solid #ccc' }, _defineProperty(_ref, 'height', '390px'), _defineProperty(_ref, 'overflow', 'auto'), _defineProperty(_ref, 'borderBottom', 'none'), _ref) },
													_react2.default.createElement(
														'ul',
														{ id: 'jobslist' },
														result1.map(function (item, i) {
															return _react2.default.createElement(
																'li',
																{ key: i,
																	onClick: _this2.handleClick.bind(_this2, i, item.jobName),
																	style: { lineHeight: '30px', listStyleType: 'none' },
																	className: active === i ? 'active' : ''
																},
																_react2.default.createElement(
																	'span',
																	{ style: { fontWeight: 'bold' } },
																	item.jobName
																),
																_react2.default.createElement(
																	'span',
																	{ className: 'li_jobsDes', style: { float: 'right' } },
																	item.jobDescription
																)
															);
														})
													)
												),
												_react2.default.createElement(
													'div',
													{ style: { display: 'flex', flexDirection: 'column', width: '30%', height: '100%', padding: '1%' } },
													_react2.default.createElement(
														_TabFromItem2.default,
														{ type: tabtype, a: jsondata },
														' '
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane', id: 'jobsForm_tab_2', style: { width: '100%', height: '100%' } },
											_react2.default.createElement(
												'div',
												{ style: { display: 'flex', flexDirection: 'column', width: '100%', height: '100%', padding: '1%' } },
												_react2.default.createElement(
													'label',
													null,
													'\u7C98\u8D34\u526A\u5207\u677F\u6570\u636E\u5230\u4E0B\u9762\u6587\u672C\u6846'
												),
												_react2.default.createElement(
													'div',
													{ id: 'inputDataGridText', style: { width: '100%', height: '100%', display: 'block' } },
													_react2.default.createElement('textarea', { id: 'txtModeInput', onPaste: function onPaste(e) {
															_this2.PasteFun(e);
														}, style: { height: '100%', width: '100%' } })
												),
												_react2.default.createElement(
													'div',
													{ id: 'inputDataGrid', style: { width: '100%', height: '100%', display: 'none' } },
													_react2.default.createElement(_JobsDataGrid2.default, { ref: function ref(node) {
															return _this2.jobsDataGrid = node;
														} })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane', id: 'jobsForm_tab_3', style: { width: '100%', height: '100%' } },
											_react2.default.createElement(
												'div',
												{ style: { display: 'flex', flexDirection: 'column', width: '100%', height: '100%', padding: '1%' } },
												_react2.default.createElement('label', null),
												_react2.default.createElement(
													'div',
													{ id: 'outputTextarea', style: { width: '100%', height: '100%' } },
													_react2.default.createElement('textarea', { id: 'txtModeOutput', style: { height: '100%', width: '100%' } })
												),
												_react2.default.createElement(
													'div',
													{ id: 'outputDataGrid', style: { width: '100%', height: '100%', display: 'none' } },
													_react2.default.createElement(_JobsDataGrid2.default, { ref: function ref(node) {
															return _this2.jobsDataGridOut = node;
														} })
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', flexDirection: 'horizontal', flexGrow: 0, padding: '10px 5px' } },
							_react2.default.createElement('div', { style: { flexGrow: 100 } }),
							_react2.default.createElement(
								'button',
								_defineProperty({ type: 'button', onClick: this.RemoteSubmit, className: 'btn btn-info', style: { width: '80px', height: '28px', marginRight: '5px', marginTop: '5px' } }, 'onClick', this.testRemoteClass),
								'\u8FDC\u7A0B\u8C03\u7528'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { width: '96', height: '28px', marginRight: '5px', marginTop: '5px' }, onClick: this.btnRefreshCurClickHandler },
								'\u5237\u65B0\u5F53\u524DJob'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', className: 'btn btn-info', style: { width: '96', height: '28px', marginTop: '5px' } },
								'\u5237\u65B0Job\u5217\u8868'
							)
						)
					)
				);
			}
		}]);
	
		return JobsForm;
	}(_react2.default.Component);
	
	exports.default = JobsForm;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var TabFromItem = function (_React$Component) {
	    _inherits(TabFromItem, _React$Component);
	
	    function TabFromItem(props, context) {
	        _classCallCheck(this, TabFromItem);
	
	        var _this = _possibleConstructorReturn(this, (TabFromItem.__proto__ || Object.getPrototypeOf(TabFromItem)).call(this, props, context));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TabFromItem, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                a = _props.a; //这里就上层的值
	
	            console.log(a); //就是进来的a
	            return React.createElement(
	                'div',
	                null,
	                type === "Null" && React.createElement(
	                    'div',
	                    { style: { paddingTop: '20px' } },
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10000', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10000', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u8FD4\u56DE\u503C\uFF1A  '
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: 'String', id: 'jobsinput10000', disabled: true, className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10001', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '5px' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10001', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u53C2\u3000\u6570\uFF1A'
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: '\u8BE5Job\u65E0\u9700\u8C03\u7528\u53C2\u6570', id: 'jobsinput10001', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    )
	                ),
	                type === "String" && React.createElement(
	                    'div',
	                    { style: { paddingTop: '20px' } },
	                    React.createElement(
	                        'h6',
	                        { style: { textAlign: 'center', fontWeight: 'bolder' } },
	                        a.jobDescription
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10000', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10000', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u8FD4\u56DE\u503C\uFF1A  '
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: a.returnDescription, id: 'jobsinput10000', disabled: true, className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10001', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '5px' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10001', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u53C2\u3000\u6570\uFF1A'
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: a.paramDescription, id: 'jobsinput10001', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    )
	                ),
	                type === "String2" && React.createElement(
	                    'div',
	                    { style: { paddingTop: '20px' } },
	                    React.createElement(
	                        'h6',
	                        { style: { textAlign: 'center', fontWeight: 'bolder' } },
	                        a.jobDescription
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10000', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10000', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u8FD4\u56DE\u503C\uFF1A  '
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: a.returnDescription, id: 'jobsinput10000', disabled: true, className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10001', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '5px' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10001', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u53C2\u3000\u6570\uFF1A'
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', readonly: 'readonly', spellcheck: 'false', placeholder: a.paramDescription, id: 'jobsinput10001', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    )
	                ),
	                type === "ReClipboard" && React.createElement(
	                    'div',
	                    { style: { paddingTop: '20px' } },
	                    React.createElement(
	                        'h6',
	                        { style: { textAlign: 'center', fontWeight: 'bolder' } },
	                        a.jobDescription
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10000', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10000', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u8FD4\u56DE\u503C\uFF1A  '
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: a.returnDescription, id: 'jobsinput10000', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10001', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '5px' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10001', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u53C2\u3000\u6570\uFF1A'
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', readonly: 'readonly', spellcheck: 'false', placeholder: a.paramDescription, id: 'jobsinput10001', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    )
	                ),
	                type === "LIST" && React.createElement(
	                    'div',
	                    { style: { paddingTop: '20px' } },
	                    React.createElement(
	                        'h6',
	                        { style: { textAlign: 'center', fontWeight: 'bolder' } },
	                        a.jobDescription
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10000', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10000', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u8FD4\u56DE\u503C\uFF1A  '
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: a.returnDescription, id: 'jobsinput10000', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10001', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '5px' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10001', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u53C2\u3000\u6570\uFF1A'
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', readonly: 'readonly', spellcheck: 'false', placeholder: a.paramDescription, id: 'jobsinput10001', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    )
	                ),
	                type === "MAP" && React.createElement(
	                    'div',
	                    { style: { paddingTop: '20px' } },
	                    React.createElement(
	                        'h6',
	                        { style: { textAlign: 'center', fontWeight: 'bolder' } },
	                        a.jobDescription
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10000', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10000', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u8FD4\u56DE\u503C\uFF1A  '
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', spellcheck: 'false', placeholder: a.returnDescription, id: 'jobsinput10000', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { id: 'JobsEditor10001', className: 'editorGroup', style: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '5px' } },
	                        React.createElement(
	                            'label',
	                            { 'for': 'jobsinput10001', className: 'fieldGroupLabel', style: { paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap', marginBottom: '0px' } },
	                            '\u53C2\u3000\u6570\uFF1A'
	                        ),
	                        React.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            React.createElement('input', { type: 'text', readonly: 'readonly', spellcheck: 'false', placeholder: a.paramDescription, id: 'jobsinput10001', className: 'form-control', style: { padding: '2px', height: '22px', width: '180px', fontSize: '12px' } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TabFromItem;
	}(React.Component);
	
	exports.default = TabFromItem;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ExportDataGrid = __webpack_require__(531);
	
	var _ExportDataGrid2 = _interopRequireDefault(_ExportDataGrid);
	
	var _HtmlArgUtil = __webpack_require__(592);
	
	var _HtmlArgUtil2 = _interopRequireDefault(_HtmlArgUtil);
	
	var _FormItemUtil = __webpack_require__(2);
	
	var _FormItemUtil2 = _interopRequireDefault(_FormItemUtil);
	
	var _CommandResolver = __webpack_require__(13);
	
	var _CommandResolver2 = _interopRequireDefault(_CommandResolver);
	
	var _GOTUtil = __webpack_require__(9);
	
	var _GOTUtil2 = _interopRequireDefault(_GOTUtil);
	
	var _GOT = __webpack_require__(11);
	
	var _GOT2 = _interopRequireDefault(_GOT);
	
	var _jqueryTableExport = __webpack_require__(533);
	
	var _jqueryTableExport2 = _interopRequireDefault(_jqueryTableExport);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _ListDataGrid = __webpack_require__(532);
	
	var _ListDataGrid2 = _interopRequireDefault(_ListDataGrid);
	
	var _CommandTask = __webpack_require__(33);
	
	var _CommandTask2 = _interopRequireDefault(_CommandTask);
	
	var _Cmd = __webpack_require__(32);
	
	var _Cmd2 = _interopRequireDefault(_Cmd);
	
	var _copyToClipboard = __webpack_require__(165);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _CommonUtil = __webpack_require__(19);
	
	var _CommonUtil2 = _interopRequireDefault(_CommonUtil);
	
	var _Warn = __webpack_require__(8);
	
	var _Warn2 = _interopRequireDefault(_Warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(776);
	
	var CustomMenu = function (_React$Component) {
		_inherits(CustomMenu, _React$Component);
	
		function CustomMenu(props, context) {
			_classCallCheck(this, CustomMenu);
	
			var _this = _possibleConstructorReturn(this, (CustomMenu.__proto__ || Object.getPrototypeOf(CustomMenu)).call(this, props, context));
	
			_this.componentDidMount = function () {
				/*var setting = {
	   data: 
	   {
	   key: {
	   	title:"label",
	   	children:"items",
	   	name:"label"
	   }
	   },
	   callback:
	   {
	   onClick: this.onItemClick.bind(this),
	   onDblClick: this.onItemDblClick.bind(this)
	   }
	   };
	   window.got.MainMenu.label="主菜单";
	   $.fn.zTree.init($(this.mainMenuTreeNode), setting, window.got.MainMenu);*/
				$(_this.slimScrollDiv).slimScroll({ height: 'auto', color: "rgba(0,0,0,0.2)", size: "3px" });
				$(_this.customMenuDiv).draggable({
					handle: ".modal-header" // 只能点击头部拖动
	
				}); //为模态对话框添加拖拽
	
				if (_this.customMenuDiv.scrollHeight > _this.customMenuDiv.clientHeight || _this.customMenuDiv.offsetHeight > _this.customMenuDiv.clientHeight) {
					$(_this.customMenuDiv).height(_this.customMenuDiv.scrollHeight + 25);
				}
	
				/*let nowHeight = $(this.customMenuDiv).outerHeight();
	   if(nowHeight<610)
	   {
	   	$(this.customMenuDiv).height(610);
	   }*/
			};
	
			_this.hideExportTable = function () {
				$("#exportModal").empty();
			};
	
			_this.state = {};
			_this.state.title = '自定义常用菜单';
			_this.state.warnTitle = "";
	
			_this.userId = window.parent.window.userInfos.userId ? window.parent.window.userInfos.userId : window.userInfos.userId;
	
			_this.state.translateX = 0, _this.state.translateY = 0, _this.moving = false;
			_this.lastX = null;
			_this.lastY = null;
			//window.onmouseup = e => this.onMouseUp(e);
			//window.onmousemove = e => this.onMouseMove(e);
			if (_this.props.menuCustomObject) _this.temp = Object.assign({ customItems: {}, groups: {} }, _this.props.menuCustomObject);else _this.temp = { customItems: {}, groups: {} };
			return _this;
		}
	
		_createClass(CustomMenu, [{
			key: 'onItemClick',
			value: function onItemClick(event, treeId, treeNode, clickFlag) {}
		}, {
			key: 'onItemDblClick',
			value: function onItemDblClick(event, treeId, treeNode, clickFlag) {}
	
			/** 拖拉 */
	
		}, {
			key: 'onMouseDown',
			value: function onMouseDown(e) {
				e.stopPropagation();
				this.moving = true;
			}
		}, {
			key: 'onMouseUp',
			value: function onMouseUp() {
				this.moving = false;
				this.lastX = null;
				this.lastY = null;
			}
		}, {
			key: 'onMouseMove',
			value: function onMouseMove(e) {
				this.moving && this.onMove(e);
			}
		}, {
			key: 'onMove',
			value: function onMove(e) {
	
				if (this.lastX && this.lastY) {
					var dx = e.clientX - this.lastX;
					var dy = e.clientY - this.lastY;
					console.log("dx:" + dx + ";dy:" + dy);
					this.setState({
						translateX: this.state.translateX + dx,
						translateY: this.state.translateY + dy
					});
				}
				this.lastX = e.clientX;
				this.lastY = e.clientY;
	
				console.log(this.state.translateX, this.state.translateY);
			}
		}, {
			key: 'menuItemClickSelect',
			value: function menuItemClickSelect(event) {
				var target = event.target;
				$("#customMenuModalContainer .customMenuTree div.selected").removeClass("selected");
				$(target).addClass("selected");
			}
		}, {
			key: 'getLabelName',
			value: function getLabelName(item) {
				var label = _GOTUtil2.default.getPropertyValue(item, "Label");
				if (label == "" | !label) {
					label = item.name;
				}
				return label;
			}
		}, {
			key: 'addMostHandler',
			value: function addMostHandler(e) {
				var parentA = $(e.target).parent().parent();
				var parentLi = parentA.parent();
	
				parentLi.addClass("usual");
				var key = parentA.attr("data-menuitemid") + "." + parentA.attr("data-idinmenu");
				this.temp.customItems[key] = { groupId: "" };
			}
		}, {
			key: 'removeMostHandler',
			value: function removeMostHandler(e) {
				var parentA = $(e.target).parent().parent();
				var parentLi = parentA.parent();
	
				parentLi.removeClass("usual");
				var key = parentA.attr("data-menuitemid") + "." + parentA.attr("data-idinmenu");
				delete this.temp.customItems[key];
				parentA.find(".most-group-info").remove();
			}
		}, {
			key: 'renderSub',
			value: function renderSub(items, moudleId, parent) {
				var content = [];
	
				if (items) {
					for (var i = 0; i < items.length; i++) {
						var item = items[i];
						//item.pId = parent.id;
						if (item.qname) {
							if (item.qname == "MenuItem") {
	
								var isShow = false;
	
								var visible = item.Properties.Visible.V;
								if (visible != 'false') {
									if (window.userInfos.isAdmin) {
										isShow = true;
									} else {
										var thisAu = moudleId + '.' + item.idInMenu;
										var authorityArr = window.xmlType1SCache[thisAu];
										if (authorityArr) {
	
											if (authorityArr.del || authorityArr.query) {
												isShow = true;
											}
										}
									}
								}
								var label = this.getLabelName(item);
	
								if (isShow) {
	
									var _clsName = "iconfont icon-default text-blue";
									var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon");
									if (iconPro) _clsName = iconPro;
									var treeviewClassName = "treeview menuItem";
									var key = item.id + "." + item.idInMenu;
									var _groupId = "";
									var _groupItem = null;
									if (this.temp.customItems.hasOwnProperty(key)) {
										treeviewClassName += " usual";
										_groupId = this.temp.customItems[key].groupId;
										if (_groupId && this.temp.groups.hasOwnProperty(_groupId)) {
											var _groupItemData = this.temp.groups[_groupId];
											_groupItem = _react2.default.createElement(
												'div',
												{ 'data-groupid': _groupId, className: 'most-group-info text-green', style: { backgroundColor: "aquamarine", marginRight: "20px" } },
												_groupItemData.name
											);
										}
									}
	
									var dataFormId = item.Properties.RefObject ? item.Properties.RefObject.refentityid : item.Properties.Source.refentityid;
									content.push(_react2.default.createElement(
										'li',
										{ className: treeviewClassName, key: 'menuItem-li' + i },
										_react2.default.createElement(
											'a',
											{ title: label, style: { cursor: "pointer", display: 'flex', alignItems: 'center', paddingTop: '1px', paddingBottom: '1px' }, onClick: this.menuItemClickSelect, 'data-formId': dataFormId, 'data-formLabel': label, 'data-menuItemId': item.id, 'data-groupId': _groupId, 'data-idInMenu': item.idInMenu },
											_react2.default.createElement('i', { className: _clsName, style: { flexShrink: 0, marginRight: '4px', marginTop: '2px', fontSize: '14px' } }),
											_react2.default.createElement(
												'div',
												null,
												label
											),
											_react2.default.createElement(
												'div',
												{ className: 'treeview-menuItem-info', style: { flexGrow: 1, alignItems: 'center', justifyContent: 'flex-end', display: 'flex', marginRight: '25px' } },
												_groupItem,
												_react2.default.createElement(
													'div',
													{ className: 'most text-green', style: { backgroundColor: "aquamarine" } },
													'\u5E38\u7528'
												),
												_react2.default.createElement('i', { title: '\u8BBE\u4E3A\u5E38\u7528', className: 'fa fa-check text-green', style: { marginBottom: '3px' }, onClick: this.addMostHandler.bind(this) }),
												_react2.default.createElement('i', { title: '\u53D6\u6D88\u5E38\u7528', className: 'fa fa-close text-red', style: { marginBottom: '3px' }, onClick: this.removeMostHandler.bind(this) })
											)
										)
									));
								}
							} else if (item.qname == "MenuSub") {
	
								var isShow = false;
								var visible = item.Properties.Visible.V;
								if (visible == 'true') {
									if (window.userInfos.isAdmin) {
										isShow = true;
									} else {
										var thisAu = moudleId + '.' + item.id;
										var authorityArr = window.xmlType1SCache[thisAu];
										if (authorityArr) {
											if (!authorityArr.del && !authorityArr.query && !authorityArr.visible) {
												isShow = false;
											} else {
												isShow = true;
											}
										}
									}
								}
	
								var label = this.getLabelName(item);
								if (isShow) {
	
									var _clsName = "fa fa-bars text-blue";
									var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon");
									if (iconPro) _clsName = iconPro;
									content.push(_react2.default.createElement(
										'li',
										{ className: 'treeview menuSub', key: 'menuSub-li' + i },
										_react2.default.createElement(
											'a',
											{ style: { cursor: "pointer" } },
											_react2.default.createElement('i', { className: _clsName }),
											_react2.default.createElement(
												'span',
												null,
												label
											),
											_react2.default.createElement(
												'span',
												{ className: 'pull-right-container' },
												_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
											)
										),
										_react2.default.createElement(
											'ul',
											{ className: 'treeview-menu' },
											this.renderSub(item.items, moudleId, item)
										)
									));
								}
							}
						} else {
							var isShow = false;
							var visible = item.Properties.Visible.V;
							if (visible == 'true') {
								if (window.userInfos.isAdmin) {
									isShow = true;
								} else {
									moudleId = item.id;
									var authorityArr = window.xmlType0SCache[moudleId];
									if (authorityArr) {
										if (authorityArr.del) {
											isShow = true;
										} else {
											isShow = false;
										}
									}
								}
							}
	
							var label = this.getLabelName(item);
							if (isShow) {
								var _clsName = "fa fa-th-list text-blue";
								var iconPro = _GOTUtil2.default.getPropertyValue(item, "Icon");
								if (iconPro) _clsName = iconPro;
								content.push(_react2.default.createElement(
									'li',
									{ className: 'treeview', key: 'treeview' + i },
									_react2.default.createElement(
										'a',
										{ style: { cursor: "pointer" } },
										_react2.default.createElement('i', { className: _clsName }),
										_react2.default.createElement(
											'span',
											null,
											label
										),
										_react2.default.createElement(
											'span',
											{ className: 'pull-right-container' },
											_react2.default.createElement('i', { className: 'fa fa-angle-left pull-right' })
										)
									),
									_react2.default.createElement(
										'ul',
										{ className: 'treeview-menu' },
										this.renderSub(item.items, moudleId, item)
									)
								));
							}
						}
					}
				}
				return content;
			}
		}, {
			key: 'hideCustomMenuGroupSet',
			value: function hideCustomMenuGroupSet(e) {
				$(this.customMenuGroupSet).hide();
			}
		}, {
			key: 'saveCustomMenuGroup',
			value: function saveCustomMenuGroup(e) {
				$(this.customMenuGroupSet).hide();
				var uuid = _CommonUtil2.default.guid();
				var groupName = $(this.inputGroupName).val();
				this.temp.groups[uuid] = { name: groupName };
	
				var closeBtn = $('<i class="fa fa-close text-red" style="position: absolute;right: 1px;top:0px;cursor:pointer"></i>').attr("data-groupid", uuid).attr("data-groupname", groupName).click(this.deleteMostGroup.bind(this));
				$(this.mostGroupContainer).prepend($('<div class="most-group text-green" style="background-color:aquamarine;font-size:17px;position: relative;padding-left: 10px;padding-right: 10px;">' + groupName + '</div>').append(closeBtn));
			}
		}, {
			key: 'addMostGroup',
			value: function addMostGroup() {
				$(this.customMenuGroupSet).show();
			}
		}, {
			key: 'getGroups',
			value: function getGroups() {
				/*
	   <div class="most-group text-green" style="font-size: 17px;background-color: aquamarine;position: relative;padding-left: 10px;padding-right: 10px;"><i class="fa fa-close text-red" style="
	     		position: absolute;
	     		right: 1px;
	   "></i>测试分组</div>
	   */
				var groups = [];
				for (var key in this.temp.groups) {
					var group = this.temp.groups[key];
					var label = group.name;
					groups.push(_react2.default.createElement(
						'div',
						{ className: 'most-group text-green', style: { backgroundColor: 'aquamarine', fontSize: '17px', position: 'relative', paddingLeft: '10px', paddingRight: '10px' } },
						label,
						_react2.default.createElement('i', { 'data-groupid': key, 'data-groupname': label, className: 'fa fa-close text-red', style: { position: 'absolute', right: '1px', top: '0px', cursor: 'pointer' }, onClick: this.deleteMostGroup.bind(this) })
					));
				}
				return groups;
			}
		}, {
			key: 'deleteMostGroup',
			value: function deleteMostGroup(e) {
	
				var groupKey = $(e.target).attr("data-groupid");
				if (this.temp.groups.hasOwnProperty(groupKey)) {
					delete this.temp.groups[groupKey];
				}
				for (var key in this.temp.customItems) {
					var customItem = this.temp.customItems[key];
					if (customItem.groupId == groupKey) customItem.groupId = "";
				}
				$(e.target).parent().remove();
	
				$("#customMenuModalContainer .most-group-info").each(function (item) {
					if ($(this).attr("data-groupid") == groupKey) $(this).remove();
				});
			}
		}, {
			key: 'addSettingToGroup',
			value: function addSettingToGroup(e) {
				var selectedMenuItems = $("#customMenuModalContainer .customMenuTree .usual div.selected");
				if (selectedMenuItems.length < 1) {
					_Warn2.default.show({ text: "请选中一个常用菜单项" });
					return;
				}
				var parentA = selectedMenuItems.parent();
				var _currentAddingToGroupKey = (parentA.prop("data-menuitemid") || parentA.attr("data-menuitemid")) + "." + (parentA.prop("data-idinmenu") || parentA.attr("data-idinmenu"));
				this.currentAddingToGroupKey = _currentAddingToGroupKey;
				this.currentAddingToGroupA = parentA;
	
				$(this.groupSelectUL).empty();
				for (var key in this.temp.groups) {
					var item = this.temp.groups[key];
					var $li = $("<li style='cursor:pointer;font-size:14px'>").click(this.groupClickHandler.bind(this)).html(item.name).attr("data-groupid", key).attr("data-groupname", item.name);
					$(this.groupSelectUL).append($li);
				}
				$(this.customMenuGroupAddContainer).show();
	
				//<li style={{cursor:'pointer'}} onClick={this.groupClickHandler.bind(this)}>111</li>
	
			}
		}, {
			key: 'saveSetting',
			value: function saveSetting(e) {
				//localStorage.setItem("tempTest",JSON.stringify(this.temp));
				var ugse = window.userSettingEntryOrig;
				ugse.menuCustomObject = JSON.stringify(this.temp);
	
				for (var k in ugse) {
					if (typeof ugse[k] != "string") ugse[k] = ugse[k].toString();
				}
	
				var command = _Command2.default.createService("gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
	
				command.appendArg(window.userInfos.userId); //ClientSession.getClientSessionInstance().userId
				command.appendArg(ugse, "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");
	
				var saveResultHandler = function saveResultHandler(data) {
					window.userSettingEntryOrig = ugse;
					if (Boolean(data.result)) {
						if (Boolean(data.result)) {
							var options = {
								state: 'success',
								text: "已成功保存您的偏好设置"
							};
							_Fade2.default.show(options);
						} else {
							var options = {
								state: 'error',
								text: "保存失败"
							};
							_Fade2.default.show(options);
						}
					}
				};
	
				var remoteArg = {
					command: command,
					resultFunction: saveResultHandler,
					sync: false
				};
				_ServiceHelper2.default.addTokenWithCommand(remoteArg);
			}
		}, {
			key: 'hideCustomMenuGroupAdd',
			value: function hideCustomMenuGroupAdd(e) {
				$(this.customMenuGroupAddContainer).hide();
			}
		}, {
			key: 'saveCustomMenuAdd',
			value: function saveCustomMenuAdd(e) {
				var lis = $(this.groupSelectUL).find("li.selected");
				if (lis.length < 1) {
					_Warn2.default.show({ text: "请选择一个分组" });
					return;
				}
				if (!this.currentAddingToGroupKey || !this.temp.customItems.hasOwnProperty(this.currentAddingToGroupKey)) return;
				var _groupId = $(lis[0]).attr("data-groupid");
				var _groupName = $(lis[0]).attr("data-groupname");
				this.temp.customItems[this.currentAddingToGroupKey].groupId = _groupId;
				var menuItemInfo = this.currentAddingToGroupA.find(".treeview-menuItem-info");
				menuItemInfo.find(".most-group-info").remove();
				menuItemInfo.prepend($("<div class='most-group-info text-green' style='background-color:aquamarine;margin-right:20px' data-groupid='" + _groupId + "'>" + _groupName + "</div>"));
				this.hideCustomMenuGroupAdd();
			}
		}, {
			key: 'groupClickHandler',
			value: function groupClickHandler(e) {
				$(this.groupSelectUL).find("li").removeClass("selected");
				$(e.target).addClass("selected");
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _columns = [];
	
				var title = this.state.title;
	
				var mainMenu = window.got.MainMenu;
				var moudleId;
				var mainContent = this.renderSub(mainMenu.items, moudleId, mainMenu);
				/*
	   <ul id='customMenuTree' ref={node=>this.mainMenuTreeNode=node} style={{height:'415px',width:'200px'}}>
	   						
	   					</ul> 
	   */
				var customMenuItemGroups = this.getGroups();
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'customMenuModalContainer', style: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }, key: 'mainModal' },
						_react2.default.createElement(
							'div',
							{ ref: function ref(node) {
									return _this2.customMenuDiv = node;
								}, style: { height: '80%', display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', overflow: 'auto', background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header' },
								_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideExportTable }),
								_react2.default.createElement(
									'h5',
									{ className: 'modal-title' },
									title
								)
							),
							_react2.default.createElement(
								'div',
								{ ref: function ref(node) {
										return _this2.slimScrollContainer = node;
									}, className: 'modal-body', style: { padding: '0px 15px', display: 'flex', flexDirection: 'column', alignItems: 'stretch', flexGrow: 1 } },
								_react2.default.createElement(
									'div',
									{ ref: function ref(node) {
											return _this2.mostGroupContainer = node;
										}, style: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '10px', marginBottom: '10px', alignItems: 'center', maxWidth: '404px' } },
									customMenuItemGroups,
									_react2.default.createElement('div', { title: '\u70B9\u51FB\u6DFB\u52A0\u5206\u7EC4', style: { cursor: 'pointer', backgroundImage: 'url("./images/add_1.png")', width: '20px', height: '20px', backgroundSize: '100% 100%', marginBottom: '5px' }, onClick: this.addMostGroup.bind(this) })
								),
								_react2.default.createElement(
									'div',
									{ className: 'skin-blue-light', ref: function ref(node) {
											return _this2.slimScrollDiv = node;
										}, style: { backgroundColor: '#f4f4f5', overflow: 'hidden', width: 'auto', marginBottom: '0', WebkitTouchCallout: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', user: 'none' } },
									_react2.default.createElement(
										'div',
										{ className: 'box-body sidebar', style: { marginTop: '5px', padding: '0', marginRight: '14px' } },
										_react2.default.createElement(
											'ul',
											{ className: 'customMenuTree sidebar-menu', style: { overflowX: 'auto', width: '400px' } },
											mainContent
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal-footer', style: { padding: '10px 15px 8px', borderTopColor: 'rgba(0,0,0,0.10)', marginTop: '10px', borderTop: '1px solid rgba(0,0,0,0.10)' } },
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-info', onClick: this.addSettingToGroup.bind(this), style: { height: '28px', width: '115px' } },
									_react2.default.createElement('i', { style: { marginRight: '3px' }, className: 'fa fa-plus', 'aria-hidden': 'true' }),
									'\u6DFB\u52A0\u5230\u5206\u7EC4'
								),
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'btn btn-info', onClick: this.saveSetting.bind(this), style: { height: '28px', width: '88px' } },
									_react2.default.createElement('i', { style: { marginRight: '3px' }, className: 'fa fa-download', 'aria-hidden': 'true' }),
									'\u4FDD\u5B58'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal', ref: function ref(node) {
										return _this2.customMenuGroupSet = node;
									}, key: 'saveModal', style: { zIndex: '2000' } },
								_react2.default.createElement(
									'div',
									{ className: 'modal-dialog', style: { marginTop: '100px', width: '640px' } },
									_react2.default.createElement(
										'div',
										{ className: 'modal-content', style: {
												background: '#FFFFFF',
												border: '1px solid #9B9B9B',
												boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
												borderRadius: '2px'
											} },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideCustomMenuGroupSet.bind(this) }),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title', style: { marginTop: '0', marginBottom: '0' } },
												'\u8BBE\u7F6E\u5206\u7EC4\u540D\u79F0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body', style: { display: 'flex', flexDirection: 'column', padding: '40px 10px' } },
											_react2.default.createElement(
												'div',
												{ style: { flexGrow: 0, textAlign: 'center' } },
												_react2.default.createElement(
													'div',
													{ style: { display: 'flex', flexDirection: 'row', paddingLeft: '35px' } },
													_react2.default.createElement(
														'div',
														{ style: { textAlign: 'right' } },
														_react2.default.createElement(
															'label',
															{ style: { paddingTop: '8px', fontFamily: 'STSongti-SC-Regular', fontSize: '12px', color: '#000000', fontWeight: 'normal' } },
															'\u5206\u7EC4\u540D\u79F0\uFF1A'
														)
													),
													_react2.default.createElement(
														'div',
														{ style: { textAlign: 'left', flexGrow: 1, marginRight: '10px' } },
														_react2.default.createElement('input', { type: 'text', spellcheck: 'false', className: 'form-control', ref: function ref(node) {
																return _this2.inputGroupName = node;
															} })
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-footer', style: { padding: '10px 15px' } },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' }, 'data-dismiss': 'modal', onClick: this.hideCustomMenuGroupSet.bind(this) },
												'\u53D6\u6D88'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px', color: '#fff' }, onClick: this.saveCustomMenuGroup.bind(this) },
												'\u786E\u5B9A'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal', ref: function ref(node) {
										return _this2.customMenuGroupAddContainer = node;
									}, key: 'addModal', style: { zIndex: '2000' } },
								_react2.default.createElement(
									'div',
									{ className: 'modal-dialog', style: { marginTop: '100px', width: '370px' } },
									_react2.default.createElement(
										'div',
										{ className: 'modal-content', style: {
												background: '#FFFFFF',
												border: '1px solid #9B9B9B',
												boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
												borderRadius: '2px'
											} },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											_react2.default.createElement('div', { className: 'modal-close', onClick: this.hideCustomMenuGroupAdd.bind(this) }),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title', style: { marginTop: '0', marginBottom: '0' } },
												'\u9009\u62E9\u5206\u7EC4'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body', style: { display: 'flex', flexDirection: 'column', padding: '20px 10px' } },
											_react2.default.createElement('ul', { className: 'customMenuGroupSelect', ref: function ref(node) {
													return _this2.groupSelectUL = node;
												} })
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-footer', style: { padding: '10px 15px' } },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '5px', width: '80px', background: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '2px', paddingTop: '3px' }, 'data-dismiss': 'modal', onClick: this.hideCustomMenuGroupAdd.bind(this) },
												'\u53D6\u6D88'
											),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn', style: { height: '28px', marginRight: '0px', width: '80px', fontFamily: 'STSongti-SC-Regular', fontSize: '14px', border: 'solid 1px #f5a623', letterSpacing: 0, textAlign: 'center', backgroundColor: '#f5a623', paddingTop: '3px', color: '#fff' }, onClick: this.saveCustomMenuAdd.bind(this) },
												'\u786E\u5B9A'
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return CustomMenu;
	}(_react2.default.Component);
	
	exports.default = CustomMenu;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var ExportDataGrid = function (_React$Component) {
	  _inherits(ExportDataGrid, _React$Component);
	
	  function ExportDataGrid(props, context) {
	    _classCallCheck(this, ExportDataGrid);
	
	    var _this = _possibleConstructorReturn(this, (ExportDataGrid.__proto__ || Object.getPrototypeOf(ExportDataGrid)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    window.ExportDataGrid = _this;
	    var rows = _this.props.rows;
	    var columns = _this.props.columns;
	    _this.state = { rows: rows, selectedIndexes: [], columns: columns };
	    return _this;
	  }
	
	  _createClass(ExportDataGrid, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(ReactDataGrid, {
	        ref: function ref(node) {
	          return _this2.grid = node;
	        },
	        onGridSort: this.handleGridSort,
	        enableCellSelect: true,
	        columns: this.props.columns
	        // columns={this.getColumns()}
	        , rowGetter: this.getRowAt,
	        rowsCount: this.getSize(),
	        onGridRowsUpdated: this.handleGridRowsUpdated
	        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	        , enableRowSelect: false,
	        rowSelection: {
	          showCheckbox: false,
	          selectBy: {
	            indexes: this.state.selectedIndexes
	
	          }
	        },
	        onRowClick: this.rowClick //this.rowClick this.rowClick.bind(this)
	        , rowHeight: 30,
	        minHeight: 375,
	        rowScrollTimeout: 500,
	        cellNavigationMode: 'loopOverRow'
	
	      });
	    }
	  }]);
	
	  return ExportDataGrid;
	}(React.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.createRows = function (numberOfRows) {
	    var rows = [];
	    for (var i = 0; i < numberOfRows; i++) {
	      rows[i] = _this3.createFakeRowObjectData(i);
	    }
	    return rows;
	  };
	
	  this.createFakeRowObjectData = function (index, data) {
	    console.log(data);
	    for (var i = 0; i < data.length; i++) {
	      var rows = _this3.state.rows.slice();
	      var _index = _this3.state.rows.length;
	      return {
	        id: 'id_' + _index,
	        title: tableName[i],
	        firstName: itemName[i],
	        lastName: lastName[i]
	      };
	    }
	  };
	
	  this.getColumns = function () {
	    var columns = _this3.state.columns.slice();
	    return columns;
	  };
	
	  this.test = function () {
	    console.log('1');
	  };
	
	  this.handleGridRowsUpdated = function (_ref) {
	    var fromRow = _ref.fromRow,
	        toRow = _ref.toRow,
	        updated = _ref.updated;
	
	    var rows = _this3.state.rows.slice();
	
	    for (var i = fromRow; i <= toRow; i++) {
	      var rowToUpdate = rows[i];
	      var updatedRow = $.extend(rowToUpdate, updated);
	      rows[i] = updatedRow;
	    }
	    _this3.setState({ rows: rows });
	  };
	
	  this.handleAddRow = function () {
	    var rows = _this3.state.rows.slice();
	    for (var i = fromRow; i <= toRow; i++) {
	      var rowToUpdate = rows[i];
	      var updatedRow = $.extend(rowToUpdate, updated);
	      rows[i] = updatedRow;
	    }
	    _this3.setState({ rows: rows });
	  };
	
	  this.deleteRow = function () {
	    var rows = _this3.state.rows.slice();
	    var selectedIndex = _this3.state.selectedIndexes[0];
	    rows.splice(selectedIndex, 1);
	    _this3.setState({ rows: rows, selectedIndexes: [rows.length - 1] });
	  };
	
	  this.getRowAt = function (index) {
	    if (index < 0 || index > _this3.getSize()) {
	      return undefined;
	    }
	
	    return _this3.state.rows[index];
	  };
	
	  this.getSize = function () {
	    return _this3.state.rows.length;
	  };
	
	  this.rowClick = function (index, record, proxy) {
	    _this3.setState({ selectedIndexes: [index] });
	  };
	
	  this.updateColumns = function (columns) {
	    alert(223);
	    _this3.props.columns = columns;
	    _this3.setState();
	  };
	
	  this.handleGridSort = function (sortColumn, sortDirection) {
	    var comparer = function comparer(a, b) {
	      if (sortDirection === 'ASC') {
	        return a[sortColumn] > b[sortColumn] ? 1 : -1;
	      } else if (sortDirection === 'DESC') {
	        return a[sortColumn] < b[sortColumn] ? 1 : -1;
	      }
	    };
	
	    var rows = sortDirection === 'NONE' ? _this3.state.rows.slice(0) : _this3.state.rows.sort(comparer);
	
	    _this3.setState({ rows: rows });
	  };
	
	  this.componentDidUpdate = function () {
	    var columns = _this3.state.columns.slice();
	  };
	};
	
	exports.default = ExportDataGrid;

/***/ },
/* 532 */
191,
/* 533 */
520,
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetWorkErrorDateTimeRender = function (_React$Component) {
	  _inherits(NetWorkErrorDateTimeRender, _React$Component);
	
	  function NetWorkErrorDateTimeRender() {
	    _classCallCheck(this, NetWorkErrorDateTimeRender);
	
	    return _possibleConstructorReturn(this, (NetWorkErrorDateTimeRender.__proto__ || Object.getPrototypeOf(NetWorkErrorDateTimeRender)).apply(this, arguments));
	  }
	
	  _createClass(NetWorkErrorDateTimeRender, [{
	    key: "render",
	    value: function render() {
	      var time = this.props.value;
	      var _date = new Date();
	      _date.setTime(time);
	
	      var y = _date.getFullYear();
	      var m = _date.getMonth() + 1;
	      var d = _date.getDate();
	      var hours = _date.getHours();
	      var minutes = _date.getMinutes();
	      var seconds = _date.getSeconds();
	      var _value = y + "年" + m + "月" + d + "日" + " " + hours + ":" + minutes + ":" + seconds;
	
	      return _react2.default.createElement(
	        "div",
	        { style: { width: "100%", height: "100%", paddingLeft: "2px", paddingTop: "3px" } },
	        _value
	      );
	    }
	  }]);
	
	  return NetWorkErrorDateTimeRender;
	}(_react2.default.Component);
	
	exports.default = NetWorkErrorDateTimeRender;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _NetWorkErrorLog$text;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _NetWorkErrorDateTimeRender = __webpack_require__(534);
	
	var _NetWorkErrorDateTimeRender2 = _interopRequireDefault(_NetWorkErrorDateTimeRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	var React = __webpack_require__(1);
	
	var NetWorkErrorLog = function (_React$Component) {
	    _inherits(NetWorkErrorLog, _React$Component);
	
	    function NetWorkErrorLog(props) {
	        _classCallCheck(this, NetWorkErrorLog);
	
	        var _this = _possibleConstructorReturn(this, (NetWorkErrorLog.__proto__ || Object.getPrototypeOf(NetWorkErrorLog)).call(this, props));
	
	        _this.close = function () {
	            var $reactComponentContainer = $("#netWorkErrorInfoModal");
	            _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	            //$reactComponentContainer.remove();
	            $("#netWorkErrorInfoModal").css("display", "none");
	        };
	
	        _this.getRowAt = function (index) {
	            if (index < 0 || index > _this.getSize()) {
	                return undefined;
	            }
	
	            return _this.state.rows[index];
	        };
	
	        _this.getSize = function () {
	            return _this.state.rows.length;
	        };
	
	        _this.rowClick = function (index, record, proxy) {
	
	            _this.setState({ selectedIndexes: [index] });
	        };
	
	        var columns = [{
	            key: 'className',
	            name: "画面",
	            width: 137,
	            resizable: true
	        }, {
	            key: 'methodName',
	            name: "方法",
	            width: 200,
	            resizable: true
	        }, {
	            key: 'startDateTime',
	            name: "发生时间",
	            width: 200,
	            resizable: true,
	            formatter: React.createElement(_NetWorkErrorDateTimeRender2.default, null)
	        }, {
	            key: 'readyState',
	            name: "浏览器响应状态",
	            width: 100,
	            resizable: true
	        }, {
	            key: 'state',
	            name: "浏览器响应描述",
	            width: 136,
	            resizable: true
	        }, {
	            key: 'httpStatus',
	            name: "HTTP响应状态",
	            width: 100,
	            resizable: true
	        }, {
	            key: 'statusText',
	            name: "HTTP响应描述",
	            width: 136,
	            resizable: true
	        }, {
	            key: 'duration',
	            name: "耗时(ms)",
	            width: 136,
	            resizable: true
	        }];
	
	        _this.columns = columns;
	        _this.state = {
	            rows: _this.props.fdataProvider,
	            selectedIndexes: [0],
	            fdataProvider: {},
	            title: _this.props.title
	        };
	
	        return _this;
	    }
	
	    _createClass(NetWorkErrorLog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            $(this.netWorkErrorLogContainer).draggable({
	                handle: ".modal-header" // 只能点击头部拖动
	            }); //为模态对话框添加拖拽
	
	            $("#netWorkErrorInfoModal").css("display", "flex");
	            var index = this.state.selectedIndexes[0];
	            if (index == -1 || index == undefined) index = 0;
	            var data = this.state.rows[0];
	            if (data) $(this.reasonDiv).html(NetWorkErrorLog.textMap[data.httpStatus]);
	        }
	    }, {
	        key: 'gridKeyDown',
	        value: function gridKeyDown(proxy) {
	            //console.log(arguments);
	            if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	                var ne = proxy["nativeEvent"];
	
	                if (ne.keyCode == 40 || ne.keyCode == 38) {
	                    var record = null;
	                    var newSelectIndexes = this.state.selectedIndexes.slice();
	                    if (newSelectIndexes.length == 0) {
	                        if (this.state.rows.length > 0) {
	                            record = ne.keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
	                            newSelectIndexes.push(0);
	                        }
	                    } else {
	                        var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	                        var newIndex = ne.keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
	                        var total = this.state.rows.length;
	                        if (newIndex >= 0 && newIndex < total) {
	                            record = this.state.rows[newIndex];
	                            newSelectIndexes = [newIndex];
	                        }
	                    }
	
	                    this.setState({ selectedIndexes: newSelectIndexes });
	                    return true;
	                }
	            }
	        }
	        /** 
	         *  <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative"}}>
	                      <i className="fa fa-close" style={{position: 'absolute',top: '13px', right: '10px', fontSize: '15px', cursor: 'pointer'}}  onClick={this.close.bind(this)}></i>
	                      <h5 className="modal-title" style={{fontWeight:'bolder'}}>{this.state.title}</h5>
	                  </div>
	          */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(
	                'div',
	                { ref: function ref(node) {
	                        return _this2.netWorkErrorLogContainer = node;
	                    }, tabIndex: '-1', style: { position: 'absolute', alignSelf: "center", borderRadius: "2px", backgroundColor: 'white', width: '750px', height: '500px', display: 'flex', flexDirection: 'column', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)' } },
	                React.createElement(
	                    'div',
	                    { className: 'modal-header', style: { background: "#ffffff", padding: "10px", position: "relative", paddingTop: '13px', paddingBottom: '13px', backgroundColor: '#F8F8F8' } },
	                    React.createElement('div', { className: 'modal-close', onClick: this.close.bind(this) }),
	                    React.createElement(
	                        'h5',
	                        { className: 'modal-title', style: { fontFamily: 'STSongti-SC-Bold', fontSize: '16px', color: '#000000', fontWeight: '500 !IMPORTANT' } },
	                        this.state.title
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column', flexGrow: 100, padding: '5px' } },
	                    React.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'column', alignSelf: 'stretch' }, ref: function ref(node) {
	                                return _this2.gridContainer = node;
	                            } },
	                        React.createElement(ReactDataGrid, {
	                            ref: function ref(node) {
	                                return _this2.grid = node;
	                            }
	                            // onGridSort={this.handleGridSort}
	                            , enableCellSelect: true,
	                            columns: this.columns //columns={this.state.columns}
	                            // columns={this.props.columns}
	                            // columns={this.getColumns()}
	                            , rowGetter: this.getRowAt,
	                            rowsCount: this.getSize()
	                            //onGridRowsUpdated={this.handleGridRowsUpdated}
	                            // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	                            , enableRowSelect: false,
	                            onGridKeyDown: this.gridKeyDown.bind(this),
	                            rowSelection: {
	                                showCheckbox: false,
	                                selectBy: {
	                                    indexes: this.state.selectedIndexes
	
	                                }
	                            },
	                            onRowClick: this.rowClick //this.rowClick this.rowClick.bind(this)
	                            , rowHeight: 30,
	                            minHeight: 310,
	                            rowScrollTimeout: 500,
	                            cellNavigationMode: 'loopOverRow'
	
	                        })
	                    ),
	                    React.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'column', flexGrow: 0, padding: '4px 0' } },
	                        React.createElement(
	                            'label',
	                            null,
	                            '\u539F\u56E0\u5206\u6790'
	                        ),
	                        React.createElement('div', { ref: function ref(node) {
	                                return _this2.reasonDiv = node;
	                            } })
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'show',
	        value: function show(fdataProvider, title) {
	
	            _reactDom2.default.render(React.createElement(NetWorkErrorLog, { fdataProvider: fdataProvider, title: title }), document.getElementById('netWorkErrorInfoModal'));
	        }
	    }]);
	
	    return NetWorkErrorLog;
	}(React.Component);
	
	NetWorkErrorLog.textMap = (_NetWorkErrorLog$text = {
	
	    0: "网络连接错误 通常有以下几种情况:<br/>1.操作系统没有连接网络或服务器（或者上游代理）已关闭<br/>2.网络较差，此次请求未能正确建立基础连接 请注意此时通过网络标记查看也可以是有信号的<br/>3.网络较差，此次请求建立了正确的基础连接，但是不足以支撑此次请求的应用数据传输过程，最终断开<br/>4.网络较差，操作系统自动切换到了其认为可能更好的另外一个网络，比如从wifi1切换到了wifi2",
	
	    400: "Bad Request <br/> 1、语义有误，当前请求无法被服务器理解。除非进行修改，否则客户端不应该重复提交这个请求。<br/> 2、请求参数有误。",
	
	    401: "Unauthorized <br/> 当前请求需要用户验证。该响应必须包含一个适用于被请求资源的 WWW-Authenticate 信息头用以询问用户信息。<br/> 客户端可以重复提交一个包含恰当的 Authorization 头信息的请求。如果当前请求已经包含了 Authorization 证书，那么401响应代表着服务器验证已经拒绝了那些证书。如果401响应包含了与前一个响应相同的身份验证询问，且浏览器已经至少尝试了一次验证，那么浏览器应当向用户展示响应中包含的实体信息，因为这个实体信息中可能包含了相关诊断信息。",
	
	    402: "Payment Required <br/> 此响应码保留以便将来使用，创造此响应码的最初目的是用于数字支付系统，然而现在并未使用。",
	
	    403: "Forbidden <br/> 服务器已经理解请求，但是拒绝执行它。与 401 响应不同的是，身份验证并不能提供任何帮助，而且这个请求也不应该被重复提交。<br/> 如果这不是一个 HEAD 请求，而且服务器希望能够讲清楚为何请求不能被执行，那么就应该在实体内描述拒绝的原因。当然服务器也可以返回一个 404 响应，假如它不希望让客户端获得任何信息。",
	
	    404: "Not Found <br/> 请求失败，请求所希望得到的资源未被在服务器上发现。<br/>没有信息能够告诉用户这个状况到底是暂时的还是永久的。假如服务器知道情况的话，应当使用410状态码来告知旧资源因为某些内部的配置机制问题，已经永久的不可用，而且没有任何可以跳转的地址。<br/>404这个状态码被广泛应用于当服务器不想揭示到底为何请求被拒绝或者没有其他适合的响应可用的情况下。",
	
	    405: "Method Not Allowed <br/> 请求行中指定的请求方法不能被用于请求相应的资源。<br/>该响应必须返回一个Allow 头信息用以表示出当前资源能够接受的请求方法的列表。<br/>鉴于 PUT，DELETE 方法会对服务器上的资源进行写操作，因而绝大部分的网页服务器都不支持或者在默认配置下不允许上述请求方法，对于此类请求均会返回405错误。",
	
	    406: "Not Acceptable <br/> 请求的资源的内容特性无法满足请求头中的条件，因而无法生成响应实体。",
	
	    407: "Proxy Authentication Required <br/> 与401响应类似，只不过客户端必须在代理服务器上进行身份验证。代理服务器必须返回一个 Proxy-Authenticate 用以进行身份询问。客户端可以返回一个 Proxy-Authorization 信息头用以验证。",
	
	    408: "Request Timeout <br/> 请求超时。客户端没有在服务器预备等待的时间内完成一个请求的发送。客户端可以随时再次提交这一请求而无需进行任何更改。",
	
	    409: "Conflict <br/> 由于和被请求的资源的当前状态之间存在冲突，请求无法完成。<br/>这个代码只允许用在这样的情况下才能被使用：用户被认为能够解决冲突，并且会重新提交新的请求。该响应应当包含足够的信息以便用户发现冲突的源头。",
	
	    410: "Gone <br/> 被请求的资源在服务器上已经不再可用，而且没有任何已知的转发地址。这样的状况应当被认为是永久性的。<br/>如果可能，拥有链接编辑功能的客户端应当在获得用户许可后删除所有指向这个地址的引用。<br/>如果服务器不知道或者无法确定这个状况是否是永久的，那么就应该使用 404 状态码。除非额外说明，否则这个响应是可缓存的。",
	
	    411: "Length Required <br/> 服务器拒绝在没有定义 Content-Length 头的情况下接受请求。<br/>在添加了表明请求消息体长度的有效 Content-Length 头之后，客户端可以再次提交该请求。",
	
	    412: "Precondition Failed <br/> 服务器在验证在请求的头字段中给出先决条件时，没能满足其中的一个或多个。<br/>这个状态码允许客户端在获取资源时在请求的元信息（请求头字段数据）中设置先决条件，以此避免该请求方法被应用到其希望的内容以外的资源上。",
	
	    413: "Payload Too Large <br/> 服务器拒绝处理当前请求，因为该请求提交的实体数据大小超过了服务器愿意或者能够处理的范围。<br/>此种情况下，服务器可以关闭连接以免客户端继续发送此请求。如果这个状况是临时的，服务器应当返回一个 Retry-After 的响应头，以告知客户端可以在多少时间以后重新尝试。",
	
	    414: "URI Too Long <br/> 请求的URI 长度超过了服务器能够解释的长度，因此服务器拒绝对该请求提供服务。<br/>这比较少见，通常的情况包括：本应使用POST方法的表单提交变成了GET方法，导致查询字符串（Query String）过长。",
	
	    415: "Unsupported Media Type <br/> 对于当前请求的方法和所请求的资源，请求中提交的实体并不是服务器中所支持的格式，因此请求被拒绝。",
	
	    416: "Requested Range Not Satisfiable <br/> 如果请求中包含了 Range 请求头，并且 Range 中指定的任何数据范围都与当前资源的可用范围不重合，<br/>同时请求中又没有定义 If-Range 请求头，那么服务器就应当返回416状态码。",
	
	    417: "Expectation Failed <br/> 此响应代码意味着服务器无法满足 期望 请求标头字段指示的期望值。",
	
	    418: "I’m a teapot <br/> 服务器拒绝尝试用 “茶壶冲泡咖啡”。"
	
	}, _defineProperty(_NetWorkErrorLog$text, '412', "Precondition Failed <br/> 该请求针对的是无法产生响应的服务器。<br/> 这可以由服务器发送，该服务器未配置为针对包含在请求 URI 中的方案和权限的组合产生响应。"), _defineProperty(_NetWorkErrorLog$text, 422, "Unprocessable Entity (WebDAV) <br/> 请求格式良好，但由于语义错误而无法遵循。"), _defineProperty(_NetWorkErrorLog$text, 423, "Locked (WebDAV) <br/> 正在访问的资源被锁定。"), _defineProperty(_NetWorkErrorLog$text, 424, "Failed Dependency (WebDAV) <br/> 由于先前的请求失败，所以此次请求失败。"), _defineProperty(_NetWorkErrorLog$text, 426, "Upgrade Required <br/> 服务器拒绝使用当前协议执行请求，但可能在客户机升级到其他协议后愿意这样做。<br/> 服务器在 426 响应中发送 Upgrade 头以指示所需的协议。"), _defineProperty(_NetWorkErrorLog$text, 428, "Precondition Required <br/> 原始服务器要求该请求是有条件的。 旨在防止“丢失更新”问题，<br/>即客户端获取资源状态，修改该状态并将其返回服务器，同时第三方修改服务器上的状态，从而导致冲突。"), _defineProperty(_NetWorkErrorLog$text, 429, "Too Many Requests <br/> 用户在给定的时间内发送了太多请求（“限制请求速率”）。"), _defineProperty(_NetWorkErrorLog$text, 431, "Request Header Fields Too Large <br/> 服务器不愿意处理请求，因为它的 请求头字段太大（ Request Header Fields Too Large）。 <br/>请求可以在减小请求头字段的大小后重新提交。"), _defineProperty(_NetWorkErrorLog$text, 451, "Unavailable For Legal Reasons <br/> 用户请求非法资源，例如：由政府审查的网页。"), _defineProperty(_NetWorkErrorLog$text, 500, "Internal Server Error <br/> 服务器遇到了不知道如何处理的情况。通常服务器日志中会有异常栈"), _defineProperty(_NetWorkErrorLog$text, 501, "Not Implemented <br/> 此请求方法不被服务器支持且无法被处理。只有GET和HEAD是要求服务器支持的，它们必定不会返回此错误代码。"), _defineProperty(_NetWorkErrorLog$text, 502, "Bad Gateway <br/> 此错误响应表明服务器作为网关需要得到一个处理这个请求的响应，但是得到一个错误的响应。"), _defineProperty(_NetWorkErrorLog$text, 503, "Service Unavailable <br/> 服务器没有准备好处理请求。 常见原因是服务器因维护或重载而停机。 <br/>请注意，与此响应一起，应发送解释问题的用户友好页面。 这个响应应该用于临时条件和 Retry-After：如果可能的话，HTTP头应该包含恢复服务之前的估计时间。 <br/>网站管理员还必须注意与此响应一起发送的与缓存相关的标头，因为这些临时条件响应通常不应被缓存。"), _defineProperty(_NetWorkErrorLog$text, 504, "Gateway Timeout <br/> 当服务器作为网关，不能及时得到响应时返回此错误代码。"), _defineProperty(_NetWorkErrorLog$text, 505, "HTTP Version Not Supported <br/> 服务器不支持请求中所使用的HTTP协议版本。"), _defineProperty(_NetWorkErrorLog$text, 506, "Variant Also Negotiates <br/> 服务器有一个内部配置错误：对请求的透明内容协商导致循环引用。"), _defineProperty(_NetWorkErrorLog$text, 507, "Insufficient Storage <br/> 服务器有内部配置错误：所选的变体资源被配置为参与透明内容协商本身，因此不是协商过程中的适当端点。"), _defineProperty(_NetWorkErrorLog$text, 508, "Loop Detected (WebDAV) The server detected an infinite loop while processing the request. <br/> 服务器在处理请求时检测到无限循环。"), _defineProperty(_NetWorkErrorLog$text, 510, "Not Extended <br/> 服务器需要对请求进一步扩展才能实现它。"), _defineProperty(_NetWorkErrorLog$text, 511, "Network Authentication Required <br/> 客户端需要进行身份验证才能获得网络访问权限。"), _NetWorkErrorLog$text);
	exports.default = NetWorkErrorLog;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ServiceHelper = __webpack_require__(10);
	
	var _ServiceHelper2 = _interopRequireDefault(_ServiceHelper);
	
	var _Command = __webpack_require__(20);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _jqueryTableExport = __webpack_require__(520);
	
	var _jqueryTableExport2 = _interopRequireDefault(_jqueryTableExport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactDataGrid = __webpack_require__(29);
	
	var _require = __webpack_require__(671),
	    Toolbar = _require.Toolbar,
	    _require$Filters = _require.Filters,
	    NumericFilter = _require$Filters.NumericFilter,
	    AutoCompleteFilter = _require$Filters.AutoCompleteFilter,
	    Selectors = _require.Data.Selectors;
	
	var React = __webpack_require__(1);
	
	__webpack_require__(777);
	
	var OnLineUser = function (_React$Component) {
	  _inherits(OnLineUser, _React$Component);
	
	  function OnLineUser(props) {
	    _classCallCheck(this, OnLineUser);
	
	    var _this = _possibleConstructorReturn(this, (OnLineUser.__proto__ || Object.getPrototypeOf(OnLineUser)).call(this, props));
	
	    _this.close = function () {
	      var $reactComponentContainer = $("#onLineUserModal");
	      _reactDom2.default.unmountComponentAtNode($reactComponentContainer[0]);
	      $("#onLineUserModal").css("display", "none");
	    };
	
	    _this.getRowAt = function (index) {
	      var rows = _this.getRows();
	      if (index < 0 || index > _this.getSize()) {
	        return undefined;
	      }
	
	      return rows[index];
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowClick = function (index, record, proxy) {
	
	      _this.setState({ selectedIndexes: [index] });
	    };
	
	    _this.onRowsSelected = function (rows) {
	      _this.setState({
	        selectedIndexes: _this.state.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }))
	      });
	    };
	
	    _this.onRowsDeselected = function (rows) {
	      var rowIndexes = rows.map(function (r) {
	        return r.rowIdx;
	      });
	      _this.setState({
	        selectedIndexes: _this.state.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        })
	      });
	    };
	
	    var columns = [{
	      key: 'userId',
	      name: "用户ID",
	      width: 70,
	      resizable: true,
	      filterable: true,
	      filterRenderer: AutoCompleteFilter
	    }, {
	      key: 'clientSessionId',
	      name: "会话ID",
	      width: 200,
	      resizable: true,
	      filterable: true
	    }, {
	      key: 'loginDate',
	      name: "登录日期",
	      width: 85,
	      resizable: true,
	      filterable: true,
	      filterRenderer: AutoCompleteFilter
	      //formatter:<NetWorkErrorDateTimeRender/>
	    }, {
	      key: 'loginTime',
	      name: "登录时间",
	      width: 80,
	      resizable: true,
	      filterable: true,
	      filterRenderer: AutoCompleteFilter
	    }, {
	      key: 'lastCallIn',
	      name: "最后访问-进",
	      width: 140,
	      resizable: true,
	      filterable: true,
	      filterRenderer: AutoCompleteFilter
	    }, {
	      key: 'lastCallOut',
	      name: "最后访问-出",
	      width: 140,
	      resizable: true,
	      filterable: true,
	      filterRenderer: AutoCompleteFilter
	    }];
	
	    _this.columns = columns;
	    _this.state = {
	      rows: _this.props.fdataProvider,
	      selectedIndexes: [0],
	      title: _this.props.title + "(" + (_this.props.fdataProvider ? _this.props.fdataProvider.length : 0) + ")",
	      filters: {}
	    };
	
	    return _this;
	  }
	
	  _createClass(OnLineUser, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $(this.netWorkErrorLogContainer).draggable({
	        handle: ".modal-header" // 只能点击头部拖动
	      }); //为模态对话框添加拖拽
	
	      $("#onLineUserModal").css("display", "flex");
	    }
	  }, {
	    key: 'getRows',
	    value: function getRows() {
	      return Selectors.getRows(this.state);
	    }
	  }, {
	    key: 'handleFilterChange',
	    value: function handleFilterChange(filter) {
	      var newFilters = Object.assign({}, this.state.filters);
	      if (filter.filterTerm) {
	        newFilters[filter.column.key] = filter;
	      } else {
	        delete newFilters[filter.column.key];
	      }
	      this.setState({ filters: newFilters });
	    }
	  }, {
	    key: 'onClearFilters',
	    value: function onClearFilters() {
	      // all filters removed
	      this.setState({ filters: {} });
	    }
	  }, {
	    key: 'getValidFilterValues',
	    value: function getValidFilterValues(columnId) {
	      var values = this.state.rows.map(function (r) {
	        return r[columnId];
	      });
	      return values.filter(function (item, i, a) {
	        return i === a.indexOf(item);
	      });
	    }
	  }, {
	    key: 'gridKeyDown',
	    value: function gridKeyDown(proxy) {
	      //console.log(arguments);
	      if (proxy != null && proxy != undefined && proxy.hasOwnProperty("nativeEvent")) {
	        var ne = proxy["nativeEvent"];
	
	        if (ne.keyCode == 40 || ne.keyCode == 38) {
	          var record = null;
	          var newSelectIndexes = this.state.selectedIndexes.slice();
	          if (newSelectIndexes.length == 0) {
	            if (this.state.rows.length > 0) {
	              record = ne.keyCode == 40 ? this.state.rows[0] : this.state.rows[this.state.rows.length - 1];
	              newSelectIndexes.push(0);
	            }
	          } else {
	            var lastIndex = newSelectIndexes[newSelectIndexes.length - 1];
	            var newIndex = ne.keyCode == 40 ? lastIndex + 1 : lastIndex - 1;
	            var total = this.state.rows.length;
	            if (newIndex >= 0 && newIndex < total) {
	              record = this.state.rows[newIndex];
	              newSelectIndexes = [newIndex];
	            }
	          }
	
	          this.setState({ selectedIndexes: newSelectIndexes });
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage() {
	      var selectedIndexes = this.state.selectedIndexes;
	      if (selectedIndexes && selectedIndexes.length > 0) {
	        var _body = $(this.txt).val();
	        if (!_body) {
	          _Fade2.default.show({ text: "请填写消息内容" });
	          return;
	        }
	        var mo = { remoteClass: "gongqi.erp.framework.message.MessageObject" };
	        mo.from = window.userInfos.userSessionId + "," + window.userInfos.userId;
	        mo.subject = "[管理员通知]";
	        mo.to = "";
	        for (var i = 0; i < selectedIndexes.length; i++) {
	          var user = this.state.rows[selectedIndexes[i]];
	          mo.to += user["clientSessionId"] + "," + user["userId"] + "|";
	        }
	        if (mo.to.length > 0) mo.to = mo.to.substr(0, mo.to.length - 1);
	        mo.bodyLabel = "通知";
	        mo.bodyType = "String";
	        mo.body = _body;
	        mo.time = new Date().Format("yyyy-MM-dd HH:mm:ss");
	        mo.modal = $(this.important).is(':checked');
	
	        var command = _Command2.default.createService("gongqi.erp.framework.services.MessageService", "dispatchMessage", "void");
	        command.appendArg(mo, "MessageObject");
	        _ServiceHelper2.default.addTokenWithCommand({ command: command, resultFunction: this.result_sendMessage_Handler.bind(this) });
	      } else {
	        _Fade2.default.show({ text: "请选择需要通知的用户" });
	      }
	    }
	  }, {
	    key: 'result_sendMessage_Handler',
	    value: function result_sendMessage_Handler(data) {
	      _Fade2.default.show({ text: "消息已发送" });
	      $(this.txt).val("");
	      $(this.important).removeAttr("checked");
	    }
	  }, {
	    key: 'refreshUsers',
	    value: function refreshUsers() {
	      _ServiceHelper2.default.call("gongqi.erp.framework.services.UserSessionService", "findAllDetail", "List", this.result_refreshUserList.bind(this), false);
	    }
	  }, {
	    key: 'result_refreshUserList',
	    value: function result_refreshUserList(data) {
	      var list = data.result;
	      this.setState({ rows: list });
	    }
	  }, {
	    key: 'deleteUsers',
	    value: function deleteUsers() {
	      var selectedIndexes = this.state.selectedIndexes;
	      if (selectedIndexes && selectedIndexes.length > 0) {
	        var user = this.state.rows[selectedIndexes[0]];
	        if (!user) return;
	        var sessionId = user.clientSessionId;
	        if (sessionId != window.userInfos.userSessionId) {
	          _ServiceHelper2.default.call("gongqi.erp.framework.services.UserSessionService", "kickOffSession", "void", this.rpc_result_kickUser.bind(this), false, null, sessionId);
	        }
	      }
	    }
	  }, {
	    key: 'exportUsers',
	    value: function exportUsers() {
	      var options = {
	        type: 'excel'
	      };
	      var exportHeads = [];
	      for (var _i = 0; _i < this.columns.length; _i++) {
	        var col = this.columns[_i];
	        var _item = { dataField: col.key, name: col.name, columnType: "String" };
	        exportHeads.push(_item);
	      }
	
	      var ac = this.state.rows.slice();
	      var exportBodys = [];
	      for (var i = 0; i < ac.length; i++) {
	        var item = ac[i];
	        var exportBody = [];
	        for (var j = 0; j < exportHeads.length; j++) {
	          var key = exportHeads[j].dataField;
	          exportBody.push(item[key]);
	        }
	        exportBodys.push(exportBody);
	      }
	
	      $(this.netWorkErrorLogContainer).tableExport(exportHeads, exportBodys, options);
	    }
	  }, {
	    key: 'rpc_result_kickUser',
	    value: function rpc_result_kickUser() {
	      var selectedIndexes = this.state.selectedIndexes;
	      if (selectedIndexes && selectedIndexes.length > 0) {
	        var selectedIndex = selectedIndexes[0];
	        var rows = this.state.rows.slice();
	        rows.splice(selectedIndex, 1);
	        var newSelectedIndex = selectedIndex - 1 > 0 ? selectedIndex - 1 : 0;
	        this.setState({ rows: rows, selectedIndexes: [newSelectedIndex] });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(
	        'div',
	        { ref: function ref(node) {
	            return _this2.netWorkErrorLogContainer = node;
	          }, tabIndex: '-1', style: { position: 'absolute', alignSelf: "center", backgroundColor: 'white', width: '800px', height: '580px', display: 'flex', flexDirection: 'column', background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px' } },
	        React.createElement(
	          'div',
	          { className: 'modal-header', style: { position: "relative" } },
	          React.createElement('div', { className: 'modal-close', onClick: this.close.bind(this) }),
	          React.createElement(
	            'h5',
	            { className: 'modal-title', style: { fontWeight: 'bolder', fontSize: '16px' } },
	            this.state.title
	          )
	        ),
	        React.createElement(
	          'div',
	          { style: { display: 'flex', flexDirection: 'column', flexGrow: 100, padding: '5px' } },
	          React.createElement(
	            'div',
	            { style: { display: 'flex', flexDirection: 'column', alignSelf: 'stretch', marginBottom: '5px' }, ref: function ref(node) {
	                return _this2.gridContainer = node;
	              } },
	            React.createElement(ReactDataGrid, {
	              ref: function ref(node) {
	                return _this2.grid = node;
	              }
	              // onGridSort={this.handleGridSort}
	              , enableCellSelect: true,
	              columns: this.columns //columns={this.state.columns}
	              // columns={this.props.columns}
	              // columns={this.getColumns()}
	              , rowGetter: this.getRowAt,
	              rowsCount: this.getSize()
	              //onGridRowsUpdated={this.handleGridRowsUpdated}
	              // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
	              , enableRowSelect: false,
	              onGridKeyDown: this.gridKeyDown.bind(this),
	              rowSelection: {
	                showCheckbox: true,
	                enableShiftSelect: true,
	                onRowsSelected: this.onRowsSelected,
	                onRowsDeselected: this.onRowsDeselected,
	                selectBy: {
	                  indexes: this.state.selectedIndexes
	                }
	              }
	              //onRowClick={this.rowClick}//this.rowClick this.rowClick.bind(this)
	              , rowHeight: 30,
	              minHeight: 250,
	              rowScrollTimeout: 500,
	              cellNavigationMode: 'loopOverRow',
	              toolbar: React.createElement(Toolbar, { enableFilter: true }),
	              onAddFilter: this.handleFilterChange.bind(this),
	              onClearFilters: this.onClearFilters.bind(this),
	              getValidFilterValues: this.getValidFilterValues.bind(this)
	            })
	          ),
	          React.createElement('textarea', { rows: '10', placeholder: '\u6B64\u5904\u952E\u5165\u6D88\u606F\u5185\u5BB9', ref: function ref(node) {
	              return _this2.txt = node;
	            }, style: { border: '1px solid #E0E2E6', borderRadius: '4px' } }),
	          React.createElement(
	            'div',
	            { className: 'onLineUser_important', style: { display: 'flex', flexDirection: 'row', flexGrow: 0, padding: '10px 0', alignItems: 'center', justifyContent: 'flex-end' } },
	            React.createElement(
	              'div',
	              { style: { marginRight: '7px', position: 'relative', width: '18px', height: '18px' } },
	              React.createElement('input', { type: 'checkbox', id: 'onlineuser_text', ref: function ref(node) {
	                  return _this2.important = node;
	                } }),
	              React.createElement('label', { htmlFor: 'onlineuser_text' })
	            ),
	            React.createElement(
	              'label',
	              { style: { marginTop: '4px', marginRight: '20px' } },
	              '\u91CD\u8981'
	            ),
	            React.createElement(
	              'button',
	              { className: 'btn btn-info', style: { color: '#0078D4', marginRight: '5px', width: '88px', height: '28px', border: '1px solid #0078D4', borderRadius: '2px' }, onClick: this.sendMessage.bind(this) },
	              React.createElement('i', { className: 'fa fa-paper-plane-o', style: { color: '#0078D4', marginRight: '5px' } }),
	              '\u53D1\u9001'
	            ),
	            React.createElement(
	              'button',
	              { className: 'btn btn-info', style: { color: '#0078D4', marginRight: '5px', width: '88px', height: '28px', border: '1px solid #0078D4', borderRadius: '2px' }, onClick: this.refreshUsers.bind(this) },
	              React.createElement('i', { className: 'fa fa-repeat', style: { color: '#0078D4', marginRight: '5px' } }),
	              '\u5237\u65B0'
	            ),
	            React.createElement(
	              'button',
	              { className: 'btn btn-info', style: { color: '#0078D4', marginRight: '5px', width: '88px', height: '28px', border: '1px solid #0078D4', borderRadius: '2px' }, onClick: this.deleteUsers.bind(this) },
	              React.createElement('i', { className: 'fa fa-trash-o', style: { color: '#0078D4', marginRight: '5px' } }),
	              '\u5220\u9664'
	            ),
	            React.createElement(
	              'button',
	              { className: 'btn btn-info', style: { color: '#0078D4', width: '88px', height: '28px', border: '1px solid #0078D4', borderRadius: '2px' }, onClick: this.exportUsers.bind(this) },
	              React.createElement('i', { className: 'fa fa-file-excel-o', style: { color: '#0078D4', marginRight: '5px' } }),
	              '\u5BFC\u51FA'
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'show',
	    value: function show(fdataProvider, title) {
	
	      _reactDom2.default.render(React.createElement(OnLineUser, { fdataProvider: fdataProvider, title: title }), document.getElementById('onLineUserModal'));
	    }
	  }]);
	
	  return OnLineUser;
	}(React.Component);
	
	exports.default = OnLineUser;

/***/ },
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BusinessMapUtil = function () {
	    function BusinessMapUtil() {
	        _classCallCheck(this, BusinessMapUtil);
	    }
	
	    _createClass(BusinessMapUtil, null, [{
	        key: "defaultline",
	
	        // gongqi.erp.basedata  基础数据 自动构建首页流程图
	
	        value: function defaultline() {
	            var line = { "shape": "edge", "attrs": { "line": { "stroke": "#1890ff", "targetMarker": { "name": "classic", "size": 8 }, "strokeDasharray": 0, "style": { "animation": "ant-line 30s infinite linear" } } },
	                "id": "", "connector": "normal", "router": { "name": "" }, "zIndex": 0, "labels": [{ "text": "" }],
	                "source": { "cell": "", "port": "port4" }, "target": { "cell": "", "port": "port3" }
	            };
	            return line;
	        }
	    }, {
	        key: "defaultCell",
	        value: function defaultCell() {
	            var cell = { "position": { "x": 0, "y": 0 }, "size": { "width": 130, "height": 85 },
	                "attrs": { "body": { "fill": "#fff" }, "avatar": { "letterSpacing": 0, "id": "", "xlinkHref": '../../../static/img/box.png' }, "name": { "fontFamily": "Arial", "fontSize": 13, "text": "", "fill": "#696969", "letterSpacing": 0, "id": "" },
	                    "explain": { "fontFamily": "Arial", "text": "", "fill": "#696969", "letterSpacing": 0 } }, "shape": "org-node", "id": "",
	                "ports": { "groups": { "top": { "position": "top", "attrs": { "circle": { "r": 4, "magnet": true, "stroke": "#2D8CF0", "strokeWidth": 2, "fill": "#fff" } } },
	                        "bottom": { "position": "bottom", "attrs": { "circle": { "r": 4, "magnet": true, "stroke": "#2D8CF0", "strokeWidth": 2, "fill": "#fff" } } },
	                        "left": { "position": "left", "attrs": { "circle": { "r": 4, "magnet": true, "stroke": "#2D8CF0", "strokeWidth": 2, "fill": "#fff" } } },
	                        "right": { "position": "right", "attrs": { "circle": { "r": 4, "magnet": true, "stroke": "#2D8CF0", "strokeWidth": 2, "fill": "#fff" } } }
	                    },
	                    "items": [{ "id": "port1", "group": "top" }, { "id": "port2", "group": "bottom" }, { "id": "port3", "group": "left" }, { "id": "port4", "group": "right" }]
	                },
	                "zIndex": 1
	            };
	            return cell;
	        }
	    }, {
	        key: "BusinessMapJSON",
	        value: function BusinessMapJSON(appId, mainmenuString) {
	            var jsonObj = {};
	            var main = JSON.parse(mainmenuString);
	            jsonObj = this.getBasedataJSON(main);
	            return jsonObj;
	        }
	    }, {
	        key: "getBasedataJSON",
	        value: function getBasedataJSON(mainMenu) {
	            var _this = this;
	
	            window.MenuItemsForBus = [];
	            var its = this.authorityMenu(mainMenu.items, null);
	            var newMenu = { 'id': "MainMenu", 'items': its };
	            this.analysisMainMenu(newMenu);
	            var xIndex = 0;
	            var yIndex = 0;
	            var jsonObj = { "cells": [] };
	            window.MenuItemsForBus.forEach(function (item, index) {
	                var userCell = _this.defaultCell();
	                if (index != 0 && index % 5 == 0) {
	                    yIndex = yIndex + 150;
	                    xIndex = 0;
	                }
	                userCell.position.x = xIndex;
	                userCell.position.y = yIndex;
	                userCell.attrs.avatar.id = item.id;
	                userCell.attrs.name.text = item.Properties.Label.V;
	                userCell.attrs.name.id = item.id;
	                userCell.id = _this.guid();
	                userCell.zIndex = index + 1;
	                xIndex = xIndex + 200;
	                jsonObj.cells.push(userCell);
	            });
	
	            return jsonObj;
	        }
	    }, {
	        key: "authorityMenu",
	        value: function authorityMenu(items, moudleId) {
	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                if (item.qname) {
	                    if (item.qname == "MenuItem") {
	                        if (!window.flatMainMenuToMenuItem.hasOwnProperty(item.id)) {
	                            window.flatMainMenuToMenuItem[item.id] = {};
	                        }
	                        var _menuKey = moudleId + '.' + item.idInMenu;
	                        window.flatMainMenuToMenuItem[item.id][_menuKey] = true;
	                        var isShow = false;
	                        var onlyQuery = false;
	                        var visible = item.Properties.Visible.V;
	                        if (visible != 'false') {
	                            if (window.userInfos.isAdmin) {
	                                isShow = true;
	                            } else {
	                                var thisAu = moudleId + '.' + item.idInMenu;
	                                var authorityArr = window.xmlType1SCache[thisAu];
	                                if (authorityArr) {
	
	                                    if (!authorityArr.del && !authorityArr.visible && !authorityArr.query) {
	                                        onlyQuery = true;
	                                    } else if (!authorityArr.del && authorityArr.query) {
	                                        isShow = true;onlyQuery = true;
	                                    } else if (authorityArr.del || authorityArr.query) {
	                                        isShow = true;
	                                    }
	                                }
	                            }
	                        } else {
	                            delete items[i];
	                            //items.splice(i,1);
	                        }
	
	                        if (!isShow) {
	                            //items.splice(i,1);
	                            delete items[i];
	                        }
	                    } else if (item.qname == "MenuSub") {
	
	                        var isShow = false;
	                        var visible = item.Properties.Visible.V;
	                        if (visible == 'true') {
	                            if (window.userInfos.isAdmin) {
	                                isShow = true;
	                            } else {
	                                var thisAu = moudleId + '.' + item.id;
	                                var authorityArr = window.xmlType1SCache[thisAu];
	                                if (authorityArr) {
	                                    if (!authorityArr.del && !authorityArr.query && !authorityArr.visible) {
	                                        isShow = false;
	                                    } else {
	                                        isShow = true;
	                                    }
	                                }
	                            }
	                        } else {
	                            //items.splice(i,1);
	                            delete items[i];
	                        }
	
	                        if (isShow) {
	                            this.authorityMenu(item.items, moudleId);
	                        } else {
	                            //items.splice(i,1);
	                            delete items[i];
	                        }
	                    }
	                } else {
	                    var isShow = false;
	                    var visible = item.Properties.Visible.V;
	                    if (visible == 'true') {
	                        if (window.userInfos.isAdmin) {
	                            isShow = true;
	                        } else {
	                            moudleId = item.id;
	                            var authorityArr = window.xmlType0SCache[moudleId];
	                            if (authorityArr) {
	                                if (authorityArr.del) {
	                                    isShow = true;
	                                } else {
	                                    isShow = false;
	                                }
	                            }
	                        }
	                    } else {
	                        //items.splice(i,1);
	                        delete items[i];
	                    }
	
	                    if (isShow) {
	                        this.authorityMenu(item.items, moudleId);
	                    } else {
	                        // items.splice(i,1);
	                        delete items[i];
	                    }
	                }
	            }
	            return items;
	        }
	    }, {
	        key: "guid",
	        value: function guid() {
	            return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    }, {
	        key: "analysisMainMenu",
	        value: function analysisMainMenu(mainMenu) {
	            var _this2 = this;
	
	            if (mainMenu) {
	                mainMenu.items.forEach(function (item) {
	                    if (item) {
	                        item.items.forEach(function (item2) {
	                            if (item2) {
	                                _this2.analysisMenuItem(item2);
	                            }
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: "analysisMenuItem",
	        value: function analysisMenuItem(item) {
	            var _this3 = this;
	
	            if (item.qname && item.qname == "MenuItem") {
	                window.MenuItemsForBus.push(item);
	            } else {
	                item.items.forEach(function (item3) {
	                    if (item3) {
	                        _this3.analysisMenuItem(item3);
	                    }
	                });
	            }
	        }
	    }]);
	
	    return BusinessMapUtil;
	}();
	
	exports.default = BusinessMapUtil;

/***/ },
/* 591 */,
/* 592 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HtmlArgUtil = function HtmlArgUtil() {
		_classCallCheck(this, HtmlArgUtil);
	};
	
	exports.default = HtmlArgUtil;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Fade = __webpack_require__(26);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LicenseUpLoad = function () {
		function LicenseUpLoad() {
			_classCallCheck(this, LicenseUpLoad);
		}
	
		_createClass(LicenseUpLoad, null, [{
			key: 'doFileUpload',
			value: function doFileUpload(task) {
				var fileUploadArg = task.arg;
	
				$("#indexcommonFileInput").off("change").on("change", function (event) {
					LicenseUpLoad.fieldUploadFileSelected(event, fileUploadArg);
				});
	
				if (fileUploadArg.type) $("#indexcommonFileInput").attr("accept", fileUploadArg.type);else $("#indexcommonFileInput").attr("accept", "*");
	
				$("#indexcommonFileInput").click();
			}
		}, {
			key: 'fieldUploadFileSelected',
			value: function fieldUploadFileSelected(e, fileUploadArg) {
				var uploadFiles = e.target.files || e.dataTransfer.files;
				var uploadFile = uploadFiles[0];
	
				if (fileUploadArg.maxSize && uploadFile.size > fileUploadArg.maxSize) {
					Warning.show({ text: fileUploadArg.sizeLimitInfo });
					return;
				}
	
				var url = fileUploadArg.url;
	
				var oMyForm = new FormData();
				oMyForm.append("licenseFile", uploadFile);
	
				var progressBar = $('<progress></progress>').css({ 'width': '15em', 'height': '2.1em' }).html('您的浏览器不支持progress元素');
	
				var progressA = $('<a></a>').css({ 'background-color': '#fff', 'color': '#ff0000', 'font-size': '1.5em' }).click(function () {
					that.client.abort();
				}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
				var progressBtn = $('<div></div>').append(progressA);
				var progressDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '40.5%', 'left': '40%', 'display': 'flex' }).append(progressBar).append(progressBtn);
				var percentageDiv = $('<span></span>');
				var time = $("<span></span>");
				var percentDiv = $('<div></div>').css({ 'position': 'absolute', 'top': '41%', 'left': '40.5%', 'font-size': '0.8em' }).append(percentageDiv).append(time);
				var progressBorder = $("<div></div>").append(progressDiv).append(percentDiv).attr('id', 'progressBorder').addClass('modal');
				$('body').append(progressBorder);
	
				if (LicenseUpLoad.tmpXMLHttpRequest == null) {
					LicenseUpLoad.tmpXMLHttpRequest = new XMLHttpRequest();
				}
	
				LicenseUpLoad.tmpXMLHttpRequest.upload.onprogress = function (pe) {
					if (pe.lengthComputable) {
						progressBorder.css('display', 'block');
						progressBar.attr('max', pe.total);
						progressBar.attr('value', pe.loaded);
						percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
					}
					var nt = new Date().getTime(); //获取当前时间
					var pertime = (nt - this.ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
					this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
					var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
					this.oloaded = pe.loaded; //重新赋值已上传文件大小，用以下次计算
	
					//上传速度计算
					var speed = perload / pertime; //单位b/s
					var bspeed = speed;
					var units = 'b/s'; //单位名称
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'k/s';
					}
					if (speed / 1024 > 1) {
						speed = speed / 1024;
						units = 'M/s';
					}
					speed = speed.toFixed(1);
					//剩余时间
					var resttime = ((pe.total - pe.loaded) / bspeed).toFixed(1);
	
					var timeContent = ' ' + speed + units + '，剩余时间：' + resttime + 's';
					time.html(timeContent);
				};
	
				LicenseUpLoad.tmpXMLHttpRequest.upload.onloadstart = function () {
					//上传开始执行方法
					this.ot = new Date().getTime(); //设置上传开始时间
					this.oloaded = 0; //设置上传开始时，以上传的文件大小为0
				};
				LicenseUpLoad.tmpXMLHttpRequest.onreadystatechange = function () {
					if (LicenseUpLoad.tmpXMLHttpRequest.readyState == 4) {
						if (LicenseUpLoad.tmpXMLHttpRequest.status == 200) {
							var options = { state: 'success', text: '更换成功,授权已自动生效！' };_Fade2.default.show(options);
						} else {
							var _options = { state: 'error', text: '更换成功！' };_Fade2.default.show(_options);
						}
						$('#indexcommonFileInput').val('');
					}
				};
	
				LicenseUpLoad.tmpXMLHttpRequest.open("POST", url, true); //+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
				LicenseUpLoad.tmpXMLHttpRequest.withCredentials = true;
	
				LicenseUpLoad.tmpXMLHttpRequest.onloadend = function (pe) {
					//alert("end");
					$('#progressBorder').remove();
				};
				LicenseUpLoad.tmpXMLHttpRequest.send(oMyForm);
			}
		}]);
	
		return LicenseUpLoad;
	}();
	
	LicenseUpLoad.tmpXMLHttpRequest = null;
	exports.default = LicenseUpLoad;

/***/ },
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "#printReportDialogModel a:focus,#printReportDialogModel a:hover{text-decoration:none;outline:none}#printReportDialogModel #accordion .panel{border:none;box-shadow:none;border-radius:0;margin-bottom:0;margin-top:3px}#printReportDialogModel #accordion .panel-heading{padding:0;border-radius:0;border:none;text-align:center}#printReportDialogModel #accordion .panel-title a{display:block;border-radius:4px;padding:10px 20px;font-size:16px;font-weight:700;color:#fff;background:#4a90e2;border-bottom:1px solid #4a90e2;position:relative;transition:all .5s ease 0s}#printReportDialogModel #accordion .panel-title a:hover{background:#09f}#printReportDialogModel #accordion .panel-title a.collapsed:after{transform:rotate(0deg)}#printReportDialogModel #accordion .panel-body{background:#167ea0;padding:0 0 0 40px;border:none;position:relative}#printReportDialogModel #accordion .panel-body p{font-size:14px;color:#fff;line-height:25px;background:#3296b7;padding:30px;margin:0}#printReportDialogModel #accordion .panel-collapse .panel-body p{opacity:0;transform:scale(.9);transition:all .5s ease-in-out 0s}#printReportDialogModel #accordion .panel-collapse.in .panel-body p{opacity:1;transform:scale(1)}", ""]);
	
	// exports


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".drpdown-blockStyle{display:block}.drpdown-noneStyle{display:none}", ""]);
	
	// exports


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".skin-black .treeview-menu>li>a.selected,.skin-blue .treeview-menu>li>a.selected{color:#fff}.skin-black-light .treeview-menu>li>a.selected{color:#000}.skin-green .treeview-menu>li>a.selected{color:#fff}.skin-green-light .treeview-menu>li>a.selected{color:#000}.skin-red .treeview-menu>li>a.selected{color:#fff}.skin-red-light .treeview-menu>li>a.selected{color:#000}.skin-purple .treeview-menu>li>a.selected{color:#fff}.skin-purple-light .treeview-menu>li>a.selected{color:#000}.skin-yellow .treeview-menu>li>a.selected{color:#fff}.skin-yellow-light .treeview-menu>li>a.selected{color:#000}#mainMenu .treeviewmenuItemA{cursor:pointer;display:flex;align-items:center;padding-top:7px;padding-bottom:7px}.treeviewmenuItemA i{flex-shrink:0;margin-right:8px;margin-top:2px;font-size:14px}.treeviewmenuItemA div{text-overflow:ellipsis;overflow:hidden}.treeview.menuSub{cursor:pointer}.treeview.menuSub .treeviewMenuSubI{margin-right:2px}.treeview a{cursor:pointer}.useDataSeti{margin-right:12px}.sidebar-menu{overflow-x:auto}.listtree-menu-title{cursor:pointer}.listtree-menu-title-div{display:flex}.listtree-menu-icon{color:#fff}.listtree-menu{width:100px;background-color:#35445d;height:100%;position:relative;list-style:none;padding-left:0;margin:0}.left-side,.main-sidebar{position:absolute;top:0;left:0;padding-top:0;min-height:100%;width:200px;z-index:810;background-color:#1055bc!important}.skin-blue-light .sidebar-menu>li.gongqi_active>a,.skin-blue-light .sidebar-menu>li:hover>a,.skin-blue-light .sidebar-menu>li:hover>a i{color:#fff!important;background:#2866c3!important}.skin-blue-light .sidebar a,.treeview>a>i.fa{color:#fff}.skin-blue-light .sidebar-menu>li>.treeview-menu{background:#1055bc}.skin-blue-light .treeview-menu>li>a{color:#fff}.skin-blue-light .treeview-menu>li.active>a,.skin-blue-light .treeview-menu>li>a:hover{background:#2866c3!important;color:#fff}.sidebar-menu .treeview-menu>li>a{padding:9px 5px 9px 15px;display:block;font-size:14px}.skin-blue-light .sidebar-form{border-radius:3px;margin:10px;border:none}.sidebar-menu li>a>.pull-right-container{position:absolute;right:3px;top:50%;margin-top:-7px}.sidebar-menu li>a>.fa-angle-left,.sidebar-menu li>a>.pull-right-container>.fa-angle-left{width:auto;height:auto;padding:0;margin-right:10px;color:#fff}", ""]);
	
	// exports


/***/ },
/* 630 */,
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, ".tab_container div{padding:5px 20px}.tab_container div label{font-size:14px;display:inline-flex}.tab_container input[type=checkbox]{width:16px;height:16px;vertical-align:middle;margin-top:0;background:#fff;border:1px solid #999;border-radius:3px;min-height:16px;min-width:16px;margin-top:2px}", ""]);
	
	// exports


/***/ },
/* 632 */,
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "#jobslist{padding:0}#jobslist>.active{background:#bfcafa}.li_jobsDes{color:#c9c9c9}#jobslist li:hover{background:#bfcafa}#jobslist>.active>.li_jobsDes,#jobslist li:hover>.li_jobsDes{color:#000}#jobsNav>li>a.noclickBtn,#jobsNav>li>a.noclickBtn:hover{color:#bbb}", ""]);
	
	// exports


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "#customMenuModalContainer .customMenuTree .menuItem .fa-check,#customMenuModalContainer .customMenuTree .menuItem .fa-close,#customMenuModalContainer .customMenuTree .menuItem .most{display:none}#customMenuModalContainer .customMenuTree .menuItem:hover .fa-check{display:block}#customMenuModalContainer .customMenuTree .menuItem.usual:hover .fa-check{display:none}#customMenuModalContainer .customMenuTree .menuItem.usual .most,#customMenuModalContainer .customMenuTree .menuItem.usual:hover .fa-close{display:block}#customMenuModalContainer .customMenuTree div.selected{background-color:#7cccfb;color:#000}#customMenuModalContainer .most-group{margin-right:7px;margin-bottom:5px}#customMenuModalContainer .customMenuGroupSelect>li.selected{background-color:#7cccfb}#customMenuModalContainer .most-group .fa-close{display:none}#customMenuModalContainer .most-group:hover .fa-close{display:block}", ""]);
	
	// exports


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports
	
	
	// module
	exports.push([module.id, "#onLineUserModal .onLineUser_important input[type=checkbox]{visibility:hidden}#onLineUserModal .onLineUser_important input[type=checkbox]+label{display:block;width:18px;height:18px;cursor:pointer;position:absolute;top:0;left:0;background:#fff;border:1px solid #0078d4}#onLineUserModal .onLineUser_important input[type=checkbox]:checked+label:before{display:block;content:\"\\2713\";text-align:center;font-size:14px;color:#0078d4;width:17px;height:18px;top:-2px;position:absolute}#onLineUserModal .react-grid-Main{outline:none}", ""]);
	
	// exports


/***/ },
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(627);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./PrintForm.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./PrintForm.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(628);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./ListMainMenuStyle.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./ListMainMenuStyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 773 */,
/* 774 */
[784, 631],
/* 775 */
[784, 633],
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(634);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./customMenu.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./customMenu.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(635);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./OnLineUser.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./OnLineUser.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./styles.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./styles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
]);


// WEBPACK FOOTER //
// index-727ff4cb9031dfd7e9bc.js